/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  _float8: { input: any; output: any; }
  _text: { input: any; output: any; }
  _uuid: { input: any; output: any; }
  bigint: { input: any; output: any; }
  bit: { input: any; output: any; }
  citext: { input: string; output: string; }
  cube: { input: any; output: any; }
  currencies: { input: string; output: string; }
  date: { input: string; output: string; }
  email_template: { input: any; output: any; }
  energy_ges_values: { input: any; output: any; }
  float8: { input: number; output: number; }
  geography: { input: any; output: any; }
  geometry: { input: any; output: any; }
  inet: { input: any; output: any; }
  invoice_status: { input: any; output: any; }
  json: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  lead_buying_status: { input: any; output: any; }
  lead_mortgage_status: { input: any; output: any; }
  lead_ownership: { input: any; output: any; }
  lead_type: { input: any; output: any; }
  marital_status: { input: any; output: any; }
  mortgage_interest_rate_type: { input: any; output: any; }
  mortgage_interest_type: { input: any; output: any; }
  mortgage_lender_type: { input: any; output: any; }
  numeric: { input: any; output: any; }
  pdf_compression_quality: { input: any; output: any; }
  place_type: { input: any; output: any; }
  places_scalar: { input: any; output: any; }
  portal_idx_protocol: { input: any; output: any; }
  property_searches_notification: { input: any; output: any; }
  smallint: { input: any; output: any; }
  subscription_status: { input: any; output: any; }
  third_pillar_organisation_type_a: { input: any; output: any; }
  third_pillar_organisation_type_b: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  tsvector: { input: any; output: any; }
  user_language: { input: any; output: any; }
  user_professional_situation: { input: any; output: any; }
  users_scalar: { input: any; output: any; }
  uuid: { input: string; output: string; }
  vector: { input: any; output: any; }
};

export type AddressInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code: CountryCode;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  route: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street_number: Scalars['String']['input'];
};

export type AgencySetupAddressInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

export type ApiKey = {
  CreatedAt?: Maybe<Scalars['timestamptz']['output']>;
  ExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  KeyPrefix?: Maybe<Scalars['String']['output']>;
  LastUsedAt?: Maybe<Scalars['timestamptz']['output']>;
  OwnerName?: Maybe<Scalars['String']['output']>;
  OwnerUserId?: Maybe<Scalars['String']['output']>;
  /** Plaintext secret is returned only by create and rotate; list/get return null. */
  PartnerApiKey?: Maybe<Scalars['String']['output']>;
  PartnerID: Scalars['String']['output'];
  PartnerName: Scalars['String']['output'];
  PartnerRole: Scalars['String']['output'];
  PartnerTeamsIds?: Maybe<Array<Scalars['String']['output']>>;
  PartnerTenantId: Scalars['String']['output'];
  RevokedAt?: Maybe<Scalars['timestamptz']['output']>;
};

export type AppraisableResult = {
  errors: Array<AppraisalError>;
  result: Scalars['Boolean']['output'];
};

export type AppraisalError = {
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  path: Array<Scalars['String']['output']>;
};

export enum AppraisalReasonType {
  AlreadyForSale = 'already_for_sale',
  BuySoon = 'buy_soon',
  BuyThis = 'buy_this',
  Inheritance = 'inheritance',
  MoveRental = 'move_rental',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Other = 'other',
  OtherNotOwner = 'other_not_owner',
  OtherOwner = 'other_owner',
  OtherRenting = 'other_renting',
  Refinance = 'refinance',
  Sell = 'sell',
  Separation = 'separation'
}

export type AutoAssignRankingAgentCh = {
  crm_link?: Maybe<Scalars['String']['output']>;
  first_lead_assigned?: Maybe<Scalars['timestamptz']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gross_margin_per_lead?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lead_to_transaction_conversion?: Maybe<Scalars['Int']['output']>;
  lead_to_transaction_score?: Maybe<Scalars['Int']['output']>;
  lead_to_visit_conversion?: Maybe<Scalars['Int']['output']>;
  lead_to_visit_score?: Maybe<Scalars['Int']['output']>;
  mandate_to_transaction_conversion?: Maybe<Scalars['Int']['output']>;
  mandate_to_transaction_score?: Maybe<Scalars['Int']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  number_of_leads_without_activity?: Maybe<Scalars['Int']['output']>;
  number_of_listings_available?: Maybe<Scalars['Int']['output']>;
  number_of_overdue_days?: Maybe<Scalars['Int']['output']>;
  number_of_overdue_leads?: Maybe<Scalars['Int']['output']>;
  overall_score?: Maybe<Scalars['Int']['output']>;
  revenues_per_lead?: Maybe<Scalars['Float']['output']>;
  total_agent_share?: Maybe<Scalars['Float']['output']>;
  total_call_center_visits?: Maybe<Scalars['Int']['output']>;
  total_commissions?: Maybe<Scalars['Float']['output']>;
  total_lead_mandates?: Maybe<Scalars['Int']['output']>;
  total_leads_assigned?: Maybe<Scalars['Int']['output']>;
  total_leads_assigned_30_days?: Maybe<Scalars['Int']['output']>;
  total_own_mandates?: Maybe<Scalars['Int']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  total_unique_lead_visits?: Maybe<Scalars['Int']['output']>;
  total_weighted_leads_assigned?: Maybe<Scalars['Float']['output']>;
  visit_to_mandate_conversion?: Maybe<Scalars['Int']['output']>;
  visit_to_mandate_score?: Maybe<Scalars['Int']['output']>;
};

export type AutoAssignRankingCh = {
  agents?: Maybe<Array<Maybe<AutoAssignRankingAgentCh>>>;
  message: Scalars['String']['output'];
};

export type AutoAssignRankingEu = {
  agents?: Maybe<Array<Maybe<QualifyingAgent>>>;
  assign_to?: Maybe<QualifyingAgent>;
  message: Scalars['String']['output'];
  should_auto_assign?: Maybe<Scalars['Boolean']['output']>;
};

export type BlockFsboUsersOutput = {
  batch_id: Scalars['uuid']['output'];
  blocked_user_ids: Array<Scalars['uuid']['output']>;
  failed_lots: Scalars['Int']['output'];
  failed_portal_listings: Scalars['Int']['output'];
  unpublished_lots: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BootstrapOnboardingAgencyOutput = {
  already_bootstrapped: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  team_id: Scalars['uuid']['output'];
};

export type BuyerLeadImportInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  lot_reference: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  stage: Scalars['String']['input'];
  updated_at?: InputMaybe<Scalars['String']['input']>;
  user_email: Scalars['String']['input'];
};

export type BuyerLeadImportOutput = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
};

export type CheckPortalConnectionOutput = {
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ClaimAgencyOutput = {
  success: Scalars['Boolean']['output'];
};

export type ClaimAgentOutput = {
  success: Scalars['Boolean']['output'];
};

export type ClaimLeadOutput = {
  id: Scalars['uuid']['output'];
  lead?: Maybe<Leads>;
};

export type CloseLeadDetails = {
  csm_rep_email?: Maybe<Scalars['String']['output']>;
  csm_rep_user_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sales_rep_email?: Maybe<Scalars['String']['output']>;
  sales_rep_user_id?: Maybe<Scalars['String']['output']>;
};

export type CloseLeadSearchResponse = {
  data: Array<CloseLeadSearchResult>;
};

export type CloseLeadSearchResult = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type CompleteFullOnboardingOutput = {
  already_onboarded: Scalars['Boolean']['output'];
  invitations_sent: Scalars['Boolean']['output'];
  onboarding_status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  team_id: Scalars['uuid']['output'];
};

export type CompositeWatermarkImagesOutput = {
  processed_count: Scalars['Int']['output'];
  skipped_count: Scalars['Int']['output'];
};

export type ContactEmailOutput = {
  email: Scalars['String']['output'];
  primary?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactPhoneNumberOutput = {
  number: Scalars['String']['output'];
  primary?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactProspectionLeadOutput = {
  lead_agent_id?: Maybe<Scalars['uuid']['output']>;
  lead_id: Scalars['uuid']['output'];
  limit: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  resets_at?: Maybe<Scalars['timestamptz']['output']>;
  used: Scalars['Int']['output'];
};

export enum CountryCode {
  Ch = 'CH',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT'
}

export type CreateBuyerLeadInput = {
  contact_id: Scalars['uuid']['input'];
  create_property_search?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id: Scalars['uuid']['input'];
  property_search_notification?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBuyerLeadOutput = {
  buyer_lead_id: Scalars['uuid']['output'];
  created: Scalars['Boolean']['output'];
  property_search_id?: Maybe<Scalars['uuid']['output']>;
};

export type CreateContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactOutput = {
  contact_id: Scalars['uuid']['output'];
  created: Scalars['Boolean']['output'];
  emails: Array<ContactEmailOutput>;
  first_name?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone_numbers: Array<ContactPhoneNumberOutput>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CreateEnquiryBuyerLeadOutput = {
  buyer_lead?: Maybe<Buyer_Leads>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  enquiry?: Maybe<Enquiries>;
  enquiry_id: Scalars['uuid']['output'];
};

export type CreateEnquiryInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_reason?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  property_search_notification?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEnquiryOutput = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  enquiry_id: Scalars['uuid']['output'];
};

export type CreateMarketplaceConversationOutput = {
  id: Scalars['uuid']['output'];
};

export type CreatePropertySearchInput = {
  contact_id: Scalars['uuid']['input'];
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['String']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type: Scalars['String']['input'];
  place_ids: Array<Scalars['uuid']['input']>;
  property_type_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  sale_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePropertySearchOutput = {
  property_search_id: Scalars['uuid']['output'];
};

export type CrmCsatQuestion = {
  id: Scalars['String']['output'];
  question: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CrmCsatStatusOutput = {
  last_responded_at?: Maybe<Scalars['String']['output']>;
  questions: Array<CrmCsatQuestion>;
  survey_iteration?: Maybe<Scalars['Int']['output']>;
  survey_iteration_start_date?: Maybe<Scalars['String']['output']>;
  survey_name?: Maybe<Scalars['String']['output']>;
};

export type CurrentSubscription = {
  current_period_end?: Maybe<Scalars['String']['output']>;
  current_period_pct?: Maybe<Scalars['Float']['output']>;
  current_period_start?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  incurred_cost?: Maybe<Scalars['Int']['output']>;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
};

export type DataForSeoApiResponse = {
  cost?: Maybe<Scalars['Float']['output']>;
  status_code?: Maybe<Scalars['Int']['output']>;
  status_message?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Scalars['jsonb']['output']>;
  tasks_count?: Maybe<Scalars['Int']['output']>;
  tasks_error?: Maybe<Scalars['Int']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type DeleteKeyResponse = {
  message?: Maybe<Scalars['String']['output']>;
  rowsDeleted?: Maybe<Scalars['String']['output']>;
};

export type DeleteMarketplaceConversationOutput = {
  id: Scalars['uuid']['output'];
};

export type DeleteTeamThemeOutput = {
  code?: Maybe<Scalars['String']['output']>;
  documents_switched?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  team_name?: Maybe<Scalars['String']['output']>;
  theme_name?: Maybe<Scalars['String']['output']>;
};

export type DeleteUserOutput = {
  id: Scalars['uuid']['output'];
};

export type DocumentRecipient = {
  last_open_at?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shared_at?: Maybe<Scalars['String']['output']>;
  total_opens: Scalars['Int']['output'];
  unique_opens: Scalars['Int']['output'];
  user_id: Scalars['uuid']['output'];
};

export type DocumentRecipientStatusOutput = {
  daily: Array<DocumentStatsDailyRow>;
  last_open_at?: Maybe<Scalars['String']['output']>;
  shared: Scalars['Boolean']['output'];
  shared_at?: Maybe<Scalars['String']['output']>;
  total_opens: Scalars['Int']['output'];
  unidentified_opens?: Maybe<Scalars['Int']['output']>;
  unique_opens: Scalars['Int']['output'];
};

export type DocumentRecipientsOutput = {
  recipients: Array<DocumentRecipient>;
};

export type DocumentStatsDailyRow = {
  date: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  unique: Scalars['Int']['output'];
};

export type DocumentStatsOutput = {
  daily: Array<DocumentStatsDailyRow>;
  total_opens: Scalars['Int']['output'];
  unidentified_opens?: Maybe<Scalars['Int']['output']>;
  unique_opens: Scalars['Int']['output'];
};

export type EnhanceImageOutput = {
  image_data: Scalars['String']['output'];
};

export type FindOnboardingSocialLinksOutput = {
  links: Array<FoundOnboardingSocialLink>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FoundOnboardingSocialLink = {
  platform: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GenerateAgencyDescription = {
  description: Scalars['String']['output'];
};

export type GenerateCmaDescription = {
  description: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type GenerateCmaReportOutput = {
  cma_report_id: Scalars['uuid']['output'];
};

export type GenerateImageMetadata = {
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GenerateLeadSummaryOutput = {
  summary: Scalars['String']['output'];
};

export type GenerateListingDescription = {
  description: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type GenerateListingTitle = {
  prompt: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type GeocodeAddressOutput = {
  country_code?: Maybe<Scalars['String']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  location_type?: Maybe<Scalars['String']['output']>;
  partial_match?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export enum GetEmailTemplateSuggestionsLanguage {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  It = 'it'
}

export type GetEmailTemplateSuggestionsOutput = {
  suggestions: Scalars['json']['output'];
};

export enum GetLeadsStatisticsGroupingMode {
  Day = 'day',
  Month = 'month',
  Quarter = 'quarter',
  Week = 'week',
  Year = 'year'
}

export enum GetLeadsStatisticsLeadOrigin {
  Leads = 'leads',
  Manual = 'manual',
  Other = 'other',
  Visibility = 'visibility'
}

export type GetLeadsStatisticsOutput = {
  data: Array<StatisticsRow>;
  filters: StatisticsFilters;
};

export type GetListingReferencesOutput = {
  id: Scalars['uuid']['output'];
  listing?: Maybe<Lots>;
  reference_aliases_encoded: Array<ReferenceAlias>;
};

export type GetMeOutput = {
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  me?: Maybe<Users>;
  me_id: Scalars['uuid']['output'];
  show_plans: Scalars['String']['output'];
  user_ids_in_led_teams?: Maybe<Array<Scalars['uuid']['output']>>;
};

export type GetOnboardingStateOutput = {
  state: OnboardingState;
  success: Scalars['Boolean']['output'];
};

export type GetPropertyDistancesOutput = {
  distances?: Maybe<Scalars['jsonb']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GetSurroundingListingPlacesOutput = {
  place?: Maybe<Places>;
  place_id: Scalars['uuid']['output'];
};

export type GetValuationLinkOutput = {
  agent?: Maybe<Users>;
  agent_id: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  landing_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  valuation_url?: Maybe<Scalars['String']['output']>;
};

export type ImportPortalListingsItem = {
  errors?: Maybe<Array<Scalars['String']['output']>>;
  external_property_id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  outcome: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type ImportPortalListingsOutput = {
  errors: Scalars['Int']['output'];
  inserted: Scalars['Int']['output'];
  items: Array<ImportPortalListingsItem>;
  page: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
  total_properties: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type ImpressionDot = {
  agent_uuid?: Maybe<Scalars['uuid']['output']>;
  appraisal_reason?: Maybe<Scalars['String']['output']>;
  event_date?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lead_id: Scalars['String']['output'];
  lng: Scalars['Float']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  requalified_or_created_at?: Maybe<Scalars['String']['output']>;
  sale_horizon?: Maybe<Scalars['String']['output']>;
};

export type ImpressionDotsOutput = {
  data?: Maybe<Array<ImpressionDot>>;
  truncated: Scalars['Boolean']['output'];
};

export type ImpressionGroup = {
  agency_id?: Maybe<Scalars['uuid']['output']>;
  average_position?: Maybe<Scalars['Float']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  user_count?: Maybe<Scalars['Int']['output']>;
};

export type ImpressionsGroupedByColumnResponse = {
  data?: Maybe<Array<ImpressionGroup>>;
};

export enum ImpressionsGroupingColumn {
  Category = 'category',
  City = 'city',
  Country = 'country',
  Date = 'date',
  DateFirstSeen = 'date_first_seen',
  Device = 'device',
  EventName = 'event_name',
  PageLocation = 'page_location',
  PageReferrer = 'page_referrer',
  PageType = 'page_type',
  Region = 'region'
}

export type ImpressionsTotalOutput = {
  average_position?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Float']['output'];
  user_count: Scalars['Float']['output'];
};

export type ImprovedText = {
  text: Scalars['String']['output'];
};

export type InsertListingActivitiesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingActivitiesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingActivitiesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingActivitiesAggregateBoolExpCount>;
};

export type InsertListingActivitiesAggregateBoolExpBoolAnd = {
  arguments: InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesAggregateBoolExpBoolOr = {
  arguments: InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingActivitiesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingActivitiesArrRelInsertInput = {
  data: Array<InsertListingActivitiesInsertInput>;
  on_conflict?: InputMaybe<InsertListingActivitiesOnConflict>;
};

export type InsertListingActivitiesBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesBoolExp>>;
  activities_participants?: InputMaybe<InsertListingActivitiesParticipantsBoolExp>;
  activities_participants_aggregate?: InputMaybe<InsertListingActivitiesParticipantsAggregateBoolExp>;
  activities_target_users?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  activities_target_users_aggregate?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExp>;
  activity_type?: InputMaybe<InsertListingActivityTypesEnumEnumComparisonExp>;
  appraisal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  assigned_to?: InputMaybe<InsertListingUuidComparisonExp>;
  assignee?: InputMaybe<InsertListingUsersBoolExp>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  calendar_event_id?: InputMaybe<InsertListingUuidComparisonExp>;
  consolidated_done_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  done?: InputMaybe<InsertListingBooleanComparisonExp>;
  done_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  due_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email_message?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_message_id?: InputMaybe<InsertListingUuidComparisonExp>;
  end_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  end_date?: InputMaybe<InsertListingDateComparisonExp>;
  enquiry_id?: InputMaybe<InsertListingUuidComparisonExp>;
  extra_data?: InputMaybe<InsertListingJsonbComparisonExp>;
  financing_request_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_overdue?: InputMaybe<InsertListingBooleanComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  location?: InputMaybe<InsertListingStringComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  note?: InputMaybe<InsertListingStringComparisonExp>;
  offer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_refused_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_status?: InputMaybe<InsertListingStringComparisonExp>;
  permissions?: InputMaybe<InsertListingActivitiesPermissionsBoolExp>;
  pinned?: InputMaybe<InsertListingBooleanComparisonExp>;
  start_date?: InputMaybe<InsertListingDateComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  success?: InputMaybe<InsertListingBooleanComparisonExp>;
  synced_from_calendar?: InputMaybe<InsertListingBooleanComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  visibility?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingActivitiesConstraint {
  /** unique or primary key constraint on columns "calendar_event_id" */
  ActivitiesCalendarEventIdUnique = 'activities_calendar_event_id_unique',
  /** unique or primary key constraint on columns "email_message_id" */
  ActivitiesEmailMessageIdUnique = 'activities_email_message_id_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ActivitiesIdTenantIdUnique = 'activities_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ActivitiesPkey = 'activities_pkey'
}

export type InsertListingActivitiesInsertInput = {
  activities_participants?: InputMaybe<InsertListingActivitiesParticipantsArrRelInsertInput>;
  activities_target_users?: InputMaybe<InsertListingActivitiesTargetUsersArrRelInsertInput>;
  activity_type?: InputMaybe<InsertListingActivityTypesEnumEnum>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  assignee?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsObjRelInsertInput>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  calendar_event_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_message?: InputMaybe<InsertListingEmailMessagesObjRelInsertInput>;
  email_message_id?: InputMaybe<Scalars['uuid']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  extra_data?: InputMaybe<Scalars['jsonb']['input']>;
  financing_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_status?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<InsertListingActivitiesPermissionsObjRelInsertInput>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  synced_from_calendar?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingActivitiesObjRelInsertInput = {
  data: InsertListingActivitiesInsertInput;
  on_conflict?: InputMaybe<InsertListingActivitiesOnConflict>;
};

export type InsertListingActivitiesOnConflict = {
  constraint: InsertListingActivitiesConstraint;
  update_columns: Array<InsertListingActivitiesUpdateColumn>;
  where?: InputMaybe<InsertListingActivitiesBoolExp>;
};

export type InsertListingActivitiesParticipantsAggregateBoolExp = {
  count?: InputMaybe<InsertListingActivitiesParticipantsAggregateBoolExpCount>;
};

export type InsertListingActivitiesParticipantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingActivitiesParticipantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesParticipantsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingActivitiesParticipantsArrRelInsertInput = {
  data: Array<InsertListingActivitiesParticipantsInsertInput>;
};

export type InsertListingActivitiesParticipantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesParticipantsBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesParticipantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesParticipantsBoolExp>>;
  activity_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  matched_user?: InputMaybe<InsertListingUsersBoolExp>;
  matched_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingActivitiesParticipantsInsertInput = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  matched_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  matched_user_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum InsertListingActivitiesParticipantsSelectColumn {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  MatchedUserId = 'matched_user_id',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status'
}

export type InsertListingActivitiesPermissionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesPermissionsBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesPermissionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesPermissionsBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingActivitiesPermissionsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingActivitiesPermissionsObjRelInsertInput = {
  data: InsertListingActivitiesPermissionsInsertInput;
};

export enum InsertListingActivitiesSelectColumn {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ConsolidatedDoneAt = 'consolidated_done_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  FinancingRequestId = 'financing_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Location = 'location',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  OfferStatus = 'offer_status',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visibility = 'visibility'
}

export enum InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

export enum InsertListingActivitiesSelectColumnActivitiesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

export type InsertListingActivitiesTargetUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingActivitiesTargetUsersAggregateBoolExpCount>;
};

export type InsertListingActivitiesTargetUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesTargetUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingActivitiesTargetUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingActivitiesTargetUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingActivitiesTargetUsersArrRelInsertInput = {
  data: Array<InsertListingActivitiesTargetUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingActivitiesTargetUsersOnConflict>;
};

export type InsertListingActivitiesTargetUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingActivitiesTargetUsersBoolExp>>;
  _not?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingActivitiesTargetUsersBoolExp>>;
  activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  activity_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  is_owner?: InputMaybe<InsertListingBooleanComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  target_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingActivitiesTargetUsersConstraint {
  /** unique or primary key constraint on columns "target_user_id", "is_owner", "activity_id", "email" */
  ActivitiesTargetUsersUindex = 'activities_target_users_uindex'
}

export type InsertListingActivitiesTargetUsersInsertInput = {
  activity?: InputMaybe<InsertListingActivitiesObjRelInsertInput>;
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  is_owner?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  target_user_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingActivitiesTargetUsersOnConflict = {
  constraint: InsertListingActivitiesTargetUsersConstraint;
  update_columns: Array<InsertListingActivitiesTargetUsersUpdateColumn>;
  where?: InputMaybe<InsertListingActivitiesTargetUsersBoolExp>;
};

export enum InsertListingActivitiesTargetUsersSelectColumn {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUserId = 'target_user_id',
  /** column name */
  Type = 'type'
}

export enum InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsOwner = 'is_owner'
}

export enum InsertListingActivitiesTargetUsersSelectColumnActivitiesTargetUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsOwner = 'is_owner'
}

export enum InsertListingActivitiesTargetUsersUpdateColumn {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUserId = 'target_user_id',
  /** column name */
  Type = 'type'
}

export enum InsertListingActivitiesUpdateColumn {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  FinancingRequestId = 'financing_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Location = 'location',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  OfferStatus = 'offer_status',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visibility = 'visibility'
}

export enum InsertListingActivityTypesEnumEnum {
  Assignment = 'assignment',
  Call = 'call',
  Change = 'change',
  CreateUser = 'create_user',
  Email = 'email',
  Match = 'match',
  Note = 'note',
  Offer = 'offer',
  Origination = 'origination',
  Requalification = 'requalification',
  Task = 'task',
  Visit = 'visit'
}

export type InsertListingActivityTypesEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingActivityTypesEnumEnum>;
  _in?: InputMaybe<Array<InsertListingActivityTypesEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingActivityTypesEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingActivityTypesEnumEnum>>;
};

export enum InsertListingAddressDisplayOptionsEnumEnum {
  /** Full address */
  FullAddress = 'full_address',
  /** Hide street and street number */
  HideStreet = 'hide_street',
  /** Hide only street number */
  HideStreetNumber = 'hide_street_number'
}

export type InsertListingAddressDisplayOptionsEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  _in?: InputMaybe<Array<InsertListingAddressDisplayOptionsEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingAddressDisplayOptionsEnumEnum>>;
};

export type InsertListingAppraisalsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingAppraisalsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingAppraisalsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingAppraisalsAggregateBoolExpCount>;
};

export type InsertListingAppraisalsAggregateBoolExpBoolAnd = {
  arguments: InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingAppraisalsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingAppraisalsAggregateBoolExpBoolOr = {
  arguments: InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingAppraisalsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingAppraisalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingAppraisalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingAppraisalsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingAppraisalsArrRelInsertInput = {
  data: Array<InsertListingAppraisalsInsertInput>;
  on_conflict?: InputMaybe<InsertListingAppraisalsOnConflict>;
};

export type InsertListingAppraisalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingAppraisalsBoolExp>>;
  _not?: InputMaybe<InsertListingAppraisalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingAppraisalsBoolExp>>;
  appraisal_perceived_value?: InputMaybe<InsertListingFloatComparisonExp>;
  balcony_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  building_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  building_standard?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume_norm?: InputMaybe<InsertListingStringComparisonExp>;
  built_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  construction_year?: InputMaybe<InsertListingIntComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  ctn?: InputMaybe<InsertListingStringComparisonExp>;
  flat_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  floor_of_flat?: InputMaybe<InsertListingIntComparisonExp>;
  garden_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  iazi_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  income_includes_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_commercial_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_luxury?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_maisonette?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_parking_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_pending?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_residential_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_secondary_residence?: InputMaybe<InsertListingBooleanComparisonExp>;
  land_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  living_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  max?: InputMaybe<InsertListingFloatComparisonExp>;
  method?: InputMaybe<InsertListingStringComparisonExp>;
  micro_location?: InputMaybe<InsertListingFloatComparisonExp>;
  min?: InputMaybe<InsertListingFloatComparisonExp>;
  minergie_code?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bathrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_commercial_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_flats?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_floors?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_indoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_lifts?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_outdoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_residential_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_rooms?: InputMaybe<InsertListingFloatComparisonExp>;
  number_of_toilets?: InputMaybe<InsertListingIntComparisonExp>;
  parking_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  parking_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  plot_has_constructible_reserve?: InputMaybe<InsertListingBooleanComparisonExp>;
  plot_is_constructible?: InputMaybe<InsertListingBooleanComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  price_per_built_surface_meter_squared?: InputMaybe<InsertListingFloatComparisonExp>;
  price_per_land_surface_meter_squared?: InputMaybe<InsertListingFloatComparisonExp>;
  price_per_living_surface_meter_squared?: InputMaybe<InsertListingFloatComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_volume?: InputMaybe<InsertListingFloatComparisonExp>;
  property_volume_norm?: InputMaybe<InsertListingStringComparisonExp>;
  relevant_servitudes?: InputMaybe<InsertListingBooleanComparisonExp>;
  renovation_year?: InputMaybe<InsertListingIntComparisonExp>;
  rent_max?: InputMaybe<InsertListingFloatComparisonExp>;
  rent_min?: InputMaybe<InsertListingFloatComparisonExp>;
  rent_value?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  share_of_ownership?: InputMaybe<InsertListingFloatComparisonExp>;
  side?: InputMaybe<InsertListingPropertySideEnumEnumComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  valuations?: InputMaybe<InsertListingValuationsBoolExp>;
  valuations_aggregate?: InputMaybe<InsertListingValuationsAggregateBoolExp>;
  value?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingAppraisalsConstraint {
  /** unique or primary key constraint on columns "id" */
  AppraisalsPkey = 'appraisals_pkey'
}

export type InsertListingAppraisalsInsertInput = {
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_pending?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  price_per_built_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  price_per_land_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  price_per_living_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  property_volume?: InputMaybe<Scalars['Float']['input']>;
  property_volume_norm?: InputMaybe<Scalars['String']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  rent_max?: InputMaybe<Scalars['Float']['input']>;
  rent_min?: InputMaybe<Scalars['Float']['input']>;
  rent_value?: InputMaybe<Scalars['Float']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<InsertListingPropertySideEnumEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  valuations?: InputMaybe<InsertListingValuationsArrRelInsertInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingAppraisalsObjRelInsertInput = {
  data: InsertListingAppraisalsInsertInput;
  on_conflict?: InputMaybe<InsertListingAppraisalsOnConflict>;
};

export type InsertListingAppraisalsOnConflict = {
  constraint: InsertListingAppraisalsConstraint;
  update_columns: Array<InsertListingAppraisalsUpdateColumn>;
  where?: InputMaybe<InsertListingAppraisalsBoolExp>;
};

export enum InsertListingAppraisalsSelectColumn {
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Max = 'max',
  /** column name */
  Method = 'method',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  Min = 'min',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerBuiltSurfaceMeterSquared = 'price_per_built_surface_meter_squared',
  /** column name */
  PricePerLandSurfaceMeterSquared = 'price_per_land_surface_meter_squared',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  PropertyVolume = 'property_volume',
  /** column name */
  PropertyVolumeNorm = 'property_volume_norm',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentMax = 'rent_max',
  /** column name */
  RentMin = 'rent_min',
  /** column name */
  RentValue = 'rent_value',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export enum InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  RelevantServitudes = 'relevant_servitudes'
}

export enum InsertListingAppraisalsSelectColumnAppraisalsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  RelevantServitudes = 'relevant_servitudes'
}

export enum InsertListingAppraisalsUpdateColumn {
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Max = 'max',
  /** column name */
  Method = 'method',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  Min = 'min',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerBuiltSurfaceMeterSquared = 'price_per_built_surface_meter_squared',
  /** column name */
  PricePerLandSurfaceMeterSquared = 'price_per_land_surface_meter_squared',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  PropertyVolume = 'property_volume',
  /** column name */
  PropertyVolumeNorm = 'property_volume_norm',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentMax = 'rent_max',
  /** column name */
  RentMin = 'rent_min',
  /** column name */
  RentValue = 'rent_value',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

export type InsertListingBigintComparisonExp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

export type InsertListingBooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type InsertListingBuyerLeadsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExpCount>;
};

export type InsertListingBuyerLeadsAggregateBoolExpBoolAnd = {
  arguments: InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingBuyerLeadsAggregateBoolExpBoolOr = {
  arguments: InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingBuyerLeadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingBuyerLeadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingBuyerLeadsArrRelInsertInput = {
  data: Array<InsertListingBuyerLeadsInsertInput>;
  on_conflict?: InputMaybe<InsertListingBuyerLeadsOnConflict>;
};

export type InsertListingBuyerLeadsBoolExp = {
  _and?: InputMaybe<Array<InsertListingBuyerLeadsBoolExp>>;
  _not?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  _or?: InputMaybe<Array<InsertListingBuyerLeadsBoolExp>>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  financial_approval?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead_stage?: InputMaybe<InsertListingLeadStagesBoolExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  source?: InputMaybe<InsertListingStringComparisonExp>;
  stage_id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_order_nr?: InputMaybe<InsertListingIntComparisonExp>;
};

export enum InsertListingBuyerLeadsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  BuyerLeadsIdTenantIdUnique = 'buyer_leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  BuyerLeadsLotIdUserIdUnique = 'buyer_leads_lot_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  BuyerLeadsPkey = 'buyer_leads_pkey'
}

export type InsertListingBuyerLeadsInsertInput = {
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  financial_approval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<InsertListingLeadStagesObjRelInsertInput>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertListingBuyerLeadsObjRelInsertInput = {
  data: InsertListingBuyerLeadsInsertInput;
  on_conflict?: InputMaybe<InsertListingBuyerLeadsOnConflict>;
};

export type InsertListingBuyerLeadsOnConflict = {
  constraint: InsertListingBuyerLeadsConstraint;
  update_columns: Array<InsertListingBuyerLeadsUpdateColumn>;
  where?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
};

export enum InsertListingBuyerLeadsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

export enum InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FinancialApproval = 'financial_approval'
}

export enum InsertListingBuyerLeadsSelectColumnBuyerLeadsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FinancialApproval = 'financial_approval'
}

export enum InsertListingBuyerLeadsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

export type InsertListingCatchmentAreasAggregateBoolExp = {
  count?: InputMaybe<InsertListingCatchmentAreasAggregateBoolExpCount>;
};

export type InsertListingCatchmentAreasAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCatchmentAreasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCatchmentAreasArrRelInsertInput = {
  data: Array<InsertListingCatchmentAreasInsertInput>;
  on_conflict?: InputMaybe<InsertListingCatchmentAreasOnConflict>;
};

export type InsertListingCatchmentAreasBoolExp = {
  _and?: InputMaybe<Array<InsertListingCatchmentAreasBoolExp>>;
  _not?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  _or?: InputMaybe<Array<InsertListingCatchmentAreasBoolExp>>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingCatchmentAreasConstraint {
  /** unique or primary key constraint on columns "place_id", "user_id", "tenant_id" */
  CatchmentAreasUserIdPlaceIdTenantIdUnique = 'catchment_areas_user_id_place_id_tenant_id_unique'
}

export type InsertListingCatchmentAreasInsertInput = {
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingCatchmentAreasOnConflict = {
  constraint: InsertListingCatchmentAreasConstraint;
  update_columns: Array<InsertListingCatchmentAreasUpdateColumn>;
  where?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
};

export enum InsertListingCatchmentAreasSelectColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingCatchmentAreasUpdateColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingCitextComparisonExp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  _regex?: InputMaybe<Scalars['citext']['input']>;
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

export type InsertListingCmaReportFilesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExpCount>;
};

export type InsertListingCmaReportFilesAggregateBoolExpBoolAnd = {
  arguments: InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportFilesAggregateBoolExpBoolOr = {
  arguments: InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCmaReportFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCmaReportFilesArrRelInsertInput = {
  data: Array<InsertListingCmaReportFilesInsertInput>;
  on_conflict?: InputMaybe<InsertListingCmaReportFilesOnConflict>;
};

export type InsertListingCmaReportFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingCmaReportFilesBoolExp>>;
  _not?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingCmaReportFilesBoolExp>>;
  cma_report?: InputMaybe<InsertListingCmaReportsBoolExp>;
  cma_report_id?: InputMaybe<InsertListingUuidComparisonExp>;
  file?: InputMaybe<InsertListingFilesBoolExp>;
  file_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_visible?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingCmaReportFilesConstraint {
  /** unique or primary key constraint on columns "file_id", "cma_report_id" */
  CmaReportFilesCmaReportIdFileIdKey = 'cma_report_files_cma_report_id_file_id_key',
  /** unique or primary key constraint on columns "order_nr", "cma_report_id" */
  CmaReportOrderUnique = 'cma_report_order_unique'
}

export type InsertListingCmaReportFilesInsertInput = {
  cma_report?: InputMaybe<InsertListingCmaReportsObjRelInsertInput>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<InsertListingFilesObjRelInsertInput>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingCmaReportFilesOnConflict = {
  constraint: InsertListingCmaReportFilesConstraint;
  update_columns: Array<InsertListingCmaReportFilesUpdateColumn>;
  where?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
};

export enum InsertListingCmaReportFilesSelectColumn {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingCmaReportFilesSelectColumnCmaReportFilesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingCmaReportFilesUpdateColumn {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingCmaReportsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingCmaReportsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingCmaReportsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingCmaReportsAggregateBoolExpCount>;
};

export type InsertListingCmaReportsAggregateBoolExpBoolAnd = {
  arguments: InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportsAggregateBoolExpBoolOr = {
  arguments: InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCmaReportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCmaReportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCmaReportsArrRelInsertInput = {
  data: Array<InsertListingCmaReportsInsertInput>;
  on_conflict?: InputMaybe<InsertListingCmaReportsOnConflict>;
};

export type InsertListingCmaReportsBoolExp = {
  _and?: InputMaybe<Array<InsertListingCmaReportsBoolExp>>;
  _not?: InputMaybe<InsertListingCmaReportsBoolExp>;
  _or?: InputMaybe<Array<InsertListingCmaReportsBoolExp>>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  caprate_estimated_monthly_rent?: InputMaybe<InsertListingIntComparisonExp>;
  caprate_minimum_required_yield?: InputMaybe<InsertListingFloatComparisonExp>;
  cma_report_files?: InputMaybe<InsertListingCmaReportFilesBoolExp>;
  cma_report_files_aggregate?: InputMaybe<InsertListingCmaReportFilesAggregateBoolExp>;
  comparable_listings?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
  comparable_listings_aggregate?: InputMaybe<InsertListingCmaReportsComparablesAggregateBoolExp>;
  construction_cost_base?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnumComparisonExp>;
  contact?: InputMaybe<InsertListingUsersBoolExp>;
  contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  cover_image?: InputMaybe<InsertListingImagesBoolExp>;
  cover_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  doc_template?: InputMaybe<InsertListingDocTemplatesBoolExp>;
  doc_template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  font_family?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  include_agent?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_agent_agency?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_append_files?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_client_testimonial?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_comparables_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_cover?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_cuprate_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_description?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_final_value?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_hedonistic_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_intrinsic_valuation?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_introduction?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_potential_buyers?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_property?: InputMaybe<InsertListingBooleanComparisonExp>;
  include_valuation_methods?: InputMaybe<InsertListingBooleanComparisonExp>;
  intrinsic_annual_deprecation_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  intrinsic_building_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  intrinsic_construction_cost?: InputMaybe<InsertListingIntComparisonExp>;
  intrinsic_custom_fields?: InputMaybe<InsertListingJsonbComparisonExp>;
  intrinsic_land_value?: InputMaybe<InsertListingIntComparisonExp>;
  introduction?: InputMaybe<InsertListingStringComparisonExp>;
  is_price_range?: InputMaybe<InsertListingBooleanComparisonExp>;
  language?: InputMaybe<InsertListingUserLanguageComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  max_budget?: InputMaybe<InsertListingIntComparisonExp>;
  min_budget?: InputMaybe<InsertListingIntComparisonExp>;
  negative_comments?: InputMaybe<InsertListingStringComparisonExp>;
  positive_comments?: InputMaybe<InsertListingStringComparisonExp>;
  price_range_max?: InputMaybe<InsertListingIntComparisonExp>;
  price_range_min?: InputMaybe<InsertListingIntComparisonExp>;
  probability_max?: InputMaybe<InsertListingFloatComparisonExp>;
  probability_min?: InputMaybe<InsertListingFloatComparisonExp>;
  probability_time_period?: InputMaybe<InsertListingIntComparisonExp>;
  report_title?: InputMaybe<InsertListingStringComparisonExp>;
  show_probability?: InputMaybe<InsertListingBooleanComparisonExp>;
  suggested_market_value?: InputMaybe<InsertListingIntComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
};

export type InsertListingCmaReportsComparablesAggregateBoolExp = {
  count?: InputMaybe<InsertListingCmaReportsComparablesAggregateBoolExpCount>;
};

export type InsertListingCmaReportsComparablesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCmaReportsComparablesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCmaReportsComparablesArrRelInsertInput = {
  data: Array<InsertListingCmaReportsComparablesInsertInput>;
  on_conflict?: InputMaybe<InsertListingCmaReportsComparablesOnConflict>;
};

export type InsertListingCmaReportsComparablesBoolExp = {
  _and?: InputMaybe<Array<InsertListingCmaReportsComparablesBoolExp>>;
  _not?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
  _or?: InputMaybe<Array<InsertListingCmaReportsComparablesBoolExp>>;
  aggregates_db__merged_listings_clusters_id?: InputMaybe<InsertListingBigintComparisonExp>;
  cma_report?: InputMaybe<InsertListingCmaReportsBoolExp>;
  cma_report_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  listing_snapshot?: InputMaybe<InsertListingJsonbComparisonExp>;
  order_nr?: InputMaybe<InsertListingFloatComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingCmaReportsComparablesConstraint {
  /** unique or primary key constraint on columns "cma_report_id", "aggregates_db__merged_listings_clusters_id" */
  CmaReportsComparablesIdListingIdUnique = 'cma_reports_comparables_id_listing_id_unique',
  /** unique or primary key constraint on columns "order_nr", "cma_report_id" */
  CmaReportsComparablesIdOrderNrUnique = 'cma_reports_comparables_id_order_nr_unique'
}

export type InsertListingCmaReportsComparablesInsertInput = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report?: InputMaybe<InsertListingCmaReportsObjRelInsertInput>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingCmaReportsComparablesOnConflict = {
  constraint: InsertListingCmaReportsComparablesConstraint;
  update_columns: Array<InsertListingCmaReportsComparablesUpdateColumn>;
  where?: InputMaybe<InsertListingCmaReportsComparablesBoolExp>;
};

export enum InsertListingCmaReportsComparablesSelectColumn {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingCmaReportsComparablesUpdateColumn {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingCmaReportsConstraint {
  /** unique or primary key constraint on columns "id" */
  CmaReportsPkey = 'cma_reports_pkey'
}

export enum InsertListingCmaReportsConstructionBaseEnumEnum {
  Surface = 'surface',
  Volume = 'volume'
}

export type InsertListingCmaReportsConstructionBaseEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnum>;
  _in?: InputMaybe<Array<InsertListingCmaReportsConstructionBaseEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingCmaReportsConstructionBaseEnumEnum>>;
};

export type InsertListingCmaReportsInsertInput = {
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  cma_report_files?: InputMaybe<InsertListingCmaReportFilesArrRelInsertInput>;
  comparable_listings?: InputMaybe<InsertListingCmaReportsComparablesArrRelInsertInput>;
  construction_cost_base?: InputMaybe<InsertListingCmaReportsConstructionBaseEnumEnum>;
  contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  doc_template?: InputMaybe<InsertListingDocTemplatesObjRelInsertInput>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  include_valuation_methods?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingCmaReportsObjRelInsertInput = {
  data: InsertListingCmaReportsInsertInput;
  on_conflict?: InputMaybe<InsertListingCmaReportsOnConflict>;
};

export type InsertListingCmaReportsOnConflict = {
  constraint: InsertListingCmaReportsConstraint;
  update_columns: Array<InsertListingCmaReportsUpdateColumn>;
  where?: InputMaybe<InsertListingCmaReportsBoolExp>;
};

export enum InsertListingCmaReportsSelectColumn {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  ShowProbability = 'show_probability'
}

export enum InsertListingCmaReportsSelectColumnCmaReportsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  ShowProbability = 'show_probability'
}

export enum InsertListingCmaReportsUpdateColumn {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeValuationMethods = 'include_valuation_methods',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingCombinedReviewsAggregateBoolExp = {
  count?: InputMaybe<InsertListingCombinedReviewsAggregateBoolExpCount>;
};

export type InsertListingCombinedReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCombinedReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCombinedReviewsArrRelInsertInput = {
  data: Array<InsertListingCombinedReviewsInsertInput>;
};

export type InsertListingCombinedReviewsBoolExp = {
  _and?: InputMaybe<Array<InsertListingCombinedReviewsBoolExp>>;
  _not?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  _or?: InputMaybe<Array<InsertListingCombinedReviewsBoolExp>>;
  display_name?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingStringComparisonExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  profile_image_url?: InputMaybe<InsertListingStringComparisonExp>;
  rating?: InputMaybe<InsertListingIntComparisonExp>;
  review_date?: InputMaybe<InsertListingStringComparisonExp>;
  review_text?: InputMaybe<InsertListingStringComparisonExp>;
  review_url?: InputMaybe<InsertListingStringComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingCombinedReviewsInsertInput = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_date?: InputMaybe<Scalars['String']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingCombinedReviewsSelectColumn {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewDate = 'review_date',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingCommissionsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingCommissionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingCommissionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingCommissionsAggregateBoolExpCount>;
};

export type InsertListingCommissionsAggregateBoolExpBoolAnd = {
  arguments: InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCommissionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCommissionsAggregateBoolExpBoolOr = {
  arguments: InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCommissionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingCommissionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingCommissionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingCommissionsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingCommissionsArrRelInsertInput = {
  data: Array<InsertListingCommissionsInsertInput>;
  on_conflict?: InputMaybe<InsertListingCommissionsOnConflict>;
};

export type InsertListingCommissionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingCommissionsBoolExp>>;
  _not?: InputMaybe<InsertListingCommissionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingCommissionsBoolExp>>;
  amount?: InputMaybe<InsertListingFloatComparisonExp>;
  beneficiary_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  contact?: InputMaybe<InsertListingUsersBoolExp>;
  contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_paid?: InputMaybe<InsertListingBooleanComparisonExp>;
  payment_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  property_transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  vat?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingCommissionsConstraint {
  /** unique or primary key constraint on columns "id" */
  CommissionsPkey = 'commissions_pkey',
  /** unique or primary key constraint on columns "property_transaction_id", "type" */
  IdxPropertyTransactionCommissionTotal = 'idx_property_transaction_commission_total'
}

export type InsertListingCommissionsInsertInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beneficiary_team_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingCommissionsOnConflict = {
  constraint: InsertListingCommissionsConstraint;
  update_columns: Array<InsertListingCommissionsUpdateColumn>;
  where?: InputMaybe<InsertListingCommissionsBoolExp>;
};

export enum InsertListingCommissionsSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  Vat = 'vat'
}

export enum InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPaid = 'is_paid'
}

export enum InsertListingCommissionsSelectColumnCommissionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPaid = 'is_paid'
}

export enum InsertListingCommissionsUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  Vat = 'vat'
}

export enum InsertListingCoolingEnumEnum {
  AirConditioning = 'air_conditioning',
  CeilingFans = 'ceiling_fans',
  None = 'none'
}

export type InsertListingCoolingEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingCoolingEnumEnum>;
  _in?: InputMaybe<Array<InsertListingCoolingEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingCoolingEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingCoolingEnumEnum>>;
};

export type InsertListingCurrenciesComparisonExp = {
  _eq?: InputMaybe<Scalars['currencies']['input']>;
  _gt?: InputMaybe<Scalars['currencies']['input']>;
  _gte?: InputMaybe<Scalars['currencies']['input']>;
  _in?: InputMaybe<Array<Scalars['currencies']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['currencies']['input']>;
  _lte?: InputMaybe<Scalars['currencies']['input']>;
  _neq?: InputMaybe<Scalars['currencies']['input']>;
  _nin?: InputMaybe<Array<Scalars['currencies']['input']>>;
};

export type InsertListingDateComparisonExp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

export type InsertListingDevelopmentImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExpCount>;
};

export type InsertListingDevelopmentImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDevelopmentImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDevelopmentImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingDevelopmentImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingDevelopmentImagesArrRelInsertInput = {
  data: Array<InsertListingDevelopmentImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingDevelopmentImagesOnConflict>;
};

export type InsertListingDevelopmentImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingDevelopmentImagesBoolExp>>;
  _not?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingDevelopmentImagesBoolExp>>;
  background_color?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  crop?: InputMaybe<InsertListingStringComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  display_on_brochure?: InputMaybe<InsertListingBooleanComparisonExp>;
  display_on_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  size?: InputMaybe<InsertListingStringComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDevelopmentImagesConstraint {
  /** unique or primary key constraint on columns "development_id", "image_id" */
  DevelopmentImagesDevelopmentIdImageIdUnique = 'development_images_development_id_image_id_unique',
  /** unique or primary key constraint on columns "order_nr", "development_id" */
  DevelopmentImagesDevelopmentIdOrderNrUnique = 'development_images_development_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  DevelopmentImagesPkey = 'development_images_pkey'
}

export type InsertListingDevelopmentImagesInsertInput = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDevelopmentImagesOnConflict = {
  constraint: InsertListingDevelopmentImagesConstraint;
  update_columns: Array<InsertListingDevelopmentImagesUpdateColumn>;
  where?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
};

export enum InsertListingDevelopmentImagesSelectColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing'
}

export enum InsertListingDevelopmentImagesSelectColumnDevelopmentImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing'
}

export enum InsertListingDevelopmentImagesUpdateColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingDevelopmentMappingsAggregateBoolExp = {
  count?: InputMaybe<InsertListingDevelopmentMappingsAggregateBoolExpCount>;
};

export type InsertListingDevelopmentMappingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingDevelopmentMappingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingDevelopmentMappingsArrRelInsertInput = {
  data: Array<InsertListingDevelopmentMappingsInsertInput>;
  on_conflict?: InputMaybe<InsertListingDevelopmentMappingsOnConflict>;
};

export type InsertListingDevelopmentMappingsBoolExp = {
  _and?: InputMaybe<Array<InsertListingDevelopmentMappingsBoolExp>>;
  _not?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
  _or?: InputMaybe<Array<InsertListingDevelopmentMappingsBoolExp>>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  svg_path?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingDevelopmentMappingsConstraint {
  /** unique or primary key constraint on columns "image_id", "lot_id" */
  DevelopmentMappingsPkey = 'development_mappings_pkey'
}

export type InsertListingDevelopmentMappingsInsertInput = {
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  svg_path?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingDevelopmentMappingsOnConflict = {
  constraint: InsertListingDevelopmentMappingsConstraint;
  update_columns: Array<InsertListingDevelopmentMappingsUpdateColumn>;
  where?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
};

export enum InsertListingDevelopmentMappingsSelectColumn {
  /** column name */
  ImageId = 'image_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SvgPath = 'svg_path',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingDevelopmentMappingsUpdateColumn {
  /** column name */
  ImageId = 'image_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SvgPath = 'svg_path',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingDevelopmentsBoolExp = {
  _and?: InputMaybe<Array<InsertListingDevelopmentsBoolExp>>;
  _not?: InputMaybe<InsertListingDevelopmentsBoolExp>;
  _or?: InputMaybe<Array<InsertListingDevelopmentsBoolExp>>;
  architect_id?: InputMaybe<InsertListingUuidComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  delivery_date?: InputMaybe<InsertListingDateComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  developer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  development_images?: InputMaybe<InsertListingDevelopmentImagesBoolExp>;
  development_images_aggregate?: InputMaybe<InsertListingDevelopmentImagesAggregateBoolExp>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  email_templates_aggregate?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExp>;
  enquiry_response_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  enquiry_response_override_lot?: InputMaybe<InsertListingBooleanComparisonExp>;
  general_contractor_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_published?: InputMaybe<InsertListingBooleanComparisonExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  mapping_image?: InputMaybe<InsertListingImagesBoolExp>;
  mapping_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  registration_type?: InputMaybe<InsertListingStringComparisonExp>;
  response_sender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  slug?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDevelopmentsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DevelopmentsIdTenantIdUnique = 'developments_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  DevelopmentsPkey = 'developments_pkey',
  /** unique or primary key constraint on columns "slug", "tenant_id" */
  DevelopmentsSlugTenantIdUnique = 'developments_slug_tenant_id_unique'
}

export type InsertListingDevelopmentsInsertInput = {
  architect_id?: InputMaybe<Scalars['uuid']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developer_id?: InputMaybe<Scalars['uuid']['input']>;
  development_images?: InputMaybe<InsertListingDevelopmentImagesArrRelInsertInput>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesArrRelInsertInput>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_override_lot?: InputMaybe<Scalars['Boolean']['input']>;
  general_contractor_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  mapping_image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  mapping_image_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_type?: InputMaybe<Scalars['String']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDevelopmentsObjRelInsertInput = {
  data: InsertListingDevelopmentsInsertInput;
  on_conflict?: InputMaybe<InsertListingDevelopmentsOnConflict>;
};

export type InsertListingDevelopmentsOnConflict = {
  constraint: InsertListingDevelopmentsConstraint;
  update_columns: Array<InsertListingDevelopmentsUpdateColumn>;
  where?: InputMaybe<InsertListingDevelopmentsBoolExp>;
};

export enum InsertListingDevelopmentsUpdateColumn {
  /** column name */
  ArchitectId = 'architect_id',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Description = 'description',
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  EnquiryResponseOverrideLot = 'enquiry_response_override_lot',
  /** column name */
  GeneralContractorId = 'general_contractor_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  MappingImageId = 'mapping_image_id',
  /** column name */
  RegistrationType = 'registration_type',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingDictionariesBoolExp = {
  _and?: InputMaybe<Array<InsertListingDictionariesBoolExp>>;
  _not?: InputMaybe<InsertListingDictionariesBoolExp>;
  _or?: InputMaybe<Array<InsertListingDictionariesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  dictionaries_types?: InputMaybe<InsertListingDictionariesTypesEnumBoolExp>;
  group?: InputMaybe<InsertListingDictionariesBoolExp>;
  group_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_deletable?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_used?: InputMaybe<InsertListingBooleanComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingDictionariesTypesEnumEnumComparisonExp>;
  types?: InputMaybe<InsertListingStringArrayComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDictionariesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DictionariesIdTenantIdUnique = 'dictionaries_id_tenant_id_unique',
  /** unique or primary key constraint on columns "type", "name" */
  DictionariesNameTypeKey = 'dictionaries_name_type_key',
  /** unique or primary key constraint on columns "type", "tenant_id", "name" */
  DictionariesNameTypeTenantIdKey = 'dictionaries_name_type_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DictionariesPkey = 'dictionaries_pkey'
}

export type InsertListingDictionariesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  dictionaries_types?: InputMaybe<InsertListingDictionariesTypesEnumObjRelInsertInput>;
  group?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<InsertListingDictionariesTypesEnumEnum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDictionariesObjRelInsertInput = {
  data: InsertListingDictionariesInsertInput;
  on_conflict?: InputMaybe<InsertListingDictionariesOnConflict>;
};

export type InsertListingDictionariesOnConflict = {
  constraint: InsertListingDictionariesConstraint;
  update_columns: Array<InsertListingDictionariesUpdateColumn>;
  where?: InputMaybe<InsertListingDictionariesBoolExp>;
};

export type InsertListingDictionariesTypesEnumBoolExp = {
  _and?: InputMaybe<Array<InsertListingDictionariesTypesEnumBoolExp>>;
  _not?: InputMaybe<InsertListingDictionariesTypesEnumBoolExp>;
  _or?: InputMaybe<Array<InsertListingDictionariesTypesEnumBoolExp>>;
  comment?: InputMaybe<InsertListingStringComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  value?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingDictionariesTypesEnumConstraint {
  /** unique or primary key constraint on columns "value" */
  DictionariesTypesEnumPkey = 'dictionaries_types_enum_pkey'
}

export enum InsertListingDictionariesTypesEnumEnum {
  /** Certifications available for users */
  Certifications = 'certifications',
  DocumentTypeGroups = 'document_type_groups',
  Documents = 'documents',
  Enums = 'enums',
  Languages = 'languages',
  LeadRefusedTypes = 'lead_refused_types',
  LeadSourceTypes = 'lead_source_types',
  LotOriginTypes = 'lot_origin_types',
  MandateProbabilityTypes = 'mandate_probability_types',
  MembershipTypes = 'membership_types',
  NationalityTypes = 'nationality_types',
  OccupationTypes = 'occupation_types',
  OfferRefusedTypes = 'offer_refused_types',
  Services = 'services',
  StringFilters = 'string_filters',
  TagsTypes = 'tags_types',
  WorkPermitTypes = 'work_permit_types'
}

export type InsertListingDictionariesTypesEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingDictionariesTypesEnumEnum>;
  _in?: InputMaybe<Array<InsertListingDictionariesTypesEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingDictionariesTypesEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingDictionariesTypesEnumEnum>>;
};

export type InsertListingDictionariesTypesEnumInsertInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingDictionariesTypesEnumObjRelInsertInput = {
  data: InsertListingDictionariesTypesEnumInsertInput;
  on_conflict?: InputMaybe<InsertListingDictionariesTypesEnumOnConflict>;
};

export type InsertListingDictionariesTypesEnumOnConflict = {
  constraint: InsertListingDictionariesTypesEnumConstraint;
  update_columns: Array<InsertListingDictionariesTypesEnumUpdateColumn>;
  where?: InputMaybe<InsertListingDictionariesTypesEnumBoolExp>;
};

export enum InsertListingDictionariesTypesEnumUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export enum InsertListingDictionariesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeletable = 'is_deletable',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingDocTemplateTypeEnumBoolExp = {
  _and?: InputMaybe<Array<InsertListingDocTemplateTypeEnumBoolExp>>;
  _not?: InputMaybe<InsertListingDocTemplateTypeEnumBoolExp>;
  _or?: InputMaybe<Array<InsertListingDocTemplateTypeEnumBoolExp>>;
  value?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingDocTemplateTypeEnumConstraint {
  /** unique or primary key constraint on columns "value" */
  DocTemplateTypeEnumPkey = 'doc_template_type_enum_pkey'
}

export enum InsertListingDocTemplateTypeEnumEnum {
  AppraisalReport = 'appraisal_report',
  CmaReport = 'cma_report',
  DevelopmentBrochure = 'development_brochure',
  FinancingPassport = 'financing_passport',
  LotBrochure = 'lot_brochure',
  Mandate = 'mandate'
}

export type InsertListingDocTemplateTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingDocTemplateTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingDocTemplateTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingDocTemplateTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingDocTemplateTypeEnumEnum>>;
};

export type InsertListingDocTemplateTypeEnumInsertInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingDocTemplateTypeEnumObjRelInsertInput = {
  data: InsertListingDocTemplateTypeEnumInsertInput;
  on_conflict?: InputMaybe<InsertListingDocTemplateTypeEnumOnConflict>;
};

export type InsertListingDocTemplateTypeEnumOnConflict = {
  constraint: InsertListingDocTemplateTypeEnumConstraint;
  update_columns: Array<InsertListingDocTemplateTypeEnumUpdateColumn>;
  where?: InputMaybe<InsertListingDocTemplateTypeEnumBoolExp>;
};

export enum InsertListingDocTemplateTypeEnumUpdateColumn {
  /** column name */
  Value = 'value'
}

export type InsertListingDocTemplatesBoolExp = {
  _and?: InputMaybe<Array<InsertListingDocTemplatesBoolExp>>;
  _not?: InputMaybe<InsertListingDocTemplatesBoolExp>;
  _or?: InputMaybe<Array<InsertListingDocTemplatesBoolExp>>;
  active?: InputMaybe<InsertListingBooleanComparisonExp>;
  content?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_tenant?: InputMaybe<InsertListingReadOnlyTenantsBoolExp>;
  doc_template_type_enum?: InputMaybe<InsertListingDocTemplateTypeEnumBoolExp>;
  doc_templates_tenants?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  doc_templates_tenants_aggregate?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExp>;
  filename_template?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  translations?: InputMaybe<InsertListingJsonbComparisonExp>;
  type?: InputMaybe<InsertListingDocTemplateTypeEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDocTemplatesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DocTemplatesIdTenantIdUnique = 'doc_templates_id_tenant_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "name" */
  DocTemplatesNameTenantIdUnique = 'doc_templates_name_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesPkey = 'doc_templates_pkey'
}

export type InsertListingDocTemplatesInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_tenant?: InputMaybe<InsertListingReadOnlyTenantsObjRelInsertInput>;
  doc_template_type_enum?: InputMaybe<InsertListingDocTemplateTypeEnumObjRelInsertInput>;
  doc_templates_tenants?: InputMaybe<InsertListingDocTemplatesTenantsArrRelInsertInput>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<InsertListingDocTemplateTypeEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDocTemplatesObjRelInsertInput = {
  data: InsertListingDocTemplatesInsertInput;
  on_conflict?: InputMaybe<InsertListingDocTemplatesOnConflict>;
};

export type InsertListingDocTemplatesOnConflict = {
  constraint: InsertListingDocTemplatesConstraint;
  update_columns: Array<InsertListingDocTemplatesUpdateColumn>;
  where?: InputMaybe<InsertListingDocTemplatesBoolExp>;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingDocTemplatesTenantsAggregateBoolExpCount>;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExpBoolAnd = {
  arguments: InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExpBoolOr = {
  arguments: InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingDocTemplatesTenantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingDocTemplatesTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingDocTemplatesTenantsArrRelInsertInput = {
  data: Array<InsertListingDocTemplatesTenantsInsertInput>;
  on_conflict?: InputMaybe<InsertListingDocTemplatesTenantsOnConflict>;
};

export type InsertListingDocTemplatesTenantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingDocTemplatesTenantsBoolExp>>;
  _not?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingDocTemplatesTenantsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  doc_template?: InputMaybe<InsertListingDocTemplatesBoolExp>;
  doc_template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_default?: InputMaybe<InsertListingBooleanComparisonExp>;
  tenant?: InputMaybe<InsertListingReadOnlyTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingDocTemplatesTenantsConstraint {
  /** unique or primary key constraint on columns "doc_template_id", "tenant_id" */
  DocTemplatesTenantsDocTemplateIdTenantIdKey = 'doc_templates_tenants_doc_template_id_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesTenantsPkey = 'doc_templates_tenants_pkey'
}

export type InsertListingDocTemplatesTenantsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template?: InputMaybe<InsertListingDocTemplatesObjRelInsertInput>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<InsertListingReadOnlyTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingDocTemplatesTenantsOnConflict = {
  constraint: InsertListingDocTemplatesTenantsConstraint;
  update_columns: Array<InsertListingDocTemplatesTenantsUpdateColumn>;
  where?: InputMaybe<InsertListingDocTemplatesTenantsBoolExp>;
};

export enum InsertListingDocTemplatesTenantsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsDefault = 'is_default'
}

export enum InsertListingDocTemplatesTenantsSelectColumnDocTemplatesTenantsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsDefault = 'is_default'
}

export enum InsertListingDocTemplatesTenantsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingDocTemplatesUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FilenameTemplate = 'filename_template',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailCampaignsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailCampaignsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailCampaignsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailCampaignsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingEmailCampaignsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EmailCampaignsIdTenantIdUnique = 'email_campaigns_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  EmailCampaignsPkey = 'email_campaigns_pkey'
}

export type InsertListingEmailCampaignsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingEmailCampaignsObjRelInsertInput = {
  data: InsertListingEmailCampaignsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailCampaignsOnConflict>;
};

export type InsertListingEmailCampaignsOnConflict = {
  constraint: InsertListingEmailCampaignsConstraint;
  update_columns: Array<InsertListingEmailCampaignsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailCampaignsBoolExp>;
};

export enum InsertListingEmailCampaignsStatusEnumEnum {
  Done = 'done',
  Pending = 'pending'
}

export type InsertListingEmailCampaignsStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailCampaignsStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailCampaignsStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailCampaignsStatusEnumEnum>>;
};

export enum InsertListingEmailCampaignsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailMessagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEmailMessagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEmailMessagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEmailMessagesAggregateBoolExpCount>;
};

export type InsertListingEmailMessagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailMessagesAggregateBoolExpBoolOr = {
  arguments: InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailMessagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailMessagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailMessagesArrRelInsertInput = {
  data: Array<InsertListingEmailMessagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailMessagesOnConflict>;
};

export type InsertListingEmailMessagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailMessagesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailMessagesBoolExp>>;
  account_id?: InputMaybe<InsertListingStringComparisonExp>;
  activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  bcc?: InputMaybe<InsertListingJsonbComparisonExp>;
  body_template?: InputMaybe<InsertListingStringComparisonExp>;
  campaign_id?: InputMaybe<InsertListingUuidComparisonExp>;
  cc?: InputMaybe<InsertListingJsonbComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email_campaign?: InputMaybe<InsertListingEmailCampaignsBoolExp>;
  email_sequences_step?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  email_thread?: InputMaybe<InsertListingEmailThreadsBoolExp>;
  error_message?: InputMaybe<InsertListingStringComparisonExp>;
  events?: InputMaybe<InsertListingJsonbComparisonExp>;
  files?: InputMaybe<InsertListingJsonbComparisonExp>;
  from?: InputMaybe<InsertListingJsonbComparisonExp>;
  from_crm?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_sent?: InputMaybe<InsertListingBooleanComparisonExp>;
  labels?: InputMaybe<InsertListingJsonbComparisonExp>;
  message_id?: InputMaybe<InsertListingStringComparisonExp>;
  nylas_thread_id?: InputMaybe<InsertListingStringComparisonExp>;
  opens?: InputMaybe<InsertListingBooleanComparisonExp>;
  reply_to?: InputMaybe<InsertListingJsonbComparisonExp>;
  reply_to_message_id?: InputMaybe<InsertListingStringComparisonExp>;
  sequences_recipient_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sequences_step_id?: InputMaybe<InsertListingUuidComparisonExp>;
  snippet?: InputMaybe<InsertListingStringComparisonExp>;
  starred?: InputMaybe<InsertListingBooleanComparisonExp>;
  status?: InputMaybe<InsertListingStringComparisonExp>;
  status_code?: InputMaybe<InsertListingStringComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  subject_template?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  thread_id?: InputMaybe<InsertListingUuidComparisonExp>;
  to?: InputMaybe<InsertListingJsonbComparisonExp>;
  unread?: InputMaybe<InsertListingBooleanComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingEmailMessagesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EmailMessagesIdTenantIdUnique = 'email_messages_id_tenant_id_unique',
  /** unique or primary key constraint on columns "created_by", "message_id" */
  EmailMessagesMessageIdCreatedByUnique = 'email_messages_message_id_created_by_unique',
  /** unique or primary key constraint on columns "id" */
  EmailMessagesPkey = 'email_messages_pkey',
  /** unique or primary key constraint on columns "sequences_recipient_id", "sequences_step_id" */
  EmailMessagesSequencesStepIdSequencesRecipientIdKey = 'email_messages_sequences_step_id_sequences_recipient_id_key'
}

export type InsertListingEmailMessagesInsertInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  activity?: InputMaybe<InsertListingActivitiesObjRelInsertInput>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  body_template?: InputMaybe<Scalars['String']['input']>;
  campaign_id?: InputMaybe<Scalars['uuid']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  date?: InputMaybe<Scalars['timestamptz']['input']>;
  email_campaign?: InputMaybe<InsertListingEmailCampaignsObjRelInsertInput>;
  email_sequences_step?: InputMaybe<InsertListingEmailSequencesStepsObjRelInsertInput>;
  email_thread?: InputMaybe<InsertListingEmailThreadsObjRelInsertInput>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['jsonb']['input']>;
  files?: InputMaybe<Scalars['jsonb']['input']>;
  from?: InputMaybe<Scalars['jsonb']['input']>;
  from_crm?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_sent?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  message_id?: InputMaybe<Scalars['String']['input']>;
  nylas_thread_id?: InputMaybe<Scalars['String']['input']>;
  opens?: InputMaybe<Scalars['Boolean']['input']>;
  reply_to?: InputMaybe<Scalars['jsonb']['input']>;
  reply_to_message_id?: InputMaybe<Scalars['String']['input']>;
  sequences_recipient_id?: InputMaybe<Scalars['uuid']['input']>;
  sequences_step_id?: InputMaybe<Scalars['uuid']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_code?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_template?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  thread_id?: InputMaybe<Scalars['uuid']['input']>;
  to?: InputMaybe<Scalars['jsonb']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingEmailMessagesObjRelInsertInput = {
  data: InsertListingEmailMessagesInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailMessagesOnConflict>;
};

export type InsertListingEmailMessagesOnConflict = {
  constraint: InsertListingEmailMessagesConstraint;
  update_columns: Array<InsertListingEmailMessagesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailMessagesBoolExp>;
};

export enum InsertListingEmailMessagesSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  BodyTemplate = 'body_template',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Events = 'events',
  /** column name */
  Files = 'files',
  /** column name */
  From = 'from',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  Id = 'id',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Labels = 'labels',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NylasThreadId = 'nylas_thread_id',
  /** column name */
  Opens = 'opens',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReplyToMessageId = 'reply_to_message_id',
  /** column name */
  SequencesRecipientId = 'sequences_recipient_id',
  /** column name */
  SequencesStepId = 'sequences_step_id',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  To = 'to',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

export enum InsertListingEmailMessagesSelectColumnEmailMessagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

export enum InsertListingEmailMessagesUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  BodyTemplate = 'body_template',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Events = 'events',
  /** column name */
  Files = 'files',
  /** column name */
  From = 'from',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  Id = 'id',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Labels = 'labels',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NylasThreadId = 'nylas_thread_id',
  /** column name */
  Opens = 'opens',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReplyToMessageId = 'reply_to_message_id',
  /** column name */
  SequencesRecipientId = 'sequences_recipient_id',
  /** column name */
  SequencesStepId = 'sequences_step_id',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  To = 'to',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailSequencesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailSequencesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailSequencesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailSequencesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  email_sequences_recipients?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
  email_sequences_recipients_aggregate?: InputMaybe<InsertListingEmailSequencesRecipientsAggregateBoolExp>;
  email_sequences_steps?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  email_sequences_steps_aggregate?: InputMaybe<InsertListingEmailSequencesStepsAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_shared_with_everyone?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_shared_with_team?: InputMaybe<InsertListingBooleanComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingEmailSequencesStatusEnumEnumComparisonExp>;
  stop_after_reply?: InputMaybe<InsertListingBooleanComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingEmailSequencesConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailSequencesPkey = 'email_sequences_pkey'
}

export type InsertListingEmailSequencesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  email_sequences_recipients?: InputMaybe<InsertListingEmailSequencesRecipientsArrRelInsertInput>;
  email_sequences_steps?: InputMaybe<InsertListingEmailSequencesStepsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InsertListingEmailSequencesStatusEnumEnum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingEmailSequencesObjRelInsertInput = {
  data: InsertListingEmailSequencesInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailSequencesOnConflict>;
};

export type InsertListingEmailSequencesOnConflict = {
  constraint: InsertListingEmailSequencesConstraint;
  update_columns: Array<InsertListingEmailSequencesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailSequencesBoolExp>;
};

export type InsertListingEmailSequencesRecipientsAggregateBoolExp = {
  count?: InputMaybe<InsertListingEmailSequencesRecipientsAggregateBoolExpCount>;
};

export type InsertListingEmailSequencesRecipientsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailSequencesRecipientsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailSequencesRecipientsArrRelInsertInput = {
  data: Array<InsertListingEmailSequencesRecipientsInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailSequencesRecipientsOnConflict>;
};

export type InsertListingEmailSequencesRecipientsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailSequencesRecipientsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailSequencesRecipientsBoolExp>>;
  buyer_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesBoolExp>;
  email_sequence_id?: InputMaybe<InsertListingUuidComparisonExp>;
  from_user?: InputMaybe<InsertListingUsersBoolExp>;
  from_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  last_step_number?: InputMaybe<InsertListingSmallintComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingEmailSequencesRecipientsConstraint {
  /** unique or primary key constraint on columns "buyer_lead_id", "user_id", "email_sequence_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdBuyerLead = 'email_sequences_recipients_email_sequence_id_user_id_buyer_lead',
  /** unique or primary key constraint on columns "user_id", "email_sequence_id", "lead_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLeadIdKe = 'email_sequences_recipients_email_sequence_id_user_id_lead_id_ke',
  /** unique or primary key constraint on columns "user_id", "email_sequence_id", "lot_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLotIdKey = 'email_sequences_recipients_email_sequence_id_user_id_lot_id_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesRecipientsPkey = 'email_sequences_recipients_pkey'
}

export type InsertListingEmailSequencesRecipientsInsertInput = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesObjRelInsertInput>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_step_number?: InputMaybe<Scalars['smallint']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingEmailSequencesRecipientsOnConflict = {
  constraint: InsertListingEmailSequencesRecipientsConstraint;
  update_columns: Array<InsertListingEmailSequencesRecipientsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailSequencesRecipientsBoolExp>;
};

export enum InsertListingEmailSequencesRecipientsSelectColumn {
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStepNumber = 'last_step_number',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingEmailSequencesRecipientsStatusEnumEnum {
  /** Active */
  Active = 'active',
  /** Stopped */
  Stopped = 'stopped'
}

export type InsertListingEmailSequencesRecipientsStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailSequencesRecipientsStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailSequencesRecipientsStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailSequencesRecipientsStatusEnumEnum>>;
};

export enum InsertListingEmailSequencesRecipientsUpdateColumn {
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStepNumber = 'last_step_number',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingEmailSequencesStatusEnumEnum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

export type InsertListingEmailSequencesStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailSequencesStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailSequencesStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailSequencesStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailSequencesStatusEnumEnum>>;
};

export type InsertListingEmailSequencesStepsAggregateBoolExp = {
  count?: InputMaybe<InsertListingEmailSequencesStepsAggregateBoolExpCount>;
};

export type InsertListingEmailSequencesStepsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailSequencesStepsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailSequencesStepsArrRelInsertInput = {
  data: Array<InsertListingEmailSequencesStepsInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailSequencesStepsOnConflict>;
};

export type InsertListingEmailSequencesStepsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailSequencesStepsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailSequencesStepsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  delay?: InputMaybe<InsertListingSmallintComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesBoolExp>;
  email_sequence_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_template?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  number?: InputMaybe<InsertListingSmallintComparisonExp>;
  template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingEmailSequencesStepsConstraint {
  /** unique or primary key constraint on columns "email_sequence_id", "number" */
  EmailSequencesStepsEmailSequenceIdNumberKey = 'email_sequences_steps_email_sequence_id_number_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesStepsPkey = 'email_sequences_steps_pkey'
}

export type InsertListingEmailSequencesStepsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  email_sequence?: InputMaybe<InsertListingEmailSequencesObjRelInsertInput>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  email_template?: InputMaybe<InsertListingEmailTemplatesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingEmailSequencesStepsObjRelInsertInput = {
  data: InsertListingEmailSequencesStepsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailSequencesStepsOnConflict>;
};

export type InsertListingEmailSequencesStepsOnConflict = {
  constraint: InsertListingEmailSequencesStepsConstraint;
  update_columns: Array<InsertListingEmailSequencesStepsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailSequencesStepsBoolExp>;
};

export enum InsertListingEmailSequencesStepsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingEmailSequencesStepsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingEmailSequencesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithTeam = 'is_shared_with_team',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StopAfterReply = 'stop_after_reply',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingEmailTemplateComparisonExp = {
  _eq?: InputMaybe<Scalars['email_template']['input']>;
  _gt?: InputMaybe<Scalars['email_template']['input']>;
  _gte?: InputMaybe<Scalars['email_template']['input']>;
  _in?: InputMaybe<Array<Scalars['email_template']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['email_template']['input']>;
  _lte?: InputMaybe<Scalars['email_template']['input']>;
  _neq?: InputMaybe<Scalars['email_template']['input']>;
  _nin?: InputMaybe<Array<Scalars['email_template']['input']>>;
};

export type InsertListingEmailTemplatesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExpCount>;
};

export type InsertListingEmailTemplatesAggregateBoolExpBoolAnd = {
  arguments: InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailTemplatesAggregateBoolExpBoolOr = {
  arguments: InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailTemplatesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailTemplatesArrRelInsertInput = {
  data: Array<InsertListingEmailTemplatesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailTemplatesOnConflict>;
};

export type InsertListingEmailTemplatesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailTemplatesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailTemplatesBoolExp>>;
  add_signature?: InputMaybe<InsertListingBooleanComparisonExp>;
  bcc?: InputMaybe<InsertListingJsonbComparisonExp>;
  cc?: InputMaybe<InsertListingJsonbComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  development?: InputMaybe<InsertListingDevelopmentsBoolExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_templates_files?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
  email_templates_files_aggregate?: InputMaybe<InsertListingEmailTemplatesFilesAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_shared?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_shared_with_everyone?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_shared_with_organisation?: InputMaybe<InsertListingBooleanComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  subject_plaintext?: InputMaybe<InsertListingStringComparisonExp>;
  target?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  text?: InputMaybe<InsertListingStringComparisonExp>;
  text_html?: InputMaybe<InsertListingStringComparisonExp>;
  text_plaintext?: InputMaybe<InsertListingStringComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingEmailTemplatesConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailTemplatesPkey = 'email_templates_pkey'
}

export type InsertListingEmailTemplatesFilesAggregateBoolExp = {
  count?: InputMaybe<InsertListingEmailTemplatesFilesAggregateBoolExpCount>;
};

export type InsertListingEmailTemplatesFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailTemplatesFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailTemplatesFilesArrRelInsertInput = {
  data: Array<InsertListingEmailTemplatesFilesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailTemplatesFilesOnConflict>;
};

export type InsertListingEmailTemplatesFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailTemplatesFilesBoolExp>>;
  _not?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailTemplatesFilesBoolExp>>;
  email_template?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  email_template_id?: InputMaybe<InsertListingUuidComparisonExp>;
  file?: InputMaybe<InsertListingFilesBoolExp>;
  file_id?: InputMaybe<InsertListingUuidComparisonExp>;
  nylas_file_id?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingEmailTemplatesFilesConstraint {
  /** unique or primary key constraint on columns "email_template_id", "file_id" */
  EmailTemplatesFilesPkey = 'email_templates_files_pkey'
}

export type InsertListingEmailTemplatesFilesInsertInput = {
  email_template?: InputMaybe<InsertListingEmailTemplatesObjRelInsertInput>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<InsertListingFilesObjRelInsertInput>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_file_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingEmailTemplatesFilesOnConflict = {
  constraint: InsertListingEmailTemplatesFilesConstraint;
  update_columns: Array<InsertListingEmailTemplatesFilesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailTemplatesFilesBoolExp>;
};

export enum InsertListingEmailTemplatesFilesSelectColumn {
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  NylasFileId = 'nylas_file_id',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingEmailTemplatesFilesUpdateColumn {
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  NylasFileId = 'nylas_file_id',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingEmailTemplatesInsertInput = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development?: InputMaybe<InsertListingDevelopmentsObjRelInsertInput>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  email_templates_files?: InputMaybe<InsertListingEmailTemplatesFilesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingEmailTemplatesObjRelInsertInput = {
  data: InsertListingEmailTemplatesInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailTemplatesOnConflict>;
};

export type InsertListingEmailTemplatesOnConflict = {
  constraint: InsertListingEmailTemplatesConstraint;
  update_columns: Array<InsertListingEmailTemplatesUpdateColumn>;
  where?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
};

export enum InsertListingEmailTemplatesSelectColumn {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation'
}

export enum InsertListingEmailTemplatesSelectColumnEmailTemplatesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation'
}

export enum InsertListingEmailTemplatesTargetEnumEnum {
  /** Sequence */
  Sequence = 'sequence',
  /** Standalone */
  Standalone = 'standalone'
}

export type InsertListingEmailTemplatesTargetEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEmailTemplatesTargetEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEmailTemplatesTargetEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEmailTemplatesTargetEnumEnum>>;
};

export enum InsertListingEmailTemplatesUpdateColumn {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingEmailThreadsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailThreadsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailThreadsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailThreadsBoolExp>>;
  account_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  draft_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  drafts?: InputMaybe<InsertListingJsonbComparisonExp>;
  email_messages?: InputMaybe<InsertListingEmailMessagesBoolExp>;
  email_messages_aggregate?: InputMaybe<InsertListingEmailMessagesAggregateBoolExp>;
  first_message_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  from_crm?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_attachments?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  initial_nylas_message_id?: InputMaybe<InsertListingStringComparisonExp>;
  labels?: InputMaybe<InsertListingJsonbComparisonExp>;
  last_message_received_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_message_sent_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_message_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  message_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  messages?: InputMaybe<InsertListingJsonbComparisonExp>;
  participants?: InputMaybe<InsertListingJsonbComparisonExp>;
  snippet?: InputMaybe<InsertListingStringComparisonExp>;
  starred?: InputMaybe<InsertListingBooleanComparisonExp>;
  subject?: InputMaybe<InsertListingStringComparisonExp>;
  thread_id?: InputMaybe<InsertListingStringComparisonExp>;
  unread?: InputMaybe<InsertListingBooleanComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  version?: InputMaybe<InsertListingIntComparisonExp>;
  visibility?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingEmailThreadsConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailThreadsPkey = 'email_threads_pkey',
  /** unique or primary key constraint on columns "thread_id", "user_id" */
  EmailThreadsThreadIdUserIdUnique = 'email_threads_thread_id_user_id_unique'
}

export type InsertListingEmailThreadsInsertInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  draft_ids?: InputMaybe<Scalars['jsonb']['input']>;
  drafts?: InputMaybe<Scalars['jsonb']['input']>;
  email_messages?: InputMaybe<InsertListingEmailMessagesArrRelInsertInput>;
  first_message_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  from_crm?: InputMaybe<Scalars['Boolean']['input']>;
  has_attachments?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  initial_nylas_message_id?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  last_message_received_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  last_message_sent_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  last_message_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  message_ids?: InputMaybe<Scalars['jsonb']['input']>;
  messages?: InputMaybe<Scalars['jsonb']['input']>;
  participants?: InputMaybe<Scalars['jsonb']['input']>;
  snippet?: InputMaybe<Scalars['String']['input']>;
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingEmailThreadsObjRelInsertInput = {
  data: InsertListingEmailThreadsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailThreadsOnConflict>;
};

export type InsertListingEmailThreadsOnConflict = {
  constraint: InsertListingEmailThreadsConstraint;
  update_columns: Array<InsertListingEmailThreadsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailThreadsBoolExp>;
};

export enum InsertListingEmailThreadsUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DraftIds = 'draft_ids',
  /** column name */
  Drafts = 'drafts',
  /** column name */
  FirstMessageTimestamp = 'first_message_timestamp',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  HasAttachments = 'has_attachments',
  /** column name */
  Id = 'id',
  /** column name */
  InitialNylasMessageId = 'initial_nylas_message_id',
  /** column name */
  Labels = 'labels',
  /** column name */
  LastMessageReceivedTimestamp = 'last_message_received_timestamp',
  /** column name */
  LastMessageSentTimestamp = 'last_message_sent_timestamp',
  /** column name */
  LastMessageTimestamp = 'last_message_timestamp',
  /** column name */
  MessageIds = 'message_ids',
  /** column name */
  Messages = 'messages',
  /** column name */
  Participants = 'participants',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Subject = 'subject',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Version = 'version',
  /** column name */
  Visibility = 'visibility'
}

export type InsertListingEmailsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEmailsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEmailsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEmailsAggregateBoolExpCount>;
};

export type InsertListingEmailsAggregateBoolExpBoolAnd = {
  arguments: InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailsAggregateBoolExpBoolOr = {
  arguments: InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEmailsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEmailsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEmailsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEmailsArrRelInsertInput = {
  data: Array<InsertListingEmailsInsertInput>;
  on_conflict?: InputMaybe<InsertListingEmailsOnConflict>;
};

export type InsertListingEmailsBoolExp = {
  _and?: InputMaybe<Array<InsertListingEmailsBoolExp>>;
  _not?: InputMaybe<InsertListingEmailsBoolExp>;
  _or?: InputMaybe<Array<InsertListingEmailsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email?: InputMaybe<InsertListingCitextComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  subscription?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  subscriptions_aggregate?: InputMaybe<InsertListingSubscriptionsAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
};

export enum InsertListingEmailsConstraint {
  /** unique or primary key constraint on columns "id" */
  EmailsPkey = 'emails_pkey',
  /** unique or primary key constraint on columns "tenant_id", "email" */
  EmailsTenantIdEmailUnique = 'emails_tenant_id_email_unique',
  /** unique or primary key constraint on columns "user_id", "tenant_id", "verified", "email" */
  EmailsUserIdTenantIdEmailVerifiedUnique = 'emails_user_id_tenant_id_email_verified_unique'
}

export type InsertListingEmailsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  subscription?: InputMaybe<InsertListingSubscriptionsObjRelInsertInput>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingEmailsObjRelInsertInput = {
  data: InsertListingEmailsInsertInput;
  on_conflict?: InputMaybe<InsertListingEmailsOnConflict>;
};

export type InsertListingEmailsOnConflict = {
  constraint: InsertListingEmailsConstraint;
  update_columns: Array<InsertListingEmailsUpdateColumn>;
  where?: InputMaybe<InsertListingEmailsBoolExp>;
};

export enum InsertListingEmailsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEmailsSelectColumnEmailsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEmailsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingEnergyClassTypeEnumEnum {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  NotSet = 'not_set'
}

export type InsertListingEnergyClassTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingEnergyClassTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingEnergyClassTypeEnumEnum>>;
};

export type InsertListingEnquiriesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingEnquiriesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingEnquiriesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingEnquiriesAggregateBoolExpCount>;
};

export type InsertListingEnquiriesAggregateBoolExpBoolAnd = {
  arguments: InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEnquiriesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEnquiriesAggregateBoolExpBoolOr = {
  arguments: InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEnquiriesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingEnquiriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingEnquiriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingEnquiriesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingEnquiriesArrRelInsertInput = {
  data: Array<InsertListingEnquiriesInsertInput>;
  on_conflict?: InputMaybe<InsertListingEnquiriesOnConflict>;
};

export type InsertListingEnquiriesBoolExp = {
  _and?: InputMaybe<Array<InsertListingEnquiriesBoolExp>>;
  _not?: InputMaybe<InsertListingEnquiriesBoolExp>;
  _or?: InputMaybe<Array<InsertListingEnquiriesBoolExp>>;
  address?: InputMaybe<InsertListingStringComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  call_times?: InputMaybe<InsertListingStringArrayComparisonExp>;
  contact_reason?: InputMaybe<InsertListingStringComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  development_registration_form_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_address?: InputMaybe<InsertListingStringComparisonExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  has_conflict?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_invalid_input?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  language?: InputMaybe<InsertListingUserLanguageComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  listing_link?: InputMaybe<InsertListingStringComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  matched_email_user?: InputMaybe<InsertListingUsersBoolExp>;
  matched_phone_user?: InputMaybe<InsertListingUsersBoolExp>;
  message?: InputMaybe<InsertListingStringComparisonExp>;
  neverbounce_result?: InputMaybe<InsertListingStringComparisonExp>;
  object_ref?: InputMaybe<InsertListingStringComparisonExp>;
  original_enquiry_id?: InputMaybe<InsertListingUuidComparisonExp>;
  phone_number?: InputMaybe<InsertListingStringComparisonExp>;
  portal?: InputMaybe<InsertListingPortalsBoolExp>;
  portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  processed?: InputMaybe<InsertListingBooleanComparisonExp>;
  property_search_notification?: InputMaybe<InsertListingPropertySearchesNotificationComparisonExp>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  raw_email?: InputMaybe<InsertListingStringComparisonExp>;
  raw_email_address?: InputMaybe<InsertListingStringComparisonExp>;
  raw_phone_number?: InputMaybe<InsertListingStringComparisonExp>;
  response_activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  response_activity_id?: InputMaybe<InsertListingUuidComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  source_email_id?: InputMaybe<InsertListingStringComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_email_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_phone_id?: InputMaybe<InsertListingUuidComparisonExp>;
  visit_date?: InputMaybe<InsertListingTimestampComparisonExp>;
};

export enum InsertListingEnquiriesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EnquiriesIdTenantIdUnique = 'enquiries_id_tenant_id_unique',
  /** unique or primary key constraint on columns "source_email_id" */
  EnquiriesSourceEmailIdUnique = 'enquiries_source_email_id_unique',
  /** unique or primary key constraint on columns "id" */
  InquiriesPkey = 'inquiries_pkey'
}

export type InsertListingEnquiriesInsertInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead?: InputMaybe<InsertListingBuyerLeadsObjRelInsertInput>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  contact_reason?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_registration_form_id?: InputMaybe<Scalars['uuid']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_conflict?: InputMaybe<Scalars['Boolean']['input']>;
  has_invalid_input?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  listing_link?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  matched_email_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  matched_phone_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  object_ref?: InputMaybe<Scalars['String']['input']>;
  original_enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<InsertListingPortalsObjRelInsertInput>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  raw_email?: InputMaybe<Scalars['String']['input']>;
  raw_email_address?: InputMaybe<Scalars['String']['input']>;
  raw_phone_number?: InputMaybe<Scalars['String']['input']>;
  response_activity?: InputMaybe<InsertListingActivitiesObjRelInsertInput>;
  response_activity_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source_email_id?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_email_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_id?: InputMaybe<Scalars['uuid']['input']>;
  visit_date?: InputMaybe<Scalars['timestamp']['input']>;
};

export type InsertListingEnquiriesObjRelInsertInput = {
  data: InsertListingEnquiriesInsertInput;
  on_conflict?: InputMaybe<InsertListingEnquiriesOnConflict>;
};

export type InsertListingEnquiriesOnConflict = {
  constraint: InsertListingEnquiriesConstraint;
  update_columns: Array<InsertListingEnquiriesUpdateColumn>;
  where?: InputMaybe<InsertListingEnquiriesBoolExp>;
};

export enum InsertListingEnquiriesSelectColumn {
  /** column name */
  Address = 'address',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  ContactReason = 'contact_reason',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentRegistrationFormId = 'development_registration_form_id',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ListingLink = 'listing_link',
  /** column name */
  Locality = 'locality',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Message = 'message',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  ObjectRef = 'object_ref',
  /** column name */
  OriginalEnquiryId = 'original_enquiry_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  RawEmail = 'raw_email',
  /** column name */
  RawEmailAddress = 'raw_email_address',
  /** column name */
  RawPhoneNumber = 'raw_phone_number',
  /** column name */
  ResponseActivityId = 'response_activity_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SourceEmailId = 'source_email_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmailId = 'user_email_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneId = 'user_phone_id',
  /** column name */
  VisitDate = 'visit_date'
}

export enum InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

export enum InsertListingEnquiriesSelectColumnEnquiriesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

export enum InsertListingEnquiriesUpdateColumn {
  /** column name */
  Address = 'address',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  ContactReason = 'contact_reason',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentRegistrationFormId = 'development_registration_form_id',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ListingLink = 'listing_link',
  /** column name */
  Locality = 'locality',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Message = 'message',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  ObjectRef = 'object_ref',
  /** column name */
  OriginalEnquiryId = 'original_enquiry_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  RawEmail = 'raw_email',
  /** column name */
  RawEmailAddress = 'raw_email_address',
  /** column name */
  RawPhoneNumber = 'raw_phone_number',
  /** column name */
  ResponseActivityId = 'response_activity_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  SourceEmailId = 'source_email_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmailId = 'user_email_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneId = 'user_phone_id',
  /** column name */
  VisitDate = 'visit_date'
}

export type InsertListingFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingFilesBoolExp>>;
  _not?: InputMaybe<InsertListingFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingFilesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  document_type?: InputMaybe<InsertListingDictionariesBoolExp>;
  document_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  mimetype?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  size?: InputMaybe<InsertListingIntComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  uploader?: InputMaybe<InsertListingUsersBoolExp>;
  uploader_id?: InputMaybe<InsertListingUuidComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingFilesConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  FilesIdTenantIdUnique = 'files_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

export type InsertListingFilesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploader?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  uploader_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingFilesObjRelInsertInput = {
  data: InsertListingFilesInsertInput;
  on_conflict?: InputMaybe<InsertListingFilesOnConflict>;
};

export type InsertListingFilesOnConflict = {
  constraint: InsertListingFilesConstraint;
  update_columns: Array<InsertListingFilesUpdateColumn>;
  where?: InputMaybe<InsertListingFilesBoolExp>;
};

export enum InsertListingFilesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  Url = 'url'
}

export type InsertListingFinancingPassportsAggregateBoolExp = {
  avg?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpAvg>;
  corr?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExpVarSamp>;
};

export type InsertListingFinancingPassportsAggregateBoolExpAvg = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCorr = {
  arguments: InsertListingFinancingPassportsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCorrArguments = {
  X: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingFinancingPassportsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingFinancingPassportsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCovarSamp = {
  arguments: InsertListingFinancingPassportsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpCovarSampArguments = {
  X: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingFinancingPassportsAggregateBoolExpMax = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpMin = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpStddevSamp = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpSum = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsAggregateBoolExpVarSamp = {
  arguments: InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingFinancingPassportsArrRelInsertInput = {
  data: Array<InsertListingFinancingPassportsInsertInput>;
  on_conflict?: InputMaybe<InsertListingFinancingPassportsOnConflict>;
};

export type InsertListingFinancingPassportsBoolExp = {
  _and?: InputMaybe<Array<InsertListingFinancingPassportsBoolExp>>;
  _not?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  _or?: InputMaybe<Array<InsertListingFinancingPassportsBoolExp>>;
  amount?: InputMaybe<InsertListingFloat8ComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  document_url?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  source?: InputMaybe<InsertListingStringComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingFinancingPassportsConstraint {
  /** unique or primary key constraint on columns "id" */
  FinancingPassportsPkey = 'financing_passports_pkey'
}

export type InsertListingFinancingPassportsInsertInput = {
  amount?: InputMaybe<Scalars['float8']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  document_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingFinancingPassportsOnConflict = {
  constraint: InsertListingFinancingPassportsConstraint;
  update_columns: Array<InsertListingFinancingPassportsUpdateColumn>;
  where?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
};

export enum InsertListingFinancingPassportsSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Source = 'source',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsSelectColumnFinancingPassportsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  Amount = 'amount'
}

export enum InsertListingFinancingPassportsUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DocumentUrl = 'document_url',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Source = 'source',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingFloat8ArrayComparisonExp = {
  _contained_in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _contains?: InputMaybe<Array<Scalars['float8']['input']>>;
  _eq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _lte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _neq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
};

export type InsertListingFloat8ComparisonExp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type InsertListingFloatComparisonExp = {
  _eq?: InputMaybe<Scalars['Float']['input']>;
  _gt?: InputMaybe<Scalars['Float']['input']>;
  _gte?: InputMaybe<Scalars['Float']['input']>;
  _in?: InputMaybe<Array<Scalars['Float']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Float']['input']>;
  _lte?: InputMaybe<Scalars['Float']['input']>;
  _neq?: InputMaybe<Scalars['Float']['input']>;
  _nin?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type InsertListingGeographyCastExp = {
  geometry?: InputMaybe<InsertListingGeometryComparisonExp>;
};

export type InsertListingGeographyComparisonExp = {
  _cast?: InputMaybe<InsertListingGeographyCastExp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  _st_d_within?: InputMaybe<InsertListingStDWithinGeographyInput>;
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type InsertListingGeometryCastExp = {
  geography?: InputMaybe<InsertListingGeographyComparisonExp>;
};

export type InsertListingGeometryComparisonExp = {
  _cast?: InputMaybe<InsertListingGeometryCastExp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _st_3d_d_within?: InputMaybe<InsertListingStDWithinInput>;
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  _st_d_within?: InputMaybe<InsertListingStDWithinInput>;
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type InsertListingGoogleAddressesBoolExp = {
  _and?: InputMaybe<Array<InsertListingGoogleAddressesBoolExp>>;
  _not?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  _or?: InputMaybe<Array<InsertListingGoogleAddressesBoolExp>>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  ctn?: InputMaybe<InsertListingStringComparisonExp>;
  formatted_address?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  place_type?: InputMaybe<InsertListingStringComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingGoogleAddressesConstraint {
  /** unique or primary key constraint on columns "id" */
  GoogleAddressesPkey = 'google_addresses_pkey'
}

export type InsertListingGoogleAddressesInsertInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingGoogleAddressesObjRelInsertInput = {
  data: InsertListingGoogleAddressesInsertInput;
  on_conflict?: InputMaybe<InsertListingGoogleAddressesOnConflict>;
};

export type InsertListingGoogleAddressesOnConflict = {
  constraint: InsertListingGoogleAddressesConstraint;
  update_columns: Array<InsertListingGoogleAddressesUpdateColumn>;
  where?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
};

export enum InsertListingGoogleAddressesUpdateColumn {
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Route = 'route',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingGoogleReviewsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExpCount>;
};

export type InsertListingGoogleReviewsAggregateBoolExpBoolAnd = {
  arguments: InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingGoogleReviewsAggregateBoolExpBoolOr = {
  arguments: InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingGoogleReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingGoogleReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingGoogleReviewsArrRelInsertInput = {
  data: Array<InsertListingGoogleReviewsInsertInput>;
  on_conflict?: InputMaybe<InsertListingGoogleReviewsOnConflict>;
};

export type InsertListingGoogleReviewsBoolExp = {
  _and?: InputMaybe<Array<InsertListingGoogleReviewsBoolExp>>;
  _not?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  _or?: InputMaybe<Array<InsertListingGoogleReviewsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_timestamp?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  local_guide?: InputMaybe<InsertListingBooleanComparisonExp>;
  original_owner_answer?: InputMaybe<InsertListingStringComparisonExp>;
  original_review_text?: InputMaybe<InsertListingStringComparisonExp>;
  owner_answer?: InputMaybe<InsertListingStringComparisonExp>;
  profile_image_url?: InputMaybe<InsertListingStringComparisonExp>;
  profile_name?: InputMaybe<InsertListingStringComparisonExp>;
  profile_url?: InputMaybe<InsertListingStringComparisonExp>;
  rating?: InputMaybe<InsertListingIntComparisonExp>;
  review_text?: InputMaybe<InsertListingStringComparisonExp>;
  review_url?: InputMaybe<InsertListingStringComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingGoogleReviewsConstraint {
  /** unique or primary key constraint on columns "id" */
  GoogleReviewsPkey = 'google_reviews_pkey',
  /** unique or primary key constraint on columns "profile_url", "team_id" */
  GoogleReviewsTeamIdProfileUrlKey = 'google_reviews_team_id_profile_url_key'
}

export type InsertListingGoogleReviewsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  local_guide?: InputMaybe<Scalars['Boolean']['input']>;
  original_owner_answer?: InputMaybe<Scalars['String']['input']>;
  original_review_text?: InputMaybe<Scalars['String']['input']>;
  owner_answer?: InputMaybe<Scalars['String']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  profile_name?: InputMaybe<Scalars['String']['input']>;
  profile_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingGoogleReviewsOnConflict = {
  constraint: InsertListingGoogleReviewsConstraint;
  update_columns: Array<InsertListingGoogleReviewsUpdateColumn>;
  where?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
};

export enum InsertListingGoogleReviewsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTimestamp = 'google_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LocalGuide = 'local_guide',
  /** column name */
  OriginalOwnerAnswer = 'original_owner_answer',
  /** column name */
  OriginalReviewText = 'original_review_text',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ProfileUrl = 'profile_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  LocalGuide = 'local_guide'
}

export enum InsertListingGoogleReviewsSelectColumnGoogleReviewsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  LocalGuide = 'local_guide'
}

export enum InsertListingGoogleReviewsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTimestamp = 'google_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LocalGuide = 'local_guide',
  /** column name */
  OriginalOwnerAnswer = 'original_owner_answer',
  /** column name */
  OriginalReviewText = 'original_review_text',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ProfileUrl = 'profile_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingHeatingDistributionEnumEnum {
  Floor = 'floor',
  ForcedAir = 'forced_air',
  Other = 'other',
  Radiators = 'radiators',
  Stove = 'stove'
}

export type InsertListingHeatingDistributionEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingHeatingDistributionEnumEnum>;
  _in?: InputMaybe<Array<InsertListingHeatingDistributionEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingHeatingDistributionEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingHeatingDistributionEnumEnum>>;
};

export enum InsertListingHeatingEnumEnum {
  Central = 'central',
  District = 'district',
  Electric = 'electric',
  Gas = 'gas',
  HeatPump = 'heat_pump',
  None = 'none',
  Oil = 'oil',
  Other = 'other',
  Pellet = 'pellet',
  Solar = 'solar',
  Wood = 'wood'
}

export type InsertListingHeatingEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingHeatingEnumEnum>;
  _in?: InputMaybe<Array<InsertListingHeatingEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingHeatingEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingHeatingEnumEnum>>;
};

export type InsertListingImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingImagesBoolExp>>;
  _not?: InputMaybe<InsertListingImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingImagesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
  user_images?: InputMaybe<InsertListingUserImagesBoolExp>;
  user_images_aggregate?: InputMaybe<InsertListingUserImagesAggregateBoolExp>;
};

export enum InsertListingImagesConstraint {
  /** unique or primary key constraint on columns "id" */
  ImagesPkey = 'images_pkey'
}

export type InsertListingImagesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_images?: InputMaybe<InsertListingUserImagesArrRelInsertInput>;
};

export type InsertListingImagesObjRelInsertInput = {
  data: InsertListingImagesInsertInput;
  on_conflict?: InputMaybe<InsertListingImagesOnConflict>;
};

export type InsertListingImagesOnConflict = {
  constraint: InsertListingImagesConstraint;
  update_columns: Array<InsertListingImagesUpdateColumn>;
  where?: InputMaybe<InsertListingImagesBoolExp>;
};

export enum InsertListingImagesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

export type InsertListingIntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InsertListingInvoiceStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['invoice_status']['input']>;
  _gt?: InputMaybe<Scalars['invoice_status']['input']>;
  _gte?: InputMaybe<Scalars['invoice_status']['input']>;
  _in?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['invoice_status']['input']>;
  _lte?: InputMaybe<Scalars['invoice_status']['input']>;
  _neq?: InputMaybe<Scalars['invoice_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
};

export type InsertListingInvoicesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingInvoicesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingInvoicesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingInvoicesAggregateBoolExpCount>;
};

export type InsertListingInvoicesAggregateBoolExpBoolAnd = {
  arguments: InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingInvoicesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingInvoicesAggregateBoolExpBoolOr = {
  arguments: InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingInvoicesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingInvoicesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingInvoicesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingInvoicesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingInvoicesArrRelInsertInput = {
  data: Array<InsertListingInvoicesInsertInput>;
  on_conflict?: InputMaybe<InsertListingInvoicesOnConflict>;
};

export type InsertListingInvoicesBoolExp = {
  _and?: InputMaybe<Array<InsertListingInvoicesBoolExp>>;
  _not?: InputMaybe<InsertListingInvoicesBoolExp>;
  _or?: InputMaybe<Array<InsertListingInvoicesBoolExp>>;
  account_country?: InputMaybe<InsertListingStringComparisonExp>;
  account_name?: InputMaybe<InsertListingStringComparisonExp>;
  account_tax_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  amount_due?: InputMaybe<InsertListingIntComparisonExp>;
  amount_paid?: InputMaybe<InsertListingIntComparisonExp>;
  amount_remaining?: InputMaybe<InsertListingIntComparisonExp>;
  application_fee_amount?: InputMaybe<InsertListingIntComparisonExp>;
  attempt_count?: InputMaybe<InsertListingIntComparisonExp>;
  attempted?: InputMaybe<InsertListingBooleanComparisonExp>;
  auto_advance?: InputMaybe<InsertListingBooleanComparisonExp>;
  billing_reason?: InputMaybe<InsertListingStringComparisonExp>;
  charge?: InputMaybe<InsertListingStringComparisonExp>;
  collection_method?: InputMaybe<InsertListingStringComparisonExp>;
  created?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  currency?: InputMaybe<InsertListingStringComparisonExp>;
  custom_fields?: InputMaybe<InsertListingJsonbComparisonExp>;
  customer?: InputMaybe<InsertListingStringComparisonExp>;
  customer_address?: InputMaybe<InsertListingJsonbComparisonExp>;
  customer_email_raw?: InputMaybe<InsertListingStringComparisonExp>;
  customer_name?: InputMaybe<InsertListingStringComparisonExp>;
  customer_phone?: InputMaybe<InsertListingStringComparisonExp>;
  customer_shipping?: InputMaybe<InsertListingJsonbComparisonExp>;
  customer_tax_exempt?: InputMaybe<InsertListingStringComparisonExp>;
  customer_tax_ids?: InputMaybe<InsertListingJsonbComparisonExp>;
  default_payment_method?: InputMaybe<InsertListingStringComparisonExp>;
  default_source?: InputMaybe<InsertListingStringComparisonExp>;
  default_tax_rates?: InputMaybe<InsertListingJsonbComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  discounts?: InputMaybe<InsertListingJsonbComparisonExp>;
  due_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  ending_balance?: InputMaybe<InsertListingIntComparisonExp>;
  footer?: InputMaybe<InsertListingStringComparisonExp>;
  hosted_invoice_url?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  invoice_object?: InputMaybe<InsertListingJsonbComparisonExp>;
  invoice_pdf?: InputMaybe<InsertListingStringComparisonExp>;
  last_finalization_error?: InputMaybe<InsertListingJsonbComparisonExp>;
  lines?: InputMaybe<InsertListingJsonbComparisonExp>;
  livemode?: InputMaybe<InsertListingBooleanComparisonExp>;
  metadata?: InputMaybe<InsertListingJsonbComparisonExp>;
  next_payment_attempt?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  number?: InputMaybe<InsertListingStringComparisonExp>;
  on_behalf_of?: InputMaybe<InsertListingStringComparisonExp>;
  paid?: InputMaybe<InsertListingBooleanComparisonExp>;
  payment_intent?: InputMaybe<InsertListingStringComparisonExp>;
  payment_settings?: InputMaybe<InsertListingJsonbComparisonExp>;
  period_end?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  period_start?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  post_payment_credit_notes_amount?: InputMaybe<InsertListingIntComparisonExp>;
  pre_payment_credit_notes_amount?: InputMaybe<InsertListingIntComparisonExp>;
  receipt_number?: InputMaybe<InsertListingStringComparisonExp>;
  starting_balance?: InputMaybe<InsertListingIntComparisonExp>;
  statement_descriptor?: InputMaybe<InsertListingStringComparisonExp>;
  status?: InputMaybe<InsertListingInvoiceStatusComparisonExp>;
  status_transitions?: InputMaybe<InsertListingJsonbComparisonExp>;
  stripe_id?: InputMaybe<InsertListingStringComparisonExp>;
  subscription?: InputMaybe<InsertListingStringComparisonExp>;
  subscription_proration_date?: InputMaybe<InsertListingIntComparisonExp>;
  subtotal?: InputMaybe<InsertListingIntComparisonExp>;
  tax?: InputMaybe<InsertListingIntComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  threshold_reason?: InputMaybe<InsertListingJsonbComparisonExp>;
  total?: InputMaybe<InsertListingIntComparisonExp>;
  total_discount_amounts?: InputMaybe<InsertListingJsonbComparisonExp>;
  total_tax_amounts?: InputMaybe<InsertListingJsonbComparisonExp>;
  transfer_data?: InputMaybe<InsertListingJsonbComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  webhooks_delivered_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingInvoicesConstraint {
  /** unique or primary key constraint on columns "id" */
  InvoicesPkey = 'invoices_pkey',
  /** unique or primary key constraint on columns "stripe_id" */
  InvoicesStripeIdUnique = 'invoices_stripe_id_unique'
}

export type InsertListingInvoicesInsertInput = {
  account_country?: InputMaybe<Scalars['String']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  amount_due?: InputMaybe<Scalars['Int']['input']>;
  amount_paid?: InputMaybe<Scalars['Int']['input']>;
  amount_remaining?: InputMaybe<Scalars['Int']['input']>;
  application_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  attempted?: InputMaybe<Scalars['Boolean']['input']>;
  auto_advance?: InputMaybe<Scalars['Boolean']['input']>;
  billing_reason?: InputMaybe<Scalars['String']['input']>;
  charge?: InputMaybe<Scalars['String']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_address?: InputMaybe<Scalars['jsonb']['input']>;
  customer_email_raw?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_phone?: InputMaybe<Scalars['String']['input']>;
  customer_shipping?: InputMaybe<Scalars['jsonb']['input']>;
  customer_tax_exempt?: InputMaybe<Scalars['String']['input']>;
  customer_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Scalars['jsonb']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  ending_balance?: InputMaybe<Scalars['Int']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  hosted_invoice_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_object?: InputMaybe<Scalars['jsonb']['input']>;
  invoice_pdf?: InputMaybe<Scalars['String']['input']>;
  last_finalization_error?: InputMaybe<Scalars['jsonb']['input']>;
  lines?: InputMaybe<Scalars['jsonb']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_payment_attempt?: InputMaybe<Scalars['timestamptz']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  on_behalf_of?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_settings?: InputMaybe<Scalars['jsonb']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  post_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  pre_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  receipt_number?: InputMaybe<Scalars['String']['input']>;
  starting_balance?: InputMaybe<Scalars['Int']['input']>;
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['invoice_status']['input']>;
  status_transitions?: InputMaybe<Scalars['jsonb']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Scalars['String']['input']>;
  subscription_proration_date?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  threshold_reason?: InputMaybe<Scalars['jsonb']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_discount_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  total_tax_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  webhooks_delivered_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingInvoicesOnConflict = {
  constraint: InsertListingInvoicesConstraint;
  update_columns: Array<InsertListingInvoicesUpdateColumn>;
  where?: InputMaybe<InsertListingInvoicesBoolExp>;
};

export enum InsertListingInvoicesSelectColumn {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountTaxIds = 'account_tax_ids',
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  ApplicationFeeAmount = 'application_fee_amount',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  BillingReason = 'billing_reason',
  /** column name */
  Charge = 'charge',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerAddress = 'customer_address',
  /** column name */
  CustomerEmailRaw = 'customer_email_raw',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerPhone = 'customer_phone',
  /** column name */
  CustomerShipping = 'customer_shipping',
  /** column name */
  CustomerTaxExempt = 'customer_tax_exempt',
  /** column name */
  CustomerTaxIds = 'customer_tax_ids',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Description = 'description',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  Footer = 'footer',
  /** column name */
  HostedInvoiceUrl = 'hosted_invoice_url',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceObject = 'invoice_object',
  /** column name */
  InvoicePdf = 'invoice_pdf',
  /** column name */
  LastFinalizationError = 'last_finalization_error',
  /** column name */
  Lines = 'lines',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPaymentAttempt = 'next_payment_attempt',
  /** column name */
  Number = 'number',
  /** column name */
  OnBehalfOf = 'on_behalf_of',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentIntent = 'payment_intent',
  /** column name */
  PaymentSettings = 'payment_settings',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PostPaymentCreditNotesAmount = 'post_payment_credit_notes_amount',
  /** column name */
  PrePaymentCreditNotesAmount = 'pre_payment_credit_notes_amount',
  /** column name */
  ReceiptNumber = 'receipt_number',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StatementDescriptor = 'statement_descriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StatusTransitions = 'status_transitions',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  Subscription = 'subscription',
  /** column name */
  SubscriptionProrationDate = 'subscription_proration_date',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThresholdReason = 'threshold_reason',
  /** column name */
  Total = 'total',
  /** column name */
  TotalDiscountAmounts = 'total_discount_amounts',
  /** column name */
  TotalTaxAmounts = 'total_tax_amounts',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebhooksDeliveredAt = 'webhooks_delivered_at'
}

export enum InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

export enum InsertListingInvoicesSelectColumnInvoicesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

export enum InsertListingInvoicesUpdateColumn {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountTaxIds = 'account_tax_ids',
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  ApplicationFeeAmount = 'application_fee_amount',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  BillingReason = 'billing_reason',
  /** column name */
  Charge = 'charge',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerAddress = 'customer_address',
  /** column name */
  CustomerEmailRaw = 'customer_email_raw',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerPhone = 'customer_phone',
  /** column name */
  CustomerShipping = 'customer_shipping',
  /** column name */
  CustomerTaxExempt = 'customer_tax_exempt',
  /** column name */
  CustomerTaxIds = 'customer_tax_ids',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Description = 'description',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  Footer = 'footer',
  /** column name */
  HostedInvoiceUrl = 'hosted_invoice_url',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceObject = 'invoice_object',
  /** column name */
  InvoicePdf = 'invoice_pdf',
  /** column name */
  LastFinalizationError = 'last_finalization_error',
  /** column name */
  Lines = 'lines',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPaymentAttempt = 'next_payment_attempt',
  /** column name */
  Number = 'number',
  /** column name */
  OnBehalfOf = 'on_behalf_of',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentIntent = 'payment_intent',
  /** column name */
  PaymentSettings = 'payment_settings',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PostPaymentCreditNotesAmount = 'post_payment_credit_notes_amount',
  /** column name */
  PrePaymentCreditNotesAmount = 'pre_payment_credit_notes_amount',
  /** column name */
  ReceiptNumber = 'receipt_number',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StatementDescriptor = 'statement_descriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StatusTransitions = 'status_transitions',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  Subscription = 'subscription',
  /** column name */
  SubscriptionProrationDate = 'subscription_proration_date',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThresholdReason = 'threshold_reason',
  /** column name */
  Total = 'total',
  /** column name */
  TotalDiscountAmounts = 'total_discount_amounts',
  /** column name */
  TotalTaxAmounts = 'total_tax_amounts',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebhooksDeliveredAt = 'webhooks_delivered_at'
}

export type InsertListingJsonbArrayComparisonExp = {
  _contained_in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _contains?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _eq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _lte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _neq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
};

export type InsertListingJsonbCastExp = {
  String?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingJsonbComparisonExp = {
  _cast?: InputMaybe<InsertListingJsonbCastExp>;
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  _has_key?: InputMaybe<Scalars['String']['input']>;
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export enum InsertListingLeadAgentSourceEnumEnum {
  Automation = 'automation',
  Crm = 'crm',
  ResultPage = 'result_page'
}

export type InsertListingLeadAgentSourceEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadAgentSourceEnumEnum>;
  _in?: InputMaybe<Array<InsertListingLeadAgentSourceEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadAgentSourceEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadAgentSourceEnumEnum>>;
};

export type InsertListingLeadAgentsAggregateBoolExp = {
  count?: InputMaybe<InsertListingLeadAgentsAggregateBoolExpCount>;
};

export type InsertListingLeadAgentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadAgentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadAgentsArrRelInsertInput = {
  data: Array<InsertListingLeadAgentsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadAgentsOnConflict>;
};

export type InsertListingLeadAgentsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadAgentsBoolExp>>;
  _not?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadAgentsBoolExp>>;
  claimed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead_stage?: InputMaybe<InsertListingLeadStagesBoolExp>;
  passed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  predicted_win_date?: InputMaybe<InsertListingDateComparisonExp>;
  source?: InputMaybe<InsertListingLeadAgentSourceEnumEnumComparisonExp>;
  stage_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  win_probability?: InputMaybe<InsertListingIntComparisonExp>;
};

export enum InsertListingLeadAgentsConstraint {
  /** unique or primary key constraint on columns "source", "user_id", "lead_id" */
  LeadAgentsLeadIdUserIdSourceKey = 'lead_agents_lead_id_user_id_source_key',
  /** unique or primary key constraint on columns "id" */
  LeadAgentsPkey = 'lead_agents_pkey'
}

export type InsertListingLeadAgentsInsertInput = {
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<InsertListingLeadStagesObjRelInsertInput>;
  passed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  source?: InputMaybe<InsertListingLeadAgentSourceEnumEnum>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertListingLeadAgentsOnConflict = {
  constraint: InsertListingLeadAgentsConstraint;
  update_columns: Array<InsertListingLeadAgentsUpdateColumn>;
  where?: InputMaybe<InsertListingLeadAgentsBoolExp>;
};

export enum InsertListingLeadAgentsSelectColumn {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WinProbability = 'win_probability'
}

export enum InsertListingLeadAgentsUpdateColumn {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WinProbability = 'win_probability'
}

export type InsertListingLeadBuyingStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
};

export type InsertListingLeadLookingPlacesAggregateBoolExp = {
  count?: InputMaybe<InsertListingLeadLookingPlacesAggregateBoolExpCount>;
};

export type InsertListingLeadLookingPlacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadLookingPlacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadLookingPlacesArrRelInsertInput = {
  data: Array<InsertListingLeadLookingPlacesInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadLookingPlacesOnConflict>;
};

export type InsertListingLeadLookingPlacesBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadLookingPlacesBoolExp>>;
  _not?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadLookingPlacesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingLeadLookingPlacesConstraint {
  /** unique or primary key constraint on columns "place_id", "lead_id" */
  LeadLookingPlacesPkey = 'lead_looking_places_pkey'
}

export type InsertListingLeadLookingPlacesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingLeadLookingPlacesOnConflict = {
  constraint: InsertListingLeadLookingPlacesConstraint;
  update_columns: Array<InsertListingLeadLookingPlacesUpdateColumn>;
  where?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
};

export enum InsertListingLeadLookingPlacesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadLookingPlacesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingLeadMortgageStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
};

export type InsertListingLeadOwnershipComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _lte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _neq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
};

export type InsertListingLeadStagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingLeadStagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLeadStagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingLeadStagesAggregateBoolExpCount>;
};

export type InsertListingLeadStagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadStagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadStagesAggregateBoolExpBoolOr = {
  arguments: InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadStagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadStagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadStagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadStagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadStagesArrRelInsertInput = {
  data: Array<InsertListingLeadStagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadStagesOnConflict>;
};

export type InsertListingLeadStagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadStagesBoolExp>>;
  _not?: InputMaybe<InsertListingLeadStagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadStagesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  deletable?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  pipeline?: InputMaybe<InsertListingPipelinesBoolExp>;
  pipeline_id?: InputMaybe<InsertListingUuidComparisonExp>;
  status?: InputMaybe<InsertListingLeadsStatusEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingLeadStagesConstraint {
  /** unique or primary key constraint on columns "order_nr", "pipeline_id" */
  LeadStagesPipelineIdOrderNrUnique = 'lead_stages_pipeline_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  LeadStagesPkey = 'lead_stages_pkey'
}

export type InsertListingLeadStagesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pipeline?: InputMaybe<InsertListingPipelinesObjRelInsertInput>;
  pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<InsertListingLeadsStatusEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingLeadStagesObjRelInsertInput = {
  data: InsertListingLeadStagesInsertInput;
  on_conflict?: InputMaybe<InsertListingLeadStagesOnConflict>;
};

export type InsertListingLeadStagesOnConflict = {
  constraint: InsertListingLeadStagesConstraint;
  update_columns: Array<InsertListingLeadStagesUpdateColumn>;
  where?: InputMaybe<InsertListingLeadStagesBoolExp>;
};

export enum InsertListingLeadStagesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PipelineId = 'pipeline_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Deletable = 'deletable'
}

export enum InsertListingLeadStagesSelectColumnLeadStagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Deletable = 'deletable'
}

export enum InsertListingLeadStagesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PipelineId = 'pipeline_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingLeadTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['lead_type']['input']>;
  _gt?: InputMaybe<Scalars['lead_type']['input']>;
  _gte?: InputMaybe<Scalars['lead_type']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_type']['input']>;
  _lte?: InputMaybe<Scalars['lead_type']['input']>;
  _neq?: InputMaybe<Scalars['lead_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_type']['input']>>;
};

export type InsertListingLeadsAggregateBoolExp = {
  avg?: InputMaybe<InsertListingLeadsAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingLeadsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLeadsAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingLeadsAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingLeadsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingLeadsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingLeadsAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingLeadsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingLeadsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingLeadsAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingLeadsAggregateBoolExpVarSamp>;
};

export type InsertListingLeadsAggregateBoolExpAvg = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpBoolAnd = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpBoolOr = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCorr = {
  arguments: InsertListingLeadsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCorrArguments = {
  X: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingLeadsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCovarSamp = {
  arguments: InsertListingLeadsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpCovarSampArguments = {
  X: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingLeadsSelectColumnLeadsAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingLeadsAggregateBoolExpMax = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpMin = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpStddevSamp = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpSum = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLeadsAggregateBoolExpVarSamp = {
  arguments: InsertListingLeadsSelectColumnLeadsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export enum InsertListingLeadsAppraisalReasonEnum {
  AlreadyForSale = 'already_for_sale',
  BuySoon = 'buy_soon',
  BuyThis = 'buy_this',
  Inheritance = 'inheritance',
  MoveRental = 'move_rental',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Other = 'other',
  OtherNotOwner = 'other_not_owner',
  OtherOwner = 'other_owner',
  OtherRenting = 'other_renting',
  Refinance = 'refinance',
  Sell = 'sell',
  Separation = 'separation'
}

export type InsertListingLeadsAppraisalReasonEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsAppraisalReasonEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsAppraisalReasonEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsAppraisalReasonEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsAppraisalReasonEnum>>;
};

export type InsertListingLeadsArrRelInsertInput = {
  data: Array<InsertListingLeadsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadsOnConflict>;
};

export type InsertListingLeadsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadsBoolExp>>;
  _not?: InputMaybe<InsertListingLeadsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadsBoolExp>>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  affordability_rate?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_premium?: InputMaybe<InsertListingFloat8ComparisonExp>;
  appraisal_inheritance_next_step?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_market_time?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_monthly_gross_rent?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_next_step?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_open_to_offer?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_perceived_value?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_perception?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_balcony_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_building_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_built_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_commercial_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_construction_year?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_country?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_ctn?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_floor_of_flat?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_garden_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  appraisal_property_has_elevator?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_garden?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_storage_room?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_income_includes_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_renovated?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_know_plot_number?: InputMaybe<InsertListingBooleanComparisonExp>;
  appraisal_property_land_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_lat?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_living_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_lng?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_locality?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_number_of_bathrooms?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_bedrooms?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_commercial_units?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_floors?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_residential_units?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_number_of_rooms?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_occupied?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_plot_number?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  appraisal_property_renovation_year?: InputMaybe<InsertListingIntComparisonExp>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_residential_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  appraisal_property_route?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_side?: InputMaybe<InsertListingPropertySideEnumEnumComparisonExp>;
  appraisal_property_state?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_property_usage?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_reason?: InputMaybe<InsertListingLeadsAppraisalReasonEnumComparisonExp>;
  appraisal_selling_with?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_separation_next_step?: InputMaybe<InsertListingStringComparisonExp>;
  appraisal_step?: InputMaybe<InsertListingStringComparisonExp>;
  assets_second_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  assets_third_pillar_a_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  buy_horizon?: InputMaybe<InsertListingLeadsBuyHorizonEnumComparisonExp>;
  call_times?: InputMaybe<InsertListingStringArrayComparisonExp>;
  cma_reports?: InputMaybe<InsertListingCmaReportsBoolExp>;
  cma_reports_aggregate?: InputMaybe<InsertListingCmaReportsAggregateBoolExp>;
  completed?: InputMaybe<InsertListingBooleanComparisonExp>;
  contact?: InputMaybe<InsertListingUsersBoolExp>;
  contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  createdBy?: InputMaybe<InsertListingUsersBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  date_of_birth?: InputMaybe<InsertListingDateComparisonExp>;
  debt?: InputMaybe<InsertListingFloat8ComparisonExp>;
  donation?: InputMaybe<InsertListingFloat8ComparisonExp>;
  email_address?: InputMaybe<InsertListingStringComparisonExp>;
  financing_crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  financing_secured?: InputMaybe<InsertListingBooleanComparisonExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  fund_usage?: InputMaybe<InsertListingFloat8ComparisonExp>;
  gender?: InputMaybe<InsertListingStringComparisonExp>;
  google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  has_accepted_terms?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_dependant_children?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_no_street_number?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_other_credits?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  imported_id?: InputMaybe<InsertListingStringComparisonExp>;
  landing_page_url?: InputMaybe<InsertListingStringComparisonExp>;
  last_activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  last_activity_done_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  last_requalification_mail_sent_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_requalification_sms_sent_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  lead_agents_aggregate?: InputMaybe<InsertListingLeadAgentsAggregateBoolExp>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  lead_looking_places_aggregate?: InputMaybe<InsertListingLeadLookingPlacesAggregateBoolExp>;
  leads_tags?: InputMaybe<InsertListingLeadsTagsBoolExp>;
  leads_tags_aggregate?: InputMaybe<InsertListingLeadsTagsAggregateBoolExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  mandate_probability?: InputMaybe<InsertListingIntComparisonExp>;
  marital_status?: InputMaybe<InsertListingStringComparisonExp>;
  max_property_value?: InputMaybe<InsertListingFloat8ComparisonExp>;
  mortgage_auto_mortgage_type?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_buying_status?: InputMaybe<InsertListingLeadBuyingStatusComparisonExp>;
  mortgage_comments?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_financial_institution?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  mortgage_google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_has_mortgage?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_insurance_provider_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_insurance_revenue?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_interest_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_interest_rate_type?: InputMaybe<InsertListingMortgageInterestRateTypeComparisonExp>;
  mortgage_is_construction?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_is_property_identified?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_lender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_lender_name?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_lender_type?: InputMaybe<InsertListingMortgageLenderTypeComparisonExp>;
  mortgage_mortgage_type?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_notary_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_product_mortgage?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_product_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_property_usage?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_property_value?: InputMaybe<InsertListingFloat8ComparisonExp>;
  mortgage_purchase_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  mortgage_purchase_price?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_real_estate_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  mortgage_report_type?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_revenue?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_sell?: InputMaybe<InsertListingBooleanComparisonExp>;
  mortgage_start_date?: InputMaybe<InsertListingDateComparisonExp>;
  mortgage_status?: InputMaybe<InsertListingLeadMortgageStatusComparisonExp>;
  mortgage_step?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_term?: InputMaybe<InsertListingStringComparisonExp>;
  nationality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  next_activity?: InputMaybe<InsertListingActivitiesBoolExp>;
  next_activity_due_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  number_of_buyers?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_dependant_children?: InputMaybe<InsertListingIntComparisonExp>;
  occupation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  occupation_text?: InputMaybe<InsertListingStringComparisonExp>;
  other_credits?: InputMaybe<InsertListingIntComparisonExp>;
  ownership?: InputMaybe<InsertListingLeadOwnershipComparisonExp>;
  parent_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_annual_premium?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_date_of_birth?: InputMaybe<InsertListingDateComparisonExp>;
  partner_donation?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_first_name?: InputMaybe<InsertListingStringComparisonExp>;
  partner_gender?: InputMaybe<InsertListingStringComparisonExp>;
  partner_has_other_credits?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_has_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_last_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_last_name?: InputMaybe<InsertListingStringComparisonExp>;
  partner_marital_status?: InputMaybe<InsertListingStringComparisonExp>;
  partner_nationality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_occupation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_occupation_text?: InputMaybe<InsertListingStringComparisonExp>;
  partner_other_credits?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_professional_situation?: InputMaybe<InsertListingUserProfessionalSituationComparisonExp>;
  partner_residence_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  partner_residence_state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_savings?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_second_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_third_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_third_pillar_a_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  partner_use_bank_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_use_insurance_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  partner_work_permit_id?: InputMaybe<InsertListingUuidComparisonExp>;
  partner_yearly_revenues?: InputMaybe<InsertListingFloat8ComparisonExp>;
  partner_yearly_revenues_at_retirement?: InputMaybe<InsertListingFloat8ComparisonExp>;
  phone_number?: InputMaybe<InsertListingStringComparisonExp>;
  potential_development?: InputMaybe<InsertListingBooleanComparisonExp>;
  predicted_listing_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  professional_situation?: InputMaybe<InsertListingUserProfessionalSituationComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_search_notification?: InputMaybe<InsertListingPropertySearchesNotificationComparisonExp>;
  property_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  property_usage?: InputMaybe<InsertListingLeadsPropertyUsageEnumComparisonExp>;
  received_mortgage_offer?: InputMaybe<InsertListingBooleanComparisonExp>;
  referrer?: InputMaybe<InsertListingStringComparisonExp>;
  referring_domain?: InputMaybe<InsertListingStringComparisonExp>;
  refused_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  relationship?: InputMaybe<InsertListingLeadsRelationshipEnumComparisonExp>;
  requalification_status?: InputMaybe<InsertListingLeadsRequalificationStatusEnumComparisonExp>;
  requalified_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  requalified_or_created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  residence_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  residence_state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sale_comments?: InputMaybe<InsertListingStringComparisonExp>;
  sale_has_found?: InputMaybe<InsertListingBooleanComparisonExp>;
  sale_horizon?: InputMaybe<InsertListingLeadsSaleHorizonEnumComparisonExp>;
  sale_is_seller?: InputMaybe<InsertListingBooleanComparisonExp>;
  sale_price?: InputMaybe<InsertListingIntComparisonExp>;
  sale_started?: InputMaybe<InsertListingBooleanComparisonExp>;
  savings?: InputMaybe<InsertListingFloat8ComparisonExp>;
  second_contact?: InputMaybe<InsertListingUsersBoolExp>;
  second_contact_id?: InputMaybe<InsertListingUuidComparisonExp>;
  second_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  should_be_requalified?: InputMaybe<InsertListingBooleanComparisonExp>;
  should_send_market_update?: InputMaybe<InsertListingBooleanComparisonExp>;
  snapshot?: InputMaybe<InsertListingJsonbComparisonExp>;
  source?: InputMaybe<InsertListingDictionariesBoolExp>;
  source_id?: InputMaybe<InsertListingUuidComparisonExp>;
  source_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  third_pillar?: InputMaybe<InsertListingFloat8ComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  usable_own_funds?: InputMaybe<InsertListingFloat8ComparisonExp>;
  use_bank_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_insurance_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_second_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_third_pillar?: InputMaybe<InsertListingBooleanComparisonExp>;
  user_info_ip?: InputMaybe<InsertListingStringComparisonExp>;
  user_info_user_agent?: InputMaybe<InsertListingStringComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
  work_permit_id?: InputMaybe<InsertListingUuidComparisonExp>;
  yearly_revenues?: InputMaybe<InsertListingFloat8ComparisonExp>;
  yearly_revenues_at_retirement?: InputMaybe<InsertListingFloat8ComparisonExp>;
};

export enum InsertListingLeadsBuyHorizonEnum {
  NotSet = 'not_set',
  Over_12Months = 'over_12_months',
  Under_3Months = 'under_3_months',
  Under_12Months = 'under_12_months'
}

export type InsertListingLeadsBuyHorizonEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsBuyHorizonEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsBuyHorizonEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsBuyHorizonEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsBuyHorizonEnum>>;
};

export enum InsertListingLeadsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LeadsIdTenantIdUnique = 'leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "imported_id", "tenant_id" */
  LeadsImportedIdTenantIdUnique = 'leads_imported_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  LeadsPkey = 'leads_pkey'
}

export type InsertListingLeadsInsertInput = {
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  annual_premium?: InputMaybe<Scalars['float8']['input']>;
  appraisal_inheritance_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_market_time?: InputMaybe<Scalars['Int']['input']>;
  appraisal_monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  appraisal_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_open_to_offer?: InputMaybe<Scalars['String']['input']>;
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  appraisal_perception?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_building_condition?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_built_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_construction_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_country?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_country_code?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_ctn?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_garden_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_view?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_renovated?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_know_plot_number?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_land_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lat?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_living_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lng?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_locality?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_occupied?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_plot_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_postcode?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_route?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_side?: InputMaybe<InsertListingPropertySideEnumEnum>;
  appraisal_property_state?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_street_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_usage?: InputMaybe<Scalars['String']['input']>;
  appraisal_reason?: InputMaybe<InsertListingLeadsAppraisalReasonEnum>;
  appraisal_selling_with?: InputMaybe<Scalars['String']['input']>;
  appraisal_separation_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_step?: InputMaybe<Scalars['String']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  buy_horizon?: InputMaybe<InsertListingLeadsBuyHorizonEnum>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  cma_reports?: InputMaybe<InsertListingCmaReportsArrRelInsertInput>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  createdBy?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['float8']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  financing_secured?: InputMaybe<Scalars['Boolean']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_dependant_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_no_street_number?: InputMaybe<Scalars['Boolean']['input']>;
  has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  last_activity_done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_requalification_mail_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_requalification_sms_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsArrRelInsertInput>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesArrRelInsertInput>;
  leads_tags?: InputMaybe<InsertListingLeadsTagsArrRelInsertInput>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  mandate_probability?: InputMaybe<Scalars['Int']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  max_property_value?: InputMaybe<Scalars['float8']['input']>;
  mortgage_auto_mortgage_type?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_buying_status?: InputMaybe<Scalars['lead_buying_status']['input']>;
  mortgage_comments?: InputMaybe<Scalars['String']['input']>;
  mortgage_financial_institution?: InputMaybe<Scalars['String']['input']>;
  mortgage_google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  mortgage_google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_has_mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_insurance_provider_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_insurance_revenue?: InputMaybe<Scalars['Float']['input']>;
  mortgage_interest_rate?: InputMaybe<Scalars['Float']['input']>;
  mortgage_interest_rate_type?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  mortgage_is_construction?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_is_property_identified?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_lender_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_lender_name?: InputMaybe<Scalars['String']['input']>;
  mortgage_lender_type?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  mortgage_mortgage_type?: InputMaybe<Scalars['String']['input']>;
  mortgage_notary_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_product_mortgage?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_product_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_property_usage?: InputMaybe<Scalars['String']['input']>;
  mortgage_property_value?: InputMaybe<Scalars['float8']['input']>;
  mortgage_purchase_date?: InputMaybe<Scalars['timestamptz']['input']>;
  mortgage_purchase_price?: InputMaybe<Scalars['Float']['input']>;
  mortgage_real_estate_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  mortgage_report_type?: InputMaybe<Scalars['String']['input']>;
  mortgage_revenue?: InputMaybe<Scalars['Float']['input']>;
  mortgage_sell?: InputMaybe<Scalars['Boolean']['input']>;
  mortgage_start_date?: InputMaybe<Scalars['date']['input']>;
  mortgage_status?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  mortgage_step?: InputMaybe<Scalars['String']['input']>;
  mortgage_term?: InputMaybe<Scalars['String']['input']>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  next_activity_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  other_credits?: InputMaybe<Scalars['Int']['input']>;
  ownership?: InputMaybe<Scalars['lead_ownership']['input']>;
  parent_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_annual_premium?: InputMaybe<Scalars['float8']['input']>;
  partner_date_of_birth?: InputMaybe<Scalars['date']['input']>;
  partner_donation?: InputMaybe<Scalars['float8']['input']>;
  partner_first_name?: InputMaybe<Scalars['String']['input']>;
  partner_gender?: InputMaybe<Scalars['String']['input']>;
  partner_has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  partner_has_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_last_bonus?: InputMaybe<Scalars['float8']['input']>;
  partner_last_name?: InputMaybe<Scalars['String']['input']>;
  partner_marital_status?: InputMaybe<Scalars['String']['input']>;
  partner_nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_text?: InputMaybe<Scalars['String']['input']>;
  partner_other_credits?: InputMaybe<Scalars['float8']['input']>;
  partner_professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  partner_residence_country_code?: InputMaybe<Scalars['String']['input']>;
  partner_residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_savings?: InputMaybe<Scalars['float8']['input']>;
  partner_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  partner_use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  potential_development?: InputMaybe<Scalars['Boolean']['input']>;
  predicted_listing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  property_usage?: InputMaybe<InsertListingLeadsPropertyUsageEnum>;
  received_mortgage_offer?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  refused_at?: InputMaybe<Scalars['timestamptz']['input']>;
  relationship?: InputMaybe<InsertListingLeadsRelationshipEnum>;
  requalification_status?: InputMaybe<InsertListingLeadsRequalificationStatusEnum>;
  requalified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_comments?: InputMaybe<Scalars['String']['input']>;
  sale_has_found?: InputMaybe<Scalars['Boolean']['input']>;
  sale_horizon?: InputMaybe<InsertListingLeadsSaleHorizonEnum>;
  sale_is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Int']['input']>;
  sale_started?: InputMaybe<Scalars['Boolean']['input']>;
  savings?: InputMaybe<Scalars['float8']['input']>;
  second_contact?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  second_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  second_pillar?: InputMaybe<Scalars['float8']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  source?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_own_funds?: InputMaybe<Scalars['float8']['input']>;
  use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_second_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  user_info_ip?: InputMaybe<Scalars['String']['input']>;
  user_info_user_agent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
};

export type InsertListingLeadsObjRelInsertInput = {
  data: InsertListingLeadsInsertInput;
  on_conflict?: InputMaybe<InsertListingLeadsOnConflict>;
};

export type InsertListingLeadsOnConflict = {
  constraint: InsertListingLeadsConstraint;
  update_columns: Array<InsertListingLeadsUpdateColumn>;
  where?: InputMaybe<InsertListingLeadsBoolExp>;
};

export enum InsertListingLeadsPropertyUsageEnum {
  NotSet = 'not_set',
  Other = 'other',
  PrimaryResidence = 'primary_residence',
  RentalProperty = 'rental_property',
  SecondaryResidence = 'secondary_residence'
}

export type InsertListingLeadsPropertyUsageEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsPropertyUsageEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsPropertyUsageEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsPropertyUsageEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsPropertyUsageEnum>>;
};

export enum InsertListingLeadsRelationshipEnum {
  Agent = 'agent',
  Buyer = 'buyer',
  Heir = 'heir',
  NotSet = 'not_set',
  Other = 'other',
  Owner = 'owner',
  Tenant = 'tenant'
}

export type InsertListingLeadsRelationshipEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsRelationshipEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsRelationshipEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsRelationshipEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsRelationshipEnum>>;
};

export enum InsertListingLeadsRequalificationStatusEnum {
  NotSet = 'not_set',
  Started = 'started'
}

export type InsertListingLeadsRequalificationStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsRequalificationStatusEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsRequalificationStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsRequalificationStatusEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsRequalificationStatusEnum>>;
};

export enum InsertListingLeadsSaleHorizonEnum {
  AlreadyForSale = 'already_for_sale',
  From_1To_2Years = 'from_1_to_2_years',
  From_2Years = 'from_2_years',
  From_6To_12Months = 'from_6_to_12_months',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Under_6Months = 'under_6_months'
}

export type InsertListingLeadsSaleHorizonEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsSaleHorizonEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsSaleHorizonEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsSaleHorizonEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsSaleHorizonEnum>>;
};

export enum InsertListingLeadsSelectColumn {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AppraisalInheritanceNextStep = 'appraisal_inheritance_next_step',
  /** column name */
  AppraisalMarketTime = 'appraisal_market_time',
  /** column name */
  AppraisalMonthlyGrossRent = 'appraisal_monthly_gross_rent',
  /** column name */
  AppraisalNextStep = 'appraisal_next_step',
  /** column name */
  AppraisalOpenToOffer = 'appraisal_open_to_offer',
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  AppraisalPerception = 'appraisal_perception',
  /** column name */
  AppraisalPropertyBalconySurface = 'appraisal_property_balcony_surface',
  /** column name */
  AppraisalPropertyBuildingCondition = 'appraisal_property_building_condition',
  /** column name */
  AppraisalPropertyBuiltSurface = 'appraisal_property_built_surface',
  /** column name */
  AppraisalPropertyCommercialPotentialRentalIncome = 'appraisal_property_commercial_potential_rental_income',
  /** column name */
  AppraisalPropertyCommercialSurface = 'appraisal_property_commercial_surface',
  /** column name */
  AppraisalPropertyCommercialYearlyRentalIncome = 'appraisal_property_commercial_yearly_rental_income',
  /** column name */
  AppraisalPropertyConstructionYear = 'appraisal_property_construction_year',
  /** column name */
  AppraisalPropertyCountry = 'appraisal_property_country',
  /** column name */
  AppraisalPropertyCountryCode = 'appraisal_property_country_code',
  /** column name */
  AppraisalPropertyCtn = 'appraisal_property_ctn',
  /** column name */
  AppraisalPropertyFloorOfFlat = 'appraisal_property_floor_of_flat',
  /** column name */
  AppraisalPropertyGardenSurface = 'appraisal_property_garden_surface',
  /** column name */
  AppraisalPropertyGoogleAddressId = 'appraisal_property_google_address_id',
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  AppraisalPropertyLandSurface = 'appraisal_property_land_surface',
  /** column name */
  AppraisalPropertyLat = 'appraisal_property_lat',
  /** column name */
  AppraisalPropertyLivingSurface = 'appraisal_property_living_surface',
  /** column name */
  AppraisalPropertyLng = 'appraisal_property_lng',
  /** column name */
  AppraisalPropertyLocality = 'appraisal_property_locality',
  /** column name */
  AppraisalPropertyNumberOfBathrooms = 'appraisal_property_number_of_bathrooms',
  /** column name */
  AppraisalPropertyNumberOfBedrooms = 'appraisal_property_number_of_bedrooms',
  /** column name */
  AppraisalPropertyNumberOfCommercialUnits = 'appraisal_property_number_of_commercial_units',
  /** column name */
  AppraisalPropertyNumberOfFloors = 'appraisal_property_number_of_floors',
  /** column name */
  AppraisalPropertyNumberOfIndoorParkings = 'appraisal_property_number_of_indoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfOutdoorParkings = 'appraisal_property_number_of_outdoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfResidentialUnits = 'appraisal_property_number_of_residential_units',
  /** column name */
  AppraisalPropertyNumberOfRooms = 'appraisal_property_number_of_rooms',
  /** column name */
  AppraisalPropertyOccupied = 'appraisal_property_occupied',
  /** column name */
  AppraisalPropertyParkingPotentialRentalIncome = 'appraisal_property_parking_potential_rental_income',
  /** column name */
  AppraisalPropertyParkingYearlyRentalIncome = 'appraisal_property_parking_yearly_rental_income',
  /** column name */
  AppraisalPropertyPlotNumber = 'appraisal_property_plot_number',
  /** column name */
  AppraisalPropertyPostcode = 'appraisal_property_postcode',
  /** column name */
  AppraisalPropertyPropertyTypeId = 'appraisal_property_property_type_id',
  /** column name */
  AppraisalPropertyRenovationYear = 'appraisal_property_renovation_year',
  /** column name */
  AppraisalPropertyResidentialPotentialRentalIncome = 'appraisal_property_residential_potential_rental_income',
  /** column name */
  AppraisalPropertyResidentialSurface = 'appraisal_property_residential_surface',
  /** column name */
  AppraisalPropertyResidentialYearlyRentalIncome = 'appraisal_property_residential_yearly_rental_income',
  /** column name */
  AppraisalPropertyRoute = 'appraisal_property_route',
  /** column name */
  AppraisalPropertySide = 'appraisal_property_side',
  /** column name */
  AppraisalPropertyState = 'appraisal_property_state',
  /** column name */
  AppraisalPropertyStreetNumber = 'appraisal_property_street_number',
  /** column name */
  AppraisalPropertyUsage = 'appraisal_property_usage',
  /** column name */
  AppraisalReason = 'appraisal_reason',
  /** column name */
  AppraisalSellingWith = 'appraisal_selling_with',
  /** column name */
  AppraisalSeparationNextStep = 'appraisal_separation_next_step',
  /** column name */
  AppraisalStep = 'appraisal_step',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  BuyHorizon = 'buy_horizon',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  LastActivityDoneAt = 'last_activity_done_at',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastRequalificationMailSentAt = 'last_requalification_mail_sent_at',
  /** column name */
  LastRequalificationSmsSentAt = 'last_requalification_sms_sent_at',
  /** column name */
  MandateProbability = 'mandate_probability',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageBuyingStatus = 'mortgage_buying_status',
  /** column name */
  MortgageComments = 'mortgage_comments',
  /** column name */
  MortgageFinancialInstitution = 'mortgage_financial_institution',
  /** column name */
  MortgageGoogleAddressId = 'mortgage_google_address_id',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageInsuranceProviderId = 'mortgage_insurance_provider_id',
  /** column name */
  MortgageInsuranceRevenue = 'mortgage_insurance_revenue',
  /** column name */
  MortgageInterestRate = 'mortgage_interest_rate',
  /** column name */
  MortgageInterestRateType = 'mortgage_interest_rate_type',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageLenderId = 'mortgage_lender_id',
  /** column name */
  MortgageLenderName = 'mortgage_lender_name',
  /** column name */
  MortgageLenderType = 'mortgage_lender_type',
  /** column name */
  MortgageMortgageType = 'mortgage_mortgage_type',
  /** column name */
  MortgageNotaryId = 'mortgage_notary_id',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgagePropertyUsage = 'mortgage_property_usage',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  MortgagePurchaseDate = 'mortgage_purchase_date',
  /** column name */
  MortgagePurchasePrice = 'mortgage_purchase_price',
  /** column name */
  MortgageRealEstateBrokerId = 'mortgage_real_estate_broker_id',
  /** column name */
  MortgageReportType = 'mortgage_report_type',
  /** column name */
  MortgageRevenue = 'mortgage_revenue',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  MortgageStartDate = 'mortgage_start_date',
  /** column name */
  MortgageStatus = 'mortgage_status',
  /** column name */
  MortgageStep = 'mortgage_step',
  /** column name */
  MortgageTerm = 'mortgage_term',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NextActivityDueAt = 'next_activity_due_at',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  OtherCredits = 'other_credits',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  ParentLeadId = 'parent_lead_id',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDateOfBirth = 'partner_date_of_birth',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerFirstName = 'partner_first_name',
  /** column name */
  PartnerGender = 'partner_gender',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerLastName = 'partner_last_name',
  /** column name */
  PartnerMaritalStatus = 'partner_marital_status',
  /** column name */
  PartnerNationalityId = 'partner_nationality_id',
  /** column name */
  PartnerOccupationId = 'partner_occupation_id',
  /** column name */
  PartnerOccupationText = 'partner_occupation_text',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerProfessionalSituation = 'partner_professional_situation',
  /** column name */
  PartnerResidenceCountryCode = 'partner_residence_country_code',
  /** column name */
  PartnerResidenceStateId = 'partner_residence_state_id',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerThirdPillarAOrganisation = 'partner_third_pillar_a_organisation',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PartnerWorkPermitId = 'partner_work_permit_id',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  PredictedListingDate = 'predicted_listing_date',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RefusedAt = 'refused_at',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  RequalificationStatus = 'requalification_status',
  /** column name */
  RequalifiedAt = 'requalified_at',
  /** column name */
  RequalifiedOrCreatedAt = 'requalified_or_created_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SaleComments = 'sale_comments',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleHorizon = 'sale_horizon',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondContactId = 'second_contact_id',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceOrganisationId = 'source_organisation_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  UserInfoIp = 'user_info_ip',
  /** column name */
  UserInfoUserAgent = 'user_info_user_agent',
  /** column name */
  Verified = 'verified',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsSelectColumnLeadsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingLeadsStatusEnum {
  Active = 'active',
  Lost = 'lost',
  Won = 'won'
}

export type InsertListingLeadsStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLeadsStatusEnum>;
  _in?: InputMaybe<Array<InsertListingLeadsStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLeadsStatusEnum>;
  _nin?: InputMaybe<Array<InsertListingLeadsStatusEnum>>;
};

export type InsertListingLeadsTagsAggregateBoolExp = {
  count?: InputMaybe<InsertListingLeadsTagsAggregateBoolExpCount>;
};

export type InsertListingLeadsTagsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLeadsTagsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLeadsTagsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLeadsTagsArrRelInsertInput = {
  data: Array<InsertListingLeadsTagsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLeadsTagsOnConflict>;
};

export type InsertListingLeadsTagsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLeadsTagsBoolExp>>;
  _not?: InputMaybe<InsertListingLeadsTagsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLeadsTagsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  dictionary?: InputMaybe<InsertListingDictionariesBoolExp>;
  dictionary_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingLeadsTagsConstraint {
  /** unique or primary key constraint on columns "id" */
  LeadsTagsPkey = 'leads_tags_pkey',
  /** unique or primary key constraint on columns "dictionary_id", "tenant_id", "lead_id" */
  LeadsTagsUnique = 'leads_tags_unique'
}

export type InsertListingLeadsTagsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  dictionary?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  dictionary_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingLeadsTagsOnConflict = {
  constraint: InsertListingLeadsTagsConstraint;
  update_columns: Array<InsertListingLeadsTagsUpdateColumn>;
  where?: InputMaybe<InsertListingLeadsTagsBoolExp>;
};

export enum InsertListingLeadsTagsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DictionaryId = 'dictionary_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadsTagsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DictionaryId = 'dictionary_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingLeadsUpdateColumn {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AppraisalInheritanceNextStep = 'appraisal_inheritance_next_step',
  /** column name */
  AppraisalMarketTime = 'appraisal_market_time',
  /** column name */
  AppraisalMonthlyGrossRent = 'appraisal_monthly_gross_rent',
  /** column name */
  AppraisalNextStep = 'appraisal_next_step',
  /** column name */
  AppraisalOpenToOffer = 'appraisal_open_to_offer',
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  AppraisalPerception = 'appraisal_perception',
  /** column name */
  AppraisalPropertyBalconySurface = 'appraisal_property_balcony_surface',
  /** column name */
  AppraisalPropertyBuildingCondition = 'appraisal_property_building_condition',
  /** column name */
  AppraisalPropertyBuiltSurface = 'appraisal_property_built_surface',
  /** column name */
  AppraisalPropertyCommercialPotentialRentalIncome = 'appraisal_property_commercial_potential_rental_income',
  /** column name */
  AppraisalPropertyCommercialSurface = 'appraisal_property_commercial_surface',
  /** column name */
  AppraisalPropertyCommercialYearlyRentalIncome = 'appraisal_property_commercial_yearly_rental_income',
  /** column name */
  AppraisalPropertyConstructionYear = 'appraisal_property_construction_year',
  /** column name */
  AppraisalPropertyCountry = 'appraisal_property_country',
  /** column name */
  AppraisalPropertyCountryCode = 'appraisal_property_country_code',
  /** column name */
  AppraisalPropertyCtn = 'appraisal_property_ctn',
  /** column name */
  AppraisalPropertyFloorOfFlat = 'appraisal_property_floor_of_flat',
  /** column name */
  AppraisalPropertyGardenSurface = 'appraisal_property_garden_surface',
  /** column name */
  AppraisalPropertyGoogleAddressId = 'appraisal_property_google_address_id',
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  AppraisalPropertyLandSurface = 'appraisal_property_land_surface',
  /** column name */
  AppraisalPropertyLat = 'appraisal_property_lat',
  /** column name */
  AppraisalPropertyLivingSurface = 'appraisal_property_living_surface',
  /** column name */
  AppraisalPropertyLng = 'appraisal_property_lng',
  /** column name */
  AppraisalPropertyLocality = 'appraisal_property_locality',
  /** column name */
  AppraisalPropertyNumberOfBathrooms = 'appraisal_property_number_of_bathrooms',
  /** column name */
  AppraisalPropertyNumberOfBedrooms = 'appraisal_property_number_of_bedrooms',
  /** column name */
  AppraisalPropertyNumberOfCommercialUnits = 'appraisal_property_number_of_commercial_units',
  /** column name */
  AppraisalPropertyNumberOfFloors = 'appraisal_property_number_of_floors',
  /** column name */
  AppraisalPropertyNumberOfIndoorParkings = 'appraisal_property_number_of_indoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfOutdoorParkings = 'appraisal_property_number_of_outdoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfResidentialUnits = 'appraisal_property_number_of_residential_units',
  /** column name */
  AppraisalPropertyNumberOfRooms = 'appraisal_property_number_of_rooms',
  /** column name */
  AppraisalPropertyOccupied = 'appraisal_property_occupied',
  /** column name */
  AppraisalPropertyParkingPotentialRentalIncome = 'appraisal_property_parking_potential_rental_income',
  /** column name */
  AppraisalPropertyParkingYearlyRentalIncome = 'appraisal_property_parking_yearly_rental_income',
  /** column name */
  AppraisalPropertyPlotNumber = 'appraisal_property_plot_number',
  /** column name */
  AppraisalPropertyPostcode = 'appraisal_property_postcode',
  /** column name */
  AppraisalPropertyPropertyTypeId = 'appraisal_property_property_type_id',
  /** column name */
  AppraisalPropertyRenovationYear = 'appraisal_property_renovation_year',
  /** column name */
  AppraisalPropertyResidentialPotentialRentalIncome = 'appraisal_property_residential_potential_rental_income',
  /** column name */
  AppraisalPropertyResidentialSurface = 'appraisal_property_residential_surface',
  /** column name */
  AppraisalPropertyResidentialYearlyRentalIncome = 'appraisal_property_residential_yearly_rental_income',
  /** column name */
  AppraisalPropertyRoute = 'appraisal_property_route',
  /** column name */
  AppraisalPropertySide = 'appraisal_property_side',
  /** column name */
  AppraisalPropertyState = 'appraisal_property_state',
  /** column name */
  AppraisalPropertyStreetNumber = 'appraisal_property_street_number',
  /** column name */
  AppraisalPropertyUsage = 'appraisal_property_usage',
  /** column name */
  AppraisalReason = 'appraisal_reason',
  /** column name */
  AppraisalSellingWith = 'appraisal_selling_with',
  /** column name */
  AppraisalSeparationNextStep = 'appraisal_separation_next_step',
  /** column name */
  AppraisalStep = 'appraisal_step',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  BuyHorizon = 'buy_horizon',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FinancingSecured = 'financing_secured',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  LastActivityDoneAt = 'last_activity_done_at',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastRequalificationMailSentAt = 'last_requalification_mail_sent_at',
  /** column name */
  LastRequalificationSmsSentAt = 'last_requalification_sms_sent_at',
  /** column name */
  MandateProbability = 'mandate_probability',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgageAutoMortgageType = 'mortgage_auto_mortgage_type',
  /** column name */
  MortgageBuyingStatus = 'mortgage_buying_status',
  /** column name */
  MortgageComments = 'mortgage_comments',
  /** column name */
  MortgageFinancialInstitution = 'mortgage_financial_institution',
  /** column name */
  MortgageGoogleAddressId = 'mortgage_google_address_id',
  /** column name */
  MortgageHasMortgage = 'mortgage_has_mortgage',
  /** column name */
  MortgageInsuranceProviderId = 'mortgage_insurance_provider_id',
  /** column name */
  MortgageInsuranceRevenue = 'mortgage_insurance_revenue',
  /** column name */
  MortgageInterestRate = 'mortgage_interest_rate',
  /** column name */
  MortgageInterestRateType = 'mortgage_interest_rate_type',
  /** column name */
  MortgageIsConstruction = 'mortgage_is_construction',
  /** column name */
  MortgageIsPropertyIdentified = 'mortgage_is_property_identified',
  /** column name */
  MortgageLenderId = 'mortgage_lender_id',
  /** column name */
  MortgageLenderName = 'mortgage_lender_name',
  /** column name */
  MortgageLenderType = 'mortgage_lender_type',
  /** column name */
  MortgageMortgageType = 'mortgage_mortgage_type',
  /** column name */
  MortgageNotaryId = 'mortgage_notary_id',
  /** column name */
  MortgageProductMortgage = 'mortgage_product_mortgage',
  /** column name */
  MortgageProductThirdPillar = 'mortgage_product_third_pillar',
  /** column name */
  MortgagePropertyUsage = 'mortgage_property_usage',
  /** column name */
  MortgagePropertyValue = 'mortgage_property_value',
  /** column name */
  MortgagePurchaseDate = 'mortgage_purchase_date',
  /** column name */
  MortgagePurchasePrice = 'mortgage_purchase_price',
  /** column name */
  MortgageRealEstateBrokerId = 'mortgage_real_estate_broker_id',
  /** column name */
  MortgageReportType = 'mortgage_report_type',
  /** column name */
  MortgageRevenue = 'mortgage_revenue',
  /** column name */
  MortgageSell = 'mortgage_sell',
  /** column name */
  MortgageStartDate = 'mortgage_start_date',
  /** column name */
  MortgageStatus = 'mortgage_status',
  /** column name */
  MortgageStep = 'mortgage_step',
  /** column name */
  MortgageTerm = 'mortgage_term',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NextActivityDueAt = 'next_activity_due_at',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  OtherCredits = 'other_credits',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  ParentLeadId = 'parent_lead_id',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDateOfBirth = 'partner_date_of_birth',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerFirstName = 'partner_first_name',
  /** column name */
  PartnerGender = 'partner_gender',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerLastName = 'partner_last_name',
  /** column name */
  PartnerMaritalStatus = 'partner_marital_status',
  /** column name */
  PartnerNationalityId = 'partner_nationality_id',
  /** column name */
  PartnerOccupationId = 'partner_occupation_id',
  /** column name */
  PartnerOccupationText = 'partner_occupation_text',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerProfessionalSituation = 'partner_professional_situation',
  /** column name */
  PartnerResidenceCountryCode = 'partner_residence_country_code',
  /** column name */
  PartnerResidenceStateId = 'partner_residence_state_id',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerThirdPillarAOrganisation = 'partner_third_pillar_a_organisation',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PartnerWorkPermitId = 'partner_work_permit_id',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  PredictedListingDate = 'predicted_listing_date',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RefusedAt = 'refused_at',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  RequalificationStatus = 'requalification_status',
  /** column name */
  RequalifiedAt = 'requalified_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SaleComments = 'sale_comments',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleHorizon = 'sale_horizon',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondContactId = 'second_contact_id',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceOrganisationId = 'source_organisation_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  UserInfoIp = 'user_info_ip',
  /** column name */
  UserInfoUserAgent = 'user_info_user_agent',
  /** column name */
  Verified = 'verified',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export type InsertListingLoginsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingLoginsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLoginsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingLoginsAggregateBoolExpCount>;
};

export type InsertListingLoginsAggregateBoolExpBoolAnd = {
  arguments: InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLoginsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLoginsAggregateBoolExpBoolOr = {
  arguments: InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLoginsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLoginsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLoginsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLoginsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLoginsArrRelInsertInput = {
  data: Array<InsertListingLoginsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLoginsOnConflict>;
};

export type InsertListingLoginsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLoginsBoolExp>>;
  _not?: InputMaybe<InsertListingLoginsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLoginsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingStringComparisonExp>;
  invalid?: InputMaybe<InsertListingBooleanComparisonExp>;
  nylas_provider?: InputMaybe<InsertListingStringComparisonExp>;
  profile?: InputMaybe<InsertListingJsonbComparisonExp>;
  provider?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tokens?: InputMaybe<InsertListingJsonbComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingLoginsConstraint {
  /** unique or primary key constraint on columns "provider", "id", "tenant_id" */
  LoginsIdProviderTenantIdUnique = 'logins_id_provider_tenant_id_unique'
}

export type InsertListingLoginsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invalid?: InputMaybe<Scalars['Boolean']['input']>;
  nylas_provider?: InputMaybe<Scalars['String']['input']>;
  profile?: InputMaybe<Scalars['jsonb']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tokens?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingLoginsOnConflict = {
  constraint: InsertListingLoginsConstraint;
  update_columns: Array<InsertListingLoginsUpdateColumn>;
  where?: InputMaybe<InsertListingLoginsBoolExp>;
};

export enum InsertListingLoginsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  NylasProvider = 'nylas_provider',
  /** column name */
  Profile = 'profile',
  /** column name */
  Provider = 'provider',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tokens = 'tokens',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

export enum InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Invalid = 'invalid'
}

export enum InsertListingLoginsSelectColumnLoginsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Invalid = 'invalid'
}

export enum InsertListingLoginsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  NylasProvider = 'nylas_provider',
  /** column name */
  Profile = 'profile',
  /** column name */
  Provider = 'provider',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Tokens = 'tokens',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

export type InsertListingLotBuyersAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotBuyersAggregateBoolExpCount>;
};

export type InsertListingLotBuyersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotBuyersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotBuyersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotBuyersArrRelInsertInput = {
  data: Array<InsertListingLotBuyersInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotBuyersOnConflict>;
};

export type InsertListingLotBuyersBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotBuyersBoolExp>>;
  _not?: InputMaybe<InsertListingLotBuyersBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotBuyersBoolExp>>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingLotBuyersConstraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotBuyersLotIdUserIdUnique = 'lot_buyers_lot_id_user_id_unique'
}

export type InsertListingLotBuyersInsertInput = {
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingLotBuyersOnConflict = {
  constraint: InsertListingLotBuyersConstraint;
  update_columns: Array<InsertListingLotBuyersUpdateColumn>;
  where?: InputMaybe<InsertListingLotBuyersBoolExp>;
};

export enum InsertListingLotBuyersSelectColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingLotBuyersUpdateColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingLotCollaboratorsAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotCollaboratorsAggregateBoolExpCount>;
};

export type InsertListingLotCollaboratorsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotCollaboratorsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotCollaboratorsArrRelInsertInput = {
  data: Array<InsertListingLotCollaboratorsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotCollaboratorsOnConflict>;
};

export type InsertListingLotCollaboratorsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotCollaboratorsBoolExp>>;
  _not?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotCollaboratorsBoolExp>>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingLotCollaboratorsConstraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotCollaboratorsLotIdUserIdUnique = 'lot_collaborators_lot_id_user_id_unique'
}

export type InsertListingLotCollaboratorsInsertInput = {
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingLotCollaboratorsOnConflict = {
  constraint: InsertListingLotCollaboratorsConstraint;
  update_columns: Array<InsertListingLotCollaboratorsUpdateColumn>;
  where?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
};

export enum InsertListingLotCollaboratorsSelectColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingLotCollaboratorsUpdateColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingLotReferenceAliasesAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotReferenceAliasesAggregateBoolExpCount>;
};

export type InsertListingLotReferenceAliasesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotReferenceAliasesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotReferenceAliasesArrRelInsertInput = {
  data: Array<InsertListingLotReferenceAliasesInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotReferenceAliasesOnConflict>;
};

export type InsertListingLotReferenceAliasesBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotReferenceAliasesBoolExp>>;
  _not?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotReferenceAliasesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  reference_alias_decoded?: InputMaybe<InsertListingIntComparisonExp>;
};

export enum InsertListingLotReferenceAliasesConstraint {
  /** unique or primary key constraint on columns "reference_alias_decoded" */
  LotReferenceAliasesPkey = 'lot_reference_aliases_pkey'
}

export type InsertListingLotReferenceAliasesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_alias_decoded?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertListingLotReferenceAliasesOnConflict = {
  constraint: InsertListingLotReferenceAliasesConstraint;
  update_columns: Array<InsertListingLotReferenceAliasesUpdateColumn>;
  where?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
};

export enum InsertListingLotReferenceAliasesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ReferenceAliasDecoded = 'reference_alias_decoded'
}

export enum InsertListingLotReferenceAliasesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ReferenceAliasDecoded = 'reference_alias_decoded'
}

export type InsertListingLotSellersAggregateBoolExp = {
  count?: InputMaybe<InsertListingLotSellersAggregateBoolExpCount>;
};

export type InsertListingLotSellersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotSellersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotSellersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotSellersArrRelInsertInput = {
  data: Array<InsertListingLotSellersInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotSellersOnConflict>;
};

export type InsertListingLotSellersBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotSellersBoolExp>>;
  _not?: InputMaybe<InsertListingLotSellersBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotSellersBoolExp>>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  seller?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingLotSellersConstraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotSellersLotIdUserIdUnique = 'lot_sellers_lot_id_user_id_unique'
}

export type InsertListingLotSellersInsertInput = {
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  seller?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingLotSellersOnConflict = {
  constraint: InsertListingLotSellersConstraint;
  update_columns: Array<InsertListingLotSellersUpdateColumn>;
  where?: InputMaybe<InsertListingLotSellersBoolExp>;
};

export enum InsertListingLotSellersSelectColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingLotSellersUpdateColumn {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingLotsAggregateBoolExp = {
  avg?: InputMaybe<InsertListingLotsAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingLotsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingLotsAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingLotsAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingLotsAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingLotsAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingLotsAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingLotsAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingLotsAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingLotsAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingLotsAggregateBoolExpVarSamp>;
};

export type InsertListingLotsAggregateBoolExpAvg = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpBoolAnd = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLotsAggregateBoolExpBoolOr = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCorr = {
  arguments: InsertListingLotsAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCorrArguments = {
  X: InsertListingLotsSelectColumnLotsAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingLotsSelectColumnLotsAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingLotsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingLotsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCovarSamp = {
  arguments: InsertListingLotsAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpCovarSampArguments = {
  X: InsertListingLotsSelectColumnLotsAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingLotsSelectColumnLotsAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingLotsAggregateBoolExpMax = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpMin = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpStddevSamp = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpSum = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsAggregateBoolExpVarSamp = {
  arguments: InsertListingLotsSelectColumnLotsAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingLotsBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingLotsArrRelInsertInput = {
  data: Array<InsertListingLotsInsertInput>;
  on_conflict?: InputMaybe<InsertListingLotsOnConflict>;
};

export type InsertListingLotsBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotsBoolExp>>;
  _not?: InputMaybe<InsertListingLotsBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotsBoolExp>>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  address_display_option?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnumComparisonExp>;
  address_display_option_brochure?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnumComparisonExp>;
  auto_matching_filters?: InputMaybe<InsertListingJsonbComparisonExp>;
  available_from?: InputMaybe<InsertListingDateComparisonExp>;
  brochure_pdf_compression_quality?: InputMaybe<InsertListingPdfCompressionQualityComparisonExp>;
  brochure_title_de?: InputMaybe<InsertListingStringComparisonExp>;
  brochure_title_en?: InputMaybe<InsertListingStringComparisonExp>;
  brochure_title_es?: InputMaybe<InsertListingStringComparisonExp>;
  brochure_title_fr?: InputMaybe<InsertListingStringComparisonExp>;
  brochure_title_it?: InputMaybe<InsertListingStringComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_leads_aggregate?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExp>;
  commission_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  created_by_user?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  currency?: InputMaybe<InsertListingCurrenciesComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  development?: InputMaybe<InsertListingDevelopmentsBoolExp>;
  development_id?: InputMaybe<InsertListingUuidComparisonExp>;
  development_mappings?: InputMaybe<InsertListingDevelopmentMappingsBoolExp>;
  development_mappings_aggregate?: InputMaybe<InsertListingDevelopmentMappingsAggregateBoolExp>;
  dummy_broker_name?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_broker_phone?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  dummy_lat?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_living_surface?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_lng?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_locality?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  dummy_organisation_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_lat?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_organisation_lng?: InputMaybe<InsertListingFloat8ComparisonExp>;
  dummy_organisation_locality?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_name?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_phone?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_route?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_state?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_organisation_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_route?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_state?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  dummy_usable_surface?: InputMaybe<InsertListingStringComparisonExp>;
  duration_in_months?: InputMaybe<InsertListingIntComparisonExp>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesBoolExp>;
  email_templates_aggregate?: InputMaybe<InsertListingEmailTemplatesAggregateBoolExp>;
  enable_auto_matching?: InputMaybe<InsertListingBooleanComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  enquiry_response_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  expected_time_to_sell?: InputMaybe<InsertListingStringComparisonExp>;
  fixed_fee?: InputMaybe<InsertListingIntComparisonExp>;
  has_success_fee?: InputMaybe<InsertListingBooleanComparisonExp>;
  hide_price_on_brochure?: InputMaybe<InsertListingBooleanComparisonExp>;
  hide_price_on_portals?: InputMaybe<InsertListingBooleanComparisonExp>;
  hide_route?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_exclusive?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_paid?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_parking_included_in_total?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_sales_tax_inclusive?: InputMaybe<InsertListingBooleanComparisonExp>;
  lead?: InputMaybe<InsertListingLeadsBoolExp>;
  lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  listing_url?: InputMaybe<InsertListingStringComparisonExp>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersBoolExp>;
  lot_buyers_aggregate?: InputMaybe<InsertListingLotBuyersAggregateBoolExp>;
  lot_collaborators?: InputMaybe<InsertListingLotCollaboratorsBoolExp>;
  lot_collaborators_aggregate?: InputMaybe<InsertListingLotCollaboratorsAggregateBoolExp>;
  lot_property_files?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  lot_property_files_aggregate?: InputMaybe<InsertListingPropertyFilesAggregateBoolExp>;
  lot_reference?: InputMaybe<InsertListingStringComparisonExp>;
  lot_reference_aliases?: InputMaybe<InsertListingLotReferenceAliasesBoolExp>;
  lot_reference_aliases_aggregate?: InputMaybe<InsertListingLotReferenceAliasesAggregateBoolExp>;
  lots_status?: InputMaybe<InsertListingLotsStatusEnumBoolExp>;
  mandate_sale_price?: InputMaybe<InsertListingFloatComparisonExp>;
  mandate_type?: InputMaybe<InsertListingStringComparisonExp>;
  minimum_net_seller_price?: InputMaybe<InsertListingFloatComparisonExp>;
  monthly_rent_computed?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_type?: InputMaybe<InsertListingStringComparisonExp>;
  offers?: InputMaybe<InsertListingOffersBoolExp>;
  offers_aggregate?: InputMaybe<InsertListingOffersAggregateBoolExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  origin?: InputMaybe<InsertListingDictionariesBoolExp>;
  origin_id?: InputMaybe<InsertListingUuidComparisonExp>;
  parking_price?: InputMaybe<InsertListingFloat8ComparisonExp>;
  payment_id?: InputMaybe<InsertListingUuidComparisonExp>;
  portal_listings?: InputMaybe<InsertListingPortalListingsBoolExp>;
  portal_listings_aggregate?: InputMaybe<InsertListingPortalListingsAggregateBoolExp>;
  price_unit?: InputMaybe<InsertListingStringComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  publish_step?: InputMaybe<InsertListingStringComparisonExp>;
  rent_extra?: InputMaybe<InsertListingFloatComparisonExp>;
  rent_net?: InputMaybe<InsertListingFloatComparisonExp>;
  response_sender?: InputMaybe<InsertListingUsersBoolExp>;
  response_sender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sale_price?: InputMaybe<InsertListingFloat8ComparisonExp>;
  sale_price_computed?: InputMaybe<InsertListingFloat8ComparisonExp>;
  sellers?: InputMaybe<InsertListingLotSellersBoolExp>;
  sellers_aggregate?: InputMaybe<InsertListingLotSellersAggregateBoolExp>;
  send_enquiries_to_sellers?: InputMaybe<InsertListingBooleanComparisonExp>;
  shared_on_mls_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  signed_at?: InputMaybe<InsertListingDateComparisonExp>;
  status?: InputMaybe<InsertListingLotsStatusEnumEnumComparisonExp>;
  success_fee_custom?: InputMaybe<InsertListingStringComparisonExp>;
  success_fee_percentage?: InputMaybe<InsertListingFloatComparisonExp>;
  success_fee_type?: InputMaybe<InsertListingStringComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  use_custom_brochure_description?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_custom_brochure_title?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_dummy_address?: InputMaybe<InsertListingBooleanComparisonExp>;
  use_dummy_contact?: InputMaybe<InsertListingBooleanComparisonExp>;
  video_url?: InputMaybe<InsertListingStringComparisonExp>;
  virtual_visit_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingLotsConstraint {
  /** unique or primary key constraint on columns "order_nr", "development_id" */
  LotsDevelopmentIdOrderNrUnique = 'lots_development_id_order_nr_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LotsIdTenantIdUnique = 'lots_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  LotsIdUindex = 'lots_id_uindex',
  /** unique or primary key constraint on columns "id" */
  LotsPkey = 'lots_pkey'
}

export type InsertListingLotsInsertInput = {
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  address_display_option?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  address_display_option_brochure?: InputMaybe<InsertListingAddressDisplayOptionsEnumEnum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_description_de?: InputMaybe<Scalars['String']['input']>;
  brochure_description_en?: InputMaybe<Scalars['String']['input']>;
  brochure_description_es?: InputMaybe<Scalars['String']['input']>;
  brochure_description_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_description_it?: InputMaybe<Scalars['String']['input']>;
  brochure_description_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_description_pt?: InputMaybe<Scalars['String']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_title_de?: InputMaybe<Scalars['String']['input']>;
  brochure_title_en?: InputMaybe<Scalars['String']['input']>;
  brochure_title_es?: InputMaybe<Scalars['String']['input']>;
  brochure_title_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_title_it?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pt?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsArrRelInsertInput>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  couples_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development?: InputMaybe<InsertListingDevelopmentsObjRelInsertInput>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  development_mappings?: InputMaybe<InsertListingDevelopmentMappingsArrRelInsertInput>;
  doc_template_theme_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  email_templates?: InputMaybe<InsertListingEmailTemplatesArrRelInsertInput>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  fsbo_hide_last_name?: InputMaybe<Scalars['Boolean']['input']>;
  fsbo_hide_phone?: InputMaybe<Scalars['Boolean']['input']>;
  furnished?: InputMaybe<Scalars['Boolean']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lead?: InputMaybe<InsertListingLeadsObjRelInsertInput>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersArrRelInsertInput>;
  lot_collaborators?: InputMaybe<InsertListingLotCollaboratorsArrRelInsertInput>;
  lot_property_files?: InputMaybe<InsertListingPropertyFilesArrRelInsertInput>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  lot_reference_aliases?: InputMaybe<InsertListingLotReferenceAliasesArrRelInsertInput>;
  lots_status?: InputMaybe<InsertListingLotsStatusEnumObjRelInsertInput>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimal_stay?: InputMaybe<Scalars['Int']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  occupied_now?: InputMaybe<Scalars['Boolean']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<InsertListingOffersArrRelInsertInput>;
  oldest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_living?: InputMaybe<Scalars['Boolean']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  portal_listings?: InputMaybe<InsertListingPortalListingsArrRelInsertInput>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  sellers?: InputMaybe<InsertListingLotSellersArrRelInsertInput>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls_at?: InputMaybe<Scalars['timestamptz']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<InsertListingLotsStatusEnumEnum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_gender?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_number?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
  watermark_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  watermark_image_url?: InputMaybe<Scalars['String']['input']>;
  watermark_opacity?: InputMaybe<Scalars['Float']['input']>;
  watermark_position?: InputMaybe<Scalars['String']['input']>;
  watermark_position_x?: InputMaybe<Scalars['Int']['input']>;
  watermark_position_y?: InputMaybe<Scalars['Int']['input']>;
  watermark_rotation?: InputMaybe<Scalars['Int']['input']>;
  watermark_scale?: InputMaybe<Scalars['Float']['input']>;
  youngest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
};

export type InsertListingLotsObjRelInsertInput = {
  data: InsertListingLotsInsertInput;
  on_conflict?: InputMaybe<InsertListingLotsOnConflict>;
};

export type InsertListingLotsOnConflict = {
  constraint: InsertListingLotsConstraint;
  update_columns: Array<InsertListingLotsUpdateColumn>;
  where?: InputMaybe<InsertListingLotsBoolExp>;
};

export enum InsertListingLotsSelectColumn {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureDescriptionDe = 'brochure_description_de',
  /** column name */
  BrochureDescriptionEn = 'brochure_description_en',
  /** column name */
  BrochureDescriptionEs = 'brochure_description_es',
  /** column name */
  BrochureDescriptionFr = 'brochure_description_fr',
  /** column name */
  BrochureDescriptionIt = 'brochure_description_it',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochureTitleDe = 'brochure_title_de',
  /** column name */
  BrochureTitleEn = 'brochure_title_en',
  /** column name */
  BrochureTitleEs = 'brochure_title_es',
  /** column name */
  BrochureTitleFr = 'brochure_title_fr',
  /** column name */
  BrochureTitleIt = 'brochure_title_it',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMlsAt = 'shared_on_mls_at',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMlsAt = 'shared_on_mls_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMlsAt = 'shared_on_mls_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpMinArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpSumArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export enum InsertListingLotsSelectColumnLotsAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

export type InsertListingLotsStatusEnumBoolExp = {
  _and?: InputMaybe<Array<InsertListingLotsStatusEnumBoolExp>>;
  _not?: InputMaybe<InsertListingLotsStatusEnumBoolExp>;
  _or?: InputMaybe<Array<InsertListingLotsStatusEnumBoolExp>>;
  comment?: InputMaybe<InsertListingStringComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  value?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingLotsStatusEnumConstraint {
  /** unique or primary key constraint on columns "value" */
  LotsStatusEnumPkey = 'lots_status_enum_pkey'
}

export enum InsertListingLotsStatusEnumEnum {
  Abandoned = 'abandoned',
  Available = 'available',
  AvailableComingSoon = 'available_coming_soon',
  AvailableOffMarket = 'available_off_market',
  Draft = 'draft',
  LostSoldOwner = 'lost_sold_owner',
  LostSoldSomeone = 'lost_sold_someone',
  Paused = 'paused',
  Reserved = 'reserved',
  Won = 'won'
}

export type InsertListingLotsStatusEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingLotsStatusEnumEnum>;
  _in?: InputMaybe<Array<InsertListingLotsStatusEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingLotsStatusEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingLotsStatusEnumEnum>>;
};

export type InsertListingLotsStatusEnumInsertInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingLotsStatusEnumObjRelInsertInput = {
  data: InsertListingLotsStatusEnumInsertInput;
  on_conflict?: InputMaybe<InsertListingLotsStatusEnumOnConflict>;
};

export type InsertListingLotsStatusEnumOnConflict = {
  constraint: InsertListingLotsStatusEnumConstraint;
  update_columns: Array<InsertListingLotsStatusEnumUpdateColumn>;
  where?: InputMaybe<InsertListingLotsStatusEnumBoolExp>;
};

export enum InsertListingLotsStatusEnumUpdateColumn {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export enum InsertListingLotsUpdateColumn {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureDescriptionDe = 'brochure_description_de',
  /** column name */
  BrochureDescriptionEn = 'brochure_description_en',
  /** column name */
  BrochureDescriptionEs = 'brochure_description_es',
  /** column name */
  BrochureDescriptionFr = 'brochure_description_fr',
  /** column name */
  BrochureDescriptionIt = 'brochure_description_it',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochureTitleDe = 'brochure_title_de',
  /** column name */
  BrochureTitleEn = 'brochure_title_en',
  /** column name */
  BrochureTitleEs = 'brochure_title_es',
  /** column name */
  BrochureTitleFr = 'brochure_title_fr',
  /** column name */
  BrochureTitleIt = 'brochure_title_it',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMlsAt = 'shared_on_mls_at',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url'
}

export type InsertListingMaritalStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['marital_status']['input']>;
  _gt?: InputMaybe<Scalars['marital_status']['input']>;
  _gte?: InputMaybe<Scalars['marital_status']['input']>;
  _in?: InputMaybe<Array<Scalars['marital_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['marital_status']['input']>;
  _lte?: InputMaybe<Scalars['marital_status']['input']>;
  _neq?: InputMaybe<Scalars['marital_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['marital_status']['input']>>;
};

export type InsertListingMortgageInterestRateTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_interest_rate_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_interest_rate_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_interest_rate_type']['input']>>;
};

export type InsertListingMortgageInterestTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_interest_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_interest_type']['input']>>;
};

export type InsertListingMortgageLenderTypeComparisonExp = {
  _eq?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _gt?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _gte?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _in?: InputMaybe<Array<Scalars['mortgage_lender_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _lte?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _neq?: InputMaybe<Scalars['mortgage_lender_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['mortgage_lender_type']['input']>>;
};

export type InsertListingMortgagesAggregateBoolExp = {
  avg?: InputMaybe<InsertListingMortgagesAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingMortgagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingMortgagesAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingMortgagesAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingMortgagesAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingMortgagesAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingMortgagesAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingMortgagesAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingMortgagesAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingMortgagesAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingMortgagesAggregateBoolExpVarSamp>;
};

export type InsertListingMortgagesAggregateBoolExpAvg = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpBoolOr = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCorr = {
  arguments: InsertListingMortgagesAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCorrArguments = {
  X: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingMortgagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingMortgagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCovarSamp = {
  arguments: InsertListingMortgagesAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpCovarSampArguments = {
  X: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingMortgagesAggregateBoolExpMax = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpMin = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpStddevSamp = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpSum = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesAggregateBoolExpVarSamp = {
  arguments: InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingMortgagesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingMortgagesArrRelInsertInput = {
  data: Array<InsertListingMortgagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingMortgagesOnConflict>;
};

export type InsertListingMortgagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingMortgagesBoolExp>>;
  _not?: InputMaybe<InsertListingMortgagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingMortgagesBoolExp>>;
  amortisation?: InputMaybe<InsertListingFloatComparisonExp>;
  annual_rental_income?: InputMaybe<InsertListingFloat8ComparisonExp>;
  banker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  borrower_property_location?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  expiry_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  interest_rate?: InputMaybe<InsertListingFloatComparisonExp>;
  lender?: InputMaybe<InsertListingStringComparisonExp>;
  lender_id?: InputMaybe<InsertListingUuidComparisonExp>;
  loan_amount?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgage_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  signed_at?: InputMaybe<InsertListingDateComparisonExp>;
  start_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  tranches_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  type?: InputMaybe<InsertListingMortgageInterestTypeComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  value?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingMortgagesConstraint {
  /** unique or primary key constraint on columns "id" */
  MortgagesPkey = 'mortgages_pkey'
}

export type InsertListingMortgagesInsertInput = {
  amortisation?: InputMaybe<Scalars['Float']['input']>;
  annual_rental_income?: InputMaybe<Scalars['float8']['input']>;
  banker_id?: InputMaybe<Scalars['uuid']['input']>;
  borrower_property_location?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  expiry_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interest_rate?: InputMaybe<Scalars['Float']['input']>;
  lender?: InputMaybe<Scalars['String']['input']>;
  lender_id?: InputMaybe<Scalars['uuid']['input']>;
  loan_amount?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  tranches_exist?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['mortgage_interest_type']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingMortgagesOnConflict = {
  constraint: InsertListingMortgagesConstraint;
  update_columns: Array<InsertListingMortgagesUpdateColumn>;
  where?: InputMaybe<InsertListingMortgagesBoolExp>;
};

export enum InsertListingMortgagesSelectColumn {
  /** column name */
  Amortisation = 'amortisation',
  /** column name */
  AnnualRentalIncome = 'annual_rental_income',
  /** column name */
  BankerId = 'banker_id',
  /** column name */
  BorrowerPropertyLocation = 'borrower_property_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRate = 'interest_rate',
  /** column name */
  Lender = 'lender',
  /** column name */
  LenderId = 'lender_id',
  /** column name */
  LoanAmount = 'loan_amount',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TranchesExist = 'tranches_exist',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  TranchesExist = 'tranches_exist'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  TranchesExist = 'tranches_exist'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpMinArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpSumArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesSelectColumnMortgagesAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  AnnualRentalIncome = 'annual_rental_income'
}

export enum InsertListingMortgagesUpdateColumn {
  /** column name */
  Amortisation = 'amortisation',
  /** column name */
  AnnualRentalIncome = 'annual_rental_income',
  /** column name */
  BankerId = 'banker_id',
  /** column name */
  BorrowerPropertyLocation = 'borrower_property_location',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  InterestRate = 'interest_rate',
  /** column name */
  Lender = 'lender',
  /** column name */
  LenderId = 'lender_id',
  /** column name */
  LoanAmount = 'loan_amount',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  TranchesExist = 'tranches_exist',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Value = 'value'
}

export type InsertListingNylasAccountConfigsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExpCount>;
};

export type InsertListingNylasAccountConfigsAggregateBoolExpBoolAnd = {
  arguments: InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingNylasAccountConfigsAggregateBoolExpBoolOr = {
  arguments: InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingNylasAccountConfigsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingNylasAccountConfigsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingNylasAccountConfigsArrRelInsertInput = {
  data: Array<InsertListingNylasAccountConfigsInsertInput>;
  on_conflict?: InputMaybe<InsertListingNylasAccountConfigsOnConflict>;
};

export type InsertListingNylasAccountConfigsBoolExp = {
  _and?: InputMaybe<Array<InsertListingNylasAccountConfigsBoolExp>>;
  _not?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  _or?: InputMaybe<Array<InsertListingNylasAccountConfigsBoolExp>>;
  account_id?: InputMaybe<InsertListingStringComparisonExp>;
  calendar_name?: InputMaybe<InsertListingStringComparisonExp>;
  calendar_sync_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  calendar_sync_enabled_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  nylas_calendar_id?: InputMaybe<InsertListingStringComparisonExp>;
  scopes?: InputMaybe<InsertListingJsonbComparisonExp>;
  sync_activity_types?: InputMaybe<InsertListingStringArrayComparisonExp>;
  sync_enabled?: InputMaybe<InsertListingBooleanComparisonExp>;
  sync_enabled_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  sync_state?: InputMaybe<InsertListingStringComparisonExp>;
  sync_state_updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  sync_type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingNylasAccountConfigsConstraint {
  /** unique or primary key constraint on columns "account_id", "user_id" */
  NylasAccountConfigsAccountIdUserIdUnique = 'nylas_account_configs_account_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  NylasAccountConfigsPkey = 'nylas_account_configs_pkey'
}

export type InsertListingNylasAccountConfigsInsertInput = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  calendar_name?: InputMaybe<Scalars['String']['input']>;
  calendar_sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_calendar_id?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  sync_activity_types?: InputMaybe<Array<Scalars['String']['input']>>;
  sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_state?: InputMaybe<Scalars['String']['input']>;
  sync_state_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingNylasAccountConfigsOnConflict = {
  constraint: InsertListingNylasAccountConfigsConstraint;
  update_columns: Array<InsertListingNylasAccountConfigsUpdateColumn>;
  where?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
};

export enum InsertListingNylasAccountConfigsSelectColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CalendarName = 'calendar_name',
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  CalendarSyncEnabledAt = 'calendar_sync_enabled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NylasCalendarId = 'nylas_calendar_id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  SyncActivityTypes = 'sync_activity_types',
  /** column name */
  SyncEnabled = 'sync_enabled',
  /** column name */
  SyncEnabledAt = 'sync_enabled_at',
  /** column name */
  SyncState = 'sync_state',
  /** column name */
  SyncStateUpdatedAt = 'sync_state_updated_at',
  /** column name */
  SyncType = 'sync_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  SyncEnabled = 'sync_enabled'
}

export enum InsertListingNylasAccountConfigsSelectColumnNylasAccountConfigsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  SyncEnabled = 'sync_enabled'
}

export enum InsertListingNylasAccountConfigsUpdateColumn {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CalendarName = 'calendar_name',
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  CalendarSyncEnabledAt = 'calendar_sync_enabled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NylasCalendarId = 'nylas_calendar_id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  SyncActivityTypes = 'sync_activity_types',
  /** column name */
  SyncEnabled = 'sync_enabled',
  /** column name */
  SyncEnabledAt = 'sync_enabled_at',
  /** column name */
  SyncState = 'sync_state',
  /** column name */
  SyncStateUpdatedAt = 'sync_state_updated_at',
  /** column name */
  SyncType = 'sync_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingOffersAggregateBoolExp = {
  count?: InputMaybe<InsertListingOffersAggregateBoolExpCount>;
};

export type InsertListingOffersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingOffersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOffersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingOffersArrRelInsertInput = {
  data: Array<InsertListingOffersInsertInput>;
  on_conflict?: InputMaybe<InsertListingOffersOnConflict>;
};

export type InsertListingOffersBoolExp = {
  _and?: InputMaybe<Array<InsertListingOffersBoolExp>>;
  _not?: InputMaybe<InsertListingOffersBoolExp>;
  _or?: InputMaybe<Array<InsertListingOffersBoolExp>>;
  amount?: InputMaybe<InsertListingIntComparisonExp>;
  buyer?: InputMaybe<InsertListingUsersBoolExp>;
  buyer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  comments?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  made_on?: InputMaybe<InsertListingDateComparisonExp>;
  offer_refused_id?: InputMaybe<InsertListingUuidComparisonExp>;
  offer_refused_type?: InputMaybe<InsertListingDictionariesBoolExp>;
  status?: InputMaybe<InsertListingOffersStatusEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  valid_until?: InputMaybe<InsertListingDateComparisonExp>;
};

export enum InsertListingOffersConstraint {
  /** unique or primary key constraint on columns "id" */
  OffersPkey = 'offers_pkey'
}

export type InsertListingOffersInsertInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_type?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  status?: InputMaybe<InsertListingOffersStatusEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

export type InsertListingOffersOnConflict = {
  constraint: InsertListingOffersConstraint;
  update_columns: Array<InsertListingOffersUpdateColumn>;
  where?: InputMaybe<InsertListingOffersBoolExp>;
};

export enum InsertListingOffersSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

export enum InsertListingOffersStatusEnum {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused'
}

export type InsertListingOffersStatusEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingOffersStatusEnum>;
  _in?: InputMaybe<Array<InsertListingOffersStatusEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingOffersStatusEnum>;
  _nin?: InputMaybe<Array<InsertListingOffersStatusEnum>>;
};

export enum InsertListingOffersUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

export type InsertListingOrganisationImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExpCount>;
};

export type InsertListingOrganisationImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingOrganisationImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingOrganisationImagesArrRelInsertInput = {
  data: Array<InsertListingOrganisationImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingOrganisationImagesOnConflict>;
};

export type InsertListingOrganisationImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingOrganisationImagesBoolExp>>;
  _not?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingOrganisationImagesBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingOrganisationImagesConstraint {
  /** unique or primary key constraint on columns "organisation_id", "is_primary" */
  IdxOrganisationImagesOrganisationIdIsPrimary = 'idx_organisation_images_organisation_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  OrganisationImagesIdKey = 'organisation_images_id_key',
  /** unique or primary key constraint on columns "organisation_id", "image_id" */
  OrganisationImagesOrganisationIdImageIdUnique = 'organisation_images_organisation_id_image_id_unique'
}

export type InsertListingOrganisationImagesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingOrganisationImagesOnConflict = {
  constraint: InsertListingOrganisationImagesConstraint;
  update_columns: Array<InsertListingOrganisationImagesUpdateColumn>;
  where?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
};

export enum InsertListingOrganisationImagesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OrganisationId = 'organisation_id'
}

export enum InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationImagesSelectColumnOrganisationImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationImagesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OrganisationId = 'organisation_id'
}

export type InsertListingOrganisationUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExpCount>;
};

export type InsertListingOrganisationUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingOrganisationUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingOrganisationUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingOrganisationUsersArrRelInsertInput = {
  data: Array<InsertListingOrganisationUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingOrganisationUsersOnConflict>;
};

export type InsertListingOrganisationUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingOrganisationUsersBoolExp>>;
  _not?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingOrganisationUsersBoolExp>>;
  is_primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  users?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingOrganisationUsersConstraint {
  /** unique or primary key constraint on columns "organisation_id", "is_primary" */
  IdxOrganisationUsersOrganisationIdIsPrimary = 'idx_organisation_users_organisation_id_is_primary',
  /** unique or primary key constraint on columns "user_id" */
  OrganisationUsersUserIdUnique = 'organisation_users_user_id_unique'
}

export type InsertListingOrganisationUsersInsertInput = {
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  users?: InputMaybe<InsertListingUsersObjRelInsertInput>;
};

export type InsertListingOrganisationUsersObjRelInsertInput = {
  data: InsertListingOrganisationUsersInsertInput;
  on_conflict?: InputMaybe<InsertListingOrganisationUsersOnConflict>;
};

export type InsertListingOrganisationUsersOnConflict = {
  constraint: InsertListingOrganisationUsersConstraint;
  update_columns: Array<InsertListingOrganisationUsersUpdateColumn>;
  where?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
};

export enum InsertListingOrganisationUsersSelectColumn {
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationUsersSelectColumnOrganisationUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingOrganisationUsersUpdateColumn {
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingOrganisationsBoolExp = {
  _and?: InputMaybe<Array<InsertListingOrganisationsBoolExp>>;
  _not?: InputMaybe<InsertListingOrganisationsBoolExp>;
  _or?: InputMaybe<Array<InsertListingOrganisationsBoolExp>>;
  branding_color?: InputMaybe<InsertListingStringComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  emails?: InputMaybe<InsertListingEmailsBoolExp>;
  emails_aggregate?: InputMaybe<InsertListingEmailsAggregateBoolExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_default_lender?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_lender?: InputMaybe<InsertListingBooleanComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  organisation_images?: InputMaybe<InsertListingOrganisationImagesBoolExp>;
  organisation_images_aggregate?: InputMaybe<InsertListingOrganisationImagesAggregateBoolExp>;
  organisation_users?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  organisation_users_aggregate?: InputMaybe<InsertListingOrganisationUsersAggregateBoolExp>;
  parent_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  phone_numbers_aggregate?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  teams?: InputMaybe<InsertListingTeamsBoolExp>;
  teams_aggregate?: InputMaybe<InsertListingTeamsAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  website?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingOrganisationsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  OrganisationsIdTenantIdUnique = 'organisations_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  OrganisationsPkey = 'organisations_pkey'
}

export type InsertListingOrganisationsInsertInput = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  emails?: InputMaybe<InsertListingEmailsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default_lender?: InputMaybe<Scalars['Boolean']['input']>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_images?: InputMaybe<InsertListingOrganisationImagesArrRelInsertInput>;
  organisation_users?: InputMaybe<InsertListingOrganisationUsersArrRelInsertInput>;
  parent_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersArrRelInsertInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<InsertListingTeamsArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingOrganisationsObjRelInsertInput = {
  data: InsertListingOrganisationsInsertInput;
  on_conflict?: InputMaybe<InsertListingOrganisationsOnConflict>;
};

export type InsertListingOrganisationsOnConflict = {
  constraint: InsertListingOrganisationsConstraint;
  update_columns: Array<InsertListingOrganisationsUpdateColumn>;
  where?: InputMaybe<InsertListingOrganisationsBoolExp>;
};

export enum InsertListingOrganisationsUpdateColumn {
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefaultLender = 'is_default_lender',
  /** column name */
  IsLender = 'is_lender',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Name = 'name',
  /** column name */
  ParentOrganisationId = 'parent_organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

export type InsertListingOutput = {
  id: Scalars['uuid']['output'];
  lot?: Maybe<Lots>;
};

export type InsertListingPaymentsAggregateBoolExp = {
  count?: InputMaybe<InsertListingPaymentsAggregateBoolExpCount>;
};

export type InsertListingPaymentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPaymentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPaymentsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPaymentsArrRelInsertInput = {
  data: Array<InsertListingPaymentsInsertInput>;
  on_conflict?: InputMaybe<InsertListingPaymentsOnConflict>;
};

export type InsertListingPaymentsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPaymentsBoolExp>>;
  _not?: InputMaybe<InsertListingPaymentsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPaymentsBoolExp>>;
  amount?: InputMaybe<InsertListingFloatComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  currency?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  payment_created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  payment_intent_id?: InputMaybe<InsertListingStringComparisonExp>;
  payment_intent_raw?: InputMaybe<InsertListingJsonbComparisonExp>;
  receipt_url?: InputMaybe<InsertListingStringComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPaymentsConstraint {
  /** unique or primary key constraint on columns "payment_intent_id" */
  PaymentsPaymentIntentIdUnique = 'payments_payment_intent_id_unique',
  /** unique or primary key constraint on columns "id" */
  PaymentsPkey = 'payments_pkey'
}

export type InsertListingPaymentsInsertInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  payment_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  payment_intent_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent_raw?: InputMaybe<Scalars['jsonb']['input']>;
  receipt_url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPaymentsOnConflict = {
  constraint: InsertListingPaymentsConstraint;
  update_columns: Array<InsertListingPaymentsUpdateColumn>;
  where?: InputMaybe<InsertListingPaymentsBoolExp>;
};

export enum InsertListingPaymentsSelectColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCreatedAt = 'payment_created_at',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  PaymentIntentRaw = 'payment_intent_raw',
  /** column name */
  ReceiptUrl = 'receipt_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPaymentsUpdateColumn {
  /** column name */
  Amount = 'amount',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PaymentCreatedAt = 'payment_created_at',
  /** column name */
  PaymentIntentId = 'payment_intent_id',
  /** column name */
  PaymentIntentRaw = 'payment_intent_raw',
  /** column name */
  ReceiptUrl = 'receipt_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingPdfCompressionQualityComparisonExp = {
  _eq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _in?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _lte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _neq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _nin?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
};

export enum InsertListingPhoneNumberTypeEnumEnum {
  /** Home phone number */
  Home = 'home',
  /** Mobile phone number */
  Mobile = 'mobile',
  /** Other phone number */
  Other = 'other',
  /** Proxy number user to track calls */
  Proxy = 'proxy',
  /** Work phone number */
  Work = 'work'
}

export type InsertListingPhoneNumberTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPhoneNumberTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPhoneNumberTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPhoneNumberTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPhoneNumberTypeEnumEnum>>;
};

export type InsertListingPhoneNumbersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExpCount>;
};

export type InsertListingPhoneNumbersAggregateBoolExpBoolAnd = {
  arguments: InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPhoneNumbersAggregateBoolExpBoolOr = {
  arguments: InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPhoneNumbersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPhoneNumbersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPhoneNumbersArrRelInsertInput = {
  data: Array<InsertListingPhoneNumbersInsertInput>;
  on_conflict?: InputMaybe<InsertListingPhoneNumbersOnConflict>;
};

export type InsertListingPhoneNumbersBoolExp = {
  _and?: InputMaybe<Array<InsertListingPhoneNumbersBoolExp>>;
  _not?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  _or?: InputMaybe<Array<InsertListingPhoneNumbersBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  number?: InputMaybe<InsertListingStringComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingPhoneNumberTypeEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  verification_attempts?: InputMaybe<InsertListingIntComparisonExp>;
  verification_code?: InputMaybe<InsertListingIntComparisonExp>;
  verification_codes_sent?: InputMaybe<InsertListingIntComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
};

export enum InsertListingPhoneNumbersConstraint {
  /** unique or primary key constraint on columns "id" */
  PhoneNumbersPkey = 'phone_numbers_pkey',
  /** unique or primary key constraint on columns "tenant_id", "number" */
  PhoneNumbersTenantIdOrganisationIdUnique = 'phone_numbers_tenant_id_organisation_id_unique',
  /** unique or primary key constraint on columns "tenant_id", "number" */
  PhoneNumbersTenantIdUserIdUnique = 'phone_numbers_tenant_id_user_id_unique'
}

export type InsertListingPhoneNumbersInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<InsertListingPhoneNumberTypeEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verification_attempts?: InputMaybe<Scalars['Int']['input']>;
  verification_code?: InputMaybe<Scalars['Int']['input']>;
  verification_codes_sent?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingPhoneNumbersOnConflict = {
  constraint: InsertListingPhoneNumbersConstraint;
  update_columns: Array<InsertListingPhoneNumbersUpdateColumn>;
  where?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
};

export enum InsertListingPhoneNumbersSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationAttempts = 'verification_attempts',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  VerificationCodesSent = 'verification_codes_sent',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPhoneNumbersSelectColumnPhoneNumbersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPhoneNumbersUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationAttempts = 'verification_attempts',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  VerificationCodesSent = 'verification_codes_sent',
  /** column name */
  Verified = 'verified'
}

export type InsertListingPipelinesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPipelinesBoolExp>>;
  _not?: InputMaybe<InsertListingPipelinesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPipelinesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  deletable?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  lead_type?: InputMaybe<InsertListingLeadTypeComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  stages?: InputMaybe<InsertListingLeadStagesBoolExp>;
  stages_aggregate?: InputMaybe<InsertListingLeadStagesAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPipelinesConstraint {
  /** unique or primary key constraint on columns "id" */
  PipelinesPkey = 'pipelines_pkey'
}

export type InsertListingPipelinesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<InsertListingLeadStagesArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPipelinesObjRelInsertInput = {
  data: InsertListingPipelinesInsertInput;
  on_conflict?: InputMaybe<InsertListingPipelinesOnConflict>;
};

export type InsertListingPipelinesOnConflict = {
  constraint: InsertListingPipelinesConstraint;
  update_columns: Array<InsertListingPipelinesUpdateColumn>;
  where?: InputMaybe<InsertListingPipelinesBoolExp>;
};

export enum InsertListingPipelinesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LeadType = 'lead_type',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPlaceTypeEnumEnum {
  /** Agglomeration */
  Agglomeration = 'agglomeration',
  /** Сountry */
  Country = 'country',
  /** District */
  District = 'district',
  /** Locality */
  Locality = 'locality',
  /** Municipality */
  Municipality = 'municipality',
  /** Neighbourhood */
  Neighbourhood = 'neighbourhood',
  /** Postcode */
  Postcode = 'postcode',
  /** Region */
  Region = 'region',
  /** State */
  State = 'state'
}

export type InsertListingPlaceTypeEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPlaceTypeEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPlaceTypeEnumEnum>>;
};

export type InsertListingPlacesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPlacesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPlacesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPlacesAggregateBoolExpCount>;
};

export type InsertListingPlacesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPlacesAggregateBoolExpBoolOr = {
  arguments: InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPlacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPlacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPlacesArrRelInsertInput = {
  data: Array<InsertListingPlacesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPlacesOnConflict>;
};

export type InsertListingPlacesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPlacesBoolExp>>;
  _not?: InputMaybe<InsertListingPlacesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPlacesBoolExp>>;
  agglomeration_id?: InputMaybe<InsertListingUuidComparisonExp>;
  breadcrumbs?: InputMaybe<InsertListingPlacesBreadcrumbsBoolExp>;
  breadcrumbs_aggregate?: InputMaybe<InsertListingPlacesBreadcrumbsAggregateBoolExp>;
  canonical_id?: InputMaybe<InsertListingUuidComparisonExp>;
  canonical_place?: InputMaybe<InsertListingPlacesBoolExp>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  catchment_areas_aggregate?: InputMaybe<InsertListingCatchmentAreasAggregateBoolExp>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  children_bbox?: InputMaybe<InsertListingJsonbComparisonExp>;
  country?: InputMaybe<InsertListingPlacesBoolExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  country_id?: InputMaybe<InsertListingUuidComparisonExp>;
  country_place?: InputMaybe<InsertListingPlacesBoolExp>;
  district?: InputMaybe<InsertListingPlacesBoolExp>;
  district_id?: InputMaybe<InsertListingUuidComparisonExp>;
  extra?: InputMaybe<InsertListingJsonbComparisonExp>;
  geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  hasura_type?: InputMaybe<InsertListingPlaceTypeEnumEnumComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  in_label?: InputMaybe<InsertListingStringComparisonExp>;
  in_label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  index?: InputMaybe<InsertListingBooleanComparisonExp>;
  index_rooms?: InputMaybe<InsertListingBooleanComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesBoolExp>;
  lead_looking_places_aggregate?: InputMaybe<InsertListingLeadLookingPlacesAggregateBoolExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingPlacesBoolExp>;
  locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality?: InputMaybe<InsertListingPlacesBoolExp>;
  municipality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality_places?: InputMaybe<InsertListingPlacesBoolExp>;
  municipality_places_aggregate?: InputMaybe<InsertListingPlacesAggregateBoolExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  neighbourhood?: InputMaybe<InsertListingPlacesBoolExp>;
  neighbourhood_id?: InputMaybe<InsertListingUuidComparisonExp>;
  parent_places?: InputMaybe<InsertListingPlacesBoolExp>;
  population?: InputMaybe<InsertListingIntComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  postcode_id?: InputMaybe<InsertListingUuidComparisonExp>;
  properties?: InputMaybe<InsertListingPropertiesBoolExp>;
  region_id?: InputMaybe<InsertListingUuidComparisonExp>;
  search_base?: InputMaybe<InsertListingTsvectorComparisonExp>;
  simplified_geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  slug?: InputMaybe<InsertListingStringComparisonExp>;
  slug_de?: InputMaybe<InsertListingStringComparisonExp>;
  slug_en?: InputMaybe<InsertListingStringComparisonExp>;
  slug_es?: InputMaybe<InsertListingStringComparisonExp>;
  slug_fr?: InputMaybe<InsertListingStringComparisonExp>;
  slug_it?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingPlacesBoolExp>;
  state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  state_places?: InputMaybe<InsertListingPlacesBoolExp>;
  state_places_aggregate?: InputMaybe<InsertListingPlacesAggregateBoolExp>;
  type?: InputMaybe<InsertListingPlaceTypeEnumEnumComparisonExp>;
};

export type InsertListingPlacesBreadcrumbsAggregateBoolExp = {
  count?: InputMaybe<InsertListingPlacesBreadcrumbsAggregateBoolExpCount>;
};

export type InsertListingPlacesBreadcrumbsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPlacesBreadcrumbsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPlacesBreadcrumbsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPlacesBreadcrumbsArrRelInsertInput = {
  data: Array<InsertListingPlacesBreadcrumbsInsertInput>;
};

export type InsertListingPlacesBreadcrumbsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPlacesBreadcrumbsBoolExp>>;
  _not?: InputMaybe<InsertListingPlacesBreadcrumbsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPlacesBreadcrumbsBoolExp>>;
  breadcrumb_place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_num?: InputMaybe<InsertListingBigintComparisonExp>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingPlacesBreadcrumbsInsertInput = {
  breadcrumb_place_id?: InputMaybe<Scalars['uuid']['input']>;
  order_num?: InputMaybe<Scalars['bigint']['input']>;
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingPlacesBreadcrumbsSelectColumn {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

export enum InsertListingPlacesConstraint {
  /** unique or primary key constraint on columns "id" */
  PlacesPkey = 'places_pkey',
  /** unique or primary key constraint on columns "slug_de" */
  PlacesSlugDeIdx = 'places_slug_de_idx',
  /** unique or primary key constraint on columns "slug_en" */
  PlacesSlugEnIdx = 'places_slug_en_idx',
  /** unique or primary key constraint on columns "slug_es" */
  PlacesSlugEsIdx = 'places_slug_es_idx',
  /** unique or primary key constraint on columns "slug_fr" */
  PlacesSlugFrIdx = 'places_slug_fr_idx',
  /** unique or primary key constraint on columns "slug_it" */
  PlacesSlugItIdx = 'places_slug_it_idx'
}

export type InsertListingPlacesInsertInput = {
  agglomeration_id?: InputMaybe<Scalars['uuid']['input']>;
  breadcrumbs?: InputMaybe<InsertListingPlacesBreadcrumbsArrRelInsertInput>;
  canonical_id?: InputMaybe<Scalars['uuid']['input']>;
  canonical_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasArrRelInsertInput>;
  centroid?: InputMaybe<Scalars['geometry']['input']>;
  children_bbox?: InputMaybe<Scalars['jsonb']['input']>;
  country?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  country_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  district?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  extra?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  hasura_type?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_label_fr?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  index_rooms?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lead_looking_places?: InputMaybe<InsertListingLeadLookingPlacesArrRelInsertInput>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_places?: InputMaybe<InsertListingPlacesArrRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  search_base?: InputMaybe<Scalars['tsvector']['input']>;
  slug_de?: InputMaybe<Scalars['String']['input']>;
  slug_en?: InputMaybe<Scalars['String']['input']>;
  slug_es?: InputMaybe<Scalars['String']['input']>;
  slug_fr?: InputMaybe<Scalars['String']['input']>;
  slug_it?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  state_places?: InputMaybe<InsertListingPlacesArrRelInsertInput>;
  type?: InputMaybe<InsertListingPlaceTypeEnumEnum>;
};

export type InsertListingPlacesObjRelInsertInput = {
  data: InsertListingPlacesInsertInput;
  on_conflict?: InputMaybe<InsertListingPlacesOnConflict>;
};

export type InsertListingPlacesOnConflict = {
  constraint: InsertListingPlacesConstraint;
  update_columns: Array<InsertListingPlacesUpdateColumn>;
  where?: InputMaybe<InsertListingPlacesBoolExp>;
};

export enum InsertListingPlacesSelectColumn {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  HasuraType = 'hasura_type',
  /** column name */
  Id = 'id',
  /** column name */
  InLabelFr = 'in_label_fr',
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SimplifiedGeom = 'simplified_geom',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

export enum InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms'
}

export enum InsertListingPlacesSelectColumnPlacesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms'
}

export enum InsertListingPlacesUpdateColumn {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  HasuraType = 'hasura_type',
  /** column name */
  Id = 'id',
  /** column name */
  InLabelFr = 'in_label_fr',
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

export type InsertListingPortalIdxProtocolComparisonExp = {
  _eq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _in?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _lte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _neq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _nin?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
};

export type InsertListingPortalListingsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPortalListingsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPortalListingsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPortalListingsAggregateBoolExpCount>;
};

export type InsertListingPortalListingsAggregateBoolExpBoolAnd = {
  arguments: InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPortalListingsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPortalListingsAggregateBoolExpBoolOr = {
  arguments: InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPortalListingsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPortalListingsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPortalListingsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPortalListingsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPortalListingsArrRelInsertInput = {
  data: Array<InsertListingPortalListingsInsertInput>;
  on_conflict?: InputMaybe<InsertListingPortalListingsOnConflict>;
};

export type InsertListingPortalListingsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPortalListingsBoolExp>>;
  _not?: InputMaybe<InsertListingPortalListingsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPortalListingsBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  external_property_id?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  last_publication_warnings?: InputMaybe<InsertListingJsonbComparisonExp>;
  live?: InputMaybe<InsertListingBooleanComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  milliseconds_online?: InputMaybe<InsertListingFloatComparisonExp>;
  portal?: InputMaybe<InsertListingPortalsBoolExp>;
  portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPortalListingsConstraint {
  /** unique or primary key constraint on columns "id" */
  PortalListingsPkey = 'portal_listings_pkey',
  /** unique or primary key constraint on columns "portal_id", "lot_id" */
  PortalListingsPortalIdLotIdKey = 'portal_listings_portal_id_lot_id_key'
}

export type InsertListingPortalListingsInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_property_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_publication_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  milliseconds_online?: InputMaybe<Scalars['Float']['input']>;
  portal?: InputMaybe<InsertListingPortalsObjRelInsertInput>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPortalListingsOnConflict = {
  constraint: InsertListingPortalListingsConstraint;
  update_columns: Array<InsertListingPortalListingsUpdateColumn>;
  where?: InputMaybe<InsertListingPortalListingsBoolExp>;
};

export enum InsertListingPortalListingsSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalPropertyId = 'external_property_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastPublicationWarnings = 'last_publication_warnings',
  /** column name */
  Live = 'live',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MillisecondsOnline = 'milliseconds_online',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Live = 'live'
}

export enum InsertListingPortalListingsSelectColumnPortalListingsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Live = 'live'
}

export enum InsertListingPortalListingsUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalPropertyId = 'external_property_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastPublicationWarnings = 'last_publication_warnings',
  /** column name */
  Live = 'live',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MillisecondsOnline = 'milliseconds_online',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingPortalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPortalsBoolExp>>;
  _not?: InputMaybe<InsertListingPortalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPortalsBoolExp>>;
  active?: InputMaybe<InsertListingBooleanComparisonExp>;
  contract_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  exact_address_required?: InputMaybe<InsertListingBooleanComparisonExp>;
  exclude_from_published_stats?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_top_premium_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_protocol?: InputMaybe<InsertListingPortalIdxProtocolComparisonExp>;
  increment?: InputMaybe<InsertListingIntComparisonExp>;
  logo?: InputMaybe<InsertListingImagesBoolExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  master_portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  password?: InputMaybe<InsertListingStringComparisonExp>;
  port?: InputMaybe<InsertListingIntComparisonExp>;
  portal_listings?: InputMaybe<InsertListingPortalListingsBoolExp>;
  portal_listings_aggregate?: InputMaybe<InsertListingPortalListingsAggregateBoolExp>;
  quota?: InputMaybe<InsertListingIntComparisonExp>;
  shared_portal?: InputMaybe<InsertListingSharedPortalsBoolExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  teams_portals_aggregate?: InputMaybe<InsertListingTeamsPortalsAggregateBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  type?: InputMaybe<InsertListingPortalsTypesEnumEnumComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
  website_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingPortalsConstraint {
  /** unique or primary key constraint on columns "increment" */
  PortalsIncrementKey = 'portals_increment_key',
  /** unique or primary key constraint on columns "id" */
  RealEstatePortalsPkey = 'real_estate_portals_pkey'
}

export type InsertListingPortalsInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  logo?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  portal_listings?: InputMaybe<InsertListingPortalListingsArrRelInsertInput>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  shared_portal?: InputMaybe<InsertListingSharedPortalsObjRelInsertInput>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsArrRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<InsertListingPortalsTypesEnumEnum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingPortalsObjRelInsertInput = {
  data: InsertListingPortalsInsertInput;
  on_conflict?: InputMaybe<InsertListingPortalsOnConflict>;
};

export type InsertListingPortalsOnConflict = {
  constraint: InsertListingPortalsConstraint;
  update_columns: Array<InsertListingPortalsUpdateColumn>;
  where?: InputMaybe<InsertListingPortalsBoolExp>;
};

export enum InsertListingPortalsTypesEnumEnum {
  Api = 'api',
  Comparis = 'comparis',
  Idealista = 'idealista',
  Idx = 'idx',
  Pisos = 'pisos',
  Shared = 'shared'
}

export type InsertListingPortalsTypesEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPortalsTypesEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPortalsTypesEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPortalsTypesEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPortalsTypesEnumEnum>>;
};

export enum InsertListingPortalsUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  ExcludeFromPublishedStats = 'exclude_from_published_stats',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  Increment = 'increment',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MasterPortalId = 'master_portal_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type InsertListingPropertiesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertiesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertiesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertiesBoolExp>>;
  appraisals?: InputMaybe<InsertListingAppraisalsBoolExp>;
  appraisals_aggregate?: InputMaybe<InsertListingAppraisalsAggregateBoolExp>;
  balcony_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  basement_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  borrower_lead_id?: InputMaybe<InsertListingUuidComparisonExp>;
  building_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  building_standard?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume?: InputMaybe<InsertListingFloatComparisonExp>;
  building_volume_norm?: InputMaybe<InsertListingStringComparisonExp>;
  built_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  ceiling_height?: InputMaybe<InsertListingFloatComparisonExp>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  charges?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  commercial_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  computed_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  construction_year?: InputMaybe<InsertListingIntComparisonExp>;
  consumption?: InputMaybe<InsertListingIntComparisonExp>;
  cooling?: InputMaybe<InsertListingCoolingEnumEnumComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  country_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  ctn?: InputMaybe<InsertListingStringComparisonExp>;
  deleted_by_user?: InputMaybe<InsertListingBooleanComparisonExp>;
  distance_to_airport?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_city_center?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_grocery_shop?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_high_school?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_hospital?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_kindergarten?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_motorway?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_primary_school?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_public_transport?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_sports_center?: InputMaybe<InsertListingFloatComparisonExp>;
  distance_to_train_station?: InputMaybe<InsertListingFloatComparisonExp>;
  district_id?: InputMaybe<InsertListingUuidComparisonExp>;
  district_place?: InputMaybe<InsertListingPlacesBoolExp>;
  emissions?: InputMaybe<InsertListingIntComparisonExp>;
  energy_certificate_version?: InputMaybe<InsertListingStringComparisonExp>;
  energy_consumption_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnumComparisonExp>;
  energy_inspection_date?: InputMaybe<InsertListingDateComparisonExp>;
  energy_reference_year?: InputMaybe<InsertListingIntComparisonExp>;
  estimated_higher_energy_cost?: InputMaybe<InsertListingIntComparisonExp>;
  estimated_lower_energy_cost?: InputMaybe<InsertListingIntComparisonExp>;
  financing_institution_id?: InputMaybe<InsertListingUuidComparisonExp>;
  flat_condition?: InputMaybe<InsertListingFloatComparisonExp>;
  floor_of_flat?: InputMaybe<InsertListingIntComparisonExp>;
  garden_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  gas_emissions_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnumComparisonExp>;
  geom?: InputMaybe<InsertListingGeometryComparisonExp>;
  google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  gross_floor_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  has_attic?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_cellar?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_elevator?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_fireplace?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_gym?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_photovoltaic_panels?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_sauna?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_storage_room?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_wellness_area?: InputMaybe<InsertListingBooleanComparisonExp>;
  heating?: InputMaybe<InsertListingHeatingEnumEnumComparisonExp>;
  heating_distribution?: InputMaybe<InsertListingHeatingDistributionEnumEnumComparisonExp>;
  iazi_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  income_includes_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_child_friendly?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_commercial_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_luxury?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_maisonette?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_new_development?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_east?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_north?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_south?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_oriented_west?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_parking_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_rental?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_residential_fully_rented?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_secondary_residence?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_wheelchair_accessible?: InputMaybe<InsertListingBooleanComparisonExp>;
  land_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  latest_appraisal?: InputMaybe<InsertListingAppraisalsBoolExp>;
  latest_appraisal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  leads?: InputMaybe<InsertListingLeadsBoolExp>;
  leads_aggregate?: InputMaybe<InsertListingLeadsAggregateBoolExp>;
  living_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  locality_place?: InputMaybe<InsertListingPlacesBoolExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  macro_location?: InputMaybe<InsertListingFloatComparisonExp>;
  micro_location?: InputMaybe<InsertListingFloatComparisonExp>;
  minergie_code?: InputMaybe<InsertListingIntComparisonExp>;
  monthly_gross_rent?: InputMaybe<InsertListingFloatComparisonExp>;
  mortgages?: InputMaybe<InsertListingMortgagesBoolExp>;
  mortgages_aggregate?: InputMaybe<InsertListingMortgagesAggregateBoolExp>;
  municipality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality_place?: InputMaybe<InsertListingPlacesBoolExp>;
  neighbourhood_id?: InputMaybe<InsertListingUuidComparisonExp>;
  neighbourhood_place?: InputMaybe<InsertListingPlacesBoolExp>;
  number_of_bathrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_commercial_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_flats?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_floors?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_indoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_lifts?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_outdoor_parkings?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_residential_units?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_rooms?: InputMaybe<InsertListingFloatComparisonExp>;
  number_of_toilets?: InputMaybe<InsertListingIntComparisonExp>;
  orientation?: InputMaybe<InsertListingStringComparisonExp>;
  ownership_form?: InputMaybe<InsertListingStringComparisonExp>;
  parking_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  parking_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  perceived_value?: InputMaybe<InsertListingFloatComparisonExp>;
  places?: InputMaybe<InsertListingPlacesBoolExp>;
  plot_has_constructible_reserve?: InputMaybe<InsertListingBooleanComparisonExp>;
  plot_is_constructible?: InputMaybe<InsertListingBooleanComparisonExp>;
  plot_number?: InputMaybe<InsertListingStringComparisonExp>;
  plot_registry_number?: InputMaybe<InsertListingStringComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  postcode_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_files?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  property_files_aggregate?: InputMaybe<InsertListingPropertyFilesAggregateBoolExp>;
  property_images?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  property_images_aggregate?: InputMaybe<InsertListingPropertyImagesAggregateBoolExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  property_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  region_id?: InputMaybe<InsertListingUuidComparisonExp>;
  relevant_servitudes?: InputMaybe<InsertListingBooleanComparisonExp>;
  renovation_fund?: InputMaybe<InsertListingFloatComparisonExp>;
  renovation_year?: InputMaybe<InsertListingIntComparisonExp>;
  residential_potential_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  residential_yearly_rental_income?: InputMaybe<InsertListingFloatComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  share_of_ownership?: InputMaybe<InsertListingFloatComparisonExp>;
  side?: InputMaybe<InsertListingPropertySideEnumEnumComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  state_place?: InputMaybe<InsertListingPlacesBoolExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  sub_locality?: InputMaybe<InsertListingStringComparisonExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  terrace_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  tsv?: InputMaybe<InsertListingTsvectorComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  usable_surface?: InputMaybe<InsertListingFloatComparisonExp>;
  weighted_floor_surface?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingPropertiesConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertiesPkey = 'properties_pkey'
}

export type InsertListingPropertiesInsertInput = {
  appraisals?: InputMaybe<InsertListingAppraisalsArrRelInsertInput>;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  bed_type?: InputMaybe<Scalars['String']['input']>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<InsertListingCoolingEnumEnum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  district_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<InsertListingEnergyClassTypeEnumEnum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<InsertListingHeatingEnumEnum>;
  heating_distribution?: InputMaybe<InsertListingHeatingDistributionEnumEnum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal?: InputMaybe<InsertListingAppraisalsObjRelInsertInput>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  leads?: InputMaybe<InsertListingLeadsArrRelInsertInput>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  mortgages?: InputMaybe<InsertListingMortgagesArrRelInsertInput>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_files?: InputMaybe<InsertListingPropertyFilesArrRelInsertInput>;
  property_images?: InputMaybe<InsertListingPropertyImagesArrRelInsertInput>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  property_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<InsertListingPropertySideEnumEnum>;
  source_property_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  state_place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  window_view?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingPropertiesObjRelInsertInput = {
  data: InsertListingPropertiesInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertiesOnConflict>;
};

export type InsertListingPropertiesOnConflict = {
  constraint: InsertListingPropertiesConstraint;
  update_columns: Array<InsertListingPropertiesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertiesBoolExp>;
};

export enum InsertListingPropertiesUpdateColumn {
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BasementSurface = 'basement_surface',
  /** column name */
  BorrowerLeadId = 'borrower_lead_id',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CeilingHeight = 'ceiling_height',
  /** column name */
  Charges = 'charges',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cooling = 'cooling',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DistanceToAirport = 'distance_to_airport',
  /** column name */
  DistanceToCityCenter = 'distance_to_city_center',
  /** column name */
  DistanceToGroceryShop = 'distance_to_grocery_shop',
  /** column name */
  DistanceToHighSchool = 'distance_to_high_school',
  /** column name */
  DistanceToHospital = 'distance_to_hospital',
  /** column name */
  DistanceToKindergarten = 'distance_to_kindergarten',
  /** column name */
  DistanceToMotorway = 'distance_to_motorway',
  /** column name */
  DistanceToPrimarySchool = 'distance_to_primary_school',
  /** column name */
  DistanceToPublicTransport = 'distance_to_public_transport',
  /** column name */
  DistanceToSportsCenter = 'distance_to_sports_center',
  /** column name */
  DistanceToTrainStation = 'distance_to_train_station',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Emissions = 'emissions',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyConsumptionClass = 'energy_consumption_class',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FinancingInstitutionId = 'financing_institution_id',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GasEmissionsClass = 'gas_emissions_class',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  GrossFloorSurface = 'gross_floor_surface',
  /** column name */
  HasAttic = 'has_attic',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGym = 'has_gym',
  /** column name */
  HasPhotovoltaicPanels = 'has_photovoltaic_panels',
  /** column name */
  HasSauna = 'has_sauna',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWellnessArea = 'has_wellness_area',
  /** column name */
  Heating = 'heating',
  /** column name */
  HeatingDistribution = 'heating_distribution',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOrientedEast = 'is_oriented_east',
  /** column name */
  IsOrientedNorth = 'is_oriented_north',
  /** column name */
  IsOrientedSouth = 'is_oriented_south',
  /** column name */
  IsOrientedWest = 'is_oriented_west',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LatestAppraisalId = 'latest_appraisal_id',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MacroLocation = 'macro_location',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  MonthlyGrossRent = 'monthly_gross_rent',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  OwnershipForm = 'ownership_form',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PerceivedValue = 'perceived_value',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  PlotNumber = 'plot_number',
  /** column name */
  PlotRegistryNumber = 'plot_registry_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationFund = 'renovation_fund',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  WeightedFloorSurface = 'weighted_floor_surface'
}

export type InsertListingPropertiesUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExpCount>;
};

export type InsertListingPropertiesUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertiesUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertiesUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertiesUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertiesUsersArrRelInsertInput = {
  data: Array<InsertListingPropertiesUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertiesUsersOnConflict>;
};

export type InsertListingPropertiesUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertiesUsersBoolExp>>;
  _not?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertiesUsersBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  role?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  verified?: InputMaybe<InsertListingBooleanComparisonExp>;
};

export enum InsertListingPropertiesUsersConstraint {
  /** unique or primary key constraint on columns "property_id", "user_id" */
  PropertiesUsersPropertyIdUserIdUnique = 'properties_users_property_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  PropertyOwnersPkey = 'property_owners_pkey'
}

export type InsertListingPropertiesUsersInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingPropertiesUsersOnConflict = {
  constraint: InsertListingPropertiesUsersConstraint;
  update_columns: Array<InsertListingPropertiesUsersUpdateColumn>;
  where?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
};

export enum InsertListingPropertiesUsersSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPropertiesUsersSelectColumnPropertiesUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Verified = 'verified'
}

export enum InsertListingPropertiesUsersUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

export type InsertListingPropertyFilesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertyFilesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertyFilesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertyFilesAggregateBoolExpCount>;
};

export type InsertListingPropertyFilesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyFilesAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertyFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertyFilesArrRelInsertInput = {
  data: Array<InsertListingPropertyFilesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertyFilesOnConflict>;
};

export type InsertListingPropertyFilesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyFilesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyFilesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyFilesBoolExp>>;
  file?: InputMaybe<InsertListingFilesBoolExp>;
  file_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_visible?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertyFilesConstraint {
  /** unique or primary key constraint on columns "property_id", "file_id" */
  PropertyFilesPropertyIdFileIdUnique = 'property_files_property_id_file_id_unique',
  /** unique or primary key constraint on columns "property_id", "file_id" */
  UniquePropertyIdFileId = 'unique_property_id_file_id',
  /** unique or primary key constraint on columns "order_nr", "property_id" */
  UniquePropertyIdOrderNr = 'unique_property_id_order_nr'
}

export type InsertListingPropertyFilesInsertInput = {
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<InsertListingFilesObjRelInsertInput>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertyFilesOnConflict = {
  constraint: InsertListingPropertyFilesConstraint;
  update_columns: Array<InsertListingPropertyFilesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyFilesBoolExp>;
};

export enum InsertListingPropertyFilesSelectColumn {
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TenantId = 'tenant_id'
}

export enum InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingPropertyFilesSelectColumnPropertyFilesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsVisible = 'is_visible'
}

export enum InsertListingPropertyFilesUpdateColumn {
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TenantId = 'tenant_id'
}

export type InsertListingPropertyImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertyImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertyImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertyImagesAggregateBoolExpCount>;
};

export type InsertListingPropertyImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertyImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertyImagesArrRelInsertInput = {
  data: Array<InsertListingPropertyImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertyImagesOnConflict>;
};

export type InsertListingPropertyImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyImagesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyImagesBoolExp>>;
  background_color?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  crop?: InputMaybe<InsertListingStringComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  display_on_brochure?: InputMaybe<InsertListingBooleanComparisonExp>;
  display_on_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_floor_plan?: InputMaybe<InsertListingBooleanComparisonExp>;
  landscape_background_color?: InputMaybe<InsertListingStringComparisonExp>;
  landscape_crop?: InputMaybe<InsertListingStringComparisonExp>;
  landscape_size?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  size?: InputMaybe<InsertListingStringComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPropertyImagesConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyImagesPkey = 'property_images_pkey',
  /** unique or primary key constraint on columns "property_id", "image_id" */
  PropertyImagesPropertyIdImageIdUnique = 'property_images_property_id_image_id_unique',
  /** unique or primary key constraint on columns "order_nr", "property_id" */
  PropertyImagesPropertyIdOrderNrUnique = 'property_images_property_id_order_nr_unique'
}

export type InsertListingPropertyImagesInsertInput = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPropertyImagesOnConflict = {
  constraint: InsertListingPropertyImagesConstraint;
  update_columns: Array<InsertListingPropertyImagesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyImagesBoolExp>;
};

export enum InsertListingPropertyImagesSelectColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

export enum InsertListingPropertyImagesSelectColumnPropertyImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

export enum InsertListingPropertyImagesUpdateColumn {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPropertySearchAggregatorSourceEnum {
  ListingClickout = 'listing_clickout',
  ListingSimilarClick = 'listing_similar_click',
  ListingsManual = 'listings_manual',
  ListingsPageNavigationClick = 'listings_page_navigation_click'
}

export type InsertListingPropertySearchAggregatorSourceEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnum>;
  _in?: InputMaybe<Array<InsertListingPropertySearchAggregatorSourceEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnum>;
  _nin?: InputMaybe<Array<InsertListingPropertySearchAggregatorSourceEnum>>;
};

export enum InsertListingPropertySearchSourceEnum {
  Aggregator = 'aggregator',
  Crm = 'crm',
  Enquiry = 'enquiry',
  ImmologicForm = 'immologic_form',
  Other = 'other',
  Valuation = 'valuation'
}

export type InsertListingPropertySearchSourceEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPropertySearchSourceEnum>;
  _in?: InputMaybe<Array<InsertListingPropertySearchSourceEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPropertySearchSourceEnum>;
  _nin?: InputMaybe<Array<InsertListingPropertySearchSourceEnum>>;
};

export type InsertListingPropertySearchesAggregateBoolExp = {
  avg?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingPropertySearchesAggregateBoolExpVarSamp>;
};

export type InsertListingPropertySearchesAggregateBoolExpAvg = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCorr = {
  arguments: InsertListingPropertySearchesAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCorrArguments = {
  X: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingPropertySearchesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCovarSamp = {
  arguments: InsertListingPropertySearchesAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpCovarSampArguments = {
  X: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingPropertySearchesAggregateBoolExpMax = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpMin = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpStddevSamp = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpSum = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesAggregateBoolExpVarSamp = {
  arguments: InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingPropertySearchesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesOnConflict>;
};

export type InsertListingPropertySearchesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesBoolExp>>;
  activate_aggregator?: InputMaybe<InsertListingBooleanComparisonExp>;
  agency_reference_contains?: InputMaybe<InsertListingStringComparisonExp>;
  aggregator_source?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnumComparisonExp>;
  awaiting_alert_handle?: InputMaybe<InsertListingBooleanComparisonExp>;
  balcony_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  book_online?: InputMaybe<InsertListingBooleanComparisonExp>;
  built_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  built_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  comment?: InputMaybe<InsertListingStringComparisonExp>;
  composite_property_type_eq?: InputMaybe<InsertListingStringComparisonExp>;
  computed_budget_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  computed_budget_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at_gte?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  garden_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  geog?: InputMaybe<InsertListingGeographyComparisonExp>;
  gross_rent_m2_yearly_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  gross_rent_m2_yearly_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  gross_rent_room_monthly_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  gross_rent_room_monthly_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  has_balcony?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_fireplace?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_garage?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_garden?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_lift?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_parking?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_swimming_pool?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_view?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  imported_id?: InputMaybe<InsertListingStringComparisonExp>;
  is_child_friendly?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_fsbo?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_furnished?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_minergie_certified?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_new_development?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_wheelchair_accessible?: InputMaybe<InsertListingBooleanComparisonExp>;
  land_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  land_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  last_alert_handle?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_notified_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  last_viewed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  living_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  living_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  max_distance?: InputMaybe<InsertListingFloat8ComparisonExp>;
  monthly_rent_gte?: InputMaybe<InsertListingIntComparisonExp>;
  monthly_rent_lte?: InputMaybe<InsertListingIntComparisonExp>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  notification?: InputMaybe<InsertListingPropertySearchesNotificationComparisonExp>;
  number_of_bathrooms_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bathrooms_lte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_bedrooms_lte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_indoor_parkings_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_outdoor_parkings_gte?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_rooms_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  number_of_rooms_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  offer_type?: InputMaybe<InsertListingStringComparisonExp>;
  portal_in?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_main_type_in?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_main_type_nin?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_searches_enquiries?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
  property_searches_enquiries_aggregate?: InputMaybe<InsertListingPropertySearchesEnquiriesAggregateBoolExp>;
  property_searches_places?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
  property_searches_places_aggregate?: InputMaybe<InsertListingPropertySearchesPlacesAggregateBoolExp>;
  property_status?: InputMaybe<InsertListingStringArrayComparisonExp>;
  property_types?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
  property_types_aggregate?: InputMaybe<InsertListingPropertySearchesPropertyTypesAggregateBoolExp>;
  property_usage?: InputMaybe<InsertListingStringComparisonExp>;
  rental_return_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  rental_return_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_gte?: InputMaybe<InsertListingIntComparisonExp>;
  sale_price_lte?: InputMaybe<InsertListingIntComparisonExp>;
  sale_price_per_land_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_per_land_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_per_living_surface_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_price_per_living_surface_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_vs_estimated_price_gte?: InputMaybe<InsertListingFloatComparisonExp>;
  sale_vs_estimated_price_lte?: InputMaybe<InsertListingFloatComparisonExp>;
  session_id?: InputMaybe<InsertListingStringComparisonExp>;
  source?: InputMaybe<InsertListingPropertySearchSourceEnumComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertySearchesTmpPkey = 'property_searches_tmp_pkey'
}

export type InsertListingPropertySearchesEnquiriesAggregateBoolExp = {
  count?: InputMaybe<InsertListingPropertySearchesEnquiriesAggregateBoolExpCount>;
};

export type InsertListingPropertySearchesEnquiriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesEnquiriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesEnquiriesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesEnquiriesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesEnquiriesOnConflict>;
};

export type InsertListingPropertySearchesEnquiriesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesEnquiriesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesEnquiriesBoolExp>>;
  enquiry?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiry_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_search?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_search_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesEnquiriesConstraint {
  /** unique or primary key constraint on columns "property_search_id", "enquiry_id" */
  PropertySearchesInquiriesPkey = 'property_searches_inquiries_pkey'
}

export type InsertListingPropertySearchesEnquiriesInsertInput = {
  enquiry?: InputMaybe<InsertListingEnquiriesObjRelInsertInput>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search?: InputMaybe<InsertListingPropertySearchesObjRelInsertInput>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesEnquiriesOnConflict = {
  constraint: InsertListingPropertySearchesEnquiriesConstraint;
  update_columns: Array<InsertListingPropertySearchesEnquiriesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesEnquiriesBoolExp>;
};

export enum InsertListingPropertySearchesEnquiriesSelectColumn {
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export enum InsertListingPropertySearchesEnquiriesUpdateColumn {
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export type InsertListingPropertySearchesInsertInput = {
  activate_aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<InsertListingPropertySearchAggregatorSourceEnum>;
  awaiting_alert_handle?: InputMaybe<Scalars['Boolean']['input']>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at_gte?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  last_alert_handle?: InputMaybe<Scalars['timestamptz']['input']>;
  last_notified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_searches_enquiries?: InputMaybe<InsertListingPropertySearchesEnquiriesArrRelInsertInput>;
  property_searches_places?: InputMaybe<InsertListingPropertySearchesPlacesArrRelInsertInput>;
  property_statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  property_types?: InputMaybe<InsertListingPropertySearchesPropertyTypesArrRelInsertInput>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<InsertListingPropertySearchSourceEnum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesNotificationComparisonExp = {
  _eq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _in?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _lte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _neq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _nin?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
};

export type InsertListingPropertySearchesObjRelInsertInput = {
  data: InsertListingPropertySearchesInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertySearchesOnConflict>;
};

export type InsertListingPropertySearchesOnConflict = {
  constraint: InsertListingPropertySearchesConstraint;
  update_columns: Array<InsertListingPropertySearchesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesBoolExp>;
};

export type InsertListingPropertySearchesPlacesAggregateBoolExp = {
  count?: InputMaybe<InsertListingPropertySearchesPlacesAggregateBoolExpCount>;
};

export type InsertListingPropertySearchesPlacesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesPlacesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesPlacesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesPlacesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesPlacesOnConflict>;
};

export type InsertListingPropertySearchesPlacesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesPlacesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesPlacesBoolExp>>;
  place?: InputMaybe<InsertListingPlacesBoolExp>;
  place_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_search?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_search_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesPlacesConstraint {
  /** unique or primary key constraint on columns "property_search_id", "place_id" */
  PropertySearchesPlacesPkey = 'property_searches_places_pkey'
}

export type InsertListingPropertySearchesPlacesInsertInput = {
  place?: InputMaybe<InsertListingPlacesObjRelInsertInput>;
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search?: InputMaybe<InsertListingPropertySearchesObjRelInsertInput>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesPlacesOnConflict = {
  constraint: InsertListingPropertySearchesPlacesConstraint;
  update_columns: Array<InsertListingPropertySearchesPlacesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesPlacesBoolExp>;
};

export enum InsertListingPropertySearchesPlacesSelectColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export enum InsertListingPropertySearchesPlacesUpdateColumn {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

export type InsertListingPropertySearchesPropertyTypesAggregateBoolExp = {
  count?: InputMaybe<InsertListingPropertySearchesPropertyTypesAggregateBoolExpCount>;
};

export type InsertListingPropertySearchesPropertyTypesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertySearchesPropertyTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertySearchesPropertyTypesArrRelInsertInput = {
  data: Array<InsertListingPropertySearchesPropertyTypesInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertySearchesPropertyTypesOnConflict>;
};

export type InsertListingPropertySearchesPropertyTypesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertySearchesPropertyTypesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertySearchesPropertyTypesBoolExp>>;
  property_search?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_search_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  property_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPropertySearchesPropertyTypesConstraint {
  /** unique or primary key constraint on columns "property_type_id", "property_search_id" */
  PropertySearchesPropertyTypesPropertySearchIdPropertyTy = 'property_searches_property_types_property_search_id_property_ty'
}

export type InsertListingPropertySearchesPropertyTypesInsertInput = {
  property_search?: InputMaybe<InsertListingPropertySearchesObjRelInsertInput>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPropertySearchesPropertyTypesOnConflict = {
  constraint: InsertListingPropertySearchesPropertyTypesConstraint;
  update_columns: Array<InsertListingPropertySearchesPropertyTypesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertySearchesPropertyTypesBoolExp>;
};

export enum InsertListingPropertySearchesPropertyTypesSelectColumn {
  /** column name */
  PropertySearchId = 'property_search_id',
  /** column name */
  PropertyTypeId = 'property_type_id'
}

export enum InsertListingPropertySearchesPropertyTypesUpdateColumn {
  /** column name */
  PropertySearchId = 'property_search_id',
  /** column name */
  PropertyTypeId = 'property_type_id'
}

export enum InsertListingPropertySearchesSelectColumn {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceGte = 'built_surface_gte',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  ComputedBudgetGte = 'computed_budget_gte',
  /** column name */
  ComputedBudgetLte = 'computed_budget_lte',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedAtGte = 'created_at_gte',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastNotifiedAt = 'last_notified_at',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpMinArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpSumArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesSelectColumnPropertySearchesAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  MaxDistance = 'max_distance'
}

export enum InsertListingPropertySearchesUpdateColumn {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceGte = 'built_surface_gte',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedAtGte = 'created_at_gte',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastNotifiedAt = 'last_notified_at',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPropertySideEnumEnum {
  Exterior = 'exterior',
  Interior = 'interior'
}

export type InsertListingPropertySideEnumEnumComparisonExp = {
  _eq?: InputMaybe<InsertListingPropertySideEnumEnum>;
  _in?: InputMaybe<Array<InsertListingPropertySideEnumEnum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InsertListingPropertySideEnumEnum>;
  _nin?: InputMaybe<Array<InsertListingPropertySideEnumEnum>>;
};

export type InsertListingPropertyTransactionsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExpCount>;
};

export type InsertListingPropertyTransactionsAggregateBoolExpBoolAnd = {
  arguments: InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyTransactionsAggregateBoolExpBoolOr = {
  arguments: InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingPropertyTransactionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPropertyTransactionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPropertyTransactionsArrRelInsertInput = {
  data: Array<InsertListingPropertyTransactionsInsertInput>;
  on_conflict?: InputMaybe<InsertListingPropertyTransactionsOnConflict>;
};

export type InsertListingPropertyTransactionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyTransactionsBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyTransactionsBoolExp>>;
  buyer_broker?: InputMaybe<InsertListingUsersBoolExp>;
  buyer_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyer_broker_team?: InputMaybe<InsertListingTeamsBoolExp>;
  buyer_broker_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  buyers?: InputMaybe<InsertListingTransactionBuyersBoolExp>;
  buyers_aggregate?: InputMaybe<InsertListingTransactionBuyersAggregateBoolExp>;
  commissions?: InputMaybe<InsertListingCommissionsBoolExp>;
  commissions_aggregate?: InputMaybe<InsertListingCommissionsAggregateBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  estimated_signature_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_published?: InputMaybe<InsertListingBooleanComparisonExp>;
  lot?: InputMaybe<InsertListingLotsBoolExp>;
  lot_id?: InputMaybe<InsertListingUuidComparisonExp>;
  notary_id?: InputMaybe<InsertListingUuidComparisonExp>;
  payment_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  property?: InputMaybe<InsertListingPropertiesBoolExp>;
  property_id?: InputMaybe<InsertListingUuidComparisonExp>;
  purchase_price?: InputMaybe<InsertListingFloatComparisonExp>;
  seller_broker?: InputMaybe<InsertListingUsersBoolExp>;
  seller_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  seller_broker_team?: InputMaybe<InsertListingTeamsBoolExp>;
  seller_broker_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  sellers?: InputMaybe<InsertListingTransactionSellersBoolExp>;
  sellers_aggregate?: InputMaybe<InsertListingTransactionSellersAggregateBoolExp>;
  signature_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPropertyTransactionsConstraint {
  /** unique or primary key constraint on columns "id" */
  PropertyTransactionsPkey = 'property_transactions_pkey'
}

export type InsertListingPropertyTransactionsInsertInput = {
  buyer_broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  buyers?: InputMaybe<InsertListingTransactionBuyersArrRelInsertInput>;
  commissions?: InputMaybe<InsertListingCommissionsArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<InsertListingLotsObjRelInsertInput>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property?: InputMaybe<InsertListingPropertiesObjRelInsertInput>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  seller_broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  sellers?: InputMaybe<InsertListingTransactionSellersArrRelInsertInput>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPropertyTransactionsObjRelInsertInput = {
  data: InsertListingPropertyTransactionsInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertyTransactionsOnConflict>;
};

export type InsertListingPropertyTransactionsOnConflict = {
  constraint: InsertListingPropertyTransactionsConstraint;
  update_columns: Array<InsertListingPropertyTransactionsUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
};

export enum InsertListingPropertyTransactionsSelectColumn {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPublished = 'is_published'
}

export enum InsertListingPropertyTransactionsSelectColumnPropertyTransactionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPublished = 'is_published'
}

export enum InsertListingPropertyTransactionsUpdateColumn {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingPropertyTypesBoolExp = {
  _and?: InputMaybe<Array<InsertListingPropertyTypesBoolExp>>;
  _not?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  _or?: InputMaybe<Array<InsertListingPropertyTypesBoolExp>>;
  appraisal_type?: InputMaybe<InsertListingStringComparisonExp>;
  composite_type?: InputMaybe<InsertListingStringComparisonExp>;
  composite_type_object?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_type_id?: InputMaybe<InsertListingIntComparisonExp>;
  is_visible?: InputMaybe<InsertListingBooleanComparisonExp>;
  label?: InputMaybe<InsertListingStringComparisonExp>;
  label_de?: InputMaybe<InsertListingStringComparisonExp>;
  label_en?: InputMaybe<InsertListingStringComparisonExp>;
  label_es?: InputMaybe<InsertListingStringComparisonExp>;
  label_fr?: InputMaybe<InsertListingStringComparisonExp>;
  label_it?: InputMaybe<InsertListingStringComparisonExp>;
  main_type?: InputMaybe<InsertListingStringComparisonExp>;
  main_type_object?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  parent_type?: InputMaybe<InsertListingPropertyTypesBoolExp>;
  pricehubble_subcode?: InputMaybe<InsertListingStringComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingPropertyTypesConstraint {
  /** unique or primary key constraint on columns "name" */
  PropertyTypesNameUnique = 'property_types_name_unique',
  /** unique or primary key constraint on columns "id" */
  PropertyTypesPkey = 'property_types_pkey'
}

export type InsertListingPropertyTypesInsertInput = {
  appraisal_type?: InputMaybe<Scalars['String']['input']>;
  composite_type?: InputMaybe<Scalars['String']['input']>;
  composite_type_object?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_type_id?: InputMaybe<Scalars['Int']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  main_type?: InputMaybe<Scalars['String']['input']>;
  main_type_object?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  parent_type?: InputMaybe<InsertListingPropertyTypesObjRelInsertInput>;
  pricehubble_subcode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingPropertyTypesObjRelInsertInput = {
  data: InsertListingPropertyTypesInsertInput;
  on_conflict?: InputMaybe<InsertListingPropertyTypesOnConflict>;
};

export type InsertListingPropertyTypesOnConflict = {
  constraint: InsertListingPropertyTypesConstraint;
  update_columns: Array<InsertListingPropertyTypesUpdateColumn>;
  where?: InputMaybe<InsertListingPropertyTypesBoolExp>;
};

export enum InsertListingPropertyTypesUpdateColumn {
  /** column name */
  AppraisalType = 'appraisal_type',
  /** column name */
  CompositeType = 'composite_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdxTypeId = 'idx_type_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  MainType = 'main_type',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PricehubbleSubcode = 'pricehubble_subcode',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingPushNotificationTokensAggregateBoolExp = {
  count?: InputMaybe<InsertListingPushNotificationTokensAggregateBoolExpCount>;
};

export type InsertListingPushNotificationTokensAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingPushNotificationTokensSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingPushNotificationTokensArrRelInsertInput = {
  data: Array<InsertListingPushNotificationTokensInsertInput>;
  on_conflict?: InputMaybe<InsertListingPushNotificationTokensOnConflict>;
};

export type InsertListingPushNotificationTokensBoolExp = {
  _and?: InputMaybe<Array<InsertListingPushNotificationTokensBoolExp>>;
  _not?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
  _or?: InputMaybe<Array<InsertListingPushNotificationTokensBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  token?: InputMaybe<InsertListingStringComparisonExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingPushNotificationTokensConstraint {
  /** unique or primary key constraint on columns "id" */
  PushNotificationTokensPkey = 'push_notification_tokens_pkey'
}

export type InsertListingPushNotificationTokensInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingPushNotificationTokensOnConflict = {
  constraint: InsertListingPushNotificationTokensConstraint;
  update_columns: Array<InsertListingPushNotificationTokensUpdateColumn>;
  where?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
};

export enum InsertListingPushNotificationTokensSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingPushNotificationTokensUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Token = 'token',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingReadOnlyTenantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingReadOnlyTenantsBoolExp>>;
  _not?: InputMaybe<InsertListingReadOnlyTenantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingReadOnlyTenantsBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingReadOnlyTenantsInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingReadOnlyTenantsObjRelInsertInput = {
  data: InsertListingReadOnlyTenantsInsertInput;
};

export type InsertListingReviewsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingReviewsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingReviewsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingReviewsAggregateBoolExpCount>;
};

export type InsertListingReviewsAggregateBoolExpBoolAnd = {
  arguments: InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingReviewsAggregateBoolExpBoolOr = {
  arguments: InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingReviewsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingReviewsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingReviewsArrRelInsertInput = {
  data: Array<InsertListingReviewsInsertInput>;
  on_conflict?: InputMaybe<InsertListingReviewsOnConflict>;
};

export type InsertListingReviewsBoolExp = {
  _and?: InputMaybe<Array<InsertListingReviewsBoolExp>>;
  _not?: InputMaybe<InsertListingReviewsBoolExp>;
  _or?: InputMaybe<Array<InsertListingReviewsBoolExp>>;
  completed?: InputMaybe<InsertListingBooleanComparisonExp>;
  completed_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  display_name?: InputMaybe<InsertListingStringComparisonExp>;
  email_address?: InputMaybe<InsertListingStringComparisonExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  formatted_address?: InputMaybe<InsertListingStringComparisonExp>;
  google_address?: InputMaybe<InsertListingGoogleAddressesBoolExp>;
  google_address_id?: InputMaybe<InsertListingUuidComparisonExp>;
  has_accepted_terms?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_buyer?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_seller?: InputMaybe<InsertListingBooleanComparisonExp>;
  language?: InputMaybe<InsertListingStringComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  neverbounce_result?: InputMaybe<InsertListingStringComparisonExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  rating?: InputMaybe<InsertListingIntComparisonExp>;
  review_text?: InputMaybe<InsertListingStringComparisonExp>;
  review_url?: InputMaybe<InsertListingStringComparisonExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  transaction_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingReviewsConstraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ReviewsIdTenantIdUnique = 'reviews_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey'
}

export type InsertListingReviewsInsertInput = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<InsertListingGoogleAddressesObjRelInsertInput>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingReviewsOnConflict = {
  constraint: InsertListingReviewsConstraint;
  update_columns: Array<InsertListingReviewsUpdateColumn>;
  where?: InputMaybe<InsertListingReviewsBoolExp>;
};

export enum InsertListingReviewsSelectColumn {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

export enum InsertListingReviewsSelectColumnReviewsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

export enum InsertListingReviewsUpdateColumn {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingSharedPortalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingSharedPortalsBoolExp>>;
  _not?: InputMaybe<InsertListingSharedPortalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingSharedPortalsBoolExp>>;
  active?: InputMaybe<InsertListingBooleanComparisonExp>;
  contract_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  email?: InputMaybe<InsertListingStringComparisonExp>;
  exact_address_required?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_top_premium_listing?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_protocol?: InputMaybe<InsertListingPortalIdxProtocolComparisonExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  password?: InputMaybe<InsertListingStringComparisonExp>;
  port?: InputMaybe<InsertListingIntComparisonExp>;
  quota?: InputMaybe<InsertListingIntComparisonExp>;
  type?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  url?: InputMaybe<InsertListingStringComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
  website_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export type InsertListingSharedPortalsInsertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingSharedPortalsObjRelInsertInput = {
  data: InsertListingSharedPortalsInsertInput;
};

export type InsertListingSmallintComparisonExp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

export type InsertListingStDWithinGeographyInput = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsertListingStDWithinInput = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type InsertListingStringArrayComparisonExp = {
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

export type InsertListingStringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  _niregex?: InputMaybe<Scalars['String']['input']>;
  _nlike?: InputMaybe<Scalars['String']['input']>;
  _nregex?: InputMaybe<Scalars['String']['input']>;
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  _regex?: InputMaybe<Scalars['String']['input']>;
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingSubscriptionStatusComparisonExp = {
  _eq?: InputMaybe<Scalars['subscription_status']['input']>;
  _gt?: InputMaybe<Scalars['subscription_status']['input']>;
  _gte?: InputMaybe<Scalars['subscription_status']['input']>;
  _in?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['subscription_status']['input']>;
  _lte?: InputMaybe<Scalars['subscription_status']['input']>;
  _neq?: InputMaybe<Scalars['subscription_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
};

export type InsertListingSubscriptionsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingSubscriptionsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingSubscriptionsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingSubscriptionsAggregateBoolExpCount>;
};

export type InsertListingSubscriptionsAggregateBoolExpBoolAnd = {
  arguments: InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingSubscriptionsAggregateBoolExpBoolOr = {
  arguments: InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingSubscriptionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingSubscriptionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingSubscriptionsArrRelInsertInput = {
  data: Array<InsertListingSubscriptionsInsertInput>;
  on_conflict?: InputMaybe<InsertListingSubscriptionsOnConflict>;
};

export type InsertListingSubscriptionsBoolExp = {
  _and?: InputMaybe<Array<InsertListingSubscriptionsBoolExp>>;
  _not?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  _or?: InputMaybe<Array<InsertListingSubscriptionsBoolExp>>;
  application_fee_percent?: InputMaybe<InsertListingFloatComparisonExp>;
  billing_cycle_anchor?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  billing_thresholds?: InputMaybe<InsertListingJsonbComparisonExp>;
  cancel_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  cancel_at_period_end?: InputMaybe<InsertListingBooleanComparisonExp>;
  canceled_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  collection_method?: InputMaybe<InsertListingStringComparisonExp>;
  created?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  current_period_end?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  current_period_start?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  customer?: InputMaybe<InsertListingStringComparisonExp>;
  customer_email?: InputMaybe<InsertListingStringComparisonExp>;
  customer_name?: InputMaybe<InsertListingStringComparisonExp>;
  customer_object?: InputMaybe<InsertListingJsonbComparisonExp>;
  days_until_due?: InputMaybe<InsertListingIntComparisonExp>;
  default_payment_method?: InputMaybe<InsertListingStringComparisonExp>;
  default_source?: InputMaybe<InsertListingStringComparisonExp>;
  default_tax_rates?: InputMaybe<InsertListingJsonbComparisonExp>;
  discount?: InputMaybe<InsertListingJsonbComparisonExp>;
  email?: InputMaybe<InsertListingEmailsBoolExp>;
  ended_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  interval_count?: InputMaybe<InsertListingIntComparisonExp>;
  invoices?: InputMaybe<InsertListingInvoicesBoolExp>;
  invoices_aggregate?: InputMaybe<InsertListingInvoicesAggregateBoolExp>;
  items?: InputMaybe<InsertListingJsonbComparisonExp>;
  latest_invoice?: InputMaybe<InsertListingStringComparisonExp>;
  livemode?: InputMaybe<InsertListingBooleanComparisonExp>;
  metadata?: InputMaybe<InsertListingJsonbComparisonExp>;
  next_pending_invoice_item_invoice?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  pause_collection?: InputMaybe<InsertListingJsonbComparisonExp>;
  pending_invoice_item_interval?: InputMaybe<InsertListingJsonbComparisonExp>;
  pending_setup_intent?: InputMaybe<InsertListingStringComparisonExp>;
  pending_update?: InputMaybe<InsertListingJsonbComparisonExp>;
  plan_name?: InputMaybe<InsertListingStringComparisonExp>;
  quantity?: InputMaybe<InsertListingIntComparisonExp>;
  schedule?: InputMaybe<InsertListingStringComparisonExp>;
  start_date?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  status?: InputMaybe<InsertListingSubscriptionStatusComparisonExp>;
  stripe_id?: InputMaybe<InsertListingStringComparisonExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  total_amount?: InputMaybe<InsertListingIntComparisonExp>;
  transfer_data?: InputMaybe<InsertListingJsonbComparisonExp>;
  trial_end?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  trial_start?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingSubscriptionsConstraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPkey = 'subscriptions_pkey',
  /** unique or primary key constraint on columns "stripe_id" */
  SubscriptionsStripeIdUnique = 'subscriptions_stripe_id_unique'
}

export type InsertListingSubscriptionsInsertInput = {
  application_fee_percent?: InputMaybe<Scalars['Float']['input']>;
  billing_cycle_anchor?: InputMaybe<Scalars['timestamptz']['input']>;
  billing_thresholds?: InputMaybe<Scalars['jsonb']['input']>;
  cancel_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_email?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_object?: InputMaybe<Scalars['jsonb']['input']>;
  days_until_due?: InputMaybe<Scalars['Int']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  discount?: InputMaybe<Scalars['jsonb']['input']>;
  email?: InputMaybe<InsertListingEmailsObjRelInsertInput>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  invoices?: InputMaybe<InsertListingInvoicesArrRelInsertInput>;
  items?: InputMaybe<Scalars['jsonb']['input']>;
  latest_invoice?: InputMaybe<Scalars['String']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_pending_invoice_item_invoice?: InputMaybe<Scalars['timestamptz']['input']>;
  pause_collection?: InputMaybe<Scalars['jsonb']['input']>;
  pending_invoice_item_interval?: InputMaybe<Scalars['jsonb']['input']>;
  pending_setup_intent?: InputMaybe<Scalars['String']['input']>;
  pending_update?: InputMaybe<Scalars['jsonb']['input']>;
  plan_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['subscription_status']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  total_amount?: InputMaybe<Scalars['Int']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  trial_end?: InputMaybe<Scalars['timestamptz']['input']>;
  trial_start?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingSubscriptionsObjRelInsertInput = {
  data: InsertListingSubscriptionsInsertInput;
  on_conflict?: InputMaybe<InsertListingSubscriptionsOnConflict>;
};

export type InsertListingSubscriptionsOnConflict = {
  constraint: InsertListingSubscriptionsConstraint;
  update_columns: Array<InsertListingSubscriptionsUpdateColumn>;
  where?: InputMaybe<InsertListingSubscriptionsBoolExp>;
};

export enum InsertListingSubscriptionsSelectColumn {
  /** column name */
  ApplicationFeePercent = 'application_fee_percent',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  BillingThresholds = 'billing_thresholds',
  /** column name */
  CancelAt = 'cancel_at',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerObject = 'customer_object',
  /** column name */
  DaysUntilDue = 'days_until_due',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Discount = 'discount',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Items = 'items',
  /** column name */
  LatestInvoice = 'latest_invoice',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPendingInvoiceItemInvoice = 'next_pending_invoice_item_invoice',
  /** column name */
  PauseCollection = 'pause_collection',
  /** column name */
  PendingInvoiceItemInterval = 'pending_invoice_item_interval',
  /** column name */
  PendingSetupIntent = 'pending_setup_intent',
  /** column name */
  PendingUpdate = 'pending_update',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  TrialEnd = 'trial_end',
  /** column name */
  TrialStart = 'trial_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

export enum InsertListingSubscriptionsSelectColumnSubscriptionsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

export enum InsertListingSubscriptionsUpdateColumn {
  /** column name */
  ApplicationFeePercent = 'application_fee_percent',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  BillingThresholds = 'billing_thresholds',
  /** column name */
  CancelAt = 'cancel_at',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerObject = 'customer_object',
  /** column name */
  DaysUntilDue = 'days_until_due',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Discount = 'discount',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Items = 'items',
  /** column name */
  LatestInvoice = 'latest_invoice',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPendingInvoiceItemInvoice = 'next_pending_invoice_item_invoice',
  /** column name */
  PauseCollection = 'pause_collection',
  /** column name */
  PendingInvoiceItemInterval = 'pending_invoice_item_interval',
  /** column name */
  PendingSetupIntent = 'pending_setup_intent',
  /** column name */
  PendingUpdate = 'pending_update',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  TrialEnd = 'trial_end',
  /** column name */
  TrialStart = 'trial_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTeamImagesAggregateBoolExp = {
  count?: InputMaybe<InsertListingTeamImagesAggregateBoolExpCount>;
};

export type InsertListingTeamImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamImagesArrRelInsertInput = {
  data: Array<InsertListingTeamImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamImagesOnConflict>;
};

export type InsertListingTeamImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamImagesBoolExp>>;
  _not?: InputMaybe<InsertListingTeamImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamImagesBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingTeamImagesConstraint {
  /** unique or primary key constraint on columns "id" */
  TeamImagesPkey = 'team_images_pkey'
}

export type InsertListingTeamImagesInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingTeamImagesOnConflict = {
  constraint: InsertListingTeamImagesConstraint;
  update_columns: Array<InsertListingTeamImagesUpdateColumn>;
  where?: InputMaybe<InsertListingTeamImagesBoolExp>;
};

export enum InsertListingTeamImagesSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingTeamImagesUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingTeamsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingTeamsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingTeamsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingTeamsAggregateBoolExpCount>;
};

export type InsertListingTeamsAggregateBoolExpBoolAnd = {
  arguments: InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsAggregateBoolExpBoolOr = {
  arguments: InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamsArrRelInsertInput = {
  data: Array<InsertListingTeamsInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamsOnConflict>;
};

export type InsertListingTeamsBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamsBoolExp>>;
  _not?: InputMaybe<InsertListingTeamsBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamsBoolExp>>;
  active_since?: InputMaybe<InsertListingIntComparisonExp>;
  agency_slug?: InputMaybe<InsertListingStringComparisonExp>;
  branding_color?: InputMaybe<InsertListingStringComparisonExp>;
  centroid?: InputMaybe<InsertListingGeometryComparisonExp>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  combined_reviews_aggregate?: InputMaybe<InsertListingCombinedReviewsAggregateBoolExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  country_id?: InputMaybe<InsertListingUuidComparisonExp>;
  cover_photo?: InputMaybe<InsertListingImagesBoolExp>;
  cover_photo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  default_team_users?: InputMaybe<InsertListingUsersBoolExp>;
  default_team_users_aggregate?: InputMaybe<InsertListingUsersAggregateBoolExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  do_follow_link?: InputMaybe<InsertListingBooleanComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  facebook_url?: InputMaybe<InsertListingStringComparisonExp>;
  google_business_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_description?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_reviews?: InputMaybe<InsertListingGoogleReviewsBoolExp>;
  google_reviews_aggregate?: InputMaybe<InsertListingGoogleReviewsAggregateBoolExp>;
  hide_exact_address?: InputMaybe<InsertListingBooleanComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  idx_agency_id?: InputMaybe<InsertListingStringComparisonExp>;
  idx_ftp_client_id?: InputMaybe<InsertListingStringComparisonExp>;
  instagram_url?: InputMaybe<InsertListingStringComparisonExp>;
  last_review_scraping?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  legal_name?: InputMaybe<InsertListingStringComparisonExp>;
  linkedin_url?: InputMaybe<InsertListingStringComparisonExp>;
  listings_agency_names?: InputMaybe<InsertListingStringArrayComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  locality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  logo?: InputMaybe<InsertListingImagesBoolExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  municipality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  neighbourhood_id?: InputMaybe<InsertListingUuidComparisonExp>;
  opening_hours?: InputMaybe<InsertListingJsonbComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  phone_numbers_aggregate?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  postcode_id?: InputMaybe<InsertListingUuidComparisonExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  region_id?: InputMaybe<InsertListingUuidComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  show_in_agency_pages?: InputMaybe<InsertListingBooleanComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  team_images?: InputMaybe<InsertListingTeamImagesBoolExp>;
  team_images_aggregate?: InputMaybe<InsertListingTeamImagesAggregateBoolExp>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  teams_portals_aggregate?: InputMaybe<InsertListingTeamsPortalsAggregateBoolExp>;
  teams_users?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  teams_users_aggregate?: InputMaybe<InsertListingTeamsUsersAggregateBoolExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  tiktok_url?: InputMaybe<InsertListingStringComparisonExp>;
  tsv?: InputMaybe<InsertListingTsvectorComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  website_url?: InputMaybe<InsertListingStringComparisonExp>;
  x_url?: InputMaybe<InsertListingStringComparisonExp>;
  youtube_url?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingTeamsConstraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  TeamsTenantIdIdIdx = 'teams_tenant_id_id_idx',
  /** unique or primary key constraint on columns "agency_slug" */
  UniqueAgencySlugIndex = 'unique_agency_slug_index'
}

export type InsertListingTeamsInsertInput = {
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsArrRelInsertInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_photo?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  default_team_users?: InputMaybe<InsertListingUsersArrRelInsertInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_reviews?: InputMaybe<InsertListingGoogleReviewsArrRelInsertInput>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  last_review_scraping?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  logo?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersArrRelInsertInput>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  team_images?: InputMaybe<InsertListingTeamImagesArrRelInsertInput>;
  teams_portals?: InputMaybe<InsertListingTeamsPortalsArrRelInsertInput>;
  teams_users?: InputMaybe<InsertListingTeamsUsersArrRelInsertInput>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  x_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingTeamsObjRelInsertInput = {
  data: InsertListingTeamsInsertInput;
  on_conflict?: InputMaybe<InsertListingTeamsOnConflict>;
};

export type InsertListingTeamsOnConflict = {
  constraint: InsertListingTeamsConstraint;
  update_columns: Array<InsertListingTeamsUpdateColumn>;
  where?: InputMaybe<InsertListingTeamsBoolExp>;
};

export type InsertListingTeamsPortalsAggregateBoolExp = {
  count?: InputMaybe<InsertListingTeamsPortalsAggregateBoolExpCount>;
};

export type InsertListingTeamsPortalsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamsPortalsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamsPortalsArrRelInsertInput = {
  data: Array<InsertListingTeamsPortalsInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamsPortalsOnConflict>;
};

export type InsertListingTeamsPortalsBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamsPortalsBoolExp>>;
  _not?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamsPortalsBoolExp>>;
  contract_id?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  portal?: InputMaybe<InsertListingPortalsBoolExp>;
  portal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
};

export enum InsertListingTeamsPortalsConstraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPortalsPkey = 'teams_portals_pkey',
  /** unique or primary key constraint on columns "portal_id", "team_id" */
  TeamsPortalsTeamIdPortalIdKey = 'teams_portals_team_id_portal_id_key'
}

export type InsertListingTeamsPortalsInsertInput = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portal?: InputMaybe<InsertListingPortalsObjRelInsertInput>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type InsertListingTeamsPortalsOnConflict = {
  constraint: InsertListingTeamsPortalsConstraint;
  update_columns: Array<InsertListingTeamsPortalsUpdateColumn>;
  where?: InputMaybe<InsertListingTeamsPortalsBoolExp>;
};

export enum InsertListingTeamsPortalsSelectColumn {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingTeamsPortalsUpdateColumn {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum InsertListingTeamsSelectColumn {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  Id = 'id',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  LastReviewScraping = 'last_review_scraping',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Route = 'route',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TiktokUrl = 'tiktok_url',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  XUrl = 'x_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

export enum InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages'
}

export enum InsertListingTeamsSelectColumnTeamsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages'
}

export enum InsertListingTeamsUpdateColumn {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  Id = 'id',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  LastReviewScraping = 'last_review_scraping',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Route = 'route',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TiktokUrl = 'tiktok_url',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  XUrl = 'x_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

export type InsertListingTeamsUsersAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingTeamsUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingTeamsUsersAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingTeamsUsersAggregateBoolExpCount>;
};

export type InsertListingTeamsUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingTeamsUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTeamsUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTeamsUsersArrRelInsertInput = {
  data: Array<InsertListingTeamsUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingTeamsUsersOnConflict>;
};

export type InsertListingTeamsUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingTeamsUsersBoolExp>>;
  _not?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingTeamsUsersBoolExp>>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  deactivated?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_leader?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  team?: InputMaybe<InsertListingTeamsBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingTeamsUsersConstraint {
  /** unique or primary key constraint on columns "user_id", "team_id" */
  TeamUsersTeamIdUserIdIdx = 'team_users_team_id_user_id_idx',
  /** unique or primary key constraint on columns "order_nr", "team_id" */
  UcTeamsUsersOrderNrTeamId = 'uc_teams_users_order_nr_team_id'
}

export type InsertListingTeamsUsersInsertInput = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  is_leader?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingTeamsUsersOnConflict = {
  constraint: InsertListingTeamsUsersConstraint;
  update_columns: Array<InsertListingTeamsUsersUpdateColumn>;
  where?: InputMaybe<InsertListingTeamsUsersBoolExp>;
};

export enum InsertListingTeamsUsersSelectColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

export enum InsertListingTeamsUsersSelectColumnTeamsUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

export enum InsertListingTeamsUsersUpdateColumn {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTenantsBoolExp = {
  _and?: InputMaybe<Array<InsertListingTenantsBoolExp>>;
  _not?: InputMaybe<InsertListingTenantsBoolExp>;
  _or?: InputMaybe<Array<InsertListingTenantsBoolExp>>;
  activate_land_registry_owners?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_details?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_iazi?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_pricehubble?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_propertydata?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_realadvisor_listings?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_realadvisor_perceived?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_realadvisor_transactions?: InputMaybe<InsertListingBooleanComparisonExp>;
  activate_model_wup?: InputMaybe<InsertListingBooleanComparisonExp>;
  country?: InputMaybe<InsertListingStringComparisonExp>;
  country_code?: InputMaybe<InsertListingStringComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  debug_email_mode?: InputMaybe<InsertListingBooleanComparisonExp>;
  default_pipeline_id?: InputMaybe<InsertListingUuidComparisonExp>;
  email_is_verified?: InputMaybe<InsertListingBooleanComparisonExp>;
  email_sender_email?: InputMaybe<InsertListingStringComparisonExp>;
  email_sender_name?: InputMaybe<InsertListingStringComparisonExp>;
  email_template?: InputMaybe<InsertListingEmailTemplateComparisonExp>;
  google_place_description?: InputMaybe<InsertListingStringComparisonExp>;
  google_place_id?: InputMaybe<InsertListingStringComparisonExp>;
  google_tag_manager_id?: InputMaybe<InsertListingStringComparisonExp>;
  homepage_url?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  lat?: InputMaybe<InsertListingFloatComparisonExp>;
  lng?: InputMaybe<InsertListingFloatComparisonExp>;
  locality?: InputMaybe<InsertListingStringComparisonExp>;
  logo_image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  main_color?: InputMaybe<InsertListingStringComparisonExp>;
  mortgage_rates?: InputMaybe<InsertListingJsonbComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  phone_main?: InputMaybe<InsertListingStringComparisonExp>;
  postcode?: InputMaybe<InsertListingStringComparisonExp>;
  route?: InputMaybe<InsertListingStringComparisonExp>;
  slug?: InputMaybe<InsertListingStringComparisonExp>;
  state?: InputMaybe<InsertListingStringComparisonExp>;
  street_number?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_secret_key?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_secret_key_test?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_webhook_secret?: InputMaybe<InsertListingStringComparisonExp>;
  stripe_webhook_secret_test?: InputMaybe<InsertListingStringComparisonExp>;
  system_user_id?: InputMaybe<InsertListingUuidComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  users?: InputMaybe<InsertListingUsersBoolExp>;
  users_aggregate?: InputMaybe<InsertListingUsersAggregateBoolExp>;
};

export enum InsertListingTenantsConstraint {
  /** unique or primary key constraint on columns "id" */
  TenantsPkey = 'tenants_pkey',
  /** unique or primary key constraint on columns "slug" */
  UniqueSlugIndex = 'unique_slug_index'
}

export type InsertListingTenantsInsertInput = {
  activate_land_registry_owners?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_details?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_iazi?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_pricehubble?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_propertydata?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_listings?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_perceived?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_wup?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  debug_email_mode?: InputMaybe<Scalars['Boolean']['input']>;
  default_pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  email_is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  email_sender_email?: InputMaybe<Scalars['String']['input']>;
  email_sender_name?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['email_template']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_tag_manager_id?: InputMaybe<Scalars['String']['input']>;
  homepage_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  main_color?: InputMaybe<Scalars['String']['input']>;
  mortgage_rates?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_main?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key_test?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret_test?: InputMaybe<Scalars['String']['input']>;
  system_user_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  users?: InputMaybe<InsertListingUsersArrRelInsertInput>;
};

export type InsertListingTenantsObjRelInsertInput = {
  data: InsertListingTenantsInsertInput;
  on_conflict?: InputMaybe<InsertListingTenantsOnConflict>;
};

export type InsertListingTenantsOnConflict = {
  constraint: InsertListingTenantsConstraint;
  update_columns: Array<InsertListingTenantsUpdateColumn>;
  where?: InputMaybe<InsertListingTenantsBoolExp>;
};

export enum InsertListingTenantsUpdateColumn {
  /** column name */
  ActivateLandRegistryOwners = 'activate_land_registry_owners',
  /** column name */
  ActivateModelDetails = 'activate_model_details',
  /** column name */
  ActivateModelIazi = 'activate_model_iazi',
  /** column name */
  ActivateModelPricehubble = 'activate_model_pricehubble',
  /** column name */
  ActivateModelPropertydata = 'activate_model_propertydata',
  /** column name */
  ActivateModelRealadvisorListings = 'activate_model_realadvisor_listings',
  /** column name */
  ActivateModelRealadvisorPerceived = 'activate_model_realadvisor_perceived',
  /** column name */
  ActivateModelRealadvisorTransactions = 'activate_model_realadvisor_transactions',
  /** column name */
  ActivateModelWup = 'activate_model_wup',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugEmailMode = 'debug_email_mode',
  /** column name */
  DefaultPipelineId = 'default_pipeline_id',
  /** column name */
  EmailIsVerified = 'email_is_verified',
  /** column name */
  EmailSenderEmail = 'email_sender_email',
  /** column name */
  EmailSenderName = 'email_sender_name',
  /** column name */
  EmailTemplate = 'email_template',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTagManagerId = 'google_tag_manager_id',
  /** column name */
  HomepageUrl = 'homepage_url',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MainColor = 'main_color',
  /** column name */
  MortgageRates = 'mortgage_rates',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneMain = 'phone_main',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StripeSecretKey = 'stripe_secret_key',
  /** column name */
  StripeSecretKeyTest = 'stripe_secret_key_test',
  /** column name */
  StripeWebhookSecret = 'stripe_webhook_secret',
  /** column name */
  StripeWebhookSecretTest = 'stripe_webhook_secret_test',
  /** column name */
  SystemUserId = 'system_user_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type InsertListingThirdPillarOrganisationTypeAComparisonExp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
};

export type InsertListingThirdPillarOrganisationTypeBComparisonExp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
};

export type InsertListingTimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

export type InsertListingTimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

export type InsertListingTransactionBuyersAggregateBoolExp = {
  count?: InputMaybe<InsertListingTransactionBuyersAggregateBoolExpCount>;
};

export type InsertListingTransactionBuyersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTransactionBuyersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTransactionBuyersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTransactionBuyersArrRelInsertInput = {
  data: Array<InsertListingTransactionBuyersInsertInput>;
};

export type InsertListingTransactionBuyersBoolExp = {
  _and?: InputMaybe<Array<InsertListingTransactionBuyersBoolExp>>;
  _not?: InputMaybe<InsertListingTransactionBuyersBoolExp>;
  _or?: InputMaybe<Array<InsertListingTransactionBuyersBoolExp>>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingTransactionBuyersInsertInput = {
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingTransactionBuyersSelectColumn {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTransactionSellersAggregateBoolExp = {
  count?: InputMaybe<InsertListingTransactionSellersAggregateBoolExpCount>;
};

export type InsertListingTransactionSellersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingTransactionSellersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingTransactionSellersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingTransactionSellersArrRelInsertInput = {
  data: Array<InsertListingTransactionSellersInsertInput>;
};

export type InsertListingTransactionSellersBoolExp = {
  _and?: InputMaybe<Array<InsertListingTransactionSellersBoolExp>>;
  _not?: InputMaybe<InsertListingTransactionSellersBoolExp>;
  _or?: InputMaybe<Array<InsertListingTransactionSellersBoolExp>>;
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  transaction_id?: InputMaybe<InsertListingUuidComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export type InsertListingTransactionSellersInsertInput = {
  property_transaction?: InputMaybe<InsertListingPropertyTransactionsObjRelInsertInput>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum InsertListingTransactionSellersSelectColumn {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingTsvectorComparisonExp = {
  _eq?: InputMaybe<Scalars['tsvector']['input']>;
  _gt?: InputMaybe<Scalars['tsvector']['input']>;
  _gte?: InputMaybe<Scalars['tsvector']['input']>;
  _in?: InputMaybe<Array<Scalars['tsvector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['tsvector']['input']>;
  _lte?: InputMaybe<Scalars['tsvector']['input']>;
  _neq?: InputMaybe<Scalars['tsvector']['input']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']['input']>>;
};

export type InsertListingUserImagesAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingUserImagesAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingUserImagesAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingUserImagesAggregateBoolExpCount>;
};

export type InsertListingUserImagesAggregateBoolExpBoolAnd = {
  arguments: InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUserImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUserImagesAggregateBoolExpBoolOr = {
  arguments: InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUserImagesBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUserImagesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingUserImagesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUserImagesBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingUserImagesArrRelInsertInput = {
  data: Array<InsertListingUserImagesInsertInput>;
  on_conflict?: InputMaybe<InsertListingUserImagesOnConflict>;
};

export type InsertListingUserImagesBoolExp = {
  _and?: InputMaybe<Array<InsertListingUserImagesBoolExp>>;
  _not?: InputMaybe<InsertListingUserImagesBoolExp>;
  _or?: InputMaybe<Array<InsertListingUserImagesBoolExp>>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  image?: InputMaybe<InsertListingImagesBoolExp>;
  image_id?: InputMaybe<InsertListingUuidComparisonExp>;
  is_primary?: InputMaybe<InsertListingBooleanComparisonExp>;
  order_nr?: InputMaybe<InsertListingIntComparisonExp>;
  user?: InputMaybe<InsertListingUsersBoolExp>;
  user_id?: InputMaybe<InsertListingUuidComparisonExp>;
};

export enum InsertListingUserImagesConstraint {
  /** unique or primary key constraint on columns "user_id", "is_primary" */
  IdxUserImagesUserIdIsPrimary = 'idx_user_images_user_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  UserImagesIdKey = 'user_images_id_key',
  /** unique or primary key constraint on columns "id" */
  UserImagesPkey = 'user_images_pkey',
  /** unique or primary key constraint on columns "user_id", "image_id" */
  UserImagesUserIdImageIdUnique = 'user_images_user_id_image_id_unique'
}

export type InsertListingUserImagesInsertInput = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<InsertListingImagesObjRelInsertInput>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type InsertListingUserImagesOnConflict = {
  constraint: InsertListingUserImagesConstraint;
  update_columns: Array<InsertListingUserImagesUpdateColumn>;
  where?: InputMaybe<InsertListingUserImagesBoolExp>;
};

export enum InsertListingUserImagesSelectColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UserId = 'user_id'
}

export enum InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingUserImagesSelectColumnUserImagesAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsPrimary = 'is_primary'
}

export enum InsertListingUserImagesUpdateColumn {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UserId = 'user_id'
}

export type InsertListingUserLanguageComparisonExp = {
  _eq?: InputMaybe<Scalars['user_language']['input']>;
  _gt?: InputMaybe<Scalars['user_language']['input']>;
  _gte?: InputMaybe<Scalars['user_language']['input']>;
  _in?: InputMaybe<Array<Scalars['user_language']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_language']['input']>;
  _lte?: InputMaybe<Scalars['user_language']['input']>;
  _neq?: InputMaybe<Scalars['user_language']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_language']['input']>>;
};

export type InsertListingUserProfessionalSituationComparisonExp = {
  _eq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _in?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _lte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _neq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
};

export type InsertListingUsersAggregateBoolExp = {
  avg?: InputMaybe<InsertListingUsersAggregateBoolExpAvg>;
  bool_and?: InputMaybe<InsertListingUsersAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingUsersAggregateBoolExpBoolOr>;
  corr?: InputMaybe<InsertListingUsersAggregateBoolExpCorr>;
  count?: InputMaybe<InsertListingUsersAggregateBoolExpCount>;
  covar_samp?: InputMaybe<InsertListingUsersAggregateBoolExpCovarSamp>;
  max?: InputMaybe<InsertListingUsersAggregateBoolExpMax>;
  min?: InputMaybe<InsertListingUsersAggregateBoolExpMin>;
  stddev_samp?: InputMaybe<InsertListingUsersAggregateBoolExpStddevSamp>;
  sum?: InputMaybe<InsertListingUsersAggregateBoolExpSum>;
  var_samp?: InputMaybe<InsertListingUsersAggregateBoolExpVarSamp>;
};

export type InsertListingUsersAggregateBoolExpAvg = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpAvgArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpBoolAnd = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUsersAggregateBoolExpBoolOr = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCorr = {
  arguments: InsertListingUsersAggregateBoolExpCorrArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCorrArguments = {
  X: InsertListingUsersSelectColumnUsersAggregateBoolExpCorrArgumentsColumns;
  Y: InsertListingUsersSelectColumnUsersAggregateBoolExpCorrArgumentsColumns;
};

export type InsertListingUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCovarSamp = {
  arguments: InsertListingUsersAggregateBoolExpCovarSampArguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpCovarSampArguments = {
  X: InsertListingUsersSelectColumnUsersAggregateBoolExpCovarSampArgumentsColumns;
  Y: InsertListingUsersSelectColumnUsersAggregateBoolExpCovarSampArgumentsColumns;
};

export type InsertListingUsersAggregateBoolExpMax = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpMaxArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpMin = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpMinArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpStddevSamp = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpStddevSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpSum = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpSumArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersAggregateBoolExpVarSamp = {
  arguments: InsertListingUsersSelectColumnUsersAggregateBoolExpVarSampArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingUsersBoolExp>;
  predicate: InsertListingFloat8ComparisonExp;
};

export type InsertListingUsersArrRelInsertInput = {
  data: Array<InsertListingUsersInsertInput>;
  on_conflict?: InputMaybe<InsertListingUsersOnConflict>;
};

export type InsertListingUsersBoolExp = {
  _and?: InputMaybe<Array<InsertListingUsersBoolExp>>;
  _not?: InputMaybe<InsertListingUsersBoolExp>;
  _or?: InputMaybe<Array<InsertListingUsersBoolExp>>;
  account_manager?: InputMaybe<InsertListingUsersBoolExp>;
  account_manager_id?: InputMaybe<InsertListingUuidComparisonExp>;
  active_since?: InputMaybe<InsertListingIntComparisonExp>;
  activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  age?: InputMaybe<InsertListingIntComparisonExp>;
  agent_slug?: InputMaybe<InsertListingStringComparisonExp>;
  annual_costs_child_support?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_costs_leasing?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_costs_other_credits?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_credits?: InputMaybe<InsertListingJsonbArrayComparisonExp>;
  annual_credits_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_income_additional_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_income_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_family_allowances?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_other?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_rent?: InputMaybe<InsertListingFloat8ComparisonExp>;
  annual_income_salary?: InputMaybe<InsertListingIntComparisonExp>;
  annual_income_salary13?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_income_salary14?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_leasings?: InputMaybe<InsertListingJsonbArrayComparisonExp>;
  annual_leasings_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_other_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  annual_other_payments?: InputMaybe<InsertListingFloat8ArrayComparisonExp>;
  assets_savings?: InputMaybe<InsertListingIntComparisonExp>;
  assets_savings_donation?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_second_pillar?: InputMaybe<InsertListingIntComparisonExp>;
  assets_second_pillar_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_second_pillar_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  assets_securities?: InputMaybe<InsertListingFloat8ComparisonExp>;
  assets_third_pillar_a?: InputMaybe<InsertListingIntComparisonExp>;
  assets_third_pillar_a_annual_premium?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<InsertListingStringComparisonExp>;
  assets_third_pillar_a_cash?: InputMaybe<InsertListingFloat8ComparisonExp>;
  assets_third_pillar_a_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_a_life_insurance?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_a_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  assets_third_pillar_a_organisation_type?: InputMaybe<InsertListingThirdPillarOrganisationTypeAComparisonExp>;
  assets_third_pillar_b?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_third_pillar_b_annual_premium?: InputMaybe<InsertListingFloatComparisonExp>;
  assets_third_pillar_b_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_b_life_insurance?: InputMaybe<InsertListingBooleanComparisonExp>;
  assets_third_pillar_b_organisation?: InputMaybe<InsertListingStringComparisonExp>;
  assets_third_pillar_b_organisation_type?: InputMaybe<InsertListingThirdPillarOrganisationTypeBComparisonExp>;
  assets_third_pillar_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  assigned_activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  assigned_activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  auto_assign_leads?: InputMaybe<InsertListingBooleanComparisonExp>;
  branding_color?: InputMaybe<InsertListingStringComparisonExp>;
  branding_logo?: InputMaybe<InsertListingStringComparisonExp>;
  branding_name?: InputMaybe<InsertListingStringComparisonExp>;
  branding_website?: InputMaybe<InsertListingStringComparisonExp>;
  broker?: InputMaybe<InsertListingUsersBoolExp>;
  broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  broker_leads?: InputMaybe<InsertListingLeadsBoolExp>;
  broker_leads_aggregate?: InputMaybe<InsertListingLeadsAggregateBoolExp>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsBoolExp>;
  buyer_leads_aggregate?: InputMaybe<InsertListingBuyerLeadsAggregateBoolExp>;
  buyer_offers?: InputMaybe<InsertListingOffersBoolExp>;
  buyer_offers_aggregate?: InputMaybe<InsertListingOffersAggregateBoolExp>;
  can_edit_settings?: InputMaybe<InsertListingBooleanComparisonExp>;
  can_user_login_as?: InputMaybe<InsertListingBooleanComparisonExp>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasBoolExp>;
  catchment_areas_aggregate?: InputMaybe<InsertListingCatchmentAreasAggregateBoolExp>;
  certifications?: InputMaybe<InsertListingStringArrayComparisonExp>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsBoolExp>;
  combined_reviews_aggregate?: InputMaybe<InsertListingCombinedReviewsAggregateBoolExp>;
  created_activities?: InputMaybe<InsertListingActivitiesBoolExp>;
  created_activities_aggregate?: InputMaybe<InsertListingActivitiesAggregateBoolExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  created_by?: InputMaybe<InsertListingUuidComparisonExp>;
  creator?: InputMaybe<InsertListingUsersBoolExp>;
  crm_link?: InputMaybe<InsertListingStringComparisonExp>;
  date_of_birth?: InputMaybe<InsertListingDateComparisonExp>;
  debt?: InputMaybe<InsertListingIntComparisonExp>;
  debt_leasing_balance?: InputMaybe<InsertListingFloat8ComparisonExp>;
  debt_mortgage_balance?: InputMaybe<InsertListingFloat8ComparisonExp>;
  debt_other_credits_balance?: InputMaybe<InsertListingIntComparisonExp>;
  default_team?: InputMaybe<InsertListingTeamsBoolExp>;
  default_team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  description?: InputMaybe<InsertListingStringComparisonExp>;
  display_name?: InputMaybe<InsertListingStringComparisonExp>;
  divorce_date?: InputMaybe<InsertListingDateComparisonExp>;
  donation?: InputMaybe<InsertListingFloat8ComparisonExp>;
  email_signature?: InputMaybe<InsertListingStringComparisonExp>;
  email_signature_html?: InputMaybe<InsertListingStringComparisonExp>;
  emails?: InputMaybe<InsertListingEmailsBoolExp>;
  emails_aggregate?: InputMaybe<InsertListingEmailsAggregateBoolExp>;
  employer?: InputMaybe<InsertListingStringComparisonExp>;
  employer_id?: InputMaybe<InsertListingUuidComparisonExp>;
  employment_commencement_date?: InputMaybe<InsertListingDateComparisonExp>;
  employment_rate?: InputMaybe<InsertListingFloat8ComparisonExp>;
  enquiries?: InputMaybe<InsertListingEnquiriesBoolExp>;
  enquiries_aggregate?: InputMaybe<InsertListingEnquiriesAggregateBoolExp>;
  facebook_profile?: InputMaybe<InsertListingStringComparisonExp>;
  financing_passports?: InputMaybe<InsertListingFinancingPassportsBoolExp>;
  financing_passports_aggregate?: InputMaybe<InsertListingFinancingPassportsAggregateBoolExp>;
  first_name?: InputMaybe<InsertListingStringComparisonExp>;
  full_name?: InputMaybe<InsertListingStringComparisonExp>;
  gender?: InputMaybe<InsertListingStringComparisonExp>;
  has_accepted_terms?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_children?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_churned?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_free_crm_access?: InputMaybe<InsertListingBooleanComparisonExp>;
  has_used_trial_button?: InputMaybe<InsertListingBooleanComparisonExp>;
  home_address_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_lat?: InputMaybe<InsertListingFloatComparisonExp>;
  home_address_lng?: InputMaybe<InsertListingFloatComparisonExp>;
  home_address_locality?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_route?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_state?: InputMaybe<InsertListingStringComparisonExp>;
  home_address_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  identification_document_expiry_date?: InputMaybe<InsertListingDateComparisonExp>;
  identification_document_issue_date?: InputMaybe<InsertListingDateComparisonExp>;
  identification_document_number?: InputMaybe<InsertListingStringComparisonExp>;
  identification_document_type_id?: InputMaybe<InsertListingUuidComparisonExp>;
  imported_id?: InputMaybe<InsertListingStringComparisonExp>;
  intercom_hash?: InputMaybe<InsertListingStringComparisonExp>;
  is_admin?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_bot?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_broker?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_deleted?: InputMaybe<InsertListingBooleanComparisonExp>;
  is_mortgage_broker?: InputMaybe<InsertListingBooleanComparisonExp>;
  job_title?: InputMaybe<InsertListingStringComparisonExp>;
  landing_page_url?: InputMaybe<InsertListingStringComparisonExp>;
  language?: InputMaybe<InsertListingUserLanguageComparisonExp>;
  languages?: InputMaybe<InsertListingStringArrayComparisonExp>;
  last_bonus?: InputMaybe<InsertListingFloat8ComparisonExp>;
  last_name?: InputMaybe<InsertListingStringComparisonExp>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsBoolExp>;
  lead_agents_aggregate?: InputMaybe<InsertListingLeadAgentsAggregateBoolExp>;
  leads?: InputMaybe<InsertListingLeadsBoolExp>;
  leads_aggregate?: InputMaybe<InsertListingLeadsAggregateBoolExp>;
  linked_in_profile?: InputMaybe<InsertListingStringComparisonExp>;
  logins?: InputMaybe<InsertListingLoginsBoolExp>;
  logins_aggregate?: InputMaybe<InsertListingLoginsAggregateBoolExp>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersBoolExp>;
  lot_buyers_aggregate?: InputMaybe<InsertListingLotBuyersAggregateBoolExp>;
  lot_sellers?: InputMaybe<InsertListingLotSellersBoolExp>;
  lot_sellers_aggregate?: InputMaybe<InsertListingLotSellersAggregateBoolExp>;
  lots?: InputMaybe<InsertListingLotsBoolExp>;
  lots_aggregate?: InputMaybe<InsertListingLotsAggregateBoolExp>;
  marital_partner_id?: InputMaybe<InsertListingUuidComparisonExp>;
  marital_status?: InputMaybe<InsertListingMaritalStatusComparisonExp>;
  matrimonial_regime?: InputMaybe<InsertListingStringComparisonExp>;
  membership_type?: InputMaybe<InsertListingStringComparisonExp>;
  modules?: InputMaybe<InsertListingStringArrayComparisonExp>;
  mortgage_broker_id?: InputMaybe<InsertListingUuidComparisonExp>;
  nationality?: InputMaybe<InsertListingDictionariesBoolExp>;
  nationality_id?: InputMaybe<InsertListingUuidComparisonExp>;
  number_of_buyers?: InputMaybe<InsertListingIntComparisonExp>;
  number_of_dependant_children?: InputMaybe<InsertListingIntComparisonExp>;
  nylas_account_config?: InputMaybe<InsertListingNylasAccountConfigsBoolExp>;
  nylas_account_config_aggregate?: InputMaybe<InsertListingNylasAccountConfigsAggregateBoolExp>;
  occupation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  occupation_text?: InputMaybe<InsertListingStringComparisonExp>;
  organisation?: InputMaybe<InsertListingOrganisationsBoolExp>;
  organisation_user?: InputMaybe<InsertListingOrganisationUsersBoolExp>;
  payments?: InputMaybe<InsertListingPaymentsBoolExp>;
  payments_aggregate?: InputMaybe<InsertListingPaymentsAggregateBoolExp>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  phone_numbers_aggregate?: InputMaybe<InsertListingPhoneNumbersAggregateBoolExp>;
  place_of_origin?: InputMaybe<InsertListingStringComparisonExp>;
  primary_phone_number?: InputMaybe<InsertListingPhoneNumbersBoolExp>;
  professional_address_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_lat?: InputMaybe<InsertListingFloat8ComparisonExp>;
  professional_address_lng?: InputMaybe<InsertListingFloat8ComparisonExp>;
  professional_address_locality?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_postcode?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_route?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_state?: InputMaybe<InsertListingStringComparisonExp>;
  professional_address_street_number?: InputMaybe<InsertListingStringComparisonExp>;
  professional_situation?: InputMaybe<InsertListingUserProfessionalSituationComparisonExp>;
  properties?: InputMaybe<InsertListingPropertiesUsersBoolExp>;
  properties_aggregate?: InputMaybe<InsertListingPropertiesUsersAggregateBoolExp>;
  properties_exist?: InputMaybe<InsertListingBooleanComparisonExp>;
  property_searches?: InputMaybe<InsertListingPropertySearchesBoolExp>;
  property_searches_aggregate?: InputMaybe<InsertListingPropertySearchesAggregateBoolExp>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsBoolExp>;
  property_transactions_aggregate?: InputMaybe<InsertListingPropertyTransactionsAggregateBoolExp>;
  push_notification_tokens?: InputMaybe<InsertListingPushNotificationTokensBoolExp>;
  push_notification_tokens_aggregate?: InputMaybe<InsertListingPushNotificationTokensAggregateBoolExp>;
  recommended_listings?: InputMaybe<InsertListingBooleanComparisonExp>;
  referrer?: InputMaybe<InsertListingStringComparisonExp>;
  referring_domain?: InputMaybe<InsertListingStringComparisonExp>;
  registered_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  residence_country_code?: InputMaybe<InsertListingStringComparisonExp>;
  residence_state_id?: InputMaybe<InsertListingUuidComparisonExp>;
  reviews?: InputMaybe<InsertListingReviewsBoolExp>;
  reviews_aggregate?: InputMaybe<InsertListingReviewsAggregateBoolExp>;
  second_pillar_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  services?: InputMaybe<InsertListingStringArrayComparisonExp>;
  show_in_agency_pages?: InputMaybe<InsertListingBooleanComparisonExp>;
  social_security_number?: InputMaybe<InsertListingStringComparisonExp>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsBoolExp>;
  subscriptions_aggregate?: InputMaybe<InsertListingSubscriptionsAggregateBoolExp>;
  team_id?: InputMaybe<InsertListingUuidComparisonExp>;
  teams_users?: InputMaybe<InsertListingTeamsUsersBoolExp>;
  teams_users_aggregate?: InputMaybe<InsertListingTeamsUsersAggregateBoolExp>;
  tenant?: InputMaybe<InsertListingTenantsBoolExp>;
  tenant_id?: InputMaybe<InsertListingUuidComparisonExp>;
  test_jwt?: InputMaybe<InsertListingStringComparisonExp>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<InsertListingUuidComparisonExp>;
  third_pillar_a_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  third_pillar_b_organisation_id?: InputMaybe<InsertListingUuidComparisonExp>;
  title?: InputMaybe<InsertListingStringComparisonExp>;
  tsv?: InputMaybe<InsertListingTsvectorComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  updates_daily_tasks?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_introduction_to_lead_contacts?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_new_lead_assigned_sms?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_newsletter?: InputMaybe<InsertListingBooleanComparisonExp>;
  updates_property_revaluation?: InputMaybe<InsertListingBooleanComparisonExp>;
  user_images?: InputMaybe<InsertListingUserImagesBoolExp>;
  user_images_aggregate?: InputMaybe<InsertListingUserImagesAggregateBoolExp>;
  wedding_date?: InputMaybe<InsertListingDateComparisonExp>;
  work_permit?: InputMaybe<InsertListingDictionariesBoolExp>;
  work_permit_id?: InputMaybe<InsertListingUuidComparisonExp>;
  yearly_revenues_at_retirement?: InputMaybe<InsertListingFloat8ComparisonExp>;
};

export enum InsertListingUsersConstraint {
  /** unique or primary key constraint on columns "agent_slug" */
  UniqueAgentSlugIndex = 'unique_agent_slug_index',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  UsersIdTenantIdUnique = 'users_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

export type InsertListingUsersInsertInput = {
  account_manager?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  account_manager_id?: InputMaybe<Scalars['uuid']['input']>;
  active_since?: InputMaybe<Scalars['Int']['input']>;
  activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  agent_slug?: InputMaybe<Scalars['String']['input']>;
  annual_costs_child_support?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_leasing?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_other_credits?: InputMaybe<Scalars['float8']['input']>;
  annual_credits?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_credits_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_additional_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_bonus?: InputMaybe<Scalars['float8']['input']>;
  annual_income_family_allowances?: InputMaybe<Scalars['float8']['input']>;
  annual_income_other?: InputMaybe<Scalars['float8']['input']>;
  annual_income_rent?: InputMaybe<Scalars['float8']['input']>;
  annual_income_salary?: InputMaybe<Scalars['Int']['input']>;
  annual_income_salary13?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_salary14?: InputMaybe<Scalars['Boolean']['input']>;
  annual_leasings?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_leasings_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_payments?: InputMaybe<Array<Scalars['float8']['input']>>;
  assets_savings?: InputMaybe<Scalars['Int']['input']>;
  assets_savings_donation?: InputMaybe<Scalars['Float']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['Int']['input']>;
  assets_second_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_second_pillar_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_securities?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a?: InputMaybe<Scalars['Int']['input']>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_cash?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  assets_third_pillar_b?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  assets_third_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assigned_activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  auto_assign_leads?: InputMaybe<Scalars['Boolean']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  branding_logo?: InputMaybe<Scalars['String']['input']>;
  branding_name?: InputMaybe<Scalars['String']['input']>;
  branding_website?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  broker_leads?: InputMaybe<InsertListingLeadsArrRelInsertInput>;
  buyer_leads?: InputMaybe<InsertListingBuyerLeadsArrRelInsertInput>;
  buyer_offers?: InputMaybe<InsertListingOffersArrRelInsertInput>;
  can_edit_settings?: InputMaybe<Scalars['Boolean']['input']>;
  can_user_login_as?: InputMaybe<Scalars['Boolean']['input']>;
  catchment_areas?: InputMaybe<InsertListingCatchmentAreasArrRelInsertInput>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  combined_reviews?: InputMaybe<InsertListingCombinedReviewsArrRelInsertInput>;
  created_activities?: InputMaybe<InsertListingActivitiesArrRelInsertInput>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<InsertListingUsersObjRelInsertInput>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['Int']['input']>;
  debt_leasing_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_mortgage_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_other_credits_balance?: InputMaybe<Scalars['Int']['input']>;
  default_team?: InputMaybe<InsertListingTeamsObjRelInsertInput>;
  default_team_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  divorce_date?: InputMaybe<Scalars['date']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_signature?: InputMaybe<Scalars['String']['input']>;
  email_signature_html?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<InsertListingEmailsArrRelInsertInput>;
  employer?: InputMaybe<Scalars['String']['input']>;
  employer_id?: InputMaybe<Scalars['uuid']['input']>;
  employment_commencement_date?: InputMaybe<Scalars['date']['input']>;
  employment_rate?: InputMaybe<Scalars['float8']['input']>;
  enquiries?: InputMaybe<InsertListingEnquiriesArrRelInsertInput>;
  facebook_profile?: InputMaybe<Scalars['String']['input']>;
  financing_passports?: InputMaybe<InsertListingFinancingPassportsArrRelInsertInput>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_free_crm_access?: InputMaybe<Scalars['Boolean']['input']>;
  has_used_trial_button?: InputMaybe<Scalars['Boolean']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_lat?: InputMaybe<Scalars['Float']['input']>;
  home_address_lng?: InputMaybe<Scalars['Float']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identification_document_expiry_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_issue_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_number?: InputMaybe<Scalars['String']['input']>;
  identification_document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_bot?: InputMaybe<Scalars['Boolean']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_mortgage_broker?: InputMaybe<Scalars['Boolean']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_agents?: InputMaybe<InsertListingLeadAgentsArrRelInsertInput>;
  leads?: InputMaybe<InsertListingLeadsArrRelInsertInput>;
  linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  logins?: InputMaybe<InsertListingLoginsArrRelInsertInput>;
  lot_buyers?: InputMaybe<InsertListingLotBuyersArrRelInsertInput>;
  lot_sellers?: InputMaybe<InsertListingLotSellersArrRelInsertInput>;
  lots?: InputMaybe<InsertListingLotsArrRelInsertInput>;
  marital_partner_id?: InputMaybe<Scalars['uuid']['input']>;
  marital_status?: InputMaybe<Scalars['marital_status']['input']>;
  matrimonial_regime?: InputMaybe<Scalars['String']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  nationality?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  nylas_account_config?: InputMaybe<InsertListingNylasAccountConfigsArrRelInsertInput>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<InsertListingOrganisationsObjRelInsertInput>;
  organisation_user?: InputMaybe<InsertListingOrganisationUsersObjRelInsertInput>;
  payments?: InputMaybe<InsertListingPaymentsArrRelInsertInput>;
  phone_numbers?: InputMaybe<InsertListingPhoneNumbersArrRelInsertInput>;
  place_of_origin?: InputMaybe<Scalars['String']['input']>;
  professional_address_country_code?: InputMaybe<Scalars['String']['input']>;
  professional_address_lat?: InputMaybe<Scalars['float8']['input']>;
  professional_address_lng?: InputMaybe<Scalars['float8']['input']>;
  professional_address_locality?: InputMaybe<Scalars['String']['input']>;
  professional_address_postcode?: InputMaybe<Scalars['String']['input']>;
  professional_address_route?: InputMaybe<Scalars['String']['input']>;
  professional_address_state?: InputMaybe<Scalars['String']['input']>;
  professional_address_street_number?: InputMaybe<Scalars['String']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  properties?: InputMaybe<InsertListingPropertiesUsersArrRelInsertInput>;
  properties_exist?: InputMaybe<Scalars['Boolean']['input']>;
  property_searches?: InputMaybe<InsertListingPropertySearchesArrRelInsertInput>;
  property_transactions?: InputMaybe<InsertListingPropertyTransactionsArrRelInsertInput>;
  push_notification_tokens?: InputMaybe<InsertListingPushNotificationTokensArrRelInsertInput>;
  recommended_listings?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  reviews?: InputMaybe<InsertListingReviewsArrRelInsertInput>;
  second_pillar_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<InsertListingSubscriptionsArrRelInsertInput>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  teams_users?: InputMaybe<InsertListingTeamsUsersArrRelInsertInput>;
  tenant?: InputMaybe<InsertListingTenantsObjRelInsertInput>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_b_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updates_daily_tasks?: InputMaybe<Scalars['Boolean']['input']>;
  updates_introduction_to_lead_contacts?: InputMaybe<Scalars['Boolean']['input']>;
  updates_new_lead_assigned_sms?: InputMaybe<Scalars['Boolean']['input']>;
  updates_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  updates_property_revaluation?: InputMaybe<Scalars['Boolean']['input']>;
  user_images?: InputMaybe<InsertListingUserImagesArrRelInsertInput>;
  wedding_date?: InputMaybe<Scalars['date']['input']>;
  work_permit?: InputMaybe<InsertListingDictionariesObjRelInsertInput>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
};

export type InsertListingUsersObjRelInsertInput = {
  data: InsertListingUsersInsertInput;
  on_conflict?: InputMaybe<InsertListingUsersOnConflict>;
};

export type InsertListingUsersOnConflict = {
  constraint: InsertListingUsersConstraint;
  update_columns: Array<InsertListingUsersUpdateColumn>;
  where?: InputMaybe<InsertListingUsersBoolExp>;
};

export enum InsertListingUsersSelectColumn {
  /** column name */
  AccountManagerId = 'account_manager_id',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualCredits = 'annual_credits',
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AnnualIncomeSalary = 'annual_income_salary',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasings = 'annual_leasings',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AnnualOtherPayments = 'annual_other_payments',
  /** column name */
  AssetsSavings = 'assets_savings',
  /** column name */
  AssetsSavingsDonation = 'assets_savings_donation',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsSecondPillarOrganisation = 'assets_second_pillar_organisation',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarA = 'assets_third_pillar_a',
  /** column name */
  AssetsThirdPillarAAnnualPremium = 'assets_third_pillar_a_annual_premium',
  /** column name */
  AssetsThirdPillarAAnnualPremiumOrganization = 'assets_third_pillar_a_annual_premium_organization',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  AssetsThirdPillarAOrganisationType = 'assets_third_pillar_a_organisation_type',
  /** column name */
  AssetsThirdPillarB = 'assets_third_pillar_b',
  /** column name */
  AssetsThirdPillarBAnnualPremium = 'assets_third_pillar_b_annual_premium',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarBOrganisation = 'assets_third_pillar_b_organisation',
  /** column name */
  AssetsThirdPillarBOrganisationType = 'assets_third_pillar_b_organisation_type',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  DebtOtherCreditsBalance = 'debt_other_credits_balance',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DivorceDate = 'divorce_date',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailSignature = 'email_signature',
  /** column name */
  EmailSignatureHtml = 'email_signature_html',
  /** column name */
  Employer = 'employer',
  /** column name */
  EmployerId = 'employer_id',
  /** column name */
  EmploymentCommencementDate = 'employment_commencement_date',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLat = 'home_address_lat',
  /** column name */
  HomeAddressLng = 'home_address_lng',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  Id = 'id',
  /** column name */
  IdentificationDocumentExpiryDate = 'identification_document_expiry_date',
  /** column name */
  IdentificationDocumentIssueDate = 'identification_document_issue_date',
  /** column name */
  IdentificationDocumentNumber = 'identification_document_number',
  /** column name */
  IdentificationDocumentTypeId = 'identification_document_type_id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  MaritalPartnerId = 'marital_partner_id',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MatrimonialRegime = 'matrimonial_regime',
  /** column name */
  MembershipType = 'membership_type',
  /** column name */
  Modules = 'modules',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  PlaceOfOrigin = 'place_of_origin',
  /** column name */
  ProfessionalAddressCountryCode = 'professional_address_country_code',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  ProfessionalAddressLocality = 'professional_address_locality',
  /** column name */
  ProfessionalAddressPostcode = 'professional_address_postcode',
  /** column name */
  ProfessionalAddressRoute = 'professional_address_route',
  /** column name */
  ProfessionalAddressState = 'professional_address_state',
  /** column name */
  ProfessionalAddressStreetNumber = 'professional_address_street_number',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SecondPillarOrganisationId = 'second_pillar_organisation_id',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  SocialSecurityNumber = 'social_security_number',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillarAAnnualPremiumOrganizationId = 'third_pillar_a_annual_premium_organization_id',
  /** column name */
  ThirdPillarAOrganisationId = 'third_pillar_a_organisation_id',
  /** column name */
  ThirdPillarBOrganisationId = 'third_pillar_b_organisation_id',
  /** column name */
  Title = 'title',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation',
  /** column name */
  WeddingDate = 'wedding_date',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpAvgArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpCorrArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpCovarSampArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpMaxArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpMinArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpStddevSampArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpSumArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersSelectColumnUsersAggregateBoolExpVarSampArgumentsColumns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export enum InsertListingUsersUpdateColumn {
  /** column name */
  AccountManagerId = 'account_manager_id',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualCredits = 'annual_credits',
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AnnualIncomeSalary = 'annual_income_salary',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasings = 'annual_leasings',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AnnualOtherPayments = 'annual_other_payments',
  /** column name */
  AssetsSavings = 'assets_savings',
  /** column name */
  AssetsSavingsDonation = 'assets_savings_donation',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsSecondPillarOrganisation = 'assets_second_pillar_organisation',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarA = 'assets_third_pillar_a',
  /** column name */
  AssetsThirdPillarAAnnualPremium = 'assets_third_pillar_a_annual_premium',
  /** column name */
  AssetsThirdPillarAAnnualPremiumOrganization = 'assets_third_pillar_a_annual_premium_organization',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  AssetsThirdPillarAOrganisationType = 'assets_third_pillar_a_organisation_type',
  /** column name */
  AssetsThirdPillarB = 'assets_third_pillar_b',
  /** column name */
  AssetsThirdPillarBAnnualPremium = 'assets_third_pillar_b_annual_premium',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarBOrganisation = 'assets_third_pillar_b_organisation',
  /** column name */
  AssetsThirdPillarBOrganisationType = 'assets_third_pillar_b_organisation_type',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  DebtOtherCreditsBalance = 'debt_other_credits_balance',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DivorceDate = 'divorce_date',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailSignature = 'email_signature',
  /** column name */
  EmailSignatureHtml = 'email_signature_html',
  /** column name */
  Employer = 'employer',
  /** column name */
  EmployerId = 'employer_id',
  /** column name */
  EmploymentCommencementDate = 'employment_commencement_date',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLat = 'home_address_lat',
  /** column name */
  HomeAddressLng = 'home_address_lng',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  Id = 'id',
  /** column name */
  IdentificationDocumentExpiryDate = 'identification_document_expiry_date',
  /** column name */
  IdentificationDocumentIssueDate = 'identification_document_issue_date',
  /** column name */
  IdentificationDocumentNumber = 'identification_document_number',
  /** column name */
  IdentificationDocumentTypeId = 'identification_document_type_id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  MaritalPartnerId = 'marital_partner_id',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MatrimonialRegime = 'matrimonial_regime',
  /** column name */
  MembershipType = 'membership_type',
  /** column name */
  Modules = 'modules',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  PlaceOfOrigin = 'place_of_origin',
  /** column name */
  ProfessionalAddressCountryCode = 'professional_address_country_code',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  ProfessionalAddressLocality = 'professional_address_locality',
  /** column name */
  ProfessionalAddressPostcode = 'professional_address_postcode',
  /** column name */
  ProfessionalAddressRoute = 'professional_address_route',
  /** column name */
  ProfessionalAddressState = 'professional_address_state',
  /** column name */
  ProfessionalAddressStreetNumber = 'professional_address_street_number',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SecondPillarOrganisationId = 'second_pillar_organisation_id',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  SocialSecurityNumber = 'social_security_number',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillarAAnnualPremiumOrganizationId = 'third_pillar_a_annual_premium_organization_id',
  /** column name */
  ThirdPillarAOrganisationId = 'third_pillar_a_organisation_id',
  /** column name */
  ThirdPillarBOrganisationId = 'third_pillar_b_organisation_id',
  /** column name */
  Title = 'title',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation',
  /** column name */
  WeddingDate = 'wedding_date',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

export type InsertListingUuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type InsertListingValuationModelsBoolExp = {
  _and?: InputMaybe<Array<InsertListingValuationModelsBoolExp>>;
  _not?: InputMaybe<InsertListingValuationModelsBoolExp>;
  _or?: InputMaybe<Array<InsertListingValuationModelsBoolExp>>;
  country_codes?: InputMaybe<InsertListingJsonbComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  name?: InputMaybe<InsertListingStringComparisonExp>;
  password?: InputMaybe<InsertListingStringComparisonExp>;
  short_name?: InputMaybe<InsertListingStringComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  username?: InputMaybe<InsertListingStringComparisonExp>;
};

export enum InsertListingValuationModelsConstraint {
  /** unique or primary key constraint on columns "name" */
  ValuationModelsPkey = 'valuation_models_pkey'
}

export type InsertListingValuationModelsInsertInput = {
  country_codes?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type InsertListingValuationModelsObjRelInsertInput = {
  data: InsertListingValuationModelsInsertInput;
  on_conflict?: InputMaybe<InsertListingValuationModelsOnConflict>;
};

export type InsertListingValuationModelsOnConflict = {
  constraint: InsertListingValuationModelsConstraint;
  update_columns: Array<InsertListingValuationModelsUpdateColumn>;
  where?: InputMaybe<InsertListingValuationModelsBoolExp>;
};

export enum InsertListingValuationModelsUpdateColumn {
  /** column name */
  CountryCodes = 'country_codes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  ShortName = 'short_name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Username = 'username'
}

export type InsertListingValuationsAggregateBoolExp = {
  bool_and?: InputMaybe<InsertListingValuationsAggregateBoolExpBoolAnd>;
  bool_or?: InputMaybe<InsertListingValuationsAggregateBoolExpBoolOr>;
  count?: InputMaybe<InsertListingValuationsAggregateBoolExpCount>;
};

export type InsertListingValuationsAggregateBoolExpBoolAnd = {
  arguments: InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolAndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingValuationsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingValuationsAggregateBoolExpBoolOr = {
  arguments: InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolOrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingValuationsBoolExp>;
  predicate: InsertListingBooleanComparisonExp;
};

export type InsertListingValuationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<InsertListingValuationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InsertListingValuationsBoolExp>;
  predicate: InsertListingIntComparisonExp;
};

export type InsertListingValuationsArrRelInsertInput = {
  data: Array<InsertListingValuationsInsertInput>;
  on_conflict?: InputMaybe<InsertListingValuationsOnConflict>;
};

export type InsertListingValuationsBoolExp = {
  _and?: InputMaybe<Array<InsertListingValuationsBoolExp>>;
  _not?: InputMaybe<InsertListingValuationsBoolExp>;
  _or?: InputMaybe<Array<InsertListingValuationsBoolExp>>;
  appraisal?: InputMaybe<InsertListingAppraisalsBoolExp>;
  appraisal_id?: InputMaybe<InsertListingUuidComparisonExp>;
  created_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  id?: InputMaybe<InsertListingUuidComparisonExp>;
  input_payload?: InputMaybe<InsertListingJsonbComparisonExp>;
  is_rental?: InputMaybe<InsertListingBooleanComparisonExp>;
  max?: InputMaybe<InsertListingFloatComparisonExp>;
  min?: InputMaybe<InsertListingFloatComparisonExp>;
  model?: InputMaybe<InsertListingStringComparisonExp>;
  model_version?: InputMaybe<InsertListingStringComparisonExp>;
  output_payload?: InputMaybe<InsertListingJsonbComparisonExp>;
  updated_at?: InputMaybe<InsertListingTimestamptzComparisonExp>;
  use_in_calculations?: InputMaybe<InsertListingBooleanComparisonExp>;
  valuation_model?: InputMaybe<InsertListingValuationModelsBoolExp>;
  value?: InputMaybe<InsertListingFloatComparisonExp>;
};

export enum InsertListingValuationsConstraint {
  /** unique or primary key constraint on columns "id" */
  ValuationsPkey = 'valuations_pkey'
}

export type InsertListingValuationsInsertInput = {
  appraisal?: InputMaybe<InsertListingAppraisalsObjRelInsertInput>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  input_payload?: InputMaybe<Scalars['jsonb']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  model_version?: InputMaybe<Scalars['String']['input']>;
  output_payload?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_in_calculations?: InputMaybe<Scalars['Boolean']['input']>;
  valuation_model?: InputMaybe<InsertListingValuationModelsObjRelInsertInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type InsertListingValuationsOnConflict = {
  constraint: InsertListingValuationsConstraint;
  update_columns: Array<InsertListingValuationsUpdateColumn>;
  where?: InputMaybe<InsertListingValuationsBoolExp>;
};

export enum InsertListingValuationsSelectColumn {
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InputPayload = 'input_payload',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Model = 'model',
  /** column name */
  ModelVersion = 'model_version',
  /** column name */
  OutputPayload = 'output_payload',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCalculations = 'use_in_calculations',
  /** column name */
  Value = 'value'
}

export enum InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  UseInCalculations = 'use_in_calculations'
}

export enum InsertListingValuationsSelectColumnValuationsAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  UseInCalculations = 'use_in_calculations'
}

export enum InsertListingValuationsUpdateColumn {
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  InputPayload = 'input_payload',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Model = 'model',
  /** column name */
  ModelVersion = 'model_version',
  /** column name */
  OutputPayload = 'output_payload',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseInCalculations = 'use_in_calculations',
  /** column name */
  Value = 'value'
}

export type InsertPoisOneInput = {
  category: Scalars['String']['input'];
  distance: Scalars['Float']['input'];
  formattedAddress: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  placeId: Scalars['String']['input'];
  primaryType: Scalars['String']['input'];
  propertyId: Scalars['uuid']['input'];
  types: Array<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntegrationConnectionTestResponse = {
  message?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export type LegacyApiKey = {
  KeyPrefix: Scalars['String']['output'];
  PartnerID: Scalars['String']['output'];
  PartnerName: Scalars['String']['output'];
  PartnerRole: Scalars['String']['output'];
  PartnerTeamsIds: Array<Scalars['String']['output']>;
  PartnerTenantId: Scalars['String']['output'];
};

export type ListingGa4Stat = {
  count: Scalars['Int']['output'];
  day: Scalars['String']['output'];
  event_name: Scalars['String']['output'];
  item_list_id?: Maybe<Scalars['String']['output']>;
};

export type ListingGa4StatsOutput = {
  data: Array<ListingGa4Stat>;
};

export type LotImportInput = {
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_description_de?: InputMaybe<Scalars['String']['input']>;
  brochure_description_en?: InputMaybe<Scalars['String']['input']>;
  brochure_description_es?: InputMaybe<Scalars['String']['input']>;
  brochure_description_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_description_it?: InputMaybe<Scalars['String']['input']>;
  brochure_title_de?: InputMaybe<Scalars['String']['input']>;
  brochure_title_en?: InputMaybe<Scalars['String']['input']>;
  brochure_title_es?: InputMaybe<Scalars['String']['input']>;
  brochure_title_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_title_it?: InputMaybe<Scalars['String']['input']>;
  broker_email?: InputMaybe<Scalars['String']['input']>;
  broker_imported_id?: InputMaybe<Scalars['String']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property_balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  property_basement_surface?: InputMaybe<Scalars['Float']['input']>;
  property_building_condition?: InputMaybe<Scalars['Int']['input']>;
  property_building_volume?: InputMaybe<Scalars['Float']['input']>;
  property_building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  property_built_surface?: InputMaybe<Scalars['Float']['input']>;
  property_ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  property_commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  property_commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_construction_year?: InputMaybe<Scalars['Int']['input']>;
  property_cooling?: InputMaybe<Scalars['String']['input']>;
  property_country?: InputMaybe<Scalars['String']['input']>;
  property_country_code?: InputMaybe<Scalars['String']['input']>;
  property_emissions?: InputMaybe<Scalars['Float']['input']>;
  property_energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  property_energy_consumption_class?: InputMaybe<Scalars['String']['input']>;
  property_energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  property_energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  property_estimated_higher_energy_cost?: InputMaybe<Scalars['Float']['input']>;
  property_estimated_lower_energy_cost?: InputMaybe<Scalars['Float']['input']>;
  property_flat_condition?: InputMaybe<Scalars['Int']['input']>;
  property_floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  property_garden_surface?: InputMaybe<Scalars['Float']['input']>;
  property_gas_emissions_class?: InputMaybe<Scalars['String']['input']>;
  property_gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  property_has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_view?: InputMaybe<Scalars['Boolean']['input']>;
  property_has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  property_heating?: InputMaybe<Scalars['String']['input']>;
  property_heating_distribution?: InputMaybe<Scalars['String']['input']>;
  property_income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  property_is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  property_land_surface?: InputMaybe<Scalars['Float']['input']>;
  property_lat?: InputMaybe<Scalars['Float']['input']>;
  property_living_surface?: InputMaybe<Scalars['Float']['input']>;
  property_lng?: InputMaybe<Scalars['Float']['input']>;
  property_locality?: InputMaybe<Scalars['String']['input']>;
  property_macro_location?: InputMaybe<Scalars['Float']['input']>;
  property_micro_location?: InputMaybe<Scalars['Float']['input']>;
  property_minergie_code?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  property_number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  property_number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  property_orientation?: InputMaybe<Scalars['String']['input']>;
  property_parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  property_plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  property_plot_number?: InputMaybe<Scalars['String']['input']>;
  property_plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  property_postcode?: InputMaybe<Scalars['String']['input']>;
  property_property_files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property_property_files_names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property_property_images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property_property_type_name?: InputMaybe<Scalars['String']['input']>;
  property_renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  property_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  property_residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_residential_surface?: InputMaybe<Scalars['Float']['input']>;
  property_residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  property_route?: InputMaybe<Scalars['String']['input']>;
  property_share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  property_state?: InputMaybe<Scalars['String']['input']>;
  property_street_number?: InputMaybe<Scalars['String']['input']>;
  property_terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  property_usable_surface?: InputMaybe<Scalars['Float']['input']>;
  property_weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
};

export type LotImportOutput = {
  lot_id?: Maybe<Scalars['uuid']['output']>;
};

export type LotMarketingMetadataInput = {
  as_organization?: InputMaybe<Scalars['String']['input']>;
  asn?: InputMaybe<Scalars['Int']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  marketing_signals?: InputMaybe<Scalars['jsonb']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

export type MarkEmailThreadReadOutput = {
  id: Scalars['uuid']['output'];
  unread: Scalars['Boolean']['output'];
};

export type MarkMarketplaceConversationReadOutput = {
  affected_rows: Scalars['Int']['output'];
};

export enum MarketplaceCountryCode {
  Ch = 'CH',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Pl = 'PL'
}

export type MarketplaceGeoInput = {
  coordinates: Scalars['jsonb']['input'];
  max_distance_km?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

export type MarketplaceListing = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  bullet_points?: Maybe<Scalars['jsonb']['output']>;
  clickout_url?: Maybe<MarketplaceListingClickoutUrl>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code: MarketplaceCountryCode;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  images?: Maybe<Scalars['jsonb']['output']>;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  map_data?: Maybe<MarketplaceListingMapData>;
  min_created_at?: Maybe<Scalars['timestamptz']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  portals?: Maybe<Array<Scalars['String']['output']>>;
  postcode?: Maybe<Scalars['String']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  show_contact_form: Scalars['Boolean']['output'];
  show_detail_page: Scalars['Boolean']['output'];
  show_phone_number: Scalars['Boolean']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_descriptions?: Maybe<Scalars['jsonb']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

export type MarketplaceListingClickoutUrl = {
  hostname: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type MarketplaceListingMapData = {
  geojson?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type MarketplaceListingMarker = {
  country_code: MarketplaceCountryCode;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  sale_price?: Maybe<Scalars['Float']['output']>;
};

export type MarketplaceListingMarkersPage = {
  items: Array<MarketplaceListingMarker>;
  total_count: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export enum MarketplaceListingSort {
  Newest = 'NEWEST',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PricePerM2Asc = 'PRICE_PER_M2_ASC',
  PricePerM2Desc = 'PRICE_PER_M2_DESC',
  Recommendation = 'RECOMMENDATION'
}

export type MarketplaceListingsPage = {
  items: Array<MarketplaceListing>;
  total_count: Scalars['Int']['output'];
};

export enum MarketplaceMessageClientOrigin {
  App = 'app',
  Web = 'web'
}

export enum MarketplaceOfferType {
  Buy = 'BUY',
  Rent = 'RENT'
}

export type MarketplacePlace = {
  bbox?: Maybe<Array<Scalars['Float']['output']>>;
  country_code: MarketplaceCountryCode;
  geom?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  label?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum MarketplacePropertyCategory {
  Appt = 'APPT',
  Building = 'BUILDING',
  Commercial = 'COMMERCIAL',
  Gastro = 'GASTRO',
  House = 'HOUSE',
  HouseAppt = 'HOUSE_APPT',
  Park = 'PARK',
  Prop = 'PROP',
  Room = 'ROOM'
}

export type MarketplaceSearchInput = {
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  country_code: MarketplaceCountryCode;
  created_at_gte?: InputMaybe<Scalars['String']['input']>;
  created_at_lte?: InputMaybe<Scalars['String']['input']>;
  geog?: InputMaybe<MarketplaceGeoInput>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  language: Scalars['String']['input'];
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type: MarketplaceOfferType;
  place_ids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  property_category?: InputMaybe<MarketplacePropertyCategory>;
  sale_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
};

export type MarketplaceSimilarSearchInput = {
  computed_surface?: InputMaybe<Scalars['Float']['input']>;
  country_code: MarketplaceCountryCode;
  excluded_listing_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  language: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  offer_price?: InputMaybe<Scalars['Float']['input']>;
  offer_type: MarketplaceOfferType;
};

export type MergeUserOutput = {
  id: Scalars['uuid']['output'];
};

export type MonthlyPerfContacts = {
  appraisal_requests?: Maybe<Scalars['Int']['output']>;
  contacts_off_platform?: Maybe<Scalars['Int']['output']>;
  phone_reveals?: Maybe<Scalars['Int']['output']>;
  profile_enquiry?: Maybe<Scalars['Int']['output']>;
  social_clicks?: Maybe<Scalars['Int']['output']>;
  website_clicks?: Maybe<Scalars['Int']['output']>;
};

export type MonthlyPerfCriteria = {
  competitors?: Maybe<Scalars['Int']['output']>;
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  you?: Maybe<Scalars['Int']['output']>;
};

export type MonthlyPerfOutput = {
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  contacts?: Maybe<MonthlyPerfContacts>;
  from_date?: Maybe<Scalars['String']['output']>;
  period_date?: Maybe<Scalars['String']['output']>;
  recent_valuations?: Maybe<Array<MonthlyPerfValuation>>;
  responsiveness_criterias?: Maybe<MonthlyPerfResponsivenessCriteria>;
  reviews_criterias?: Maybe<MonthlyPerfCriteria>;
  sales_criterias?: Maybe<MonthlyPerfCriteria>;
  team_id?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['String']['output']>;
  top_3_percentage?: Maybe<Scalars['Int']['output']>;
  top_locations?: Maybe<Array<MonthlyPerfTopLocation>>;
  valuation_appearances_count?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<MonthlyPerfVisibility>;
};

export type MonthlyPerfResponsivenessCriteria = {
  competitors?: Maybe<Scalars['String']['output']>;
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  you?: Maybe<Scalars['String']['output']>;
};

export type MonthlyPerfTopLocation = {
  avg_position?: Maybe<Scalars['Float']['output']>;
  impressions: Scalars['Int']['output'];
  location_name?: Maybe<Scalars['String']['output']>;
};

export type MonthlyPerfValuation = {
  isPositive?: Maybe<Scalars['Boolean']['output']>;
  location_name?: Maybe<Scalars['String']['output']>;
  map_image_url?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  time_ago?: Maybe<Scalars['String']['output']>;
  user_type?: Maybe<Scalars['String']['output']>;
};

export type MonthlyPerfVisibility = {
  avg_position?: Maybe<Scalars['Float']['output']>;
  rank_impressions?: Maybe<Scalars['Int']['output']>;
  rank_position?: Maybe<Scalars['Int']['output']>;
  rank_views?: Maybe<Scalars['Int']['output']>;
  total_impressions?: Maybe<Scalars['Int']['output']>;
  total_nearby?: Maybe<Scalars['Int']['output']>;
  total_views?: Maybe<Scalars['Int']['output']>;
};

export enum MortgageBuyingStatusType {
  Identified = 'identified',
  Offer = 'offer',
  Searching = 'searching',
  Visited = 'visited'
}

export type MyHomeAgency = {
  avgRating?: Maybe<Scalars['Float']['output']>;
  hideExactAddress: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['uuid']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  reviewsCount: Scalars['Int']['output'];
  route?: Maybe<Scalars['String']['output']>;
  showInAgencyPages: Scalars['Boolean']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
};

export type MyHomeAgentCard = {
  agent: MyHomePublicAgent;
  contactId?: Maybe<Scalars['uuid']['output']>;
  contacted: Scalars['Boolean']['output'];
  distance?: Maybe<Scalars['Float']['output']>;
  nearbyRadiusKm?: Maybe<Scalars['Float']['output']>;
  nearbyTransactionCount?: Maybe<Scalars['Int']['output']>;
  totalTransactions: Scalars['Int']['output'];
  transactionsInDistrict: Scalars['Int']['output'];
  transactionsInLocation: Scalars['Int']['output'];
  transactionsInMunicipality: Scalars['Int']['output'];
  transactionsInRadius: Scalars['Int']['output'];
  transactionsInState: Scalars['Int']['output'];
};

export type MyHomeAgentExpandedStats = {
  allTransactions: Array<MyHomeAgentTransaction>;
  localCount: Scalars['Int']['output'];
  localTransactions: Array<MyHomeAgentTransaction>;
  overallMedianPrice?: Maybe<Scalars['Float']['output']>;
  propertyTypeStats: Array<MyHomeAgentPropertyTypeStat>;
  totalCount: Scalars['Int']['output'];
};

export type MyHomeAgentExpandedStatsResult = {
  data?: Maybe<MyHomeAgentExpandedStats>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MyHomeAgentPropertyTypeStat = {
  count: Scalars['Int']['output'];
  medianPrice?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type MyHomeAgentReview = {
  createdAt?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isSeller: Scalars['Boolean']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
  text: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type MyHomeAgentTransaction = {
  imageUrl?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  rooms?: Maybe<Scalars['Float']['output']>;
  signatureDate?: Maybe<Scalars['timestamptz']['output']>;
  transactionId: Scalars['uuid']['output'];
  typeLabel: Scalars['String']['output'];
};

export type MyHomeAgents = {
  agents: Array<MyHomeAgentCard>;
  leadId: Scalars['uuid']['output'];
};

export type MyHomeAgentsResult = {
  data?: Maybe<MyHomeAgents>;
  errorCode?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MyHomeAppraisal = {
  contactId: Scalars['uuid']['output'];
  status: MyHomeAppraisalStatus;
};

export type MyHomeAppraisalResult = {
  data?: Maybe<MyHomeAppraisal>;
  errorCode?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum MyHomeAppraisalStatus {
  AlreadyContacted = 'ALREADY_CONTACTED',
  Created = 'CREATED'
}

export type MyHomeAttributionInput = {
  landingPageUrl?: InputMaybe<Scalars['String']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
};

export enum MyHomeOriginPlatform {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export type MyHomePublicAgent = {
  activeSince?: Maybe<Scalars['Float']['output']>;
  agency: MyHomeAgency;
  avgRating?: Maybe<Scalars['Float']['output']>;
  fullName: Scalars['String']['output'];
  hiresOnRealadvisor: Scalars['Int']['output'];
  id: Scalars['uuid']['output'];
  languages: Array<Scalars['String']['output']>;
  medianSalesPrice?: Maybe<Scalars['Float']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  review?: Maybe<MyHomeAgentReview>;
  reviewsCount: Scalars['Int']['output'];
  salesCount: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type NearbyImpressionLocality = {
  agency_id: Scalars['uuid']['output'];
  average_position?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type NearbyImpressionProfileView = {
  agency_id: Scalars['uuid']['output'];
  user_count: Scalars['Int']['output'];
};

export type NearbyImpressionTotal = {
  agency_id: Scalars['uuid']['output'];
  average_position?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  user_count: Scalars['Int']['output'];
};

export type NearbyImpressionsResponse = {
  by_locality?: Maybe<Array<NearbyImpressionLocality>>;
  profile_views?: Maybe<Array<NearbyImpressionProfileView>>;
  totals?: Maybe<Array<NearbyImpressionTotal>>;
};

export type OnboardingInvitationInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type OnboardingState = {
  agent: OnboardingStateAgent;
  can_edit_team: Scalars['Boolean']['output'];
  can_invite_team_members: Scalars['Boolean']['output'];
  country_code?: Maybe<Scalars['String']['output']>;
  is_claimed_profile: Scalars['Boolean']['output'];
  team?: Maybe<OnboardingStateTeam>;
};

export type OnboardingStateAddress = {
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type OnboardingStateAgent = {
  active_since?: Maybe<Scalars['Int']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  facebook_profile?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  instagram_profile?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  linked_in_profile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  tiktok_profile?: Maybe<Scalars['String']['output']>;
  user_image_id?: Maybe<Scalars['uuid']['output']>;
  user_image_url?: Maybe<Scalars['String']['output']>;
  x_profile?: Maybe<Scalars['String']['output']>;
  youtube_profile?: Maybe<Scalars['String']['output']>;
};

export type OnboardingStateTeam = {
  active_since?: Maybe<Scalars['Int']['output']>;
  address: OnboardingStateAddress;
  cover_photo_image_id?: Maybe<Scalars['uuid']['output']>;
  cover_photo_image_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  instagram_url?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  members: Array<OnboardingTeamMember>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  show_in_agency_pages?: Maybe<Scalars['Boolean']['output']>;
  tiktok_url?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  x_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

export type OnboardingTeamMember = {
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  image_url?: Maybe<Scalars['String']['output']>;
  is_leader: Scalars['Boolean']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
};

export type OrganisationBillingSummaryOutput = {
  arr_amount_cents: Scalars['Int']['output'];
  billing_interval?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  customer_count: Scalars['Int']['output'];
  customer_since?: Maybe<Scalars['String']['output']>;
  discount_label?: Maybe<Scalars['String']['output']>;
  history_url?: Maybe<Scalars['String']['output']>;
  invoices_outstanding_amount_cents: Scalars['Int']['output'];
  invoices_outstanding_count: Scalars['Int']['output'];
  invoices_paid_count: Scalars['Int']['output'];
  lifetime_value_amount_cents: Scalars['Int']['output'];
  mrr_amount_cents: Scalars['Int']['output'];
  mrr_list_amount_cents: Scalars['Int']['output'];
  next_invoice_amount_cents?: Maybe<Scalars['Int']['output']>;
  next_invoice_date?: Maybe<Scalars['String']['output']>;
  renewal_date?: Maybe<Scalars['String']['output']>;
  subscription_status?: Maybe<Scalars['String']['output']>;
};

export type OrganisationEngagementScoreOutput = {
  history: Array<OrganisationEngagementScorePoint>;
  organisation_id: Scalars['uuid']['output'];
  previous_score: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  signals: Array<OrganisationEngagementSignal>;
  updated_at: Scalars['String']['output'];
};

export type OrganisationEngagementScorePoint = {
  cma?: Maybe<Scalars['Int']['output']>;
  crm?: Maybe<Scalars['Int']['output']>;
  date: Scalars['String']['output'];
  profile?: Maybe<Scalars['Int']['output']>;
  prospection_map?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
  transactions?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['Int']['output']>;
  widget?: Maybe<Scalars['Int']['output']>;
};

export type OrganisationEngagementSignal = {
  counted: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  previous_score: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type OrganisationMonitoringAnalyticsOutput = {
  phone_clicks_total: Scalars['Int']['output'];
  profile_views_by_date: Array<OrganisationMonitoringAnalyticsPoint>;
  profile_views_total: Scalars['Int']['output'];
  valuation_impressions_by_date: Array<OrganisationMonitoringAnalyticsPoint>;
  valuation_impressions_by_position?: Maybe<Array<OrganisationMonitoringAnalyticsPositionPoint>>;
  valuation_impressions_total: Scalars['Int']['output'];
};

export type OrganisationMonitoringAnalyticsPoint = {
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type OrganisationMonitoringAnalyticsPositionPoint = {
  count: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type OrganisationPosthogCsatOutput = {
  average_score?: Maybe<Scalars['Float']['output']>;
  last_response_date?: Maybe<Scalars['String']['output']>;
  response_count: Scalars['Int']['output'];
  response_rate_percent: Scalars['Int']['output'];
  responses: Array<OrganisationPosthogCsatResponse>;
  survey_count: Scalars['Int']['output'];
  team_user_count: Scalars['Int']['output'];
};

export type OrganisationPosthogCsatResponse = {
  responded_at: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  survey_id: Scalars['String']['output'];
  survey_name?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type OrganisationPosthogDailyPoint = {
  active_users: Scalars['Int']['output'];
  b2b_mobile_events: Scalars['Int']['output'];
  crm_web_events: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  events: Scalars['Int']['output'];
};

export type OrganisationPosthogModuleUsage = {
  active_days_30d: Scalars['Int']['output'];
  active_users_30d: Scalars['Int']['output'];
  daily_series: Array<OrganisationPosthogDailyPoint>;
  eligible: Scalars['Boolean']['output'];
  events_30d: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  source_breakdown: OrganisationPosthogSourceBreakdown;
  users: Array<OrganisationPosthogModuleUserUsage>;
};

export type OrganisationPosthogModuleUserUsage = {
  active_days_30d: Scalars['Int']['output'];
  events_30d: Scalars['Int']['output'];
  last_seen_date?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['String']['output'];
};

export type OrganisationPosthogSourceBreakdown = {
  b2b_mobile_events: Scalars['Int']['output'];
  crm_web_events: Scalars['Int']['output'];
};

export type OrganisationPosthogSourceUsage = {
  b2b_mobile: OrganisationPosthogSourceUsageMetric;
  crm_web: OrganisationPosthogSourceUsageMetric;
};

export type OrganisationPosthogSourceUsageMetric = {
  active_users_30d: Scalars['Int']['output'];
  last_seen_date?: Maybe<Scalars['String']['output']>;
};

export type OrganisationPosthogUsageOutput = {
  cma: OrganisationPosthogModuleUsage;
  crm: OrganisationPosthogModuleUsage;
  pmap: OrganisationPosthogModuleUsage;
  source_usage: OrganisationPosthogSourceUsage;
  visibility: OrganisationPosthogModuleUsage;
};

export type OrganisationVisibilityPositionBreakdown = {
  count: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
  weighted: Scalars['Float']['output'];
};

export type OrganisationVisibilityScoreOutput = {
  computed_at: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  current: OrganisationVisibilityScoreWindow;
  delta: Scalars['Int']['output'];
  hostname: Scalars['String']['output'];
  organisation_id: Scalars['uuid']['output'];
  previous: OrganisationVisibilityScoreWindow;
  window_days: Scalars['Int']['output'];
};

export type OrganisationVisibilityScoreSignal = {
  color: Scalars['String']['output'];
  id: Scalars['String']['output'];
  max_points: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
};

export type OrganisationVisibilityScoreWindow = {
  effective_impressions: Scalars['Float']['output'];
  phone_clicks_total: Scalars['Int']['output'];
  position_breakdown: Array<OrganisationVisibilityPositionBreakdown>;
  profile_points: Scalars['Int']['output'];
  profile_views_target: Scalars['Float']['output'];
  profile_views_total: Scalars['Int']['output'];
  raw_score: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
  seller_contact_target_per_month?: Maybe<Scalars['Int']['output']>;
  signals: Array<OrganisationVisibilityScoreSignal>;
  size_multiplier: Scalars['Float']['output'];
  target_impressions: Scalars['Float']['output'];
  transactions_count_24mo: Scalars['Int']['output'];
  valuation_points: Scalars['Int']['output'];
  valuation_views_total: Scalars['Int']['output'];
};

export type ParcelAtPointOutput = {
  area_m2?: Maybe<Scalars['Float']['output']>;
  attributes?: Maybe<Scalars['jsonb']['output']>;
  found: Scalars['Boolean']['output'];
  geometry?: Maybe<Scalars['jsonb']['output']>;
  parcel_id?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type Place = {
  category: Scalars['String']['output'];
  distance: Scalars['Int']['output'];
  formattedAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  primaryType: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
};

export type PortalListing = {
  created_at: Scalars['timestamptz']['output'];
  external_property_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_publication_warnings?: Maybe<Scalars['jsonb']['output']>;
  live: Scalars['Boolean']['output'];
  lot?: Maybe<Lots>;
  lot_id: Scalars['uuid']['output'];
  milliseconds_online: Scalars['Float']['output'];
  portal?: Maybe<Portals>;
  portal_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

export type PreparedUpload = {
  id: Scalars['String']['output'];
  signed_url: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PropertyAppraisableOutput = {
  appraisable: AppraisableResult;
};

export type PropertyAppraisalInput = {
  address: AddressInput;
  appraisal_market_time?: InputMaybe<Scalars['Int']['input']>;
  appraisal_open_to_offer?: InputMaybe<Scalars['String']['input']>;
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_occupied?: InputMaybe<Scalars['String']['input']>;
  appraisal_reason?: InputMaybe<AppraisalReasonType>;
  appraisal_selling_with?: InputMaybe<Scalars['String']['input']>;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Int']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  living_surface: Scalars['Float']['input'];
  mortgage_buying_status?: InputMaybe<MortgageBuyingStatusType>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  property_type: PropertyType;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  received_mortgage_offer?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<RelationshipType>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  sale_horizon?: InputMaybe<SaleHorizonType>;
  source?: InputMaybe<Scalars['String']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type PropertyAppraisalOutput = {
  id: Scalars['ID']['output'];
  lead_id: Scalars['uuid']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  property_id: Scalars['ID']['output'];
  updated_at: Scalars['String']['output'];
  valuations: Array<Valuation>;
  value: Scalars['Float']['output'];
};

export type PropertySearchImportInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  notification: Scalars['String']['input'];
  number_of_bedrooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type: Scalars['String']['input'];
  places: Array<Scalars['String']['input']>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  source: Scalars['String']['input'];
};

export type PropertySearchImportOutput = {
  property_search?: Maybe<Property_Searches>;
  property_search_id?: Maybe<Scalars['uuid']['output']>;
};

export enum PropertyType {
  Apartment = 'apartment',
  ApartmentDuplex = 'apartment_duplex',
  ApartmentPenthouse = 'apartment_penthouse',
  ApartmentPenthouseDuplex = 'apartment_penthouse_duplex',
  HouseAttachedEnd = 'house_attached_end',
  HouseAttachedMiddle = 'house_attached_middle',
  HouseDetached = 'house_detached',
  HouseSemiDetached = 'house_semi_detached'
}

export type ProspectionContactQuotaOutput = {
  enabled: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  remaining: Scalars['Int']['output'];
  resets_at?: Maybe<Scalars['timestamptz']['output']>;
  used: Scalars['Int']['output'];
};

export type QualifyingAgent = {
  already_assigned?: Maybe<Scalars['Boolean']['output']>;
  amount_spent?: Maybe<Scalars['Float']['output']>;
  assigned_leads?: Maybe<Scalars['Float']['output']>;
  auto_assign_leads?: Maybe<Scalars['Boolean']['output']>;
  cost_per_lead?: Maybe<Scalars['Float']['output']>;
  crm_link?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  subscriptions?: Maybe<Array<Maybe<CurrentSubscription>>>;
};

export type ReadPortalIdxOutput = {
  columns: Array<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  rows: Scalars['json']['output'];
  truncated: Scalars['Boolean']['output'];
};

export type ReferenceAlias = {
  alias: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
};

export type RefuseLeadOutput = {
  id: Scalars['uuid']['output'];
  lead?: Maybe<Leads>;
};

export enum RelationshipType {
  Agent = 'agent',
  Buyer = 'buyer',
  Heir = 'heir',
  NotSet = 'not_set',
  Other = 'other',
  Owner = 'owner',
  Tenant = 'tenant'
}

export enum SaleHorizonType {
  AlreadyForSale = 'already_for_sale',
  From_1To_2Years = 'from_1_to_2_years',
  From_2Years = 'from_2_years',
  From_6To_12Months = 'from_6_to_12_months',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Under_6Months = 'under_6_months'
}

export type SaveOnboardingProgressInput = {
  active_since?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<AgencySetupAddressInput>;
  agent_active_since?: InputMaybe<Scalars['Int']['input']>;
  agent_certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  agent_description?: InputMaybe<Scalars['String']['input']>;
  agent_facebook_profile?: InputMaybe<Scalars['String']['input']>;
  agent_first_name?: InputMaybe<Scalars['String']['input']>;
  agent_instagram_profile?: InputMaybe<Scalars['String']['input']>;
  agent_languages?: InputMaybe<Array<Scalars['String']['input']>>;
  agent_last_name?: InputMaybe<Scalars['String']['input']>;
  agent_linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  agent_services?: InputMaybe<Array<Scalars['String']['input']>>;
  agent_tiktok_profile?: InputMaybe<Scalars['String']['input']>;
  agent_user_image_id?: InputMaybe<Scalars['uuid']['input']>;
  agent_x_profile?: InputMaybe<Scalars['String']['input']>;
  agent_youtube_profile?: InputMaybe<Scalars['String']['input']>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  x_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

export type SaveOnboardingProgressOutput = {
  success: Scalars['Boolean']['output'];
  team_id: Scalars['uuid']['output'];
};

export type SaveTeamThemeOutput = {
  code?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Boolean']['output']>;
  documents_switched?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  ok: Scalars['Boolean']['output'];
  problems?: Maybe<Array<Scalars['String']['output']>>;
  team_names?: Maybe<Array<Scalars['String']['output']>>;
  theme_id?: Maybe<Scalars['uuid']['output']>;
  theme_name?: Maybe<Scalars['String']['output']>;
};

export type SendBuyersAutoMatchingEmailOutput = {
  notified: Scalars['Boolean']['output'];
  stage_updated?: Maybe<Scalars['Boolean']['output']>;
};

export type SendMarketplaceMessageOutput = {
  message: SendMarketplaceMessagePayload;
};

export type SendMarketplaceMessagePayload = {
  body: Scalars['String']['output'];
  client_message_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  origin: Scalars['String']['output'];
  requires_caution: Scalars['Boolean']['output'];
  risk_reasons: Scalars['jsonb']['output'];
};

export type SetTeamThemeDefaultOutput = {
  code?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  team_name?: Maybe<Scalars['String']['output']>;
  theme_id?: Maybe<Scalars['uuid']['output']>;
  theme_name?: Maybe<Scalars['String']['output']>;
};

export type SlackNotificationOutput = {
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StartReviewGoogleAddressInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

export type StartReviewMarketingMetadataInput = {
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  marketing_signals?: InputMaybe<Scalars['jsonb']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

export type StartReviewResponse = {
  id: Scalars['uuid']['output'];
  success: Scalars['Boolean']['output'];
};

export type StartTrialOutput = {
  success: Scalars['Boolean']['output'];
};

export type StatisticsFilters = {
  end_date: Scalars['date']['output'];
  grouping_mode: GetLeadsStatisticsGroupingMode;
  lead_origins?: Maybe<Array<GetLeadsStatisticsLeadOrigin>>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  start_date: Scalars['date']['output'];
  team_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

export type StatisticsRow = {
  assigned_leads: Scalars['Int']['output'];
  call_attempts: Scalars['Int']['output'];
  call_missed: Scalars['Int']['output'];
  call_successful: Scalars['Int']['output'];
  claimed_leads: Scalars['Int']['output'];
  date_group: Scalars['String']['output'];
  rental_mandate: Scalars['Int']['output'];
  sale_mandate: Scalars['Int']['output'];
  visit_booked: Scalars['Int']['output'];
  visit_completed: Scalars['Int']['output'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCustomerSearchResponse = {
  data: Array<StripeCustomerSearchResult>;
};

export type StripeCustomerSearchResult = {
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type SyncDictionaryEnumsOutput = {
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TakedownAgencyOutput = {
  success: Scalars['Boolean']['output'];
};

export type TakedownAgentOutput = {
  success: Scalars['Boolean']['output'];
};

export type TeamThemeContextOutput = {
  can_delete?: Maybe<Scalars['Boolean']['output']>;
  can_set_default?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  documents_on_theme?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  is_team_default?: Maybe<Scalars['Boolean']['output']>;
  is_team_theme?: Maybe<Scalars['Boolean']['output']>;
  layouts?: Maybe<Array<TeamThemeLayout>>;
  ok: Scalars['Boolean']['output'];
  only_this_document?: Maybe<Scalars['Boolean']['output']>;
  other_part?: Maybe<TeamThemeOtherPart>;
  team_choices?: Maybe<Array<TeamThemeTeam>>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  theme_id?: Maybe<Scalars['uuid']['output']>;
  theme_name?: Maybe<Scalars['String']['output']>;
};

export type TeamThemeLayout = {
  content: Scalars['String']['output'];
  name: Scalars['String']['output'];
  theme_id: Scalars['uuid']['output'];
};

export type TeamThemeOtherPart = {
  content: Scalars['String']['output'];
  document_type: Scalars['String']['output'];
  documents_on_part: Scalars['Int']['output'];
  file_id: Scalars['uuid']['output'];
};

export type TeamThemeTeam = {
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
};

export type TestWebhookOutput = {
  results: Array<TestWebhookResult>;
};

export type TestWebhookResult = {
  error?: Maybe<Scalars['String']['output']>;
  event_type: Scalars['String']['output'];
  status_code?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TopCompetitorStatsOutput = {
  medianResponseMinutes?: Maybe<Scalars['Float']['output']>;
  profileCompletion?: Maybe<Scalars['Int']['output']>;
};

export type TrackedDocumentUrlOutput = {
  url: Scalars['String']['output'];
};

export type TranslatedAgentReview = {
  cache_changed: Scalars['Boolean']['output'];
  source_language?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TranslatedText = {
  text: Scalars['String']['output'];
};

export type UnblockFsboUsersOutput = {
  user_ids: Array<Scalars['uuid']['output']>;
};

export type UpdateEmailThreadVisibilityOutput = {
  id: Scalars['uuid']['output'];
  visibility: Scalars['String']['output'];
};

export type UpdatePortalListing = {
  success: Scalars['Boolean']['output'];
  warnings?: Maybe<Scalars['jsonb']['output']>;
};

export type UpdateUserEmailPreferencesOutput = {
  id: Scalars['uuid']['output'];
};

export type UpdateUserPermissionFlagsOutput = {
  id: Scalars['uuid']['output'];
};

export type UserImportInput = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone_numbers?: InputMaybe<Array<Scalars['String']['input']>>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

export type UserImportOutput = {
  label: Scalars['String']['output'];
  skip_reason?: Maybe<Scalars['String']['output']>;
  skipped: Scalars['Boolean']['output'];
};

export type ValidateInvitationOutput = {
  magic_token?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

export type ValidateWebhookUrlOutput = {
  reason?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type Valuation = {
  id: Scalars['ID']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  valuation_model: ValuationModel;
  value: Scalars['Float']['output'];
};

export type ValuationLinkOutput = {
  agent_id?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  landing_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  survey_id?: Maybe<Scalars['String']['output']>;
  valuation_url?: Maybe<Scalars['String']['output']>;
};

export type ValuationModel = {
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
};

export type ValuePropertyOutput = {
  appraisal?: Maybe<Appraisals>;
  appraisal_id: Scalars['uuid']['output'];
};

/** Boolean expression to compare columns of type "_float8". All fields are combined with logical 'AND'. */
export type _Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_float8']['input']>;
  _gt?: InputMaybe<Scalars['_float8']['input']>;
  _gte?: InputMaybe<Scalars['_float8']['input']>;
  _in?: InputMaybe<Array<Scalars['_float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_float8']['input']>;
  _lte?: InputMaybe<Scalars['_float8']['input']>;
  _neq?: InputMaybe<Scalars['_float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['_float8']['input']>>;
};

/** Boolean expression to compare columns of type "_text". All fields are combined with logical 'AND'. */
export type _Text_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['_text']['input']>;
  _gt?: InputMaybe<Scalars['_text']['input']>;
  _gte?: InputMaybe<Scalars['_text']['input']>;
  _in?: InputMaybe<Array<Scalars['_text']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['_text']['input']>;
  _lte?: InputMaybe<Scalars['_text']['input']>;
  _neq?: InputMaybe<Scalars['_text']['input']>;
  _nin?: InputMaybe<Array<Scalars['_text']['input']>>;
};

export type Activate_Property_Image_Version_Args = {
  expected_current_image_id?: InputMaybe<Scalars['uuid']['input']>;
  property_image_id?: InputMaybe<Scalars['uuid']['input']>;
  target_image_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Timeline events and to-dos: calls, visits, tasks, notes, emails, offers and system events, told apart by activity_type. A row hangs off one or more of lead_id, lot_id, buyer_lead_id, enquiry_id, offer_id, development_id or user_id. assigned_to is the agent responsible, created_by the author. Open to-dos: done = false and activity_type in (task, call, visit), by consolidated_due_at; the CRM's next activity of a lead also counts open assignment rows. Very large: filter on lead_id, lot_id, assigned_to, created_by or a date. */
export type Activities = {
  /** An array relationship */
  activities_target_users: Array<Activities_Target_Users>;
  activity_type: Activity_Types_Enum_Enum;
  appraisal_id?: Maybe<Scalars['uuid']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  assignee?: Maybe<Users>;
  /** An object relationship */
  buyer_lead?: Maybe<Buyer_Leads>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  calendar_event_id?: Maybe<Scalars['uuid']['output']>;
  consolidated_done_at?: Maybe<Scalars['timestamptz']['output']>;
  /** When it is due: due_at, else the end of start_date; NULL for notes. Filled for open (done = false) rows; NULL on most done rows: use consolidated_done_at for those. */
  consolidated_due_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  done: Scalars['Boolean']['output'];
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  email_message?: Maybe<Email_Messages>;
  email_message_id?: Maybe<Scalars['uuid']['output']>;
  end_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  enquiry?: Maybe<Enquiries>;
  enquiry_id?: Maybe<Scalars['uuid']['output']>;
  extra_data?: Maybe<Scalars['jsonb']['output']>;
  financing_request_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "is_overdue" */
  is_overdue?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "is_today" */
  is_today?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  offer?: Maybe<Offers>;
  offer_id?: Maybe<Scalars['uuid']['output']>;
  offer_status?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "performance_activities_due_sort_at" */
  performance_due_sort_at?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "performance_activity_is_listed" */
  performance_is_listed?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "performance_activity_is_overdue" */
  performance_is_overdue?: Maybe<Scalars['Boolean']['output']>;
  pinned: Scalars['Boolean']['output'];
  start_date?: Maybe<Scalars['date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  /** Outcome once done. Visit: true = took place, false = cancelled. Call: true = reached, false = tried. */
  success: Scalars['Boolean']['output'];
  synced_from_calendar: Scalars['Boolean']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: Maybe<Scalars['uuid']['output']>;
  visibility: Scalars['String']['output'];
};


/** Timeline events and to-dos: calls, visits, tasks, notes, emails, offers and system events, told apart by activity_type. A row hangs off one or more of lead_id, lot_id, buyer_lead_id, enquiry_id, offer_id, development_id or user_id. assigned_to is the agent responsible, created_by the author. Open to-dos: done = false and activity_type in (task, call, visit), by consolidated_due_at; the CRM's next activity of a lead also counts open assignment rows. Very large: filter on lead_id, lot_id, assigned_to, created_by or a date. */
export type ActivitiesActivities_Target_UsersArgs = {
  distinct_on?: InputMaybe<Array<Activities_Target_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Target_Users_Order_By>>;
  where?: InputMaybe<Activities_Target_Users_Bool_Exp>;
};


/** Timeline events and to-dos: calls, visits, tasks, notes, emails, offers and system events, told apart by activity_type. A row hangs off one or more of lead_id, lot_id, buyer_lead_id, enquiry_id, offer_id, development_id or user_id. assigned_to is the agent responsible, created_by the author. Open to-dos: done = false and activity_type in (task, call, visit), by consolidated_due_at; the CRM's next activity of a lead also counts open assignment rows. Very large: filter on lead_id, lot_id, assigned_to, created_by or a date. */
export type ActivitiesExtra_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "activities" */
export type Activities_Aggregate = {
  aggregate?: Maybe<Activities_Aggregate_Fields>;
  nodes: Array<Activities>;
};

export type Activities_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Activities_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Activities_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Activities_Aggregate_Bool_Exp_Count>;
};

export type Activities_Aggregate_Bool_Exp_Bool_And = {
  arguments: Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activities_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activities_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Activities_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activities_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "activities" */
export type Activities_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Activities_Max_Fields>;
  min?: Maybe<Activities_Min_Fields>;
};


/** aggregate fields of "activities" */
export type Activities_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activities_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "activities" */
export type Activities_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activities_Max_Order_By>;
  min?: InputMaybe<Activities_Min_Order_By>;
};

/** input type for inserting array relation for remote table "activities" */
export type Activities_Arr_Rel_Insert_Input = {
  data: Array<Activities_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};

/** Boolean expression to filter rows from the table "activities". All fields are combined with a logical 'AND'. */
export type Activities_Bool_Exp = {
  _and?: InputMaybe<Array<Activities_Bool_Exp>>;
  _not?: InputMaybe<Activities_Bool_Exp>;
  _or?: InputMaybe<Array<Activities_Bool_Exp>>;
  activities_target_users?: InputMaybe<Activities_Target_Users_Bool_Exp>;
  activity_type?: InputMaybe<Activity_Types_Enum_Enum_Comparison_Exp>;
  appraisal_id?: InputMaybe<Uuid_Comparison_Exp>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  assignee?: InputMaybe<Users_Bool_Exp>;
  buyer_lead?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  calendar_event_id?: InputMaybe<Uuid_Comparison_Exp>;
  consolidated_done_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  consolidated_due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  done?: InputMaybe<Boolean_Comparison_Exp>;
  done_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_message?: InputMaybe<Email_Messages_Bool_Exp>;
  email_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  end_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  enquiry?: InputMaybe<Enquiries_Bool_Exp>;
  enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra_data?: InputMaybe<Jsonb_Comparison_Exp>;
  financing_request_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_overdue?: InputMaybe<Boolean_Comparison_Exp>;
  is_today?: InputMaybe<Boolean_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  location?: InputMaybe<String_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  offer?: InputMaybe<Offers_Bool_Exp>;
  offer_id?: InputMaybe<Uuid_Comparison_Exp>;
  offer_status?: InputMaybe<String_Comparison_Exp>;
  performance_due_sort_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  performance_is_listed?: InputMaybe<Boolean_Comparison_Exp>;
  performance_is_overdue?: InputMaybe<Boolean_Comparison_Exp>;
  pinned?: InputMaybe<Boolean_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  synced_from_calendar?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "activities" */
export enum Activities_Constraint {
  /** unique or primary key constraint on columns "calendar_event_id" */
  ActivitiesCalendarEventIdUnique = 'activities_calendar_event_id_unique',
  /** unique or primary key constraint on columns "email_message_id", "buyer_lead_id" */
  ActivitiesEmailMessageIdBuyerLeadIdUnique = 'activities_email_message_id_buyer_lead_id_unique',
  /** unique or primary key constraint on columns "email_message_id", "enquiry_id" */
  ActivitiesEmailMessageIdEnquiryIdUnique = 'activities_email_message_id_enquiry_id_unique',
  /** unique or primary key constraint on columns "lead_id", "email_message_id" */
  ActivitiesEmailMessageIdLeadIdUnique = 'activities_email_message_id_lead_id_unique',
  /** unique or primary key constraint on columns "email_message_id", "lot_id" */
  ActivitiesEmailMessageIdLotIdUnique = 'activities_email_message_id_lot_id_unique',
  /** unique or primary key constraint on columns "user_id", "email_message_id" */
  ActivitiesEmailMessageIdUserIdUnique = 'activities_email_message_id_user_id_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ActivitiesIdTenantIdUnique = 'activities_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ActivitiesPkey = 'activities_pkey'
}

/** input type for inserting data into table "activities" */
export type Activities_Insert_Input = {
  activities_target_users?: InputMaybe<Activities_Target_Users_Arr_Rel_Insert_Input>;
  activity_type?: InputMaybe<Activity_Types_Enum_Enum>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  assignee?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buyer_lead?: InputMaybe<Buyer_Leads_Obj_Rel_Insert_Input>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  calendar_event_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_message_id?: InputMaybe<Scalars['uuid']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  enquiry?: InputMaybe<Enquiries_Obj_Rel_Insert_Input>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  extra_data?: InputMaybe<Scalars['jsonb']['input']>;
  financing_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer?: InputMaybe<Offers_Obj_Rel_Insert_Input>;
  offer_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_status?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Outcome once done. Visit: true = took place, false = cancelled. Call: true = reached, false = tried. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  synced_from_calendar?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Activities_Max_Fields = {
  appraisal_id?: Maybe<Scalars['uuid']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  calendar_event_id?: Maybe<Scalars['uuid']['output']>;
  consolidated_done_at?: Maybe<Scalars['timestamptz']['output']>;
  /** When it is due: due_at, else the end of start_date; NULL for notes. Filled for open (done = false) rows; NULL on most done rows: use consolidated_done_at for those. */
  consolidated_due_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  email_message_id?: Maybe<Scalars['uuid']['output']>;
  end_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  enquiry_id?: Maybe<Scalars['uuid']['output']>;
  financing_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offer_id?: Maybe<Scalars['uuid']['output']>;
  offer_status?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "performance_activities_due_sort_at" */
  performance_due_sort_at?: Maybe<Scalars['timestamptz']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "activities" */
export type Activities_Max_Order_By = {
  appraisal_id?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  calendar_event_id?: InputMaybe<Order_By>;
  consolidated_done_at?: InputMaybe<Order_By>;
  /** When it is due: due_at, else the end of start_date; NULL for notes. Filled for open (done = false) rows; NULL on most done rows: use consolidated_done_at for those. */
  consolidated_due_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  financing_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  offer_status?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Activities_Min_Fields = {
  appraisal_id?: Maybe<Scalars['uuid']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  calendar_event_id?: Maybe<Scalars['uuid']['output']>;
  consolidated_done_at?: Maybe<Scalars['timestamptz']['output']>;
  /** When it is due: due_at, else the end of start_date; NULL for notes. Filled for open (done = false) rows; NULL on most done rows: use consolidated_done_at for those. */
  consolidated_due_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  email_message_id?: Maybe<Scalars['uuid']['output']>;
  end_at?: Maybe<Scalars['timestamptz']['output']>;
  end_date?: Maybe<Scalars['date']['output']>;
  enquiry_id?: Maybe<Scalars['uuid']['output']>;
  financing_request_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  offer_id?: Maybe<Scalars['uuid']['output']>;
  offer_status?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "performance_activities_due_sort_at" */
  performance_due_sort_at?: Maybe<Scalars['timestamptz']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "activities" */
export type Activities_Min_Order_By = {
  appraisal_id?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  calendar_event_id?: InputMaybe<Order_By>;
  consolidated_done_at?: InputMaybe<Order_By>;
  /** When it is due: due_at, else the end of start_date; NULL for notes. Filled for open (done = false) rows; NULL on most done rows: use consolidated_done_at for those. */
  consolidated_due_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  financing_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offer_id?: InputMaybe<Order_By>;
  offer_status?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activities" */
export type Activities_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activities>;
};

/** input type for inserting object relation for remote table "activities" */
export type Activities_Obj_Rel_Insert_Input = {
  data: Activities_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};

/** on_conflict condition type for table "activities" */
export type Activities_On_Conflict = {
  constraint: Activities_Constraint;
  update_columns?: Array<Activities_Update_Column>;
  where?: InputMaybe<Activities_Bool_Exp>;
};

/** Ordering options when selecting data from "activities". */
export type Activities_Order_By = {
  activities_target_users_aggregate?: InputMaybe<Activities_Target_Users_Aggregate_Order_By>;
  activity_type?: InputMaybe<Order_By>;
  appraisal_id?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  assignee?: InputMaybe<Users_Order_By>;
  buyer_lead?: InputMaybe<Buyer_Leads_Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  calendar_event_id?: InputMaybe<Order_By>;
  consolidated_done_at?: InputMaybe<Order_By>;
  consolidated_due_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  development_id?: InputMaybe<Order_By>;
  done?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  email_message?: InputMaybe<Email_Messages_Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  enquiry?: InputMaybe<Enquiries_Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  extra_data?: InputMaybe<Order_By>;
  financing_request_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_overdue?: InputMaybe<Order_By>;
  is_today?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  offer?: InputMaybe<Offers_Order_By>;
  offer_id?: InputMaybe<Order_By>;
  offer_status?: InputMaybe<Order_By>;
  performance_due_sort_at?: InputMaybe<Order_By>;
  performance_is_listed?: InputMaybe<Order_By>;
  performance_is_overdue?: InputMaybe<Order_By>;
  pinned?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  synced_from_calendar?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** primary key columns input for table: activities */
export type Activities_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "activities" */
export enum Activities_Select_Column {
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  AppraisalId = 'appraisal_id',
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CalendarEventId = 'calendar_event_id',
  /** column name */
  ConsolidatedDoneAt = 'consolidated_done_at',
  /** column name */
  ConsolidatedDueAt = 'consolidated_due_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  ExtraData = 'extra_data',
  /** column name */
  FinancingRequestId = 'financing_request_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Location = 'location',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  OfferId = 'offer_id',
  /** column name */
  OfferStatus = 'offer_status',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visibility = 'visibility'
}

/** select "activities_aggregate_bool_exp_bool_and_arguments_columns" columns of table "activities" */
export enum Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

/** select "activities_aggregate_bool_exp_bool_or_arguments_columns" columns of table "activities" */
export enum Activities_Select_Column_Activities_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Done = 'done',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  Success = 'success',
  /** column name */
  SyncedFromCalendar = 'synced_from_calendar'
}

/** input type for updating data in table "activities" */
export type Activities_Set_Input = {
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Outcome once done. Visit: true = took place, false = cancelled. Call: true = reached, false = tried. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "activities" */
export type Activities_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activities_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activities_Stream_Cursor_Value_Input = {
  activity_type?: InputMaybe<Activity_Types_Enum_Enum>;
  appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  calendar_event_id?: InputMaybe<Scalars['uuid']['input']>;
  consolidated_done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** When it is due: due_at, else the end of start_date; NULL for notes. Filled for open (done = false) rows; NULL on most done rows: use consolidated_done_at for those. */
  consolidated_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_message_id?: InputMaybe<Scalars['uuid']['input']>;
  end_at?: InputMaybe<Scalars['timestamptz']['input']>;
  end_date?: InputMaybe<Scalars['date']['input']>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  extra_data?: InputMaybe<Scalars['jsonb']['input']>;
  financing_request_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_status?: InputMaybe<Scalars['String']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Outcome once done. Visit: true = took place, false = cancelled. Call: true = reached, false = tried. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  synced_from_calendar?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The person the activity is about when it is not attached to a lead, listing, buyer lead or enquiry: a contact, or the agent for agent events (module_granted, module_revoked, create_user and similar). Not who did it: see assigned_to and created_by. */
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "activities_target_users" */
export type Activities_Target_Users = {
  /** An object relationship */
  activity: Activities;
  activity_id: Scalars['uuid']['output'];
  email?: Maybe<Scalars['String']['output']>;
  is_owner: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  target_user_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
};

/** order by aggregate values of table "activities_target_users" */
export type Activities_Target_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Activities_Target_Users_Max_Order_By>;
  min?: InputMaybe<Activities_Target_Users_Min_Order_By>;
};

/** input type for inserting array relation for remote table "activities_target_users" */
export type Activities_Target_Users_Arr_Rel_Insert_Input = {
  data: Array<Activities_Target_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activities_Target_Users_On_Conflict>;
};

/** Boolean expression to filter rows from the table "activities_target_users". All fields are combined with a logical 'AND'. */
export type Activities_Target_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Activities_Target_Users_Bool_Exp>>;
  _not?: InputMaybe<Activities_Target_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Activities_Target_Users_Bool_Exp>>;
  activity?: InputMaybe<Activities_Bool_Exp>;
  activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  is_owner?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  target_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "activities_target_users" */
export enum Activities_Target_Users_Constraint {
  /** unique or primary key constraint on columns "id" */
  ActivitiesTargetUsersPkey = 'activities_target_users_pkey',
  /** unique or primary key constraint on columns "email", "is_owner", "activity_id", "target_user_id" */
  ActivitiesTargetUsersUindex = 'activities_target_users_uindex'
}

/** input type for inserting data into table "activities_target_users" */
export type Activities_Target_Users_Insert_Input = {
  activity?: InputMaybe<Activities_Obj_Rel_Insert_Input>;
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  target_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "activities_target_users" */
export type Activities_Target_Users_Max_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_user_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "activities_target_users" */
export type Activities_Target_Users_Min_Order_By = {
  activity_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_user_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "activities_target_users" */
export type Activities_Target_Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activities_Target_Users>;
};

/** on_conflict condition type for table "activities_target_users" */
export type Activities_Target_Users_On_Conflict = {
  constraint: Activities_Target_Users_Constraint;
  update_columns?: Array<Activities_Target_Users_Update_Column>;
  where?: InputMaybe<Activities_Target_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "activities_target_users". */
export type Activities_Target_Users_Order_By = {
  activity?: InputMaybe<Activities_Order_By>;
  activity_id?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  is_owner?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  target_user_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "activities_target_users" */
export enum Activities_Target_Users_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  Email = 'email',
  /** column name */
  IsOwner = 'is_owner',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  TargetUserId = 'target_user_id',
  /** column name */
  Type = 'type'
}

/** placeholder for update columns of table "activities_target_users" (current role has no relevant permissions) */
export enum Activities_Target_Users_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** update columns of table "activities" */
export enum Activities_Update_Column {
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Location = 'location',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Note = 'note',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Subject = 'subject',
  /** column name */
  Success = 'success',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Visibility = 'visibility'
}

export type Activities_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activities_Set_Input>;
  /** filter the rows which have to be updated */
  where: Activities_Bool_Exp;
};

/** columns and relationships of "activity_feed" */
export type Activity_Feed = {
  /** An object relationship */
  activity?: Maybe<Activities>;
  activity_id: Scalars['uuid']['output'];
  activity_type: Scalars['String']['output'];
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  done: Scalars['Boolean']['output'];
  done_asc_key: Scalars['timestamptz']['output'];
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  done_desc_key: Scalars['timestamptz']['output'];
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  due_sort_at: Scalars['timestamptz']['output'];
  has_parent: Scalars['Boolean']['output'];
  pinned: Scalars['Boolean']['output'];
  start_date?: Maybe<Scalars['date']['output']>;
  success: Scalars['Boolean']['output'];
  tenant_id: Scalars['uuid']['output'];
  visibility: Scalars['String']['output'];
};

/** aggregated selection of "activity_feed" */
export type Activity_Feed_Aggregate = {
  aggregate?: Maybe<Activity_Feed_Aggregate_Fields>;
  nodes: Array<Activity_Feed>;
};

/** aggregate fields of "activity_feed" */
export type Activity_Feed_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Feed_Max_Fields>;
  min?: Maybe<Activity_Feed_Min_Fields>;
};


/** aggregate fields of "activity_feed" */
export type Activity_Feed_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Activity_Feed_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "activity_feed". All fields are combined with a logical 'AND'. */
export type Activity_Feed_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Feed_Bool_Exp>>;
  _not?: InputMaybe<Activity_Feed_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Feed_Bool_Exp>>;
  activity?: InputMaybe<Activities_Bool_Exp>;
  activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  activity_type?: InputMaybe<String_Comparison_Exp>;
  assigned_to?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  done?: InputMaybe<Boolean_Comparison_Exp>;
  done_asc_key?: InputMaybe<Timestamptz_Comparison_Exp>;
  done_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  done_desc_key?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  due_sort_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  has_parent?: InputMaybe<Boolean_Comparison_Exp>;
  pinned?: InputMaybe<Boolean_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Activity_Feed_Max_Fields = {
  activity_id?: Maybe<Scalars['uuid']['output']>;
  activity_type?: Maybe<Scalars['String']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  done_asc_key?: Maybe<Scalars['timestamptz']['output']>;
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  done_desc_key?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  due_sort_at?: Maybe<Scalars['timestamptz']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Activity_Feed_Min_Fields = {
  activity_id?: Maybe<Scalars['uuid']['output']>;
  activity_type?: Maybe<Scalars['String']['output']>;
  assigned_to?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  done_asc_key?: Maybe<Scalars['timestamptz']['output']>;
  done_at?: Maybe<Scalars['timestamptz']['output']>;
  done_desc_key?: Maybe<Scalars['timestamptz']['output']>;
  due_at?: Maybe<Scalars['timestamptz']['output']>;
  due_sort_at?: Maybe<Scalars['timestamptz']['output']>;
  start_date?: Maybe<Scalars['date']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "activity_feed". */
export type Activity_Feed_Order_By = {
  activity?: InputMaybe<Activities_Order_By>;
  activity_id?: InputMaybe<Order_By>;
  activity_type?: InputMaybe<Order_By>;
  assigned_to?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  done?: InputMaybe<Order_By>;
  done_asc_key?: InputMaybe<Order_By>;
  done_at?: InputMaybe<Order_By>;
  done_desc_key?: InputMaybe<Order_By>;
  due_at?: InputMaybe<Order_By>;
  due_sort_at?: InputMaybe<Order_By>;
  has_parent?: InputMaybe<Order_By>;
  pinned?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** columns and relationships of "activity_feed_quarantine" */
export type Activity_Feed_Quarantine = {
  principal_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "activity_feed_quarantine". All fields are combined with a logical 'AND'. */
export type Activity_Feed_Quarantine_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Feed_Quarantine_Bool_Exp>>;
  _not?: InputMaybe<Activity_Feed_Quarantine_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Feed_Quarantine_Bool_Exp>>;
  principal_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "activity_feed_quarantine". */
export type Activity_Feed_Quarantine_Order_By = {
  principal_id?: InputMaybe<Order_By>;
};

/** select columns of table "activity_feed_quarantine" */
export enum Activity_Feed_Quarantine_Select_Column {
  /** column name */
  PrincipalId = 'principal_id'
}

/** Streaming cursor of the table "activity_feed_quarantine" */
export type Activity_Feed_Quarantine_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Feed_Quarantine_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Feed_Quarantine_Stream_Cursor_Value_Input = {
  principal_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** select columns of table "activity_feed" */
export enum Activity_Feed_Select_Column {
  /** column name */
  ActivityId = 'activity_id',
  /** column name */
  ActivityType = 'activity_type',
  /** column name */
  AssignedTo = 'assigned_to',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Done = 'done',
  /** column name */
  DoneAscKey = 'done_asc_key',
  /** column name */
  DoneAt = 'done_at',
  /** column name */
  DoneDescKey = 'done_desc_key',
  /** column name */
  DueAt = 'due_at',
  /** column name */
  DueSortAt = 'due_sort_at',
  /** column name */
  HasParent = 'has_parent',
  /** column name */
  Pinned = 'pinned',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Success = 'success',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Visibility = 'visibility'
}

/** columns and relationships of "activity_feed_status" */
export type Activity_Feed_Status = {
  ready: Scalars['Boolean']['output'];
};

/** Boolean expression to filter rows from the table "activity_feed_status". All fields are combined with a logical 'AND'. */
export type Activity_Feed_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Activity_Feed_Status_Bool_Exp>>;
  _not?: InputMaybe<Activity_Feed_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Activity_Feed_Status_Bool_Exp>>;
  ready?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "activity_feed_status". */
export type Activity_Feed_Status_Order_By = {
  ready?: InputMaybe<Order_By>;
};

/** select columns of table "activity_feed_status" */
export enum Activity_Feed_Status_Select_Column {
  /** column name */
  Ready = 'ready'
}

/** Streaming cursor of the table "activity_feed_status" */
export type Activity_Feed_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Feed_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Feed_Status_Stream_Cursor_Value_Input = {
  ready?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "activity_feed" */
export type Activity_Feed_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Activity_Feed_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Feed_Stream_Cursor_Value_Input = {
  activity_id?: InputMaybe<Scalars['uuid']['input']>;
  activity_type?: InputMaybe<Scalars['String']['input']>;
  assigned_to?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  done_asc_key?: InputMaybe<Scalars['timestamptz']['input']>;
  done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  done_desc_key?: InputMaybe<Scalars['timestamptz']['input']>;
  due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  due_sort_at?: InputMaybe<Scalars['timestamptz']['input']>;
  has_parent?: InputMaybe<Scalars['Boolean']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

export enum Activity_Types_Enum_Enum {
  AgencyProfileVisibilityChanged = 'agency_profile_visibility_changed',
  AgentOptIn = 'agent_opt_in',
  AgentProfileVisibilityChanged = 'agent_profile_visibility_changed',
  AgentQuizCompleted = 'agent_quiz_completed',
  Assignment = 'assignment',
  Call = 'call',
  Change = 'change',
  CreateUser = 'create_user',
  Email = 'email',
  LeadStatusAgent = 'lead_status_agent',
  Match = 'match',
  ModuleGranted = 'module_granted',
  ModuleRevoked = 'module_revoked',
  Note = 'note',
  Offer = 'offer',
  OnboardingCompleted = 'onboarding_completed',
  OnboardingEnrolled = 'onboarding_enrolled',
  OnboardingStatusChanged = 'onboarding_status_changed',
  Origination = 'origination',
  Requalification = 'requalification',
  Task = 'task',
  Visit = 'visit'
}

/** Boolean expression to compare columns of type "activity_types_enum_enum". All fields are combined with logical 'AND'. */
export type Activity_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Activity_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Activity_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Activity_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Activity_Types_Enum_Enum>>;
};

/** columns and relationships of "address_display_options_enum" */
export type Address_Display_Options_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "address_display_options_enum". All fields are combined with a logical 'AND'. */
export type Address_Display_Options_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Display_Options_Enum_Bool_Exp>>;
  _not?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Display_Options_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Address_Display_Options_Enum_Enum {
  /** Full address */
  FullAddress = 'full_address',
  /** Hide street and street number */
  HideStreet = 'hide_street',
  /** Hide only street number */
  HideStreetNumber = 'hide_street_number'
}

/** Boolean expression to compare columns of type "address_display_options_enum_enum". All fields are combined with logical 'AND'. */
export type Address_Display_Options_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Address_Display_Options_Enum_Enum>;
  _in?: InputMaybe<Array<Address_Display_Options_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Address_Display_Options_Enum_Enum>;
  _nin?: InputMaybe<Array<Address_Display_Options_Enum_Enum>>;
};

/** Ordering options when selecting data from "address_display_options_enum". */
export type Address_Display_Options_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "address_display_options_enum" */
export enum Address_Display_Options_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "address_display_options_enum" */
export type Address_Display_Options_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Display_Options_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Display_Options_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "agencies" */
export type Agencies = {
  agency_slug?: Maybe<Scalars['String']['output']>;
  avg_rating?: Maybe<Scalars['numeric']['output']>;
  centroid?: Maybe<Scalars['geometry']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  latest_review_comment?: Maybe<Scalars['String']['output']>;
  latest_review_created_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_review_display_name?: Maybe<Scalars['String']['output']>;
  latest_review_id?: Maybe<Scalars['uuid']['output']>;
  latest_review_is_seller?: Maybe<Scalars['Boolean']['output']>;
  latest_review_rating?: Maybe<Scalars['Int']['output']>;
  latest_review_transaction_id?: Maybe<Scalars['uuid']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  median_sales_price?: Maybe<Scalars['float8']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reviews_count?: Maybe<Scalars['bigint']['output']>;
  sales_count?: Maybe<Scalars['bigint']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "agencies". All fields are combined with a logical 'AND'. */
export type Agencies_Bool_Exp = {
  _and?: InputMaybe<Array<Agencies_Bool_Exp>>;
  _not?: InputMaybe<Agencies_Bool_Exp>;
  _or?: InputMaybe<Array<Agencies_Bool_Exp>>;
  agency_slug?: InputMaybe<String_Comparison_Exp>;
  avg_rating?: InputMaybe<Numeric_Comparison_Exp>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  latest_review_comment?: InputMaybe<String_Comparison_Exp>;
  latest_review_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  latest_review_display_name?: InputMaybe<String_Comparison_Exp>;
  latest_review_id?: InputMaybe<Uuid_Comparison_Exp>;
  latest_review_is_seller?: InputMaybe<Boolean_Comparison_Exp>;
  latest_review_rating?: InputMaybe<Int_Comparison_Exp>;
  latest_review_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  median_sales_price?: InputMaybe<Float8_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  reviews_count?: InputMaybe<Bigint_Comparison_Exp>;
  sales_count?: InputMaybe<Bigint_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "agencies". */
export type Agencies_Order_By = {
  agency_slug?: InputMaybe<Order_By>;
  avg_rating?: InputMaybe<Order_By>;
  centroid?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  latest_review_comment?: InputMaybe<Order_By>;
  latest_review_created_at?: InputMaybe<Order_By>;
  latest_review_display_name?: InputMaybe<Order_By>;
  latest_review_id?: InputMaybe<Order_By>;
  latest_review_is_seller?: InputMaybe<Order_By>;
  latest_review_rating?: InputMaybe<Order_By>;
  latest_review_transaction_id?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  median_sales_price?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  reviews_count?: InputMaybe<Order_By>;
  sales_count?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "agencies" */
export enum Agencies_Select_Column {
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  AvgRating = 'avg_rating',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  Id = 'id',
  /** column name */
  LatestReviewComment = 'latest_review_comment',
  /** column name */
  LatestReviewCreatedAt = 'latest_review_created_at',
  /** column name */
  LatestReviewDisplayName = 'latest_review_display_name',
  /** column name */
  LatestReviewId = 'latest_review_id',
  /** column name */
  LatestReviewIsSeller = 'latest_review_is_seller',
  /** column name */
  LatestReviewRating = 'latest_review_rating',
  /** column name */
  LatestReviewTransactionId = 'latest_review_transaction_id',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MedianSalesPrice = 'median_sales_price',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  ReviewsCount = 'reviews_count',
  /** column name */
  SalesCount = 'sales_count',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "agencies" */
export type Agencies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agencies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agencies_Stream_Cursor_Value_Input = {
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  avg_rating?: InputMaybe<Scalars['numeric']['input']>;
  centroid?: InputMaybe<Scalars['geometry']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  latest_review_comment?: InputMaybe<Scalars['String']['input']>;
  latest_review_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  latest_review_display_name?: InputMaybe<Scalars['String']['input']>;
  latest_review_id?: InputMaybe<Scalars['uuid']['input']>;
  latest_review_is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  latest_review_rating?: InputMaybe<Scalars['Int']['input']>;
  latest_review_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  median_sales_price?: InputMaybe<Scalars['float8']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reviews_count?: InputMaybe<Scalars['bigint']['input']>;
  sales_count?: InputMaybe<Scalars['bigint']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Agent_Ranking_Places_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Agent_Ranking_Properties_Args = {
  dedupe_by_team?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['String']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Agent_Statistics_Args = {
  filters?: InputMaybe<Scalars['json']['input']>;
};

/** Shape of the rows the function agent_statistics returns, one per agent: leads assigned and claimed, calls, visits, mandates, offers, transactions and commission over a period. The table itself holds no row: call the function, with filters such as date_gte and date_lt, and teamId_in or brokerId_in as comma-separated ids. */
export type Agent_Stats = {
  assigned_leads?: Maybe<Scalars['Int']['output']>;
  call_attempts?: Maybe<Scalars['Int']['output']>;
  call_attempts_missed?: Maybe<Scalars['Int']['output']>;
  call_attempts_successful?: Maybe<Scalars['Int']['output']>;
  claimed_leads?: Maybe<Scalars['Int']['output']>;
  gross_commission?: Maybe<Scalars['float8']['output']>;
  mandates_published?: Maybe<Scalars['Int']['output']>;
  mandates_signed?: Maybe<Scalars['Int']['output']>;
  offers_accepted?: Maybe<Scalars['Int']['output']>;
  offers_made?: Maybe<Scalars['Int']['output']>;
  offers_refused?: Maybe<Scalars['Int']['output']>;
  tenant_id: Scalars['uuid']['output'];
  transactions_closed?: Maybe<Scalars['Int']['output']>;
  transactions_volume?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  visits_booked?: Maybe<Scalars['Int']['output']>;
  visits_completed?: Maybe<Scalars['Int']['output']>;
  visits_planned?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "agent_stats". All fields are combined with a logical 'AND'. */
export type Agent_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Agent_Stats_Bool_Exp>>;
  _not?: InputMaybe<Agent_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Agent_Stats_Bool_Exp>>;
  assigned_leads?: InputMaybe<Int_Comparison_Exp>;
  call_attempts?: InputMaybe<Int_Comparison_Exp>;
  call_attempts_missed?: InputMaybe<Int_Comparison_Exp>;
  call_attempts_successful?: InputMaybe<Int_Comparison_Exp>;
  claimed_leads?: InputMaybe<Int_Comparison_Exp>;
  gross_commission?: InputMaybe<Float8_Comparison_Exp>;
  mandates_published?: InputMaybe<Int_Comparison_Exp>;
  mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  offers_accepted?: InputMaybe<Int_Comparison_Exp>;
  offers_made?: InputMaybe<Int_Comparison_Exp>;
  offers_refused?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  transactions_closed?: InputMaybe<Int_Comparison_Exp>;
  transactions_volume?: InputMaybe<Float8_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  visits_booked?: InputMaybe<Int_Comparison_Exp>;
  visits_completed?: InputMaybe<Int_Comparison_Exp>;
  visits_planned?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "agent_stats". */
export type Agent_Stats_Order_By = {
  assigned_leads?: InputMaybe<Order_By>;
  call_attempts?: InputMaybe<Order_By>;
  call_attempts_missed?: InputMaybe<Order_By>;
  call_attempts_successful?: InputMaybe<Order_By>;
  claimed_leads?: InputMaybe<Order_By>;
  gross_commission?: InputMaybe<Order_By>;
  mandates_published?: InputMaybe<Order_By>;
  mandates_signed?: InputMaybe<Order_By>;
  offers_accepted?: InputMaybe<Order_By>;
  offers_made?: InputMaybe<Order_By>;
  offers_refused?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transactions_closed?: InputMaybe<Order_By>;
  transactions_volume?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  visits_booked?: InputMaybe<Order_By>;
  visits_completed?: InputMaybe<Order_By>;
  visits_planned?: InputMaybe<Order_By>;
};

/** select columns of table "agent_stats" */
export enum Agent_Stats_Select_Column {
  /** column name */
  AssignedLeads = 'assigned_leads',
  /** column name */
  CallAttempts = 'call_attempts',
  /** column name */
  CallAttemptsMissed = 'call_attempts_missed',
  /** column name */
  CallAttemptsSuccessful = 'call_attempts_successful',
  /** column name */
  ClaimedLeads = 'claimed_leads',
  /** column name */
  GrossCommission = 'gross_commission',
  /** column name */
  MandatesPublished = 'mandates_published',
  /** column name */
  MandatesSigned = 'mandates_signed',
  /** column name */
  OffersAccepted = 'offers_accepted',
  /** column name */
  OffersMade = 'offers_made',
  /** column name */
  OffersRefused = 'offers_refused',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionsClosed = 'transactions_closed',
  /** column name */
  TransactionsVolume = 'transactions_volume',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VisitsBooked = 'visits_booked',
  /** column name */
  VisitsCompleted = 'visits_completed',
  /** column name */
  VisitsPlanned = 'visits_planned'
}

/** Streaming cursor of the table "agent_stats" */
export type Agent_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agent_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agent_Stats_Stream_Cursor_Value_Input = {
  assigned_leads?: InputMaybe<Scalars['Int']['input']>;
  call_attempts?: InputMaybe<Scalars['Int']['input']>;
  call_attempts_missed?: InputMaybe<Scalars['Int']['input']>;
  call_attempts_successful?: InputMaybe<Scalars['Int']['input']>;
  claimed_leads?: InputMaybe<Scalars['Int']['input']>;
  gross_commission?: InputMaybe<Scalars['float8']['input']>;
  mandates_published?: InputMaybe<Scalars['Int']['input']>;
  mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  offers_accepted?: InputMaybe<Scalars['Int']['input']>;
  offers_made?: InputMaybe<Scalars['Int']['input']>;
  offers_refused?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transactions_closed?: InputMaybe<Scalars['Int']['input']>;
  transactions_volume?: InputMaybe<Scalars['float8']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  visits_booked?: InputMaybe<Scalars['Int']['input']>;
  visits_completed?: InputMaybe<Scalars['Int']['input']>;
  visits_planned?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "agents" */
export type Agents = {
  agency_slug?: Maybe<Scalars['String']['output']>;
  agent_slug?: Maybe<Scalars['String']['output']>;
  avg_rating?: Maybe<Scalars['numeric']['output']>;
  centroid?: Maybe<Scalars['geometry']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_name?: Maybe<Scalars['String']['output']>;
  latest_review_comment?: Maybe<Scalars['String']['output']>;
  latest_review_created_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_review_display_name?: Maybe<Scalars['String']['output']>;
  latest_review_id?: Maybe<Scalars['uuid']['output']>;
  latest_review_is_seller?: Maybe<Scalars['Boolean']['output']>;
  latest_review_rating?: Maybe<Scalars['Int']['output']>;
  latest_review_transaction_id?: Maybe<Scalars['uuid']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  median_sales_price?: Maybe<Scalars['float8']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  reviews_count?: Maybe<Scalars['bigint']['output']>;
  sales_count?: Maybe<Scalars['bigint']['output']>;
  team_avg_rating?: Maybe<Scalars['numeric']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  team_reviews_count?: Maybe<Scalars['bigint']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "agents". All fields are combined with a logical 'AND'. */
export type Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Agents_Bool_Exp>>;
  _not?: InputMaybe<Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Agents_Bool_Exp>>;
  agency_slug?: InputMaybe<String_Comparison_Exp>;
  agent_slug?: InputMaybe<String_Comparison_Exp>;
  avg_rating?: InputMaybe<Numeric_Comparison_Exp>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  languages?: InputMaybe<String_Array_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  latest_review_comment?: InputMaybe<String_Comparison_Exp>;
  latest_review_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  latest_review_display_name?: InputMaybe<String_Comparison_Exp>;
  latest_review_id?: InputMaybe<Uuid_Comparison_Exp>;
  latest_review_is_seller?: InputMaybe<Boolean_Comparison_Exp>;
  latest_review_rating?: InputMaybe<Int_Comparison_Exp>;
  latest_review_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  median_sales_price?: InputMaybe<Float8_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  reviews_count?: InputMaybe<Bigint_Comparison_Exp>;
  sales_count?: InputMaybe<Bigint_Comparison_Exp>;
  team_avg_rating?: InputMaybe<Numeric_Comparison_Exp>;
  team_name?: InputMaybe<String_Comparison_Exp>;
  team_reviews_count?: InputMaybe<Bigint_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "agents". */
export type Agents_Order_By = {
  agency_slug?: InputMaybe<Order_By>;
  agent_slug?: InputMaybe<Order_By>;
  avg_rating?: InputMaybe<Order_By>;
  centroid?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  latest_review_comment?: InputMaybe<Order_By>;
  latest_review_created_at?: InputMaybe<Order_By>;
  latest_review_display_name?: InputMaybe<Order_By>;
  latest_review_id?: InputMaybe<Order_By>;
  latest_review_is_seller?: InputMaybe<Order_By>;
  latest_review_rating?: InputMaybe<Order_By>;
  latest_review_transaction_id?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  median_sales_price?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  reviews_count?: InputMaybe<Order_By>;
  sales_count?: InputMaybe<Order_By>;
  team_avg_rating?: InputMaybe<Order_By>;
  team_name?: InputMaybe<Order_By>;
  team_reviews_count?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** Shape of the rows the functions get_agents_ranking and places_agent_ranking return: an agent (user_id -> users) with transaction counts around a location. The table itself holds no row: call a function. */
export type Agents_Rankings = {
  distance?: Maybe<Scalars['float8']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount: Scalars['Int']['output'];
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  total_transactions: Scalars['Int']['output'];
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['uuid']['output'];
};

export type Agents_Rankings_Aggregate = {
  aggregate?: Maybe<Agents_Rankings_Aggregate_Fields>;
  nodes: Array<Agents_Rankings>;
};

/** aggregate fields of "agents_rankings" */
export type Agents_Rankings_Aggregate_Fields = {
  avg?: Maybe<Agents_Rankings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Agents_Rankings_Max_Fields>;
  min?: Maybe<Agents_Rankings_Min_Fields>;
  stddev?: Maybe<Agents_Rankings_Stddev_Fields>;
  stddev_pop?: Maybe<Agents_Rankings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Agents_Rankings_Stddev_Samp_Fields>;
  sum?: Maybe<Agents_Rankings_Sum_Fields>;
  var_pop?: Maybe<Agents_Rankings_Var_Pop_Fields>;
  var_samp?: Maybe<Agents_Rankings_Var_Samp_Fields>;
  variance?: Maybe<Agents_Rankings_Variance_Fields>;
};


/** aggregate fields of "agents_rankings" */
export type Agents_Rankings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Agents_Rankings_Avg_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "agents_rankings". All fields are combined with a logical 'AND'. */
export type Agents_Rankings_Bool_Exp = {
  _and?: InputMaybe<Array<Agents_Rankings_Bool_Exp>>;
  _not?: InputMaybe<Agents_Rankings_Bool_Exp>;
  _or?: InputMaybe<Array<Agents_Rankings_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  nearby_radius_km?: InputMaybe<Float8_Comparison_Exp>;
  nearby_transaction_count?: InputMaybe<Int_Comparison_Exp>;
  payment_amount?: InputMaybe<Int_Comparison_Exp>;
  subscription_status?: InputMaybe<Subscription_Status_Comparison_Exp>;
  total_transactions?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_district?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_location?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_municipality?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_radius?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_state?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Agents_Rankings_Max_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Agents_Rankings_Min_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "agents_rankings". */
export type Agents_Rankings_Order_By = {
  distance?: InputMaybe<Order_By>;
  nearby_radius_km?: InputMaybe<Order_By>;
  nearby_transaction_count?: InputMaybe<Order_By>;
  payment_amount?: InputMaybe<Order_By>;
  subscription_status?: InputMaybe<Order_By>;
  total_transactions?: InputMaybe<Order_By>;
  transactions_in_district?: InputMaybe<Order_By>;
  transactions_in_location?: InputMaybe<Order_By>;
  transactions_in_municipality?: InputMaybe<Order_By>;
  transactions_in_radius?: InputMaybe<Order_By>;
  transactions_in_state?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "agents_rankings" */
export enum Agents_Rankings_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  NearbyRadiusKm = 'nearby_radius_km',
  /** column name */
  NearbyTransactionCount = 'nearby_transaction_count',
  /** column name */
  PaymentAmount = 'payment_amount',
  /** column name */
  SubscriptionStatus = 'subscription_status',
  /** column name */
  TotalTransactions = 'total_transactions',
  /** column name */
  TransactionsInDistrict = 'transactions_in_district',
  /** column name */
  TransactionsInLocation = 'transactions_in_location',
  /** column name */
  TransactionsInMunicipality = 'transactions_in_municipality',
  /** column name */
  TransactionsInRadius = 'transactions_in_radius',
  /** column name */
  TransactionsInState = 'transactions_in_state',
  /** column name */
  UserId = 'user_id'
}

/** aggregate stddev on columns */
export type Agents_Rankings_Stddev_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Agents_Rankings_Stddev_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Agents_Rankings_Stddev_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Agents_Rankings_Sum_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Agents_Rankings_Var_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Agents_Rankings_Var_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Agents_Rankings_Variance_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "agents" */
export enum Agents_Select_Column {
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AvgRating = 'avg_rating',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Id = 'id',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LatestReviewComment = 'latest_review_comment',
  /** column name */
  LatestReviewCreatedAt = 'latest_review_created_at',
  /** column name */
  LatestReviewDisplayName = 'latest_review_display_name',
  /** column name */
  LatestReviewId = 'latest_review_id',
  /** column name */
  LatestReviewIsSeller = 'latest_review_is_seller',
  /** column name */
  LatestReviewRating = 'latest_review_rating',
  /** column name */
  LatestReviewTransactionId = 'latest_review_transaction_id',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MedianSalesPrice = 'median_sales_price',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  ReviewsCount = 'reviews_count',
  /** column name */
  SalesCount = 'sales_count',
  /** column name */
  TeamAvgRating = 'team_avg_rating',
  /** column name */
  TeamName = 'team_name',
  /** column name */
  TeamReviewsCount = 'team_reviews_count',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "agents" */
export type Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Agents_Stream_Cursor_Value_Input = {
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  agent_slug?: InputMaybe<Scalars['String']['input']>;
  avg_rating?: InputMaybe<Scalars['numeric']['input']>;
  centroid?: InputMaybe<Scalars['geometry']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  latest_review_comment?: InputMaybe<Scalars['String']['input']>;
  latest_review_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  latest_review_display_name?: InputMaybe<Scalars['String']['input']>;
  latest_review_id?: InputMaybe<Scalars['uuid']['input']>;
  latest_review_is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  latest_review_rating?: InputMaybe<Scalars['Int']['input']>;
  latest_review_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  median_sales_price?: InputMaybe<Scalars['float8']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  reviews_count?: InputMaybe<Scalars['bigint']['input']>;
  sales_count?: InputMaybe<Scalars['bigint']['input']>;
  team_avg_rating?: InputMaybe<Scalars['numeric']['input']>;
  team_name?: InputMaybe<Scalars['String']['input']>;
  team_reviews_count?: InputMaybe<Scalars['bigint']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "api_keys" */
export type Api_Keys = {
  access_level: Scalars['String']['output'];
  /** An array relationship */
  api_keys_teams: Array<Api_Keys_Teams>;
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  /** An object relationship */
  creator: Users;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  key_prefix: Scalars['String']['output'];
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  name: Scalars['String']['output'];
  /** An object relationship */
  owner: Users;
  owner_user_id: Scalars['uuid']['output'];
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  revoked_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  revoker?: Maybe<Users>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
};


/** columns and relationships of "api_keys" */
export type Api_KeysApi_Keys_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Teams_Order_By>>;
  where?: InputMaybe<Api_Keys_Teams_Bool_Exp>;
};

/** aggregated selection of "api_keys" */
export type Api_Keys_Aggregate = {
  aggregate?: Maybe<Api_Keys_Aggregate_Fields>;
  nodes: Array<Api_Keys>;
};

/** aggregate fields of "api_keys" */
export type Api_Keys_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Api_Keys_Max_Fields>;
  min?: Maybe<Api_Keys_Min_Fields>;
};


/** aggregate fields of "api_keys" */
export type Api_Keys_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Api_Keys_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "api_keys". All fields are combined with a logical 'AND'. */
export type Api_Keys_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Keys_Bool_Exp>>;
  _not?: InputMaybe<Api_Keys_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Keys_Bool_Exp>>;
  access_level?: InputMaybe<String_Comparison_Exp>;
  api_keys_teams?: InputMaybe<Api_Keys_Teams_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  expires_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key_prefix?: InputMaybe<String_Comparison_Exp>;
  last_used_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<Users_Bool_Exp>;
  owner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  revoked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  revoked_by?: InputMaybe<Uuid_Comparison_Exp>;
  revoker?: InputMaybe<Users_Bool_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Api_Keys_Max_Fields = {
  access_level?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key_prefix?: Maybe<Scalars['String']['output']>;
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['uuid']['output']>;
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  revoked_by?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Api_Keys_Min_Fields = {
  access_level?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  expires_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key_prefix?: Maybe<Scalars['String']['output']>;
  last_used_at?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owner_user_id?: Maybe<Scalars['uuid']['output']>;
  revoked_at?: Maybe<Scalars['timestamptz']['output']>;
  revoked_by?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "api_keys". */
export type Api_Keys_Order_By = {
  access_level?: InputMaybe<Order_By>;
  api_keys_teams_aggregate?: InputMaybe<Api_Keys_Teams_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  expires_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key_prefix?: InputMaybe<Order_By>;
  last_used_at?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Users_Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  revoked_at?: InputMaybe<Order_By>;
  revoked_by?: InputMaybe<Order_By>;
  revoker?: InputMaybe<Users_Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "api_keys" */
export enum Api_Keys_Select_Column {
  /** column name */
  AccessLevel = 'access_level',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  KeyPrefix = 'key_prefix',
  /** column name */
  LastUsedAt = 'last_used_at',
  /** column name */
  Name = 'name',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  RevokedAt = 'revoked_at',
  /** column name */
  RevokedBy = 'revoked_by',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "api_keys" */
export type Api_Keys_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Api_Keys_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Api_Keys_Stream_Cursor_Value_Input = {
  access_level?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  expires_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key_prefix?: InputMaybe<Scalars['String']['input']>;
  last_used_at?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  revoked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  revoked_by?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "api_keys_teams" */
export type Api_Keys_Teams = {
  /** An object relationship */
  api_key: Api_Keys;
  api_key_id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "api_keys_teams" */
export type Api_Keys_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Api_Keys_Teams_Max_Order_By>;
  min?: InputMaybe<Api_Keys_Teams_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "api_keys_teams". All fields are combined with a logical 'AND'. */
export type Api_Keys_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Api_Keys_Teams_Bool_Exp>>;
  _not?: InputMaybe<Api_Keys_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Api_Keys_Teams_Bool_Exp>>;
  api_key?: InputMaybe<Api_Keys_Bool_Exp>;
  api_key_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "api_keys_teams" */
export type Api_Keys_Teams_Max_Order_By = {
  api_key_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "api_keys_teams" */
export type Api_Keys_Teams_Min_Order_By = {
  api_key_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "api_keys_teams". */
export type Api_Keys_Teams_Order_By = {
  api_key?: InputMaybe<Api_Keys_Order_By>;
  api_key_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** select columns of table "api_keys_teams" */
export enum Api_Keys_Teams_Select_Column {
  /** column name */
  ApiKeyId = 'api_key_id',
  /** column name */
  TeamId = 'team_id'
}

/** Streaming cursor of the table "api_keys_teams" */
export type Api_Keys_Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Api_Keys_Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Api_Keys_Teams_Stream_Cursor_Value_Input = {
  api_key_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Apply_Notification_Channels_To_Existing_Users_Args = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  setting_type?: InputMaybe<Scalars['String']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Valuation estimates of a property (property_id -> properties): value with min and max for a sale, rent_value with rent_min and rent_max for a rent, next to the description of the property they were computed from. A property gets a row per valuation run; properties.latest_appraisal_id is the current one, so the estimate of a lead is leads.property -> latest_appraisal. Very large: read it through a property. */
export type Appraisals = {
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  building_condition?: Maybe<Scalars['Float']['output']>;
  building_standard?: Maybe<Scalars['Float']['output']>;
  building_volume?: Maybe<Scalars['Float']['output']>;
  building_volume_norm?: Maybe<Scalars['String']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  ctn?: Maybe<Scalars['String']['output']>;
  flat_condition?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  iazi_address_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_luxury?: Maybe<Scalars['Boolean']['output']>;
  is_maisonette?: Maybe<Scalars['Boolean']['output']>;
  is_pending: Scalars['Boolean']['output'];
  is_secondary_residence?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  micro_location?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  minergie_code?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  number_of_flats?: Maybe<Scalars['Int']['output']>;
  number_of_floors?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_lifts?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Int']['output']>;
  plot_has_constructible_reserve?: Maybe<Scalars['Boolean']['output']>;
  plot_is_constructible?: Maybe<Scalars['Boolean']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  price_per_land_surface_meter_squared?: Maybe<Scalars['Float']['output']>;
  price_per_living_surface_meter_squared?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  property?: Maybe<Properties>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
  property_volume?: Maybe<Scalars['Float']['output']>;
  property_volume_norm?: Maybe<Scalars['String']['output']>;
  relevant_servitudes?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_max?: Maybe<Scalars['Float']['output']>;
  rent_min?: Maybe<Scalars['Float']['output']>;
  rent_value?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  share_of_ownership?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  valuations: Array<Valuations>;
  value?: Maybe<Scalars['Float']['output']>;
};


/** Valuation estimates of a property (property_id -> properties): value with min and max for a sale, rent_value with rent_min and rent_max for a rent, next to the description of the property they were computed from. A property gets a row per valuation run; properties.latest_appraisal_id is the current one, so the estimate of a lead is leads.property -> latest_appraisal. Very large: read it through a property. */
export type AppraisalsValuationsArgs = {
  distinct_on?: InputMaybe<Array<Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuations_Order_By>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};

/** order by aggregate values of table "appraisals" */
export type Appraisals_Aggregate_Order_By = {
  avg?: InputMaybe<Appraisals_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Appraisals_Max_Order_By>;
  min?: InputMaybe<Appraisals_Min_Order_By>;
  stddev?: InputMaybe<Appraisals_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Appraisals_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Appraisals_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Appraisals_Sum_Order_By>;
  var_pop?: InputMaybe<Appraisals_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Appraisals_Var_Samp_Order_By>;
  variance?: InputMaybe<Appraisals_Variance_Order_By>;
};

/** order by avg() on columns of table "appraisals" */
export type Appraisals_Avg_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "appraisals". All fields are combined with a logical 'AND'. */
export type Appraisals_Bool_Exp = {
  _and?: InputMaybe<Array<Appraisals_Bool_Exp>>;
  _not?: InputMaybe<Appraisals_Bool_Exp>;
  _or?: InputMaybe<Array<Appraisals_Bool_Exp>>;
  appraisal_perceived_value?: InputMaybe<Float_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  building_condition?: InputMaybe<Float_Comparison_Exp>;
  building_standard?: InputMaybe<Float_Comparison_Exp>;
  building_volume?: InputMaybe<Float_Comparison_Exp>;
  building_volume_norm?: InputMaybe<String_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ctn?: InputMaybe<String_Comparison_Exp>;
  flat_condition?: InputMaybe<Float_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  iazi_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_luxury?: InputMaybe<Boolean_Comparison_Exp>;
  is_maisonette?: InputMaybe<Boolean_Comparison_Exp>;
  is_pending?: InputMaybe<Boolean_Comparison_Exp>;
  is_secondary_residence?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  max?: InputMaybe<Float_Comparison_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  micro_location?: InputMaybe<Float_Comparison_Exp>;
  min?: InputMaybe<Float_Comparison_Exp>;
  minergie_code?: InputMaybe<Int_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_flats?: InputMaybe<Int_Comparison_Exp>;
  number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_lifts?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Int_Comparison_Exp>;
  plot_has_constructible_reserve?: InputMaybe<Boolean_Comparison_Exp>;
  plot_is_constructible?: InputMaybe<Boolean_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_per_land_surface_meter_squared?: InputMaybe<Float_Comparison_Exp>;
  price_per_living_surface_meter_squared?: InputMaybe<Float_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_volume?: InputMaybe<Float_Comparison_Exp>;
  property_volume_norm?: InputMaybe<String_Comparison_Exp>;
  relevant_servitudes?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_max?: InputMaybe<Float_Comparison_Exp>;
  rent_min?: InputMaybe<Float_Comparison_Exp>;
  rent_value?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  share_of_ownership?: InputMaybe<Float_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  valuations?: InputMaybe<Valuations_Bool_Exp>;
  value?: InputMaybe<Float_Comparison_Exp>;
};

/** order by max() on columns of table "appraisals" */
export type Appraisals_Max_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  property_volume_norm?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "appraisals" */
export type Appraisals_Min_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  property_volume_norm?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "appraisals". */
export type Appraisals_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_luxury?: InputMaybe<Order_By>;
  is_maisonette?: InputMaybe<Order_By>;
  is_pending?: InputMaybe<Order_By>;
  is_secondary_residence?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  plot_has_constructible_reserve?: InputMaybe<Order_By>;
  plot_is_constructible?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  property_volume_norm?: InputMaybe<Order_By>;
  relevant_servitudes?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  valuations_aggregate?: InputMaybe<Valuations_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "appraisals_public_view" */
export type Appraisals_Public_View = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  price_per_living_surface_meter_squared?: Maybe<Scalars['Float']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "appraisals_public_view". All fields are combined with a logical 'AND'. */
export type Appraisals_Public_View_Bool_Exp = {
  _and?: InputMaybe<Array<Appraisals_Public_View_Bool_Exp>>;
  _not?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
  _or?: InputMaybe<Array<Appraisals_Public_View_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_per_living_surface_meter_squared?: InputMaybe<Float_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "appraisals_public_view". */
export type Appraisals_Public_View_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "appraisals_public_view" */
export enum Appraisals_Public_View_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  Route = 'route',
  /** column name */
  TenantId = 'tenant_id'
}

/** select columns of table "appraisals" */
export enum Appraisals_Select_Column {
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsPending = 'is_pending',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Max = 'max',
  /** column name */
  Method = 'method',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  Min = 'min',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PricePerLandSurfaceMeterSquared = 'price_per_land_surface_meter_squared',
  /** column name */
  PricePerLivingSurfaceMeterSquared = 'price_per_living_surface_meter_squared',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  PropertyVolume = 'property_volume',
  /** column name */
  PropertyVolumeNorm = 'property_volume_norm',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentMax = 'rent_max',
  /** column name */
  RentMin = 'rent_min',
  /** column name */
  RentValue = 'rent_value',
  /** column name */
  Route = 'route',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** order by stddev() on columns of table "appraisals" */
export type Appraisals_Stddev_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "appraisals" */
export type Appraisals_Stddev_Pop_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "appraisals" */
export type Appraisals_Stddev_Samp_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "appraisals" */
export type Appraisals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Appraisals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Appraisals_Stream_Cursor_Value_Input = {
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_pending?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  price_per_land_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  price_per_living_surface_meter_squared?: InputMaybe<Scalars['Float']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  property_volume?: InputMaybe<Scalars['Float']['input']>;
  property_volume_norm?: InputMaybe<Scalars['String']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  rent_max?: InputMaybe<Scalars['Float']['input']>;
  rent_min?: InputMaybe<Scalars['Float']['input']>;
  rent_value?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "appraisals" */
export type Appraisals_Sum_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "appraisals" */
export type Appraisals_Var_Pop_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "appraisals" */
export type Appraisals_Var_Samp_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "appraisals" */
export type Appraisals_Variance_Order_By = {
  appraisal_perceived_value?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  price_per_land_surface_meter_squared?: InputMaybe<Order_By>;
  price_per_living_surface_meter_squared?: InputMaybe<Order_By>;
  property_volume?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_max?: InputMaybe<Order_By>;
  rent_min?: InputMaybe<Order_By>;
  rent_value?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** columns and relationships of "available_email_templates" */
export type Available_Email_Templates = {
  value?: Maybe<Scalars['email_template']['output']>;
};

/** Boolean expression to filter rows from the table "available_email_templates". All fields are combined with a logical 'AND'. */
export type Available_Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Available_Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Available_Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Available_Email_Templates_Bool_Exp>>;
  value?: InputMaybe<Email_Template_Comparison_Exp>;
};

/** Ordering options when selecting data from "available_email_templates". */
export type Available_Email_Templates_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** select columns of table "available_email_templates" */
export enum Available_Email_Templates_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "available_email_templates" */
export type Available_Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Available_Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Available_Email_Templates_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['email_template']['input']>;
};

/** columns and relationships of "bed_type_enum" */
export type Bed_Type_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "bed_type_enum". All fields are combined with a logical 'AND'. */
export type Bed_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Bed_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Bed_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Bed_Type_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Bed_Type_Enum_Enum {
  /** Double bed */
  Double = 'double',
  /** No bed */
  None = 'none',
  /** Separate beds */
  SeparateBeds = 'separate_beds',
  /** Single bed */
  Single = 'single'
}

/** Boolean expression to compare columns of type "bed_type_enum_enum". All fields are combined with logical 'AND'. */
export type Bed_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Bed_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Bed_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Bed_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Bed_Type_Enum_Enum>>;
};

/** Ordering options when selecting data from "bed_type_enum". */
export type Bed_Type_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "bed_type_enum" */
export enum Bed_Type_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "bed_type_enum" */
export type Bed_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bed_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bed_Type_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** Boolean expression to compare columns of type "bit". All fields are combined with logical 'AND'. */
export type Bit_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bit']['input']>;
  _gt?: InputMaybe<Scalars['bit']['input']>;
  _gte?: InputMaybe<Scalars['bit']['input']>;
  _in?: InputMaybe<Array<Scalars['bit']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bit']['input']>;
  _lte?: InputMaybe<Scalars['bit']['input']>;
  _neq?: InputMaybe<Scalars['bit']['input']>;
  _nin?: InputMaybe<Array<Scalars['bit']['input']>>;
};

export type Bulk_Reassign_User_Account_Manager_Args = {
  new_account_manager_id?: InputMaybe<Scalars['uuid']['input']>;
  selected_users?: InputMaybe<Scalars['jsonb']['input']>;
  transfer_open_activities?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A buyer (user_id -> users) interested in one listing (lot_id -> lots), at a pipeline stage (stage_id -> lead_stages). Seller leads are in leads, not here. Won or lost can show on status or on the stage's status: check both. */
export type Buyer_Leads = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  financial_approval?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** True when the buyer_lead was created via the MLS path (creator does not share any team with the lot broker, and the lot is MLS-shared). Computed by the auto_set_buyer_lead_is_mls trigger at INSERT. */
  is_mls: Scalars['Boolean']['output'];
  /** An object relationship */
  lead_stage?: Maybe<Lead_Stages>;
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  /** An object relationship */
  mls_lot?: Maybe<Mls_Lots>;
  /** An object relationship */
  mls_share?: Maybe<Mls_Shares>;
  /** MLS share context - null for owner data, set for MLS publication data */
  mls_share_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  mls_user?: Maybe<Users_View>;
  order_nr: Scalars['Int']['output'];
  source?: Maybe<Scalars['String']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  status: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  user_order_nr: Scalars['Int']['output'];
};


/** A buyer (user_id -> users) interested in one listing (lot_id -> lots), at a pipeline stage (stage_id -> lead_stages). Seller leads are in leads, not here. Won or lost can show on status or on the stage's status: check both. */
export type Buyer_LeadsActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** A buyer (user_id -> users) interested in one listing (lot_id -> lots), at a pipeline stage (stage_id -> lead_stages). Seller leads are in leads, not here. Won or lost can show on status or on the stage's status: check both. */
export type Buyer_LeadsActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};

/** aggregated selection of "buyer_leads" */
export type Buyer_Leads_Aggregate = {
  aggregate?: Maybe<Buyer_Leads_Aggregate_Fields>;
  nodes: Array<Buyer_Leads>;
};

export type Buyer_Leads_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp_Count>;
};

export type Buyer_Leads_Aggregate_Bool_Exp_Bool_And = {
  arguments: Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Buyer_Leads_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Buyer_Leads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Buyer_Leads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "buyer_leads" */
export type Buyer_Leads_Aggregate_Fields = {
  avg?: Maybe<Buyer_Leads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buyer_Leads_Max_Fields>;
  min?: Maybe<Buyer_Leads_Min_Fields>;
  stddev?: Maybe<Buyer_Leads_Stddev_Fields>;
  stddev_pop?: Maybe<Buyer_Leads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Buyer_Leads_Stddev_Samp_Fields>;
  sum?: Maybe<Buyer_Leads_Sum_Fields>;
  var_pop?: Maybe<Buyer_Leads_Var_Pop_Fields>;
  var_samp?: Maybe<Buyer_Leads_Var_Samp_Fields>;
  variance?: Maybe<Buyer_Leads_Variance_Fields>;
};


/** aggregate fields of "buyer_leads" */
export type Buyer_Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "buyer_leads" */
export type Buyer_Leads_Aggregate_Order_By = {
  avg?: InputMaybe<Buyer_Leads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Buyer_Leads_Max_Order_By>;
  min?: InputMaybe<Buyer_Leads_Min_Order_By>;
  stddev?: InputMaybe<Buyer_Leads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Buyer_Leads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Buyer_Leads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Buyer_Leads_Sum_Order_By>;
  var_pop?: InputMaybe<Buyer_Leads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Buyer_Leads_Var_Samp_Order_By>;
  variance?: InputMaybe<Buyer_Leads_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "buyer_leads" */
export type Buyer_Leads_Arr_Rel_Insert_Input = {
  data: Array<Buyer_Leads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};

/** aggregate avg on columns */
export type Buyer_Leads_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "buyer_leads" */
export type Buyer_Leads_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "buyer_leads". All fields are combined with a logical 'AND'. */
export type Buyer_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Buyer_Leads_Bool_Exp>>;
  _not?: InputMaybe<Buyer_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Buyer_Leads_Bool_Exp>>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  financial_approval?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_mls?: InputMaybe<Boolean_Comparison_Exp>;
  lead_stage?: InputMaybe<Lead_Stages_Bool_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  mls_lot?: InputMaybe<Mls_Lots_Bool_Exp>;
  mls_share?: InputMaybe<Mls_Shares_Bool_Exp>;
  mls_share_id?: InputMaybe<Uuid_Comparison_Exp>;
  mls_user?: InputMaybe<Users_View_Bool_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_order_nr?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "buyer_leads" */
export enum Buyer_Leads_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  BuyerLeadsIdTenantIdUnique = 'buyer_leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  BuyerLeadsLotIdUserIdUnique = 'buyer_leads_lot_id_user_id_unique',
  /** unique or primary key constraint on columns "id" */
  BuyerLeadsPkey = 'buyer_leads_pkey'
}

/** input type for incrementing numeric columns in table "buyer_leads" */
export type Buyer_Leads_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "buyer_leads" */
export type Buyer_Leads_Insert_Input = {
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<Lead_Stages_Obj_Rel_Insert_Input>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  mls_share?: InputMaybe<Mls_Shares_Obj_Rel_Insert_Input>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Buyer_Leads_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** MLS share context - null for owner data, set for MLS publication data */
  mls_share_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "buyer_leads" */
export type Buyer_Leads_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  /** MLS share context - null for owner data, set for MLS publication data */
  mls_share_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Buyer_Leads_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** MLS share context - null for owner data, set for MLS publication data */
  mls_share_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "buyer_leads" */
export type Buyer_Leads_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  /** MLS share context - null for owner data, set for MLS publication data */
  mls_share_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "buyer_leads" */
export type Buyer_Leads_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buyer_Leads>;
};

/** input type for inserting object relation for remote table "buyer_leads" */
export type Buyer_Leads_Obj_Rel_Insert_Input = {
  data: Buyer_Leads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};

/** on_conflict condition type for table "buyer_leads" */
export type Buyer_Leads_On_Conflict = {
  constraint: Buyer_Leads_Constraint;
  update_columns?: Array<Buyer_Leads_Update_Column>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};

/** Ordering options when selecting data from "buyer_leads". */
export type Buyer_Leads_Order_By = {
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  financial_approval?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_mls?: InputMaybe<Order_By>;
  lead_stage?: InputMaybe<Lead_Stages_Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  mls_lot?: InputMaybe<Mls_Lots_Order_By>;
  mls_share?: InputMaybe<Mls_Shares_Order_By>;
  mls_share_id?: InputMaybe<Order_By>;
  mls_user?: InputMaybe<Users_View_Order_By>;
  order_nr?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** primary key columns input for table: buyer_leads */
export type Buyer_Leads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "buyer_leads" */
export enum Buyer_Leads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  IsMls = 'is_mls',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MlsShareId = 'mls_share_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

/** select "buyer_leads_aggregate_bool_exp_bool_and_arguments_columns" columns of table "buyer_leads" */
export enum Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  IsMls = 'is_mls'
}

/** select "buyer_leads_aggregate_bool_exp_bool_or_arguments_columns" columns of table "buyer_leads" */
export enum Buyer_Leads_Select_Column_Buyer_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  IsMls = 'is_mls'
}

/** input type for updating data in table "buyer_leads" */
export type Buyer_Leads_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  financial_approval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Buyer_Leads_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "buyer_leads" */
export type Buyer_Leads_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Buyer_Leads_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "buyer_leads" */
export type Buyer_Leads_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Buyer_Leads_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "buyer_leads" */
export type Buyer_Leads_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "buyer_leads" */
export type Buyer_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Buyer_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Buyer_Leads_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  financial_approval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** True when the buyer_lead was created via the MLS path (creator does not share any team with the lot broker, and the lot is MLS-shared). Computed by the auto_set_buyer_lead_is_mls trigger at INSERT. */
  is_mls?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  /** MLS share context - null for owner data, set for MLS publication data */
  mls_share_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Buyer_Leads_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
  user_order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "buyer_leads" */
export type Buyer_Leads_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "buyer_leads" */
export enum Buyer_Leads_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FinancialApproval = 'financial_approval',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserOrderNr = 'user_order_nr'
}

export type Buyer_Leads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buyer_Leads_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buyer_Leads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Buyer_Leads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Buyer_Leads_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "buyer_leads" */
export type Buyer_Leads_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Buyer_Leads_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "buyer_leads" */
export type Buyer_Leads_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Buyer_Leads_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
  user_order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "buyer_leads" */
export type Buyer_Leads_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
  user_order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "catchment_areas" */
export type Catchment_Areas = {
  /** An object relationship */
  place: Places;
  place_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "catchment_areas" */
export type Catchment_Areas_Aggregate = {
  aggregate?: Maybe<Catchment_Areas_Aggregate_Fields>;
  nodes: Array<Catchment_Areas>;
};

export type Catchment_Areas_Aggregate_Bool_Exp = {
  count?: InputMaybe<Catchment_Areas_Aggregate_Bool_Exp_Count>;
};

export type Catchment_Areas_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Catchment_Areas_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "catchment_areas" */
export type Catchment_Areas_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Catchment_Areas_Max_Fields>;
  min?: Maybe<Catchment_Areas_Min_Fields>;
};


/** aggregate fields of "catchment_areas" */
export type Catchment_Areas_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "catchment_areas" */
export type Catchment_Areas_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Catchment_Areas_Max_Order_By>;
  min?: InputMaybe<Catchment_Areas_Min_Order_By>;
};

/** input type for inserting array relation for remote table "catchment_areas" */
export type Catchment_Areas_Arr_Rel_Insert_Input = {
  data: Array<Catchment_Areas_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Catchment_Areas_On_Conflict>;
};

/** Boolean expression to filter rows from the table "catchment_areas". All fields are combined with a logical 'AND'. */
export type Catchment_Areas_Bool_Exp = {
  _and?: InputMaybe<Array<Catchment_Areas_Bool_Exp>>;
  _not?: InputMaybe<Catchment_Areas_Bool_Exp>;
  _or?: InputMaybe<Array<Catchment_Areas_Bool_Exp>>;
  place?: InputMaybe<Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "catchment_areas" */
export enum Catchment_Areas_Constraint {
  /** unique or primary key constraint on columns "user_id", "tenant_id", "place_id" */
  CatchmentAreasPkey = 'catchment_areas_pkey',
  /** unique or primary key constraint on columns "user_id", "tenant_id", "place_id" */
  CatchmentAreasUserIdPlaceIdTenantIdUnique = 'catchment_areas_user_id_place_id_tenant_id_unique'
}

/** input type for inserting data into table "catchment_areas" */
export type Catchment_Areas_Insert_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Catchment_Areas_Max_Fields = {
  place_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "catchment_areas" */
export type Catchment_Areas_Max_Order_By = {
  place_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Catchment_Areas_Min_Fields = {
  place_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "catchment_areas" */
export type Catchment_Areas_Min_Order_By = {
  place_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "catchment_areas" */
export type Catchment_Areas_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Catchment_Areas>;
};

/** on_conflict condition type for table "catchment_areas" */
export type Catchment_Areas_On_Conflict = {
  constraint: Catchment_Areas_Constraint;
  update_columns?: Array<Catchment_Areas_Update_Column>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};

/** Ordering options when selecting data from "catchment_areas". */
export type Catchment_Areas_Order_By = {
  place?: InputMaybe<Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "catchment_areas" */
export enum Catchment_Areas_Select_Column {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "catchment_areas" */
export type Catchment_Areas_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Catchment_Areas_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Catchment_Areas_Stream_Cursor_Value_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "catchment_areas" (current role has no relevant permissions) */
export enum Catchment_Areas_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "buildings" */
export type Ch_Buildings = {
  display_information?: Maybe<Scalars['jsonb']['output']>;
  extra?: Maybe<Scalars['jsonb']['output']>;
  footprint_area_m2?: Maybe<Scalars['float8']['output']>;
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
  local_building_id?: Maybe<Scalars['String']['output']>;
  number_of_floors?: Maybe<Scalars['Int']['output']>;
  plot_id?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['float8']['output']>;
  year_built?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "buildings" */
export type Ch_BuildingsDisplay_InformationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "buildings" */
export type Ch_BuildingsExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "buildings". All fields are combined with a logical 'AND'. */
export type Ch_Buildings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Buildings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Buildings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Buildings_Bool_Exp>>;
  display_information?: InputMaybe<Jsonb_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  footprint_area_m2?: InputMaybe<Float8_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  local_building_id?: InputMaybe<String_Comparison_Exp>;
  number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  plot_id?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float8_Comparison_Exp>;
  year_built?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "buildings". */
export type Ch_Buildings_Order_By = {
  display_information?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  footprint_area_m2?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_building_id?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  plot_id?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
  year_built?: InputMaybe<Order_By>;
};

/** select columns of table "buildings" */
export enum Ch_Buildings_Select_Column {
  /** column name */
  DisplayInformation = 'display_information',
  /** column name */
  Extra = 'extra',
  /** column name */
  FootprintAreaM2 = 'footprint_area_m2',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  LocalBuildingId = 'local_building_id',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  PlotId = 'plot_id',
  /** column name */
  Volume = 'volume',
  /** column name */
  YearBuilt = 'year_built'
}

/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, every property type: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Ch_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Ch_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Ch_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<Ch_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Ch_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  state?: Maybe<Ch_States>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, every property type: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Ch_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, every property type: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Ch_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, every property type: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Ch_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, every property type: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Ch_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Ch_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Ch_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Ch_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Ch_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Ch_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Cma_Listings_Max_Fields>;
  min?: Maybe<Ch_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Ch_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Ch_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ch_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Ch_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Ch_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Ch_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Ch_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<Ch_States_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** columns and relationships of "cma_listings_distance" */
export type Ch_Cma_Listings_Distance = {
  distance_in_meters: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  listing?: Maybe<Ch_Cma_Listings>;
  listing_id: Scalars['Int']['output'];
  state_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_listings_distance" */
export type Ch_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Ch_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Ch_Cma_Listings_Distance>;
};

/** aggregate fields of "cma_listings_distance" */
export type Ch_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Ch_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Ch_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Ch_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Ch_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Ch_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "cma_listings_distance" */
export type Ch_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Ch_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  listing?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Ch_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "cma_listings_distance". */
export type Ch_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing?: InputMaybe<Ch_Cma_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings_distance" */
export enum Ch_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Ch_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Ch_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Ch_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Ch_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Ch_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Ch_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state?: InputMaybe<Ch_States_Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Ch_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Ch_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cma_rental_listings" */
export type Ch_Cma_Rental_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Ch_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Ch_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Ch_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_rental_listings_places" */
  places?: Maybe<Array<Ch_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_rental_listings" */
export type Ch_Cma_Rental_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Ch_Cma_Rental_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Ch_Cma_Rental_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Ch_Cma_Rental_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_rental_listings" */
export type Ch_Cma_Rental_Listings_Aggregate = {
  aggregate?: Maybe<Ch_Cma_Rental_Listings_Aggregate_Fields>;
  nodes: Array<Ch_Cma_Rental_Listings>;
};

/** aggregate fields of "cma_rental_listings" */
export type Ch_Cma_Rental_Listings_Aggregate_Fields = {
  avg?: Maybe<Ch_Cma_Rental_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Cma_Rental_Listings_Max_Fields>;
  min?: Maybe<Ch_Cma_Rental_Listings_Min_Fields>;
  stddev?: Maybe<Ch_Cma_Rental_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Cma_Rental_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Cma_Rental_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Cma_Rental_Listings_Sum_Fields>;
  var_pop?: Maybe<Ch_Cma_Rental_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Cma_Rental_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ch_Cma_Rental_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_rental_listings" */
export type Ch_Cma_Rental_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Cma_Rental_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Cma_Rental_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_rental_listings". All fields are combined with a logical 'AND'. */
export type Ch_Cma_Rental_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Cma_Rental_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Cma_Rental_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Cma_Rental_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Ch_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Ch_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Cma_Rental_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Ch_Cma_Rental_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_rental_listings". */
export type Ch_Cma_Rental_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Ch_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Ch_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_rental_listings" */
export enum Ch_Cma_Rental_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Ch_Cma_Rental_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Cma_Rental_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Cma_Rental_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Cma_Rental_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Cma_Rental_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Cma_Rental_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Cma_Rental_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Ch_External_Transactions = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  source_payload?: Maybe<Scalars['jsonb']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};


/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Ch_External_TransactionsSource_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_transactions" */
export type Ch_External_Transactions_Aggregate = {
  aggregate?: Maybe<Ch_External_Transactions_Aggregate_Fields>;
  nodes: Array<Ch_External_Transactions>;
};

/** aggregate fields of "external_transactions" */
export type Ch_External_Transactions_Aggregate_Fields = {
  avg?: Maybe<Ch_External_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_External_Transactions_Max_Fields>;
  min?: Maybe<Ch_External_Transactions_Min_Fields>;
  stddev?: Maybe<Ch_External_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_External_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_External_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_External_Transactions_Sum_Fields>;
  var_pop?: Maybe<Ch_External_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_External_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Ch_External_Transactions_Variance_Fields>;
};


/** aggregate fields of "external_transactions" */
export type Ch_External_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_External_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_External_Transactions_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions". All fields are combined with a logical 'AND'. */
export type Ch_External_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_External_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Ch_External_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_External_Transactions_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** Rows returned by get_external_transactions_distance: a recorded sale and its distance_in_meters from the point asked. Data in France only. The table itself holds no row: call the function, with _lat and _lng always; nearest first unless _sort_field (with _sort_direction) is set. _max_distance_meters is 5 km by default and 50 km at most; pass _max_distance_meters: null to search a whole _postcode, bbox or _polygon_geojson beyond 5 km. _property_main_type, _cutoff_date and _cutoff_date_max, surfaces, rooms and price narrow further. At most 5000 rows (_max_results): a count over it stops there, so narrow the area or the dates for a large city. */
export type Ch_External_Transactions_Distance = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  distance_in_meters: Scalars['Float']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "external_transactions_distance" */
export type Ch_External_Transactions_Distance_Aggregate = {
  aggregate?: Maybe<Ch_External_Transactions_Distance_Aggregate_Fields>;
  nodes: Array<Ch_External_Transactions_Distance>;
};

/** aggregate fields of "external_transactions_distance" */
export type Ch_External_Transactions_Distance_Aggregate_Fields = {
  avg?: Maybe<Ch_External_Transactions_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_External_Transactions_Distance_Max_Fields>;
  min?: Maybe<Ch_External_Transactions_Distance_Min_Fields>;
  stddev?: Maybe<Ch_External_Transactions_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_External_Transactions_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_External_Transactions_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_External_Transactions_Distance_Sum_Fields>;
  var_pop?: Maybe<Ch_External_Transactions_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_External_Transactions_Distance_Var_Samp_Fields>;
  variance?: Maybe<Ch_External_Transactions_Distance_Variance_Fields>;
};


/** aggregate fields of "external_transactions_distance" */
export type Ch_External_Transactions_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_External_Transactions_Distance_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions_distance". All fields are combined with a logical 'AND'. */
export type Ch_External_Transactions_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_External_Transactions_Distance_Bool_Exp>>;
  _not?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_External_Transactions_Distance_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_External_Transactions_Distance_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ch_External_Transactions_Distance_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions_distance". */
export type Ch_External_Transactions_Distance_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions_distance" */
export enum Ch_External_Transactions_Distance_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Ch_External_Transactions_Distance_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_External_Transactions_Distance_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_External_Transactions_Distance_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_External_Transactions_Distance_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_External_Transactions_Distance_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_External_Transactions_Distance_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_External_Transactions_Distance_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Ch_External_Transactions_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Ch_External_Transactions_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions". */
export type Ch_External_Transactions_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_payload?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions" */
export enum Ch_External_Transactions_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  SourcePayload = 'source_payload',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Ch_External_Transactions_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_External_Transactions_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_External_Transactions_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_External_Transactions_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_External_Transactions_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_External_Transactions_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_External_Transactions_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Ch_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Ch_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Ch_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Ch_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Ch_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Ch_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_hash?: Maybe<Scalars['bit']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Ch_Merged_Images_Aggregate = {
  aggregate?: Maybe<Ch_Merged_Images_Aggregate_Fields>;
  nodes: Array<Ch_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Ch_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Ch_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Merged_Images_Max_Fields>;
  min?: Maybe<Ch_Merged_Images_Min_Fields>;
  stddev?: Maybe<Ch_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Ch_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Ch_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Ch_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Ch_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Ch_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Ch_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Ch_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Ch_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_hash?: InputMaybe<Bit_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Ch_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Ch_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Ch_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_hash?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Ch_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageHash = 'image_hash',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Ch_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Ch_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Ch_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Ch_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Ch_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Ch_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Ch_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Ch_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Ch_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_composite_property_type" */
  composite_property_type?: Maybe<Scalars['String']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Ch_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Ch_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Ch_Property_Main_Type_Enum;
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** Hidden from the public site by an admin (per listing, together with its duplicates). It does not say whether the listing is still online: see offline_since. */
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Ch_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Ch_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Ch_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Ch_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Ch_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Ch_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Ch_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Ch_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Merged_Listings_Max_Fields>;
  min?: Maybe<Ch_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Ch_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Ch_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ch_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Ch_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Ch_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  composite_property_type?: InputMaybe<String_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<Ch_Property_Main_Type_Enum_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Ch_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Ch_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  composite_property_type?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Ch_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Ch_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_Places = {
  /** An object relationship */
  agglomeration?: Maybe<Ch_Places>;
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  bbox?: Maybe<Scalars['_float8']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Ch_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Ch_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Ch_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  children_count?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  district?: Maybe<Ch_Places>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** An object relationship */
  locality?: Maybe<Ch_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Ch_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Ch_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Ch_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  neighbourhood?: Maybe<Ch_Places>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_stats: Array<Ch_Price_Stats>;
  /** An aggregate relationship */
  price_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** An array relationship */
  price_stats_historical: Array<Ch_Price_Stats_Historical>;
  /** An aggregate relationship */
  price_stats_historical_aggregate: Ch_Price_Stats_Historical_Aggregate;
  /** An array relationship */
  price_stats_quantiles: Array<Ch_Price_Stats_Quantiles>;
  /** An aggregate relationship */
  price_stats_quantiles_aggregate: Ch_Price_Stats_Quantiles_Aggregate;
  /** An object relationship */
  region?: Maybe<Ch_Places>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  state?: Maybe<Ch_Places>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Ch_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Ch_Places_Aggregate;
  /** An array relationship */
  street_stats_locality: Array<Ch_Street_Stats>;
  /** An aggregate relationship */
  street_stats_locality_aggregate: Ch_Street_Stats_Aggregate;
  /** An array relationship */
  street_stats_municipality: Array<Ch_Street_Stats>;
  /** An aggregate relationship */
  street_stats_municipality_aggregate: Ch_Street_Stats_Aggregate;
  type: Scalars['String']['output'];
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesPrice_StatsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesPrice_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesPrice_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesPrice_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesPrice_Stats_QuantilesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesPrice_Stats_Quantiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesStreet_Stats_LocalityArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesStreet_Stats_Locality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesStreet_Stats_MunicipalityArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Ch_PlacesStreet_Stats_Municipality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Ch_Places_Aggregate = {
  aggregate?: Maybe<Ch_Places_Aggregate_Fields>;
  nodes: Array<Ch_Places>;
};

/** aggregate fields of "places" */
export type Ch_Places_Aggregate_Fields = {
  avg?: Maybe<Ch_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Places_Max_Fields>;
  min?: Maybe<Ch_Places_Min_Fields>;
  stddev?: Maybe<Ch_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Places_Sum_Fields>;
  var_pop?: Maybe<Ch_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Places_Var_Samp_Fields>;
  variance?: Maybe<Ch_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Ch_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Ch_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Places_Max_Order_By>;
  min?: InputMaybe<Ch_Places_Min_Order_By>;
  stddev?: InputMaybe<Ch_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Ch_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Ch_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Places_Bool_Exp>>;
  _not?: InputMaybe<Ch_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Places_Bool_Exp>>;
  agglomeration?: InputMaybe<Ch_Places_Bool_Exp>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  bbox?: InputMaybe<_Float8_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Ch_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district?: InputMaybe<Ch_Places_Bool_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<Ch_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Ch_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Ch_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Ch_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_stats?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
  price_stats_historical?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
  price_stats_quantiles?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
  region?: InputMaybe<Ch_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  slug_pl?: InputMaybe<String_Comparison_Exp>;
  slug_pt?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Ch_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Ch_Places_Bool_Exp>;
  street_stats_locality?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
  street_stats_municipality?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** For a municipality, a locality or a neighbourhood (place_id), the places it sits in (breadcrumb_place_id -> places): order_num 1 locality, 2 municipality, 3 state; the place itself and non-state aliases are left out, so a locality starts at 2. */
export type Ch_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Ch_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Ch_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Ch_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Ch_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Ch_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Ch_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Ch_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Ch_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Ch_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Ch_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Ch_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Ch_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Ch_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Ch_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Ch_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Ch_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Ch_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Ch_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Ch_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Ch_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Ch_Places_Order_By = {
  agglomeration?: InputMaybe<Ch_Places_Order_By>;
  agglomeration_id?: InputMaybe<Order_By>;
  bbox?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Ch_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Ch_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district?: InputMaybe<Ch_Places_Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Ch_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Ch_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Ch_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood?: InputMaybe<Ch_Places_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_stats_aggregate?: InputMaybe<Ch_Price_Stats_Aggregate_Order_By>;
  price_stats_historical_aggregate?: InputMaybe<Ch_Price_Stats_Historical_Aggregate_Order_By>;
  price_stats_quantiles_aggregate?: InputMaybe<Ch_Price_Stats_Quantiles_Aggregate_Order_By>;
  region?: InputMaybe<Ch_Places_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state?: InputMaybe<Ch_Places_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Ch_Places_Aggregate_Order_By>;
  street_stats_locality_aggregate?: InputMaybe<Ch_Street_Stats_Aggregate_Order_By>;
  street_stats_municipality_aggregate?: InputMaybe<Ch_Street_Stats_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Ch_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  Bbox = 'bbox',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  SlugPl = 'slug_pl',
  /** column name */
  SlugPt = 'slug_pt',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Ch_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Ch_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Ch_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Ch_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Ch_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Ch_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Ch_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Ch_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Cadastral plots in Switzerland, France and Spain: the outline in geom, area_m2, and the raw cadastre attributes in extra, which differ per country. */
export type Ch_Plots = {
  area_m2?: Maybe<Scalars['numeric']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
};


/** Cadastral plots in Switzerland, France and Spain: the outline in geom, area_m2, and the raw cadastre attributes in extra, which differ per country. */
export type Ch_PlotsExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "plots". All fields are combined with a logical 'AND'. */
export type Ch_Plots_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Plots_Bool_Exp>>;
  _not?: InputMaybe<Ch_Plots_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Plots_Bool_Exp>>;
  area_m2?: InputMaybe<Numeric_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "plots". */
export type Ch_Plots_Order_By = {
  area_m2?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "plots" */
export enum Ch_Plots_Select_Column {
  /** column name */
  AreaM2 = 'area_m2',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Ch_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Ch_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Ch_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Ch_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Ch_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Ch_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Ch_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Ch_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Ch_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Ch_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "post_merged_listings" */
export type Ch_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Ch_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Ch_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Ch_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Ch_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Ch_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Ch_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Ch_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Ch_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Ch_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Ch_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Ch_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Ch_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Ch_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Ch_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Ch_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Ch_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Ch_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Ch_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Ch_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Price estimates of a place: one row per place_id x property_main_type x number_of_rooms. number_of_rooms = 0 is all sizes; property_main_type is ANY (all types), HOUSE or APPT. sale_price_m2_50 is the modelled price per m2; _10 and _90 are that estimate scaled to a typical low and high, not percentiles of the place. monthly_rent_* is gross monthly rent, yearly_rent_m2_* yearly rent per m2. Rebuilt monthly. */
export type Ch_Price_Stats = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "price_stats" */
export type Ch_Price_Stats_Aggregate = {
  aggregate?: Maybe<Ch_Price_Stats_Aggregate_Fields>;
  nodes: Array<Ch_Price_Stats>;
};

/** aggregate fields of "price_stats" */
export type Ch_Price_Stats_Aggregate_Fields = {
  avg?: Maybe<Ch_Price_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Price_Stats_Max_Fields>;
  min?: Maybe<Ch_Price_Stats_Min_Fields>;
  stddev?: Maybe<Ch_Price_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Price_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Price_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Price_Stats_Sum_Fields>;
  var_pop?: Maybe<Ch_Price_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Price_Stats_Var_Samp_Fields>;
  variance?: Maybe<Ch_Price_Stats_Variance_Fields>;
};


/** aggregate fields of "price_stats" */
export type Ch_Price_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats" */
export type Ch_Price_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Price_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Price_Stats_Max_Order_By>;
  min?: InputMaybe<Ch_Price_Stats_Min_Order_By>;
  stddev?: InputMaybe<Ch_Price_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Price_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Price_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Price_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Price_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Price_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Price_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Price_Stats_Avg_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats" */
export type Ch_Price_Stats_Avg_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats". All fields are combined with a logical 'AND'. */
export type Ch_Price_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Price_Stats_Bool_Exp>>;
  _not?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Price_Stats_Bool_Exp>>;
  monthly_rent_10?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_50?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_90?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_type?: InputMaybe<Place_Type_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_count?: InputMaybe<Int_Comparison_Exp>;
  rent_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_price_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_90?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_90?: InputMaybe<Float_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  yearly_rent_m2_10?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_50?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_90?: InputMaybe<Float_Comparison_Exp>;
};

/** Modelled sale price per m2 of a place over time: one row per place_id x property_main_type x number_of_rooms x date. All property types is 'ALL' here, where price_stats says ANY; number_of_rooms = 0 is all sizes. Daily for countries, states, districts and agglomerations, monthly for municipalities and localities. Always filter place_id, property_main_type, number_of_rooms and a date range. */
export type Ch_Price_Stats_Historical = {
  date: Scalars['date']['output'];
  number_of_rooms: Scalars['Int']['output'];
  place_id: Scalars['uuid']['output'];
  property_main_type: Scalars['String']['output'];
  sale_price_m2: Scalars['Float']['output'];
};

/** aggregated selection of "price_stats_historical" */
export type Ch_Price_Stats_Historical_Aggregate = {
  aggregate?: Maybe<Ch_Price_Stats_Historical_Aggregate_Fields>;
  nodes: Array<Ch_Price_Stats_Historical>;
};

/** aggregate fields of "price_stats_historical" */
export type Ch_Price_Stats_Historical_Aggregate_Fields = {
  avg?: Maybe<Ch_Price_Stats_Historical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Price_Stats_Historical_Max_Fields>;
  min?: Maybe<Ch_Price_Stats_Historical_Min_Fields>;
  stddev?: Maybe<Ch_Price_Stats_Historical_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Price_Stats_Historical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Price_Stats_Historical_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Price_Stats_Historical_Sum_Fields>;
  var_pop?: Maybe<Ch_Price_Stats_Historical_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Price_Stats_Historical_Var_Samp_Fields>;
  variance?: Maybe<Ch_Price_Stats_Historical_Variance_Fields>;
};


/** aggregate fields of "price_stats_historical" */
export type Ch_Price_Stats_Historical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Price_Stats_Historical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Price_Stats_Historical_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Price_Stats_Historical_Max_Order_By>;
  min?: InputMaybe<Ch_Price_Stats_Historical_Min_Order_By>;
  stddev?: InputMaybe<Ch_Price_Stats_Historical_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Price_Stats_Historical_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Price_Stats_Historical_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Price_Stats_Historical_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Price_Stats_Historical_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Price_Stats_Historical_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Price_Stats_Historical_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Price_Stats_Historical_Avg_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Avg_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_historical". All fields are combined with a logical 'AND'. */
export type Ch_Price_Stats_Historical_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Price_Stats_Historical_Bool_Exp>>;
  _not?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Price_Stats_Historical_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  sale_price_m2?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Price_Stats_Historical_Max_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Price_Stats_Historical_Min_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_historical". */
export type Ch_Price_Stats_Historical_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_historical" */
export enum Ch_Price_Stats_Historical_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  SalePriceM2 = 'sale_price_m2'
}

/** aggregate stddev on columns */
export type Ch_Price_Stats_Historical_Stddev_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Stddev_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Price_Stats_Historical_Stddev_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Stddev_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Price_Stats_Historical_Stddev_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Stddev_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Price_Stats_Historical_Sum_Fields = {
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Sum_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Price_Stats_Historical_Var_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Var_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Price_Stats_Historical_Var_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Var_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Price_Stats_Historical_Variance_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_historical" */
export type Ch_Price_Stats_Historical_Variance_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Ch_Price_Stats_Max_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats" */
export type Ch_Price_Stats_Max_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Price_Stats_Min_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats" */
export type Ch_Price_Stats_Min_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats". */
export type Ch_Price_Stats_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles = {
  computed_surface_per_room_median?: Maybe<Scalars['jsonb']['output']>;
  confidence?: Maybe<Scalars['float8']['output']>;
  inherited?: Maybe<Scalars['Boolean']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  place_id: Scalars['uuid']['output'];
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_distribution?: Maybe<Scalars['jsonb']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  price_per_m2_percentiles?: Maybe<Scalars['jsonb']['output']>;
  property_main_type: Scalars['String']['output'];
  rent_generated_at?: Maybe<Scalars['date']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_distribution?: Maybe<Scalars['jsonb']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_percentiles?: Maybe<Scalars['jsonb']['output']>;
  sale_generated_at?: Maybe<Scalars['date']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesComputed_Surface_Per_Room_MedianArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesPrice_Per_M2_DistributionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesPrice_Per_M2_PercentilesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesRent_Per_M2_DistributionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "price_stats_quantiles" */
export type Ch_Price_Stats_QuantilesRent_Per_M2_PercentilesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate = {
  aggregate?: Maybe<Ch_Price_Stats_Quantiles_Aggregate_Fields>;
  nodes: Array<Ch_Price_Stats_Quantiles>;
};

/** aggregate fields of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate_Fields = {
  avg?: Maybe<Ch_Price_Stats_Quantiles_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Price_Stats_Quantiles_Max_Fields>;
  min?: Maybe<Ch_Price_Stats_Quantiles_Min_Fields>;
  stddev?: Maybe<Ch_Price_Stats_Quantiles_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Price_Stats_Quantiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Price_Stats_Quantiles_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Price_Stats_Quantiles_Sum_Fields>;
  var_pop?: Maybe<Ch_Price_Stats_Quantiles_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Price_Stats_Quantiles_Var_Samp_Fields>;
  variance?: Maybe<Ch_Price_Stats_Quantiles_Variance_Fields>;
};


/** aggregate fields of "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Price_Stats_Quantiles_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Price_Stats_Quantiles_Max_Order_By>;
  min?: InputMaybe<Ch_Price_Stats_Quantiles_Min_Order_By>;
  stddev?: InputMaybe<Ch_Price_Stats_Quantiles_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Price_Stats_Quantiles_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Price_Stats_Quantiles_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Price_Stats_Quantiles_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Price_Stats_Quantiles_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Price_Stats_Quantiles_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Price_Stats_Quantiles_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Price_Stats_Quantiles_Avg_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Avg_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_quantiles". All fields are combined with a logical 'AND'. */
export type Ch_Price_Stats_Quantiles_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Bool_Exp>>;
  _not?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Bool_Exp>>;
  computed_surface_per_room_median?: InputMaybe<Jsonb_Comparison_Exp>;
  confidence?: InputMaybe<Float8_Comparison_Exp>;
  inherited?: InputMaybe<Boolean_Comparison_Exp>;
  p2m_cv?: InputMaybe<Float8_Comparison_Exp>;
  percent_listings?: InputMaybe<Float8_Comparison_Exp>;
  percent_perceived?: InputMaybe<Float8_Comparison_Exp>;
  percent_sred?: InputMaybe<Float8_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_cv?: InputMaybe<Float8_Comparison_Exp>;
  price_median?: InputMaybe<Float8_Comparison_Exp>;
  price_p10?: InputMaybe<Float8_Comparison_Exp>;
  price_p90?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_distribution?: InputMaybe<Jsonb_Comparison_Exp>;
  price_per_m2_median?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_median_listings?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_median_sred?: InputMaybe<Float8_Comparison_Exp>;
  price_per_m2_percentiles?: InputMaybe<Jsonb_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_generated_at?: InputMaybe<Date_Comparison_Exp>;
  rent_median?: InputMaybe<Float8_Comparison_Exp>;
  rent_p10?: InputMaybe<Float8_Comparison_Exp>;
  rent_p90?: InputMaybe<Float8_Comparison_Exp>;
  rent_per_m2_distribution?: InputMaybe<Jsonb_Comparison_Exp>;
  rent_per_m2_median?: InputMaybe<Float8_Comparison_Exp>;
  rent_per_m2_percentiles?: InputMaybe<Jsonb_Comparison_Exp>;
  sale_generated_at?: InputMaybe<Date_Comparison_Exp>;
  stock?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Price_Stats_Quantiles_Max_Fields = {
  confidence?: Maybe<Scalars['float8']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_generated_at?: Maybe<Scalars['date']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  sale_generated_at?: Maybe<Scalars['date']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Max_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_generated_at?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  sale_generated_at?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Price_Stats_Quantiles_Min_Fields = {
  confidence?: Maybe<Scalars['float8']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_generated_at?: Maybe<Scalars['date']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  sale_generated_at?: Maybe<Scalars['date']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Min_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_generated_at?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  sale_generated_at?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_quantiles". */
export type Ch_Price_Stats_Quantiles_Order_By = {
  computed_surface_per_room_median?: InputMaybe<Order_By>;
  confidence?: InputMaybe<Order_By>;
  inherited?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_distribution?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  price_per_m2_percentiles?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_generated_at?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_distribution?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  rent_per_m2_percentiles?: InputMaybe<Order_By>;
  sale_generated_at?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_quantiles" */
export enum Ch_Price_Stats_Quantiles_Select_Column {
  /** column name */
  ComputedSurfacePerRoomMedian = 'computed_surface_per_room_median',
  /** column name */
  Confidence = 'confidence',
  /** column name */
  Inherited = 'inherited',
  /** column name */
  P2mCv = 'p2m_cv',
  /** column name */
  PercentListings = 'percent_listings',
  /** column name */
  PercentPerceived = 'percent_perceived',
  /** column name */
  PercentSred = 'percent_sred',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PriceCv = 'price_cv',
  /** column name */
  PriceMedian = 'price_median',
  /** column name */
  PriceP10 = 'price_p10',
  /** column name */
  PriceP90 = 'price_p90',
  /** column name */
  PricePerM2Distribution = 'price_per_m2_distribution',
  /** column name */
  PricePerM2Median = 'price_per_m2_median',
  /** column name */
  PricePerM2MedianListings = 'price_per_m2_median_listings',
  /** column name */
  PricePerM2MedianSred = 'price_per_m2_median_sred',
  /** column name */
  PricePerM2Percentiles = 'price_per_m2_percentiles',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentGeneratedAt = 'rent_generated_at',
  /** column name */
  RentMedian = 'rent_median',
  /** column name */
  RentP10 = 'rent_p10',
  /** column name */
  RentP90 = 'rent_p90',
  /** column name */
  RentPerM2Distribution = 'rent_per_m2_distribution',
  /** column name */
  RentPerM2Median = 'rent_per_m2_median',
  /** column name */
  RentPerM2Percentiles = 'rent_per_m2_percentiles',
  /** column name */
  SaleGeneratedAt = 'sale_generated_at',
  /** column name */
  Stock = 'stock'
}

/** aggregate stddev on columns */
export type Ch_Price_Stats_Quantiles_Stddev_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Stddev_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Price_Stats_Quantiles_Stddev_Pop_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Stddev_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Price_Stats_Quantiles_Stddev_Samp_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Stddev_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Price_Stats_Quantiles_Sum_Fields = {
  confidence?: Maybe<Scalars['float8']['output']>;
  p2m_cv?: Maybe<Scalars['float8']['output']>;
  percent_listings?: Maybe<Scalars['float8']['output']>;
  percent_perceived?: Maybe<Scalars['float8']['output']>;
  percent_sred?: Maybe<Scalars['float8']['output']>;
  price_cv?: Maybe<Scalars['float8']['output']>;
  price_median?: Maybe<Scalars['float8']['output']>;
  price_p10?: Maybe<Scalars['float8']['output']>;
  price_p90?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['float8']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['float8']['output']>;
  rent_median?: Maybe<Scalars['float8']['output']>;
  rent_p10?: Maybe<Scalars['float8']['output']>;
  rent_p90?: Maybe<Scalars['float8']['output']>;
  rent_per_m2_median?: Maybe<Scalars['float8']['output']>;
  stock?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Sum_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Price_Stats_Quantiles_Var_Pop_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Var_Pop_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Price_Stats_Quantiles_Var_Samp_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Var_Samp_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Price_Stats_Quantiles_Variance_Fields = {
  confidence?: Maybe<Scalars['Float']['output']>;
  p2m_cv?: Maybe<Scalars['Float']['output']>;
  percent_listings?: Maybe<Scalars['Float']['output']>;
  percent_perceived?: Maybe<Scalars['Float']['output']>;
  percent_sred?: Maybe<Scalars['Float']['output']>;
  price_cv?: Maybe<Scalars['Float']['output']>;
  price_median?: Maybe<Scalars['Float']['output']>;
  price_p10?: Maybe<Scalars['Float']['output']>;
  price_p90?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_listings?: Maybe<Scalars['Float']['output']>;
  price_per_m2_median_sred?: Maybe<Scalars['Float']['output']>;
  rent_median?: Maybe<Scalars['Float']['output']>;
  rent_p10?: Maybe<Scalars['Float']['output']>;
  rent_p90?: Maybe<Scalars['Float']['output']>;
  rent_per_m2_median?: Maybe<Scalars['Float']['output']>;
  stock?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_quantiles" */
export type Ch_Price_Stats_Quantiles_Variance_Order_By = {
  confidence?: InputMaybe<Order_By>;
  p2m_cv?: InputMaybe<Order_By>;
  percent_listings?: InputMaybe<Order_By>;
  percent_perceived?: InputMaybe<Order_By>;
  percent_sred?: InputMaybe<Order_By>;
  price_cv?: InputMaybe<Order_By>;
  price_median?: InputMaybe<Order_By>;
  price_p10?: InputMaybe<Order_By>;
  price_p90?: InputMaybe<Order_By>;
  price_per_m2_median?: InputMaybe<Order_By>;
  price_per_m2_median_listings?: InputMaybe<Order_By>;
  price_per_m2_median_sred?: InputMaybe<Order_By>;
  rent_median?: InputMaybe<Order_By>;
  rent_p10?: InputMaybe<Order_By>;
  rent_p90?: InputMaybe<Order_By>;
  rent_per_m2_median?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats" */
export enum Ch_Price_Stats_Select_Column {
  /** column name */
  MonthlyRent_10 = 'monthly_rent_10',
  /** column name */
  MonthlyRent_50 = 'monthly_rent_50',
  /** column name */
  MonthlyRent_90 = 'monthly_rent_90',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PlaceParentId = 'place_parent_id',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentCount = 'rent_count',
  /** column name */
  RentCount_3month = 'rent_count_3month',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleCount_3month = 'sale_count_3month',
  /** column name */
  SalePrice_10 = 'sale_price_10',
  /** column name */
  SalePrice_50 = 'sale_price_50',
  /** column name */
  SalePrice_90 = 'sale_price_90',
  /** column name */
  SalePriceM2_10 = 'sale_price_m2_10',
  /** column name */
  SalePriceM2_50 = 'sale_price_m2_50',
  /** column name */
  SalePriceM2_90 = 'sale_price_m2_90',
  /** column name */
  Stock = 'stock',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  YearlyRentM2_10 = 'yearly_rent_m2_10',
  /** column name */
  YearlyRentM2_50 = 'yearly_rent_m2_50',
  /** column name */
  YearlyRentM2_90 = 'yearly_rent_m2_90'
}

/** aggregate stddev on columns */
export type Ch_Price_Stats_Stddev_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats" */
export type Ch_Price_Stats_Stddev_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Price_Stats_Stddev_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats" */
export type Ch_Price_Stats_Stddev_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Price_Stats_Stddev_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats" */
export type Ch_Price_Stats_Stddev_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Price_Stats_Sum_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats" */
export type Ch_Price_Stats_Sum_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Price_Stats_Var_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats" */
export type Ch_Price_Stats_Var_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Price_Stats_Var_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats" */
export type Ch_Price_Stats_Var_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Price_Stats_Variance_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats" */
export type Ch_Price_Stats_Variance_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

export enum Ch_Property_Main_Type_Enum {
  Agri = 'AGRI',
  Appt = 'APPT',
  Building = 'BUILDING',
  Commercial = 'COMMERCIAL',
  Garden = 'GARDEN',
  Gastro = 'GASTRO',
  House = 'HOUSE',
  HouseAppt = 'HOUSE_APPT',
  Indus = 'INDUS',
  Other = 'OTHER',
  Park = 'PARK',
  Prop = 'PROP',
  Room = 'ROOM',
  Secondary = 'SECONDARY'
}

/** Boolean expression to compare columns of type "ch_property_main_type_enum". All fields are combined with logical 'AND'. */
export type Ch_Property_Main_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Ch_Property_Main_Type_Enum>;
  _in?: InputMaybe<Array<Ch_Property_Main_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Ch_Property_Main_Type_Enum>;
  _nin?: InputMaybe<Array<Ch_Property_Main_Type_Enum>>;
};

/** columns and relationships of "property_types" */
export type Ch_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Ch_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Ch_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Ch_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Ch_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "rental_cma_listings_distance" */
export type Ch_Rental_Cma_Listings_Distance = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  is_online?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  listing?: Maybe<Ch_Cma_Rental_Listings>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

export type Ch_Rental_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Ch_Rental_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Ch_Rental_Cma_Listings_Distance>;
};

/** aggregate fields of "rental_cma_listings_distance" */
export type Ch_Rental_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Ch_Rental_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Rental_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Ch_Rental_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Ch_Rental_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Rental_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Rental_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Rental_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Ch_Rental_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Rental_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Ch_Rental_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "rental_cma_listings_distance" */
export type Ch_Rental_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Ch_Rental_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Ch_Rental_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float8_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  listing?: InputMaybe<Ch_Cma_Rental_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  net_rent_per_sqm?: InputMaybe<Float8_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Rental_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Ch_Rental_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "rental_cma_listings_distance". */
export type Ch_Rental_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  listing?: InputMaybe<Ch_Cma_Rental_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  net_rent_per_sqm?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_cma_listings_distance" */
export enum Ch_Rental_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  NetRentPerSqm = 'net_rent_per_sqm',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Ch_Rental_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Ch_Rental_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Ch_Rental_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Ch_Rental_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Ch_Rental_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Ch_Rental_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Ch_Rental_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "states" */
export type Ch_States = {
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "states". All fields are combined with a logical 'AND'. */
export type Ch_States_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_States_Bool_Exp>>;
  _not?: InputMaybe<Ch_States_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_States_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "states". */
export type Ch_States_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "states" */
export enum Ch_States_Select_Column {
  /** column name */
  Name = 'name'
}

/** Sale price per m2 by street (route) within a municipality or locality: median, mean, 15th and 85th percentile, and total_count, the number of data points behind them. A street with a small total_count is noise: ask for at least 15. Rebuilt monthly. */
export type Ch_Street_Stats = {
  geom?: Maybe<Scalars['geometry']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  is_cross_locality?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  locality?: Maybe<Ch_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  municipality?: Maybe<Ch_Places>;
  municipality_id: Scalars['uuid']['output'];
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['uuid']['output'];
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "street_stats" */
export type Ch_Street_Stats_Aggregate = {
  aggregate?: Maybe<Ch_Street_Stats_Aggregate_Fields>;
  nodes: Array<Ch_Street_Stats>;
};

/** aggregate fields of "street_stats" */
export type Ch_Street_Stats_Aggregate_Fields = {
  avg?: Maybe<Ch_Street_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Ch_Street_Stats_Max_Fields>;
  min?: Maybe<Ch_Street_Stats_Min_Fields>;
  stddev?: Maybe<Ch_Street_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Ch_Street_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ch_Street_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Ch_Street_Stats_Sum_Fields>;
  var_pop?: Maybe<Ch_Street_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Ch_Street_Stats_Var_Samp_Fields>;
  variance?: Maybe<Ch_Street_Stats_Variance_Fields>;
};


/** aggregate fields of "street_stats" */
export type Ch_Street_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "street_stats" */
export type Ch_Street_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Ch_Street_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ch_Street_Stats_Max_Order_By>;
  min?: InputMaybe<Ch_Street_Stats_Min_Order_By>;
  stddev?: InputMaybe<Ch_Street_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ch_Street_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ch_Street_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ch_Street_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Ch_Street_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ch_Street_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Ch_Street_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Ch_Street_Stats_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "street_stats" */
export type Ch_Street_Stats_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "street_stats". All fields are combined with a logical 'AND'. */
export type Ch_Street_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Ch_Street_Stats_Bool_Exp>>;
  _not?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Ch_Street_Stats_Bool_Exp>>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  is_cross_locality?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  locality?: InputMaybe<Ch_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  mean_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  median_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  municipality?: InputMaybe<Ch_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  num_street_numbers?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_count?: InputMaybe<Int_Comparison_Exp>;
  upper_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Ch_Street_Stats_Max_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "street_stats" */
export type Ch_Street_Stats_Max_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ch_Street_Stats_Min_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "street_stats" */
export type Ch_Street_Stats_Min_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "street_stats". */
export type Ch_Street_Stats_Order_By = {
  geom?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  is_cross_locality?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Ch_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Ch_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** select columns of table "street_stats" */
export enum Ch_Street_Stats_Select_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  IsCrossLocality = 'is_cross_locality',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  Lower_15PercentilePricePerM2 = 'lower_15_percentile_price_per_m2',
  /** column name */
  MeanPricePerM2 = 'mean_price_per_m2',
  /** column name */
  MedianPricePerM2 = 'median_price_per_m2',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NumStreetNumbers = 'num_street_numbers',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  Upper_15PercentilePricePerM2 = 'upper_15_percentile_price_per_m2'
}

/** aggregate stddev on columns */
export type Ch_Street_Stats_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "street_stats" */
export type Ch_Street_Stats_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ch_Street_Stats_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "street_stats" */
export type Ch_Street_Stats_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ch_Street_Stats_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "street_stats" */
export type Ch_Street_Stats_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Ch_Street_Stats_Sum_Fields = {
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "street_stats" */
export type Ch_Street_Stats_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Ch_Street_Stats_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "street_stats" */
export type Ch_Street_Stats_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ch_Street_Stats_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "street_stats" */
export type Ch_Street_Stats_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ch_Street_Stats_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "street_stats" */
export type Ch_Street_Stats_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** columns and relationships of "Chat" */
export type Chat_Api_Chat = {
  active_stream_id?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  conversation_traces: Array<Chat_Api_Conversation_Trace>;
  /** An aggregate relationship */
  conversation_traces_aggregate: Chat_Api_Conversation_Trace_Aggregate;
  createdAt: Scalars['timestamptz']['output'];
  device_browser?: Maybe<Scalars['String']['output']>;
  device_form?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  messages: Array<Chat_Api_Message>;
  /** An aggregate relationship */
  messages_aggregate: Chat_Api_Message_Aggregate;
  model?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  mutation_audits: Array<Chat_Api_Mutation_Audit>;
  /** An aggregate relationship */
  mutation_audits_aggregate: Chat_Api_Mutation_Audit_Aggregate;
  title: Scalars['String']['output'];
  userId: Scalars['uuid']['output'];
  user_agent?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "Chat" */
export type Chat_Api_ChatConversation_TracesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Trace_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
};


/** columns and relationships of "Chat" */
export type Chat_Api_ChatConversation_Traces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Trace_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
};


/** columns and relationships of "Chat" */
export type Chat_Api_ChatMessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Message_Bool_Exp>;
};


/** columns and relationships of "Chat" */
export type Chat_Api_ChatMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Message_Bool_Exp>;
};


/** columns and relationships of "Chat" */
export type Chat_Api_ChatMutation_AuditsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Mutation_Audit_Order_By>>;
  where?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
};


/** columns and relationships of "Chat" */
export type Chat_Api_ChatMutation_Audits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Mutation_Audit_Order_By>>;
  where?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
};

/** aggregated selection of "Chat" */
export type Chat_Api_Chat_Aggregate = {
  aggregate?: Maybe<Chat_Api_Chat_Aggregate_Fields>;
  nodes: Array<Chat_Api_Chat>;
};

/** aggregate fields of "Chat" */
export type Chat_Api_Chat_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Chat_Max_Fields>;
  min?: Maybe<Chat_Api_Chat_Min_Fields>;
};


/** aggregate fields of "Chat" */
export type Chat_Api_Chat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Chat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Chat". All fields are combined with a logical 'AND'. */
export type Chat_Api_Chat_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Chat_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Chat_Bool_Exp>>;
  active_stream_id?: InputMaybe<String_Comparison_Exp>;
  client?: InputMaybe<String_Comparison_Exp>;
  conversation_traces?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
  conversation_traces_aggregate?: InputMaybe<Conversation_Trace_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_browser?: InputMaybe<String_Comparison_Exp>;
  device_form?: InputMaybe<String_Comparison_Exp>;
  device_model?: InputMaybe<String_Comparison_Exp>;
  device_os?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location_city?: InputMaybe<String_Comparison_Exp>;
  location_country?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Chat_Api_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Message_Aggregate_Bool_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  mutation_audits?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
  mutation_audits_aggregate?: InputMaybe<Mutation_Audit_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  user_agent?: InputMaybe<String_Comparison_Exp>;
  user_name?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Chat_Max_Fields = {
  active_stream_id?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  device_browser?: Maybe<Scalars['String']['output']>;
  device_form?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Chat_Api_Chat_Min_Fields = {
  active_stream_id?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  device_browser?: Maybe<Scalars['String']['output']>;
  device_form?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "chat_model_setting" */
export type Chat_Api_Chat_Model_Setting = {
  context_window?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  first_seen_at: Scalars['timestamptz']['output'];
  is_default_free: Scalars['Boolean']['output'];
  is_default_paid: Scalars['Boolean']['output'];
  last_seen_at: Scalars['timestamptz']['output'];
  model_id: Scalars['String']['output'];
  model_type?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price_per_m_cache_read?: Maybe<Scalars['numeric']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['numeric']['output']>;
  price_per_m_input?: Maybe<Scalars['numeric']['output']>;
  price_per_m_output?: Maybe<Scalars['numeric']['output']>;
  /** An array relationship */
  pricing_history: Array<Chat_Api_Model_Pricing>;
  /** An aggregate relationship */
  pricing_history_aggregate: Chat_Api_Model_Pricing_Aggregate;
  provider: Scalars['String']['output'];
  supports_vision: Scalars['Boolean']['output'];
  tier: Scalars['String']['output'];
  tier_overridden: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "chat_model_setting" */
export type Chat_Api_Chat_Model_SettingPricing_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Model_Pricing_Order_By>>;
  where?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
};


/** columns and relationships of "chat_model_setting" */
export type Chat_Api_Chat_Model_SettingPricing_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Model_Pricing_Order_By>>;
  where?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
};

/** aggregated selection of "chat_model_setting" */
export type Chat_Api_Chat_Model_Setting_Aggregate = {
  aggregate?: Maybe<Chat_Api_Chat_Model_Setting_Aggregate_Fields>;
  nodes: Array<Chat_Api_Chat_Model_Setting>;
};

/** aggregate fields of "chat_model_setting" */
export type Chat_Api_Chat_Model_Setting_Aggregate_Fields = {
  avg?: Maybe<Chat_Api_Chat_Model_Setting_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Chat_Model_Setting_Max_Fields>;
  min?: Maybe<Chat_Api_Chat_Model_Setting_Min_Fields>;
  stddev?: Maybe<Chat_Api_Chat_Model_Setting_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Api_Chat_Model_Setting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Api_Chat_Model_Setting_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Api_Chat_Model_Setting_Sum_Fields>;
  var_pop?: Maybe<Chat_Api_Chat_Model_Setting_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Api_Chat_Model_Setting_Var_Samp_Fields>;
  variance?: Maybe<Chat_Api_Chat_Model_Setting_Variance_Fields>;
};


/** aggregate fields of "chat_model_setting" */
export type Chat_Api_Chat_Model_Setting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Chat_Api_Chat_Model_Setting_Avg_Fields = {
  context_window?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['Float']['output']>;
  price_per_m_input?: Maybe<Scalars['Float']['output']>;
  price_per_m_output?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "chat_model_setting". All fields are combined with a logical 'AND'. */
export type Chat_Api_Chat_Model_Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Chat_Model_Setting_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Bool_Exp>>;
  context_window?: InputMaybe<Int_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  first_seen_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  is_default_free?: InputMaybe<Boolean_Comparison_Exp>;
  is_default_paid?: InputMaybe<Boolean_Comparison_Exp>;
  last_seen_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  model_type?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  price_per_m_cache_read?: InputMaybe<Numeric_Comparison_Exp>;
  price_per_m_cache_write?: InputMaybe<Numeric_Comparison_Exp>;
  price_per_m_input?: InputMaybe<Numeric_Comparison_Exp>;
  price_per_m_output?: InputMaybe<Numeric_Comparison_Exp>;
  pricing_history?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
  pricing_history_aggregate?: InputMaybe<Model_Pricing_Aggregate_Bool_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  supports_vision?: InputMaybe<Boolean_Comparison_Exp>;
  tier?: InputMaybe<String_Comparison_Exp>;
  tier_overridden?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Chat_Model_Setting_Max_Fields = {
  context_window?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  first_seen_at?: Maybe<Scalars['timestamptz']['output']>;
  last_seen_at?: Maybe<Scalars['timestamptz']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['numeric']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['numeric']['output']>;
  price_per_m_input?: Maybe<Scalars['numeric']['output']>;
  price_per_m_output?: Maybe<Scalars['numeric']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Chat_Api_Chat_Model_Setting_Min_Fields = {
  context_window?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  first_seen_at?: Maybe<Scalars['timestamptz']['output']>;
  last_seen_at?: Maybe<Scalars['timestamptz']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  model_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['numeric']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['numeric']['output']>;
  price_per_m_input?: Maybe<Scalars['numeric']['output']>;
  price_per_m_output?: Maybe<Scalars['numeric']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "chat_model_setting". */
export type Chat_Api_Chat_Model_Setting_Order_By = {
  context_window?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  first_seen_at?: InputMaybe<Order_By>;
  is_default_free?: InputMaybe<Order_By>;
  is_default_paid?: InputMaybe<Order_By>;
  last_seen_at?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  model_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  price_per_m_cache_read?: InputMaybe<Order_By>;
  price_per_m_cache_write?: InputMaybe<Order_By>;
  price_per_m_input?: InputMaybe<Order_By>;
  price_per_m_output?: InputMaybe<Order_By>;
  pricing_history_aggregate?: InputMaybe<Chat_Api_Model_Pricing_Aggregate_Order_By>;
  provider?: InputMaybe<Order_By>;
  supports_vision?: InputMaybe<Order_By>;
  tier?: InputMaybe<Order_By>;
  tier_overridden?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "chat_model_setting" */
export enum Chat_Api_Chat_Model_Setting_Select_Column {
  /** column name */
  ContextWindow = 'context_window',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  FirstSeenAt = 'first_seen_at',
  /** column name */
  IsDefaultFree = 'is_default_free',
  /** column name */
  IsDefaultPaid = 'is_default_paid',
  /** column name */
  LastSeenAt = 'last_seen_at',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ModelType = 'model_type',
  /** column name */
  Name = 'name',
  /** column name */
  PricePerMCacheRead = 'price_per_m_cache_read',
  /** column name */
  PricePerMCacheWrite = 'price_per_m_cache_write',
  /** column name */
  PricePerMInput = 'price_per_m_input',
  /** column name */
  PricePerMOutput = 'price_per_m_output',
  /** column name */
  Provider = 'provider',
  /** column name */
  SupportsVision = 'supports_vision',
  /** column name */
  Tier = 'tier',
  /** column name */
  TierOverridden = 'tier_overridden',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Chat_Api_Chat_Model_Setting_Stddev_Fields = {
  context_window?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['Float']['output']>;
  price_per_m_input?: Maybe<Scalars['Float']['output']>;
  price_per_m_output?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Chat_Api_Chat_Model_Setting_Stddev_Pop_Fields = {
  context_window?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['Float']['output']>;
  price_per_m_input?: Maybe<Scalars['Float']['output']>;
  price_per_m_output?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Chat_Api_Chat_Model_Setting_Stddev_Samp_Fields = {
  context_window?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['Float']['output']>;
  price_per_m_input?: Maybe<Scalars['Float']['output']>;
  price_per_m_output?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "chat_model_setting" */
export type Chat_Api_Chat_Model_Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Chat_Model_Setting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Chat_Model_Setting_Stream_Cursor_Value_Input = {
  context_window?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first_seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  is_default_free?: InputMaybe<Scalars['Boolean']['input']>;
  is_default_paid?: InputMaybe<Scalars['Boolean']['input']>;
  last_seen_at?: InputMaybe<Scalars['timestamptz']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  model_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price_per_m_cache_read?: InputMaybe<Scalars['numeric']['input']>;
  price_per_m_cache_write?: InputMaybe<Scalars['numeric']['input']>;
  price_per_m_input?: InputMaybe<Scalars['numeric']['input']>;
  price_per_m_output?: InputMaybe<Scalars['numeric']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  supports_vision?: InputMaybe<Scalars['Boolean']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
  tier_overridden?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Chat_Api_Chat_Model_Setting_Sum_Fields = {
  context_window?: Maybe<Scalars['Int']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['numeric']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['numeric']['output']>;
  price_per_m_input?: Maybe<Scalars['numeric']['output']>;
  price_per_m_output?: Maybe<Scalars['numeric']['output']>;
};

/** aggregate var_pop on columns */
export type Chat_Api_Chat_Model_Setting_Var_Pop_Fields = {
  context_window?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['Float']['output']>;
  price_per_m_input?: Maybe<Scalars['Float']['output']>;
  price_per_m_output?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Chat_Api_Chat_Model_Setting_Var_Samp_Fields = {
  context_window?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['Float']['output']>;
  price_per_m_input?: Maybe<Scalars['Float']['output']>;
  price_per_m_output?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Chat_Api_Chat_Model_Setting_Variance_Fields = {
  context_window?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_read?: Maybe<Scalars['Float']['output']>;
  price_per_m_cache_write?: Maybe<Scalars['Float']['output']>;
  price_per_m_input?: Maybe<Scalars['Float']['output']>;
  price_per_m_output?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "Chat". */
export type Chat_Api_Chat_Order_By = {
  active_stream_id?: InputMaybe<Order_By>;
  client?: InputMaybe<Order_By>;
  conversation_traces_aggregate?: InputMaybe<Chat_Api_Conversation_Trace_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  device_browser?: InputMaybe<Order_By>;
  device_form?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  device_os?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_city?: InputMaybe<Order_By>;
  location_country?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Chat_Api_Message_Aggregate_Order_By>;
  model?: InputMaybe<Order_By>;
  mutation_audits_aggregate?: InputMaybe<Chat_Api_Mutation_Audit_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
  user_name?: InputMaybe<Order_By>;
};

/** select columns of table "Chat" */
export enum Chat_Api_Chat_Select_Column {
  /** column name */
  ActiveStreamId = 'active_stream_id',
  /** column name */
  Client = 'client',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DeviceBrowser = 'device_browser',
  /** column name */
  DeviceForm = 'device_form',
  /** column name */
  DeviceModel = 'device_model',
  /** column name */
  DeviceOs = 'device_os',
  /** column name */
  Id = 'id',
  /** column name */
  LocationCity = 'location_city',
  /** column name */
  LocationCountry = 'location_country',
  /** column name */
  Model = 'model',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'userId',
  /** column name */
  UserAgent = 'user_agent',
  /** column name */
  UserName = 'user_name'
}

/** Streaming cursor of the table "chat" */
export type Chat_Api_Chat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Chat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Chat_Stream_Cursor_Value_Input = {
  active_stream_id?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device_browser?: InputMaybe<Scalars['String']['input']>;
  device_form?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_os?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_country?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "conversation_message" */
export type Chat_Api_Conversation_Message = {
  content?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  model_id?: Maybe<Scalars['String']['output']>;
  order_index: Scalars['Int']['output'];
  /** An array relationship */
  parts: Array<Chat_Api_Conversation_Part>;
  /** An aggregate relationship */
  parts_aggregate: Chat_Api_Conversation_Part_Aggregate;
  provider_response_id?: Maybe<Scalars['String']['output']>;
  provider_response_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  role: Scalars['String']['output'];
  step_index?: Maybe<Scalars['Int']['output']>;
  step_type?: Maybe<Scalars['String']['output']>;
  token_usage?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  trace: Chat_Api_Conversation_Trace;
  trace_id: Scalars['uuid']['output'];
};


/** columns and relationships of "conversation_message" */
export type Chat_Api_Conversation_MessagePartsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Part_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
};


/** columns and relationships of "conversation_message" */
export type Chat_Api_Conversation_MessageParts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Part_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
};


/** columns and relationships of "conversation_message" */
export type Chat_Api_Conversation_MessageToken_UsageArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "conversation_message" */
export type Chat_Api_Conversation_Message_Aggregate = {
  aggregate?: Maybe<Chat_Api_Conversation_Message_Aggregate_Fields>;
  nodes: Array<Chat_Api_Conversation_Message>;
};

/** aggregate fields of "conversation_message" */
export type Chat_Api_Conversation_Message_Aggregate_Fields = {
  avg?: Maybe<Chat_Api_Conversation_Message_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Conversation_Message_Max_Fields>;
  min?: Maybe<Chat_Api_Conversation_Message_Min_Fields>;
  stddev?: Maybe<Chat_Api_Conversation_Message_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Api_Conversation_Message_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Api_Conversation_Message_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Api_Conversation_Message_Sum_Fields>;
  var_pop?: Maybe<Chat_Api_Conversation_Message_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Api_Conversation_Message_Var_Samp_Fields>;
  variance?: Maybe<Chat_Api_Conversation_Message_Variance_Fields>;
};


/** aggregate fields of "conversation_message" */
export type Chat_Api_Conversation_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "conversation_message" */
export type Chat_Api_Conversation_Message_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_Api_Conversation_Message_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Api_Conversation_Message_Max_Order_By>;
  min?: InputMaybe<Chat_Api_Conversation_Message_Min_Order_By>;
  stddev?: InputMaybe<Chat_Api_Conversation_Message_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_Api_Conversation_Message_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_Api_Conversation_Message_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_Api_Conversation_Message_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_Api_Conversation_Message_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_Api_Conversation_Message_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_Api_Conversation_Message_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Chat_Api_Conversation_Message_Avg_Fields = {
  order_index?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Avg_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "conversation_message". All fields are combined with a logical 'AND'. */
export type Chat_Api_Conversation_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Conversation_Message_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Conversation_Message_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  order_index?: InputMaybe<Int_Comparison_Exp>;
  parts?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
  parts_aggregate?: InputMaybe<Conversation_Part_Aggregate_Bool_Exp>;
  provider_response_id?: InputMaybe<String_Comparison_Exp>;
  provider_response_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  step_index?: InputMaybe<Int_Comparison_Exp>;
  step_type?: InputMaybe<String_Comparison_Exp>;
  token_usage?: InputMaybe<Jsonb_Comparison_Exp>;
  trace?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
  trace_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Conversation_Message_Max_Fields = {
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
  provider_response_id?: Maybe<Scalars['String']['output']>;
  provider_response_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
  step_type?: Maybe<Scalars['String']['output']>;
  trace_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  provider_response_id?: InputMaybe<Order_By>;
  provider_response_timestamp?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
  step_type?: InputMaybe<Order_By>;
  trace_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Api_Conversation_Message_Min_Fields = {
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
  provider_response_id?: Maybe<Scalars['String']['output']>;
  provider_response_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
  step_type?: Maybe<Scalars['String']['output']>;
  trace_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  provider_response_id?: InputMaybe<Order_By>;
  provider_response_timestamp?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
  step_type?: InputMaybe<Order_By>;
  trace_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "conversation_message". */
export type Chat_Api_Conversation_Message_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  parts_aggregate?: InputMaybe<Chat_Api_Conversation_Part_Aggregate_Order_By>;
  provider_response_id?: InputMaybe<Order_By>;
  provider_response_timestamp?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
  step_type?: InputMaybe<Order_By>;
  token_usage?: InputMaybe<Order_By>;
  trace?: InputMaybe<Chat_Api_Conversation_Trace_Order_By>;
  trace_id?: InputMaybe<Order_By>;
};

/** select columns of table "conversation_message" */
export enum Chat_Api_Conversation_Message_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  OrderIndex = 'order_index',
  /** column name */
  ProviderResponseId = 'provider_response_id',
  /** column name */
  ProviderResponseTimestamp = 'provider_response_timestamp',
  /** column name */
  Role = 'role',
  /** column name */
  StepIndex = 'step_index',
  /** column name */
  StepType = 'step_type',
  /** column name */
  TokenUsage = 'token_usage',
  /** column name */
  TraceId = 'trace_id'
}

/** aggregate stddev on columns */
export type Chat_Api_Conversation_Message_Stddev_Fields = {
  order_index?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Stddev_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_Api_Conversation_Message_Stddev_Pop_Fields = {
  order_index?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Stddev_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_Api_Conversation_Message_Stddev_Samp_Fields = {
  order_index?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Stddev_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "conversation_message" */
export type Chat_Api_Conversation_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Conversation_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Conversation_Message_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  provider_response_id?: InputMaybe<Scalars['String']['input']>;
  provider_response_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  step_index?: InputMaybe<Scalars['Int']['input']>;
  step_type?: InputMaybe<Scalars['String']['input']>;
  token_usage?: InputMaybe<Scalars['jsonb']['input']>;
  trace_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Chat_Api_Conversation_Message_Sum_Fields = {
  order_index?: Maybe<Scalars['Int']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Sum_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Chat_Api_Conversation_Message_Var_Pop_Fields = {
  order_index?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Var_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_Api_Conversation_Message_Var_Samp_Fields = {
  order_index?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Var_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_Api_Conversation_Message_Variance_Fields = {
  order_index?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "conversation_message" */
export type Chat_Api_Conversation_Message_Variance_Order_By = {
  order_index?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** columns and relationships of "conversation_part" */
export type Chat_Api_Conversation_Part = {
  approval_id?: Maybe<Scalars['String']['output']>;
  file_media_type?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  file_storage_key?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  message: Chat_Api_Conversation_Message;
  message_id: Scalars['uuid']['output'];
  order_index: Scalars['Int']['output'];
  text_value?: Maybe<Scalars['String']['output']>;
  tool_call_id?: Maybe<Scalars['String']['output']>;
  tool_input?: Maybe<Scalars['jsonb']['output']>;
  tool_name?: Maybe<Scalars['String']['output']>;
  tool_output?: Maybe<Scalars['jsonb']['output']>;
  type: Scalars['String']['output'];
};


/** columns and relationships of "conversation_part" */
export type Chat_Api_Conversation_PartTool_InputArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "conversation_part" */
export type Chat_Api_Conversation_PartTool_OutputArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "conversation_part" */
export type Chat_Api_Conversation_Part_Aggregate = {
  aggregate?: Maybe<Chat_Api_Conversation_Part_Aggregate_Fields>;
  nodes: Array<Chat_Api_Conversation_Part>;
};

/** aggregate fields of "conversation_part" */
export type Chat_Api_Conversation_Part_Aggregate_Fields = {
  avg?: Maybe<Chat_Api_Conversation_Part_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Conversation_Part_Max_Fields>;
  min?: Maybe<Chat_Api_Conversation_Part_Min_Fields>;
  stddev?: Maybe<Chat_Api_Conversation_Part_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Api_Conversation_Part_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Api_Conversation_Part_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Api_Conversation_Part_Sum_Fields>;
  var_pop?: Maybe<Chat_Api_Conversation_Part_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Api_Conversation_Part_Var_Samp_Fields>;
  variance?: Maybe<Chat_Api_Conversation_Part_Variance_Fields>;
};


/** aggregate fields of "conversation_part" */
export type Chat_Api_Conversation_Part_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "conversation_part" */
export type Chat_Api_Conversation_Part_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_Api_Conversation_Part_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Api_Conversation_Part_Max_Order_By>;
  min?: InputMaybe<Chat_Api_Conversation_Part_Min_Order_By>;
  stddev?: InputMaybe<Chat_Api_Conversation_Part_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_Api_Conversation_Part_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_Api_Conversation_Part_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_Api_Conversation_Part_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_Api_Conversation_Part_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_Api_Conversation_Part_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_Api_Conversation_Part_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Chat_Api_Conversation_Part_Avg_Fields = {
  file_size?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Avg_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "conversation_part". All fields are combined with a logical 'AND'. */
export type Chat_Api_Conversation_Part_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Conversation_Part_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Conversation_Part_Bool_Exp>>;
  approval_id?: InputMaybe<String_Comparison_Exp>;
  file_media_type?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  file_size?: InputMaybe<Int_Comparison_Exp>;
  file_storage_key?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
  message_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_index?: InputMaybe<Int_Comparison_Exp>;
  text_value?: InputMaybe<String_Comparison_Exp>;
  tool_call_id?: InputMaybe<String_Comparison_Exp>;
  tool_input?: InputMaybe<Jsonb_Comparison_Exp>;
  tool_name?: InputMaybe<String_Comparison_Exp>;
  tool_output?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Conversation_Part_Max_Fields = {
  approval_id?: Maybe<Scalars['String']['output']>;
  file_media_type?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  file_storage_key?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
  text_value?: Maybe<Scalars['String']['output']>;
  tool_call_id?: Maybe<Scalars['String']['output']>;
  tool_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Max_Order_By = {
  approval_id?: InputMaybe<Order_By>;
  file_media_type?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  file_storage_key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  text_value?: InputMaybe<Order_By>;
  tool_call_id?: InputMaybe<Order_By>;
  tool_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Api_Conversation_Part_Min_Fields = {
  approval_id?: Maybe<Scalars['String']['output']>;
  file_media_type?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  file_storage_key?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['uuid']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
  text_value?: Maybe<Scalars['String']['output']>;
  tool_call_id?: Maybe<Scalars['String']['output']>;
  tool_name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Min_Order_By = {
  approval_id?: InputMaybe<Order_By>;
  file_media_type?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  file_storage_key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  text_value?: InputMaybe<Order_By>;
  tool_call_id?: InputMaybe<Order_By>;
  tool_name?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "conversation_part". */
export type Chat_Api_Conversation_Part_Order_By = {
  approval_id?: InputMaybe<Order_By>;
  file_media_type?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  file_size?: InputMaybe<Order_By>;
  file_storage_key?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Chat_Api_Conversation_Message_Order_By>;
  message_id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  text_value?: InputMaybe<Order_By>;
  tool_call_id?: InputMaybe<Order_By>;
  tool_input?: InputMaybe<Order_By>;
  tool_name?: InputMaybe<Order_By>;
  tool_output?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "conversation_part" */
export enum Chat_Api_Conversation_Part_Select_Column {
  /** column name */
  ApprovalId = 'approval_id',
  /** column name */
  FileMediaType = 'file_media_type',
  /** column name */
  FileName = 'file_name',
  /** column name */
  FileSize = 'file_size',
  /** column name */
  FileStorageKey = 'file_storage_key',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  OrderIndex = 'order_index',
  /** column name */
  TextValue = 'text_value',
  /** column name */
  ToolCallId = 'tool_call_id',
  /** column name */
  ToolInput = 'tool_input',
  /** column name */
  ToolName = 'tool_name',
  /** column name */
  ToolOutput = 'tool_output',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Chat_Api_Conversation_Part_Stddev_Fields = {
  file_size?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Stddev_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_Api_Conversation_Part_Stddev_Pop_Fields = {
  file_size?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Stddev_Pop_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_Api_Conversation_Part_Stddev_Samp_Fields = {
  file_size?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Stddev_Samp_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "conversation_part" */
export type Chat_Api_Conversation_Part_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Conversation_Part_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Conversation_Part_Stream_Cursor_Value_Input = {
  approval_id?: InputMaybe<Scalars['String']['input']>;
  file_media_type?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  file_size?: InputMaybe<Scalars['Int']['input']>;
  file_storage_key?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  message_id?: InputMaybe<Scalars['uuid']['input']>;
  order_index?: InputMaybe<Scalars['Int']['input']>;
  text_value?: InputMaybe<Scalars['String']['input']>;
  tool_call_id?: InputMaybe<Scalars['String']['input']>;
  tool_input?: InputMaybe<Scalars['jsonb']['input']>;
  tool_name?: InputMaybe<Scalars['String']['input']>;
  tool_output?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Chat_Api_Conversation_Part_Sum_Fields = {
  file_size?: Maybe<Scalars['Int']['output']>;
  order_index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Sum_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Chat_Api_Conversation_Part_Var_Pop_Fields = {
  file_size?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Var_Pop_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_Api_Conversation_Part_Var_Samp_Fields = {
  file_size?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Var_Samp_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_Api_Conversation_Part_Variance_Fields = {
  file_size?: Maybe<Scalars['Float']['output']>;
  order_index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "conversation_part" */
export type Chat_Api_Conversation_Part_Variance_Order_By = {
  file_size?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
};

/** columns and relationships of "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call = {
  created_at: Scalars['timestamptz']['output'];
  duration_ms?: Maybe<Scalars['Int']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  started_at: Scalars['timestamptz']['output'];
  step_index?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  timed_out: Scalars['Boolean']['output'];
  tool_call_id: Scalars['String']['output'];
  tool_name: Scalars['String']['output'];
  /** An object relationship */
  trace: Chat_Api_Conversation_Trace;
  trace_id: Scalars['uuid']['output'];
};

/** aggregated selection of "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Aggregate = {
  aggregate?: Maybe<Chat_Api_Conversation_Tool_Call_Aggregate_Fields>;
  nodes: Array<Chat_Api_Conversation_Tool_Call>;
};

/** aggregate fields of "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Aggregate_Fields = {
  avg?: Maybe<Chat_Api_Conversation_Tool_Call_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Conversation_Tool_Call_Max_Fields>;
  min?: Maybe<Chat_Api_Conversation_Tool_Call_Min_Fields>;
  stddev?: Maybe<Chat_Api_Conversation_Tool_Call_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Api_Conversation_Tool_Call_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Api_Conversation_Tool_Call_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Api_Conversation_Tool_Call_Sum_Fields>;
  var_pop?: Maybe<Chat_Api_Conversation_Tool_Call_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Api_Conversation_Tool_Call_Var_Samp_Fields>;
  variance?: Maybe<Chat_Api_Conversation_Tool_Call_Variance_Fields>;
};


/** aggregate fields of "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_Api_Conversation_Tool_Call_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Api_Conversation_Tool_Call_Max_Order_By>;
  min?: InputMaybe<Chat_Api_Conversation_Tool_Call_Min_Order_By>;
  stddev?: InputMaybe<Chat_Api_Conversation_Tool_Call_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_Api_Conversation_Tool_Call_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_Api_Conversation_Tool_Call_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_Api_Conversation_Tool_Call_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_Api_Conversation_Tool_Call_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_Api_Conversation_Tool_Call_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_Api_Conversation_Tool_Call_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Chat_Api_Conversation_Tool_Call_Avg_Fields = {
  duration_ms?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Avg_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "conversation_tool_call". All fields are combined with a logical 'AND'. */
export type Chat_Api_Conversation_Tool_Call_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  duration_ms?: InputMaybe<Int_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  finished_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  started_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  step_index?: InputMaybe<Int_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  timed_out?: InputMaybe<Boolean_Comparison_Exp>;
  tool_call_id?: InputMaybe<String_Comparison_Exp>;
  tool_name?: InputMaybe<String_Comparison_Exp>;
  trace?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
  trace_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Conversation_Tool_Call_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duration_ms?: Maybe<Scalars['Int']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
  tool_call_id?: Maybe<Scalars['String']['output']>;
  tool_name?: Maybe<Scalars['String']['output']>;
  trace_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
  tool_call_id?: InputMaybe<Order_By>;
  tool_name?: InputMaybe<Order_By>;
  trace_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Api_Conversation_Tool_Call_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  duration_ms?: Maybe<Scalars['Int']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  started_at?: Maybe<Scalars['timestamptz']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
  tool_call_id?: Maybe<Scalars['String']['output']>;
  tool_name?: Maybe<Scalars['String']['output']>;
  trace_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
  tool_call_id?: InputMaybe<Order_By>;
  tool_name?: InputMaybe<Order_By>;
  trace_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "conversation_tool_call". */
export type Chat_Api_Conversation_Tool_Call_Order_By = {
  created_at?: InputMaybe<Order_By>;
  duration_ms?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  started_at?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  timed_out?: InputMaybe<Order_By>;
  tool_call_id?: InputMaybe<Order_By>;
  tool_name?: InputMaybe<Order_By>;
  trace?: InputMaybe<Chat_Api_Conversation_Trace_Order_By>;
  trace_id?: InputMaybe<Order_By>;
};

/** select columns of table "conversation_tool_call" */
export enum Chat_Api_Conversation_Tool_Call_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DurationMs = 'duration_ms',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  StartedAt = 'started_at',
  /** column name */
  StepIndex = 'step_index',
  /** column name */
  Success = 'success',
  /** column name */
  TimedOut = 'timed_out',
  /** column name */
  ToolCallId = 'tool_call_id',
  /** column name */
  ToolName = 'tool_name',
  /** column name */
  TraceId = 'trace_id'
}

/** select "conversation_tool_call_aggregate_bool_exp_bool_and_arguments_columns" columns of table "conversation_tool_call" */
export enum Chat_Api_Conversation_Tool_Call_Select_Column_Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Success = 'success',
  /** column name */
  TimedOut = 'timed_out'
}

/** select "conversation_tool_call_aggregate_bool_exp_bool_or_arguments_columns" columns of table "conversation_tool_call" */
export enum Chat_Api_Conversation_Tool_Call_Select_Column_Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Success = 'success',
  /** column name */
  TimedOut = 'timed_out'
}

/** aggregate stddev on columns */
export type Chat_Api_Conversation_Tool_Call_Stddev_Fields = {
  duration_ms?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Stddev_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_Api_Conversation_Tool_Call_Stddev_Pop_Fields = {
  duration_ms?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Stddev_Pop_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_Api_Conversation_Tool_Call_Stddev_Samp_Fields = {
  duration_ms?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Stddev_Samp_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Conversation_Tool_Call_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Conversation_Tool_Call_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  duration_ms?: InputMaybe<Scalars['Int']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  started_at?: InputMaybe<Scalars['timestamptz']['input']>;
  step_index?: InputMaybe<Scalars['Int']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  timed_out?: InputMaybe<Scalars['Boolean']['input']>;
  tool_call_id?: InputMaybe<Scalars['String']['input']>;
  tool_name?: InputMaybe<Scalars['String']['input']>;
  trace_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Chat_Api_Conversation_Tool_Call_Sum_Fields = {
  duration_ms?: Maybe<Scalars['Int']['output']>;
  step_index?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Sum_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Chat_Api_Conversation_Tool_Call_Var_Pop_Fields = {
  duration_ms?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Var_Pop_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_Api_Conversation_Tool_Call_Var_Samp_Fields = {
  duration_ms?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Var_Samp_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_Api_Conversation_Tool_Call_Variance_Fields = {
  duration_ms?: Maybe<Scalars['Float']['output']>;
  step_index?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "conversation_tool_call" */
export type Chat_Api_Conversation_Tool_Call_Variance_Order_By = {
  duration_ms?: InputMaybe<Order_By>;
  step_index?: InputMaybe<Order_By>;
};

/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_Trace = {
  /** An object relationship */
  chat: Chat_Api_Chat;
  chat_id: Scalars['uuid']['output'];
  client?: Maybe<Scalars['String']['output']>;
  cost_usd?: Maybe<Scalars['numeric']['output']>;
  created_at: Scalars['timestamptz']['output'];
  device_browser?: Maybe<Scalars['String']['output']>;
  device_form?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  finish_reason?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  messages: Array<Chat_Api_Conversation_Message>;
  /** An aggregate relationship */
  messages_aggregate: Chat_Api_Conversation_Message_Aggregate;
  model_id?: Maybe<Scalars['String']['output']>;
  provider_metadata?: Maybe<Scalars['jsonb']['output']>;
  raw_finish_reason?: Maybe<Scalars['String']['output']>;
  screen_h?: Maybe<Scalars['Int']['output']>;
  screen_w?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  stream_id?: Maybe<Scalars['String']['output']>;
  token_usage?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  tool_calls: Array<Chat_Api_Conversation_Tool_Call>;
  /** An aggregate relationship */
  tool_calls_aggregate: Chat_Api_Conversation_Tool_Call_Aggregate;
  user_agent?: Maybe<Scalars['String']['output']>;
  viewport_h?: Maybe<Scalars['Int']['output']>;
  viewport_w?: Maybe<Scalars['Int']['output']>;
  warnings?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_TraceMessagesArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
};


/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_TraceMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
};


/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_TraceProvider_MetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_TraceToken_UsageArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_TraceTool_CallsArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
};


/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_TraceTool_Calls_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
};


/** columns and relationships of "conversation_trace" */
export type Chat_Api_Conversation_TraceWarningsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "conversation_trace" */
export type Chat_Api_Conversation_Trace_Aggregate = {
  aggregate?: Maybe<Chat_Api_Conversation_Trace_Aggregate_Fields>;
  nodes: Array<Chat_Api_Conversation_Trace>;
};

/** aggregate fields of "conversation_trace" */
export type Chat_Api_Conversation_Trace_Aggregate_Fields = {
  avg?: Maybe<Chat_Api_Conversation_Trace_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Conversation_Trace_Max_Fields>;
  min?: Maybe<Chat_Api_Conversation_Trace_Min_Fields>;
  stddev?: Maybe<Chat_Api_Conversation_Trace_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Api_Conversation_Trace_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Api_Conversation_Trace_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Api_Conversation_Trace_Sum_Fields>;
  var_pop?: Maybe<Chat_Api_Conversation_Trace_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Api_Conversation_Trace_Var_Samp_Fields>;
  variance?: Maybe<Chat_Api_Conversation_Trace_Variance_Fields>;
};


/** aggregate fields of "conversation_trace" */
export type Chat_Api_Conversation_Trace_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_Api_Conversation_Trace_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Api_Conversation_Trace_Max_Order_By>;
  min?: InputMaybe<Chat_Api_Conversation_Trace_Min_Order_By>;
  stddev?: InputMaybe<Chat_Api_Conversation_Trace_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_Api_Conversation_Trace_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_Api_Conversation_Trace_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_Api_Conversation_Trace_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_Api_Conversation_Trace_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_Api_Conversation_Trace_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_Api_Conversation_Trace_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Chat_Api_Conversation_Trace_Avg_Fields = {
  cost_usd?: Maybe<Scalars['Float']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Float']['output']>;
  screen_w?: Maybe<Scalars['Float']['output']>;
  viewport_h?: Maybe<Scalars['Float']['output']>;
  viewport_w?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Avg_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "conversation_trace". All fields are combined with a logical 'AND'. */
export type Chat_Api_Conversation_Trace_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Conversation_Trace_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Conversation_Trace_Bool_Exp>>;
  chat?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
  chat_id?: InputMaybe<Uuid_Comparison_Exp>;
  client?: InputMaybe<String_Comparison_Exp>;
  cost_usd?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  device_browser?: InputMaybe<String_Comparison_Exp>;
  device_form?: InputMaybe<String_Comparison_Exp>;
  device_model?: InputMaybe<String_Comparison_Exp>;
  device_os?: InputMaybe<String_Comparison_Exp>;
  dpr?: InputMaybe<Float_Comparison_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  finish_reason?: InputMaybe<String_Comparison_Exp>;
  finished_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  location_city?: InputMaybe<String_Comparison_Exp>;
  location_country?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
  messages_aggregate?: InputMaybe<Conversation_Message_Aggregate_Bool_Exp>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  provider_metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  raw_finish_reason?: InputMaybe<String_Comparison_Exp>;
  screen_h?: InputMaybe<Int_Comparison_Exp>;
  screen_w?: InputMaybe<Int_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  stream_id?: InputMaybe<String_Comparison_Exp>;
  token_usage?: InputMaybe<Jsonb_Comparison_Exp>;
  tool_calls?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
  tool_calls_aggregate?: InputMaybe<Conversation_Tool_Call_Aggregate_Bool_Exp>;
  user_agent?: InputMaybe<String_Comparison_Exp>;
  viewport_h?: InputMaybe<Int_Comparison_Exp>;
  viewport_w?: InputMaybe<Int_Comparison_Exp>;
  warnings?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Conversation_Trace_Max_Fields = {
  chat_id?: Maybe<Scalars['uuid']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  cost_usd?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_browser?: Maybe<Scalars['String']['output']>;
  device_form?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  finish_reason?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  raw_finish_reason?: Maybe<Scalars['String']['output']>;
  screen_h?: Maybe<Scalars['Int']['output']>;
  screen_w?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stream_id?: Maybe<Scalars['String']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  viewport_h?: Maybe<Scalars['Int']['output']>;
  viewport_w?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Max_Order_By = {
  chat_id?: InputMaybe<Order_By>;
  client?: InputMaybe<Order_By>;
  cost_usd?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_browser?: InputMaybe<Order_By>;
  device_form?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  device_os?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  finish_reason?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_city?: InputMaybe<Order_By>;
  location_country?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  raw_finish_reason?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stream_id?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Api_Conversation_Trace_Min_Fields = {
  chat_id?: Maybe<Scalars['uuid']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  cost_usd?: Maybe<Scalars['numeric']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  device_browser?: Maybe<Scalars['String']['output']>;
  device_form?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_os?: Maybe<Scalars['String']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  finish_reason?: Maybe<Scalars['String']['output']>;
  finished_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  location_city?: Maybe<Scalars['String']['output']>;
  location_country?: Maybe<Scalars['String']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  raw_finish_reason?: Maybe<Scalars['String']['output']>;
  screen_h?: Maybe<Scalars['Int']['output']>;
  screen_w?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stream_id?: Maybe<Scalars['String']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
  viewport_h?: Maybe<Scalars['Int']['output']>;
  viewport_w?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Min_Order_By = {
  chat_id?: InputMaybe<Order_By>;
  client?: InputMaybe<Order_By>;
  cost_usd?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_browser?: InputMaybe<Order_By>;
  device_form?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  device_os?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  finish_reason?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_city?: InputMaybe<Order_By>;
  location_country?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  raw_finish_reason?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stream_id?: InputMaybe<Order_By>;
  user_agent?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "conversation_trace". */
export type Chat_Api_Conversation_Trace_Order_By = {
  chat?: InputMaybe<Chat_Api_Chat_Order_By>;
  chat_id?: InputMaybe<Order_By>;
  client?: InputMaybe<Order_By>;
  cost_usd?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  device_browser?: InputMaybe<Order_By>;
  device_form?: InputMaybe<Order_By>;
  device_model?: InputMaybe<Order_By>;
  device_os?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  finish_reason?: InputMaybe<Order_By>;
  finished_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location_city?: InputMaybe<Order_By>;
  location_country?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Chat_Api_Conversation_Message_Aggregate_Order_By>;
  model_id?: InputMaybe<Order_By>;
  provider_metadata?: InputMaybe<Order_By>;
  raw_finish_reason?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stream_id?: InputMaybe<Order_By>;
  token_usage?: InputMaybe<Order_By>;
  tool_calls_aggregate?: InputMaybe<Chat_Api_Conversation_Tool_Call_Aggregate_Order_By>;
  user_agent?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
  warnings?: InputMaybe<Order_By>;
};

/** select columns of table "conversation_trace" */
export enum Chat_Api_Conversation_Trace_Select_Column {
  /** column name */
  ChatId = 'chat_id',
  /** column name */
  Client = 'client',
  /** column name */
  CostUsd = 'cost_usd',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeviceBrowser = 'device_browser',
  /** column name */
  DeviceForm = 'device_form',
  /** column name */
  DeviceModel = 'device_model',
  /** column name */
  DeviceOs = 'device_os',
  /** column name */
  Dpr = 'dpr',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  FinishReason = 'finish_reason',
  /** column name */
  FinishedAt = 'finished_at',
  /** column name */
  Id = 'id',
  /** column name */
  LocationCity = 'location_city',
  /** column name */
  LocationCountry = 'location_country',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  ProviderMetadata = 'provider_metadata',
  /** column name */
  RawFinishReason = 'raw_finish_reason',
  /** column name */
  ScreenH = 'screen_h',
  /** column name */
  ScreenW = 'screen_w',
  /** column name */
  Status = 'status',
  /** column name */
  StreamId = 'stream_id',
  /** column name */
  TokenUsage = 'token_usage',
  /** column name */
  UserAgent = 'user_agent',
  /** column name */
  ViewportH = 'viewport_h',
  /** column name */
  ViewportW = 'viewport_w',
  /** column name */
  Warnings = 'warnings'
}

/** aggregate stddev on columns */
export type Chat_Api_Conversation_Trace_Stddev_Fields = {
  cost_usd?: Maybe<Scalars['Float']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Float']['output']>;
  screen_w?: Maybe<Scalars['Float']['output']>;
  viewport_h?: Maybe<Scalars['Float']['output']>;
  viewport_w?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Stddev_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_Api_Conversation_Trace_Stddev_Pop_Fields = {
  cost_usd?: Maybe<Scalars['Float']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Float']['output']>;
  screen_w?: Maybe<Scalars['Float']['output']>;
  viewport_h?: Maybe<Scalars['Float']['output']>;
  viewport_w?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Stddev_Pop_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_Api_Conversation_Trace_Stddev_Samp_Fields = {
  cost_usd?: Maybe<Scalars['Float']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Float']['output']>;
  screen_w?: Maybe<Scalars['Float']['output']>;
  viewport_h?: Maybe<Scalars['Float']['output']>;
  viewport_w?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Stddev_Samp_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Conversation_Trace_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Conversation_Trace_Stream_Cursor_Value_Input = {
  chat_id?: InputMaybe<Scalars['uuid']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  cost_usd?: InputMaybe<Scalars['numeric']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  device_browser?: InputMaybe<Scalars['String']['input']>;
  device_form?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_os?: InputMaybe<Scalars['String']['input']>;
  dpr?: InputMaybe<Scalars['Float']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  finish_reason?: InputMaybe<Scalars['String']['input']>;
  finished_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  location_city?: InputMaybe<Scalars['String']['input']>;
  location_country?: InputMaybe<Scalars['String']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['jsonb']['input']>;
  raw_finish_reason?: InputMaybe<Scalars['String']['input']>;
  screen_h?: InputMaybe<Scalars['Int']['input']>;
  screen_w?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stream_id?: InputMaybe<Scalars['String']['input']>;
  token_usage?: InputMaybe<Scalars['jsonb']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
  viewport_h?: InputMaybe<Scalars['Int']['input']>;
  viewport_w?: InputMaybe<Scalars['Int']['input']>;
  warnings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type Chat_Api_Conversation_Trace_Sum_Fields = {
  cost_usd?: Maybe<Scalars['numeric']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Int']['output']>;
  screen_w?: Maybe<Scalars['Int']['output']>;
  viewport_h?: Maybe<Scalars['Int']['output']>;
  viewport_w?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Sum_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Chat_Api_Conversation_Trace_Var_Pop_Fields = {
  cost_usd?: Maybe<Scalars['Float']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Float']['output']>;
  screen_w?: Maybe<Scalars['Float']['output']>;
  viewport_h?: Maybe<Scalars['Float']['output']>;
  viewport_w?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Var_Pop_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_Api_Conversation_Trace_Var_Samp_Fields = {
  cost_usd?: Maybe<Scalars['Float']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Float']['output']>;
  screen_w?: Maybe<Scalars['Float']['output']>;
  viewport_h?: Maybe<Scalars['Float']['output']>;
  viewport_w?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Var_Samp_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_Api_Conversation_Trace_Variance_Fields = {
  cost_usd?: Maybe<Scalars['Float']['output']>;
  dpr?: Maybe<Scalars['Float']['output']>;
  screen_h?: Maybe<Scalars['Float']['output']>;
  screen_w?: Maybe<Scalars['Float']['output']>;
  viewport_h?: Maybe<Scalars['Float']['output']>;
  viewport_w?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "conversation_trace" */
export type Chat_Api_Conversation_Trace_Variance_Order_By = {
  cost_usd?: InputMaybe<Order_By>;
  dpr?: InputMaybe<Order_By>;
  screen_h?: InputMaybe<Order_By>;
  screen_w?: InputMaybe<Order_By>;
  viewport_h?: InputMaybe<Order_By>;
  viewport_w?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Chat_Api_Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "Message_v2" */
export type Chat_Api_Message = {
  attachments: Scalars['jsonb']['output'];
  /** An object relationship */
  chat: Chat_Api_Chat;
  chatId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  parts: Scalars['jsonb']['output'];
  role: Scalars['String']['output'];
};


/** columns and relationships of "Message_v2" */
export type Chat_Api_MessageAttachmentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Message_v2" */
export type Chat_Api_MessageMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Message_v2" */
export type Chat_Api_MessagePartsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "Message_v2" */
export type Chat_Api_Message_Aggregate = {
  aggregate?: Maybe<Chat_Api_Message_Aggregate_Fields>;
  nodes: Array<Chat_Api_Message>;
};

/** aggregate fields of "Message_v2" */
export type Chat_Api_Message_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Message_Max_Fields>;
  min?: Maybe<Chat_Api_Message_Min_Fields>;
};


/** aggregate fields of "Message_v2" */
export type Chat_Api_Message_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Message_v2" */
export type Chat_Api_Message_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Api_Message_Max_Order_By>;
  min?: InputMaybe<Chat_Api_Message_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "Message_v2". All fields are combined with a logical 'AND'. */
export type Chat_Api_Message_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Message_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Message_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Message_Bool_Exp>>;
  attachments?: InputMaybe<Jsonb_Comparison_Exp>;
  chat?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
  chatId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  parts?: InputMaybe<Jsonb_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Message_Max_Fields = {
  chatId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Message_v2" */
export type Chat_Api_Message_Max_Order_By = {
  chatId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Api_Message_Min_Fields = {
  chatId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Message_v2" */
export type Chat_Api_Message_Min_Order_By = {
  chatId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "Message_v2". */
export type Chat_Api_Message_Order_By = {
  attachments?: InputMaybe<Order_By>;
  chat?: InputMaybe<Chat_Api_Chat_Order_By>;
  chatId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  parts?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
};

/** select columns of table "Message_v2" */
export enum Chat_Api_Message_Select_Column {
  /** column name */
  Attachments = 'attachments',
  /** column name */
  ChatId = 'chatId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  Parts = 'parts',
  /** column name */
  Role = 'role'
}

/** Streaming cursor of the table "message" */
export type Chat_Api_Message_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Message_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Message_Stream_Cursor_Value_Input = {
  attachments?: InputMaybe<Scalars['jsonb']['input']>;
  chatId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  parts?: InputMaybe<Scalars['jsonb']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "model_pricing" */
export type Chat_Api_Model_Pricing = {
  effective_from: Scalars['timestamp']['output'];
  effective_until?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  model_id: Scalars['String']['output'];
  /** An object relationship */
  model_setting?: Maybe<Chat_Api_Chat_Model_Setting>;
  price_per_million: Scalars['numeric']['output'];
  token_type: Scalars['String']['output'];
};

/** aggregated selection of "model_pricing" */
export type Chat_Api_Model_Pricing_Aggregate = {
  aggregate?: Maybe<Chat_Api_Model_Pricing_Aggregate_Fields>;
  nodes: Array<Chat_Api_Model_Pricing>;
};

/** aggregate fields of "model_pricing" */
export type Chat_Api_Model_Pricing_Aggregate_Fields = {
  avg?: Maybe<Chat_Api_Model_Pricing_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Model_Pricing_Max_Fields>;
  min?: Maybe<Chat_Api_Model_Pricing_Min_Fields>;
  stddev?: Maybe<Chat_Api_Model_Pricing_Stddev_Fields>;
  stddev_pop?: Maybe<Chat_Api_Model_Pricing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Chat_Api_Model_Pricing_Stddev_Samp_Fields>;
  sum?: Maybe<Chat_Api_Model_Pricing_Sum_Fields>;
  var_pop?: Maybe<Chat_Api_Model_Pricing_Var_Pop_Fields>;
  var_samp?: Maybe<Chat_Api_Model_Pricing_Var_Samp_Fields>;
  variance?: Maybe<Chat_Api_Model_Pricing_Variance_Fields>;
};


/** aggregate fields of "model_pricing" */
export type Chat_Api_Model_Pricing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "model_pricing" */
export type Chat_Api_Model_Pricing_Aggregate_Order_By = {
  avg?: InputMaybe<Chat_Api_Model_Pricing_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Api_Model_Pricing_Max_Order_By>;
  min?: InputMaybe<Chat_Api_Model_Pricing_Min_Order_By>;
  stddev?: InputMaybe<Chat_Api_Model_Pricing_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Chat_Api_Model_Pricing_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Chat_Api_Model_Pricing_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Chat_Api_Model_Pricing_Sum_Order_By>;
  var_pop?: InputMaybe<Chat_Api_Model_Pricing_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Chat_Api_Model_Pricing_Var_Samp_Order_By>;
  variance?: InputMaybe<Chat_Api_Model_Pricing_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Chat_Api_Model_Pricing_Avg_Fields = {
  price_per_million?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Avg_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "model_pricing". All fields are combined with a logical 'AND'. */
export type Chat_Api_Model_Pricing_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Model_Pricing_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Model_Pricing_Bool_Exp>>;
  effective_from?: InputMaybe<Timestamp_Comparison_Exp>;
  effective_until?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  model_id?: InputMaybe<String_Comparison_Exp>;
  model_setting?: InputMaybe<Chat_Api_Chat_Model_Setting_Bool_Exp>;
  price_per_million?: InputMaybe<Numeric_Comparison_Exp>;
  token_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Model_Pricing_Max_Fields = {
  effective_from?: Maybe<Scalars['timestamp']['output']>;
  effective_until?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  price_per_million?: Maybe<Scalars['numeric']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Max_Order_By = {
  effective_from?: InputMaybe<Order_By>;
  effective_until?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  price_per_million?: InputMaybe<Order_By>;
  token_type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Api_Model_Pricing_Min_Fields = {
  effective_from?: Maybe<Scalars['timestamp']['output']>;
  effective_until?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  model_id?: Maybe<Scalars['String']['output']>;
  price_per_million?: Maybe<Scalars['numeric']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Min_Order_By = {
  effective_from?: InputMaybe<Order_By>;
  effective_until?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  price_per_million?: InputMaybe<Order_By>;
  token_type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "model_pricing". */
export type Chat_Api_Model_Pricing_Order_By = {
  effective_from?: InputMaybe<Order_By>;
  effective_until?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  model_id?: InputMaybe<Order_By>;
  model_setting?: InputMaybe<Chat_Api_Chat_Model_Setting_Order_By>;
  price_per_million?: InputMaybe<Order_By>;
  token_type?: InputMaybe<Order_By>;
};

/** select columns of table "model_pricing" */
export enum Chat_Api_Model_Pricing_Select_Column {
  /** column name */
  EffectiveFrom = 'effective_from',
  /** column name */
  EffectiveUntil = 'effective_until',
  /** column name */
  Id = 'id',
  /** column name */
  ModelId = 'model_id',
  /** column name */
  PricePerMillion = 'price_per_million',
  /** column name */
  TokenType = 'token_type'
}

/** aggregate stddev on columns */
export type Chat_Api_Model_Pricing_Stddev_Fields = {
  price_per_million?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Stddev_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Chat_Api_Model_Pricing_Stddev_Pop_Fields = {
  price_per_million?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Stddev_Pop_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Chat_Api_Model_Pricing_Stddev_Samp_Fields = {
  price_per_million?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Stddev_Samp_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "model_pricing" */
export type Chat_Api_Model_Pricing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Model_Pricing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Model_Pricing_Stream_Cursor_Value_Input = {
  effective_from?: InputMaybe<Scalars['timestamp']['input']>;
  effective_until?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  model_id?: InputMaybe<Scalars['String']['input']>;
  price_per_million?: InputMaybe<Scalars['numeric']['input']>;
  token_type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Chat_Api_Model_Pricing_Sum_Fields = {
  price_per_million?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Sum_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Chat_Api_Model_Pricing_Var_Pop_Fields = {
  price_per_million?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Var_Pop_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Chat_Api_Model_Pricing_Var_Samp_Fields = {
  price_per_million?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Var_Samp_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Chat_Api_Model_Pricing_Variance_Fields = {
  price_per_million?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "model_pricing" */
export type Chat_Api_Model_Pricing_Variance_Order_By = {
  price_per_million?: InputMaybe<Order_By>;
};

/** columns and relationships of "MutationAudit" */
export type Chat_Api_Mutation_Audit = {
  /** An object relationship */
  chat?: Maybe<Chat_Api_Chat>;
  chatId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  operation: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId: Scalars['uuid']['output'];
  variables?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "MutationAudit" */
export type Chat_Api_Mutation_AuditVariablesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "MutationAudit" */
export type Chat_Api_Mutation_Audit_Aggregate = {
  aggregate?: Maybe<Chat_Api_Mutation_Audit_Aggregate_Fields>;
  nodes: Array<Chat_Api_Mutation_Audit>;
};

/** aggregate fields of "MutationAudit" */
export type Chat_Api_Mutation_Audit_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Chat_Api_Mutation_Audit_Max_Fields>;
  min?: Maybe<Chat_Api_Mutation_Audit_Min_Fields>;
};


/** aggregate fields of "MutationAudit" */
export type Chat_Api_Mutation_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "MutationAudit" */
export type Chat_Api_Mutation_Audit_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Chat_Api_Mutation_Audit_Max_Order_By>;
  min?: InputMaybe<Chat_Api_Mutation_Audit_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "MutationAudit". All fields are combined with a logical 'AND'. */
export type Chat_Api_Mutation_Audit_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Api_Mutation_Audit_Bool_Exp>>;
  _not?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Api_Mutation_Audit_Bool_Exp>>;
  chat?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
  chatId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<String_Comparison_Exp>;
  result?: InputMaybe<String_Comparison_Exp>;
  success?: InputMaybe<Boolean_Comparison_Exp>;
  userId?: InputMaybe<Uuid_Comparison_Exp>;
  variables?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** aggregate max on columns */
export type Chat_Api_Mutation_Audit_Max_Fields = {
  chatId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "MutationAudit" */
export type Chat_Api_Mutation_Audit_Max_Order_By = {
  chatId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Chat_Api_Mutation_Audit_Min_Fields = {
  chatId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "MutationAudit" */
export type Chat_Api_Mutation_Audit_Min_Order_By = {
  chatId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "MutationAudit". */
export type Chat_Api_Mutation_Audit_Order_By = {
  chat?: InputMaybe<Chat_Api_Chat_Order_By>;
  chatId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  success?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
};

/** select columns of table "MutationAudit" */
export enum Chat_Api_Mutation_Audit_Select_Column {
  /** column name */
  ChatId = 'chatId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Operation = 'operation',
  /** column name */
  Result = 'result',
  /** column name */
  Success = 'success',
  /** column name */
  UserId = 'userId',
  /** column name */
  Variables = 'variables'
}

/** select "mutation_audit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "MutationAudit" */
export enum Chat_Api_Mutation_Audit_Select_Column_Mutation_Audit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Success = 'success'
}

/** select "mutation_audit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "MutationAudit" */
export enum Chat_Api_Mutation_Audit_Select_Column_Mutation_Audit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Success = 'success'
}

/** Streaming cursor of the table "mutation_audit" */
export type Chat_Api_Mutation_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Api_Mutation_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Chat_Api_Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Api_Mutation_Audit_Stream_Cursor_Value_Input = {
  chatId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
  success?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  variables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** columns and relationships of "cma_report_files" */
export type Cma_Report_Files = {
  /** An object relationship */
  cma_report?: Maybe<Cma_Reports>;
  cma_report_id: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  is_visible: Scalars['Boolean']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_report_files" */
export type Cma_Report_Files_Aggregate = {
  aggregate?: Maybe<Cma_Report_Files_Aggregate_Fields>;
  nodes: Array<Cma_Report_Files>;
};

export type Cma_Report_Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp_Count>;
};

export type Cma_Report_Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Report_Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "cma_report_files" */
export type Cma_Report_Files_Aggregate_Fields = {
  avg?: Maybe<Cma_Report_Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cma_Report_Files_Max_Fields>;
  min?: Maybe<Cma_Report_Files_Min_Fields>;
  stddev?: Maybe<Cma_Report_Files_Stddev_Fields>;
  stddev_pop?: Maybe<Cma_Report_Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cma_Report_Files_Stddev_Samp_Fields>;
  sum?: Maybe<Cma_Report_Files_Sum_Fields>;
  var_pop?: Maybe<Cma_Report_Files_Var_Pop_Fields>;
  var_samp?: Maybe<Cma_Report_Files_Var_Samp_Fields>;
  variance?: Maybe<Cma_Report_Files_Variance_Fields>;
};


/** aggregate fields of "cma_report_files" */
export type Cma_Report_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cma_report_files" */
export type Cma_Report_Files_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Report_Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Report_Files_Max_Order_By>;
  min?: InputMaybe<Cma_Report_Files_Min_Order_By>;
  stddev?: InputMaybe<Cma_Report_Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Report_Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Report_Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Report_Files_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Report_Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Report_Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Report_Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cma_report_files" */
export type Cma_Report_Files_Arr_Rel_Insert_Input = {
  data: Array<Cma_Report_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Report_Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Cma_Report_Files_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cma_report_files" */
export type Cma_Report_Files_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_report_files". All fields are combined with a logical 'AND'. */
export type Cma_Report_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Report_Files_Bool_Exp>>;
  _not?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Report_Files_Bool_Exp>>;
  cma_report?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "cma_report_files" */
export enum Cma_Report_Files_Constraint {
  /** unique or primary key constraint on columns "cma_report_id", "file_id" */
  CmaReportFilesCmaReportIdFileIdKey = 'cma_report_files_cma_report_id_file_id_key',
  /** unique or primary key constraint on columns "cma_report_id", "file_id" */
  CmaReportFilesPkey = 'cma_report_files_pkey',
  /** unique or primary key constraint on columns "cma_report_id", "order_nr" */
  CmaReportOrderUnique = 'cma_report_order_unique'
}

/** input type for incrementing numeric columns in table "cma_report_files" */
export type Cma_Report_Files_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cma_report_files" */
export type Cma_Report_Files_Insert_Input = {
  cma_report?: InputMaybe<Cma_Reports_Obj_Rel_Insert_Input>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Cma_Report_Files_Max_Fields = {
  cma_report_id?: Maybe<Scalars['uuid']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "cma_report_files" */
export type Cma_Report_Files_Max_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cma_Report_Files_Min_Fields = {
  cma_report_id?: Maybe<Scalars['uuid']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "cma_report_files" */
export type Cma_Report_Files_Min_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_report_files" */
export type Cma_Report_Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Report_Files>;
};

/** on_conflict condition type for table "cma_report_files" */
export type Cma_Report_Files_On_Conflict = {
  constraint: Cma_Report_Files_Constraint;
  update_columns?: Array<Cma_Report_Files_Update_Column>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_report_files". */
export type Cma_Report_Files_Order_By = {
  cma_report?: InputMaybe<Cma_Reports_Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cma_report_files */
export type Cma_Report_Files_Pk_Columns_Input = {
  cma_report_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};

/** select columns of table "cma_report_files" */
export enum Cma_Report_Files_Select_Column {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id'
}

/** select "cma_report_files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cma_report_files" */
export enum Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVisible = 'is_visible'
}

/** select "cma_report_files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cma_report_files" */
export enum Cma_Report_Files_Select_Column_Cma_Report_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVisible = 'is_visible'
}

/** input type for updating data in table "cma_report_files" */
export type Cma_Report_Files_Set_Input = {
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Cma_Report_Files_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cma_report_files" */
export type Cma_Report_Files_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cma_Report_Files_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cma_report_files" */
export type Cma_Report_Files_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cma_Report_Files_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cma_report_files" */
export type Cma_Report_Files_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_report_files" */
export type Cma_Report_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Report_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Report_Files_Stream_Cursor_Value_Input = {
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Cma_Report_Files_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cma_report_files" */
export type Cma_Report_Files_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "cma_report_files" */
export enum Cma_Report_Files_Update_Column {
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr'
}

export type Cma_Report_Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cma_Report_Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cma_Report_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cma_Report_Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cma_Report_Files_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cma_report_files" */
export type Cma_Report_Files_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cma_Report_Files_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cma_report_files" */
export type Cma_Report_Files_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cma_Report_Files_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cma_report_files" */
export type Cma_Report_Files_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "cma_report_source_enum" */
export type Cma_Report_Source_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "cma_report_source_enum". All fields are combined with a logical 'AND'. */
export type Cma_Report_Source_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Report_Source_Enum_Bool_Exp>>;
  _not?: InputMaybe<Cma_Report_Source_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Report_Source_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Cma_Report_Source_Enum_Enum {
  /** CMA created from an existing lead */
  CmaFromLead = 'cma_from_lead',
  /** CMA created from scratch without a lead */
  CmaFromScratch = 'cma_from_scratch',
  /** CMA generated via direct link with lead ID parameter */
  DirectLinkLeadId = 'direct_link_lead_id',
  /** CMA generated from the lead detail page */
  LeadDetailPage = 'lead_detail_page'
}

/** Boolean expression to compare columns of type "cma_report_source_enum_enum". All fields are combined with logical 'AND'. */
export type Cma_Report_Source_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cma_Report_Source_Enum_Enum>;
  _in?: InputMaybe<Array<Cma_Report_Source_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Cma_Report_Source_Enum_Enum>;
  _nin?: InputMaybe<Array<Cma_Report_Source_Enum_Enum>>;
};

/** Ordering options when selecting data from "cma_report_source_enum". */
export type Cma_Report_Source_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "cma_report_source_enum" */
export enum Cma_Report_Source_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "cma_report_source_enum" */
export type Cma_Report_Source_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Report_Source_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Report_Source_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_Reports = {
  adjust_price_by_evolution?: Maybe<Scalars['Boolean']['output']>;
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  cma_agent_transactions: Array<Cma_Reports_Agent_Transactions>;
  /** An array relationship */
  cma_property_transactions: Array<Cma_Reports_Property_Transactions>;
  /** An array relationship */
  cma_report_files: Array<Cma_Report_Files>;
  /** An aggregate relationship */
  cma_report_files_aggregate: Cma_Report_Files_Aggregate;
  /** An array relationship */
  cma_user_reviews: Array<Cma_Reports_User_Reviews>;
  /** An array relationship */
  comparable_listings: Array<Cma_Reports_Comparables>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  construction_cost_base?: Maybe<Cma_Reports_Construction_Base_Enum_Enum>;
  /** An object relationship */
  contact?: Maybe<Users>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cover_image?: Maybe<Images>;
  cover_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  description_de?: Maybe<Scalars['String']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_fr?: Maybe<Scalars['String']['output']>;
  description_it?: Maybe<Scalars['String']['output']>;
  description_pl?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  doc_template?: Maybe<Doc_Templates>;
  doc_template_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  doc_template_theme?: Maybe<Doc_Templates>;
  doc_template_theme_id?: Maybe<Scalars['uuid']['output']>;
  font_family?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  include_agency_description: Scalars['Boolean']['output'];
  include_agent: Scalars['Boolean']['output'];
  include_agent_agency: Scalars['Boolean']['output'];
  include_append_files: Scalars['Boolean']['output'];
  include_client_testimonial: Scalars['Boolean']['output'];
  include_comparable_listing_details: Scalars['Boolean']['output'];
  include_comparables_valuation: Scalars['Boolean']['output'];
  include_cover: Scalars['Boolean']['output'];
  include_cuprate_valuation: Scalars['Boolean']['output'];
  include_description: Scalars['Boolean']['output'];
  include_final_value: Scalars['Boolean']['output'];
  include_hedonistic_valuation: Scalars['Boolean']['output'];
  include_intrinsic_valuation: Scalars['Boolean']['output'];
  include_introduction: Scalars['Boolean']['output'];
  include_market_data: Scalars['Boolean']['output'];
  include_photos: Scalars['Boolean']['output'];
  include_poi_map: Scalars['Boolean']['output'];
  include_pois: Scalars['Boolean']['output'];
  include_potential_buyers: Scalars['Boolean']['output'];
  include_property: Scalars['Boolean']['output'];
  include_rental_comparable_listing_details: Scalars['Boolean']['output'];
  include_rental_comparables: Scalars['Boolean']['output'];
  include_transactions?: Maybe<Scalars['Boolean']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: Maybe<Scalars['jsonb']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "cma_reports_is_completed" */
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  is_price_range: Scalars['Boolean']['output'];
  is_property_comparable_listings_square_meter_calculation?: Maybe<Scalars['Boolean']['output']>;
  is_property_transaction_square_meter_calculation?: Maybe<Scalars['Boolean']['output']>;
  language: Scalars['user_language']['output'];
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  market_comparison_places?: Maybe<Scalars['jsonb']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['float8']['output']>;
  market_data_show_chart: Scalars['Boolean']['output'];
  market_data_show_map: Scalars['Boolean']['output'];
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  negative_comments?: Maybe<Scalars['String']['output']>;
  poi_map_zoom_level: Scalars['Float']['output'];
  positive_comments?: Maybe<Scalars['String']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables: Scalars['jsonb']['output'];
  rental_comparables_search_params: Scalars['jsonb']['output'];
  report_source?: Maybe<Cma_Report_Source_Enum_Enum>;
  report_title?: Maybe<Scalars['String']['output']>;
  show_comparable_listing_cards: Scalars['Boolean']['output'];
  show_full_idx_description: Scalars['Boolean']['output'];
  show_full_rental_description: Scalars['Boolean']['output'];
  show_probability: Scalars['Boolean']['output'];
  show_rental_comparable_listing_cards: Scalars['Boolean']['output'];
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode: Scalars['String']['output'];
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsAgency_Team_MembersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsCma_Agent_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsCma_Property_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Property_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Property_Transactions_Bool_Exp>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsCma_Report_FilesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsCma_Report_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsCma_User_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_User_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_User_Reviews_Order_By>>;
  where?: InputMaybe<Cma_Reports_User_Reviews_Bool_Exp>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsComparable_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Comparables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Comparables_Order_By>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsIntrinsic_Custom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsMarket_Comparison_PlacesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsRental_ComparablesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Comparative market analysis reports on a property (property_id -> properties), usually for a lead (lead_id -> leads) and its contact (contact_id -> users). broker_id -> users is the agent who owns the report. */
export type Cma_ReportsRental_Comparables_Search_ParamsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions = {
  /** An object relationship */
  cma_report: Cma_Reports;
  cma_report_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  distance_in_meters?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  transaction: Property_Transactions;
  transaction_id: Scalars['uuid']['output'];
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: Maybe<Scalars['Int']['output']>;
};

/** order by aggregate values of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Reports_Agent_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Reports_Agent_Transactions_Max_Order_By>;
  min?: InputMaybe<Cma_Reports_Agent_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Cma_Reports_Agent_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Reports_Agent_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Reports_Agent_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Reports_Agent_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Reports_Agent_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Reports_Agent_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Reports_Agent_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Cma_Reports_Agent_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_Agent_Transactions_On_Conflict>;
};

/** order by avg() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Avg_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_reports_agent_transactions". All fields are combined with a logical 'AND'. */
export type Cma_Reports_Agent_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Bool_Exp>>;
  cma_report?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Numeric_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  zone?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "cma_reports_agent_transactions" */
export enum Cma_Reports_Agent_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  CmaReportsAgentTransactionsPkey = 'cma_reports_agent_transactions_pkey',
  /** unique or primary key constraint on columns "transaction_id", "cma_report_id" */
  CmaReportsAgentTransactionsUnique = 'cma_reports_agent_transactions_unique'
}

/** input type for inserting data into table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Insert_Input = {
  cma_report?: InputMaybe<Cma_Reports_Obj_Rel_Insert_Input>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  distance_in_meters?: InputMaybe<Scalars['numeric']['input']>;
  transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Max_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Min_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Reports_Agent_Transactions>;
};

/** on_conflict condition type for table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_On_Conflict = {
  constraint: Cma_Reports_Agent_Transactions_Constraint;
  update_columns?: Array<Cma_Reports_Agent_Transactions_Update_Column>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_reports_agent_transactions". */
export type Cma_Reports_Agent_Transactions_Order_By = {
  cma_report?: InputMaybe<Cma_Reports_Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Property_Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  zone?: InputMaybe<Order_By>;
};

/** select columns of table "cma_reports_agent_transactions" */
export enum Cma_Reports_Agent_Transactions_Select_Column {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  Zone = 'zone'
}

/** order by stddev() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Stddev_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Stddev_Pop_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Stddev_Samp_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Reports_Agent_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Reports_Agent_Transactions_Stream_Cursor_Value_Input = {
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_in_meters?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Sum_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "cma_reports_agent_transactions" (current role has no relevant permissions) */
export enum Cma_Reports_Agent_Transactions_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Var_Pop_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Var_Samp_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "cma_reports_agent_transactions" */
export type Cma_Reports_Agent_Transactions_Variance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  /** Geographic zone: 1=WithinThirtyKm, 2=SameMunicipality, 3=SameDistrict, 4=SameState, 5=SameCountry, 6=DifferentCountry */
  zone?: InputMaybe<Order_By>;
};

/** aggregated selection of "cma_reports" */
export type Cma_Reports_Aggregate = {
  aggregate?: Maybe<Cma_Reports_Aggregate_Fields>;
  nodes: Array<Cma_Reports>;
};

export type Cma_Reports_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp_Var_Samp>;
};

export type Cma_Reports_Aggregate_Bool_Exp_Avg = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Bool_And = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Corr = {
  arguments: Cma_Reports_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Cma_Reports_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Cma_Reports_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Cma_Reports_Aggregate_Bool_Exp_Max = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Min = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Sum = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Cma_Reports_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Cma_Reports_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "cma_reports" */
export type Cma_Reports_Aggregate_Fields = {
  avg?: Maybe<Cma_Reports_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Cma_Reports_Max_Fields>;
  min?: Maybe<Cma_Reports_Min_Fields>;
  stddev?: Maybe<Cma_Reports_Stddev_Fields>;
  stddev_pop?: Maybe<Cma_Reports_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cma_Reports_Stddev_Samp_Fields>;
  sum?: Maybe<Cma_Reports_Sum_Fields>;
  var_pop?: Maybe<Cma_Reports_Var_Pop_Fields>;
  var_samp?: Maybe<Cma_Reports_Var_Samp_Fields>;
  variance?: Maybe<Cma_Reports_Variance_Fields>;
};


/** aggregate fields of "cma_reports" */
export type Cma_Reports_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "cma_reports" */
export type Cma_Reports_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Reports_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Reports_Max_Order_By>;
  min?: InputMaybe<Cma_Reports_Min_Order_By>;
  stddev?: InputMaybe<Cma_Reports_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Reports_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Reports_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Reports_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Reports_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Reports_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Reports_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Append_Input = {
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Scalars['jsonb']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  market_comparison_places?: InputMaybe<Scalars['jsonb']['input']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "cma_reports" */
export type Cma_Reports_Arr_Rel_Insert_Input = {
  data: Array<Cma_Reports_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};

/** aggregate avg on columns */
export type Cma_Reports_Avg_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "cma_reports" */
export type Cma_Reports_Avg_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_reports". All fields are combined with a logical 'AND'. */
export type Cma_Reports_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Reports_Bool_Exp>>;
  _not?: InputMaybe<Cma_Reports_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Reports_Bool_Exp>>;
  adjust_price_by_evolution?: InputMaybe<Boolean_Comparison_Exp>;
  agency_team_members?: InputMaybe<Jsonb_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  caprate_estimated_monthly_rent?: InputMaybe<Int_Comparison_Exp>;
  caprate_minimum_required_yield?: InputMaybe<Float_Comparison_Exp>;
  cma_agent_transactions?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
  cma_property_transactions?: InputMaybe<Cma_Reports_Property_Transactions_Bool_Exp>;
  cma_report_files?: InputMaybe<Cma_Report_Files_Bool_Exp>;
  cma_report_files_aggregate?: InputMaybe<Cma_Report_Files_Aggregate_Bool_Exp>;
  cma_user_reviews?: InputMaybe<Cma_Reports_User_Reviews_Bool_Exp>;
  comparable_listings?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
  comparable_listings_map_zoom_level?: InputMaybe<Int_Comparison_Exp>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum_Comparison_Exp>;
  contact?: InputMaybe<Users_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  cover_image?: InputMaybe<Images_Bool_Exp>;
  cover_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  description_de?: InputMaybe<String_Comparison_Exp>;
  description_en?: InputMaybe<String_Comparison_Exp>;
  description_es?: InputMaybe<String_Comparison_Exp>;
  description_fr?: InputMaybe<String_Comparison_Exp>;
  description_it?: InputMaybe<String_Comparison_Exp>;
  description_pl?: InputMaybe<String_Comparison_Exp>;
  description_pt?: InputMaybe<String_Comparison_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  doc_template_theme?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  font_family?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_agency_description?: InputMaybe<Boolean_Comparison_Exp>;
  include_agent?: InputMaybe<Boolean_Comparison_Exp>;
  include_agent_agency?: InputMaybe<Boolean_Comparison_Exp>;
  include_append_files?: InputMaybe<Boolean_Comparison_Exp>;
  include_client_testimonial?: InputMaybe<Boolean_Comparison_Exp>;
  include_comparable_listing_details?: InputMaybe<Boolean_Comparison_Exp>;
  include_comparables_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_cover?: InputMaybe<Boolean_Comparison_Exp>;
  include_cuprate_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_description?: InputMaybe<Boolean_Comparison_Exp>;
  include_final_value?: InputMaybe<Boolean_Comparison_Exp>;
  include_hedonistic_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_intrinsic_valuation?: InputMaybe<Boolean_Comparison_Exp>;
  include_introduction?: InputMaybe<Boolean_Comparison_Exp>;
  include_market_data?: InputMaybe<Boolean_Comparison_Exp>;
  include_photos?: InputMaybe<Boolean_Comparison_Exp>;
  include_poi_map?: InputMaybe<Boolean_Comparison_Exp>;
  include_pois?: InputMaybe<Boolean_Comparison_Exp>;
  include_potential_buyers?: InputMaybe<Boolean_Comparison_Exp>;
  include_property?: InputMaybe<Boolean_Comparison_Exp>;
  include_rental_comparable_listing_details?: InputMaybe<Boolean_Comparison_Exp>;
  include_rental_comparables?: InputMaybe<Boolean_Comparison_Exp>;
  include_transactions?: InputMaybe<Boolean_Comparison_Exp>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Float_Comparison_Exp>;
  intrinsic_building_surface?: InputMaybe<Float_Comparison_Exp>;
  intrinsic_construction_cost?: InputMaybe<Int_Comparison_Exp>;
  intrinsic_custom_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  intrinsic_land_value?: InputMaybe<Int_Comparison_Exp>;
  introduction?: InputMaybe<String_Comparison_Exp>;
  is_completed?: InputMaybe<Boolean_Comparison_Exp>;
  is_price_range?: InputMaybe<Boolean_Comparison_Exp>;
  is_property_comparable_listings_square_meter_calculation?: InputMaybe<Boolean_Comparison_Exp>;
  is_property_transaction_square_meter_calculation?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  market_comparison_places?: InputMaybe<Jsonb_Comparison_Exp>;
  market_data_map_zoom_level?: InputMaybe<Float8_Comparison_Exp>;
  market_data_show_chart?: InputMaybe<Boolean_Comparison_Exp>;
  market_data_show_map?: InputMaybe<Boolean_Comparison_Exp>;
  max_budget?: InputMaybe<Int_Comparison_Exp>;
  min_budget?: InputMaybe<Int_Comparison_Exp>;
  negative_comments?: InputMaybe<String_Comparison_Exp>;
  poi_map_zoom_level?: InputMaybe<Float_Comparison_Exp>;
  positive_comments?: InputMaybe<String_Comparison_Exp>;
  price_range_max?: InputMaybe<Int_Comparison_Exp>;
  price_range_min?: InputMaybe<Int_Comparison_Exp>;
  probability_max?: InputMaybe<Float_Comparison_Exp>;
  probability_min?: InputMaybe<Float_Comparison_Exp>;
  probability_time_period?: InputMaybe<Int_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Int_Comparison_Exp>;
  rental_comparables?: InputMaybe<Jsonb_Comparison_Exp>;
  rental_comparables_search_params?: InputMaybe<Jsonb_Comparison_Exp>;
  report_source?: InputMaybe<Cma_Report_Source_Enum_Enum_Comparison_Exp>;
  report_title?: InputMaybe<String_Comparison_Exp>;
  show_comparable_listing_cards?: InputMaybe<Boolean_Comparison_Exp>;
  show_full_idx_description?: InputMaybe<Boolean_Comparison_Exp>;
  show_full_rental_description?: InputMaybe<Boolean_Comparison_Exp>;
  show_probability?: InputMaybe<Boolean_Comparison_Exp>;
  show_rental_comparable_listing_cards?: InputMaybe<Boolean_Comparison_Exp>;
  sort_display_mode?: InputMaybe<String_Comparison_Exp>;
  suggested_market_value?: InputMaybe<Int_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_map_zoom_level?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "cma_reports_comparables" */
export type Cma_Reports_Comparables = {
  aggregates_db__merged_listings_clusters_id: Scalars['bigint']['output'];
  /** An object relationship */
  cma_report: Cma_Reports;
  cma_report_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  listing_snapshot?: Maybe<Scalars['jsonb']['output']>;
  order_nr: Scalars['Float']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "cma_reports_comparables" */
export type Cma_Reports_ComparablesListing_SnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Reports_Comparables_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Reports_Comparables_Max_Order_By>;
  min?: InputMaybe<Cma_Reports_Comparables_Min_Order_By>;
  stddev?: InputMaybe<Cma_Reports_Comparables_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Reports_Comparables_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Reports_Comparables_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Reports_Comparables_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Reports_Comparables_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Reports_Comparables_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Reports_Comparables_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Comparables_Append_Input = {
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Arr_Rel_Insert_Input = {
  data: Array<Cma_Reports_Comparables_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_Comparables_On_Conflict>;
};

/** order by avg() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Avg_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_reports_comparables". All fields are combined with a logical 'AND'. */
export type Cma_Reports_Comparables_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Reports_Comparables_Bool_Exp>>;
  _not?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Reports_Comparables_Bool_Exp>>;
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Bigint_Comparison_Exp>;
  cma_report?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  listing_snapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  order_nr?: InputMaybe<Float_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "cma_reports_comparables" */
export enum Cma_Reports_Comparables_Constraint {
  /** unique or primary key constraint on columns "cma_report_id", "aggregates_db__merged_listings_clusters_id" */
  CmaReportsComparablesIdListingIdUnique = 'cma_reports_comparables_id_listing_id_unique',
  /** unique or primary key constraint on columns "cma_report_id", "order_nr" */
  CmaReportsComparablesIdOrderNrUnique = 'cma_reports_comparables_id_order_nr_unique',
  /** unique or primary key constraint on columns "cma_report_id", "aggregates_db__merged_listings_clusters_id" */
  CmaReportsComparablesPkey = 'cma_reports_comparables_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cma_Reports_Comparables_Delete_At_Path_Input = {
  listing_snapshot?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cma_Reports_Comparables_Delete_Elem_Input = {
  listing_snapshot?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cma_Reports_Comparables_Delete_Key_Input = {
  listing_snapshot?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Inc_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Insert_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report?: InputMaybe<Cma_Reports_Obj_Rel_Insert_Input>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
};

/** order by max() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Max_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Min_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Reports_Comparables>;
};

/** on_conflict condition type for table "cma_reports_comparables" */
export type Cma_Reports_Comparables_On_Conflict = {
  constraint: Cma_Reports_Comparables_Constraint;
  update_columns?: Array<Cma_Reports_Comparables_Update_Column>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_reports_comparables". */
export type Cma_Reports_Comparables_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  cma_report?: InputMaybe<Cma_Reports_Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  listing_snapshot?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cma_reports_comparables */
export type Cma_Reports_Comparables_Pk_Columns_Input = {
  aggregates_db__merged_listings_clusters_id: Scalars['bigint']['input'];
  cma_report_id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Comparables_Prepend_Input = {
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "cma_reports_comparables" */
export enum Cma_Reports_Comparables_Select_Column {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Set_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stddev_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stddev_Pop_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stddev_Samp_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Reports_Comparables_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Reports_Comparables_Stream_Cursor_Value_Input = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Scalars['bigint']['input']>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  listing_snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  order_nr?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Sum_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "cma_reports_comparables" */
export enum Cma_Reports_Comparables_Update_Column {
  /** column name */
  AggregatesDbMergedListingsClustersId = 'aggregates_db__merged_listings_clusters_id',
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ListingSnapshot = 'listing_snapshot',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Cma_Reports_Comparables_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cma_Reports_Comparables_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cma_Reports_Comparables_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cma_Reports_Comparables_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cma_Reports_Comparables_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cma_Reports_Comparables_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cma_Reports_Comparables_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cma_Reports_Comparables_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cma_Reports_Comparables_Bool_Exp;
};

/** order by var_pop() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Var_Pop_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Var_Samp_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "cma_reports_comparables" */
export type Cma_Reports_Comparables_Variance_Order_By = {
  aggregates_db__merged_listings_clusters_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "cma_reports" */
export enum Cma_Reports_Constraint {
  /** unique or primary key constraint on columns "id" */
  CmaReportsPkey = 'cma_reports_pkey'
}

export enum Cma_Reports_Construction_Base_Enum_Enum {
  Surface = 'surface',
  Volume = 'volume'
}

/** Boolean expression to compare columns of type "cma_reports_construction_base_enum_enum". All fields are combined with logical 'AND'. */
export type Cma_Reports_Construction_Base_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  _in?: InputMaybe<Array<Cma_Reports_Construction_Base_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  _nin?: InputMaybe<Array<Cma_Reports_Construction_Base_Enum_Enum>>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Cma_Reports_Delete_At_Path_Input = {
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Array<Scalars['String']['input']>>;
  market_comparison_places?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Cma_Reports_Delete_Elem_Input = {
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Scalars['Int']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['Int']['input']>;
  market_comparison_places?: InputMaybe<Scalars['Int']['input']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Cma_Reports_Delete_Key_Input = {
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Scalars['String']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['String']['input']>;
  market_comparison_places?: InputMaybe<Scalars['String']['input']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "cma_reports" */
export type Cma_Reports_Inc_Input = {
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  market_data_map_zoom_level?: InputMaybe<Scalars['float8']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  poi_map_zoom_level?: InputMaybe<Scalars['Float']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  transaction_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "cma_reports" */
export type Cma_Reports_Insert_Input = {
  adjust_price_by_evolution?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Scalars['jsonb']['input']>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  cma_agent_transactions?: InputMaybe<Cma_Reports_Agent_Transactions_Arr_Rel_Insert_Input>;
  cma_property_transactions?: InputMaybe<Cma_Reports_Property_Transactions_Arr_Rel_Insert_Input>;
  cma_report_files?: InputMaybe<Cma_Report_Files_Arr_Rel_Insert_Input>;
  cma_user_reviews?: InputMaybe<Cma_Reports_User_Reviews_Arr_Rel_Insert_Input>;
  comparable_listings?: InputMaybe<Cma_Reports_Comparables_Arr_Rel_Insert_Input>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  description_de?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_fr?: InputMaybe<Scalars['String']['input']>;
  description_it?: InputMaybe<Scalars['String']['input']>;
  description_pl?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  doc_template?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  doc_template_theme?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_theme_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_agency_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparable_listing_details?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_market_data?: InputMaybe<Scalars['Boolean']['input']>;
  include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  include_poi_map?: InputMaybe<Scalars['Boolean']['input']>;
  include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  include_rental_comparable_listing_details?: InputMaybe<Scalars['Boolean']['input']>;
  include_rental_comparables?: InputMaybe<Scalars['Boolean']['input']>;
  include_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  market_comparison_places?: InputMaybe<Scalars['jsonb']['input']>;
  market_data_map_zoom_level?: InputMaybe<Scalars['float8']['input']>;
  market_data_show_chart?: InputMaybe<Scalars['Boolean']['input']>;
  market_data_show_map?: InputMaybe<Scalars['Boolean']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  poi_map_zoom_level?: InputMaybe<Scalars['Float']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Scalars['jsonb']['input']>;
  rental_comparables_search_params?: InputMaybe<Scalars['jsonb']['input']>;
  report_source?: InputMaybe<Cma_Report_Source_Enum_Enum>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_comparable_listing_cards?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_idx_description?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_rental_description?: InputMaybe<Scalars['Boolean']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  show_rental_comparable_listing_cards?: InputMaybe<Scalars['Boolean']['input']>;
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode?: InputMaybe<Scalars['String']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Cma_Reports_Max_Fields = {
  broker_id?: Maybe<Scalars['uuid']['output']>;
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  cover_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description_de?: Maybe<Scalars['String']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_fr?: Maybe<Scalars['String']['output']>;
  description_it?: Maybe<Scalars['String']['output']>;
  description_pl?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  doc_template_id?: Maybe<Scalars['uuid']['output']>;
  doc_template_theme_id?: Maybe<Scalars['uuid']['output']>;
  font_family?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['float8']['output']>;
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  negative_comments?: Maybe<Scalars['String']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  positive_comments?: Maybe<Scalars['String']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  report_title?: Maybe<Scalars['String']['output']>;
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode?: Maybe<Scalars['String']['output']>;
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "cma_reports" */
export type Cma_Reports_Max_Order_By = {
  broker_id?: InputMaybe<Order_By>;
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  cover_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description_de?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_it?: InputMaybe<Order_By>;
  description_pl?: InputMaybe<Order_By>;
  description_pt?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  doc_template_theme_id?: InputMaybe<Order_By>;
  font_family?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  negative_comments?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  positive_comments?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  report_title?: InputMaybe<Order_By>;
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Cma_Reports_Min_Fields = {
  broker_id?: Maybe<Scalars['uuid']['output']>;
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  cover_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description_de?: Maybe<Scalars['String']['output']>;
  description_en?: Maybe<Scalars['String']['output']>;
  description_es?: Maybe<Scalars['String']['output']>;
  description_fr?: Maybe<Scalars['String']['output']>;
  description_it?: Maybe<Scalars['String']['output']>;
  description_pl?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  doc_template_id?: Maybe<Scalars['uuid']['output']>;
  doc_template_theme_id?: Maybe<Scalars['uuid']['output']>;
  font_family?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['float8']['output']>;
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  negative_comments?: Maybe<Scalars['String']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  positive_comments?: Maybe<Scalars['String']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  report_title?: Maybe<Scalars['String']['output']>;
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode?: Maybe<Scalars['String']['output']>;
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "cma_reports" */
export type Cma_Reports_Min_Order_By = {
  broker_id?: InputMaybe<Order_By>;
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  cover_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description_de?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_it?: InputMaybe<Order_By>;
  description_pl?: InputMaybe<Order_By>;
  description_pt?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  doc_template_theme_id?: InputMaybe<Order_By>;
  font_family?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  negative_comments?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  positive_comments?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  report_title?: InputMaybe<Order_By>;
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_reports" */
export type Cma_Reports_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Reports>;
};

/** input type for inserting object relation for remote table "cma_reports" */
export type Cma_Reports_Obj_Rel_Insert_Input = {
  data: Cma_Reports_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};

/** on_conflict condition type for table "cma_reports" */
export type Cma_Reports_On_Conflict = {
  constraint: Cma_Reports_Constraint;
  update_columns?: Array<Cma_Reports_Update_Column>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_reports". */
export type Cma_Reports_Order_By = {
  adjust_price_by_evolution?: InputMaybe<Order_By>;
  agency_team_members?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  cma_agent_transactions_aggregate?: InputMaybe<Cma_Reports_Agent_Transactions_Aggregate_Order_By>;
  cma_property_transactions_aggregate?: InputMaybe<Cma_Reports_Property_Transactions_Aggregate_Order_By>;
  cma_report_files_aggregate?: InputMaybe<Cma_Report_Files_Aggregate_Order_By>;
  cma_user_reviews_aggregate?: InputMaybe<Cma_Reports_User_Reviews_Aggregate_Order_By>;
  comparable_listings_aggregate?: InputMaybe<Cma_Reports_Comparables_Aggregate_Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  construction_cost_base?: InputMaybe<Order_By>;
  contact?: InputMaybe<Users_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  cover_image?: InputMaybe<Images_Order_By>;
  cover_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  description_de?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_it?: InputMaybe<Order_By>;
  description_pl?: InputMaybe<Order_By>;
  description_pt?: InputMaybe<Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  doc_template_theme?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_theme_id?: InputMaybe<Order_By>;
  font_family?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_agency_description?: InputMaybe<Order_By>;
  include_agent?: InputMaybe<Order_By>;
  include_agent_agency?: InputMaybe<Order_By>;
  include_append_files?: InputMaybe<Order_By>;
  include_client_testimonial?: InputMaybe<Order_By>;
  include_comparable_listing_details?: InputMaybe<Order_By>;
  include_comparables_valuation?: InputMaybe<Order_By>;
  include_cover?: InputMaybe<Order_By>;
  include_cuprate_valuation?: InputMaybe<Order_By>;
  include_description?: InputMaybe<Order_By>;
  include_final_value?: InputMaybe<Order_By>;
  include_hedonistic_valuation?: InputMaybe<Order_By>;
  include_intrinsic_valuation?: InputMaybe<Order_By>;
  include_introduction?: InputMaybe<Order_By>;
  include_market_data?: InputMaybe<Order_By>;
  include_photos?: InputMaybe<Order_By>;
  include_poi_map?: InputMaybe<Order_By>;
  include_pois?: InputMaybe<Order_By>;
  include_potential_buyers?: InputMaybe<Order_By>;
  include_property?: InputMaybe<Order_By>;
  include_transactions?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_custom_fields?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  introduction?: InputMaybe<Order_By>;
  is_completed?: InputMaybe<Order_By>;
  is_price_range?: InputMaybe<Order_By>;
  is_property_comparable_listings_square_meter_calculation?: InputMaybe<Order_By>;
  is_property_transaction_square_meter_calculation?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  market_comparison_places?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  market_data_show_chart?: InputMaybe<Order_By>;
  market_data_show_map?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  negative_comments?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  positive_comments?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  rental_comparables?: InputMaybe<Order_By>;
  report_source?: InputMaybe<Order_By>;
  report_title?: InputMaybe<Order_By>;
  show_comparable_listing_cards?: InputMaybe<Order_By>;
  show_full_idx_description?: InputMaybe<Order_By>;
  show_full_rental_description?: InputMaybe<Order_By>;
  show_probability?: InputMaybe<Order_By>;
  show_rental_comparable_listing_cards?: InputMaybe<Order_By>;
  sort_display_mode?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: cma_reports */
export type Cma_Reports_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Cma_Reports_Prepend_Input = {
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Scalars['jsonb']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  market_comparison_places?: InputMaybe<Scalars['jsonb']['input']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions = {
  /** An object relationship */
  cma_report: Cma_Reports;
  cma_report_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  distance_in_meters?: Maybe<Scalars['numeric']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  include_in_median: Scalars['Boolean']['output'];
  order_nr: Scalars['Int']['output'];
  price_evolution_rate?: Maybe<Scalars['numeric']['output']>;
  /** Timestamp of the most recent price-evolution rate calculation; NULL means stale or never computed. */
  price_evolution_rate_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  source: Scalars['String']['output'];
  /** An object relationship */
  transaction?: Maybe<Property_Transactions_Country_View>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Cma_Reports_Property_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Reports_Property_Transactions_Max_Order_By>;
  min?: InputMaybe<Cma_Reports_Property_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Cma_Reports_Property_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Cma_Reports_Property_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Cma_Reports_Property_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Cma_Reports_Property_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Cma_Reports_Property_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Cma_Reports_Property_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Cma_Reports_Property_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Cma_Reports_Property_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_Property_Transactions_On_Conflict>;
};

/** order by avg() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Avg_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "cma_reports_property_transactions". All fields are combined with a logical 'AND'. */
export type Cma_Reports_Property_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Reports_Property_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Cma_Reports_Property_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Reports_Property_Transactions_Bool_Exp>>;
  cma_report?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Numeric_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  include_in_median?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  price_evolution_rate?: InputMaybe<Numeric_Comparison_Exp>;
  price_evolution_rate_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  transaction?: InputMaybe<Property_Transactions_Country_View_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "cma_reports_property_transactions" */
export enum Cma_Reports_Property_Transactions_Constraint {
  /** unique or primary key constraint on columns "transaction_id", "cma_report_id" */
  CmaReportsPropertyTransactiCmaReportIdTransactionIdKey = 'cma_reports_property_transacti_cma_report_id_transaction_id_key',
  /** unique or primary key constraint on columns "external_id", "cma_report_id", "source" */
  CmaReportsPropertyTransactionsExternalUnique = 'cma_reports_property_transactions_external_unique',
  /** unique or primary key constraint on columns "cma_report_id", "order_nr" */
  CmaReportsPropertyTransactionsIdOrderNrUnique = 'cma_reports_property_transactions_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  CmaReportsPropertyTransactionsPkey = 'cma_reports_property_transactions_pkey'
}

/** input type for incrementing numeric columns in table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Inc_Input = {
  distance_in_meters?: InputMaybe<Scalars['numeric']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  price_evolution_rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Insert_Input = {
  cma_report?: InputMaybe<Cma_Reports_Obj_Rel_Insert_Input>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  distance_in_meters?: InputMaybe<Scalars['numeric']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  include_in_median?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  price_evolution_rate?: InputMaybe<Scalars['numeric']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Max_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
  /** Timestamp of the most recent price-evolution rate calculation; NULL means stale or never computed. */
  price_evolution_rate_updated_at?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Min_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
  /** Timestamp of the most recent price-evolution rate calculation; NULL means stale or never computed. */
  price_evolution_rate_updated_at?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Reports_Property_Transactions>;
};

/** on_conflict condition type for table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_On_Conflict = {
  constraint: Cma_Reports_Property_Transactions_Constraint;
  update_columns?: Array<Cma_Reports_Property_Transactions_Update_Column>;
  where?: InputMaybe<Cma_Reports_Property_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_reports_property_transactions". */
export type Cma_Reports_Property_Transactions_Order_By = {
  cma_report?: InputMaybe<Cma_Reports_Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  include_in_median?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
  price_evolution_rate_updated_at?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Property_Transactions_Country_View_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cma_reports_property_transactions */
export type Cma_Reports_Property_Transactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "cma_reports_property_transactions" */
export enum Cma_Reports_Property_Transactions_Select_Column {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeInMedian = 'include_in_median',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PriceEvolutionRate = 'price_evolution_rate',
  /** column name */
  PriceEvolutionRateUpdatedAt = 'price_evolution_rate_updated_at',
  /** column name */
  Source = 'source',
  /** column name */
  TransactionId = 'transaction_id'
}

/** input type for updating data in table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Set_Input = {
  distance_in_meters?: InputMaybe<Scalars['numeric']['input']>;
  include_in_median?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  price_evolution_rate?: InputMaybe<Scalars['numeric']['input']>;
  /** Timestamp of the most recent price-evolution rate calculation; NULL means stale or never computed. */
  price_evolution_rate_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by stddev() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Stddev_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Stddev_Pop_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Stddev_Samp_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Reports_Property_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Reports_Property_Transactions_Stream_Cursor_Value_Input = {
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  distance_in_meters?: InputMaybe<Scalars['numeric']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_in_median?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  price_evolution_rate?: InputMaybe<Scalars['numeric']['input']>;
  /** Timestamp of the most recent price-evolution rate calculation; NULL means stale or never computed. */
  price_evolution_rate_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Sum_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** update columns of table "cma_reports_property_transactions" */
export enum Cma_Reports_Property_Transactions_Update_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  IncludeInMedian = 'include_in_median',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PriceEvolutionRate = 'price_evolution_rate',
  /** column name */
  PriceEvolutionRateUpdatedAt = 'price_evolution_rate_updated_at'
}

export type Cma_Reports_Property_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cma_Reports_Property_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cma_Reports_Property_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cma_Reports_Property_Transactions_Bool_Exp;
};

/** order by var_pop() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Var_Pop_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Var_Samp_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "cma_reports_property_transactions" */
export type Cma_Reports_Property_Transactions_Variance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  price_evolution_rate?: InputMaybe<Order_By>;
};

/** select columns of table "cma_reports" */
export enum Cma_Reports_Select_Column {
  /** column name */
  AdjustPriceByEvolution = 'adjust_price_by_evolution',
  /** column name */
  AgencyTeamMembers = 'agency_team_members',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ComparableListingsMapZoomLevel = 'comparable_listings_map_zoom_level',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DescriptionDe = 'description_de',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionIt = 'description_it',
  /** column name */
  DescriptionPl = 'description_pl',
  /** column name */
  DescriptionPt = 'description_pt',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  DocTemplateThemeId = 'doc_template_theme_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeAgencyDescription = 'include_agency_description',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparableListingDetails = 'include_comparable_listing_details',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludeMarketData = 'include_market_data',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePoiMap = 'include_poi_map',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeTransactions = 'include_transactions',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  IsPropertyComparableListingsSquareMeterCalculation = 'is_property_comparable_listings_square_meter_calculation',
  /** column name */
  IsPropertyTransactionSquareMeterCalculation = 'is_property_transaction_square_meter_calculation',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MarketComparisonPlaces = 'market_comparison_places',
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level',
  /** column name */
  MarketDataShowChart = 'market_data_show_chart',
  /** column name */
  MarketDataShowMap = 'market_data_show_map',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PoiMapZoomLevel = 'poi_map_zoom_level',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RentalComparableListingsMapZoomLevel = 'rental_comparable_listings_map_zoom_level',
  /** column name */
  RentalComparables = 'rental_comparables',
  /** column name */
  ReportSource = 'report_source',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowComparableListingCards = 'show_comparable_listing_cards',
  /** column name */
  ShowFullIdxDescription = 'show_full_idx_description',
  /** column name */
  ShowFullRentalDescription = 'show_full_rental_description',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  ShowRentalComparableListingCards = 'show_rental_comparable_listing_cards',
  /** column name */
  SortDisplayMode = 'sort_display_mode',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionMapZoomLevel = 'transaction_map_zoom_level',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "cma_reports_aggregate_bool_exp_avg_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** select "cma_reports_aggregate_bool_exp_bool_and_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AdjustPriceByEvolution = 'adjust_price_by_evolution',
  /** column name */
  IncludeAgencyDescription = 'include_agency_description',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparableListingDetails = 'include_comparable_listing_details',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludeMarketData = 'include_market_data',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePoiMap = 'include_poi_map',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeTransactions = 'include_transactions',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  IsPropertyComparableListingsSquareMeterCalculation = 'is_property_comparable_listings_square_meter_calculation',
  /** column name */
  IsPropertyTransactionSquareMeterCalculation = 'is_property_transaction_square_meter_calculation',
  /** column name */
  MarketDataShowChart = 'market_data_show_chart',
  /** column name */
  MarketDataShowMap = 'market_data_show_map',
  /** column name */
  ShowComparableListingCards = 'show_comparable_listing_cards',
  /** column name */
  ShowFullIdxDescription = 'show_full_idx_description',
  /** column name */
  ShowFullRentalDescription = 'show_full_rental_description',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  ShowRentalComparableListingCards = 'show_rental_comparable_listing_cards'
}

/** select "cma_reports_aggregate_bool_exp_bool_or_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AdjustPriceByEvolution = 'adjust_price_by_evolution',
  /** column name */
  IncludeAgencyDescription = 'include_agency_description',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparableListingDetails = 'include_comparable_listing_details',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludeMarketData = 'include_market_data',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePoiMap = 'include_poi_map',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeTransactions = 'include_transactions',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  IsPropertyComparableListingsSquareMeterCalculation = 'is_property_comparable_listings_square_meter_calculation',
  /** column name */
  IsPropertyTransactionSquareMeterCalculation = 'is_property_transaction_square_meter_calculation',
  /** column name */
  MarketDataShowChart = 'market_data_show_chart',
  /** column name */
  MarketDataShowMap = 'market_data_show_map',
  /** column name */
  ShowComparableListingCards = 'show_comparable_listing_cards',
  /** column name */
  ShowFullIdxDescription = 'show_full_idx_description',
  /** column name */
  ShowFullRentalDescription = 'show_full_rental_description',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  ShowRentalComparableListingCards = 'show_rental_comparable_listing_cards'
}

/** select "cma_reports_aggregate_bool_exp_corr_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** select "cma_reports_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** select "cma_reports_aggregate_bool_exp_max_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** select "cma_reports_aggregate_bool_exp_min_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** select "cma_reports_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** select "cma_reports_aggregate_bool_exp_sum_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** select "cma_reports_aggregate_bool_exp_var_samp_arguments_columns" columns of table "cma_reports" */
export enum Cma_Reports_Select_Column_Cma_Reports_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level'
}

/** input type for updating data in table "cma_reports" */
export type Cma_Reports_Set_Input = {
  adjust_price_by_evolution?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Scalars['jsonb']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description_de?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_fr?: InputMaybe<Scalars['String']['input']>;
  description_it?: InputMaybe<Scalars['String']['input']>;
  description_pl?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  doc_template_theme_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  include_agency_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparable_listing_details?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_market_data?: InputMaybe<Scalars['Boolean']['input']>;
  include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  include_poi_map?: InputMaybe<Scalars['Boolean']['input']>;
  include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  include_rental_comparable_listing_details?: InputMaybe<Scalars['Boolean']['input']>;
  include_rental_comparables?: InputMaybe<Scalars['Boolean']['input']>;
  include_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  is_property_comparable_listings_square_meter_calculation?: InputMaybe<Scalars['Boolean']['input']>;
  is_property_transaction_square_meter_calculation?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  market_comparison_places?: InputMaybe<Scalars['jsonb']['input']>;
  market_data_map_zoom_level?: InputMaybe<Scalars['float8']['input']>;
  market_data_show_chart?: InputMaybe<Scalars['Boolean']['input']>;
  market_data_show_map?: InputMaybe<Scalars['Boolean']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  poi_map_zoom_level?: InputMaybe<Scalars['Float']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Scalars['jsonb']['input']>;
  rental_comparables_search_params?: InputMaybe<Scalars['jsonb']['input']>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_comparable_listing_cards?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_idx_description?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_rental_description?: InputMaybe<Scalars['Boolean']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  show_rental_comparable_listing_cards?: InputMaybe<Scalars['Boolean']['input']>;
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode?: InputMaybe<Scalars['String']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  transaction_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Cma_Reports_Stddev_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "cma_reports" */
export type Cma_Reports_Stddev_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Cma_Reports_Stddev_Pop_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "cma_reports" */
export type Cma_Reports_Stddev_Pop_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Cma_Reports_Stddev_Samp_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "cma_reports" */
export type Cma_Reports_Stddev_Samp_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "cma_reports" */
export type Cma_Reports_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Reports_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Reports_Stream_Cursor_Value_Input = {
  adjust_price_by_evolution?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ordered team members shown on the agency page: [{user_id, is_visible}]. NULL shows the 6 newest members. */
  agency_team_members?: InputMaybe<Scalars['jsonb']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  caprate_estimated_monthly_rent?: InputMaybe<Scalars['Int']['input']>;
  caprate_minimum_required_yield?: InputMaybe<Scalars['Float']['input']>;
  comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
  construction_cost_base?: InputMaybe<Cma_Reports_Construction_Base_Enum_Enum>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description_de?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_fr?: InputMaybe<Scalars['String']['input']>;
  description_it?: InputMaybe<Scalars['String']['input']>;
  description_pl?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  doc_template_theme_id?: InputMaybe<Scalars['uuid']['input']>;
  font_family?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  include_agency_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent?: InputMaybe<Scalars['Boolean']['input']>;
  include_agent_agency?: InputMaybe<Scalars['Boolean']['input']>;
  include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  include_client_testimonial?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparable_listing_details?: InputMaybe<Scalars['Boolean']['input']>;
  include_comparables_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  include_cuprate_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_description?: InputMaybe<Scalars['Boolean']['input']>;
  include_final_value?: InputMaybe<Scalars['Boolean']['input']>;
  include_hedonistic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_intrinsic_valuation?: InputMaybe<Scalars['Boolean']['input']>;
  include_introduction?: InputMaybe<Scalars['Boolean']['input']>;
  include_market_data?: InputMaybe<Scalars['Boolean']['input']>;
  include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  include_poi_map?: InputMaybe<Scalars['Boolean']['input']>;
  include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  include_potential_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  include_property?: InputMaybe<Scalars['Boolean']['input']>;
  include_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_building_surface?: InputMaybe<Scalars['Float']['input']>;
  intrinsic_construction_cost?: InputMaybe<Scalars['Int']['input']>;
  /** Array of custom fields for intrinsic valuation, each containing id, title, and value */
  intrinsic_custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  intrinsic_land_value?: InputMaybe<Scalars['Int']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  is_price_range?: InputMaybe<Scalars['Boolean']['input']>;
  is_property_comparable_listings_square_meter_calculation?: InputMaybe<Scalars['Boolean']['input']>;
  is_property_transaction_square_meter_calculation?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  market_comparison_places?: InputMaybe<Scalars['jsonb']['input']>;
  market_data_map_zoom_level?: InputMaybe<Scalars['float8']['input']>;
  market_data_show_chart?: InputMaybe<Scalars['Boolean']['input']>;
  market_data_show_map?: InputMaybe<Scalars['Boolean']['input']>;
  max_budget?: InputMaybe<Scalars['Int']['input']>;
  min_budget?: InputMaybe<Scalars['Int']['input']>;
  negative_comments?: InputMaybe<Scalars['String']['input']>;
  poi_map_zoom_level?: InputMaybe<Scalars['Float']['input']>;
  positive_comments?: InputMaybe<Scalars['String']['input']>;
  price_range_max?: InputMaybe<Scalars['Int']['input']>;
  price_range_min?: InputMaybe<Scalars['Int']['input']>;
  probability_max?: InputMaybe<Scalars['Float']['input']>;
  probability_min?: InputMaybe<Scalars['Float']['input']>;
  probability_time_period?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
  /** Selected rental listing snapshots. Separate from sale comparable cluster IDs. */
  rental_comparables?: InputMaybe<Scalars['jsonb']['input']>;
  report_source?: InputMaybe<Cma_Report_Source_Enum_Enum>;
  report_title?: InputMaybe<Scalars['String']['input']>;
  show_comparable_listing_cards?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_idx_description?: InputMaybe<Scalars['Boolean']['input']>;
  show_full_rental_description?: InputMaybe<Scalars['Boolean']['input']>;
  show_probability?: InputMaybe<Scalars['Boolean']['input']>;
  show_rental_comparable_listing_cards?: InputMaybe<Scalars['Boolean']['input']>;
  /** Preferred ordering for agent transactions (nearest | recent). */
  sort_display_mode?: InputMaybe<Scalars['String']['input']>;
  suggested_market_value?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Cma_Reports_Sum_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Int']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Int']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Int']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['float8']['output']>;
  max_budget?: Maybe<Scalars['Int']['output']>;
  min_budget?: Maybe<Scalars['Int']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Int']['output']>;
  price_range_min?: Maybe<Scalars['Int']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Int']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Int']['output']>;
  suggested_market_value?: Maybe<Scalars['Int']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "cma_reports" */
export type Cma_Reports_Sum_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** update columns of table "cma_reports" */
export enum Cma_Reports_Update_Column {
  /** column name */
  AdjustPriceByEvolution = 'adjust_price_by_evolution',
  /** column name */
  AgencyTeamMembers = 'agency_team_members',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CaprateEstimatedMonthlyRent = 'caprate_estimated_monthly_rent',
  /** column name */
  CaprateMinimumRequiredYield = 'caprate_minimum_required_yield',
  /** column name */
  ComparableListingsMapZoomLevel = 'comparable_listings_map_zoom_level',
  /** column name */
  ConstructionCostBase = 'construction_cost_base',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CoverImageId = 'cover_image_id',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DescriptionDe = 'description_de',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionIt = 'description_it',
  /** column name */
  DescriptionPl = 'description_pl',
  /** column name */
  DescriptionPt = 'description_pt',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  DocTemplateThemeId = 'doc_template_theme_id',
  /** column name */
  FontFamily = 'font_family',
  /** column name */
  IncludeAgencyDescription = 'include_agency_description',
  /** column name */
  IncludeAgent = 'include_agent',
  /** column name */
  IncludeAgentAgency = 'include_agent_agency',
  /** column name */
  IncludeAppendFiles = 'include_append_files',
  /** column name */
  IncludeClientTestimonial = 'include_client_testimonial',
  /** column name */
  IncludeComparableListingDetails = 'include_comparable_listing_details',
  /** column name */
  IncludeComparablesValuation = 'include_comparables_valuation',
  /** column name */
  IncludeCover = 'include_cover',
  /** column name */
  IncludeCuprateValuation = 'include_cuprate_valuation',
  /** column name */
  IncludeDescription = 'include_description',
  /** column name */
  IncludeFinalValue = 'include_final_value',
  /** column name */
  IncludeHedonisticValuation = 'include_hedonistic_valuation',
  /** column name */
  IncludeIntrinsicValuation = 'include_intrinsic_valuation',
  /** column name */
  IncludeIntroduction = 'include_introduction',
  /** column name */
  IncludeMarketData = 'include_market_data',
  /** column name */
  IncludePhotos = 'include_photos',
  /** column name */
  IncludePoiMap = 'include_poi_map',
  /** column name */
  IncludePois = 'include_pois',
  /** column name */
  IncludePotentialBuyers = 'include_potential_buyers',
  /** column name */
  IncludeProperty = 'include_property',
  /** column name */
  IncludeTransactions = 'include_transactions',
  /** column name */
  IntrinsicAnnualDeprecationRate = 'intrinsic_annual_deprecation_rate',
  /** column name */
  IntrinsicBuildingSurface = 'intrinsic_building_surface',
  /** column name */
  IntrinsicConstructionCost = 'intrinsic_construction_cost',
  /** column name */
  IntrinsicCustomFields = 'intrinsic_custom_fields',
  /** column name */
  IntrinsicLandValue = 'intrinsic_land_value',
  /** column name */
  Introduction = 'introduction',
  /** column name */
  IsPriceRange = 'is_price_range',
  /** column name */
  IsPropertyComparableListingsSquareMeterCalculation = 'is_property_comparable_listings_square_meter_calculation',
  /** column name */
  IsPropertyTransactionSquareMeterCalculation = 'is_property_transaction_square_meter_calculation',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  MarketComparisonPlaces = 'market_comparison_places',
  /** column name */
  MarketDataMapZoomLevel = 'market_data_map_zoom_level',
  /** column name */
  MarketDataShowChart = 'market_data_show_chart',
  /** column name */
  MarketDataShowMap = 'market_data_show_map',
  /** column name */
  MaxBudget = 'max_budget',
  /** column name */
  MinBudget = 'min_budget',
  /** column name */
  NegativeComments = 'negative_comments',
  /** column name */
  PoiMapZoomLevel = 'poi_map_zoom_level',
  /** column name */
  PositiveComments = 'positive_comments',
  /** column name */
  PriceRangeMax = 'price_range_max',
  /** column name */
  PriceRangeMin = 'price_range_min',
  /** column name */
  ProbabilityMax = 'probability_max',
  /** column name */
  ProbabilityMin = 'probability_min',
  /** column name */
  ProbabilityTimePeriod = 'probability_time_period',
  /** column name */
  RentalComparableListingsMapZoomLevel = 'rental_comparable_listings_map_zoom_level',
  /** column name */
  RentalComparables = 'rental_comparables',
  /** column name */
  ReportTitle = 'report_title',
  /** column name */
  ShowComparableListingCards = 'show_comparable_listing_cards',
  /** column name */
  ShowFullIdxDescription = 'show_full_idx_description',
  /** column name */
  ShowFullRentalDescription = 'show_full_rental_description',
  /** column name */
  ShowProbability = 'show_probability',
  /** column name */
  ShowRentalComparableListingCards = 'show_rental_comparable_listing_cards',
  /** column name */
  SortDisplayMode = 'sort_display_mode',
  /** column name */
  SuggestedMarketValue = 'suggested_market_value',
  /** column name */
  TransactionMapZoomLevel = 'transaction_map_zoom_level'
}

export type Cma_Reports_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Cma_Reports_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Cma_Reports_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Cma_Reports_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Cma_Reports_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cma_Reports_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Cma_Reports_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cma_Reports_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cma_Reports_Bool_Exp;
};

/** Junction table linking CMA reports to their top 6 testimonial reviews. */
export type Cma_Reports_User_Reviews = {
  /** An object relationship */
  cma_report: Cma_Reports;
  cma_report_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  review: Reviews;
  review_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Cma_Reports_User_Reviews_Max_Order_By>;
  min?: InputMaybe<Cma_Reports_User_Reviews_Min_Order_By>;
};

/** input type for inserting array relation for remote table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_Arr_Rel_Insert_Input = {
  data: Array<Cma_Reports_User_Reviews_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Cma_Reports_User_Reviews_On_Conflict>;
};

/** Boolean expression to filter rows from the table "cma_reports_user_reviews". All fields are combined with a logical 'AND'. */
export type Cma_Reports_User_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Cma_Reports_User_Reviews_Bool_Exp>>;
  _not?: InputMaybe<Cma_Reports_User_Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Cma_Reports_User_Reviews_Bool_Exp>>;
  cma_report?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_report_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  review?: InputMaybe<Reviews_Bool_Exp>;
  review_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "cma_reports_user_reviews" */
export enum Cma_Reports_User_Reviews_Constraint {
  /** unique or primary key constraint on columns "id" */
  CmaReportsUserReviewsPkey = 'cma_reports_user_reviews_pkey',
  /** unique or primary key constraint on columns "cma_report_id", "review_id" */
  CmaReportsUserReviewsUnique = 'cma_reports_user_reviews_unique'
}

/** input type for inserting data into table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_Insert_Input = {
  cma_report?: InputMaybe<Cma_Reports_Obj_Rel_Insert_Input>;
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  review?: InputMaybe<Reviews_Obj_Rel_Insert_Input>;
  review_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_Max_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_Min_Order_By = {
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Cma_Reports_User_Reviews>;
};

/** on_conflict condition type for table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_On_Conflict = {
  constraint: Cma_Reports_User_Reviews_Constraint;
  update_columns?: Array<Cma_Reports_User_Reviews_Update_Column>;
  where?: InputMaybe<Cma_Reports_User_Reviews_Bool_Exp>;
};

/** Ordering options when selecting data from "cma_reports_user_reviews". */
export type Cma_Reports_User_Reviews_Order_By = {
  cma_report?: InputMaybe<Cma_Reports_Order_By>;
  cma_report_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review?: InputMaybe<Reviews_Order_By>;
  review_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_reports_user_reviews" */
export enum Cma_Reports_User_Reviews_Select_Column {
  /** column name */
  CmaReportId = 'cma_report_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReviewId = 'review_id'
}

/** Streaming cursor of the table "cma_reports_user_reviews" */
export type Cma_Reports_User_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cma_Reports_User_Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cma_Reports_User_Reviews_Stream_Cursor_Value_Input = {
  cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  review_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "cma_reports_user_reviews" (current role has no relevant permissions) */
export enum Cma_Reports_User_Reviews_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** aggregate var_pop on columns */
export type Cma_Reports_Var_Pop_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "cma_reports" */
export type Cma_Reports_Var_Pop_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Cma_Reports_Var_Samp_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "cma_reports" */
export type Cma_Reports_Var_Samp_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Cma_Reports_Variance_Fields = {
  caprate_estimated_monthly_rent?: Maybe<Scalars['Float']['output']>;
  caprate_minimum_required_yield?: Maybe<Scalars['Float']['output']>;
  comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  intrinsic_annual_deprecation_rate?: Maybe<Scalars['Float']['output']>;
  intrinsic_building_surface?: Maybe<Scalars['Float']['output']>;
  intrinsic_construction_cost?: Maybe<Scalars['Float']['output']>;
  intrinsic_land_value?: Maybe<Scalars['Float']['output']>;
  market_data_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  max_budget?: Maybe<Scalars['Float']['output']>;
  min_budget?: Maybe<Scalars['Float']['output']>;
  poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  price_range_max?: Maybe<Scalars['Float']['output']>;
  price_range_min?: Maybe<Scalars['Float']['output']>;
  probability_max?: Maybe<Scalars['Float']['output']>;
  probability_min?: Maybe<Scalars['Float']['output']>;
  probability_time_period?: Maybe<Scalars['Float']['output']>;
  rental_comparable_listings_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  suggested_market_value?: Maybe<Scalars['Float']['output']>;
  transaction_map_zoom_level?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "cma_reports" */
export type Cma_Reports_Variance_Order_By = {
  caprate_estimated_monthly_rent?: InputMaybe<Order_By>;
  caprate_minimum_required_yield?: InputMaybe<Order_By>;
  comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  intrinsic_annual_deprecation_rate?: InputMaybe<Order_By>;
  intrinsic_building_surface?: InputMaybe<Order_By>;
  intrinsic_construction_cost?: InputMaybe<Order_By>;
  intrinsic_land_value?: InputMaybe<Order_By>;
  market_data_map_zoom_level?: InputMaybe<Order_By>;
  max_budget?: InputMaybe<Order_By>;
  min_budget?: InputMaybe<Order_By>;
  poi_map_zoom_level?: InputMaybe<Order_By>;
  price_range_max?: InputMaybe<Order_By>;
  price_range_min?: InputMaybe<Order_By>;
  probability_max?: InputMaybe<Order_By>;
  probability_min?: InputMaybe<Order_By>;
  probability_time_period?: InputMaybe<Order_By>;
  rental_comparable_listings_map_zoom_level?: InputMaybe<Order_By>;
  suggested_market_value?: InputMaybe<Order_By>;
  transaction_map_zoom_level?: InputMaybe<Order_By>;
};

/** Every review shown publicly, from two sources told apart by type: 'native' for the submitted reviews of the reviews table, 'google' for google_reviews. A native review carries the agent reviewed (user_id -> users) and that agent's default team as team_id; verified = it is tied to a transaction. A Google review has a team_id and no user_id. A Google review that repeats a native one of the same team is left out. */
export type Combined_Reviews = {
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_date?: Maybe<Scalars['String']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  owner_answer_translations?: Maybe<Scalars['jsonb']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_date?: Maybe<Scalars['String']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  translations?: Maybe<Scalars['jsonb']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};


/** Every review shown publicly, from two sources told apart by type: 'native' for the submitted reviews of the reviews table, 'google' for google_reviews. A native review carries the agent reviewed (user_id -> users) and that agent's default team as team_id; verified = it is tied to a transaction. A Google review has a team_id and no user_id. A Google review that repeats a native one of the same team is left out. */
export type Combined_ReviewsOwner_Answer_TranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Every review shown publicly, from two sources told apart by type: 'native' for the submitted reviews of the reviews table, 'google' for google_reviews. A native review carries the agent reviewed (user_id -> users) and that agent's default team as team_id; verified = it is tied to a transaction. A Google review has a team_id and no user_id. A Google review that repeats a native one of the same team is left out. */
export type Combined_ReviewsTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "combined_reviews" */
export type Combined_Reviews_Aggregate = {
  aggregate?: Maybe<Combined_Reviews_Aggregate_Fields>;
  nodes: Array<Combined_Reviews>;
};

export type Combined_Reviews_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp_Count>;
};

export type Combined_Reviews_Aggregate_Bool_Exp_Bool_And = {
  arguments: Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Combined_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Combined_Reviews_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Combined_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Combined_Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Combined_Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "combined_reviews" */
export type Combined_Reviews_Aggregate_Fields = {
  avg?: Maybe<Combined_Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Combined_Reviews_Max_Fields>;
  min?: Maybe<Combined_Reviews_Min_Fields>;
  stddev?: Maybe<Combined_Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Combined_Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Combined_Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Combined_Reviews_Sum_Fields>;
  var_pop?: Maybe<Combined_Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Combined_Reviews_Var_Samp_Fields>;
  variance?: Maybe<Combined_Reviews_Variance_Fields>;
};


/** aggregate fields of "combined_reviews" */
export type Combined_Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "combined_reviews" */
export type Combined_Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Combined_Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Combined_Reviews_Max_Order_By>;
  min?: InputMaybe<Combined_Reviews_Min_Order_By>;
  stddev?: InputMaybe<Combined_Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Combined_Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Combined_Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Combined_Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Combined_Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Combined_Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Combined_Reviews_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Combined_Reviews_Avg_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "combined_reviews" */
export type Combined_Reviews_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "combined_reviews". All fields are combined with a logical 'AND'. */
export type Combined_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Combined_Reviews_Bool_Exp>>;
  _not?: InputMaybe<Combined_Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Combined_Reviews_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_answer?: InputMaybe<String_Comparison_Exp>;
  owner_answer_date?: InputMaybe<String_Comparison_Exp>;
  owner_answer_source_language?: InputMaybe<String_Comparison_Exp>;
  owner_answer_translations?: InputMaybe<Jsonb_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_date?: InputMaybe<String_Comparison_Exp>;
  review_text?: InputMaybe<String_Comparison_Exp>;
  review_url?: InputMaybe<String_Comparison_Exp>;
  source_language?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** aggregate max on columns */
export type Combined_Reviews_Max_Fields = {
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_date?: Maybe<Scalars['String']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_date?: Maybe<Scalars['String']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "combined_reviews" */
export type Combined_Reviews_Max_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_date?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Combined_Reviews_Min_Fields = {
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_date?: Maybe<Scalars['String']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_date?: Maybe<Scalars['String']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "combined_reviews" */
export type Combined_Reviews_Min_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_date?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "combined_reviews". */
export type Combined_Reviews_Order_By = {
  display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_date?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  owner_answer_translations?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_date?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** select columns of table "combined_reviews" */
export enum Combined_Reviews_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  OwnerAnswerDate = 'owner_answer_date',
  /** column name */
  OwnerAnswerSourceLanguage = 'owner_answer_source_language',
  /** column name */
  OwnerAnswerTranslations = 'owner_answer_translations',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewDate = 'review_date',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  SourceLanguage = 'source_language',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

/** select "combined_reviews_aggregate_bool_exp_bool_and_arguments_columns" columns of table "combined_reviews" */
export enum Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** select "combined_reviews_aggregate_bool_exp_bool_or_arguments_columns" columns of table "combined_reviews" */
export enum Combined_Reviews_Select_Column_Combined_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Verified = 'verified'
}

/** aggregate stddev on columns */
export type Combined_Reviews_Stddev_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "combined_reviews" */
export type Combined_Reviews_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Combined_Reviews_Stddev_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "combined_reviews" */
export type Combined_Reviews_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Combined_Reviews_Stddev_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "combined_reviews" */
export type Combined_Reviews_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "combined_reviews" */
export type Combined_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Combined_Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Combined_Reviews_Stream_Cursor_Value_Input = {
  display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_answer?: InputMaybe<Scalars['String']['input']>;
  owner_answer_date?: InputMaybe<Scalars['String']['input']>;
  owner_answer_source_language?: InputMaybe<Scalars['String']['input']>;
  owner_answer_translations?: InputMaybe<Scalars['jsonb']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_date?: InputMaybe<Scalars['String']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  source_language?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Combined_Reviews_Sum_Fields = {
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "combined_reviews" */
export type Combined_Reviews_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Combined_Reviews_Var_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "combined_reviews" */
export type Combined_Reviews_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Combined_Reviews_Var_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "combined_reviews" */
export type Combined_Reviews_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Combined_Reviews_Variance_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "combined_reviews" */
export type Combined_Reviews_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "commissions" */
export type Commissions = {
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiary_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  contact?: Maybe<Users>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_paid?: Maybe<Scalars['Boolean']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  /** An object relationship */
  transaction?: Maybe<Property_Transactions>;
  type?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "commissions" */
export type Commissions_Aggregate = {
  aggregate?: Maybe<Commissions_Aggregate_Fields>;
  nodes: Array<Commissions>;
};

export type Commissions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Commissions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Commissions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Commissions_Aggregate_Bool_Exp_Count>;
};

export type Commissions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Commissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Commissions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Commissions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Commissions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Commissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Commissions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "commissions" */
export type Commissions_Aggregate_Fields = {
  avg?: Maybe<Commissions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Commissions_Max_Fields>;
  min?: Maybe<Commissions_Min_Fields>;
  stddev?: Maybe<Commissions_Stddev_Fields>;
  stddev_pop?: Maybe<Commissions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Commissions_Stddev_Samp_Fields>;
  sum?: Maybe<Commissions_Sum_Fields>;
  var_pop?: Maybe<Commissions_Var_Pop_Fields>;
  var_samp?: Maybe<Commissions_Var_Samp_Fields>;
  variance?: Maybe<Commissions_Variance_Fields>;
};


/** aggregate fields of "commissions" */
export type Commissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Commissions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "commissions" */
export type Commissions_Aggregate_Order_By = {
  avg?: InputMaybe<Commissions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Commissions_Max_Order_By>;
  min?: InputMaybe<Commissions_Min_Order_By>;
  stddev?: InputMaybe<Commissions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Commissions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Commissions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Commissions_Sum_Order_By>;
  var_pop?: InputMaybe<Commissions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Commissions_Var_Samp_Order_By>;
  variance?: InputMaybe<Commissions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "commissions" */
export type Commissions_Arr_Rel_Insert_Input = {
  data: Array<Commissions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Commissions_On_Conflict>;
};

/** aggregate avg on columns */
export type Commissions_Avg_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "commissions" */
export type Commissions_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "commissions". All fields are combined with a logical 'AND'. */
export type Commissions_Bool_Exp = {
  _and?: InputMaybe<Array<Commissions_Bool_Exp>>;
  _not?: InputMaybe<Commissions_Bool_Exp>;
  _or?: InputMaybe<Array<Commissions_Bool_Exp>>;
  amount?: InputMaybe<Float_Comparison_Exp>;
  beneficiary_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  contact?: InputMaybe<Users_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_paid?: InputMaybe<Boolean_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  property_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  vat?: InputMaybe<Float_Comparison_Exp>;
};

/** unique or primary key constraints on table "commissions" */
export enum Commissions_Constraint {
  /** unique or primary key constraint on columns "id" */
  CommissionsPkey = 'commissions_pkey',
  /** unique or primary key constraint on columns "type", "property_transaction_id" */
  IdxPropertyTransactionCommissionTotal = 'idx_property_transaction_commission_total'
}

/** input type for incrementing numeric columns in table "commissions" */
export type Commissions_Inc_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "commissions" */
export type Commissions_Insert_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beneficiary_team_id?: InputMaybe<Scalars['uuid']['input']>;
  contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  type?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Commissions_Max_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiary_team_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "commissions" */
export type Commissions_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  beneficiary_team_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Commissions_Min_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  beneficiary_team_id?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "commissions" */
export type Commissions_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  beneficiary_team_id?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "commissions" */
export type Commissions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Commissions>;
};

/** on_conflict condition type for table "commissions" */
export type Commissions_On_Conflict = {
  constraint: Commissions_Constraint;
  update_columns?: Array<Commissions_Update_Column>;
  where?: InputMaybe<Commissions_Bool_Exp>;
};

/** Ordering options when selecting data from "commissions". */
export type Commissions_Order_By = {
  amount?: InputMaybe<Order_By>;
  beneficiary_team_id?: InputMaybe<Order_By>;
  contact?: InputMaybe<Users_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_paid?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  transaction?: InputMaybe<Property_Transactions_Order_By>;
  type?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** primary key columns input for table: commissions */
export type Commissions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "commissions" */
export enum Commissions_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  Type = 'type',
  /** column name */
  Vat = 'vat'
}

/** select "commissions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "commissions" */
export enum Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPaid = 'is_paid'
}

/** select "commissions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "commissions" */
export enum Commissions_Select_Column_Commissions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPaid = 'is_paid'
}

/** input type for updating data in table "commissions" */
export type Commissions_Set_Input = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  beneficiary_team_id?: InputMaybe<Scalars['uuid']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  vat?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate stddev on columns */
export type Commissions_Stddev_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "commissions" */
export type Commissions_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Commissions_Stddev_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "commissions" */
export type Commissions_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Commissions_Stddev_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "commissions" */
export type Commissions_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Commissions_Sum_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "commissions" */
export type Commissions_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** update columns of table "commissions" */
export enum Commissions_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BeneficiaryTeamId = 'beneficiary_team_id',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  Vat = 'vat'
}

export type Commissions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Commissions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Commissions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Commissions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Commissions_Var_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "commissions" */
export type Commissions_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Commissions_Var_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "commissions" */
export type Commissions_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Commissions_Variance_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "commissions" */
export type Commissions_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

export type Conversation_Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Conversation_Message_Aggregate_Bool_Exp_Count>;
};

export type Conversation_Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Conversation_Part_Aggregate_Bool_Exp = {
  count?: InputMaybe<Conversation_Part_Aggregate_Bool_Exp_Count>;
};

export type Conversation_Part_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Conversation_Tool_Call_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Conversation_Tool_Call_Aggregate_Bool_Exp_Count>;
};

export type Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_And = {
  arguments: Chat_Api_Conversation_Tool_Call_Select_Column_Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Chat_Api_Conversation_Tool_Call_Select_Column_Conversation_Tool_Call_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Conversation_Tool_Call_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Conversation_Trace_Aggregate_Bool_Exp = {
  count?: InputMaybe<Conversation_Trace_Aggregate_Bool_Exp_Count>;
};

export type Conversation_Trace_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** columns and relationships of "cooling_enum" */
export type Cooling_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "cooling_enum". All fields are combined with a logical 'AND'. */
export type Cooling_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Cooling_Enum_Bool_Exp>>;
  _not?: InputMaybe<Cooling_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Cooling_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Cooling_Enum_Enum {
  AirConditioning = 'air_conditioning',
  CeilingFans = 'ceiling_fans',
  None = 'none'
}

/** Boolean expression to compare columns of type "cooling_enum_enum". All fields are combined with logical 'AND'. */
export type Cooling_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cooling_Enum_Enum>;
  _in?: InputMaybe<Array<Cooling_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Cooling_Enum_Enum>;
  _nin?: InputMaybe<Array<Cooling_Enum_Enum>>;
};

/** Ordering options when selecting data from "cooling_enum". */
export type Cooling_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "cooling_enum" */
export enum Cooling_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "cooling_enum" */
export type Cooling_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cooling_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cooling_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "countries" */
export type Countries = {
  country_code: Scalars['String']['output'];
  country_code_iso_3: Scalars['String']['output'];
  geog: Scalars['geography']['output'];
  id: Scalars['uuid']['output'];
  local_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone_number_allowed: Scalars['Boolean']['output'];
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type Countries_Bool_Exp = {
  _and?: InputMaybe<Array<Countries_Bool_Exp>>;
  _not?: InputMaybe<Countries_Bool_Exp>;
  _or?: InputMaybe<Array<Countries_Bool_Exp>>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_code_iso_3?: InputMaybe<String_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  local_name?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_number_allowed?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Ordering options when selecting data from "countries". */
export type Countries_Order_By = {
  country_code?: InputMaybe<Order_By>;
  country_code_iso_3?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_name?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number_allowed?: InputMaybe<Order_By>;
};

/** select columns of table "countries" */
export enum Countries_Select_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryCodeIso_3 = 'country_code_iso_3',
  /** column name */
  Geog = 'geog',
  /** column name */
  Id = 'id',
  /** column name */
  LocalName = 'local_name',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumberAllowed = 'phone_number_allowed'
}

/** Streaming cursor of the table "countries" */
export type Countries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Countries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Countries_Stream_Cursor_Value_Input = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_code_iso_3?: InputMaybe<Scalars['String']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  local_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number_allowed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to compare columns of type "cube". All fields are combined with logical 'AND'. */
export type Cube_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['cube']['input']>;
  _gt?: InputMaybe<Scalars['cube']['input']>;
  _gte?: InputMaybe<Scalars['cube']['input']>;
  _in?: InputMaybe<Array<Scalars['cube']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['cube']['input']>;
  _lte?: InputMaybe<Scalars['cube']['input']>;
  _neq?: InputMaybe<Scalars['cube']['input']>;
  _nin?: InputMaybe<Array<Scalars['cube']['input']>>;
};

/** Boolean expression to compare columns of type "currencies". All fields are combined with logical 'AND'. */
export type Currencies_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['currencies']['input']>;
  _gt?: InputMaybe<Scalars['currencies']['input']>;
  _gte?: InputMaybe<Scalars['currencies']['input']>;
  _in?: InputMaybe<Array<Scalars['currencies']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['currencies']['input']>;
  _lte?: InputMaybe<Scalars['currencies']['input']>;
  _neq?: InputMaybe<Scalars['currencies']['input']>;
  _nin?: InputMaybe<Array<Scalars['currencies']['input']>>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "development_collaborators" */
export type Development_Collaborators = {
  /** An object relationship */
  development: Developments;
  development_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "development_collaborators" */
export type Development_Collaborators_Aggregate = {
  aggregate?: Maybe<Development_Collaborators_Aggregate_Fields>;
  nodes: Array<Development_Collaborators>;
};

export type Development_Collaborators_Aggregate_Bool_Exp = {
  count?: InputMaybe<Development_Collaborators_Aggregate_Bool_Exp_Count>;
};

export type Development_Collaborators_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Development_Collaborators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Development_Collaborators_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "development_collaborators" */
export type Development_Collaborators_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Development_Collaborators_Max_Fields>;
  min?: Maybe<Development_Collaborators_Min_Fields>;
};


/** aggregate fields of "development_collaborators" */
export type Development_Collaborators_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Development_Collaborators_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "development_collaborators" */
export type Development_Collaborators_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Development_Collaborators_Max_Order_By>;
  min?: InputMaybe<Development_Collaborators_Min_Order_By>;
};

/** input type for inserting array relation for remote table "development_collaborators" */
export type Development_Collaborators_Arr_Rel_Insert_Input = {
  data: Array<Development_Collaborators_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Development_Collaborators_On_Conflict>;
};

/** Boolean expression to filter rows from the table "development_collaborators". All fields are combined with a logical 'AND'. */
export type Development_Collaborators_Bool_Exp = {
  _and?: InputMaybe<Array<Development_Collaborators_Bool_Exp>>;
  _not?: InputMaybe<Development_Collaborators_Bool_Exp>;
  _or?: InputMaybe<Array<Development_Collaborators_Bool_Exp>>;
  development?: InputMaybe<Developments_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "development_collaborators" */
export enum Development_Collaborators_Constraint {
  /** unique or primary key constraint on columns "user_id", "development_id" */
  DevelopmentCollaboratorsDevelopmentIdUserIdUnique = 'development_collaborators_development_id_user_id_unique',
  /** unique or primary key constraint on columns "user_id", "development_id" */
  DevelopmentCollaboratorsPkey = 'development_collaborators_pkey'
}

/** input type for inserting data into table "development_collaborators" */
export type Development_Collaborators_Insert_Input = {
  development?: InputMaybe<Developments_Obj_Rel_Insert_Input>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Development_Collaborators_Max_Fields = {
  development_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "development_collaborators" */
export type Development_Collaborators_Max_Order_By = {
  development_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Development_Collaborators_Min_Fields = {
  development_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "development_collaborators" */
export type Development_Collaborators_Min_Order_By = {
  development_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "development_collaborators" */
export type Development_Collaborators_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Development_Collaborators>;
};

/** on_conflict condition type for table "development_collaborators" */
export type Development_Collaborators_On_Conflict = {
  constraint: Development_Collaborators_Constraint;
  update_columns?: Array<Development_Collaborators_Update_Column>;
  where?: InputMaybe<Development_Collaborators_Bool_Exp>;
};

/** Ordering options when selecting data from "development_collaborators". */
export type Development_Collaborators_Order_By = {
  development?: InputMaybe<Developments_Order_By>;
  development_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "development_collaborators" */
export enum Development_Collaborators_Select_Column {
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  UserId = 'user_id'
}

/** placeholder for update columns of table "development_collaborators" (current role has no relevant permissions) */
export enum Development_Collaborators_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "development_files" */
export type Development_Files = {
  /** An object relationship */
  development: Developments;
  development_id: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
};

/** aggregated selection of "development_files" */
export type Development_Files_Aggregate = {
  aggregate?: Maybe<Development_Files_Aggregate_Fields>;
  nodes: Array<Development_Files>;
};

export type Development_Files_Aggregate_Bool_Exp = {
  count?: InputMaybe<Development_Files_Aggregate_Bool_Exp_Count>;
};

export type Development_Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Development_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Development_Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "development_files" */
export type Development_Files_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Development_Files_Max_Fields>;
  min?: Maybe<Development_Files_Min_Fields>;
};


/** aggregate fields of "development_files" */
export type Development_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Development_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "development_files" */
export type Development_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Development_Files_Max_Order_By>;
  min?: InputMaybe<Development_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "development_files" */
export type Development_Files_Arr_Rel_Insert_Input = {
  data: Array<Development_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Development_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "development_files". All fields are combined with a logical 'AND'. */
export type Development_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Development_Files_Bool_Exp>>;
  _not?: InputMaybe<Development_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Development_Files_Bool_Exp>>;
  development?: InputMaybe<Developments_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "development_files" */
export enum Development_Files_Constraint {
  /** unique or primary key constraint on columns "file_id", "development_id" */
  DevelopmentFilesDevelopmentIdFileIdUnique = 'development_files_development_id_file_id_unique',
  /** unique or primary key constraint on columns "file_id", "development_id" */
  DevelopmentFilesPkey = 'development_files_pkey'
}

/** input type for inserting data into table "development_files" */
export type Development_Files_Insert_Input = {
  development?: InputMaybe<Developments_Obj_Rel_Insert_Input>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Development_Files_Max_Fields = {
  development_id?: Maybe<Scalars['uuid']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "development_files" */
export type Development_Files_Max_Order_By = {
  development_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Development_Files_Min_Fields = {
  development_id?: Maybe<Scalars['uuid']['output']>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "development_files" */
export type Development_Files_Min_Order_By = {
  development_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "development_files" */
export type Development_Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Development_Files>;
};

/** on_conflict condition type for table "development_files" */
export type Development_Files_On_Conflict = {
  constraint: Development_Files_Constraint;
  update_columns?: Array<Development_Files_Update_Column>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "development_files". */
export type Development_Files_Order_By = {
  development?: InputMaybe<Developments_Order_By>;
  development_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "development_files" */
export enum Development_Files_Select_Column {
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "development_files" */
export type Development_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Development_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Development_Files_Stream_Cursor_Value_Input = {
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "development_files" (current role has no relevant permissions) */
export enum Development_Files_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "development_images" */
export type Development_Images = {
  background_color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  crop: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  development: Developments;
  development_id: Scalars['uuid']['output'];
  display_on_brochure: Scalars['Boolean']['output'];
  display_on_listing: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  order_nr: Scalars['Int']['output'];
  size: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "development_images" */
export type Development_Images_Aggregate = {
  aggregate?: Maybe<Development_Images_Aggregate_Fields>;
  nodes: Array<Development_Images>;
};

export type Development_Images_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Development_Images_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Development_Images_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Development_Images_Aggregate_Bool_Exp_Count>;
};

export type Development_Images_Aggregate_Bool_Exp_Bool_And = {
  arguments: Development_Images_Select_Column_Development_Images_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Development_Images_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Development_Images_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Development_Images_Select_Column_Development_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Development_Images_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Development_Images_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Development_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Development_Images_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "development_images" */
export type Development_Images_Aggregate_Fields = {
  avg?: Maybe<Development_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Development_Images_Max_Fields>;
  min?: Maybe<Development_Images_Min_Fields>;
  stddev?: Maybe<Development_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Development_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Development_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Development_Images_Sum_Fields>;
  var_pop?: Maybe<Development_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Development_Images_Var_Samp_Fields>;
  variance?: Maybe<Development_Images_Variance_Fields>;
};


/** aggregate fields of "development_images" */
export type Development_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Development_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "development_images" */
export type Development_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Development_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Development_Images_Max_Order_By>;
  min?: InputMaybe<Development_Images_Min_Order_By>;
  stddev?: InputMaybe<Development_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Development_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Development_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Development_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Development_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Development_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Development_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "development_images" */
export type Development_Images_Arr_Rel_Insert_Input = {
  data: Array<Development_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Development_Images_On_Conflict>;
};

/** aggregate avg on columns */
export type Development_Images_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "development_images" */
export type Development_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "development_images". All fields are combined with a logical 'AND'. */
export type Development_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Development_Images_Bool_Exp>>;
  _not?: InputMaybe<Development_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Development_Images_Bool_Exp>>;
  background_color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  development?: InputMaybe<Developments_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  display_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  display_on_listing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "development_images" */
export enum Development_Images_Constraint {
  /** unique or primary key constraint on columns "image_id", "development_id" */
  DevelopmentImagesDevelopmentIdImageIdUnique = 'development_images_development_id_image_id_unique',
  /** unique or primary key constraint on columns "order_nr", "development_id" */
  DevelopmentImagesDevelopmentIdOrderNrUnique = 'development_images_development_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  DevelopmentImagesPkey = 'development_images_pkey'
}

/** input type for incrementing numeric columns in table "development_images" */
export type Development_Images_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "development_images" */
export type Development_Images_Insert_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development?: InputMaybe<Developments_Obj_Rel_Insert_Input>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Development_Images_Max_Fields = {
  background_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "development_images" */
export type Development_Images_Max_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Development_Images_Min_Fields = {
  background_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "development_images" */
export type Development_Images_Min_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "development_images" */
export type Development_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Development_Images>;
};

/** on_conflict condition type for table "development_images" */
export type Development_Images_On_Conflict = {
  constraint: Development_Images_Constraint;
  update_columns?: Array<Development_Images_Update_Column>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "development_images". */
export type Development_Images_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development?: InputMaybe<Developments_Order_By>;
  development_id?: InputMaybe<Order_By>;
  display_on_brochure?: InputMaybe<Order_By>;
  display_on_listing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: development_images */
export type Development_Images_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "development_images" */
export enum Development_Images_Select_Column {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "development_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "development_images" */
export enum Development_Images_Select_Column_Development_Images_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing'
}

/** select "development_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "development_images" */
export enum Development_Images_Select_Column_Development_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing'
}

/** input type for updating data in table "development_images" */
export type Development_Images_Set_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Development_Images_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "development_images" */
export type Development_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Development_Images_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "development_images" */
export type Development_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Development_Images_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "development_images" */
export type Development_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "development_images" */
export type Development_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Development_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Development_Images_Stream_Cursor_Value_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Development_Images_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "development_images" */
export type Development_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "development_images" */
export enum Development_Images_Update_Column {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title'
}

export type Development_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Development_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Development_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Development_Images_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Development_Images_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "development_images" */
export type Development_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Development_Images_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "development_images" */
export type Development_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Development_Images_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "development_images" */
export type Development_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "development_mappings" */
export type Development_Mappings = {
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  svg_path: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "development_mappings" */
export type Development_Mappings_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Development_Mappings_Max_Order_By>;
  min?: InputMaybe<Development_Mappings_Min_Order_By>;
};

/** input type for inserting array relation for remote table "development_mappings" */
export type Development_Mappings_Arr_Rel_Insert_Input = {
  data: Array<Development_Mappings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Development_Mappings_On_Conflict>;
};

/** Boolean expression to filter rows from the table "development_mappings". All fields are combined with a logical 'AND'. */
export type Development_Mappings_Bool_Exp = {
  _and?: InputMaybe<Array<Development_Mappings_Bool_Exp>>;
  _not?: InputMaybe<Development_Mappings_Bool_Exp>;
  _or?: InputMaybe<Array<Development_Mappings_Bool_Exp>>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  svg_path?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "development_mappings" */
export enum Development_Mappings_Constraint {
  /** unique or primary key constraint on columns "image_id", "lot_id" */
  DevelopmentMappingsPkey = 'development_mappings_pkey'
}

/** input type for inserting data into table "development_mappings" */
export type Development_Mappings_Insert_Input = {
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  svg_path?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "development_mappings" */
export type Development_Mappings_Max_Order_By = {
  image_id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  svg_path?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "development_mappings" */
export type Development_Mappings_Min_Order_By = {
  image_id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  svg_path?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "development_mappings" */
export type Development_Mappings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Development_Mappings>;
};

/** on_conflict condition type for table "development_mappings" */
export type Development_Mappings_On_Conflict = {
  constraint: Development_Mappings_Constraint;
  update_columns?: Array<Development_Mappings_Update_Column>;
  where?: InputMaybe<Development_Mappings_Bool_Exp>;
};

/** Ordering options when selecting data from "development_mappings". */
export type Development_Mappings_Order_By = {
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  svg_path?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: development_mappings */
export type Development_Mappings_Pk_Columns_Input = {
  image_id: Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
};

/** select columns of table "development_mappings" */
export enum Development_Mappings_Select_Column {
  /** column name */
  ImageId = 'image_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  SvgPath = 'svg_path',
  /** column name */
  TenantId = 'tenant_id'
}

/** input type for updating data in table "development_mappings" */
export type Development_Mappings_Set_Input = {
  svg_path?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "development_mappings" */
export type Development_Mappings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Development_Mappings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Development_Mappings_Stream_Cursor_Value_Input = {
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  svg_path?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "development_mappings" */
export enum Development_Mappings_Update_Column {
  /** column name */
  SvgPath = 'svg_path'
}

export type Development_Mappings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Development_Mappings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Development_Mappings_Bool_Exp;
};

/** columns and relationships of "development_status_enum" */
export type Development_Status_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "development_status_enum". All fields are combined with a logical 'AND'. */
export type Development_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Development_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Development_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Development_Status_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Development_Status_Enum_Enum {
  Construction = 'construction',
  Delivered = 'delivered',
  Draft = 'draft',
  Marketing = 'marketing'
}

/** Boolean expression to compare columns of type "development_status_enum_enum". All fields are combined with logical 'AND'. */
export type Development_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Development_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Development_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Development_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Development_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "development_status_enum". */
export type Development_Status_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "development_status_enum" */
export enum Development_Status_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "development_status_enum" */
export type Development_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Development_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Development_Status_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** New-build projects. Their units are lots with development_id set. */
export type Developments = {
  /** An object relationship */
  architect?: Maybe<Organisations>;
  architect_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  delivery_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  developer?: Maybe<Organisations>;
  developer_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  development_collaborators: Array<Development_Collaborators>;
  /** An aggregate relationship */
  development_collaborators_aggregate: Development_Collaborators_Aggregate;
  /** An array relationship */
  development_files: Array<Development_Files>;
  /** An aggregate relationship */
  development_files_aggregate: Development_Files_Aggregate;
  /** An array relationship */
  development_images: Array<Development_Images>;
  /** An aggregate relationship */
  development_images_aggregate: Development_Images_Aggregate;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  enquiry_response_enabled?: Maybe<Scalars['Boolean']['output']>;
  enquiry_response_override_lot: Scalars['Boolean']['output'];
  /** An object relationship */
  general_contractor?: Maybe<Organisations>;
  general_contractor_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_published: Scalars['Boolean']['output'];
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  /** An object relationship */
  mapping_image?: Maybe<Images>;
  mapping_image_id?: Maybe<Scalars['uuid']['output']>;
  registration_type: Scalars['String']['output'];
  /** An object relationship */
  response_sender?: Maybe<Users>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  slug: Scalars['String']['output'];
  status: Development_Status_Enum_Enum;
  tenant_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsDevelopment_CollaboratorsArgs = {
  distinct_on?: InputMaybe<Array<Development_Collaborators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Collaborators_Order_By>>;
  where?: InputMaybe<Development_Collaborators_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsDevelopment_Collaborators_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Collaborators_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Collaborators_Order_By>>;
  where?: InputMaybe<Development_Collaborators_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsDevelopment_FilesArgs = {
  distinct_on?: InputMaybe<Array<Development_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Files_Order_By>>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsDevelopment_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Files_Order_By>>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsDevelopment_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsDevelopment_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** New-build projects. Their units are lots with development_id set. */
export type DevelopmentsLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};

/** aggregated selection of "developments" */
export type Developments_Aggregate = {
  aggregate?: Maybe<Developments_Aggregate_Fields>;
  nodes: Array<Developments>;
};

export type Developments_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Developments_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Developments_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Developments_Aggregate_Bool_Exp_Count>;
};

export type Developments_Aggregate_Bool_Exp_Bool_And = {
  arguments: Developments_Select_Column_Developments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Developments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Developments_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Developments_Select_Column_Developments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Developments_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Developments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Developments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Developments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "developments" */
export type Developments_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Developments_Max_Fields>;
  min?: Maybe<Developments_Min_Fields>;
};


/** aggregate fields of "developments" */
export type Developments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Developments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "developments" */
export type Developments_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Developments_Max_Order_By>;
  min?: InputMaybe<Developments_Min_Order_By>;
};

/** input type for inserting array relation for remote table "developments" */
export type Developments_Arr_Rel_Insert_Input = {
  data: Array<Developments_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Developments_On_Conflict>;
};

/** Boolean expression to filter rows from the table "developments". All fields are combined with a logical 'AND'. */
export type Developments_Bool_Exp = {
  _and?: InputMaybe<Array<Developments_Bool_Exp>>;
  _not?: InputMaybe<Developments_Bool_Exp>;
  _or?: InputMaybe<Array<Developments_Bool_Exp>>;
  architect?: InputMaybe<Organisations_Bool_Exp>;
  architect_id?: InputMaybe<Uuid_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_leads?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  delivery_date?: InputMaybe<Date_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  developer?: InputMaybe<Organisations_Bool_Exp>;
  developer_id?: InputMaybe<Uuid_Comparison_Exp>;
  development_collaborators?: InputMaybe<Development_Collaborators_Bool_Exp>;
  development_collaborators_aggregate?: InputMaybe<Development_Collaborators_Aggregate_Bool_Exp>;
  development_files?: InputMaybe<Development_Files_Bool_Exp>;
  development_files_aggregate?: InputMaybe<Development_Files_Aggregate_Bool_Exp>;
  development_images?: InputMaybe<Development_Images_Bool_Exp>;
  development_images_aggregate?: InputMaybe<Development_Images_Aggregate_Bool_Exp>;
  email_templates?: InputMaybe<Email_Templates_Bool_Exp>;
  enquiry_response_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  enquiry_response_override_lot?: InputMaybe<Boolean_Comparison_Exp>;
  general_contractor?: InputMaybe<Organisations_Bool_Exp>;
  general_contractor_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  mapping_image?: InputMaybe<Images_Bool_Exp>;
  mapping_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  registration_type?: InputMaybe<String_Comparison_Exp>;
  response_sender?: InputMaybe<Users_Bool_Exp>;
  response_sender_id?: InputMaybe<Uuid_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Development_Status_Enum_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "developments" */
export enum Developments_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DevelopmentsIdTenantIdUnique = 'developments_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  DevelopmentsPkey = 'developments_pkey',
  /** unique or primary key constraint on columns "slug", "tenant_id" */
  DevelopmentsSlugTenantIdUnique = 'developments_slug_tenant_id_unique'
}

/** input type for inserting data into table "developments" */
export type Developments_Insert_Input = {
  architect?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  architect_id?: InputMaybe<Scalars['uuid']['input']>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<Buyer_Leads_Arr_Rel_Insert_Input>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  delivery_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developer?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  developer_id?: InputMaybe<Scalars['uuid']['input']>;
  development_collaborators?: InputMaybe<Development_Collaborators_Arr_Rel_Insert_Input>;
  development_files?: InputMaybe<Development_Files_Arr_Rel_Insert_Input>;
  development_images?: InputMaybe<Development_Images_Arr_Rel_Insert_Input>;
  email_templates?: InputMaybe<Email_Templates_Arr_Rel_Insert_Input>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_override_lot?: InputMaybe<Scalars['Boolean']['input']>;
  general_contractor?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  general_contractor_id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lots?: InputMaybe<Lots_Arr_Rel_Insert_Input>;
  mapping_image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  mapping_image_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_type?: InputMaybe<Scalars['String']['input']>;
  response_sender?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Development_Status_Enum_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Developments_Max_Fields = {
  architect_id?: Maybe<Scalars['uuid']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  delivery_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developer_id?: Maybe<Scalars['uuid']['output']>;
  general_contractor_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mapping_image_id?: Maybe<Scalars['uuid']['output']>;
  registration_type?: Maybe<Scalars['String']['output']>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "developments" */
export type Developments_Max_Order_By = {
  architect_id?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  developer_id?: InputMaybe<Order_By>;
  general_contractor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapping_image_id?: InputMaybe<Order_By>;
  registration_type?: InputMaybe<Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Developments_Min_Fields = {
  architect_id?: Maybe<Scalars['uuid']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  delivery_date?: Maybe<Scalars['date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developer_id?: Maybe<Scalars['uuid']['output']>;
  general_contractor_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mapping_image_id?: Maybe<Scalars['uuid']['output']>;
  registration_type?: Maybe<Scalars['String']['output']>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "developments" */
export type Developments_Min_Order_By = {
  architect_id?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  developer_id?: InputMaybe<Order_By>;
  general_contractor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mapping_image_id?: InputMaybe<Order_By>;
  registration_type?: InputMaybe<Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "developments" */
export type Developments_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Developments>;
};

/** input type for inserting object relation for remote table "developments" */
export type Developments_Obj_Rel_Insert_Input = {
  data: Developments_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Developments_On_Conflict>;
};

/** on_conflict condition type for table "developments" */
export type Developments_On_Conflict = {
  constraint: Developments_Constraint;
  update_columns?: Array<Developments_Update_Column>;
  where?: InputMaybe<Developments_Bool_Exp>;
};

/** Ordering options when selecting data from "developments". */
export type Developments_Order_By = {
  architect?: InputMaybe<Organisations_Order_By>;
  architect_id?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  delivery_date?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  developer?: InputMaybe<Organisations_Order_By>;
  developer_id?: InputMaybe<Order_By>;
  development_collaborators_aggregate?: InputMaybe<Development_Collaborators_Aggregate_Order_By>;
  development_files_aggregate?: InputMaybe<Development_Files_Aggregate_Order_By>;
  development_images_aggregate?: InputMaybe<Development_Images_Aggregate_Order_By>;
  email_templates_aggregate?: InputMaybe<Email_Templates_Aggregate_Order_By>;
  enquiry_response_enabled?: InputMaybe<Order_By>;
  enquiry_response_override_lot?: InputMaybe<Order_By>;
  general_contractor?: InputMaybe<Organisations_Order_By>;
  general_contractor_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  mapping_image?: InputMaybe<Images_Order_By>;
  mapping_image_id?: InputMaybe<Order_By>;
  registration_type?: InputMaybe<Order_By>;
  response_sender?: InputMaybe<Users_Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: developments */
export type Developments_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "developments" */
export enum Developments_Select_Column {
  /** column name */
  ArchitectId = 'architect_id',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Description = 'description',
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  EnquiryResponseOverrideLot = 'enquiry_response_override_lot',
  /** column name */
  GeneralContractorId = 'general_contractor_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  MappingImageId = 'mapping_image_id',
  /** column name */
  RegistrationType = 'registration_type',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "developments_aggregate_bool_exp_bool_and_arguments_columns" columns of table "developments" */
export enum Developments_Select_Column_Developments_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  EnquiryResponseOverrideLot = 'enquiry_response_override_lot',
  /** column name */
  IsPublished = 'is_published'
}

/** select "developments_aggregate_bool_exp_bool_or_arguments_columns" columns of table "developments" */
export enum Developments_Select_Column_Developments_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  EnquiryResponseOverrideLot = 'enquiry_response_override_lot',
  /** column name */
  IsPublished = 'is_published'
}

/** input type for updating data in table "developments" */
export type Developments_Set_Input = {
  architect_id?: InputMaybe<Scalars['uuid']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developer_id?: InputMaybe<Scalars['uuid']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_override_lot?: InputMaybe<Scalars['Boolean']['input']>;
  general_contractor_id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  mapping_image_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_type?: InputMaybe<Scalars['String']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Development_Status_Enum_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "developments" */
export type Developments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Developments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Developments_Stream_Cursor_Value_Input = {
  architect_id?: InputMaybe<Scalars['uuid']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  delivery_date?: InputMaybe<Scalars['date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developer_id?: InputMaybe<Scalars['uuid']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_override_lot?: InputMaybe<Scalars['Boolean']['input']>;
  general_contractor_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  mapping_image_id?: InputMaybe<Scalars['uuid']['input']>;
  registration_type?: InputMaybe<Scalars['String']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Development_Status_Enum_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "developments" */
export enum Developments_Update_Column {
  /** column name */
  ArchitectId = 'architect_id',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DeliveryDate = 'delivery_date',
  /** column name */
  Description = 'description',
  /** column name */
  DeveloperId = 'developer_id',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  EnquiryResponseOverrideLot = 'enquiry_response_override_lot',
  /** column name */
  GeneralContractorId = 'general_contractor_id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  MappingImageId = 'mapping_image_id',
  /** column name */
  RegistrationType = 'registration_type',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  Slug = 'slug',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Developments_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Developments_Set_Input>;
  /** filter the rows which have to be updated */
  where: Developments_Bool_Exp;
};

/** Labels for lookup values (label_<language>), grouped by type: lead source types, listing origin types, refusal reasons and others. tenant_id NULL = shared by every tenant. Rows of type 'enums' label the values of enum tables, with name = '<enum table>.<value>'. */
export type Dictionaries = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  dictionaries_types: Dictionaries_Types_Enum;
  /** An object relationship */
  group?: Maybe<Dictionaries>;
  group_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  is_deletable?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "dictionary_is_used" */
  is_used?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "dictionary_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en: Scalars['String']['output'];
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  type: Dictionaries_Types_Enum_Enum;
  types?: Maybe<Array<Scalars['String']['output']>>;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "dictionaries" */
export type Dictionaries_Aggregate = {
  aggregate?: Maybe<Dictionaries_Aggregate_Fields>;
  nodes: Array<Dictionaries>;
};

/** aggregate fields of "dictionaries" */
export type Dictionaries_Aggregate_Fields = {
  avg?: Maybe<Dictionaries_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Dictionaries_Max_Fields>;
  min?: Maybe<Dictionaries_Min_Fields>;
  stddev?: Maybe<Dictionaries_Stddev_Fields>;
  stddev_pop?: Maybe<Dictionaries_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Dictionaries_Stddev_Samp_Fields>;
  sum?: Maybe<Dictionaries_Sum_Fields>;
  var_pop?: Maybe<Dictionaries_Var_Pop_Fields>;
  var_samp?: Maybe<Dictionaries_Var_Samp_Fields>;
  variance?: Maybe<Dictionaries_Variance_Fields>;
};


/** aggregate fields of "dictionaries" */
export type Dictionaries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dictionaries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Dictionaries_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dictionaries". All fields are combined with a logical 'AND'. */
export type Dictionaries_Bool_Exp = {
  _and?: InputMaybe<Array<Dictionaries_Bool_Exp>>;
  _not?: InputMaybe<Dictionaries_Bool_Exp>;
  _or?: InputMaybe<Array<Dictionaries_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dictionaries_types?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
  group?: InputMaybe<Dictionaries_Bool_Exp>;
  group_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_deletable?: InputMaybe<Boolean_Comparison_Exp>;
  is_used?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum_Comparison_Exp>;
  types?: InputMaybe<String_Array_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "dictionaries" */
export enum Dictionaries_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DictionariesIdTenantIdUnique = 'dictionaries_id_tenant_id_unique',
  /** unique or primary key constraint on columns "type", "name" */
  DictionariesNameTypeKey = 'dictionaries_name_type_key',
  /** unique or primary key constraint on columns "type", "name", "tenant_id" */
  DictionariesNameTypeTenantIdKey = 'dictionaries_name_type_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DictionariesPkey = 'dictionaries_pkey'
}

/** input type for incrementing numeric columns in table "dictionaries" */
export type Dictionaries_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dictionaries" */
export type Dictionaries_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Dictionaries_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "dictionary_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  types?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Dictionaries_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  group_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "dictionary_label" */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  types?: Maybe<Array<Scalars['String']['output']>>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "dictionaries" */
export type Dictionaries_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Dictionaries>;
};

/** input type for inserting object relation for remote table "dictionaries" */
export type Dictionaries_Obj_Rel_Insert_Input = {
  data: Dictionaries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dictionaries_On_Conflict>;
};

/** on_conflict condition type for table "dictionaries" */
export type Dictionaries_On_Conflict = {
  constraint: Dictionaries_Constraint;
  update_columns?: Array<Dictionaries_Update_Column>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};

/** Ordering options when selecting data from "dictionaries". */
export type Dictionaries_Order_By = {
  created_at?: InputMaybe<Order_By>;
  dictionaries_types?: InputMaybe<Dictionaries_Types_Enum_Order_By>;
  group?: InputMaybe<Dictionaries_Order_By>;
  group_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_deletable?: InputMaybe<Order_By>;
  is_used?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  types?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dictionaries */
export type Dictionaries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dictionaries" */
export enum Dictionaries_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeletable = 'is_deletable',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "dictionaries" */
export type Dictionaries_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Dictionaries_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Dictionaries_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Dictionaries_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dictionaries" */
export type Dictionaries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dictionaries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dictionaries_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  group_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_deletable?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Dictionaries_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "dictionaries_types_enum" */
export type Dictionaries_Types_Enum = {
  comment: Scalars['String']['output'];
  /** A computed field, executes function "dictionaries_types_enum_label" */
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "dictionaries_types_enum". All fields are combined with a logical 'AND'. */
export type Dictionaries_Types_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Dictionaries_Types_Enum_Bool_Exp>>;
  _not?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Dictionaries_Types_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Dictionaries_Types_Enum_Enum {
  /** Certifications available for users */
  Certifications = 'certifications',
  DocumentTypeGroups = 'document_type_groups',
  Documents = 'documents',
  Enums = 'enums',
  Languages = 'languages',
  LeadRefusedTypes = 'lead_refused_types',
  LeadSourceTypes = 'lead_source_types',
  LotOriginTypes = 'lot_origin_types',
  MandateProbabilityTypes = 'mandate_probability_types',
  MembershipTypes = 'membership_types',
  NationalityTypes = 'nationality_types',
  OccupationTypes = 'occupation_types',
  OfferRefusedTypes = 'offer_refused_types',
  /** Point of Interest types for properties */
  PoiTypes = 'poi_types',
  Services = 'services',
  StringFilters = 'string_filters',
  TagsTypes = 'tags_types',
  WorkPermitTypes = 'work_permit_types'
}

/** Boolean expression to compare columns of type "dictionaries_types_enum_enum". All fields are combined with logical 'AND'. */
export type Dictionaries_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Dictionaries_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Dictionaries_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Dictionaries_Types_Enum_Enum>>;
};

/** Ordering options when selecting data from "dictionaries_types_enum". */
export type Dictionaries_Types_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "dictionaries_types_enum" */
export enum Dictionaries_Types_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "dictionaries_types_enum" */
export type Dictionaries_Types_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dictionaries_Types_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dictionaries_Types_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "dictionaries" */
export enum Dictionaries_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDeletable = 'is_deletable',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  Types = 'types',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Dictionaries_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Dictionaries_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dictionaries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dictionaries_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Dictionaries_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Dictionaries_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Dictionaries_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "doc_template_themes" */
export type Doc_Template_Themes = {
  active: Scalars['Boolean']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  created_by_tenant?: Maybe<Read_Only_Tenants>;
  created_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  doc_template_themes_teams: Array<Doc_Template_Themes_Teams>;
  /** An array relationship */
  doc_template_themes_tenants: Array<Doc_Template_Themes_Tenants>;
  /** An array relationship */
  doc_templates: Array<Doc_Templates>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "doc_template_themes" */
export type Doc_Template_ThemesDoc_Template_Themes_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Themes_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Themes_Teams_Order_By>>;
  where?: InputMaybe<Doc_Template_Themes_Teams_Bool_Exp>;
};


/** columns and relationships of "doc_template_themes" */
export type Doc_Template_ThemesDoc_Template_Themes_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Themes_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Themes_Tenants_Order_By>>;
  where?: InputMaybe<Doc_Template_Themes_Tenants_Bool_Exp>;
};


/** columns and relationships of "doc_template_themes" */
export type Doc_Template_ThemesDoc_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Order_By>>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "doc_template_themes". All fields are combined with a logical 'AND'. */
export type Doc_Template_Themes_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Template_Themes_Bool_Exp>>;
  _not?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Template_Themes_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by_tenant?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  created_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  doc_template_themes_teams?: InputMaybe<Doc_Template_Themes_Teams_Bool_Exp>;
  doc_template_themes_tenants?: InputMaybe<Doc_Template_Themes_Tenants_Bool_Exp>;
  doc_templates?: InputMaybe<Doc_Templates_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "doc_template_themes" */
export enum Doc_Template_Themes_Constraint {
  /** unique or primary key constraint on columns "name", "tenant_id" */
  DocTemplateThemesNameTenantIdKey = 'doc_template_themes_name_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DocTemplateThemesPkey = 'doc_template_themes_pkey'
}

/** input type for inserting data into table "doc_template_themes" */
export type Doc_Template_Themes_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  doc_template_themes_teams?: InputMaybe<Doc_Template_Themes_Teams_Arr_Rel_Insert_Input>;
  doc_template_themes_tenants?: InputMaybe<Doc_Template_Themes_Tenants_Arr_Rel_Insert_Input>;
  doc_templates?: InputMaybe<Doc_Templates_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "doc_template_themes" */
export type Doc_Template_Themes_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Template_Themes>;
};

/** input type for inserting object relation for remote table "doc_template_themes" */
export type Doc_Template_Themes_Obj_Rel_Insert_Input = {
  data: Doc_Template_Themes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Template_Themes_On_Conflict>;
};

/** on_conflict condition type for table "doc_template_themes" */
export type Doc_Template_Themes_On_Conflict = {
  constraint: Doc_Template_Themes_Constraint;
  update_columns?: Array<Doc_Template_Themes_Update_Column>;
  where?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_template_themes". */
export type Doc_Template_Themes_Order_By = {
  active?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by_tenant?: InputMaybe<Read_Only_Tenants_Order_By>;
  created_by_user_id?: InputMaybe<Order_By>;
  doc_template_themes_teams_aggregate?: InputMaybe<Doc_Template_Themes_Teams_Aggregate_Order_By>;
  doc_template_themes_tenants_aggregate?: InputMaybe<Doc_Template_Themes_Tenants_Aggregate_Order_By>;
  doc_templates_aggregate?: InputMaybe<Doc_Templates_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: doc_template_themes */
export type Doc_Template_Themes_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "doc_template_themes" */
export enum Doc_Template_Themes_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedByUserId = 'created_by_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_template_themes" */
export type Doc_Template_Themes_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "doc_template_themes" */
export type Doc_Template_Themes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Template_Themes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Template_Themes_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_default: Scalars['Boolean']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  /** An object relationship */
  theme: Doc_Template_Themes;
  theme_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Template_Themes_Teams_Max_Order_By>;
  min?: InputMaybe<Doc_Template_Themes_Teams_Min_Order_By>;
};

/** input type for inserting array relation for remote table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_Arr_Rel_Insert_Input = {
  data: Array<Doc_Template_Themes_Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Template_Themes_Teams_On_Conflict>;
};

/** Boolean expression to filter rows from the table "doc_template_themes_teams". All fields are combined with a logical 'AND'. */
export type Doc_Template_Themes_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Template_Themes_Teams_Bool_Exp>>;
  _not?: InputMaybe<Doc_Template_Themes_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Template_Themes_Teams_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  theme?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
  theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "doc_template_themes_teams" */
export enum Doc_Template_Themes_Teams_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocTemplateThemesTeamsPkey = 'doc_template_themes_teams_pkey',
  /** unique or primary key constraint on columns "theme_id", "team_id" */
  DocTemplateThemesTeamsThemeIdTeamIdKey = 'doc_template_themes_teams_theme_id_team_id_key'
}

/** input type for inserting data into table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_Insert_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  theme?: InputMaybe<Doc_Template_Themes_Obj_Rel_Insert_Input>;
  theme_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Template_Themes_Teams>;
};

/** on_conflict condition type for table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_On_Conflict = {
  constraint: Doc_Template_Themes_Teams_Constraint;
  update_columns?: Array<Doc_Template_Themes_Teams_Update_Column>;
  where?: InputMaybe<Doc_Template_Themes_Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_template_themes_teams". */
export type Doc_Template_Themes_Teams_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  theme?: InputMaybe<Doc_Template_Themes_Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: doc_template_themes_teams */
export type Doc_Template_Themes_Teams_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "doc_template_themes_teams" */
export enum Doc_Template_Themes_Teams_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  ThemeId = 'theme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_template_themes_teams" */
export type Doc_Template_Themes_Teams_Set_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "doc_template_themes_teams" */
export enum Doc_Template_Themes_Teams_Update_Column {
  /** column name */
  IsDefault = 'is_default'
}

export type Doc_Template_Themes_Teams_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Template_Themes_Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Template_Themes_Teams_Bool_Exp;
};

/** columns and relationships of "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_default: Scalars['Boolean']['output'];
  /** An object relationship */
  tenant?: Maybe<Read_Only_Tenants>;
  tenant_id: Scalars['uuid']['output'];
  /** An object relationship */
  theme: Doc_Template_Themes;
  theme_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Template_Themes_Tenants_Max_Order_By>;
  min?: InputMaybe<Doc_Template_Themes_Tenants_Min_Order_By>;
};

/** input type for inserting array relation for remote table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_Arr_Rel_Insert_Input = {
  data: Array<Doc_Template_Themes_Tenants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Template_Themes_Tenants_On_Conflict>;
};

/** Boolean expression to filter rows from the table "doc_template_themes_tenants". All fields are combined with a logical 'AND'. */
export type Doc_Template_Themes_Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Template_Themes_Tenants_Bool_Exp>>;
  _not?: InputMaybe<Doc_Template_Themes_Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Template_Themes_Tenants_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  tenant?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  theme?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
  theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "doc_template_themes_tenants" */
export enum Doc_Template_Themes_Tenants_Constraint {
  /** unique or primary key constraint on columns "id" */
  DocTemplateThemesTenantsPkey = 'doc_template_themes_tenants_pkey',
  /** unique or primary key constraint on columns "theme_id", "tenant_id" */
  DocTemplateThemesTenantsThemeIdTenantIdKey = 'doc_template_themes_tenants_theme_id_tenant_id_key'
}

/** input type for inserting data into table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_Insert_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  theme?: InputMaybe<Doc_Template_Themes_Obj_Rel_Insert_Input>;
  theme_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Template_Themes_Tenants>;
};

/** on_conflict condition type for table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_On_Conflict = {
  constraint: Doc_Template_Themes_Tenants_Constraint;
  update_columns?: Array<Doc_Template_Themes_Tenants_Update_Column>;
  where?: InputMaybe<Doc_Template_Themes_Tenants_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_template_themes_tenants". */
export type Doc_Template_Themes_Tenants_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Read_Only_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  theme?: InputMaybe<Doc_Template_Themes_Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: doc_template_themes_tenants */
export type Doc_Template_Themes_Tenants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "doc_template_themes_tenants" */
export enum Doc_Template_Themes_Tenants_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThemeId = 'theme_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_template_themes_tenants" */
export type Doc_Template_Themes_Tenants_Set_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "doc_template_themes_tenants" */
export enum Doc_Template_Themes_Tenants_Update_Column {
  /** column name */
  IsDefault = 'is_default'
}

export type Doc_Template_Themes_Tenants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Template_Themes_Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Template_Themes_Tenants_Bool_Exp;
};

/** update columns of table "doc_template_themes" */
export enum Doc_Template_Themes_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Name = 'name'
}

export type Doc_Template_Themes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Template_Themes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Template_Themes_Bool_Exp;
};

/** Enum for doc_template_type */
export type Doc_Template_Type_Enum = {
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "doc_template_type_enum". All fields are combined with a logical 'AND'. */
export type Doc_Template_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Template_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Template_Type_Enum_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Doc_Template_Type_Enum_Enum {
  AppraisalReport = 'appraisal_report',
  CmaReport = 'cma_report',
  CmaReportTheme = 'cma_report_theme',
  DevelopmentBrochure = 'development_brochure',
  FinancingPassport = 'financing_passport',
  LotBrochure = 'lot_brochure',
  LotBrochureTheme = 'lot_brochure_theme',
  Mandate = 'mandate',
  SellerReport = 'seller_report',
  Theme = 'theme'
}

/** Boolean expression to compare columns of type "doc_template_type_enum_enum". All fields are combined with logical 'AND'. */
export type Doc_Template_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Doc_Template_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Doc_Template_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Doc_Template_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Doc_Template_Type_Enum_Enum>>;
};

/** Ordering options when selecting data from "doc_template_type_enum". */
export type Doc_Template_Type_Enum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** select columns of table "doc_template_type_enum" */
export enum Doc_Template_Type_Enum_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "doc_template_type_enum" */
export type Doc_Template_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Template_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Template_Type_Enum_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The last 20 versions of a document template, kept by a trigger before each change of its content or texts. Restoring the newest one undoes the last change and removes it from the list. */
export type Doc_Template_Versions = {
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  doc_template: Doc_Templates;
  doc_template_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  translations?: Maybe<Scalars['jsonb']['output']>;
  updated_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  updated_by_user?: Maybe<Users>;
};


/** The last 20 versions of a document template, kept by a trigger before each change of its content or texts. Restoring the newest one undoes the last change and removes it from the list. */
export type Doc_Template_VersionsTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "doc_template_versions" */
export type Doc_Template_Versions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Template_Versions_Max_Order_By>;
  min?: InputMaybe<Doc_Template_Versions_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "doc_template_versions". All fields are combined with a logical 'AND'. */
export type Doc_Template_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Template_Versions_Bool_Exp>>;
  _not?: InputMaybe<Doc_Template_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Template_Versions_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_by?: InputMaybe<Uuid_Comparison_Exp>;
  updated_by_user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "doc_template_versions" */
export type Doc_Template_Versions_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_template_versions" */
export type Doc_Template_Versions_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "doc_template_versions". */
export type Doc_Template_Versions_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Order_By>;
  updated_by_user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "doc_template_versions" */
export enum Doc_Template_Versions_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  Translations = 'translations',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** Streaming cursor of the table "doc_template_versions" */
export type Doc_Template_Versions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Template_Versions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Template_Versions_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  updated_by?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "doc_templates" */
export type Doc_Templates = {
  active: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_tenant?: Maybe<Read_Only_Tenants>;
  /** An object relationship */
  doc_template_type_enum: Doc_Template_Type_Enum;
  /** An array relationship */
  doc_templates_teams: Array<Doc_Templates_Teams>;
  /** An array relationship */
  doc_templates_tenants: Array<Doc_Templates_Tenants>;
  filename_template: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  /** An object relationship */
  theme?: Maybe<Doc_Template_Themes>;
  theme_id?: Maybe<Scalars['uuid']['output']>;
  translations?: Maybe<Scalars['jsonb']['output']>;
  type: Doc_Template_Type_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  versions: Array<Doc_Template_Versions>;
};


/** columns and relationships of "doc_templates" */
export type Doc_TemplatesDoc_Templates_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Teams_Order_By>>;
  where?: InputMaybe<Doc_Templates_Teams_Bool_Exp>;
};


/** columns and relationships of "doc_templates" */
export type Doc_TemplatesDoc_Templates_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Tenants_Order_By>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


/** columns and relationships of "doc_templates" */
export type Doc_TemplatesTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "doc_templates" */
export type Doc_TemplatesVersionsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Versions_Order_By>>;
  where?: InputMaybe<Doc_Template_Versions_Bool_Exp>;
};

/** order by aggregate values of table "doc_templates" */
export type Doc_Templates_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Templates_Max_Order_By>;
  min?: InputMaybe<Doc_Templates_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Doc_Templates_Append_Input = {
  translations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "doc_templates" */
export type Doc_Templates_Arr_Rel_Insert_Input = {
  data: Array<Doc_Templates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Templates_On_Conflict>;
};

/** Boolean expression to filter rows from the table "doc_templates". All fields are combined with a logical 'AND'. */
export type Doc_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Templates_Bool_Exp>>;
  _not?: InputMaybe<Doc_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Templates_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_tenant?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  doc_template_type_enum?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
  doc_templates_teams?: InputMaybe<Doc_Templates_Teams_Bool_Exp>;
  doc_templates_tenants?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
  filename_template?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  theme?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
  theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<Doc_Template_Type_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  versions?: InputMaybe<Doc_Template_Versions_Bool_Exp>;
};

/** unique or primary key constraints on table "doc_templates" */
export enum Doc_Templates_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DocTemplatesIdTenantIdUnique = 'doc_templates_id_tenant_id_unique',
  /** unique or primary key constraint on columns "type", "name", "tenant_id" */
  DocTemplatesNameTenantIdUnique = 'doc_templates_name_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesPkey = 'doc_templates_pkey',
  /** unique or primary key constraint on columns "type", "theme_id" */
  DocTemplatesThemeIdTypeKey = 'doc_templates_theme_id_type_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Doc_Templates_Delete_At_Path_Input = {
  translations?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Doc_Templates_Delete_Elem_Input = {
  translations?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Doc_Templates_Delete_Key_Input = {
  translations?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "doc_templates" */
export type Doc_Templates_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  doc_templates_teams?: InputMaybe<Doc_Templates_Teams_Arr_Rel_Insert_Input>;
  doc_templates_tenants?: InputMaybe<Doc_Templates_Tenants_Arr_Rel_Insert_Input>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Doc_Template_Themes_Obj_Rel_Insert_Input>;
  theme_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Doc_Template_Type_Enum_Enum>;
};

/** order by max() on columns of table "doc_templates" */
export type Doc_Templates_Max_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  filename_template?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_templates" */
export type Doc_Templates_Min_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  filename_template?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  theme_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "doc_templates" */
export type Doc_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Templates>;
};

/** input type for inserting object relation for remote table "doc_templates" */
export type Doc_Templates_Obj_Rel_Insert_Input = {
  data: Doc_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Templates_On_Conflict>;
};

/** on_conflict condition type for table "doc_templates" */
export type Doc_Templates_On_Conflict = {
  constraint: Doc_Templates_Constraint;
  update_columns?: Array<Doc_Templates_Update_Column>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_templates". */
export type Doc_Templates_Order_By = {
  active?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_tenant?: InputMaybe<Read_Only_Tenants_Order_By>;
  doc_template_type_enum?: InputMaybe<Doc_Template_Type_Enum_Order_By>;
  doc_templates_teams_aggregate?: InputMaybe<Doc_Templates_Teams_Aggregate_Order_By>;
  doc_templates_tenants_aggregate?: InputMaybe<Doc_Templates_Tenants_Aggregate_Order_By>;
  filename_template?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  theme?: InputMaybe<Doc_Template_Themes_Order_By>;
  theme_id?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  versions_aggregate?: InputMaybe<Doc_Template_Versions_Aggregate_Order_By>;
};

/** primary key columns input for table: doc_templates */
export type Doc_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Doc_Templates_Prepend_Input = {
  translations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "doc_templates" */
export enum Doc_Templates_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  FilenameTemplate = 'filename_template',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThemeId = 'theme_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_templates" */
export type Doc_Templates_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "doc_templates" */
export type Doc_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Templates_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  filename_template?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  theme_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  type?: InputMaybe<Doc_Template_Type_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "doc_templates_teams" */
export type Doc_Templates_Teams = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  doc_template: Doc_Templates;
  doc_template_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_default: Scalars['Boolean']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "doc_templates_teams" */
export type Doc_Templates_Teams_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Templates_Teams_Max_Order_By>;
  min?: InputMaybe<Doc_Templates_Teams_Min_Order_By>;
};

/** input type for inserting array relation for remote table "doc_templates_teams" */
export type Doc_Templates_Teams_Arr_Rel_Insert_Input = {
  data: Array<Doc_Templates_Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Templates_Teams_On_Conflict>;
};

/** Boolean expression to filter rows from the table "doc_templates_teams". All fields are combined with a logical 'AND'. */
export type Doc_Templates_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Templates_Teams_Bool_Exp>>;
  _not?: InputMaybe<Doc_Templates_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Templates_Teams_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "doc_templates_teams" */
export enum Doc_Templates_Teams_Constraint {
  /** unique or primary key constraint on columns "doc_template_id", "team_id" */
  DocTemplatesTeamsDocTemplateIdTeamIdKey = 'doc_templates_teams_doc_template_id_team_id_key',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesTeamsPkey = 'doc_templates_teams_pkey'
}

/** input type for inserting data into table "doc_templates_teams" */
export type Doc_Templates_Teams_Insert_Input = {
  doc_template?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "doc_templates_teams" */
export type Doc_Templates_Teams_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_templates_teams" */
export type Doc_Templates_Teams_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "doc_templates_teams" */
export type Doc_Templates_Teams_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Templates_Teams>;
};

/** on_conflict condition type for table "doc_templates_teams" */
export type Doc_Templates_Teams_On_Conflict = {
  constraint: Doc_Templates_Teams_Constraint;
  update_columns?: Array<Doc_Templates_Teams_Update_Column>;
  where?: InputMaybe<Doc_Templates_Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_templates_teams". */
export type Doc_Templates_Teams_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: doc_templates_teams */
export type Doc_Templates_Teams_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "doc_templates_teams" */
export enum Doc_Templates_Teams_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_templates_teams" */
export type Doc_Templates_Teams_Set_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "doc_templates_teams" */
export enum Doc_Templates_Teams_Update_Column {
  /** column name */
  IsDefault = 'is_default'
}

export type Doc_Templates_Teams_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Templates_Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Templates_Teams_Bool_Exp;
};

/** columns and relationships of "doc_templates_tenants" */
export type Doc_Templates_Tenants = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  doc_template: Doc_Templates;
  doc_template_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  is_default: Scalars['Boolean']['output'];
  /** An object relationship */
  tenant?: Maybe<Read_Only_Tenants>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Doc_Templates_Tenants_Max_Order_By>;
  min?: InputMaybe<Doc_Templates_Tenants_Min_Order_By>;
};

/** input type for inserting array relation for remote table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Arr_Rel_Insert_Input = {
  data: Array<Doc_Templates_Tenants_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Doc_Templates_Tenants_On_Conflict>;
};

/** Boolean expression to filter rows from the table "doc_templates_tenants". All fields are combined with a logical 'AND'. */
export type Doc_Templates_Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Doc_Templates_Tenants_Bool_Exp>>;
  _not?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Doc_Templates_Tenants_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default?: InputMaybe<Boolean_Comparison_Exp>;
  tenant?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "doc_templates_tenants" */
export enum Doc_Templates_Tenants_Constraint {
  /** unique or primary key constraint on columns "doc_template_id", "tenant_id" */
  DocTemplatesTenantsDocTemplateIdTenantIdKey = 'doc_templates_tenants_doc_template_id_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  DocTemplatesTenantsPkey = 'doc_templates_tenants_pkey'
}

/** input type for inserting data into table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Doc_Templates_Tenants>;
};

/** on_conflict condition type for table "doc_templates_tenants" */
export type Doc_Templates_Tenants_On_Conflict = {
  constraint: Doc_Templates_Tenants_Constraint;
  update_columns?: Array<Doc_Templates_Tenants_Update_Column>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};

/** Ordering options when selecting data from "doc_templates_tenants". */
export type Doc_Templates_Tenants_Order_By = {
  created_at?: InputMaybe<Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_default?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Read_Only_Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: doc_templates_tenants */
export type Doc_Templates_Tenants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "doc_templates_tenants" */
export enum Doc_Templates_Tenants_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocTemplateId = 'doc_template_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefault = 'is_default',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Set_Input = {
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "doc_templates_tenants" */
export type Doc_Templates_Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Doc_Templates_Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Doc_Templates_Tenants_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "doc_templates_tenants" */
export enum Doc_Templates_Tenants_Update_Column {
  /** column name */
  IsDefault = 'is_default'
}

export type Doc_Templates_Tenants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Templates_Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Templates_Tenants_Bool_Exp;
};

/** update columns of table "doc_templates" */
export enum Doc_Templates_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Content = 'content',
  /** column name */
  FilenameTemplate = 'filename_template',
  /** column name */
  Name = 'name',
  /** column name */
  Translations = 'translations'
}

export type Doc_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Doc_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Doc_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Doc_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Doc_Templates_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Doc_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Doc_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Doc_Templates_Bool_Exp;
};

/** columns and relationships of "email_campaigns" */
export type Email_Campaigns = {
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  email_messages: Array<Email_Messages>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  id: Scalars['uuid']['output'];
  status?: Maybe<Email_Campaigns_Status_Enum_Enum>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
};


/** columns and relationships of "email_campaigns" */
export type Email_CampaignsEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


/** columns and relationships of "email_campaigns" */
export type Email_CampaignsEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};

/** aggregated selection of "email_campaigns" */
export type Email_Campaigns_Aggregate = {
  aggregate?: Maybe<Email_Campaigns_Aggregate_Fields>;
  nodes: Array<Email_Campaigns>;
};

/** aggregate fields of "email_campaigns" */
export type Email_Campaigns_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Email_Campaigns_Max_Fields>;
  min?: Maybe<Email_Campaigns_Min_Fields>;
};


/** aggregate fields of "email_campaigns" */
export type Email_Campaigns_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Campaigns_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "email_campaigns". All fields are combined with a logical 'AND'. */
export type Email_Campaigns_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Campaigns_Bool_Exp>>;
  _not?: InputMaybe<Email_Campaigns_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Campaigns_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  email_messages?: InputMaybe<Email_Messages_Bool_Exp>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Email_Campaigns_Status_Enum_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** aggregate max on columns */
export type Email_Campaigns_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Email_Campaigns_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "email_campaigns". */
export type Email_Campaigns_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "email_campaigns" */
export enum Email_Campaigns_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export enum Email_Campaigns_Status_Enum_Enum {
  Done = 'done',
  Pending = 'pending'
}

/** Boolean expression to compare columns of type "email_campaigns_status_enum_enum". All fields are combined with logical 'AND'. */
export type Email_Campaigns_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Campaigns_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Email_Campaigns_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Campaigns_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Email_Campaigns_Status_Enum_Enum>>;
};

/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_Messages = {
  account_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  activity?: Maybe<Activities>;
  bcc: Scalars['jsonb']['output'];
  body_template?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  cc: Scalars['jsonb']['output'];
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  date: Scalars['timestamptz']['output'];
  /** An object relationship */
  email_campaign?: Maybe<Email_Campaigns>;
  /** An array relationship */
  email_messages_files: Array<Email_Messages_Files>;
  /** An object relationship */
  email_sequences_step?: Maybe<Email_Sequences_Steps>;
  /** An object relationship */
  email_thread?: Maybe<Email_Threads>;
  error_message?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['jsonb']['output']>;
  files?: Maybe<Scalars['jsonb']['output']>;
  from: Scalars['jsonb']['output'];
  from_crm: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_sent: Scalars['Boolean']['output'];
  labels?: Maybe<Scalars['jsonb']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  nylas_thread_id?: Maybe<Scalars['String']['output']>;
  opens?: Maybe<Scalars['Boolean']['output']>;
  reply_to: Scalars['jsonb']['output'];
  reply_to_message_id?: Maybe<Scalars['String']['output']>;
  sequences_recipient_id?: Maybe<Scalars['uuid']['output']>;
  sequences_step_id?: Maybe<Scalars['uuid']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  starred?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  status_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_template?: Maybe<Scalars['String']['output']>;
  tenant_id: Scalars['uuid']['output'];
  thread_id?: Maybe<Scalars['uuid']['output']>;
  to: Scalars['jsonb']['output'];
  unread?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['timestamptz']['output'];
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesBccArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesCcArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesEmail_Messages_FilesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Files_Order_By>>;
  where?: InputMaybe<Email_Messages_Files_Bool_Exp>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesEventsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesFilesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesFromArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesLabelsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesReply_ToArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Emails sent from the CRM or synced from a connected mailbox: subject, snippet, from, to, date, grouped in threads (thread_id -> email_threads). An email logged on a lead, a listing or a contact is an activity whose email_message_id points here: to know whether a lead was emailed, read its activities. Very large: reach it from an activity or a thread. */
export type Email_MessagesToArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "email_messages" */
export type Email_Messages_Aggregate = {
  aggregate?: Maybe<Email_Messages_Aggregate_Fields>;
  nodes: Array<Email_Messages>;
};

export type Email_Messages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Email_Messages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Email_Messages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Email_Messages_Aggregate_Bool_Exp_Count>;
};

export type Email_Messages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Email_Messages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Messages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Email_Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_messages" */
export type Email_Messages_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Email_Messages_Max_Fields>;
  min?: Maybe<Email_Messages_Min_Fields>;
};


/** aggregate fields of "email_messages" */
export type Email_Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email_messages" */
export type Email_Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Messages_Max_Order_By>;
  min?: InputMaybe<Email_Messages_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "email_messages". All fields are combined with a logical 'AND'. */
export type Email_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Messages_Bool_Exp>>;
  _not?: InputMaybe<Email_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Messages_Bool_Exp>>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  activity?: InputMaybe<Activities_Bool_Exp>;
  bcc?: InputMaybe<Jsonb_Comparison_Exp>;
  body_template?: InputMaybe<String_Comparison_Exp>;
  campaign_id?: InputMaybe<Uuid_Comparison_Exp>;
  cc?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  date?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_campaign?: InputMaybe<Email_Campaigns_Bool_Exp>;
  email_messages_files?: InputMaybe<Email_Messages_Files_Bool_Exp>;
  email_sequences_step?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  email_thread?: InputMaybe<Email_Threads_Bool_Exp>;
  error_message?: InputMaybe<String_Comparison_Exp>;
  events?: InputMaybe<Jsonb_Comparison_Exp>;
  files?: InputMaybe<Jsonb_Comparison_Exp>;
  from?: InputMaybe<Jsonb_Comparison_Exp>;
  from_crm?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_sent?: InputMaybe<Boolean_Comparison_Exp>;
  labels?: InputMaybe<Jsonb_Comparison_Exp>;
  message_id?: InputMaybe<String_Comparison_Exp>;
  nylas_thread_id?: InputMaybe<String_Comparison_Exp>;
  opens?: InputMaybe<Boolean_Comparison_Exp>;
  reply_to?: InputMaybe<Jsonb_Comparison_Exp>;
  reply_to_message_id?: InputMaybe<String_Comparison_Exp>;
  sequences_recipient_id?: InputMaybe<Uuid_Comparison_Exp>;
  sequences_step_id?: InputMaybe<Uuid_Comparison_Exp>;
  snippet?: InputMaybe<String_Comparison_Exp>;
  starred?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_code?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  subject_template?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  thread_id?: InputMaybe<Uuid_Comparison_Exp>;
  to?: InputMaybe<Jsonb_Comparison_Exp>;
  unread?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "email_messages_files" */
export type Email_Messages_Files = {
  account_id?: Maybe<Scalars['String']['output']>;
  content_type?: Maybe<Scalars['String']['output']>;
  email_message_id: Scalars['uuid']['output'];
  /** An object relationship */
  file?: Maybe<Files>;
  file_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nylas_file_id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  tenant_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "email_messages_files" */
export type Email_Messages_Files_Aggregate_Order_By = {
  avg?: InputMaybe<Email_Messages_Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Messages_Files_Max_Order_By>;
  min?: InputMaybe<Email_Messages_Files_Min_Order_By>;
  stddev?: InputMaybe<Email_Messages_Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Email_Messages_Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Email_Messages_Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Email_Messages_Files_Sum_Order_By>;
  var_pop?: InputMaybe<Email_Messages_Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Email_Messages_Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Email_Messages_Files_Variance_Order_By>;
};

/** order by avg() on columns of table "email_messages_files" */
export type Email_Messages_Files_Avg_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_messages_files". All fields are combined with a logical 'AND'. */
export type Email_Messages_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Messages_Files_Bool_Exp>>;
  _not?: InputMaybe<Email_Messages_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Messages_Files_Bool_Exp>>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  content_type?: InputMaybe<String_Comparison_Exp>;
  email_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nylas_file_id?: InputMaybe<String_Comparison_Exp>;
  object?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "email_messages_files" */
export type Email_Messages_Files_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  object?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "email_messages_files" */
export type Email_Messages_Files_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  object?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "email_messages_files". */
export type Email_Messages_Files_Order_By = {
  account_id?: InputMaybe<Order_By>;
  content_type?: InputMaybe<Order_By>;
  email_message_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  object?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "email_messages_files" */
export enum Email_Messages_Files_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  ContentType = 'content_type',
  /** column name */
  EmailMessageId = 'email_message_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NylasFileId = 'nylas_file_id',
  /** column name */
  Object = 'object',
  /** column name */
  Size = 'size',
  /** column name */
  TenantId = 'tenant_id'
}

/** order by stddev() on columns of table "email_messages_files" */
export type Email_Messages_Files_Stddev_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "email_messages_files" */
export type Email_Messages_Files_Stddev_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "email_messages_files" */
export type Email_Messages_Files_Stddev_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "email_messages_files" */
export type Email_Messages_Files_Sum_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "email_messages_files" */
export type Email_Messages_Files_Var_Pop_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "email_messages_files" */
export type Email_Messages_Files_Var_Samp_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "email_messages_files" */
export type Email_Messages_Files_Variance_Order_By = {
  size?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Email_Messages_Max_Fields = {
  account_id?: Maybe<Scalars['String']['output']>;
  body_template?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  nylas_thread_id?: Maybe<Scalars['String']['output']>;
  reply_to_message_id?: Maybe<Scalars['String']['output']>;
  sequences_recipient_id?: Maybe<Scalars['uuid']['output']>;
  sequences_step_id?: Maybe<Scalars['uuid']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_template?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "email_messages" */
export type Email_Messages_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  body_template?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  nylas_thread_id?: InputMaybe<Order_By>;
  reply_to_message_id?: InputMaybe<Order_By>;
  sequences_recipient_id?: InputMaybe<Order_By>;
  sequences_step_id?: InputMaybe<Order_By>;
  snippet?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_template?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Messages_Min_Fields = {
  account_id?: Maybe<Scalars['String']['output']>;
  body_template?: Maybe<Scalars['String']['output']>;
  campaign_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  date?: Maybe<Scalars['timestamptz']['output']>;
  error_message?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  message_id?: Maybe<Scalars['String']['output']>;
  nylas_thread_id?: Maybe<Scalars['String']['output']>;
  reply_to_message_id?: Maybe<Scalars['String']['output']>;
  sequences_recipient_id?: Maybe<Scalars['uuid']['output']>;
  sequences_step_id?: Maybe<Scalars['uuid']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  status_code?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_template?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  thread_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "email_messages" */
export type Email_Messages_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  body_template?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  error_message?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  nylas_thread_id?: InputMaybe<Order_By>;
  reply_to_message_id?: InputMaybe<Order_By>;
  sequences_recipient_id?: InputMaybe<Order_By>;
  sequences_step_id?: InputMaybe<Order_By>;
  snippet?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_template?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "email_messages". */
export type Email_Messages_Order_By = {
  account_id?: InputMaybe<Order_By>;
  activity?: InputMaybe<Activities_Order_By>;
  bcc?: InputMaybe<Order_By>;
  body_template?: InputMaybe<Order_By>;
  campaign_id?: InputMaybe<Order_By>;
  cc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  email_campaign?: InputMaybe<Email_Campaigns_Order_By>;
  email_messages_files_aggregate?: InputMaybe<Email_Messages_Files_Aggregate_Order_By>;
  email_sequences_step?: InputMaybe<Email_Sequences_Steps_Order_By>;
  email_thread?: InputMaybe<Email_Threads_Order_By>;
  error_message?: InputMaybe<Order_By>;
  events?: InputMaybe<Order_By>;
  files?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  from_crm?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_sent?: InputMaybe<Order_By>;
  labels?: InputMaybe<Order_By>;
  message_id?: InputMaybe<Order_By>;
  nylas_thread_id?: InputMaybe<Order_By>;
  opens?: InputMaybe<Order_By>;
  reply_to?: InputMaybe<Order_By>;
  reply_to_message_id?: InputMaybe<Order_By>;
  sequences_recipient_id?: InputMaybe<Order_By>;
  sequences_step_id?: InputMaybe<Order_By>;
  snippet?: InputMaybe<Order_By>;
  starred?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_code?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_template?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  thread_id?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  unread?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "email_messages" */
export enum Email_Messages_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  BodyTemplate = 'body_template',
  /** column name */
  CampaignId = 'campaign_id',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Date = 'date',
  /** column name */
  ErrorMessage = 'error_message',
  /** column name */
  Events = 'events',
  /** column name */
  Files = 'files',
  /** column name */
  From = 'from',
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  Id = 'id',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Labels = 'labels',
  /** column name */
  MessageId = 'message_id',
  /** column name */
  NylasThreadId = 'nylas_thread_id',
  /** column name */
  Opens = 'opens',
  /** column name */
  ReplyTo = 'reply_to',
  /** column name */
  ReplyToMessageId = 'reply_to_message_id',
  /** column name */
  SequencesRecipientId = 'sequences_recipient_id',
  /** column name */
  SequencesStepId = 'sequences_step_id',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Status = 'status',
  /** column name */
  StatusCode = 'status_code',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectTemplate = 'subject_template',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThreadId = 'thread_id',
  /** column name */
  To = 'to',
  /** column name */
  Unread = 'unread',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "email_messages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "email_messages" */
export enum Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

/** select "email_messages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "email_messages" */
export enum Email_Messages_Select_Column_Email_Messages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  FromCrm = 'from_crm',
  /** column name */
  IsSent = 'is_sent',
  /** column name */
  Opens = 'opens',
  /** column name */
  Starred = 'starred',
  /** column name */
  Unread = 'unread'
}

/** columns and relationships of "email_sequences" */
export type Email_Sequences = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  /** An object relationship */
  created_by_user: Users;
  /** An array relationship */
  email_sequences_recipients: Array<Email_Sequences_Recipients>;
  /** An aggregate relationship */
  email_sequences_recipients_aggregate: Email_Sequences_Recipients_Aggregate;
  /** An array relationship */
  email_sequences_steps: Array<Email_Sequences_Steps>;
  /** An aggregate relationship */
  email_sequences_steps_aggregate: Email_Sequences_Steps_Aggregate;
  id: Scalars['uuid']['output'];
  is_shared_with_everyone?: Maybe<Scalars['Boolean']['output']>;
  is_shared_with_team?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: Email_Sequences_Status_Enum_Enum;
  stop_after_reply?: Maybe<Scalars['Boolean']['output']>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_StepsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


/** columns and relationships of "email_sequences" */
export type Email_SequencesEmail_Sequences_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "email_sequences". All fields are combined with a logical 'AND'. */
export type Email_Sequences_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Sequences_Bool_Exp>>;
  _not?: InputMaybe<Email_Sequences_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Sequences_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  email_sequences_recipients?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
  email_sequences_recipients_aggregate?: InputMaybe<Email_Sequences_Recipients_Aggregate_Bool_Exp>;
  email_sequences_steps?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  email_sequences_steps_aggregate?: InputMaybe<Email_Sequences_Steps_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_shared_with_everyone?: InputMaybe<Boolean_Comparison_Exp>;
  is_shared_with_team?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum_Comparison_Exp>;
  stop_after_reply?: InputMaybe<Boolean_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_sequences" */
export enum Email_Sequences_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailSequencesPkey = 'email_sequences_pkey'
}

/** input type for inserting data into table "email_sequences" */
export type Email_Sequences_Insert_Input = {
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  email_sequences_recipients?: InputMaybe<Email_Sequences_Recipients_Arr_Rel_Insert_Input>;
  email_sequences_steps?: InputMaybe<Email_Sequences_Steps_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
};

/** response of any mutation on the table "email_sequences" */
export type Email_Sequences_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Sequences>;
};

/** input type for inserting object relation for remote table "email_sequences" */
export type Email_Sequences_Obj_Rel_Insert_Input = {
  data: Email_Sequences_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Sequences_On_Conflict>;
};

/** on_conflict condition type for table "email_sequences" */
export type Email_Sequences_On_Conflict = {
  constraint: Email_Sequences_Constraint;
  update_columns?: Array<Email_Sequences_Update_Column>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};

/** Ordering options when selecting data from "email_sequences". */
export type Email_Sequences_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  email_sequences_recipients_aggregate?: InputMaybe<Email_Sequences_Recipients_Aggregate_Order_By>;
  email_sequences_steps_aggregate?: InputMaybe<Email_Sequences_Steps_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_shared_with_everyone?: InputMaybe<Order_By>;
  is_shared_with_team?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stop_after_reply?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_sequences */
export type Email_Sequences_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "email_sequences_recipients" */
export type Email_Sequences_Recipients = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyer_leads?: Maybe<Buyer_Leads>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  email_messages: Array<Email_Messages>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  /** An object relationship */
  email_sequence: Email_Sequences;
  email_sequence_id: Scalars['uuid']['output'];
  /** An object relationship */
  from_user: Users;
  from_user_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  last_step_number?: Maybe<Scalars['smallint']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  status: Email_Sequences_Recipients_Status_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "email_sequences_recipients" */
export type Email_Sequences_RecipientsEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


/** columns and relationships of "email_sequences_recipients" */
export type Email_Sequences_RecipientsEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};

/** aggregated selection of "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate = {
  aggregate?: Maybe<Email_Sequences_Recipients_Aggregate_Fields>;
  nodes: Array<Email_Sequences_Recipients>;
};

export type Email_Sequences_Recipients_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Sequences_Recipients_Aggregate_Bool_Exp_Count>;
};

export type Email_Sequences_Recipients_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate_Fields = {
  avg?: Maybe<Email_Sequences_Recipients_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Email_Sequences_Recipients_Max_Fields>;
  min?: Maybe<Email_Sequences_Recipients_Min_Fields>;
  stddev?: Maybe<Email_Sequences_Recipients_Stddev_Fields>;
  stddev_pop?: Maybe<Email_Sequences_Recipients_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Email_Sequences_Recipients_Stddev_Samp_Fields>;
  sum?: Maybe<Email_Sequences_Recipients_Sum_Fields>;
  var_pop?: Maybe<Email_Sequences_Recipients_Var_Pop_Fields>;
  var_samp?: Maybe<Email_Sequences_Recipients_Var_Samp_Fields>;
  variance?: Maybe<Email_Sequences_Recipients_Variance_Fields>;
};


/** aggregate fields of "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Aggregate_Order_By = {
  avg?: InputMaybe<Email_Sequences_Recipients_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Sequences_Recipients_Max_Order_By>;
  min?: InputMaybe<Email_Sequences_Recipients_Min_Order_By>;
  stddev?: InputMaybe<Email_Sequences_Recipients_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Email_Sequences_Recipients_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Email_Sequences_Recipients_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Email_Sequences_Recipients_Sum_Order_By>;
  var_pop?: InputMaybe<Email_Sequences_Recipients_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Email_Sequences_Recipients_Var_Samp_Order_By>;
  variance?: InputMaybe<Email_Sequences_Recipients_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Arr_Rel_Insert_Input = {
  data: Array<Email_Sequences_Recipients_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Sequences_Recipients_On_Conflict>;
};

/** aggregate avg on columns */
export type Email_Sequences_Recipients_Avg_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Avg_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_sequences_recipients". All fields are combined with a logical 'AND'. */
export type Email_Sequences_Recipients_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Sequences_Recipients_Bool_Exp>>;
  _not?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Sequences_Recipients_Bool_Exp>>;
  buyer_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_leads?: InputMaybe<Buyer_Leads_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_messages?: InputMaybe<Email_Messages_Bool_Exp>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Bool_Exp>;
  email_sequence?: InputMaybe<Email_Sequences_Bool_Exp>;
  email_sequence_id?: InputMaybe<Uuid_Comparison_Exp>;
  from_user?: InputMaybe<Users_Bool_Exp>;
  from_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_step_number?: InputMaybe<Smallint_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_sequences_recipients" */
export enum Email_Sequences_Recipients_Constraint {
  /** unique or primary key constraint on columns "user_id", "buyer_lead_id", "email_sequence_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdBuyerLead = 'email_sequences_recipients_email_sequence_id_user_id_buyer_lead',
  /** unique or primary key constraint on columns "user_id", "lead_id", "email_sequence_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLeadIdKe = 'email_sequences_recipients_email_sequence_id_user_id_lead_id_ke',
  /** unique or primary key constraint on columns "user_id", "lot_id", "email_sequence_id" */
  EmailSequencesRecipientsEmailSequenceIdUserIdLotIdKey = 'email_sequences_recipients_email_sequence_id_user_id_lot_id_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesRecipientsPkey = 'email_sequences_recipients_pkey'
}

/** input type for inserting data into table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Insert_Input = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<Buyer_Leads_Obj_Rel_Insert_Input>;
  email_sequence?: InputMaybe<Email_Sequences_Obj_Rel_Insert_Input>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_step_number?: InputMaybe<Scalars['smallint']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Email_Sequences_Recipients_Max_Fields = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_step_number?: Maybe<Scalars['smallint']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Max_Order_By = {
  buyer_lead_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_step_number?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Sequences_Recipients_Min_Fields = {
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  from_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_step_number?: Maybe<Scalars['smallint']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Min_Order_By = {
  buyer_lead_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_step_number?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Sequences_Recipients>;
};

/** on_conflict condition type for table "email_sequences_recipients" */
export type Email_Sequences_Recipients_On_Conflict = {
  constraint: Email_Sequences_Recipients_Constraint;
  update_columns?: Array<Email_Sequences_Recipients_Update_Column>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};

/** Ordering options when selecting data from "email_sequences_recipients". */
export type Email_Sequences_Recipients_Order_By = {
  buyer_lead_id?: InputMaybe<Order_By>;
  buyer_leads?: InputMaybe<Buyer_Leads_Order_By>;
  created_at?: InputMaybe<Order_By>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Order_By>;
  email_sequence?: InputMaybe<Email_Sequences_Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  from_user?: InputMaybe<Users_Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_step_number?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_sequences_recipients */
export type Email_Sequences_Recipients_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email_sequences_recipients" */
export enum Email_Sequences_Recipients_Select_Column {
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastStepNumber = 'last_step_number',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Set_Input = {
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
};

export enum Email_Sequences_Recipients_Status_Enum_Enum {
  /** Active */
  Active = 'active',
  /** Stopped */
  Stopped = 'stopped'
}

/** Boolean expression to compare columns of type "email_sequences_recipients_status_enum_enum". All fields are combined with logical 'AND'. */
export type Email_Sequences_Recipients_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Email_Sequences_Recipients_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Email_Sequences_Recipients_Status_Enum_Enum>>;
};

/** aggregate stddev on columns */
export type Email_Sequences_Recipients_Stddev_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stddev_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Email_Sequences_Recipients_Stddev_Pop_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stddev_Pop_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Email_Sequences_Recipients_Stddev_Samp_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stddev_Samp_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Sequences_Recipients_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Sequences_Recipients_Stream_Cursor_Value_Input = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  from_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_step_number?: InputMaybe<Scalars['smallint']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Email_Sequences_Recipients_Status_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Email_Sequences_Recipients_Sum_Fields = {
  last_step_number?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Sum_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** update columns of table "email_sequences_recipients" */
export enum Email_Sequences_Recipients_Update_Column {
  /** column name */
  Status = 'status'
}

export type Email_Sequences_Recipients_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Sequences_Recipients_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Sequences_Recipients_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Sequences_Recipients_Var_Pop_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Var_Pop_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Email_Sequences_Recipients_Var_Samp_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Var_Samp_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Email_Sequences_Recipients_Variance_Fields = {
  last_step_number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "email_sequences_recipients" */
export type Email_Sequences_Recipients_Variance_Order_By = {
  last_step_number?: InputMaybe<Order_By>;
};

/** select columns of table "email_sequences" */
export enum Email_Sequences_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithTeam = 'is_shared_with_team',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StopAfterReply = 'stop_after_reply',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "email_sequences" */
export type Email_Sequences_Set_Input = {
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum Email_Sequences_Status_Enum_Enum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive'
}

/** Boolean expression to compare columns of type "email_sequences_status_enum_enum". All fields are combined with logical 'AND'. */
export type Email_Sequences_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Email_Sequences_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Email_Sequences_Status_Enum_Enum>>;
};

/** columns and relationships of "email_sequences_steps" */
export type Email_Sequences_Steps = {
  created_at: Scalars['timestamptz']['output'];
  delay: Scalars['smallint']['output'];
  /** An array relationship */
  email_messages: Array<Email_Messages>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  /** An object relationship */
  email_sequence: Email_Sequences;
  email_sequence_id: Scalars['uuid']['output'];
  /** An object relationship */
  email_template: Email_Templates;
  id: Scalars['uuid']['output'];
  number: Scalars['smallint']['output'];
  template_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** columns and relationships of "email_sequences_steps" */
export type Email_Sequences_StepsEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


/** columns and relationships of "email_sequences_steps" */
export type Email_Sequences_StepsEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};

/** aggregated selection of "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate = {
  aggregate?: Maybe<Email_Sequences_Steps_Aggregate_Fields>;
  nodes: Array<Email_Sequences_Steps>;
};

export type Email_Sequences_Steps_Aggregate_Bool_Exp = {
  count?: InputMaybe<Email_Sequences_Steps_Aggregate_Bool_Exp_Count>;
};

export type Email_Sequences_Steps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate_Fields = {
  avg?: Maybe<Email_Sequences_Steps_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Email_Sequences_Steps_Max_Fields>;
  min?: Maybe<Email_Sequences_Steps_Min_Fields>;
  stddev?: Maybe<Email_Sequences_Steps_Stddev_Fields>;
  stddev_pop?: Maybe<Email_Sequences_Steps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Email_Sequences_Steps_Stddev_Samp_Fields>;
  sum?: Maybe<Email_Sequences_Steps_Sum_Fields>;
  var_pop?: Maybe<Email_Sequences_Steps_Var_Pop_Fields>;
  var_samp?: Maybe<Email_Sequences_Steps_Var_Samp_Fields>;
  variance?: Maybe<Email_Sequences_Steps_Variance_Fields>;
};


/** aggregate fields of "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "email_sequences_steps" */
export type Email_Sequences_Steps_Aggregate_Order_By = {
  avg?: InputMaybe<Email_Sequences_Steps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Sequences_Steps_Max_Order_By>;
  min?: InputMaybe<Email_Sequences_Steps_Min_Order_By>;
  stddev?: InputMaybe<Email_Sequences_Steps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Email_Sequences_Steps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Email_Sequences_Steps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Email_Sequences_Steps_Sum_Order_By>;
  var_pop?: InputMaybe<Email_Sequences_Steps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Email_Sequences_Steps_Var_Samp_Order_By>;
  variance?: InputMaybe<Email_Sequences_Steps_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "email_sequences_steps" */
export type Email_Sequences_Steps_Arr_Rel_Insert_Input = {
  data: Array<Email_Sequences_Steps_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Sequences_Steps_On_Conflict>;
};

/** aggregate avg on columns */
export type Email_Sequences_Steps_Avg_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Avg_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "email_sequences_steps". All fields are combined with a logical 'AND'. */
export type Email_Sequences_Steps_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Sequences_Steps_Bool_Exp>>;
  _not?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Sequences_Steps_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  delay?: InputMaybe<Smallint_Comparison_Exp>;
  email_messages?: InputMaybe<Email_Messages_Bool_Exp>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Bool_Exp>;
  email_sequence?: InputMaybe<Email_Sequences_Bool_Exp>;
  email_sequence_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_template?: InputMaybe<Email_Templates_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  number?: InputMaybe<Smallint_Comparison_Exp>;
  template_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_sequences_steps" */
export enum Email_Sequences_Steps_Constraint {
  /** unique or primary key constraint on columns "number", "email_sequence_id" */
  EmailSequencesStepsEmailSequenceIdNumberKey = 'email_sequences_steps_email_sequence_id_number_key',
  /** unique or primary key constraint on columns "id" */
  EmailSequencesStepsPkey = 'email_sequences_steps_pkey'
}

/** input type for incrementing numeric columns in table "email_sequences_steps" */
export type Email_Sequences_Steps_Inc_Input = {
  delay?: InputMaybe<Scalars['smallint']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "email_sequences_steps" */
export type Email_Sequences_Steps_Insert_Input = {
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_sequence?: InputMaybe<Email_Sequences_Obj_Rel_Insert_Input>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  email_template?: InputMaybe<Email_Templates_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Email_Sequences_Steps_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  delay?: Maybe<Scalars['smallint']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['smallint']['output']>;
  template_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delay?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Email_Sequences_Steps_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  delay?: Maybe<Scalars['smallint']['output']>;
  email_sequence_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['smallint']['output']>;
  template_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delay?: InputMaybe<Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_sequences_steps" */
export type Email_Sequences_Steps_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Sequences_Steps>;
};

/** on_conflict condition type for table "email_sequences_steps" */
export type Email_Sequences_Steps_On_Conflict = {
  constraint: Email_Sequences_Steps_Constraint;
  update_columns?: Array<Email_Sequences_Steps_Update_Column>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};

/** Ordering options when selecting data from "email_sequences_steps". */
export type Email_Sequences_Steps_Order_By = {
  created_at?: InputMaybe<Order_By>;
  delay?: InputMaybe<Order_By>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Order_By>;
  email_sequence?: InputMaybe<Email_Sequences_Order_By>;
  email_sequence_id?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Email_Templates_Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  template_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_sequences_steps */
export type Email_Sequences_Steps_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "email_sequences_steps" */
export enum Email_Sequences_Steps_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Id = 'id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "email_sequences_steps" */
export type Email_Sequences_Steps_Set_Input = {
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Email_Sequences_Steps_Stddev_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Stddev_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Email_Sequences_Steps_Stddev_Pop_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Stddev_Pop_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Email_Sequences_Steps_Stddev_Samp_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Stddev_Samp_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_sequences_steps" */
export type Email_Sequences_Steps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Sequences_Steps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Sequences_Steps_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  delay?: InputMaybe<Scalars['smallint']['input']>;
  email_sequence_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  number?: InputMaybe<Scalars['smallint']['input']>;
  template_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Email_Sequences_Steps_Sum_Fields = {
  delay?: Maybe<Scalars['smallint']['output']>;
  number?: Maybe<Scalars['smallint']['output']>;
};

/** order by sum() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Sum_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** update columns of table "email_sequences_steps" */
export enum Email_Sequences_Steps_Update_Column {
  /** column name */
  Delay = 'delay',
  /** column name */
  EmailSequenceId = 'email_sequence_id',
  /** column name */
  Number = 'number',
  /** column name */
  TemplateId = 'template_id'
}

export type Email_Sequences_Steps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Sequences_Steps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Sequences_Steps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Sequences_Steps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Sequences_Steps_Var_Pop_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Var_Pop_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Email_Sequences_Steps_Var_Samp_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Var_Samp_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Email_Sequences_Steps_Variance_Fields = {
  delay?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "email_sequences_steps" */
export type Email_Sequences_Steps_Variance_Order_By = {
  delay?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "email_sequences" */
export type Email_Sequences_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Sequences_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Sequences_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_team?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Email_Sequences_Status_Enum_Enum>;
  stop_after_reply?: InputMaybe<Scalars['Boolean']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "email_sequences" */
export enum Email_Sequences_Update_Column {
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithTeam = 'is_shared_with_team',
  /** column name */
  Name = 'name',
  /** column name */
  Status = 'status',
  /** column name */
  StopAfterReply = 'stop_after_reply'
}

export type Email_Sequences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Sequences_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Sequences_Bool_Exp;
};

/** Boolean expression to compare columns of type "email_template". All fields are combined with logical 'AND'. */
export type Email_Template_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['email_template']['input']>;
  _gt?: InputMaybe<Scalars['email_template']['input']>;
  _gte?: InputMaybe<Scalars['email_template']['input']>;
  _in?: InputMaybe<Array<Scalars['email_template']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['email_template']['input']>;
  _lte?: InputMaybe<Scalars['email_template']['input']>;
  _neq?: InputMaybe<Scalars['email_template']['input']>;
  _nin?: InputMaybe<Array<Scalars['email_template']['input']>>;
};

/** columns and relationships of "email_templates" */
export type Email_Templates = {
  add_signature: Scalars['Boolean']['output'];
  bcc?: Maybe<Scalars['jsonb']['output']>;
  cc?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  development?: Maybe<Developments>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  email_templates_files: Array<Email_Templates_Files>;
  id: Scalars['uuid']['output'];
  is_shared: Scalars['Boolean']['output'];
  is_shared_with_everyone: Scalars['Boolean']['output'];
  is_shared_with_organisation: Scalars['Boolean']['output'];
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subject_plaintext?: Maybe<Scalars['String']['output']>;
  target: Email_Templates_Target_Enum_Enum;
  tenant_id: Scalars['uuid']['output'];
  text?: Maybe<Scalars['String']['output']>;
  text_html?: Maybe<Scalars['String']['output']>;
  text_plaintext?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "email_templates" */
export type Email_TemplatesBccArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_templates" */
export type Email_TemplatesCcArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "email_templates" */
export type Email_TemplatesEmail_Templates_FilesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Files_Order_By>>;
  where?: InputMaybe<Email_Templates_Files_Bool_Exp>;
};

/** order by aggregate values of table "email_templates" */
export type Email_Templates_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Templates_Max_Order_By>;
  min?: InputMaybe<Email_Templates_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Templates_Append_Input = {
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "email_templates" */
export type Email_Templates_Arr_Rel_Insert_Input = {
  data: Array<Email_Templates_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_templates". All fields are combined with a logical 'AND'. */
export type Email_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Templates_Bool_Exp>>;
  _not?: InputMaybe<Email_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Templates_Bool_Exp>>;
  add_signature?: InputMaybe<Boolean_Comparison_Exp>;
  bcc?: InputMaybe<Jsonb_Comparison_Exp>;
  cc?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  development?: InputMaybe<Developments_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_templates_files?: InputMaybe<Email_Templates_Files_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_shared?: InputMaybe<Boolean_Comparison_Exp>;
  is_shared_with_everyone?: InputMaybe<Boolean_Comparison_Exp>;
  is_shared_with_organisation?: InputMaybe<Boolean_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  subject_plaintext?: InputMaybe<String_Comparison_Exp>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  text?: InputMaybe<String_Comparison_Exp>;
  text_html?: InputMaybe<String_Comparison_Exp>;
  text_plaintext?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_templates" */
export enum Email_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailTemplatesPkey = 'email_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Templates_Delete_At_Path_Input = {
  bcc?: InputMaybe<Array<Scalars['String']['input']>>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Templates_Delete_Elem_Input = {
  bcc?: InputMaybe<Scalars['Int']['input']>;
  cc?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Templates_Delete_Key_Input = {
  bcc?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "email_templates_files" */
export type Email_Templates_Files = {
  /** An object relationship */
  email_template: Email_Templates;
  email_template_id: Scalars['uuid']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  nylas_file_id?: Maybe<Scalars['String']['output']>;
  tenant_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "email_templates_files" */
export type Email_Templates_Files_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Email_Templates_Files_Max_Order_By>;
  min?: InputMaybe<Email_Templates_Files_Min_Order_By>;
};

/** input type for inserting array relation for remote table "email_templates_files" */
export type Email_Templates_Files_Arr_Rel_Insert_Input = {
  data: Array<Email_Templates_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Templates_Files_On_Conflict>;
};

/** Boolean expression to filter rows from the table "email_templates_files". All fields are combined with a logical 'AND'. */
export type Email_Templates_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Templates_Files_Bool_Exp>>;
  _not?: InputMaybe<Email_Templates_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Templates_Files_Bool_Exp>>;
  email_template?: InputMaybe<Email_Templates_Bool_Exp>;
  email_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  nylas_file_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_templates_files" */
export enum Email_Templates_Files_Constraint {
  /** unique or primary key constraint on columns "email_template_id", "file_id" */
  EmailTemplatesFilesPkey = 'email_templates_files_pkey'
}

/** input type for inserting data into table "email_templates_files" */
export type Email_Templates_Files_Insert_Input = {
  email_template?: InputMaybe<Email_Templates_Obj_Rel_Insert_Input>;
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_file_id?: InputMaybe<Scalars['String']['input']>;
};

/** order by max() on columns of table "email_templates_files" */
export type Email_Templates_Files_Max_Order_By = {
  email_template_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "email_templates_files" */
export type Email_Templates_Files_Min_Order_By = {
  email_template_id?: InputMaybe<Order_By>;
  file_id?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_templates_files" */
export type Email_Templates_Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Templates_Files>;
};

/** on_conflict condition type for table "email_templates_files" */
export type Email_Templates_Files_On_Conflict = {
  constraint: Email_Templates_Files_Constraint;
  update_columns?: Array<Email_Templates_Files_Update_Column>;
  where?: InputMaybe<Email_Templates_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "email_templates_files". */
export type Email_Templates_Files_Order_By = {
  email_template?: InputMaybe<Email_Templates_Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  nylas_file_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "email_templates_files" */
export enum Email_Templates_Files_Select_Column {
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  FileId = 'file_id',
  /** column name */
  NylasFileId = 'nylas_file_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** placeholder for update columns of table "email_templates_files" (current role has no relevant permissions) */
export enum Email_Templates_Files_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for inserting data into table "email_templates" */
export type Email_Templates_Insert_Input = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  development?: InputMaybe<Developments_Obj_Rel_Insert_Input>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  email_templates_files?: InputMaybe<Email_Templates_Files_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "email_templates" */
export type Email_Templates_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_plaintext?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  text_html?: InputMaybe<Order_By>;
  text_plaintext?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "email_templates" */
export type Email_Templates_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_plaintext?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  text_html?: InputMaybe<Order_By>;
  text_plaintext?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "email_templates" */
export type Email_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Templates>;
};

/** input type for inserting object relation for remote table "email_templates" */
export type Email_Templates_Obj_Rel_Insert_Input = {
  data: Email_Templates_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};

/** on_conflict condition type for table "email_templates" */
export type Email_Templates_On_Conflict = {
  constraint: Email_Templates_Constraint;
  update_columns?: Array<Email_Templates_Update_Column>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "email_templates". */
export type Email_Templates_Order_By = {
  add_signature?: InputMaybe<Order_By>;
  bcc?: InputMaybe<Order_By>;
  cc?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development?: InputMaybe<Developments_Order_By>;
  development_id?: InputMaybe<Order_By>;
  email_templates_files_aggregate?: InputMaybe<Email_Templates_Files_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_shared?: InputMaybe<Order_By>;
  is_shared_with_everyone?: InputMaybe<Order_By>;
  is_shared_with_organisation?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  subject_plaintext?: InputMaybe<Order_By>;
  target?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  text?: InputMaybe<Order_By>;
  text_html?: InputMaybe<Order_By>;
  text_plaintext?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_templates */
export type Email_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Templates_Prepend_Input = {
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "email_templates" */
export enum Email_Templates_Select_Column {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "email_templates" */
export type Email_Templates_Set_Input = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "email_templates" */
export type Email_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Templates_Stream_Cursor_Value_Input = {
  add_signature?: InputMaybe<Scalars['Boolean']['input']>;
  bcc?: InputMaybe<Scalars['jsonb']['input']>;
  cc?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_everyone?: InputMaybe<Scalars['Boolean']['input']>;
  is_shared_with_organisation?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_plaintext?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  text_html?: InputMaybe<Scalars['String']['input']>;
  text_plaintext?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export enum Email_Templates_Target_Enum_Enum {
  /** Sequence */
  Sequence = 'sequence',
  /** Standalone */
  Standalone = 'standalone'
}

/** Boolean expression to compare columns of type "email_templates_target_enum_enum". All fields are combined with logical 'AND'. */
export type Email_Templates_Target_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  _in?: InputMaybe<Array<Email_Templates_Target_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Email_Templates_Target_Enum_Enum>;
  _nin?: InputMaybe<Array<Email_Templates_Target_Enum_Enum>>;
};

/** update columns of table "email_templates" */
export enum Email_Templates_Update_Column {
  /** column name */
  AddSignature = 'add_signature',
  /** column name */
  Bcc = 'bcc',
  /** column name */
  Cc = 'cc',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsSharedWithEveryone = 'is_shared_with_everyone',
  /** column name */
  IsSharedWithOrganisation = 'is_shared_with_organisation',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Name = 'name',
  /** column name */
  Subject = 'subject',
  /** column name */
  SubjectPlaintext = 'subject_plaintext',
  /** column name */
  Target = 'target',
  /** column name */
  Text = 'text',
  /** column name */
  TextHtml = 'text_html',
  /** column name */
  TextPlaintext = 'text_plaintext',
  /** column name */
  Type = 'type'
}

export type Email_Templates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Email_Templates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Templates_Bool_Exp;
};

/** Email conversations of the mailboxes agents connected. Their messages are in email_messages. */
export type Email_Threads = {
  /** An array relationship */
  email_messages: Array<Email_Messages>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  has_attachments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  last_message_received_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  last_message_sent_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  starred?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  unread?: Maybe<Scalars['Boolean']['output']>;
  visibility: Scalars['String']['output'];
};


/** Email conversations of the mailboxes agents connected. Their messages are in email_messages. */
export type Email_ThreadsEmail_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


/** Email conversations of the mailboxes agents connected. Their messages are in email_messages. */
export type Email_ThreadsEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "email_threads". All fields are combined with a logical 'AND'. */
export type Email_Threads_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Threads_Bool_Exp>>;
  _not?: InputMaybe<Email_Threads_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Threads_Bool_Exp>>;
  email_messages?: InputMaybe<Email_Messages_Bool_Exp>;
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Bool_Exp>;
  has_attachments?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_message_received_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_message_sent_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  snippet?: InputMaybe<String_Comparison_Exp>;
  starred?: InputMaybe<Boolean_Comparison_Exp>;
  subject?: InputMaybe<String_Comparison_Exp>;
  unread?: InputMaybe<Boolean_Comparison_Exp>;
  visibility?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "email_threads". */
export type Email_Threads_Order_By = {
  email_messages_aggregate?: InputMaybe<Email_Messages_Aggregate_Order_By>;
  has_attachments?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message_received_timestamp?: InputMaybe<Order_By>;
  last_message_sent_timestamp?: InputMaybe<Order_By>;
  snippet?: InputMaybe<Order_By>;
  starred?: InputMaybe<Order_By>;
  subject?: InputMaybe<Order_By>;
  unread?: InputMaybe<Order_By>;
  visibility?: InputMaybe<Order_By>;
};

/** select columns of table "email_threads" */
export enum Email_Threads_Select_Column {
  /** column name */
  HasAttachments = 'has_attachments',
  /** column name */
  Id = 'id',
  /** column name */
  LastMessageReceivedTimestamp = 'last_message_received_timestamp',
  /** column name */
  LastMessageSentTimestamp = 'last_message_sent_timestamp',
  /** column name */
  Snippet = 'snippet',
  /** column name */
  Starred = 'starred',
  /** column name */
  Subject = 'subject',
  /** column name */
  Unread = 'unread',
  /** column name */
  Visibility = 'visibility'
}

/** Email addresses of a user (user_id -> users), a team or an organisation. primary marks the main one. */
export type Emails = {
  created_at: Scalars['timestamptz']['output'];
  email: Scalars['citext']['output'];
  email_display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  primary: Scalars['Boolean']['output'];
  /** An object relationship */
  subscription?: Maybe<Subscriptions>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verified: Scalars['Boolean']['output'];
};


/** Email addresses of a user (user_id -> users), a team or an organisation. primary marks the main one. */
export type EmailsSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** Email addresses of a user (user_id -> users), a team or an organisation. primary marks the main one. */
export type EmailsSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** order by aggregate values of table "emails" */
export type Emails_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Emails_Max_Order_By>;
  min?: InputMaybe<Emails_Min_Order_By>;
};

/** input type for inserting array relation for remote table "emails" */
export type Emails_Arr_Rel_Insert_Input = {
  data: Array<Emails_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};

/** Boolean expression to filter rows from the table "emails". All fields are combined with a logical 'AND'. */
export type Emails_Bool_Exp = {
  _and?: InputMaybe<Array<Emails_Bool_Exp>>;
  _not?: InputMaybe<Emails_Bool_Exp>;
  _or?: InputMaybe<Array<Emails_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  email_display_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "emails" */
export enum Emails_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailsPkey = 'emails_pkey',
  /** unique or primary key constraint on columns "email", "owner_id", "tenant_id" */
  EmailsTenantEmailOwnerUnique = 'emails_tenant_email_owner_unique',
  /** unique or primary key constraint on columns "email", "tenant_id" */
  EmailsTenantIdOrganisationIdUnique = 'emails_tenant_id_organisation_id_unique',
  /** unique or primary key constraint on columns "email", "tenant_id" */
  EmailsTenantIdTeamIdUnique = 'emails_tenant_id_team_id_unique',
  /** unique or primary key constraint on columns "email", "tenant_id" */
  EmailsTenantIdUserIdUnique = 'emails_tenant_id_user_id_unique',
  /** unique or primary key constraint on columns "email", "user_id", "verified", "tenant_id" */
  EmailsUserIdTenantIdEmailVerifiedUnique = 'emails_user_id_tenant_id_email_verified_unique'
}

/** input type for inserting data into table "emails" */
export type Emails_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "emails" */
export type Emails_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "emails" */
export type Emails_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "emails" */
export type Emails_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Emails>;
};

/** on_conflict condition type for table "emails" */
export type Emails_On_Conflict = {
  constraint: Emails_Constraint;
  update_columns?: Array<Emails_Update_Column>;
  where?: InputMaybe<Emails_Bool_Exp>;
};

/** Ordering options when selecting data from "emails". */
export type Emails_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_display_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: emails */
export type Emails_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "emails" */
export enum Emails_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  EmailDisplayName = 'email_display_name',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "emails" */
export type Emails_Set_Input = {
  email?: InputMaybe<Scalars['citext']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "emails" */
export type Emails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Emails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Emails_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  email_display_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "emails" */
export enum Emails_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

export type Emails_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Emails_Set_Input>;
  /** filter the rows which have to be updated */
  where: Emails_Bool_Exp;
};

export enum Energy_Class_Type_Enum_Enum {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
  F = 'f',
  G = 'g',
  NotSet = 'not_set'
}

/** Boolean expression to compare columns of type "energy_class_type_enum_enum". All fields are combined with logical 'AND'. */
export type Energy_Class_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Energy_Class_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Energy_Class_Type_Enum_Enum>>;
};

/** Boolean expression to compare columns of type "energy_ges_values". All fields are combined with logical 'AND'. */
export type Energy_Ges_Values_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _gt?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _gte?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _in?: InputMaybe<Array<Scalars['energy_ges_values']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _lte?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _neq?: InputMaybe<Scalars['energy_ges_values']['input']>;
  _nin?: InputMaybe<Array<Scalars['energy_ges_values']['input']>>;
};

/** Inbound contact requests from portals, agency pages or the app, about a listing (lot_id -> lots) or addressed to a broker or team. processed = handled. buyer_lead_id is the buyer lead created from it; a seller lead created from it points back through leads.origin_enquiry_id. */
export type Enquiries = {
  address?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyer_lead?: Maybe<Buyer_Leads>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  contact_reason?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  development_registration_form_id?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  has_conflict?: Maybe<Scalars['Boolean']['output']>;
  has_invalid_input?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  language?: Maybe<Scalars['user_language']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  listing_link?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  marketing_metadata?: Maybe<Marketing_Metadata>;
  /** An object relationship */
  matched_email_user?: Maybe<Users>;
  /** An object relationship */
  matched_phone_user?: Maybe<Users>;
  message?: Maybe<Scalars['String']['output']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  object_ref?: Maybe<Scalars['String']['output']>;
  original_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  portal?: Maybe<Portals>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  processed: Scalars['Boolean']['output'];
  /** An object relationship */
  profile_lead_marker?: Maybe<Profile_Lead_Enquiry_Markers>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  /** An object relationship */
  property_transaction?: Maybe<Property_Transactions>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  raw_email?: Maybe<Scalars['String']['output']>;
  raw_email_address?: Maybe<Scalars['String']['output']>;
  raw_phone_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  response_activity?: Maybe<Activities>;
  response_activity_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  seller_lead?: Maybe<Leads>;
  session_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Enquiries_Source_Enum_Enum>;
  source_email_id?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_email_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_id?: Maybe<Scalars['uuid']['output']>;
  visit_date?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "enquiries" */
export type Enquiries_Aggregate = {
  aggregate?: Maybe<Enquiries_Aggregate_Fields>;
  nodes: Array<Enquiries>;
};

export type Enquiries_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Enquiries_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Enquiries_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Enquiries_Aggregate_Bool_Exp_Count>;
};

export type Enquiries_Aggregate_Bool_Exp_Bool_And = {
  arguments: Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enquiries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Enquiries_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enquiries_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Enquiries_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Enquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Enquiries_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "enquiries" */
export type Enquiries_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Enquiries_Max_Fields>;
  min?: Maybe<Enquiries_Min_Fields>;
};


/** aggregate fields of "enquiries" */
export type Enquiries_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Enquiries_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "enquiries" */
export type Enquiries_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Enquiries_Max_Order_By>;
  min?: InputMaybe<Enquiries_Min_Order_By>;
};

/** input type for inserting array relation for remote table "enquiries" */
export type Enquiries_Arr_Rel_Insert_Input = {
  data: Array<Enquiries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Enquiries_On_Conflict>;
};

/** Boolean expression to filter rows from the table "enquiries". All fields are combined with a logical 'AND'. */
export type Enquiries_Bool_Exp = {
  _and?: InputMaybe<Array<Enquiries_Bool_Exp>>;
  _not?: InputMaybe<Enquiries_Bool_Exp>;
  _or?: InputMaybe<Array<Enquiries_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_lead?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  call_times?: InputMaybe<String_Array_Comparison_Exp>;
  contact_reason?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  development_registration_form_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  has_conflict?: InputMaybe<Boolean_Comparison_Exp>;
  has_invalid_input?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  listing_link?: InputMaybe<String_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Bool_Exp>;
  matched_email_user?: InputMaybe<Users_Bool_Exp>;
  matched_phone_user?: InputMaybe<Users_Bool_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  neverbounce_result?: InputMaybe<String_Comparison_Exp>;
  object_ref?: InputMaybe<String_Comparison_Exp>;
  original_enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<Portals_Bool_Exp>;
  portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  processed?: InputMaybe<Boolean_Comparison_Exp>;
  profile_lead_marker?: InputMaybe<Profile_Lead_Enquiry_Markers_Bool_Exp>;
  property_search_notification?: InputMaybe<Property_Searches_Notification_Comparison_Exp>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  raw_email?: InputMaybe<String_Comparison_Exp>;
  raw_email_address?: InputMaybe<String_Comparison_Exp>;
  raw_phone_number?: InputMaybe<String_Comparison_Exp>;
  response_activity?: InputMaybe<Activities_Bool_Exp>;
  response_activity_id?: InputMaybe<Uuid_Comparison_Exp>;
  seller_lead?: InputMaybe<Leads_Bool_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Enquiries_Source_Enum_Enum_Comparison_Exp>;
  source_email_id?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_email_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_phone_id?: InputMaybe<Uuid_Comparison_Exp>;
  visit_date?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "enquiries" */
export enum Enquiries_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EnquiriesIdTenantIdUnique = 'enquiries_id_tenant_id_unique',
  /** unique or primary key constraint on columns "source_email_id" */
  EnquiriesSourceEmailIdUnique = 'enquiries_source_email_id_unique',
  /** unique or primary key constraint on columns "id" */
  InquiriesPkey = 'inquiries_pkey'
}

/** input type for inserting data into table "enquiries" */
export type Enquiries_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead?: InputMaybe<Buyer_Leads_Obj_Rel_Insert_Input>;
  contact_reason?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_conflict?: InputMaybe<Scalars['Boolean']['input']>;
  has_invalid_input?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  matched_email_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  matched_phone_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  message?: InputMaybe<Scalars['String']['input']>;
  original_enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Portals_Obj_Rel_Insert_Input>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  raw_email_address?: InputMaybe<Scalars['String']['input']>;
  raw_phone_number?: InputMaybe<Scalars['String']['input']>;
  response_activity?: InputMaybe<Activities_Obj_Rel_Insert_Input>;
  seller_lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  source?: InputMaybe<Enquiries_Source_Enum_Enum>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_email_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Enquiries_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  contact_reason?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  development_registration_form_id?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  listing_link?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  object_ref?: Maybe<Scalars['String']['output']>;
  original_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  raw_email?: Maybe<Scalars['String']['output']>;
  raw_email_address?: Maybe<Scalars['String']['output']>;
  raw_phone_number?: Maybe<Scalars['String']['output']>;
  response_activity_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_email_id?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_email_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_id?: Maybe<Scalars['uuid']['output']>;
  visit_date?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "enquiries" */
export type Enquiries_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_reason?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development_registration_form_id?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  listing_link?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: InputMaybe<Order_By>;
  object_ref?: InputMaybe<Order_By>;
  original_enquiry_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  raw_email?: InputMaybe<Order_By>;
  raw_email_address?: InputMaybe<Order_By>;
  raw_phone_number?: InputMaybe<Order_By>;
  response_activity_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_email_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_id?: InputMaybe<Order_By>;
  visit_date?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Enquiries_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_lead_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  contact_reason?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  development_registration_form_id?: Maybe<Scalars['uuid']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  listing_link?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  object_ref?: Maybe<Scalars['String']['output']>;
  original_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  property_transaction_id?: Maybe<Scalars['uuid']['output']>;
  raw_email?: Maybe<Scalars['String']['output']>;
  raw_email_address?: Maybe<Scalars['String']['output']>;
  raw_phone_number?: Maybe<Scalars['String']['output']>;
  response_activity_id?: Maybe<Scalars['uuid']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_email_id?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_email_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_phone_id?: Maybe<Scalars['uuid']['output']>;
  visit_date?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "enquiries" */
export type Enquiries_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_reason?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development_registration_form_id?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  listing_link?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: InputMaybe<Order_By>;
  object_ref?: InputMaybe<Order_By>;
  original_enquiry_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  raw_email?: InputMaybe<Order_By>;
  raw_email_address?: InputMaybe<Order_By>;
  raw_phone_number?: InputMaybe<Order_By>;
  response_activity_id?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_email_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_email_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_id?: InputMaybe<Order_By>;
  visit_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "enquiries" */
export type Enquiries_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Enquiries>;
};

/** input type for inserting object relation for remote table "enquiries" */
export type Enquiries_Obj_Rel_Insert_Input = {
  data: Enquiries_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Enquiries_On_Conflict>;
};

/** on_conflict condition type for table "enquiries" */
export type Enquiries_On_Conflict = {
  constraint: Enquiries_Constraint;
  update_columns?: Array<Enquiries_Update_Column>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};

/** Ordering options when selecting data from "enquiries". */
export type Enquiries_Order_By = {
  address?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_lead?: InputMaybe<Buyer_Leads_Order_By>;
  buyer_lead_id?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_reason?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development_registration_form_id?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  has_conflict?: InputMaybe<Order_By>;
  has_invalid_input?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  listing_link?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Order_By>;
  matched_email_user?: InputMaybe<Users_Order_By>;
  matched_phone_user?: InputMaybe<Users_Order_By>;
  message?: InputMaybe<Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  object_ref?: InputMaybe<Order_By>;
  original_enquiry_id?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  portal?: InputMaybe<Portals_Order_By>;
  portal_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  processed?: InputMaybe<Order_By>;
  profile_lead_marker?: InputMaybe<Profile_Lead_Enquiry_Markers_Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  raw_email?: InputMaybe<Order_By>;
  raw_email_address?: InputMaybe<Order_By>;
  raw_phone_number?: InputMaybe<Order_By>;
  response_activity?: InputMaybe<Activities_Order_By>;
  response_activity_id?: InputMaybe<Order_By>;
  seller_lead?: InputMaybe<Leads_Order_By>;
  session_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_email_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_email_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_phone_id?: InputMaybe<Order_By>;
  visit_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: enquiries */
export type Enquiries_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "enquiries" */
export enum Enquiries_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  ContactReason = 'contact_reason',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DevelopmentRegistrationFormId = 'development_registration_form_id',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ListingLink = 'listing_link',
  /** column name */
  Locality = 'locality',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Message = 'message',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  ObjectRef = 'object_ref',
  /** column name */
  OriginalEnquiryId = 'original_enquiry_id',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Processed = 'processed',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  RawEmail = 'raw_email',
  /** column name */
  RawEmailAddress = 'raw_email_address',
  /** column name */
  RawPhoneNumber = 'raw_phone_number',
  /** column name */
  ResponseActivityId = 'response_activity_id',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  SourceEmailId = 'source_email_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserEmailId = 'user_email_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserPhoneId = 'user_phone_id',
  /** column name */
  VisitDate = 'visit_date'
}

/** select "enquiries_aggregate_bool_exp_bool_and_arguments_columns" columns of table "enquiries" */
export enum Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

/** select "enquiries_aggregate_bool_exp_bool_or_arguments_columns" columns of table "enquiries" */
export enum Enquiries_Select_Column_Enquiries_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasConflict = 'has_conflict',
  /** column name */
  HasInvalidInput = 'has_invalid_input',
  /** column name */
  Processed = 'processed'
}

/** input type for updating data in table "enquiries" */
export type Enquiries_Set_Input = {
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  response_activity_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "enquiries_source_enum" */
export type Enquiries_Source_Enum = {
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "enquiries_source_enum". All fields are combined with a logical 'AND'. */
export type Enquiries_Source_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Enquiries_Source_Enum_Bool_Exp>>;
  _not?: InputMaybe<Enquiries_Source_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Enquiries_Source_Enum_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Enquiries_Source_Enum_Enum {
  /** Received from agent/agency contact form */
  AgencyPages = 'agency_pages',
  /** Received from our mobile application */
  MobileApp = 'mobile_app',
  /** Parsed from portal email */
  Portal = 'portal',
  /** Received from price pages transaction modal contact form */
  PricePages = 'price_pages',
  /** Unknown */
  Unknown = 'unknown'
}

/** Boolean expression to compare columns of type "enquiries_source_enum_enum". All fields are combined with logical 'AND'. */
export type Enquiries_Source_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Enquiries_Source_Enum_Enum>;
  _in?: InputMaybe<Array<Enquiries_Source_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Enquiries_Source_Enum_Enum>;
  _nin?: InputMaybe<Array<Enquiries_Source_Enum_Enum>>;
};

/** Ordering options when selecting data from "enquiries_source_enum". */
export type Enquiries_Source_Enum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** select columns of table "enquiries_source_enum" */
export enum Enquiries_Source_Enum_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "enquiries_source_enum" */
export type Enquiries_Source_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enquiries_Source_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enquiries_Source_Enum_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "enquiries" */
export type Enquiries_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Enquiries_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Enquiries_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  contact_reason?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_registration_form_id?: InputMaybe<Scalars['uuid']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  has_conflict?: InputMaybe<Scalars['Boolean']['input']>;
  has_invalid_input?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  listing_link?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** Valid = 0, Not Valid = 1, Disposable =	2, No Accept All = 3, Unkown = 4 */
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  object_ref?: InputMaybe<Scalars['String']['input']>;
  original_enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  raw_email?: InputMaybe<Scalars['String']['input']>;
  raw_email_address?: InputMaybe<Scalars['String']['input']>;
  raw_phone_number?: InputMaybe<Scalars['String']['input']>;
  response_activity_id?: InputMaybe<Scalars['uuid']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Enquiries_Source_Enum_Enum>;
  source_email_id?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_email_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_phone_id?: InputMaybe<Scalars['uuid']['input']>;
  visit_date?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "enquiries" */
export enum Enquiries_Update_Column {
  /** column name */
  BuyerLeadId = 'buyer_lead_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  Processed = 'processed',
  /** column name */
  ResponseActivityId = 'response_activity_id',
  /** column name */
  UserId = 'user_id'
}

export type Enquiries_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Enquiries_Set_Input>;
  /** filter the rows which have to be updated */
  where: Enquiries_Bool_Exp;
};

/** columns and relationships of "cma_listings" */
export type Es_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Es_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Es_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<Es_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Es_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  state?: Maybe<Es_States>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "cma_listings" */
export type Es_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Es_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Es_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Es_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Es_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Es_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Cma_Listings_Max_Fields>;
  min?: Maybe<Es_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Es_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Es_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Es_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Es_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Es_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Es_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Es_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<Es_States_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** columns and relationships of "cma_listings_distance" */
export type Es_Cma_Listings_Distance = {
  distance_in_meters: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  listing?: Maybe<Es_Cma_Listings>;
  listing_id: Scalars['Int']['output'];
  state_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_listings_distance" */
export type Es_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Es_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Es_Cma_Listings_Distance>;
};

/** aggregate fields of "cma_listings_distance" */
export type Es_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Es_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Es_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Es_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Es_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Es_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "cma_listings_distance" */
export type Es_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Es_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  listing?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Es_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "cma_listings_distance". */
export type Es_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing?: InputMaybe<Es_Cma_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings_distance" */
export enum Es_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Es_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Es_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Es_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Es_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Es_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state?: InputMaybe<Es_States_Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Es_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Es_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cma_rental_listings" */
export type Es_Cma_Rental_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Es_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Es_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Es_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_rental_listings_places" */
  places?: Maybe<Array<Es_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_rental_listings" */
export type Es_Cma_Rental_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Es_Cma_Rental_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Es_Cma_Rental_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Es_Cma_Rental_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_rental_listings" */
export type Es_Cma_Rental_Listings_Aggregate = {
  aggregate?: Maybe<Es_Cma_Rental_Listings_Aggregate_Fields>;
  nodes: Array<Es_Cma_Rental_Listings>;
};

/** aggregate fields of "cma_rental_listings" */
export type Es_Cma_Rental_Listings_Aggregate_Fields = {
  avg?: Maybe<Es_Cma_Rental_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Cma_Rental_Listings_Max_Fields>;
  min?: Maybe<Es_Cma_Rental_Listings_Min_Fields>;
  stddev?: Maybe<Es_Cma_Rental_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Cma_Rental_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Cma_Rental_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Cma_Rental_Listings_Sum_Fields>;
  var_pop?: Maybe<Es_Cma_Rental_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Cma_Rental_Listings_Var_Samp_Fields>;
  variance?: Maybe<Es_Cma_Rental_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_rental_listings" */
export type Es_Cma_Rental_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Cma_Rental_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Cma_Rental_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_rental_listings". All fields are combined with a logical 'AND'. */
export type Es_Cma_Rental_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Cma_Rental_Listings_Bool_Exp>>;
  _not?: InputMaybe<Es_Cma_Rental_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Cma_Rental_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Es_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Es_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Cma_Rental_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Es_Cma_Rental_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_rental_listings". */
export type Es_Cma_Rental_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Es_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_rental_listings" */
export enum Es_Cma_Rental_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Es_Cma_Rental_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Cma_Rental_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Cma_Rental_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Cma_Rental_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Cma_Rental_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Cma_Rental_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Cma_Rental_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Es_External_Transactions = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  source_payload?: Maybe<Scalars['jsonb']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};


/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Es_External_TransactionsSource_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_transactions" */
export type Es_External_Transactions_Aggregate = {
  aggregate?: Maybe<Es_External_Transactions_Aggregate_Fields>;
  nodes: Array<Es_External_Transactions>;
};

/** aggregate fields of "external_transactions" */
export type Es_External_Transactions_Aggregate_Fields = {
  avg?: Maybe<Es_External_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_External_Transactions_Max_Fields>;
  min?: Maybe<Es_External_Transactions_Min_Fields>;
  stddev?: Maybe<Es_External_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Es_External_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_External_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Es_External_Transactions_Sum_Fields>;
  var_pop?: Maybe<Es_External_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Es_External_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Es_External_Transactions_Variance_Fields>;
};


/** aggregate fields of "external_transactions" */
export type Es_External_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_External_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_External_Transactions_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions". All fields are combined with a logical 'AND'. */
export type Es_External_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Es_External_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Es_External_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Es_External_Transactions_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** Rows returned by get_external_transactions_distance: a recorded sale and its distance_in_meters from the point asked. Data in France only. The table itself holds no row: call the function, with _lat and _lng always; nearest first unless _sort_field (with _sort_direction) is set. _max_distance_meters is 5 km by default and 50 km at most; pass _max_distance_meters: null to search a whole _postcode, bbox or _polygon_geojson beyond 5 km. _property_main_type, _cutoff_date and _cutoff_date_max, surfaces, rooms and price narrow further. At most 5000 rows (_max_results): a count over it stops there, so narrow the area or the dates for a large city. */
export type Es_External_Transactions_Distance = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  distance_in_meters: Scalars['Float']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "external_transactions_distance" */
export type Es_External_Transactions_Distance_Aggregate = {
  aggregate?: Maybe<Es_External_Transactions_Distance_Aggregate_Fields>;
  nodes: Array<Es_External_Transactions_Distance>;
};

/** aggregate fields of "external_transactions_distance" */
export type Es_External_Transactions_Distance_Aggregate_Fields = {
  avg?: Maybe<Es_External_Transactions_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_External_Transactions_Distance_Max_Fields>;
  min?: Maybe<Es_External_Transactions_Distance_Min_Fields>;
  stddev?: Maybe<Es_External_Transactions_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Es_External_Transactions_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_External_Transactions_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Es_External_Transactions_Distance_Sum_Fields>;
  var_pop?: Maybe<Es_External_Transactions_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Es_External_Transactions_Distance_Var_Samp_Fields>;
  variance?: Maybe<Es_External_Transactions_Distance_Variance_Fields>;
};


/** aggregate fields of "external_transactions_distance" */
export type Es_External_Transactions_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_External_Transactions_Distance_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions_distance". All fields are combined with a logical 'AND'. */
export type Es_External_Transactions_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Es_External_Transactions_Distance_Bool_Exp>>;
  _not?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Es_External_Transactions_Distance_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_External_Transactions_Distance_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Es_External_Transactions_Distance_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions_distance". */
export type Es_External_Transactions_Distance_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions_distance" */
export enum Es_External_Transactions_Distance_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Es_External_Transactions_Distance_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_External_Transactions_Distance_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_External_Transactions_Distance_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_External_Transactions_Distance_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Es_External_Transactions_Distance_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_External_Transactions_Distance_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_External_Transactions_Distance_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Es_External_Transactions_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Es_External_Transactions_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions". */
export type Es_External_Transactions_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_payload?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions" */
export enum Es_External_Transactions_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  SourcePayload = 'source_payload',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Es_External_Transactions_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_External_Transactions_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_External_Transactions_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_External_Transactions_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Es_External_Transactions_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_External_Transactions_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_External_Transactions_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Es_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Es_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Es_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Es_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Es_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Es_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Es_Merged_Images_Aggregate = {
  aggregate?: Maybe<Es_Merged_Images_Aggregate_Fields>;
  nodes: Array<Es_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Es_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Es_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Merged_Images_Max_Fields>;
  min?: Maybe<Es_Merged_Images_Min_Fields>;
  stddev?: Maybe<Es_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Es_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Es_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Es_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Es_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Es_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Es_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Es_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Es_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Es_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Es_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Es_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Es_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Es_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Es_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Es_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Es_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Es_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Es_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Es_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Es_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Es_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Es_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Es_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Es_Property_Main_Type_Enum;
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** Hidden from the public site by an admin (per listing, together with its duplicates). It does not say whether the listing is still online: see offline_since. */
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Es_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Es_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Es_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "merged_listings" */
export type Es_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Es_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Es_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Es_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Es_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Merged_Listings_Max_Fields>;
  min?: Maybe<Es_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Es_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Es_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Es_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Es_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Es_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<Es_Property_Main_Type_Enum_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Es_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Es_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Es_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Es_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Es_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Es_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Es_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Es_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Es_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Es_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<Es_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: Es_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_stats: Array<Es_Price_Stats>;
  /** An aggregate relationship */
  price_stats_aggregate: Es_Price_Stats_Aggregate;
  /** An array relationship */
  price_stats_historical: Array<Es_Price_Stats_Historical>;
  /** An aggregate relationship */
  price_stats_historical_aggregate: Es_Price_Stats_Historical_Aggregate;
  /** An array relationship */
  region: Array<Es_Places>;
  /** An aggregate relationship */
  region_aggregate: Es_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<Es_Places>;
  /** An aggregate relationship */
  state_aggregate: Es_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Es_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Es_Places_Aggregate;
  /** An array relationship */
  street_stats_locality: Array<Es_Street_Stats>;
  /** An aggregate relationship */
  street_stats_locality_aggregate: Es_Street_Stats_Aggregate;
  /** An array relationship */
  street_stats_municipality: Array<Es_Street_Stats>;
  /** An aggregate relationship */
  street_stats_municipality_aggregate: Es_Street_Stats_Aggregate;
  type: Scalars['String']['output'];
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesPrice_StatsArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesPrice_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesPrice_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesPrice_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesStreet_Stats_LocalityArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesStreet_Stats_Locality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesStreet_Stats_MunicipalityArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Es_PlacesStreet_Stats_Municipality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Es_Places_Aggregate = {
  aggregate?: Maybe<Es_Places_Aggregate_Fields>;
  nodes: Array<Es_Places>;
};

/** aggregate fields of "places" */
export type Es_Places_Aggregate_Fields = {
  avg?: Maybe<Es_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Places_Max_Fields>;
  min?: Maybe<Es_Places_Min_Fields>;
  stddev?: Maybe<Es_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Places_Sum_Fields>;
  var_pop?: Maybe<Es_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Places_Var_Samp_Fields>;
  variance?: Maybe<Es_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Es_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Es_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Places_Max_Order_By>;
  min?: InputMaybe<Es_Places_Min_Order_By>;
  stddev?: InputMaybe<Es_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Es_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Es_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Places_Bool_Exp>>;
  _not?: InputMaybe<Es_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Es_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Es_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Es_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Es_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_stats?: InputMaybe<Es_Price_Stats_Bool_Exp>;
  price_stats_historical?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
  region?: InputMaybe<Es_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  slug_pl?: InputMaybe<String_Comparison_Exp>;
  slug_pt?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Es_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Es_Places_Bool_Exp>;
  street_stats_locality?: InputMaybe<Es_Street_Stats_Bool_Exp>;
  street_stats_municipality?: InputMaybe<Es_Street_Stats_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** For a municipality, a locality or a neighbourhood (place_id), the places it sits in (breadcrumb_place_id -> places): order_num 1 locality, 2 municipality, 3 state; the place itself and non-state aliases are left out, so a locality starts at 2. */
export type Es_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Es_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Es_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Es_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Es_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Es_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Es_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Es_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Es_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Es_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Es_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Es_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Es_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Es_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Es_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Es_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Es_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Es_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Es_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Es_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Es_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Es_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Es_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Es_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Es_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_stats_aggregate?: InputMaybe<Es_Price_Stats_Aggregate_Order_By>;
  price_stats_historical_aggregate?: InputMaybe<Es_Price_Stats_Historical_Aggregate_Order_By>;
  region_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Es_Places_Aggregate_Order_By>;
  street_stats_locality_aggregate?: InputMaybe<Es_Street_Stats_Aggregate_Order_By>;
  street_stats_municipality_aggregate?: InputMaybe<Es_Street_Stats_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Es_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  SlugPl = 'slug_pl',
  /** column name */
  SlugPt = 'slug_pt',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Es_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Es_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Es_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Es_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Es_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Es_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Es_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Es_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Cadastral plots in Switzerland, France and Spain: the outline in geom, area_m2, and the raw cadastre attributes in extra, which differ per country. */
export type Es_Plots = {
  area_m2?: Maybe<Scalars['numeric']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  local_plot_id?: Maybe<Scalars['String']['output']>;
};


/** Cadastral plots in Switzerland, France and Spain: the outline in geom, area_m2, and the raw cadastre attributes in extra, which differ per country. */
export type Es_PlotsExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "plots". All fields are combined with a logical 'AND'. */
export type Es_Plots_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Plots_Bool_Exp>>;
  _not?: InputMaybe<Es_Plots_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Plots_Bool_Exp>>;
  area_m2?: InputMaybe<Numeric_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  local_plot_id?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "plots". */
export type Es_Plots_Order_By = {
  area_m2?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_plot_id?: InputMaybe<Order_By>;
};

/** select columns of table "plots" */
export enum Es_Plots_Select_Column {
  /** column name */
  AreaM2 = 'area_m2',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  LocalPlotId = 'local_plot_id'
}

/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Es_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Es_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Es_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Es_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Es_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Es_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Es_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Es_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Es_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Es_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "post_merged_listings" */
export type Es_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Es_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Es_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Es_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Es_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Es_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Es_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Es_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Es_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Es_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Es_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Es_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Es_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Es_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Es_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Es_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Es_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Es_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Es_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Es_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Es_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Price estimates of a place: one row per place_id x property_main_type x number_of_rooms. number_of_rooms = 0 is all sizes; property_main_type is ANY (all types), HOUSE or APPT. sale_price_m2_50 is the modelled price per m2; _10 and _90 are that estimate scaled to a typical low and high, not percentiles of the place. monthly_rent_* is gross monthly rent, yearly_rent_m2_* yearly rent per m2. Rebuilt monthly. */
export type Es_Price_Stats = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "price_stats" */
export type Es_Price_Stats_Aggregate = {
  aggregate?: Maybe<Es_Price_Stats_Aggregate_Fields>;
  nodes: Array<Es_Price_Stats>;
};

/** aggregate fields of "price_stats" */
export type Es_Price_Stats_Aggregate_Fields = {
  avg?: Maybe<Es_Price_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Price_Stats_Max_Fields>;
  min?: Maybe<Es_Price_Stats_Min_Fields>;
  stddev?: Maybe<Es_Price_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Price_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Price_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Price_Stats_Sum_Fields>;
  var_pop?: Maybe<Es_Price_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Price_Stats_Var_Samp_Fields>;
  variance?: Maybe<Es_Price_Stats_Variance_Fields>;
};


/** aggregate fields of "price_stats" */
export type Es_Price_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats" */
export type Es_Price_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Price_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Price_Stats_Max_Order_By>;
  min?: InputMaybe<Es_Price_Stats_Min_Order_By>;
  stddev?: InputMaybe<Es_Price_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Price_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Price_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Price_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Price_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Price_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Price_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Price_Stats_Avg_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats" */
export type Es_Price_Stats_Avg_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats". All fields are combined with a logical 'AND'. */
export type Es_Price_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Price_Stats_Bool_Exp>>;
  _not?: InputMaybe<Es_Price_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Price_Stats_Bool_Exp>>;
  monthly_rent_10?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_50?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_90?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_type?: InputMaybe<Place_Type_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_count?: InputMaybe<Int_Comparison_Exp>;
  rent_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_price_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_90?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_90?: InputMaybe<Float_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  yearly_rent_m2_10?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_50?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_90?: InputMaybe<Float_Comparison_Exp>;
};

/** Modelled sale price per m2 of a place over time: one row per place_id x property_main_type x number_of_rooms x date. All property types is 'ALL' here, where price_stats says ANY; number_of_rooms = 0 is all sizes. Daily for countries, states, districts and agglomerations, monthly for municipalities and localities. Always filter place_id, property_main_type, number_of_rooms and a date range. */
export type Es_Price_Stats_Historical = {
  date: Scalars['date']['output'];
  number_of_rooms: Scalars['Int']['output'];
  place_id: Scalars['uuid']['output'];
  property_main_type: Scalars['String']['output'];
  sale_price_m2: Scalars['Float']['output'];
};

/** aggregated selection of "price_stats_historical" */
export type Es_Price_Stats_Historical_Aggregate = {
  aggregate?: Maybe<Es_Price_Stats_Historical_Aggregate_Fields>;
  nodes: Array<Es_Price_Stats_Historical>;
};

/** aggregate fields of "price_stats_historical" */
export type Es_Price_Stats_Historical_Aggregate_Fields = {
  avg?: Maybe<Es_Price_Stats_Historical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Price_Stats_Historical_Max_Fields>;
  min?: Maybe<Es_Price_Stats_Historical_Min_Fields>;
  stddev?: Maybe<Es_Price_Stats_Historical_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Price_Stats_Historical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Price_Stats_Historical_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Price_Stats_Historical_Sum_Fields>;
  var_pop?: Maybe<Es_Price_Stats_Historical_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Price_Stats_Historical_Var_Samp_Fields>;
  variance?: Maybe<Es_Price_Stats_Historical_Variance_Fields>;
};


/** aggregate fields of "price_stats_historical" */
export type Es_Price_Stats_Historical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Price_Stats_Historical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Price_Stats_Historical_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Price_Stats_Historical_Max_Order_By>;
  min?: InputMaybe<Es_Price_Stats_Historical_Min_Order_By>;
  stddev?: InputMaybe<Es_Price_Stats_Historical_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Price_Stats_Historical_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Price_Stats_Historical_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Price_Stats_Historical_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Price_Stats_Historical_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Price_Stats_Historical_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Price_Stats_Historical_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Price_Stats_Historical_Avg_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Avg_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_historical". All fields are combined with a logical 'AND'. */
export type Es_Price_Stats_Historical_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Price_Stats_Historical_Bool_Exp>>;
  _not?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Price_Stats_Historical_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  sale_price_m2?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Price_Stats_Historical_Max_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Price_Stats_Historical_Min_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_historical". */
export type Es_Price_Stats_Historical_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_historical" */
export enum Es_Price_Stats_Historical_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  SalePriceM2 = 'sale_price_m2'
}

/** aggregate stddev on columns */
export type Es_Price_Stats_Historical_Stddev_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Stddev_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Price_Stats_Historical_Stddev_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Stddev_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Price_Stats_Historical_Stddev_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Stddev_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Price_Stats_Historical_Sum_Fields = {
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Sum_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Price_Stats_Historical_Var_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Var_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Price_Stats_Historical_Var_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Var_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Price_Stats_Historical_Variance_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_historical" */
export type Es_Price_Stats_Historical_Variance_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Es_Price_Stats_Max_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats" */
export type Es_Price_Stats_Max_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Price_Stats_Min_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats" */
export type Es_Price_Stats_Min_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats". */
export type Es_Price_Stats_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats" */
export enum Es_Price_Stats_Select_Column {
  /** column name */
  MonthlyRent_10 = 'monthly_rent_10',
  /** column name */
  MonthlyRent_50 = 'monthly_rent_50',
  /** column name */
  MonthlyRent_90 = 'monthly_rent_90',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PlaceParentId = 'place_parent_id',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentCount = 'rent_count',
  /** column name */
  RentCount_3month = 'rent_count_3month',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleCount_3month = 'sale_count_3month',
  /** column name */
  SalePrice_10 = 'sale_price_10',
  /** column name */
  SalePrice_50 = 'sale_price_50',
  /** column name */
  SalePrice_90 = 'sale_price_90',
  /** column name */
  SalePriceM2_10 = 'sale_price_m2_10',
  /** column name */
  SalePriceM2_50 = 'sale_price_m2_50',
  /** column name */
  SalePriceM2_90 = 'sale_price_m2_90',
  /** column name */
  Stock = 'stock',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  YearlyRentM2_10 = 'yearly_rent_m2_10',
  /** column name */
  YearlyRentM2_50 = 'yearly_rent_m2_50',
  /** column name */
  YearlyRentM2_90 = 'yearly_rent_m2_90'
}

/** aggregate stddev on columns */
export type Es_Price_Stats_Stddev_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats" */
export type Es_Price_Stats_Stddev_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Price_Stats_Stddev_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats" */
export type Es_Price_Stats_Stddev_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Price_Stats_Stddev_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats" */
export type Es_Price_Stats_Stddev_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Price_Stats_Sum_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats" */
export type Es_Price_Stats_Sum_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Price_Stats_Var_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats" */
export type Es_Price_Stats_Var_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Price_Stats_Var_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats" */
export type Es_Price_Stats_Var_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Price_Stats_Variance_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats" */
export type Es_Price_Stats_Variance_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

export enum Es_Property_Main_Type_Enum {
  Agri = 'AGRI',
  Appt = 'APPT',
  Building = 'BUILDING',
  Commercial = 'COMMERCIAL',
  Garden = 'GARDEN',
  Gastro = 'GASTRO',
  House = 'HOUSE',
  HouseAppt = 'HOUSE_APPT',
  Indus = 'INDUS',
  Other = 'OTHER',
  Park = 'PARK',
  Prop = 'PROP',
  Room = 'ROOM',
  Secondary = 'SECONDARY'
}

/** Boolean expression to compare columns of type "es_property_main_type_enum". All fields are combined with logical 'AND'. */
export type Es_Property_Main_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Es_Property_Main_Type_Enum>;
  _in?: InputMaybe<Array<Es_Property_Main_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Es_Property_Main_Type_Enum>;
  _nin?: InputMaybe<Array<Es_Property_Main_Type_Enum>>;
};

/** columns and relationships of "property_types" */
export type Es_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Es_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Es_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Es_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Es_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "rental_cma_listings_distance" */
export type Es_Rental_Cma_Listings_Distance = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  is_online?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  listing?: Maybe<Es_Cma_Rental_Listings>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

export type Es_Rental_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Es_Rental_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Es_Rental_Cma_Listings_Distance>;
};

/** aggregate fields of "rental_cma_listings_distance" */
export type Es_Rental_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Es_Rental_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Rental_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Es_Rental_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Es_Rental_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Rental_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Rental_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Rental_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Es_Rental_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Rental_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Es_Rental_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "rental_cma_listings_distance" */
export type Es_Rental_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Es_Rental_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Es_Rental_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float8_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  listing?: InputMaybe<Es_Cma_Rental_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  net_rent_per_sqm?: InputMaybe<Float8_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Rental_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Es_Rental_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "rental_cma_listings_distance". */
export type Es_Rental_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  listing?: InputMaybe<Es_Cma_Rental_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  net_rent_per_sqm?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_cma_listings_distance" */
export enum Es_Rental_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  NetRentPerSqm = 'net_rent_per_sqm',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Es_Rental_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Es_Rental_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Es_Rental_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Es_Rental_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Es_Rental_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Es_Rental_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Es_Rental_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "states" */
export type Es_States = {
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "states". All fields are combined with a logical 'AND'. */
export type Es_States_Bool_Exp = {
  _and?: InputMaybe<Array<Es_States_Bool_Exp>>;
  _not?: InputMaybe<Es_States_Bool_Exp>;
  _or?: InputMaybe<Array<Es_States_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "states". */
export type Es_States_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "states" */
export enum Es_States_Select_Column {
  /** column name */
  Name = 'name'
}

/** Sale price per m2 by street (route) within a municipality or locality: median, mean, 15th and 85th percentile, and total_count, the number of data points behind them. A street with a small total_count is noise: ask for at least 15. Rebuilt monthly. */
export type Es_Street_Stats = {
  geom?: Maybe<Scalars['geometry']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  is_cross_locality?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  locality?: Maybe<Es_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  municipality?: Maybe<Es_Places>;
  municipality_id: Scalars['uuid']['output'];
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['uuid']['output'];
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "street_stats" */
export type Es_Street_Stats_Aggregate = {
  aggregate?: Maybe<Es_Street_Stats_Aggregate_Fields>;
  nodes: Array<Es_Street_Stats>;
};

/** aggregate fields of "street_stats" */
export type Es_Street_Stats_Aggregate_Fields = {
  avg?: Maybe<Es_Street_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Es_Street_Stats_Max_Fields>;
  min?: Maybe<Es_Street_Stats_Min_Fields>;
  stddev?: Maybe<Es_Street_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Es_Street_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Es_Street_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Es_Street_Stats_Sum_Fields>;
  var_pop?: Maybe<Es_Street_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Es_Street_Stats_Var_Samp_Fields>;
  variance?: Maybe<Es_Street_Stats_Variance_Fields>;
};


/** aggregate fields of "street_stats" */
export type Es_Street_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "street_stats" */
export type Es_Street_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Es_Street_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Es_Street_Stats_Max_Order_By>;
  min?: InputMaybe<Es_Street_Stats_Min_Order_By>;
  stddev?: InputMaybe<Es_Street_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Es_Street_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Es_Street_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Es_Street_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Es_Street_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Es_Street_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Es_Street_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Es_Street_Stats_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "street_stats" */
export type Es_Street_Stats_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "street_stats". All fields are combined with a logical 'AND'. */
export type Es_Street_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Es_Street_Stats_Bool_Exp>>;
  _not?: InputMaybe<Es_Street_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Es_Street_Stats_Bool_Exp>>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  is_cross_locality?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  locality?: InputMaybe<Es_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  mean_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  median_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  municipality?: InputMaybe<Es_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  num_street_numbers?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_count?: InputMaybe<Int_Comparison_Exp>;
  upper_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Es_Street_Stats_Max_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "street_stats" */
export type Es_Street_Stats_Max_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Es_Street_Stats_Min_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "street_stats" */
export type Es_Street_Stats_Min_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "street_stats". */
export type Es_Street_Stats_Order_By = {
  geom?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  is_cross_locality?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Es_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Es_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** select columns of table "street_stats" */
export enum Es_Street_Stats_Select_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  IsCrossLocality = 'is_cross_locality',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  Lower_15PercentilePricePerM2 = 'lower_15_percentile_price_per_m2',
  /** column name */
  MeanPricePerM2 = 'mean_price_per_m2',
  /** column name */
  MedianPricePerM2 = 'median_price_per_m2',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NumStreetNumbers = 'num_street_numbers',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  Upper_15PercentilePricePerM2 = 'upper_15_percentile_price_per_m2'
}

/** aggregate stddev on columns */
export type Es_Street_Stats_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "street_stats" */
export type Es_Street_Stats_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Es_Street_Stats_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "street_stats" */
export type Es_Street_Stats_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Es_Street_Stats_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "street_stats" */
export type Es_Street_Stats_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Es_Street_Stats_Sum_Fields = {
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "street_stats" */
export type Es_Street_Stats_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Es_Street_Stats_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "street_stats" */
export type Es_Street_Stats_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Es_Street_Stats_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "street_stats" */
export type Es_Street_Stats_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Es_Street_Stats_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "street_stats" */
export type Es_Street_Stats_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** columns and relationships of "files" */
export type Files = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  document_type?: Maybe<Dictionaries>;
  document_type_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Size in bytes */
  size: Scalars['Int']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploader?: Maybe<Users>;
  uploader_id?: Maybe<Scalars['uuid']['output']>;
  url: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp = {
  _and?: InputMaybe<Array<Files_Bool_Exp>>;
  _not?: InputMaybe<Files_Bool_Exp>;
  _or?: InputMaybe<Array<Files_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  document_type?: InputMaybe<Dictionaries_Bool_Exp>;
  document_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mimetype?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  size?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  uploader?: InputMaybe<Users_Bool_Exp>;
  uploader_id?: InputMaybe<Uuid_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "files" */
export enum Files_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  FilesIdTenantIdUnique = 'files_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  FilesPkey = 'files_pkey'
}

/** input type for inserting data into table "files" */
export type Files_Insert_Input = {
  document_type?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Size in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  uploader?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "files" */
export type Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files>;
};

/** input type for inserting object relation for remote table "files" */
export type Files_Obj_Rel_Insert_Input = {
  data: Files_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict>;
};

/** on_conflict condition type for table "files" */
export type Files_On_Conflict = {
  constraint: Files_Constraint;
  update_columns?: Array<Files_Update_Column>;
  where?: InputMaybe<Files_Bool_Exp>;
};

/** Ordering options when selecting data from "files". */
export type Files_Order_By = {
  created_at?: InputMaybe<Order_By>;
  document_type?: InputMaybe<Dictionaries_Order_By>;
  document_type_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mimetype?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  uploader?: InputMaybe<Users_Order_By>;
  uploader_id?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: files */
export type Files_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "files" */
export enum Files_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DocumentTypeId = 'document_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Mimetype = 'mimetype',
  /** column name */
  Name = 'name',
  /** column name */
  Size = 'size',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UploaderId = 'uploader_id',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "files" */
export type Files_Set_Input = {
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Size in bytes */
  size?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  uploader_id?: InputMaybe<Scalars['uuid']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "files" */
export enum Files_Update_Column {
  /** column name */
  DocumentTypeId = 'document_type_id'
}

export type Files_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp;
};

export type Find_Cma_Leads_By_Address_Args = {
  p_locality?: InputMaybe<Scalars['String']['input']>;
  p_postcode?: InputMaybe<Scalars['String']['input']>;
  p_route?: InputMaybe<Scalars['String']['input']>;
  p_street_number?: InputMaybe<Scalars['String']['input']>;
};

export type Find_Price_Map_Places_Args = {
  p_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['float8']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['float8']['input']>>;
  _eq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _gte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['float8']['input']>>;
  _lte?: InputMaybe<Array<Scalars['float8']['input']>>;
  _neq?: InputMaybe<Array<Scalars['float8']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['float8']['input']>>>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Fr_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Fr_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Fr_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_listings_places" */
  places?: Maybe<Array<Fr_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Fr_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  state?: Maybe<Fr_States>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Fr_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Fr_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Fr_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Fr_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Fr_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Fr_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Fr_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Fr_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Fr_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Cma_Listings_Max_Fields>;
  min?: Maybe<Fr_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Fr_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Fr_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Fr_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Fr_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Fr_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Fr_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Fr_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<Fr_States_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** columns and relationships of "cma_listings_distance" */
export type Fr_Cma_Listings_Distance = {
  distance_in_meters: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  listing?: Maybe<Fr_Cma_Listings>;
  listing_id: Scalars['Int']['output'];
  state_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_listings_distance" */
export type Fr_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Fr_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Fr_Cma_Listings_Distance>;
};

/** aggregate fields of "cma_listings_distance" */
export type Fr_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Fr_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Fr_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Fr_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Fr_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Fr_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "cma_listings_distance" */
export type Fr_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Fr_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  listing?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Fr_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "cma_listings_distance". */
export type Fr_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing?: InputMaybe<Fr_Cma_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings_distance" */
export enum Fr_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Fr_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Fr_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Fr_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Fr_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Fr_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state?: InputMaybe<Fr_States_Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Fr_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Fr_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cma_rental_listings" */
export type Fr_Cma_Rental_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Fr_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Fr_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Fr_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_rental_listings_places" */
  places?: Maybe<Array<Fr_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_rental_listings" */
export type Fr_Cma_Rental_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Fr_Cma_Rental_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Fr_Cma_Rental_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Fr_Cma_Rental_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_rental_listings" */
export type Fr_Cma_Rental_Listings_Aggregate = {
  aggregate?: Maybe<Fr_Cma_Rental_Listings_Aggregate_Fields>;
  nodes: Array<Fr_Cma_Rental_Listings>;
};

/** aggregate fields of "cma_rental_listings" */
export type Fr_Cma_Rental_Listings_Aggregate_Fields = {
  avg?: Maybe<Fr_Cma_Rental_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Cma_Rental_Listings_Max_Fields>;
  min?: Maybe<Fr_Cma_Rental_Listings_Min_Fields>;
  stddev?: Maybe<Fr_Cma_Rental_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Cma_Rental_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Cma_Rental_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Cma_Rental_Listings_Sum_Fields>;
  var_pop?: Maybe<Fr_Cma_Rental_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Cma_Rental_Listings_Var_Samp_Fields>;
  variance?: Maybe<Fr_Cma_Rental_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_rental_listings" */
export type Fr_Cma_Rental_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Cma_Rental_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Cma_Rental_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_rental_listings". All fields are combined with a logical 'AND'. */
export type Fr_Cma_Rental_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Cma_Rental_Listings_Bool_Exp>>;
  _not?: InputMaybe<Fr_Cma_Rental_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Cma_Rental_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Fr_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Fr_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Cma_Rental_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Fr_Cma_Rental_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_rental_listings". */
export type Fr_Cma_Rental_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Fr_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_rental_listings" */
export enum Fr_Cma_Rental_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Fr_Cma_Rental_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Cma_Rental_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Cma_Rental_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Cma_Rental_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Cma_Rental_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Cma_Rental_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Cma_Rental_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Energy performance certificates of buildings: France only (DPE and GES), empty elsewhere. energy_rating and emissions_rating are A to G; date_of_diagnostic and date_of_expiry; located by a point (geom); extra holds the raw DPE fields. */
export type Fr_Energy_Certificates = {
  date_of_diagnostic?: Maybe<Scalars['date']['output']>;
  date_of_expiry?: Maybe<Scalars['date']['output']>;
  emissions_rating?: Maybe<Scalars['String']['output']>;
  energy_rating?: Maybe<Scalars['String']['output']>;
  external_id: Scalars['String']['output'];
  extra: Scalars['jsonb']['output'];
  geom?: Maybe<Scalars['geometry']['output']>;
  id: Scalars['uuid']['output'];
};


/** Energy performance certificates of buildings: France only (DPE and GES), empty elsewhere. energy_rating and emissions_rating are A to G; date_of_diagnostic and date_of_expiry; located by a point (geom); extra holds the raw DPE fields. */
export type Fr_Energy_CertificatesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "energy_certificates". All fields are combined with a logical 'AND'. */
export type Fr_Energy_Certificates_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Energy_Certificates_Bool_Exp>>;
  _not?: InputMaybe<Fr_Energy_Certificates_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Energy_Certificates_Bool_Exp>>;
  date_of_diagnostic?: InputMaybe<Date_Comparison_Exp>;
  date_of_expiry?: InputMaybe<Date_Comparison_Exp>;
  emissions_rating?: InputMaybe<String_Comparison_Exp>;
  energy_rating?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "energy_certificates". */
export type Fr_Energy_Certificates_Order_By = {
  date_of_diagnostic?: InputMaybe<Order_By>;
  date_of_expiry?: InputMaybe<Order_By>;
  emissions_rating?: InputMaybe<Order_By>;
  energy_rating?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** select columns of table "energy_certificates" */
export enum Fr_Energy_Certificates_Select_Column {
  /** column name */
  DateOfDiagnostic = 'date_of_diagnostic',
  /** column name */
  DateOfExpiry = 'date_of_expiry',
  /** column name */
  EmissionsRating = 'emissions_rating',
  /** column name */
  EnergyRating = 'energy_rating',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id'
}

/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Fr_External_Transactions = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  source_payload?: Maybe<Scalars['jsonb']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};


/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Fr_External_TransactionsSource_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_transactions" */
export type Fr_External_Transactions_Aggregate = {
  aggregate?: Maybe<Fr_External_Transactions_Aggregate_Fields>;
  nodes: Array<Fr_External_Transactions>;
};

/** aggregate fields of "external_transactions" */
export type Fr_External_Transactions_Aggregate_Fields = {
  avg?: Maybe<Fr_External_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_External_Transactions_Max_Fields>;
  min?: Maybe<Fr_External_Transactions_Min_Fields>;
  stddev?: Maybe<Fr_External_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_External_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_External_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_External_Transactions_Sum_Fields>;
  var_pop?: Maybe<Fr_External_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_External_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Fr_External_Transactions_Variance_Fields>;
};


/** aggregate fields of "external_transactions" */
export type Fr_External_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_External_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_External_Transactions_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions". All fields are combined with a logical 'AND'. */
export type Fr_External_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_External_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Fr_External_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_External_Transactions_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** Rows returned by get_external_transactions_distance: a recorded sale and its distance_in_meters from the point asked. Data in France only. The table itself holds no row: call the function, with _lat and _lng always; nearest first unless _sort_field (with _sort_direction) is set. _max_distance_meters is 5 km by default and 50 km at most; pass _max_distance_meters: null to search a whole _postcode, bbox or _polygon_geojson beyond 5 km. _property_main_type, _cutoff_date and _cutoff_date_max, surfaces, rooms and price narrow further. At most 5000 rows (_max_results): a count over it stops there, so narrow the area or the dates for a large city. */
export type Fr_External_Transactions_Distance = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  distance_in_meters: Scalars['Float']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "external_transactions_distance" */
export type Fr_External_Transactions_Distance_Aggregate = {
  aggregate?: Maybe<Fr_External_Transactions_Distance_Aggregate_Fields>;
  nodes: Array<Fr_External_Transactions_Distance>;
};

/** aggregate fields of "external_transactions_distance" */
export type Fr_External_Transactions_Distance_Aggregate_Fields = {
  avg?: Maybe<Fr_External_Transactions_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_External_Transactions_Distance_Max_Fields>;
  min?: Maybe<Fr_External_Transactions_Distance_Min_Fields>;
  stddev?: Maybe<Fr_External_Transactions_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_External_Transactions_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_External_Transactions_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_External_Transactions_Distance_Sum_Fields>;
  var_pop?: Maybe<Fr_External_Transactions_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_External_Transactions_Distance_Var_Samp_Fields>;
  variance?: Maybe<Fr_External_Transactions_Distance_Variance_Fields>;
};


/** aggregate fields of "external_transactions_distance" */
export type Fr_External_Transactions_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_External_Transactions_Distance_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions_distance". All fields are combined with a logical 'AND'. */
export type Fr_External_Transactions_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_External_Transactions_Distance_Bool_Exp>>;
  _not?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_External_Transactions_Distance_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_External_Transactions_Distance_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fr_External_Transactions_Distance_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions_distance". */
export type Fr_External_Transactions_Distance_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions_distance" */
export enum Fr_External_Transactions_Distance_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Fr_External_Transactions_Distance_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_External_Transactions_Distance_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_External_Transactions_Distance_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_External_Transactions_Distance_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_External_Transactions_Distance_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_External_Transactions_Distance_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_External_Transactions_Distance_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Fr_External_Transactions_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Fr_External_Transactions_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions". */
export type Fr_External_Transactions_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_payload?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions" */
export enum Fr_External_Transactions_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  SourcePayload = 'source_payload',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Fr_External_Transactions_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_External_Transactions_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_External_Transactions_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_External_Transactions_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_External_Transactions_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_External_Transactions_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_External_Transactions_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Fr_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Fr_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Fr_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Fr_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Fr_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Fr_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Fr_Merged_Images_Aggregate = {
  aggregate?: Maybe<Fr_Merged_Images_Aggregate_Fields>;
  nodes: Array<Fr_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Fr_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Fr_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Merged_Images_Max_Fields>;
  min?: Maybe<Fr_Merged_Images_Min_Fields>;
  stddev?: Maybe<Fr_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Fr_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Fr_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Fr_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Fr_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Fr_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Fr_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Fr_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Fr_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Fr_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Fr_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Fr_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Fr_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Fr_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Fr_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Fr_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Fr_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Fr_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Fr_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Fr_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Fr_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Fr_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Fr_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Fr_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Fr_Property_Main_Type_Enum;
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** Hidden from the public site by an admin (per listing, together with its duplicates). It does not say whether the listing is still online: see offline_since. */
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Fr_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Fr_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Fr_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Fr_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Fr_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Fr_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Fr_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Fr_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Merged_Listings_Max_Fields>;
  min?: Maybe<Fr_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Fr_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Fr_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Fr_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Fr_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Fr_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<Fr_Property_Main_Type_Enum_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Fr_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Fr_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Fr_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Fr_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Fr_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Fr_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Fr_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Fr_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Fr_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Fr_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<Fr_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: Fr_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_stats: Array<Fr_Price_Stats>;
  /** An aggregate relationship */
  price_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** An array relationship */
  price_stats_historical: Array<Fr_Price_Stats_Historical>;
  /** An aggregate relationship */
  price_stats_historical_aggregate: Fr_Price_Stats_Historical_Aggregate;
  /** An array relationship */
  region: Array<Fr_Places>;
  /** An aggregate relationship */
  region_aggregate: Fr_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<Fr_Places>;
  /** An aggregate relationship */
  state_aggregate: Fr_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Fr_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Fr_Places_Aggregate;
  /** An array relationship */
  street_stats_locality: Array<Fr_Street_Stats>;
  /** An aggregate relationship */
  street_stats_locality_aggregate: Fr_Street_Stats_Aggregate;
  /** An array relationship */
  street_stats_municipality: Array<Fr_Street_Stats>;
  /** An aggregate relationship */
  street_stats_municipality_aggregate: Fr_Street_Stats_Aggregate;
  type: Scalars['String']['output'];
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesPrice_StatsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesPrice_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesPrice_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesPrice_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesStreet_Stats_LocalityArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesStreet_Stats_Locality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesStreet_Stats_MunicipalityArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Fr_PlacesStreet_Stats_Municipality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Fr_Places_Aggregate = {
  aggregate?: Maybe<Fr_Places_Aggregate_Fields>;
  nodes: Array<Fr_Places>;
};

/** aggregate fields of "places" */
export type Fr_Places_Aggregate_Fields = {
  avg?: Maybe<Fr_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Places_Max_Fields>;
  min?: Maybe<Fr_Places_Min_Fields>;
  stddev?: Maybe<Fr_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Places_Sum_Fields>;
  var_pop?: Maybe<Fr_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Places_Var_Samp_Fields>;
  variance?: Maybe<Fr_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Fr_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Fr_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Places_Max_Order_By>;
  min?: InputMaybe<Fr_Places_Min_Order_By>;
  stddev?: InputMaybe<Fr_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Fr_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Fr_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Places_Bool_Exp>>;
  _not?: InputMaybe<Fr_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Fr_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Fr_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Fr_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Fr_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_stats?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
  price_stats_historical?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
  region?: InputMaybe<Fr_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  slug_pl?: InputMaybe<String_Comparison_Exp>;
  slug_pt?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Fr_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Fr_Places_Bool_Exp>;
  street_stats_locality?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
  street_stats_municipality?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** For a municipality, a locality or a neighbourhood (place_id), the places it sits in (breadcrumb_place_id -> places): order_num 1 locality, 2 municipality, 3 state; the place itself and non-state aliases are left out, so a locality starts at 2. */
export type Fr_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Fr_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Fr_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Fr_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Fr_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Fr_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Fr_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Fr_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Fr_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Fr_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Fr_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Fr_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Fr_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Fr_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Fr_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Fr_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Fr_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Fr_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Fr_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Fr_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Fr_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Fr_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Fr_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Fr_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Fr_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_stats_aggregate?: InputMaybe<Fr_Price_Stats_Aggregate_Order_By>;
  price_stats_historical_aggregate?: InputMaybe<Fr_Price_Stats_Historical_Aggregate_Order_By>;
  region_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Fr_Places_Aggregate_Order_By>;
  street_stats_locality_aggregate?: InputMaybe<Fr_Street_Stats_Aggregate_Order_By>;
  street_stats_municipality_aggregate?: InputMaybe<Fr_Street_Stats_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Fr_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  SlugPl = 'slug_pl',
  /** column name */
  SlugPt = 'slug_pt',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Fr_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Fr_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Fr_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Fr_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Fr_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Fr_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Fr_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Fr_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Cadastral plots in Switzerland, France and Spain: the outline in geom, area_m2, and the raw cadastre attributes in extra, which differ per country. */
export type Fr_Plots = {
  area_m2?: Maybe<Scalars['numeric']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  local_plot_id?: Maybe<Scalars['String']['output']>;
};


/** Cadastral plots in Switzerland, France and Spain: the outline in geom, area_m2, and the raw cadastre attributes in extra, which differ per country. */
export type Fr_PlotsExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "plots". All fields are combined with a logical 'AND'. */
export type Fr_Plots_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Plots_Bool_Exp>>;
  _not?: InputMaybe<Fr_Plots_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Plots_Bool_Exp>>;
  area_m2?: InputMaybe<Numeric_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  local_plot_id?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "plots". */
export type Fr_Plots_Order_By = {
  area_m2?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_plot_id?: InputMaybe<Order_By>;
};

/** select columns of table "plots" */
export enum Fr_Plots_Select_Column {
  /** column name */
  AreaM2 = 'area_m2',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  LocalPlotId = 'local_plot_id'
}

/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Fr_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Fr_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Fr_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Fr_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Fr_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Fr_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Fr_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Fr_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Fr_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Fr_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "post_merged_listings" */
export type Fr_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Fr_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Fr_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Fr_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Fr_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Fr_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Fr_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Fr_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Fr_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Fr_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Fr_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Fr_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Fr_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Fr_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Fr_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Fr_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Fr_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Fr_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Fr_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Fr_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Price estimates of a place: one row per place_id x property_main_type x number_of_rooms. number_of_rooms = 0 is all sizes; property_main_type is ANY (all types), HOUSE or APPT. sale_price_m2_50 is the modelled price per m2; _10 and _90 are that estimate scaled to a typical low and high, not percentiles of the place. monthly_rent_* is gross monthly rent, yearly_rent_m2_* yearly rent per m2. Rebuilt monthly. */
export type Fr_Price_Stats = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "price_stats" */
export type Fr_Price_Stats_Aggregate = {
  aggregate?: Maybe<Fr_Price_Stats_Aggregate_Fields>;
  nodes: Array<Fr_Price_Stats>;
};

/** aggregate fields of "price_stats" */
export type Fr_Price_Stats_Aggregate_Fields = {
  avg?: Maybe<Fr_Price_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Price_Stats_Max_Fields>;
  min?: Maybe<Fr_Price_Stats_Min_Fields>;
  stddev?: Maybe<Fr_Price_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Price_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Price_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Price_Stats_Sum_Fields>;
  var_pop?: Maybe<Fr_Price_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Price_Stats_Var_Samp_Fields>;
  variance?: Maybe<Fr_Price_Stats_Variance_Fields>;
};


/** aggregate fields of "price_stats" */
export type Fr_Price_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats" */
export type Fr_Price_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Price_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Price_Stats_Max_Order_By>;
  min?: InputMaybe<Fr_Price_Stats_Min_Order_By>;
  stddev?: InputMaybe<Fr_Price_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Price_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Price_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Price_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Price_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Price_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Price_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Price_Stats_Avg_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats" */
export type Fr_Price_Stats_Avg_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats". All fields are combined with a logical 'AND'. */
export type Fr_Price_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Price_Stats_Bool_Exp>>;
  _not?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Price_Stats_Bool_Exp>>;
  monthly_rent_10?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_50?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_90?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_type?: InputMaybe<Place_Type_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_count?: InputMaybe<Int_Comparison_Exp>;
  rent_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_price_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_90?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_90?: InputMaybe<Float_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  yearly_rent_m2_10?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_50?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_90?: InputMaybe<Float_Comparison_Exp>;
};

/** Modelled sale price per m2 of a place over time: one row per place_id x property_main_type x number_of_rooms x date. All property types is 'ALL' here, where price_stats says ANY; number_of_rooms = 0 is all sizes. Daily for countries, states, districts and agglomerations, monthly for municipalities and localities. Always filter place_id, property_main_type, number_of_rooms and a date range. */
export type Fr_Price_Stats_Historical = {
  date: Scalars['date']['output'];
  number_of_rooms: Scalars['Int']['output'];
  place_id: Scalars['uuid']['output'];
  property_main_type: Scalars['String']['output'];
  sale_price_m2: Scalars['Float']['output'];
};

/** aggregated selection of "price_stats_historical" */
export type Fr_Price_Stats_Historical_Aggregate = {
  aggregate?: Maybe<Fr_Price_Stats_Historical_Aggregate_Fields>;
  nodes: Array<Fr_Price_Stats_Historical>;
};

/** aggregate fields of "price_stats_historical" */
export type Fr_Price_Stats_Historical_Aggregate_Fields = {
  avg?: Maybe<Fr_Price_Stats_Historical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Price_Stats_Historical_Max_Fields>;
  min?: Maybe<Fr_Price_Stats_Historical_Min_Fields>;
  stddev?: Maybe<Fr_Price_Stats_Historical_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Price_Stats_Historical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Price_Stats_Historical_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Price_Stats_Historical_Sum_Fields>;
  var_pop?: Maybe<Fr_Price_Stats_Historical_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Price_Stats_Historical_Var_Samp_Fields>;
  variance?: Maybe<Fr_Price_Stats_Historical_Variance_Fields>;
};


/** aggregate fields of "price_stats_historical" */
export type Fr_Price_Stats_Historical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Price_Stats_Historical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Price_Stats_Historical_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Price_Stats_Historical_Max_Order_By>;
  min?: InputMaybe<Fr_Price_Stats_Historical_Min_Order_By>;
  stddev?: InputMaybe<Fr_Price_Stats_Historical_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Price_Stats_Historical_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Price_Stats_Historical_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Price_Stats_Historical_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Price_Stats_Historical_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Price_Stats_Historical_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Price_Stats_Historical_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Price_Stats_Historical_Avg_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Avg_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_historical". All fields are combined with a logical 'AND'. */
export type Fr_Price_Stats_Historical_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Price_Stats_Historical_Bool_Exp>>;
  _not?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Price_Stats_Historical_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  sale_price_m2?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Price_Stats_Historical_Max_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Price_Stats_Historical_Min_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_historical". */
export type Fr_Price_Stats_Historical_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_historical" */
export enum Fr_Price_Stats_Historical_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  SalePriceM2 = 'sale_price_m2'
}

/** aggregate stddev on columns */
export type Fr_Price_Stats_Historical_Stddev_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Stddev_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Price_Stats_Historical_Stddev_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Stddev_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Price_Stats_Historical_Stddev_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Stddev_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Price_Stats_Historical_Sum_Fields = {
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Sum_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Price_Stats_Historical_Var_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Var_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Price_Stats_Historical_Var_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Var_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Price_Stats_Historical_Variance_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_historical" */
export type Fr_Price_Stats_Historical_Variance_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Fr_Price_Stats_Max_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats" */
export type Fr_Price_Stats_Max_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Price_Stats_Min_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats" */
export type Fr_Price_Stats_Min_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats". */
export type Fr_Price_Stats_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats" */
export enum Fr_Price_Stats_Select_Column {
  /** column name */
  MonthlyRent_10 = 'monthly_rent_10',
  /** column name */
  MonthlyRent_50 = 'monthly_rent_50',
  /** column name */
  MonthlyRent_90 = 'monthly_rent_90',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PlaceParentId = 'place_parent_id',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentCount = 'rent_count',
  /** column name */
  RentCount_3month = 'rent_count_3month',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleCount_3month = 'sale_count_3month',
  /** column name */
  SalePrice_10 = 'sale_price_10',
  /** column name */
  SalePrice_50 = 'sale_price_50',
  /** column name */
  SalePrice_90 = 'sale_price_90',
  /** column name */
  SalePriceM2_10 = 'sale_price_m2_10',
  /** column name */
  SalePriceM2_50 = 'sale_price_m2_50',
  /** column name */
  SalePriceM2_90 = 'sale_price_m2_90',
  /** column name */
  Stock = 'stock',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  YearlyRentM2_10 = 'yearly_rent_m2_10',
  /** column name */
  YearlyRentM2_50 = 'yearly_rent_m2_50',
  /** column name */
  YearlyRentM2_90 = 'yearly_rent_m2_90'
}

/** aggregate stddev on columns */
export type Fr_Price_Stats_Stddev_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats" */
export type Fr_Price_Stats_Stddev_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Price_Stats_Stddev_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats" */
export type Fr_Price_Stats_Stddev_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Price_Stats_Stddev_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats" */
export type Fr_Price_Stats_Stddev_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Price_Stats_Sum_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats" */
export type Fr_Price_Stats_Sum_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Price_Stats_Var_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats" */
export type Fr_Price_Stats_Var_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Price_Stats_Var_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats" */
export type Fr_Price_Stats_Var_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Price_Stats_Variance_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats" */
export type Fr_Price_Stats_Variance_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

export enum Fr_Property_Main_Type_Enum {
  Agri = 'AGRI',
  Appt = 'APPT',
  Building = 'BUILDING',
  Commercial = 'COMMERCIAL',
  Garden = 'GARDEN',
  Gastro = 'GASTRO',
  House = 'HOUSE',
  HouseAppt = 'HOUSE_APPT',
  Indus = 'INDUS',
  Other = 'OTHER',
  Park = 'PARK',
  Prop = 'PROP',
  Room = 'ROOM',
  Secondary = 'SECONDARY'
}

/** Boolean expression to compare columns of type "fr_property_main_type_enum". All fields are combined with logical 'AND'. */
export type Fr_Property_Main_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Fr_Property_Main_Type_Enum>;
  _in?: InputMaybe<Array<Fr_Property_Main_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Fr_Property_Main_Type_Enum>;
  _nin?: InputMaybe<Array<Fr_Property_Main_Type_Enum>>;
};

/** columns and relationships of "property_types" */
export type Fr_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Fr_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Fr_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Fr_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Fr_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "rental_cma_listings_distance" */
export type Fr_Rental_Cma_Listings_Distance = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  is_online?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  listing?: Maybe<Fr_Cma_Rental_Listings>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

export type Fr_Rental_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Fr_Rental_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Fr_Rental_Cma_Listings_Distance>;
};

/** aggregate fields of "rental_cma_listings_distance" */
export type Fr_Rental_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Fr_Rental_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Rental_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Fr_Rental_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Fr_Rental_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Rental_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Rental_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Rental_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Fr_Rental_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Rental_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Fr_Rental_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "rental_cma_listings_distance" */
export type Fr_Rental_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Fr_Rental_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Fr_Rental_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float8_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  listing?: InputMaybe<Fr_Cma_Rental_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  net_rent_per_sqm?: InputMaybe<Float8_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Rental_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Fr_Rental_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "rental_cma_listings_distance". */
export type Fr_Rental_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  listing?: InputMaybe<Fr_Cma_Rental_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  net_rent_per_sqm?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_cma_listings_distance" */
export enum Fr_Rental_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  NetRentPerSqm = 'net_rent_per_sqm',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Fr_Rental_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Fr_Rental_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Fr_Rental_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Fr_Rental_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Fr_Rental_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Fr_Rental_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Fr_Rental_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "states" */
export type Fr_States = {
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "states". All fields are combined with a logical 'AND'. */
export type Fr_States_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_States_Bool_Exp>>;
  _not?: InputMaybe<Fr_States_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_States_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "states". */
export type Fr_States_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "states" */
export enum Fr_States_Select_Column {
  /** column name */
  Name = 'name'
}

/** Sale price per m2 by street (route) within a municipality or locality: median, mean, 15th and 85th percentile, and total_count, the number of data points behind them. A street with a small total_count is noise: ask for at least 15. Rebuilt monthly. */
export type Fr_Street_Stats = {
  geom?: Maybe<Scalars['geometry']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  is_cross_locality?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  locality?: Maybe<Fr_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  municipality?: Maybe<Fr_Places>;
  municipality_id: Scalars['uuid']['output'];
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['uuid']['output'];
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "street_stats" */
export type Fr_Street_Stats_Aggregate = {
  aggregate?: Maybe<Fr_Street_Stats_Aggregate_Fields>;
  nodes: Array<Fr_Street_Stats>;
};

/** aggregate fields of "street_stats" */
export type Fr_Street_Stats_Aggregate_Fields = {
  avg?: Maybe<Fr_Street_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Fr_Street_Stats_Max_Fields>;
  min?: Maybe<Fr_Street_Stats_Min_Fields>;
  stddev?: Maybe<Fr_Street_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Fr_Street_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Fr_Street_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Fr_Street_Stats_Sum_Fields>;
  var_pop?: Maybe<Fr_Street_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Fr_Street_Stats_Var_Samp_Fields>;
  variance?: Maybe<Fr_Street_Stats_Variance_Fields>;
};


/** aggregate fields of "street_stats" */
export type Fr_Street_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "street_stats" */
export type Fr_Street_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Fr_Street_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fr_Street_Stats_Max_Order_By>;
  min?: InputMaybe<Fr_Street_Stats_Min_Order_By>;
  stddev?: InputMaybe<Fr_Street_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Fr_Street_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Fr_Street_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Fr_Street_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Fr_Street_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Fr_Street_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Fr_Street_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Fr_Street_Stats_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "street_stats" */
export type Fr_Street_Stats_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "street_stats". All fields are combined with a logical 'AND'. */
export type Fr_Street_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Fr_Street_Stats_Bool_Exp>>;
  _not?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Fr_Street_Stats_Bool_Exp>>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  is_cross_locality?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  locality?: InputMaybe<Fr_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  mean_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  median_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  municipality?: InputMaybe<Fr_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  num_street_numbers?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_count?: InputMaybe<Int_Comparison_Exp>;
  upper_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fr_Street_Stats_Max_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "street_stats" */
export type Fr_Street_Stats_Max_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fr_Street_Stats_Min_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "street_stats" */
export type Fr_Street_Stats_Min_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "street_stats". */
export type Fr_Street_Stats_Order_By = {
  geom?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  is_cross_locality?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Fr_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Fr_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** select columns of table "street_stats" */
export enum Fr_Street_Stats_Select_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  IsCrossLocality = 'is_cross_locality',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  Lower_15PercentilePricePerM2 = 'lower_15_percentile_price_per_m2',
  /** column name */
  MeanPricePerM2 = 'mean_price_per_m2',
  /** column name */
  MedianPricePerM2 = 'median_price_per_m2',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NumStreetNumbers = 'num_street_numbers',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  Upper_15PercentilePricePerM2 = 'upper_15_percentile_price_per_m2'
}

/** aggregate stddev on columns */
export type Fr_Street_Stats_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "street_stats" */
export type Fr_Street_Stats_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Fr_Street_Stats_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "street_stats" */
export type Fr_Street_Stats_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Fr_Street_Stats_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "street_stats" */
export type Fr_Street_Stats_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Fr_Street_Stats_Sum_Fields = {
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "street_stats" */
export type Fr_Street_Stats_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Fr_Street_Stats_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "street_stats" */
export type Fr_Street_Stats_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Fr_Street_Stats_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "street_stats" */
export type Fr_Street_Stats_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Fr_Street_Stats_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "street_stats" */
export type Fr_Street_Stats_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

export type Fsbo_Seller_Cluster_Args = {
  p_lot_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Row type of fsbo_seller_cluster(); never populated. */
export type Fsbo_Seller_Cluster_Result = {
  accounts: Scalars['jsonb']['output'];
  blocked_accounts: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  lot_id: Scalars['uuid']['output'];
  network_owner?: Maybe<Scalars['String']['output']>;
  other_accounts: Scalars['Int']['output'];
  rejected_accounts: Scalars['Int']['output'];
  tenant_id: Scalars['uuid']['output'];
  value: Scalars['String']['output'];
};


/** Row type of fsbo_seller_cluster(); never populated. */
export type Fsbo_Seller_Cluster_ResultAccountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "fsbo_seller_cluster_result". All fields are combined with a logical 'AND'. */
export type Fsbo_Seller_Cluster_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Bool_Exp>>;
  _not?: InputMaybe<Fsbo_Seller_Cluster_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Bool_Exp>>;
  accounts?: InputMaybe<Jsonb_Comparison_Exp>;
  blocked_accounts?: InputMaybe<Int_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  network_owner?: InputMaybe<String_Comparison_Exp>;
  other_accounts?: InputMaybe<Int_Comparison_Exp>;
  rejected_accounts?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "fsbo_seller_cluster_result". */
export type Fsbo_Seller_Cluster_Result_Order_By = {
  accounts?: InputMaybe<Order_By>;
  blocked_accounts?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  network_owner?: InputMaybe<Order_By>;
  other_accounts?: InputMaybe<Order_By>;
  rejected_accounts?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "fsbo_seller_cluster_result" */
export enum Fsbo_Seller_Cluster_Result_Select_Column {
  /** column name */
  Accounts = 'accounts',
  /** column name */
  BlockedAccounts = 'blocked_accounts',
  /** column name */
  Kind = 'kind',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NetworkOwner = 'network_owner',
  /** column name */
  OtherAccounts = 'other_accounts',
  /** column name */
  RejectedAccounts = 'rejected_accounts',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "fsbo_seller_cluster_result" */
export type Fsbo_Seller_Cluster_Result_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fsbo_Seller_Cluster_Result_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fsbo_Seller_Cluster_Result_Stream_Cursor_Value_Input = {
  accounts?: InputMaybe<Scalars['jsonb']['input']>;
  blocked_accounts?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  network_owner?: InputMaybe<Scalars['String']['input']>;
  other_accounts?: InputMaybe<Scalars['Int']['input']>;
  rejected_accounts?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Geography_Cast_Exp = {
  geometry?: InputMaybe<Geometry_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geography". All fields are combined with logical 'AND'. */
export type Geography_Comparison_Exp = {
  _cast?: InputMaybe<Geography_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geography']['input']>;
  _gt?: InputMaybe<Scalars['geography']['input']>;
  _gte?: InputMaybe<Scalars['geography']['input']>;
  _in?: InputMaybe<Array<Scalars['geography']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geography']['input']>;
  _lte?: InputMaybe<Scalars['geography']['input']>;
  _neq?: InputMaybe<Scalars['geography']['input']>;
  _nin?: InputMaybe<Array<Scalars['geography']['input']>>;
  /** is the column within a given distance from the given geography value */
  _st_d_within?: InputMaybe<St_D_Within_Geography_Input>;
  /** does the column spatially intersect the given geography value */
  _st_intersects?: InputMaybe<Scalars['geography']['input']>;
};

export type Geometry_Cast_Exp = {
  geography?: InputMaybe<Geography_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "geometry". All fields are combined with logical 'AND'. */
export type Geometry_Comparison_Exp = {
  _cast?: InputMaybe<Geometry_Cast_Exp>;
  _eq?: InputMaybe<Scalars['geometry']['input']>;
  _gt?: InputMaybe<Scalars['geometry']['input']>;
  _gte?: InputMaybe<Scalars['geometry']['input']>;
  _in?: InputMaybe<Array<Scalars['geometry']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['geometry']['input']>;
  _lte?: InputMaybe<Scalars['geometry']['input']>;
  _neq?: InputMaybe<Scalars['geometry']['input']>;
  _nin?: InputMaybe<Array<Scalars['geometry']['input']>>;
  /** is the column within a given 3D distance from the given geometry value */
  _st_3d_d_within?: InputMaybe<St_D_Within_Input>;
  /** does the column spatially intersect the given geometry value in 3D */
  _st_3d_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column contain the given geometry value */
  _st_contains?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column cross the given geometry value */
  _st_crosses?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column within a given distance from the given geometry value */
  _st_d_within?: InputMaybe<St_D_Within_Input>;
  /** is the column equal to given geometry value (directionality is ignored) */
  _st_equals?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column spatially intersect the given geometry value */
  _st_intersects?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column 'spatially overlap' (intersect but not completely contain) the given geometry value */
  _st_overlaps?: InputMaybe<Scalars['geometry']['input']>;
  /** does the column have atleast one point in common with the given geometry value */
  _st_touches?: InputMaybe<Scalars['geometry']['input']>;
  /** is the column contained in the given geometry value */
  _st_within?: InputMaybe<Scalars['geometry']['input']>;
};

export type Get_Activities_Feed_For_Lead_Args = {
  p_lead_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Activities_Feed_For_Lot_Args = {
  p_lot_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Activities_Feed_For_User_Args = {
  p_after_date?: InputMaybe<Scalars['timestamptz']['input']>;
  p_overdue?: InputMaybe<Scalars['Boolean']['input']>;
  p_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Agents_Ranking_Args = {
  agent_ids?: InputMaybe<Scalars['_uuid']['input']>;
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lng?: InputMaybe<Scalars['float8']['input']>;
  location_uuid?: InputMaybe<Scalars['uuid']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['String']['input']>;
  tenant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Agents_Ranking_Deduped_Args = {
  agent_ids?: InputMaybe<Scalars['_uuid']['input']>;
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lng?: InputMaybe<Scalars['float8']['input']>;
  location_uuid?: InputMaybe<Scalars['uuid']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['String']['input']>;
  tenant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Appraisals_By_Slug_Args = {
  place_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Buy_Rent_Listings_Args = {
  p_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Catchment_Area_Args = {
  target_population?: InputMaybe<Scalars['Int']['input']>;
  x?: InputMaybe<Scalars['float8']['input']>;
  y?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Cma_Agent_Transactions_Args = {
  p_cma_report_id?: InputMaybe<Scalars['uuid']['input']>;
  p_limit?: InputMaybe<Scalars['Int']['input']>;
  p_offset?: InputMaybe<Scalars['Int']['input']>;
  p_sorting_mode?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Cma_Listings_By_Radius_Args = {
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _radius_meters?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Cma_Listings_Distance_Args = {
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _listing_ids?: InputMaybe<Scalars['jsonb']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _locality?: InputMaybe<Scalars['String']['input']>;
  _postcode?: InputMaybe<Scalars['String']['input']>;
  _state_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_External_Transactions_Distance_Args = {
  _bbox_max_lat?: InputMaybe<Scalars['Float']['input']>;
  _bbox_max_lng?: InputMaybe<Scalars['Float']['input']>;
  _bbox_min_lat?: InputMaybe<Scalars['Float']['input']>;
  _bbox_min_lng?: InputMaybe<Scalars['Float']['input']>;
  _cutoff_date?: InputMaybe<Scalars['date']['input']>;
  _cutoff_date_max?: InputMaybe<Scalars['date']['input']>;
  _land_surface_max?: InputMaybe<Scalars['Float']['input']>;
  _land_surface_min?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _living_surface_max?: InputMaybe<Scalars['Float']['input']>;
  _living_surface_min?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _max_distance_meters?: InputMaybe<Scalars['Float']['input']>;
  _max_results?: InputMaybe<Scalars['Int']['input']>;
  _polygon_geojson?: InputMaybe<Scalars['String']['input']>;
  _postcode?: InputMaybe<Scalars['String']['input']>;
  _price_max?: InputMaybe<Scalars['Int']['input']>;
  _price_min?: InputMaybe<Scalars['Int']['input']>;
  _property_main_type?: InputMaybe<Scalars['_text']['input']>;
  _rooms_max?: InputMaybe<Scalars['Int']['input']>;
  _rooms_min?: InputMaybe<Scalars['Int']['input']>;
  _sort_direction?: InputMaybe<Scalars['String']['input']>;
  _sort_field?: InputMaybe<Scalars['String']['input']>;
  _source?: InputMaybe<Scalars['_text']['input']>;
};

export type Get_House_Appt_Price_Stats_Args = {
  p_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Listings_Stats_Args = {
  numberofrooms?: InputMaybe<Scalars['Int']['input']>;
  placeid?: InputMaybe<Scalars['uuid']['input']>;
  propertymaintype?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Listings_Stats_By_Place_Slug_Args = {
  p_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Local_Activity_Feed_Args = {
  current_team_id?: InputMaybe<Scalars['uuid']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lng?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  radius_km?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Lot_Publication_History_Args = {
  p_lot_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Map_Place_Stats_Args = {
  p_slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Marketplace_Similar_Online_Listings_Args = {
  _computed_surface?: InputMaybe<Scalars['Float']['input']>;
  _extra_params?: InputMaybe<Scalars['jsonb']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _offer_price?: InputMaybe<Scalars['Float']['input']>;
  _offer_type?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Merged_Listings_Args = {
  listings_ids?: InputMaybe<Scalars['String']['input']>;
  show_hidden_listings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Get_Nearby_Appraisals_Args = {
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lon?: InputMaybe<Scalars['float8']['input']>;
  municipality_uuid?: InputMaybe<Scalars['uuid']['input']>;
  radius_meters?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Nearby_Reviews_Args = {
  p_lat?: InputMaybe<Scalars['Float']['input']>;
  p_limit?: InputMaybe<Scalars['Int']['input']>;
  p_lng?: InputMaybe<Scalars['Float']['input']>;
  p_max_distance?: InputMaybe<Scalars['Float']['input']>;
  p_offset?: InputMaybe<Scalars['Int']['input']>;
  p_tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Nearby_Transactions_Args = {
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lon?: InputMaybe<Scalars['float8']['input']>;
  municipality_uuid?: InputMaybe<Scalars['uuid']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  radius_meters?: InputMaybe<Scalars['float8']['input']>;
  today_date?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type Get_Online_Listing_Map_Data_Args = {
  _id?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Place_By_Slug_Args = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Property_Transactions_Distance_Args = {
  p_country_code?: InputMaybe<Scalars['String']['input']>;
  p_match_main_type?: InputMaybe<Scalars['Boolean']['input']>;
  p_max_distance_meters?: InputMaybe<Scalars['float8']['input']>;
  p_max_results?: InputMaybe<Scalars['Int']['input']>;
  p_max_signature_date?: InputMaybe<Scalars['date']['input']>;
  p_target_property_id?: InputMaybe<Scalars['uuid']['input']>;
  p_years_back?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Rental_Cma_Listings_Distance_Args = {
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _state_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Reviews_In_Location_Args = {
  p_geom?: InputMaybe<Scalars['geometry']['input']>;
  p_limit?: InputMaybe<Scalars['Int']['input']>;
  p_tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Get_Similar_Listings_Args = {
  _built_surface?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _living_surface?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _property_main_type?: InputMaybe<Scalars['String']['input']>;
  _sale_price?: InputMaybe<Scalars['Float']['input']>;
  _usable_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Similar_Listings_Cohorts_Args = {
  _built_surface?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_scale?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_weight?: InputMaybe<Scalars['Float']['input']>;
  _geog_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _geog_scale?: InputMaybe<Scalars['Float']['input']>;
  _geog_weight?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _living_surface?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _number_of_rooms_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_scale?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_weight?: InputMaybe<Scalars['Float']['input']>;
  _online_ratio?: InputMaybe<Scalars['Float']['input']>;
  _price_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _price_scale?: InputMaybe<Scalars['Float']['input']>;
  _price_weight?: InputMaybe<Scalars['Float']['input']>;
  _property_main_type?: InputMaybe<Scalars['String']['input']>;
  _sale_price?: InputMaybe<Scalars['Float']['input']>;
  _usable_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Similar_Listings_Vector_Args = {
  _built_surface?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_scale?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_weight?: InputMaybe<Scalars['Float']['input']>;
  _geog_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _geog_scale?: InputMaybe<Scalars['Float']['input']>;
  _geog_weight?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _living_surface?: InputMaybe<Scalars['Float']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _number_of_rooms_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_scale?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_weight?: InputMaybe<Scalars['Float']['input']>;
  _online_ratio?: InputMaybe<Scalars['Float']['input']>;
  _price_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _price_scale?: InputMaybe<Scalars['Float']['input']>;
  _price_weight?: InputMaybe<Scalars['Float']['input']>;
  _property_main_type?: InputMaybe<Scalars['String']['input']>;
  _sale_price?: InputMaybe<Scalars['Float']['input']>;
  _usable_surface?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Similar_Online_Listings_Args = {
  _computed_surface?: InputMaybe<Scalars['Float']['input']>;
  _extra_params?: InputMaybe<Scalars['jsonb']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _offer_price?: InputMaybe<Scalars['Float']['input']>;
  _offer_type?: InputMaybe<Scalars['String']['input']>;
};

export type Get_Similar_Online_Listings_Ids_Args = {
  _id?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Similar_Online_Listings_Vector_Args = {
  _computed_surface?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_scale?: InputMaybe<Scalars['Float']['input']>;
  _computed_surface_weight?: InputMaybe<Scalars['Float']['input']>;
  _geog_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _geog_scale?: InputMaybe<Scalars['Float']['input']>;
  _geog_weight?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  _number_of_rooms_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_scale?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms_weight?: InputMaybe<Scalars['Float']['input']>;
  _offer_price?: InputMaybe<Scalars['Float']['input']>;
  _offer_type?: InputMaybe<Scalars['String']['input']>;
  _price_percent_limit?: InputMaybe<Scalars['Float']['input']>;
  _price_scale?: InputMaybe<Scalars['Float']['input']>;
  _price_weight?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Similar_Rental_Listings_Cohorts_Args = {
  _computed_surface?: InputMaybe<Scalars['Float']['input']>;
  _lat?: InputMaybe<Scalars['Float']['input']>;
  _limit?: InputMaybe<Scalars['Int']['input']>;
  _lng?: InputMaybe<Scalars['Float']['input']>;
  _number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  _property_main_type?: InputMaybe<Scalars['String']['input']>;
  _rent_net_monthly?: InputMaybe<Scalars['Float']['input']>;
};

export type Get_Teams_Ranking_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  location_lat?: InputMaybe<Scalars['float8']['input']>;
  location_lng?: InputMaybe<Scalars['float8']['input']>;
  location_uuid?: InputMaybe<Scalars['uuid']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['String']['input']>;
  tenant_uuid?: InputMaybe<Scalars['uuid']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export type Get_Teams_Ranking_By_Distance_Args = {
  current_team_id?: InputMaybe<Scalars['uuid']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
};

export type Get_Translated_Enum_Args = {
  enum_table_name?: InputMaybe<Scalars['String']['input']>;
};

export type Global_Statistics_Args = {
  filters?: InputMaybe<Scalars['json']['input']>;
};

/** Shape of the rows the function global_statistics returns, one per period (date = start of the day, week, month, quarter or year named by groupBy, which is required): the seller side (leads, calls, visits, mandates) and the buyer side (enquiries, buyer leads, calls, visits, offers, transactions, commission). The table itself holds no row: call the function with a filters json such as date_gte, date_lt and groupBy. */
export type Global_Stats = {
  buyers_agent_share?: Maybe<Scalars['float8']['output']>;
  buyers_call_attempts?: Maybe<Scalars['Int']['output']>;
  buyers_call_attempts_missed?: Maybe<Scalars['Int']['output']>;
  buyers_call_attempts_successful?: Maybe<Scalars['Int']['output']>;
  buyers_gross_commission?: Maybe<Scalars['float8']['output']>;
  buyers_new_buyer_leads?: Maybe<Scalars['Int']['output']>;
  buyers_new_enquiries?: Maybe<Scalars['Int']['output']>;
  buyers_offers_accepted?: Maybe<Scalars['Int']['output']>;
  buyers_offers_made?: Maybe<Scalars['Int']['output']>;
  buyers_offers_refused?: Maybe<Scalars['Int']['output']>;
  buyers_own_share?: Maybe<Scalars['float8']['output']>;
  buyers_property_searches_created?: Maybe<Scalars['Int']['output']>;
  buyers_realadvisor_share?: Maybe<Scalars['float8']['output']>;
  buyers_transactions_closed?: Maybe<Scalars['Int']['output']>;
  buyers_transactions_closed_rent?: Maybe<Scalars['Int']['output']>;
  buyers_transactions_closed_sale?: Maybe<Scalars['Int']['output']>;
  buyers_transactions_volume?: Maybe<Scalars['float8']['output']>;
  buyers_visits_booked?: Maybe<Scalars['Int']['output']>;
  buyers_visits_completed?: Maybe<Scalars['Int']['output']>;
  buyers_visits_planned?: Maybe<Scalars['Int']['output']>;
  date: Scalars['date']['output'];
  sellers_assigned_leads?: Maybe<Scalars['Int']['output']>;
  sellers_call_attempts?: Maybe<Scalars['Int']['output']>;
  sellers_call_attempts_missed?: Maybe<Scalars['Int']['output']>;
  sellers_call_attempts_successful?: Maybe<Scalars['Int']['output']>;
  sellers_claimed_leads?: Maybe<Scalars['Int']['output']>;
  sellers_mandates_published?: Maybe<Scalars['Int']['output']>;
  sellers_mandates_signed?: Maybe<Scalars['Int']['output']>;
  sellers_rent_mandates_signed?: Maybe<Scalars['Int']['output']>;
  sellers_rent_mandates_signed_broker?: Maybe<Scalars['Int']['output']>;
  sellers_rent_mandates_signed_realadvisor?: Maybe<Scalars['Int']['output']>;
  sellers_sale_mandates_signed?: Maybe<Scalars['Int']['output']>;
  sellers_sale_mandates_signed_broker?: Maybe<Scalars['Int']['output']>;
  sellers_sale_mandates_signed_realadvisor?: Maybe<Scalars['Int']['output']>;
  sellers_seller_leads?: Maybe<Scalars['Int']['output']>;
  sellers_seller_leads_months?: Maybe<Scalars['Int']['output']>;
  sellers_total_leads?: Maybe<Scalars['Int']['output']>;
  sellers_total_requalified?: Maybe<Scalars['Int']['output']>;
  sellers_visits_booked?: Maybe<Scalars['Int']['output']>;
  sellers_visits_completed?: Maybe<Scalars['Int']['output']>;
  sellers_visits_planned?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "global_stats". All fields are combined with a logical 'AND'. */
export type Global_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Global_Stats_Bool_Exp>>;
  _not?: InputMaybe<Global_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Global_Stats_Bool_Exp>>;
  buyers_agent_share?: InputMaybe<Float8_Comparison_Exp>;
  buyers_call_attempts?: InputMaybe<Int_Comparison_Exp>;
  buyers_call_attempts_missed?: InputMaybe<Int_Comparison_Exp>;
  buyers_call_attempts_successful?: InputMaybe<Int_Comparison_Exp>;
  buyers_gross_commission?: InputMaybe<Float8_Comparison_Exp>;
  buyers_new_buyer_leads?: InputMaybe<Int_Comparison_Exp>;
  buyers_new_enquiries?: InputMaybe<Int_Comparison_Exp>;
  buyers_offers_accepted?: InputMaybe<Int_Comparison_Exp>;
  buyers_offers_made?: InputMaybe<Int_Comparison_Exp>;
  buyers_offers_refused?: InputMaybe<Int_Comparison_Exp>;
  buyers_own_share?: InputMaybe<Float8_Comparison_Exp>;
  buyers_property_searches_created?: InputMaybe<Int_Comparison_Exp>;
  buyers_realadvisor_share?: InputMaybe<Float8_Comparison_Exp>;
  buyers_transactions_closed?: InputMaybe<Int_Comparison_Exp>;
  buyers_transactions_closed_rent?: InputMaybe<Int_Comparison_Exp>;
  buyers_transactions_closed_sale?: InputMaybe<Int_Comparison_Exp>;
  buyers_transactions_volume?: InputMaybe<Float8_Comparison_Exp>;
  buyers_visits_booked?: InputMaybe<Int_Comparison_Exp>;
  buyers_visits_completed?: InputMaybe<Int_Comparison_Exp>;
  buyers_visits_planned?: InputMaybe<Int_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  sellers_assigned_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_call_attempts?: InputMaybe<Int_Comparison_Exp>;
  sellers_call_attempts_missed?: InputMaybe<Int_Comparison_Exp>;
  sellers_call_attempts_successful?: InputMaybe<Int_Comparison_Exp>;
  sellers_claimed_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_mandates_published?: InputMaybe<Int_Comparison_Exp>;
  sellers_mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  sellers_rent_mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  sellers_rent_mandates_signed_broker?: InputMaybe<Int_Comparison_Exp>;
  sellers_rent_mandates_signed_realadvisor?: InputMaybe<Int_Comparison_Exp>;
  sellers_sale_mandates_signed?: InputMaybe<Int_Comparison_Exp>;
  sellers_sale_mandates_signed_broker?: InputMaybe<Int_Comparison_Exp>;
  sellers_sale_mandates_signed_realadvisor?: InputMaybe<Int_Comparison_Exp>;
  sellers_seller_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_seller_leads_months?: InputMaybe<Int_Comparison_Exp>;
  sellers_total_leads?: InputMaybe<Int_Comparison_Exp>;
  sellers_total_requalified?: InputMaybe<Int_Comparison_Exp>;
  sellers_visits_booked?: InputMaybe<Int_Comparison_Exp>;
  sellers_visits_completed?: InputMaybe<Int_Comparison_Exp>;
  sellers_visits_planned?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "global_stats". */
export type Global_Stats_Order_By = {
  buyers_agent_share?: InputMaybe<Order_By>;
  buyers_call_attempts?: InputMaybe<Order_By>;
  buyers_call_attempts_missed?: InputMaybe<Order_By>;
  buyers_call_attempts_successful?: InputMaybe<Order_By>;
  buyers_gross_commission?: InputMaybe<Order_By>;
  buyers_new_buyer_leads?: InputMaybe<Order_By>;
  buyers_new_enquiries?: InputMaybe<Order_By>;
  buyers_offers_accepted?: InputMaybe<Order_By>;
  buyers_offers_made?: InputMaybe<Order_By>;
  buyers_offers_refused?: InputMaybe<Order_By>;
  buyers_own_share?: InputMaybe<Order_By>;
  buyers_property_searches_created?: InputMaybe<Order_By>;
  buyers_realadvisor_share?: InputMaybe<Order_By>;
  buyers_transactions_closed?: InputMaybe<Order_By>;
  buyers_transactions_closed_rent?: InputMaybe<Order_By>;
  buyers_transactions_closed_sale?: InputMaybe<Order_By>;
  buyers_transactions_volume?: InputMaybe<Order_By>;
  buyers_visits_booked?: InputMaybe<Order_By>;
  buyers_visits_completed?: InputMaybe<Order_By>;
  buyers_visits_planned?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  sellers_assigned_leads?: InputMaybe<Order_By>;
  sellers_call_attempts?: InputMaybe<Order_By>;
  sellers_call_attempts_missed?: InputMaybe<Order_By>;
  sellers_call_attempts_successful?: InputMaybe<Order_By>;
  sellers_claimed_leads?: InputMaybe<Order_By>;
  sellers_mandates_published?: InputMaybe<Order_By>;
  sellers_mandates_signed?: InputMaybe<Order_By>;
  sellers_rent_mandates_signed?: InputMaybe<Order_By>;
  sellers_rent_mandates_signed_broker?: InputMaybe<Order_By>;
  sellers_rent_mandates_signed_realadvisor?: InputMaybe<Order_By>;
  sellers_sale_mandates_signed?: InputMaybe<Order_By>;
  sellers_sale_mandates_signed_broker?: InputMaybe<Order_By>;
  sellers_sale_mandates_signed_realadvisor?: InputMaybe<Order_By>;
  sellers_seller_leads?: InputMaybe<Order_By>;
  sellers_seller_leads_months?: InputMaybe<Order_By>;
  sellers_total_leads?: InputMaybe<Order_By>;
  sellers_total_requalified?: InputMaybe<Order_By>;
  sellers_visits_booked?: InputMaybe<Order_By>;
  sellers_visits_completed?: InputMaybe<Order_By>;
  sellers_visits_planned?: InputMaybe<Order_By>;
};

/** select columns of table "global_stats" */
export enum Global_Stats_Select_Column {
  /** column name */
  BuyersAgentShare = 'buyers_agent_share',
  /** column name */
  BuyersCallAttempts = 'buyers_call_attempts',
  /** column name */
  BuyersCallAttemptsMissed = 'buyers_call_attempts_missed',
  /** column name */
  BuyersCallAttemptsSuccessful = 'buyers_call_attempts_successful',
  /** column name */
  BuyersGrossCommission = 'buyers_gross_commission',
  /** column name */
  BuyersNewBuyerLeads = 'buyers_new_buyer_leads',
  /** column name */
  BuyersNewEnquiries = 'buyers_new_enquiries',
  /** column name */
  BuyersOffersAccepted = 'buyers_offers_accepted',
  /** column name */
  BuyersOffersMade = 'buyers_offers_made',
  /** column name */
  BuyersOffersRefused = 'buyers_offers_refused',
  /** column name */
  BuyersOwnShare = 'buyers_own_share',
  /** column name */
  BuyersPropertySearchesCreated = 'buyers_property_searches_created',
  /** column name */
  BuyersRealadvisorShare = 'buyers_realadvisor_share',
  /** column name */
  BuyersTransactionsClosed = 'buyers_transactions_closed',
  /** column name */
  BuyersTransactionsClosedRent = 'buyers_transactions_closed_rent',
  /** column name */
  BuyersTransactionsClosedSale = 'buyers_transactions_closed_sale',
  /** column name */
  BuyersTransactionsVolume = 'buyers_transactions_volume',
  /** column name */
  BuyersVisitsBooked = 'buyers_visits_booked',
  /** column name */
  BuyersVisitsCompleted = 'buyers_visits_completed',
  /** column name */
  BuyersVisitsPlanned = 'buyers_visits_planned',
  /** column name */
  Date = 'date',
  /** column name */
  SellersAssignedLeads = 'sellers_assigned_leads',
  /** column name */
  SellersCallAttempts = 'sellers_call_attempts',
  /** column name */
  SellersCallAttemptsMissed = 'sellers_call_attempts_missed',
  /** column name */
  SellersCallAttemptsSuccessful = 'sellers_call_attempts_successful',
  /** column name */
  SellersClaimedLeads = 'sellers_claimed_leads',
  /** column name */
  SellersMandatesPublished = 'sellers_mandates_published',
  /** column name */
  SellersMandatesSigned = 'sellers_mandates_signed',
  /** column name */
  SellersRentMandatesSigned = 'sellers_rent_mandates_signed',
  /** column name */
  SellersRentMandatesSignedBroker = 'sellers_rent_mandates_signed_broker',
  /** column name */
  SellersRentMandatesSignedRealadvisor = 'sellers_rent_mandates_signed_realadvisor',
  /** column name */
  SellersSaleMandatesSigned = 'sellers_sale_mandates_signed',
  /** column name */
  SellersSaleMandatesSignedBroker = 'sellers_sale_mandates_signed_broker',
  /** column name */
  SellersSaleMandatesSignedRealadvisor = 'sellers_sale_mandates_signed_realadvisor',
  /** column name */
  SellersSellerLeads = 'sellers_seller_leads',
  /** column name */
  SellersSellerLeadsMonths = 'sellers_seller_leads_months',
  /** column name */
  SellersTotalLeads = 'sellers_total_leads',
  /** column name */
  SellersTotalRequalified = 'sellers_total_requalified',
  /** column name */
  SellersVisitsBooked = 'sellers_visits_booked',
  /** column name */
  SellersVisitsCompleted = 'sellers_visits_completed',
  /** column name */
  SellersVisitsPlanned = 'sellers_visits_planned'
}

/** Streaming cursor of the table "global_stats" */
export type Global_Stats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Global_Stats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Global_Stats_Stream_Cursor_Value_Input = {
  buyers_agent_share?: InputMaybe<Scalars['float8']['input']>;
  buyers_call_attempts?: InputMaybe<Scalars['Int']['input']>;
  buyers_call_attempts_missed?: InputMaybe<Scalars['Int']['input']>;
  buyers_call_attempts_successful?: InputMaybe<Scalars['Int']['input']>;
  buyers_gross_commission?: InputMaybe<Scalars['float8']['input']>;
  buyers_new_buyer_leads?: InputMaybe<Scalars['Int']['input']>;
  buyers_new_enquiries?: InputMaybe<Scalars['Int']['input']>;
  buyers_offers_accepted?: InputMaybe<Scalars['Int']['input']>;
  buyers_offers_made?: InputMaybe<Scalars['Int']['input']>;
  buyers_offers_refused?: InputMaybe<Scalars['Int']['input']>;
  buyers_own_share?: InputMaybe<Scalars['float8']['input']>;
  buyers_property_searches_created?: InputMaybe<Scalars['Int']['input']>;
  buyers_realadvisor_share?: InputMaybe<Scalars['float8']['input']>;
  buyers_transactions_closed?: InputMaybe<Scalars['Int']['input']>;
  buyers_transactions_closed_rent?: InputMaybe<Scalars['Int']['input']>;
  buyers_transactions_closed_sale?: InputMaybe<Scalars['Int']['input']>;
  buyers_transactions_volume?: InputMaybe<Scalars['float8']['input']>;
  buyers_visits_booked?: InputMaybe<Scalars['Int']['input']>;
  buyers_visits_completed?: InputMaybe<Scalars['Int']['input']>;
  buyers_visits_planned?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['date']['input']>;
  sellers_assigned_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_call_attempts?: InputMaybe<Scalars['Int']['input']>;
  sellers_call_attempts_missed?: InputMaybe<Scalars['Int']['input']>;
  sellers_call_attempts_successful?: InputMaybe<Scalars['Int']['input']>;
  sellers_claimed_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_mandates_published?: InputMaybe<Scalars['Int']['input']>;
  sellers_mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  sellers_rent_mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  sellers_rent_mandates_signed_broker?: InputMaybe<Scalars['Int']['input']>;
  sellers_rent_mandates_signed_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  sellers_sale_mandates_signed?: InputMaybe<Scalars['Int']['input']>;
  sellers_sale_mandates_signed_broker?: InputMaybe<Scalars['Int']['input']>;
  sellers_sale_mandates_signed_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  sellers_seller_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_seller_leads_months?: InputMaybe<Scalars['Int']['input']>;
  sellers_total_leads?: InputMaybe<Scalars['Int']['input']>;
  sellers_total_requalified?: InputMaybe<Scalars['Int']['input']>;
  sellers_visits_booked?: InputMaybe<Scalars['Int']['input']>;
  sellers_visits_completed?: InputMaybe<Scalars['Int']['input']>;
  sellers_visits_planned?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "google_addresses" */
export type Google_Addresses = {
  centroid?: Maybe<Scalars['geometry']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  properties: Array<Properties>;
};


/** columns and relationships of "google_addresses" */
export type Google_AddressesPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "google_addresses". All fields are combined with a logical 'AND'. */
export type Google_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Google_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Google_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Google_Addresses_Bool_Exp>>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  properties?: InputMaybe<Properties_Bool_Exp>;
};

/** unique or primary key constraints on table "google_addresses" */
export enum Google_Addresses_Constraint {
  /** unique or primary key constraint on columns "id" */
  GoogleAddressesPkey = 'google_addresses_pkey'
}

/** input type for inserting data into table "google_addresses" */
export type Google_Addresses_Insert_Input = {
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  place_type?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Properties_Arr_Rel_Insert_Input>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** response of any mutation on the table "google_addresses" */
export type Google_Addresses_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Google_Addresses>;
};

/** input type for inserting object relation for remote table "google_addresses" */
export type Google_Addresses_Obj_Rel_Insert_Input = {
  data: Google_Addresses_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Google_Addresses_On_Conflict>;
};

/** on_conflict condition type for table "google_addresses" */
export type Google_Addresses_On_Conflict = {
  constraint: Google_Addresses_Constraint;
  update_columns?: Array<Google_Addresses_Update_Column>;
  where?: InputMaybe<Google_Addresses_Bool_Exp>;
};

/** Ordering options when selecting data from "google_addresses". */
export type Google_Addresses_Order_By = {
  centroid?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  properties_aggregate?: InputMaybe<Properties_Aggregate_Order_By>;
};

/** select columns of table "google_addresses" */
export enum Google_Addresses_Select_Column {
  /** column name */
  Centroid = 'centroid',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** placeholder for update columns of table "google_addresses" (current role has no relevant permissions) */
export enum Google_Addresses_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Reviews imported from the Google profile of a team (team_id -> teams): rating, review_text, profile_name and google_timestamp. They name no agent. combined_reviews has them together with the reviews collected by RealAdvisor. */
export type Google_Reviews = {
  created_at: Scalars['timestamptz']['output'];
  google_place_id: Scalars['String']['output'];
  google_timestamp: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  local_guide: Scalars['Boolean']['output'];
  original_owner_answer?: Maybe<Scalars['String']['output']>;
  original_review_text?: Maybe<Scalars['String']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  owner_answer_translations: Scalars['jsonb']['output'];
  profile_image_url: Scalars['String']['output'];
  profile_name: Scalars['String']['output'];
  profile_url: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  review_text?: Maybe<Scalars['String']['output']>;
  review_url: Scalars['String']['output'];
  source_language?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  translations: Scalars['jsonb']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Reviews imported from the Google profile of a team (team_id -> teams): rating, review_text, profile_name and google_timestamp. They name no agent. combined_reviews has them together with the reviews collected by RealAdvisor. */
export type Google_ReviewsOwner_Answer_TranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Reviews imported from the Google profile of a team (team_id -> teams): rating, review_text, profile_name and google_timestamp. They name no agent. combined_reviews has them together with the reviews collected by RealAdvisor. */
export type Google_ReviewsTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "google_reviews" */
export type Google_Reviews_Aggregate = {
  aggregate?: Maybe<Google_Reviews_Aggregate_Fields>;
  nodes: Array<Google_Reviews>;
};

export type Google_Reviews_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp_Count>;
};

export type Google_Reviews_Aggregate_Bool_Exp_Bool_And = {
  arguments: Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Google_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Google_Reviews_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Google_Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Google_Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Google_Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "google_reviews" */
export type Google_Reviews_Aggregate_Fields = {
  avg?: Maybe<Google_Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Google_Reviews_Max_Fields>;
  min?: Maybe<Google_Reviews_Min_Fields>;
  stddev?: Maybe<Google_Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Google_Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Google_Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Google_Reviews_Sum_Fields>;
  var_pop?: Maybe<Google_Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Google_Reviews_Var_Samp_Fields>;
  variance?: Maybe<Google_Reviews_Variance_Fields>;
};


/** aggregate fields of "google_reviews" */
export type Google_Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "google_reviews" */
export type Google_Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Google_Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Google_Reviews_Max_Order_By>;
  min?: InputMaybe<Google_Reviews_Min_Order_By>;
  stddev?: InputMaybe<Google_Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Google_Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Google_Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Google_Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Google_Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Google_Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Google_Reviews_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Google_Reviews_Avg_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "google_reviews" */
export type Google_Reviews_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "google_reviews". All fields are combined with a logical 'AND'. */
export type Google_Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Google_Reviews_Bool_Exp>>;
  _not?: InputMaybe<Google_Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Google_Reviews_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  google_timestamp?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  local_guide?: InputMaybe<Boolean_Comparison_Exp>;
  original_owner_answer?: InputMaybe<String_Comparison_Exp>;
  original_review_text?: InputMaybe<String_Comparison_Exp>;
  owner_answer?: InputMaybe<String_Comparison_Exp>;
  owner_answer_source_language?: InputMaybe<String_Comparison_Exp>;
  owner_answer_translations?: InputMaybe<Jsonb_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  profile_name?: InputMaybe<String_Comparison_Exp>;
  profile_url?: InputMaybe<String_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_text?: InputMaybe<String_Comparison_Exp>;
  review_url?: InputMaybe<String_Comparison_Exp>;
  source_language?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Google_Reviews_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  original_owner_answer?: Maybe<Scalars['String']['output']>;
  original_review_text?: Maybe<Scalars['String']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  profile_name?: Maybe<Scalars['String']['output']>;
  profile_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "google_reviews" */
export type Google_Reviews_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  original_owner_answer?: InputMaybe<Order_By>;
  original_review_text?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  profile_name?: InputMaybe<Order_By>;
  profile_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Google_Reviews_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_timestamp?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  original_owner_answer?: Maybe<Scalars['String']['output']>;
  original_review_text?: Maybe<Scalars['String']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  profile_name?: Maybe<Scalars['String']['output']>;
  profile_url?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "google_reviews" */
export type Google_Reviews_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  original_owner_answer?: InputMaybe<Order_By>;
  original_review_text?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  profile_name?: InputMaybe<Order_By>;
  profile_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "google_reviews" */
export type Google_Reviews_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Google_Reviews>;
};

/** Ordering options when selecting data from "google_reviews". */
export type Google_Reviews_Order_By = {
  created_at?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_timestamp?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  local_guide?: InputMaybe<Order_By>;
  original_owner_answer?: InputMaybe<Order_By>;
  original_review_text?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  owner_answer_translations?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  profile_name?: InputMaybe<Order_By>;
  profile_url?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "google_reviews" */
export enum Google_Reviews_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTimestamp = 'google_timestamp',
  /** column name */
  Id = 'id',
  /** column name */
  LocalGuide = 'local_guide',
  /** column name */
  OriginalOwnerAnswer = 'original_owner_answer',
  /** column name */
  OriginalReviewText = 'original_review_text',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  OwnerAnswerSourceLanguage = 'owner_answer_source_language',
  /** column name */
  OwnerAnswerTranslations = 'owner_answer_translations',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  ProfileName = 'profile_name',
  /** column name */
  ProfileUrl = 'profile_url',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  SourceLanguage = 'source_language',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "google_reviews_aggregate_bool_exp_bool_and_arguments_columns" columns of table "google_reviews" */
export enum Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  LocalGuide = 'local_guide'
}

/** select "google_reviews_aggregate_bool_exp_bool_or_arguments_columns" columns of table "google_reviews" */
export enum Google_Reviews_Select_Column_Google_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  LocalGuide = 'local_guide'
}

/** aggregate stddev on columns */
export type Google_Reviews_Stddev_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "google_reviews" */
export type Google_Reviews_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Google_Reviews_Stddev_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "google_reviews" */
export type Google_Reviews_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Google_Reviews_Stddev_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "google_reviews" */
export type Google_Reviews_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "google_reviews" */
export type Google_Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Google_Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Google_Reviews_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  local_guide?: InputMaybe<Scalars['Boolean']['input']>;
  original_owner_answer?: InputMaybe<Scalars['String']['input']>;
  original_review_text?: InputMaybe<Scalars['String']['input']>;
  owner_answer?: InputMaybe<Scalars['String']['input']>;
  owner_answer_source_language?: InputMaybe<Scalars['String']['input']>;
  owner_answer_translations?: InputMaybe<Scalars['jsonb']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
  profile_name?: InputMaybe<Scalars['String']['input']>;
  profile_url?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  source_language?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Google_Reviews_Sum_Fields = {
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "google_reviews" */
export type Google_Reviews_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Google_Reviews_Var_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "google_reviews" */
export type Google_Reviews_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Google_Reviews_Var_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "google_reviews" */
export type Google_Reviews_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Google_Reviews_Variance_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "google_reviews" */
export type Google_Reviews_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** columns and relationships of "heating_distribution_enum" */
export type Heating_Distribution_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "heating_distribution_enum". All fields are combined with a logical 'AND'. */
export type Heating_Distribution_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Heating_Distribution_Enum_Bool_Exp>>;
  _not?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Heating_Distribution_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Heating_Distribution_Enum_Enum {
  Floor = 'floor',
  ForcedAir = 'forced_air',
  Other = 'other',
  Radiators = 'radiators',
  Stove = 'stove'
}

/** Boolean expression to compare columns of type "heating_distribution_enum_enum". All fields are combined with logical 'AND'. */
export type Heating_Distribution_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Heating_Distribution_Enum_Enum>;
  _in?: InputMaybe<Array<Heating_Distribution_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Heating_Distribution_Enum_Enum>;
  _nin?: InputMaybe<Array<Heating_Distribution_Enum_Enum>>;
};

/** Ordering options when selecting data from "heating_distribution_enum". */
export type Heating_Distribution_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "heating_distribution_enum" */
export enum Heating_Distribution_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "heating_distribution_enum" */
export type Heating_Distribution_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Heating_Distribution_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Heating_Distribution_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "heating_enum" */
export type Heating_Enum = {
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "heating_enum". All fields are combined with a logical 'AND'. */
export type Heating_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Heating_Enum_Bool_Exp>>;
  _not?: InputMaybe<Heating_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Heating_Enum_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Heating_Enum_Enum {
  Central = 'central',
  District = 'district',
  Electric = 'electric',
  Gas = 'gas',
  HeatPump = 'heat_pump',
  None = 'none',
  Oil = 'oil',
  Other = 'other',
  Pellet = 'pellet',
  Solar = 'solar',
  Wood = 'wood'
}

/** Boolean expression to compare columns of type "heating_enum_enum". All fields are combined with logical 'AND'. */
export type Heating_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Heating_Enum_Enum>;
  _in?: InputMaybe<Array<Heating_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Heating_Enum_Enum>;
  _nin?: InputMaybe<Array<Heating_Enum_Enum>>;
};

/** Ordering options when selecting data from "heating_enum". */
export type Heating_Enum_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** select columns of table "heating_enum" */
export enum Heating_Enum_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "heating_enum" */
export type Heating_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Heating_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Heating_Enum_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "images" */
export type Images = {
  ai_enhanced_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  development_images: Array<Development_Images>;
  /** An aggregate relationship */
  development_images_aggregate: Development_Images_Aggregate;
  /** An array relationship */
  developments: Array<Developments>;
  /** An aggregate relationship */
  developments_aggregate: Developments_Aggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  organisation_images: Array<Organisation_Images>;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  user_images: Array<User_Images>;
};


/** columns and relationships of "images" */
export type ImagesDevelopment_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


/** columns and relationships of "images" */
export type ImagesDevelopment_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


/** columns and relationships of "images" */
export type ImagesDevelopmentsArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


/** columns and relationships of "images" */
export type ImagesDevelopments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


/** columns and relationships of "images" */
export type ImagesOrganisation_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Images_Order_By>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


/** columns and relationships of "images" */
export type ImagesUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "images". All fields are combined with a logical 'AND'. */
export type Images_Bool_Exp = {
  _and?: InputMaybe<Array<Images_Bool_Exp>>;
  _not?: InputMaybe<Images_Bool_Exp>;
  _or?: InputMaybe<Array<Images_Bool_Exp>>;
  ai_enhanced_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  development_images?: InputMaybe<Development_Images_Bool_Exp>;
  development_images_aggregate?: InputMaybe<Development_Images_Aggregate_Bool_Exp>;
  developments?: InputMaybe<Developments_Bool_Exp>;
  developments_aggregate?: InputMaybe<Developments_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_images?: InputMaybe<Organisation_Images_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  user_images?: InputMaybe<User_Images_Bool_Exp>;
};

/** unique or primary key constraints on table "images" */
export enum Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImagesPkey = 'images_pkey'
}

/** input type for inserting data into table "images" */
export type Images_Insert_Input = {
  ai_enhanced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  development_images?: InputMaybe<Development_Images_Arr_Rel_Insert_Input>;
  developments?: InputMaybe<Developments_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  organisation_images?: InputMaybe<Organisation_Images_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  user_images?: InputMaybe<User_Images_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "images" */
export type Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Images>;
};

/** input type for inserting object relation for remote table "images" */
export type Images_Obj_Rel_Insert_Input = {
  data: Images_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Images_On_Conflict>;
};

/** on_conflict condition type for table "images" */
export type Images_On_Conflict = {
  constraint: Images_Constraint;
  update_columns?: Array<Images_Update_Column>;
  where?: InputMaybe<Images_Bool_Exp>;
};

/** Ordering options when selecting data from "images". */
export type Images_Order_By = {
  ai_enhanced_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  development_images_aggregate?: InputMaybe<Development_Images_Aggregate_Order_By>;
  developments_aggregate?: InputMaybe<Developments_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_images_aggregate?: InputMaybe<Organisation_Images_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  user_images_aggregate?: InputMaybe<User_Images_Aggregate_Order_By>;
};

/** select columns of table "images" */
export enum Images_Select_Column {
  /** column name */
  AiEnhancedAt = 'ai_enhanced_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url'
}

/** Streaming cursor of the table "images" */
export type Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Images_Stream_Cursor_Value_Input = {
  ai_enhanced_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "images" (current role has no relevant permissions) */
export enum Images_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Boolean expression to compare columns of type "inet". All fields are combined with logical 'AND'. */
export type Inet_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['inet']['input']>;
  _gt?: InputMaybe<Scalars['inet']['input']>;
  _gte?: InputMaybe<Scalars['inet']['input']>;
  _in?: InputMaybe<Array<Scalars['inet']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['inet']['input']>;
  _lte?: InputMaybe<Scalars['inet']['input']>;
  _neq?: InputMaybe<Scalars['inet']['input']>;
  _nin?: InputMaybe<Array<Scalars['inet']['input']>>;
};

/** columns and relationships of "invitations" */
export type Invitations = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  email: Scalars['citext']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  invited_by: Users;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
};

/** aggregated selection of "invitations" */
export type Invitations_Aggregate = {
  aggregate?: Maybe<Invitations_Aggregate_Fields>;
  nodes: Array<Invitations>;
};

/** aggregate fields of "invitations" */
export type Invitations_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Invitations_Max_Fields>;
  min?: Maybe<Invitations_Min_Fields>;
};


/** aggregate fields of "invitations" */
export type Invitations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invitations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "invitations". All fields are combined with a logical 'AND'. */
export type Invitations_Bool_Exp = {
  _and?: InputMaybe<Array<Invitations_Bool_Exp>>;
  _not?: InputMaybe<Invitations_Bool_Exp>;
  _or?: InputMaybe<Array<Invitations_Bool_Exp>>;
  accepted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cancelled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invited_by?: InputMaybe<Users_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "invitations" */
export enum Invitations_Constraint {
  /** unique or primary key constraint on columns "email", "organisation_id", "team_id", "tenant_id" */
  InvitationsEmailTeamIdOrganisationIdTenantIdKey = 'invitations_email_team_id_organisation_id_tenant_id_key',
  /** unique or primary key constraint on columns "id" */
  InvitationsPkey = 'invitations_pkey',
  /** unique or primary key constraint on columns "token" */
  InvitationsTokenKey = 'invitations_token_key'
}

/** input type for inserting data into table "invitations" */
export type Invitations_Insert_Input = {
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  invited_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Invitations_Max_Fields = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Invitations_Min_Fields = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  cancelled_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "invitations" */
export type Invitations_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Invitations>;
};

/** on_conflict condition type for table "invitations" */
export type Invitations_On_Conflict = {
  constraint: Invitations_Constraint;
  update_columns?: Array<Invitations_Update_Column>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};

/** Ordering options when selecting data from "invitations". */
export type Invitations_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  cancelled_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Users_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: invitations */
export type Invitations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "invitations" */
export enum Invitations_Select_Column {
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  CancelledAt = 'cancelled_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** input type for updating data in table "invitations" */
export type Invitations_Set_Input = {
  cancelled_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "invitations" */
export type Invitations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invitations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invitations_Stream_Cursor_Value_Input = {
  accepted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cancelled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "invitations" */
export enum Invitations_Update_Column {
  /** column name */
  CancelledAt = 'cancelled_at'
}

export type Invitations_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Invitations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Invitations_Bool_Exp;
};

/** Boolean expression to compare columns of type "invoice_status". All fields are combined with logical 'AND'. */
export type Invoice_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['invoice_status']['input']>;
  _gt?: InputMaybe<Scalars['invoice_status']['input']>;
  _gte?: InputMaybe<Scalars['invoice_status']['input']>;
  _in?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['invoice_status']['input']>;
  _lte?: InputMaybe<Scalars['invoice_status']['input']>;
  _neq?: InputMaybe<Scalars['invoice_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['invoice_status']['input']>>;
};

/** columns and relationships of "invoices" */
export type Invoices = {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  account_tax_ids?: Maybe<Scalars['jsonb']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  attempted?: Maybe<Scalars['Boolean']['output']>;
  auto_advance: Scalars['Boolean']['output'];
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency: Scalars['String']['output'];
  custom_fields?: Maybe<Scalars['jsonb']['output']>;
  customer: Scalars['String']['output'];
  customer_address?: Maybe<Scalars['jsonb']['output']>;
  customer_email_raw?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_shipping?: Maybe<Scalars['jsonb']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  customer_tax_ids?: Maybe<Scalars['jsonb']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Scalars['jsonb']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Scalars['jsonb']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  invoice_object?: Maybe<Scalars['jsonb']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  last_finalization_error?: Maybe<Scalars['jsonb']['output']>;
  lines?: Maybe<Scalars['jsonb']['output']>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_payment_attempt?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  paid: Scalars['Boolean']['output'];
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_settings?: Maybe<Scalars['jsonb']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status: Scalars['invoice_status']['output'];
  status_transitions?: Maybe<Scalars['jsonb']['output']>;
  stripe_id: Scalars['String']['output'];
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tenant_id: Scalars['uuid']['output'];
  threshold_reason?: Maybe<Scalars['jsonb']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  total_discount_amounts?: Maybe<Scalars['jsonb']['output']>;
  total_tax_amounts?: Maybe<Scalars['jsonb']['output']>;
  transfer_data?: Maybe<Scalars['jsonb']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  webhooks_delivered_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "invoices" */
export type InvoicesAccount_Tax_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustom_FieldsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustomer_AddressArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustomer_ShippingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesCustomer_Tax_IdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesDefault_Tax_RatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesDiscountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesInvoice_ObjectArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesLast_Finalization_ErrorArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesLinesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesPayment_SettingsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesStatus_TransitionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesThreshold_ReasonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesTotal_Discount_AmountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesTotal_Tax_AmountsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "invoices" */
export type InvoicesTransfer_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "invoices" */
export type Invoices_Aggregate = {
  aggregate?: Maybe<Invoices_Aggregate_Fields>;
  nodes: Array<Invoices>;
};

export type Invoices_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Invoices_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Invoices_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Invoices_Aggregate_Bool_Exp_Count>;
};

export type Invoices_Aggregate_Bool_Exp_Bool_And = {
  arguments: Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoices_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Invoices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Invoices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "invoices" */
export type Invoices_Aggregate_Fields = {
  avg?: Maybe<Invoices_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Invoices_Max_Fields>;
  min?: Maybe<Invoices_Min_Fields>;
  stddev?: Maybe<Invoices_Stddev_Fields>;
  stddev_pop?: Maybe<Invoices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Invoices_Stddev_Samp_Fields>;
  sum?: Maybe<Invoices_Sum_Fields>;
  var_pop?: Maybe<Invoices_Var_Pop_Fields>;
  var_samp?: Maybe<Invoices_Var_Samp_Fields>;
  variance?: Maybe<Invoices_Variance_Fields>;
};


/** aggregate fields of "invoices" */
export type Invoices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Invoices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "invoices" */
export type Invoices_Aggregate_Order_By = {
  avg?: InputMaybe<Invoices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Invoices_Max_Order_By>;
  min?: InputMaybe<Invoices_Min_Order_By>;
  stddev?: InputMaybe<Invoices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Invoices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Invoices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Invoices_Sum_Order_By>;
  var_pop?: InputMaybe<Invoices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Invoices_Var_Samp_Order_By>;
  variance?: InputMaybe<Invoices_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Invoices_Avg_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "invoices" */
export type Invoices_Avg_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "invoices". All fields are combined with a logical 'AND'. */
export type Invoices_Bool_Exp = {
  _and?: InputMaybe<Array<Invoices_Bool_Exp>>;
  _not?: InputMaybe<Invoices_Bool_Exp>;
  _or?: InputMaybe<Array<Invoices_Bool_Exp>>;
  account_country?: InputMaybe<String_Comparison_Exp>;
  account_name?: InputMaybe<String_Comparison_Exp>;
  account_tax_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  amount_due?: InputMaybe<Int_Comparison_Exp>;
  amount_paid?: InputMaybe<Int_Comparison_Exp>;
  amount_remaining?: InputMaybe<Int_Comparison_Exp>;
  application_fee_amount?: InputMaybe<Int_Comparison_Exp>;
  attempt_count?: InputMaybe<Int_Comparison_Exp>;
  attempted?: InputMaybe<Boolean_Comparison_Exp>;
  auto_advance?: InputMaybe<Boolean_Comparison_Exp>;
  billing_reason?: InputMaybe<String_Comparison_Exp>;
  charge?: InputMaybe<String_Comparison_Exp>;
  collection_method?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  custom_fields?: InputMaybe<Jsonb_Comparison_Exp>;
  customer?: InputMaybe<String_Comparison_Exp>;
  customer_address?: InputMaybe<Jsonb_Comparison_Exp>;
  customer_email_raw?: InputMaybe<String_Comparison_Exp>;
  customer_name?: InputMaybe<String_Comparison_Exp>;
  customer_phone?: InputMaybe<String_Comparison_Exp>;
  customer_shipping?: InputMaybe<Jsonb_Comparison_Exp>;
  customer_tax_exempt?: InputMaybe<String_Comparison_Exp>;
  customer_tax_ids?: InputMaybe<Jsonb_Comparison_Exp>;
  default_payment_method?: InputMaybe<String_Comparison_Exp>;
  default_source?: InputMaybe<String_Comparison_Exp>;
  default_tax_rates?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  discounts?: InputMaybe<Jsonb_Comparison_Exp>;
  due_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  ending_balance?: InputMaybe<Int_Comparison_Exp>;
  footer?: InputMaybe<String_Comparison_Exp>;
  hosted_invoice_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_object?: InputMaybe<Jsonb_Comparison_Exp>;
  invoice_pdf?: InputMaybe<String_Comparison_Exp>;
  last_finalization_error?: InputMaybe<Jsonb_Comparison_Exp>;
  lines?: InputMaybe<Jsonb_Comparison_Exp>;
  livemode?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_payment_attempt?: InputMaybe<Timestamptz_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  on_behalf_of?: InputMaybe<String_Comparison_Exp>;
  paid?: InputMaybe<Boolean_Comparison_Exp>;
  payment_intent?: InputMaybe<String_Comparison_Exp>;
  payment_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  post_payment_credit_notes_amount?: InputMaybe<Int_Comparison_Exp>;
  pre_payment_credit_notes_amount?: InputMaybe<Int_Comparison_Exp>;
  receipt_number?: InputMaybe<String_Comparison_Exp>;
  starting_balance?: InputMaybe<Int_Comparison_Exp>;
  statement_descriptor?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Invoice_Status_Comparison_Exp>;
  status_transitions?: InputMaybe<Jsonb_Comparison_Exp>;
  stripe_id?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<String_Comparison_Exp>;
  subscription_proration_date?: InputMaybe<Int_Comparison_Exp>;
  subtotal?: InputMaybe<Int_Comparison_Exp>;
  tax?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  threshold_reason?: InputMaybe<Jsonb_Comparison_Exp>;
  total?: InputMaybe<Int_Comparison_Exp>;
  total_discount_amounts?: InputMaybe<Jsonb_Comparison_Exp>;
  total_tax_amounts?: InputMaybe<Jsonb_Comparison_Exp>;
  transfer_data?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  webhooks_delivered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Invoices_Max_Fields = {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email_raw?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  next_payment_attempt?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['invoice_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  webhooks_delivered_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "invoices" */
export type Invoices_Max_Order_By = {
  account_country?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  billing_reason?: InputMaybe<Order_By>;
  charge?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email_raw?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_phone?: InputMaybe<Order_By>;
  customer_tax_exempt?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  footer?: InputMaybe<Order_By>;
  hosted_invoice_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_pdf?: InputMaybe<Order_By>;
  next_payment_attempt?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  on_behalf_of?: InputMaybe<Order_By>;
  payment_intent?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  receipt_number?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  statement_descriptor?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhooks_delivered_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Invoices_Min_Fields = {
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  billing_reason?: Maybe<Scalars['String']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email_raw?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_phone?: Maybe<Scalars['String']['output']>;
  customer_tax_exempt?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['timestamptz']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  next_payment_attempt?: Maybe<Scalars['timestamptz']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  on_behalf_of?: Maybe<Scalars['String']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  period_end?: Maybe<Scalars['timestamptz']['output']>;
  period_start?: Maybe<Scalars['timestamptz']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  receipt_number?: Maybe<Scalars['String']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['invoice_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  webhooks_delivered_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "invoices" */
export type Invoices_Min_Order_By = {
  account_country?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  billing_reason?: InputMaybe<Order_By>;
  charge?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email_raw?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_phone?: InputMaybe<Order_By>;
  customer_tax_exempt?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  footer?: InputMaybe<Order_By>;
  hosted_invoice_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_pdf?: InputMaybe<Order_By>;
  next_payment_attempt?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  on_behalf_of?: InputMaybe<Order_By>;
  payment_intent?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  receipt_number?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  statement_descriptor?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhooks_delivered_at?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "invoices". */
export type Invoices_Order_By = {
  account_country?: InputMaybe<Order_By>;
  account_name?: InputMaybe<Order_By>;
  account_tax_ids?: InputMaybe<Order_By>;
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  attempted?: InputMaybe<Order_By>;
  auto_advance?: InputMaybe<Order_By>;
  billing_reason?: InputMaybe<Order_By>;
  charge?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  custom_fields?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_address?: InputMaybe<Order_By>;
  customer_email_raw?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_phone?: InputMaybe<Order_By>;
  customer_shipping?: InputMaybe<Order_By>;
  customer_tax_exempt?: InputMaybe<Order_By>;
  customer_tax_ids?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  default_tax_rates?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  discounts?: InputMaybe<Order_By>;
  due_date?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  footer?: InputMaybe<Order_By>;
  hosted_invoice_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_object?: InputMaybe<Order_By>;
  invoice_pdf?: InputMaybe<Order_By>;
  last_finalization_error?: InputMaybe<Order_By>;
  lines?: InputMaybe<Order_By>;
  livemode?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_payment_attempt?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  on_behalf_of?: InputMaybe<Order_By>;
  paid?: InputMaybe<Order_By>;
  payment_intent?: InputMaybe<Order_By>;
  payment_settings?: InputMaybe<Order_By>;
  period_end?: InputMaybe<Order_By>;
  period_start?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  receipt_number?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  statement_descriptor?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_transitions?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  threshold_reason?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  total_discount_amounts?: InputMaybe<Order_By>;
  total_tax_amounts?: InputMaybe<Order_By>;
  transfer_data?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  webhooks_delivered_at?: InputMaybe<Order_By>;
};

/** select columns of table "invoices" */
export enum Invoices_Select_Column {
  /** column name */
  AccountCountry = 'account_country',
  /** column name */
  AccountName = 'account_name',
  /** column name */
  AccountTaxIds = 'account_tax_ids',
  /** column name */
  AmountDue = 'amount_due',
  /** column name */
  AmountPaid = 'amount_paid',
  /** column name */
  AmountRemaining = 'amount_remaining',
  /** column name */
  ApplicationFeeAmount = 'application_fee_amount',
  /** column name */
  AttemptCount = 'attempt_count',
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  BillingReason = 'billing_reason',
  /** column name */
  Charge = 'charge',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  CustomFields = 'custom_fields',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerAddress = 'customer_address',
  /** column name */
  CustomerEmailRaw = 'customer_email_raw',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerPhone = 'customer_phone',
  /** column name */
  CustomerShipping = 'customer_shipping',
  /** column name */
  CustomerTaxExempt = 'customer_tax_exempt',
  /** column name */
  CustomerTaxIds = 'customer_tax_ids',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Description = 'description',
  /** column name */
  Discounts = 'discounts',
  /** column name */
  DueDate = 'due_date',
  /** column name */
  EndingBalance = 'ending_balance',
  /** column name */
  Footer = 'footer',
  /** column name */
  HostedInvoiceUrl = 'hosted_invoice_url',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceObject = 'invoice_object',
  /** column name */
  InvoicePdf = 'invoice_pdf',
  /** column name */
  LastFinalizationError = 'last_finalization_error',
  /** column name */
  Lines = 'lines',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPaymentAttempt = 'next_payment_attempt',
  /** column name */
  Number = 'number',
  /** column name */
  OnBehalfOf = 'on_behalf_of',
  /** column name */
  Paid = 'paid',
  /** column name */
  PaymentIntent = 'payment_intent',
  /** column name */
  PaymentSettings = 'payment_settings',
  /** column name */
  PeriodEnd = 'period_end',
  /** column name */
  PeriodStart = 'period_start',
  /** column name */
  PostPaymentCreditNotesAmount = 'post_payment_credit_notes_amount',
  /** column name */
  PrePaymentCreditNotesAmount = 'pre_payment_credit_notes_amount',
  /** column name */
  ReceiptNumber = 'receipt_number',
  /** column name */
  StartingBalance = 'starting_balance',
  /** column name */
  StatementDescriptor = 'statement_descriptor',
  /** column name */
  Status = 'status',
  /** column name */
  StatusTransitions = 'status_transitions',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  Subscription = 'subscription',
  /** column name */
  SubscriptionProrationDate = 'subscription_proration_date',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Tax = 'tax',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThresholdReason = 'threshold_reason',
  /** column name */
  Total = 'total',
  /** column name */
  TotalDiscountAmounts = 'total_discount_amounts',
  /** column name */
  TotalTaxAmounts = 'total_tax_amounts',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WebhooksDeliveredAt = 'webhooks_delivered_at'
}

/** select "invoices_aggregate_bool_exp_bool_and_arguments_columns" columns of table "invoices" */
export enum Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

/** select "invoices_aggregate_bool_exp_bool_or_arguments_columns" columns of table "invoices" */
export enum Invoices_Select_Column_Invoices_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Attempted = 'attempted',
  /** column name */
  AutoAdvance = 'auto_advance',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Paid = 'paid'
}

/** aggregate stddev on columns */
export type Invoices_Stddev_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "invoices" */
export type Invoices_Stddev_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Invoices_Stddev_Pop_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "invoices" */
export type Invoices_Stddev_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Invoices_Stddev_Samp_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "invoices" */
export type Invoices_Stddev_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "invoices" */
export type Invoices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Invoices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Invoices_Stream_Cursor_Value_Input = {
  account_country?: InputMaybe<Scalars['String']['input']>;
  account_name?: InputMaybe<Scalars['String']['input']>;
  account_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  amount_due?: InputMaybe<Scalars['Int']['input']>;
  amount_paid?: InputMaybe<Scalars['Int']['input']>;
  amount_remaining?: InputMaybe<Scalars['Int']['input']>;
  application_fee_amount?: InputMaybe<Scalars['Int']['input']>;
  attempt_count?: InputMaybe<Scalars['Int']['input']>;
  attempted?: InputMaybe<Scalars['Boolean']['input']>;
  auto_advance?: InputMaybe<Scalars['Boolean']['input']>;
  billing_reason?: InputMaybe<Scalars['String']['input']>;
  charge?: InputMaybe<Scalars['String']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Scalars['jsonb']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_address?: InputMaybe<Scalars['jsonb']['input']>;
  customer_email_raw?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_phone?: InputMaybe<Scalars['String']['input']>;
  customer_shipping?: InputMaybe<Scalars['jsonb']['input']>;
  customer_tax_exempt?: InputMaybe<Scalars['String']['input']>;
  customer_tax_ids?: InputMaybe<Scalars['jsonb']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Scalars['jsonb']['input']>;
  due_date?: InputMaybe<Scalars['timestamptz']['input']>;
  ending_balance?: InputMaybe<Scalars['Int']['input']>;
  footer?: InputMaybe<Scalars['String']['input']>;
  hosted_invoice_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invoice_object?: InputMaybe<Scalars['jsonb']['input']>;
  invoice_pdf?: InputMaybe<Scalars['String']['input']>;
  last_finalization_error?: InputMaybe<Scalars['jsonb']['input']>;
  lines?: InputMaybe<Scalars['jsonb']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_payment_attempt?: InputMaybe<Scalars['timestamptz']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  on_behalf_of?: InputMaybe<Scalars['String']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_settings?: InputMaybe<Scalars['jsonb']['input']>;
  period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  post_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  pre_payment_credit_notes_amount?: InputMaybe<Scalars['Int']['input']>;
  receipt_number?: InputMaybe<Scalars['String']['input']>;
  starting_balance?: InputMaybe<Scalars['Int']['input']>;
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['invoice_status']['input']>;
  status_transitions?: InputMaybe<Scalars['jsonb']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Scalars['String']['input']>;
  subscription_proration_date?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  tax?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  threshold_reason?: InputMaybe<Scalars['jsonb']['input']>;
  total?: InputMaybe<Scalars['Int']['input']>;
  total_discount_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  total_tax_amounts?: InputMaybe<Scalars['jsonb']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  webhooks_delivered_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Invoices_Sum_Fields = {
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Int']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  subscription_proration_date?: Maybe<Scalars['Int']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "invoices" */
export type Invoices_Sum_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Invoices_Var_Pop_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "invoices" */
export type Invoices_Var_Pop_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Invoices_Var_Samp_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "invoices" */
export type Invoices_Var_Samp_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Invoices_Variance_Fields = {
  amount_due?: Maybe<Scalars['Float']['output']>;
  amount_paid?: Maybe<Scalars['Float']['output']>;
  amount_remaining?: Maybe<Scalars['Float']['output']>;
  application_fee_amount?: Maybe<Scalars['Float']['output']>;
  attempt_count?: Maybe<Scalars['Float']['output']>;
  ending_balance?: Maybe<Scalars['Float']['output']>;
  post_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  pre_payment_credit_notes_amount?: Maybe<Scalars['Float']['output']>;
  starting_balance?: Maybe<Scalars['Float']['output']>;
  subscription_proration_date?: Maybe<Scalars['Float']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "invoices" */
export type Invoices_Variance_Order_By = {
  amount_due?: InputMaybe<Order_By>;
  amount_paid?: InputMaybe<Order_By>;
  amount_remaining?: InputMaybe<Order_By>;
  application_fee_amount?: InputMaybe<Order_By>;
  attempt_count?: InputMaybe<Order_By>;
  ending_balance?: InputMaybe<Order_By>;
  post_payment_credit_notes_amount?: InputMaybe<Order_By>;
  pre_payment_credit_notes_amount?: InputMaybe<Order_By>;
  starting_balance?: InputMaybe<Order_By>;
  subscription_proration_date?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  tax?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type It_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<It_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: It_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<It_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<It_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  state?: Maybe<It_States>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type It_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type It_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type It_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use online_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type It_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type It_Cma_Listings_Aggregate = {
  aggregate?: Maybe<It_Cma_Listings_Aggregate_Fields>;
  nodes: Array<It_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type It_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<It_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Cma_Listings_Max_Fields>;
  min?: Maybe<It_Cma_Listings_Min_Fields>;
  stddev?: Maybe<It_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<It_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<It_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<It_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<It_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<It_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type It_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type It_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<It_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<It_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<It_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<It_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<It_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<It_States_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** columns and relationships of "cma_listings_distance" */
export type It_Cma_Listings_Distance = {
  distance_in_meters: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  listing?: Maybe<It_Cma_Listings>;
  listing_id: Scalars['Int']['output'];
  state_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_listings_distance" */
export type It_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<It_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<It_Cma_Listings_Distance>;
};

/** aggregate fields of "cma_listings_distance" */
export type It_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<It_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<It_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<It_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<It_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<It_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<It_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<It_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<It_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "cma_listings_distance" */
export type It_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings_distance". All fields are combined with a logical 'AND'. */
export type It_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<It_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<It_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  listing?: InputMaybe<It_Cma_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type It_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "cma_listings_distance". */
export type It_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing?: InputMaybe<It_Cma_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings_distance" */
export enum It_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type It_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type It_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type It_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type It_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type It_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<It_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state?: InputMaybe<It_States_Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum It_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type It_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type It_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cma_rental_listings" */
export type It_Cma_Rental_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<It_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: It_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<It_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_rental_listings_places" */
  places?: Maybe<Array<It_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_rental_listings" */
export type It_Cma_Rental_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type It_Cma_Rental_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type It_Cma_Rental_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type It_Cma_Rental_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_rental_listings" */
export type It_Cma_Rental_Listings_Aggregate = {
  aggregate?: Maybe<It_Cma_Rental_Listings_Aggregate_Fields>;
  nodes: Array<It_Cma_Rental_Listings>;
};

/** aggregate fields of "cma_rental_listings" */
export type It_Cma_Rental_Listings_Aggregate_Fields = {
  avg?: Maybe<It_Cma_Rental_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Cma_Rental_Listings_Max_Fields>;
  min?: Maybe<It_Cma_Rental_Listings_Min_Fields>;
  stddev?: Maybe<It_Cma_Rental_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<It_Cma_Rental_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Cma_Rental_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<It_Cma_Rental_Listings_Sum_Fields>;
  var_pop?: Maybe<It_Cma_Rental_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<It_Cma_Rental_Listings_Var_Samp_Fields>;
  variance?: Maybe<It_Cma_Rental_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_rental_listings" */
export type It_Cma_Rental_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Cma_Rental_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Cma_Rental_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_rental_listings". All fields are combined with a logical 'AND'. */
export type It_Cma_Rental_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<It_Cma_Rental_Listings_Bool_Exp>>;
  _not?: InputMaybe<It_Cma_Rental_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<It_Cma_Rental_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<It_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<It_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Cma_Rental_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type It_Cma_Rental_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_rental_listings". */
export type It_Cma_Rental_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<It_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_rental_listings" */
export enum It_Cma_Rental_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type It_Cma_Rental_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Cma_Rental_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Cma_Rental_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Cma_Rental_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type It_Cma_Rental_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Cma_Rental_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Cma_Rental_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type It_External_Transactions = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  source_payload?: Maybe<Scalars['jsonb']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};


/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type It_External_TransactionsSource_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_transactions" */
export type It_External_Transactions_Aggregate = {
  aggregate?: Maybe<It_External_Transactions_Aggregate_Fields>;
  nodes: Array<It_External_Transactions>;
};

/** aggregate fields of "external_transactions" */
export type It_External_Transactions_Aggregate_Fields = {
  avg?: Maybe<It_External_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_External_Transactions_Max_Fields>;
  min?: Maybe<It_External_Transactions_Min_Fields>;
  stddev?: Maybe<It_External_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<It_External_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_External_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<It_External_Transactions_Sum_Fields>;
  var_pop?: Maybe<It_External_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<It_External_Transactions_Var_Samp_Fields>;
  variance?: Maybe<It_External_Transactions_Variance_Fields>;
};


/** aggregate fields of "external_transactions" */
export type It_External_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_External_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_External_Transactions_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions". All fields are combined with a logical 'AND'. */
export type It_External_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<It_External_Transactions_Bool_Exp>>;
  _not?: InputMaybe<It_External_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<It_External_Transactions_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** Rows returned by get_external_transactions_distance: a recorded sale and its distance_in_meters from the point asked. Data in France only. The table itself holds no row: call the function, with _lat and _lng always; nearest first unless _sort_field (with _sort_direction) is set. _max_distance_meters is 5 km by default and 50 km at most; pass _max_distance_meters: null to search a whole _postcode, bbox or _polygon_geojson beyond 5 km. _property_main_type, _cutoff_date and _cutoff_date_max, surfaces, rooms and price narrow further. At most 5000 rows (_max_results): a count over it stops there, so narrow the area or the dates for a large city. */
export type It_External_Transactions_Distance = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  distance_in_meters: Scalars['Float']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "external_transactions_distance" */
export type It_External_Transactions_Distance_Aggregate = {
  aggregate?: Maybe<It_External_Transactions_Distance_Aggregate_Fields>;
  nodes: Array<It_External_Transactions_Distance>;
};

/** aggregate fields of "external_transactions_distance" */
export type It_External_Transactions_Distance_Aggregate_Fields = {
  avg?: Maybe<It_External_Transactions_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_External_Transactions_Distance_Max_Fields>;
  min?: Maybe<It_External_Transactions_Distance_Min_Fields>;
  stddev?: Maybe<It_External_Transactions_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<It_External_Transactions_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_External_Transactions_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<It_External_Transactions_Distance_Sum_Fields>;
  var_pop?: Maybe<It_External_Transactions_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<It_External_Transactions_Distance_Var_Samp_Fields>;
  variance?: Maybe<It_External_Transactions_Distance_Variance_Fields>;
};


/** aggregate fields of "external_transactions_distance" */
export type It_External_Transactions_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_External_Transactions_Distance_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions_distance". All fields are combined with a logical 'AND'. */
export type It_External_Transactions_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<It_External_Transactions_Distance_Bool_Exp>>;
  _not?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<It_External_Transactions_Distance_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_External_Transactions_Distance_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type It_External_Transactions_Distance_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions_distance". */
export type It_External_Transactions_Distance_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions_distance" */
export enum It_External_Transactions_Distance_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type It_External_Transactions_Distance_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_External_Transactions_Distance_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_External_Transactions_Distance_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_External_Transactions_Distance_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type It_External_Transactions_Distance_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_External_Transactions_Distance_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_External_Transactions_Distance_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type It_External_Transactions_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type It_External_Transactions_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions". */
export type It_External_Transactions_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_payload?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions" */
export enum It_External_Transactions_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  SourcePayload = 'source_payload',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type It_External_Transactions_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_External_Transactions_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_External_Transactions_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_External_Transactions_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type It_External_Transactions_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_External_Transactions_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_External_Transactions_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type It_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type It_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type It_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<It_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<It_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type It_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum It_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type It_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type It_Merged_Images_Aggregate = {
  aggregate?: Maybe<It_Merged_Images_Aggregate_Fields>;
  nodes: Array<It_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type It_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<It_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Merged_Images_Max_Fields>;
  min?: Maybe<It_Merged_Images_Min_Fields>;
  stddev?: Maybe<It_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<It_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<It_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<It_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<It_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<It_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type It_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type It_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<It_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Merged_Images_Max_Order_By>;
  min?: InputMaybe<It_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<It_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<It_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type It_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type It_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<It_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<It_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<It_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type It_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type It_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type It_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum It_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type It_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type It_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type It_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type It_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type It_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type It_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type It_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type It_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type It_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<It_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: It_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** Hidden from the public site by an admin (per listing, together with its duplicates). It does not say whether the listing is still online: see offline_since. */
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type It_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type It_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type It_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "merged_listings" */
export type It_Merged_Listings_Aggregate = {
  aggregate?: Maybe<It_Merged_Listings_Aggregate_Fields>;
  nodes: Array<It_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type It_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<It_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Merged_Listings_Max_Fields>;
  min?: Maybe<It_Merged_Listings_Min_Fields>;
  stddev?: Maybe<It_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<It_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<It_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<It_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<It_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<It_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type It_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type It_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<It_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<It_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<It_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type It_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type It_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum It_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type It_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type It_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<It_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: It_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<It_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<It_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<It_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: It_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<It_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: It_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_stats: Array<It_Price_Stats>;
  /** An aggregate relationship */
  price_stats_aggregate: It_Price_Stats_Aggregate;
  /** An array relationship */
  price_stats_historical: Array<It_Price_Stats_Historical>;
  /** An aggregate relationship */
  price_stats_historical_aggregate: It_Price_Stats_Historical_Aggregate;
  /** An array relationship */
  region: Array<It_Places>;
  /** An aggregate relationship */
  region_aggregate: It_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<It_Places>;
  /** An aggregate relationship */
  state_aggregate: It_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<It_Places>;
  /** An aggregate relationship */
  state_places_aggregate: It_Places_Aggregate;
  /** An array relationship */
  street_stats_locality: Array<It_Street_Stats>;
  /** An aggregate relationship */
  street_stats_locality_aggregate: It_Street_Stats_Aggregate;
  /** An array relationship */
  street_stats_municipality: Array<It_Street_Stats>;
  /** An aggregate relationship */
  street_stats_municipality_aggregate: It_Street_Stats_Aggregate;
  type: Scalars['String']['output'];
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesPrice_StatsArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesPrice_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesPrice_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesPrice_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesStreet_Stats_LocalityArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesStreet_Stats_Locality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesStreet_Stats_MunicipalityArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type It_PlacesStreet_Stats_Municipality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};

/** aggregated selection of "places" */
export type It_Places_Aggregate = {
  aggregate?: Maybe<It_Places_Aggregate_Fields>;
  nodes: Array<It_Places>;
};

/** aggregate fields of "places" */
export type It_Places_Aggregate_Fields = {
  avg?: Maybe<It_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Places_Max_Fields>;
  min?: Maybe<It_Places_Min_Fields>;
  stddev?: Maybe<It_Places_Stddev_Fields>;
  stddev_pop?: Maybe<It_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Places_Stddev_Samp_Fields>;
  sum?: Maybe<It_Places_Sum_Fields>;
  var_pop?: Maybe<It_Places_Var_Pop_Fields>;
  var_samp?: Maybe<It_Places_Var_Samp_Fields>;
  variance?: Maybe<It_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type It_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type It_Places_Aggregate_Order_By = {
  avg?: InputMaybe<It_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Places_Max_Order_By>;
  min?: InputMaybe<It_Places_Min_Order_By>;
  stddev?: InputMaybe<It_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Places_Sum_Order_By>;
  var_pop?: InputMaybe<It_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type It_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type It_Places_Bool_Exp = {
  _and?: InputMaybe<Array<It_Places_Bool_Exp>>;
  _not?: InputMaybe<It_Places_Bool_Exp>;
  _or?: InputMaybe<Array<It_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<It_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<It_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<It_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<It_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_stats?: InputMaybe<It_Price_Stats_Bool_Exp>;
  price_stats_historical?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
  region?: InputMaybe<It_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  slug_pl?: InputMaybe<String_Comparison_Exp>;
  slug_pt?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<It_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<It_Places_Bool_Exp>;
  street_stats_locality?: InputMaybe<It_Street_Stats_Bool_Exp>;
  street_stats_municipality?: InputMaybe<It_Street_Stats_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** For a municipality, a locality or a neighbourhood (place_id), the places it sits in (breadcrumb_place_id -> places): order_num 1 locality, 2 municipality, 3 state; the place itself and non-state aliases are left out, so a locality starts at 2. */
export type It_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<It_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<It_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<It_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<It_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<It_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<It_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<It_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<It_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<It_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<It_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<It_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<It_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<It_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<It_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<It_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type It_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<It_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<It_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<It_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type It_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<It_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum It_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type It_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type It_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type It_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type It_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type It_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type It_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<It_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<It_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<It_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_stats_aggregate?: InputMaybe<It_Price_Stats_Aggregate_Order_By>;
  price_stats_historical_aggregate?: InputMaybe<It_Price_Stats_Historical_Aggregate_Order_By>;
  region_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<It_Places_Aggregate_Order_By>;
  street_stats_locality_aggregate?: InputMaybe<It_Street_Stats_Aggregate_Order_By>;
  street_stats_municipality_aggregate?: InputMaybe<It_Street_Stats_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum It_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  SlugPl = 'slug_pl',
  /** column name */
  SlugPt = 'slug_pt',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type It_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type It_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type It_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type It_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type It_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type It_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type It_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type It_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type It_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<It_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: It_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<It_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<It_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<It_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type It_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type It_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type It_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type It_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "post_merged_listings" */
export type It_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<It_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<It_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type It_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<It_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<It_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<It_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<It_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<It_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<It_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<It_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<It_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type It_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type It_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<It_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<It_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<It_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<It_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<It_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type It_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type It_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<It_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<It_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<It_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum It_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type It_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type It_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Price estimates of a place: one row per place_id x property_main_type x number_of_rooms. number_of_rooms = 0 is all sizes; property_main_type is ANY (all types), HOUSE or APPT. sale_price_m2_50 is the modelled price per m2; _10 and _90 are that estimate scaled to a typical low and high, not percentiles of the place. monthly_rent_* is gross monthly rent, yearly_rent_m2_* yearly rent per m2. Rebuilt monthly. */
export type It_Price_Stats = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "price_stats" */
export type It_Price_Stats_Aggregate = {
  aggregate?: Maybe<It_Price_Stats_Aggregate_Fields>;
  nodes: Array<It_Price_Stats>;
};

/** aggregate fields of "price_stats" */
export type It_Price_Stats_Aggregate_Fields = {
  avg?: Maybe<It_Price_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Price_Stats_Max_Fields>;
  min?: Maybe<It_Price_Stats_Min_Fields>;
  stddev?: Maybe<It_Price_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<It_Price_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Price_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<It_Price_Stats_Sum_Fields>;
  var_pop?: Maybe<It_Price_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<It_Price_Stats_Var_Samp_Fields>;
  variance?: Maybe<It_Price_Stats_Variance_Fields>;
};


/** aggregate fields of "price_stats" */
export type It_Price_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats" */
export type It_Price_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<It_Price_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Price_Stats_Max_Order_By>;
  min?: InputMaybe<It_Price_Stats_Min_Order_By>;
  stddev?: InputMaybe<It_Price_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Price_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Price_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Price_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<It_Price_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Price_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Price_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Price_Stats_Avg_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats" */
export type It_Price_Stats_Avg_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats". All fields are combined with a logical 'AND'. */
export type It_Price_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<It_Price_Stats_Bool_Exp>>;
  _not?: InputMaybe<It_Price_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<It_Price_Stats_Bool_Exp>>;
  monthly_rent_10?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_50?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_90?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_type?: InputMaybe<Place_Type_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_count?: InputMaybe<Int_Comparison_Exp>;
  rent_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_price_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_90?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_90?: InputMaybe<Float_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  yearly_rent_m2_10?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_50?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_90?: InputMaybe<Float_Comparison_Exp>;
};

/** Modelled sale price per m2 of a place over time: one row per place_id x property_main_type x number_of_rooms x date. All property types is 'ALL' here, where price_stats says ANY; number_of_rooms = 0 is all sizes. Daily for countries, states, districts and agglomerations, monthly for municipalities and localities. Always filter place_id, property_main_type, number_of_rooms and a date range. */
export type It_Price_Stats_Historical = {
  date: Scalars['date']['output'];
  number_of_rooms: Scalars['Int']['output'];
  place_id: Scalars['uuid']['output'];
  property_main_type: Scalars['String']['output'];
  sale_price_m2: Scalars['Float']['output'];
};

/** aggregated selection of "price_stats_historical" */
export type It_Price_Stats_Historical_Aggregate = {
  aggregate?: Maybe<It_Price_Stats_Historical_Aggregate_Fields>;
  nodes: Array<It_Price_Stats_Historical>;
};

/** aggregate fields of "price_stats_historical" */
export type It_Price_Stats_Historical_Aggregate_Fields = {
  avg?: Maybe<It_Price_Stats_Historical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Price_Stats_Historical_Max_Fields>;
  min?: Maybe<It_Price_Stats_Historical_Min_Fields>;
  stddev?: Maybe<It_Price_Stats_Historical_Stddev_Fields>;
  stddev_pop?: Maybe<It_Price_Stats_Historical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Price_Stats_Historical_Stddev_Samp_Fields>;
  sum?: Maybe<It_Price_Stats_Historical_Sum_Fields>;
  var_pop?: Maybe<It_Price_Stats_Historical_Var_Pop_Fields>;
  var_samp?: Maybe<It_Price_Stats_Historical_Var_Samp_Fields>;
  variance?: Maybe<It_Price_Stats_Historical_Variance_Fields>;
};


/** aggregate fields of "price_stats_historical" */
export type It_Price_Stats_Historical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Price_Stats_Historical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_historical" */
export type It_Price_Stats_Historical_Aggregate_Order_By = {
  avg?: InputMaybe<It_Price_Stats_Historical_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Price_Stats_Historical_Max_Order_By>;
  min?: InputMaybe<It_Price_Stats_Historical_Min_Order_By>;
  stddev?: InputMaybe<It_Price_Stats_Historical_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Price_Stats_Historical_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Price_Stats_Historical_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Price_Stats_Historical_Sum_Order_By>;
  var_pop?: InputMaybe<It_Price_Stats_Historical_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Price_Stats_Historical_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Price_Stats_Historical_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Price_Stats_Historical_Avg_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Avg_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_historical". All fields are combined with a logical 'AND'. */
export type It_Price_Stats_Historical_Bool_Exp = {
  _and?: InputMaybe<Array<It_Price_Stats_Historical_Bool_Exp>>;
  _not?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
  _or?: InputMaybe<Array<It_Price_Stats_Historical_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  sale_price_m2?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Price_Stats_Historical_Max_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Price_Stats_Historical_Min_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_historical". */
export type It_Price_Stats_Historical_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_historical" */
export enum It_Price_Stats_Historical_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  SalePriceM2 = 'sale_price_m2'
}

/** aggregate stddev on columns */
export type It_Price_Stats_Historical_Stddev_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Stddev_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Price_Stats_Historical_Stddev_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Stddev_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Price_Stats_Historical_Stddev_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Stddev_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Price_Stats_Historical_Sum_Fields = {
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Sum_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Price_Stats_Historical_Var_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Var_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Price_Stats_Historical_Var_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Var_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Price_Stats_Historical_Variance_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_historical" */
export type It_Price_Stats_Historical_Variance_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type It_Price_Stats_Max_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats" */
export type It_Price_Stats_Max_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Price_Stats_Min_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats" */
export type It_Price_Stats_Min_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats". */
export type It_Price_Stats_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats" */
export enum It_Price_Stats_Select_Column {
  /** column name */
  MonthlyRent_10 = 'monthly_rent_10',
  /** column name */
  MonthlyRent_50 = 'monthly_rent_50',
  /** column name */
  MonthlyRent_90 = 'monthly_rent_90',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PlaceParentId = 'place_parent_id',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentCount = 'rent_count',
  /** column name */
  RentCount_3month = 'rent_count_3month',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleCount_3month = 'sale_count_3month',
  /** column name */
  SalePrice_10 = 'sale_price_10',
  /** column name */
  SalePrice_50 = 'sale_price_50',
  /** column name */
  SalePrice_90 = 'sale_price_90',
  /** column name */
  SalePriceM2_10 = 'sale_price_m2_10',
  /** column name */
  SalePriceM2_50 = 'sale_price_m2_50',
  /** column name */
  SalePriceM2_90 = 'sale_price_m2_90',
  /** column name */
  Stock = 'stock',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  YearlyRentM2_10 = 'yearly_rent_m2_10',
  /** column name */
  YearlyRentM2_50 = 'yearly_rent_m2_50',
  /** column name */
  YearlyRentM2_90 = 'yearly_rent_m2_90'
}

/** aggregate stddev on columns */
export type It_Price_Stats_Stddev_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats" */
export type It_Price_Stats_Stddev_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Price_Stats_Stddev_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats" */
export type It_Price_Stats_Stddev_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Price_Stats_Stddev_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats" */
export type It_Price_Stats_Stddev_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Price_Stats_Sum_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats" */
export type It_Price_Stats_Sum_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Price_Stats_Var_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats" */
export type It_Price_Stats_Var_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Price_Stats_Var_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats" */
export type It_Price_Stats_Var_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Price_Stats_Variance_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats" */
export type It_Price_Stats_Variance_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_types" */
export type It_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type It_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<It_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<It_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<It_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type It_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum It_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "rental_cma_listings_distance" */
export type It_Rental_Cma_Listings_Distance = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  is_online?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  listing?: Maybe<It_Cma_Rental_Listings>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

export type It_Rental_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<It_Rental_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<It_Rental_Cma_Listings_Distance>;
};

/** aggregate fields of "rental_cma_listings_distance" */
export type It_Rental_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<It_Rental_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Rental_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<It_Rental_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<It_Rental_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<It_Rental_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Rental_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<It_Rental_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<It_Rental_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<It_Rental_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<It_Rental_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "rental_cma_listings_distance" */
export type It_Rental_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type It_Rental_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_cma_listings_distance". All fields are combined with a logical 'AND'. */
export type It_Rental_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float8_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  listing?: InputMaybe<It_Cma_Rental_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  net_rent_per_sqm?: InputMaybe<Float8_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Rental_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type It_Rental_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "rental_cma_listings_distance". */
export type It_Rental_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  listing?: InputMaybe<It_Cma_Rental_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  net_rent_per_sqm?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_cma_listings_distance" */
export enum It_Rental_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  NetRentPerSqm = 'net_rent_per_sqm',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type It_Rental_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type It_Rental_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type It_Rental_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type It_Rental_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type It_Rental_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type It_Rental_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type It_Rental_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "states" */
export type It_States = {
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "states". All fields are combined with a logical 'AND'. */
export type It_States_Bool_Exp = {
  _and?: InputMaybe<Array<It_States_Bool_Exp>>;
  _not?: InputMaybe<It_States_Bool_Exp>;
  _or?: InputMaybe<Array<It_States_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "states". */
export type It_States_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "states" */
export enum It_States_Select_Column {
  /** column name */
  Name = 'name'
}

/** Sale price per m2 by street (route) within a municipality or locality: median, mean, 15th and 85th percentile, and total_count, the number of data points behind them. A street with a small total_count is noise: ask for at least 15. Rebuilt monthly. */
export type It_Street_Stats = {
  geom?: Maybe<Scalars['geometry']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  is_cross_locality?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  locality?: Maybe<It_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  municipality?: Maybe<It_Places>;
  municipality_id: Scalars['uuid']['output'];
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['uuid']['output'];
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "street_stats" */
export type It_Street_Stats_Aggregate = {
  aggregate?: Maybe<It_Street_Stats_Aggregate_Fields>;
  nodes: Array<It_Street_Stats>;
};

/** aggregate fields of "street_stats" */
export type It_Street_Stats_Aggregate_Fields = {
  avg?: Maybe<It_Street_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<It_Street_Stats_Max_Fields>;
  min?: Maybe<It_Street_Stats_Min_Fields>;
  stddev?: Maybe<It_Street_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<It_Street_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<It_Street_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<It_Street_Stats_Sum_Fields>;
  var_pop?: Maybe<It_Street_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<It_Street_Stats_Var_Samp_Fields>;
  variance?: Maybe<It_Street_Stats_Variance_Fields>;
};


/** aggregate fields of "street_stats" */
export type It_Street_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "street_stats" */
export type It_Street_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<It_Street_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<It_Street_Stats_Max_Order_By>;
  min?: InputMaybe<It_Street_Stats_Min_Order_By>;
  stddev?: InputMaybe<It_Street_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<It_Street_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<It_Street_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<It_Street_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<It_Street_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<It_Street_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<It_Street_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type It_Street_Stats_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "street_stats" */
export type It_Street_Stats_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "street_stats". All fields are combined with a logical 'AND'. */
export type It_Street_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<It_Street_Stats_Bool_Exp>>;
  _not?: InputMaybe<It_Street_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<It_Street_Stats_Bool_Exp>>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  is_cross_locality?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  locality?: InputMaybe<It_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  mean_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  median_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  municipality?: InputMaybe<It_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  num_street_numbers?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_count?: InputMaybe<Int_Comparison_Exp>;
  upper_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type It_Street_Stats_Max_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "street_stats" */
export type It_Street_Stats_Max_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type It_Street_Stats_Min_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "street_stats" */
export type It_Street_Stats_Min_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "street_stats". */
export type It_Street_Stats_Order_By = {
  geom?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  is_cross_locality?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<It_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality?: InputMaybe<It_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** select columns of table "street_stats" */
export enum It_Street_Stats_Select_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  IsCrossLocality = 'is_cross_locality',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  Lower_15PercentilePricePerM2 = 'lower_15_percentile_price_per_m2',
  /** column name */
  MeanPricePerM2 = 'mean_price_per_m2',
  /** column name */
  MedianPricePerM2 = 'median_price_per_m2',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NumStreetNumbers = 'num_street_numbers',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  Upper_15PercentilePricePerM2 = 'upper_15_percentile_price_per_m2'
}

/** aggregate stddev on columns */
export type It_Street_Stats_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "street_stats" */
export type It_Street_Stats_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type It_Street_Stats_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "street_stats" */
export type It_Street_Stats_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type It_Street_Stats_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "street_stats" */
export type It_Street_Stats_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type It_Street_Stats_Sum_Fields = {
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "street_stats" */
export type It_Street_Stats_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type It_Street_Stats_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "street_stats" */
export type It_Street_Stats_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type It_Street_Stats_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "street_stats" */
export type It_Street_Stats_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type It_Street_Stats_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "street_stats" */
export type It_Street_Stats_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']['input']>;
  _gt?: InputMaybe<Scalars['json']['input']>;
  _gte?: InputMaybe<Scalars['json']['input']>;
  _in?: InputMaybe<Array<Scalars['json']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['json']['input']>;
  _lte?: InputMaybe<Scalars['json']['input']>;
  _neq?: InputMaybe<Scalars['json']['input']>;
  _nin?: InputMaybe<Array<Scalars['json']['input']>>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _eq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _lte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _neq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export type Lead_Agent_Ranking_Properties_Args = {
  dedupe_by_team?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_order?: InputMaybe<Scalars['String']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

export enum Lead_Agent_Source_Enum_Enum {
  /** Seller lead created from an agent or agency profile */
  AgencyPages = 'agency_pages',
  Automation = 'automation',
  Crm = 'crm',
  /** Lead requested from the CRM prospection map */
  ProspectionMap = 'prospection_map',
  ResultPage = 'result_page'
}

/** Boolean expression to compare columns of type "lead_agent_source_enum_enum". All fields are combined with logical 'AND'. */
export type Lead_Agent_Source_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  _in?: InputMaybe<Array<Lead_Agent_Source_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  _nin?: InputMaybe<Array<Lead_Agent_Source_Enum_Enum>>;
};

/** Agents holding a lead: lead_id -> leads, user_id -> users (the agent), stage_id -> lead_stages (that row's stage). Unique on (lead_id, user_id, source): one agent can have several rows for one lead, one per source, so count distinct lead_id. An agent's current leads: user_id = the agent and passed_at IS NULL; the active ones: the stage's status = 'active'. */
export type Lead_Agents = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lead: Leads;
  lead_id: Scalars['uuid']['output'];
  /** An object relationship */
  lead_stage?: Maybe<Lead_Stages>;
  /** An object relationship */
  marketing_metadata?: Maybe<Marketing_Metadata>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: Maybe<Scalars['timestamptz']['output']>;
  predicted_win_date?: Maybe<Scalars['date']['output']>;
  /** How the agent got the lead: result_page (the owner picked the agent on the valuation page), automation (distributed by RealAdvisor), agency_pages (an enquiry on the agent's profile), prospection_map (requested from the prospection map), crm (entered or assigned by hand). */
  source?: Maybe<Lead_Agent_Source_Enum_Enum>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "lead_agents" */
export type Lead_Agents_Aggregate = {
  aggregate?: Maybe<Lead_Agents_Aggregate_Fields>;
  nodes: Array<Lead_Agents>;
};

export type Lead_Agents_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lead_Agents_Aggregate_Bool_Exp_Count>;
};

export type Lead_Agents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Agents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lead_agents" */
export type Lead_Agents_Aggregate_Fields = {
  avg?: Maybe<Lead_Agents_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lead_Agents_Max_Fields>;
  min?: Maybe<Lead_Agents_Min_Fields>;
  stddev?: Maybe<Lead_Agents_Stddev_Fields>;
  stddev_pop?: Maybe<Lead_Agents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lead_Agents_Stddev_Samp_Fields>;
  sum?: Maybe<Lead_Agents_Sum_Fields>;
  var_pop?: Maybe<Lead_Agents_Var_Pop_Fields>;
  var_samp?: Maybe<Lead_Agents_Var_Samp_Fields>;
  variance?: Maybe<Lead_Agents_Variance_Fields>;
};


/** aggregate fields of "lead_agents" */
export type Lead_Agents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lead_agents" */
export type Lead_Agents_Aggregate_Order_By = {
  avg?: InputMaybe<Lead_Agents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lead_Agents_Max_Order_By>;
  min?: InputMaybe<Lead_Agents_Min_Order_By>;
  stddev?: InputMaybe<Lead_Agents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lead_Agents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lead_Agents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lead_Agents_Sum_Order_By>;
  var_pop?: InputMaybe<Lead_Agents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lead_Agents_Var_Samp_Order_By>;
  variance?: InputMaybe<Lead_Agents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lead_agents" */
export type Lead_Agents_Arr_Rel_Insert_Input = {
  data: Array<Lead_Agents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lead_Agents_On_Conflict>;
};

/** aggregate avg on columns */
export type Lead_Agents_Avg_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lead_agents" */
export type Lead_Agents_Avg_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lead_agents". All fields are combined with a logical 'AND'. */
export type Lead_Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Agents_Bool_Exp>>;
  _not?: InputMaybe<Lead_Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Agents_Bool_Exp>>;
  claimed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  lead_stage?: InputMaybe<Lead_Stages_Bool_Exp>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Bool_Exp>;
  passed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  predicted_win_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<Lead_Agent_Source_Enum_Enum_Comparison_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  win_probability?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "lead_agents" */
export enum Lead_Agents_Constraint {
  /** unique or primary key constraint on columns "lead_id" */
  LeadAgentsActiveAgencyPagesLeadKey = 'lead_agents_active_agency_pages_lead_key',
  /** unique or primary key constraint on columns "user_id", "lead_id", "source" */
  LeadAgentsLeadIdUserIdSourceKey = 'lead_agents_lead_id_user_id_source_key',
  /** unique or primary key constraint on columns "id" */
  LeadAgentsPkey = 'lead_agents_pkey'
}

/** input type for incrementing numeric columns in table "lead_agents" */
export type Lead_Agents_Inc_Input = {
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lead_agents" */
export type Lead_Agents_Insert_Input = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  lead_stage?: InputMaybe<Lead_Stages_Obj_Rel_Insert_Input>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  /** How the agent got the lead: result_page (the owner picked the agent on the valuation page), automation (distributed by RealAdvisor), agency_pages (an enquiry on the agent's profile), prospection_map (requested from the prospection map), crm (entered or assigned by hand). */
  source?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Lead_Agents_Max_Fields = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: Maybe<Scalars['timestamptz']['output']>;
  predicted_win_date?: Maybe<Scalars['date']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "lead_agents" */
export type Lead_Agents_Max_Order_By = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: InputMaybe<Order_By>;
  predicted_win_date?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lead_Agents_Min_Fields = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: Maybe<Scalars['timestamptz']['output']>;
  predicted_win_date?: Maybe<Scalars['date']['output']>;
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "lead_agents" */
export type Lead_Agents_Min_Order_By = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: InputMaybe<Order_By>;
  predicted_win_date?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  win_probability?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lead_agents" */
export type Lead_Agents_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lead_Agents>;
};

/** on_conflict condition type for table "lead_agents" */
export type Lead_Agents_On_Conflict = {
  constraint: Lead_Agents_Constraint;
  update_columns?: Array<Lead_Agents_Update_Column>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};

/** Ordering options when selecting data from "lead_agents". */
export type Lead_Agents_Order_By = {
  claimed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  lead_stage?: InputMaybe<Lead_Stages_Order_By>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Order_By>;
  passed_at?: InputMaybe<Order_By>;
  predicted_win_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  win_probability?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lead_agents */
export type Lead_Agents_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lead_agents" */
export enum Lead_Agents_Select_Column {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  Source = 'source',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WinProbability = 'win_probability'
}

/** input type for updating data in table "lead_agents" */
export type Lead_Agents_Set_Input = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Lead_Agents_Stddev_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lead_agents" */
export type Lead_Agents_Stddev_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lead_Agents_Stddev_Pop_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lead_agents" */
export type Lead_Agents_Stddev_Pop_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lead_Agents_Stddev_Samp_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lead_agents" */
export type Lead_Agents_Stddev_Samp_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lead_agents" */
export type Lead_Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Agents_Stream_Cursor_Value_Input = {
  /** When the agent accepted the lead. NULL with passed_at NULL and an active stage = waiting for acceptance; old rows can be NULL even when won or lost. */
  claimed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  /** When the lead stopped being this agent's: refused or passed by the agent, or taken off them by a leader or admin (reassigned_at is also set for a reassignment). Set = no longer theirs. */
  passed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
  /** How the agent got the lead: result_page (the owner picked the agent on the valuation page), automation (distributed by RealAdvisor), agency_pages (an enquiry on the agent's profile), prospection_map (requested from the prospection map), crm (entered or assigned by hand). */
  source?: InputMaybe<Lead_Agent_Source_Enum_Enum>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  win_probability?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Lead_Agents_Sum_Fields = {
  win_probability?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "lead_agents" */
export type Lead_Agents_Sum_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** update columns of table "lead_agents" */
export enum Lead_Agents_Update_Column {
  /** column name */
  ClaimedAt = 'claimed_at',
  /** column name */
  PassedAt = 'passed_at',
  /** column name */
  PredictedWinDate = 'predicted_win_date',
  /** column name */
  StageId = 'stage_id',
  /** column name */
  WinProbability = 'win_probability'
}

export type Lead_Agents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lead_Agents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lead_Agents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lead_Agents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lead_Agents_Var_Pop_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lead_agents" */
export type Lead_Agents_Var_Pop_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lead_Agents_Var_Samp_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lead_agents" */
export type Lead_Agents_Var_Samp_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lead_Agents_Variance_Fields = {
  win_probability?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lead_agents" */
export type Lead_Agents_Variance_Order_By = {
  win_probability?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "lead_buying_status". All fields are combined with logical 'AND'. */
export type Lead_Buying_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_buying_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_buying_status']['input']>>;
};

/** Boolean expression to compare columns of type "lead_mortgage_status". All fields are combined with logical 'AND'. */
export type Lead_Mortgage_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _gte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _lte?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _neq?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_mortgage_status']['input']>>;
};

/** Boolean expression to compare columns of type "lead_ownership". All fields are combined with logical 'AND'. */
export type Lead_Ownership_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _gte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_ownership']['input']>;
  _lte?: InputMaybe<Scalars['lead_ownership']['input']>;
  _neq?: InputMaybe<Scalars['lead_ownership']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_ownership']['input']>>;
};

/** Stages of a pipeline, in order_nr order. status (active, won, lost) is the business state of whatever sits at that stage. Referenced by lead_agents.stage_id and buyer_leads.stage_id. */
export type Lead_Stages = {
  created_at: Scalars['timestamptz']['output'];
  deletable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** compute lead stages label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  pipeline: Pipelines;
  pipeline_id: Scalars['uuid']['output'];
  status: Leads_Status_Enum;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "lead_stages" */
export type Lead_Stages_Aggregate = {
  aggregate?: Maybe<Lead_Stages_Aggregate_Fields>;
  nodes: Array<Lead_Stages>;
};

export type Lead_Stages_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp_Count>;
};

export type Lead_Stages_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Stages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lead_Stages_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Stages_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lead_Stages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lead_Stages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lead_stages" */
export type Lead_Stages_Aggregate_Fields = {
  avg?: Maybe<Lead_Stages_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lead_Stages_Max_Fields>;
  min?: Maybe<Lead_Stages_Min_Fields>;
  stddev?: Maybe<Lead_Stages_Stddev_Fields>;
  stddev_pop?: Maybe<Lead_Stages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lead_Stages_Stddev_Samp_Fields>;
  sum?: Maybe<Lead_Stages_Sum_Fields>;
  var_pop?: Maybe<Lead_Stages_Var_Pop_Fields>;
  var_samp?: Maybe<Lead_Stages_Var_Samp_Fields>;
  variance?: Maybe<Lead_Stages_Variance_Fields>;
};


/** aggregate fields of "lead_stages" */
export type Lead_Stages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lead_stages" */
export type Lead_Stages_Aggregate_Order_By = {
  avg?: InputMaybe<Lead_Stages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lead_Stages_Max_Order_By>;
  min?: InputMaybe<Lead_Stages_Min_Order_By>;
  stddev?: InputMaybe<Lead_Stages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lead_Stages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lead_Stages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lead_Stages_Sum_Order_By>;
  var_pop?: InputMaybe<Lead_Stages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lead_Stages_Var_Samp_Order_By>;
  variance?: InputMaybe<Lead_Stages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lead_stages" */
export type Lead_Stages_Arr_Rel_Insert_Input = {
  data: Array<Lead_Stages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};

/** aggregate avg on columns */
export type Lead_Stages_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lead_stages" */
export type Lead_Stages_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lead_stages". All fields are combined with a logical 'AND'. */
export type Lead_Stages_Bool_Exp = {
  _and?: InputMaybe<Array<Lead_Stages_Bool_Exp>>;
  _not?: InputMaybe<Lead_Stages_Bool_Exp>;
  _or?: InputMaybe<Array<Lead_Stages_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletable?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  pipeline?: InputMaybe<Pipelines_Bool_Exp>;
  pipeline_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Leads_Status_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "lead_stages" */
export enum Lead_Stages_Constraint {
  /** unique or primary key constraint on columns "pipeline_id", "order_nr" */
  LeadStagesPipelineIdOrderNrUnique = 'lead_stages_pipeline_id_order_nr_unique',
  /** unique or primary key constraint on columns "id" */
  LeadStagesPkey = 'lead_stages_pkey'
}

/** input type for incrementing numeric columns in table "lead_stages" */
export type Lead_Stages_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lead_stages" */
export type Lead_Stages_Insert_Input = {
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pipeline?: InputMaybe<Pipelines_Obj_Rel_Insert_Input>;
  pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Leads_Status_Enum>;
};

/** aggregate max on columns */
export type Lead_Stages_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** compute lead stages label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pipeline_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "lead_stages" */
export type Lead_Stages_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  pipeline_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lead_Stages_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** compute lead stages label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pipeline_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "lead_stages" */
export type Lead_Stages_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  pipeline_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lead_stages" */
export type Lead_Stages_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lead_Stages>;
};

/** input type for inserting object relation for remote table "lead_stages" */
export type Lead_Stages_Obj_Rel_Insert_Input = {
  data: Lead_Stages_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};

/** on_conflict condition type for table "lead_stages" */
export type Lead_Stages_On_Conflict = {
  constraint: Lead_Stages_Constraint;
  update_columns?: Array<Lead_Stages_Update_Column>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};

/** Ordering options when selecting data from "lead_stages". */
export type Lead_Stages_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deletable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  pipeline?: InputMaybe<Pipelines_Order_By>;
  pipeline_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lead_stages */
export type Lead_Stages_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "lead_stages" */
export enum Lead_Stages_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PipelineId = 'pipeline_id',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "lead_stages_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lead_stages" */
export enum Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deletable = 'deletable'
}

/** select "lead_stages_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lead_stages" */
export enum Lead_Stages_Select_Column_Lead_Stages_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deletable = 'deletable'
}

/** input type for updating data in table "lead_stages" */
export type Lead_Stages_Set_Input = {
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Leads_Status_Enum>;
};

/** aggregate stddev on columns */
export type Lead_Stages_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lead_stages" */
export type Lead_Stages_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lead_Stages_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lead_stages" */
export type Lead_Stages_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lead_Stages_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lead_stages" */
export type Lead_Stages_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lead_stages" */
export type Lead_Stages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lead_Stages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lead_Stages_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Leads_Status_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Lead_Stages_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "lead_stages" */
export type Lead_Stages_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "lead_stages" */
export enum Lead_Stages_Update_Column {
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Status = 'status'
}

export type Lead_Stages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lead_Stages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lead_Stages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lead_Stages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lead_Stages_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lead_stages" */
export type Lead_Stages_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lead_Stages_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lead_stages" */
export type Lead_Stages_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lead_Stages_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lead_stages" */
export type Lead_Stages_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "lead_type". All fields are combined with logical 'AND'. */
export type Lead_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['lead_type']['input']>;
  _gt?: InputMaybe<Scalars['lead_type']['input']>;
  _gte?: InputMaybe<Scalars['lead_type']['input']>;
  _in?: InputMaybe<Array<Scalars['lead_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['lead_type']['input']>;
  _lte?: InputMaybe<Scalars['lead_type']['input']>;
  _neq?: InputMaybe<Scalars['lead_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['lead_type']['input']>>;
};

/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type Leads = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  annual_premium?: Maybe<Scalars['float8']['output']>;
  anonymized_contact?: Maybe<Scalars['String']['output']>;
  appraisal_inheritance_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_open_to_offer?: Maybe<Scalars['String']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_country?: Maybe<Scalars['String']['output']>;
  appraisal_property_country_code?: Maybe<Scalars['String']['output']>;
  appraisal_property_ctn?: Maybe<Scalars['String']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_google_address_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_has_elevator?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_garden?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_has_view?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_income_includes_parking?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_commercial_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_parking_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_renovated?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_is_residential_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_know_plot_number?: Maybe<Scalars['Boolean']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_locality?: Maybe<Scalars['String']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_occupied?: Maybe<Scalars['String']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_plot_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_postcode?: Maybe<Scalars['String']['output']>;
  appraisal_property_property_type_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_route?: Maybe<Scalars['String']['output']>;
  appraisal_property_side?: Maybe<Property_Side_Enum_Enum>;
  appraisal_property_state?: Maybe<Scalars['String']['output']>;
  appraisal_property_street_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_usage?: Maybe<Scalars['String']['output']>;
  appraisal_reason: Leads_Appraisal_Reason_Enum;
  appraisal_selling_with?: Maybe<Scalars['String']['output']>;
  appraisal_separation_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_step?: Maybe<Scalars['String']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  /** Deprecated: the leads.broker_id column was dropped; who holds a lead is on lead_agents. Returns one agent from the caller's teams, possibly one who already passed the lead. Computed row by row with no index: do not select, filter or sort on it. Use lead_agents.user_id with passed_at IS NULL. */
  broker_id?: Maybe<Scalars['uuid']['output']>;
  buy_horizon: Leads_Buy_Horizon_Enum;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  /** Deprecated: the column was dropped. Returns the latest agent from the caller's teams who claimed the lead, possibly one who passed it since. Not indexed: use lead_agents.claimed_at. */
  claimed_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  cma_reports: Array<Cma_Reports>;
  /** An aggregate relationship */
  cma_reports_aggregate: Cma_Reports_Aggregate;
  completed: Scalars['Boolean']['output'];
  /** An object relationship */
  contact?: Maybe<Users>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  createdBy?: Maybe<Users>;
  created_at: Scalars['timestamptz']['output'];
  /** Who created the lead: the agent for a lead entered in the CRM, the owner for a self-service valuation. Not who holds it: see lead_agents. */
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  /** A computed field, executes function "leads_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  google_address?: Maybe<Google_Addresses>;
  has_accepted_terms?: Maybe<Scalars['Boolean']['output']>;
  has_dependant_children?: Maybe<Scalars['Boolean']['output']>;
  has_no_street_number?: Maybe<Scalars['Boolean']['output']>;
  has_other_credits?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  imported_id?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "computed_last_activity" */
  last_activity?: Maybe<Array<Activities>>;
  last_activity_done_at?: Maybe<Scalars['timestamptz']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_requalification_mail_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  last_requalification_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** An array relationship */
  leads_acls: Array<Leads_Acl>;
  /** An array relationship */
  leads_tags: Array<Leads_Tags>;
  /** An aggregate relationship */
  leads_tags_aggregate: Leads_Tags_Aggregate;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  market_update_subscribed: Scalars['Boolean']['output'];
  /** An object relationship */
  marketing_metadata?: Maybe<Marketing_Metadata>;
  /** Attribution snapshot captured when the lead was created (api upsertLead / valuation-studio); NULL for older leads and server-side writers */
  marketing_metadata_id?: Maybe<Scalars['uuid']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_buying_status?: Maybe<Scalars['lead_buying_status']['output']>;
  mortgage_status?: Maybe<Scalars['lead_mortgage_status']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "computed_next_activity" */
  next_activity?: Maybe<Array<Activities>>;
  next_activity_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  origin_enquiry?: Maybe<Enquiries>;
  origin_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  owner_team?: Maybe<Teams>;
  owner_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  owner_user?: Maybe<Users>;
  /** Set only on leads born from an enquiry to an agent's public profile, together with owner_team_id and origin_enquiry_id. Not who holds the lead: see lead_agents. */
  owner_user_id?: Maybe<Scalars['uuid']['output']>;
  ownership?: Maybe<Scalars['lead_ownership']['output']>;
  parent_lead_id?: Maybe<Scalars['uuid']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_date_of_birth?: Maybe<Scalars['date']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_first_name?: Maybe<Scalars['String']['output']>;
  partner_gender?: Maybe<Scalars['String']['output']>;
  partner_has_other_credits?: Maybe<Scalars['Boolean']['output']>;
  partner_has_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_last_name?: Maybe<Scalars['String']['output']>;
  partner_marital_status?: Maybe<Scalars['String']['output']>;
  partner_nationality_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_text?: Maybe<Scalars['String']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  partner_residence_country_code?: Maybe<Scalars['String']['output']>;
  partner_residence_state_id?: Maybe<Scalars['uuid']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  partner_use_bank_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  partner_use_insurance_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  partner_work_permit_id?: Maybe<Scalars['uuid']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  potential_development: Scalars['Boolean']['output'];
  predicted_listing_date?: Maybe<Scalars['timestamptz']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  /** An object relationship */
  profile_contact?: Maybe<Profile_Enquiry_Contacts_View>;
  /** An object relationship */
  property?: Maybe<Properties>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  /** An object relationship */
  property_type?: Maybe<Property_Types>;
  property_usage: Leads_Property_Usage_Enum;
  purchase_date?: Maybe<Scalars['date']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  received_mortgage_offer?: Maybe<Scalars['Boolean']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  refused_at?: Maybe<Scalars['timestamptz']['output']>;
  relationship: Leads_Relationship_Enum;
  requalification_email_subscribed: Scalars['Boolean']['output'];
  requalification_sms_subscribed: Scalars['Boolean']['output'];
  requalification_status: Leads_Requalification_Status_Enum;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_or_created_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  sale_comments?: Maybe<Scalars['String']['output']>;
  sale_has_found?: Maybe<Scalars['Boolean']['output']>;
  sale_horizon: Leads_Sale_Horizon_Enum;
  /** Legacy: no current code writes it, and it was last set in 2022 (NULL on nearly every lead). Do not use it; for seller leads see appraisal_reason and completed. */
  sale_is_seller?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  sale_started?: Maybe<Scalars['Boolean']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  second_contact?: Maybe<Users>;
  second_contact_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "should_be_requalified" */
  should_be_requalified?: Maybe<Scalars['Boolean']['output']>;
  snapshot?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  source: Dictionaries;
  source_id: Scalars['uuid']['output'];
  source_organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** Deprecated: the column was dropped. A lead has one stage per agent assignment; this returns the stage of the single agent broker_id picks. Not indexed: use lead_agents.stage_id with lead_stages.status. */
  stage_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  third_pillar?: Maybe<Scalars['float8']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  use_bank_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  use_insurance_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  use_second_pillar?: Maybe<Scalars['Boolean']['output']>;
  use_third_pillar?: Maybe<Scalars['Boolean']['output']>;
  user_info_ip?: Maybe<Scalars['String']['output']>;
  user_info_user_agent?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsCma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsCma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLast_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLeads_AclsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Acl_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Acl_Order_By>>;
  where?: InputMaybe<Leads_Acl_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLeads_TagsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLeads_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsNext_ActivityArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Leads: a property owner from a valuation request, or a contact entered by an agent. Seller leads in stats are appraisal_reason = 'sell' and completed = true; the CRM also reads already_for_sale and buy_this as intent to sell. contact_id -> users is the owner, property_id -> properties the property. Who holds the lead and its stage are on lead_agents, not here. completed = false is an unfinished valuation form. */
export type LeadsSnapshotArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "leads_acl" */
export type Leads_Acl = {
  lead_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "leads_acl" */
export type Leads_Acl_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Leads_Acl_Max_Order_By>;
  min?: InputMaybe<Leads_Acl_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "leads_acl". All fields are combined with a logical 'AND'. */
export type Leads_Acl_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Acl_Bool_Exp>>;
  _not?: InputMaybe<Leads_Acl_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Acl_Bool_Exp>>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "leads_acl" */
export type Leads_Acl_Max_Order_By = {
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "leads_acl" */
export type Leads_Acl_Min_Order_By = {
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "leads_acl". */
export type Leads_Acl_Order_By = {
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "leads_acl" */
export enum Leads_Acl_Select_Column {
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** aggregated selection of "leads" */
export type Leads_Aggregate = {
  aggregate?: Maybe<Leads_Aggregate_Fields>;
  nodes: Array<Leads>;
};

export type Leads_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Leads_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Leads_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Leads_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Leads_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Leads_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Leads_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Leads_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Leads_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Leads_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Leads_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Leads_Aggregate_Bool_Exp_Var_Samp>;
};

export type Leads_Aggregate_Bool_Exp_Avg = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Bool_And = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Corr = {
  arguments: Leads_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Leads_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Leads_Aggregate_Bool_Exp_Max = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Min = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Sum = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Leads_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Leads_Select_Column_Leads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "leads" */
export type Leads_Aggregate_Fields = {
  avg?: Maybe<Leads_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Leads_Max_Fields>;
  min?: Maybe<Leads_Min_Fields>;
  stddev?: Maybe<Leads_Stddev_Fields>;
  stddev_pop?: Maybe<Leads_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Leads_Stddev_Samp_Fields>;
  sum?: Maybe<Leads_Sum_Fields>;
  var_pop?: Maybe<Leads_Var_Pop_Fields>;
  var_samp?: Maybe<Leads_Var_Samp_Fields>;
  variance?: Maybe<Leads_Variance_Fields>;
};


/** aggregate fields of "leads" */
export type Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "leads" */
export type Leads_Aggregate_Order_By = {
  avg?: InputMaybe<Leads_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Leads_Max_Order_By>;
  min?: InputMaybe<Leads_Min_Order_By>;
  stddev?: InputMaybe<Leads_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Leads_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Leads_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Leads_Sum_Order_By>;
  var_pop?: InputMaybe<Leads_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Leads_Var_Samp_Order_By>;
  variance?: InputMaybe<Leads_Variance_Order_By>;
};

export enum Leads_Appraisal_Reason_Enum {
  AlreadyForSale = 'already_for_sale',
  BuySoon = 'buy_soon',
  BuyThis = 'buy_this',
  Inheritance = 'inheritance',
  MoveRental = 'move_rental',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Other = 'other',
  OtherNotOwner = 'other_not_owner',
  OtherOwner = 'other_owner',
  OtherRenting = 'other_renting',
  Refinance = 'refinance',
  Sell = 'sell',
  Separation = 'separation'
}

/** Boolean expression to compare columns of type "leads_appraisal_reason_enum". All fields are combined with logical 'AND'. */
export type Leads_Appraisal_Reason_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Appraisal_Reason_Enum>;
  _in?: InputMaybe<Array<Leads_Appraisal_Reason_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Appraisal_Reason_Enum>;
  _nin?: InputMaybe<Array<Leads_Appraisal_Reason_Enum>>;
};

/** input type for inserting array relation for remote table "leads" */
export type Leads_Arr_Rel_Insert_Input = {
  data: Array<Leads_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};

/** aggregate avg on columns */
export type Leads_Avg_Fields = {
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "leads" */
export type Leads_Avg_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "leads". All fields are combined with a logical 'AND'. */
export type Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Bool_Exp>>;
  _not?: InputMaybe<Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Bool_Exp>>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  annual_premium?: InputMaybe<Float8_Comparison_Exp>;
  anonymized_contact?: InputMaybe<String_Comparison_Exp>;
  appraisal_inheritance_next_step?: InputMaybe<String_Comparison_Exp>;
  appraisal_market_time?: InputMaybe<Int_Comparison_Exp>;
  appraisal_monthly_gross_rent?: InputMaybe<Float_Comparison_Exp>;
  appraisal_next_step?: InputMaybe<String_Comparison_Exp>;
  appraisal_open_to_offer?: InputMaybe<String_Comparison_Exp>;
  appraisal_perceived_value?: InputMaybe<Float_Comparison_Exp>;
  appraisal_perception?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_built_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_commercial_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_construction_year?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_country?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_country_code?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_ctn?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_garden_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  appraisal_property_has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_has_view?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_income_includes_parking?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_renovated?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_know_plot_number?: InputMaybe<Boolean_Comparison_Exp>;
  appraisal_property_land_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_lat?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_living_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_lng?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_locality?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_residential_units?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_occupied?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_plot_number?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_postcode?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  appraisal_property_renovation_year?: InputMaybe<Int_Comparison_Exp>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_residential_surface?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  appraisal_property_route?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_side?: InputMaybe<Property_Side_Enum_Enum_Comparison_Exp>;
  appraisal_property_state?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_street_number?: InputMaybe<String_Comparison_Exp>;
  appraisal_property_usage?: InputMaybe<String_Comparison_Exp>;
  appraisal_reason?: InputMaybe<Leads_Appraisal_Reason_Enum_Comparison_Exp>;
  appraisal_selling_with?: InputMaybe<String_Comparison_Exp>;
  appraisal_separation_next_step?: InputMaybe<String_Comparison_Exp>;
  appraisal_step?: InputMaybe<String_Comparison_Exp>;
  assets_second_pillar?: InputMaybe<Float8_Comparison_Exp>;
  assets_third_pillar_a_organisation?: InputMaybe<String_Comparison_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buy_horizon?: InputMaybe<Leads_Buy_Horizon_Enum_Comparison_Exp>;
  call_times?: InputMaybe<String_Array_Comparison_Exp>;
  claimed_by?: InputMaybe<Uuid_Comparison_Exp>;
  cma_reports?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  contact?: InputMaybe<Users_Bool_Exp>;
  contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  createdBy?: InputMaybe<Users_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  debt?: InputMaybe<Float8_Comparison_Exp>;
  donation?: InputMaybe<Float8_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  google_address?: InputMaybe<Google_Addresses_Bool_Exp>;
  has_accepted_terms?: InputMaybe<Boolean_Comparison_Exp>;
  has_dependant_children?: InputMaybe<Boolean_Comparison_Exp>;
  has_no_street_number?: InputMaybe<Boolean_Comparison_Exp>;
  has_other_credits?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_id?: InputMaybe<String_Comparison_Exp>;
  landing_page_url?: InputMaybe<String_Comparison_Exp>;
  last_activity?: InputMaybe<Activities_Bool_Exp>;
  last_activity_done_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_bonus?: InputMaybe<Float8_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  last_requalification_mail_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_requalification_sms_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lead_agents?: InputMaybe<Lead_Agents_Bool_Exp>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Bool_Exp>;
  leads_acls?: InputMaybe<Leads_Acl_Bool_Exp>;
  leads_tags?: InputMaybe<Leads_Tags_Bool_Exp>;
  leads_tags_aggregate?: InputMaybe<Leads_Tags_Aggregate_Bool_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  mandate_probability?: InputMaybe<Int_Comparison_Exp>;
  marital_status?: InputMaybe<String_Comparison_Exp>;
  market_update_subscribed?: InputMaybe<Boolean_Comparison_Exp>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Bool_Exp>;
  marketing_metadata_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_property_value?: InputMaybe<Float8_Comparison_Exp>;
  mortgage_buying_status?: InputMaybe<Lead_Buying_Status_Comparison_Exp>;
  mortgage_status?: InputMaybe<Lead_Mortgage_Status_Comparison_Exp>;
  nationality_id?: InputMaybe<Uuid_Comparison_Exp>;
  next_activity?: InputMaybe<Activities_Bool_Exp>;
  next_activity_due_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  number_of_buyers?: InputMaybe<Int_Comparison_Exp>;
  number_of_dependant_children?: InputMaybe<Int_Comparison_Exp>;
  occupation_id?: InputMaybe<Uuid_Comparison_Exp>;
  occupation_text?: InputMaybe<String_Comparison_Exp>;
  origin_enquiry?: InputMaybe<Enquiries_Bool_Exp>;
  origin_enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
  other_credits?: InputMaybe<Int_Comparison_Exp>;
  owner_team?: InputMaybe<Teams_Bool_Exp>;
  owner_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_user?: InputMaybe<Users_Bool_Exp>;
  owner_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  ownership?: InputMaybe<Lead_Ownership_Comparison_Exp>;
  parent_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_annual_premium?: InputMaybe<Float8_Comparison_Exp>;
  partner_date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  partner_donation?: InputMaybe<Float8_Comparison_Exp>;
  partner_first_name?: InputMaybe<String_Comparison_Exp>;
  partner_gender?: InputMaybe<String_Comparison_Exp>;
  partner_has_other_credits?: InputMaybe<Boolean_Comparison_Exp>;
  partner_has_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  partner_last_bonus?: InputMaybe<Float8_Comparison_Exp>;
  partner_last_name?: InputMaybe<String_Comparison_Exp>;
  partner_marital_status?: InputMaybe<String_Comparison_Exp>;
  partner_nationality_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_occupation_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_occupation_text?: InputMaybe<String_Comparison_Exp>;
  partner_other_credits?: InputMaybe<Float8_Comparison_Exp>;
  partner_professional_situation?: InputMaybe<User_Professional_Situation_Comparison_Exp>;
  partner_residence_country_code?: InputMaybe<String_Comparison_Exp>;
  partner_residence_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_savings?: InputMaybe<Float8_Comparison_Exp>;
  partner_second_pillar?: InputMaybe<Float8_Comparison_Exp>;
  partner_third_pillar?: InputMaybe<Float8_Comparison_Exp>;
  partner_third_pillar_a_organisation?: InputMaybe<String_Comparison_Exp>;
  partner_use_bank_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  partner_use_insurance_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  partner_work_permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  partner_yearly_revenues?: InputMaybe<Float8_Comparison_Exp>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Float8_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  potential_development?: InputMaybe<Boolean_Comparison_Exp>;
  predicted_listing_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  professional_situation?: InputMaybe<User_Professional_Situation_Comparison_Exp>;
  profile_contact?: InputMaybe<Profile_Enquiry_Contacts_View_Bool_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search_notification?: InputMaybe<Property_Searches_Notification_Comparison_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_usage?: InputMaybe<Leads_Property_Usage_Enum_Comparison_Exp>;
  purchase_date?: InputMaybe<Date_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  received_mortgage_offer?: InputMaybe<Boolean_Comparison_Exp>;
  referrer?: InputMaybe<String_Comparison_Exp>;
  referring_domain?: InputMaybe<String_Comparison_Exp>;
  refused_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  relationship?: InputMaybe<Leads_Relationship_Enum_Comparison_Exp>;
  requalification_email_subscribed?: InputMaybe<Boolean_Comparison_Exp>;
  requalification_sms_subscribed?: InputMaybe<Boolean_Comparison_Exp>;
  requalification_status?: InputMaybe<Leads_Requalification_Status_Enum_Comparison_Exp>;
  requalified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  requalified_or_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  residence_country_code?: InputMaybe<String_Comparison_Exp>;
  residence_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_comments?: InputMaybe<String_Comparison_Exp>;
  sale_has_found?: InputMaybe<Boolean_Comparison_Exp>;
  sale_horizon?: InputMaybe<Leads_Sale_Horizon_Enum_Comparison_Exp>;
  sale_is_seller?: InputMaybe<Boolean_Comparison_Exp>;
  sale_price?: InputMaybe<Int_Comparison_Exp>;
  sale_started?: InputMaybe<Boolean_Comparison_Exp>;
  savings?: InputMaybe<Float8_Comparison_Exp>;
  second_contact?: InputMaybe<Users_Bool_Exp>;
  second_contact_id?: InputMaybe<Uuid_Comparison_Exp>;
  second_pillar?: InputMaybe<Float8_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  should_be_requalified?: InputMaybe<Boolean_Comparison_Exp>;
  snapshot?: InputMaybe<Jsonb_Comparison_Exp>;
  source?: InputMaybe<Dictionaries_Bool_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  stage_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  third_pillar?: InputMaybe<Float8_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usable_own_funds?: InputMaybe<Float8_Comparison_Exp>;
  use_bank_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  use_insurance_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  use_second_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  use_third_pillar?: InputMaybe<Boolean_Comparison_Exp>;
  user_info_ip?: InputMaybe<String_Comparison_Exp>;
  user_info_user_agent?: InputMaybe<String_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
  work_permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  yearly_revenues?: InputMaybe<Float8_Comparison_Exp>;
  yearly_revenues_at_retirement?: InputMaybe<Float8_Comparison_Exp>;
};

export enum Leads_Buy_Horizon_Enum {
  NotSet = 'not_set',
  Over_12Months = 'over_12_months',
  Under_3Months = 'under_3_months',
  Under_12Months = 'under_12_months'
}

/** Boolean expression to compare columns of type "leads_buy_horizon_enum". All fields are combined with logical 'AND'. */
export type Leads_Buy_Horizon_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Buy_Horizon_Enum>;
  _in?: InputMaybe<Array<Leads_Buy_Horizon_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Buy_Horizon_Enum>;
  _nin?: InputMaybe<Array<Leads_Buy_Horizon_Enum>>;
};

/** unique or primary key constraints on table "leads" */
export enum Leads_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LeadsIdTenantIdUnique = 'leads_id_tenant_id_unique',
  /** unique or primary key constraint on columns "imported_id", "tenant_id" */
  LeadsImportedIdTenantIdUnique = 'leads_imported_id_tenant_id_unique',
  /** unique or primary key constraint on columns "origin_enquiry_id" */
  LeadsOriginEnquiryIdKey = 'leads_origin_enquiry_id_key',
  /** unique or primary key constraint on columns "id" */
  LeadsPkey = 'leads_pkey'
}

/** input type for incrementing numeric columns in table "leads" */
export type Leads_Inc_Input = {
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "leads" */
export type Leads_Insert_Input = {
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  cma_reports?: InputMaybe<Cma_Reports_Arr_Rel_Insert_Input>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  createdBy?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  /** Who created the lead: the agent for a lead entered in the CRM, the owner for a self-service valuation. Not who holds it: see lead_agents. */
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<Google_Addresses_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_agents?: InputMaybe<Lead_Agents_Arr_Rel_Insert_Input>;
  leads_tags?: InputMaybe<Leads_Tags_Arr_Rel_Insert_Input>;
  lots?: InputMaybe<Lots_Arr_Rel_Insert_Input>;
  origin_enquiry?: InputMaybe<Enquiries_Obj_Rel_Insert_Input>;
  owner_team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  owner_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  relationship?: InputMaybe<Leads_Relationship_Enum>;
  sale_horizon?: InputMaybe<Leads_Sale_Horizon_Enum>;
  second_contact?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  source?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Leads_Max_Fields = {
  annual_premium?: Maybe<Scalars['float8']['output']>;
  anonymized_contact?: Maybe<Scalars['String']['output']>;
  appraisal_inheritance_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_open_to_offer?: Maybe<Scalars['String']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_country?: Maybe<Scalars['String']['output']>;
  appraisal_property_country_code?: Maybe<Scalars['String']['output']>;
  appraisal_property_ctn?: Maybe<Scalars['String']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_google_address_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_locality?: Maybe<Scalars['String']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_occupied?: Maybe<Scalars['String']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_plot_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_postcode?: Maybe<Scalars['String']['output']>;
  appraisal_property_property_type_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_route?: Maybe<Scalars['String']['output']>;
  appraisal_property_state?: Maybe<Scalars['String']['output']>;
  appraisal_property_street_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_usage?: Maybe<Scalars['String']['output']>;
  appraisal_selling_with?: Maybe<Scalars['String']['output']>;
  appraisal_separation_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_step?: Maybe<Scalars['String']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  /** Deprecated: the leads.broker_id column was dropped; who holds a lead is on lead_agents. Returns one agent from the caller's teams, possibly one who already passed the lead. Computed row by row with no index: do not select, filter or sort on it. Use lead_agents.user_id with passed_at IS NULL. */
  broker_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  /** Deprecated: the column was dropped. Returns the latest agent from the caller's teams who claimed the lead, possibly one who passed it since. Not indexed: use lead_agents.claimed_at. */
  claimed_by?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Who created the lead: the agent for a lead entered in the CRM, the owner for a self-service valuation. Not who holds it: see lead_agents. */
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "leads_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  last_activity_done_at?: Maybe<Scalars['timestamptz']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_requalification_mail_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  last_requalification_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  /** Attribution snapshot captured when the lead was created (api upsertLead / valuation-studio); NULL for older leads and server-side writers */
  marketing_metadata_id?: Maybe<Scalars['uuid']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_buying_status?: Maybe<Scalars['lead_buying_status']['output']>;
  mortgage_status?: Maybe<Scalars['lead_mortgage_status']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  next_activity_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  origin_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  owner_team_id?: Maybe<Scalars['uuid']['output']>;
  /** Set only on leads born from an enquiry to an agent's public profile, together with owner_team_id and origin_enquiry_id. Not who holds the lead: see lead_agents. */
  owner_user_id?: Maybe<Scalars['uuid']['output']>;
  ownership?: Maybe<Scalars['lead_ownership']['output']>;
  parent_lead_id?: Maybe<Scalars['uuid']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_date_of_birth?: Maybe<Scalars['date']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_first_name?: Maybe<Scalars['String']['output']>;
  partner_gender?: Maybe<Scalars['String']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_last_name?: Maybe<Scalars['String']['output']>;
  partner_marital_status?: Maybe<Scalars['String']['output']>;
  partner_nationality_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_text?: Maybe<Scalars['String']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  partner_residence_country_code?: Maybe<Scalars['String']['output']>;
  partner_residence_state_id?: Maybe<Scalars['uuid']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  partner_work_permit_id?: Maybe<Scalars['uuid']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  predicted_listing_date?: Maybe<Scalars['timestamptz']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  purchase_date?: Maybe<Scalars['date']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  refused_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_or_created_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  sale_comments?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  second_contact_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** Deprecated: the column was dropped. A lead has one stage per agent assignment; this returns the stage of the single agent broker_id picks. Not indexed: use lead_agents.stage_id with lead_stages.status. */
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  user_info_ip?: Maybe<Scalars['String']['output']>;
  user_info_user_agent?: Maybe<Scalars['String']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by max() on columns of table "leads" */
export type Leads_Max_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  anonymized_contact?: InputMaybe<Order_By>;
  appraisal_inheritance_next_step?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_next_step?: InputMaybe<Order_By>;
  appraisal_open_to_offer?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_country?: InputMaybe<Order_By>;
  appraisal_property_country_code?: InputMaybe<Order_By>;
  appraisal_property_ctn?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_google_address_id?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_locality?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_occupied?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_plot_number?: InputMaybe<Order_By>;
  appraisal_property_postcode?: InputMaybe<Order_By>;
  appraisal_property_property_type_id?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_route?: InputMaybe<Order_By>;
  appraisal_property_state?: InputMaybe<Order_By>;
  appraisal_property_street_number?: InputMaybe<Order_By>;
  appraisal_property_usage?: InputMaybe<Order_By>;
  appraisal_selling_with?: InputMaybe<Order_By>;
  appraisal_separation_next_step?: InputMaybe<Order_By>;
  appraisal_step?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Who created the lead: the agent for a lead entered in the CRM, the owner for a self-service valuation. Not who holds it: see lead_agents. */
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  last_activity_done_at?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_requalification_mail_sent_at?: InputMaybe<Order_By>;
  last_requalification_sms_sent_at?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  /** Attribution snapshot captured when the lead was created (api upsertLead / valuation-studio); NULL for older leads and server-side writers */
  marketing_metadata_id?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_buying_status?: InputMaybe<Order_By>;
  mortgage_status?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  next_activity_due_at?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  origin_enquiry_id?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  owner_team_id?: InputMaybe<Order_By>;
  /** Set only on leads born from an enquiry to an agent's public profile, together with owner_team_id and origin_enquiry_id. Not who holds the lead: see lead_agents. */
  owner_user_id?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  parent_lead_id?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_date_of_birth?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_first_name?: InputMaybe<Order_By>;
  partner_gender?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_last_name?: InputMaybe<Order_By>;
  partner_marital_status?: InputMaybe<Order_By>;
  partner_nationality_id?: InputMaybe<Order_By>;
  partner_occupation_id?: InputMaybe<Order_By>;
  partner_occupation_text?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_professional_situation?: InputMaybe<Order_By>;
  partner_residence_country_code?: InputMaybe<Order_By>;
  partner_residence_state_id?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_third_pillar_a_organisation?: InputMaybe<Order_By>;
  partner_work_permit_id?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  predicted_listing_date?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  purchase_date?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  refused_at?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  requalified_or_created_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  sale_comments?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_contact_id?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_organisation_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  user_info_ip?: InputMaybe<Order_By>;
  user_info_user_agent?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Leads_Min_Fields = {
  annual_premium?: Maybe<Scalars['float8']['output']>;
  anonymized_contact?: Maybe<Scalars['String']['output']>;
  appraisal_inheritance_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_open_to_offer?: Maybe<Scalars['String']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_country?: Maybe<Scalars['String']['output']>;
  appraisal_property_country_code?: Maybe<Scalars['String']['output']>;
  appraisal_property_ctn?: Maybe<Scalars['String']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_google_address_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_locality?: Maybe<Scalars['String']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_occupied?: Maybe<Scalars['String']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_plot_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_postcode?: Maybe<Scalars['String']['output']>;
  appraisal_property_property_type_id?: Maybe<Scalars['uuid']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_route?: Maybe<Scalars['String']['output']>;
  appraisal_property_state?: Maybe<Scalars['String']['output']>;
  appraisal_property_street_number?: Maybe<Scalars['String']['output']>;
  appraisal_property_usage?: Maybe<Scalars['String']['output']>;
  appraisal_selling_with?: Maybe<Scalars['String']['output']>;
  appraisal_separation_next_step?: Maybe<Scalars['String']['output']>;
  appraisal_step?: Maybe<Scalars['String']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  /** Deprecated: the leads.broker_id column was dropped; who holds a lead is on lead_agents. Returns one agent from the caller's teams, possibly one who already passed the lead. Computed row by row with no index: do not select, filter or sort on it. Use lead_agents.user_id with passed_at IS NULL. */
  broker_id?: Maybe<Scalars['uuid']['output']>;
  call_times?: Maybe<Array<Scalars['String']['output']>>;
  /** Deprecated: the column was dropped. Returns the latest agent from the caller's teams who claimed the lead, possibly one who passed it since. Not indexed: use lead_agents.claimed_at. */
  claimed_by?: Maybe<Scalars['uuid']['output']>;
  contact_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Who created the lead: the agent for a lead entered in the CRM, the owner for a self-service valuation. Not who holds it: see lead_agents. */
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "leads_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  last_activity_done_at?: Maybe<Scalars['timestamptz']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  last_requalification_mail_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  last_requalification_sms_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  marital_status?: Maybe<Scalars['String']['output']>;
  /** Attribution snapshot captured when the lead was created (api upsertLead / valuation-studio); NULL for older leads and server-side writers */
  marketing_metadata_id?: Maybe<Scalars['uuid']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  mortgage_buying_status?: Maybe<Scalars['lead_buying_status']['output']>;
  mortgage_status?: Maybe<Scalars['lead_mortgage_status']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  next_activity_due_at?: Maybe<Scalars['timestamptz']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  origin_enquiry_id?: Maybe<Scalars['uuid']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  owner_team_id?: Maybe<Scalars['uuid']['output']>;
  /** Set only on leads born from an enquiry to an agent's public profile, together with owner_team_id and origin_enquiry_id. Not who holds the lead: see lead_agents. */
  owner_user_id?: Maybe<Scalars['uuid']['output']>;
  ownership?: Maybe<Scalars['lead_ownership']['output']>;
  parent_lead_id?: Maybe<Scalars['uuid']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_date_of_birth?: Maybe<Scalars['date']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_first_name?: Maybe<Scalars['String']['output']>;
  partner_gender?: Maybe<Scalars['String']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_last_name?: Maybe<Scalars['String']['output']>;
  partner_marital_status?: Maybe<Scalars['String']['output']>;
  partner_nationality_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_id?: Maybe<Scalars['uuid']['output']>;
  partner_occupation_text?: Maybe<Scalars['String']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  partner_residence_country_code?: Maybe<Scalars['String']['output']>;
  partner_residence_state_id?: Maybe<Scalars['uuid']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  partner_work_permit_id?: Maybe<Scalars['uuid']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  predicted_listing_date?: Maybe<Scalars['timestamptz']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_search_notification?: Maybe<Scalars['property_searches_notification']['output']>;
  purchase_date?: Maybe<Scalars['date']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  refused_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  requalified_or_created_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  sale_comments?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  second_contact_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  source_organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** Deprecated: the column was dropped. A lead has one stage per agent assignment; this returns the stage of the single agent broker_id picks. Not indexed: use lead_agents.stage_id with lead_stages.status. */
  stage_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  user_info_ip?: Maybe<Scalars['String']['output']>;
  user_info_user_agent?: Maybe<Scalars['String']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by min() on columns of table "leads" */
export type Leads_Min_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  anonymized_contact?: InputMaybe<Order_By>;
  appraisal_inheritance_next_step?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_next_step?: InputMaybe<Order_By>;
  appraisal_open_to_offer?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_country?: InputMaybe<Order_By>;
  appraisal_property_country_code?: InputMaybe<Order_By>;
  appraisal_property_ctn?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_google_address_id?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_locality?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_occupied?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_plot_number?: InputMaybe<Order_By>;
  appraisal_property_postcode?: InputMaybe<Order_By>;
  appraisal_property_property_type_id?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_route?: InputMaybe<Order_By>;
  appraisal_property_state?: InputMaybe<Order_By>;
  appraisal_property_street_number?: InputMaybe<Order_By>;
  appraisal_property_usage?: InputMaybe<Order_By>;
  appraisal_selling_with?: InputMaybe<Order_By>;
  appraisal_separation_next_step?: InputMaybe<Order_By>;
  appraisal_step?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  contact_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  /** Who created the lead: the agent for a lead entered in the CRM, the owner for a self-service valuation. Not who holds it: see lead_agents. */
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  last_activity_done_at?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_requalification_mail_sent_at?: InputMaybe<Order_By>;
  last_requalification_sms_sent_at?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  /** Attribution snapshot captured when the lead was created (api upsertLead / valuation-studio); NULL for older leads and server-side writers */
  marketing_metadata_id?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_buying_status?: InputMaybe<Order_By>;
  mortgage_status?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  next_activity_due_at?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  origin_enquiry_id?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  owner_team_id?: InputMaybe<Order_By>;
  /** Set only on leads born from an enquiry to an agent's public profile, together with owner_team_id and origin_enquiry_id. Not who holds the lead: see lead_agents. */
  owner_user_id?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  parent_lead_id?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_date_of_birth?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_first_name?: InputMaybe<Order_By>;
  partner_gender?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_last_name?: InputMaybe<Order_By>;
  partner_marital_status?: InputMaybe<Order_By>;
  partner_nationality_id?: InputMaybe<Order_By>;
  partner_occupation_id?: InputMaybe<Order_By>;
  partner_occupation_text?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_professional_situation?: InputMaybe<Order_By>;
  partner_residence_country_code?: InputMaybe<Order_By>;
  partner_residence_state_id?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_third_pillar_a_organisation?: InputMaybe<Order_By>;
  partner_work_permit_id?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  predicted_listing_date?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  purchase_date?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  refused_at?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  requalified_or_created_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  sale_comments?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_contact_id?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_organisation_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  user_info_ip?: InputMaybe<Order_By>;
  user_info_user_agent?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "leads" */
export type Leads_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Leads>;
};

/** input type for inserting object relation for remote table "leads" */
export type Leads_Obj_Rel_Insert_Input = {
  data: Leads_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};

/** on_conflict condition type for table "leads" */
export type Leads_On_Conflict = {
  constraint: Leads_Constraint;
  update_columns?: Array<Leads_Update_Column>;
  where?: InputMaybe<Leads_Bool_Exp>;
};

/** Ordering options when selecting data from "leads". */
export type Leads_Order_By = {
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  annual_premium?: InputMaybe<Order_By>;
  anonymized_contact?: InputMaybe<Order_By>;
  appraisal_inheritance_next_step?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_next_step?: InputMaybe<Order_By>;
  appraisal_open_to_offer?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_country?: InputMaybe<Order_By>;
  appraisal_property_country_code?: InputMaybe<Order_By>;
  appraisal_property_ctn?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_google_address_id?: InputMaybe<Order_By>;
  appraisal_property_has_elevator?: InputMaybe<Order_By>;
  appraisal_property_has_garden?: InputMaybe<Order_By>;
  appraisal_property_has_storage_room?: InputMaybe<Order_By>;
  appraisal_property_has_swimming_pool?: InputMaybe<Order_By>;
  appraisal_property_has_view?: InputMaybe<Order_By>;
  appraisal_property_income_includes_parking?: InputMaybe<Order_By>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Order_By>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Order_By>;
  appraisal_property_is_renovated?: InputMaybe<Order_By>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Order_By>;
  appraisal_property_know_plot_number?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_locality?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_occupied?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_plot_number?: InputMaybe<Order_By>;
  appraisal_property_postcode?: InputMaybe<Order_By>;
  appraisal_property_property_type_id?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_route?: InputMaybe<Order_By>;
  appraisal_property_side?: InputMaybe<Order_By>;
  appraisal_property_state?: InputMaybe<Order_By>;
  appraisal_property_street_number?: InputMaybe<Order_By>;
  appraisal_property_usage?: InputMaybe<Order_By>;
  appraisal_reason?: InputMaybe<Order_By>;
  appraisal_selling_with?: InputMaybe<Order_By>;
  appraisal_separation_next_step?: InputMaybe<Order_By>;
  appraisal_step?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buy_horizon?: InputMaybe<Order_By>;
  call_times?: InputMaybe<Order_By>;
  claimed_by?: InputMaybe<Order_By>;
  cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Order_By>;
  completed?: InputMaybe<Order_By>;
  contact?: InputMaybe<Users_Order_By>;
  contact_id?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Users_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  google_address?: InputMaybe<Google_Addresses_Order_By>;
  has_accepted_terms?: InputMaybe<Order_By>;
  has_dependant_children?: InputMaybe<Order_By>;
  has_no_street_number?: InputMaybe<Order_By>;
  has_other_credits?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  last_activity_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  last_activity_done_at?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  last_requalification_mail_sent_at?: InputMaybe<Order_By>;
  last_requalification_sms_sent_at?: InputMaybe<Order_By>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Order_By>;
  leads_acls_aggregate?: InputMaybe<Leads_Acl_Aggregate_Order_By>;
  leads_tags_aggregate?: InputMaybe<Leads_Tags_Aggregate_Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  market_update_subscribed?: InputMaybe<Order_By>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Order_By>;
  marketing_metadata_id?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  mortgage_buying_status?: InputMaybe<Order_By>;
  mortgage_status?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  next_activity_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  next_activity_due_at?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  origin_enquiry?: InputMaybe<Enquiries_Order_By>;
  origin_enquiry_id?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  owner_team?: InputMaybe<Teams_Order_By>;
  owner_team_id?: InputMaybe<Order_By>;
  owner_user?: InputMaybe<Users_Order_By>;
  owner_user_id?: InputMaybe<Order_By>;
  ownership?: InputMaybe<Order_By>;
  parent_lead_id?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_date_of_birth?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_first_name?: InputMaybe<Order_By>;
  partner_gender?: InputMaybe<Order_By>;
  partner_has_other_credits?: InputMaybe<Order_By>;
  partner_has_third_pillar?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_last_name?: InputMaybe<Order_By>;
  partner_marital_status?: InputMaybe<Order_By>;
  partner_nationality_id?: InputMaybe<Order_By>;
  partner_occupation_id?: InputMaybe<Order_By>;
  partner_occupation_text?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_professional_situation?: InputMaybe<Order_By>;
  partner_residence_country_code?: InputMaybe<Order_By>;
  partner_residence_state_id?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_third_pillar_a_organisation?: InputMaybe<Order_By>;
  partner_use_bank_third_pillar?: InputMaybe<Order_By>;
  partner_use_insurance_third_pillar?: InputMaybe<Order_By>;
  partner_work_permit_id?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  potential_development?: InputMaybe<Order_By>;
  predicted_listing_date?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  profile_contact?: InputMaybe<Profile_Enquiry_Contacts_View_Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_search_notification?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_usage?: InputMaybe<Order_By>;
  purchase_date?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  received_mortgage_offer?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  refused_at?: InputMaybe<Order_By>;
  relationship?: InputMaybe<Order_By>;
  requalification_email_subscribed?: InputMaybe<Order_By>;
  requalification_sms_subscribed?: InputMaybe<Order_By>;
  requalification_status?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  requalified_or_created_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  sale_comments?: InputMaybe<Order_By>;
  sale_has_found?: InputMaybe<Order_By>;
  sale_horizon?: InputMaybe<Order_By>;
  sale_is_seller?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_started?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_contact?: InputMaybe<Users_Order_By>;
  second_contact_id?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  should_be_requalified?: InputMaybe<Order_By>;
  snapshot?: InputMaybe<Order_By>;
  source?: InputMaybe<Dictionaries_Order_By>;
  source_id?: InputMaybe<Order_By>;
  source_organisation_id?: InputMaybe<Order_By>;
  stage_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  use_bank_third_pillar?: InputMaybe<Order_By>;
  use_insurance_third_pillar?: InputMaybe<Order_By>;
  use_second_pillar?: InputMaybe<Order_By>;
  use_third_pillar?: InputMaybe<Order_By>;
  user_info_ip?: InputMaybe<Order_By>;
  user_info_user_agent?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** primary key columns input for table: leads */
export type Leads_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

export enum Leads_Property_Usage_Enum {
  NotSet = 'not_set',
  Other = 'other',
  PrimaryResidence = 'primary_residence',
  RentalProperty = 'rental_property',
  SecondaryResidence = 'secondary_residence'
}

/** Boolean expression to compare columns of type "leads_property_usage_enum". All fields are combined with logical 'AND'. */
export type Leads_Property_Usage_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Property_Usage_Enum>;
  _in?: InputMaybe<Array<Leads_Property_Usage_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Property_Usage_Enum>;
  _nin?: InputMaybe<Array<Leads_Property_Usage_Enum>>;
};

export enum Leads_Relationship_Enum {
  Agent = 'agent',
  Buyer = 'buyer',
  Heir = 'heir',
  NotSet = 'not_set',
  Other = 'other',
  Owner = 'owner',
  PastOwner = 'past_owner',
  Tenant = 'tenant'
}

/** Boolean expression to compare columns of type "leads_relationship_enum". All fields are combined with logical 'AND'. */
export type Leads_Relationship_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Relationship_Enum>;
  _in?: InputMaybe<Array<Leads_Relationship_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Relationship_Enum>;
  _nin?: InputMaybe<Array<Leads_Relationship_Enum>>;
};

export enum Leads_Requalification_Status_Enum {
  NotSet = 'not_set',
  Started = 'started'
}

/** Boolean expression to compare columns of type "leads_requalification_status_enum". All fields are combined with logical 'AND'. */
export type Leads_Requalification_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Requalification_Status_Enum>;
  _in?: InputMaybe<Array<Leads_Requalification_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Requalification_Status_Enum>;
  _nin?: InputMaybe<Array<Leads_Requalification_Status_Enum>>;
};

export enum Leads_Sale_Horizon_Enum {
  AlreadyForSale = 'already_for_sale',
  From_1To_2Years = 'from_1_to_2_years',
  From_2Years = 'from_2_years',
  From_6To_12Months = 'from_6_to_12_months',
  NotSelling = 'not_selling',
  NotSet = 'not_set',
  Under_6Months = 'under_6_months'
}

/** Boolean expression to compare columns of type "leads_sale_horizon_enum". All fields are combined with logical 'AND'. */
export type Leads_Sale_Horizon_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Sale_Horizon_Enum>;
  _in?: InputMaybe<Array<Leads_Sale_Horizon_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Sale_Horizon_Enum>;
  _nin?: InputMaybe<Array<Leads_Sale_Horizon_Enum>>;
};

/** select columns of table "leads" */
export enum Leads_Select_Column {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AnonymizedContact = 'anonymized_contact',
  /** column name */
  AppraisalInheritanceNextStep = 'appraisal_inheritance_next_step',
  /** column name */
  AppraisalMarketTime = 'appraisal_market_time',
  /** column name */
  AppraisalMonthlyGrossRent = 'appraisal_monthly_gross_rent',
  /** column name */
  AppraisalNextStep = 'appraisal_next_step',
  /** column name */
  AppraisalOpenToOffer = 'appraisal_open_to_offer',
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  AppraisalPerception = 'appraisal_perception',
  /** column name */
  AppraisalPropertyBalconySurface = 'appraisal_property_balcony_surface',
  /** column name */
  AppraisalPropertyBuiltSurface = 'appraisal_property_built_surface',
  /** column name */
  AppraisalPropertyCommercialPotentialRentalIncome = 'appraisal_property_commercial_potential_rental_income',
  /** column name */
  AppraisalPropertyCommercialSurface = 'appraisal_property_commercial_surface',
  /** column name */
  AppraisalPropertyCommercialYearlyRentalIncome = 'appraisal_property_commercial_yearly_rental_income',
  /** column name */
  AppraisalPropertyConstructionYear = 'appraisal_property_construction_year',
  /** column name */
  AppraisalPropertyCountry = 'appraisal_property_country',
  /** column name */
  AppraisalPropertyCountryCode = 'appraisal_property_country_code',
  /** column name */
  AppraisalPropertyCtn = 'appraisal_property_ctn',
  /** column name */
  AppraisalPropertyFloorOfFlat = 'appraisal_property_floor_of_flat',
  /** column name */
  AppraisalPropertyGardenSurface = 'appraisal_property_garden_surface',
  /** column name */
  AppraisalPropertyGoogleAddressId = 'appraisal_property_google_address_id',
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  AppraisalPropertyLandSurface = 'appraisal_property_land_surface',
  /** column name */
  AppraisalPropertyLat = 'appraisal_property_lat',
  /** column name */
  AppraisalPropertyLivingSurface = 'appraisal_property_living_surface',
  /** column name */
  AppraisalPropertyLng = 'appraisal_property_lng',
  /** column name */
  AppraisalPropertyLocality = 'appraisal_property_locality',
  /** column name */
  AppraisalPropertyNumberOfBathrooms = 'appraisal_property_number_of_bathrooms',
  /** column name */
  AppraisalPropertyNumberOfBedrooms = 'appraisal_property_number_of_bedrooms',
  /** column name */
  AppraisalPropertyNumberOfCommercialUnits = 'appraisal_property_number_of_commercial_units',
  /** column name */
  AppraisalPropertyNumberOfFloors = 'appraisal_property_number_of_floors',
  /** column name */
  AppraisalPropertyNumberOfIndoorParkings = 'appraisal_property_number_of_indoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfOutdoorParkings = 'appraisal_property_number_of_outdoor_parkings',
  /** column name */
  AppraisalPropertyNumberOfResidentialUnits = 'appraisal_property_number_of_residential_units',
  /** column name */
  AppraisalPropertyNumberOfRooms = 'appraisal_property_number_of_rooms',
  /** column name */
  AppraisalPropertyOccupied = 'appraisal_property_occupied',
  /** column name */
  AppraisalPropertyParkingPotentialRentalIncome = 'appraisal_property_parking_potential_rental_income',
  /** column name */
  AppraisalPropertyParkingYearlyRentalIncome = 'appraisal_property_parking_yearly_rental_income',
  /** column name */
  AppraisalPropertyPlotNumber = 'appraisal_property_plot_number',
  /** column name */
  AppraisalPropertyPostcode = 'appraisal_property_postcode',
  /** column name */
  AppraisalPropertyPropertyTypeId = 'appraisal_property_property_type_id',
  /** column name */
  AppraisalPropertyRenovationYear = 'appraisal_property_renovation_year',
  /** column name */
  AppraisalPropertyResidentialPotentialRentalIncome = 'appraisal_property_residential_potential_rental_income',
  /** column name */
  AppraisalPropertyResidentialSurface = 'appraisal_property_residential_surface',
  /** column name */
  AppraisalPropertyResidentialYearlyRentalIncome = 'appraisal_property_residential_yearly_rental_income',
  /** column name */
  AppraisalPropertyRoute = 'appraisal_property_route',
  /** column name */
  AppraisalPropertySide = 'appraisal_property_side',
  /** column name */
  AppraisalPropertyState = 'appraisal_property_state',
  /** column name */
  AppraisalPropertyStreetNumber = 'appraisal_property_street_number',
  /** column name */
  AppraisalPropertyUsage = 'appraisal_property_usage',
  /** column name */
  AppraisalReason = 'appraisal_reason',
  /** column name */
  AppraisalSellingWith = 'appraisal_selling_with',
  /** column name */
  AppraisalSeparationNextStep = 'appraisal_separation_next_step',
  /** column name */
  AppraisalStep = 'appraisal_step',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  BuyHorizon = 'buy_horizon',
  /** column name */
  CallTimes = 'call_times',
  /** column name */
  Completed = 'completed',
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  LastActivityDoneAt = 'last_activity_done_at',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LastRequalificationMailSentAt = 'last_requalification_mail_sent_at',
  /** column name */
  LastRequalificationSmsSentAt = 'last_requalification_sms_sent_at',
  /** column name */
  MandateProbability = 'mandate_probability',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MarketUpdateSubscribed = 'market_update_subscribed',
  /** column name */
  MarketingMetadataId = 'marketing_metadata_id',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  MortgageBuyingStatus = 'mortgage_buying_status',
  /** column name */
  MortgageStatus = 'mortgage_status',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NextActivityDueAt = 'next_activity_due_at',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  OriginEnquiryId = 'origin_enquiry_id',
  /** column name */
  OtherCredits = 'other_credits',
  /** column name */
  OwnerTeamId = 'owner_team_id',
  /** column name */
  OwnerUserId = 'owner_user_id',
  /** column name */
  Ownership = 'ownership',
  /** column name */
  ParentLeadId = 'parent_lead_id',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDateOfBirth = 'partner_date_of_birth',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerFirstName = 'partner_first_name',
  /** column name */
  PartnerGender = 'partner_gender',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerLastName = 'partner_last_name',
  /** column name */
  PartnerMaritalStatus = 'partner_marital_status',
  /** column name */
  PartnerNationalityId = 'partner_nationality_id',
  /** column name */
  PartnerOccupationId = 'partner_occupation_id',
  /** column name */
  PartnerOccupationText = 'partner_occupation_text',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerProfessionalSituation = 'partner_professional_situation',
  /** column name */
  PartnerResidenceCountryCode = 'partner_residence_country_code',
  /** column name */
  PartnerResidenceStateId = 'partner_residence_state_id',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerThirdPillarAOrganisation = 'partner_third_pillar_a_organisation',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PartnerWorkPermitId = 'partner_work_permit_id',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  PredictedListingDate = 'predicted_listing_date',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertySearchNotification = 'property_search_notification',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  PurchaseDate = 'purchase_date',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RefusedAt = 'refused_at',
  /** column name */
  Relationship = 'relationship',
  /** column name */
  RequalificationEmailSubscribed = 'requalification_email_subscribed',
  /** column name */
  RequalificationSmsSubscribed = 'requalification_sms_subscribed',
  /** column name */
  RequalificationStatus = 'requalification_status',
  /** column name */
  RequalifiedAt = 'requalified_at',
  /** column name */
  RequalifiedOrCreatedAt = 'requalified_or_created_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SaleComments = 'sale_comments',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleHorizon = 'sale_horizon',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondContactId = 'second_contact_id',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Snapshot = 'snapshot',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  SourceOrganisationId = 'source_organisation_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  UserInfoIp = 'user_info_ip',
  /** column name */
  UserInfoUserAgent = 'user_info_user_agent',
  /** column name */
  Verified = 'verified',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_avg_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_bool_and_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MarketUpdateSubscribed = 'market_update_subscribed',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  RequalificationEmailSubscribed = 'requalification_email_subscribed',
  /** column name */
  RequalificationSmsSubscribed = 'requalification_sms_subscribed',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

/** select "leads_aggregate_bool_exp_bool_or_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AppraisalPropertyHasElevator = 'appraisal_property_has_elevator',
  /** column name */
  AppraisalPropertyHasGarden = 'appraisal_property_has_garden',
  /** column name */
  AppraisalPropertyHasStorageRoom = 'appraisal_property_has_storage_room',
  /** column name */
  AppraisalPropertyHasSwimmingPool = 'appraisal_property_has_swimming_pool',
  /** column name */
  AppraisalPropertyHasView = 'appraisal_property_has_view',
  /** column name */
  AppraisalPropertyIncomeIncludesParking = 'appraisal_property_income_includes_parking',
  /** column name */
  AppraisalPropertyIsCommercialFullyRented = 'appraisal_property_is_commercial_fully_rented',
  /** column name */
  AppraisalPropertyIsParkingFullyRented = 'appraisal_property_is_parking_fully_rented',
  /** column name */
  AppraisalPropertyIsRenovated = 'appraisal_property_is_renovated',
  /** column name */
  AppraisalPropertyIsResidentialFullyRented = 'appraisal_property_is_residential_fully_rented',
  /** column name */
  AppraisalPropertyKnowPlotNumber = 'appraisal_property_know_plot_number',
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasDependantChildren = 'has_dependant_children',
  /** column name */
  HasNoStreetNumber = 'has_no_street_number',
  /** column name */
  HasOtherCredits = 'has_other_credits',
  /** column name */
  MarketUpdateSubscribed = 'market_update_subscribed',
  /** column name */
  PartnerHasOtherCredits = 'partner_has_other_credits',
  /** column name */
  PartnerHasThirdPillar = 'partner_has_third_pillar',
  /** column name */
  PartnerUseBankThirdPillar = 'partner_use_bank_third_pillar',
  /** column name */
  PartnerUseInsuranceThirdPillar = 'partner_use_insurance_third_pillar',
  /** column name */
  PotentialDevelopment = 'potential_development',
  /** column name */
  ReceivedMortgageOffer = 'received_mortgage_offer',
  /** column name */
  RequalificationEmailSubscribed = 'requalification_email_subscribed',
  /** column name */
  RequalificationSmsSubscribed = 'requalification_sms_subscribed',
  /** column name */
  SaleHasFound = 'sale_has_found',
  /** column name */
  SaleIsSeller = 'sale_is_seller',
  /** column name */
  SaleStarted = 'sale_started',
  /** column name */
  UseBankThirdPillar = 'use_bank_third_pillar',
  /** column name */
  UseInsuranceThirdPillar = 'use_insurance_third_pillar',
  /** column name */
  UseSecondPillar = 'use_second_pillar',
  /** column name */
  UseThirdPillar = 'use_third_pillar',
  /** column name */
  Verified = 'verified'
}

/** select "leads_aggregate_bool_exp_corr_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_max_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_min_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_sum_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "leads_aggregate_bool_exp_var_samp_arguments_columns" columns of table "leads" */
export enum Leads_Select_Column_Leads_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AnnualPremium = 'annual_premium',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  Debt = 'debt',
  /** column name */
  Donation = 'donation',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  MaxPropertyValue = 'max_property_value',
  /** column name */
  PartnerAnnualPremium = 'partner_annual_premium',
  /** column name */
  PartnerDonation = 'partner_donation',
  /** column name */
  PartnerLastBonus = 'partner_last_bonus',
  /** column name */
  PartnerOtherCredits = 'partner_other_credits',
  /** column name */
  PartnerSavings = 'partner_savings',
  /** column name */
  PartnerSecondPillar = 'partner_second_pillar',
  /** column name */
  PartnerThirdPillar = 'partner_third_pillar',
  /** column name */
  PartnerYearlyRevenues = 'partner_yearly_revenues',
  /** column name */
  PartnerYearlyRevenuesAtRetirement = 'partner_yearly_revenues_at_retirement',
  /** column name */
  Savings = 'savings',
  /** column name */
  SecondPillar = 'second_pillar',
  /** column name */
  ThirdPillar = 'third_pillar',
  /** column name */
  UsableOwnFunds = 'usable_own_funds',
  /** column name */
  YearlyRevenues = 'yearly_revenues',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** input type for updating data in table "leads" */
export type Leads_Set_Input = {
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  market_update_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_date?: InputMaybe<Scalars['date']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  requalification_email_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  requalification_sms_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "leads_status" */
export type Leads_Status = {
  /** A computed field, executes function "leads_status_label" */
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "leads_status". All fields are combined with a logical 'AND'. */
export type Leads_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Status_Bool_Exp>>;
  _not?: InputMaybe<Leads_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Status_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Leads_Status_Enum {
  Active = 'active',
  Lost = 'lost',
  Won = 'won'
}

/** Boolean expression to compare columns of type "leads_status_enum". All fields are combined with logical 'AND'. */
export type Leads_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Leads_Status_Enum>;
  _in?: InputMaybe<Array<Leads_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Leads_Status_Enum>;
  _nin?: InputMaybe<Array<Leads_Status_Enum>>;
};

/** Ordering options when selecting data from "leads_status". */
export type Leads_Status_Order_By = {
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "leads_status" */
export enum Leads_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "leads_status" */
export type Leads_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Leads_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Leads_Status_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Leads_Stddev_Fields = {
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "leads" */
export type Leads_Stddev_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Leads_Stddev_Pop_Fields = {
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "leads" */
export type Leads_Stddev_Pop_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Leads_Stddev_Samp_Fields = {
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "leads" */
export type Leads_Stddev_Samp_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "leads" */
export type Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Leads_Stream_Cursor_Value_Input = {
  annual_premium?: InputMaybe<Scalars['float8']['input']>;
  anonymized_contact?: InputMaybe<Scalars['String']['input']>;
  appraisal_inheritance_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_market_time?: InputMaybe<Scalars['Int']['input']>;
  appraisal_monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  appraisal_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_open_to_offer?: InputMaybe<Scalars['String']['input']>;
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  appraisal_perception?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_built_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_construction_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_country?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_country_code?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_ctn?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_garden_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_has_view?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_renovated?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_know_plot_number?: InputMaybe<Scalars['Boolean']['input']>;
  appraisal_property_land_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lat?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_living_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_lng?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_locality?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_occupied?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_plot_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_postcode?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  appraisal_property_renovation_year?: InputMaybe<Scalars['Int']['input']>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_surface?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  appraisal_property_route?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_side?: InputMaybe<Property_Side_Enum_Enum>;
  appraisal_property_state?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_street_number?: InputMaybe<Scalars['String']['input']>;
  appraisal_property_usage?: InputMaybe<Scalars['String']['input']>;
  appraisal_reason?: InputMaybe<Leads_Appraisal_Reason_Enum>;
  appraisal_selling_with?: InputMaybe<Scalars['String']['input']>;
  appraisal_separation_next_step?: InputMaybe<Scalars['String']['input']>;
  appraisal_step?: InputMaybe<Scalars['String']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  buy_horizon?: InputMaybe<Leads_Buy_Horizon_Enum>;
  call_times?: InputMaybe<Array<Scalars['String']['input']>>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Who created the lead: the agent for a lead entered in the CRM, the owner for a self-service valuation. Not who holds it: see lead_agents. */
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['float8']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_dependant_children?: InputMaybe<Scalars['Boolean']['input']>;
  has_no_street_number?: InputMaybe<Scalars['Boolean']['input']>;
  has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  last_activity_done_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  last_requalification_mail_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_requalification_sms_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  mandate_probability?: InputMaybe<Scalars['Int']['input']>;
  marital_status?: InputMaybe<Scalars['String']['input']>;
  market_update_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribution snapshot captured when the lead was created (api upsertLead / valuation-studio); NULL for older leads and server-side writers */
  marketing_metadata_id?: InputMaybe<Scalars['uuid']['input']>;
  max_property_value?: InputMaybe<Scalars['float8']['input']>;
  mortgage_buying_status?: InputMaybe<Scalars['lead_buying_status']['input']>;
  mortgage_status?: InputMaybe<Scalars['lead_mortgage_status']['input']>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  next_activity_due_at?: InputMaybe<Scalars['timestamptz']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  origin_enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  other_credits?: InputMaybe<Scalars['Int']['input']>;
  owner_team_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Set only on leads born from an enquiry to an agent's public profile, together with owner_team_id and origin_enquiry_id. Not who holds the lead: see lead_agents. */
  owner_user_id?: InputMaybe<Scalars['uuid']['input']>;
  ownership?: InputMaybe<Scalars['lead_ownership']['input']>;
  parent_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_annual_premium?: InputMaybe<Scalars['float8']['input']>;
  partner_date_of_birth?: InputMaybe<Scalars['date']['input']>;
  partner_donation?: InputMaybe<Scalars['float8']['input']>;
  partner_first_name?: InputMaybe<Scalars['String']['input']>;
  partner_gender?: InputMaybe<Scalars['String']['input']>;
  partner_has_other_credits?: InputMaybe<Scalars['Boolean']['input']>;
  partner_has_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_last_bonus?: InputMaybe<Scalars['float8']['input']>;
  partner_last_name?: InputMaybe<Scalars['String']['input']>;
  partner_marital_status?: InputMaybe<Scalars['String']['input']>;
  partner_nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_occupation_text?: InputMaybe<Scalars['String']['input']>;
  partner_other_credits?: InputMaybe<Scalars['float8']['input']>;
  partner_professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  partner_residence_country_code?: InputMaybe<Scalars['String']['input']>;
  partner_residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_savings?: InputMaybe<Scalars['float8']['input']>;
  partner_second_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar?: InputMaybe<Scalars['float8']['input']>;
  partner_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  partner_use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  partner_work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  partner_yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  potential_development?: InputMaybe<Scalars['Boolean']['input']>;
  predicted_listing_date?: InputMaybe<Scalars['timestamptz']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search_notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  property_usage?: InputMaybe<Leads_Property_Usage_Enum>;
  purchase_date?: InputMaybe<Scalars['date']['input']>;
  purchase_price?: InputMaybe<Scalars['Int']['input']>;
  received_mortgage_offer?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  refused_at?: InputMaybe<Scalars['timestamptz']['input']>;
  relationship?: InputMaybe<Leads_Relationship_Enum>;
  requalification_email_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  requalification_sms_subscribed?: InputMaybe<Scalars['Boolean']['input']>;
  requalification_status?: InputMaybe<Leads_Requalification_Status_Enum>;
  requalified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  requalified_or_created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_comments?: InputMaybe<Scalars['String']['input']>;
  sale_has_found?: InputMaybe<Scalars['Boolean']['input']>;
  sale_horizon?: InputMaybe<Leads_Sale_Horizon_Enum>;
  /** Legacy: no current code writes it, and it was last set in 2022 (NULL on nearly every lead). Do not use it; for seller leads see appraisal_reason and completed. */
  sale_is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  sale_price?: InputMaybe<Scalars['Int']['input']>;
  sale_started?: InputMaybe<Scalars['Boolean']['input']>;
  savings?: InputMaybe<Scalars['float8']['input']>;
  second_contact_id?: InputMaybe<Scalars['uuid']['input']>;
  second_pillar?: InputMaybe<Scalars['float8']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  snapshot?: InputMaybe<Scalars['jsonb']['input']>;
  source_id?: InputMaybe<Scalars['uuid']['input']>;
  source_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar?: InputMaybe<Scalars['float8']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_own_funds?: InputMaybe<Scalars['float8']['input']>;
  use_bank_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_insurance_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_second_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  use_third_pillar?: InputMaybe<Scalars['Boolean']['input']>;
  user_info_ip?: InputMaybe<Scalars['String']['input']>;
  user_info_user_agent?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  yearly_revenues?: InputMaybe<Scalars['float8']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregate sum on columns */
export type Leads_Sum_Fields = {
  annual_premium?: Maybe<Scalars['float8']['output']>;
  appraisal_market_time?: Maybe<Scalars['Int']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Int']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Int']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['float8']['output']>;
  debt?: Maybe<Scalars['float8']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  mandate_probability?: Maybe<Scalars['Int']['output']>;
  max_property_value?: Maybe<Scalars['float8']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  other_credits?: Maybe<Scalars['Int']['output']>;
  partner_annual_premium?: Maybe<Scalars['float8']['output']>;
  partner_donation?: Maybe<Scalars['float8']['output']>;
  partner_last_bonus?: Maybe<Scalars['float8']['output']>;
  partner_other_credits?: Maybe<Scalars['float8']['output']>;
  partner_savings?: Maybe<Scalars['float8']['output']>;
  partner_second_pillar?: Maybe<Scalars['float8']['output']>;
  partner_third_pillar?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['float8']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  sale_price?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['float8']['output']>;
  second_pillar?: Maybe<Scalars['float8']['output']>;
  third_pillar?: Maybe<Scalars['float8']['output']>;
  usable_own_funds?: Maybe<Scalars['float8']['output']>;
  yearly_revenues?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "leads" */
export type Leads_Sum_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Tags put on a lead (lead_id -> leads). The tag is a dictionaries row (dictionary_id), which carries its label. */
export type Leads_Tags = {
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** An object relationship */
  dictionary?: Maybe<Dictionaries>;
  dictionary_id: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "leads_tags" */
export type Leads_Tags_Aggregate = {
  aggregate?: Maybe<Leads_Tags_Aggregate_Fields>;
  nodes: Array<Leads_Tags>;
};

export type Leads_Tags_Aggregate_Bool_Exp = {
  count?: InputMaybe<Leads_Tags_Aggregate_Bool_Exp_Count>;
};

export type Leads_Tags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Leads_Tags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "leads_tags" */
export type Leads_Tags_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Leads_Tags_Max_Fields>;
  min?: Maybe<Leads_Tags_Min_Fields>;
};


/** aggregate fields of "leads_tags" */
export type Leads_Tags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "leads_tags" */
export type Leads_Tags_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Leads_Tags_Max_Order_By>;
  min?: InputMaybe<Leads_Tags_Min_Order_By>;
};

/** input type for inserting array relation for remote table "leads_tags" */
export type Leads_Tags_Arr_Rel_Insert_Input = {
  data: Array<Leads_Tags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Leads_Tags_On_Conflict>;
};

/** Boolean expression to filter rows from the table "leads_tags". All fields are combined with a logical 'AND'. */
export type Leads_Tags_Bool_Exp = {
  _and?: InputMaybe<Array<Leads_Tags_Bool_Exp>>;
  _not?: InputMaybe<Leads_Tags_Bool_Exp>;
  _or?: InputMaybe<Array<Leads_Tags_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  dictionary?: InputMaybe<Dictionaries_Bool_Exp>;
  dictionary_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "leads_tags" */
export enum Leads_Tags_Constraint {
  /** unique or primary key constraint on columns "id" */
  LeadsTagsPkey = 'leads_tags_pkey',
  /** unique or primary key constraint on columns "lead_id", "dictionary_id", "tenant_id" */
  LeadsTagsUnique = 'leads_tags_unique'
}

/** input type for inserting data into table "leads_tags" */
export type Leads_Tags_Insert_Input = {
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  dictionary?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  dictionary_id?: InputMaybe<Scalars['uuid']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Leads_Tags_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  dictionary_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "leads_tags" */
export type Leads_Tags_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  dictionary_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Leads_Tags_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  dictionary_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "leads_tags" */
export type Leads_Tags_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  dictionary_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "leads_tags" */
export type Leads_Tags_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Leads_Tags>;
};

/** on_conflict condition type for table "leads_tags" */
export type Leads_Tags_On_Conflict = {
  constraint: Leads_Tags_Constraint;
  update_columns?: Array<Leads_Tags_Update_Column>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};

/** Ordering options when selecting data from "leads_tags". */
export type Leads_Tags_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  dictionary?: InputMaybe<Dictionaries_Order_By>;
  dictionary_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "leads_tags" */
export enum Leads_Tags_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DictionaryId = 'dictionary_id',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "leads_tags" */
export type Leads_Tags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Leads_Tags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Leads_Tags_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  dictionary_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** placeholder for update columns of table "leads_tags" (current role has no relevant permissions) */
export enum Leads_Tags_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type Leads_The_Same_Address_Args = {
  p_lead_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "leads" */
export enum Leads_Update_Column {
  /** column name */
  ContactId = 'contact_id',
  /** column name */
  MarketUpdateSubscribed = 'market_update_subscribed',
  /** column name */
  PurchaseDate = 'purchase_date',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  RequalificationEmailSubscribed = 'requalification_email_subscribed',
  /** column name */
  RequalificationSmsSubscribed = 'requalification_sms_subscribed'
}

export type Leads_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Leads_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Leads_Set_Input>;
  /** filter the rows which have to be updated */
  where: Leads_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Leads_Var_Pop_Fields = {
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "leads" */
export type Leads_Var_Pop_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Leads_Var_Samp_Fields = {
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "leads" */
export type Leads_Var_Samp_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Leads_Variance_Fields = {
  annual_premium?: Maybe<Scalars['Float']['output']>;
  appraisal_market_time?: Maybe<Scalars['Float']['output']>;
  appraisal_monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_property_balcony_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_built_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_construction_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_floor_of_flat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_garden_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_land_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lat?: Maybe<Scalars['Float']['output']>;
  appraisal_property_living_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_lng?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_commercial_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_floors?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_residential_units?: Maybe<Scalars['Float']['output']>;
  appraisal_property_number_of_rooms?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_renovation_year?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_surface?: Maybe<Scalars['Float']['output']>;
  appraisal_property_residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  mandate_probability?: Maybe<Scalars['Float']['output']>;
  max_property_value?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  other_credits?: Maybe<Scalars['Float']['output']>;
  partner_annual_premium?: Maybe<Scalars['Float']['output']>;
  partner_donation?: Maybe<Scalars['Float']['output']>;
  partner_last_bonus?: Maybe<Scalars['Float']['output']>;
  partner_other_credits?: Maybe<Scalars['Float']['output']>;
  partner_savings?: Maybe<Scalars['Float']['output']>;
  partner_second_pillar?: Maybe<Scalars['Float']['output']>;
  partner_third_pillar?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues?: Maybe<Scalars['Float']['output']>;
  partner_yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  savings?: Maybe<Scalars['Float']['output']>;
  second_pillar?: Maybe<Scalars['Float']['output']>;
  third_pillar?: Maybe<Scalars['Float']['output']>;
  usable_own_funds?: Maybe<Scalars['Float']['output']>;
  yearly_revenues?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "leads" */
export type Leads_Variance_Order_By = {
  annual_premium?: InputMaybe<Order_By>;
  appraisal_market_time?: InputMaybe<Order_By>;
  appraisal_monthly_gross_rent?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_property_balcony_surface?: InputMaybe<Order_By>;
  appraisal_property_built_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_commercial_surface?: InputMaybe<Order_By>;
  appraisal_property_commercial_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_construction_year?: InputMaybe<Order_By>;
  appraisal_property_floor_of_flat?: InputMaybe<Order_By>;
  appraisal_property_garden_surface?: InputMaybe<Order_By>;
  appraisal_property_land_surface?: InputMaybe<Order_By>;
  appraisal_property_lat?: InputMaybe<Order_By>;
  appraisal_property_living_surface?: InputMaybe<Order_By>;
  appraisal_property_lng?: InputMaybe<Order_By>;
  appraisal_property_number_of_bathrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_bedrooms?: InputMaybe<Order_By>;
  appraisal_property_number_of_commercial_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_floors?: InputMaybe<Order_By>;
  appraisal_property_number_of_indoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_outdoor_parkings?: InputMaybe<Order_By>;
  appraisal_property_number_of_residential_units?: InputMaybe<Order_By>;
  appraisal_property_number_of_rooms?: InputMaybe<Order_By>;
  appraisal_property_parking_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_parking_yearly_rental_income?: InputMaybe<Order_By>;
  appraisal_property_renovation_year?: InputMaybe<Order_By>;
  appraisal_property_residential_potential_rental_income?: InputMaybe<Order_By>;
  appraisal_property_residential_surface?: InputMaybe<Order_By>;
  appraisal_property_residential_yearly_rental_income?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  mandate_probability?: InputMaybe<Order_By>;
  max_property_value?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  other_credits?: InputMaybe<Order_By>;
  partner_annual_premium?: InputMaybe<Order_By>;
  partner_donation?: InputMaybe<Order_By>;
  partner_last_bonus?: InputMaybe<Order_By>;
  partner_other_credits?: InputMaybe<Order_By>;
  partner_savings?: InputMaybe<Order_By>;
  partner_second_pillar?: InputMaybe<Order_By>;
  partner_third_pillar?: InputMaybe<Order_By>;
  partner_yearly_revenues?: InputMaybe<Order_By>;
  partner_yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  savings?: InputMaybe<Order_By>;
  second_pillar?: InputMaybe<Order_By>;
  third_pillar?: InputMaybe<Order_By>;
  usable_own_funds?: InputMaybe<Order_By>;
  yearly_revenues?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** columns and relationships of "local_activity_feed_items" */
export type Local_Activity_Feed_Items = {
  display_name?: Maybe<Scalars['String']['output']>;
  distance_meters?: Maybe<Scalars['float8']['output']>;
  feed_id?: Maybe<Scalars['String']['output']>;
  feed_type?: Maybe<Scalars['String']['output']>;
  listing_currency?: Maybe<Scalars['String']['output']>;
  listing_id?: Maybe<Scalars['uuid']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Int']['output']>;
  listing_offer_type?: Maybe<Scalars['String']['output']>;
  listing_price?: Maybe<Scalars['float8']['output']>;
  listing_title?: Maybe<Scalars['String']['output']>;
  number_of_rooms?: Maybe<Scalars['float8']['output']>;
  occurred_at?: Maybe<Scalars['timestamptz']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_image_url?: Maybe<Scalars['String']['output']>;
  property_locality?: Maybe<Scalars['String']['output']>;
  property_postcode?: Maybe<Scalars['String']['output']>;
  property_route?: Maybe<Scalars['String']['output']>;
  property_street_number?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  property_type_label?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['float8']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  team_agency_slug?: Maybe<Scalars['String']['output']>;
  team_agents_count?: Maybe<Scalars['Int']['output']>;
  team_cover_url?: Maybe<Scalars['String']['output']>;
  team_description?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  team_locality?: Maybe<Scalars['String']['output']>;
  team_logo_url?: Maybe<Scalars['String']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  team_postcode?: Maybe<Scalars['String']['output']>;
  team_route?: Maybe<Scalars['String']['output']>;
  team_slug?: Maybe<Scalars['String']['output']>;
  team_street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_agent_slug?: Maybe<Scalars['String']['output']>;
  user_full_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_image_url?: Maybe<Scalars['String']['output']>;
};

export type Local_Activity_Feed_Items_Aggregate = {
  aggregate?: Maybe<Local_Activity_Feed_Items_Aggregate_Fields>;
  nodes: Array<Local_Activity_Feed_Items>;
};

/** aggregate fields of "local_activity_feed_items" */
export type Local_Activity_Feed_Items_Aggregate_Fields = {
  avg?: Maybe<Local_Activity_Feed_Items_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Local_Activity_Feed_Items_Max_Fields>;
  min?: Maybe<Local_Activity_Feed_Items_Min_Fields>;
  stddev?: Maybe<Local_Activity_Feed_Items_Stddev_Fields>;
  stddev_pop?: Maybe<Local_Activity_Feed_Items_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Local_Activity_Feed_Items_Stddev_Samp_Fields>;
  sum?: Maybe<Local_Activity_Feed_Items_Sum_Fields>;
  var_pop?: Maybe<Local_Activity_Feed_Items_Var_Pop_Fields>;
  var_samp?: Maybe<Local_Activity_Feed_Items_Var_Samp_Fields>;
  variance?: Maybe<Local_Activity_Feed_Items_Variance_Fields>;
};


/** aggregate fields of "local_activity_feed_items" */
export type Local_Activity_Feed_Items_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Local_Activity_Feed_Items_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Local_Activity_Feed_Items_Avg_Fields = {
  distance_meters?: Maybe<Scalars['Float']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Float']['output']>;
  listing_price?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  team_agents_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "local_activity_feed_items". All fields are combined with a logical 'AND'. */
export type Local_Activity_Feed_Items_Bool_Exp = {
  _and?: InputMaybe<Array<Local_Activity_Feed_Items_Bool_Exp>>;
  _not?: InputMaybe<Local_Activity_Feed_Items_Bool_Exp>;
  _or?: InputMaybe<Array<Local_Activity_Feed_Items_Bool_Exp>>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  distance_meters?: InputMaybe<Float8_Comparison_Exp>;
  feed_id?: InputMaybe<String_Comparison_Exp>;
  feed_type?: InputMaybe<String_Comparison_Exp>;
  listing_currency?: InputMaybe<String_Comparison_Exp>;
  listing_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_live_portals_count?: InputMaybe<Int_Comparison_Exp>;
  listing_offer_type?: InputMaybe<String_Comparison_Exp>;
  listing_price?: InputMaybe<Float8_Comparison_Exp>;
  listing_title?: InputMaybe<String_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float8_Comparison_Exp>;
  occurred_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_image_url?: InputMaybe<String_Comparison_Exp>;
  property_locality?: InputMaybe<String_Comparison_Exp>;
  property_postcode?: InputMaybe<String_Comparison_Exp>;
  property_route?: InputMaybe<String_Comparison_Exp>;
  property_street_number?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_type_label?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Float8_Comparison_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_text?: InputMaybe<String_Comparison_Exp>;
  signature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  source_id?: InputMaybe<Uuid_Comparison_Exp>;
  team_agency_slug?: InputMaybe<String_Comparison_Exp>;
  team_agents_count?: InputMaybe<Int_Comparison_Exp>;
  team_cover_url?: InputMaybe<String_Comparison_Exp>;
  team_description?: InputMaybe<String_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  team_locality?: InputMaybe<String_Comparison_Exp>;
  team_logo_url?: InputMaybe<String_Comparison_Exp>;
  team_name?: InputMaybe<String_Comparison_Exp>;
  team_postcode?: InputMaybe<String_Comparison_Exp>;
  team_route?: InputMaybe<String_Comparison_Exp>;
  team_slug?: InputMaybe<String_Comparison_Exp>;
  team_street_number?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_agent_slug?: InputMaybe<String_Comparison_Exp>;
  user_full_name?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_image_url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Local_Activity_Feed_Items_Max_Fields = {
  display_name?: Maybe<Scalars['String']['output']>;
  distance_meters?: Maybe<Scalars['float8']['output']>;
  feed_id?: Maybe<Scalars['String']['output']>;
  feed_type?: Maybe<Scalars['String']['output']>;
  listing_currency?: Maybe<Scalars['String']['output']>;
  listing_id?: Maybe<Scalars['uuid']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Int']['output']>;
  listing_offer_type?: Maybe<Scalars['String']['output']>;
  listing_price?: Maybe<Scalars['float8']['output']>;
  listing_title?: Maybe<Scalars['String']['output']>;
  number_of_rooms?: Maybe<Scalars['float8']['output']>;
  occurred_at?: Maybe<Scalars['timestamptz']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_image_url?: Maybe<Scalars['String']['output']>;
  property_locality?: Maybe<Scalars['String']['output']>;
  property_postcode?: Maybe<Scalars['String']['output']>;
  property_route?: Maybe<Scalars['String']['output']>;
  property_street_number?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  property_type_label?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['float8']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  team_agency_slug?: Maybe<Scalars['String']['output']>;
  team_agents_count?: Maybe<Scalars['Int']['output']>;
  team_cover_url?: Maybe<Scalars['String']['output']>;
  team_description?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  team_locality?: Maybe<Scalars['String']['output']>;
  team_logo_url?: Maybe<Scalars['String']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  team_postcode?: Maybe<Scalars['String']['output']>;
  team_route?: Maybe<Scalars['String']['output']>;
  team_slug?: Maybe<Scalars['String']['output']>;
  team_street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_agent_slug?: Maybe<Scalars['String']['output']>;
  user_full_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_image_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Local_Activity_Feed_Items_Min_Fields = {
  display_name?: Maybe<Scalars['String']['output']>;
  distance_meters?: Maybe<Scalars['float8']['output']>;
  feed_id?: Maybe<Scalars['String']['output']>;
  feed_type?: Maybe<Scalars['String']['output']>;
  listing_currency?: Maybe<Scalars['String']['output']>;
  listing_id?: Maybe<Scalars['uuid']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Int']['output']>;
  listing_offer_type?: Maybe<Scalars['String']['output']>;
  listing_price?: Maybe<Scalars['float8']['output']>;
  listing_title?: Maybe<Scalars['String']['output']>;
  number_of_rooms?: Maybe<Scalars['float8']['output']>;
  occurred_at?: Maybe<Scalars['timestamptz']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_image_url?: Maybe<Scalars['String']['output']>;
  property_locality?: Maybe<Scalars['String']['output']>;
  property_postcode?: Maybe<Scalars['String']['output']>;
  property_route?: Maybe<Scalars['String']['output']>;
  property_street_number?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  property_type_label?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['float8']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  source_id?: Maybe<Scalars['uuid']['output']>;
  team_agency_slug?: Maybe<Scalars['String']['output']>;
  team_agents_count?: Maybe<Scalars['Int']['output']>;
  team_cover_url?: Maybe<Scalars['String']['output']>;
  team_description?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  team_locality?: Maybe<Scalars['String']['output']>;
  team_logo_url?: Maybe<Scalars['String']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
  team_postcode?: Maybe<Scalars['String']['output']>;
  team_route?: Maybe<Scalars['String']['output']>;
  team_slug?: Maybe<Scalars['String']['output']>;
  team_street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_agent_slug?: Maybe<Scalars['String']['output']>;
  user_full_name?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  user_image_url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "local_activity_feed_items". */
export type Local_Activity_Feed_Items_Order_By = {
  display_name?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  feed_id?: InputMaybe<Order_By>;
  feed_type?: InputMaybe<Order_By>;
  listing_currency?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  listing_live_portals_count?: InputMaybe<Order_By>;
  listing_offer_type?: InputMaybe<Order_By>;
  listing_price?: InputMaybe<Order_By>;
  listing_title?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  occurred_at?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_image_url?: InputMaybe<Order_By>;
  property_locality?: InputMaybe<Order_By>;
  property_postcode?: InputMaybe<Order_By>;
  property_route?: InputMaybe<Order_By>;
  property_street_number?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_type_label?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source_id?: InputMaybe<Order_By>;
  team_agency_slug?: InputMaybe<Order_By>;
  team_agents_count?: InputMaybe<Order_By>;
  team_cover_url?: InputMaybe<Order_By>;
  team_description?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  team_locality?: InputMaybe<Order_By>;
  team_logo_url?: InputMaybe<Order_By>;
  team_name?: InputMaybe<Order_By>;
  team_postcode?: InputMaybe<Order_By>;
  team_route?: InputMaybe<Order_By>;
  team_slug?: InputMaybe<Order_By>;
  team_street_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user_agent_slug?: InputMaybe<Order_By>;
  user_full_name?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_image_url?: InputMaybe<Order_By>;
};

/** select columns of table "local_activity_feed_items" */
export enum Local_Activity_Feed_Items_Select_Column {
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DistanceMeters = 'distance_meters',
  /** column name */
  FeedId = 'feed_id',
  /** column name */
  FeedType = 'feed_type',
  /** column name */
  ListingCurrency = 'listing_currency',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  ListingLivePortalsCount = 'listing_live_portals_count',
  /** column name */
  ListingOfferType = 'listing_offer_type',
  /** column name */
  ListingPrice = 'listing_price',
  /** column name */
  ListingTitle = 'listing_title',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  OccurredAt = 'occurred_at',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyImageUrl = 'property_image_url',
  /** column name */
  PropertyLocality = 'property_locality',
  /** column name */
  PropertyPostcode = 'property_postcode',
  /** column name */
  PropertyRoute = 'property_route',
  /** column name */
  PropertyStreetNumber = 'property_street_number',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  PropertyTypeLabel = 'property_type_label',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  SourceId = 'source_id',
  /** column name */
  TeamAgencySlug = 'team_agency_slug',
  /** column name */
  TeamAgentsCount = 'team_agents_count',
  /** column name */
  TeamCoverUrl = 'team_cover_url',
  /** column name */
  TeamDescription = 'team_description',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TeamLocality = 'team_locality',
  /** column name */
  TeamLogoUrl = 'team_logo_url',
  /** column name */
  TeamName = 'team_name',
  /** column name */
  TeamPostcode = 'team_postcode',
  /** column name */
  TeamRoute = 'team_route',
  /** column name */
  TeamSlug = 'team_slug',
  /** column name */
  TeamStreetNumber = 'team_street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserAgentSlug = 'user_agent_slug',
  /** column name */
  UserFullName = 'user_full_name',
  /** column name */
  UserId = 'user_id',
  /** column name */
  UserImageUrl = 'user_image_url'
}

/** aggregate stddev on columns */
export type Local_Activity_Feed_Items_Stddev_Fields = {
  distance_meters?: Maybe<Scalars['Float']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Float']['output']>;
  listing_price?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  team_agents_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Local_Activity_Feed_Items_Stddev_Pop_Fields = {
  distance_meters?: Maybe<Scalars['Float']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Float']['output']>;
  listing_price?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  team_agents_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Local_Activity_Feed_Items_Stddev_Samp_Fields = {
  distance_meters?: Maybe<Scalars['Float']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Float']['output']>;
  listing_price?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  team_agents_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Local_Activity_Feed_Items_Sum_Fields = {
  distance_meters?: Maybe<Scalars['float8']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Int']['output']>;
  listing_price?: Maybe<Scalars['float8']['output']>;
  number_of_rooms?: Maybe<Scalars['float8']['output']>;
  purchase_price?: Maybe<Scalars['float8']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  team_agents_count?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Local_Activity_Feed_Items_Var_Pop_Fields = {
  distance_meters?: Maybe<Scalars['Float']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Float']['output']>;
  listing_price?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  team_agents_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Local_Activity_Feed_Items_Var_Samp_Fields = {
  distance_meters?: Maybe<Scalars['Float']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Float']['output']>;
  listing_price?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  team_agents_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Local_Activity_Feed_Items_Variance_Fields = {
  distance_meters?: Maybe<Scalars['Float']['output']>;
  listing_live_portals_count?: Maybe<Scalars['Float']['output']>;
  listing_price?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  team_agents_count?: Maybe<Scalars['Float']['output']>;
};

/** Precomputed surrounding localities (same predicate as get_surrounding_listing_places). Maintained incrementally by triggers on places; full rebuild via refresh_locality_adjacency(). */
export type Locality_Adjacency = {
  adj_locality_id: Scalars['uuid']['output'];
  locality_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "locality_adjacency". All fields are combined with a logical 'AND'. */
export type Locality_Adjacency_Bool_Exp = {
  _and?: InputMaybe<Array<Locality_Adjacency_Bool_Exp>>;
  _not?: InputMaybe<Locality_Adjacency_Bool_Exp>;
  _or?: InputMaybe<Array<Locality_Adjacency_Bool_Exp>>;
  adj_locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "locality_adjacency". */
export type Locality_Adjacency_Order_By = {
  adj_locality_id?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
};

/** select columns of table "locality_adjacency" */
export enum Locality_Adjacency_Select_Column {
  /** column name */
  AdjLocalityId = 'adj_locality_id',
  /** column name */
  LocalityId = 'locality_id'
}

/** Streaming cursor of the table "locality_adjacency" */
export type Locality_Adjacency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Locality_Adjacency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Locality_Adjacency_Stream_Cursor_Value_Input = {
  adj_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "logins" */
export type Logins = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  invalid: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  /** A computed field, executes function "logins_self_nylas_provider" */
  self_nylas_provider?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "logins_self_username" */
  self_username?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
};

/** order by aggregate values of table "logins" */
export type Logins_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Logins_Max_Order_By>;
  min?: InputMaybe<Logins_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "logins". All fields are combined with a logical 'AND'. */
export type Logins_Bool_Exp = {
  _and?: InputMaybe<Array<Logins_Bool_Exp>>;
  _not?: InputMaybe<Logins_Bool_Exp>;
  _or?: InputMaybe<Array<Logins_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  invalid?: InputMaybe<Boolean_Comparison_Exp>;
  provider?: InputMaybe<String_Comparison_Exp>;
  self_nylas_provider?: InputMaybe<String_Comparison_Exp>;
  self_username?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "logins" */
export type Logins_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "logins" */
export type Logins_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "logins". */
export type Logins_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invalid?: InputMaybe<Order_By>;
  provider?: InputMaybe<Order_By>;
  self_nylas_provider?: InputMaybe<Order_By>;
  self_username?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
};

/** select columns of table "logins" */
export enum Logins_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Invalid = 'invalid',
  /** column name */
  Provider = 'provider'
}

/** Return type of get_lot_publication_history(); never populated directly. */
export type Lot_Publication_History_Result = {
  history: Scalars['jsonb']['output'];
  lot_id: Scalars['uuid']['output'];
};


/** Return type of get_lot_publication_history(); never populated directly. */
export type Lot_Publication_History_ResultHistoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "lot_publication_history_result". All fields are combined with a logical 'AND'. */
export type Lot_Publication_History_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Lot_Publication_History_Result_Bool_Exp>>;
  _not?: InputMaybe<Lot_Publication_History_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Lot_Publication_History_Result_Bool_Exp>>;
  history?: InputMaybe<Jsonb_Comparison_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "lot_publication_history_result". */
export type Lot_Publication_History_Result_Order_By = {
  history?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
};

/** select columns of table "lot_publication_history_result" */
export enum Lot_Publication_History_Result_Select_Column {
  /** column name */
  History = 'history',
  /** column name */
  LotId = 'lot_id'
}

/** columns and relationships of "lot_reference_aliases" */
export type Lot_Reference_Aliases = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  reference_alias_decoded: Scalars['Int']['output'];
};

/** order by aggregate values of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Aggregate_Order_By = {
  avg?: InputMaybe<Lot_Reference_Aliases_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lot_Reference_Aliases_Max_Order_By>;
  min?: InputMaybe<Lot_Reference_Aliases_Min_Order_By>;
  stddev?: InputMaybe<Lot_Reference_Aliases_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lot_Reference_Aliases_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lot_Reference_Aliases_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lot_Reference_Aliases_Sum_Order_By>;
  var_pop?: InputMaybe<Lot_Reference_Aliases_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lot_Reference_Aliases_Var_Samp_Order_By>;
  variance?: InputMaybe<Lot_Reference_Aliases_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Arr_Rel_Insert_Input = {
  data: Array<Lot_Reference_Aliases_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lot_Reference_Aliases_On_Conflict>;
};

/** order by avg() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Avg_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lot_reference_aliases". All fields are combined with a logical 'AND'. */
export type Lot_Reference_Aliases_Bool_Exp = {
  _and?: InputMaybe<Array<Lot_Reference_Aliases_Bool_Exp>>;
  _not?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
  _or?: InputMaybe<Array<Lot_Reference_Aliases_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  reference_alias_decoded?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "lot_reference_aliases" */
export enum Lot_Reference_Aliases_Constraint {
  /** unique or primary key constraint on columns "reference_alias_decoded" */
  LotReferenceAliasesPkey = 'lot_reference_aliases_pkey'
}

/** input type for inserting data into table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_alias_decoded?: InputMaybe<Scalars['Int']['input']>;
};

/** order by max() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lot_Reference_Aliases>;
};

/** on_conflict condition type for table "lot_reference_aliases" */
export type Lot_Reference_Aliases_On_Conflict = {
  constraint: Lot_Reference_Aliases_Constraint;
  update_columns?: Array<Lot_Reference_Aliases_Update_Column>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};

/** Ordering options when selecting data from "lot_reference_aliases". */
export type Lot_Reference_Aliases_Order_By = {
  created_at?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** select columns of table "lot_reference_aliases" */
export enum Lot_Reference_Aliases_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ReferenceAliasDecoded = 'reference_alias_decoded'
}

/** order by stddev() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stddev_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stddev_Pop_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stddev_Samp_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lot_Reference_Aliases_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lot_Reference_Aliases_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reference_alias_decoded?: InputMaybe<Scalars['Int']['input']>;
};

/** order by sum() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Sum_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "lot_reference_aliases" (current role has no relevant permissions) */
export enum Lot_Reference_Aliases_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Var_Pop_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Var_Samp_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "lot_reference_aliases" */
export type Lot_Reference_Aliases_Variance_Order_By = {
  reference_alias_decoded?: InputMaybe<Order_By>;
};

/** The owners of a listing: one row per seller (user_id -> users) of a lot (lot_id -> lots). */
export type Lot_Sellers = {
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  /** An object relationship */
  seller: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "lot_sellers" */
export type Lot_Sellers_Aggregate = {
  aggregate?: Maybe<Lot_Sellers_Aggregate_Fields>;
  nodes: Array<Lot_Sellers>;
};

export type Lot_Sellers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Lot_Sellers_Aggregate_Bool_Exp_Count>;
};

export type Lot_Sellers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lot_Sellers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "lot_sellers" */
export type Lot_Sellers_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Lot_Sellers_Max_Fields>;
  min?: Maybe<Lot_Sellers_Min_Fields>;
};


/** aggregate fields of "lot_sellers" */
export type Lot_Sellers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lot_sellers" */
export type Lot_Sellers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lot_Sellers_Max_Order_By>;
  min?: InputMaybe<Lot_Sellers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "lot_sellers" */
export type Lot_Sellers_Arr_Rel_Insert_Input = {
  data: Array<Lot_Sellers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lot_Sellers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "lot_sellers". All fields are combined with a logical 'AND'. */
export type Lot_Sellers_Bool_Exp = {
  _and?: InputMaybe<Array<Lot_Sellers_Bool_Exp>>;
  _not?: InputMaybe<Lot_Sellers_Bool_Exp>;
  _or?: InputMaybe<Array<Lot_Sellers_Bool_Exp>>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  seller?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "lot_sellers" */
export enum Lot_Sellers_Constraint {
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotSellersLotIdUserIdUnique = 'lot_sellers_lot_id_user_id_unique',
  /** unique or primary key constraint on columns "user_id", "lot_id" */
  LotSellersPkey = 'lot_sellers_pkey'
}

/** input type for inserting data into table "lot_sellers" */
export type Lot_Sellers_Insert_Input = {
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  seller?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Lot_Sellers_Max_Fields = {
  lot_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "lot_sellers" */
export type Lot_Sellers_Max_Order_By = {
  lot_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Lot_Sellers_Min_Fields = {
  lot_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "lot_sellers" */
export type Lot_Sellers_Min_Order_By = {
  lot_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lot_sellers" */
export type Lot_Sellers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lot_Sellers>;
};

/** on_conflict condition type for table "lot_sellers" */
export type Lot_Sellers_On_Conflict = {
  constraint: Lot_Sellers_Constraint;
  update_columns?: Array<Lot_Sellers_Update_Column>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};

/** Ordering options when selecting data from "lot_sellers". */
export type Lot_Sellers_Order_By = {
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  seller?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "lot_sellers" */
export enum Lot_Sellers_Select_Column {
  /** column name */
  LotId = 'lot_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "lot_sellers" */
export type Lot_Sellers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lot_Sellers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lot_Sellers_Stream_Cursor_Value_Input = {
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "lot_sellers" (current role has no relevant permissions) */
export enum Lot_Sellers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type Lots = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  address_display_option: Address_Display_Options_Enum_Enum;
  address_display_option_brochure: Address_Display_Options_Enum_Enum;
  auto_matching_filters?: Maybe<Scalars['jsonb']['output']>;
  auto_matching_response_enabled: Scalars['Boolean']['output'];
  /** An object relationship */
  automatching_sender?: Maybe<Users>;
  automatching_sender_id?: Maybe<Scalars['uuid']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  brochure_cover_image?: Maybe<Images>;
  brochure_cover_image_id?: Maybe<Scalars['uuid']['output']>;
  brochure_description_de?: Maybe<Scalars['String']['output']>;
  brochure_description_en?: Maybe<Scalars['String']['output']>;
  brochure_description_es?: Maybe<Scalars['String']['output']>;
  brochure_description_fr?: Maybe<Scalars['String']['output']>;
  brochure_description_it?: Maybe<Scalars['String']['output']>;
  brochure_description_layout: Scalars['smallint']['output'];
  brochure_description_pl?: Maybe<Scalars['String']['output']>;
  brochure_description_pt?: Maybe<Scalars['String']['output']>;
  brochure_doc_template_id?: Maybe<Scalars['uuid']['output']>;
  brochure_font_family?: Maybe<Scalars['String']['output']>;
  brochure_include_append_files: Scalars['Boolean']['output'];
  brochure_include_cover: Scalars['Boolean']['output'];
  brochure_include_description: Scalars['Boolean']['output'];
  brochure_include_photos: Scalars['Boolean']['output'];
  brochure_include_poi_map: Scalars['Boolean']['output'];
  brochure_include_pois: Scalars['Boolean']['output'];
  brochure_include_property: Scalars['Boolean']['output'];
  brochure_pdf_compression_quality: Scalars['pdf_compression_quality']['output'];
  brochure_poi_map_zoom_level: Scalars['Float']['output'];
  brochure_show_agent_on_brochure: Scalars['Boolean']['output'];
  brochure_title_de?: Maybe<Scalars['String']['output']>;
  brochure_title_en?: Maybe<Scalars['String']['output']>;
  brochure_title_es?: Maybe<Scalars['String']['output']>;
  brochure_title_fr?: Maybe<Scalars['String']['output']>;
  brochure_title_it?: Maybe<Scalars['String']['output']>;
  brochure_title_pl?: Maybe<Scalars['String']['output']>;
  brochure_title_pt?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  couples_allowed?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  created_by_user?: Maybe<Users>;
  /** A computed field, executes function "lot_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  development?: Maybe<Developments>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  development_mappings: Array<Development_Mappings>;
  /** An object relationship */
  doc_template?: Maybe<Doc_Templates>;
  /** An object relationship */
  doc_template_theme?: Maybe<Doc_Templates>;
  doc_template_theme_id?: Maybe<Scalars['uuid']['output']>;
  dummy_broker_name?: Maybe<Scalars['String']['output']>;
  dummy_broker_phone?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_geom?: Maybe<Scalars['geometry']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_living_surface: Scalars['String']['output'];
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_locality_id?: Maybe<Scalars['uuid']['output']>;
  dummy_organisation_country_code?: Maybe<Scalars['String']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_locality?: Maybe<Scalars['String']['output']>;
  dummy_organisation_name?: Maybe<Scalars['String']['output']>;
  dummy_organisation_phone?: Maybe<Scalars['String']['output']>;
  dummy_organisation_postcode?: Maybe<Scalars['String']['output']>;
  dummy_organisation_route?: Maybe<Scalars['String']['output']>;
  dummy_organisation_state?: Maybe<Scalars['String']['output']>;
  dummy_organisation_street_number?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  dummy_usable_surface: Scalars['String']['output'];
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  enable_auto_matching: Scalars['Boolean']['output'];
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  enquiry_response_enabled?: Maybe<Scalars['Boolean']['output']>;
  expected_time_to_sell: Scalars['String']['output'];
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  /** FSBO listings only: when true, the advertiser's name is published as first name + last initial ("John S.") instead of the full name. Defaults to false. */
  fsbo_hide_last_name: Scalars['Boolean']['output'];
  /** FSBO listings only: when true, the advertiser's phone number is not published on the listing (e.g. IDX visit_phone). A manually entered contact phone is always published. Defaults to false. */
  fsbo_hide_phone: Scalars['Boolean']['output'];
  furnished?: Maybe<Scalars['Boolean']['output']>;
  has_success_fee: Scalars['Boolean']['output'];
  hide_price_on_brochure: Scalars['Boolean']['output'];
  hide_price_on_portals: Scalars['Boolean']['output'];
  /** A computed field, executes function "hide_route" */
  hide_route?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  is_exclusive?: Maybe<Scalars['Boolean']['output']>;
  is_paid: Scalars['Boolean']['output'];
  is_parking_included_in_total: Scalars['Boolean']['output'];
  is_sales_tax_inclusive?: Maybe<Scalars['Boolean']['output']>;
  last_seller_notification_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  listing_url?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lot_property_files: Array<Property_Files>;
  /** An aggregate relationship */
  lot_property_files_aggregate: Property_Files_Aggregate;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lot_reference_aliases: Array<Lot_Reference_Aliases>;
  /** An object relationship */
  lots_status: Lots_Status_Enum;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  mandate_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  marketing_metadata?: Maybe<Marketing_Metadata>;
  minimal_stay?: Maybe<Scalars['Int']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  /** Type of commission: percentage or fixed */
  mls_commission_type?: Maybe<Mls_Commission_Type_Enum_Enum>;
  mls_note?: Maybe<Scalars['String']['output']>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode: Scalars['String']['output'];
  /** An array relationship */
  mls_shares: Array<Mls_Shares>;
  /** An aggregate relationship */
  mls_shares_aggregate: Mls_Shares_Aggregate;
  /** Whether commission terms are enabled for MLS sharing */
  mls_terms_enabled?: Maybe<Scalars['Boolean']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  occupied_now?: Maybe<Scalars['Boolean']['output']>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  oldest_tenant_age?: Maybe<Scalars['Int']['output']>;
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  origin?: Maybe<Dictionaries>;
  origin_id?: Maybe<Scalars['uuid']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  owner_living?: Maybe<Scalars['Boolean']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price_type?: Maybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
  pets_allowed?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  publish_step?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  response_sender?: Maybe<Users>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum;
  /** An array relationship */
  sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  sellers_aggregate: Lot_Sellers_Aggregate;
  send_enquiries_to_sellers: Scalars['Boolean']['output'];
  shared_on_mls_at?: Maybe<Scalars['timestamptz']['output']>;
  show_image_captions_on_brochure?: Maybe<Scalars['Boolean']['output']>;
  signed_at?: Maybe<Scalars['date']['output']>;
  smoking_allowed?: Maybe<Scalars['Boolean']['output']>;
  status: Lots_Status_Enum_Enum;
  success_fee_custom?: Maybe<Scalars['String']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  success_fee_type: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_gender?: Maybe<Tenant_Gender_Enum_Enum>;
  tenant_id: Scalars['uuid']['output'];
  tenant_number?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  use_custom_brochure_description: Scalars['Boolean']['output'];
  use_custom_brochure_title: Scalars['Boolean']['output'];
  use_dummy_address?: Maybe<Scalars['Boolean']['output']>;
  use_dummy_contact: Scalars['Boolean']['output'];
  video_url?: Maybe<Scalars['String']['output']>;
  virtual_visit_url?: Maybe<Scalars['String']['output']>;
  watermark_enabled: Scalars['Boolean']['output'];
  watermark_image_url?: Maybe<Scalars['String']['output']>;
  watermark_opacity: Scalars['numeric']['output'];
  watermark_position: Scalars['String']['output'];
  watermark_position_x: Scalars['Int']['output'];
  watermark_position_y: Scalars['Int']['output'];
  watermark_rotation: Scalars['Int']['output'];
  watermark_scale: Scalars['numeric']['output'];
  youngest_tenant_age?: Maybe<Scalars['Int']['output']>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsAuto_Matching_FiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsDevelopment_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Development_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Mappings_Order_By>>;
  where?: InputMaybe<Development_Mappings_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsLot_Property_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsLot_Property_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsLot_Reference_AliasesArgs = {
  distinct_on?: InputMaybe<Array<Lot_Reference_Aliases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Reference_Aliases_Order_By>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsMls_SharesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsMls_Shares_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsSellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


/** Listings: one unit put on the market, for sale or rent. property_id -> properties is the property, lead_id -> leads the seller lead it came from, broker_id -> users the listing agent. status: draft, pending_review or rejected before publication; on the market as available, available_coming_soon, available_off_market or reserved (count all four as active); paused; then won (sold or rented by the agency), lost_* or abandoned. sale_price_computed is the total sale price (set only when offer_type = 'sell'); monthly_rent_computed is rent_net + rent_extra per month (only when offer_type = 'rent'), whatever the price_unit. */
export type LotsSellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};

/** aggregated selection of "lots" */
export type Lots_Aggregate = {
  aggregate?: Maybe<Lots_Aggregate_Fields>;
  nodes: Array<Lots>;
};

export type Lots_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Lots_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Lots_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Lots_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Lots_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Lots_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Lots_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Lots_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Lots_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Lots_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Lots_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Lots_Aggregate_Bool_Exp_Var_Samp>;
};

export type Lots_Aggregate_Bool_Exp_Avg = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Bool_And = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Corr = {
  arguments: Lots_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Lots_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Lots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Lots_Aggregate_Bool_Exp_Max = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Min = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Sum = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Lots_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Lots_Select_Column_Lots_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Lots_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "lots" */
export type Lots_Aggregate_Fields = {
  avg?: Maybe<Lots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Lots_Max_Fields>;
  min?: Maybe<Lots_Min_Fields>;
  stddev?: Maybe<Lots_Stddev_Fields>;
  stddev_pop?: Maybe<Lots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Lots_Stddev_Samp_Fields>;
  sum?: Maybe<Lots_Sum_Fields>;
  var_pop?: Maybe<Lots_Var_Pop_Fields>;
  var_samp?: Maybe<Lots_Var_Samp_Fields>;
  variance?: Maybe<Lots_Variance_Fields>;
};


/** aggregate fields of "lots" */
export type Lots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Lots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "lots" */
export type Lots_Aggregate_Order_By = {
  avg?: InputMaybe<Lots_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Lots_Max_Order_By>;
  min?: InputMaybe<Lots_Min_Order_By>;
  stddev?: InputMaybe<Lots_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Lots_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Lots_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Lots_Sum_Order_By>;
  var_pop?: InputMaybe<Lots_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Lots_Var_Samp_Order_By>;
  variance?: InputMaybe<Lots_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Lots_Append_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "lots" */
export type Lots_Arr_Rel_Insert_Input = {
  data: Array<Lots_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};

/** aggregate avg on columns */
export type Lots_Avg_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Float']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_position_x?: Maybe<Scalars['Float']['output']>;
  watermark_position_y?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_scale?: Maybe<Scalars['Float']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "lots" */
export type Lots_Avg_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "lots". All fields are combined with a logical 'AND'. */
export type Lots_Bool_Exp = {
  _and?: InputMaybe<Array<Lots_Bool_Exp>>;
  _not?: InputMaybe<Lots_Bool_Exp>;
  _or?: InputMaybe<Array<Lots_Bool_Exp>>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum_Comparison_Exp>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum_Comparison_Exp>;
  auto_matching_filters?: InputMaybe<Jsonb_Comparison_Exp>;
  auto_matching_response_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  automatching_sender?: InputMaybe<Users_Bool_Exp>;
  automatching_sender_id?: InputMaybe<Uuid_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  brochure_cover_image?: InputMaybe<Images_Bool_Exp>;
  brochure_cover_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  brochure_description_de?: InputMaybe<String_Comparison_Exp>;
  brochure_description_en?: InputMaybe<String_Comparison_Exp>;
  brochure_description_es?: InputMaybe<String_Comparison_Exp>;
  brochure_description_fr?: InputMaybe<String_Comparison_Exp>;
  brochure_description_it?: InputMaybe<String_Comparison_Exp>;
  brochure_description_layout?: InputMaybe<Smallint_Comparison_Exp>;
  brochure_description_pl?: InputMaybe<String_Comparison_Exp>;
  brochure_description_pt?: InputMaybe<String_Comparison_Exp>;
  brochure_doc_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  brochure_font_family?: InputMaybe<String_Comparison_Exp>;
  brochure_include_append_files?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_cover?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_description?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_photos?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_poi_map?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_pois?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_include_property?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_pdf_compression_quality?: InputMaybe<Pdf_Compression_Quality_Comparison_Exp>;
  brochure_poi_map_zoom_level?: InputMaybe<Float_Comparison_Exp>;
  brochure_show_agent_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  brochure_title_de?: InputMaybe<String_Comparison_Exp>;
  brochure_title_en?: InputMaybe<String_Comparison_Exp>;
  brochure_title_es?: InputMaybe<String_Comparison_Exp>;
  brochure_title_fr?: InputMaybe<String_Comparison_Exp>;
  brochure_title_it?: InputMaybe<String_Comparison_Exp>;
  brochure_title_pl?: InputMaybe<String_Comparison_Exp>;
  brochure_title_pt?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_leads?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp>;
  commission_rate?: InputMaybe<Float_Comparison_Exp>;
  couples_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_by_user?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<Currencies_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  development?: InputMaybe<Developments_Bool_Exp>;
  development_id?: InputMaybe<Uuid_Comparison_Exp>;
  development_mappings?: InputMaybe<Development_Mappings_Bool_Exp>;
  doc_template?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_theme?: InputMaybe<Doc_Templates_Bool_Exp>;
  doc_template_theme_id?: InputMaybe<Uuid_Comparison_Exp>;
  dummy_broker_name?: InputMaybe<String_Comparison_Exp>;
  dummy_broker_phone?: InputMaybe<String_Comparison_Exp>;
  dummy_country_code?: InputMaybe<String_Comparison_Exp>;
  dummy_geom?: InputMaybe<Geometry_Comparison_Exp>;
  dummy_lat?: InputMaybe<Float8_Comparison_Exp>;
  dummy_living_surface?: InputMaybe<String_Comparison_Exp>;
  dummy_lng?: InputMaybe<Float8_Comparison_Exp>;
  dummy_locality?: InputMaybe<String_Comparison_Exp>;
  dummy_locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  dummy_organisation_country_code?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_lat?: InputMaybe<Float8_Comparison_Exp>;
  dummy_organisation_lng?: InputMaybe<Float8_Comparison_Exp>;
  dummy_organisation_locality?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_name?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_phone?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_postcode?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_route?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_state?: InputMaybe<String_Comparison_Exp>;
  dummy_organisation_street_number?: InputMaybe<String_Comparison_Exp>;
  dummy_postcode?: InputMaybe<String_Comparison_Exp>;
  dummy_route?: InputMaybe<String_Comparison_Exp>;
  dummy_state?: InputMaybe<String_Comparison_Exp>;
  dummy_street_number?: InputMaybe<String_Comparison_Exp>;
  dummy_usable_surface?: InputMaybe<String_Comparison_Exp>;
  duration_in_months?: InputMaybe<Int_Comparison_Exp>;
  email_templates?: InputMaybe<Email_Templates_Bool_Exp>;
  enable_auto_matching?: InputMaybe<Boolean_Comparison_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  enquiry_response_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  expected_time_to_sell?: InputMaybe<String_Comparison_Exp>;
  fixed_fee?: InputMaybe<Int_Comparison_Exp>;
  fsbo_hide_last_name?: InputMaybe<Boolean_Comparison_Exp>;
  fsbo_hide_phone?: InputMaybe<Boolean_Comparison_Exp>;
  furnished?: InputMaybe<Boolean_Comparison_Exp>;
  has_success_fee?: InputMaybe<Boolean_Comparison_Exp>;
  hide_price_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  hide_price_on_portals?: InputMaybe<Boolean_Comparison_Exp>;
  hide_route?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indoor_parking_price?: InputMaybe<Float8_Comparison_Exp>;
  is_exclusive?: InputMaybe<Boolean_Comparison_Exp>;
  is_paid?: InputMaybe<Boolean_Comparison_Exp>;
  is_parking_included_in_total?: InputMaybe<Boolean_Comparison_Exp>;
  is_sales_tax_inclusive?: InputMaybe<Boolean_Comparison_Exp>;
  last_seller_notification_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_url?: InputMaybe<String_Comparison_Exp>;
  lot_property_files?: InputMaybe<Property_Files_Bool_Exp>;
  lot_property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  lot_reference_aliases?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
  lots_status?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
  mandate_sale_price?: InputMaybe<Float_Comparison_Exp>;
  mandate_type?: InputMaybe<String_Comparison_Exp>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Bool_Exp>;
  minimal_stay?: InputMaybe<Int_Comparison_Exp>;
  minimum_net_seller_price?: InputMaybe<Float_Comparison_Exp>;
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Numeric_Comparison_Exp>;
  mls_buyer_agent_share_percent?: InputMaybe<Numeric_Comparison_Exp>;
  mls_commission_type?: InputMaybe<Mls_Commission_Type_Enum_Enum_Comparison_Exp>;
  mls_note?: InputMaybe<String_Comparison_Exp>;
  mls_share_mode?: InputMaybe<String_Comparison_Exp>;
  mls_shares?: InputMaybe<Mls_Shares_Bool_Exp>;
  mls_shares_aggregate?: InputMaybe<Mls_Shares_Aggregate_Bool_Exp>;
  mls_terms_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  monthly_rent_computed?: InputMaybe<Float_Comparison_Exp>;
  mortgage_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  occupied_now?: InputMaybe<Boolean_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offers?: InputMaybe<Offers_Bool_Exp>;
  offers_aggregate?: InputMaybe<Offers_Aggregate_Bool_Exp>;
  oldest_tenant_age?: InputMaybe<Int_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  origin?: InputMaybe<Dictionaries_Bool_Exp>;
  origin_id?: InputMaybe<Uuid_Comparison_Exp>;
  outdoor_parking_price?: InputMaybe<Float8_Comparison_Exp>;
  owner_living?: InputMaybe<Boolean_Comparison_Exp>;
  parking_price?: InputMaybe<Float8_Comparison_Exp>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum_Comparison_Exp>;
  payment_id?: InputMaybe<Uuid_Comparison_Exp>;
  pets_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  portal_listings?: InputMaybe<Portal_Listings_Bool_Exp>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  publish_step?: InputMaybe<String_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  response_sender?: InputMaybe<Users_Bool_Exp>;
  response_sender_id?: InputMaybe<Uuid_Comparison_Exp>;
  sale_price?: InputMaybe<Float8_Comparison_Exp>;
  sale_price_computed?: InputMaybe<Float8_Comparison_Exp>;
  seller_notification_frequency?: InputMaybe<Seller_Notification_Frequency_Enum_Enum_Comparison_Exp>;
  sellers?: InputMaybe<Lot_Sellers_Bool_Exp>;
  sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Bool_Exp>;
  send_enquiries_to_sellers?: InputMaybe<Boolean_Comparison_Exp>;
  shared_on_mls_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  show_image_captions_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  signed_at?: InputMaybe<Date_Comparison_Exp>;
  smoking_allowed?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<Lots_Status_Enum_Enum_Comparison_Exp>;
  success_fee_custom?: InputMaybe<String_Comparison_Exp>;
  success_fee_percentage?: InputMaybe<Float_Comparison_Exp>;
  success_fee_type?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_gender?: InputMaybe<Tenant_Gender_Enum_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_number?: InputMaybe<Int_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_custom_brochure_description?: InputMaybe<Boolean_Comparison_Exp>;
  use_custom_brochure_title?: InputMaybe<Boolean_Comparison_Exp>;
  use_dummy_address?: InputMaybe<Boolean_Comparison_Exp>;
  use_dummy_contact?: InputMaybe<Boolean_Comparison_Exp>;
  video_url?: InputMaybe<String_Comparison_Exp>;
  virtual_visit_url?: InputMaybe<String_Comparison_Exp>;
  watermark_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  watermark_image_url?: InputMaybe<String_Comparison_Exp>;
  watermark_opacity?: InputMaybe<Numeric_Comparison_Exp>;
  watermark_position?: InputMaybe<String_Comparison_Exp>;
  watermark_position_x?: InputMaybe<Int_Comparison_Exp>;
  watermark_position_y?: InputMaybe<Int_Comparison_Exp>;
  watermark_rotation?: InputMaybe<Int_Comparison_Exp>;
  watermark_scale?: InputMaybe<Numeric_Comparison_Exp>;
  youngest_tenant_age?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "lots" */
export enum Lots_Constraint {
  /** unique or primary key constraint on columns "order_nr", "development_id" */
  LotsDevelopmentIdOrderNrUnique = 'lots_development_id_order_nr_unique',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  LotsIdTenantIdUnique = 'lots_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  LotsIdUindex = 'lots_id_uindex',
  /** unique or primary key constraint on columns "id" */
  LotsPkey = 'lots_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Lots_Delete_At_Path_Input = {
  auto_matching_filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Lots_Delete_Elem_Input = {
  auto_matching_filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Lots_Delete_Key_Input = {
  auto_matching_filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "lots" */
export type Lots_Inc_Input = {
  brochure_description_layout?: InputMaybe<Scalars['smallint']['input']>;
  brochure_poi_map_zoom_level?: InputMaybe<Scalars['Float']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  minimal_stay?: InputMaybe<Scalars['Int']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Scalars['numeric']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  oldest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  tenant_number?: InputMaybe<Scalars['Int']['input']>;
  watermark_opacity?: InputMaybe<Scalars['numeric']['input']>;
  watermark_position_x?: InputMaybe<Scalars['Int']['input']>;
  watermark_position_y?: InputMaybe<Scalars['Int']['input']>;
  watermark_rotation?: InputMaybe<Scalars['Int']['input']>;
  watermark_scale?: InputMaybe<Scalars['numeric']['input']>;
  youngest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "lots" */
export type Lots_Insert_Input = {
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  automatching_sender?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_cover_image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  brochure_cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_description_de?: InputMaybe<Scalars['String']['input']>;
  brochure_description_en?: InputMaybe<Scalars['String']['input']>;
  brochure_description_es?: InputMaybe<Scalars['String']['input']>;
  brochure_description_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_description_it?: InputMaybe<Scalars['String']['input']>;
  brochure_description_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_description_pt?: InputMaybe<Scalars['String']['input']>;
  brochure_font_family?: InputMaybe<Scalars['String']['input']>;
  brochure_include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_description?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_property?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_title_de?: InputMaybe<Scalars['String']['input']>;
  brochure_title_en?: InputMaybe<Scalars['String']['input']>;
  brochure_title_es?: InputMaybe<Scalars['String']['input']>;
  brochure_title_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_title_it?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pt?: InputMaybe<Scalars['String']['input']>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_leads?: InputMaybe<Buyer_Leads_Arr_Rel_Insert_Input>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  couples_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  created_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development?: InputMaybe<Developments_Obj_Rel_Insert_Input>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  development_mappings?: InputMaybe<Development_Mappings_Arr_Rel_Insert_Input>;
  doc_template?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_theme?: InputMaybe<Doc_Templates_Obj_Rel_Insert_Input>;
  doc_template_theme_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  email_templates?: InputMaybe<Email_Templates_Arr_Rel_Insert_Input>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiries?: InputMaybe<Enquiries_Arr_Rel_Insert_Input>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  /** FSBO listings only: when true, the advertiser's name is published as first name + last initial ("John S.") instead of the full name. Defaults to false. */
  fsbo_hide_last_name?: InputMaybe<Scalars['Boolean']['input']>;
  /** FSBO listings only: when true, the advertiser's phone number is not published on the listing (e.g. IDX visit_phone). A manually entered contact phone is always published. Defaults to false. */
  fsbo_hide_phone?: InputMaybe<Scalars['Boolean']['input']>;
  furnished?: InputMaybe<Scalars['Boolean']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  last_seller_notification_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead?: InputMaybe<Leads_Obj_Rel_Insert_Input>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_property_files?: InputMaybe<Property_Files_Arr_Rel_Insert_Input>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  lot_reference_aliases?: InputMaybe<Lot_Reference_Aliases_Arr_Rel_Insert_Input>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimal_stay?: InputMaybe<Scalars['Int']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Scalars['numeric']['input']>;
  /** Type of commission: percentage or fixed */
  mls_commission_type?: InputMaybe<Mls_Commission_Type_Enum_Enum>;
  mls_note?: InputMaybe<Scalars['String']['input']>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode?: InputMaybe<Scalars['String']['input']>;
  mls_shares?: InputMaybe<Mls_Shares_Arr_Rel_Insert_Input>;
  /** Whether commission terms are enabled for MLS sharing */
  mls_terms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  occupied_now?: InputMaybe<Scalars['Boolean']['input']>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: InputMaybe<Scalars['String']['input']>;
  offers?: InputMaybe<Offers_Arr_Rel_Insert_Input>;
  oldest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  owner_living?: InputMaybe<Scalars['Boolean']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  portal_listings?: InputMaybe<Portal_Listings_Arr_Rel_Insert_Input>;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  seller_notification_frequency?: InputMaybe<Seller_Notification_Frequency_Enum_Enum>;
  sellers?: InputMaybe<Lot_Sellers_Arr_Rel_Insert_Input>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls_at?: InputMaybe<Scalars['timestamptz']['input']>;
  show_image_captions_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Lots_Status_Enum_Enum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  tenant_gender?: InputMaybe<Tenant_Gender_Enum_Enum>;
  tenant_number?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
  watermark_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  watermark_image_url?: InputMaybe<Scalars['String']['input']>;
  watermark_opacity?: InputMaybe<Scalars['numeric']['input']>;
  watermark_position?: InputMaybe<Scalars['String']['input']>;
  watermark_position_x?: InputMaybe<Scalars['Int']['input']>;
  watermark_position_y?: InputMaybe<Scalars['Int']['input']>;
  watermark_rotation?: InputMaybe<Scalars['Int']['input']>;
  watermark_scale?: InputMaybe<Scalars['numeric']['input']>;
  youngest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Lots_Max_Fields = {
  automatching_sender_id?: Maybe<Scalars['uuid']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_cover_image_id?: Maybe<Scalars['uuid']['output']>;
  brochure_description_de?: Maybe<Scalars['String']['output']>;
  brochure_description_en?: Maybe<Scalars['String']['output']>;
  brochure_description_es?: Maybe<Scalars['String']['output']>;
  brochure_description_fr?: Maybe<Scalars['String']['output']>;
  brochure_description_it?: Maybe<Scalars['String']['output']>;
  brochure_description_layout?: Maybe<Scalars['smallint']['output']>;
  brochure_description_pl?: Maybe<Scalars['String']['output']>;
  brochure_description_pt?: Maybe<Scalars['String']['output']>;
  brochure_doc_template_id?: Maybe<Scalars['uuid']['output']>;
  brochure_font_family?: Maybe<Scalars['String']['output']>;
  brochure_pdf_compression_quality?: Maybe<Scalars['pdf_compression_quality']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  brochure_title_de?: Maybe<Scalars['String']['output']>;
  brochure_title_en?: Maybe<Scalars['String']['output']>;
  brochure_title_es?: Maybe<Scalars['String']['output']>;
  brochure_title_fr?: Maybe<Scalars['String']['output']>;
  brochure_title_it?: Maybe<Scalars['String']['output']>;
  brochure_title_pl?: Maybe<Scalars['String']['output']>;
  brochure_title_pt?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "lot_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  doc_template_theme_id?: Maybe<Scalars['uuid']['output']>;
  dummy_broker_name?: Maybe<Scalars['String']['output']>;
  dummy_broker_phone?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_living_surface?: Maybe<Scalars['String']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_locality_id?: Maybe<Scalars['uuid']['output']>;
  dummy_organisation_country_code?: Maybe<Scalars['String']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_locality?: Maybe<Scalars['String']['output']>;
  dummy_organisation_name?: Maybe<Scalars['String']['output']>;
  dummy_organisation_phone?: Maybe<Scalars['String']['output']>;
  dummy_organisation_postcode?: Maybe<Scalars['String']['output']>;
  dummy_organisation_route?: Maybe<Scalars['String']['output']>;
  dummy_organisation_state?: Maybe<Scalars['String']['output']>;
  dummy_organisation_street_number?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  dummy_usable_surface?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  expected_time_to_sell?: Maybe<Scalars['String']['output']>;
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  last_seller_notification_at?: Maybe<Scalars['timestamptz']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  listing_url?: Maybe<Scalars['String']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  mandate_type?: Maybe<Scalars['String']['output']>;
  minimal_stay?: Maybe<Scalars['Int']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  mls_note?: Maybe<Scalars['String']['output']>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode?: Maybe<Scalars['String']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: Maybe<Scalars['String']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Int']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  origin_id?: Maybe<Scalars['uuid']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  publish_step?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  shared_on_mls_at?: Maybe<Scalars['timestamptz']['output']>;
  signed_at?: Maybe<Scalars['date']['output']>;
  success_fee_custom?: Maybe<Scalars['String']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  success_fee_type?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  tenant_number?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
  virtual_visit_url?: Maybe<Scalars['String']['output']>;
  watermark_image_url?: Maybe<Scalars['String']['output']>;
  watermark_opacity?: Maybe<Scalars['numeric']['output']>;
  watermark_position?: Maybe<Scalars['String']['output']>;
  watermark_position_x?: Maybe<Scalars['Int']['output']>;
  watermark_position_y?: Maybe<Scalars['Int']['output']>;
  watermark_rotation?: Maybe<Scalars['Int']['output']>;
  watermark_scale?: Maybe<Scalars['numeric']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "lots" */
export type Lots_Max_Order_By = {
  automatching_sender_id?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  brochure_cover_image_id?: InputMaybe<Order_By>;
  brochure_description_de?: InputMaybe<Order_By>;
  brochure_description_en?: InputMaybe<Order_By>;
  brochure_description_es?: InputMaybe<Order_By>;
  brochure_description_fr?: InputMaybe<Order_By>;
  brochure_description_it?: InputMaybe<Order_By>;
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_description_pl?: InputMaybe<Order_By>;
  brochure_description_pt?: InputMaybe<Order_By>;
  brochure_doc_template_id?: InputMaybe<Order_By>;
  brochure_font_family?: InputMaybe<Order_By>;
  brochure_pdf_compression_quality?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  brochure_title_de?: InputMaybe<Order_By>;
  brochure_title_en?: InputMaybe<Order_By>;
  brochure_title_es?: InputMaybe<Order_By>;
  brochure_title_fr?: InputMaybe<Order_By>;
  brochure_title_it?: InputMaybe<Order_By>;
  brochure_title_pl?: InputMaybe<Order_By>;
  brochure_title_pt?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  doc_template_theme_id?: InputMaybe<Order_By>;
  dummy_broker_name?: InputMaybe<Order_By>;
  dummy_broker_phone?: InputMaybe<Order_By>;
  dummy_country_code?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_living_surface?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_locality?: InputMaybe<Order_By>;
  dummy_locality_id?: InputMaybe<Order_By>;
  dummy_organisation_country_code?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  dummy_organisation_locality?: InputMaybe<Order_By>;
  dummy_organisation_name?: InputMaybe<Order_By>;
  dummy_organisation_phone?: InputMaybe<Order_By>;
  dummy_organisation_postcode?: InputMaybe<Order_By>;
  dummy_organisation_route?: InputMaybe<Order_By>;
  dummy_organisation_state?: InputMaybe<Order_By>;
  dummy_organisation_street_number?: InputMaybe<Order_By>;
  dummy_postcode?: InputMaybe<Order_By>;
  dummy_route?: InputMaybe<Order_By>;
  dummy_state?: InputMaybe<Order_By>;
  dummy_street_number?: InputMaybe<Order_By>;
  dummy_usable_surface?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  expected_time_to_sell?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  last_seller_notification_at?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  listing_url?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  mandate_type?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  mls_note?: InputMaybe<Order_By>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  origin_id?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  publish_step?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  shared_on_mls_at?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  success_fee_custom?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  success_fee_type?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  virtual_visit_url?: InputMaybe<Order_By>;
  watermark_image_url?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** columns and relationships of "lots_member_access_enum" */
export type Lots_Member_Access_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "lots_member_access_enum". All fields are combined with a logical 'AND'. */
export type Lots_Member_Access_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Lots_Member_Access_Enum_Bool_Exp>>;
  _not?: InputMaybe<Lots_Member_Access_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Lots_Member_Access_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Lots_Member_Access_Enum_Enum {
  /** Non-leader members can view and edit all team listings */
  EditAll = 'edit_all',
  /** Non-leader members can only view and edit listings they are assigned to */
  OwnOnly = 'own_only',
  /** Non-leader members can view all team listings but only edit their own listings */
  ReadAll = 'read_all'
}

/** Boolean expression to compare columns of type "lots_member_access_enum_enum". All fields are combined with logical 'AND'. */
export type Lots_Member_Access_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lots_Member_Access_Enum_Enum>;
  _in?: InputMaybe<Array<Lots_Member_Access_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lots_Member_Access_Enum_Enum>;
  _nin?: InputMaybe<Array<Lots_Member_Access_Enum_Enum>>;
};

/** Ordering options when selecting data from "lots_member_access_enum". */
export type Lots_Member_Access_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "lots_member_access_enum" */
export enum Lots_Member_Access_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lots_member_access_enum" */
export type Lots_Member_Access_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lots_Member_Access_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lots_Member_Access_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate min on columns */
export type Lots_Min_Fields = {
  automatching_sender_id?: Maybe<Scalars['uuid']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_cover_image_id?: Maybe<Scalars['uuid']['output']>;
  brochure_description_de?: Maybe<Scalars['String']['output']>;
  brochure_description_en?: Maybe<Scalars['String']['output']>;
  brochure_description_es?: Maybe<Scalars['String']['output']>;
  brochure_description_fr?: Maybe<Scalars['String']['output']>;
  brochure_description_it?: Maybe<Scalars['String']['output']>;
  brochure_description_layout?: Maybe<Scalars['smallint']['output']>;
  brochure_description_pl?: Maybe<Scalars['String']['output']>;
  brochure_description_pt?: Maybe<Scalars['String']['output']>;
  brochure_doc_template_id?: Maybe<Scalars['uuid']['output']>;
  brochure_font_family?: Maybe<Scalars['String']['output']>;
  brochure_pdf_compression_quality?: Maybe<Scalars['pdf_compression_quality']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  brochure_title_de?: Maybe<Scalars['String']['output']>;
  brochure_title_en?: Maybe<Scalars['String']['output']>;
  brochure_title_es?: Maybe<Scalars['String']['output']>;
  brochure_title_fr?: Maybe<Scalars['String']['output']>;
  brochure_title_it?: Maybe<Scalars['String']['output']>;
  brochure_title_pl?: Maybe<Scalars['String']['output']>;
  brochure_title_pt?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "lot_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  development_id?: Maybe<Scalars['uuid']['output']>;
  doc_template_theme_id?: Maybe<Scalars['uuid']['output']>;
  dummy_broker_name?: Maybe<Scalars['String']['output']>;
  dummy_broker_phone?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_living_surface?: Maybe<Scalars['String']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_locality_id?: Maybe<Scalars['uuid']['output']>;
  dummy_organisation_country_code?: Maybe<Scalars['String']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_locality?: Maybe<Scalars['String']['output']>;
  dummy_organisation_name?: Maybe<Scalars['String']['output']>;
  dummy_organisation_phone?: Maybe<Scalars['String']['output']>;
  dummy_organisation_postcode?: Maybe<Scalars['String']['output']>;
  dummy_organisation_route?: Maybe<Scalars['String']['output']>;
  dummy_organisation_state?: Maybe<Scalars['String']['output']>;
  dummy_organisation_street_number?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  dummy_usable_surface?: Maybe<Scalars['String']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  expected_time_to_sell?: Maybe<Scalars['String']['output']>;
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  last_seller_notification_at?: Maybe<Scalars['timestamptz']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  listing_url?: Maybe<Scalars['String']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  mandate_type?: Maybe<Scalars['String']['output']>;
  minimal_stay?: Maybe<Scalars['Int']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  mls_note?: Maybe<Scalars['String']['output']>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode?: Maybe<Scalars['String']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: Maybe<Scalars['String']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Int']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  origin_id?: Maybe<Scalars['uuid']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  payment_id?: Maybe<Scalars['uuid']['output']>;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  publish_step?: Maybe<Scalars['String']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  shared_on_mls_at?: Maybe<Scalars['timestamptz']['output']>;
  signed_at?: Maybe<Scalars['date']['output']>;
  success_fee_custom?: Maybe<Scalars['String']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  success_fee_type?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  tenant_number?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  video_url?: Maybe<Scalars['String']['output']>;
  virtual_visit_url?: Maybe<Scalars['String']['output']>;
  watermark_image_url?: Maybe<Scalars['String']['output']>;
  watermark_opacity?: Maybe<Scalars['numeric']['output']>;
  watermark_position?: Maybe<Scalars['String']['output']>;
  watermark_position_x?: Maybe<Scalars['Int']['output']>;
  watermark_position_y?: Maybe<Scalars['Int']['output']>;
  watermark_rotation?: Maybe<Scalars['Int']['output']>;
  watermark_scale?: Maybe<Scalars['numeric']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "lots" */
export type Lots_Min_Order_By = {
  automatching_sender_id?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  brochure_cover_image_id?: InputMaybe<Order_By>;
  brochure_description_de?: InputMaybe<Order_By>;
  brochure_description_en?: InputMaybe<Order_By>;
  brochure_description_es?: InputMaybe<Order_By>;
  brochure_description_fr?: InputMaybe<Order_By>;
  brochure_description_it?: InputMaybe<Order_By>;
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_description_pl?: InputMaybe<Order_By>;
  brochure_description_pt?: InputMaybe<Order_By>;
  brochure_doc_template_id?: InputMaybe<Order_By>;
  brochure_font_family?: InputMaybe<Order_By>;
  brochure_pdf_compression_quality?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  brochure_title_de?: InputMaybe<Order_By>;
  brochure_title_en?: InputMaybe<Order_By>;
  brochure_title_es?: InputMaybe<Order_By>;
  brochure_title_fr?: InputMaybe<Order_By>;
  brochure_title_it?: InputMaybe<Order_By>;
  brochure_title_pl?: InputMaybe<Order_By>;
  brochure_title_pt?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development_id?: InputMaybe<Order_By>;
  doc_template_theme_id?: InputMaybe<Order_By>;
  dummy_broker_name?: InputMaybe<Order_By>;
  dummy_broker_phone?: InputMaybe<Order_By>;
  dummy_country_code?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_living_surface?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_locality?: InputMaybe<Order_By>;
  dummy_locality_id?: InputMaybe<Order_By>;
  dummy_organisation_country_code?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  dummy_organisation_locality?: InputMaybe<Order_By>;
  dummy_organisation_name?: InputMaybe<Order_By>;
  dummy_organisation_phone?: InputMaybe<Order_By>;
  dummy_organisation_postcode?: InputMaybe<Order_By>;
  dummy_organisation_route?: InputMaybe<Order_By>;
  dummy_organisation_state?: InputMaybe<Order_By>;
  dummy_organisation_street_number?: InputMaybe<Order_By>;
  dummy_postcode?: InputMaybe<Order_By>;
  dummy_route?: InputMaybe<Order_By>;
  dummy_state?: InputMaybe<Order_By>;
  dummy_street_number?: InputMaybe<Order_By>;
  dummy_usable_surface?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  expected_time_to_sell?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  last_seller_notification_at?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  listing_url?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  mandate_type?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  mls_note?: InputMaybe<Order_By>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  origin_id?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  publish_step?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  shared_on_mls_at?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  success_fee_custom?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  success_fee_type?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  virtual_visit_url?: InputMaybe<Order_By>;
  watermark_image_url?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "lots" */
export type Lots_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Lots>;
};

/** input type for inserting object relation for remote table "lots" */
export type Lots_Obj_Rel_Insert_Input = {
  data: Lots_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};

/** on_conflict condition type for table "lots" */
export type Lots_On_Conflict = {
  constraint: Lots_Constraint;
  update_columns?: Array<Lots_Update_Column>;
  where?: InputMaybe<Lots_Bool_Exp>;
};

/** Ordering options when selecting data from "lots". */
export type Lots_Order_By = {
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  address_display_option?: InputMaybe<Order_By>;
  address_display_option_brochure?: InputMaybe<Order_By>;
  auto_matching_filters?: InputMaybe<Order_By>;
  auto_matching_response_enabled?: InputMaybe<Order_By>;
  automatching_sender?: InputMaybe<Users_Order_By>;
  automatching_sender_id?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  brochure_cover_image?: InputMaybe<Images_Order_By>;
  brochure_cover_image_id?: InputMaybe<Order_By>;
  brochure_description_de?: InputMaybe<Order_By>;
  brochure_description_en?: InputMaybe<Order_By>;
  brochure_description_es?: InputMaybe<Order_By>;
  brochure_description_fr?: InputMaybe<Order_By>;
  brochure_description_it?: InputMaybe<Order_By>;
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_description_pl?: InputMaybe<Order_By>;
  brochure_description_pt?: InputMaybe<Order_By>;
  brochure_doc_template_id?: InputMaybe<Order_By>;
  brochure_font_family?: InputMaybe<Order_By>;
  brochure_include_append_files?: InputMaybe<Order_By>;
  brochure_include_cover?: InputMaybe<Order_By>;
  brochure_include_description?: InputMaybe<Order_By>;
  brochure_include_photos?: InputMaybe<Order_By>;
  brochure_include_poi_map?: InputMaybe<Order_By>;
  brochure_include_pois?: InputMaybe<Order_By>;
  brochure_include_property?: InputMaybe<Order_By>;
  brochure_pdf_compression_quality?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  brochure_show_agent_on_brochure?: InputMaybe<Order_By>;
  brochure_title_de?: InputMaybe<Order_By>;
  brochure_title_en?: InputMaybe<Order_By>;
  brochure_title_es?: InputMaybe<Order_By>;
  brochure_title_fr?: InputMaybe<Order_By>;
  brochure_title_it?: InputMaybe<Order_By>;
  brochure_title_pl?: InputMaybe<Order_By>;
  brochure_title_pt?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  couples_allowed?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_by_user?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  development?: InputMaybe<Developments_Order_By>;
  development_id?: InputMaybe<Order_By>;
  development_mappings_aggregate?: InputMaybe<Development_Mappings_Aggregate_Order_By>;
  doc_template?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_theme?: InputMaybe<Doc_Templates_Order_By>;
  doc_template_theme_id?: InputMaybe<Order_By>;
  dummy_broker_name?: InputMaybe<Order_By>;
  dummy_broker_phone?: InputMaybe<Order_By>;
  dummy_country_code?: InputMaybe<Order_By>;
  dummy_geom?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_living_surface?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_locality?: InputMaybe<Order_By>;
  dummy_locality_id?: InputMaybe<Order_By>;
  dummy_organisation_country_code?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  dummy_organisation_locality?: InputMaybe<Order_By>;
  dummy_organisation_name?: InputMaybe<Order_By>;
  dummy_organisation_phone?: InputMaybe<Order_By>;
  dummy_organisation_postcode?: InputMaybe<Order_By>;
  dummy_organisation_route?: InputMaybe<Order_By>;
  dummy_organisation_state?: InputMaybe<Order_By>;
  dummy_organisation_street_number?: InputMaybe<Order_By>;
  dummy_postcode?: InputMaybe<Order_By>;
  dummy_route?: InputMaybe<Order_By>;
  dummy_state?: InputMaybe<Order_By>;
  dummy_street_number?: InputMaybe<Order_By>;
  dummy_usable_surface?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  email_templates_aggregate?: InputMaybe<Email_Templates_Aggregate_Order_By>;
  enable_auto_matching?: InputMaybe<Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  enquiry_response_enabled?: InputMaybe<Order_By>;
  expected_time_to_sell?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  fsbo_hide_last_name?: InputMaybe<Order_By>;
  fsbo_hide_phone?: InputMaybe<Order_By>;
  furnished?: InputMaybe<Order_By>;
  has_success_fee?: InputMaybe<Order_By>;
  hide_price_on_brochure?: InputMaybe<Order_By>;
  hide_price_on_portals?: InputMaybe<Order_By>;
  hide_route?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  is_exclusive?: InputMaybe<Order_By>;
  is_paid?: InputMaybe<Order_By>;
  is_parking_included_in_total?: InputMaybe<Order_By>;
  is_sales_tax_inclusive?: InputMaybe<Order_By>;
  last_seller_notification_at?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  listing_url?: InputMaybe<Order_By>;
  lot_property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  lot_reference_aliases_aggregate?: InputMaybe<Lot_Reference_Aliases_Aggregate_Order_By>;
  lots_status?: InputMaybe<Lots_Status_Enum_Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  mandate_type?: InputMaybe<Order_By>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  mls_commission_type?: InputMaybe<Order_By>;
  mls_note?: InputMaybe<Order_By>;
  mls_share_mode?: InputMaybe<Order_By>;
  mls_shares_aggregate?: InputMaybe<Mls_Shares_Aggregate_Order_By>;
  mls_terms_enabled?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  occupied_now?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offers_aggregate?: InputMaybe<Offers_Aggregate_Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  origin?: InputMaybe<Dictionaries_Order_By>;
  origin_id?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  owner_living?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  parking_price_type?: InputMaybe<Order_By>;
  payment_id?: InputMaybe<Order_By>;
  pets_allowed?: InputMaybe<Order_By>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  publish_step?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  response_sender?: InputMaybe<Users_Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  seller_notification_frequency?: InputMaybe<Order_By>;
  sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Order_By>;
  send_enquiries_to_sellers?: InputMaybe<Order_By>;
  shared_on_mls_at?: InputMaybe<Order_By>;
  show_image_captions_on_brochure?: InputMaybe<Order_By>;
  signed_at?: InputMaybe<Order_By>;
  smoking_allowed?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  success_fee_custom?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  success_fee_type?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_gender?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_custom_brochure_description?: InputMaybe<Order_By>;
  use_custom_brochure_title?: InputMaybe<Order_By>;
  use_dummy_address?: InputMaybe<Order_By>;
  use_dummy_contact?: InputMaybe<Order_By>;
  video_url?: InputMaybe<Order_By>;
  virtual_visit_url?: InputMaybe<Order_By>;
  watermark_enabled?: InputMaybe<Order_By>;
  watermark_image_url?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** primary key columns input for table: lots */
export type Lots_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Lots_Prepend_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "lots" */
export enum Lots_Select_Column {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AutoMatchingResponseEnabled = 'auto_matching_response_enabled',
  /** column name */
  AutomatchingSenderId = 'automatching_sender_id',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureCoverImageId = 'brochure_cover_image_id',
  /** column name */
  BrochureDescriptionDe = 'brochure_description_de',
  /** column name */
  BrochureDescriptionEn = 'brochure_description_en',
  /** column name */
  BrochureDescriptionEs = 'brochure_description_es',
  /** column name */
  BrochureDescriptionFr = 'brochure_description_fr',
  /** column name */
  BrochureDescriptionIt = 'brochure_description_it',
  /** column name */
  BrochureDescriptionLayout = 'brochure_description_layout',
  /** column name */
  BrochureDescriptionPl = 'brochure_description_pl',
  /** column name */
  BrochureDescriptionPt = 'brochure_description_pt',
  /** column name */
  BrochureDocTemplateId = 'brochure_doc_template_id',
  /** column name */
  BrochureFontFamily = 'brochure_font_family',
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludePoiMap = 'brochure_include_poi_map',
  /** column name */
  BrochureIncludePois = 'brochure_include_pois',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochurePoiMapZoomLevel = 'brochure_poi_map_zoom_level',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  BrochureTitleDe = 'brochure_title_de',
  /** column name */
  BrochureTitleEn = 'brochure_title_en',
  /** column name */
  BrochureTitleEs = 'brochure_title_es',
  /** column name */
  BrochureTitleFr = 'brochure_title_fr',
  /** column name */
  BrochureTitleIt = 'brochure_title_it',
  /** column name */
  BrochureTitlePl = 'brochure_title_pl',
  /** column name */
  BrochureTitlePt = 'brochure_title_pt',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  CouplesAllowed = 'couples_allowed',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DocTemplateThemeId = 'doc_template_theme_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  FsboHideLastName = 'fsbo_hide_last_name',
  /** column name */
  FsboHidePhone = 'fsbo_hide_phone',
  /** column name */
  Furnished = 'furnished',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LastSellerNotificationAt = 'last_seller_notification_at',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimalStay = 'minimal_stay',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MlsBuyerAgentShareFixedAmount = 'mls_buyer_agent_share_fixed_amount',
  /** column name */
  MlsBuyerAgentSharePercent = 'mls_buyer_agent_share_percent',
  /** column name */
  MlsCommissionType = 'mls_commission_type',
  /** column name */
  MlsNote = 'mls_note',
  /** column name */
  MlsShareMode = 'mls_share_mode',
  /** column name */
  MlsTermsEnabled = 'mls_terms_enabled',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OccupiedNow = 'occupied_now',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OldestTenantAge = 'oldest_tenant_age',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  OwnerLiving = 'owner_living',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  ParkingPriceType = 'parking_price_type',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SellerNotificationFrequency = 'seller_notification_frequency',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMlsAt = 'shared_on_mls_at',
  /** column name */
  ShowImageCaptionsOnBrochure = 'show_image_captions_on_brochure',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  TenantGender = 'tenant_gender',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TenantNumber = 'tenant_number',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url',
  /** column name */
  WatermarkEnabled = 'watermark_enabled',
  /** column name */
  WatermarkImageUrl = 'watermark_image_url',
  /** column name */
  WatermarkOpacity = 'watermark_opacity',
  /** column name */
  WatermarkPosition = 'watermark_position',
  /** column name */
  WatermarkPositionX = 'watermark_position_x',
  /** column name */
  WatermarkPositionY = 'watermark_position_y',
  /** column name */
  WatermarkRotation = 'watermark_rotation',
  /** column name */
  WatermarkScale = 'watermark_scale',
  /** column name */
  YoungestTenantAge = 'youngest_tenant_age'
}

/** select "lots_aggregate_bool_exp_avg_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_bool_and_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AutoMatchingResponseEnabled = 'auto_matching_response_enabled',
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludePoiMap = 'brochure_include_poi_map',
  /** column name */
  BrochureIncludePois = 'brochure_include_pois',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  CouplesAllowed = 'couples_allowed',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  FsboHideLastName = 'fsbo_hide_last_name',
  /** column name */
  FsboHidePhone = 'fsbo_hide_phone',
  /** column name */
  Furnished = 'furnished',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  MlsTermsEnabled = 'mls_terms_enabled',
  /** column name */
  OccupiedNow = 'occupied_now',
  /** column name */
  OwnerLiving = 'owner_living',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  ShowImageCaptionsOnBrochure = 'show_image_captions_on_brochure',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  WatermarkEnabled = 'watermark_enabled'
}

/** select "lots_aggregate_bool_exp_bool_or_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AutoMatchingResponseEnabled = 'auto_matching_response_enabled',
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludePoiMap = 'brochure_include_poi_map',
  /** column name */
  BrochureIncludePois = 'brochure_include_pois',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  CouplesAllowed = 'couples_allowed',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  FsboHideLastName = 'fsbo_hide_last_name',
  /** column name */
  FsboHidePhone = 'fsbo_hide_phone',
  /** column name */
  Furnished = 'furnished',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  MlsTermsEnabled = 'mls_terms_enabled',
  /** column name */
  OccupiedNow = 'occupied_now',
  /** column name */
  OwnerLiving = 'owner_living',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  ShowImageCaptionsOnBrochure = 'show_image_captions_on_brochure',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  WatermarkEnabled = 'watermark_enabled'
}

/** select "lots_aggregate_bool_exp_corr_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_max_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_min_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_sum_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** select "lots_aggregate_bool_exp_var_samp_arguments_columns" columns of table "lots" */
export enum Lots_Select_Column_Lots_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed'
}

/** input type for updating data in table "lots" */
export type Lots_Set_Input = {
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  auto_matching_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  automatching_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_description_de?: InputMaybe<Scalars['String']['input']>;
  brochure_description_en?: InputMaybe<Scalars['String']['input']>;
  brochure_description_es?: InputMaybe<Scalars['String']['input']>;
  brochure_description_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_description_it?: InputMaybe<Scalars['String']['input']>;
  brochure_description_layout?: InputMaybe<Scalars['smallint']['input']>;
  brochure_description_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_description_pt?: InputMaybe<Scalars['String']['input']>;
  brochure_doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_font_family?: InputMaybe<Scalars['String']['input']>;
  brochure_include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_description?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_poi_map?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_property?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_poi_map_zoom_level?: InputMaybe<Scalars['Float']['input']>;
  brochure_show_agent_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_title_de?: InputMaybe<Scalars['String']['input']>;
  brochure_title_en?: InputMaybe<Scalars['String']['input']>;
  brochure_title_es?: InputMaybe<Scalars['String']['input']>;
  brochure_title_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_title_it?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pt?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  couples_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  doc_template_theme_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  /** FSBO listings only: when true, the advertiser's name is published as first name + last initial ("John S.") instead of the full name. Defaults to false. */
  fsbo_hide_last_name?: InputMaybe<Scalars['Boolean']['input']>;
  /** FSBO listings only: when true, the advertiser's phone number is not published on the listing (e.g. IDX visit_phone). A manually entered contact phone is always published. Defaults to false. */
  fsbo_hide_phone?: InputMaybe<Scalars['Boolean']['input']>;
  furnished?: InputMaybe<Scalars['Boolean']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  last_seller_notification_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimal_stay?: InputMaybe<Scalars['Int']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Scalars['numeric']['input']>;
  /** Type of commission: percentage or fixed */
  mls_commission_type?: InputMaybe<Mls_Commission_Type_Enum_Enum>;
  mls_note?: InputMaybe<Scalars['String']['input']>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode?: InputMaybe<Scalars['String']['input']>;
  /** Whether commission terms are enabled for MLS sharing */
  mls_terms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  occupied_now?: InputMaybe<Scalars['Boolean']['input']>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: InputMaybe<Scalars['String']['input']>;
  oldest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  owner_living?: InputMaybe<Scalars['Boolean']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  seller_notification_frequency?: InputMaybe<Seller_Notification_Frequency_Enum_Enum>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls_at?: InputMaybe<Scalars['timestamptz']['input']>;
  show_image_captions_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Lots_Status_Enum_Enum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  tenant_gender?: InputMaybe<Tenant_Gender_Enum_Enum>;
  tenant_number?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
  watermark_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  watermark_image_url?: InputMaybe<Scalars['String']['input']>;
  watermark_opacity?: InputMaybe<Scalars['numeric']['input']>;
  watermark_position?: InputMaybe<Scalars['String']['input']>;
  watermark_position_x?: InputMaybe<Scalars['Int']['input']>;
  watermark_position_y?: InputMaybe<Scalars['Int']['input']>;
  watermark_rotation?: InputMaybe<Scalars['Int']['input']>;
  watermark_scale?: InputMaybe<Scalars['numeric']['input']>;
  youngest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
};

/** columns and relationships of "lots_status_enum" */
export type Lots_Status_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "lots_status_enum_label" */
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "lots_status_enum". All fields are combined with a logical 'AND'. */
export type Lots_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Lots_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Lots_Status_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Lots_Status_Enum_Enum {
  Abandoned = 'abandoned',
  Available = 'available',
  AvailableComingSoon = 'available_coming_soon',
  AvailableOffMarket = 'available_off_market',
  Draft = 'draft',
  LostSoldOwner = 'lost_sold_owner',
  LostSoldSomeone = 'lost_sold_someone',
  Paused = 'paused',
  /** Listing pending review before publication */
  PendingReview = 'pending_review',
  /** Listing rejected after review */
  Rejected = 'rejected',
  Reserved = 'reserved',
  Won = 'won'
}

/** Boolean expression to compare columns of type "lots_status_enum_enum". All fields are combined with logical 'AND'. */
export type Lots_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Lots_Status_Enum_Enum>;
  _in?: InputMaybe<Array<Lots_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Lots_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<Lots_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "lots_status_enum". */
export type Lots_Status_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "lots_status_enum" */
export enum Lots_Status_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "lots_status_enum" */
export type Lots_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lots_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lots_Status_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Lots_Stddev_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Float']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_position_x?: Maybe<Scalars['Float']['output']>;
  watermark_position_y?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_scale?: Maybe<Scalars['Float']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "lots" */
export type Lots_Stddev_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Lots_Stddev_Pop_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Float']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_position_x?: Maybe<Scalars['Float']['output']>;
  watermark_position_y?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_scale?: Maybe<Scalars['Float']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "lots" */
export type Lots_Stddev_Pop_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Lots_Stddev_Samp_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Float']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_position_x?: Maybe<Scalars['Float']['output']>;
  watermark_position_y?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_scale?: Maybe<Scalars['Float']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "lots" */
export type Lots_Stddev_Samp_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "lots" */
export type Lots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Lots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Lots_Stream_Cursor_Value_Input = {
  address_display_option?: InputMaybe<Address_Display_Options_Enum_Enum>;
  address_display_option_brochure?: InputMaybe<Address_Display_Options_Enum_Enum>;
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  auto_matching_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  automatching_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_cover_image_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_description_de?: InputMaybe<Scalars['String']['input']>;
  brochure_description_en?: InputMaybe<Scalars['String']['input']>;
  brochure_description_es?: InputMaybe<Scalars['String']['input']>;
  brochure_description_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_description_it?: InputMaybe<Scalars['String']['input']>;
  brochure_description_layout?: InputMaybe<Scalars['smallint']['input']>;
  brochure_description_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_description_pt?: InputMaybe<Scalars['String']['input']>;
  brochure_doc_template_id?: InputMaybe<Scalars['uuid']['input']>;
  brochure_font_family?: InputMaybe<Scalars['String']['input']>;
  brochure_include_append_files?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_cover?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_description?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_photos?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_poi_map?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_pois?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_include_property?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_pdf_compression_quality?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  brochure_poi_map_zoom_level?: InputMaybe<Scalars['Float']['input']>;
  brochure_show_agent_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  brochure_title_de?: InputMaybe<Scalars['String']['input']>;
  brochure_title_en?: InputMaybe<Scalars['String']['input']>;
  brochure_title_es?: InputMaybe<Scalars['String']['input']>;
  brochure_title_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_title_it?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pl?: InputMaybe<Scalars['String']['input']>;
  brochure_title_pt?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  commission_rate?: InputMaybe<Scalars['Float']['input']>;
  couples_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  doc_template_theme_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_broker_name?: InputMaybe<Scalars['String']['input']>;
  dummy_broker_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_geom?: InputMaybe<Scalars['geometry']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_living_surface?: InputMaybe<Scalars['String']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_locality_id?: InputMaybe<Scalars['uuid']['input']>;
  dummy_organisation_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_organisation_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_name?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_phone?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_route?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_state?: InputMaybe<Scalars['String']['input']>;
  dummy_organisation_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  dummy_usable_surface?: InputMaybe<Scalars['String']['input']>;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  enable_auto_matching?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_response_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expected_time_to_sell?: InputMaybe<Scalars['String']['input']>;
  fixed_fee?: InputMaybe<Scalars['Int']['input']>;
  /** FSBO listings only: when true, the advertiser's name is published as first name + last initial ("John S.") instead of the full name. Defaults to false. */
  fsbo_hide_last_name?: InputMaybe<Scalars['Boolean']['input']>;
  /** FSBO listings only: when true, the advertiser's phone number is not published on the listing (e.g. IDX visit_phone). A manually entered contact phone is always published. Defaults to false. */
  fsbo_hide_phone?: InputMaybe<Scalars['Boolean']['input']>;
  furnished?: InputMaybe<Scalars['Boolean']['input']>;
  has_success_fee?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  is_exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  is_paid?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_included_in_total?: InputMaybe<Scalars['Boolean']['input']>;
  is_sales_tax_inclusive?: InputMaybe<Scalars['Boolean']['input']>;
  last_seller_notification_at?: InputMaybe<Scalars['timestamptz']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_url?: InputMaybe<Scalars['String']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  mandate_sale_price?: InputMaybe<Scalars['Float']['input']>;
  mandate_type?: InputMaybe<Scalars['String']['input']>;
  minimal_stay?: InputMaybe<Scalars['Int']['input']>;
  minimum_net_seller_price?: InputMaybe<Scalars['Float']['input']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Scalars['numeric']['input']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Scalars['numeric']['input']>;
  /** Type of commission: percentage or fixed */
  mls_commission_type?: InputMaybe<Mls_Commission_Type_Enum_Enum>;
  mls_note?: InputMaybe<Scalars['String']['input']>;
  /** How listing is shared: everyone or individual teams */
  mls_share_mode?: InputMaybe<Scalars['String']['input']>;
  /** Whether commission terms are enabled for MLS sharing */
  mls_terms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  occupied_now?: InputMaybe<Scalars['Boolean']['input']>;
  /** 'sell' or 'rent'; NULL counts as sell, but sale_price_computed is NULL when offer_type is NULL. property_searches says 'buy' and 'rent' instead. */
  offer_type?: InputMaybe<Scalars['String']['input']>;
  oldest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  origin_id?: InputMaybe<Scalars['uuid']['input']>;
  outdoor_parking_price?: InputMaybe<Scalars['float8']['input']>;
  owner_living?: InputMaybe<Scalars['Boolean']['input']>;
  parking_price?: InputMaybe<Scalars['float8']['input']>;
  parking_price_type?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  payment_id?: InputMaybe<Scalars['uuid']['input']>;
  pets_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** What sale_price and rent_net are per: sell (total) or sellm2 (per m2); monthly, yearly, weekly, daily or m2yearly for a rent. */
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  publish_step?: InputMaybe<Scalars['String']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  sale_price_computed?: InputMaybe<Scalars['float8']['input']>;
  seller_notification_frequency?: InputMaybe<Seller_Notification_Frequency_Enum_Enum>;
  send_enquiries_to_sellers?: InputMaybe<Scalars['Boolean']['input']>;
  shared_on_mls_at?: InputMaybe<Scalars['timestamptz']['input']>;
  show_image_captions_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  signed_at?: InputMaybe<Scalars['date']['input']>;
  smoking_allowed?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Lots_Status_Enum_Enum>;
  success_fee_custom?: InputMaybe<Scalars['String']['input']>;
  success_fee_percentage?: InputMaybe<Scalars['Float']['input']>;
  success_fee_type?: InputMaybe<Scalars['String']['input']>;
  tenant_gender?: InputMaybe<Tenant_Gender_Enum_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_number?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_contact?: InputMaybe<Scalars['Boolean']['input']>;
  video_url?: InputMaybe<Scalars['String']['input']>;
  virtual_visit_url?: InputMaybe<Scalars['String']['input']>;
  watermark_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  watermark_image_url?: InputMaybe<Scalars['String']['input']>;
  watermark_opacity?: InputMaybe<Scalars['numeric']['input']>;
  watermark_position?: InputMaybe<Scalars['String']['input']>;
  watermark_position_x?: InputMaybe<Scalars['Int']['input']>;
  watermark_position_y?: InputMaybe<Scalars['Int']['input']>;
  watermark_rotation?: InputMaybe<Scalars['Int']['input']>;
  watermark_scale?: InputMaybe<Scalars['numeric']['input']>;
  youngest_tenant_age?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Lots_Sum_Fields = {
  brochure_description_layout?: Maybe<Scalars['smallint']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['float8']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['float8']['output']>;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  fixed_fee?: Maybe<Scalars['Int']['output']>;
  indoor_parking_price?: Maybe<Scalars['float8']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Int']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Int']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  outdoor_parking_price?: Maybe<Scalars['float8']['output']>;
  parking_price?: Maybe<Scalars['float8']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  sale_price_computed?: Maybe<Scalars['float8']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Int']['output']>;
  watermark_opacity?: Maybe<Scalars['numeric']['output']>;
  watermark_position_x?: Maybe<Scalars['Int']['output']>;
  watermark_position_y?: Maybe<Scalars['Int']['output']>;
  watermark_rotation?: Maybe<Scalars['Int']['output']>;
  watermark_scale?: Maybe<Scalars['numeric']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "lots" */
export type Lots_Sum_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** update columns of table "lots" */
export enum Lots_Update_Column {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AddressDisplayOptionBrochure = 'address_display_option_brochure',
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  AutoMatchingResponseEnabled = 'auto_matching_response_enabled',
  /** column name */
  AutomatchingSenderId = 'automatching_sender_id',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureCoverImageId = 'brochure_cover_image_id',
  /** column name */
  BrochureDescriptionDe = 'brochure_description_de',
  /** column name */
  BrochureDescriptionEn = 'brochure_description_en',
  /** column name */
  BrochureDescriptionEs = 'brochure_description_es',
  /** column name */
  BrochureDescriptionFr = 'brochure_description_fr',
  /** column name */
  BrochureDescriptionIt = 'brochure_description_it',
  /** column name */
  BrochureDescriptionLayout = 'brochure_description_layout',
  /** column name */
  BrochureDescriptionPl = 'brochure_description_pl',
  /** column name */
  BrochureDescriptionPt = 'brochure_description_pt',
  /** column name */
  BrochureDocTemplateId = 'brochure_doc_template_id',
  /** column name */
  BrochureFontFamily = 'brochure_font_family',
  /** column name */
  BrochureIncludeAppendFiles = 'brochure_include_append_files',
  /** column name */
  BrochureIncludeCover = 'brochure_include_cover',
  /** column name */
  BrochureIncludeDescription = 'brochure_include_description',
  /** column name */
  BrochureIncludePhotos = 'brochure_include_photos',
  /** column name */
  BrochureIncludePoiMap = 'brochure_include_poi_map',
  /** column name */
  BrochureIncludePois = 'brochure_include_pois',
  /** column name */
  BrochureIncludeProperty = 'brochure_include_property',
  /** column name */
  BrochurePdfCompressionQuality = 'brochure_pdf_compression_quality',
  /** column name */
  BrochurePoiMapZoomLevel = 'brochure_poi_map_zoom_level',
  /** column name */
  BrochureShowAgentOnBrochure = 'brochure_show_agent_on_brochure',
  /** column name */
  BrochureTitleDe = 'brochure_title_de',
  /** column name */
  BrochureTitleEn = 'brochure_title_en',
  /** column name */
  BrochureTitleEs = 'brochure_title_es',
  /** column name */
  BrochureTitleFr = 'brochure_title_fr',
  /** column name */
  BrochureTitleIt = 'brochure_title_it',
  /** column name */
  BrochureTitlePl = 'brochure_title_pl',
  /** column name */
  BrochureTitlePt = 'brochure_title_pt',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CommissionRate = 'commission_rate',
  /** column name */
  CouplesAllowed = 'couples_allowed',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DevelopmentId = 'development_id',
  /** column name */
  DocTemplateThemeId = 'doc_template_theme_id',
  /** column name */
  DummyBrokerName = 'dummy_broker_name',
  /** column name */
  DummyBrokerPhone = 'dummy_broker_phone',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyGeom = 'dummy_geom',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLivingSurface = 'dummy_living_surface',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyLocalityId = 'dummy_locality_id',
  /** column name */
  DummyOrganisationCountryCode = 'dummy_organisation_country_code',
  /** column name */
  DummyOrganisationLat = 'dummy_organisation_lat',
  /** column name */
  DummyOrganisationLng = 'dummy_organisation_lng',
  /** column name */
  DummyOrganisationLocality = 'dummy_organisation_locality',
  /** column name */
  DummyOrganisationName = 'dummy_organisation_name',
  /** column name */
  DummyOrganisationPhone = 'dummy_organisation_phone',
  /** column name */
  DummyOrganisationPostcode = 'dummy_organisation_postcode',
  /** column name */
  DummyOrganisationRoute = 'dummy_organisation_route',
  /** column name */
  DummyOrganisationState = 'dummy_organisation_state',
  /** column name */
  DummyOrganisationStreetNumber = 'dummy_organisation_street_number',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  DummyUsableSurface = 'dummy_usable_surface',
  /** column name */
  DurationInMonths = 'duration_in_months',
  /** column name */
  EnableAutoMatching = 'enable_auto_matching',
  /** column name */
  EnquiryResponseEnabled = 'enquiry_response_enabled',
  /** column name */
  ExpectedTimeToSell = 'expected_time_to_sell',
  /** column name */
  FixedFee = 'fixed_fee',
  /** column name */
  FsboHideLastName = 'fsbo_hide_last_name',
  /** column name */
  FsboHidePhone = 'fsbo_hide_phone',
  /** column name */
  Furnished = 'furnished',
  /** column name */
  HasSuccessFee = 'has_success_fee',
  /** column name */
  HidePriceOnBrochure = 'hide_price_on_brochure',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  IndoorParkingPrice = 'indoor_parking_price',
  /** column name */
  IsExclusive = 'is_exclusive',
  /** column name */
  IsPaid = 'is_paid',
  /** column name */
  IsParkingIncludedInTotal = 'is_parking_included_in_total',
  /** column name */
  IsSalesTaxInclusive = 'is_sales_tax_inclusive',
  /** column name */
  LastSellerNotificationAt = 'last_seller_notification_at',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  ListingUrl = 'listing_url',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MandateSalePrice = 'mandate_sale_price',
  /** column name */
  MandateType = 'mandate_type',
  /** column name */
  MinimalStay = 'minimal_stay',
  /** column name */
  MinimumNetSellerPrice = 'minimum_net_seller_price',
  /** column name */
  MlsBuyerAgentShareFixedAmount = 'mls_buyer_agent_share_fixed_amount',
  /** column name */
  MlsBuyerAgentSharePercent = 'mls_buyer_agent_share_percent',
  /** column name */
  MlsCommissionType = 'mls_commission_type',
  /** column name */
  MlsNote = 'mls_note',
  /** column name */
  MlsShareMode = 'mls_share_mode',
  /** column name */
  MlsTermsEnabled = 'mls_terms_enabled',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  OccupiedNow = 'occupied_now',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OldestTenantAge = 'oldest_tenant_age',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OriginId = 'origin_id',
  /** column name */
  OutdoorParkingPrice = 'outdoor_parking_price',
  /** column name */
  OwnerLiving = 'owner_living',
  /** column name */
  ParkingPrice = 'parking_price',
  /** column name */
  ParkingPriceType = 'parking_price_type',
  /** column name */
  PaymentId = 'payment_id',
  /** column name */
  PetsAllowed = 'pets_allowed',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PublishStep = 'publish_step',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceComputed = 'sale_price_computed',
  /** column name */
  SellerNotificationFrequency = 'seller_notification_frequency',
  /** column name */
  SendEnquiriesToSellers = 'send_enquiries_to_sellers',
  /** column name */
  SharedOnMlsAt = 'shared_on_mls_at',
  /** column name */
  ShowImageCaptionsOnBrochure = 'show_image_captions_on_brochure',
  /** column name */
  SignedAt = 'signed_at',
  /** column name */
  SmokingAllowed = 'smoking_allowed',
  /** column name */
  Status = 'status',
  /** column name */
  SuccessFeeCustom = 'success_fee_custom',
  /** column name */
  SuccessFeePercentage = 'success_fee_percentage',
  /** column name */
  SuccessFeeType = 'success_fee_type',
  /** column name */
  TenantGender = 'tenant_gender',
  /** column name */
  TenantNumber = 'tenant_number',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address',
  /** column name */
  UseDummyContact = 'use_dummy_contact',
  /** column name */
  VideoUrl = 'video_url',
  /** column name */
  VirtualVisitUrl = 'virtual_visit_url',
  /** column name */
  WatermarkEnabled = 'watermark_enabled',
  /** column name */
  WatermarkImageUrl = 'watermark_image_url',
  /** column name */
  WatermarkOpacity = 'watermark_opacity',
  /** column name */
  WatermarkPosition = 'watermark_position',
  /** column name */
  WatermarkPositionX = 'watermark_position_x',
  /** column name */
  WatermarkPositionY = 'watermark_position_y',
  /** column name */
  WatermarkRotation = 'watermark_rotation',
  /** column name */
  WatermarkScale = 'watermark_scale',
  /** column name */
  YoungestTenantAge = 'youngest_tenant_age'
}

export type Lots_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Lots_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Lots_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Lots_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Lots_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Lots_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Lots_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Lots_Set_Input>;
  /** filter the rows which have to be updated */
  where: Lots_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Lots_Var_Pop_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Float']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_position_x?: Maybe<Scalars['Float']['output']>;
  watermark_position_y?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_scale?: Maybe<Scalars['Float']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "lots" */
export type Lots_Var_Pop_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Lots_Var_Samp_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Float']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_position_x?: Maybe<Scalars['Float']['output']>;
  watermark_position_y?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_scale?: Maybe<Scalars['Float']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "lots" */
export type Lots_Var_Samp_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Lots_Variance_Fields = {
  brochure_description_layout?: Maybe<Scalars['Float']['output']>;
  brochure_poi_map_zoom_level?: Maybe<Scalars['Float']['output']>;
  commission_rate?: Maybe<Scalars['Float']['output']>;
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lat?: Maybe<Scalars['Float']['output']>;
  dummy_organisation_lng?: Maybe<Scalars['Float']['output']>;
  duration_in_months?: Maybe<Scalars['Float']['output']>;
  fixed_fee?: Maybe<Scalars['Float']['output']>;
  indoor_parking_price?: Maybe<Scalars['Float']['output']>;
  mandate_sale_price?: Maybe<Scalars['Float']['output']>;
  minimal_stay?: Maybe<Scalars['Float']['output']>;
  minimum_net_seller_price?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  oldest_tenant_age?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  outdoor_parking_price?: Maybe<Scalars['Float']['output']>;
  parking_price?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_computed?: Maybe<Scalars['Float']['output']>;
  success_fee_percentage?: Maybe<Scalars['Float']['output']>;
  tenant_number?: Maybe<Scalars['Float']['output']>;
  watermark_opacity?: Maybe<Scalars['Float']['output']>;
  watermark_position_x?: Maybe<Scalars['Float']['output']>;
  watermark_position_y?: Maybe<Scalars['Float']['output']>;
  watermark_rotation?: Maybe<Scalars['Float']['output']>;
  watermark_scale?: Maybe<Scalars['Float']['output']>;
  youngest_tenant_age?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "lots" */
export type Lots_Variance_Order_By = {
  brochure_description_layout?: InputMaybe<Order_By>;
  brochure_poi_map_zoom_level?: InputMaybe<Order_By>;
  commission_rate?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_organisation_lat?: InputMaybe<Order_By>;
  dummy_organisation_lng?: InputMaybe<Order_By>;
  duration_in_months?: InputMaybe<Order_By>;
  fixed_fee?: InputMaybe<Order_By>;
  indoor_parking_price?: InputMaybe<Order_By>;
  mandate_sale_price?: InputMaybe<Order_By>;
  minimal_stay?: InputMaybe<Order_By>;
  minimum_net_seller_price?: InputMaybe<Order_By>;
  /** Buyer agent fixed commission amount */
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  /** Buyer agent commission percentage (0-100) */
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  oldest_tenant_age?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  outdoor_parking_price?: InputMaybe<Order_By>;
  parking_price?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_computed?: InputMaybe<Order_By>;
  success_fee_percentage?: InputMaybe<Order_By>;
  tenant_number?: InputMaybe<Order_By>;
  watermark_opacity?: InputMaybe<Order_By>;
  watermark_position_x?: InputMaybe<Order_By>;
  watermark_position_y?: InputMaybe<Order_By>;
  watermark_rotation?: InputMaybe<Order_By>;
  watermark_scale?: InputMaybe<Order_By>;
  youngest_tenant_age?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "marital_status". All fields are combined with logical 'AND'. */
export type Marital_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['marital_status']['input']>;
  _gt?: InputMaybe<Scalars['marital_status']['input']>;
  _gte?: InputMaybe<Scalars['marital_status']['input']>;
  _in?: InputMaybe<Array<Scalars['marital_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['marital_status']['input']>;
  _lte?: InputMaybe<Scalars['marital_status']['input']>;
  _neq?: InputMaybe<Scalars['marital_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['marital_status']['input']>>;
};

/** columns and relationships of "marketing_metadata" */
export type Marketing_Metadata = {
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  ip_address?: Maybe<Scalars['inet']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "marketing_metadata". All fields are combined with a logical 'AND'. */
export type Marketing_Metadata_Bool_Exp = {
  _and?: InputMaybe<Array<Marketing_Metadata_Bool_Exp>>;
  _not?: InputMaybe<Marketing_Metadata_Bool_Exp>;
  _or?: InputMaybe<Array<Marketing_Metadata_Bool_Exp>>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  ip_address?: InputMaybe<Inet_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  utm_campaign?: InputMaybe<String_Comparison_Exp>;
  utm_source?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "marketing_metadata". */
export type Marketing_Metadata_Order_By = {
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ip_address?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  utm_campaign?: InputMaybe<Order_By>;
  utm_source?: InputMaybe<Order_By>;
};

/** select columns of table "marketing_metadata" */
export enum Marketing_Metadata_Select_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IpAddress = 'ip_address',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UtmCampaign = 'utm_campaign',
  /** column name */
  UtmSource = 'utm_source'
}

/** Streaming cursor of the table "marketing_metadata" */
export type Marketing_Metadata_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketing_Metadata_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketing_Metadata_Stream_Cursor_Value_Input = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ip_address?: InputMaybe<Scalars['inet']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "marketplace_conversation_participants" */
export type Marketplace_Conversation_Participants = {
  archived_at?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  conversation: Marketplace_Conversations;
  conversation_id: Scalars['uuid']['output'];
  is_unread: Scalars['Boolean']['output'];
  joined_at: Scalars['timestamptz']['output'];
  last_read_at?: Maybe<Scalars['timestamptz']['output']>;
  role: Marketplace_Participant_Role_Enum_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "marketplace_conversation_participants" */
export type Marketplace_Conversation_Participants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Marketplace_Conversation_Participants_Max_Order_By>;
  min?: InputMaybe<Marketplace_Conversation_Participants_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "marketplace_conversation_participants". All fields are combined with a logical 'AND'. */
export type Marketplace_Conversation_Participants_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Conversation_Participants_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Conversation_Participants_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Conversation_Participants_Bool_Exp>>;
  archived_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  conversation?: InputMaybe<Marketplace_Conversations_Bool_Exp>;
  conversation_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_unread?: InputMaybe<Boolean_Comparison_Exp>;
  joined_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_read_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  role?: InputMaybe<Marketplace_Participant_Role_Enum_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "marketplace_conversation_participants" */
export type Marketplace_Conversation_Participants_Max_Order_By = {
  archived_at?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  joined_at?: InputMaybe<Order_By>;
  last_read_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "marketplace_conversation_participants" */
export type Marketplace_Conversation_Participants_Min_Order_By = {
  archived_at?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  joined_at?: InputMaybe<Order_By>;
  last_read_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "marketplace_conversation_participants" */
export type Marketplace_Conversation_Participants_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Marketplace_Conversation_Participants>;
};

/** Ordering options when selecting data from "marketplace_conversation_participants". */
export type Marketplace_Conversation_Participants_Order_By = {
  archived_at?: InputMaybe<Order_By>;
  conversation?: InputMaybe<Marketplace_Conversations_Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  is_unread?: InputMaybe<Order_By>;
  joined_at?: InputMaybe<Order_By>;
  last_read_at?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: marketplace_conversation_participants */
export type Marketplace_Conversation_Participants_Pk_Columns_Input = {
  conversation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "marketplace_conversation_participants" */
export enum Marketplace_Conversation_Participants_Select_Column {
  /** column name */
  ArchivedAt = 'archived_at',
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  IsUnread = 'is_unread',
  /** column name */
  JoinedAt = 'joined_at',
  /** column name */
  LastReadAt = 'last_read_at',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "marketplace_conversation_participants" */
export type Marketplace_Conversation_Participants_Set_Input = {
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "marketplace_conversation_participants" */
export type Marketplace_Conversation_Participants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Conversation_Participants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Conversation_Participants_Stream_Cursor_Value_Input = {
  archived_at?: InputMaybe<Scalars['timestamptz']['input']>;
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  is_unread?: InputMaybe<Scalars['Boolean']['input']>;
  joined_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_read_at?: InputMaybe<Scalars['timestamptz']['input']>;
  role?: InputMaybe<Marketplace_Participant_Role_Enum_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Marketplace_Conversation_Participants_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Marketplace_Conversation_Participants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Marketplace_Conversation_Participants_Bool_Exp;
};

/** Marketplace participant identities with display names resolved from users at read time so account anonymization is reflected immediately. */
export type Marketplace_Conversation_Public_Participants = {
  /** An object relationship */
  conversation?: Maybe<Marketplace_Conversations>;
  conversation_id?: Maybe<Scalars['uuid']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  joined_at?: Maybe<Scalars['timestamptz']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "marketplace_conversation_public_participants" */
export type Marketplace_Conversation_Public_Participants_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Marketplace_Conversation_Public_Participants_Max_Order_By>;
  min?: InputMaybe<Marketplace_Conversation_Public_Participants_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "marketplace_conversation_public_participants". All fields are combined with a logical 'AND'. */
export type Marketplace_Conversation_Public_Participants_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Conversation_Public_Participants_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Bool_Exp>>;
  conversation?: InputMaybe<Marketplace_Conversations_Bool_Exp>;
  conversation_id?: InputMaybe<Uuid_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  joined_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  role?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "marketplace_conversation_public_participants" */
export type Marketplace_Conversation_Public_Participants_Max_Order_By = {
  conversation_id?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  joined_at?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "marketplace_conversation_public_participants" */
export type Marketplace_Conversation_Public_Participants_Min_Order_By = {
  conversation_id?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  joined_at?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "marketplace_conversation_public_participants". */
export type Marketplace_Conversation_Public_Participants_Order_By = {
  conversation?: InputMaybe<Marketplace_Conversations_Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  joined_at?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "marketplace_conversation_public_participants" */
export enum Marketplace_Conversation_Public_Participants_Select_Column {
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  JoinedAt = 'joined_at',
  /** column name */
  Role = 'role',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "marketplace_conversation_public_participants" */
export type Marketplace_Conversation_Public_Participants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Conversation_Public_Participants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Conversation_Public_Participants_Stream_Cursor_Value_Input = {
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  joined_at?: InputMaybe<Scalars['timestamptz']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Marketplace conversation identity plus an immutable listing snapshot captured at conversation creation; listing changes and delisting do not rewrite message history. */
export type Marketplace_Conversations = {
  aggregator_listing_id: Scalars['Int']['output'];
  buyer_user_id: Scalars['uuid']['output'];
  /** A computed field, executes function "marketplace_conversation_can_message" */
  can_message?: Maybe<Scalars['Boolean']['output']>;
  country_code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  last_message?: Maybe<Marketplace_Messages>;
  last_message_at?: Maybe<Scalars['timestamptz']['output']>;
  last_message_id?: Maybe<Scalars['uuid']['output']>;
  listing_currency?: Maybe<Scalars['String']['output']>;
  listing_image_url?: Maybe<Scalars['String']['output']>;
  listing_locality?: Maybe<Scalars['String']['output']>;
  listing_price?: Maybe<Scalars['numeric']['output']>;
  listing_public_url?: Maybe<Scalars['String']['output']>;
  listing_title: Scalars['String']['output'];
  /** Nullable after a lot is deleted; the listing snapshot and both participants message history remain available. */
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  messages: Array<Marketplace_Messages>;
  /** An array relationship */
  participants: Array<Marketplace_Conversation_Participants>;
  /** An array relationship */
  public_participants: Array<Marketplace_Conversation_Public_Participants>;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Marketplace conversation identity plus an immutable listing snapshot captured at conversation creation; listing changes and delisting do not rewrite message history. */
export type Marketplace_ConversationsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Messages_Order_By>>;
  where?: InputMaybe<Marketplace_Messages_Bool_Exp>;
};


/** Marketplace conversation identity plus an immutable listing snapshot captured at conversation creation; listing changes and delisting do not rewrite message history. */
export type Marketplace_ConversationsParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversation_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversation_Participants_Order_By>>;
  where?: InputMaybe<Marketplace_Conversation_Participants_Bool_Exp>;
};


/** Marketplace conversation identity plus an immutable listing snapshot captured at conversation creation; listing changes and delisting do not rewrite message history. */
export type Marketplace_ConversationsPublic_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Order_By>>;
  where?: InputMaybe<Marketplace_Conversation_Public_Participants_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "marketplace_conversations". All fields are combined with a logical 'AND'. */
export type Marketplace_Conversations_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Conversations_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Conversations_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Conversations_Bool_Exp>>;
  aggregator_listing_id?: InputMaybe<Int_Comparison_Exp>;
  buyer_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  can_message?: InputMaybe<Boolean_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_message?: InputMaybe<Marketplace_Messages_Bool_Exp>;
  last_message_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  listing_currency?: InputMaybe<String_Comparison_Exp>;
  listing_image_url?: InputMaybe<String_Comparison_Exp>;
  listing_locality?: InputMaybe<String_Comparison_Exp>;
  listing_price?: InputMaybe<Numeric_Comparison_Exp>;
  listing_public_url?: InputMaybe<String_Comparison_Exp>;
  listing_title?: InputMaybe<String_Comparison_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  messages?: InputMaybe<Marketplace_Messages_Bool_Exp>;
  participants?: InputMaybe<Marketplace_Conversation_Participants_Bool_Exp>;
  public_participants?: InputMaybe<Marketplace_Conversation_Public_Participants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Ordering options when selecting data from "marketplace_conversations". */
export type Marketplace_Conversations_Order_By = {
  aggregator_listing_id?: InputMaybe<Order_By>;
  buyer_user_id?: InputMaybe<Order_By>;
  can_message?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_message?: InputMaybe<Marketplace_Messages_Order_By>;
  last_message_at?: InputMaybe<Order_By>;
  last_message_id?: InputMaybe<Order_By>;
  listing_currency?: InputMaybe<Order_By>;
  listing_image_url?: InputMaybe<Order_By>;
  listing_locality?: InputMaybe<Order_By>;
  listing_price?: InputMaybe<Order_By>;
  listing_public_url?: InputMaybe<Order_By>;
  listing_title?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  messages_aggregate?: InputMaybe<Marketplace_Messages_Aggregate_Order_By>;
  participants_aggregate?: InputMaybe<Marketplace_Conversation_Participants_Aggregate_Order_By>;
  public_participants_aggregate?: InputMaybe<Marketplace_Conversation_Public_Participants_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "marketplace_conversations" */
export enum Marketplace_Conversations_Select_Column {
  /** column name */
  AggregatorListingId = 'aggregator_listing_id',
  /** column name */
  BuyerUserId = 'buyer_user_id',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LastMessageAt = 'last_message_at',
  /** column name */
  LastMessageId = 'last_message_id',
  /** column name */
  ListingCurrency = 'listing_currency',
  /** column name */
  ListingImageUrl = 'listing_image_url',
  /** column name */
  ListingLocality = 'listing_locality',
  /** column name */
  ListingPrice = 'listing_price',
  /** column name */
  ListingPublicUrl = 'listing_public_url',
  /** column name */
  ListingTitle = 'listing_title',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "marketplace_conversations" */
export type Marketplace_Conversations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Conversations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Conversations_Stream_Cursor_Value_Input = {
  aggregator_listing_id?: InputMaybe<Scalars['Int']['input']>;
  buyer_user_id?: InputMaybe<Scalars['uuid']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_message_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_message_id?: InputMaybe<Scalars['uuid']['input']>;
  listing_currency?: InputMaybe<Scalars['String']['input']>;
  listing_image_url?: InputMaybe<Scalars['String']['input']>;
  listing_locality?: InputMaybe<Scalars['String']['input']>;
  listing_price?: InputMaybe<Scalars['numeric']['input']>;
  listing_public_url?: InputMaybe<Scalars['String']['input']>;
  listing_title?: InputMaybe<Scalars['String']['input']>;
  /** Nullable after a lot is deleted; the listing snapshot and both participants message history remain available. */
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "marketplace_message_delivery_channel_enum" */
export type Marketplace_Message_Delivery_Channel_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "marketplace_message_delivery_channel_enum". All fields are combined with a logical 'AND'. */
export type Marketplace_Message_Delivery_Channel_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Message_Delivery_Channel_Enum_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Message_Delivery_Channel_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Message_Delivery_Channel_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "marketplace_message_delivery_channel_enum". */
export type Marketplace_Message_Delivery_Channel_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "marketplace_message_delivery_channel_enum" */
export enum Marketplace_Message_Delivery_Channel_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "marketplace_message_delivery_channel_enum" */
export type Marketplace_Message_Delivery_Channel_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Message_Delivery_Channel_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Message_Delivery_Channel_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "marketplace_message_delivery_status_enum" */
export type Marketplace_Message_Delivery_Status_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "marketplace_message_delivery_status_enum". All fields are combined with a logical 'AND'. */
export type Marketplace_Message_Delivery_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Message_Delivery_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Message_Delivery_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Message_Delivery_Status_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "marketplace_message_delivery_status_enum". */
export type Marketplace_Message_Delivery_Status_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "marketplace_message_delivery_status_enum" */
export enum Marketplace_Message_Delivery_Status_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "marketplace_message_delivery_status_enum" */
export type Marketplace_Message_Delivery_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Message_Delivery_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Message_Delivery_Status_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "marketplace_message_origin_enum" */
export type Marketplace_Message_Origin_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "marketplace_message_origin_enum". All fields are combined with a logical 'AND'. */
export type Marketplace_Message_Origin_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Message_Origin_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Marketplace_Message_Origin_Enum_Enum {
  /** Message sent from the native app through the send action. */
  App = 'app',
  /** Message ingested from an inbound email reply. */
  Email = 'email',
  /** Message sent from the web inbox through the send action. */
  Web = 'web'
}

/** Boolean expression to compare columns of type "marketplace_message_origin_enum_enum". All fields are combined with logical 'AND'. */
export type Marketplace_Message_Origin_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Marketplace_Message_Origin_Enum_Enum>;
  _in?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Marketplace_Message_Origin_Enum_Enum>;
  _nin?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Enum>>;
};

/** Ordering options when selecting data from "marketplace_message_origin_enum". */
export type Marketplace_Message_Origin_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "marketplace_message_origin_enum" */
export enum Marketplace_Message_Origin_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "marketplace_message_origin_enum" */
export type Marketplace_Message_Origin_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Message_Origin_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Message_Origin_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "marketplace_messages" */
export type Marketplace_Messages = {
  body: Scalars['String']['output'];
  client_message_id: Scalars['uuid']['output'];
  /** An object relationship */
  conversation: Marketplace_Conversations;
  conversation_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  origin: Marketplace_Message_Origin_Enum_Enum;
  /** Set by the send action and inbound route based on lightweight risk heuristics. Kept as a boolean projection alongside risk_reasons so clients can read both without a join. */
  requires_caution: Scalars['Boolean']['output'];
  /** JSON array of short reason codes explaining the caution flag (e.g. ["external_url"], ["phone_number"]). Empty array when requires_caution = false. */
  risk_reasons: Scalars['jsonb']['output'];
  /** An object relationship */
  sender: Users;
  sender_user_id: Scalars['uuid']['output'];
};


/** columns and relationships of "marketplace_messages" */
export type Marketplace_MessagesRisk_ReasonsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "marketplace_messages" */
export type Marketplace_Messages_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Marketplace_Messages_Max_Order_By>;
  min?: InputMaybe<Marketplace_Messages_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "marketplace_messages". All fields are combined with a logical 'AND'. */
export type Marketplace_Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Messages_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Messages_Bool_Exp>>;
  body?: InputMaybe<String_Comparison_Exp>;
  client_message_id?: InputMaybe<Uuid_Comparison_Exp>;
  conversation?: InputMaybe<Marketplace_Conversations_Bool_Exp>;
  conversation_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  origin?: InputMaybe<Marketplace_Message_Origin_Enum_Enum_Comparison_Exp>;
  requires_caution?: InputMaybe<Boolean_Comparison_Exp>;
  risk_reasons?: InputMaybe<Jsonb_Comparison_Exp>;
  sender?: InputMaybe<Users_Bool_Exp>;
  sender_user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "marketplace_messages" */
export type Marketplace_Messages_Max_Order_By = {
  body?: InputMaybe<Order_By>;
  client_message_id?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sender_user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "marketplace_messages" */
export type Marketplace_Messages_Min_Order_By = {
  body?: InputMaybe<Order_By>;
  client_message_id?: InputMaybe<Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sender_user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "marketplace_messages". */
export type Marketplace_Messages_Order_By = {
  body?: InputMaybe<Order_By>;
  client_message_id?: InputMaybe<Order_By>;
  conversation?: InputMaybe<Marketplace_Conversations_Order_By>;
  conversation_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  origin?: InputMaybe<Order_By>;
  requires_caution?: InputMaybe<Order_By>;
  risk_reasons?: InputMaybe<Order_By>;
  sender?: InputMaybe<Users_Order_By>;
  sender_user_id?: InputMaybe<Order_By>;
};

/** select columns of table "marketplace_messages" */
export enum Marketplace_Messages_Select_Column {
  /** column name */
  Body = 'body',
  /** column name */
  ClientMessageId = 'client_message_id',
  /** column name */
  ConversationId = 'conversation_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Origin = 'origin',
  /** column name */
  RequiresCaution = 'requires_caution',
  /** column name */
  RiskReasons = 'risk_reasons',
  /** column name */
  SenderUserId = 'sender_user_id'
}

/** Streaming cursor of the table "marketplace_messages" */
export type Marketplace_Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Messages_Stream_Cursor_Value_Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  client_message_id?: InputMaybe<Scalars['uuid']['input']>;
  conversation_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  origin?: InputMaybe<Marketplace_Message_Origin_Enum_Enum>;
  /** Set by the send action and inbound route based on lightweight risk heuristics. Kept as a boolean projection alongside risk_reasons so clients can read both without a join. */
  requires_caution?: InputMaybe<Scalars['Boolean']['input']>;
  /** JSON array of short reason codes explaining the caution flag (e.g. ["external_url"], ["phone_number"]). Empty array when requires_caution = false. */
  risk_reasons?: InputMaybe<Scalars['jsonb']['input']>;
  sender_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "marketplace_participant_role_enum" */
export type Marketplace_Participant_Role_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "marketplace_participant_role_enum". All fields are combined with a logical 'AND'. */
export type Marketplace_Participant_Role_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Bool_Exp>>;
  _not?: InputMaybe<Marketplace_Participant_Role_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Marketplace_Participant_Role_Enum_Enum {
  /** The user who initiated the conversation from a marketplace listing. */
  Buyer = 'buyer',
  /** The FSBO seller attached to the listing. */
  Seller = 'seller'
}

/** Boolean expression to compare columns of type "marketplace_participant_role_enum_enum". All fields are combined with logical 'AND'. */
export type Marketplace_Participant_Role_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Marketplace_Participant_Role_Enum_Enum>;
  _in?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Marketplace_Participant_Role_Enum_Enum>;
  _nin?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Enum>>;
};

/** Ordering options when selecting data from "marketplace_participant_role_enum". */
export type Marketplace_Participant_Role_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "marketplace_participant_role_enum" */
export enum Marketplace_Participant_Role_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "marketplace_participant_role_enum" */
export type Marketplace_Participant_Role_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Marketplace_Participant_Role_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Marketplace_Participant_Role_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Merged_Listings_Compare_Args = {
  computed_price_per_sqm_gte?: InputMaybe<Scalars['Int']['input']>;
  computed_price_per_sqm_lte?: InputMaybe<Scalars['Int']['input']>;
  computed_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  computed_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  district_id_in?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Int']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Int']['input']>;
  locality_id_in?: InputMaybe<Scalars['String']['input']>;
  municipality_id_in?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id_in?: InputMaybe<Scalars['String']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offline?: InputMaybe<Scalars['Boolean']['input']>;
  property_main_type_in?: InputMaybe<Scalars['String']['input']>;
  property_type_in?: InputMaybe<Scalars['String']['input']>;
  property_type_nin?: InputMaybe<Scalars['String']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sort_by?: InputMaybe<Scalars['String']['input']>;
  sort_dir?: InputMaybe<Scalars['String']['input']>;
  state_id_in?: InputMaybe<Scalars['String']['input']>;
};

export type Message_Aggregate_Bool_Exp = {
  count?: InputMaybe<Message_Aggregate_Bool_Exp_Count>;
};

export type Message_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Message_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Mls_Agent_Buyer_Matches_Args = {
  lot_ids?: InputMaybe<Scalars['_uuid']['input']>;
};

/** Users who are brokers of active MLS listings (available/reserved only) */
export type Mls_Brokers = {
  /** An object relationship */
  default_mls_team?: Maybe<Mls_Teams>;
  /** An object relationship */
  default_team?: Maybe<Teams>;
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  emails: Array<Emails>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  user_images: Array<User_Images>;
};


/** Users who are brokers of active MLS listings (available/reserved only) */
export type Mls_BrokersEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


/** Users who are brokers of active MLS listings (available/reserved only) */
export type Mls_BrokersPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** Users who are brokers of active MLS listings (available/reserved only) */
export type Mls_BrokersPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** Users who are brokers of active MLS listings (available/reserved only) */
export type Mls_BrokersUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};

/** aggregated selection of "mls_brokers" */
export type Mls_Brokers_Aggregate = {
  aggregate?: Maybe<Mls_Brokers_Aggregate_Fields>;
  nodes: Array<Mls_Brokers>;
};

/** aggregate fields of "mls_brokers" */
export type Mls_Brokers_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mls_Brokers_Max_Fields>;
  min?: Maybe<Mls_Brokers_Min_Fields>;
};


/** aggregate fields of "mls_brokers" */
export type Mls_Brokers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mls_Brokers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mls_brokers". All fields are combined with a logical 'AND'. */
export type Mls_Brokers_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Brokers_Bool_Exp>>;
  _not?: InputMaybe<Mls_Brokers_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Brokers_Bool_Exp>>;
  default_mls_team?: InputMaybe<Mls_Teams_Bool_Exp>;
  default_team?: InputMaybe<Teams_Bool_Exp>;
  default_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  emails?: InputMaybe<Emails_Bool_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  phone_numbers?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_images?: InputMaybe<User_Images_Bool_Exp>;
};

/** aggregate max on columns */
export type Mls_Brokers_Max_Fields = {
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Mls_Brokers_Min_Fields = {
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "mls_brokers". */
export type Mls_Brokers_Order_By = {
  default_mls_team?: InputMaybe<Mls_Teams_Order_By>;
  default_team?: InputMaybe<Teams_Order_By>;
  default_team_id?: InputMaybe<Order_By>;
  emails_aggregate?: InputMaybe<Emails_Aggregate_Order_By>;
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user_images_aggregate?: InputMaybe<User_Images_Aggregate_Order_By>;
};

/** select columns of table "mls_brokers" */
export enum Mls_Brokers_Select_Column {
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  ProfileImageUrl = 'profile_image_url',
  /** column name */
  TenantId = 'tenant_id'
}

/** Return type of mls_agent_buyer_matches(); never populated, no direct select. */
export type Mls_Buyer_Match_Edge = {
  buyer_user_id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  property_search_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "mls_buyer_match_edge". All fields are combined with a logical 'AND'. */
export type Mls_Buyer_Match_Edge_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Buyer_Match_Edge_Bool_Exp>>;
  _not?: InputMaybe<Mls_Buyer_Match_Edge_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Buyer_Match_Edge_Bool_Exp>>;
  buyer_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "mls_buyer_match_edge". */
export type Mls_Buyer_Match_Edge_Order_By = {
  buyer_user_id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** select columns of table "mls_buyer_match_edge" */
export enum Mls_Buyer_Match_Edge_Select_Column {
  /** column name */
  BuyerUserId = 'buyer_user_id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

/** Streaming cursor of the table "mls_buyer_match_edge" */
export type Mls_Buyer_Match_Edge_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Buyer_Match_Edge_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Buyer_Match_Edge_Stream_Cursor_Value_Input = {
  buyer_user_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** MLS commission calculation types */
export type Mls_Commission_Type_Enum = {
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "mls_commission_type_enum". All fields are combined with a logical 'AND'. */
export type Mls_Commission_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Commission_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Mls_Commission_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Commission_Type_Enum_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Mls_Commission_Type_Enum_Enum {
  /** Fixed commission amount */
  Fixed = 'fixed',
  /** Commission as percentage of sale/rent price */
  Percentage = 'percentage'
}

/** Boolean expression to compare columns of type "mls_commission_type_enum_enum". All fields are combined with logical 'AND'. */
export type Mls_Commission_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Mls_Commission_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Mls_Commission_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Mls_Commission_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Mls_Commission_Type_Enum_Enum>>;
};

/** Ordering options when selecting data from "mls_commission_type_enum". */
export type Mls_Commission_Type_Enum_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "mls_commission_type_enum" */
export enum Mls_Commission_Type_Enum_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "mls_commission_type_enum" */
export type Mls_Commission_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Commission_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Commission_Type_Enum_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Per-listing per-team MLS enquiry auto-response configuration */
export type Mls_Listing_Enquiry_Settings = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  email_template?: Maybe<Email_Templates>;
  /** Email template used for auto-response */
  email_template_id?: Maybe<Scalars['uuid']['output']>;
  /** Whether auto-response is enabled for this listing */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lot: Lots;
  /** The MLS listing this setting applies to */
  lot_id: Scalars['uuid']['output'];
  /** An object relationship */
  response_sender?: Maybe<Users>;
  /** User whose email account sends the response */
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  team: Teams;
  /** The team that owns this enquiry response config */
  team_id: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_Aggregate = {
  aggregate?: Maybe<Mls_Listing_Enquiry_Settings_Aggregate_Fields>;
  nodes: Array<Mls_Listing_Enquiry_Settings>;
};

/** aggregate fields of "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mls_Listing_Enquiry_Settings_Max_Fields>;
  min?: Maybe<Mls_Listing_Enquiry_Settings_Min_Fields>;
};


/** aggregate fields of "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mls_listing_enquiry_settings". All fields are combined with a logical 'AND'. */
export type Mls_Listing_Enquiry_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Bool_Exp>>;
  _not?: InputMaybe<Mls_Listing_Enquiry_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_template?: InputMaybe<Email_Templates_Bool_Exp>;
  email_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  response_sender?: InputMaybe<Users_Bool_Exp>;
  response_sender_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mls_listing_enquiry_settings" */
export enum Mls_Listing_Enquiry_Settings_Constraint {
  /** unique or primary key constraint on columns "lot_id", "team_id" */
  MlsListingEnquirySettingsLotIdTeamIdKey = 'mls_listing_enquiry_settings_lot_id_team_id_key',
  /** unique or primary key constraint on columns "id" */
  MlsListingEnquirySettingsPkey = 'mls_listing_enquiry_settings_pkey'
}

/** input type for inserting data into table "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_Insert_Input = {
  email_template?: InputMaybe<Email_Templates_Obj_Rel_Insert_Input>;
  /** Email template used for auto-response */
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Whether auto-response is enabled for this listing */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  /** The MLS listing this setting applies to */
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  response_sender?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  /** User whose email account sends the response */
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  /** The team that owns this enquiry response config */
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Mls_Listing_Enquiry_Settings_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Email template used for auto-response */
  email_template_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** The MLS listing this setting applies to */
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** User whose email account sends the response */
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  /** The team that owns this enquiry response config */
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Mls_Listing_Enquiry_Settings_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** Email template used for auto-response */
  email_template_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** The MLS listing this setting applies to */
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** User whose email account sends the response */
  response_sender_id?: Maybe<Scalars['uuid']['output']>;
  /** The team that owns this enquiry response config */
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mls_Listing_Enquiry_Settings>;
};

/** on_conflict condition type for table "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_On_Conflict = {
  constraint: Mls_Listing_Enquiry_Settings_Constraint;
  update_columns?: Array<Mls_Listing_Enquiry_Settings_Update_Column>;
  where?: InputMaybe<Mls_Listing_Enquiry_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "mls_listing_enquiry_settings". */
export type Mls_Listing_Enquiry_Settings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Email_Templates_Order_By>;
  email_template_id?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  response_sender?: InputMaybe<Users_Order_By>;
  response_sender_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mls_listing_enquiry_settings */
export type Mls_Listing_Enquiry_Settings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mls_listing_enquiry_settings" */
export enum Mls_Listing_Enquiry_Settings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  ResponseSenderId = 'response_sender_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_Set_Input = {
  /** Email template used for auto-response */
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Whether auto-response is enabled for this listing */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** User whose email account sends the response */
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "mls_listing_enquiry_settings" */
export type Mls_Listing_Enquiry_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Listing_Enquiry_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Listing_Enquiry_Settings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Email template used for auto-response */
  email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Whether auto-response is enabled for this listing */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The MLS listing this setting applies to */
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  /** User whose email account sends the response */
  response_sender_id?: InputMaybe<Scalars['uuid']['input']>;
  /** The team that owns this enquiry response config */
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mls_listing_enquiry_settings" */
export enum Mls_Listing_Enquiry_Settings_Update_Column {
  /** column name */
  EmailTemplateId = 'email_template_id',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ResponseSenderId = 'response_sender_id'
}

export type Mls_Listing_Enquiry_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mls_Listing_Enquiry_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mls_Listing_Enquiry_Settings_Bool_Exp;
};

/** MLS listings — shared on MLS, excluding won/lost/abandoned/rejected */
export type Mls_Lots = {
  /** Compute MLS access status for a lot based on requesting user teams */
  access_status?: Maybe<Scalars['String']['output']>;
  address_display_option?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_description_de?: Maybe<Scalars['String']['output']>;
  brochure_description_en?: Maybe<Scalars['String']['output']>;
  brochure_description_es?: Maybe<Scalars['String']['output']>;
  brochure_description_fr?: Maybe<Scalars['String']['output']>;
  brochure_description_it?: Maybe<Scalars['String']['output']>;
  brochure_title_de?: Maybe<Scalars['String']['output']>;
  brochure_title_en?: Maybe<Scalars['String']['output']>;
  brochure_title_es?: Maybe<Scalars['String']['output']>;
  brochure_title_fr?: Maybe<Scalars['String']['output']>;
  brochure_title_it?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Mls_Brokers>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  /** Returns the address an agent is allowed to see for an MLS lot, per mls_lot_disclosure: real for owner / shared; for a restricted lot the dummy address, the real one for full_address, the real street / locality / postcode on the ~1 km cell for hide_street_number, otherwise lat/lng quantised to a ~1 km grid with street / locality / postcode withheld. address_display_option is applied on top of the restricted branches only. Keys: route, street_number, locality, postcode, state, country_code, lat, lng, approximate. This is the only address source granted to role agent for MLS lots -- the raw columns on mls_properties are not. */
  effective_address?: Maybe<Scalars['jsonb']['output']>;
  hide_price_on_portals?: Maybe<Scalars['Boolean']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** Commune (municipality, else locality) an MLS lot counts in on the market-pulse choropleth: the real one when mls_lot_disclosure is open / full / street (the locality is disclosed), otherwise the commune containing the dummy point or the ~1 km cell the address discloses. Never more precise than mls_lot_effective_address. */
  market_place_id?: Maybe<Scalars['uuid']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  mls_commission_type?: Maybe<Scalars['String']['output']>;
  mls_note?: Maybe<Scalars['String']['output']>;
  mls_share_mode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  mls_shares: Array<Mls_Shares>;
  /** An aggregate relationship */
  mls_shares_aggregate: Mls_Shares_Aggregate;
  mls_terms_enabled?: Maybe<Scalars['Boolean']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  price_unit?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  property?: Maybe<Mls_Properties>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  shared_on_mls_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  use_custom_brochure_description?: Maybe<Scalars['Boolean']['output']>;
  use_custom_brochure_title?: Maybe<Scalars['Boolean']['output']>;
  use_dummy_address?: Maybe<Scalars['Boolean']['output']>;
};


/** MLS listings — shared on MLS, excluding won/lost/abandoned/rejected */
export type Mls_LotsEffective_AddressArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** MLS listings — shared on MLS, excluding won/lost/abandoned/rejected */
export type Mls_LotsMls_SharesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


/** MLS listings — shared on MLS, excluding won/lost/abandoned/rejected */
export type Mls_LotsMls_Shares_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


/** MLS listings — shared on MLS, excluding won/lost/abandoned/rejected */
export type Mls_LotsPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** MLS listings — shared on MLS, excluding won/lost/abandoned/rejected */
export type Mls_LotsPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};

/** aggregated selection of "mls_lots" */
export type Mls_Lots_Aggregate = {
  aggregate?: Maybe<Mls_Lots_Aggregate_Fields>;
  nodes: Array<Mls_Lots>;
};

/** aggregate fields of "mls_lots" */
export type Mls_Lots_Aggregate_Fields = {
  avg?: Maybe<Mls_Lots_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mls_Lots_Max_Fields>;
  min?: Maybe<Mls_Lots_Min_Fields>;
  stddev?: Maybe<Mls_Lots_Stddev_Fields>;
  stddev_pop?: Maybe<Mls_Lots_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mls_Lots_Stddev_Samp_Fields>;
  sum?: Maybe<Mls_Lots_Sum_Fields>;
  var_pop?: Maybe<Mls_Lots_Var_Pop_Fields>;
  var_samp?: Maybe<Mls_Lots_Var_Samp_Fields>;
  variance?: Maybe<Mls_Lots_Variance_Fields>;
};


/** aggregate fields of "mls_lots" */
export type Mls_Lots_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mls_Lots_Avg_Fields = {
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mls_lots". All fields are combined with a logical 'AND'. */
export type Mls_Lots_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Lots_Bool_Exp>>;
  _not?: InputMaybe<Mls_Lots_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Lots_Bool_Exp>>;
  access_status?: InputMaybe<String_Comparison_Exp>;
  address_display_option?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  brochure_description_de?: InputMaybe<String_Comparison_Exp>;
  brochure_description_en?: InputMaybe<String_Comparison_Exp>;
  brochure_description_es?: InputMaybe<String_Comparison_Exp>;
  brochure_description_fr?: InputMaybe<String_Comparison_Exp>;
  brochure_description_it?: InputMaybe<String_Comparison_Exp>;
  brochure_title_de?: InputMaybe<String_Comparison_Exp>;
  brochure_title_en?: InputMaybe<String_Comparison_Exp>;
  brochure_title_es?: InputMaybe<String_Comparison_Exp>;
  brochure_title_fr?: InputMaybe<String_Comparison_Exp>;
  brochure_title_it?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Mls_Brokers_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<Currencies_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dummy_country_code?: InputMaybe<String_Comparison_Exp>;
  dummy_lat?: InputMaybe<Float8_Comparison_Exp>;
  dummy_lng?: InputMaybe<Float8_Comparison_Exp>;
  dummy_locality?: InputMaybe<String_Comparison_Exp>;
  dummy_postcode?: InputMaybe<String_Comparison_Exp>;
  dummy_route?: InputMaybe<String_Comparison_Exp>;
  dummy_state?: InputMaybe<String_Comparison_Exp>;
  dummy_street_number?: InputMaybe<String_Comparison_Exp>;
  effective_address?: InputMaybe<Jsonb_Comparison_Exp>;
  hide_price_on_portals?: InputMaybe<Boolean_Comparison_Exp>;
  hot_score?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  market_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Numeric_Comparison_Exp>;
  mls_buyer_agent_share_percent?: InputMaybe<Numeric_Comparison_Exp>;
  mls_commission_type?: InputMaybe<String_Comparison_Exp>;
  mls_note?: InputMaybe<String_Comparison_Exp>;
  mls_share_mode?: InputMaybe<String_Comparison_Exp>;
  mls_shares?: InputMaybe<Mls_Shares_Bool_Exp>;
  mls_shares_aggregate?: InputMaybe<Mls_Shares_Aggregate_Bool_Exp>;
  mls_terms_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  monthly_rent_computed?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  portal_listings?: InputMaybe<Portal_Listings_Bool_Exp>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property?: InputMaybe<Mls_Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  sale_price?: InputMaybe<Float8_Comparison_Exp>;
  shared_on_mls_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  use_custom_brochure_description?: InputMaybe<Boolean_Comparison_Exp>;
  use_custom_brochure_title?: InputMaybe<Boolean_Comparison_Exp>;
  use_dummy_address?: InputMaybe<Boolean_Comparison_Exp>;
};

export type Mls_Lots_In_Viewport_Args = {
  max_lat?: InputMaybe<Scalars['float8']['input']>;
  max_lng?: InputMaybe<Scalars['float8']['input']>;
  min_lat?: InputMaybe<Scalars['float8']['input']>;
  min_lng?: InputMaybe<Scalars['float8']['input']>;
  p_country_code?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Mls_Lots_Max_Fields = {
  /** Compute MLS access status for a lot based on requesting user teams */
  access_status?: Maybe<Scalars['String']['output']>;
  address_display_option?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_description_de?: Maybe<Scalars['String']['output']>;
  brochure_description_en?: Maybe<Scalars['String']['output']>;
  brochure_description_es?: Maybe<Scalars['String']['output']>;
  brochure_description_fr?: Maybe<Scalars['String']['output']>;
  brochure_description_it?: Maybe<Scalars['String']['output']>;
  brochure_title_de?: Maybe<Scalars['String']['output']>;
  brochure_title_en?: Maybe<Scalars['String']['output']>;
  brochure_title_es?: Maybe<Scalars['String']['output']>;
  brochure_title_fr?: Maybe<Scalars['String']['output']>;
  brochure_title_it?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  mls_commission_type?: Maybe<Scalars['String']['output']>;
  mls_note?: Maybe<Scalars['String']['output']>;
  mls_share_mode?: Maybe<Scalars['String']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  shared_on_mls_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Mls_Lots_Min_Fields = {
  /** Compute MLS access status for a lot based on requesting user teams */
  access_status?: Maybe<Scalars['String']['output']>;
  address_display_option?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  brochure_description_de?: Maybe<Scalars['String']['output']>;
  brochure_description_en?: Maybe<Scalars['String']['output']>;
  brochure_description_es?: Maybe<Scalars['String']['output']>;
  brochure_description_fr?: Maybe<Scalars['String']['output']>;
  brochure_description_it?: Maybe<Scalars['String']['output']>;
  brochure_title_de?: Maybe<Scalars['String']['output']>;
  brochure_title_en?: Maybe<Scalars['String']['output']>;
  brochure_title_es?: Maybe<Scalars['String']['output']>;
  brochure_title_fr?: Maybe<Scalars['String']['output']>;
  brochure_title_it?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['currencies']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dummy_country_code?: Maybe<Scalars['String']['output']>;
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  dummy_locality?: Maybe<Scalars['String']['output']>;
  dummy_postcode?: Maybe<Scalars['String']['output']>;
  dummy_route?: Maybe<Scalars['String']['output']>;
  dummy_state?: Maybe<Scalars['String']['output']>;
  dummy_street_number?: Maybe<Scalars['String']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  mls_commission_type?: Maybe<Scalars['String']['output']>;
  mls_note?: Maybe<Scalars['String']['output']>;
  mls_share_mode?: Maybe<Scalars['String']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
  shared_on_mls_at?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "mls_lots". */
export type Mls_Lots_Order_By = {
  access_status?: InputMaybe<Order_By>;
  address_display_option?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  brochure_description_de?: InputMaybe<Order_By>;
  brochure_description_en?: InputMaybe<Order_By>;
  brochure_description_es?: InputMaybe<Order_By>;
  brochure_description_fr?: InputMaybe<Order_By>;
  brochure_description_it?: InputMaybe<Order_By>;
  brochure_title_de?: InputMaybe<Order_By>;
  brochure_title_en?: InputMaybe<Order_By>;
  brochure_title_es?: InputMaybe<Order_By>;
  brochure_title_fr?: InputMaybe<Order_By>;
  brochure_title_it?: InputMaybe<Order_By>;
  broker?: InputMaybe<Mls_Brokers_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dummy_country_code?: InputMaybe<Order_By>;
  dummy_lat?: InputMaybe<Order_By>;
  dummy_lng?: InputMaybe<Order_By>;
  dummy_locality?: InputMaybe<Order_By>;
  dummy_postcode?: InputMaybe<Order_By>;
  dummy_route?: InputMaybe<Order_By>;
  dummy_state?: InputMaybe<Order_By>;
  dummy_street_number?: InputMaybe<Order_By>;
  effective_address?: InputMaybe<Order_By>;
  hide_price_on_portals?: InputMaybe<Order_By>;
  hot_score?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  market_place_id?: InputMaybe<Order_By>;
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Order_By>;
  mls_buyer_agent_share_percent?: InputMaybe<Order_By>;
  mls_commission_type?: InputMaybe<Order_By>;
  mls_note?: InputMaybe<Order_By>;
  mls_share_mode?: InputMaybe<Order_By>;
  mls_shares_aggregate?: InputMaybe<Mls_Shares_Aggregate_Order_By>;
  mls_terms_enabled?: InputMaybe<Order_By>;
  monthly_rent_computed?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property?: InputMaybe<Mls_Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  shared_on_mls_at?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  use_custom_brochure_description?: InputMaybe<Order_By>;
  use_custom_brochure_title?: InputMaybe<Order_By>;
  use_dummy_address?: InputMaybe<Order_By>;
};

/** select columns of table "mls_lots" */
export enum Mls_Lots_Select_Column {
  /** column name */
  AddressDisplayOption = 'address_display_option',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BrochureDescriptionDe = 'brochure_description_de',
  /** column name */
  BrochureDescriptionEn = 'brochure_description_en',
  /** column name */
  BrochureDescriptionEs = 'brochure_description_es',
  /** column name */
  BrochureDescriptionFr = 'brochure_description_fr',
  /** column name */
  BrochureDescriptionIt = 'brochure_description_it',
  /** column name */
  BrochureTitleDe = 'brochure_title_de',
  /** column name */
  BrochureTitleEn = 'brochure_title_en',
  /** column name */
  BrochureTitleEs = 'brochure_title_es',
  /** column name */
  BrochureTitleFr = 'brochure_title_fr',
  /** column name */
  BrochureTitleIt = 'brochure_title_it',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DummyCountryCode = 'dummy_country_code',
  /** column name */
  DummyLat = 'dummy_lat',
  /** column name */
  DummyLng = 'dummy_lng',
  /** column name */
  DummyLocality = 'dummy_locality',
  /** column name */
  DummyPostcode = 'dummy_postcode',
  /** column name */
  DummyRoute = 'dummy_route',
  /** column name */
  DummyState = 'dummy_state',
  /** column name */
  DummyStreetNumber = 'dummy_street_number',
  /** column name */
  HidePriceOnPortals = 'hide_price_on_portals',
  /** column name */
  Id = 'id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MlsBuyerAgentShareFixedAmount = 'mls_buyer_agent_share_fixed_amount',
  /** column name */
  MlsBuyerAgentSharePercent = 'mls_buyer_agent_share_percent',
  /** column name */
  MlsCommissionType = 'mls_commission_type',
  /** column name */
  MlsNote = 'mls_note',
  /** column name */
  MlsShareMode = 'mls_share_mode',
  /** column name */
  MlsTermsEnabled = 'mls_terms_enabled',
  /** column name */
  MonthlyRentComputed = 'monthly_rent_computed',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SharedOnMlsAt = 'shared_on_mls_at',
  /** column name */
  Status = 'status',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  UseCustomBrochureDescription = 'use_custom_brochure_description',
  /** column name */
  UseCustomBrochureTitle = 'use_custom_brochure_title',
  /** column name */
  UseDummyAddress = 'use_dummy_address'
}

/** aggregate stddev on columns */
export type Mls_Lots_Stddev_Fields = {
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mls_Lots_Stddev_Pop_Fields = {
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mls_Lots_Stddev_Samp_Fields = {
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mls_lots" */
export type Mls_Lots_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Lots_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Lots_Stream_Cursor_Value_Input = {
  address_display_option?: InputMaybe<Scalars['String']['input']>;
  available_from?: InputMaybe<Scalars['date']['input']>;
  brochure_description_de?: InputMaybe<Scalars['String']['input']>;
  brochure_description_en?: InputMaybe<Scalars['String']['input']>;
  brochure_description_es?: InputMaybe<Scalars['String']['input']>;
  brochure_description_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_description_it?: InputMaybe<Scalars['String']['input']>;
  brochure_title_de?: InputMaybe<Scalars['String']['input']>;
  brochure_title_en?: InputMaybe<Scalars['String']['input']>;
  brochure_title_es?: InputMaybe<Scalars['String']['input']>;
  brochure_title_fr?: InputMaybe<Scalars['String']['input']>;
  brochure_title_it?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['currencies']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dummy_country_code?: InputMaybe<Scalars['String']['input']>;
  dummy_lat?: InputMaybe<Scalars['float8']['input']>;
  dummy_lng?: InputMaybe<Scalars['float8']['input']>;
  dummy_locality?: InputMaybe<Scalars['String']['input']>;
  dummy_postcode?: InputMaybe<Scalars['String']['input']>;
  dummy_route?: InputMaybe<Scalars['String']['input']>;
  dummy_state?: InputMaybe<Scalars['String']['input']>;
  dummy_street_number?: InputMaybe<Scalars['String']['input']>;
  hide_price_on_portals?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot_reference?: InputMaybe<Scalars['String']['input']>;
  mls_buyer_agent_share_fixed_amount?: InputMaybe<Scalars['numeric']['input']>;
  mls_buyer_agent_share_percent?: InputMaybe<Scalars['numeric']['input']>;
  mls_commission_type?: InputMaybe<Scalars['String']['input']>;
  mls_note?: InputMaybe<Scalars['String']['input']>;
  mls_share_mode?: InputMaybe<Scalars['String']['input']>;
  mls_terms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  monthly_rent_computed?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  price_unit?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  rent_extra?: InputMaybe<Scalars['Float']['input']>;
  rent_net?: InputMaybe<Scalars['Float']['input']>;
  sale_price?: InputMaybe<Scalars['float8']['input']>;
  shared_on_mls_at?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  use_custom_brochure_description?: InputMaybe<Scalars['Boolean']['input']>;
  use_custom_brochure_title?: InputMaybe<Scalars['Boolean']['input']>;
  use_dummy_address?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Mls_Lots_Sum_Fields = {
  dummy_lat?: Maybe<Scalars['float8']['output']>;
  dummy_lng?: Maybe<Scalars['float8']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['numeric']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['numeric']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Mls_Lots_Var_Pop_Fields = {
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mls_Lots_Var_Samp_Fields = {
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mls_Lots_Variance_Fields = {
  dummy_lat?: Maybe<Scalars['Float']['output']>;
  dummy_lng?: Maybe<Scalars['Float']['output']>;
  /** Continuous hot-demand score for an MLS lot. Sum over the lot's mls_shares of exp(-LAMBDA * age_in_days), LAMBDA = ln(2)/14 (14-day half-life). Computed at query time — no maintenance state. OK while mls_shares stays small (<~50 per lot); revisit with a denormalised side table if share volume grows. */
  hot_score?: Maybe<Scalars['float8']['output']>;
  mls_buyer_agent_share_fixed_amount?: Maybe<Scalars['Float']['output']>;
  mls_buyer_agent_share_percent?: Maybe<Scalars['Float']['output']>;
  monthly_rent_computed?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
};

/** Teams in the MLS network whose tenant has an active brokerage module grant, with broker counts, active listings, denormalised place ids, tenant-derived country_code, and cross-tenant-safe logo_url */
export type Mls_Network_Teams = {
  active_mls_listings_count?: Maybe<Scalars['bigint']['output']>;
  broker_count?: Maybe<Scalars['bigint']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "mls_network_team_places" */
  places?: Maybe<Array<Places>>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};


/** Teams in the MLS network whose tenant has an active brokerage module grant, with broker counts, active listings, denormalised place ids, tenant-derived country_code, and cross-tenant-safe logo_url */
export type Mls_Network_TeamsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};

/** aggregated selection of "mls_network_teams" */
export type Mls_Network_Teams_Aggregate = {
  aggregate?: Maybe<Mls_Network_Teams_Aggregate_Fields>;
  nodes: Array<Mls_Network_Teams>;
};

/** aggregate fields of "mls_network_teams" */
export type Mls_Network_Teams_Aggregate_Fields = {
  avg?: Maybe<Mls_Network_Teams_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Mls_Network_Teams_Max_Fields>;
  min?: Maybe<Mls_Network_Teams_Min_Fields>;
  stddev?: Maybe<Mls_Network_Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Mls_Network_Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Mls_Network_Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Mls_Network_Teams_Sum_Fields>;
  var_pop?: Maybe<Mls_Network_Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Mls_Network_Teams_Var_Samp_Fields>;
  variance?: Maybe<Mls_Network_Teams_Variance_Fields>;
};


/** aggregate fields of "mls_network_teams" */
export type Mls_Network_Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mls_Network_Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Mls_Network_Teams_Avg_Fields = {
  active_mls_listings_count?: Maybe<Scalars['Float']['output']>;
  broker_count?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "mls_network_teams". All fields are combined with a logical 'AND'. */
export type Mls_Network_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Network_Teams_Bool_Exp>>;
  _not?: InputMaybe<Mls_Network_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Network_Teams_Bool_Exp>>;
  active_mls_listings_count?: InputMaybe<Bigint_Comparison_Exp>;
  broker_count?: InputMaybe<Bigint_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  logo_url?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mls_Network_Teams_Max_Fields = {
  active_mls_listings_count?: Maybe<Scalars['bigint']['output']>;
  broker_count?: Maybe<Scalars['bigint']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Mls_Network_Teams_Min_Fields = {
  active_mls_listings_count?: Maybe<Scalars['bigint']['output']>;
  broker_count?: Maybe<Scalars['bigint']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "mls_network_teams". */
export type Mls_Network_Teams_Order_By = {
  active_mls_listings_count?: InputMaybe<Order_By>;
  broker_count?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  logo_url?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "mls_network_teams" */
export enum Mls_Network_Teams_Select_Column {
  /** column name */
  ActiveMlsListingsCount = 'active_mls_listings_count',
  /** column name */
  BrokerCount = 'broker_count',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Id = 'id',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LogoUrl = 'logo_url',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  StateId = 'state_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** aggregate stddev on columns */
export type Mls_Network_Teams_Stddev_Fields = {
  active_mls_listings_count?: Maybe<Scalars['Float']['output']>;
  broker_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Mls_Network_Teams_Stddev_Pop_Fields = {
  active_mls_listings_count?: Maybe<Scalars['Float']['output']>;
  broker_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Mls_Network_Teams_Stddev_Samp_Fields = {
  active_mls_listings_count?: Maybe<Scalars['Float']['output']>;
  broker_count?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "mls_network_teams" */
export type Mls_Network_Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Network_Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Network_Teams_Stream_Cursor_Value_Input = {
  active_mls_listings_count?: InputMaybe<Scalars['bigint']['input']>;
  broker_count?: InputMaybe<Scalars['bigint']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_url?: InputMaybe<Scalars['String']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Mls_Network_Teams_Sum_Fields = {
  active_mls_listings_count?: Maybe<Scalars['bigint']['output']>;
  broker_count?: Maybe<Scalars['bigint']['output']>;
};

/** aggregate var_pop on columns */
export type Mls_Network_Teams_Var_Pop_Fields = {
  active_mls_listings_count?: Maybe<Scalars['Float']['output']>;
  broker_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Mls_Network_Teams_Var_Samp_Fields = {
  active_mls_listings_count?: Maybe<Scalars['Float']['output']>;
  broker_count?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Mls_Network_Teams_Variance_Fields = {
  active_mls_listings_count?: Maybe<Scalars['Float']['output']>;
  broker_count?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "mls_properties" */
export type Mls_Properties = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  basement_surface?: Maybe<Scalars['Float']['output']>;
  building_condition?: Maybe<Scalars['Float']['output']>;
  building_standard?: Maybe<Scalars['Float']['output']>;
  building_volume?: Maybe<Scalars['Float']['output']>;
  building_volume_norm?: Maybe<Scalars['String']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  ceiling_height?: Maybe<Scalars['Float']['output']>;
  charges?: Maybe<Scalars['Float']['output']>;
  commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  commercial_surface?: Maybe<Scalars['Float']['output']>;
  commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  consumption?: Maybe<Scalars['Int']['output']>;
  cooling?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  ctn?: Maybe<Scalars['String']['output']>;
  emissions?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_consumption_class?: Maybe<Scalars['String']['output']>;
  energy_inspection_date?: Maybe<Scalars['date']['output']>;
  energy_reference_year?: Maybe<Scalars['Int']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Int']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Int']['output']>;
  flat_condition?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gas_emissions_class?: Maybe<Scalars['String']['output']>;
  gross_floor_surface?: Maybe<Scalars['Float']['output']>;
  has_attic?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_gym?: Maybe<Scalars['Boolean']['output']>;
  has_photovoltaic_panels?: Maybe<Scalars['Boolean']['output']>;
  has_sauna?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_wellness_area?: Maybe<Scalars['Boolean']['output']>;
  heating?: Maybe<Scalars['String']['output']>;
  heating_distribution?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  income_includes_parking?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_commercial_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_luxury?: Maybe<Scalars['Boolean']['output']>;
  is_maisonette?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_parking_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_rental?: Maybe<Scalars['Boolean']['output']>;
  is_residential_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_secondary_residence?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  macro_location?: Maybe<Scalars['Float']['output']>;
  micro_location?: Maybe<Scalars['Float']['output']>;
  minergie_code?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  mls_lots?: Maybe<Mls_Lots>;
  monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  number_of_flats?: Maybe<Scalars['Int']['output']>;
  number_of_floors?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_lifts?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  ownership_form?: Maybe<Scalars['String']['output']>;
  parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  perceived_value?: Maybe<Scalars['Float']['output']>;
  /** Places of an MLS property, limited to what mls_lot_effective_address discloses: every level when the caller may see the locality of one of its lots (mls_lot_disclosure open / full / street), the state alone for a cell lot, the places containing the dummy point for a dummy one. The ungated predecessor leaked the commune of a restricted listing on both the read and the filter side. Track with session_argument so the gate runs server-side. */
  places?: Maybe<Array<Places>>;
  plot_has_constructible_reserve?: Maybe<Scalars['Boolean']['output']>;
  plot_is_constructible?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  property_files: Array<Property_Files>;
  /** An aggregate relationship */
  property_files_aggregate: Property_Files_Aggregate;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** An object relationship */
  property_type?: Maybe<Property_Types>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
  relevant_servitudes?: Maybe<Scalars['Boolean']['output']>;
  renovation_fund?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  residential_surface?: Maybe<Scalars['Float']['output']>;
  residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  share_of_ownership?: Maybe<Scalars['Float']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  weighted_floor_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesProperty_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesProperty_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** columns and relationships of "mls_properties" */
export type Mls_PropertiesProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "mls_properties". All fields are combined with a logical 'AND'. */
export type Mls_Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Properties_Bool_Exp>>;
  _not?: InputMaybe<Mls_Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Properties_Bool_Exp>>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  basement_surface?: InputMaybe<Float_Comparison_Exp>;
  building_condition?: InputMaybe<Float_Comparison_Exp>;
  building_standard?: InputMaybe<Float_Comparison_Exp>;
  building_volume?: InputMaybe<Float_Comparison_Exp>;
  building_volume_norm?: InputMaybe<String_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  ceiling_height?: InputMaybe<Float_Comparison_Exp>;
  charges?: InputMaybe<Float_Comparison_Exp>;
  commercial_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  commercial_surface?: InputMaybe<Float_Comparison_Exp>;
  commercial_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  consumption?: InputMaybe<Int_Comparison_Exp>;
  cooling?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  ctn?: InputMaybe<String_Comparison_Exp>;
  emissions?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_consumption_class?: InputMaybe<String_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Date_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Int_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  flat_condition?: InputMaybe<Float_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  gas_emissions_class?: InputMaybe<String_Comparison_Exp>;
  gross_floor_surface?: InputMaybe<Float_Comparison_Exp>;
  has_attic?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_gym?: InputMaybe<Boolean_Comparison_Exp>;
  has_photovoltaic_panels?: InputMaybe<Boolean_Comparison_Exp>;
  has_sauna?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_wellness_area?: InputMaybe<Boolean_Comparison_Exp>;
  heating?: InputMaybe<String_Comparison_Exp>;
  heating_distribution?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income_includes_parking?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_commercial_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_luxury?: InputMaybe<Boolean_Comparison_Exp>;
  is_maisonette?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_parking_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_rental?: InputMaybe<Boolean_Comparison_Exp>;
  is_residential_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_secondary_residence?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  macro_location?: InputMaybe<Float_Comparison_Exp>;
  micro_location?: InputMaybe<Float_Comparison_Exp>;
  minergie_code?: InputMaybe<Int_Comparison_Exp>;
  mls_lots?: InputMaybe<Mls_Lots_Bool_Exp>;
  monthly_gross_rent?: InputMaybe<Float_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_commercial_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_flats?: InputMaybe<Int_Comparison_Exp>;
  number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_lifts?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_residential_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Int_Comparison_Exp>;
  orientation?: InputMaybe<String_Comparison_Exp>;
  ownership_form?: InputMaybe<String_Comparison_Exp>;
  parking_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  parking_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  perceived_value?: InputMaybe<Float_Comparison_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  plot_has_constructible_reserve?: InputMaybe<Boolean_Comparison_Exp>;
  plot_is_constructible?: InputMaybe<Boolean_Comparison_Exp>;
  property_files?: InputMaybe<Property_Files_Bool_Exp>;
  property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Bool_Exp>;
  property_images?: InputMaybe<Property_Images_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Bool_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  relevant_servitudes?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_fund?: InputMaybe<Float_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  residential_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  residential_surface?: InputMaybe<Float_Comparison_Exp>;
  residential_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  share_of_ownership?: InputMaybe<Float_Comparison_Exp>;
  side?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  weighted_floor_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "mls_properties". */
export type Mls_Properties_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  cooling?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_consumption_class?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gas_emissions_class?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  has_attic?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_gym?: InputMaybe<Order_By>;
  has_photovoltaic_panels?: InputMaybe<Order_By>;
  has_sauna?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_wellness_area?: InputMaybe<Order_By>;
  heating?: InputMaybe<Order_By>;
  heating_distribution?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income_includes_parking?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_commercial_fully_rented?: InputMaybe<Order_By>;
  is_luxury?: InputMaybe<Order_By>;
  is_maisonette?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_parking_fully_rented?: InputMaybe<Order_By>;
  is_rental?: InputMaybe<Order_By>;
  is_residential_fully_rented?: InputMaybe<Order_By>;
  is_secondary_residence?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  mls_lots?: InputMaybe<Mls_Lots_Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  plot_has_constructible_reserve?: InputMaybe<Order_By>;
  plot_is_constructible?: InputMaybe<Order_By>;
  property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Order_By>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  relevant_servitudes?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  side?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** Team-level MLS configuration for auto-publish and auto-match */
export type Mls_Settings = {
  /** Automatically match new shared listings with team buyers */
  auto_match_with_buyers?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  auto_matching_email_template?: Maybe<Email_Templates>;
  /** Email template for auto-matching notifications */
  auto_matching_email_template_id?: Maybe<Scalars['uuid']['output']>;
  /** Automatically publish newly-shared MLS listings on team website */
  auto_publish_shared_listings?: Maybe<Scalars['Boolean']['output']>;
  /** Automatically send matching email when new listings are shared */
  auto_send_matching_email?: Maybe<Scalars['Boolean']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** Boolean expression to filter rows from the table "mls_settings". All fields are combined with a logical 'AND'. */
export type Mls_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Settings_Bool_Exp>>;
  _not?: InputMaybe<Mls_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Settings_Bool_Exp>>;
  auto_match_with_buyers?: InputMaybe<Boolean_Comparison_Exp>;
  auto_matching_email_template?: InputMaybe<Email_Templates_Bool_Exp>;
  auto_matching_email_template_id?: InputMaybe<Uuid_Comparison_Exp>;
  auto_publish_shared_listings?: InputMaybe<Boolean_Comparison_Exp>;
  auto_send_matching_email?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mls_settings" */
export enum Mls_Settings_Constraint {
  /** unique or primary key constraint on columns "id" */
  MlsSettingsPkey = 'mls_settings_pkey',
  /** unique or primary key constraint on columns "team_id" */
  MlsSettingsTeamIdKey = 'mls_settings_team_id_key'
}

/** input type for inserting data into table "mls_settings" */
export type Mls_Settings_Insert_Input = {
  /** Automatically match new shared listings with team buyers */
  auto_match_with_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  auto_matching_email_template?: InputMaybe<Email_Templates_Obj_Rel_Insert_Input>;
  /** Email template for auto-matching notifications */
  auto_matching_email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Automatically publish newly-shared MLS listings on team website */
  auto_publish_shared_listings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automatically send matching email when new listings are shared */
  auto_send_matching_email?: InputMaybe<Scalars['Boolean']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "mls_settings" */
export type Mls_Settings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mls_Settings>;
};

/** on_conflict condition type for table "mls_settings" */
export type Mls_Settings_On_Conflict = {
  constraint: Mls_Settings_Constraint;
  update_columns?: Array<Mls_Settings_Update_Column>;
  where?: InputMaybe<Mls_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "mls_settings". */
export type Mls_Settings_Order_By = {
  auto_match_with_buyers?: InputMaybe<Order_By>;
  auto_matching_email_template?: InputMaybe<Email_Templates_Order_By>;
  auto_matching_email_template_id?: InputMaybe<Order_By>;
  auto_publish_shared_listings?: InputMaybe<Order_By>;
  auto_send_matching_email?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mls_settings */
export type Mls_Settings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "mls_settings" */
export enum Mls_Settings_Select_Column {
  /** column name */
  AutoMatchWithBuyers = 'auto_match_with_buyers',
  /** column name */
  AutoMatchingEmailTemplateId = 'auto_matching_email_template_id',
  /** column name */
  AutoPublishSharedListings = 'auto_publish_shared_listings',
  /** column name */
  AutoSendMatchingEmail = 'auto_send_matching_email',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mls_settings" */
export type Mls_Settings_Set_Input = {
  /** Automatically match new shared listings with team buyers */
  auto_match_with_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email template for auto-matching notifications */
  auto_matching_email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Automatically publish newly-shared MLS listings on team website */
  auto_publish_shared_listings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automatically send matching email when new listings are shared */
  auto_send_matching_email?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "mls_settings" */
export type Mls_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Settings_Stream_Cursor_Value_Input = {
  /** Automatically match new shared listings with team buyers */
  auto_match_with_buyers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Email template for auto-matching notifications */
  auto_matching_email_template_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Automatically publish newly-shared MLS listings on team website */
  auto_publish_shared_listings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automatically send matching email when new listings are shared */
  auto_send_matching_email?: InputMaybe<Scalars['Boolean']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mls_settings" */
export enum Mls_Settings_Update_Column {
  /** column name */
  AutoMatchWithBuyers = 'auto_match_with_buyers',
  /** column name */
  AutoMatchingEmailTemplateId = 'auto_matching_email_template_id',
  /** column name */
  AutoPublishSharedListings = 'auto_publish_shared_listings',
  /** column name */
  AutoSendMatchingEmail = 'auto_send_matching_email'
}

export type Mls_Settings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mls_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mls_Settings_Bool_Exp;
};

/** MLS listing share modes */
export type Mls_Share_Mode_Enum = {
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "mls_share_mode_enum". All fields are combined with a logical 'AND'. */
export type Mls_Share_Mode_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Share_Mode_Enum_Bool_Exp>>;
  _not?: InputMaybe<Mls_Share_Mode_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Share_Mode_Enum_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "mls_share_mode_enum". */
export type Mls_Share_Mode_Enum_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "mls_share_mode_enum" */
export enum Mls_Share_Mode_Enum_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "mls_share_mode_enum" */
export type Mls_Share_Mode_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Share_Mode_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Share_Mode_Enum_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** MLS share statuses (shared/pending/rejected) */
export type Mls_Share_Status_Enum = {
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "mls_share_status_enum". All fields are combined with a logical 'AND'. */
export type Mls_Share_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Share_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<Mls_Share_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Share_Status_Enum_Bool_Exp>>;
  description?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "mls_share_status_enum". */
export type Mls_Share_Status_Enum_Order_By = {
  description?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "mls_share_status_enum" */
export enum Mls_Share_Status_Enum_Select_Column {
  /** column name */
  Description = 'description',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "mls_share_status_enum" */
export type Mls_Share_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Share_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Share_Status_Enum_Stream_Cursor_Value_Input = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Unified MLS sharing table (shares + requests merged) */
export type Mls_Shares = {
  auto_matching_filters?: Maybe<Scalars['jsonb']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** When the share was approved/rejected */
  handled_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lot: Lots;
  /** The listing being shared */
  lot_id: Scalars['uuid']['output'];
  /** An object relationship */
  requested_by_user?: Maybe<Users>;
  /** User who requested access (null if proactive share) */
  requested_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** Get requester full name bypassing RLS */
  requester_name?: Maybe<Scalars['String']['output']>;
  /** Get requesting team name bypassing RLS */
  requester_team_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  shared_by_user?: Maybe<Users>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** Share status: shared, pending, rejected */
  status: Scalars['String']['output'];
  /** An object relationship */
  status_enum: Mls_Share_Status_Enum;
  /** An object relationship */
  team: Teams;
  /** The team this listing is shared with or requested by */
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Unified MLS sharing table (shares + requests merged) */
export type Mls_SharesAuto_Matching_FiltersArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "mls_shares" */
export type Mls_Shares_Aggregate = {
  aggregate?: Maybe<Mls_Shares_Aggregate_Fields>;
  nodes: Array<Mls_Shares>;
};

export type Mls_Shares_Aggregate_Bool_Exp = {
  count?: InputMaybe<Mls_Shares_Aggregate_Bool_Exp_Count>;
};

export type Mls_Shares_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Mls_Shares_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "mls_shares" */
export type Mls_Shares_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mls_Shares_Max_Fields>;
  min?: Maybe<Mls_Shares_Min_Fields>;
};


/** aggregate fields of "mls_shares" */
export type Mls_Shares_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "mls_shares" */
export type Mls_Shares_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Mls_Shares_Max_Order_By>;
  min?: InputMaybe<Mls_Shares_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Mls_Shares_Append_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "mls_shares" */
export type Mls_Shares_Arr_Rel_Insert_Input = {
  data: Array<Mls_Shares_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Mls_Shares_On_Conflict>;
};

/** Boolean expression to filter rows from the table "mls_shares". All fields are combined with a logical 'AND'. */
export type Mls_Shares_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Shares_Bool_Exp>>;
  _not?: InputMaybe<Mls_Shares_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Shares_Bool_Exp>>;
  auto_matching_filters?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  handled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  requested_by_user?: InputMaybe<Users_Bool_Exp>;
  requested_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  requester_name?: InputMaybe<String_Comparison_Exp>;
  requester_team_name?: InputMaybe<String_Comparison_Exp>;
  shared_by_user?: InputMaybe<Users_Bool_Exp>;
  shared_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  status_enum?: InputMaybe<Mls_Share_Status_Enum_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "mls_shares" */
export enum Mls_Shares_Constraint {
  /** unique or primary key constraint on columns "lot_id", "team_id" */
  MlsSharesLotIdTeamIdKey = 'mls_shares_lot_id_team_id_key',
  /** unique or primary key constraint on columns "id" */
  MlsSharesPkey = 'mls_shares_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Mls_Shares_Delete_At_Path_Input = {
  auto_matching_filters?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Mls_Shares_Delete_Elem_Input = {
  auto_matching_filters?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Mls_Shares_Delete_Key_Input = {
  auto_matching_filters?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "mls_shares" */
export type Mls_Shares_Insert_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  /** The listing being shared */
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  requested_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  /** User who requested access (null if proactive share) */
  requested_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  shared_by_user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Share status: shared, pending, rejected */
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  /** The team this listing is shared with or requested by */
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Mls_Shares_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** When the share was approved/rejected */
  handled_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** The listing being shared */
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** User who requested access (null if proactive share) */
  requested_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** Get requester full name bypassing RLS */
  requester_name?: Maybe<Scalars['String']['output']>;
  /** Get requesting team name bypassing RLS */
  requester_team_name?: Maybe<Scalars['String']['output']>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** Share status: shared, pending, rejected */
  status?: Maybe<Scalars['String']['output']>;
  /** The team this listing is shared with or requested by */
  team_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "mls_shares" */
export type Mls_Shares_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  /** When the share was approved/rejected */
  handled_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The listing being shared */
  lot_id?: InputMaybe<Order_By>;
  /** User who requested access (null if proactive share) */
  requested_by_user_id?: InputMaybe<Order_By>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: InputMaybe<Order_By>;
  /** Share status: shared, pending, rejected */
  status?: InputMaybe<Order_By>;
  /** The team this listing is shared with or requested by */
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Mls_Shares_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  /** When the share was approved/rejected */
  handled_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** The listing being shared */
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** User who requested access (null if proactive share) */
  requested_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** Get requester full name bypassing RLS */
  requester_name?: Maybe<Scalars['String']['output']>;
  /** Get requesting team name bypassing RLS */
  requester_team_name?: Maybe<Scalars['String']['output']>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** Share status: shared, pending, rejected */
  status?: Maybe<Scalars['String']['output']>;
  /** The team this listing is shared with or requested by */
  team_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "mls_shares" */
export type Mls_Shares_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  /** When the share was approved/rejected */
  handled_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** The listing being shared */
  lot_id?: InputMaybe<Order_By>;
  /** User who requested access (null if proactive share) */
  requested_by_user_id?: InputMaybe<Order_By>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: InputMaybe<Order_By>;
  /** Share status: shared, pending, rejected */
  status?: InputMaybe<Order_By>;
  /** The team this listing is shared with or requested by */
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "mls_shares" */
export type Mls_Shares_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Mls_Shares>;
};

/** input type for inserting object relation for remote table "mls_shares" */
export type Mls_Shares_Obj_Rel_Insert_Input = {
  data: Mls_Shares_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Mls_Shares_On_Conflict>;
};

/** on_conflict condition type for table "mls_shares" */
export type Mls_Shares_On_Conflict = {
  constraint: Mls_Shares_Constraint;
  update_columns?: Array<Mls_Shares_Update_Column>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};

/** Ordering options when selecting data from "mls_shares". */
export type Mls_Shares_Order_By = {
  auto_matching_filters?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  handled_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  requested_by_user?: InputMaybe<Users_Order_By>;
  requested_by_user_id?: InputMaybe<Order_By>;
  requester_name?: InputMaybe<Order_By>;
  requester_team_name?: InputMaybe<Order_By>;
  shared_by_user?: InputMaybe<Users_Order_By>;
  shared_by_user_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  status_enum?: InputMaybe<Mls_Share_Status_Enum_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: mls_shares */
export type Mls_Shares_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Mls_Shares_Prepend_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "mls_shares" */
export enum Mls_Shares_Select_Column {
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HandledAt = 'handled_at',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  RequestedByUserId = 'requested_by_user_id',
  /** column name */
  SharedByUserId = 'shared_by_user_id',
  /** column name */
  Status = 'status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "mls_shares" */
export type Mls_Shares_Set_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  /** When the share was approved/rejected */
  handled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Share status: shared, pending, rejected */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "mls_shares" */
export type Mls_Shares_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Mls_Shares_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Mls_Shares_Stream_Cursor_Value_Input = {
  auto_matching_filters?: InputMaybe<Scalars['jsonb']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** When the share was approved/rejected */
  handled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** The listing being shared */
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  /** User who requested access (null if proactive share) */
  requested_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  /** User who shared/approved (null if pending) */
  shared_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Share status: shared, pending, rejected */
  status?: InputMaybe<Scalars['String']['input']>;
  /** The team this listing is shared with or requested by */
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "mls_shares" */
export enum Mls_Shares_Update_Column {
  /** column name */
  AutoMatchingFilters = 'auto_matching_filters',
  /** column name */
  HandledAt = 'handled_at',
  /** column name */
  SharedByUserId = 'shared_by_user_id',
  /** column name */
  Status = 'status'
}

export type Mls_Shares_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Mls_Shares_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Mls_Shares_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Mls_Shares_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Mls_Shares_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Mls_Shares_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Mls_Shares_Set_Input>;
  /** filter the rows which have to be updated */
  where: Mls_Shares_Bool_Exp;
};

/** Teams with active MLS listings (available/reserved only) */
export type Mls_Teams = {
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  logo?: Maybe<Images>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "mls_teams" */
export type Mls_Teams_Aggregate = {
  aggregate?: Maybe<Mls_Teams_Aggregate_Fields>;
  nodes: Array<Mls_Teams>;
};

/** aggregate fields of "mls_teams" */
export type Mls_Teams_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Mls_Teams_Max_Fields>;
  min?: Maybe<Mls_Teams_Min_Fields>;
};


/** aggregate fields of "mls_teams" */
export type Mls_Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Mls_Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "mls_teams". All fields are combined with a logical 'AND'. */
export type Mls_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Mls_Teams_Bool_Exp>>;
  _not?: InputMaybe<Mls_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Mls_Teams_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  logo?: InputMaybe<Images_Bool_Exp>;
  logo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Mls_Teams_Max_Fields = {
  id?: Maybe<Scalars['uuid']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Mls_Teams_Min_Fields = {
  id?: Maybe<Scalars['uuid']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "mls_teams". */
export type Mls_Teams_Order_By = {
  id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Images_Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "mls_teams" */
export enum Mls_Teams_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id'
}

export type Model_Pricing_Aggregate_Bool_Exp = {
  count?: InputMaybe<Model_Pricing_Aggregate_Bool_Exp_Count>;
};

export type Model_Pricing_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export enum Modules_Enum_Enum {
  AiChat = 'ai_chat',
  Brokerage = 'brokerage',
  CmaReports = 'cma_reports',
  Financing = 'financing',
  Leads = 'leads',
  ProspectionMap = 'prospection_map',
  ProspectionMapV2 = 'prospection_map_v2',
  ValuationLink = 'valuation_link',
  Visibility = 'visibility',
  Voip = 'voip'
}

/** Boolean expression to compare columns of type "modules_enum_enum". All fields are combined with logical 'AND'. */
export type Modules_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Modules_Enum_Enum>;
  _in?: InputMaybe<Array<Modules_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Modules_Enum_Enum>;
  _nin?: InputMaybe<Array<Modules_Enum_Enum>>;
};

export type Mutation_Audit_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Mutation_Audit_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Mutation_Audit_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Mutation_Audit_Aggregate_Bool_Exp_Count>;
};

export type Mutation_Audit_Aggregate_Bool_Exp_Bool_And = {
  arguments: Chat_Api_Mutation_Audit_Select_Column_Mutation_Audit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mutation_Audit_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Chat_Api_Mutation_Audit_Select_Column_Mutation_Audit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Mutation_Audit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** mutation root */
export type Mutation_Root = {
  /** execute VOLATILE function "activate_property_image_version" which returns "property_images" */
  activate_property_image_version: Array<Property_Images>;
  /** execute VOLATILE function "apply_notification_channels_to_existing_users" which returns "notification_settings" */
  apply_notification_channels_to_existing_users: Array<Notification_Settings>;
  auto_search_pois: Scalars['Boolean']['output'];
  /**
   * Block FSBO advertisers (shadow ban, #24256): flags each account and takes
   * its live FSBO listings down. One call blocks an advertiser together with
   * the linked accounts the reviewer ticked; they share a batch id (pass an
   * existing batch_id to join it) so they can be unblocked together. Tenant
   * admins only; consumer accounts of the caller's tenant (or any tenant for
   * RealAdvisor staff).
   */
  block_fsbo_users?: Maybe<BlockFsboUsersOutput>;
  bootstrap_onboarding_agency?: Maybe<BootstrapOnboardingAgencyOutput>;
  /** execute VOLATILE function "bulk_reassign_user_account_manager" which returns "users" */
  bulk_reassign_user_account_manager: Array<Users>;
  /** Claim an unclaimed agency — promotes caller to leader and grants CRM access */
  claim_agency?: Maybe<ClaimAgencyOutput>;
  /** Claim the calling agent's own unclaimed profile and grant CRM access */
  claim_agent?: Maybe<ClaimAgentOutput>;
  claim_lead?: Maybe<ClaimLeadOutput>;
  complete_full_onboarding?: Maybe<CompleteFullOnboardingOutput>;
  composite_watermark_images?: Maybe<CompositeWatermarkImagesOutput>;
  contact_prospection_lead?: Maybe<ContactProspectionLeadOutput>;
  /** Create a buyer lead for a contact on a lot (idempotent on the lot/contact pair); optionally derives a property search from the lot */
  create_buyer_lead?: Maybe<CreateBuyerLeadOutput>;
  /** Create or match a contact using the enquiry-pipeline user matching rules (email / normalized phone) */
  create_contact?: Maybe<CreateContactOutput>;
  /** Create an enquiry with legacy-parity side effects (user matching, buyer lead, property search) */
  create_enquiry?: Maybe<CreateEnquiryOutput>;
  create_enquiry_buyer_lead?: Maybe<CreateEnquiryBuyerLeadOutput>;
  create_key?: Maybe<ApiKey>;
  create_marketplace_conversation: CreateMarketplaceConversationOutput;
  /** Create a property search for a contact with explicit criteria (places, property types, price/surface/room bounds) */
  create_property_search?: Maybe<CreatePropertySearchOutput>;
  /** delete data from the table: "activities" */
  delete_activities?: Maybe<Activities_Mutation_Response>;
  /** delete single row from the table: "activities" */
  delete_activities_by_pk?: Maybe<Activities>;
  /** delete data from the table: "activities_target_users" */
  delete_activities_target_users?: Maybe<Activities_Target_Users_Mutation_Response>;
  /** delete data from the table: "buyer_leads" */
  delete_buyer_leads?: Maybe<Buyer_Leads_Mutation_Response>;
  /** delete single row from the table: "buyer_leads" */
  delete_buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  /** delete data from the table: "catchment_areas" */
  delete_catchment_areas?: Maybe<Catchment_Areas_Mutation_Response>;
  /** delete single row from the table: "catchment_areas" */
  delete_catchment_areas_by_pk?: Maybe<Catchment_Areas>;
  /** delete data from the table: "cma_report_files" */
  delete_cma_report_files?: Maybe<Cma_Report_Files_Mutation_Response>;
  /** delete single row from the table: "cma_report_files" */
  delete_cma_report_files_by_pk?: Maybe<Cma_Report_Files>;
  /** delete data from the table: "cma_reports" */
  delete_cma_reports?: Maybe<Cma_Reports_Mutation_Response>;
  /** delete data from the table: "cma_reports_agent_transactions" */
  delete_cma_reports_agent_transactions?: Maybe<Cma_Reports_Agent_Transactions_Mutation_Response>;
  /** delete single row from the table: "cma_reports_agent_transactions" */
  delete_cma_reports_agent_transactions_by_pk?: Maybe<Cma_Reports_Agent_Transactions>;
  /** delete single row from the table: "cma_reports" */
  delete_cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** delete data from the table: "cma_reports_comparables" */
  delete_cma_reports_comparables?: Maybe<Cma_Reports_Comparables_Mutation_Response>;
  /** delete single row from the table: "cma_reports_comparables" */
  delete_cma_reports_comparables_by_pk?: Maybe<Cma_Reports_Comparables>;
  /** delete data from the table: "cma_reports_property_transactions" */
  delete_cma_reports_property_transactions?: Maybe<Cma_Reports_Property_Transactions_Mutation_Response>;
  /** delete single row from the table: "cma_reports_property_transactions" */
  delete_cma_reports_property_transactions_by_pk?: Maybe<Cma_Reports_Property_Transactions>;
  /** delete data from the table: "cma_reports_user_reviews" */
  delete_cma_reports_user_reviews?: Maybe<Cma_Reports_User_Reviews_Mutation_Response>;
  /** delete single row from the table: "cma_reports_user_reviews" */
  delete_cma_reports_user_reviews_by_pk?: Maybe<Cma_Reports_User_Reviews>;
  /** delete data from the table: "commissions" */
  delete_commissions?: Maybe<Commissions_Mutation_Response>;
  /** delete single row from the table: "commissions" */
  delete_commissions_by_pk?: Maybe<Commissions>;
  /** delete data from the table: "development_collaborators" */
  delete_development_collaborators?: Maybe<Development_Collaborators_Mutation_Response>;
  /** delete single row from the table: "development_collaborators" */
  delete_development_collaborators_by_pk?: Maybe<Development_Collaborators>;
  /** delete data from the table: "development_files" */
  delete_development_files?: Maybe<Development_Files_Mutation_Response>;
  /** delete single row from the table: "development_files" */
  delete_development_files_by_pk?: Maybe<Development_Files>;
  /** delete data from the table: "development_images" */
  delete_development_images?: Maybe<Development_Images_Mutation_Response>;
  /** delete single row from the table: "development_images" */
  delete_development_images_by_pk?: Maybe<Development_Images>;
  /** delete data from the table: "development_mappings" */
  delete_development_mappings?: Maybe<Development_Mappings_Mutation_Response>;
  /** delete single row from the table: "development_mappings" */
  delete_development_mappings_by_pk?: Maybe<Development_Mappings>;
  /** delete data from the table: "developments" */
  delete_developments?: Maybe<Developments_Mutation_Response>;
  /** delete single row from the table: "developments" */
  delete_developments_by_pk?: Maybe<Developments>;
  /** delete data from the table: "dictionaries" */
  delete_dictionaries?: Maybe<Dictionaries_Mutation_Response>;
  /** delete single row from the table: "dictionaries" */
  delete_dictionaries_by_pk?: Maybe<Dictionaries>;
  /** delete data from the table: "doc_template_themes" */
  delete_doc_template_themes?: Maybe<Doc_Template_Themes_Mutation_Response>;
  /** delete single row from the table: "doc_template_themes" */
  delete_doc_template_themes_by_pk?: Maybe<Doc_Template_Themes>;
  /** delete data from the table: "doc_template_themes_teams" */
  delete_doc_template_themes_teams?: Maybe<Doc_Template_Themes_Teams_Mutation_Response>;
  /** delete single row from the table: "doc_template_themes_teams" */
  delete_doc_template_themes_teams_by_pk?: Maybe<Doc_Template_Themes_Teams>;
  /** delete data from the table: "doc_template_themes_tenants" */
  delete_doc_template_themes_tenants?: Maybe<Doc_Template_Themes_Tenants_Mutation_Response>;
  /** delete single row from the table: "doc_template_themes_tenants" */
  delete_doc_template_themes_tenants_by_pk?: Maybe<Doc_Template_Themes_Tenants>;
  /** delete data from the table: "doc_templates" */
  delete_doc_templates?: Maybe<Doc_Templates_Mutation_Response>;
  /** delete single row from the table: "doc_templates" */
  delete_doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** delete data from the table: "doc_templates_teams" */
  delete_doc_templates_teams?: Maybe<Doc_Templates_Teams_Mutation_Response>;
  /** delete single row from the table: "doc_templates_teams" */
  delete_doc_templates_teams_by_pk?: Maybe<Doc_Templates_Teams>;
  /** delete data from the table: "doc_templates_tenants" */
  delete_doc_templates_tenants?: Maybe<Doc_Templates_Tenants_Mutation_Response>;
  /** delete single row from the table: "doc_templates_tenants" */
  delete_doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** delete data from the table: "email_sequences" */
  delete_email_sequences?: Maybe<Email_Sequences_Mutation_Response>;
  /** delete single row from the table: "email_sequences" */
  delete_email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** delete data from the table: "email_sequences_recipients" */
  delete_email_sequences_recipients?: Maybe<Email_Sequences_Recipients_Mutation_Response>;
  /** delete single row from the table: "email_sequences_recipients" */
  delete_email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** delete data from the table: "email_sequences_steps" */
  delete_email_sequences_steps?: Maybe<Email_Sequences_Steps_Mutation_Response>;
  /** delete single row from the table: "email_sequences_steps" */
  delete_email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** delete data from the table: "email_templates" */
  delete_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** delete single row from the table: "email_templates" */
  delete_email_templates_by_pk?: Maybe<Email_Templates>;
  /** delete data from the table: "email_templates_files" */
  delete_email_templates_files?: Maybe<Email_Templates_Files_Mutation_Response>;
  /** delete single row from the table: "email_templates_files" */
  delete_email_templates_files_by_pk?: Maybe<Email_Templates_Files>;
  /** delete data from the table: "emails" */
  delete_emails?: Maybe<Emails_Mutation_Response>;
  /** delete single row from the table: "emails" */
  delete_emails_by_pk?: Maybe<Emails>;
  /** delete data from the table: "enquiries" */
  delete_enquiries?: Maybe<Enquiries_Mutation_Response>;
  /** delete single row from the table: "enquiries" */
  delete_enquiries_by_pk?: Maybe<Enquiries>;
  /** delete data from the table: "files" */
  delete_files?: Maybe<Files_Mutation_Response>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: Maybe<Files>;
  /** delete data from the table: "google_reviews" */
  delete_google_reviews?: Maybe<Google_Reviews_Mutation_Response>;
  /** delete single row from the table: "google_reviews" */
  delete_google_reviews_by_pk?: Maybe<Google_Reviews>;
  /** delete data from the table: "images" */
  delete_images?: Maybe<Images_Mutation_Response>;
  /** delete single row from the table: "images" */
  delete_images_by_pk?: Maybe<Images>;
  delete_key?: Maybe<DeleteKeyResponse>;
  /** delete data from the table: "lead_agents" */
  delete_lead_agents?: Maybe<Lead_Agents_Mutation_Response>;
  /** delete single row from the table: "lead_agents" */
  delete_lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** delete data from the table: "lead_stages" */
  delete_lead_stages?: Maybe<Lead_Stages_Mutation_Response>;
  /** delete single row from the table: "lead_stages" */
  delete_lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** delete data from the table: "leads" */
  delete_leads?: Maybe<Leads_Mutation_Response>;
  /** delete single row from the table: "leads" */
  delete_leads_by_pk?: Maybe<Leads>;
  /** delete data from the table: "leads_tags" */
  delete_leads_tags?: Maybe<Leads_Tags_Mutation_Response>;
  /** delete single row from the table: "leads_tags" */
  delete_leads_tags_by_pk?: Maybe<Leads_Tags>;
  delete_legacy_key?: Maybe<DeleteKeyResponse>;
  /** delete data from the table: "lot_sellers" */
  delete_lot_sellers?: Maybe<Lot_Sellers_Mutation_Response>;
  /** delete single row from the table: "lot_sellers" */
  delete_lot_sellers_by_pk?: Maybe<Lot_Sellers>;
  /** delete data from the table: "lots" */
  delete_lots?: Maybe<Lots_Mutation_Response>;
  /** delete single row from the table: "lots" */
  delete_lots_by_pk?: Maybe<Lots>;
  delete_marketplace_conversation: DeleteMarketplaceConversationOutput;
  /** delete data from the table: "mls_listing_enquiry_settings" */
  delete_mls_listing_enquiry_settings?: Maybe<Mls_Listing_Enquiry_Settings_Mutation_Response>;
  /** delete single row from the table: "mls_listing_enquiry_settings" */
  delete_mls_listing_enquiry_settings_by_pk?: Maybe<Mls_Listing_Enquiry_Settings>;
  /** delete data from the table: "mls_shares" */
  delete_mls_shares?: Maybe<Mls_Shares_Mutation_Response>;
  /** delete single row from the table: "mls_shares" */
  delete_mls_shares_by_pk?: Maybe<Mls_Shares>;
  /** delete data from the table: "notification_settings" */
  delete_notification_settings?: Maybe<Notification_Settings_Mutation_Response>;
  /** delete single row from the table: "notification_settings" */
  delete_notification_settings_by_pk?: Maybe<Notification_Settings>;
  /** delete data from the table: "offers" */
  delete_offers?: Maybe<Offers_Mutation_Response>;
  /** delete single row from the table: "offers" */
  delete_offers_by_pk?: Maybe<Offers>;
  /** delete data from the table: "organisation_images" */
  delete_organisation_images?: Maybe<Organisation_Images_Mutation_Response>;
  /** delete single row from the table: "organisation_images" */
  delete_organisation_images_by_pk?: Maybe<Organisation_Images>;
  /** delete data from the table: "organisations" */
  delete_organisations?: Maybe<Organisations_Mutation_Response>;
  /** delete single row from the table: "organisations" */
  delete_organisations_by_pk?: Maybe<Organisations>;
  /** delete data from the table: "phone_numbers" */
  delete_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** delete single row from the table: "phone_numbers" */
  delete_phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** delete data from the table: "pipelines" */
  delete_pipelines?: Maybe<Pipelines_Mutation_Response>;
  /** delete single row from the table: "pipelines" */
  delete_pipelines_by_pk?: Maybe<Pipelines>;
  /** delete data from the table: "portals" */
  delete_portals?: Maybe<Portals_Mutation_Response>;
  /** delete single row from the table: "portals" */
  delete_portals_by_pk?: Maybe<Portals>;
  /** delete data from the table: "property_files" */
  delete_property_files?: Maybe<Property_Files_Mutation_Response>;
  /** delete single row from the table: "property_files" */
  delete_property_files_by_pk?: Maybe<Property_Files>;
  /** delete data from the table: "property_images" */
  delete_property_images?: Maybe<Property_Images_Mutation_Response>;
  /** delete single row from the table: "property_images" */
  delete_property_images_by_pk?: Maybe<Property_Images>;
  /** delete data from the table: "property_pois" */
  delete_property_pois?: Maybe<Property_Pois_Mutation_Response>;
  /** delete single row from the table: "property_pois" */
  delete_property_pois_by_pk?: Maybe<Property_Pois>;
  /** delete data from the table: "property_searches" */
  delete_property_searches?: Maybe<Property_Searches_Mutation_Response>;
  /** delete single row from the table: "property_searches" */
  delete_property_searches_by_pk?: Maybe<Property_Searches>;
  /** delete data from the table: "property_searches_places" */
  delete_property_searches_places?: Maybe<Property_Searches_Places_Mutation_Response>;
  /** delete single row from the table: "property_searches_places" */
  delete_property_searches_places_by_pk?: Maybe<Property_Searches_Places>;
  /** delete data from the table: "property_searches_property_types" */
  delete_property_searches_property_types?: Maybe<Property_Searches_Property_Types_Mutation_Response>;
  /** delete single row from the table: "property_searches_property_types" */
  delete_property_searches_property_types_by_pk?: Maybe<Property_Searches_Property_Types>;
  /** delete data from the table: "property_transactions" */
  delete_property_transactions?: Maybe<Property_Transactions_Mutation_Response>;
  /** delete single row from the table: "property_transactions" */
  delete_property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** delete data from the table: "property_transactions_listings" */
  delete_property_transactions_listings?: Maybe<Property_Transactions_Listings_Mutation_Response>;
  /** delete single row from the table: "property_transactions_listings" */
  delete_property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** delete data from the table: "prospection_contact_message_templates" */
  delete_prospection_contact_message_templates?: Maybe<Prospection_Contact_Message_Templates_Mutation_Response>;
  /** delete single row from the table: "prospection_contact_message_templates" */
  delete_prospection_contact_message_templates_by_pk?: Maybe<Prospection_Contact_Message_Templates>;
  /** delete data from the table: "prospection_contact_teams" */
  delete_prospection_contact_teams?: Maybe<Prospection_Contact_Teams_Mutation_Response>;
  /** delete single row from the table: "prospection_contact_teams" */
  delete_prospection_contact_teams_by_pk?: Maybe<Prospection_Contact_Teams>;
  /** delete data from the table: "prospection_marks" */
  delete_prospection_marks?: Maybe<Prospection_Marks_Mutation_Response>;
  /** delete single row from the table: "prospection_marks" */
  delete_prospection_marks_by_pk?: Maybe<Prospection_Marks>;
  /** delete data from the table: "push_notification_tokens" */
  delete_push_notification_tokens?: Maybe<Push_Notification_Tokens_Mutation_Response>;
  /** delete single row from the table: "push_notification_tokens" */
  delete_push_notification_tokens_by_pk?: Maybe<Push_Notification_Tokens>;
  /** delete data from the table: "review_invitation_templates" */
  delete_review_invitation_templates?: Maybe<Review_Invitation_Templates_Mutation_Response>;
  /** delete single row from the table: "review_invitation_templates" */
  delete_review_invitation_templates_by_pk?: Maybe<Review_Invitation_Templates>;
  /** delete data from the table: "reviews" */
  delete_reviews?: Maybe<Reviews_Mutation_Response>;
  /** delete single row from the table: "reviews" */
  delete_reviews_by_pk?: Maybe<Reviews>;
  /** delete data from the table: "smart_lists" */
  delete_smart_lists?: Maybe<Smart_Lists_Mutation_Response>;
  /** delete single row from the table: "smart_lists" */
  delete_smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** delete data from the table: "team_images" */
  delete_team_images?: Maybe<Team_Images_Mutation_Response>;
  /** delete single row from the table: "team_images" */
  delete_team_images_by_pk?: Maybe<Team_Images>;
  /** Delete the open document's team theme (a variation made by the caller or a team leader) and switch the documents that use it back to the default look */
  delete_team_theme?: Maybe<DeleteTeamThemeOutput>;
  /** delete data from the table: "teams" */
  delete_teams?: Maybe<Teams_Mutation_Response>;
  /** delete single row from the table: "teams" */
  delete_teams_by_pk?: Maybe<Teams>;
  /** delete data from the table: "teams_portals" */
  delete_teams_portals?: Maybe<Teams_Portals_Mutation_Response>;
  /** delete single row from the table: "teams_portals" */
  delete_teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** delete data from the table: "teams_users" */
  delete_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** delete data from the table: "transaction_buyers" */
  delete_transaction_buyers?: Maybe<Transaction_Buyers_Mutation_Response>;
  /** delete single row from the table: "transaction_buyers" */
  delete_transaction_buyers_by_pk?: Maybe<Transaction_Buyers>;
  /** delete data from the table: "transaction_sellers" */
  delete_transaction_sellers?: Maybe<Transaction_Sellers_Mutation_Response>;
  /** delete single row from the table: "transaction_sellers" */
  delete_transaction_sellers_by_pk?: Maybe<Transaction_Sellers>;
  delete_user?: Maybe<DeleteUserOutput>;
  /** delete data from the table: "user_images" */
  delete_user_images?: Maybe<User_Images_Mutation_Response>;
  /** delete single row from the table: "user_images" */
  delete_user_images_by_pk?: Maybe<User_Images>;
  /** delete data from the table: "user_product_experiences" */
  delete_user_product_experiences?: Maybe<User_Product_Experiences_Mutation_Response>;
  /** delete single row from the table: "user_product_experiences" */
  delete_user_product_experiences_by_pk?: Maybe<User_Product_Experiences>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** delete data from the table: "users_listings" */
  delete_users_listings?: Maybe<Users_Listings_Mutation_Response>;
  /** delete single row from the table: "users_listings" */
  delete_users_listings_by_pk?: Maybe<Users_Listings>;
  /** delete data from the table: "webhook_subscriptions" */
  delete_webhook_subscriptions?: Maybe<Webhook_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "webhook_subscriptions" */
  delete_webhook_subscriptions_by_pk?: Maybe<Webhook_Subscriptions>;
  /** delete data from the table: "webhook_subscriptions_event_types" */
  delete_webhook_subscriptions_event_types?: Maybe<Webhook_Subscriptions_Event_Types_Mutation_Response>;
  /** delete single row from the table: "webhook_subscriptions_event_types" */
  delete_webhook_subscriptions_event_types_by_pk?: Maybe<Webhook_Subscriptions_Event_Types>;
  /** enhance-image */
  enhance_image?: Maybe<EnhanceImageOutput>;
  /** generate-lead-summary */
  generateLeadSummary?: Maybe<GenerateLeadSummaryOutput>;
  /** generate_cma_report */
  generate_cma_report?: Maybe<GenerateCmaReportOutput>;
  get_property_distances: GetPropertyDistancesOutput;
  /** Import buyer leads */
  import_buyer_leads?: Maybe<Array<BuyerLeadImportOutput>>;
  /** Import lots */
  import_lots?: Maybe<Array<LotImportOutput>>;
  /** Import listings from a portal feed (idealista, pisos) */
  import_portal_listings?: Maybe<ImportPortalListingsOutput>;
  /** Import property searches */
  import_property_searches?: Maybe<Array<PropertySearchImportOutput>>;
  /** Import users (contacts) */
  import_users?: Maybe<Array<UserImportOutput>>;
  /** insert data into the table: "activities" */
  insert_activities?: Maybe<Activities_Mutation_Response>;
  /** insert a single row into the table: "activities" */
  insert_activities_one?: Maybe<Activities>;
  /** insert data into the table: "activities_target_users" */
  insert_activities_target_users?: Maybe<Activities_Target_Users_Mutation_Response>;
  /** insert a single row into the table: "activities_target_users" */
  insert_activities_target_users_one?: Maybe<Activities_Target_Users>;
  /** insert data into the table: "buyer_leads" */
  insert_buyer_leads?: Maybe<Buyer_Leads_Mutation_Response>;
  /** insert a single row into the table: "buyer_leads" */
  insert_buyer_leads_one?: Maybe<Buyer_Leads>;
  /** insert data into the table: "catchment_areas" */
  insert_catchment_areas?: Maybe<Catchment_Areas_Mutation_Response>;
  /** insert a single row into the table: "catchment_areas" */
  insert_catchment_areas_one?: Maybe<Catchment_Areas>;
  /** insert data into the table: "cma_report_files" */
  insert_cma_report_files?: Maybe<Cma_Report_Files_Mutation_Response>;
  /** insert a single row into the table: "cma_report_files" */
  insert_cma_report_files_one?: Maybe<Cma_Report_Files>;
  /** insert data into the table: "cma_reports" */
  insert_cma_reports?: Maybe<Cma_Reports_Mutation_Response>;
  /** insert data into the table: "cma_reports_agent_transactions" */
  insert_cma_reports_agent_transactions?: Maybe<Cma_Reports_Agent_Transactions_Mutation_Response>;
  /** insert a single row into the table: "cma_reports_agent_transactions" */
  insert_cma_reports_agent_transactions_one?: Maybe<Cma_Reports_Agent_Transactions>;
  /** insert data into the table: "cma_reports_comparables" */
  insert_cma_reports_comparables?: Maybe<Cma_Reports_Comparables_Mutation_Response>;
  /** insert a single row into the table: "cma_reports_comparables" */
  insert_cma_reports_comparables_one?: Maybe<Cma_Reports_Comparables>;
  /** insert a single row into the table: "cma_reports" */
  insert_cma_reports_one?: Maybe<Cma_Reports>;
  /** insert data into the table: "cma_reports_property_transactions" */
  insert_cma_reports_property_transactions?: Maybe<Cma_Reports_Property_Transactions_Mutation_Response>;
  /** insert a single row into the table: "cma_reports_property_transactions" */
  insert_cma_reports_property_transactions_one?: Maybe<Cma_Reports_Property_Transactions>;
  /** insert data into the table: "cma_reports_user_reviews" */
  insert_cma_reports_user_reviews?: Maybe<Cma_Reports_User_Reviews_Mutation_Response>;
  /** insert a single row into the table: "cma_reports_user_reviews" */
  insert_cma_reports_user_reviews_one?: Maybe<Cma_Reports_User_Reviews>;
  /** insert data into the table: "commissions" */
  insert_commissions?: Maybe<Commissions_Mutation_Response>;
  /** insert a single row into the table: "commissions" */
  insert_commissions_one?: Maybe<Commissions>;
  /** insert data into the table: "development_collaborators" */
  insert_development_collaborators?: Maybe<Development_Collaborators_Mutation_Response>;
  /** insert a single row into the table: "development_collaborators" */
  insert_development_collaborators_one?: Maybe<Development_Collaborators>;
  /** insert data into the table: "development_files" */
  insert_development_files?: Maybe<Development_Files_Mutation_Response>;
  /** insert a single row into the table: "development_files" */
  insert_development_files_one?: Maybe<Development_Files>;
  /** insert data into the table: "development_images" */
  insert_development_images?: Maybe<Development_Images_Mutation_Response>;
  /** insert a single row into the table: "development_images" */
  insert_development_images_one?: Maybe<Development_Images>;
  /** insert data into the table: "development_mappings" */
  insert_development_mappings?: Maybe<Development_Mappings_Mutation_Response>;
  /** insert a single row into the table: "development_mappings" */
  insert_development_mappings_one?: Maybe<Development_Mappings>;
  /** insert data into the table: "developments" */
  insert_developments?: Maybe<Developments_Mutation_Response>;
  /** insert a single row into the table: "developments" */
  insert_developments_one?: Maybe<Developments>;
  /** insert data into the table: "dictionaries" */
  insert_dictionaries?: Maybe<Dictionaries_Mutation_Response>;
  /** insert a single row into the table: "dictionaries" */
  insert_dictionaries_one?: Maybe<Dictionaries>;
  /** insert data into the table: "doc_template_themes" */
  insert_doc_template_themes?: Maybe<Doc_Template_Themes_Mutation_Response>;
  /** insert a single row into the table: "doc_template_themes" */
  insert_doc_template_themes_one?: Maybe<Doc_Template_Themes>;
  /** insert data into the table: "doc_template_themes_teams" */
  insert_doc_template_themes_teams?: Maybe<Doc_Template_Themes_Teams_Mutation_Response>;
  /** insert a single row into the table: "doc_template_themes_teams" */
  insert_doc_template_themes_teams_one?: Maybe<Doc_Template_Themes_Teams>;
  /** insert data into the table: "doc_template_themes_tenants" */
  insert_doc_template_themes_tenants?: Maybe<Doc_Template_Themes_Tenants_Mutation_Response>;
  /** insert a single row into the table: "doc_template_themes_tenants" */
  insert_doc_template_themes_tenants_one?: Maybe<Doc_Template_Themes_Tenants>;
  /** insert data into the table: "doc_templates" */
  insert_doc_templates?: Maybe<Doc_Templates_Mutation_Response>;
  /** insert a single row into the table: "doc_templates" */
  insert_doc_templates_one?: Maybe<Doc_Templates>;
  /** insert data into the table: "doc_templates_teams" */
  insert_doc_templates_teams?: Maybe<Doc_Templates_Teams_Mutation_Response>;
  /** insert a single row into the table: "doc_templates_teams" */
  insert_doc_templates_teams_one?: Maybe<Doc_Templates_Teams>;
  /** insert data into the table: "doc_templates_tenants" */
  insert_doc_templates_tenants?: Maybe<Doc_Templates_Tenants_Mutation_Response>;
  /** insert a single row into the table: "doc_templates_tenants" */
  insert_doc_templates_tenants_one?: Maybe<Doc_Templates_Tenants>;
  /** insert data into the table: "email_sequences" */
  insert_email_sequences?: Maybe<Email_Sequences_Mutation_Response>;
  /** insert a single row into the table: "email_sequences" */
  insert_email_sequences_one?: Maybe<Email_Sequences>;
  /** insert data into the table: "email_sequences_recipients" */
  insert_email_sequences_recipients?: Maybe<Email_Sequences_Recipients_Mutation_Response>;
  /** insert a single row into the table: "email_sequences_recipients" */
  insert_email_sequences_recipients_one?: Maybe<Email_Sequences_Recipients>;
  /** insert data into the table: "email_sequences_steps" */
  insert_email_sequences_steps?: Maybe<Email_Sequences_Steps_Mutation_Response>;
  /** insert a single row into the table: "email_sequences_steps" */
  insert_email_sequences_steps_one?: Maybe<Email_Sequences_Steps>;
  /** insert data into the table: "email_templates" */
  insert_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** insert data into the table: "email_templates_files" */
  insert_email_templates_files?: Maybe<Email_Templates_Files_Mutation_Response>;
  /** insert a single row into the table: "email_templates_files" */
  insert_email_templates_files_one?: Maybe<Email_Templates_Files>;
  /** insert a single row into the table: "email_templates" */
  insert_email_templates_one?: Maybe<Email_Templates>;
  /** insert data into the table: "emails" */
  insert_emails?: Maybe<Emails_Mutation_Response>;
  /** insert a single row into the table: "emails" */
  insert_emails_one?: Maybe<Emails>;
  /** insert data into the table: "enquiries" */
  insert_enquiries?: Maybe<Enquiries_Mutation_Response>;
  /** insert a single row into the table: "enquiries" */
  insert_enquiries_one?: Maybe<Enquiries>;
  /** insert data into the table: "files" */
  insert_files?: Maybe<Files_Mutation_Response>;
  /** insert a single row into the table: "files" */
  insert_files_one?: Maybe<Files>;
  /** insert data into the table: "google_addresses" */
  insert_google_addresses?: Maybe<Google_Addresses_Mutation_Response>;
  /** insert a single row into the table: "google_addresses" */
  insert_google_addresses_one?: Maybe<Google_Addresses>;
  /** insert data into the table: "images" */
  insert_images?: Maybe<Images_Mutation_Response>;
  /** insert a single row into the table: "images" */
  insert_images_one?: Maybe<Images>;
  /** insert data into the table: "invitations" */
  insert_invitations?: Maybe<Invitations_Mutation_Response>;
  /** insert a single row into the table: "invitations" */
  insert_invitations_one?: Maybe<Invitations>;
  /** insert data into the table: "lead_agents" */
  insert_lead_agents?: Maybe<Lead_Agents_Mutation_Response>;
  /** insert a single row into the table: "lead_agents" */
  insert_lead_agents_one?: Maybe<Lead_Agents>;
  /** insert data into the table: "lead_stages" */
  insert_lead_stages?: Maybe<Lead_Stages_Mutation_Response>;
  /** insert a single row into the table: "lead_stages" */
  insert_lead_stages_one?: Maybe<Lead_Stages>;
  /** insert data into the table: "leads" */
  insert_leads?: Maybe<Leads_Mutation_Response>;
  /** insert a single row into the table: "leads" */
  insert_leads_one?: Maybe<Leads>;
  /** insert data into the table: "leads_tags" */
  insert_leads_tags?: Maybe<Leads_Tags_Mutation_Response>;
  /** insert a single row into the table: "leads_tags" */
  insert_leads_tags_one?: Maybe<Leads_Tags>;
  /** insert data into the table: "lot_reference_aliases" */
  insert_lot_reference_aliases?: Maybe<Lot_Reference_Aliases_Mutation_Response>;
  /** insert a single row into the table: "lot_reference_aliases" */
  insert_lot_reference_aliases_one?: Maybe<Lot_Reference_Aliases>;
  /** insert data into the table: "lot_sellers" */
  insert_lot_sellers?: Maybe<Lot_Sellers_Mutation_Response>;
  /** insert a single row into the table: "lot_sellers" */
  insert_lot_sellers_one?: Maybe<Lot_Sellers>;
  /** insert data into the table: "lots" */
  insert_lots?: Maybe<Lots_Mutation_Response>;
  insert_lots_derived?: Maybe<InsertListingOutput>;
  /** insert a single row into the table: "lots" */
  insert_lots_one?: Maybe<Lots>;
  /** insert data into the table: "mls_listing_enquiry_settings" */
  insert_mls_listing_enquiry_settings?: Maybe<Mls_Listing_Enquiry_Settings_Mutation_Response>;
  /** insert a single row into the table: "mls_listing_enquiry_settings" */
  insert_mls_listing_enquiry_settings_one?: Maybe<Mls_Listing_Enquiry_Settings>;
  /** insert data into the table: "mls_settings" */
  insert_mls_settings?: Maybe<Mls_Settings_Mutation_Response>;
  /** insert a single row into the table: "mls_settings" */
  insert_mls_settings_one?: Maybe<Mls_Settings>;
  /** insert data into the table: "mls_shares" */
  insert_mls_shares?: Maybe<Mls_Shares_Mutation_Response>;
  /** insert a single row into the table: "mls_shares" */
  insert_mls_shares_one?: Maybe<Mls_Shares>;
  /** insert data into the table: "notification_settings" */
  insert_notification_settings?: Maybe<Notification_Settings_Mutation_Response>;
  /** insert a single row into the table: "notification_settings" */
  insert_notification_settings_one?: Maybe<Notification_Settings>;
  /** insert data into the table: "offers" */
  insert_offers?: Maybe<Offers_Mutation_Response>;
  /** insert a single row into the table: "offers" */
  insert_offers_one?: Maybe<Offers>;
  /** insert data into the table: "organisation_images" */
  insert_organisation_images?: Maybe<Organisation_Images_Mutation_Response>;
  /** insert a single row into the table: "organisation_images" */
  insert_organisation_images_one?: Maybe<Organisation_Images>;
  /** insert data into the table: "organisations" */
  insert_organisations?: Maybe<Organisations_Mutation_Response>;
  /** insert a single row into the table: "organisations" */
  insert_organisations_one?: Maybe<Organisations>;
  /** insert data into the table: "phone_number_type_enum" */
  insert_phone_number_type_enum?: Maybe<Phone_Number_Type_Enum_Mutation_Response>;
  /** insert a single row into the table: "phone_number_type_enum" */
  insert_phone_number_type_enum_one?: Maybe<Phone_Number_Type_Enum>;
  /** insert data into the table: "phone_numbers" */
  insert_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** insert a single row into the table: "phone_numbers" */
  insert_phone_numbers_one?: Maybe<Phone_Numbers>;
  /** insert data into the table: "pipelines" */
  insert_pipelines?: Maybe<Pipelines_Mutation_Response>;
  /** insert a single row into the table: "pipelines" */
  insert_pipelines_one?: Maybe<Pipelines>;
  insert_pois_one: Scalars['Boolean']['output'];
  /** insert data into the table: "portal_listings" */
  insert_portal_listings?: Maybe<Portal_Listings_Mutation_Response>;
  /** insert a single row into the table: "portal_listings" */
  insert_portal_listings_one?: Maybe<Portal_Listings>;
  /** insert data into the table: "portals" */
  insert_portals?: Maybe<Portals_Mutation_Response>;
  /** insert a single row into the table: "portals" */
  insert_portals_one?: Maybe<Portals>;
  /** insert data into the table: "properties" */
  insert_properties?: Maybe<Properties_Mutation_Response>;
  /** insert a single row into the table: "properties" */
  insert_properties_one?: Maybe<Properties>;
  /** insert data into the table: "property_files" */
  insert_property_files?: Maybe<Property_Files_Mutation_Response>;
  /** insert a single row into the table: "property_files" */
  insert_property_files_one?: Maybe<Property_Files>;
  /** insert data into the table: "property_images" */
  insert_property_images?: Maybe<Property_Images_Mutation_Response>;
  /** insert a single row into the table: "property_images" */
  insert_property_images_one?: Maybe<Property_Images>;
  /** insert data into the table: "property_searches" */
  insert_property_searches?: Maybe<Property_Searches_Mutation_Response>;
  /** insert data into the table: "property_searches_enquiries" */
  insert_property_searches_enquiries?: Maybe<Property_Searches_Enquiries_Mutation_Response>;
  /** insert a single row into the table: "property_searches_enquiries" */
  insert_property_searches_enquiries_one?: Maybe<Property_Searches_Enquiries>;
  /** insert a single row into the table: "property_searches" */
  insert_property_searches_one?: Maybe<Property_Searches>;
  /** insert data into the table: "property_searches_places" */
  insert_property_searches_places?: Maybe<Property_Searches_Places_Mutation_Response>;
  /** insert a single row into the table: "property_searches_places" */
  insert_property_searches_places_one?: Maybe<Property_Searches_Places>;
  /** insert data into the table: "property_searches_property_types" */
  insert_property_searches_property_types?: Maybe<Property_Searches_Property_Types_Mutation_Response>;
  /** insert a single row into the table: "property_searches_property_types" */
  insert_property_searches_property_types_one?: Maybe<Property_Searches_Property_Types>;
  /** insert data into the table: "property_transactions" */
  insert_property_transactions?: Maybe<Property_Transactions_Mutation_Response>;
  /** insert data into the table: "property_transactions_listings" */
  insert_property_transactions_listings?: Maybe<Property_Transactions_Listings_Mutation_Response>;
  /** insert a single row into the table: "property_transactions_listings" */
  insert_property_transactions_listings_one?: Maybe<Property_Transactions_Listings>;
  /** insert a single row into the table: "property_transactions" */
  insert_property_transactions_one?: Maybe<Property_Transactions>;
  /** insert data into the table: "prospection_contact_message_templates" */
  insert_prospection_contact_message_templates?: Maybe<Prospection_Contact_Message_Templates_Mutation_Response>;
  /** insert a single row into the table: "prospection_contact_message_templates" */
  insert_prospection_contact_message_templates_one?: Maybe<Prospection_Contact_Message_Templates>;
  /** insert data into the table: "prospection_contact_settings" */
  insert_prospection_contact_settings?: Maybe<Prospection_Contact_Settings_Mutation_Response>;
  /** insert a single row into the table: "prospection_contact_settings" */
  insert_prospection_contact_settings_one?: Maybe<Prospection_Contact_Settings>;
  /** insert data into the table: "prospection_contact_teams" */
  insert_prospection_contact_teams?: Maybe<Prospection_Contact_Teams_Mutation_Response>;
  /** insert a single row into the table: "prospection_contact_teams" */
  insert_prospection_contact_teams_one?: Maybe<Prospection_Contact_Teams>;
  /** insert data into the table: "prospection_marks" */
  insert_prospection_marks?: Maybe<Prospection_Marks_Mutation_Response>;
  /** insert a single row into the table: "prospection_marks" */
  insert_prospection_marks_one?: Maybe<Prospection_Marks>;
  /** insert data into the table: "push_notification_tokens" */
  insert_push_notification_tokens?: Maybe<Push_Notification_Tokens_Mutation_Response>;
  /** insert a single row into the table: "push_notification_tokens" */
  insert_push_notification_tokens_one?: Maybe<Push_Notification_Tokens>;
  /** insert data into the table: "review_invitation_templates" */
  insert_review_invitation_templates?: Maybe<Review_Invitation_Templates_Mutation_Response>;
  /** insert a single row into the table: "review_invitation_templates" */
  insert_review_invitation_templates_one?: Maybe<Review_Invitation_Templates>;
  /** insert data into the table: "reviews" */
  insert_reviews?: Maybe<Reviews_Mutation_Response>;
  /** insert a single row into the table: "reviews" */
  insert_reviews_one?: Maybe<Reviews>;
  /** insert data into the table: "smart_lists" */
  insert_smart_lists?: Maybe<Smart_Lists_Mutation_Response>;
  /** insert a single row into the table: "smart_lists" */
  insert_smart_lists_one?: Maybe<Smart_Lists>;
  /** insert data into the table: "team_images" */
  insert_team_images?: Maybe<Team_Images_Mutation_Response>;
  /** insert a single row into the table: "team_images" */
  insert_team_images_one?: Maybe<Team_Images>;
  /** insert data into the table: "teams" */
  insert_teams?: Maybe<Teams_Mutation_Response>;
  /** insert a single row into the table: "teams" */
  insert_teams_one?: Maybe<Teams>;
  /** insert data into the table: "teams_portals" */
  insert_teams_portals?: Maybe<Teams_Portals_Mutation_Response>;
  /** insert a single row into the table: "teams_portals" */
  insert_teams_portals_one?: Maybe<Teams_Portals>;
  /** insert data into the table: "teams_users" */
  insert_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** insert a single row into the table: "teams_users" */
  insert_teams_users_one?: Maybe<Teams_Users>;
  /** insert data into the table: "transaction_buyers" */
  insert_transaction_buyers?: Maybe<Transaction_Buyers_Mutation_Response>;
  /** insert a single row into the table: "transaction_buyers" */
  insert_transaction_buyers_one?: Maybe<Transaction_Buyers>;
  /** insert data into the table: "transaction_sellers" */
  insert_transaction_sellers?: Maybe<Transaction_Sellers_Mutation_Response>;
  /** insert a single row into the table: "transaction_sellers" */
  insert_transaction_sellers_one?: Maybe<Transaction_Sellers>;
  /** insert data into the table: "user_images" */
  insert_user_images?: Maybe<User_Images_Mutation_Response>;
  /** insert a single row into the table: "user_images" */
  insert_user_images_one?: Maybe<User_Images>;
  /** insert data into the table: "user_notification_preferences" */
  insert_user_notification_preferences?: Maybe<User_Notification_Preferences_Mutation_Response>;
  /** insert a single row into the table: "user_notification_preferences" */
  insert_user_notification_preferences_one?: Maybe<User_Notification_Preferences>;
  /** insert data into the table: "user_product_experiences" */
  insert_user_product_experiences?: Maybe<User_Product_Experiences_Mutation_Response>;
  /** insert a single row into the table: "user_product_experiences" */
  insert_user_product_experiences_one?: Maybe<User_Product_Experiences>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert data into the table: "users_listings" */
  insert_users_listings?: Maybe<Users_Listings_Mutation_Response>;
  /** insert a single row into the table: "users_listings" */
  insert_users_listings_one?: Maybe<Users_Listings>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** insert data into the table: "webhook_subscriptions" */
  insert_webhook_subscriptions?: Maybe<Webhook_Subscriptions_Mutation_Response>;
  /** insert data into the table: "webhook_subscriptions_event_types" */
  insert_webhook_subscriptions_event_types?: Maybe<Webhook_Subscriptions_Event_Types_Mutation_Response>;
  /** insert a single row into the table: "webhook_subscriptions_event_types" */
  insert_webhook_subscriptions_event_types_one?: Maybe<Webhook_Subscriptions_Event_Types>;
  /** insert a single row into the table: "webhook_subscriptions" */
  insert_webhook_subscriptions_one?: Maybe<Webhook_Subscriptions>;
  manual_search_pois: Array<Place>;
  /** Marks an email thread read in the CRM (not in the mailbox provider), mailbox owner only whatever the role (rule lives in the handler; no super_admin on purpose, a CRM session never carries it). */
  mark_email_thread_read?: Maybe<MarkEmailThreadReadOutput>;
  /** execute VOLATILE function "mark_listing_publication_import" which returns "lot_publication_history_result" */
  mark_listing_publication_import: Array<Lot_Publication_History_Result>;
  mark_marketplace_conversation_read: MarkMarketplaceConversationReadOutput;
  merge_user?: Maybe<MergeUserOutput>;
  prepare_upload?: Maybe<PreparedUpload>;
  property_appraisal?: Maybe<PropertyAppraisalOutput>;
  refuse_lead?: Maybe<RefuseLeadOutput>;
  /** Creates an idempotent My Home agent contact after verifying lead ownership and eligibility */
  requestMyHomeAppraisal: MyHomeAppraisalResult;
  /** execute VOLATILE function "reset_cma_market_comparison_places" which returns "cma_reports" */
  reset_cma_market_comparison_places: Array<Cma_Reports>;
  save_onboarding_progress?: Maybe<SaveOnboardingProgressOutput>;
  /** execute VOLATILE function "save_property_image_version" which returns "property_images" */
  save_property_image_version: Array<Property_Images>;
  /** Save a linted theme file for the caller's team (update the team theme or create a team copy) */
  save_team_theme?: Maybe<SaveTeamThemeOutput>;
  scrape_google_reviews?: Maybe<DataForSeoApiResponse>;
  send_buyers_auto_matching_email?: Maybe<SendBuyersAutoMatchingEmailOutput>;
  send_marketplace_message: SendMarketplaceMessageOutput;
  /** Send a slack notification */
  send_slack_notification?: Maybe<SlackNotificationOutput>;
  /** execute VOLATILE function "set_default_team" which returns "users" */
  set_default_team: Array<Users>;
  /** Make the open document's team theme the default of the caller's team */
  set_team_theme_default?: Maybe<SetTeamThemeDefaultOutput>;
  /** execute VOLATILE function "set_user_module_grant" which returns "users" */
  set_user_module_grant: Array<Users>;
  start_review?: Maybe<StartReviewResponse>;
  /** Start a free CRM trial for the current agent */
  start_trial?: Maybe<StartTrialOutput>;
  /** Hide an agency and all its members from public pages */
  takedown_agency?: Maybe<TakedownAgencyOutput>;
  /** Hide the calling agent's profile from public pages and mark it as claimed */
  takedown_agent?: Maybe<TakedownAgentOutput>;
  test_webhook?: Maybe<TestWebhookOutput>;
  /**
   * user role is for FSBO sellers calling the action from agg-next /
   * realadvisor-app to unpublish their own lot. The handler enforces
   * ownership for user callers (see toggle-portal-listing/index.ts).
   */
  toggle_portal_listing?: Maybe<PortalListing>;
  /** Sign + shorten a docs URL into a trackable share link */
  tracked_document_url?: Maybe<TrackedDocumentUrlOutput>;
  translate_agent_review?: Maybe<TranslatedAgentReview>;
  /** Lift block_fsbo_users blocks (one account, or a whole batch). */
  unblock_fsbo_users?: Maybe<UnblockFsboUsersOutput>;
  /** update data of the table: "activities" */
  update_activities?: Maybe<Activities_Mutation_Response>;
  /** update single row of the table: "activities" */
  update_activities_by_pk?: Maybe<Activities>;
  /** update multiples rows of table: "activities" */
  update_activities_many?: Maybe<Array<Maybe<Activities_Mutation_Response>>>;
  /** update data of the table: "buyer_leads" */
  update_buyer_leads?: Maybe<Buyer_Leads_Mutation_Response>;
  /** update single row of the table: "buyer_leads" */
  update_buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  /** update multiples rows of table: "buyer_leads" */
  update_buyer_leads_many?: Maybe<Array<Maybe<Buyer_Leads_Mutation_Response>>>;
  /** update data of the table: "cma_report_files" */
  update_cma_report_files?: Maybe<Cma_Report_Files_Mutation_Response>;
  /** update single row of the table: "cma_report_files" */
  update_cma_report_files_by_pk?: Maybe<Cma_Report_Files>;
  /** update multiples rows of table: "cma_report_files" */
  update_cma_report_files_many?: Maybe<Array<Maybe<Cma_Report_Files_Mutation_Response>>>;
  /** update data of the table: "cma_reports" */
  update_cma_reports?: Maybe<Cma_Reports_Mutation_Response>;
  /** update single row of the table: "cma_reports" */
  update_cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** update data of the table: "cma_reports_comparables" */
  update_cma_reports_comparables?: Maybe<Cma_Reports_Comparables_Mutation_Response>;
  /** update single row of the table: "cma_reports_comparables" */
  update_cma_reports_comparables_by_pk?: Maybe<Cma_Reports_Comparables>;
  /** update multiples rows of table: "cma_reports_comparables" */
  update_cma_reports_comparables_many?: Maybe<Array<Maybe<Cma_Reports_Comparables_Mutation_Response>>>;
  /** update multiples rows of table: "cma_reports" */
  update_cma_reports_many?: Maybe<Array<Maybe<Cma_Reports_Mutation_Response>>>;
  /** update data of the table: "cma_reports_property_transactions" */
  update_cma_reports_property_transactions?: Maybe<Cma_Reports_Property_Transactions_Mutation_Response>;
  /** update single row of the table: "cma_reports_property_transactions" */
  update_cma_reports_property_transactions_by_pk?: Maybe<Cma_Reports_Property_Transactions>;
  /** update multiples rows of table: "cma_reports_property_transactions" */
  update_cma_reports_property_transactions_many?: Maybe<Array<Maybe<Cma_Reports_Property_Transactions_Mutation_Response>>>;
  /** update data of the table: "commissions" */
  update_commissions?: Maybe<Commissions_Mutation_Response>;
  /** update single row of the table: "commissions" */
  update_commissions_by_pk?: Maybe<Commissions>;
  /** update multiples rows of table: "commissions" */
  update_commissions_many?: Maybe<Array<Maybe<Commissions_Mutation_Response>>>;
  /** update data of the table: "development_images" */
  update_development_images?: Maybe<Development_Images_Mutation_Response>;
  /** update single row of the table: "development_images" */
  update_development_images_by_pk?: Maybe<Development_Images>;
  /** update multiples rows of table: "development_images" */
  update_development_images_many?: Maybe<Array<Maybe<Development_Images_Mutation_Response>>>;
  /** update data of the table: "development_mappings" */
  update_development_mappings?: Maybe<Development_Mappings_Mutation_Response>;
  /** update single row of the table: "development_mappings" */
  update_development_mappings_by_pk?: Maybe<Development_Mappings>;
  /** update multiples rows of table: "development_mappings" */
  update_development_mappings_many?: Maybe<Array<Maybe<Development_Mappings_Mutation_Response>>>;
  /** update data of the table: "developments" */
  update_developments?: Maybe<Developments_Mutation_Response>;
  /** update single row of the table: "developments" */
  update_developments_by_pk?: Maybe<Developments>;
  /** update multiples rows of table: "developments" */
  update_developments_many?: Maybe<Array<Maybe<Developments_Mutation_Response>>>;
  /** update data of the table: "dictionaries" */
  update_dictionaries?: Maybe<Dictionaries_Mutation_Response>;
  /** update single row of the table: "dictionaries" */
  update_dictionaries_by_pk?: Maybe<Dictionaries>;
  /** update multiples rows of table: "dictionaries" */
  update_dictionaries_many?: Maybe<Array<Maybe<Dictionaries_Mutation_Response>>>;
  /** update data of the table: "doc_template_themes" */
  update_doc_template_themes?: Maybe<Doc_Template_Themes_Mutation_Response>;
  /** update single row of the table: "doc_template_themes" */
  update_doc_template_themes_by_pk?: Maybe<Doc_Template_Themes>;
  /** update multiples rows of table: "doc_template_themes" */
  update_doc_template_themes_many?: Maybe<Array<Maybe<Doc_Template_Themes_Mutation_Response>>>;
  /** update data of the table: "doc_template_themes_teams" */
  update_doc_template_themes_teams?: Maybe<Doc_Template_Themes_Teams_Mutation_Response>;
  /** update single row of the table: "doc_template_themes_teams" */
  update_doc_template_themes_teams_by_pk?: Maybe<Doc_Template_Themes_Teams>;
  /** update multiples rows of table: "doc_template_themes_teams" */
  update_doc_template_themes_teams_many?: Maybe<Array<Maybe<Doc_Template_Themes_Teams_Mutation_Response>>>;
  /** update data of the table: "doc_template_themes_tenants" */
  update_doc_template_themes_tenants?: Maybe<Doc_Template_Themes_Tenants_Mutation_Response>;
  /** update single row of the table: "doc_template_themes_tenants" */
  update_doc_template_themes_tenants_by_pk?: Maybe<Doc_Template_Themes_Tenants>;
  /** update multiples rows of table: "doc_template_themes_tenants" */
  update_doc_template_themes_tenants_many?: Maybe<Array<Maybe<Doc_Template_Themes_Tenants_Mutation_Response>>>;
  /** update data of the table: "doc_templates" */
  update_doc_templates?: Maybe<Doc_Templates_Mutation_Response>;
  /** update single row of the table: "doc_templates" */
  update_doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** update multiples rows of table: "doc_templates" */
  update_doc_templates_many?: Maybe<Array<Maybe<Doc_Templates_Mutation_Response>>>;
  /** update data of the table: "doc_templates_teams" */
  update_doc_templates_teams?: Maybe<Doc_Templates_Teams_Mutation_Response>;
  /** update single row of the table: "doc_templates_teams" */
  update_doc_templates_teams_by_pk?: Maybe<Doc_Templates_Teams>;
  /** update multiples rows of table: "doc_templates_teams" */
  update_doc_templates_teams_many?: Maybe<Array<Maybe<Doc_Templates_Teams_Mutation_Response>>>;
  /** update data of the table: "doc_templates_tenants" */
  update_doc_templates_tenants?: Maybe<Doc_Templates_Tenants_Mutation_Response>;
  /** update single row of the table: "doc_templates_tenants" */
  update_doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** update multiples rows of table: "doc_templates_tenants" */
  update_doc_templates_tenants_many?: Maybe<Array<Maybe<Doc_Templates_Tenants_Mutation_Response>>>;
  /** update data of the table: "email_sequences" */
  update_email_sequences?: Maybe<Email_Sequences_Mutation_Response>;
  /** update single row of the table: "email_sequences" */
  update_email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** update multiples rows of table: "email_sequences" */
  update_email_sequences_many?: Maybe<Array<Maybe<Email_Sequences_Mutation_Response>>>;
  /** update data of the table: "email_sequences_recipients" */
  update_email_sequences_recipients?: Maybe<Email_Sequences_Recipients_Mutation_Response>;
  /** update single row of the table: "email_sequences_recipients" */
  update_email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** update multiples rows of table: "email_sequences_recipients" */
  update_email_sequences_recipients_many?: Maybe<Array<Maybe<Email_Sequences_Recipients_Mutation_Response>>>;
  /** update data of the table: "email_sequences_steps" */
  update_email_sequences_steps?: Maybe<Email_Sequences_Steps_Mutation_Response>;
  /** update single row of the table: "email_sequences_steps" */
  update_email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** update multiples rows of table: "email_sequences_steps" */
  update_email_sequences_steps_many?: Maybe<Array<Maybe<Email_Sequences_Steps_Mutation_Response>>>;
  /** update data of the table: "email_templates" */
  update_email_templates?: Maybe<Email_Templates_Mutation_Response>;
  /** update single row of the table: "email_templates" */
  update_email_templates_by_pk?: Maybe<Email_Templates>;
  /** update multiples rows of table: "email_templates" */
  update_email_templates_many?: Maybe<Array<Maybe<Email_Templates_Mutation_Response>>>;
  /** Email thread visibility toggle, mailbox owner only whatever the role (rule lives in the handler; no super_admin on purpose, a CRM session never carries it). */
  update_email_thread_visibility?: Maybe<UpdateEmailThreadVisibilityOutput>;
  /** update data of the table: "emails" */
  update_emails?: Maybe<Emails_Mutation_Response>;
  /** update single row of the table: "emails" */
  update_emails_by_pk?: Maybe<Emails>;
  /** update multiples rows of table: "emails" */
  update_emails_many?: Maybe<Array<Maybe<Emails_Mutation_Response>>>;
  /** update data of the table: "enquiries" */
  update_enquiries?: Maybe<Enquiries_Mutation_Response>;
  /** update single row of the table: "enquiries" */
  update_enquiries_by_pk?: Maybe<Enquiries>;
  /** update multiples rows of table: "enquiries" */
  update_enquiries_many?: Maybe<Array<Maybe<Enquiries_Mutation_Response>>>;
  /** update data of the table: "files" */
  update_files?: Maybe<Files_Mutation_Response>;
  /** update single row of the table: "files" */
  update_files_by_pk?: Maybe<Files>;
  /** update multiples rows of table: "files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response>>>;
  /** update data of the table: "invitations" */
  update_invitations?: Maybe<Invitations_Mutation_Response>;
  /** update single row of the table: "invitations" */
  update_invitations_by_pk?: Maybe<Invitations>;
  /** update multiples rows of table: "invitations" */
  update_invitations_many?: Maybe<Array<Maybe<Invitations_Mutation_Response>>>;
  /** update_key */
  update_key?: Maybe<ApiKey>;
  /** update data of the table: "lead_agents" */
  update_lead_agents?: Maybe<Lead_Agents_Mutation_Response>;
  /** update single row of the table: "lead_agents" */
  update_lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** update multiples rows of table: "lead_agents" */
  update_lead_agents_many?: Maybe<Array<Maybe<Lead_Agents_Mutation_Response>>>;
  /** update data of the table: "lead_stages" */
  update_lead_stages?: Maybe<Lead_Stages_Mutation_Response>;
  /** update single row of the table: "lead_stages" */
  update_lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** update multiples rows of table: "lead_stages" */
  update_lead_stages_many?: Maybe<Array<Maybe<Lead_Stages_Mutation_Response>>>;
  /** update data of the table: "leads" */
  update_leads?: Maybe<Leads_Mutation_Response>;
  /** update single row of the table: "leads" */
  update_leads_by_pk?: Maybe<Leads>;
  /** update multiples rows of table: "leads" */
  update_leads_many?: Maybe<Array<Maybe<Leads_Mutation_Response>>>;
  update_legacy_key?: Maybe<LegacyApiKey>;
  /** update data of the table: "lots" */
  update_lots?: Maybe<Lots_Mutation_Response>;
  /** update single row of the table: "lots" */
  update_lots_by_pk?: Maybe<Lots>;
  /** update multiples rows of table: "lots" */
  update_lots_many?: Maybe<Array<Maybe<Lots_Mutation_Response>>>;
  /** update data of the table: "marketplace_conversation_participants" */
  update_marketplace_conversation_participants?: Maybe<Marketplace_Conversation_Participants_Mutation_Response>;
  /** update single row of the table: "marketplace_conversation_participants" */
  update_marketplace_conversation_participants_by_pk?: Maybe<Marketplace_Conversation_Participants>;
  /** update multiples rows of table: "marketplace_conversation_participants" */
  update_marketplace_conversation_participants_many?: Maybe<Array<Maybe<Marketplace_Conversation_Participants_Mutation_Response>>>;
  /** update data of the table: "mls_listing_enquiry_settings" */
  update_mls_listing_enquiry_settings?: Maybe<Mls_Listing_Enquiry_Settings_Mutation_Response>;
  /** update single row of the table: "mls_listing_enquiry_settings" */
  update_mls_listing_enquiry_settings_by_pk?: Maybe<Mls_Listing_Enquiry_Settings>;
  /** update multiples rows of table: "mls_listing_enquiry_settings" */
  update_mls_listing_enquiry_settings_many?: Maybe<Array<Maybe<Mls_Listing_Enquiry_Settings_Mutation_Response>>>;
  /** update data of the table: "mls_settings" */
  update_mls_settings?: Maybe<Mls_Settings_Mutation_Response>;
  /** update single row of the table: "mls_settings" */
  update_mls_settings_by_pk?: Maybe<Mls_Settings>;
  /** update multiples rows of table: "mls_settings" */
  update_mls_settings_many?: Maybe<Array<Maybe<Mls_Settings_Mutation_Response>>>;
  /** update data of the table: "mls_shares" */
  update_mls_shares?: Maybe<Mls_Shares_Mutation_Response>;
  /** update single row of the table: "mls_shares" */
  update_mls_shares_by_pk?: Maybe<Mls_Shares>;
  /** update multiples rows of table: "mls_shares" */
  update_mls_shares_many?: Maybe<Array<Maybe<Mls_Shares_Mutation_Response>>>;
  /** update data of the table: "notification_settings" */
  update_notification_settings?: Maybe<Notification_Settings_Mutation_Response>;
  /** update single row of the table: "notification_settings" */
  update_notification_settings_by_pk?: Maybe<Notification_Settings>;
  /** update multiples rows of table: "notification_settings" */
  update_notification_settings_many?: Maybe<Array<Maybe<Notification_Settings_Mutation_Response>>>;
  /** update data of the table: "offers" */
  update_offers?: Maybe<Offers_Mutation_Response>;
  /** update single row of the table: "offers" */
  update_offers_by_pk?: Maybe<Offers>;
  /** update multiples rows of table: "offers" */
  update_offers_many?: Maybe<Array<Maybe<Offers_Mutation_Response>>>;
  /** update data of the table: "organisation_images" */
  update_organisation_images?: Maybe<Organisation_Images_Mutation_Response>;
  /** update single row of the table: "organisation_images" */
  update_organisation_images_by_pk?: Maybe<Organisation_Images>;
  /** update multiples rows of table: "organisation_images" */
  update_organisation_images_many?: Maybe<Array<Maybe<Organisation_Images_Mutation_Response>>>;
  /** update data of the table: "organisations" */
  update_organisations?: Maybe<Organisations_Mutation_Response>;
  /** update single row of the table: "organisations" */
  update_organisations_by_pk?: Maybe<Organisations>;
  /** update multiples rows of table: "organisations" */
  update_organisations_many?: Maybe<Array<Maybe<Organisations_Mutation_Response>>>;
  /** update data of the table: "phone_numbers" */
  update_phone_numbers?: Maybe<Phone_Numbers_Mutation_Response>;
  /** update single row of the table: "phone_numbers" */
  update_phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** update multiples rows of table: "phone_numbers" */
  update_phone_numbers_many?: Maybe<Array<Maybe<Phone_Numbers_Mutation_Response>>>;
  /** update data of the table: "pipelines" */
  update_pipelines?: Maybe<Pipelines_Mutation_Response>;
  /** update single row of the table: "pipelines" */
  update_pipelines_by_pk?: Maybe<Pipelines>;
  /** update multiples rows of table: "pipelines" */
  update_pipelines_many?: Maybe<Array<Maybe<Pipelines_Mutation_Response>>>;
  update_portal_listing?: Maybe<UpdatePortalListing>;
  /** update data of the table: "portal_listings" */
  update_portal_listings?: Maybe<Portal_Listings_Mutation_Response>;
  /** update single row of the table: "portal_listings" */
  update_portal_listings_by_pk?: Maybe<Portal_Listings>;
  /** update multiples rows of table: "portal_listings" */
  update_portal_listings_many?: Maybe<Array<Maybe<Portal_Listings_Mutation_Response>>>;
  /** update data of the table: "portals" */
  update_portals?: Maybe<Portals_Mutation_Response>;
  /** update single row of the table: "portals" */
  update_portals_by_pk?: Maybe<Portals>;
  /** update multiples rows of table: "portals" */
  update_portals_many?: Maybe<Array<Maybe<Portals_Mutation_Response>>>;
  /** update data of the table: "properties" */
  update_properties?: Maybe<Properties_Mutation_Response>;
  /** update single row of the table: "properties" */
  update_properties_by_pk?: Maybe<Properties>;
  /** update multiples rows of table: "properties" */
  update_properties_many?: Maybe<Array<Maybe<Properties_Mutation_Response>>>;
  /** update data of the table: "property_files" */
  update_property_files?: Maybe<Property_Files_Mutation_Response>;
  /** update single row of the table: "property_files" */
  update_property_files_by_pk?: Maybe<Property_Files>;
  /** update multiples rows of table: "property_files" */
  update_property_files_many?: Maybe<Array<Maybe<Property_Files_Mutation_Response>>>;
  /** update data of the table: "property_images" */
  update_property_images?: Maybe<Property_Images_Mutation_Response>;
  /** update single row of the table: "property_images" */
  update_property_images_by_pk?: Maybe<Property_Images>;
  /** update multiples rows of table: "property_images" */
  update_property_images_many?: Maybe<Array<Maybe<Property_Images_Mutation_Response>>>;
  /** update data of the table: "property_searches" */
  update_property_searches?: Maybe<Property_Searches_Mutation_Response>;
  /** update single row of the table: "property_searches" */
  update_property_searches_by_pk?: Maybe<Property_Searches>;
  /** update multiples rows of table: "property_searches" */
  update_property_searches_many?: Maybe<Array<Maybe<Property_Searches_Mutation_Response>>>;
  /** update data of the table: "property_transactions" */
  update_property_transactions?: Maybe<Property_Transactions_Mutation_Response>;
  /** update single row of the table: "property_transactions" */
  update_property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** update data of the table: "property_transactions_listings" */
  update_property_transactions_listings?: Maybe<Property_Transactions_Listings_Mutation_Response>;
  /** update single row of the table: "property_transactions_listings" */
  update_property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** update multiples rows of table: "property_transactions_listings" */
  update_property_transactions_listings_many?: Maybe<Array<Maybe<Property_Transactions_Listings_Mutation_Response>>>;
  /** update multiples rows of table: "property_transactions" */
  update_property_transactions_many?: Maybe<Array<Maybe<Property_Transactions_Mutation_Response>>>;
  /** update data of the table: "prospection_contact_message_templates" */
  update_prospection_contact_message_templates?: Maybe<Prospection_Contact_Message_Templates_Mutation_Response>;
  /** update single row of the table: "prospection_contact_message_templates" */
  update_prospection_contact_message_templates_by_pk?: Maybe<Prospection_Contact_Message_Templates>;
  /** update multiples rows of table: "prospection_contact_message_templates" */
  update_prospection_contact_message_templates_many?: Maybe<Array<Maybe<Prospection_Contact_Message_Templates_Mutation_Response>>>;
  /** update data of the table: "prospection_contact_settings" */
  update_prospection_contact_settings?: Maybe<Prospection_Contact_Settings_Mutation_Response>;
  /** update single row of the table: "prospection_contact_settings" */
  update_prospection_contact_settings_by_pk?: Maybe<Prospection_Contact_Settings>;
  /** update multiples rows of table: "prospection_contact_settings" */
  update_prospection_contact_settings_many?: Maybe<Array<Maybe<Prospection_Contact_Settings_Mutation_Response>>>;
  /** update data of the table: "prospection_contact_teams" */
  update_prospection_contact_teams?: Maybe<Prospection_Contact_Teams_Mutation_Response>;
  /** update single row of the table: "prospection_contact_teams" */
  update_prospection_contact_teams_by_pk?: Maybe<Prospection_Contact_Teams>;
  /** update multiples rows of table: "prospection_contact_teams" */
  update_prospection_contact_teams_many?: Maybe<Array<Maybe<Prospection_Contact_Teams_Mutation_Response>>>;
  /** update data of the table: "prospection_marks" */
  update_prospection_marks?: Maybe<Prospection_Marks_Mutation_Response>;
  /** update single row of the table: "prospection_marks" */
  update_prospection_marks_by_pk?: Maybe<Prospection_Marks>;
  /** update multiples rows of table: "prospection_marks" */
  update_prospection_marks_many?: Maybe<Array<Maybe<Prospection_Marks_Mutation_Response>>>;
  /** update data of the table: "push_notification_tokens" */
  update_push_notification_tokens?: Maybe<Push_Notification_Tokens_Mutation_Response>;
  /** update single row of the table: "push_notification_tokens" */
  update_push_notification_tokens_by_pk?: Maybe<Push_Notification_Tokens>;
  /** update multiples rows of table: "push_notification_tokens" */
  update_push_notification_tokens_many?: Maybe<Array<Maybe<Push_Notification_Tokens_Mutation_Response>>>;
  /** update data of the table: "review_invitation_templates" */
  update_review_invitation_templates?: Maybe<Review_Invitation_Templates_Mutation_Response>;
  /** update single row of the table: "review_invitation_templates" */
  update_review_invitation_templates_by_pk?: Maybe<Review_Invitation_Templates>;
  /** update multiples rows of table: "review_invitation_templates" */
  update_review_invitation_templates_many?: Maybe<Array<Maybe<Review_Invitation_Templates_Mutation_Response>>>;
  /** update data of the table: "reviews" */
  update_reviews?: Maybe<Reviews_Mutation_Response>;
  /** update single row of the table: "reviews" */
  update_reviews_by_pk?: Maybe<Reviews>;
  /** update multiples rows of table: "reviews" */
  update_reviews_many?: Maybe<Array<Maybe<Reviews_Mutation_Response>>>;
  /** update data of the table: "smart_lists" */
  update_smart_lists?: Maybe<Smart_Lists_Mutation_Response>;
  /** update single row of the table: "smart_lists" */
  update_smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** update multiples rows of table: "smart_lists" */
  update_smart_lists_many?: Maybe<Array<Maybe<Smart_Lists_Mutation_Response>>>;
  /** update data of the table: "subscriptions" */
  update_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** update single row of the table: "subscriptions" */
  update_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** update multiples rows of table: "subscriptions" */
  update_subscriptions_many?: Maybe<Array<Maybe<Subscriptions_Mutation_Response>>>;
  /** update data of the table: "teams" */
  update_teams?: Maybe<Teams_Mutation_Response>;
  /** update single row of the table: "teams" */
  update_teams_by_pk?: Maybe<Teams>;
  /** update multiples rows of table: "teams" */
  update_teams_many?: Maybe<Array<Maybe<Teams_Mutation_Response>>>;
  /** update data of the table: "teams_portals" */
  update_teams_portals?: Maybe<Teams_Portals_Mutation_Response>;
  /** update single row of the table: "teams_portals" */
  update_teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** update multiples rows of table: "teams_portals" */
  update_teams_portals_many?: Maybe<Array<Maybe<Teams_Portals_Mutation_Response>>>;
  /** update data of the table: "teams_users" */
  update_teams_users?: Maybe<Teams_Users_Mutation_Response>;
  /** update multiples rows of table: "teams_users" */
  update_teams_users_many?: Maybe<Array<Maybe<Teams_Users_Mutation_Response>>>;
  /** update data of the table: "tenants" */
  update_tenants?: Maybe<Tenants_Mutation_Response>;
  /** update single row of the table: "tenants" */
  update_tenants_by_pk?: Maybe<Tenants>;
  /** update multiples rows of table: "tenants" */
  update_tenants_many?: Maybe<Array<Maybe<Tenants_Mutation_Response>>>;
  /** Email signature + From display name; self-scoped for agents, tenant-scoped target for tenant_admin/super_admin (rule lives in the handler) */
  update_user_email_preferences?: Maybe<UpdateUserEmailPreferencesOutput>;
  /** update data of the table: "user_images" */
  update_user_images?: Maybe<User_Images_Mutation_Response>;
  /** update single row of the table: "user_images" */
  update_user_images_by_pk?: Maybe<User_Images>;
  /** update multiples rows of table: "user_images" */
  update_user_images_many?: Maybe<Array<Maybe<User_Images_Mutation_Response>>>;
  /** update data of the table: "user_notification_preferences" */
  update_user_notification_preferences?: Maybe<User_Notification_Preferences_Mutation_Response>;
  /** update single row of the table: "user_notification_preferences" */
  update_user_notification_preferences_by_pk?: Maybe<User_Notification_Preferences>;
  /** update multiples rows of table: "user_notification_preferences" */
  update_user_notification_preferences_many?: Maybe<Array<Maybe<User_Notification_Preferences_Mutation_Response>>>;
  update_user_permission_flags?: Maybe<UpdateUserPermissionFlagsOutput>;
  /** update data of the table: "user_product_experiences" */
  update_user_product_experiences?: Maybe<User_Product_Experiences_Mutation_Response>;
  /** update single row of the table: "user_product_experiences" */
  update_user_product_experiences_by_pk?: Maybe<User_Product_Experiences>;
  /** update multiples rows of table: "user_product_experiences" */
  update_user_product_experiences_many?: Maybe<Array<Maybe<User_Product_Experiences_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update data of the table: "users_listings" */
  update_users_listings?: Maybe<Users_Listings_Mutation_Response>;
  /** update single row of the table: "users_listings" */
  update_users_listings_by_pk?: Maybe<Users_Listings>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** update data of the table: "webhook_subscriptions" */
  update_webhook_subscriptions?: Maybe<Webhook_Subscriptions_Mutation_Response>;
  /** update single row of the table: "webhook_subscriptions" */
  update_webhook_subscriptions_by_pk?: Maybe<Webhook_Subscriptions>;
  /** update multiples rows of table: "webhook_subscriptions" */
  update_webhook_subscriptions_many?: Maybe<Array<Maybe<Webhook_Subscriptions_Mutation_Response>>>;
  /** execute VOLATILE function "upsert_mls_share_criteria" which returns "mls_shares" */
  upsert_mls_share_criteria: Array<Mls_Shares>;
  upsert_valuation_link?: Maybe<ValuationLinkOutput>;
  validate_webhook_url?: Maybe<ValidateWebhookUrlOutput>;
  value_property?: Maybe<ValuePropertyOutput>;
};


/** mutation root */
export type Mutation_RootActivate_Property_Image_VersionArgs = {
  args: Activate_Property_Image_Version_Args;
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootApply_Notification_Channels_To_Existing_UsersArgs = {
  args: Apply_Notification_Channels_To_Existing_Users_Args;
  distinct_on?: InputMaybe<Array<Notification_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Settings_Order_By>>;
  where?: InputMaybe<Notification_Settings_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootAuto_Search_PoisArgs = {
  property_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootBlock_Fsbo_UsersArgs = {
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  user_ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootBootstrap_Onboarding_AgencyArgs = {
  address: AgencySetupAddressInput;
  team_name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootBulk_Reassign_User_Account_ManagerArgs = {
  args: Bulk_Reassign_User_Account_Manager_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootClaim_AgencyArgs = {
  team_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootClaim_LeadArgs = {
  broker_id: Scalars['uuid']['input'];
  id: Scalars['uuid']['input'];
  should_create_call_activity?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootComplete_Full_OnboardingArgs = {
  active_since?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<AgencySetupAddressInput>;
  agent_active_since?: InputMaybe<Scalars['Int']['input']>;
  agent_certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  agent_description?: InputMaybe<Scalars['String']['input']>;
  agent_facebook_profile?: InputMaybe<Scalars['String']['input']>;
  agent_first_name?: InputMaybe<Scalars['String']['input']>;
  agent_instagram_profile?: InputMaybe<Scalars['String']['input']>;
  agent_languages?: InputMaybe<Array<Scalars['String']['input']>>;
  agent_last_name?: InputMaybe<Scalars['String']['input']>;
  agent_linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  agent_services?: InputMaybe<Array<Scalars['String']['input']>>;
  agent_tiktok_profile?: InputMaybe<Scalars['String']['input']>;
  agent_user_image_id?: InputMaybe<Scalars['uuid']['input']>;
  agent_x_profile?: InputMaybe<Scalars['String']['input']>;
  agent_youtube_profile?: InputMaybe<Scalars['String']['input']>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<Array<OnboardingInvitationInput>>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  team_name: Scalars['String']['input'];
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  x_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootComposite_Watermark_ImagesArgs = {
  lot_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootContact_Prospection_LeadArgs = {
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead_id: Scalars['uuid']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootCreate_Buyer_LeadArgs = {
  object: CreateBuyerLeadInput;
};


/** mutation root */
export type Mutation_RootCreate_ContactArgs = {
  object: CreateContactInput;
};


/** mutation root */
export type Mutation_RootCreate_EnquiryArgs = {
  object: CreateEnquiryInput;
};


/** mutation root */
export type Mutation_RootCreate_Enquiry_Buyer_LeadArgs = {
  enquiryId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootCreate_KeyArgs = {
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  partnerName: Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** mutation root */
export type Mutation_RootCreate_Marketplace_ConversationArgs = {
  country_code: Scalars['String']['input'];
  listing_id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootCreate_Property_SearchArgs = {
  object: CreatePropertySearchInput;
};


/** mutation root */
export type Mutation_RootDelete_ActivitiesArgs = {
  where: Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Activities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Activities_Target_UsersArgs = {
  where: Activities_Target_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Buyer_LeadsArgs = {
  where: Buyer_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Buyer_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Catchment_AreasArgs = {
  where: Catchment_Areas_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Catchment_Areas_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  tenant_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cma_Report_FilesArgs = {
  where: Cma_Report_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Report_Files_By_PkArgs = {
  cma_report_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cma_ReportsArgs = {
  where: Cma_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_Agent_TransactionsArgs = {
  where: Cma_Reports_Agent_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_Agent_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_ComparablesArgs = {
  where: Cma_Reports_Comparables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_Comparables_By_PkArgs = {
  aggregates_db__merged_listings_clusters_id: Scalars['bigint']['input'];
  cma_report_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_Property_TransactionsArgs = {
  where: Cma_Reports_Property_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_Property_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_User_ReviewsArgs = {
  where: Cma_Reports_User_Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cma_Reports_User_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CommissionsArgs = {
  where: Commissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Commissions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Development_CollaboratorsArgs = {
  where: Development_Collaborators_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Development_Collaborators_By_PkArgs = {
  development_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Development_FilesArgs = {
  where: Development_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Development_Files_By_PkArgs = {
  development_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Development_ImagesArgs = {
  where: Development_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Development_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Development_MappingsArgs = {
  where: Development_Mappings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Development_Mappings_By_PkArgs = {
  image_id: Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DevelopmentsArgs = {
  where: Developments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Developments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DictionariesArgs = {
  where: Dictionaries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dictionaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_Template_ThemesArgs = {
  where: Doc_Template_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Template_Themes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_Template_Themes_TeamsArgs = {
  where: Doc_Template_Themes_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Template_Themes_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_Template_Themes_TenantsArgs = {
  where: Doc_Template_Themes_Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Template_Themes_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_TemplatesArgs = {
  where: Doc_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_TeamsArgs = {
  where: Doc_Templates_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_TenantsArgs = {
  where: Doc_Templates_Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Doc_Templates_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_SequencesArgs = {
  where: Email_Sequences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_RecipientsArgs = {
  where: Email_Sequences_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_StepsArgs = {
  where: Email_Sequences_Steps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Sequences_Steps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_TemplatesArgs = {
  where: Email_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Email_Templates_FilesArgs = {
  where: Email_Templates_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Templates_Files_By_PkArgs = {
  email_template_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EmailsArgs = {
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Emails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EnquiriesArgs = {
  where: Enquiries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Enquiries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FilesArgs = {
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Files_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Google_ReviewsArgs = {
  where: Google_Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Google_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ImagesArgs = {
  where: Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_KeyArgs = {
  partnerId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lead_AgentsArgs = {
  where: Lead_Agents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lead_StagesArgs = {
  where: Lead_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lead_Stages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LeadsArgs = {
  where: Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Leads_TagsArgs = {
  where: Leads_Tags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Leads_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Legacy_KeyArgs = {
  partnerId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Lot_SellersArgs = {
  where: Lot_Sellers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lot_Sellers_By_PkArgs = {
  lot_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_LotsArgs = {
  where: Lots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Lots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Marketplace_ConversationArgs = {
  conversation_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mls_Listing_Enquiry_SettingsArgs = {
  where: Mls_Listing_Enquiry_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mls_Listing_Enquiry_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Mls_SharesArgs = {
  where: Mls_Shares_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Mls_Shares_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Notification_SettingsArgs = {
  where: Notification_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Notification_Settings_By_PkArgs = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OffersArgs = {
  where: Offers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Offers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_ImagesArgs = {
  where: Organisation_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_OrganisationsArgs = {
  where: Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Phone_NumbersArgs = {
  where: Phone_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Phone_Numbers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PipelinesArgs = {
  where: Pipelines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pipelines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PortalsArgs = {
  where: Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_FilesArgs = {
  where: Property_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Files_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  property_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_ImagesArgs = {
  where: Property_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_PoisArgs = {
  where: Property_Pois_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Pois_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_SearchesArgs = {
  where: Property_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Searches_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Searches_PlacesArgs = {
  where: Property_Searches_Places_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Searches_Places_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_search_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Searches_Property_TypesArgs = {
  where: Property_Searches_Property_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Searches_Property_Types_By_PkArgs = {
  property_search_id: Scalars['uuid']['input'];
  property_type_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_TransactionsArgs = {
  where: Property_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Property_Transactions_ListingsArgs = {
  where: Property_Transactions_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Property_Transactions_Listings_By_PkArgs = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Prospection_Contact_Message_TemplatesArgs = {
  where: Prospection_Contact_Message_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prospection_Contact_Message_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Prospection_Contact_TeamsArgs = {
  where: Prospection_Contact_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prospection_Contact_Teams_By_PkArgs = {
  team_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Prospection_MarksArgs = {
  where: Prospection_Marks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Prospection_Marks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Push_Notification_TokensArgs = {
  where: Push_Notification_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Push_Notification_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Review_Invitation_TemplatesArgs = {
  where: Review_Invitation_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_Invitation_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReviewsArgs = {
  where: Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Smart_ListsArgs = {
  where: Smart_Lists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Smart_Lists_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Team_ImagesArgs = {
  where: Team_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Team_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Team_ThemeArgs = {
  document_id: Scalars['uuid']['input'];
  document_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TeamsArgs = {
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_PortalsArgs = {
  where: Teams_Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Teams_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Teams_UsersArgs = {
  where: Teams_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_BuyersArgs = {
  where: Transaction_Buyers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_Buyers_By_PkArgs = {
  transaction_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Transaction_SellersArgs = {
  where: Transaction_Sellers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Transaction_Sellers_By_PkArgs = {
  transaction_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserArgs = {
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_ImagesArgs = {
  where: User_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_User_Product_ExperiencesArgs = {
  where: User_Product_Experiences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Product_Experiences_By_PkArgs = {
  key: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Users_ListingsArgs = {
  where: Users_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_Listings_By_PkArgs = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Webhook_SubscriptionsArgs = {
  where: Webhook_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Webhook_Subscriptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Webhook_Subscriptions_Event_TypesArgs = {
  where: Webhook_Subscriptions_Event_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Webhook_Subscriptions_Event_Types_By_PkArgs = {
  event_type: Scalars['String']['input'];
  webhook_subscription_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootEnhance_ImageArgs = {
  aspect_ratio?: InputMaybe<Scalars['String']['input']>;
  image_size?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  source_image_data: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootGenerateLeadSummaryArgs = {
  lead_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootGenerate_Cma_ReportArgs = {
  lead_id: Scalars['uuid']['input'];
  source: Cma_Report_Source_Enum_Enum;
};


/** mutation root */
export type Mutation_RootGet_Property_DistancesArgs = {
  property_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootImport_Buyer_LeadsArgs = {
  objects: Array<BuyerLeadImportInput>;
};


/** mutation root */
export type Mutation_RootImport_LotsArgs = {
  development_id?: InputMaybe<Scalars['uuid']['input']>;
  objects: Array<LotImportInput>;
};


/** mutation root */
export type Mutation_RootImport_Portal_ListingsArgs = {
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  dry_run: Scalars['Boolean']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  portal_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootImport_Property_SearchesArgs = {
  objects: Array<PropertySearchImportInput>;
};


/** mutation root */
export type Mutation_RootImport_UsersArgs = {
  objects: Array<UserImportInput>;
};


/** mutation root */
export type Mutation_RootInsert_ActivitiesArgs = {
  objects: Array<Activities_Insert_Input>;
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activities_OneArgs = {
  object: Activities_Insert_Input;
  on_conflict?: InputMaybe<Activities_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activities_Target_UsersArgs = {
  objects: Array<Activities_Target_Users_Insert_Input>;
  on_conflict?: InputMaybe<Activities_Target_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Activities_Target_Users_OneArgs = {
  object: Activities_Target_Users_Insert_Input;
  on_conflict?: InputMaybe<Activities_Target_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_LeadsArgs = {
  objects: Array<Buyer_Leads_Insert_Input>;
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Buyer_Leads_OneArgs = {
  object: Buyer_Leads_Insert_Input;
  on_conflict?: InputMaybe<Buyer_Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Catchment_AreasArgs = {
  objects: Array<Catchment_Areas_Insert_Input>;
  on_conflict?: InputMaybe<Catchment_Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Catchment_Areas_OneArgs = {
  object: Catchment_Areas_Insert_Input;
  on_conflict?: InputMaybe<Catchment_Areas_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Report_FilesArgs = {
  objects: Array<Cma_Report_Files_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Report_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Report_Files_OneArgs = {
  object: Cma_Report_Files_Insert_Input;
  on_conflict?: InputMaybe<Cma_Report_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_ReportsArgs = {
  objects: Array<Cma_Reports_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_Agent_TransactionsArgs = {
  objects: Array<Cma_Reports_Agent_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Reports_Agent_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_Agent_Transactions_OneArgs = {
  object: Cma_Reports_Agent_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Cma_Reports_Agent_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_ComparablesArgs = {
  objects: Array<Cma_Reports_Comparables_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Reports_Comparables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_Comparables_OneArgs = {
  object: Cma_Reports_Comparables_Insert_Input;
  on_conflict?: InputMaybe<Cma_Reports_Comparables_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_OneArgs = {
  object: Cma_Reports_Insert_Input;
  on_conflict?: InputMaybe<Cma_Reports_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_Property_TransactionsArgs = {
  objects: Array<Cma_Reports_Property_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Reports_Property_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_Property_Transactions_OneArgs = {
  object: Cma_Reports_Property_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Cma_Reports_Property_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_User_ReviewsArgs = {
  objects: Array<Cma_Reports_User_Reviews_Insert_Input>;
  on_conflict?: InputMaybe<Cma_Reports_User_Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cma_Reports_User_Reviews_OneArgs = {
  object: Cma_Reports_User_Reviews_Insert_Input;
  on_conflict?: InputMaybe<Cma_Reports_User_Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CommissionsArgs = {
  objects: Array<Commissions_Insert_Input>;
  on_conflict?: InputMaybe<Commissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Commissions_OneArgs = {
  object: Commissions_Insert_Input;
  on_conflict?: InputMaybe<Commissions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_CollaboratorsArgs = {
  objects: Array<Development_Collaborators_Insert_Input>;
  on_conflict?: InputMaybe<Development_Collaborators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_Collaborators_OneArgs = {
  object: Development_Collaborators_Insert_Input;
  on_conflict?: InputMaybe<Development_Collaborators_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_FilesArgs = {
  objects: Array<Development_Files_Insert_Input>;
  on_conflict?: InputMaybe<Development_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_Files_OneArgs = {
  object: Development_Files_Insert_Input;
  on_conflict?: InputMaybe<Development_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_ImagesArgs = {
  objects: Array<Development_Images_Insert_Input>;
  on_conflict?: InputMaybe<Development_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_Images_OneArgs = {
  object: Development_Images_Insert_Input;
  on_conflict?: InputMaybe<Development_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_MappingsArgs = {
  objects: Array<Development_Mappings_Insert_Input>;
  on_conflict?: InputMaybe<Development_Mappings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Development_Mappings_OneArgs = {
  object: Development_Mappings_Insert_Input;
  on_conflict?: InputMaybe<Development_Mappings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DevelopmentsArgs = {
  objects: Array<Developments_Insert_Input>;
  on_conflict?: InputMaybe<Developments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Developments_OneArgs = {
  object: Developments_Insert_Input;
  on_conflict?: InputMaybe<Developments_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_DictionariesArgs = {
  objects: Array<Dictionaries_Insert_Input>;
  on_conflict?: InputMaybe<Dictionaries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dictionaries_OneArgs = {
  object: Dictionaries_Insert_Input;
  on_conflict?: InputMaybe<Dictionaries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Template_ThemesArgs = {
  objects: Array<Doc_Template_Themes_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Template_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Template_Themes_OneArgs = {
  object: Doc_Template_Themes_Insert_Input;
  on_conflict?: InputMaybe<Doc_Template_Themes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Template_Themes_TeamsArgs = {
  objects: Array<Doc_Template_Themes_Teams_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Template_Themes_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Template_Themes_Teams_OneArgs = {
  object: Doc_Template_Themes_Teams_Insert_Input;
  on_conflict?: InputMaybe<Doc_Template_Themes_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Template_Themes_TenantsArgs = {
  objects: Array<Doc_Template_Themes_Tenants_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Template_Themes_Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Template_Themes_Tenants_OneArgs = {
  object: Doc_Template_Themes_Tenants_Insert_Input;
  on_conflict?: InputMaybe<Doc_Template_Themes_Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_TemplatesArgs = {
  objects: Array<Doc_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_OneArgs = {
  object: Doc_Templates_Insert_Input;
  on_conflict?: InputMaybe<Doc_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_TeamsArgs = {
  objects: Array<Doc_Templates_Teams_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Templates_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_Teams_OneArgs = {
  object: Doc_Templates_Teams_Insert_Input;
  on_conflict?: InputMaybe<Doc_Templates_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_TenantsArgs = {
  objects: Array<Doc_Templates_Tenants_Insert_Input>;
  on_conflict?: InputMaybe<Doc_Templates_Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Doc_Templates_Tenants_OneArgs = {
  object: Doc_Templates_Tenants_Insert_Input;
  on_conflict?: InputMaybe<Doc_Templates_Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_SequencesArgs = {
  objects: Array<Email_Sequences_Insert_Input>;
  on_conflict?: InputMaybe<Email_Sequences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_OneArgs = {
  object: Email_Sequences_Insert_Input;
  on_conflict?: InputMaybe<Email_Sequences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_RecipientsArgs = {
  objects: Array<Email_Sequences_Recipients_Insert_Input>;
  on_conflict?: InputMaybe<Email_Sequences_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_Recipients_OneArgs = {
  object: Email_Sequences_Recipients_Insert_Input;
  on_conflict?: InputMaybe<Email_Sequences_Recipients_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_StepsArgs = {
  objects: Array<Email_Sequences_Steps_Insert_Input>;
  on_conflict?: InputMaybe<Email_Sequences_Steps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Sequences_Steps_OneArgs = {
  object: Email_Sequences_Steps_Insert_Input;
  on_conflict?: InputMaybe<Email_Sequences_Steps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_TemplatesArgs = {
  objects: Array<Email_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Templates_FilesArgs = {
  objects: Array<Email_Templates_Files_Insert_Input>;
  on_conflict?: InputMaybe<Email_Templates_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Templates_Files_OneArgs = {
  object: Email_Templates_Files_Insert_Input;
  on_conflict?: InputMaybe<Email_Templates_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Templates_OneArgs = {
  object: Email_Templates_Insert_Input;
  on_conflict?: InputMaybe<Email_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EmailsArgs = {
  objects: Array<Emails_Insert_Input>;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Emails_OneArgs = {
  object: Emails_Insert_Input;
  on_conflict?: InputMaybe<Emails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_EnquiriesArgs = {
  objects: Array<Enquiries_Insert_Input>;
  on_conflict?: InputMaybe<Enquiries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Enquiries_OneArgs = {
  object: Enquiries_Insert_Input;
  on_conflict?: InputMaybe<Enquiries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_FilesArgs = {
  objects: Array<Files_Insert_Input>;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Files_OneArgs = {
  object: Files_Insert_Input;
  on_conflict?: InputMaybe<Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Google_AddressesArgs = {
  objects: Array<Google_Addresses_Insert_Input>;
  on_conflict?: InputMaybe<Google_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Google_Addresses_OneArgs = {
  object: Google_Addresses_Insert_Input;
  on_conflict?: InputMaybe<Google_Addresses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ImagesArgs = {
  objects: Array<Images_Insert_Input>;
  on_conflict?: InputMaybe<Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Images_OneArgs = {
  object: Images_Insert_Input;
  on_conflict?: InputMaybe<Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_InvitationsArgs = {
  objects: Array<Invitations_Insert_Input>;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Invitations_OneArgs = {
  object: Invitations_Insert_Input;
  on_conflict?: InputMaybe<Invitations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_AgentsArgs = {
  objects: Array<Lead_Agents_Insert_Input>;
  on_conflict?: InputMaybe<Lead_Agents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Agents_OneArgs = {
  object: Lead_Agents_Insert_Input;
  on_conflict?: InputMaybe<Lead_Agents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_StagesArgs = {
  objects: Array<Lead_Stages_Insert_Input>;
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lead_Stages_OneArgs = {
  object: Lead_Stages_Insert_Input;
  on_conflict?: InputMaybe<Lead_Stages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LeadsArgs = {
  objects: Array<Leads_Insert_Input>;
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Leads_OneArgs = {
  object: Leads_Insert_Input;
  on_conflict?: InputMaybe<Leads_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Leads_TagsArgs = {
  objects: Array<Leads_Tags_Insert_Input>;
  on_conflict?: InputMaybe<Leads_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Leads_Tags_OneArgs = {
  object: Leads_Tags_Insert_Input;
  on_conflict?: InputMaybe<Leads_Tags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_Reference_AliasesArgs = {
  objects: Array<Lot_Reference_Aliases_Insert_Input>;
  on_conflict?: InputMaybe<Lot_Reference_Aliases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_Reference_Aliases_OneArgs = {
  object: Lot_Reference_Aliases_Insert_Input;
  on_conflict?: InputMaybe<Lot_Reference_Aliases_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_SellersArgs = {
  objects: Array<Lot_Sellers_Insert_Input>;
  on_conflict?: InputMaybe<Lot_Sellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lot_Sellers_OneArgs = {
  object: Lot_Sellers_Insert_Input;
  on_conflict?: InputMaybe<Lot_Sellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_LotsArgs = {
  objects: Array<Lots_Insert_Input>;
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Lots_DerivedArgs = {
  lot: InsertListingLotsInsertInput;
  marketing_metadata?: InputMaybe<LotMarketingMetadataInput>;
  uploadMedias?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootInsert_Lots_OneArgs = {
  object: Lots_Insert_Input;
  on_conflict?: InputMaybe<Lots_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mls_Listing_Enquiry_SettingsArgs = {
  objects: Array<Mls_Listing_Enquiry_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Mls_Listing_Enquiry_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mls_Listing_Enquiry_Settings_OneArgs = {
  object: Mls_Listing_Enquiry_Settings_Insert_Input;
  on_conflict?: InputMaybe<Mls_Listing_Enquiry_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mls_SettingsArgs = {
  objects: Array<Mls_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Mls_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mls_Settings_OneArgs = {
  object: Mls_Settings_Insert_Input;
  on_conflict?: InputMaybe<Mls_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mls_SharesArgs = {
  objects: Array<Mls_Shares_Insert_Input>;
  on_conflict?: InputMaybe<Mls_Shares_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Mls_Shares_OneArgs = {
  object: Mls_Shares_Insert_Input;
  on_conflict?: InputMaybe<Mls_Shares_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_SettingsArgs = {
  objects: Array<Notification_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Notification_Settings_OneArgs = {
  object: Notification_Settings_Insert_Input;
  on_conflict?: InputMaybe<Notification_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OffersArgs = {
  objects: Array<Offers_Insert_Input>;
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Offers_OneArgs = {
  object: Offers_Insert_Input;
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_ImagesArgs = {
  objects: Array<Organisation_Images_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Images_OneArgs = {
  object: Organisation_Images_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganisationsArgs = {
  objects: Array<Organisations_Insert_Input>;
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisations_OneArgs = {
  object: Organisations_Insert_Input;
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Number_Type_EnumArgs = {
  objects: Array<Phone_Number_Type_Enum_Insert_Input>;
  on_conflict?: InputMaybe<Phone_Number_Type_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Number_Type_Enum_OneArgs = {
  object: Phone_Number_Type_Enum_Insert_Input;
  on_conflict?: InputMaybe<Phone_Number_Type_Enum_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_NumbersArgs = {
  objects: Array<Phone_Numbers_Insert_Input>;
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Phone_Numbers_OneArgs = {
  object: Phone_Numbers_Insert_Input;
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PipelinesArgs = {
  objects: Array<Pipelines_Insert_Input>;
  on_conflict?: InputMaybe<Pipelines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pipelines_OneArgs = {
  object: Pipelines_Insert_Input;
  on_conflict?: InputMaybe<Pipelines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pois_OneArgs = {
  input: InsertPoisOneInput;
};


/** mutation root */
export type Mutation_RootInsert_Portal_ListingsArgs = {
  objects: Array<Portal_Listings_Insert_Input>;
  on_conflict?: InputMaybe<Portal_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Portal_Listings_OneArgs = {
  object: Portal_Listings_Insert_Input;
  on_conflict?: InputMaybe<Portal_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PortalsArgs = {
  objects: Array<Portals_Insert_Input>;
  on_conflict?: InputMaybe<Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Portals_OneArgs = {
  object: Portals_Insert_Input;
  on_conflict?: InputMaybe<Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PropertiesArgs = {
  objects: Array<Properties_Insert_Input>;
  on_conflict?: InputMaybe<Properties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Properties_OneArgs = {
  object: Properties_Insert_Input;
  on_conflict?: InputMaybe<Properties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_FilesArgs = {
  objects: Array<Property_Files_Insert_Input>;
  on_conflict?: InputMaybe<Property_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Files_OneArgs = {
  object: Property_Files_Insert_Input;
  on_conflict?: InputMaybe<Property_Files_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_ImagesArgs = {
  objects: Array<Property_Images_Insert_Input>;
  on_conflict?: InputMaybe<Property_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Images_OneArgs = {
  object: Property_Images_Insert_Input;
  on_conflict?: InputMaybe<Property_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_SearchesArgs = {
  objects: Array<Property_Searches_Insert_Input>;
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_EnquiriesArgs = {
  objects: Array<Property_Searches_Enquiries_Insert_Input>;
  on_conflict?: InputMaybe<Property_Searches_Enquiries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_Enquiries_OneArgs = {
  object: Property_Searches_Enquiries_Insert_Input;
  on_conflict?: InputMaybe<Property_Searches_Enquiries_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_OneArgs = {
  object: Property_Searches_Insert_Input;
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_PlacesArgs = {
  objects: Array<Property_Searches_Places_Insert_Input>;
  on_conflict?: InputMaybe<Property_Searches_Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_Places_OneArgs = {
  object: Property_Searches_Places_Insert_Input;
  on_conflict?: InputMaybe<Property_Searches_Places_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_Property_TypesArgs = {
  objects: Array<Property_Searches_Property_Types_Insert_Input>;
  on_conflict?: InputMaybe<Property_Searches_Property_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Searches_Property_Types_OneArgs = {
  object: Property_Searches_Property_Types_Insert_Input;
  on_conflict?: InputMaybe<Property_Searches_Property_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_TransactionsArgs = {
  objects: Array<Property_Transactions_Insert_Input>;
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Transactions_ListingsArgs = {
  objects: Array<Property_Transactions_Listings_Insert_Input>;
  on_conflict?: InputMaybe<Property_Transactions_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Transactions_Listings_OneArgs = {
  object: Property_Transactions_Listings_Insert_Input;
  on_conflict?: InputMaybe<Property_Transactions_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Property_Transactions_OneArgs = {
  object: Property_Transactions_Insert_Input;
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_Contact_Message_TemplatesArgs = {
  objects: Array<Prospection_Contact_Message_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Prospection_Contact_Message_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_Contact_Message_Templates_OneArgs = {
  object: Prospection_Contact_Message_Templates_Insert_Input;
  on_conflict?: InputMaybe<Prospection_Contact_Message_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_Contact_SettingsArgs = {
  objects: Array<Prospection_Contact_Settings_Insert_Input>;
  on_conflict?: InputMaybe<Prospection_Contact_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_Contact_Settings_OneArgs = {
  object: Prospection_Contact_Settings_Insert_Input;
  on_conflict?: InputMaybe<Prospection_Contact_Settings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_Contact_TeamsArgs = {
  objects: Array<Prospection_Contact_Teams_Insert_Input>;
  on_conflict?: InputMaybe<Prospection_Contact_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_Contact_Teams_OneArgs = {
  object: Prospection_Contact_Teams_Insert_Input;
  on_conflict?: InputMaybe<Prospection_Contact_Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_MarksArgs = {
  objects: Array<Prospection_Marks_Insert_Input>;
  on_conflict?: InputMaybe<Prospection_Marks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Prospection_Marks_OneArgs = {
  object: Prospection_Marks_Insert_Input;
  on_conflict?: InputMaybe<Prospection_Marks_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Notification_TokensArgs = {
  objects: Array<Push_Notification_Tokens_Insert_Input>;
  on_conflict?: InputMaybe<Push_Notification_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Push_Notification_Tokens_OneArgs = {
  object: Push_Notification_Tokens_Insert_Input;
  on_conflict?: InputMaybe<Push_Notification_Tokens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_Invitation_TemplatesArgs = {
  objects: Array<Review_Invitation_Templates_Insert_Input>;
  on_conflict?: InputMaybe<Review_Invitation_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_Invitation_Templates_OneArgs = {
  object: Review_Invitation_Templates_Insert_Input;
  on_conflict?: InputMaybe<Review_Invitation_Templates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReviewsArgs = {
  objects: Array<Reviews_Insert_Input>;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Reviews_OneArgs = {
  object: Reviews_Insert_Input;
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_ListsArgs = {
  objects: Array<Smart_Lists_Insert_Input>;
  on_conflict?: InputMaybe<Smart_Lists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Smart_Lists_OneArgs = {
  object: Smart_Lists_Insert_Input;
  on_conflict?: InputMaybe<Smart_Lists_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_ImagesArgs = {
  objects: Array<Team_Images_Insert_Input>;
  on_conflict?: InputMaybe<Team_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Team_Images_OneArgs = {
  object: Team_Images_Insert_Input;
  on_conflict?: InputMaybe<Team_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TeamsArgs = {
  objects: Array<Teams_Insert_Input>;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_OneArgs = {
  object: Teams_Insert_Input;
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_PortalsArgs = {
  objects: Array<Teams_Portals_Insert_Input>;
  on_conflict?: InputMaybe<Teams_Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_Portals_OneArgs = {
  object: Teams_Portals_Insert_Input;
  on_conflict?: InputMaybe<Teams_Portals_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_UsersArgs = {
  objects: Array<Teams_Users_Insert_Input>;
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Teams_Users_OneArgs = {
  object: Teams_Users_Insert_Input;
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_BuyersArgs = {
  objects: Array<Transaction_Buyers_Insert_Input>;
  on_conflict?: InputMaybe<Transaction_Buyers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Buyers_OneArgs = {
  object: Transaction_Buyers_Insert_Input;
  on_conflict?: InputMaybe<Transaction_Buyers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_SellersArgs = {
  objects: Array<Transaction_Sellers_Insert_Input>;
  on_conflict?: InputMaybe<Transaction_Sellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Transaction_Sellers_OneArgs = {
  object: Transaction_Sellers_Insert_Input;
  on_conflict?: InputMaybe<Transaction_Sellers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_ImagesArgs = {
  objects: Array<User_Images_Insert_Input>;
  on_conflict?: InputMaybe<User_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Images_OneArgs = {
  object: User_Images_Insert_Input;
  on_conflict?: InputMaybe<User_Images_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Notification_PreferencesArgs = {
  objects: Array<User_Notification_Preferences_Insert_Input>;
  on_conflict?: InputMaybe<User_Notification_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Notification_Preferences_OneArgs = {
  object: User_Notification_Preferences_Insert_Input;
  on_conflict?: InputMaybe<User_Notification_Preferences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Product_ExperiencesArgs = {
  objects: Array<User_Product_Experiences_Insert_Input>;
  on_conflict?: InputMaybe<User_Product_Experiences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Product_Experiences_OneArgs = {
  object: User_Product_Experiences_Insert_Input;
  on_conflict?: InputMaybe<User_Product_Experiences_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_ListingsArgs = {
  objects: Array<Users_Listings_Insert_Input>;
  on_conflict?: InputMaybe<Users_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_Listings_OneArgs = {
  object: Users_Listings_Insert_Input;
  on_conflict?: InputMaybe<Users_Listings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webhook_SubscriptionsArgs = {
  objects: Array<Webhook_Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Webhook_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webhook_Subscriptions_Event_TypesArgs = {
  objects: Array<Webhook_Subscriptions_Event_Types_Insert_Input>;
  on_conflict?: InputMaybe<Webhook_Subscriptions_Event_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webhook_Subscriptions_Event_Types_OneArgs = {
  object: Webhook_Subscriptions_Event_Types_Insert_Input;
  on_conflict?: InputMaybe<Webhook_Subscriptions_Event_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Webhook_Subscriptions_OneArgs = {
  object: Webhook_Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Webhook_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootManual_Search_PoisArgs = {
  property_id: Scalars['uuid']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootMark_Email_Thread_ReadArgs = {
  thread_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootMark_Listing_Publication_ImportArgs = {
  distinct_on?: InputMaybe<Array<Lot_Publication_History_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Publication_History_Result_Order_By>>;
  where?: InputMaybe<Lot_Publication_History_Result_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootMark_Marketplace_Conversation_ReadArgs = {
  conversation_id: Scalars['uuid']['input'];
  last_seen_message_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootMerge_UserArgs = {
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  left_user_id: Scalars['uuid']['input'];
  primary_email?: InputMaybe<Scalars['String']['input']>;
  resolve_enquiries?: InputMaybe<Scalars['Boolean']['input']>;
  right_user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootPrepare_UploadArgs = {
  file_name: Scalars['String']['input'];
  file_type: Scalars['String']['input'];
  id: Scalars['String']['input'];
  mime_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootProperty_AppraisalArgs = {
  object: PropertyAppraisalInput;
};


/** mutation root */
export type Mutation_RootRefuse_LeadArgs = {
  broker_id: Scalars['uuid']['input'];
  id: Scalars['uuid']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootRequestMyHomeAppraisalArgs = {
  agentId: Scalars['uuid']['input'];
  attribution?: InputMaybe<MyHomeAttributionInput>;
  leadId: Scalars['uuid']['input'];
  originPlatform: MyHomeOriginPlatform;
  requestId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootReset_Cma_Market_Comparison_PlacesArgs = {
  args: Reset_Cma_Market_Comparison_Places_Args;
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootSave_Onboarding_ProgressArgs = {
  input: SaveOnboardingProgressInput;
};


/** mutation root */
export type Mutation_RootSave_Property_Image_VersionArgs = {
  args: Save_Property_Image_Version_Args;
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootSave_Team_ThemeArgs = {
  allow_shared: Scalars['Boolean']['input'];
  apply_to?: InputMaybe<Array<Scalars['uuid']['input']>>;
  content: Scalars['String']['input'];
  document_id: Scalars['uuid']['input'];
  document_type: Scalars['String']['input'];
  part?: InputMaybe<Scalars['String']['input']>;
  previous_content: Scalars['String']['input'];
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  theme_name?: InputMaybe<Scalars['String']['input']>;
};


/** mutation root */
export type Mutation_RootScrape_Google_ReviewsArgs = {
  team_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSend_Buyers_Auto_Matching_EmailArgs = {
  buyerLeadId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootSend_Marketplace_MessageArgs = {
  body: Scalars['String']['input'];
  client_message_id: Scalars['uuid']['input'];
  conversation_id: Scalars['uuid']['input'];
  origin?: InputMaybe<MarketplaceMessageClientOrigin>;
};


/** mutation root */
export type Mutation_RootSend_Slack_NotificationArgs = {
  channel: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSet_Default_TeamArgs = {
  args: Set_Default_Team_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootSet_Team_Theme_DefaultArgs = {
  document_id: Scalars['uuid']['input'];
  document_type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootSet_User_Module_GrantArgs = {
  args: Set_User_Module_Grant_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootStart_ReviewArgs = {
  address: StartReviewGoogleAddressInput;
  agent_id: Scalars['uuid']['input'];
  email_address: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  is_seller: Scalars['Boolean']['input'];
  last_name: Scalars['String']['input'];
  marketing_metadata?: InputMaybe<StartReviewMarketingMetadataInput>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  referer: Scalars['String']['input'];
  token: Scalars['String']['input'];
  transaction_date: Scalars['timestamptz']['input'];
};


/** mutation root */
export type Mutation_RootTakedown_AgencyArgs = {
  team_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootTest_WebhookArgs = {
  subscription_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootToggle_Portal_ListingArgs = {
  lot_id: Scalars['uuid']['input'];
  portal_id: Scalars['uuid']['input'];
  skip_ftp_check?: InputMaybe<Scalars['Boolean']['input']>;
};


/** mutation root */
export type Mutation_RootTracked_Document_UrlArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
  document_type?: InputMaybe<Scalars['String']['input']>;
  recipient_id?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootTranslate_Agent_ReviewArgs = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  review_id: Scalars['uuid']['input'];
  review_type: Scalars['String']['input'];
  target_language: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUnblock_Fsbo_UsersArgs = {
  user_ids: Array<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUpdate_ActivitiesArgs = {
  _set?: InputMaybe<Activities_Set_Input>;
  where: Activities_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Activities_By_PkArgs = {
  _set?: InputMaybe<Activities_Set_Input>;
  pk_columns: Activities_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Activities_ManyArgs = {
  updates: Array<Activities_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_LeadsArgs = {
  _inc?: InputMaybe<Buyer_Leads_Inc_Input>;
  _set?: InputMaybe<Buyer_Leads_Set_Input>;
  where: Buyer_Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Leads_By_PkArgs = {
  _inc?: InputMaybe<Buyer_Leads_Inc_Input>;
  _set?: InputMaybe<Buyer_Leads_Set_Input>;
  pk_columns: Buyer_Leads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Buyer_Leads_ManyArgs = {
  updates: Array<Buyer_Leads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Report_FilesArgs = {
  _inc?: InputMaybe<Cma_Report_Files_Inc_Input>;
  _set?: InputMaybe<Cma_Report_Files_Set_Input>;
  where: Cma_Report_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Report_Files_By_PkArgs = {
  _inc?: InputMaybe<Cma_Report_Files_Inc_Input>;
  _set?: InputMaybe<Cma_Report_Files_Set_Input>;
  pk_columns: Cma_Report_Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Report_Files_ManyArgs = {
  updates: Array<Cma_Report_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_ReportsArgs = {
  _append?: InputMaybe<Cma_Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Cma_Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cma_Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cma_Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Cma_Reports_Inc_Input>;
  _prepend?: InputMaybe<Cma_Reports_Prepend_Input>;
  _set?: InputMaybe<Cma_Reports_Set_Input>;
  where: Cma_Reports_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_By_PkArgs = {
  _append?: InputMaybe<Cma_Reports_Append_Input>;
  _delete_at_path?: InputMaybe<Cma_Reports_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cma_Reports_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cma_Reports_Delete_Key_Input>;
  _inc?: InputMaybe<Cma_Reports_Inc_Input>;
  _prepend?: InputMaybe<Cma_Reports_Prepend_Input>;
  _set?: InputMaybe<Cma_Reports_Set_Input>;
  pk_columns: Cma_Reports_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_ComparablesArgs = {
  _append?: InputMaybe<Cma_Reports_Comparables_Append_Input>;
  _delete_at_path?: InputMaybe<Cma_Reports_Comparables_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cma_Reports_Comparables_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cma_Reports_Comparables_Delete_Key_Input>;
  _inc?: InputMaybe<Cma_Reports_Comparables_Inc_Input>;
  _prepend?: InputMaybe<Cma_Reports_Comparables_Prepend_Input>;
  _set?: InputMaybe<Cma_Reports_Comparables_Set_Input>;
  where: Cma_Reports_Comparables_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_Comparables_By_PkArgs = {
  _append?: InputMaybe<Cma_Reports_Comparables_Append_Input>;
  _delete_at_path?: InputMaybe<Cma_Reports_Comparables_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Cma_Reports_Comparables_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Cma_Reports_Comparables_Delete_Key_Input>;
  _inc?: InputMaybe<Cma_Reports_Comparables_Inc_Input>;
  _prepend?: InputMaybe<Cma_Reports_Comparables_Prepend_Input>;
  _set?: InputMaybe<Cma_Reports_Comparables_Set_Input>;
  pk_columns: Cma_Reports_Comparables_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_Comparables_ManyArgs = {
  updates: Array<Cma_Reports_Comparables_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_ManyArgs = {
  updates: Array<Cma_Reports_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_Property_TransactionsArgs = {
  _inc?: InputMaybe<Cma_Reports_Property_Transactions_Inc_Input>;
  _set?: InputMaybe<Cma_Reports_Property_Transactions_Set_Input>;
  where: Cma_Reports_Property_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_Property_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Cma_Reports_Property_Transactions_Inc_Input>;
  _set?: InputMaybe<Cma_Reports_Property_Transactions_Set_Input>;
  pk_columns: Cma_Reports_Property_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cma_Reports_Property_Transactions_ManyArgs = {
  updates: Array<Cma_Reports_Property_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CommissionsArgs = {
  _inc?: InputMaybe<Commissions_Inc_Input>;
  _set?: InputMaybe<Commissions_Set_Input>;
  where: Commissions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Commissions_By_PkArgs = {
  _inc?: InputMaybe<Commissions_Inc_Input>;
  _set?: InputMaybe<Commissions_Set_Input>;
  pk_columns: Commissions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Commissions_ManyArgs = {
  updates: Array<Commissions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Development_ImagesArgs = {
  _inc?: InputMaybe<Development_Images_Inc_Input>;
  _set?: InputMaybe<Development_Images_Set_Input>;
  where: Development_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Development_Images_By_PkArgs = {
  _inc?: InputMaybe<Development_Images_Inc_Input>;
  _set?: InputMaybe<Development_Images_Set_Input>;
  pk_columns: Development_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Development_Images_ManyArgs = {
  updates: Array<Development_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Development_MappingsArgs = {
  _set?: InputMaybe<Development_Mappings_Set_Input>;
  where: Development_Mappings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Development_Mappings_By_PkArgs = {
  _set?: InputMaybe<Development_Mappings_Set_Input>;
  pk_columns: Development_Mappings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Development_Mappings_ManyArgs = {
  updates: Array<Development_Mappings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DevelopmentsArgs = {
  _set?: InputMaybe<Developments_Set_Input>;
  where: Developments_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Developments_By_PkArgs = {
  _set?: InputMaybe<Developments_Set_Input>;
  pk_columns: Developments_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Developments_ManyArgs = {
  updates: Array<Developments_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DictionariesArgs = {
  _inc?: InputMaybe<Dictionaries_Inc_Input>;
  _set?: InputMaybe<Dictionaries_Set_Input>;
  where: Dictionaries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dictionaries_By_PkArgs = {
  _inc?: InputMaybe<Dictionaries_Inc_Input>;
  _set?: InputMaybe<Dictionaries_Set_Input>;
  pk_columns: Dictionaries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dictionaries_ManyArgs = {
  updates: Array<Dictionaries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_ThemesArgs = {
  _set?: InputMaybe<Doc_Template_Themes_Set_Input>;
  where: Doc_Template_Themes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_By_PkArgs = {
  _set?: InputMaybe<Doc_Template_Themes_Set_Input>;
  pk_columns: Doc_Template_Themes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_ManyArgs = {
  updates: Array<Doc_Template_Themes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_TeamsArgs = {
  _set?: InputMaybe<Doc_Template_Themes_Teams_Set_Input>;
  where: Doc_Template_Themes_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_Teams_By_PkArgs = {
  _set?: InputMaybe<Doc_Template_Themes_Teams_Set_Input>;
  pk_columns: Doc_Template_Themes_Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_Teams_ManyArgs = {
  updates: Array<Doc_Template_Themes_Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_TenantsArgs = {
  _set?: InputMaybe<Doc_Template_Themes_Tenants_Set_Input>;
  where: Doc_Template_Themes_Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_Tenants_By_PkArgs = {
  _set?: InputMaybe<Doc_Template_Themes_Tenants_Set_Input>;
  pk_columns: Doc_Template_Themes_Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Template_Themes_Tenants_ManyArgs = {
  updates: Array<Doc_Template_Themes_Tenants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_TemplatesArgs = {
  _append?: InputMaybe<Doc_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Templates_Prepend_Input>;
  _set?: InputMaybe<Doc_Templates_Set_Input>;
  where: Doc_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_By_PkArgs = {
  _append?: InputMaybe<Doc_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Doc_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Doc_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Doc_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Doc_Templates_Prepend_Input>;
  _set?: InputMaybe<Doc_Templates_Set_Input>;
  pk_columns: Doc_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_ManyArgs = {
  updates: Array<Doc_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_TeamsArgs = {
  _set?: InputMaybe<Doc_Templates_Teams_Set_Input>;
  where: Doc_Templates_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_Teams_By_PkArgs = {
  _set?: InputMaybe<Doc_Templates_Teams_Set_Input>;
  pk_columns: Doc_Templates_Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_Teams_ManyArgs = {
  updates: Array<Doc_Templates_Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_TenantsArgs = {
  _set?: InputMaybe<Doc_Templates_Tenants_Set_Input>;
  where: Doc_Templates_Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_Tenants_By_PkArgs = {
  _set?: InputMaybe<Doc_Templates_Tenants_Set_Input>;
  pk_columns: Doc_Templates_Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Doc_Templates_Tenants_ManyArgs = {
  updates: Array<Doc_Templates_Tenants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_SequencesArgs = {
  _set?: InputMaybe<Email_Sequences_Set_Input>;
  where: Email_Sequences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_By_PkArgs = {
  _set?: InputMaybe<Email_Sequences_Set_Input>;
  pk_columns: Email_Sequences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_ManyArgs = {
  updates: Array<Email_Sequences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_RecipientsArgs = {
  _set?: InputMaybe<Email_Sequences_Recipients_Set_Input>;
  where: Email_Sequences_Recipients_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Recipients_By_PkArgs = {
  _set?: InputMaybe<Email_Sequences_Recipients_Set_Input>;
  pk_columns: Email_Sequences_Recipients_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Recipients_ManyArgs = {
  updates: Array<Email_Sequences_Recipients_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_StepsArgs = {
  _inc?: InputMaybe<Email_Sequences_Steps_Inc_Input>;
  _set?: InputMaybe<Email_Sequences_Steps_Set_Input>;
  where: Email_Sequences_Steps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Steps_By_PkArgs = {
  _inc?: InputMaybe<Email_Sequences_Steps_Inc_Input>;
  _set?: InputMaybe<Email_Sequences_Steps_Set_Input>;
  pk_columns: Email_Sequences_Steps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Sequences_Steps_ManyArgs = {
  updates: Array<Email_Sequences_Steps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_TemplatesArgs = {
  _append?: InputMaybe<Email_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  _set?: InputMaybe<Email_Templates_Set_Input>;
  where: Email_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Templates_By_PkArgs = {
  _append?: InputMaybe<Email_Templates_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Templates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Templates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Templates_Delete_Key_Input>;
  _prepend?: InputMaybe<Email_Templates_Prepend_Input>;
  _set?: InputMaybe<Email_Templates_Set_Input>;
  pk_columns: Email_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Templates_ManyArgs = {
  updates: Array<Email_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Thread_VisibilityArgs = {
  thread_id: Scalars['uuid']['input'];
  visibility: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_EmailsArgs = {
  _set?: InputMaybe<Emails_Set_Input>;
  where: Emails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_By_PkArgs = {
  _set?: InputMaybe<Emails_Set_Input>;
  pk_columns: Emails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Emails_ManyArgs = {
  updates: Array<Emails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EnquiriesArgs = {
  _set?: InputMaybe<Enquiries_Set_Input>;
  where: Enquiries_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Enquiries_By_PkArgs = {
  _set?: InputMaybe<Enquiries_Set_Input>;
  pk_columns: Enquiries_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Enquiries_ManyArgs = {
  updates: Array<Enquiries_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_FilesArgs = {
  _set?: InputMaybe<Files_Set_Input>;
  where: Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Files_By_PkArgs = {
  _set?: InputMaybe<Files_Set_Input>;
  pk_columns: Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs = {
  updates: Array<Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_InvitationsArgs = {
  _set?: InputMaybe<Invitations_Set_Input>;
  where: Invitations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Invitations_By_PkArgs = {
  _set?: InputMaybe<Invitations_Set_Input>;
  pk_columns: Invitations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Invitations_ManyArgs = {
  updates: Array<Invitations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_KeyArgs = {
  partnerId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_AgentsArgs = {
  _inc?: InputMaybe<Lead_Agents_Inc_Input>;
  _set?: InputMaybe<Lead_Agents_Set_Input>;
  where: Lead_Agents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Agents_By_PkArgs = {
  _inc?: InputMaybe<Lead_Agents_Inc_Input>;
  _set?: InputMaybe<Lead_Agents_Set_Input>;
  pk_columns: Lead_Agents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Agents_ManyArgs = {
  updates: Array<Lead_Agents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_StagesArgs = {
  _inc?: InputMaybe<Lead_Stages_Inc_Input>;
  _set?: InputMaybe<Lead_Stages_Set_Input>;
  where: Lead_Stages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Stages_By_PkArgs = {
  _inc?: InputMaybe<Lead_Stages_Inc_Input>;
  _set?: InputMaybe<Lead_Stages_Set_Input>;
  pk_columns: Lead_Stages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lead_Stages_ManyArgs = {
  updates: Array<Lead_Stages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_LeadsArgs = {
  _inc?: InputMaybe<Leads_Inc_Input>;
  _set?: InputMaybe<Leads_Set_Input>;
  where: Leads_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Leads_By_PkArgs = {
  _inc?: InputMaybe<Leads_Inc_Input>;
  _set?: InputMaybe<Leads_Set_Input>;
  pk_columns: Leads_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Leads_ManyArgs = {
  updates: Array<Leads_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_KeyArgs = {
  partnerId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** mutation root */
export type Mutation_RootUpdate_LotsArgs = {
  _append?: InputMaybe<Lots_Append_Input>;
  _delete_at_path?: InputMaybe<Lots_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lots_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lots_Delete_Key_Input>;
  _inc?: InputMaybe<Lots_Inc_Input>;
  _prepend?: InputMaybe<Lots_Prepend_Input>;
  _set?: InputMaybe<Lots_Set_Input>;
  where: Lots_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Lots_By_PkArgs = {
  _append?: InputMaybe<Lots_Append_Input>;
  _delete_at_path?: InputMaybe<Lots_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Lots_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Lots_Delete_Key_Input>;
  _inc?: InputMaybe<Lots_Inc_Input>;
  _prepend?: InputMaybe<Lots_Prepend_Input>;
  _set?: InputMaybe<Lots_Set_Input>;
  pk_columns: Lots_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Lots_ManyArgs = {
  updates: Array<Lots_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Marketplace_Conversation_ParticipantsArgs = {
  _set?: InputMaybe<Marketplace_Conversation_Participants_Set_Input>;
  where: Marketplace_Conversation_Participants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Marketplace_Conversation_Participants_By_PkArgs = {
  _set?: InputMaybe<Marketplace_Conversation_Participants_Set_Input>;
  pk_columns: Marketplace_Conversation_Participants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Marketplace_Conversation_Participants_ManyArgs = {
  updates: Array<Marketplace_Conversation_Participants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_Listing_Enquiry_SettingsArgs = {
  _set?: InputMaybe<Mls_Listing_Enquiry_Settings_Set_Input>;
  where: Mls_Listing_Enquiry_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_Listing_Enquiry_Settings_By_PkArgs = {
  _set?: InputMaybe<Mls_Listing_Enquiry_Settings_Set_Input>;
  pk_columns: Mls_Listing_Enquiry_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_Listing_Enquiry_Settings_ManyArgs = {
  updates: Array<Mls_Listing_Enquiry_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_SettingsArgs = {
  _set?: InputMaybe<Mls_Settings_Set_Input>;
  where: Mls_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_Settings_By_PkArgs = {
  _set?: InputMaybe<Mls_Settings_Set_Input>;
  pk_columns: Mls_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_Settings_ManyArgs = {
  updates: Array<Mls_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_SharesArgs = {
  _append?: InputMaybe<Mls_Shares_Append_Input>;
  _delete_at_path?: InputMaybe<Mls_Shares_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mls_Shares_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mls_Shares_Delete_Key_Input>;
  _prepend?: InputMaybe<Mls_Shares_Prepend_Input>;
  _set?: InputMaybe<Mls_Shares_Set_Input>;
  where: Mls_Shares_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_Shares_By_PkArgs = {
  _append?: InputMaybe<Mls_Shares_Append_Input>;
  _delete_at_path?: InputMaybe<Mls_Shares_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Mls_Shares_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Mls_Shares_Delete_Key_Input>;
  _prepend?: InputMaybe<Mls_Shares_Prepend_Input>;
  _set?: InputMaybe<Mls_Shares_Set_Input>;
  pk_columns: Mls_Shares_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Mls_Shares_ManyArgs = {
  updates: Array<Mls_Shares_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_SettingsArgs = {
  _inc?: InputMaybe<Notification_Settings_Inc_Input>;
  _set?: InputMaybe<Notification_Settings_Set_Input>;
  where: Notification_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Settings_By_PkArgs = {
  _inc?: InputMaybe<Notification_Settings_Inc_Input>;
  _set?: InputMaybe<Notification_Settings_Set_Input>;
  pk_columns: Notification_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Settings_ManyArgs = {
  updates: Array<Notification_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OffersArgs = {
  _inc?: InputMaybe<Offers_Inc_Input>;
  _set?: InputMaybe<Offers_Set_Input>;
  where: Offers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_By_PkArgs = {
  _inc?: InputMaybe<Offers_Inc_Input>;
  _set?: InputMaybe<Offers_Set_Input>;
  pk_columns: Offers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Offers_ManyArgs = {
  updates: Array<Offers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_ImagesArgs = {
  _inc?: InputMaybe<Organisation_Images_Inc_Input>;
  _set?: InputMaybe<Organisation_Images_Set_Input>;
  where: Organisation_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Images_By_PkArgs = {
  _inc?: InputMaybe<Organisation_Images_Inc_Input>;
  _set?: InputMaybe<Organisation_Images_Set_Input>;
  pk_columns: Organisation_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Images_ManyArgs = {
  updates: Array<Organisation_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganisationsArgs = {
  _inc?: InputMaybe<Organisations_Inc_Input>;
  _set?: InputMaybe<Organisations_Set_Input>;
  where: Organisations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisations_By_PkArgs = {
  _inc?: InputMaybe<Organisations_Inc_Input>;
  _set?: InputMaybe<Organisations_Set_Input>;
  pk_columns: Organisations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisations_ManyArgs = {
  updates: Array<Organisations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_NumbersArgs = {
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  where: Phone_Numbers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Numbers_By_PkArgs = {
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  pk_columns: Phone_Numbers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Phone_Numbers_ManyArgs = {
  updates: Array<Phone_Numbers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PipelinesArgs = {
  _set?: InputMaybe<Pipelines_Set_Input>;
  where: Pipelines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pipelines_By_PkArgs = {
  _set?: InputMaybe<Pipelines_Set_Input>;
  pk_columns: Pipelines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pipelines_ManyArgs = {
  updates: Array<Pipelines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Portal_ListingArgs = {
  lot_id: Scalars['uuid']['input'];
  portal_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_Portal_ListingsArgs = {
  _set?: InputMaybe<Portal_Listings_Set_Input>;
  where: Portal_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Portal_Listings_By_PkArgs = {
  _set?: InputMaybe<Portal_Listings_Set_Input>;
  pk_columns: Portal_Listings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Portal_Listings_ManyArgs = {
  updates: Array<Portal_Listings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PortalsArgs = {
  _inc?: InputMaybe<Portals_Inc_Input>;
  _set?: InputMaybe<Portals_Set_Input>;
  where: Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Portals_By_PkArgs = {
  _inc?: InputMaybe<Portals_Inc_Input>;
  _set?: InputMaybe<Portals_Set_Input>;
  pk_columns: Portals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Portals_ManyArgs = {
  updates: Array<Portals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PropertiesArgs = {
  _inc?: InputMaybe<Properties_Inc_Input>;
  _set?: InputMaybe<Properties_Set_Input>;
  where: Properties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Properties_By_PkArgs = {
  _inc?: InputMaybe<Properties_Inc_Input>;
  _set?: InputMaybe<Properties_Set_Input>;
  pk_columns: Properties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Properties_ManyArgs = {
  updates: Array<Properties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_FilesArgs = {
  _inc?: InputMaybe<Property_Files_Inc_Input>;
  _set?: InputMaybe<Property_Files_Set_Input>;
  where: Property_Files_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Files_By_PkArgs = {
  _inc?: InputMaybe<Property_Files_Inc_Input>;
  _set?: InputMaybe<Property_Files_Set_Input>;
  pk_columns: Property_Files_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Files_ManyArgs = {
  updates: Array<Property_Files_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_ImagesArgs = {
  _inc?: InputMaybe<Property_Images_Inc_Input>;
  _set?: InputMaybe<Property_Images_Set_Input>;
  where: Property_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Images_By_PkArgs = {
  _inc?: InputMaybe<Property_Images_Inc_Input>;
  _set?: InputMaybe<Property_Images_Set_Input>;
  pk_columns: Property_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Images_ManyArgs = {
  updates: Array<Property_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_SearchesArgs = {
  _inc?: InputMaybe<Property_Searches_Inc_Input>;
  _set?: InputMaybe<Property_Searches_Set_Input>;
  where: Property_Searches_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Searches_By_PkArgs = {
  _inc?: InputMaybe<Property_Searches_Inc_Input>;
  _set?: InputMaybe<Property_Searches_Set_Input>;
  pk_columns: Property_Searches_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Searches_ManyArgs = {
  updates: Array<Property_Searches_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_TransactionsArgs = {
  _inc?: InputMaybe<Property_Transactions_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Set_Input>;
  where: Property_Transactions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_By_PkArgs = {
  _inc?: InputMaybe<Property_Transactions_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Set_Input>;
  pk_columns: Property_Transactions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_ListingsArgs = {
  _inc?: InputMaybe<Property_Transactions_Listings_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Listings_Set_Input>;
  where: Property_Transactions_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_Listings_By_PkArgs = {
  _inc?: InputMaybe<Property_Transactions_Listings_Inc_Input>;
  _set?: InputMaybe<Property_Transactions_Listings_Set_Input>;
  pk_columns: Property_Transactions_Listings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_Listings_ManyArgs = {
  updates: Array<Property_Transactions_Listings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Property_Transactions_ManyArgs = {
  updates: Array<Property_Transactions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_Message_TemplatesArgs = {
  _set?: InputMaybe<Prospection_Contact_Message_Templates_Set_Input>;
  where: Prospection_Contact_Message_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_Message_Templates_By_PkArgs = {
  _set?: InputMaybe<Prospection_Contact_Message_Templates_Set_Input>;
  pk_columns: Prospection_Contact_Message_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_Message_Templates_ManyArgs = {
  updates: Array<Prospection_Contact_Message_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_SettingsArgs = {
  _inc?: InputMaybe<Prospection_Contact_Settings_Inc_Input>;
  _set?: InputMaybe<Prospection_Contact_Settings_Set_Input>;
  where: Prospection_Contact_Settings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_Settings_By_PkArgs = {
  _inc?: InputMaybe<Prospection_Contact_Settings_Inc_Input>;
  _set?: InputMaybe<Prospection_Contact_Settings_Set_Input>;
  pk_columns: Prospection_Contact_Settings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_Settings_ManyArgs = {
  updates: Array<Prospection_Contact_Settings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_TeamsArgs = {
  _inc?: InputMaybe<Prospection_Contact_Teams_Inc_Input>;
  _set?: InputMaybe<Prospection_Contact_Teams_Set_Input>;
  where: Prospection_Contact_Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_Teams_By_PkArgs = {
  _inc?: InputMaybe<Prospection_Contact_Teams_Inc_Input>;
  _set?: InputMaybe<Prospection_Contact_Teams_Set_Input>;
  pk_columns: Prospection_Contact_Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Contact_Teams_ManyArgs = {
  updates: Array<Prospection_Contact_Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_MarksArgs = {
  _set?: InputMaybe<Prospection_Marks_Set_Input>;
  where: Prospection_Marks_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Marks_By_PkArgs = {
  _set?: InputMaybe<Prospection_Marks_Set_Input>;
  pk_columns: Prospection_Marks_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Prospection_Marks_ManyArgs = {
  updates: Array<Prospection_Marks_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Push_Notification_TokensArgs = {
  _set?: InputMaybe<Push_Notification_Tokens_Set_Input>;
  where: Push_Notification_Tokens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Push_Notification_Tokens_By_PkArgs = {
  _set?: InputMaybe<Push_Notification_Tokens_Set_Input>;
  pk_columns: Push_Notification_Tokens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Push_Notification_Tokens_ManyArgs = {
  updates: Array<Push_Notification_Tokens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Invitation_TemplatesArgs = {
  _set?: InputMaybe<Review_Invitation_Templates_Set_Input>;
  where: Review_Invitation_Templates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Invitation_Templates_By_PkArgs = {
  _set?: InputMaybe<Review_Invitation_Templates_Set_Input>;
  pk_columns: Review_Invitation_Templates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Review_Invitation_Templates_ManyArgs = {
  updates: Array<Review_Invitation_Templates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReviewsArgs = {
  _inc?: InputMaybe<Reviews_Inc_Input>;
  _set?: InputMaybe<Reviews_Set_Input>;
  where: Reviews_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Reviews_By_PkArgs = {
  _inc?: InputMaybe<Reviews_Inc_Input>;
  _set?: InputMaybe<Reviews_Set_Input>;
  pk_columns: Reviews_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Reviews_ManyArgs = {
  updates: Array<Reviews_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_ListsArgs = {
  _append?: InputMaybe<Smart_Lists_Append_Input>;
  _delete_at_path?: InputMaybe<Smart_Lists_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Smart_Lists_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Smart_Lists_Delete_Key_Input>;
  _prepend?: InputMaybe<Smart_Lists_Prepend_Input>;
  _set?: InputMaybe<Smart_Lists_Set_Input>;
  where: Smart_Lists_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Lists_By_PkArgs = {
  _append?: InputMaybe<Smart_Lists_Append_Input>;
  _delete_at_path?: InputMaybe<Smart_Lists_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Smart_Lists_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Smart_Lists_Delete_Key_Input>;
  _prepend?: InputMaybe<Smart_Lists_Prepend_Input>;
  _set?: InputMaybe<Smart_Lists_Set_Input>;
  pk_columns: Smart_Lists_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Smart_Lists_ManyArgs = {
  updates: Array<Smart_Lists_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionsArgs = {
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_By_PkArgs = {
  _set?: InputMaybe<Subscriptions_Set_Input>;
  pk_columns: Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_ManyArgs = {
  updates: Array<Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TeamsArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  where: Teams_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_By_PkArgs = {
  _append?: InputMaybe<Teams_Append_Input>;
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  _inc?: InputMaybe<Teams_Inc_Input>;
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  _set?: InputMaybe<Teams_Set_Input>;
  pk_columns: Teams_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_ManyArgs = {
  updates: Array<Teams_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_PortalsArgs = {
  _set?: InputMaybe<Teams_Portals_Set_Input>;
  where: Teams_Portals_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Portals_By_PkArgs = {
  _set?: InputMaybe<Teams_Portals_Set_Input>;
  pk_columns: Teams_Portals_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Portals_ManyArgs = {
  updates: Array<Teams_Portals_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_UsersArgs = {
  _inc?: InputMaybe<Teams_Users_Inc_Input>;
  _set?: InputMaybe<Teams_Users_Set_Input>;
  where: Teams_Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Teams_Users_ManyArgs = {
  updates: Array<Teams_Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantsArgs = {
  _inc?: InputMaybe<Tenants_Inc_Input>;
  _set?: InputMaybe<Tenants_Set_Input>;
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_By_PkArgs = {
  _inc?: InputMaybe<Tenants_Inc_Input>;
  _set?: InputMaybe<Tenants_Set_Input>;
  pk_columns: Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_ManyArgs = {
  updates: Array<Tenants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Email_PreferencesArgs = {
  email_display_name?: InputMaybe<Scalars['String']['input']>;
  email_id?: InputMaybe<Scalars['uuid']['input']>;
  email_signature?: InputMaybe<Scalars['String']['input']>;
  email_signature_html?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};


/** mutation root */
export type Mutation_RootUpdate_User_ImagesArgs = {
  _inc?: InputMaybe<User_Images_Inc_Input>;
  _set?: InputMaybe<User_Images_Set_Input>;
  where: User_Images_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Images_By_PkArgs = {
  _inc?: InputMaybe<User_Images_Inc_Input>;
  _set?: InputMaybe<User_Images_Set_Input>;
  pk_columns: User_Images_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Images_ManyArgs = {
  updates: Array<User_Images_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_PreferencesArgs = {
  _set?: InputMaybe<User_Notification_Preferences_Set_Input>;
  where: User_Notification_Preferences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_Preferences_By_PkArgs = {
  _set?: InputMaybe<User_Notification_Preferences_Set_Input>;
  pk_columns: User_Notification_Preferences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_Preferences_ManyArgs = {
  updates: Array<User_Notification_Preferences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Permission_FlagsArgs = {
  can_edit_settings?: InputMaybe<Scalars['Boolean']['input']>;
  can_user_login_as?: InputMaybe<Scalars['Boolean']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  user_id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootUpdate_User_Product_ExperiencesArgs = {
  _inc?: InputMaybe<User_Product_Experiences_Inc_Input>;
  _set?: InputMaybe<User_Product_Experiences_Set_Input>;
  where: User_Product_Experiences_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Product_Experiences_By_PkArgs = {
  _inc?: InputMaybe<User_Product_Experiences_Inc_Input>;
  _set?: InputMaybe<User_Product_Experiences_Set_Input>;
  pk_columns: User_Product_Experiences_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Product_Experiences_ManyArgs = {
  updates: Array<User_Product_Experiences_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _inc?: InputMaybe<Users_Inc_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ListingsArgs = {
  _inc?: InputMaybe<Users_Listings_Inc_Input>;
  _set?: InputMaybe<Users_Listings_Set_Input>;
  where: Users_Listings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_Listings_By_PkArgs = {
  _inc?: InputMaybe<Users_Listings_Inc_Input>;
  _set?: InputMaybe<Users_Listings_Set_Input>;
  pk_columns: Users_Listings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Webhook_SubscriptionsArgs = {
  _set?: InputMaybe<Webhook_Subscriptions_Set_Input>;
  where: Webhook_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Webhook_Subscriptions_By_PkArgs = {
  _set?: InputMaybe<Webhook_Subscriptions_Set_Input>;
  pk_columns: Webhook_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Webhook_Subscriptions_ManyArgs = {
  updates: Array<Webhook_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpsert_Mls_Share_CriteriaArgs = {
  args: Upsert_Mls_Share_Criteria_Args;
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpsert_Valuation_LinkArgs = {
  agent_id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootValidate_Webhook_UrlArgs = {
  url: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootValue_PropertyArgs = {
  property_id: Scalars['String']['input'];
};

export type Notification_Setting_Impact_Args = {
  audience?: InputMaybe<Scalars['String']['input']>;
  country_codes?: InputMaybe<Scalars['_text']['input']>;
  modules?: InputMaybe<Scalars['_text']['input']>;
  setting_type?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "notification_setting_impact_result" */
export type Notification_Setting_Impact_Result = {
  any_on: Scalars['Int']['output'];
  computed_for: Scalars['uuid']['output'];
  eligible_users: Scalars['Int']['output'];
  email_on: Scalars['Int']['output'];
  email_unset: Scalars['Int']['output'];
  push_on: Scalars['Int']['output'];
  push_unset: Scalars['Int']['output'];
  sms_on: Scalars['Int']['output'];
  sms_unset: Scalars['Int']['output'];
  team_leader_cc_on: Scalars['Int']['output'];
  team_leader_cc_unset: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "notification_setting_impact_result". All fields are combined with a logical 'AND'. */
export type Notification_Setting_Impact_Result_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Setting_Impact_Result_Bool_Exp>>;
  _not?: InputMaybe<Notification_Setting_Impact_Result_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Setting_Impact_Result_Bool_Exp>>;
  any_on?: InputMaybe<Int_Comparison_Exp>;
  computed_for?: InputMaybe<Uuid_Comparison_Exp>;
  eligible_users?: InputMaybe<Int_Comparison_Exp>;
  email_on?: InputMaybe<Int_Comparison_Exp>;
  email_unset?: InputMaybe<Int_Comparison_Exp>;
  push_on?: InputMaybe<Int_Comparison_Exp>;
  push_unset?: InputMaybe<Int_Comparison_Exp>;
  sms_on?: InputMaybe<Int_Comparison_Exp>;
  sms_unset?: InputMaybe<Int_Comparison_Exp>;
  team_leader_cc_on?: InputMaybe<Int_Comparison_Exp>;
  team_leader_cc_unset?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "notification_setting_impact_result". */
export type Notification_Setting_Impact_Result_Order_By = {
  any_on?: InputMaybe<Order_By>;
  computed_for?: InputMaybe<Order_By>;
  eligible_users?: InputMaybe<Order_By>;
  email_on?: InputMaybe<Order_By>;
  email_unset?: InputMaybe<Order_By>;
  push_on?: InputMaybe<Order_By>;
  push_unset?: InputMaybe<Order_By>;
  sms_on?: InputMaybe<Order_By>;
  sms_unset?: InputMaybe<Order_By>;
  team_leader_cc_on?: InputMaybe<Order_By>;
  team_leader_cc_unset?: InputMaybe<Order_By>;
};

/** select columns of table "notification_setting_impact_result" */
export enum Notification_Setting_Impact_Result_Select_Column {
  /** column name */
  AnyOn = 'any_on',
  /** column name */
  ComputedFor = 'computed_for',
  /** column name */
  EligibleUsers = 'eligible_users',
  /** column name */
  EmailOn = 'email_on',
  /** column name */
  EmailUnset = 'email_unset',
  /** column name */
  PushOn = 'push_on',
  /** column name */
  PushUnset = 'push_unset',
  /** column name */
  SmsOn = 'sms_on',
  /** column name */
  SmsUnset = 'sms_unset',
  /** column name */
  TeamLeaderCcOn = 'team_leader_cc_on',
  /** column name */
  TeamLeaderCcUnset = 'team_leader_cc_unset'
}

/** columns and relationships of "notification_settings" */
export type Notification_Settings = {
  audience: Scalars['String']['output'];
  country_codes?: Maybe<Array<Scalars['String']['output']>>;
  created_at: Scalars['timestamptz']['output'];
  description_de?: Maybe<Scalars['String']['output']>;
  description_en: Scalars['String']['output'];
  description_es?: Maybe<Scalars['String']['output']>;
  description_fr?: Maybe<Scalars['String']['output']>;
  description_it?: Maybe<Scalars['String']['output']>;
  description_pl?: Maybe<Scalars['String']['output']>;
  description_pt?: Maybe<Scalars['String']['output']>;
  email_available: Scalars['Boolean']['output'];
  email_default: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  label_de?: Maybe<Scalars['String']['output']>;
  label_en: Scalars['String']['output'];
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  order_nr: Scalars['Int']['output'];
  push_available: Scalars['Boolean']['output'];
  push_default: Scalars['Boolean']['output'];
  requires_channel: Scalars['Boolean']['output'];
  sms_available: Scalars['Boolean']['output'];
  sms_default: Scalars['Boolean']['output'];
  team_leader_cc_available: Scalars['Boolean']['output'];
  team_leader_cc_default: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  user_preferences: Array<User_Notification_Preferences>;
};


/** columns and relationships of "notification_settings" */
export type Notification_SettingsUser_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notification_Preferences_Order_By>>;
  where?: InputMaybe<User_Notification_Preferences_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "notification_settings". All fields are combined with a logical 'AND'. */
export type Notification_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Settings_Bool_Exp>>;
  _not?: InputMaybe<Notification_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Settings_Bool_Exp>>;
  audience?: InputMaybe<String_Comparison_Exp>;
  country_codes?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description_de?: InputMaybe<String_Comparison_Exp>;
  description_en?: InputMaybe<String_Comparison_Exp>;
  description_es?: InputMaybe<String_Comparison_Exp>;
  description_fr?: InputMaybe<String_Comparison_Exp>;
  description_it?: InputMaybe<String_Comparison_Exp>;
  description_pl?: InputMaybe<String_Comparison_Exp>;
  description_pt?: InputMaybe<String_Comparison_Exp>;
  email_available?: InputMaybe<Boolean_Comparison_Exp>;
  email_default?: InputMaybe<Boolean_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  modules?: InputMaybe<String_Array_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  push_available?: InputMaybe<Boolean_Comparison_Exp>;
  push_default?: InputMaybe<Boolean_Comparison_Exp>;
  requires_channel?: InputMaybe<Boolean_Comparison_Exp>;
  sms_available?: InputMaybe<Boolean_Comparison_Exp>;
  sms_default?: InputMaybe<Boolean_Comparison_Exp>;
  team_leader_cc_available?: InputMaybe<Boolean_Comparison_Exp>;
  team_leader_cc_default?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_preferences?: InputMaybe<User_Notification_Preferences_Bool_Exp>;
};

/** unique or primary key constraints on table "notification_settings" */
export enum Notification_Settings_Constraint {
  /** unique or primary key constraint on columns "type" */
  NotificationSettingsPkey = 'notification_settings_pkey'
}

/** input type for incrementing numeric columns in table "notification_settings" */
export type Notification_Settings_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "notification_settings" */
export type Notification_Settings_Insert_Input = {
  audience?: InputMaybe<Scalars['String']['input']>;
  country_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  description_de?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_fr?: InputMaybe<Scalars['String']['input']>;
  description_it?: InputMaybe<Scalars['String']['input']>;
  description_pl?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  email_available?: InputMaybe<Scalars['Boolean']['input']>;
  email_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  push_available?: InputMaybe<Scalars['Boolean']['input']>;
  push_default?: InputMaybe<Scalars['Boolean']['input']>;
  requires_channel?: InputMaybe<Scalars['Boolean']['input']>;
  sms_available?: InputMaybe<Scalars['Boolean']['input']>;
  sms_default?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_available?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_default?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_preferences?: InputMaybe<User_Notification_Preferences_Arr_Rel_Insert_Input>;
};

/** response of any mutation on the table "notification_settings" */
export type Notification_Settings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Settings>;
};

/** input type for inserting object relation for remote table "notification_settings" */
export type Notification_Settings_Obj_Rel_Insert_Input = {
  data: Notification_Settings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Notification_Settings_On_Conflict>;
};

/** on_conflict condition type for table "notification_settings" */
export type Notification_Settings_On_Conflict = {
  constraint: Notification_Settings_Constraint;
  update_columns?: Array<Notification_Settings_Update_Column>;
  where?: InputMaybe<Notification_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_settings". */
export type Notification_Settings_Order_By = {
  audience?: InputMaybe<Order_By>;
  country_codes?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description_de?: InputMaybe<Order_By>;
  description_en?: InputMaybe<Order_By>;
  description_es?: InputMaybe<Order_By>;
  description_fr?: InputMaybe<Order_By>;
  description_it?: InputMaybe<Order_By>;
  description_pl?: InputMaybe<Order_By>;
  description_pt?: InputMaybe<Order_By>;
  email_available?: InputMaybe<Order_By>;
  email_default?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  push_available?: InputMaybe<Order_By>;
  push_default?: InputMaybe<Order_By>;
  requires_channel?: InputMaybe<Order_By>;
  sms_available?: InputMaybe<Order_By>;
  sms_default?: InputMaybe<Order_By>;
  team_leader_cc_available?: InputMaybe<Order_By>;
  team_leader_cc_default?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_preferences_aggregate?: InputMaybe<User_Notification_Preferences_Aggregate_Order_By>;
};

/** primary key columns input for table: notification_settings */
export type Notification_Settings_Pk_Columns_Input = {
  type: Scalars['String']['input'];
};

/** select columns of table "notification_settings" */
export enum Notification_Settings_Select_Column {
  /** column name */
  Audience = 'audience',
  /** column name */
  CountryCodes = 'country_codes',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DescriptionDe = 'description_de',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionIt = 'description_it',
  /** column name */
  DescriptionPl = 'description_pl',
  /** column name */
  DescriptionPt = 'description_pt',
  /** column name */
  EmailAvailable = 'email_available',
  /** column name */
  EmailDefault = 'email_default',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Modules = 'modules',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PushAvailable = 'push_available',
  /** column name */
  PushDefault = 'push_default',
  /** column name */
  RequiresChannel = 'requires_channel',
  /** column name */
  SmsAvailable = 'sms_available',
  /** column name */
  SmsDefault = 'sms_default',
  /** column name */
  TeamLeaderCcAvailable = 'team_leader_cc_available',
  /** column name */
  TeamLeaderCcDefault = 'team_leader_cc_default',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "notification_settings" */
export type Notification_Settings_Set_Input = {
  audience?: InputMaybe<Scalars['String']['input']>;
  country_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  description_de?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_fr?: InputMaybe<Scalars['String']['input']>;
  description_it?: InputMaybe<Scalars['String']['input']>;
  description_pl?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  email_available?: InputMaybe<Scalars['Boolean']['input']>;
  email_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  push_available?: InputMaybe<Scalars['Boolean']['input']>;
  push_default?: InputMaybe<Scalars['Boolean']['input']>;
  requires_channel?: InputMaybe<Scalars['Boolean']['input']>;
  sms_available?: InputMaybe<Scalars['Boolean']['input']>;
  sms_default?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_available?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_default?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "notification_settings" */
export type Notification_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Settings_Stream_Cursor_Value_Input = {
  audience?: InputMaybe<Scalars['String']['input']>;
  country_codes?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  description_de?: InputMaybe<Scalars['String']['input']>;
  description_en?: InputMaybe<Scalars['String']['input']>;
  description_es?: InputMaybe<Scalars['String']['input']>;
  description_fr?: InputMaybe<Scalars['String']['input']>;
  description_it?: InputMaybe<Scalars['String']['input']>;
  description_pl?: InputMaybe<Scalars['String']['input']>;
  description_pt?: InputMaybe<Scalars['String']['input']>;
  email_available?: InputMaybe<Scalars['Boolean']['input']>;
  email_default?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  push_available?: InputMaybe<Scalars['Boolean']['input']>;
  push_default?: InputMaybe<Scalars['Boolean']['input']>;
  requires_channel?: InputMaybe<Scalars['Boolean']['input']>;
  sms_available?: InputMaybe<Scalars['Boolean']['input']>;
  sms_default?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_available?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_default?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "notification_settings" */
export enum Notification_Settings_Update_Column {
  /** column name */
  Audience = 'audience',
  /** column name */
  CountryCodes = 'country_codes',
  /** column name */
  DescriptionDe = 'description_de',
  /** column name */
  DescriptionEn = 'description_en',
  /** column name */
  DescriptionEs = 'description_es',
  /** column name */
  DescriptionFr = 'description_fr',
  /** column name */
  DescriptionIt = 'description_it',
  /** column name */
  DescriptionPl = 'description_pl',
  /** column name */
  DescriptionPt = 'description_pt',
  /** column name */
  EmailAvailable = 'email_available',
  /** column name */
  EmailDefault = 'email_default',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Modules = 'modules',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PushAvailable = 'push_available',
  /** column name */
  PushDefault = 'push_default',
  /** column name */
  RequiresChannel = 'requires_channel',
  /** column name */
  SmsAvailable = 'sms_available',
  /** column name */
  SmsDefault = 'sms_default',
  /** column name */
  TeamLeaderCcAvailable = 'team_leader_cc_available',
  /** column name */
  TeamLeaderCcDefault = 'team_leader_cc_default',
  /** column name */
  Type = 'type'
}

export type Notification_Settings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Notification_Settings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Settings_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** columns and relationships of "nylas_account_configs" */
export type Nylas_Account_Configs = {
  account_id?: Maybe<Scalars['String']['output']>;
  calendar_name?: Maybe<Scalars['String']['output']>;
  calendar_sync_enabled: Scalars['Boolean']['output'];
  calendar_sync_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  nylas_calendar_id?: Maybe<Scalars['String']['output']>;
  scopes?: Maybe<Scalars['jsonb']['output']>;
  sync_activity_types?: Maybe<Array<Scalars['String']['output']>>;
  sync_enabled?: Maybe<Scalars['Boolean']['output']>;
  sync_enabled_at?: Maybe<Scalars['timestamptz']['output']>;
  sync_state?: Maybe<Scalars['String']['output']>;
  sync_state_updated_at?: Maybe<Scalars['timestamptz']['output']>;
  sync_type?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "nylas_account_configs" */
export type Nylas_Account_ConfigsScopesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** order by aggregate values of table "nylas_account_configs" */
export type Nylas_Account_Configs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Nylas_Account_Configs_Max_Order_By>;
  min?: InputMaybe<Nylas_Account_Configs_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "nylas_account_configs". All fields are combined with a logical 'AND'. */
export type Nylas_Account_Configs_Bool_Exp = {
  _and?: InputMaybe<Array<Nylas_Account_Configs_Bool_Exp>>;
  _not?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
  _or?: InputMaybe<Array<Nylas_Account_Configs_Bool_Exp>>;
  account_id?: InputMaybe<String_Comparison_Exp>;
  calendar_name?: InputMaybe<String_Comparison_Exp>;
  calendar_sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  calendar_sync_enabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  nylas_calendar_id?: InputMaybe<String_Comparison_Exp>;
  scopes?: InputMaybe<Jsonb_Comparison_Exp>;
  sync_activity_types?: InputMaybe<String_Array_Comparison_Exp>;
  sync_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  sync_enabled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sync_state?: InputMaybe<String_Comparison_Exp>;
  sync_state_updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  sync_type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "nylas_account_configs" */
export type Nylas_Account_Configs_Max_Order_By = {
  account_id?: InputMaybe<Order_By>;
  calendar_name?: InputMaybe<Order_By>;
  calendar_sync_enabled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nylas_calendar_id?: InputMaybe<Order_By>;
  sync_activity_types?: InputMaybe<Order_By>;
  sync_enabled_at?: InputMaybe<Order_By>;
  sync_state?: InputMaybe<Order_By>;
  sync_state_updated_at?: InputMaybe<Order_By>;
  sync_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "nylas_account_configs" */
export type Nylas_Account_Configs_Min_Order_By = {
  account_id?: InputMaybe<Order_By>;
  calendar_name?: InputMaybe<Order_By>;
  calendar_sync_enabled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nylas_calendar_id?: InputMaybe<Order_By>;
  sync_activity_types?: InputMaybe<Order_By>;
  sync_enabled_at?: InputMaybe<Order_By>;
  sync_state?: InputMaybe<Order_By>;
  sync_state_updated_at?: InputMaybe<Order_By>;
  sync_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "nylas_account_configs". */
export type Nylas_Account_Configs_Order_By = {
  account_id?: InputMaybe<Order_By>;
  calendar_name?: InputMaybe<Order_By>;
  calendar_sync_enabled?: InputMaybe<Order_By>;
  calendar_sync_enabled_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  nylas_calendar_id?: InputMaybe<Order_By>;
  scopes?: InputMaybe<Order_By>;
  sync_activity_types?: InputMaybe<Order_By>;
  sync_enabled?: InputMaybe<Order_By>;
  sync_enabled_at?: InputMaybe<Order_By>;
  sync_state?: InputMaybe<Order_By>;
  sync_state_updated_at?: InputMaybe<Order_By>;
  sync_type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "nylas_account_configs" */
export enum Nylas_Account_Configs_Select_Column {
  /** column name */
  AccountId = 'account_id',
  /** column name */
  CalendarName = 'calendar_name',
  /** column name */
  CalendarSyncEnabled = 'calendar_sync_enabled',
  /** column name */
  CalendarSyncEnabledAt = 'calendar_sync_enabled_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  NylasCalendarId = 'nylas_calendar_id',
  /** column name */
  Scopes = 'scopes',
  /** column name */
  SyncActivityTypes = 'sync_activity_types',
  /** column name */
  SyncEnabled = 'sync_enabled',
  /** column name */
  SyncEnabledAt = 'sync_enabled_at',
  /** column name */
  SyncState = 'sync_state',
  /** column name */
  SyncStateUpdatedAt = 'sync_state_updated_at',
  /** column name */
  SyncType = 'sync_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "nylas_account_configs" */
export type Nylas_Account_Configs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Nylas_Account_Configs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Nylas_Account_Configs_Stream_Cursor_Value_Input = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  calendar_name?: InputMaybe<Scalars['String']['input']>;
  calendar_sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  calendar_sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nylas_calendar_id?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['jsonb']['input']>;
  sync_activity_types?: InputMaybe<Array<Scalars['String']['input']>>;
  sync_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sync_enabled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_state?: InputMaybe<Scalars['String']['input']>;
  sync_state_updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  sync_type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** A buyer's (buyer_id -> users) price offer on a listing (lot_id -> lots): amount, made_on, valid_until and status (pending, accepted, refused). The currency is the listing's. */
export type Offers = {
  amount: Scalars['Int']['output'];
  /** An object relationship */
  buyer: Users;
  buyer_id: Scalars['uuid']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  made_on: Scalars['date']['output'];
  /** An object relationship */
  mls_share?: Maybe<Mls_Shares>;
  offer_refused_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  offer_refused_type?: Maybe<Dictionaries>;
  status: Offers_Status_Enum;
  updated_at: Scalars['timestamptz']['output'];
  valid_until?: Maybe<Scalars['date']['output']>;
};

/** aggregated selection of "offers" */
export type Offers_Aggregate = {
  aggregate?: Maybe<Offers_Aggregate_Fields>;
  nodes: Array<Offers>;
};

export type Offers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Offers_Aggregate_Bool_Exp_Count>;
};

export type Offers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Offers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Offers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "offers" */
export type Offers_Aggregate_Fields = {
  avg?: Maybe<Offers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Offers_Max_Fields>;
  min?: Maybe<Offers_Min_Fields>;
  stddev?: Maybe<Offers_Stddev_Fields>;
  stddev_pop?: Maybe<Offers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Offers_Stddev_Samp_Fields>;
  sum?: Maybe<Offers_Sum_Fields>;
  var_pop?: Maybe<Offers_Var_Pop_Fields>;
  var_samp?: Maybe<Offers_Var_Samp_Fields>;
  variance?: Maybe<Offers_Variance_Fields>;
};


/** aggregate fields of "offers" */
export type Offers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Offers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "offers" */
export type Offers_Aggregate_Order_By = {
  avg?: InputMaybe<Offers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Offers_Max_Order_By>;
  min?: InputMaybe<Offers_Min_Order_By>;
  stddev?: InputMaybe<Offers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Offers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Offers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Offers_Sum_Order_By>;
  var_pop?: InputMaybe<Offers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Offers_Var_Samp_Order_By>;
  variance?: InputMaybe<Offers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "offers" */
export type Offers_Arr_Rel_Insert_Input = {
  data: Array<Offers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};

/** aggregate avg on columns */
export type Offers_Avg_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "offers" */
export type Offers_Avg_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "offers". All fields are combined with a logical 'AND'. */
export type Offers_Bool_Exp = {
  _and?: InputMaybe<Array<Offers_Bool_Exp>>;
  _not?: InputMaybe<Offers_Bool_Exp>;
  _or?: InputMaybe<Array<Offers_Bool_Exp>>;
  amount?: InputMaybe<Int_Comparison_Exp>;
  buyer?: InputMaybe<Users_Bool_Exp>;
  buyer_id?: InputMaybe<Uuid_Comparison_Exp>;
  comments?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  made_on?: InputMaybe<Date_Comparison_Exp>;
  mls_share?: InputMaybe<Mls_Shares_Bool_Exp>;
  offer_refused_id?: InputMaybe<Uuid_Comparison_Exp>;
  offer_refused_type?: InputMaybe<Dictionaries_Bool_Exp>;
  status?: InputMaybe<Offers_Status_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  valid_until?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "offers" */
export enum Offers_Constraint {
  /** unique or primary key constraint on columns "id" */
  OffersPkey = 'offers_pkey'
}

/** input type for incrementing numeric columns in table "offers" */
export type Offers_Inc_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "offers" */
export type Offers_Insert_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  mls_share?: InputMaybe<Mls_Shares_Obj_Rel_Insert_Input>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  offer_refused_type?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Offers_Status_Enum>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate max on columns */
export type Offers_Max_Fields = {
  amount?: Maybe<Scalars['Int']['output']>;
  buyer_id?: Maybe<Scalars['uuid']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  made_on?: Maybe<Scalars['date']['output']>;
  offer_refused_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  valid_until?: Maybe<Scalars['date']['output']>;
};

/** order by max() on columns of table "offers" */
export type Offers_Max_Order_By = {
  amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  made_on?: InputMaybe<Order_By>;
  offer_refused_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Offers_Min_Fields = {
  amount?: Maybe<Scalars['Int']['output']>;
  buyer_id?: Maybe<Scalars['uuid']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  made_on?: Maybe<Scalars['date']['output']>;
  offer_refused_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  valid_until?: Maybe<Scalars['date']['output']>;
};

/** order by min() on columns of table "offers" */
export type Offers_Min_Order_By = {
  amount?: InputMaybe<Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  made_on?: InputMaybe<Order_By>;
  offer_refused_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "offers" */
export type Offers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Offers>;
};

/** input type for inserting object relation for remote table "offers" */
export type Offers_Obj_Rel_Insert_Input = {
  data: Offers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Offers_On_Conflict>;
};

/** on_conflict condition type for table "offers" */
export type Offers_On_Conflict = {
  constraint: Offers_Constraint;
  update_columns?: Array<Offers_Update_Column>;
  where?: InputMaybe<Offers_Bool_Exp>;
};

/** Ordering options when selecting data from "offers". */
export type Offers_Order_By = {
  amount?: InputMaybe<Order_By>;
  buyer?: InputMaybe<Users_Order_By>;
  buyer_id?: InputMaybe<Order_By>;
  comments?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  made_on?: InputMaybe<Order_By>;
  mls_share?: InputMaybe<Mls_Shares_Order_By>;
  offer_refused_id?: InputMaybe<Order_By>;
  offer_refused_type?: InputMaybe<Dictionaries_Order_By>;
  status?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  valid_until?: InputMaybe<Order_By>;
};

/** primary key columns input for table: offers */
export type Offers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "offers" */
export enum Offers_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

/** input type for updating data in table "offers" */
export type Offers_Set_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Offers_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

export enum Offers_Status_Enum {
  Accepted = 'accepted',
  Pending = 'pending',
  Refused = 'refused'
}

/** Boolean expression to compare columns of type "offers_status_enum". All fields are combined with logical 'AND'. */
export type Offers_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Offers_Status_Enum>;
  _in?: InputMaybe<Array<Offers_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Offers_Status_Enum>;
  _nin?: InputMaybe<Array<Offers_Status_Enum>>;
};

/** aggregate stddev on columns */
export type Offers_Stddev_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "offers" */
export type Offers_Stddev_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Offers_Stddev_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "offers" */
export type Offers_Stddev_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Offers_Stddev_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "offers" */
export type Offers_Stddev_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "offers" */
export type Offers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Offers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Offers_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  buyer_id?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  made_on?: InputMaybe<Scalars['date']['input']>;
  offer_refused_id?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<Offers_Status_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  valid_until?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate sum on columns */
export type Offers_Sum_Fields = {
  amount?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "offers" */
export type Offers_Sum_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** update columns of table "offers" */
export enum Offers_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  BuyerId = 'buyer_id',
  /** column name */
  Comments = 'comments',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MadeOn = 'made_on',
  /** column name */
  OfferRefusedId = 'offer_refused_id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ValidUntil = 'valid_until'
}

export type Offers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Offers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Offers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Offers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Offers_Var_Pop_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "offers" */
export type Offers_Var_Pop_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Offers_Var_Samp_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "offers" */
export type Offers_Var_Samp_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Offers_Variance_Fields = {
  amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "offers" */
export type Offers_Variance_Order_By = {
  amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "online_listing_map_data" */
export type Online_Listing_Map_Data = {
  geojson?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

export type Online_Listing_Map_Data_Aggregate = {
  aggregate?: Maybe<Online_Listing_Map_Data_Aggregate_Fields>;
  nodes: Array<Online_Listing_Map_Data>;
};

/** aggregate fields of "online_listing_map_data" */
export type Online_Listing_Map_Data_Aggregate_Fields = {
  avg?: Maybe<Online_Listing_Map_Data_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Online_Listing_Map_Data_Max_Fields>;
  min?: Maybe<Online_Listing_Map_Data_Min_Fields>;
  stddev?: Maybe<Online_Listing_Map_Data_Stddev_Fields>;
  stddev_pop?: Maybe<Online_Listing_Map_Data_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Online_Listing_Map_Data_Stddev_Samp_Fields>;
  sum?: Maybe<Online_Listing_Map_Data_Sum_Fields>;
  var_pop?: Maybe<Online_Listing_Map_Data_Var_Pop_Fields>;
  var_samp?: Maybe<Online_Listing_Map_Data_Var_Samp_Fields>;
  variance?: Maybe<Online_Listing_Map_Data_Variance_Fields>;
};


/** aggregate fields of "online_listing_map_data" */
export type Online_Listing_Map_Data_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Online_Listing_Map_Data_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "online_listing_map_data". All fields are combined with a logical 'AND'. */
export type Online_Listing_Map_Data_Bool_Exp = {
  _and?: InputMaybe<Array<Online_Listing_Map_Data_Bool_Exp>>;
  _not?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
  _or?: InputMaybe<Array<Online_Listing_Map_Data_Bool_Exp>>;
  geojson?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
};

/** aggregate max on columns */
export type Online_Listing_Map_Data_Max_Fields = {
  geojson?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** aggregate min on columns */
export type Online_Listing_Map_Data_Min_Fields = {
  geojson?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** Ordering options when selecting data from "online_listing_map_data". */
export type Online_Listing_Map_Data_Order_By = {
  geojson?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** select columns of table "online_listing_map_data" */
export enum Online_Listing_Map_Data_Select_Column {
  /** column name */
  Geojson = 'geojson',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng'
}

/** aggregate stddev on columns */
export type Online_Listing_Map_Data_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Online_Listing_Map_Data_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Online_Listing_Map_Data_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Online_Listing_Map_Data_Sum_Fields = {
  lat?: Maybe<Scalars['float8']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Online_Listing_Map_Data_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Online_Listing_Map_Data_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Online_Listing_Map_Data_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Listings on the market now in Switzerland, deduplicated: one row per property, with every portal that carries it in portals and urls. offer_type is 'buy' or 'rent'. Rebuilt every few hours. For listings that went offline, or history, read post_merged_listings. */
export type Online_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  bullet_points?: Maybe<Scalars['jsonb']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  idx_client_id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Scalars['jsonb']['output']>;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_top_listing?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_place?: Maybe<Ch_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  min_created_at?: Maybe<Scalars['timestamptz']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  portals?: Maybe<Scalars['_text']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_descriptions?: Maybe<Scalars['jsonb']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  urls?: Maybe<Scalars['_text']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  users_listings: Array<Users_Listings>;
  /** An aggregate relationship */
  users_listings_aggregate: Users_Listings_Aggregate;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Listings on the market now in Switzerland, deduplicated: one row per property, with every portal that carries it in portals and urls. offer_type is 'buy' or 'rent'. Rebuilt every few hours. For listings that went offline, or history, read post_merged_listings. */
export type Online_ListingsBullet_PointsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Listings on the market now in Switzerland, deduplicated: one row per property, with every portal that carries it in portals and urls. offer_type is 'buy' or 'rent'. Rebuilt every few hours. For listings that went offline, or history, read post_merged_listings. */
export type Online_ListingsImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Listings on the market now in Switzerland, deduplicated: one row per property, with every portal that carries it in portals and urls. offer_type is 'buy' or 'rent'. Rebuilt every few hours. For listings that went offline, or history, read post_merged_listings. */
export type Online_ListingsTranslated_DescriptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Listings on the market now in Switzerland, deduplicated: one row per property, with every portal that carries it in portals and urls. offer_type is 'buy' or 'rent'. Rebuilt every few hours. For listings that went offline, or history, read post_merged_listings. */
export type Online_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Listings on the market now in Switzerland, deduplicated: one row per property, with every portal that carries it in portals and urls. offer_type is 'buy' or 'rent'. Rebuilt every few hours. For listings that went offline, or history, read post_merged_listings. */
export type Online_ListingsUsers_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


/** Listings on the market now in Switzerland, deduplicated: one row per property, with every portal that carries it in portals and urls. offer_type is 'buy' or 'rent'. Rebuilt every few hours. For listings that went offline, or history, read post_merged_listings. */
export type Online_ListingsUsers_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};

export type Online_Listings_Aggregate = {
  aggregate?: Maybe<Online_Listings_Aggregate_Fields>;
  nodes: Array<Online_Listings>;
};

/** aggregate fields of "online_listings" */
export type Online_Listings_Aggregate_Fields = {
  avg?: Maybe<Online_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Online_Listings_Max_Fields>;
  min?: Maybe<Online_Listings_Min_Fields>;
  stddev?: Maybe<Online_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Online_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Online_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Online_Listings_Sum_Fields>;
  var_pop?: Maybe<Online_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Online_Listings_Var_Samp_Fields>;
  variance?: Maybe<Online_Listings_Variance_Fields>;
};


/** aggregate fields of "online_listings" */
export type Online_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Online_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Online_Listings_Avg_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "online_listings". All fields are combined with a logical 'AND'. */
export type Online_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Online_Listings_Bool_Exp>>;
  _not?: InputMaybe<Online_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Online_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_id?: InputMaybe<Uuid_Comparison_Exp>;
  agency_logo_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_rating?: InputMaybe<Float_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  agency_reviews_count?: InputMaybe<Int_Comparison_Exp>;
  agency_slug?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  bullet_points?: InputMaybe<Jsonb_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  idx_client_id?: InputMaybe<String_Comparison_Exp>;
  images?: InputMaybe<Jsonb_Comparison_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_top_listing?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_place?: InputMaybe<Ch_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  min_created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  portals?: InputMaybe<_Text_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_descriptions?: InputMaybe<Jsonb_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  urls?: InputMaybe<_Text_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  users_listings?: InputMaybe<Users_Listings_Bool_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Online_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idx_client_id?: Maybe<Scalars['String']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  min_created_at?: Maybe<Scalars['timestamptz']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Online_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_id?: Maybe<Scalars['uuid']['output']>;
  agency_logo_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idx_client_id?: Maybe<Scalars['String']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  min_created_at?: Maybe<Scalars['timestamptz']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "online_listings". */
export type Online_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_id?: InputMaybe<Order_By>;
  agency_logo_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_rating?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  agency_reviews_count?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  bullet_points?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_client_id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_top_listing?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_place?: InputMaybe<Ch_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  min_created_at?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  portals?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_descriptions?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  urls?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  users_listings_aggregate?: InputMaybe<Users_Listings_Aggregate_Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "online_listings" */
export enum Online_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyId = 'agency_id',
  /** column name */
  AgencyLogoUrl = 'agency_logo_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyRating = 'agency_rating',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AgencyReviewsCount = 'agency_reviews_count',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  BulletPoints = 'bullet_points',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IdxClientId = 'idx_client_id',
  /** column name */
  Images = 'images',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsTopListing = 'is_top_listing',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MinCreatedAt = 'min_created_at',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Portals = 'portals',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedDescriptions = 'translated_descriptions',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  Urls = 'urls',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Online_Listings_Stddev_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Online_Listings_Stddev_Pop_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Online_Listings_Stddev_Samp_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Online_Listings_Sum_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Int']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Online_Listings_Var_Pop_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Online_Listings_Var_Samp_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Online_Listings_Variance_Fields = {
  agency_rating?: Maybe<Scalars['Float']['output']>;
  agency_reviews_count?: Maybe<Scalars['Float']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "organisation_images" */
export type Organisation_Images = {
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  is_primary?: Maybe<Scalars['Boolean']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "organisation_images" */
export type Organisation_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Organisation_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Images_Max_Order_By>;
  min?: InputMaybe<Organisation_Images_Min_Order_By>;
  stddev?: InputMaybe<Organisation_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organisation_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organisation_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organisation_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Organisation_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organisation_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Organisation_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organisation_images" */
export type Organisation_Images_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Images_On_Conflict>;
};

/** order by avg() on columns of table "organisation_images" */
export type Organisation_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_images". All fields are combined with a logical 'AND'. */
export type Organisation_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Images_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Images_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_images" */
export enum Organisation_Images_Constraint {
  /** unique or primary key constraint on columns "organisation_id", "is_primary" */
  IdxOrganisationImagesOrganisationIdIsPrimary = 'idx_organisation_images_organisation_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  OrganisationImagesIdKey = 'organisation_images_id_key',
  /** unique or primary key constraint on columns "image_id", "organisation_id" */
  OrganisationImagesOrganisationIdImageIdUnique = 'organisation_images_organisation_id_image_id_unique',
  /** unique or primary key constraint on columns "id" */
  OrganisationImagesPkey = 'organisation_images_pkey'
}

/** input type for incrementing numeric columns in table "organisation_images" */
export type Organisation_Images_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "organisation_images" */
export type Organisation_Images_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "organisation_images" */
export type Organisation_Images_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organisation_images" */
export type Organisation_Images_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_images" */
export type Organisation_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Images>;
};

/** on_conflict condition type for table "organisation_images" */
export type Organisation_Images_On_Conflict = {
  constraint: Organisation_Images_Constraint;
  update_columns?: Array<Organisation_Images_Update_Column>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_images". */
export type Organisation_Images_Order_By = {
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_images */
export type Organisation_Images_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organisation_images" */
export enum Organisation_Images_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  OrganisationId = 'organisation_id'
}

/** input type for updating data in table "organisation_images" */
export type Organisation_Images_Set_Input = {
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "organisation_images" */
export type Organisation_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "organisation_images" */
export type Organisation_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "organisation_images" */
export type Organisation_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organisation_images" */
export type Organisation_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Images_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "organisation_images" */
export type Organisation_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "organisation_images" */
export enum Organisation_Images_Update_Column {
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr'
}

export type Organisation_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisation_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Images_Bool_Exp;
};

/** order by var_pop() on columns of table "organisation_images" */
export type Organisation_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "organisation_images" */
export type Organisation_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "organisation_images" */
export type Organisation_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "organisation_users" */
export type Organisation_Users = {
  /** An object relationship */
  organisation: Organisations;
  organisation_id: Scalars['uuid']['output'];
  /** An object relationship */
  users: Users;
};

/** order by aggregate values of table "organisation_users" */
export type Organisation_Users_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Users_Max_Order_By>;
  min?: InputMaybe<Organisation_Users_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "organisation_users". All fields are combined with a logical 'AND'. */
export type Organisation_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Users_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Users_Bool_Exp>>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** order by max() on columns of table "organisation_users" */
export type Organisation_Users_Max_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "organisation_users" */
export type Organisation_Users_Min_Order_By = {
  organisation_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "organisation_users". */
export type Organisation_Users_Order_By = {
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  users?: InputMaybe<Users_Order_By>;
};

/** select columns of table "organisation_users" */
export enum Organisation_Users_Select_Column {
  /** column name */
  OrganisationId = 'organisation_id'
}

/** Streaming cursor of the table "organisation_users" */
export type Organisation_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Users_Stream_Cursor_Value_Input = {
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type Organisations = {
  branding_color?: Maybe<Scalars['String']['output']>;
  close_lead_id?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  csm_rep?: Maybe<Users>;
  csm_rep_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  emails: Array<Emails>;
  id: Scalars['uuid']['output'];
  is_default_lender?: Maybe<Scalars['Boolean']['output']>;
  is_lender: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  linked_tenant?: Maybe<Tenants>;
  linked_tenant_id?: Maybe<Scalars['uuid']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  organisation_images: Array<Organisation_Images>;
  /** An array relationship */
  organisation_users: Array<Organisation_Users>;
  parent_organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sales_rep?: Maybe<Users>;
  sales_rep_user_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  stripe_customer_ids: Array<Scalars['String']['output']>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  website?: Maybe<Scalars['String']['output']>;
};


/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type OrganisationsEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type OrganisationsOrganisation_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Images_Order_By>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type OrganisationsOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Users_Order_By>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type OrganisationsPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type OrganisationsPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type OrganisationsTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


/** The legal entity that is RealAdvisor's customer: it signs and pays, and may own several teams (teams.organisation_id). is_lender marks mortgage partners, not agencies. csm_rep_user_id and sales_rep_user_id are RealAdvisor staff. */
export type OrganisationsTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** aggregated selection of "organisations" */
export type Organisations_Aggregate = {
  aggregate?: Maybe<Organisations_Aggregate_Fields>;
  nodes: Array<Organisations>;
};

/** aggregate fields of "organisations" */
export type Organisations_Aggregate_Fields = {
  avg?: Maybe<Organisations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Organisations_Max_Fields>;
  min?: Maybe<Organisations_Min_Fields>;
  stddev?: Maybe<Organisations_Stddev_Fields>;
  stddev_pop?: Maybe<Organisations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organisations_Stddev_Samp_Fields>;
  sum?: Maybe<Organisations_Sum_Fields>;
  var_pop?: Maybe<Organisations_Var_Pop_Fields>;
  var_samp?: Maybe<Organisations_Var_Samp_Fields>;
  variance?: Maybe<Organisations_Variance_Fields>;
};


/** aggregate fields of "organisations" */
export type Organisations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Organisations_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "organisations". All fields are combined with a logical 'AND'. */
export type Organisations_Bool_Exp = {
  _and?: InputMaybe<Array<Organisations_Bool_Exp>>;
  _not?: InputMaybe<Organisations_Bool_Exp>;
  _or?: InputMaybe<Array<Organisations_Bool_Exp>>;
  branding_color?: InputMaybe<String_Comparison_Exp>;
  close_lead_id?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  csm_rep?: InputMaybe<Users_Bool_Exp>;
  csm_rep_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  emails?: InputMaybe<Emails_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_default_lender?: InputMaybe<Boolean_Comparison_Exp>;
  is_lender?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  linked_tenant?: InputMaybe<Tenants_Bool_Exp>;
  linked_tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_images?: InputMaybe<Organisation_Images_Bool_Exp>;
  organisation_users?: InputMaybe<Organisation_Users_Bool_Exp>;
  parent_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_numbers?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  sales_rep?: InputMaybe<Users_Bool_Exp>;
  sales_rep_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  stripe_customer_ids?: InputMaybe<String_Array_Comparison_Exp>;
  teams?: InputMaybe<Teams_Bool_Exp>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisations" */
export enum Organisations_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  OrganisationsIdTenantIdUnique = 'organisations_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  OrganisationsPkey = 'organisations_pkey'
}

/** input type for incrementing numeric columns in table "organisations" */
export type Organisations_Inc_Input = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "organisations" */
export type Organisations_Insert_Input = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  close_lead_id?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  csm_rep?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  csm_rep_user_id?: InputMaybe<Scalars['uuid']['input']>;
  emails?: InputMaybe<Emails_Arr_Rel_Insert_Input>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  linked_tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation_images?: InputMaybe<Organisation_Images_Arr_Rel_Insert_Input>;
  phone_numbers?: InputMaybe<Phone_Numbers_Arr_Rel_Insert_Input>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  sales_rep?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  sales_rep_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  teams?: InputMaybe<Teams_Arr_Rel_Insert_Input>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Organisations_Max_Fields = {
  branding_color?: Maybe<Scalars['String']['output']>;
  close_lead_id?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  csm_rep_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  linked_tenant_id?: Maybe<Scalars['uuid']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  sales_rep_user_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  stripe_customer_ids?: Maybe<Array<Scalars['String']['output']>>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Organisations_Min_Fields = {
  branding_color?: Maybe<Scalars['String']['output']>;
  close_lead_id?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  csm_rep_user_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  linked_tenant_id?: Maybe<Scalars['uuid']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  sales_rep_user_id?: Maybe<Scalars['uuid']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  stripe_customer_ids?: Maybe<Array<Scalars['String']['output']>>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "organisations" */
export type Organisations_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisations>;
};

/** input type for inserting object relation for remote table "organisations" */
export type Organisations_Obj_Rel_Insert_Input = {
  data: Organisations_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisations_On_Conflict>;
};

/** on_conflict condition type for table "organisations" */
export type Organisations_On_Conflict = {
  constraint: Organisations_Constraint;
  update_columns?: Array<Organisations_Update_Column>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};

/** Ordering options when selecting data from "organisations". */
export type Organisations_Order_By = {
  branding_color?: InputMaybe<Order_By>;
  close_lead_id?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  csm_rep?: InputMaybe<Users_Order_By>;
  csm_rep_user_id?: InputMaybe<Order_By>;
  emails_aggregate?: InputMaybe<Emails_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  is_default_lender?: InputMaybe<Order_By>;
  is_lender?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  linked_tenant?: InputMaybe<Tenants_Order_By>;
  linked_tenant_id?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_images_aggregate?: InputMaybe<Organisation_Images_Aggregate_Order_By>;
  organisation_users_aggregate?: InputMaybe<Organisation_Users_Aggregate_Order_By>;
  parent_organisation_id?: InputMaybe<Order_By>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  postcode?: InputMaybe<Order_By>;
  sales_rep?: InputMaybe<Users_Order_By>;
  sales_rep_user_id?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  stripe_customer_ids?: InputMaybe<Order_By>;
  teams_aggregate?: InputMaybe<Teams_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisations */
export type Organisations_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

export type Organisations_Search_Args = {
  order_by_first_ids?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** select columns of table "organisations" */
export enum Organisations_Select_Column {
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  CloseLeadId = 'close_lead_id',
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CsmRepUserId = 'csm_rep_user_id',
  /** column name */
  Id = 'id',
  /** column name */
  IsDefaultLender = 'is_default_lender',
  /** column name */
  IsLender = 'is_lender',
  /** column name */
  Lat = 'lat',
  /** column name */
  LinkedTenantId = 'linked_tenant_id',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Name = 'name',
  /** column name */
  ParentOrganisationId = 'parent_organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  SalesRepUserId = 'sales_rep_user_id',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StripeCustomerIds = 'stripe_customer_ids',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "organisations" */
export type Organisations_Set_Input = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  close_lead_id?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  csm_rep_user_id?: InputMaybe<Scalars['uuid']['input']>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  linked_tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  sales_rep_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Organisations_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Organisations_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Organisations_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "organisations" */
export type Organisations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisations_Stream_Cursor_Value_Input = {
  branding_color?: InputMaybe<Scalars['String']['input']>;
  close_lead_id?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  csm_rep_user_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_default_lender?: InputMaybe<Scalars['Boolean']['input']>;
  is_lender?: InputMaybe<Scalars['Boolean']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  linked_tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  sales_rep_user_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_customer_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Organisations_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** update columns of table "organisations" */
export enum Organisations_Update_Column {
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  CloseLeadId = 'close_lead_id',
  /** column name */
  Country = 'country',
  /** column name */
  CsmRepUserId = 'csm_rep_user_id',
  /** column name */
  IsLender = 'is_lender',
  /** column name */
  Lat = 'lat',
  /** column name */
  LinkedTenantId = 'linked_tenant_id',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Name = 'name',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  SalesRepUserId = 'sales_rep_user_id',
  /** column name */
  State = 'state',
  /** column name */
  Street = 'street',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StripeCustomerIds = 'stripe_customer_ids',
  /** column name */
  Website = 'website'
}

export type Organisations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organisations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organisations_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Organisations_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Organisations_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export enum Parking_Price_Type_Enum_Enum {
  /** Price per parking space */
  PerSpacePrice = 'per_space_price',
  /** Total price */
  TotalPrice = 'total_price'
}

/** Boolean expression to compare columns of type "parking_price_type_enum_enum". All fields are combined with logical 'AND'. */
export type Parking_Price_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Parking_Price_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Parking_Price_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Parking_Price_Type_Enum_Enum>>;
};

/** Boolean expression to compare columns of type "pdf_compression_quality". All fields are combined with logical 'AND'. */
export type Pdf_Compression_Quality_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _gte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _in?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _lte?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _neq?: InputMaybe<Scalars['pdf_compression_quality']['input']>;
  _nin?: InputMaybe<Array<Scalars['pdf_compression_quality']['input']>>;
};

/** columns and relationships of "phone_number_type_enum" */
export type Phone_Number_Type_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "phone_number_type_enum". All fields are combined with a logical 'AND'. */
export type Phone_Number_Type_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Phone_Number_Type_Enum_Bool_Exp>>;
  _not?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Phone_Number_Type_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "phone_number_type_enum" */
export enum Phone_Number_Type_Enum_Constraint {
  /** unique or primary key constraint on columns "value" */
  PhoneNumberTypeEnumPkey = 'phone_number_type_enum_pkey'
}

export enum Phone_Number_Type_Enum_Enum {
  /** Home phone number */
  Home = 'home',
  /** Mobile phone number */
  Mobile = 'mobile',
  /** Other phone number */
  Other = 'other',
  /** Proxy number user to track calls */
  Proxy = 'proxy',
  /** Work phone number */
  Work = 'work'
}

/** Boolean expression to compare columns of type "phone_number_type_enum_enum". All fields are combined with logical 'AND'. */
export type Phone_Number_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Phone_Number_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Phone_Number_Type_Enum_Enum>>;
};

/** input type for inserting data into table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_Insert_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** response of any mutation on the table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Phone_Number_Type_Enum>;
};

/** on_conflict condition type for table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_On_Conflict = {
  constraint: Phone_Number_Type_Enum_Constraint;
  update_columns?: Array<Phone_Number_Type_Enum_Update_Column>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};

/** Ordering options when selecting data from "phone_number_type_enum". */
export type Phone_Number_Type_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "phone_number_type_enum" */
export enum Phone_Number_Type_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "phone_number_type_enum" */
export type Phone_Number_Type_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phone_Number_Type_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phone_Number_Type_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** placeholder for update columns of table "phone_number_type_enum" (current role has no relevant permissions) */
export enum Phone_Number_Type_Enum_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** Phone numbers of a user (user_id -> users), a team or an organisation. primary marks the main one; type 'proxy' is a masking number, not the person's own. */
export type Phone_Numbers = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  is_visibility: Scalars['Boolean']['output'];
  number: Scalars['String']['output'];
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  primary?: Maybe<Scalars['Boolean']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  type?: Maybe<Phone_Number_Type_Enum_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** aggregated selection of "phone_numbers" */
export type Phone_Numbers_Aggregate = {
  aggregate?: Maybe<Phone_Numbers_Aggregate_Fields>;
  nodes: Array<Phone_Numbers>;
};

export type Phone_Numbers_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp_Count>;
};

export type Phone_Numbers_Aggregate_Bool_Exp_Bool_And = {
  arguments: Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Phone_Numbers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Phone_Numbers_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Phone_Numbers_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Phone_Numbers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Phone_Numbers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "phone_numbers" */
export type Phone_Numbers_Aggregate_Fields = {
  avg?: Maybe<Phone_Numbers_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Phone_Numbers_Max_Fields>;
  min?: Maybe<Phone_Numbers_Min_Fields>;
  stddev?: Maybe<Phone_Numbers_Stddev_Fields>;
  stddev_pop?: Maybe<Phone_Numbers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Phone_Numbers_Stddev_Samp_Fields>;
  sum?: Maybe<Phone_Numbers_Sum_Fields>;
  var_pop?: Maybe<Phone_Numbers_Var_Pop_Fields>;
  var_samp?: Maybe<Phone_Numbers_Var_Samp_Fields>;
  variance?: Maybe<Phone_Numbers_Variance_Fields>;
};


/** aggregate fields of "phone_numbers" */
export type Phone_Numbers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "phone_numbers" */
export type Phone_Numbers_Aggregate_Order_By = {
  avg?: InputMaybe<Phone_Numbers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Phone_Numbers_Max_Order_By>;
  min?: InputMaybe<Phone_Numbers_Min_Order_By>;
  stddev?: InputMaybe<Phone_Numbers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Phone_Numbers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Phone_Numbers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Phone_Numbers_Sum_Order_By>;
  var_pop?: InputMaybe<Phone_Numbers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Phone_Numbers_Var_Samp_Order_By>;
  variance?: InputMaybe<Phone_Numbers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "phone_numbers" */
export type Phone_Numbers_Arr_Rel_Insert_Input = {
  data: Array<Phone_Numbers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Phone_Numbers_On_Conflict>;
};

/** aggregate avg on columns */
export type Phone_Numbers_Avg_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "phone_numbers" */
export type Phone_Numbers_Avg_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "phone_numbers". All fields are combined with a logical 'AND'. */
export type Phone_Numbers_Bool_Exp = {
  _and?: InputMaybe<Array<Phone_Numbers_Bool_Exp>>;
  _not?: InputMaybe<Phone_Numbers_Bool_Exp>;
  _or?: InputMaybe<Array<Phone_Numbers_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_visibility?: InputMaybe<Boolean_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  primary?: InputMaybe<Boolean_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  verification_attempts?: InputMaybe<Int_Comparison_Exp>;
  verification_code?: InputMaybe<Int_Comparison_Exp>;
  verification_codes_sent?: InputMaybe<Int_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "phone_numbers" */
export enum Phone_Numbers_Constraint {
  /** unique or primary key constraint on columns "id" */
  PhoneNumbersPkey = 'phone_numbers_pkey',
  /** unique or primary key constraint on columns "number" */
  PhoneNumbersProxyTeamUnique = 'phone_numbers_proxy_team_unique',
  /** unique or primary key constraint on columns "number", "tenant_id" */
  PhoneNumbersTenantIdOrganisationIdUnique = 'phone_numbers_tenant_id_organisation_id_unique',
  /** unique or primary key constraint on columns "number", "tenant_id" */
  PhoneNumbersTenantIdUserIdUnique = 'phone_numbers_tenant_id_user_id_unique',
  /** unique or primary key constraint on columns "user_id" */
  PhoneNumbersUserVisibilityUnique = 'phone_numbers_user_visibility_unique'
}

/** input type for inserting data into table "phone_numbers" */
export type Phone_Numbers_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_visibility?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Phone_Numbers_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "phone_numbers" */
export type Phone_Numbers_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Phone_Numbers_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "phone_numbers" */
export type Phone_Numbers_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "phone_numbers" */
export type Phone_Numbers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Phone_Numbers>;
};

/** on_conflict condition type for table "phone_numbers" */
export type Phone_Numbers_On_Conflict = {
  constraint: Phone_Numbers_Constraint;
  update_columns?: Array<Phone_Numbers_Update_Column>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};

/** Ordering options when selecting data from "phone_numbers". */
export type Phone_Numbers_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_visibility?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  primary?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: phone_numbers */
export type Phone_Numbers_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "phone_numbers" */
export enum Phone_Numbers_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsVisibility = 'is_visibility',
  /** column name */
  Number = 'number',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Primary = 'primary',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VerificationAttempts = 'verification_attempts',
  /** column name */
  VerificationCode = 'verification_code',
  /** column name */
  VerificationCodesSent = 'verification_codes_sent',
  /** column name */
  Verified = 'verified'
}

/** select "phone_numbers_aggregate_bool_exp_bool_and_arguments_columns" columns of table "phone_numbers" */
export enum Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVisibility = 'is_visibility',
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

/** select "phone_numbers_aggregate_bool_exp_bool_or_arguments_columns" columns of table "phone_numbers" */
export enum Phone_Numbers_Select_Column_Phone_Numbers_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVisibility = 'is_visibility',
  /** column name */
  Primary = 'primary',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "phone_numbers" */
export type Phone_Numbers_Set_Input = {
  is_visibility?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Phone_Numbers_Stddev_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "phone_numbers" */
export type Phone_Numbers_Stddev_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Phone_Numbers_Stddev_Pop_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "phone_numbers" */
export type Phone_Numbers_Stddev_Pop_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Phone_Numbers_Stddev_Samp_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "phone_numbers" */
export type Phone_Numbers_Stddev_Samp_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "phone_numbers" */
export type Phone_Numbers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Phone_Numbers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Phone_Numbers_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_visibility?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Phone_Number_Type_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
  verification_attempts?: InputMaybe<Scalars['Int']['input']>;
  verification_code?: InputMaybe<Scalars['Int']['input']>;
  verification_codes_sent?: InputMaybe<Scalars['Int']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate sum on columns */
export type Phone_Numbers_Sum_Fields = {
  verification_attempts?: Maybe<Scalars['Int']['output']>;
  verification_code?: Maybe<Scalars['Int']['output']>;
  verification_codes_sent?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "phone_numbers" */
export type Phone_Numbers_Sum_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** update columns of table "phone_numbers" */
export enum Phone_Numbers_Update_Column {
  /** column name */
  IsVisibility = 'is_visibility',
  /** column name */
  Number = 'number',
  /** column name */
  Primary = 'primary',
  /** column name */
  Type = 'type',
  /** column name */
  Verified = 'verified'
}

export type Phone_Numbers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Phone_Numbers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Phone_Numbers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Phone_Numbers_Var_Pop_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "phone_numbers" */
export type Phone_Numbers_Var_Pop_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Phone_Numbers_Var_Samp_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "phone_numbers" */
export type Phone_Numbers_Var_Samp_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Phone_Numbers_Variance_Fields = {
  verification_attempts?: Maybe<Scalars['Float']['output']>;
  verification_code?: Maybe<Scalars['Float']['output']>;
  verification_codes_sent?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "phone_numbers" */
export type Phone_Numbers_Variance_Order_By = {
  verification_attempts?: InputMaybe<Order_By>;
  verification_code?: InputMaybe<Order_By>;
  verification_codes_sent?: InputMaybe<Order_By>;
};

/** A tenant's pipelines. lead_type says what moves through them: sales for seller leads, buyer for buyer leads; financing is legacy. Their stages are in lead_stages. */
export type Pipelines = {
  created_at: Scalars['timestamptz']['output'];
  deletable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** computed label based on x-hasura-website-language session variable */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lead_type: Scalars['lead_type']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  stages: Array<Lead_Stages>;
  /** An aggregate relationship */
  stages_aggregate: Lead_Stages_Aggregate;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** A tenant's pipelines. lead_type says what moves through them: sales for seller leads, buyer for buyer leads; financing is legacy. Their stages are in lead_stages. */
export type PipelinesStagesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


/** A tenant's pipelines. lead_type says what moves through them: sales for seller leads, buyer for buyer leads; financing is legacy. Their stages are in lead_stages. */
export type PipelinesStages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};

/** aggregated selection of "pipelines" */
export type Pipelines_Aggregate = {
  aggregate?: Maybe<Pipelines_Aggregate_Fields>;
  nodes: Array<Pipelines>;
};

/** aggregate fields of "pipelines" */
export type Pipelines_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Pipelines_Max_Fields>;
  min?: Maybe<Pipelines_Min_Fields>;
};


/** aggregate fields of "pipelines" */
export type Pipelines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pipelines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "pipelines". All fields are combined with a logical 'AND'. */
export type Pipelines_Bool_Exp = {
  _and?: InputMaybe<Array<Pipelines_Bool_Exp>>;
  _not?: InputMaybe<Pipelines_Bool_Exp>;
  _or?: InputMaybe<Array<Pipelines_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deletable?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lead_type?: InputMaybe<Lead_Type_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  stages?: InputMaybe<Lead_Stages_Bool_Exp>;
  stages_aggregate?: InputMaybe<Lead_Stages_Aggregate_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "pipelines" */
export enum Pipelines_Constraint {
  /** unique or primary key constraint on columns "id" */
  PipelinesPkey = 'pipelines_pkey'
}

/** input type for inserting data into table "pipelines" */
export type Pipelines_Insert_Input = {
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stages?: InputMaybe<Lead_Stages_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Pipelines_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** computed label based on x-hasura-website-language session variable */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lead_type?: Maybe<Scalars['lead_type']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Pipelines_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** computed label based on x-hasura-website-language session variable */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lead_type?: Maybe<Scalars['lead_type']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "pipelines" */
export type Pipelines_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Pipelines>;
};

/** input type for inserting object relation for remote table "pipelines" */
export type Pipelines_Obj_Rel_Insert_Input = {
  data: Pipelines_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Pipelines_On_Conflict>;
};

/** on_conflict condition type for table "pipelines" */
export type Pipelines_On_Conflict = {
  constraint: Pipelines_Constraint;
  update_columns?: Array<Pipelines_Update_Column>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};

/** Ordering options when selecting data from "pipelines". */
export type Pipelines_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deletable?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lead_type?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  stages_aggregate?: InputMaybe<Lead_Stages_Aggregate_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pipelines */
export type Pipelines_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "pipelines" */
export enum Pipelines_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deletable = 'deletable',
  /** column name */
  Id = 'id',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  LeadType = 'lead_type',
  /** column name */
  Name = 'name',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "pipelines" */
export type Pipelines_Set_Input = {
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "pipelines" */
export type Pipelines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pipelines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pipelines_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deletable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  lead_type?: InputMaybe<Scalars['lead_type']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "pipelines" */
export enum Pipelines_Update_Column {
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  LeadType = 'lead_type',
  /** column name */
  Name = 'name'
}

export type Pipelines_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pipelines_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pipelines_Bool_Exp;
};

/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. Polish listing and price data stopped updating in June 2026. */
export type Pl_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pl_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pl_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<Pl_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Pl_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  state?: Maybe<Pl_States>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. Polish listing and price data stopped updating in June 2026. */
export type Pl_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. Polish listing and price data stopped updating in June 2026. */
export type Pl_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. Polish listing and price data stopped updating in June 2026. */
export type Pl_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. Polish listing and price data stopped updating in June 2026. */
export type Pl_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Pl_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Pl_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Pl_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Pl_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Pl_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Cma_Listings_Max_Fields>;
  min?: Maybe<Pl_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Pl_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Pl_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pl_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Pl_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Pl_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Pl_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Pl_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<Pl_States_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** columns and relationships of "cma_listings_distance" */
export type Pl_Cma_Listings_Distance = {
  distance_in_meters: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  listing?: Maybe<Pl_Cma_Listings>;
  listing_id: Scalars['Int']['output'];
  state_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_listings_distance" */
export type Pl_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Pl_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Pl_Cma_Listings_Distance>;
};

/** aggregate fields of "cma_listings_distance" */
export type Pl_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Pl_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Pl_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Pl_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Pl_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Pl_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "cma_listings_distance" */
export type Pl_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Pl_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  listing?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Pl_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "cma_listings_distance". */
export type Pl_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing?: InputMaybe<Pl_Cma_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings_distance" */
export enum Pl_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Pl_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Pl_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pl_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Pl_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pl_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Pl_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Pl_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state?: InputMaybe<Pl_States_Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Pl_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pl_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cma_rental_listings" */
export type Pl_Cma_Rental_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pl_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pl_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Pl_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_rental_listings_places" */
  places?: Maybe<Array<Pl_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pl_Cma_Rental_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pl_Cma_Rental_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pl_Cma_Rental_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pl_Cma_Rental_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_rental_listings" */
export type Pl_Cma_Rental_Listings_Aggregate = {
  aggregate?: Maybe<Pl_Cma_Rental_Listings_Aggregate_Fields>;
  nodes: Array<Pl_Cma_Rental_Listings>;
};

/** aggregate fields of "cma_rental_listings" */
export type Pl_Cma_Rental_Listings_Aggregate_Fields = {
  avg?: Maybe<Pl_Cma_Rental_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Cma_Rental_Listings_Max_Fields>;
  min?: Maybe<Pl_Cma_Rental_Listings_Min_Fields>;
  stddev?: Maybe<Pl_Cma_Rental_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Cma_Rental_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Cma_Rental_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Cma_Rental_Listings_Sum_Fields>;
  var_pop?: Maybe<Pl_Cma_Rental_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Cma_Rental_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pl_Cma_Rental_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_rental_listings" */
export type Pl_Cma_Rental_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Cma_Rental_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_Cma_Rental_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_rental_listings". All fields are combined with a logical 'AND'. */
export type Pl_Cma_Rental_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Cma_Rental_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pl_Cma_Rental_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Cma_Rental_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Pl_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Pl_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Cma_Rental_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pl_Cma_Rental_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_rental_listings". */
export type Pl_Cma_Rental_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pl_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Pl_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Pl_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_rental_listings" */
export enum Pl_Cma_Rental_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pl_Cma_Rental_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_Cma_Rental_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_Cma_Rental_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_Cma_Rental_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_Cma_Rental_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_Cma_Rental_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_Cma_Rental_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Pl_External_Transactions = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  source_payload?: Maybe<Scalars['jsonb']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};


/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Pl_External_TransactionsSource_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_transactions" */
export type Pl_External_Transactions_Aggregate = {
  aggregate?: Maybe<Pl_External_Transactions_Aggregate_Fields>;
  nodes: Array<Pl_External_Transactions>;
};

/** aggregate fields of "external_transactions" */
export type Pl_External_Transactions_Aggregate_Fields = {
  avg?: Maybe<Pl_External_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_External_Transactions_Max_Fields>;
  min?: Maybe<Pl_External_Transactions_Min_Fields>;
  stddev?: Maybe<Pl_External_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_External_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_External_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_External_Transactions_Sum_Fields>;
  var_pop?: Maybe<Pl_External_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_External_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Pl_External_Transactions_Variance_Fields>;
};


/** aggregate fields of "external_transactions" */
export type Pl_External_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_External_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_External_Transactions_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions". All fields are combined with a logical 'AND'. */
export type Pl_External_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_External_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Pl_External_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_External_Transactions_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** Rows returned by get_external_transactions_distance: a recorded sale and its distance_in_meters from the point asked. Data in France only. The table itself holds no row: call the function, with _lat and _lng always; nearest first unless _sort_field (with _sort_direction) is set. _max_distance_meters is 5 km by default and 50 km at most; pass _max_distance_meters: null to search a whole _postcode, bbox or _polygon_geojson beyond 5 km. _property_main_type, _cutoff_date and _cutoff_date_max, surfaces, rooms and price narrow further. At most 5000 rows (_max_results): a count over it stops there, so narrow the area or the dates for a large city. */
export type Pl_External_Transactions_Distance = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  distance_in_meters: Scalars['Float']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "external_transactions_distance" */
export type Pl_External_Transactions_Distance_Aggregate = {
  aggregate?: Maybe<Pl_External_Transactions_Distance_Aggregate_Fields>;
  nodes: Array<Pl_External_Transactions_Distance>;
};

/** aggregate fields of "external_transactions_distance" */
export type Pl_External_Transactions_Distance_Aggregate_Fields = {
  avg?: Maybe<Pl_External_Transactions_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_External_Transactions_Distance_Max_Fields>;
  min?: Maybe<Pl_External_Transactions_Distance_Min_Fields>;
  stddev?: Maybe<Pl_External_Transactions_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_External_Transactions_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_External_Transactions_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_External_Transactions_Distance_Sum_Fields>;
  var_pop?: Maybe<Pl_External_Transactions_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_External_Transactions_Distance_Var_Samp_Fields>;
  variance?: Maybe<Pl_External_Transactions_Distance_Variance_Fields>;
};


/** aggregate fields of "external_transactions_distance" */
export type Pl_External_Transactions_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_External_Transactions_Distance_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions_distance". All fields are combined with a logical 'AND'. */
export type Pl_External_Transactions_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_External_Transactions_Distance_Bool_Exp>>;
  _not?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_External_Transactions_Distance_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_External_Transactions_Distance_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pl_External_Transactions_Distance_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions_distance". */
export type Pl_External_Transactions_Distance_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions_distance" */
export enum Pl_External_Transactions_Distance_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Pl_External_Transactions_Distance_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_External_Transactions_Distance_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_External_Transactions_Distance_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_External_Transactions_Distance_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_External_Transactions_Distance_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_External_Transactions_Distance_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_External_Transactions_Distance_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Pl_External_Transactions_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pl_External_Transactions_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions". */
export type Pl_External_Transactions_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_payload?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions" */
export enum Pl_External_Transactions_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  SourcePayload = 'source_payload',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Pl_External_Transactions_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_External_Transactions_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_External_Transactions_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_External_Transactions_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_External_Transactions_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_External_Transactions_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_External_Transactions_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Pl_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Pl_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Pl_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Pl_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Pl_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Pl_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Pl_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Pl_Merged_Images_Aggregate = {
  aggregate?: Maybe<Pl_Merged_Images_Aggregate_Fields>;
  nodes: Array<Pl_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Pl_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Pl_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Merged_Images_Max_Fields>;
  min?: Maybe<Pl_Merged_Images_Min_Fields>;
  stddev?: Maybe<Pl_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Pl_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Pl_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Pl_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Pl_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Pl_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pl_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Pl_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Pl_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pl_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pl_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pl_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Pl_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pl_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Pl_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pl_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Pl_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Pl_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Pl_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pl_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Pl_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Pl_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Pl_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Pl_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Pl_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pl_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Pl_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pl_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Pl_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pl_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Pl_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pl_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Pl_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pl_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Pl_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pl_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Pl_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pl_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pl_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pl_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** Hidden from the public site by an admin (per listing, together with its duplicates). It does not say whether the listing is still online: see offline_since. */
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pl_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pl_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pl_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "merged_listings" */
export type Pl_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Pl_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Pl_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Pl_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Pl_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Merged_Listings_Max_Fields>;
  min?: Maybe<Pl_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Pl_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Pl_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pl_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Pl_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Pl_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pl_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Pl_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pl_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Pl_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pl_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Pl_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Pl_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Pl_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Pl_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Pl_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Pl_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<Pl_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: Pl_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_stats: Array<Pl_Price_Stats>;
  /** An aggregate relationship */
  price_stats_aggregate: Pl_Price_Stats_Aggregate;
  /** An array relationship */
  price_stats_historical: Array<Pl_Price_Stats_Historical>;
  /** An aggregate relationship */
  price_stats_historical_aggregate: Pl_Price_Stats_Historical_Aggregate;
  /** An array relationship */
  region: Array<Pl_Places>;
  /** An aggregate relationship */
  region_aggregate: Pl_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<Pl_Places>;
  /** An aggregate relationship */
  state_aggregate: Pl_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Pl_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Pl_Places_Aggregate;
  /** An array relationship */
  street_stats_locality: Array<Pl_Street_Stats>;
  /** An aggregate relationship */
  street_stats_locality_aggregate: Pl_Street_Stats_Aggregate;
  /** An array relationship */
  street_stats_municipality: Array<Pl_Street_Stats>;
  /** An aggregate relationship */
  street_stats_municipality_aggregate: Pl_Street_Stats_Aggregate;
  type: Scalars['String']['output'];
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesPrice_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesPrice_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesPrice_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesPrice_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesStreet_Stats_LocalityArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesStreet_Stats_Locality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesStreet_Stats_MunicipalityArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pl_PlacesStreet_Stats_Municipality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Pl_Places_Aggregate = {
  aggregate?: Maybe<Pl_Places_Aggregate_Fields>;
  nodes: Array<Pl_Places>;
};

/** aggregate fields of "places" */
export type Pl_Places_Aggregate_Fields = {
  avg?: Maybe<Pl_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Places_Max_Fields>;
  min?: Maybe<Pl_Places_Min_Fields>;
  stddev?: Maybe<Pl_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Places_Sum_Fields>;
  var_pop?: Maybe<Pl_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Places_Var_Samp_Fields>;
  variance?: Maybe<Pl_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Pl_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Pl_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Pl_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pl_Places_Max_Order_By>;
  min?: InputMaybe<Pl_Places_Min_Order_By>;
  stddev?: InputMaybe<Pl_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pl_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pl_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pl_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Pl_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pl_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Pl_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pl_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Pl_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Pl_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Places_Bool_Exp>>;
  _not?: InputMaybe<Pl_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Pl_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Pl_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Pl_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Pl_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_stats?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
  price_stats_historical?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
  region?: InputMaybe<Pl_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  slug_pl?: InputMaybe<String_Comparison_Exp>;
  slug_pt?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Pl_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Pl_Places_Bool_Exp>;
  street_stats_locality?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
  street_stats_municipality?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** For a municipality, a locality or a neighbourhood (place_id), the places it sits in (breadcrumb_place_id -> places): order_num 1 locality, 2 municipality, 3 state; the place itself and non-state aliases are left out, so a locality starts at 2. */
export type Pl_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Pl_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Pl_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Pl_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Pl_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Pl_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Pl_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Pl_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Pl_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Pl_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pl_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Pl_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Pl_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pl_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pl_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pl_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Pl_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pl_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Pl_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pl_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Pl_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Pl_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pl_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Pl_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Pl_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Pl_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Pl_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pl_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pl_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pl_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pl_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pl_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pl_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Pl_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Pl_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Pl_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pl_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Pl_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Pl_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Pl_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Pl_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Pl_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Pl_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<Pl_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_stats_aggregate?: InputMaybe<Pl_Price_Stats_Aggregate_Order_By>;
  price_stats_historical_aggregate?: InputMaybe<Pl_Price_Stats_Historical_Aggregate_Order_By>;
  region_aggregate?: InputMaybe<Pl_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<Pl_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Pl_Places_Aggregate_Order_By>;
  street_stats_locality_aggregate?: InputMaybe<Pl_Street_Stats_Aggregate_Order_By>;
  street_stats_municipality_aggregate?: InputMaybe<Pl_Street_Stats_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Pl_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  SlugPl = 'slug_pl',
  /** column name */
  SlugPt = 'slug_pt',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Pl_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Pl_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pl_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Pl_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pl_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Pl_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pl_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Pl_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pl_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Pl_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pl_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Pl_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pl_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Pl_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pl_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pl_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pl_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Pl_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Pl_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Pl_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pl_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pl_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pl_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pl_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "post_merged_listings" */
export type Pl_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Pl_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Pl_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Pl_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Pl_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Pl_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Pl_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Pl_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pl_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Pl_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Pl_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pl_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Pl_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Pl_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pl_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Pl_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pl_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Pl_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Pl_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Pl_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Pl_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pl_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Price estimates of a place: one row per place_id x property_main_type x number_of_rooms. number_of_rooms = 0 is all sizes; property_main_type is ANY (all types), HOUSE or APPT. sale_price_m2_50 is the modelled price per m2; _10 and _90 are that estimate scaled to a typical low and high, not percentiles of the place. monthly_rent_* is gross monthly rent, yearly_rent_m2_* yearly rent per m2. Rebuilt monthly. */
export type Pl_Price_Stats = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "price_stats" */
export type Pl_Price_Stats_Aggregate = {
  aggregate?: Maybe<Pl_Price_Stats_Aggregate_Fields>;
  nodes: Array<Pl_Price_Stats>;
};

/** aggregate fields of "price_stats" */
export type Pl_Price_Stats_Aggregate_Fields = {
  avg?: Maybe<Pl_Price_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Price_Stats_Max_Fields>;
  min?: Maybe<Pl_Price_Stats_Min_Fields>;
  stddev?: Maybe<Pl_Price_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Price_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Price_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Price_Stats_Sum_Fields>;
  var_pop?: Maybe<Pl_Price_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Price_Stats_Var_Samp_Fields>;
  variance?: Maybe<Pl_Price_Stats_Variance_Fields>;
};


/** aggregate fields of "price_stats" */
export type Pl_Price_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats" */
export type Pl_Price_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Pl_Price_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pl_Price_Stats_Max_Order_By>;
  min?: InputMaybe<Pl_Price_Stats_Min_Order_By>;
  stddev?: InputMaybe<Pl_Price_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pl_Price_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pl_Price_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pl_Price_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Pl_Price_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pl_Price_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Pl_Price_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pl_Price_Stats_Avg_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats" */
export type Pl_Price_Stats_Avg_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats". All fields are combined with a logical 'AND'. */
export type Pl_Price_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Price_Stats_Bool_Exp>>;
  _not?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Price_Stats_Bool_Exp>>;
  monthly_rent_10?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_50?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_90?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_type?: InputMaybe<Place_Type_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_count?: InputMaybe<Int_Comparison_Exp>;
  rent_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_price_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_90?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_90?: InputMaybe<Float_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  yearly_rent_m2_10?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_50?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_90?: InputMaybe<Float_Comparison_Exp>;
};

/** Modelled sale price per m2 of a place over time: one row per place_id x property_main_type x number_of_rooms x date. All property types is 'ALL' here, where price_stats says ANY; number_of_rooms = 0 is all sizes. Daily for countries, states, districts and agglomerations, monthly for municipalities and localities. Always filter place_id, property_main_type, number_of_rooms and a date range. */
export type Pl_Price_Stats_Historical = {
  date: Scalars['date']['output'];
  number_of_rooms: Scalars['Int']['output'];
  place_id: Scalars['uuid']['output'];
  property_main_type: Scalars['String']['output'];
  sale_price_m2: Scalars['Float']['output'];
};

/** aggregated selection of "price_stats_historical" */
export type Pl_Price_Stats_Historical_Aggregate = {
  aggregate?: Maybe<Pl_Price_Stats_Historical_Aggregate_Fields>;
  nodes: Array<Pl_Price_Stats_Historical>;
};

/** aggregate fields of "price_stats_historical" */
export type Pl_Price_Stats_Historical_Aggregate_Fields = {
  avg?: Maybe<Pl_Price_Stats_Historical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Price_Stats_Historical_Max_Fields>;
  min?: Maybe<Pl_Price_Stats_Historical_Min_Fields>;
  stddev?: Maybe<Pl_Price_Stats_Historical_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Price_Stats_Historical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Price_Stats_Historical_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Price_Stats_Historical_Sum_Fields>;
  var_pop?: Maybe<Pl_Price_Stats_Historical_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Price_Stats_Historical_Var_Samp_Fields>;
  variance?: Maybe<Pl_Price_Stats_Historical_Variance_Fields>;
};


/** aggregate fields of "price_stats_historical" */
export type Pl_Price_Stats_Historical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Price_Stats_Historical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Aggregate_Order_By = {
  avg?: InputMaybe<Pl_Price_Stats_Historical_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pl_Price_Stats_Historical_Max_Order_By>;
  min?: InputMaybe<Pl_Price_Stats_Historical_Min_Order_By>;
  stddev?: InputMaybe<Pl_Price_Stats_Historical_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pl_Price_Stats_Historical_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pl_Price_Stats_Historical_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pl_Price_Stats_Historical_Sum_Order_By>;
  var_pop?: InputMaybe<Pl_Price_Stats_Historical_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pl_Price_Stats_Historical_Var_Samp_Order_By>;
  variance?: InputMaybe<Pl_Price_Stats_Historical_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pl_Price_Stats_Historical_Avg_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Avg_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_historical". All fields are combined with a logical 'AND'. */
export type Pl_Price_Stats_Historical_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Price_Stats_Historical_Bool_Exp>>;
  _not?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Price_Stats_Historical_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  sale_price_m2?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Price_Stats_Historical_Max_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pl_Price_Stats_Historical_Min_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_historical". */
export type Pl_Price_Stats_Historical_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_historical" */
export enum Pl_Price_Stats_Historical_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  SalePriceM2 = 'sale_price_m2'
}

/** aggregate stddev on columns */
export type Pl_Price_Stats_Historical_Stddev_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Stddev_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pl_Price_Stats_Historical_Stddev_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Stddev_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pl_Price_Stats_Historical_Stddev_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Stddev_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pl_Price_Stats_Historical_Sum_Fields = {
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Sum_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pl_Price_Stats_Historical_Var_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Var_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pl_Price_Stats_Historical_Var_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Var_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pl_Price_Stats_Historical_Variance_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_historical" */
export type Pl_Price_Stats_Historical_Variance_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Pl_Price_Stats_Max_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats" */
export type Pl_Price_Stats_Max_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pl_Price_Stats_Min_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats" */
export type Pl_Price_Stats_Min_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats". */
export type Pl_Price_Stats_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats" */
export enum Pl_Price_Stats_Select_Column {
  /** column name */
  MonthlyRent_10 = 'monthly_rent_10',
  /** column name */
  MonthlyRent_50 = 'monthly_rent_50',
  /** column name */
  MonthlyRent_90 = 'monthly_rent_90',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PlaceParentId = 'place_parent_id',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentCount = 'rent_count',
  /** column name */
  RentCount_3month = 'rent_count_3month',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleCount_3month = 'sale_count_3month',
  /** column name */
  SalePrice_10 = 'sale_price_10',
  /** column name */
  SalePrice_50 = 'sale_price_50',
  /** column name */
  SalePrice_90 = 'sale_price_90',
  /** column name */
  SalePriceM2_10 = 'sale_price_m2_10',
  /** column name */
  SalePriceM2_50 = 'sale_price_m2_50',
  /** column name */
  SalePriceM2_90 = 'sale_price_m2_90',
  /** column name */
  Stock = 'stock',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  YearlyRentM2_10 = 'yearly_rent_m2_10',
  /** column name */
  YearlyRentM2_50 = 'yearly_rent_m2_50',
  /** column name */
  YearlyRentM2_90 = 'yearly_rent_m2_90'
}

/** aggregate stddev on columns */
export type Pl_Price_Stats_Stddev_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats" */
export type Pl_Price_Stats_Stddev_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pl_Price_Stats_Stddev_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats" */
export type Pl_Price_Stats_Stddev_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pl_Price_Stats_Stddev_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats" */
export type Pl_Price_Stats_Stddev_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pl_Price_Stats_Sum_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats" */
export type Pl_Price_Stats_Sum_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pl_Price_Stats_Var_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats" */
export type Pl_Price_Stats_Var_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pl_Price_Stats_Var_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats" */
export type Pl_Price_Stats_Var_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pl_Price_Stats_Variance_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats" */
export type Pl_Price_Stats_Variance_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_types" */
export type Pl_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Pl_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Pl_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Pl_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Pl_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "rental_cma_listings_distance" */
export type Pl_Rental_Cma_Listings_Distance = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  is_online?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  listing?: Maybe<Pl_Cma_Rental_Listings>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

export type Pl_Rental_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Pl_Rental_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Pl_Rental_Cma_Listings_Distance>;
};

/** aggregate fields of "rental_cma_listings_distance" */
export type Pl_Rental_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Pl_Rental_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Rental_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Pl_Rental_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Pl_Rental_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Rental_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Rental_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Rental_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Pl_Rental_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Rental_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Pl_Rental_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "rental_cma_listings_distance" */
export type Pl_Rental_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pl_Rental_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Pl_Rental_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float8_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  listing?: InputMaybe<Pl_Cma_Rental_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  net_rent_per_sqm?: InputMaybe<Float8_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Rental_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Pl_Rental_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "rental_cma_listings_distance". */
export type Pl_Rental_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  listing?: InputMaybe<Pl_Cma_Rental_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  net_rent_per_sqm?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_cma_listings_distance" */
export enum Pl_Rental_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  NetRentPerSqm = 'net_rent_per_sqm',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Pl_Rental_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pl_Rental_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pl_Rental_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pl_Rental_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Pl_Rental_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pl_Rental_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pl_Rental_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "states" */
export type Pl_States = {
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "states". All fields are combined with a logical 'AND'. */
export type Pl_States_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_States_Bool_Exp>>;
  _not?: InputMaybe<Pl_States_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_States_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "states". */
export type Pl_States_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "states" */
export enum Pl_States_Select_Column {
  /** column name */
  Name = 'name'
}

/** Sale price per m2 by street (route) within a municipality or locality: median, mean, 15th and 85th percentile, and total_count, the number of data points behind them. A street with a small total_count is noise: ask for at least 15. Rebuilt monthly. */
export type Pl_Street_Stats = {
  geom?: Maybe<Scalars['geometry']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  is_cross_locality?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  locality?: Maybe<Pl_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  municipality?: Maybe<Pl_Places>;
  municipality_id: Scalars['uuid']['output'];
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['uuid']['output'];
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "street_stats" */
export type Pl_Street_Stats_Aggregate = {
  aggregate?: Maybe<Pl_Street_Stats_Aggregate_Fields>;
  nodes: Array<Pl_Street_Stats>;
};

/** aggregate fields of "street_stats" */
export type Pl_Street_Stats_Aggregate_Fields = {
  avg?: Maybe<Pl_Street_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pl_Street_Stats_Max_Fields>;
  min?: Maybe<Pl_Street_Stats_Min_Fields>;
  stddev?: Maybe<Pl_Street_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Pl_Street_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pl_Street_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Pl_Street_Stats_Sum_Fields>;
  var_pop?: Maybe<Pl_Street_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Pl_Street_Stats_Var_Samp_Fields>;
  variance?: Maybe<Pl_Street_Stats_Variance_Fields>;
};


/** aggregate fields of "street_stats" */
export type Pl_Street_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "street_stats" */
export type Pl_Street_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Pl_Street_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pl_Street_Stats_Max_Order_By>;
  min?: InputMaybe<Pl_Street_Stats_Min_Order_By>;
  stddev?: InputMaybe<Pl_Street_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pl_Street_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pl_Street_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pl_Street_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Pl_Street_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pl_Street_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Pl_Street_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pl_Street_Stats_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "street_stats" */
export type Pl_Street_Stats_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "street_stats". All fields are combined with a logical 'AND'. */
export type Pl_Street_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Pl_Street_Stats_Bool_Exp>>;
  _not?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Pl_Street_Stats_Bool_Exp>>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  is_cross_locality?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  locality?: InputMaybe<Pl_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  mean_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  median_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  municipality?: InputMaybe<Pl_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  num_street_numbers?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_count?: InputMaybe<Int_Comparison_Exp>;
  upper_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pl_Street_Stats_Max_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "street_stats" */
export type Pl_Street_Stats_Max_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pl_Street_Stats_Min_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "street_stats" */
export type Pl_Street_Stats_Min_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "street_stats". */
export type Pl_Street_Stats_Order_By = {
  geom?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  is_cross_locality?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Pl_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Pl_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** select columns of table "street_stats" */
export enum Pl_Street_Stats_Select_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  IsCrossLocality = 'is_cross_locality',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  Lower_15PercentilePricePerM2 = 'lower_15_percentile_price_per_m2',
  /** column name */
  MeanPricePerM2 = 'mean_price_per_m2',
  /** column name */
  MedianPricePerM2 = 'median_price_per_m2',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NumStreetNumbers = 'num_street_numbers',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  Upper_15PercentilePricePerM2 = 'upper_15_percentile_price_per_m2'
}

/** aggregate stddev on columns */
export type Pl_Street_Stats_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "street_stats" */
export type Pl_Street_Stats_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pl_Street_Stats_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "street_stats" */
export type Pl_Street_Stats_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pl_Street_Stats_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "street_stats" */
export type Pl_Street_Stats_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pl_Street_Stats_Sum_Fields = {
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "street_stats" */
export type Pl_Street_Stats_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pl_Street_Stats_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "street_stats" */
export type Pl_Street_Stats_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pl_Street_Stats_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "street_stats" */
export type Pl_Street_Stats_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pl_Street_Stats_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "street_stats" */
export type Pl_Street_Stats_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

export type Place_By_Slug_Args = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Place_By_Type_Args = {
  hasura_type?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['uuid']['input']>;
  municipality?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['uuid']['input']>;
};

/** Boolean expression to compare columns of type "place_type". All fields are combined with logical 'AND'. */
export type Place_Type_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['place_type']['input']>;
  _gt?: InputMaybe<Scalars['place_type']['input']>;
  _gte?: InputMaybe<Scalars['place_type']['input']>;
  _in?: InputMaybe<Array<Scalars['place_type']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['place_type']['input']>;
  _lte?: InputMaybe<Scalars['place_type']['input']>;
  _neq?: InputMaybe<Scalars['place_type']['input']>;
  _nin?: InputMaybe<Array<Scalars['place_type']['input']>>;
};

export enum Place_Type_Enum_Enum {
  /** Agglomeration */
  Agglomeration = 'agglomeration',
  /** Сountry */
  Country = 'country',
  /** District */
  District = 'district',
  /** Locality */
  Locality = 'locality',
  /** Municipality */
  Municipality = 'municipality',
  /** Neighbourhood */
  Neighbourhood = 'neighbourhood',
  /** Postcode */
  Postcode = 'postcode',
  /** Region */
  Region = 'region',
  /** State */
  State = 'state'
}

/** Boolean expression to compare columns of type "place_type_enum_enum". All fields are combined with logical 'AND'. */
export type Place_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Place_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Place_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Place_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Place_Type_Enum_Enum>>;
};

/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type Places = {
  /** A computed field, executes function "places_agent_ranking" */
  agent_ranking?: Maybe<Array<Agents_Rankings>>;
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Places>;
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  children_bbox: Scalars['jsonb']['output'];
  /** An object relationship */
  country?: Maybe<Places>;
  country_code: Scalars['String']['output'];
  country_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  country_place?: Maybe<Places>;
  /** An object relationship */
  district?: Maybe<Places>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  hasura_type?: Maybe<Place_Type_Enum_Enum>;
  id: Scalars['uuid']['output'];
  /** to use instead of repetitive logic on client, x-hasura-website-language must be set */
  in_label?: Maybe<Scalars['String']['output']>;
  in_label_fr?: Maybe<Scalars['String']['output']>;
  index: Scalars['Boolean']['output'];
  index_rooms: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  /** An object relationship */
  locality?: Maybe<Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Places_Aggregate;
  name: Scalars['String']['output'];
  /** An object relationship */
  neighbourhood?: Maybe<Places>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  parent_places?: Maybe<Array<Places>>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  /** Gets all properties in a given place */
  properties?: Maybe<Array<Properties>>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  simplified_geom?: Maybe<Scalars['geometry']['output']>;
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  state?: Maybe<Places>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Places>;
  /** An aggregate relationship */
  state_places_aggregate: Places_Aggregate;
  /** A computed field, executes function "places_team_ranking" */
  team_ranking?: Maybe<Array<Teams_Rankings>>;
  type: Place_Type_Enum_Enum;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesAgent_RankingArgs = {
  args?: InputMaybe<Agent_Ranking_Places_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesParent_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** Geography from country down to neighbourhood and postcode; type says the level. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). */
export type PlacesTeam_RankingArgs = {
  args?: InputMaybe<Team_Ranking_Places_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};

export type Places_Agent_Ranking_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  hasura_session?: InputMaybe<Scalars['json']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  place_row?: InputMaybe<Scalars['places_scalar']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

/** aggregated selection of "places" */
export type Places_Aggregate = {
  aggregate?: Maybe<Places_Aggregate_Fields>;
  nodes: Array<Places>;
};

export type Places_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Places_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Places_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Places_Aggregate_Bool_Exp_Count>;
};

export type Places_Aggregate_Bool_Exp_Bool_And = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Places_Select_Column_Places_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Places_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Places_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "places" */
export type Places_Aggregate_Fields = {
  avg?: Maybe<Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Places_Max_Fields>;
  min?: Maybe<Places_Min_Fields>;
  stddev?: Maybe<Places_Stddev_Fields>;
  stddev_pop?: Maybe<Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Places_Stddev_Samp_Fields>;
  sum?: Maybe<Places_Sum_Fields>;
  var_pop?: Maybe<Places_Var_Pop_Fields>;
  var_samp?: Maybe<Places_Var_Samp_Fields>;
  variance?: Maybe<Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Places_Aggregate_Order_By = {
  avg?: InputMaybe<Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Places_Max_Order_By>;
  min?: InputMaybe<Places_Min_Order_By>;
  stddev?: InputMaybe<Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Places_Sum_Order_By>;
  var_pop?: InputMaybe<Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Places_Bool_Exp = {
  _and?: InputMaybe<Array<Places_Bool_Exp>>;
  _not?: InputMaybe<Places_Bool_Exp>;
  _or?: InputMaybe<Array<Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Places_Bool_Exp>;
  catchment_areas?: InputMaybe<Catchment_Areas_Bool_Exp>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  country?: InputMaybe<Places_Bool_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  country_place?: InputMaybe<Places_Bool_Exp>;
  district?: InputMaybe<Places_Bool_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  hasura_type?: InputMaybe<Place_Type_Enum_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  in_label?: InputMaybe<String_Comparison_Exp>;
  in_label_fr?: InputMaybe<String_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  index_rooms?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Places_Bool_Exp>;
  municipality_places_aggregate?: InputMaybe<Places_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  parent_places?: InputMaybe<Places_Bool_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  properties?: InputMaybe<Properties_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  simplified_geom?: InputMaybe<Geometry_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  slug_pl?: InputMaybe<String_Comparison_Exp>;
  slug_pt?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Places_Bool_Exp>;
  state_places_aggregate?: InputMaybe<Places_Aggregate_Bool_Exp>;
  type?: InputMaybe<Place_Type_Enum_Enum_Comparison_Exp>;
};

/** aggregate max on columns */
export type Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** to use instead of repetitive logic on client, x-hasura-website-language must be set */
  in_label?: Maybe<Scalars['String']['output']>;
  in_label_fr?: Maybe<Scalars['String']['output']>;
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places" */
export type Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_label_fr?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** to use instead of repetitive logic on client, x-hasura-website-language must be set */
  in_label?: Maybe<Scalars['String']['output']>;
  in_label_fr?: Maybe<Scalars['String']['output']>;
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places" */
export type Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_label_fr?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Places_Order_By>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  country?: InputMaybe<Places_Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  country_place?: InputMaybe<Places_Order_By>;
  district?: InputMaybe<Places_Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  hasura_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  in_label?: InputMaybe<Order_By>;
  in_label_fr?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  index_rooms?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood?: InputMaybe<Places_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  parent_places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  properties_aggregate?: InputMaybe<Properties_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  simplified_geom?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state?: InputMaybe<Places_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  HasuraType = 'hasura_type',
  /** column name */
  Id = 'id',
  /** column name */
  InLabelFr = 'in_label_fr',
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SimplifiedGeom = 'simplified_geom',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  SlugPl = 'slug_pl',
  /** column name */
  SlugPt = 'slug_pt',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** select "places_aggregate_bool_exp_bool_and_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms'
}

/** select "places_aggregate_bool_exp_bool_or_arguments_columns" columns of table "places" */
export enum Places_Select_Column_Places_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Index = 'index',
  /** column name */
  IndexRooms = 'index_rooms'
}

/** aggregate stddev on columns */
export type Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "places" */
export type Places_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Places_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Places_Stream_Cursor_Value_Input = {
  agglomeration_id?: InputMaybe<Scalars['uuid']['input']>;
  canonical_id?: InputMaybe<Scalars['uuid']['input']>;
  children_bbox?: InputMaybe<Scalars['jsonb']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  extra?: InputMaybe<Scalars['jsonb']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  hasura_type?: InputMaybe<Place_Type_Enum_Enum>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  in_label_fr?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  index_rooms?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  population?: InputMaybe<Scalars['Int']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  search_base?: InputMaybe<Scalars['tsvector']['input']>;
  simplified_geom?: InputMaybe<Scalars['geometry']['input']>;
  slug_de?: InputMaybe<Scalars['String']['input']>;
  slug_en?: InputMaybe<Scalars['String']['input']>;
  slug_es?: InputMaybe<Scalars['String']['input']>;
  slug_fr?: InputMaybe<Scalars['String']['input']>;
  slug_it?: InputMaybe<Scalars['String']['input']>;
  slug_pl?: InputMaybe<Scalars['String']['input']>;
  slug_pt?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Place_Type_Enum_Enum>;
};

/** aggregate sum on columns */
export type Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** columns and relationships of "pois" */
export type Pois = {
  category: Scalars['String']['output'];
  formatted_address: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  name: Scalars['String']['output'];
  primary_type: Scalars['String']['output'];
  /** An array relationship */
  property_pois: Array<Property_Pois>;
  types: Array<Scalars['String']['output']>;
};


/** columns and relationships of "pois" */
export type PoisProperty_PoisArgs = {
  distinct_on?: InputMaybe<Array<Property_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Pois_Order_By>>;
  where?: InputMaybe<Property_Pois_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "pois". All fields are combined with a logical 'AND'. */
export type Pois_Bool_Exp = {
  _and?: InputMaybe<Array<Pois_Bool_Exp>>;
  _not?: InputMaybe<Pois_Bool_Exp>;
  _or?: InputMaybe<Array<Pois_Bool_Exp>>;
  category?: InputMaybe<String_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  primary_type?: InputMaybe<String_Comparison_Exp>;
  property_pois?: InputMaybe<Property_Pois_Bool_Exp>;
  types?: InputMaybe<String_Array_Comparison_Exp>;
};

/** Ordering options when selecting data from "pois". */
export type Pois_Order_By = {
  category?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  primary_type?: InputMaybe<Order_By>;
  property_pois_aggregate?: InputMaybe<Property_Pois_Aggregate_Order_By>;
  types?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "portal_idx_protocol". All fields are combined with logical 'AND'. */
export type Portal_Idx_Protocol_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _gte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _in?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _lte?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _neq?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  _nin?: InputMaybe<Array<Scalars['portal_idx_protocol']['input']>>;
};

/** Publication of a listing on a portal: lot_id -> lots, portal_id -> portals. live = true is published there now; last_publication_warnings holds the warnings of the last publication. */
export type Portal_Listings = {
  created_at: Scalars['timestamptz']['output'];
  external_property_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  last_publication_warnings?: Maybe<Scalars['jsonb']['output']>;
  live: Scalars['Boolean']['output'];
  /** An object relationship */
  lot: Lots;
  lot_id: Scalars['uuid']['output'];
  milliseconds_online: Scalars['Float']['output'];
  /** An object relationship */
  portal: Portals;
  portal_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};


/** Publication of a listing on a portal: lot_id -> lots, portal_id -> portals. live = true is published there now; last_publication_warnings holds the warnings of the last publication. */
export type Portal_ListingsLast_Publication_WarningsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "portal_listings" */
export type Portal_Listings_Aggregate = {
  aggregate?: Maybe<Portal_Listings_Aggregate_Fields>;
  nodes: Array<Portal_Listings>;
};

export type Portal_Listings_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp_Count>;
};

export type Portal_Listings_Aggregate_Bool_Exp_Bool_And = {
  arguments: Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Portal_Listings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Portal_Listings_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Portal_Listings_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Portal_Listings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Portal_Listings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "portal_listings" */
export type Portal_Listings_Aggregate_Fields = {
  avg?: Maybe<Portal_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Portal_Listings_Max_Fields>;
  min?: Maybe<Portal_Listings_Min_Fields>;
  stddev?: Maybe<Portal_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Portal_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Portal_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Portal_Listings_Sum_Fields>;
  var_pop?: Maybe<Portal_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Portal_Listings_Var_Samp_Fields>;
  variance?: Maybe<Portal_Listings_Variance_Fields>;
};


/** aggregate fields of "portal_listings" */
export type Portal_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "portal_listings" */
export type Portal_Listings_Aggregate_Order_By = {
  avg?: InputMaybe<Portal_Listings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Portal_Listings_Max_Order_By>;
  min?: InputMaybe<Portal_Listings_Min_Order_By>;
  stddev?: InputMaybe<Portal_Listings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Portal_Listings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Portal_Listings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Portal_Listings_Sum_Order_By>;
  var_pop?: InputMaybe<Portal_Listings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Portal_Listings_Var_Samp_Order_By>;
  variance?: InputMaybe<Portal_Listings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "portal_listings" */
export type Portal_Listings_Arr_Rel_Insert_Input = {
  data: Array<Portal_Listings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Portal_Listings_On_Conflict>;
};

/** aggregate avg on columns */
export type Portal_Listings_Avg_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "portal_listings" */
export type Portal_Listings_Avg_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "portal_listings". All fields are combined with a logical 'AND'. */
export type Portal_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Portal_Listings_Bool_Exp>>;
  _not?: InputMaybe<Portal_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Portal_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  external_property_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_publication_warnings?: InputMaybe<Jsonb_Comparison_Exp>;
  live?: InputMaybe<Boolean_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  milliseconds_online?: InputMaybe<Float_Comparison_Exp>;
  portal?: InputMaybe<Portals_Bool_Exp>;
  portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "portal_listings" */
export enum Portal_Listings_Constraint {
  /** unique or primary key constraint on columns "id" */
  PortalListingsPkey = 'portal_listings_pkey',
  /** unique or primary key constraint on columns "portal_id", "external_property_id" */
  PortalListingsPortalIdExternalPropertyIdKey = 'portal_listings_portal_id_external_property_id_key',
  /** unique or primary key constraint on columns "lot_id", "portal_id" */
  PortalListingsPortalIdLotIdKey = 'portal_listings_portal_id_lot_id_key'
}

/** input type for inserting data into table "portal_listings" */
export type Portal_Listings_Insert_Input = {
  external_property_id?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  portal?: InputMaybe<Portals_Obj_Rel_Insert_Input>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Portal_Listings_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_property_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "portal_listings" */
export type Portal_Listings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_property_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  milliseconds_online?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Portal_Listings_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  external_property_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
  portal_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "portal_listings" */
export type Portal_Listings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_property_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  milliseconds_online?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "portal_listings" */
export type Portal_Listings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Portal_Listings>;
};

/** on_conflict condition type for table "portal_listings" */
export type Portal_Listings_On_Conflict = {
  constraint: Portal_Listings_Constraint;
  update_columns?: Array<Portal_Listings_Update_Column>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};

/** Ordering options when selecting data from "portal_listings". */
export type Portal_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  external_property_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_publication_warnings?: InputMaybe<Order_By>;
  live?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  milliseconds_online?: InputMaybe<Order_By>;
  portal?: InputMaybe<Portals_Order_By>;
  portal_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: portal_listings */
export type Portal_Listings_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "portal_listings" */
export enum Portal_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExternalPropertyId = 'external_property_id',
  /** column name */
  Id = 'id',
  /** column name */
  LastPublicationWarnings = 'last_publication_warnings',
  /** column name */
  Live = 'live',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  MillisecondsOnline = 'milliseconds_online',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "portal_listings_aggregate_bool_exp_bool_and_arguments_columns" columns of table "portal_listings" */
export enum Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Live = 'live'
}

/** select "portal_listings_aggregate_bool_exp_bool_or_arguments_columns" columns of table "portal_listings" */
export enum Portal_Listings_Select_Column_Portal_Listings_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Live = 'live'
}

/** input type for updating data in table "portal_listings" */
export type Portal_Listings_Set_Input = {
  external_property_id?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate stddev on columns */
export type Portal_Listings_Stddev_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "portal_listings" */
export type Portal_Listings_Stddev_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Portal_Listings_Stddev_Pop_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "portal_listings" */
export type Portal_Listings_Stddev_Pop_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Portal_Listings_Stddev_Samp_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "portal_listings" */
export type Portal_Listings_Stddev_Samp_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "portal_listings" */
export type Portal_Listings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portal_Listings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portal_Listings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  external_property_id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_publication_warnings?: InputMaybe<Scalars['jsonb']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  milliseconds_online?: InputMaybe<Scalars['Float']['input']>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Portal_Listings_Sum_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "portal_listings" */
export type Portal_Listings_Sum_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** update columns of table "portal_listings" */
export enum Portal_Listings_Update_Column {
  /** column name */
  ExternalPropertyId = 'external_property_id',
  /** column name */
  Live = 'live'
}

export type Portal_Listings_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Portal_Listings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Portal_Listings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Portal_Listings_Var_Pop_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "portal_listings" */
export type Portal_Listings_Var_Pop_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Portal_Listings_Var_Samp_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "portal_listings" */
export type Portal_Listings_Var_Samp_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Portal_Listings_Variance_Fields = {
  milliseconds_online?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "portal_listings" */
export type Portal_Listings_Variance_Order_By = {
  milliseconds_online?: InputMaybe<Order_By>;
};

/** A portal listings are published to, owned by a tenant or a team (team_id -> teams): name, type and active. Teams are also given portals through teams_portals. The listings published through it are in portal_listings. */
export type Portals = {
  active: Scalars['Boolean']['output'];
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  exact_address_required: Scalars['Boolean']['output'];
  exclude_from_published_stats: Scalars['Boolean']['output'];
  has_top_premium_listing?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  idx_protocol: Scalars['portal_idx_protocol']['output'];
  increment: Scalars['Int']['output'];
  /** An object relationship */
  logo?: Maybe<Images>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  master_portal_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  quota?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  shared_portal?: Maybe<Shared_Portals>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  type: Portals_Types_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};


/** A portal listings are published to, owned by a tenant or a team (team_id -> teams): name, type and active. Teams are also given portals through teams_portals. The listings published through it are in portal_listings. */
export type PortalsEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** A portal listings are published to, owned by a tenant or a team (team_id -> teams): name, type and active. Teams are also given portals through teams_portals. The listings published through it are in portal_listings. */
export type PortalsEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** A portal listings are published to, owned by a tenant or a team (team_id -> teams): name, type and active. Teams are also given portals through teams_portals. The listings published through it are in portal_listings. */
export type PortalsPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** A portal listings are published to, owned by a tenant or a team (team_id -> teams): name, type and active. Teams are also given portals through teams_portals. The listings published through it are in portal_listings. */
export type PortalsPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


/** A portal listings are published to, owned by a tenant or a team (team_id -> teams): name, type and active. Teams are also given portals through teams_portals. The listings published through it are in portal_listings. */
export type PortalsTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};

/** aggregated selection of "portals" */
export type Portals_Aggregate = {
  aggregate?: Maybe<Portals_Aggregate_Fields>;
  nodes: Array<Portals>;
};

/** aggregate fields of "portals" */
export type Portals_Aggregate_Fields = {
  avg?: Maybe<Portals_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Portals_Max_Fields>;
  min?: Maybe<Portals_Min_Fields>;
  stddev?: Maybe<Portals_Stddev_Fields>;
  stddev_pop?: Maybe<Portals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Portals_Stddev_Samp_Fields>;
  sum?: Maybe<Portals_Sum_Fields>;
  var_pop?: Maybe<Portals_Var_Pop_Fields>;
  var_samp?: Maybe<Portals_Var_Samp_Fields>;
  variance?: Maybe<Portals_Variance_Fields>;
};


/** aggregate fields of "portals" */
export type Portals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Portals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Portals_Avg_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "portals". All fields are combined with a logical 'AND'. */
export type Portals_Bool_Exp = {
  _and?: InputMaybe<Array<Portals_Bool_Exp>>;
  _not?: InputMaybe<Portals_Bool_Exp>;
  _or?: InputMaybe<Array<Portals_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  contract_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  exact_address_required?: InputMaybe<Boolean_Comparison_Exp>;
  exclude_from_published_stats?: InputMaybe<Boolean_Comparison_Exp>;
  has_top_premium_listing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_protocol?: InputMaybe<Portal_Idx_Protocol_Comparison_Exp>;
  increment?: InputMaybe<Int_Comparison_Exp>;
  logo?: InputMaybe<Images_Bool_Exp>;
  logo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  master_portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  port?: InputMaybe<Int_Comparison_Exp>;
  portal_listings?: InputMaybe<Portal_Listings_Bool_Exp>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Bool_Exp>;
  quota?: InputMaybe<Int_Comparison_Exp>;
  shared_portal?: InputMaybe<Shared_Portals_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams_portals?: InputMaybe<Teams_Portals_Bool_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Portals_Types_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "portals" */
export enum Portals_Constraint {
  /** unique or primary key constraint on columns "increment" */
  PortalsIncrementKey = 'portals_increment_key',
  /** unique or primary key constraint on columns "id" */
  RealEstatePortalsPkey = 'real_estate_portals_pkey'
}

/** input type for incrementing numeric columns in table "portals" */
export type Portals_Inc_Input = {
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "portals" */
export type Portals_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enquiries?: InputMaybe<Enquiries_Arr_Rel_Insert_Input>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  logo?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  portal_listings?: InputMaybe<Portal_Listings_Arr_Rel_Insert_Input>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  teams_portals?: InputMaybe<Teams_Portals_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Portals_Types_Enum_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Portals_Max_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  increment?: Maybe<Scalars['Int']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  master_portal_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Portals_Min_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  increment?: Maybe<Scalars['Int']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  master_portal_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "portals" */
export type Portals_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Portals>;
};

/** input type for inserting object relation for remote table "portals" */
export type Portals_Obj_Rel_Insert_Input = {
  data: Portals_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Portals_On_Conflict>;
};

/** on_conflict condition type for table "portals" */
export type Portals_On_Conflict = {
  constraint: Portals_Constraint;
  update_columns?: Array<Portals_Update_Column>;
  where?: InputMaybe<Portals_Bool_Exp>;
};

/** Ordering options when selecting data from "portals". */
export type Portals_Order_By = {
  active?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  exact_address_required?: InputMaybe<Order_By>;
  exclude_from_published_stats?: InputMaybe<Order_By>;
  has_top_premium_listing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_protocol?: InputMaybe<Order_By>;
  increment?: InputMaybe<Order_By>;
  logo?: InputMaybe<Images_Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  master_portal_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  port?: InputMaybe<Order_By>;
  portal_listings_aggregate?: InputMaybe<Portal_Listings_Aggregate_Order_By>;
  quota?: InputMaybe<Order_By>;
  shared_portal?: InputMaybe<Shared_Portals_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  teams_portals_aggregate?: InputMaybe<Teams_Portals_Aggregate_Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: portals */
export type Portals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "portals" */
export enum Portals_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  ExcludeFromPublishedStats = 'exclude_from_published_stats',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  Increment = 'increment',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MasterPortalId = 'master_portal_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** input type for updating data in table "portals" */
export type Portals_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Portals_Types_Enum_Enum>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Portals_Stddev_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Portals_Stddev_Pop_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Portals_Stddev_Samp_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "portals" */
export type Portals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portals_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  exclude_from_published_stats?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  master_portal_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Portals_Types_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Portals_Sum_Fields = {
  increment?: Maybe<Scalars['Int']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
};

/** columns and relationships of "portals_types_enum" */
export type Portals_Types_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "portals_types_enum". All fields are combined with a logical 'AND'. */
export type Portals_Types_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Portals_Types_Enum_Bool_Exp>>;
  _not?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Portals_Types_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Portals_Types_Enum_Enum {
  Api = 'api',
  Comparis = 'comparis',
  Fotocasa = 'fotocasa',
  Idealista = 'idealista',
  Idx = 'idx',
  Pisos = 'pisos',
  Shared = 'shared'
}

/** Boolean expression to compare columns of type "portals_types_enum_enum". All fields are combined with logical 'AND'. */
export type Portals_Types_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Portals_Types_Enum_Enum>;
  _in?: InputMaybe<Array<Portals_Types_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Portals_Types_Enum_Enum>;
  _nin?: InputMaybe<Array<Portals_Types_Enum_Enum>>;
};

/** Ordering options when selecting data from "portals_types_enum". */
export type Portals_Types_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "portals_types_enum" */
export enum Portals_Types_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "portals_types_enum" */
export type Portals_Types_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Portals_Types_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Portals_Types_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "portals" */
export enum Portals_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  ExcludeFromPublishedStats = 'exclude_from_published_stats',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MasterPortalId = 'master_portal_id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Type = 'type',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

export type Portals_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Portals_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Portals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Portals_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Portals_Var_Pop_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Portals_Var_Samp_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Portals_Variance_Fields = {
  increment?: Maybe<Scalars['Float']['output']>;
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "profile_enquiry_contacts_view" */
export type Profile_Enquiry_Contacts_View = {
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "profile_enquiry_contacts_view". All fields are combined with a logical 'AND'. */
export type Profile_Enquiry_Contacts_View_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Enquiry_Contacts_View_Bool_Exp>>;
  _not?: InputMaybe<Profile_Enquiry_Contacts_View_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Enquiry_Contacts_View_Bool_Exp>>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "profile_enquiry_contacts_view". */
export type Profile_Enquiry_Contacts_View_Order_By = {
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
};

/** columns and relationships of "profile_lead_enquiry_markers" */
export type Profile_Lead_Enquiry_Markers = {
  enquiry_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "profile_lead_enquiry_markers". All fields are combined with a logical 'AND'. */
export type Profile_Lead_Enquiry_Markers_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Lead_Enquiry_Markers_Bool_Exp>>;
  _not?: InputMaybe<Profile_Lead_Enquiry_Markers_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Lead_Enquiry_Markers_Bool_Exp>>;
  enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "profile_lead_enquiry_markers". */
export type Profile_Lead_Enquiry_Markers_Order_By = {
  enquiry_id?: InputMaybe<Order_By>;
};

/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type Properties = {
  /** A computed field, executes function "properties_agent_ranking" */
  agent_ranking?: Maybe<Array<Agents_Rankings>>;
  /** An array relationship */
  appraisals: Array<Appraisals>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  basement_surface?: Maybe<Scalars['Float']['output']>;
  bed_type?: Maybe<Bed_Type_Enum_Enum>;
  borrower_lead_id?: Maybe<Scalars['uuid']['output']>;
  building_condition?: Maybe<Scalars['Float']['output']>;
  building_standard?: Maybe<Scalars['Float']['output']>;
  building_volume?: Maybe<Scalars['Float']['output']>;
  building_volume_norm?: Maybe<Scalars['String']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  ceiling_height?: Maybe<Scalars['Float']['output']>;
  charges?: Maybe<Scalars['Float']['output']>;
  /** An array relationship */
  cma_reports: Array<Cma_Reports>;
  /** An aggregate relationship */
  cma_reports_aggregate: Cma_Reports_Aggregate;
  commercial_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  commercial_surface?: Maybe<Scalars['Float']['output']>;
  commercial_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  consumption?: Maybe<Scalars['Int']['output']>;
  cooling?: Maybe<Cooling_Enum_Enum>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  ctn?: Maybe<Scalars['String']['output']>;
  deleted_by_user: Scalars['Boolean']['output'];
  distance_to_airport?: Maybe<Scalars['Float']['output']>;
  distance_to_city_center?: Maybe<Scalars['Float']['output']>;
  distance_to_grocery_shop?: Maybe<Scalars['Float']['output']>;
  distance_to_high_school?: Maybe<Scalars['Float']['output']>;
  distance_to_hospital?: Maybe<Scalars['Float']['output']>;
  distance_to_kindergarten?: Maybe<Scalars['Float']['output']>;
  distance_to_motorway?: Maybe<Scalars['Float']['output']>;
  distance_to_primary_school?: Maybe<Scalars['Float']['output']>;
  distance_to_public_transport?: Maybe<Scalars['Float']['output']>;
  distance_to_sports_center?: Maybe<Scalars['Float']['output']>;
  distance_to_train_station?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  district_place?: Maybe<Places>;
  emissions?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_consumption_class?: Maybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: Maybe<Scalars['date']['output']>;
  energy_reference_year?: Maybe<Scalars['Int']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Int']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Int']['output']>;
  financing_institution_id?: Maybe<Scalars['uuid']['output']>;
  flat_condition?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  gas_emissions_class?: Maybe<Energy_Class_Type_Enum_Enum>;
  geom?: Maybe<Scalars['geometry']['output']>;
  /** An object relationship */
  google_address?: Maybe<Google_Addresses>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  gross_floor_surface?: Maybe<Scalars['Float']['output']>;
  has_attic?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_gym?: Maybe<Scalars['Boolean']['output']>;
  has_photovoltaic_panels?: Maybe<Scalars['Boolean']['output']>;
  has_sauna?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_wellness_area?: Maybe<Scalars['Boolean']['output']>;
  heating?: Maybe<Heating_Enum_Enum>;
  heating_distribution?: Maybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  income_includes_parking?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_commercial_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_luxury?: Maybe<Scalars['Boolean']['output']>;
  is_maisonette?: Maybe<Scalars['Boolean']['output']>;
  is_new_development: Scalars['Boolean']['output'];
  is_oriented_east: Scalars['Boolean']['output'];
  is_oriented_north: Scalars['Boolean']['output'];
  is_oriented_south: Scalars['Boolean']['output'];
  is_oriented_west: Scalars['Boolean']['output'];
  is_parking_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_rental?: Maybe<Scalars['Boolean']['output']>;
  is_residential_fully_rented?: Maybe<Scalars['Boolean']['output']>;
  is_secondary_residence?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  /** An object relationship */
  latest_appraisal?: Maybe<Appraisals>;
  latest_appraisal_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "properties_lead_agent_ranking" */
  lead_agent_ranking?: Maybe<Array<Agents_Rankings>>;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_place?: Maybe<Places>;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  macro_location?: Maybe<Scalars['Float']['output']>;
  micro_location?: Maybe<Scalars['Float']['output']>;
  minergie_code?: Maybe<Scalars['Int']['output']>;
  monthly_gross_rent?: Maybe<Scalars['Float']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality_place?: Maybe<Places>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  neighbourhood_place?: Maybe<Places>;
  number_of_bathrooms?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_commercial_units?: Maybe<Scalars['Int']['output']>;
  number_of_flats?: Maybe<Scalars['Int']['output']>;
  number_of_floors?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_lifts?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_residential_units?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  ownership_form?: Maybe<Scalars['String']['output']>;
  parking_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  parking_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  perceived_value?: Maybe<Scalars['Float']['output']>;
  places?: Maybe<Array<Places>>;
  plot_has_constructible_reserve?: Maybe<Scalars['Boolean']['output']>;
  plot_is_constructible?: Maybe<Scalars['Boolean']['output']>;
  plot_number?: Maybe<Scalars['String']['output']>;
  plot_registry_number?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_files: Array<Property_Files>;
  /** An aggregate relationship */
  property_files_aggregate: Property_Files_Aggregate;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** An array relationship */
  property_pois: Array<Property_Pois>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** An object relationship */
  property_type?: Maybe<Property_Types>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  relevant_servitudes?: Maybe<Scalars['Boolean']['output']>;
  renovation_fund?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  residential_potential_rental_income?: Maybe<Scalars['Float']['output']>;
  residential_surface?: Maybe<Scalars['Float']['output']>;
  residential_yearly_rental_income?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  share_of_ownership?: Maybe<Scalars['Float']['output']>;
  side?: Maybe<Property_Side_Enum_Enum>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  state_place?: Maybe<Places>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  weighted_floor_surface?: Maybe<Scalars['Float']['output']>;
  window_view?: Maybe<Window_View_Enum_Enum>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesAgent_RankingArgs = {
  args?: InputMaybe<Agent_Ranking_Properties_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesAppraisalsArgs = {
  distinct_on?: InputMaybe<Array<Appraisals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Order_By>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesCma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesCma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesLead_Agent_RankingArgs = {
  args?: InputMaybe<Lead_Agent_Ranking_Properties_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesProperty_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesProperty_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesProperty_PoisArgs = {
  distinct_on?: InputMaybe<Array<Property_Pois_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Pois_Order_By>>;
  where?: InputMaybe<Property_Pois_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** A physical property: address, place ids (locality_id, municipality_id, state_id -> places), surfaces in m2 and features. Shared by leads, lots, cma_reports and property_transactions. */
export type PropertiesProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};

/** order by aggregate values of table "properties" */
export type Properties_Aggregate_Order_By = {
  avg?: InputMaybe<Properties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Properties_Max_Order_By>;
  min?: InputMaybe<Properties_Min_Order_By>;
  stddev?: InputMaybe<Properties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Properties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Properties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Properties_Sum_Order_By>;
  var_pop?: InputMaybe<Properties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Properties_Var_Samp_Order_By>;
  variance?: InputMaybe<Properties_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "properties" */
export type Properties_Arr_Rel_Insert_Input = {
  data: Array<Properties_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Properties_On_Conflict>;
};

/** order by avg() on columns of table "properties" */
export type Properties_Avg_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "properties". All fields are combined with a logical 'AND'. */
export type Properties_Bool_Exp = {
  _and?: InputMaybe<Array<Properties_Bool_Exp>>;
  _not?: InputMaybe<Properties_Bool_Exp>;
  _or?: InputMaybe<Array<Properties_Bool_Exp>>;
  appraisals?: InputMaybe<Appraisals_Bool_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  basement_surface?: InputMaybe<Float_Comparison_Exp>;
  bed_type?: InputMaybe<Bed_Type_Enum_Enum_Comparison_Exp>;
  borrower_lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  building_condition?: InputMaybe<Float_Comparison_Exp>;
  building_standard?: InputMaybe<Float_Comparison_Exp>;
  building_volume?: InputMaybe<Float_Comparison_Exp>;
  building_volume_norm?: InputMaybe<String_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  ceiling_height?: InputMaybe<Float_Comparison_Exp>;
  charges?: InputMaybe<Float_Comparison_Exp>;
  cma_reports?: InputMaybe<Cma_Reports_Bool_Exp>;
  cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp>;
  commercial_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  commercial_surface?: InputMaybe<Float_Comparison_Exp>;
  commercial_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  consumption?: InputMaybe<Int_Comparison_Exp>;
  cooling?: InputMaybe<Cooling_Enum_Enum_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  ctn?: InputMaybe<String_Comparison_Exp>;
  deleted_by_user?: InputMaybe<Boolean_Comparison_Exp>;
  distance_to_airport?: InputMaybe<Float_Comparison_Exp>;
  distance_to_city_center?: InputMaybe<Float_Comparison_Exp>;
  distance_to_grocery_shop?: InputMaybe<Float_Comparison_Exp>;
  distance_to_high_school?: InputMaybe<Float_Comparison_Exp>;
  distance_to_hospital?: InputMaybe<Float_Comparison_Exp>;
  distance_to_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  distance_to_motorway?: InputMaybe<Float_Comparison_Exp>;
  distance_to_primary_school?: InputMaybe<Float_Comparison_Exp>;
  distance_to_public_transport?: InputMaybe<Float_Comparison_Exp>;
  distance_to_sports_center?: InputMaybe<Float_Comparison_Exp>;
  distance_to_train_station?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  district_place?: InputMaybe<Places_Bool_Exp>;
  emissions?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Date_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Int_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Int_Comparison_Exp>;
  financing_institution_id?: InputMaybe<Uuid_Comparison_Exp>;
  flat_condition?: InputMaybe<Float_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_address?: InputMaybe<Google_Addresses_Bool_Exp>;
  google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  gross_floor_surface?: InputMaybe<Float_Comparison_Exp>;
  has_attic?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_gym?: InputMaybe<Boolean_Comparison_Exp>;
  has_photovoltaic_panels?: InputMaybe<Boolean_Comparison_Exp>;
  has_sauna?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_wellness_area?: InputMaybe<Boolean_Comparison_Exp>;
  heating?: InputMaybe<Heating_Enum_Enum_Comparison_Exp>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum_Comparison_Exp>;
  iazi_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  income_includes_parking?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_commercial_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_luxury?: InputMaybe<Boolean_Comparison_Exp>;
  is_maisonette?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_east?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_north?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_south?: InputMaybe<Boolean_Comparison_Exp>;
  is_oriented_west?: InputMaybe<Boolean_Comparison_Exp>;
  is_parking_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_rental?: InputMaybe<Boolean_Comparison_Exp>;
  is_residential_fully_rented?: InputMaybe<Boolean_Comparison_Exp>;
  is_secondary_residence?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  latest_appraisal?: InputMaybe<Appraisals_Bool_Exp>;
  latest_appraisal_id?: InputMaybe<Uuid_Comparison_Exp>;
  leads?: InputMaybe<Leads_Bool_Exp>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Bool_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_place?: InputMaybe<Places_Bool_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  macro_location?: InputMaybe<Float_Comparison_Exp>;
  micro_location?: InputMaybe<Float_Comparison_Exp>;
  minergie_code?: InputMaybe<Int_Comparison_Exp>;
  monthly_gross_rent?: InputMaybe<Float_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_place?: InputMaybe<Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_place?: InputMaybe<Places_Bool_Exp>;
  number_of_bathrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_commercial_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_flats?: InputMaybe<Int_Comparison_Exp>;
  number_of_floors?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_lifts?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_residential_units?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Int_Comparison_Exp>;
  orientation?: InputMaybe<String_Comparison_Exp>;
  ownership_form?: InputMaybe<String_Comparison_Exp>;
  parking_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  parking_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  perceived_value?: InputMaybe<Float_Comparison_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  plot_has_constructible_reserve?: InputMaybe<Boolean_Comparison_Exp>;
  plot_is_constructible?: InputMaybe<Boolean_Comparison_Exp>;
  plot_number?: InputMaybe<String_Comparison_Exp>;
  plot_registry_number?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_files?: InputMaybe<Property_Files_Bool_Exp>;
  property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Bool_Exp>;
  property_images?: InputMaybe<Property_Images_Bool_Exp>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Bool_Exp>;
  property_pois?: InputMaybe<Property_Pois_Bool_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  relevant_servitudes?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_fund?: InputMaybe<Float_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  residential_potential_rental_income?: InputMaybe<Float_Comparison_Exp>;
  residential_surface?: InputMaybe<Float_Comparison_Exp>;
  residential_yearly_rental_income?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  share_of_ownership?: InputMaybe<Float_Comparison_Exp>;
  side?: InputMaybe<Property_Side_Enum_Enum_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_place?: InputMaybe<Places_Bool_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  weighted_floor_surface?: InputMaybe<Float_Comparison_Exp>;
  window_view?: InputMaybe<Window_View_Enum_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "properties" */
export enum Properties_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertiesPkey = 'properties_pkey'
}

/** input type for incrementing numeric columns in table "properties" */
export type Properties_Inc_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "properties" */
export type Properties_Insert_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  bed_type?: InputMaybe<Bed_Type_Enum_Enum>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  cma_reports?: InputMaybe<Cma_Reports_Arr_Rel_Insert_Input>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<Cooling_Enum_Enum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address?: InputMaybe<Google_Addresses_Obj_Rel_Insert_Input>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Heating_Enum_Enum>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  leads?: InputMaybe<Leads_Arr_Rel_Insert_Input>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  lots?: InputMaybe<Lots_Arr_Rel_Insert_Input>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_files?: InputMaybe<Property_Files_Arr_Rel_Insert_Input>;
  property_images?: InputMaybe<Property_Images_Arr_Rel_Insert_Input>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<Property_Side_Enum_Enum>;
  source_property_id?: InputMaybe<Scalars['uuid']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  window_view?: InputMaybe<Window_View_Enum_Enum>;
};

/** order by max() on columns of table "properties" */
export type Properties_Max_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  borrower_lead_id?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  financing_institution_id?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  latest_appraisal_id?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  plot_number?: InputMaybe<Order_By>;
  plot_registry_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "properties" */
export type Properties_Min_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  borrower_lead_id?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  financing_institution_id?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  latest_appraisal_id?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  plot_number?: InputMaybe<Order_By>;
  plot_registry_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "properties" */
export type Properties_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Properties>;
};

/** input type for inserting object relation for remote table "properties" */
export type Properties_Obj_Rel_Insert_Input = {
  data: Properties_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Properties_On_Conflict>;
};

/** on_conflict condition type for table "properties" */
export type Properties_On_Conflict = {
  constraint: Properties_Constraint;
  update_columns?: Array<Properties_Update_Column>;
  where?: InputMaybe<Properties_Bool_Exp>;
};

/** Ordering options when selecting data from "properties". */
export type Properties_Order_By = {
  appraisals_aggregate?: InputMaybe<Appraisals_Aggregate_Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  bed_type?: InputMaybe<Order_By>;
  borrower_lead_id?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  building_volume_norm?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  cooling?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  ctn?: InputMaybe<Order_By>;
  deleted_by_user?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  district_place?: InputMaybe<Places_Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_consumption_class?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  financing_institution_id?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gas_emissions_class?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  google_address?: InputMaybe<Google_Addresses_Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  has_attic?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_gym?: InputMaybe<Order_By>;
  has_photovoltaic_panels?: InputMaybe<Order_By>;
  has_sauna?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_wellness_area?: InputMaybe<Order_By>;
  heating?: InputMaybe<Order_By>;
  heating_distribution?: InputMaybe<Order_By>;
  iazi_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  income_includes_parking?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_commercial_fully_rented?: InputMaybe<Order_By>;
  is_luxury?: InputMaybe<Order_By>;
  is_maisonette?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_oriented_east?: InputMaybe<Order_By>;
  is_oriented_north?: InputMaybe<Order_By>;
  is_oriented_south?: InputMaybe<Order_By>;
  is_oriented_west?: InputMaybe<Order_By>;
  is_parking_fully_rented?: InputMaybe<Order_By>;
  is_rental?: InputMaybe<Order_By>;
  is_residential_fully_rented?: InputMaybe<Order_By>;
  is_secondary_residence?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  latest_appraisal?: InputMaybe<Appraisals_Order_By>;
  latest_appraisal_id?: InputMaybe<Order_By>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_place?: InputMaybe<Places_Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_place?: InputMaybe<Places_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  neighbourhood_place?: InputMaybe<Places_Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  orientation?: InputMaybe<Order_By>;
  ownership_form?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  plot_has_constructible_reserve?: InputMaybe<Order_By>;
  plot_is_constructible?: InputMaybe<Order_By>;
  plot_number?: InputMaybe<Order_By>;
  plot_registry_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_files_aggregate?: InputMaybe<Property_Files_Aggregate_Order_By>;
  property_images_aggregate?: InputMaybe<Property_Images_Aggregate_Order_By>;
  property_pois_aggregate?: InputMaybe<Property_Pois_Aggregate_Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  relevant_servitudes?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  side?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_place?: InputMaybe<Places_Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
  window_view?: InputMaybe<Order_By>;
};

/** primary key columns input for table: properties */
export type Properties_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "properties" */
export enum Properties_Select_Column {
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BasementSurface = 'basement_surface',
  /** column name */
  BedType = 'bed_type',
  /** column name */
  BorrowerLeadId = 'borrower_lead_id',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CeilingHeight = 'ceiling_height',
  /** column name */
  Charges = 'charges',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cooling = 'cooling',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DistanceToAirport = 'distance_to_airport',
  /** column name */
  DistanceToCityCenter = 'distance_to_city_center',
  /** column name */
  DistanceToGroceryShop = 'distance_to_grocery_shop',
  /** column name */
  DistanceToHighSchool = 'distance_to_high_school',
  /** column name */
  DistanceToHospital = 'distance_to_hospital',
  /** column name */
  DistanceToKindergarten = 'distance_to_kindergarten',
  /** column name */
  DistanceToMotorway = 'distance_to_motorway',
  /** column name */
  DistanceToPrimarySchool = 'distance_to_primary_school',
  /** column name */
  DistanceToPublicTransport = 'distance_to_public_transport',
  /** column name */
  DistanceToSportsCenter = 'distance_to_sports_center',
  /** column name */
  DistanceToTrainStation = 'distance_to_train_station',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Emissions = 'emissions',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyConsumptionClass = 'energy_consumption_class',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FinancingInstitutionId = 'financing_institution_id',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GasEmissionsClass = 'gas_emissions_class',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  GrossFloorSurface = 'gross_floor_surface',
  /** column name */
  HasAttic = 'has_attic',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGym = 'has_gym',
  /** column name */
  HasPhotovoltaicPanels = 'has_photovoltaic_panels',
  /** column name */
  HasSauna = 'has_sauna',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWellnessArea = 'has_wellness_area',
  /** column name */
  Heating = 'heating',
  /** column name */
  HeatingDistribution = 'heating_distribution',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOrientedEast = 'is_oriented_east',
  /** column name */
  IsOrientedNorth = 'is_oriented_north',
  /** column name */
  IsOrientedSouth = 'is_oriented_south',
  /** column name */
  IsOrientedWest = 'is_oriented_west',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LatestAppraisalId = 'latest_appraisal_id',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MacroLocation = 'macro_location',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  MonthlyGrossRent = 'monthly_gross_rent',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  OwnershipForm = 'ownership_form',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PerceivedValue = 'perceived_value',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  PlotNumber = 'plot_number',
  /** column name */
  PlotRegistryNumber = 'plot_registry_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationFund = 'renovation_fund',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  WeightedFloorSurface = 'weighted_floor_surface',
  /** column name */
  WindowView = 'window_view'
}

/** input type for updating data in table "properties" */
export type Properties_Set_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  bed_type?: InputMaybe<Bed_Type_Enum_Enum>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<Cooling_Enum_Enum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Heating_Enum_Enum>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<Property_Side_Enum_Enum>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  window_view?: InputMaybe<Window_View_Enum_Enum>;
};

/** order by stddev() on columns of table "properties" */
export type Properties_Stddev_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "properties" */
export type Properties_Stddev_Pop_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "properties" */
export type Properties_Stddev_Samp_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "properties" */
export type Properties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Properties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Properties_Stream_Cursor_Value_Input = {
  balcony_surface?: InputMaybe<Scalars['Float']['input']>;
  basement_surface?: InputMaybe<Scalars['Float']['input']>;
  bed_type?: InputMaybe<Bed_Type_Enum_Enum>;
  borrower_lead_id?: InputMaybe<Scalars['uuid']['input']>;
  building_condition?: InputMaybe<Scalars['Float']['input']>;
  building_standard?: InputMaybe<Scalars['Float']['input']>;
  building_volume?: InputMaybe<Scalars['Float']['input']>;
  building_volume_norm?: InputMaybe<Scalars['String']['input']>;
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  ceiling_height?: InputMaybe<Scalars['Float']['input']>;
  charges?: InputMaybe<Scalars['Float']['input']>;
  commercial_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  commercial_surface?: InputMaybe<Scalars['Float']['input']>;
  commercial_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  computed_surface?: InputMaybe<Scalars['Float']['input']>;
  construction_year?: InputMaybe<Scalars['Int']['input']>;
  consumption?: InputMaybe<Scalars['Int']['input']>;
  cooling?: InputMaybe<Cooling_Enum_Enum>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  ctn?: InputMaybe<Scalars['String']['input']>;
  deleted_by_user?: InputMaybe<Scalars['Boolean']['input']>;
  distance_to_airport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_city_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_grocery_shop?: InputMaybe<Scalars['Float']['input']>;
  distance_to_high_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_hospital?: InputMaybe<Scalars['Float']['input']>;
  distance_to_kindergarten?: InputMaybe<Scalars['Float']['input']>;
  distance_to_motorway?: InputMaybe<Scalars['Float']['input']>;
  distance_to_primary_school?: InputMaybe<Scalars['Float']['input']>;
  distance_to_public_transport?: InputMaybe<Scalars['Float']['input']>;
  distance_to_sports_center?: InputMaybe<Scalars['Float']['input']>;
  distance_to_train_station?: InputMaybe<Scalars['Float']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  emissions?: InputMaybe<Scalars['Int']['input']>;
  energy_certificate_version?: InputMaybe<Scalars['String']['input']>;
  energy_consumption_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  energy_inspection_date?: InputMaybe<Scalars['date']['input']>;
  energy_reference_year?: InputMaybe<Scalars['Int']['input']>;
  estimated_higher_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  estimated_lower_energy_cost?: InputMaybe<Scalars['Int']['input']>;
  financing_institution_id?: InputMaybe<Scalars['uuid']['input']>;
  flat_condition?: InputMaybe<Scalars['Float']['input']>;
  floor_of_flat?: InputMaybe<Scalars['Int']['input']>;
  garden_surface?: InputMaybe<Scalars['Float']['input']>;
  gas_emissions_class?: InputMaybe<Energy_Class_Type_Enum_Enum>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  gross_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  has_attic?: InputMaybe<Scalars['Boolean']['input']>;
  has_cellar?: InputMaybe<Scalars['Boolean']['input']>;
  has_elevator?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_gym?: InputMaybe<Scalars['Boolean']['input']>;
  has_photovoltaic_panels?: InputMaybe<Scalars['Boolean']['input']>;
  has_sauna?: InputMaybe<Scalars['Boolean']['input']>;
  has_storage_room?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  has_wellness_area?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Heating_Enum_Enum>;
  heating_distribution?: InputMaybe<Heating_Distribution_Enum_Enum>;
  iazi_address_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  income_includes_parking?: InputMaybe<Scalars['Boolean']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_commercial_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_luxury?: InputMaybe<Scalars['Boolean']['input']>;
  is_maisonette?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_east?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_north?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_south?: InputMaybe<Scalars['Boolean']['input']>;
  is_oriented_west?: InputMaybe<Scalars['Boolean']['input']>;
  is_parking_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_rental?: InputMaybe<Scalars['Boolean']['input']>;
  is_residential_fully_rented?: InputMaybe<Scalars['Boolean']['input']>;
  is_secondary_residence?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  latest_appraisal_id?: InputMaybe<Scalars['uuid']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  macro_location?: InputMaybe<Scalars['Float']['input']>;
  micro_location?: InputMaybe<Scalars['Float']['input']>;
  minergie_code?: InputMaybe<Scalars['Int']['input']>;
  monthly_gross_rent?: InputMaybe<Scalars['Float']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_bathrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_commercial_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_flats?: InputMaybe<Scalars['Int']['input']>;
  number_of_floors?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_lifts?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings?: InputMaybe<Scalars['Int']['input']>;
  number_of_residential_units?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  number_of_toilets?: InputMaybe<Scalars['Int']['input']>;
  orientation?: InputMaybe<Scalars['String']['input']>;
  ownership_form?: InputMaybe<Scalars['String']['input']>;
  parking_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  parking_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  perceived_value?: InputMaybe<Scalars['Float']['input']>;
  plot_has_constructible_reserve?: InputMaybe<Scalars['Boolean']['input']>;
  plot_is_constructible?: InputMaybe<Scalars['Boolean']['input']>;
  plot_number?: InputMaybe<Scalars['String']['input']>;
  plot_registry_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  relevant_servitudes?: InputMaybe<Scalars['Boolean']['input']>;
  renovation_fund?: InputMaybe<Scalars['Float']['input']>;
  renovation_year?: InputMaybe<Scalars['Int']['input']>;
  residential_potential_rental_income?: InputMaybe<Scalars['Float']['input']>;
  residential_surface?: InputMaybe<Scalars['Float']['input']>;
  residential_yearly_rental_income?: InputMaybe<Scalars['Float']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  share_of_ownership?: InputMaybe<Scalars['Float']['input']>;
  side?: InputMaybe<Property_Side_Enum_Enum>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  sub_locality?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  terrace_surface?: InputMaybe<Scalars['Float']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  weighted_floor_surface?: InputMaybe<Scalars['Float']['input']>;
  window_view?: InputMaybe<Window_View_Enum_Enum>;
};

/** order by sum() on columns of table "properties" */
export type Properties_Sum_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** update columns of table "properties" */
export enum Properties_Update_Column {
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BasementSurface = 'basement_surface',
  /** column name */
  BedType = 'bed_type',
  /** column name */
  BorrowerLeadId = 'borrower_lead_id',
  /** column name */
  BuildingCondition = 'building_condition',
  /** column name */
  BuildingStandard = 'building_standard',
  /** column name */
  BuildingVolume = 'building_volume',
  /** column name */
  BuildingVolumeNorm = 'building_volume_norm',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CeilingHeight = 'ceiling_height',
  /** column name */
  Charges = 'charges',
  /** column name */
  CommercialPotentialRentalIncome = 'commercial_potential_rental_income',
  /** column name */
  CommercialSurface = 'commercial_surface',
  /** column name */
  CommercialYearlyRentalIncome = 'commercial_yearly_rental_income',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  Consumption = 'consumption',
  /** column name */
  Cooling = 'cooling',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  Ctn = 'ctn',
  /** column name */
  DeletedByUser = 'deleted_by_user',
  /** column name */
  DistanceToAirport = 'distance_to_airport',
  /** column name */
  DistanceToCityCenter = 'distance_to_city_center',
  /** column name */
  DistanceToGroceryShop = 'distance_to_grocery_shop',
  /** column name */
  DistanceToHighSchool = 'distance_to_high_school',
  /** column name */
  DistanceToHospital = 'distance_to_hospital',
  /** column name */
  DistanceToKindergarten = 'distance_to_kindergarten',
  /** column name */
  DistanceToMotorway = 'distance_to_motorway',
  /** column name */
  DistanceToPrimarySchool = 'distance_to_primary_school',
  /** column name */
  DistanceToPublicTransport = 'distance_to_public_transport',
  /** column name */
  DistanceToSportsCenter = 'distance_to_sports_center',
  /** column name */
  DistanceToTrainStation = 'distance_to_train_station',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Emissions = 'emissions',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyConsumptionClass = 'energy_consumption_class',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FinancingInstitutionId = 'financing_institution_id',
  /** column name */
  FlatCondition = 'flat_condition',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  GasEmissionsClass = 'gas_emissions_class',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  GrossFloorSurface = 'gross_floor_surface',
  /** column name */
  HasAttic = 'has_attic',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGym = 'has_gym',
  /** column name */
  HasPhotovoltaicPanels = 'has_photovoltaic_panels',
  /** column name */
  HasSauna = 'has_sauna',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWellnessArea = 'has_wellness_area',
  /** column name */
  Heating = 'heating',
  /** column name */
  HeatingDistribution = 'heating_distribution',
  /** column name */
  IaziAddressId = 'iazi_address_id',
  /** column name */
  IncomeIncludesParking = 'income_includes_parking',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsCommercialFullyRented = 'is_commercial_fully_rented',
  /** column name */
  IsLuxury = 'is_luxury',
  /** column name */
  IsMaisonette = 'is_maisonette',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOrientedEast = 'is_oriented_east',
  /** column name */
  IsOrientedNorth = 'is_oriented_north',
  /** column name */
  IsOrientedSouth = 'is_oriented_south',
  /** column name */
  IsOrientedWest = 'is_oriented_west',
  /** column name */
  IsParkingFullyRented = 'is_parking_fully_rented',
  /** column name */
  IsRental = 'is_rental',
  /** column name */
  IsResidentialFullyRented = 'is_residential_fully_rented',
  /** column name */
  IsSecondaryResidence = 'is_secondary_residence',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LatestAppraisalId = 'latest_appraisal_id',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MacroLocation = 'macro_location',
  /** column name */
  MicroLocation = 'micro_location',
  /** column name */
  MinergieCode = 'minergie_code',
  /** column name */
  MonthlyGrossRent = 'monthly_gross_rent',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfCommercialUnits = 'number_of_commercial_units',
  /** column name */
  NumberOfFlats = 'number_of_flats',
  /** column name */
  NumberOfFloors = 'number_of_floors',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLifts = 'number_of_lifts',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfResidentialUnits = 'number_of_residential_units',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  Orientation = 'orientation',
  /** column name */
  OwnershipForm = 'ownership_form',
  /** column name */
  ParkingPotentialRentalIncome = 'parking_potential_rental_income',
  /** column name */
  ParkingYearlyRentalIncome = 'parking_yearly_rental_income',
  /** column name */
  PerceivedValue = 'perceived_value',
  /** column name */
  PlotHasConstructibleReserve = 'plot_has_constructible_reserve',
  /** column name */
  PlotIsConstructible = 'plot_is_constructible',
  /** column name */
  PlotNumber = 'plot_number',
  /** column name */
  PlotRegistryNumber = 'plot_registry_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  RelevantServitudes = 'relevant_servitudes',
  /** column name */
  RenovationFund = 'renovation_fund',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  ResidentialPotentialRentalIncome = 'residential_potential_rental_income',
  /** column name */
  ResidentialSurface = 'residential_surface',
  /** column name */
  ResidentialYearlyRentalIncome = 'residential_yearly_rental_income',
  /** column name */
  Route = 'route',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  ShareOfOwnership = 'share_of_ownership',
  /** column name */
  Side = 'side',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  WeightedFloorSurface = 'weighted_floor_surface',
  /** column name */
  WindowView = 'window_view'
}

export type Properties_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Properties_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Properties_Set_Input>;
  /** filter the rows which have to be updated */
  where: Properties_Bool_Exp;
};

/** order by var_pop() on columns of table "properties" */
export type Properties_Var_Pop_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "properties" */
export type Properties_Var_Samp_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "properties" */
export type Properties_Variance_Order_By = {
  balcony_surface?: InputMaybe<Order_By>;
  basement_surface?: InputMaybe<Order_By>;
  building_condition?: InputMaybe<Order_By>;
  building_standard?: InputMaybe<Order_By>;
  building_volume?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  ceiling_height?: InputMaybe<Order_By>;
  charges?: InputMaybe<Order_By>;
  commercial_potential_rental_income?: InputMaybe<Order_By>;
  commercial_surface?: InputMaybe<Order_By>;
  commercial_yearly_rental_income?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  consumption?: InputMaybe<Order_By>;
  distance_to_airport?: InputMaybe<Order_By>;
  distance_to_city_center?: InputMaybe<Order_By>;
  distance_to_grocery_shop?: InputMaybe<Order_By>;
  distance_to_high_school?: InputMaybe<Order_By>;
  distance_to_hospital?: InputMaybe<Order_By>;
  distance_to_kindergarten?: InputMaybe<Order_By>;
  distance_to_motorway?: InputMaybe<Order_By>;
  distance_to_primary_school?: InputMaybe<Order_By>;
  distance_to_public_transport?: InputMaybe<Order_By>;
  distance_to_sports_center?: InputMaybe<Order_By>;
  distance_to_train_station?: InputMaybe<Order_By>;
  emissions?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  flat_condition?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  gross_floor_surface?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  macro_location?: InputMaybe<Order_By>;
  micro_location?: InputMaybe<Order_By>;
  minergie_code?: InputMaybe<Order_By>;
  monthly_gross_rent?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_commercial_units?: InputMaybe<Order_By>;
  number_of_flats?: InputMaybe<Order_By>;
  number_of_floors?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_lifts?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_residential_units?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  parking_potential_rental_income?: InputMaybe<Order_By>;
  parking_yearly_rental_income?: InputMaybe<Order_By>;
  perceived_value?: InputMaybe<Order_By>;
  renovation_fund?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  residential_potential_rental_income?: InputMaybe<Order_By>;
  residential_surface?: InputMaybe<Order_By>;
  residential_yearly_rental_income?: InputMaybe<Order_By>;
  share_of_ownership?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  weighted_floor_surface?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_files" */
export type Property_Files = {
  display_on_listing: Scalars['Boolean']['output'];
  /** An object relationship */
  file: Files;
  file_id: Scalars['uuid']['output'];
  is_visible: Scalars['Boolean']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  tenant_id: Scalars['uuid']['output'];
};

/** aggregated selection of "property_files" */
export type Property_Files_Aggregate = {
  aggregate?: Maybe<Property_Files_Aggregate_Fields>;
  nodes: Array<Property_Files>;
};

export type Property_Files_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Files_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Files_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Files_Aggregate_Bool_Exp_Count>;
};

export type Property_Files_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Files_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Files_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Files_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Files_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_files" */
export type Property_Files_Aggregate_Fields = {
  avg?: Maybe<Property_Files_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Files_Max_Fields>;
  min?: Maybe<Property_Files_Min_Fields>;
  stddev?: Maybe<Property_Files_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Files_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Files_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Files_Sum_Fields>;
  var_pop?: Maybe<Property_Files_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Files_Var_Samp_Fields>;
  variance?: Maybe<Property_Files_Variance_Fields>;
};


/** aggregate fields of "property_files" */
export type Property_Files_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Files_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_files" */
export type Property_Files_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Files_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Files_Max_Order_By>;
  min?: InputMaybe<Property_Files_Min_Order_By>;
  stddev?: InputMaybe<Property_Files_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Files_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Files_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Files_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Files_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Files_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Files_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_files" */
export type Property_Files_Arr_Rel_Insert_Input = {
  data: Array<Property_Files_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Files_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Files_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_files" */
export type Property_Files_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_files". All fields are combined with a logical 'AND'. */
export type Property_Files_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Files_Bool_Exp>>;
  _not?: InputMaybe<Property_Files_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Files_Bool_Exp>>;
  display_on_listing?: InputMaybe<Boolean_Comparison_Exp>;
  file?: InputMaybe<Files_Bool_Exp>;
  file_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_files" */
export enum Property_Files_Constraint {
  /** unique or primary key constraint on columns "property_id", "file_id" */
  PropertyFilesPkey = 'property_files_pkey',
  /** unique or primary key constraint on columns "property_id", "file_id" */
  PropertyFilesPropertyIdFileIdUnique = 'property_files_property_id_file_id_unique',
  /** unique or primary key constraint on columns "property_id", "file_id" */
  UniquePropertyIdFileId = 'unique_property_id_file_id',
  /** unique or primary key constraint on columns "property_id", "order_nr" */
  UniquePropertyIdOrderNr = 'unique_property_id_order_nr'
}

/** input type for incrementing numeric columns in table "property_files" */
export type Property_Files_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_files" */
export type Property_Files_Insert_Input = {
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Property_Files_Max_Fields = {
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_files" */
export type Property_Files_Max_Order_By = {
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Files_Min_Fields = {
  file_id?: Maybe<Scalars['uuid']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_files" */
export type Property_Files_Min_Order_By = {
  file_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_files" */
export type Property_Files_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Files>;
};

/** on_conflict condition type for table "property_files" */
export type Property_Files_On_Conflict = {
  constraint: Property_Files_Constraint;
  update_columns?: Array<Property_Files_Update_Column>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};

/** Ordering options when selecting data from "property_files". */
export type Property_Files_Order_By = {
  display_on_listing?: InputMaybe<Order_By>;
  file?: InputMaybe<Files_Order_By>;
  file_id?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_files */
export type Property_Files_Pk_Columns_Input = {
  file_id: Scalars['uuid']['input'];
  property_id: Scalars['uuid']['input'];
};

/** select columns of table "property_files" */
export enum Property_Files_Select_Column {
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  FileId = 'file_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** select "property_files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_files" */
export enum Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsVisible = 'is_visible'
}

/** select "property_files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_files" */
export enum Property_Files_Select_Column_Property_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsVisible = 'is_visible'
}

/** input type for updating data in table "property_files" */
export type Property_Files_Set_Input = {
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Property_Files_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_files" */
export type Property_Files_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Files_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_files" */
export type Property_Files_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Files_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_files" */
export type Property_Files_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_files" */
export type Property_Files_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Files_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Files_Stream_Cursor_Value_Input = {
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  file_id?: InputMaybe<Scalars['uuid']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Property_Files_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_files" */
export type Property_Files_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "property_files" */
export enum Property_Files_Update_Column {
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  OrderNr = 'order_nr'
}

export type Property_Files_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Files_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Files_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Files_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Files_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_files" */
export type Property_Files_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Files_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_files" */
export type Property_Files_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Files_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_files" */
export type Property_Files_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_image_versions" */
export type Property_Image_Versions = {
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  property_image_id: Scalars['uuid']['output'];
  /** An object relationship */
  source_image?: Maybe<Images>;
  source_image_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by aggregate values of table "property_image_versions" */
export type Property_Image_Versions_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Image_Versions_Max_Order_By>;
  min?: InputMaybe<Property_Image_Versions_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "property_image_versions". All fields are combined with a logical 'AND'. */
export type Property_Image_Versions_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Image_Versions_Bool_Exp>>;
  _not?: InputMaybe<Property_Image_Versions_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Image_Versions_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  prompt?: InputMaybe<String_Comparison_Exp>;
  property_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  source_image?: InputMaybe<Images_Bool_Exp>;
  source_image_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "property_image_versions" */
export type Property_Image_Versions_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  prompt?: InputMaybe<Order_By>;
  property_image_id?: InputMaybe<Order_By>;
  source_image_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_image_versions" */
export type Property_Image_Versions_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  prompt?: InputMaybe<Order_By>;
  property_image_id?: InputMaybe<Order_By>;
  source_image_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "property_image_versions". */
export type Property_Image_Versions_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  prompt?: InputMaybe<Order_By>;
  property_image_id?: InputMaybe<Order_By>;
  source_image?: InputMaybe<Images_Order_By>;
  source_image_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_image_versions" */
export enum Property_Image_Versions_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  Prompt = 'prompt',
  /** column name */
  PropertyImageId = 'property_image_id',
  /** column name */
  SourceImageId = 'source_image_id'
}

/** columns and relationships of "property_images" */
export type Property_Images = {
  background_color: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  crop: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_on_brochure: Scalars['Boolean']['output'];
  display_on_listing: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  is_floor_plan: Scalars['Boolean']['output'];
  landscape_background_color: Scalars['String']['output'];
  landscape_crop: Scalars['String']['output'];
  landscape_size: Scalars['String']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  size: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  versions: Array<Property_Image_Versions>;
  watermarked_url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "property_images" */
export type Property_ImagesVersionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Image_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Image_Versions_Order_By>>;
  where?: InputMaybe<Property_Image_Versions_Bool_Exp>;
};

/** aggregated selection of "property_images" */
export type Property_Images_Aggregate = {
  aggregate?: Maybe<Property_Images_Aggregate_Fields>;
  nodes: Array<Property_Images>;
};

export type Property_Images_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Images_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Images_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Images_Aggregate_Bool_Exp_Count>;
};

export type Property_Images_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Images_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Images_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Images_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Images_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Images_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_images" */
export type Property_Images_Aggregate_Fields = {
  avg?: Maybe<Property_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Images_Max_Fields>;
  min?: Maybe<Property_Images_Min_Fields>;
  stddev?: Maybe<Property_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Images_Sum_Fields>;
  var_pop?: Maybe<Property_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Images_Var_Samp_Fields>;
  variance?: Maybe<Property_Images_Variance_Fields>;
};


/** aggregate fields of "property_images" */
export type Property_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_images" */
export type Property_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Images_Max_Order_By>;
  min?: InputMaybe<Property_Images_Min_Order_By>;
  stddev?: InputMaybe<Property_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_images" */
export type Property_Images_Arr_Rel_Insert_Input = {
  data: Array<Property_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Images_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Images_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_images" */
export type Property_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_images". All fields are combined with a logical 'AND'. */
export type Property_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Images_Bool_Exp>>;
  _not?: InputMaybe<Property_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Images_Bool_Exp>>;
  background_color?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  crop?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_on_brochure?: InputMaybe<Boolean_Comparison_Exp>;
  display_on_listing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_floor_plan?: InputMaybe<Boolean_Comparison_Exp>;
  landscape_background_color?: InputMaybe<String_Comparison_Exp>;
  landscape_crop?: InputMaybe<String_Comparison_Exp>;
  landscape_size?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  size?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  versions?: InputMaybe<Property_Image_Versions_Bool_Exp>;
  watermarked_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_images" */
export enum Property_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyImagesPkey = 'property_images_pkey',
  /** unique or primary key constraint on columns "image_id", "property_id" */
  PropertyImagesPropertyIdImageIdUnique = 'property_images_property_id_image_id_unique',
  /** unique or primary key constraint on columns "property_id", "order_nr" */
  PropertyImagesPropertyIdOrderNrUnique = 'property_images_property_id_order_nr_unique'
}

/** input type for incrementing numeric columns in table "property_images" */
export type Property_Images_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_images" */
export type Property_Images_Insert_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Property_Images_Max_Fields = {
  background_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_id?: Maybe<Scalars['uuid']['output']>;
  landscape_background_color?: Maybe<Scalars['String']['output']>;
  landscape_crop?: Maybe<Scalars['String']['output']>;
  landscape_size?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  watermarked_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "property_images" */
export type Property_Images_Max_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  landscape_background_color?: InputMaybe<Order_By>;
  landscape_crop?: InputMaybe<Order_By>;
  landscape_size?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  watermarked_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Images_Min_Fields = {
  background_color?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  crop?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_id?: Maybe<Scalars['uuid']['output']>;
  landscape_background_color?: Maybe<Scalars['String']['output']>;
  landscape_crop?: Maybe<Scalars['String']['output']>;
  landscape_size?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  watermarked_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "property_images" */
export type Property_Images_Min_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  landscape_background_color?: InputMaybe<Order_By>;
  landscape_crop?: InputMaybe<Order_By>;
  landscape_size?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  watermarked_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_images" */
export type Property_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Images>;
};

/** on_conflict condition type for table "property_images" */
export type Property_Images_On_Conflict = {
  constraint: Property_Images_Constraint;
  update_columns?: Array<Property_Images_Update_Column>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "property_images". */
export type Property_Images_Order_By = {
  background_color?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  crop?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_on_brochure?: InputMaybe<Order_By>;
  display_on_listing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  is_floor_plan?: InputMaybe<Order_By>;
  landscape_background_color?: InputMaybe<Order_By>;
  landscape_crop?: InputMaybe<Order_By>;
  landscape_size?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  size?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  versions_aggregate?: InputMaybe<Property_Image_Versions_Aggregate_Order_By>;
  watermarked_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_images */
export type Property_Images_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_images" */
export enum Property_Images_Select_Column {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WatermarkedUrl = 'watermarked_url'
}

/** select "property_images_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_images" */
export enum Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

/** select "property_images_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_images" */
export enum Property_Images_Select_Column_Property_Images_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  IsFloorPlan = 'is_floor_plan'
}

/** input type for updating data in table "property_images" */
export type Property_Images_Set_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Images_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_images" */
export type Property_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Images_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_images" */
export type Property_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Images_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_images" */
export type Property_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_images" */
export type Property_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Images_Stream_Cursor_Value_Input = {
  background_color?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  crop?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_on_brochure?: InputMaybe<Scalars['Boolean']['input']>;
  display_on_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_floor_plan?: InputMaybe<Scalars['Boolean']['input']>;
  landscape_background_color?: InputMaybe<Scalars['String']['input']>;
  landscape_crop?: InputMaybe<Scalars['String']['input']>;
  landscape_size?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  watermarked_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Property_Images_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_images" */
export type Property_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "property_images" */
export enum Property_Images_Update_Column {
  /** column name */
  BackgroundColor = 'background_color',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Crop = 'crop',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnBrochure = 'display_on_brochure',
  /** column name */
  DisplayOnListing = 'display_on_listing',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsFloorPlan = 'is_floor_plan',
  /** column name */
  LandscapeBackgroundColor = 'landscape_background_color',
  /** column name */
  LandscapeCrop = 'landscape_crop',
  /** column name */
  LandscapeSize = 'landscape_size',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  Size = 'size',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Images_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Images_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_images" */
export type Property_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Images_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_images" */
export type Property_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Images_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_images" */
export type Property_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_pois" */
export type Property_Pois = {
  cycling_distance_meters?: Maybe<Scalars['Int']['output']>;
  cycling_time_minutes?: Maybe<Scalars['Int']['output']>;
  distance_meters: Scalars['Int']['output'];
  driving_distance_meters?: Maybe<Scalars['Int']['output']>;
  driving_time_minutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  poi: Pois;
  poi_id: Scalars['uuid']['output'];
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  transit_distance_meters?: Maybe<Scalars['Int']['output']>;
  transit_time_minutes?: Maybe<Scalars['Int']['output']>;
  walking_distance_meters?: Maybe<Scalars['Int']['output']>;
  walking_time_minutes?: Maybe<Scalars['Int']['output']>;
};

/** order by aggregate values of table "property_pois" */
export type Property_Pois_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Pois_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Pois_Max_Order_By>;
  min?: InputMaybe<Property_Pois_Min_Order_By>;
  stddev?: InputMaybe<Property_Pois_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Pois_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Pois_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Pois_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Pois_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Pois_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Pois_Variance_Order_By>;
};

/** order by avg() on columns of table "property_pois" */
export type Property_Pois_Avg_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_pois". All fields are combined with a logical 'AND'. */
export type Property_Pois_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Pois_Bool_Exp>>;
  _not?: InputMaybe<Property_Pois_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Pois_Bool_Exp>>;
  cycling_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  cycling_time_minutes?: InputMaybe<Int_Comparison_Exp>;
  distance_meters?: InputMaybe<Int_Comparison_Exp>;
  driving_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  driving_time_minutes?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  poi?: InputMaybe<Pois_Bool_Exp>;
  poi_id?: InputMaybe<Uuid_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  transit_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  transit_time_minutes?: InputMaybe<Int_Comparison_Exp>;
  walking_distance_meters?: InputMaybe<Int_Comparison_Exp>;
  walking_time_minutes?: InputMaybe<Int_Comparison_Exp>;
};

/** order by max() on columns of table "property_pois" */
export type Property_Pois_Max_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poi_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_pois" */
export type Property_Pois_Min_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poi_id?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_pois" */
export type Property_Pois_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Pois>;
};

/** Ordering options when selecting data from "property_pois". */
export type Property_Pois_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  poi?: InputMaybe<Pois_Order_By>;
  poi_id?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** select columns of table "property_pois" */
export enum Property_Pois_Select_Column {
  /** column name */
  CyclingDistanceMeters = 'cycling_distance_meters',
  /** column name */
  CyclingTimeMinutes = 'cycling_time_minutes',
  /** column name */
  DistanceMeters = 'distance_meters',
  /** column name */
  DrivingDistanceMeters = 'driving_distance_meters',
  /** column name */
  DrivingTimeMinutes = 'driving_time_minutes',
  /** column name */
  Id = 'id',
  /** column name */
  PoiId = 'poi_id',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  TransitDistanceMeters = 'transit_distance_meters',
  /** column name */
  TransitTimeMinutes = 'transit_time_minutes',
  /** column name */
  WalkingDistanceMeters = 'walking_distance_meters',
  /** column name */
  WalkingTimeMinutes = 'walking_time_minutes'
}

/** order by stddev() on columns of table "property_pois" */
export type Property_Pois_Stddev_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "property_pois" */
export type Property_Pois_Stddev_Pop_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "property_pois" */
export type Property_Pois_Stddev_Samp_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "property_pois" */
export type Property_Pois_Sum_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "property_pois" */
export type Property_Pois_Var_Pop_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "property_pois" */
export type Property_Pois_Var_Samp_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "property_pois" */
export type Property_Pois_Variance_Order_By = {
  cycling_distance_meters?: InputMaybe<Order_By>;
  cycling_time_minutes?: InputMaybe<Order_By>;
  distance_meters?: InputMaybe<Order_By>;
  driving_distance_meters?: InputMaybe<Order_By>;
  driving_time_minutes?: InputMaybe<Order_By>;
  transit_distance_meters?: InputMaybe<Order_By>;
  transit_time_minutes?: InputMaybe<Order_By>;
  walking_distance_meters?: InputMaybe<Order_By>;
  walking_time_minutes?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_search_aggregator_source" */
export type Property_Search_Aggregator_Source = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "property_search_aggregator_source". All fields are combined with a logical 'AND'. */
export type Property_Search_Aggregator_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Search_Aggregator_Source_Bool_Exp>>;
  _not?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Search_Aggregator_Source_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Property_Search_Aggregator_Source_Enum {
  ListingClickout = 'listing_clickout',
  ListingSimilarClick = 'listing_similar_click',
  ListingsManual = 'listings_manual',
  ListingsPageNavigationClick = 'listings_page_navigation_click'
}

/** Boolean expression to compare columns of type "property_search_aggregator_source_enum". All fields are combined with logical 'AND'. */
export type Property_Search_Aggregator_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  _in?: InputMaybe<Array<Property_Search_Aggregator_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  _nin?: InputMaybe<Array<Property_Search_Aggregator_Source_Enum>>;
};

/** Ordering options when selecting data from "property_search_aggregator_source". */
export type Property_Search_Aggregator_Source_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "property_search_aggregator_source" */
export enum Property_Search_Aggregator_Source_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "property_search_aggregator_source" */
export type Property_Search_Aggregator_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Search_Aggregator_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Search_Aggregator_Source_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "property_search_source" */
export type Property_Search_Source = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "property_search_source". All fields are combined with a logical 'AND'. */
export type Property_Search_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Search_Source_Bool_Exp>>;
  _not?: InputMaybe<Property_Search_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Search_Source_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Property_Search_Source_Enum {
  Aggregator = 'aggregator',
  Android = 'android',
  Crm = 'crm',
  Enquiry = 'enquiry',
  ImmologicForm = 'immologic_form',
  Ios = 'ios',
  Other = 'other',
  Valuation = 'valuation'
}

/** Boolean expression to compare columns of type "property_search_source_enum". All fields are combined with logical 'AND'. */
export type Property_Search_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Search_Source_Enum>;
  _in?: InputMaybe<Array<Property_Search_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Search_Source_Enum>;
  _nin?: InputMaybe<Array<Property_Search_Source_Enum>>;
};

/** Ordering options when selecting data from "property_search_source". */
export type Property_Search_Source_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "property_search_source" */
export enum Property_Search_Source_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "property_search_source" */
export type Property_Search_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Search_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Search_Source_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** What a contact (user_id -> users) is looking for: offer type, budget and surface bands, places. offer_type is 'buy' or 'rent'. */
export type Property_Searches = {
  activate_aggregator: Scalars['Boolean']['output'];
  agency_reference_contains?: Maybe<Scalars['String']['output']>;
  aggregator_source?: Maybe<Property_Search_Aggregator_Source_Enum>;
  awaiting_alert_handle: Scalars['Boolean']['output'];
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  composite_property_type_eq?: Maybe<Scalars['String']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_at_gte?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_lift?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool: Scalars['Boolean']['output'];
  has_view?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  imported_id?: Maybe<Scalars['String']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  last_alert_handle: Scalars['timestamptz']['output'];
  last_notified_at?: Maybe<Scalars['timestamptz']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  notification: Scalars['property_searches_notification']['output'];
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  portal_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_nin?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  property_searches_enquiries: Array<Property_Searches_Enquiries>;
  /** An array relationship */
  property_searches_places: Array<Property_Searches_Places>;
  property_status?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  property_types: Array<Property_Searches_Property_Types>;
  /** An aggregate relationship */
  property_types_aggregate: Property_Searches_Property_Types_Aggregate;
  property_usage?: Maybe<Scalars['String']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Property_Search_Source_Enum>;
  tenant_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
  travel_mode?: Maybe<Travel_Modes_Enum_Enum>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** What a contact (user_id -> users) is looking for: offer type, budget and surface bands, places. offer_type is 'buy' or 'rent'. */
export type Property_SearchesProperty_Searches_EnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Enquiries_Order_By>>;
  where?: InputMaybe<Property_Searches_Enquiries_Bool_Exp>;
};


/** What a contact (user_id -> users) is looking for: offer type, budget and surface bands, places. offer_type is 'buy' or 'rent'. */
export type Property_SearchesProperty_Searches_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Places_Order_By>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


/** What a contact (user_id -> users) is looking for: offer type, budget and surface bands, places. offer_type is 'buy' or 'rent'. */
export type Property_SearchesProperty_TypesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Property_Types_Order_By>>;
  where?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
};


/** What a contact (user_id -> users) is looking for: offer type, budget and surface bands, places. offer_type is 'buy' or 'rent'. */
export type Property_SearchesProperty_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Property_Types_Order_By>>;
  where?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
};

/** aggregated selection of "property_searches" */
export type Property_Searches_Aggregate = {
  aggregate?: Maybe<Property_Searches_Aggregate_Fields>;
  nodes: Array<Property_Searches>;
};

export type Property_Searches_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Property_Searches_Aggregate_Bool_Exp_Var_Samp>;
};

export type Property_Searches_Aggregate_Bool_Exp_Avg = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Corr = {
  arguments: Property_Searches_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Property_Searches_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Searches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Property_Searches_Aggregate_Bool_Exp_Max = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Min = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Sum = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Property_Searches_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "property_searches" */
export type Property_Searches_Aggregate_Fields = {
  avg?: Maybe<Property_Searches_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Searches_Max_Fields>;
  min?: Maybe<Property_Searches_Min_Fields>;
  stddev?: Maybe<Property_Searches_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Searches_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Searches_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Searches_Sum_Fields>;
  var_pop?: Maybe<Property_Searches_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Searches_Var_Samp_Fields>;
  variance?: Maybe<Property_Searches_Variance_Fields>;
};


/** aggregate fields of "property_searches" */
export type Property_Searches_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Searches_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_searches" */
export type Property_Searches_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Searches_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Min_Order_By>;
  stddev?: InputMaybe<Property_Searches_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Searches_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Searches_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Searches_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Searches_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Searches_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Searches_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_searches" */
export type Property_Searches_Arr_Rel_Insert_Input = {
  data: Array<Property_Searches_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Searches_Avg_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_searches" */
export type Property_Searches_Avg_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_searches". All fields are combined with a logical 'AND'. */
export type Property_Searches_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Bool_Exp>>;
  activate_aggregator?: InputMaybe<Boolean_Comparison_Exp>;
  agency_reference_contains?: InputMaybe<String_Comparison_Exp>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum_Comparison_Exp>;
  awaiting_alert_handle?: InputMaybe<Boolean_Comparison_Exp>;
  balcony_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  built_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  comment?: InputMaybe<String_Comparison_Exp>;
  composite_property_type_eq?: InputMaybe<String_Comparison_Exp>;
  computed_budget_gte?: InputMaybe<Float_Comparison_Exp>;
  computed_budget_lte?: InputMaybe<Float_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_gte?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  garden_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  gross_rent_m2_yearly_gte?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2_yearly_lte?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly_gte?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly_lte?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_lift?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_id?: InputMaybe<String_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  land_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  last_alert_handle?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_notified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  last_viewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  living_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  living_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  max_distance?: InputMaybe<Float8_Comparison_Exp>;
  max_travel_time?: InputMaybe<Int_Comparison_Exp>;
  monthly_rent_gte?: InputMaybe<Int_Comparison_Exp>;
  monthly_rent_lte?: InputMaybe<Int_Comparison_Exp>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Float_Comparison_Exp>;
  notification?: InputMaybe<Property_Searches_Notification_Comparison_Exp>;
  number_of_bathrooms_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_bathrooms_lte?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_bedrooms_lte?: InputMaybe<Int_Comparison_Exp>;
  number_of_indoor_parkings_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings_gte?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms_gte?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms_lte?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  portal_in?: InputMaybe<String_Array_Comparison_Exp>;
  property_main_type_in?: InputMaybe<String_Array_Comparison_Exp>;
  property_main_type_nin?: InputMaybe<String_Array_Comparison_Exp>;
  property_searches_enquiries?: InputMaybe<Property_Searches_Enquiries_Bool_Exp>;
  property_searches_places?: InputMaybe<Property_Searches_Places_Bool_Exp>;
  property_status?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
  property_types_aggregate?: InputMaybe<Property_Searches_Property_Types_Aggregate_Bool_Exp>;
  property_usage?: InputMaybe<String_Comparison_Exp>;
  rental_return_gte?: InputMaybe<Float_Comparison_Exp>;
  rental_return_lte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_gte?: InputMaybe<Int_Comparison_Exp>;
  sale_price_lte?: InputMaybe<Int_Comparison_Exp>;
  sale_price_per_land_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface_gte?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface_lte?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price_gte?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price_lte?: InputMaybe<Float_Comparison_Exp>;
  session_id?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Property_Search_Source_Enum_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  travel_from_lat?: InputMaybe<Float8_Comparison_Exp>;
  travel_from_lng?: InputMaybe<Float8_Comparison_Exp>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_searches" */
export enum Property_Searches_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertySearchesTmpPkey = 'property_searches_tmp_pkey'
}

/** columns and relationships of "property_searches_enquiries" */
export type Property_Searches_Enquiries = {
  /** An object relationship */
  enquiry: Enquiries;
  enquiry_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_search: Property_Searches;
  property_search_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Enquiries_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Enquiries_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Arr_Rel_Insert_Input = {
  data: Array<Property_Searches_Enquiries_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_Enquiries_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_searches_enquiries". All fields are combined with a logical 'AND'. */
export type Property_Searches_Enquiries_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Enquiries_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Enquiries_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Enquiries_Bool_Exp>>;
  enquiry?: InputMaybe<Enquiries_Bool_Exp>;
  enquiry_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search?: InputMaybe<Property_Searches_Bool_Exp>;
  property_search_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_searches_enquiries" */
export enum Property_Searches_Enquiries_Constraint {
  /** unique or primary key constraint on columns "property_search_id", "enquiry_id" */
  PropertySearchesInquiriesPkey = 'property_searches_inquiries_pkey'
}

/** input type for inserting data into table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Insert_Input = {
  enquiry?: InputMaybe<Enquiries_Obj_Rel_Insert_Input>;
  enquiry_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search?: InputMaybe<Property_Searches_Obj_Rel_Insert_Input>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Max_Order_By = {
  enquiry_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Min_Order_By = {
  enquiry_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_searches_enquiries" */
export type Property_Searches_Enquiries_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Searches_Enquiries>;
};

/** on_conflict condition type for table "property_searches_enquiries" */
export type Property_Searches_Enquiries_On_Conflict = {
  constraint: Property_Searches_Enquiries_Constraint;
  update_columns?: Array<Property_Searches_Enquiries_Update_Column>;
  where?: InputMaybe<Property_Searches_Enquiries_Bool_Exp>;
};

/** Ordering options when selecting data from "property_searches_enquiries". */
export type Property_Searches_Enquiries_Order_By = {
  enquiry?: InputMaybe<Enquiries_Order_By>;
  enquiry_id?: InputMaybe<Order_By>;
  property_search?: InputMaybe<Property_Searches_Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_searches_enquiries" */
export enum Property_Searches_Enquiries_Select_Column {
  /** column name */
  EnquiryId = 'enquiry_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

/** placeholder for update columns of table "property_searches_enquiries" (current role has no relevant permissions) */
export enum Property_Searches_Enquiries_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for incrementing numeric columns in table "property_searches" */
export type Property_Searches_Inc_Input = {
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "property_searches" */
export type Property_Searches_Insert_Input = {
  activate_aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  awaiting_alert_handle?: InputMaybe<Scalars['Boolean']['input']>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at_gte?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  last_alert_handle?: InputMaybe<Scalars['timestamptz']['input']>;
  last_notified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_searches_enquiries?: InputMaybe<Property_Searches_Enquiries_Arr_Rel_Insert_Input>;
  property_searches_places?: InputMaybe<Property_Searches_Places_Arr_Rel_Insert_Input>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_types?: InputMaybe<Property_Searches_Property_Types_Arr_Rel_Insert_Input>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Property_Search_Source_Enum>;
  title?: InputMaybe<Scalars['String']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Property_Searches_Max_Fields = {
  agency_reference_contains?: Maybe<Scalars['String']['output']>;
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  composite_property_type_eq?: Maybe<Scalars['String']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at_gte?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  last_alert_handle?: Maybe<Scalars['timestamptz']['output']>;
  last_notified_at?: Maybe<Scalars['timestamptz']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  notification?: Maybe<Scalars['property_searches_notification']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  portal_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_nin?: Maybe<Array<Scalars['String']['output']>>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_usage?: Maybe<Scalars['String']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_searches" */
export type Property_Searches_Max_Order_By = {
  agency_reference_contains?: InputMaybe<Order_By>;
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  composite_property_type_eq?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_gte?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  last_alert_handle?: InputMaybe<Order_By>;
  last_notified_at?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  notification?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  portal_in?: InputMaybe<Order_By>;
  property_main_type_in?: InputMaybe<Order_By>;
  property_main_type_nin?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_usage?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Searches_Min_Fields = {
  agency_reference_contains?: Maybe<Scalars['String']['output']>;
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  composite_property_type_eq?: Maybe<Scalars['String']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at_gte?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  last_alert_handle?: Maybe<Scalars['timestamptz']['output']>;
  last_notified_at?: Maybe<Scalars['timestamptz']['output']>;
  last_viewed_at?: Maybe<Scalars['timestamptz']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  notification?: Maybe<Scalars['property_searches_notification']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  portal_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_in?: Maybe<Array<Scalars['String']['output']>>;
  property_main_type_nin?: Maybe<Array<Scalars['String']['output']>>;
  property_status?: Maybe<Scalars['String']['output']>;
  property_usage?: Maybe<Scalars['String']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  session_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_searches" */
export type Property_Searches_Min_Order_By = {
  agency_reference_contains?: InputMaybe<Order_By>;
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  composite_property_type_eq?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_gte?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  last_alert_handle?: InputMaybe<Order_By>;
  last_notified_at?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  notification?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  portal_in?: InputMaybe<Order_By>;
  property_main_type_in?: InputMaybe<Order_By>;
  property_main_type_nin?: InputMaybe<Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_usage?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_searches" */
export type Property_Searches_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Searches>;
};

/** Boolean expression to compare columns of type "property_searches_notification". All fields are combined with logical 'AND'. */
export type Property_Searches_Notification_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _gte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _in?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _lte?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _neq?: InputMaybe<Scalars['property_searches_notification']['input']>;
  _nin?: InputMaybe<Array<Scalars['property_searches_notification']['input']>>;
};

/** input type for inserting object relation for remote table "property_searches" */
export type Property_Searches_Obj_Rel_Insert_Input = {
  data: Property_Searches_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_On_Conflict>;
};

/** on_conflict condition type for table "property_searches" */
export type Property_Searches_On_Conflict = {
  constraint: Property_Searches_Constraint;
  update_columns?: Array<Property_Searches_Update_Column>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};

/** Ordering options when selecting data from "property_searches". */
export type Property_Searches_Order_By = {
  activate_aggregator?: InputMaybe<Order_By>;
  agency_reference_contains?: InputMaybe<Order_By>;
  aggregator_source?: InputMaybe<Order_By>;
  awaiting_alert_handle?: InputMaybe<Order_By>;
  balcony_surface_gte?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  comment?: InputMaybe<Order_By>;
  composite_property_type_eq?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_gte?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_lift?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  last_alert_handle?: InputMaybe<Order_By>;
  last_notified_at?: InputMaybe<Order_By>;
  last_viewed_at?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  notification?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  portal_in?: InputMaybe<Order_By>;
  property_main_type_in?: InputMaybe<Order_By>;
  property_main_type_nin?: InputMaybe<Order_By>;
  property_searches_enquiries_aggregate?: InputMaybe<Property_Searches_Enquiries_Aggregate_Order_By>;
  property_searches_places_aggregate?: InputMaybe<Property_Searches_Places_Aggregate_Order_By>;
  property_status?: InputMaybe<Order_By>;
  property_types_aggregate?: InputMaybe<Property_Searches_Property_Types_Aggregate_Order_By>;
  property_usage?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  session_id?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
  travel_mode?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_searches */
export type Property_Searches_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "property_searches_places" */
export type Property_Searches_Places = {
  /** An object relationship */
  place: Places;
  place_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_search: Property_Searches;
  property_search_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "property_searches_places" */
export type Property_Searches_Places_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Places_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Places_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_searches_places" */
export type Property_Searches_Places_Arr_Rel_Insert_Input = {
  data: Array<Property_Searches_Places_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_Places_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_searches_places". All fields are combined with a logical 'AND'. */
export type Property_Searches_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Places_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Places_Bool_Exp>>;
  place?: InputMaybe<Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_search?: InputMaybe<Property_Searches_Bool_Exp>;
  property_search_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_searches_places" */
export enum Property_Searches_Places_Constraint {
  /** unique or primary key constraint on columns "property_search_id", "place_id" */
  PropertySearchesPlacesPkey = 'property_searches_places_pkey'
}

/** input type for inserting data into table "property_searches_places" */
export type Property_Searches_Places_Insert_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search?: InputMaybe<Property_Searches_Obj_Rel_Insert_Input>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "property_searches_places" */
export type Property_Searches_Places_Max_Order_By = {
  place_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_searches_places" */
export type Property_Searches_Places_Min_Order_By = {
  place_id?: InputMaybe<Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_searches_places" */
export type Property_Searches_Places_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Searches_Places>;
};

/** on_conflict condition type for table "property_searches_places" */
export type Property_Searches_Places_On_Conflict = {
  constraint: Property_Searches_Places_Constraint;
  update_columns?: Array<Property_Searches_Places_Update_Column>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};

/** Ordering options when selecting data from "property_searches_places". */
export type Property_Searches_Places_Order_By = {
  place?: InputMaybe<Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_search?: InputMaybe<Property_Searches_Order_By>;
  property_search_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_searches_places" */
export enum Property_Searches_Places_Select_Column {
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertySearchId = 'property_search_id'
}

/** Streaming cursor of the table "property_searches_places" */
export type Property_Searches_Places_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Searches_Places_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Searches_Places_Stream_Cursor_Value_Input = {
  place_id?: InputMaybe<Scalars['uuid']['input']>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "property_searches_places" (current role has no relevant permissions) */
export enum Property_Searches_Places_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "property_searches_property_types" */
export type Property_Searches_Property_Types = {
  /** An object relationship */
  property_search?: Maybe<Property_Searches>;
  property_search_id: Scalars['uuid']['output'];
  /** An object relationship */
  property_type: Property_Types;
  property_type_id: Scalars['uuid']['output'];
};

/** aggregated selection of "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate = {
  aggregate?: Maybe<Property_Searches_Property_Types_Aggregate_Fields>;
  nodes: Array<Property_Searches_Property_Types>;
};

export type Property_Searches_Property_Types_Aggregate_Bool_Exp = {
  count?: InputMaybe<Property_Searches_Property_Types_Aggregate_Bool_Exp_Count>;
};

export type Property_Searches_Property_Types_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Searches_Property_Types_Max_Fields>;
  min?: Maybe<Property_Searches_Property_Types_Min_Fields>;
};


/** aggregate fields of "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Searches_Property_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_searches_property_types" */
export type Property_Searches_Property_Types_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Searches_Property_Types_Max_Order_By>;
  min?: InputMaybe<Property_Searches_Property_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "property_searches_property_types" */
export type Property_Searches_Property_Types_Arr_Rel_Insert_Input = {
  data: Array<Property_Searches_Property_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Searches_Property_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "property_searches_property_types". All fields are combined with a logical 'AND'. */
export type Property_Searches_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Searches_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Searches_Property_Types_Bool_Exp>>;
  property_search?: InputMaybe<Property_Searches_Bool_Exp>;
  property_search_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_type?: InputMaybe<Property_Types_Bool_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_searches_property_types" */
export enum Property_Searches_Property_Types_Constraint {
  /** unique or primary key constraint on columns "property_search_id", "property_type_id" */
  PropertySearchesPropertyTypesPropertySearchIdPropertyTy = 'property_searches_property_types_property_search_id_property_ty'
}

/** input type for inserting data into table "property_searches_property_types" */
export type Property_Searches_Property_Types_Insert_Input = {
  property_search?: InputMaybe<Property_Searches_Obj_Rel_Insert_Input>;
  property_search_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Property_Searches_Property_Types_Max_Fields = {
  property_search_id?: Maybe<Scalars['uuid']['output']>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "property_searches_property_types" */
export type Property_Searches_Property_Types_Max_Order_By = {
  property_search_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Searches_Property_Types_Min_Fields = {
  property_search_id?: Maybe<Scalars['uuid']['output']>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "property_searches_property_types" */
export type Property_Searches_Property_Types_Min_Order_By = {
  property_search_id?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_searches_property_types" */
export type Property_Searches_Property_Types_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Searches_Property_Types>;
};

/** on_conflict condition type for table "property_searches_property_types" */
export type Property_Searches_Property_Types_On_Conflict = {
  constraint: Property_Searches_Property_Types_Constraint;
  update_columns?: Array<Property_Searches_Property_Types_Update_Column>;
  where?: InputMaybe<Property_Searches_Property_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "property_searches_property_types". */
export type Property_Searches_Property_Types_Order_By = {
  property_search?: InputMaybe<Property_Searches_Order_By>;
  property_search_id?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Property_Types_Order_By>;
  property_type_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_searches_property_types" */
export enum Property_Searches_Property_Types_Select_Column {
  /** column name */
  PropertySearchId = 'property_search_id',
  /** column name */
  PropertyTypeId = 'property_type_id'
}

/** placeholder for update columns of table "property_searches_property_types" (current role has no relevant permissions) */
export enum Property_Searches_Property_Types_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** select columns of table "property_searches" */
export enum Property_Searches_Select_Column {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceGte = 'built_surface_gte',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  ComputedBudgetGte = 'computed_budget_gte',
  /** column name */
  ComputedBudgetLte = 'computed_budget_lte',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedAtGte = 'created_at_gte',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastNotifiedAt = 'last_notified_at',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MaxTravelTime = 'max_travel_time',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng',
  /** column name */
  TravelMode = 'travel_mode',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "property_searches_aggregate_bool_exp_avg_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

/** select "property_searches_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible'
}

/** select "property_searches_aggregate_bool_exp_corr_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_max_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_min_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_sum_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** select "property_searches_aggregate_bool_exp_var_samp_arguments_columns" columns of table "property_searches" */
export enum Property_Searches_Select_Column_Property_Searches_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng'
}

/** input type for updating data in table "property_searches" */
export type Property_Searches_Set_Input = {
  activate_aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  awaiting_alert_handle?: InputMaybe<Scalars['Boolean']['input']>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at_gte?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  last_alert_handle?: InputMaybe<Scalars['timestamptz']['input']>;
  last_notified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Property_Search_Source_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Property_Searches_Stddev_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_searches" */
export type Property_Searches_Stddev_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Searches_Stddev_Pop_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_searches" */
export type Property_Searches_Stddev_Pop_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Searches_Stddev_Samp_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_searches" */
export type Property_Searches_Stddev_Samp_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_searches" */
export type Property_Searches_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Searches_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Searches_Stream_Cursor_Value_Input = {
  activate_aggregator?: InputMaybe<Scalars['Boolean']['input']>;
  agency_reference_contains?: InputMaybe<Scalars['String']['input']>;
  aggregator_source?: InputMaybe<Property_Search_Aggregator_Source_Enum>;
  awaiting_alert_handle?: InputMaybe<Scalars['Boolean']['input']>;
  balcony_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  book_online?: InputMaybe<Scalars['Boolean']['input']>;
  built_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  built_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  composite_property_type_eq?: InputMaybe<Scalars['String']['input']>;
  computed_budget_gte?: InputMaybe<Scalars['Float']['input']>;
  computed_budget_lte?: InputMaybe<Scalars['Float']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at_gte?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  garden_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  geog?: InputMaybe<Scalars['geography']['input']>;
  gross_rent_m2_yearly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_m2_yearly_lte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_gte?: InputMaybe<Scalars['Float']['input']>;
  gross_rent_room_monthly_lte?: InputMaybe<Scalars['Float']['input']>;
  has_balcony?: InputMaybe<Scalars['Boolean']['input']>;
  has_fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  has_garage?: InputMaybe<Scalars['Boolean']['input']>;
  has_garden?: InputMaybe<Scalars['Boolean']['input']>;
  has_lift?: InputMaybe<Scalars['Boolean']['input']>;
  has_parking?: InputMaybe<Scalars['Boolean']['input']>;
  has_swimming_pool?: InputMaybe<Scalars['Boolean']['input']>;
  has_view?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  is_child_friendly?: InputMaybe<Scalars['Boolean']['input']>;
  is_fsbo?: InputMaybe<Scalars['Boolean']['input']>;
  is_furnished?: InputMaybe<Scalars['Boolean']['input']>;
  is_minergie_certified?: InputMaybe<Scalars['Boolean']['input']>;
  is_new_development?: InputMaybe<Scalars['Boolean']['input']>;
  is_wheelchair_accessible?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  last_alert_handle?: InputMaybe<Scalars['timestamptz']['input']>;
  last_notified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  last_viewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  max_travel_time?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_gte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_lte?: InputMaybe<Scalars['Int']['input']>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Scalars['Float']['input']>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Scalars['Float']['input']>;
  notification?: InputMaybe<Scalars['property_searches_notification']['input']>;
  number_of_bathrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bathrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_bedrooms_lte?: InputMaybe<Scalars['Int']['input']>;
  number_of_indoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_outdoor_parkings_gte?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms_gte?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms_lte?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  portal_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_in?: InputMaybe<Array<Scalars['String']['input']>>;
  property_main_type_nin?: InputMaybe<Array<Scalars['String']['input']>>;
  property_status?: InputMaybe<Scalars['String']['input']>;
  property_usage?: InputMaybe<Scalars['String']['input']>;
  rental_return_gte?: InputMaybe<Scalars['Float']['input']>;
  rental_return_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_gte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_lte?: InputMaybe<Scalars['Int']['input']>;
  sale_price_per_land_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_land_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_price_per_living_surface_lte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_gte?: InputMaybe<Scalars['Float']['input']>;
  sale_vs_estimated_price_lte?: InputMaybe<Scalars['Float']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Property_Search_Source_Enum>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  travel_from_lat?: InputMaybe<Scalars['float8']['input']>;
  travel_from_lng?: InputMaybe<Scalars['float8']['input']>;
  travel_mode?: InputMaybe<Travel_Modes_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Property_Searches_Sum_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['float8']['output']>;
  max_travel_time?: Maybe<Scalars['Int']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Int']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Int']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Int']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Int']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Int']['output']>;
  sale_price_lte?: Maybe<Scalars['Int']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['float8']['output']>;
  travel_from_lng?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "property_searches" */
export type Property_Searches_Sum_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** update columns of table "property_searches" */
export enum Property_Searches_Update_Column {
  /** column name */
  ActivateAggregator = 'activate_aggregator',
  /** column name */
  AgencyReferenceContains = 'agency_reference_contains',
  /** column name */
  AggregatorSource = 'aggregator_source',
  /** column name */
  AwaitingAlertHandle = 'awaiting_alert_handle',
  /** column name */
  BalconySurfaceGte = 'balcony_surface_gte',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurfaceGte = 'built_surface_gte',
  /** column name */
  BuiltSurfaceLte = 'built_surface_lte',
  /** column name */
  Comment = 'comment',
  /** column name */
  CompositePropertyTypeEq = 'composite_property_type_eq',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedAtGte = 'created_at_gte',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  GardenSurfaceGte = 'garden_surface_gte',
  /** column name */
  Geog = 'geog',
  /** column name */
  GrossRentM2YearlyGte = 'gross_rent_m2_yearly_gte',
  /** column name */
  GrossRentM2YearlyLte = 'gross_rent_m2_yearly_lte',
  /** column name */
  GrossRentRoomMonthlyGte = 'gross_rent_room_monthly_gte',
  /** column name */
  GrossRentRoomMonthlyLte = 'gross_rent_room_monthly_lte',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasLift = 'has_lift',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasView = 'has_view',
  /** column name */
  Id = 'id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  LandSurfaceGte = 'land_surface_gte',
  /** column name */
  LandSurfaceLte = 'land_surface_lte',
  /** column name */
  LastAlertHandle = 'last_alert_handle',
  /** column name */
  LastNotifiedAt = 'last_notified_at',
  /** column name */
  LastViewedAt = 'last_viewed_at',
  /** column name */
  LivingSurfaceGte = 'living_surface_gte',
  /** column name */
  LivingSurfaceLte = 'living_surface_lte',
  /** column name */
  MaxDistance = 'max_distance',
  /** column name */
  MaxTravelTime = 'max_travel_time',
  /** column name */
  MonthlyRentGte = 'monthly_rent_gte',
  /** column name */
  MonthlyRentLte = 'monthly_rent_lte',
  /** column name */
  MonthlyRentVsEstimatedRentGte = 'monthly_rent_vs_estimated_rent_gte',
  /** column name */
  MonthlyRentVsEstimatedRentLte = 'monthly_rent_vs_estimated_rent_lte',
  /** column name */
  Notification = 'notification',
  /** column name */
  NumberOfBathroomsGte = 'number_of_bathrooms_gte',
  /** column name */
  NumberOfBathroomsLte = 'number_of_bathrooms_lte',
  /** column name */
  NumberOfBedroomsGte = 'number_of_bedrooms_gte',
  /** column name */
  NumberOfBedroomsLte = 'number_of_bedrooms_lte',
  /** column name */
  NumberOfIndoorParkingsGte = 'number_of_indoor_parkings_gte',
  /** column name */
  NumberOfOutdoorParkingsGte = 'number_of_outdoor_parkings_gte',
  /** column name */
  NumberOfRoomsGte = 'number_of_rooms_gte',
  /** column name */
  NumberOfRoomsLte = 'number_of_rooms_lte',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  PortalIn = 'portal_in',
  /** column name */
  PropertyMainTypeIn = 'property_main_type_in',
  /** column name */
  PropertyMainTypeNin = 'property_main_type_nin',
  /** column name */
  PropertyStatus = 'property_status',
  /** column name */
  PropertyUsage = 'property_usage',
  /** column name */
  RentalReturnGte = 'rental_return_gte',
  /** column name */
  RentalReturnLte = 'rental_return_lte',
  /** column name */
  SalePriceGte = 'sale_price_gte',
  /** column name */
  SalePriceLte = 'sale_price_lte',
  /** column name */
  SalePricePerLandSurfaceGte = 'sale_price_per_land_surface_gte',
  /** column name */
  SalePricePerLandSurfaceLte = 'sale_price_per_land_surface_lte',
  /** column name */
  SalePricePerLivingSurfaceGte = 'sale_price_per_living_surface_gte',
  /** column name */
  SalePricePerLivingSurfaceLte = 'sale_price_per_living_surface_lte',
  /** column name */
  SaleVsEstimatedPriceGte = 'sale_vs_estimated_price_gte',
  /** column name */
  SaleVsEstimatedPriceLte = 'sale_vs_estimated_price_lte',
  /** column name */
  SessionId = 'session_id',
  /** column name */
  Source = 'source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  TravelFromLat = 'travel_from_lat',
  /** column name */
  TravelFromLng = 'travel_from_lng',
  /** column name */
  TravelMode = 'travel_mode',
  /** column name */
  UserId = 'user_id'
}

export type Property_Searches_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Searches_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Searches_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Searches_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Searches_Var_Pop_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_searches" */
export type Property_Searches_Var_Pop_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Searches_Var_Samp_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_searches" */
export type Property_Searches_Var_Samp_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Searches_Variance_Fields = {
  balcony_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_gte?: Maybe<Scalars['Float']['output']>;
  built_surface_lte?: Maybe<Scalars['Float']['output']>;
  computed_budget_gte?: Maybe<Scalars['Float']['output']>;
  computed_budget_lte?: Maybe<Scalars['Float']['output']>;
  garden_surface_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2_yearly_lte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_gte?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly_lte?: Maybe<Scalars['Float']['output']>;
  land_surface_gte?: Maybe<Scalars['Float']['output']>;
  land_surface_lte?: Maybe<Scalars['Float']['output']>;
  living_surface_gte?: Maybe<Scalars['Float']['output']>;
  living_surface_lte?: Maybe<Scalars['Float']['output']>;
  max_distance?: Maybe<Scalars['Float']['output']>;
  max_travel_time?: Maybe<Scalars['Float']['output']>;
  monthly_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_lte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_gte?: Maybe<Scalars['Float']['output']>;
  monthly_rent_vs_estimated_rent_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms_lte?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_gte?: Maybe<Scalars['Float']['output']>;
  number_of_rooms_lte?: Maybe<Scalars['Float']['output']>;
  rental_return_gte?: Maybe<Scalars['Float']['output']>;
  rental_return_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_gte?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface_lte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_gte?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price_lte?: Maybe<Scalars['Float']['output']>;
  travel_from_lat?: Maybe<Scalars['Float']['output']>;
  travel_from_lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_searches" */
export type Property_Searches_Variance_Order_By = {
  balcony_surface_gte?: InputMaybe<Order_By>;
  built_surface_gte?: InputMaybe<Order_By>;
  built_surface_lte?: InputMaybe<Order_By>;
  computed_budget_gte?: InputMaybe<Order_By>;
  computed_budget_lte?: InputMaybe<Order_By>;
  garden_surface_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_gte?: InputMaybe<Order_By>;
  gross_rent_m2_yearly_lte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_gte?: InputMaybe<Order_By>;
  gross_rent_room_monthly_lte?: InputMaybe<Order_By>;
  land_surface_gte?: InputMaybe<Order_By>;
  land_surface_lte?: InputMaybe<Order_By>;
  living_surface_gte?: InputMaybe<Order_By>;
  living_surface_lte?: InputMaybe<Order_By>;
  max_distance?: InputMaybe<Order_By>;
  max_travel_time?: InputMaybe<Order_By>;
  monthly_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_lte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_gte?: InputMaybe<Order_By>;
  monthly_rent_vs_estimated_rent_lte?: InputMaybe<Order_By>;
  number_of_bathrooms_gte?: InputMaybe<Order_By>;
  number_of_bathrooms_lte?: InputMaybe<Order_By>;
  number_of_bedrooms_gte?: InputMaybe<Order_By>;
  number_of_bedrooms_lte?: InputMaybe<Order_By>;
  number_of_indoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_outdoor_parkings_gte?: InputMaybe<Order_By>;
  number_of_rooms_gte?: InputMaybe<Order_By>;
  number_of_rooms_lte?: InputMaybe<Order_By>;
  rental_return_gte?: InputMaybe<Order_By>;
  rental_return_lte?: InputMaybe<Order_By>;
  sale_price_gte?: InputMaybe<Order_By>;
  sale_price_lte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_land_surface_lte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_gte?: InputMaybe<Order_By>;
  sale_price_per_living_surface_lte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_gte?: InputMaybe<Order_By>;
  sale_vs_estimated_price_lte?: InputMaybe<Order_By>;
  travel_from_lat?: InputMaybe<Order_By>;
  travel_from_lng?: InputMaybe<Order_By>;
};

export enum Property_Side_Enum_Enum {
  Exterior = 'exterior',
  Interior = 'interior'
}

/** Boolean expression to compare columns of type "property_side_enum_enum". All fields are combined with logical 'AND'. */
export type Property_Side_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Property_Side_Enum_Enum>;
  _in?: InputMaybe<Array<Property_Side_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Property_Side_Enum_Enum>;
  _nin?: InputMaybe<Array<Property_Side_Enum_Enum>>;
};

/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_Transactions = {
  /** An object relationship */
  buyer_broker?: Maybe<Users>;
  buyer_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  buyer_broker_team?: Maybe<Teams>;
  buyer_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  buyers: Array<Transaction_Buyers>;
  /** An aggregate relationship */
  buyers_aggregate: Transaction_Buyers_Aggregate;
  /** An array relationship */
  cma_reports_agent_transactions: Array<Cma_Reports_Agent_Transactions>;
  /** An array relationship */
  commissions: Array<Commissions>;
  /** An aggregate relationship */
  commissions_aggregate: Commissions_Aggregate;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  creator?: Maybe<Users>;
  crm_link?: Maybe<Scalars['String']['output']>;
  estimated_signature_date?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  is_published: Scalars['Boolean']['output'];
  /** An object relationship */
  lot?: Maybe<Lots>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  mls_share?: Maybe<Mls_Shares>;
  notary_id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  property: Properties;
  property_id: Scalars['uuid']['output'];
  /** An array relationship */
  property_transactions_listings: Array<Property_Transactions_Listings>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** An object relationship */
  seller_broker?: Maybe<Users>;
  seller_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  seller_broker_team?: Maybe<Teams>;
  seller_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  sellers: Array<Transaction_Sellers>;
  /** An aggregate relationship */
  sellers_aggregate: Transaction_Sellers_Aggregate;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  tenant_id: Scalars['uuid']['output'];
  /** An array relationship */
  transaction_valuations: Array<Transaction_Valuations>;
  /** An aggregate relationship */
  transaction_valuations_aggregate: Transaction_Valuations_Aggregate;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsBuyersArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Buyers_Order_By>>;
  where?: InputMaybe<Transaction_Buyers_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsBuyers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Buyers_Order_By>>;
  where?: InputMaybe<Transaction_Buyers_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsCma_Reports_Agent_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsCommissionsArgs = {
  distinct_on?: InputMaybe<Array<Commissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Commissions_Order_By>>;
  where?: InputMaybe<Commissions_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsCommissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Commissions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Commissions_Order_By>>;
  where?: InputMaybe<Commissions_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsProperty_Transactions_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Listings_Order_By>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsSellersArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Sellers_Order_By>>;
  where?: InputMaybe<Transaction_Sellers_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsSellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Sellers_Order_By>>;
  where?: InputMaybe<Transaction_Sellers_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsTransaction_ValuationsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Valuations_Order_By>>;
  where?: InputMaybe<Transaction_Valuations_Bool_Exp>;
};


/** Deals recorded by an agency: purchase_price, signature_date, the seller and buyer brokers and their teams, on a property (property_id -> properties). There is no currency column: use the listing's currency when lot_id is set, else the currency of the tenant's country (tenants.country_code). is_published = shown publicly, after review. */
export type Property_TransactionsTransaction_Valuations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Valuations_Order_By>>;
  where?: InputMaybe<Transaction_Valuations_Bool_Exp>;
};

/** aggregated selection of "property_transactions" */
export type Property_Transactions_Aggregate = {
  aggregate?: Maybe<Property_Transactions_Aggregate_Fields>;
  nodes: Array<Property_Transactions>;
};

export type Property_Transactions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp_Count>;
};

export type Property_Transactions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Transactions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Transactions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Property_Transactions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Property_Transactions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "property_transactions" */
export type Property_Transactions_Aggregate_Fields = {
  avg?: Maybe<Property_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Transactions_Max_Fields>;
  min?: Maybe<Property_Transactions_Min_Fields>;
  stddev?: Maybe<Property_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Transactions_Sum_Fields>;
  var_pop?: Maybe<Property_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Property_Transactions_Variance_Fields>;
};


/** aggregate fields of "property_transactions" */
export type Property_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_transactions" */
export type Property_Transactions_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Transactions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Transactions_Max_Order_By>;
  min?: InputMaybe<Property_Transactions_Min_Order_By>;
  stddev?: InputMaybe<Property_Transactions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Transactions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Transactions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Transactions_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Transactions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Transactions_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Transactions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_transactions" */
export type Property_Transactions_Arr_Rel_Insert_Input = {
  data: Array<Property_Transactions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};

/** aggregate avg on columns */
export type Property_Transactions_Avg_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_transactions" */
export type Property_Transactions_Avg_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_transactions". All fields are combined with a logical 'AND'. */
export type Property_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Property_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Transactions_Bool_Exp>>;
  buyer_broker?: InputMaybe<Users_Bool_Exp>;
  buyer_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyer_broker_team?: InputMaybe<Teams_Bool_Exp>;
  buyer_broker_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  buyers?: InputMaybe<Transaction_Buyers_Bool_Exp>;
  buyers_aggregate?: InputMaybe<Transaction_Buyers_Aggregate_Bool_Exp>;
  cma_reports_agent_transactions?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
  commissions?: InputMaybe<Commissions_Bool_Exp>;
  commissions_aggregate?: InputMaybe<Commissions_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  estimated_signature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  lot?: InputMaybe<Lots_Bool_Exp>;
  lot_id?: InputMaybe<Uuid_Comparison_Exp>;
  mls_share?: InputMaybe<Mls_Shares_Bool_Exp>;
  notary_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  property?: InputMaybe<Properties_Bool_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_transactions_listings?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
  purchase_price?: InputMaybe<Float_Comparison_Exp>;
  reviewed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  reviewed_by?: InputMaybe<Uuid_Comparison_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Bool_Exp>;
  seller_broker?: InputMaybe<Users_Bool_Exp>;
  seller_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  seller_broker_team?: InputMaybe<Teams_Bool_Exp>;
  seller_broker_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  sellers?: InputMaybe<Transaction_Sellers_Bool_Exp>;
  sellers_aggregate?: InputMaybe<Transaction_Sellers_Aggregate_Bool_Exp>;
  signature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_valuations?: InputMaybe<Transaction_Valuations_Bool_Exp>;
  transaction_valuations_aggregate?: InputMaybe<Transaction_Valuations_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_transactions" */
export enum Property_Transactions_Constraint {
  /** unique or primary key constraint on columns "id" */
  PropertyTransactionsPkey = 'property_transactions_pkey'
}

/** Optimized country-based view of property transactions for CMA step-transaction functionality */
export type Property_Transactions_Country_View = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  is_published?: Maybe<Scalars['Boolean']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  locality_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  locality_place?: Maybe<Places>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_id?: Maybe<Scalars['uuid']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "property_transactions_country_view". All fields are combined with a logical 'AND'. */
export type Property_Transactions_Country_View_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Transactions_Country_View_Bool_Exp>>;
  _not?: InputMaybe<Property_Transactions_Country_View_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Transactions_Country_View_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_published?: InputMaybe<Boolean_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_name?: InputMaybe<String_Comparison_Exp>;
  locality_place?: InputMaybe<Places_Bool_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Float_Comparison_Exp>;
  signature_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_transactions_country_view". */
export type Property_Transactions_Country_View_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_name?: InputMaybe<Order_By>;
  locality_place?: InputMaybe<Places_Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_id?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_transactions_country_view" */
export enum Property_Transactions_Country_View_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LocalityName = 'locality_name',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeId = 'property_type_id',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "property_transactions_country_view" */
export type Property_Transactions_Country_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Transactions_Country_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Transactions_Country_View_Stream_Cursor_Value_Input = {
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  land_surface?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_name?: InputMaybe<Scalars['String']['input']>;
  number_of_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_main_type?: InputMaybe<Scalars['String']['input']>;
  property_type_id?: InputMaybe<Scalars['uuid']['input']>;
  property_type_name?: InputMaybe<Scalars['String']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "property_transactions_distance" */
export type Property_Transactions_Distance = {
  distance_in_meters: Scalars['float8']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  transaction?: Maybe<Property_Transactions_Country_View>;
  transaction_id: Scalars['uuid']['output'];
};

export type Property_Transactions_Distance_Aggregate = {
  aggregate?: Maybe<Property_Transactions_Distance_Aggregate_Fields>;
  nodes: Array<Property_Transactions_Distance>;
};

/** aggregate fields of "property_transactions_distance" */
export type Property_Transactions_Distance_Aggregate_Fields = {
  avg?: Maybe<Property_Transactions_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Transactions_Distance_Max_Fields>;
  min?: Maybe<Property_Transactions_Distance_Min_Fields>;
  stddev?: Maybe<Property_Transactions_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Transactions_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Transactions_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Transactions_Distance_Sum_Fields>;
  var_pop?: Maybe<Property_Transactions_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Transactions_Distance_Var_Samp_Fields>;
  variance?: Maybe<Property_Transactions_Distance_Variance_Fields>;
};


/** aggregate fields of "property_transactions_distance" */
export type Property_Transactions_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Property_Transactions_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "property_transactions_distance". All fields are combined with a logical 'AND'. */
export type Property_Transactions_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Transactions_Distance_Bool_Exp>>;
  _not?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Transactions_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float8_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction?: InputMaybe<Property_Transactions_Country_View_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Property_Transactions_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Property_Transactions_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "property_transactions_distance". */
export type Property_Transactions_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Property_Transactions_Country_View_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** select columns of table "property_transactions_distance" */
export enum Property_Transactions_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  TransactionId = 'transaction_id'
}

/** aggregate stddev on columns */
export type Property_Transactions_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Property_Transactions_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Property_Transactions_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "property_transactions_distance" */
export type Property_Transactions_Distance_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Transactions_Distance_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Transactions_Distance_Stream_Cursor_Value_Input = {
  distance_in_meters?: InputMaybe<Scalars['float8']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Property_Transactions_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Property_Transactions_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Property_Transactions_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Property_Transactions_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
};

/** input type for incrementing numeric columns in table "property_transactions" */
export type Property_Transactions_Inc_Input = {
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "property_transactions" */
export type Property_Transactions_Insert_Input = {
  buyer_broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  buyers?: InputMaybe<Transaction_Buyers_Arr_Rel_Insert_Input>;
  cma_reports_agent_transactions?: InputMaybe<Cma_Reports_Agent_Transactions_Arr_Rel_Insert_Input>;
  commissions?: InputMaybe<Commissions_Arr_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot?: InputMaybe<Lots_Obj_Rel_Insert_Input>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  mls_share?: InputMaybe<Mls_Shares_Obj_Rel_Insert_Input>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property?: InputMaybe<Properties_Obj_Rel_Insert_Input>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transactions_listings?: InputMaybe<Property_Transactions_Listings_Arr_Rel_Insert_Input>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  seller_broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  sellers?: InputMaybe<Transaction_Sellers_Arr_Rel_Insert_Input>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** columns and relationships of "property_transactions_listings" */
export type Property_Transactions_Listings = {
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  listing_id: Scalars['Int']['output'];
  /** An object relationship */
  property_transaction: Property_Transactions;
  property_transaction_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  verified: Scalars['Boolean']['output'];
};

/** order by aggregate values of table "property_transactions_listings" */
export type Property_Transactions_Listings_Aggregate_Order_By = {
  avg?: InputMaybe<Property_Transactions_Listings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Property_Transactions_Listings_Max_Order_By>;
  min?: InputMaybe<Property_Transactions_Listings_Min_Order_By>;
  stddev?: InputMaybe<Property_Transactions_Listings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Property_Transactions_Listings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Property_Transactions_Listings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Property_Transactions_Listings_Sum_Order_By>;
  var_pop?: InputMaybe<Property_Transactions_Listings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Property_Transactions_Listings_Var_Samp_Order_By>;
  variance?: InputMaybe<Property_Transactions_Listings_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "property_transactions_listings" */
export type Property_Transactions_Listings_Arr_Rel_Insert_Input = {
  data: Array<Property_Transactions_Listings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Transactions_Listings_On_Conflict>;
};

/** order by avg() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Avg_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "property_transactions_listings". All fields are combined with a logical 'AND'. */
export type Property_Transactions_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Transactions_Listings_Bool_Exp>>;
  _not?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Transactions_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  verified?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "property_transactions_listings" */
export enum Property_Transactions_Listings_Constraint {
  /** unique or primary key constraint on columns "property_transaction_id", "listing_id" */
  PropertyTransactionsListingsPkey = 'property_transactions_listings_pkey'
}

/** input type for incrementing numeric columns in table "property_transactions_listings" */
export type Property_Transactions_Listings_Inc_Input = {
  listing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_transactions_listings" */
export type Property_Transactions_Listings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by max() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_transactions_listings" */
export type Property_Transactions_Listings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Transactions_Listings>;
};

/** on_conflict condition type for table "property_transactions_listings" */
export type Property_Transactions_Listings_On_Conflict = {
  constraint: Property_Transactions_Listings_Constraint;
  update_columns?: Array<Property_Transactions_Listings_Update_Column>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};

/** Ordering options when selecting data from "property_transactions_listings". */
export type Property_Transactions_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  property_transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  verified?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_transactions_listings */
export type Property_Transactions_Listings_Pk_Columns_Input = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};

/** select columns of table "property_transactions_listings" */
export enum Property_Transactions_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

/** input type for updating data in table "property_transactions_listings" */
export type Property_Transactions_Listings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by stddev() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Stddev_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Stddev_Pop_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Stddev_Samp_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_transactions_listings" */
export type Property_Transactions_Listings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Transactions_Listings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Transactions_Listings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  listing_id?: InputMaybe<Scalars['Int']['input']>;
  property_transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by sum() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Sum_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** update columns of table "property_transactions_listings" */
export enum Property_Transactions_Listings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  PropertyTransactionId = 'property_transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Verified = 'verified'
}

export type Property_Transactions_Listings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Transactions_Listings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Transactions_Listings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Transactions_Listings_Bool_Exp;
};

/** order by var_pop() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Var_Pop_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Var_Samp_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "property_transactions_listings" */
export type Property_Transactions_Listings_Variance_Order_By = {
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Property_Transactions_Max_Fields = {
  buyer_broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  crm_link?: Maybe<Scalars['String']['output']>;
  estimated_signature_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  notary_id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['uuid']['output']>;
  seller_broker_id?: Maybe<Scalars['uuid']['output']>;
  seller_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_transactions" */
export type Property_Transactions_Max_Order_By = {
  buyer_broker_id?: InputMaybe<Order_By>;
  buyer_broker_team_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  estimated_signature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  notary_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  seller_broker_id?: InputMaybe<Order_By>;
  seller_broker_team_id?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Property_Transactions_Min_Fields = {
  buyer_broker_id?: Maybe<Scalars['uuid']['output']>;
  buyer_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  crm_link?: Maybe<Scalars['String']['output']>;
  estimated_signature_date?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lot_id?: Maybe<Scalars['uuid']['output']>;
  notary_id?: Maybe<Scalars['uuid']['output']>;
  payment_date?: Maybe<Scalars['timestamptz']['output']>;
  property_id?: Maybe<Scalars['uuid']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
  reviewed_at?: Maybe<Scalars['timestamptz']['output']>;
  reviewed_by?: Maybe<Scalars['uuid']['output']>;
  seller_broker_id?: Maybe<Scalars['uuid']['output']>;
  seller_broker_team_id?: Maybe<Scalars['uuid']['output']>;
  signature_date?: Maybe<Scalars['timestamptz']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_transactions" */
export type Property_Transactions_Min_Order_By = {
  buyer_broker_id?: InputMaybe<Order_By>;
  buyer_broker_team_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  estimated_signature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lot_id?: InputMaybe<Order_By>;
  notary_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property_id?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  seller_broker_id?: InputMaybe<Order_By>;
  seller_broker_team_id?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "property_transactions" */
export type Property_Transactions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Property_Transactions>;
};

/** input type for inserting object relation for remote table "property_transactions" */
export type Property_Transactions_Obj_Rel_Insert_Input = {
  data: Property_Transactions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Property_Transactions_On_Conflict>;
};

/** on_conflict condition type for table "property_transactions" */
export type Property_Transactions_On_Conflict = {
  constraint: Property_Transactions_Constraint;
  update_columns?: Array<Property_Transactions_Update_Column>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};

/** Ordering options when selecting data from "property_transactions". */
export type Property_Transactions_Order_By = {
  buyer_broker?: InputMaybe<Users_Order_By>;
  buyer_broker_id?: InputMaybe<Order_By>;
  buyer_broker_team?: InputMaybe<Teams_Order_By>;
  buyer_broker_team_id?: InputMaybe<Order_By>;
  buyers_aggregate?: InputMaybe<Transaction_Buyers_Aggregate_Order_By>;
  cma_reports_agent_transactions_aggregate?: InputMaybe<Cma_Reports_Agent_Transactions_Aggregate_Order_By>;
  commissions_aggregate?: InputMaybe<Commissions_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  estimated_signature_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_published?: InputMaybe<Order_By>;
  lot?: InputMaybe<Lots_Order_By>;
  lot_id?: InputMaybe<Order_By>;
  mls_share?: InputMaybe<Mls_Shares_Order_By>;
  notary_id?: InputMaybe<Order_By>;
  payment_date?: InputMaybe<Order_By>;
  property?: InputMaybe<Properties_Order_By>;
  property_id?: InputMaybe<Order_By>;
  property_transactions_listings_aggregate?: InputMaybe<Property_Transactions_Listings_Aggregate_Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  reviewed_at?: InputMaybe<Order_By>;
  reviewed_by?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  seller_broker?: InputMaybe<Users_Order_By>;
  seller_broker_id?: InputMaybe<Order_By>;
  seller_broker_team?: InputMaybe<Teams_Order_By>;
  seller_broker_team_id?: InputMaybe<Order_By>;
  sellers_aggregate?: InputMaybe<Transaction_Sellers_Aggregate_Order_By>;
  signature_date?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_valuations_aggregate?: InputMaybe<Transaction_Valuations_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: property_transactions */
export type Property_Transactions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_transactions" */
export enum Property_Transactions_Select_Column {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PropertyId = 'property_id',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "property_transactions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "property_transactions" */
export enum Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsPublished = 'is_published'
}

/** select "property_transactions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "property_transactions" */
export enum Property_Transactions_Select_Column_Property_Transactions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsPublished = 'is_published'
}

/** input type for updating data in table "property_transactions" */
export type Property_Transactions_Set_Input = {
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Property_Transactions_Stddev_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_transactions" */
export type Property_Transactions_Stddev_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Property_Transactions_Stddev_Pop_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "property_transactions" */
export type Property_Transactions_Stddev_Pop_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Property_Transactions_Stddev_Samp_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "property_transactions" */
export type Property_Transactions_Stddev_Samp_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "property_transactions" */
export type Property_Transactions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Transactions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Transactions_Stream_Cursor_Value_Input = {
  buyer_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  buyer_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  estimated_signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  notary_id?: InputMaybe<Scalars['uuid']['input']>;
  payment_date?: InputMaybe<Scalars['timestamptz']['input']>;
  property_id?: InputMaybe<Scalars['uuid']['input']>;
  purchase_price?: InputMaybe<Scalars['Float']['input']>;
  reviewed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  reviewed_by?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  seller_broker_team_id?: InputMaybe<Scalars['uuid']['input']>;
  signature_date?: InputMaybe<Scalars['timestamptz']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Transactions_Sum_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "property_transactions" */
export type Property_Transactions_Sum_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** update columns of table "property_transactions" */
export enum Property_Transactions_Update_Column {
  /** column name */
  BuyerBrokerId = 'buyer_broker_id',
  /** column name */
  BuyerBrokerTeamId = 'buyer_broker_team_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EstimatedSignatureDate = 'estimated_signature_date',
  /** column name */
  IsPublished = 'is_published',
  /** column name */
  LotId = 'lot_id',
  /** column name */
  NotaryId = 'notary_id',
  /** column name */
  PaymentDate = 'payment_date',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  ReviewedAt = 'reviewed_at',
  /** column name */
  ReviewedBy = 'reviewed_by',
  /** column name */
  SellerBrokerId = 'seller_broker_id',
  /** column name */
  SellerBrokerTeamId = 'seller_broker_team_id',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Property_Transactions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Property_Transactions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Property_Transactions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Property_Transactions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Property_Transactions_Var_Pop_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "property_transactions" */
export type Property_Transactions_Var_Pop_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Property_Transactions_Var_Samp_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "property_transactions" */
export type Property_Transactions_Var_Samp_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Property_Transactions_Variance_Fields = {
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_transactions" */
export type Property_Transactions_Variance_Order_By = {
  purchase_price?: InputMaybe<Order_By>;
};

/** Catalogue of property types. main_type groups them: HOUSE, APPT, PARK, INDUS and others. */
export type Property_Types = {
  appraisal_type?: Maybe<Scalars['String']['output']>;
  composite_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  composite_type_object?: Maybe<Property_Types>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  is_visible?: Maybe<Scalars['Boolean']['output']>;
  /** compute property type label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  main_type?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  main_type_object?: Maybe<Property_Types>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parent_type?: Maybe<Property_Types>;
  pricehubble_subcode?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_types" */
export type Property_Types_Aggregate = {
  aggregate?: Maybe<Property_Types_Aggregate_Fields>;
  nodes: Array<Property_Types>;
};

/** aggregate fields of "property_types" */
export type Property_Types_Aggregate_Fields = {
  avg?: Maybe<Property_Types_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Property_Types_Max_Fields>;
  min?: Maybe<Property_Types_Min_Fields>;
  stddev?: Maybe<Property_Types_Stddev_Fields>;
  stddev_pop?: Maybe<Property_Types_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Property_Types_Stddev_Samp_Fields>;
  sum?: Maybe<Property_Types_Sum_Fields>;
  var_pop?: Maybe<Property_Types_Var_Pop_Fields>;
  var_samp?: Maybe<Property_Types_Var_Samp_Fields>;
  variance?: Maybe<Property_Types_Variance_Fields>;
};


/** aggregate fields of "property_types" */
export type Property_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Property_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Property_Types_Avg_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Property_Types_Bool_Exp>>;
  appraisal_type?: InputMaybe<String_Comparison_Exp>;
  composite_type?: InputMaybe<String_Comparison_Exp>;
  composite_type_object?: InputMaybe<Property_Types_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_type_id?: InputMaybe<Int_Comparison_Exp>;
  is_visible?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  main_type?: InputMaybe<String_Comparison_Exp>;
  main_type_object?: InputMaybe<Property_Types_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  parent_type?: InputMaybe<Property_Types_Bool_Exp>;
  pricehubble_subcode?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** aggregate max on columns */
export type Property_Types_Max_Fields = {
  appraisal_type?: Maybe<Scalars['String']['output']>;
  composite_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  /** compute property type label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  main_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pricehubble_subcode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Property_Types_Min_Fields = {
  appraisal_type?: Maybe<Scalars['String']['output']>;
  composite_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  /** compute property type label */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  main_type?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  pricehubble_subcode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** Ordering options when selecting data from "property_types". */
export type Property_Types_Order_By = {
  appraisal_type?: InputMaybe<Order_By>;
  composite_type?: InputMaybe<Order_By>;
  composite_type_object?: InputMaybe<Property_Types_Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_type_id?: InputMaybe<Order_By>;
  is_visible?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  main_type?: InputMaybe<Order_By>;
  main_type_object?: InputMaybe<Property_Types_Order_By>;
  name?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  parent_type?: InputMaybe<Property_Types_Order_By>;
  pricehubble_subcode?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Property_Types_Select_Column {
  /** column name */
  AppraisalType = 'appraisal_type',
  /** column name */
  CompositeType = 'composite_type',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IdxTypeId = 'idx_type_id',
  /** column name */
  IsVisible = 'is_visible',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  MainType = 'main_type',
  /** column name */
  Name = 'name',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  PricehubbleSubcode = 'pricehubble_subcode',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** aggregate stddev on columns */
export type Property_Types_Stddev_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Property_Types_Stddev_Pop_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Property_Types_Stddev_Samp_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "property_types" */
export type Property_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Property_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Property_Types_Stream_Cursor_Value_Input = {
  appraisal_type?: InputMaybe<Scalars['String']['input']>;
  composite_type?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_type_id?: InputMaybe<Scalars['Int']['input']>;
  is_visible?: InputMaybe<Scalars['Boolean']['input']>;
  label_de?: InputMaybe<Scalars['String']['input']>;
  label_en?: InputMaybe<Scalars['String']['input']>;
  label_es?: InputMaybe<Scalars['String']['input']>;
  label_fr?: InputMaybe<Scalars['String']['input']>;
  label_it?: InputMaybe<Scalars['String']['input']>;
  label_pl?: InputMaybe<Scalars['String']['input']>;
  label_pt?: InputMaybe<Scalars['String']['input']>;
  main_type?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  pricehubble_subcode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Property_Types_Sum_Fields = {
  idx_type_id?: Maybe<Scalars['Int']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Property_Types_Var_Pop_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Property_Types_Var_Samp_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Property_Types_Variance_Fields = {
  idx_type_id?: Maybe<Scalars['Float']['output']>;
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "prospection_contact_message_templates" */
export type Prospection_Contact_Message_Templates = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  language: Scalars['user_language']['output'];
  message: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "prospection_contact_message_templates". All fields are combined with a logical 'AND'. */
export type Prospection_Contact_Message_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Contact_Message_Templates_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Contact_Message_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Contact_Message_Templates_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospection_contact_message_templates" */
export enum Prospection_Contact_Message_Templates_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProspectionContactMessageTemplatesPkey = 'prospection_contact_message_templates_pkey',
  /** unique or primary key constraint on columns "user_id", "language" */
  ProspectionContactMessageTemplatesUserLanguageKey = 'prospection_contact_message_templates_user_language_key'
}

/** input type for inserting data into table "prospection_contact_message_templates" */
export type Prospection_Contact_Message_Templates_Insert_Input = {
  language?: InputMaybe<Scalars['user_language']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** response of any mutation on the table "prospection_contact_message_templates" */
export type Prospection_Contact_Message_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospection_Contact_Message_Templates>;
};

/** on_conflict condition type for table "prospection_contact_message_templates" */
export type Prospection_Contact_Message_Templates_On_Conflict = {
  constraint: Prospection_Contact_Message_Templates_Constraint;
  update_columns?: Array<Prospection_Contact_Message_Templates_Update_Column>;
  where?: InputMaybe<Prospection_Contact_Message_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "prospection_contact_message_templates". */
export type Prospection_Contact_Message_Templates_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospection_contact_message_templates */
export type Prospection_Contact_Message_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "prospection_contact_message_templates" */
export enum Prospection_Contact_Message_Templates_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  Message = 'message',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "prospection_contact_message_templates" */
export type Prospection_Contact_Message_Templates_Set_Input = {
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "prospection_contact_message_templates" */
export type Prospection_Contact_Message_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospection_Contact_Message_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospection_Contact_Message_Templates_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "prospection_contact_message_templates" */
export enum Prospection_Contact_Message_Templates_Update_Column {
  /** column name */
  Message = 'message'
}

export type Prospection_Contact_Message_Templates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospection_Contact_Message_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospection_Contact_Message_Templates_Bool_Exp;
};

/** columns and relationships of "prospection_contact_settings" */
export type Prospection_Contact_Settings = {
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  weekly_limit: Scalars['Int']['output'];
};

/** Boolean expression to filter rows from the table "prospection_contact_settings". All fields are combined with a logical 'AND'. */
export type Prospection_Contact_Settings_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Contact_Settings_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Contact_Settings_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Contact_Settings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weekly_limit?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospection_contact_settings" */
export enum Prospection_Contact_Settings_Constraint {
  /** unique or primary key constraint on columns "tenant_id" */
  ProspectionContactSettingsPkey = 'prospection_contact_settings_pkey'
}

/** input type for incrementing numeric columns in table "prospection_contact_settings" */
export type Prospection_Contact_Settings_Inc_Input = {
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "prospection_contact_settings" */
export type Prospection_Contact_Settings_Insert_Input = {
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "prospection_contact_settings" */
export type Prospection_Contact_Settings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospection_Contact_Settings>;
};

/** on_conflict condition type for table "prospection_contact_settings" */
export type Prospection_Contact_Settings_On_Conflict = {
  constraint: Prospection_Contact_Settings_Constraint;
  update_columns?: Array<Prospection_Contact_Settings_Update_Column>;
  where?: InputMaybe<Prospection_Contact_Settings_Bool_Exp>;
};

/** Ordering options when selecting data from "prospection_contact_settings". */
export type Prospection_Contact_Settings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weekly_limit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospection_contact_settings */
export type Prospection_Contact_Settings_Pk_Columns_Input = {
  tenant_id: Scalars['uuid']['input'];
};

/** select columns of table "prospection_contact_settings" */
export enum Prospection_Contact_Settings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyLimit = 'weekly_limit'
}

/** input type for updating data in table "prospection_contact_settings" */
export type Prospection_Contact_Settings_Set_Input = {
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Streaming cursor of the table "prospection_contact_settings" */
export type Prospection_Contact_Settings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospection_Contact_Settings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospection_Contact_Settings_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "prospection_contact_settings" */
export enum Prospection_Contact_Settings_Update_Column {
  /** column name */
  WeeklyLimit = 'weekly_limit'
}

export type Prospection_Contact_Settings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prospection_Contact_Settings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospection_Contact_Settings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospection_Contact_Settings_Bool_Exp;
};

/** columns and relationships of "prospection_contact_teams" */
export type Prospection_Contact_Teams = {
  counter_reset_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  creator?: Maybe<Users>;
  enabled: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  weekly_limit?: Maybe<Scalars['Int']['output']>;
};

/** Boolean expression to filter rows from the table "prospection_contact_teams". All fields are combined with a logical 'AND'. */
export type Prospection_Contact_Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Contact_Teams_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Contact_Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Contact_Teams_Bool_Exp>>;
  counter_reset_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  weekly_limit?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospection_contact_teams" */
export enum Prospection_Contact_Teams_Constraint {
  /** unique or primary key constraint on columns "team_id" */
  ProspectionContactTeamsPkey = 'prospection_contact_teams_pkey'
}

/** input type for incrementing numeric columns in table "prospection_contact_teams" */
export type Prospection_Contact_Teams_Inc_Input = {
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "prospection_contact_teams" */
export type Prospection_Contact_Teams_Insert_Input = {
  counter_reset_at?: InputMaybe<Scalars['timestamptz']['input']>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** response of any mutation on the table "prospection_contact_teams" */
export type Prospection_Contact_Teams_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospection_Contact_Teams>;
};

/** on_conflict condition type for table "prospection_contact_teams" */
export type Prospection_Contact_Teams_On_Conflict = {
  constraint: Prospection_Contact_Teams_Constraint;
  update_columns?: Array<Prospection_Contact_Teams_Update_Column>;
  where?: InputMaybe<Prospection_Contact_Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "prospection_contact_teams". */
export type Prospection_Contact_Teams_Order_By = {
  counter_reset_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  enabled?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  weekly_limit?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospection_contact_teams */
export type Prospection_Contact_Teams_Pk_Columns_Input = {
  team_id: Scalars['uuid']['input'];
};

/** select columns of table "prospection_contact_teams" */
export enum Prospection_Contact_Teams_Select_Column {
  /** column name */
  CounterResetAt = 'counter_reset_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Note = 'note',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  WeeklyLimit = 'weekly_limit'
}

/** input type for updating data in table "prospection_contact_teams" */
export type Prospection_Contact_Teams_Set_Input = {
  counter_reset_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Streaming cursor of the table "prospection_contact_teams" */
export type Prospection_Contact_Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospection_Contact_Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospection_Contact_Teams_Stream_Cursor_Value_Input = {
  counter_reset_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  weekly_limit?: InputMaybe<Scalars['Int']['input']>;
};

/** update columns of table "prospection_contact_teams" */
export enum Prospection_Contact_Teams_Update_Column {
  /** column name */
  CounterResetAt = 'counter_reset_at',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Note = 'note',
  /** column name */
  WeeklyLimit = 'weekly_limit'
}

export type Prospection_Contact_Teams_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Prospection_Contact_Teams_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospection_Contact_Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospection_Contact_Teams_Bool_Exp;
};

/** columns and relationships of "prospection_map_contact_attempts" */
export type Prospection_Map_Contact_Attempts = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  declined_at?: Maybe<Scalars['timestamptz']['output']>;
  email_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  language: Scalars['user_language']['output'];
  /** An object relationship */
  lead: Leads;
  lead_id: Scalars['uuid']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "prospection_map_contact_attempts" */
export type Prospection_Map_Contact_Attempts_Aggregate = {
  aggregate?: Maybe<Prospection_Map_Contact_Attempts_Aggregate_Fields>;
  nodes: Array<Prospection_Map_Contact_Attempts>;
};

/** aggregate fields of "prospection_map_contact_attempts" */
export type Prospection_Map_Contact_Attempts_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Prospection_Map_Contact_Attempts_Max_Fields>;
  min?: Maybe<Prospection_Map_Contact_Attempts_Min_Fields>;
};


/** aggregate fields of "prospection_map_contact_attempts" */
export type Prospection_Map_Contact_Attempts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "prospection_map_contact_attempts". All fields are combined with a logical 'AND'. */
export type Prospection_Map_Contact_Attempts_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Map_Contact_Attempts_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Bool_Exp>>;
  accepted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  declined_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_sent_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Prospection_Map_Contact_Attempts_Max_Fields = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  declined_at?: Maybe<Scalars['timestamptz']['output']>;
  email_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Prospection_Map_Contact_Attempts_Min_Fields = {
  accepted_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  declined_at?: Maybe<Scalars['timestamptz']['output']>;
  email_sent_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "prospection_map_contact_attempts". */
export type Prospection_Map_Contact_Attempts_Order_By = {
  accepted_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  declined_at?: InputMaybe<Order_By>;
  email_sent_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "prospection_map_contact_attempts" */
export enum Prospection_Map_Contact_Attempts_Select_Column {
  /** column name */
  AcceptedAt = 'accepted_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DeclinedAt = 'declined_at',
  /** column name */
  EmailSentAt = 'email_sent_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Message = 'message',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "prospection_map_contact_attempts" */
export type Prospection_Map_Contact_Attempts_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospection_Map_Contact_Attempts_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospection_Map_Contact_Attempts_Stream_Cursor_Value_Input = {
  accepted_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  declined_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email_sent_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "prospection_map_emailable_leads" */
export type Prospection_Map_Emailable_Leads = {
  lead_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "prospection_map_emailable_leads". All fields are combined with a logical 'AND'. */
export type Prospection_Map_Emailable_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Map_Emailable_Leads_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Map_Emailable_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Map_Emailable_Leads_Bool_Exp>>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "prospection_map_emailable_leads". */
export type Prospection_Map_Emailable_Leads_Order_By = {
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "prospection_map_emailable_leads" */
export enum Prospection_Map_Emailable_Leads_Select_Column {
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "prospection_map_emailable_leads" */
export type Prospection_Map_Emailable_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospection_Map_Emailable_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospection_Map_Emailable_Leads_Stream_Cursor_Value_Input = {
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "prospection_map_full_leads" */
export type Prospection_Map_Full_Leads = {
  lead_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "prospection_map_full_leads". All fields are combined with a logical 'AND'. */
export type Prospection_Map_Full_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Map_Full_Leads_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Map_Full_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Map_Full_Leads_Bool_Exp>>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "prospection_map_full_leads". */
export type Prospection_Map_Full_Leads_Order_By = {
  lead_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
};

/** select columns of table "prospection_map_full_leads" */
export enum Prospection_Map_Full_Leads_Select_Column {
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TenantId = 'tenant_id'
}

/** Streaming cursor of the table "prospection_map_full_leads" */
export type Prospection_Map_Full_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospection_Map_Full_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospection_Map_Full_Leads_Stream_Cursor_Value_Input = {
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "prospection_map_lead_addresses" */
export type Prospection_Map_Lead_Addresses = {
  country_code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  main_type?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  rooms?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  surface?: Maybe<Scalars['Float']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "prospection_map_lead_addresses". All fields are combined with a logical 'AND'. */
export type Prospection_Map_Lead_Addresses_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Map_Lead_Addresses_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Map_Lead_Addresses_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Map_Lead_Addresses_Bool_Exp>>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  date?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  main_type?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  rooms?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  surface?: InputMaybe<Float_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  value?: InputMaybe<Float_Comparison_Exp>;
};

export type Prospection_Map_Lead_Addresses_In_Bbox_Args = {
  east?: InputMaybe<Scalars['float8']['input']>;
  house_ids?: InputMaybe<Scalars['_uuid']['input']>;
  north?: InputMaybe<Scalars['float8']['input']>;
  south?: InputMaybe<Scalars['float8']['input']>;
  west?: InputMaybe<Scalars['float8']['input']>;
};

/** Ordering options when selecting data from "prospection_map_lead_addresses". */
export type Prospection_Map_Lead_Addresses_Order_By = {
  country_code?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  main_type?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  rooms?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  surface?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "prospection_map_lead_addresses" */
export enum Prospection_Map_Lead_Addresses_Select_Column {
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Date = 'date',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MainType = 'main_type',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Reason = 'reason',
  /** column name */
  Rooms = 'rooms',
  /** column name */
  Route = 'route',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  Surface = 'surface',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Value = 'value'
}

/** columns and relationships of "prospection_marks" */
export type Prospection_Marks = {
  address?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  lat: Scalars['float8']['output'];
  lng: Scalars['float8']['output'];
  locality?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  parcel_id?: Maybe<Scalars['String']['output']>;
  parcel_source?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  updated_by?: Maybe<Users>;
  updated_by_user_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** Boolean expression to filter rows from the table "prospection_marks". All fields are combined with a logical 'AND'. */
export type Prospection_Marks_Bool_Exp = {
  _and?: InputMaybe<Array<Prospection_Marks_Bool_Exp>>;
  _not?: InputMaybe<Prospection_Marks_Bool_Exp>;
  _or?: InputMaybe<Array<Prospection_Marks_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  parcel_id?: InputMaybe<String_Comparison_Exp>;
  parcel_source?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_by?: InputMaybe<Users_Bool_Exp>;
  updated_by_user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "prospection_marks" */
export enum Prospection_Marks_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProspectionMarksPkey = 'prospection_marks_pkey',
  /** unique or primary key constraint on columns "user_id", "parcel_id", "parcel_source" */
  ProspectionMarksUserParcelKey = 'prospection_marks_user_parcel_key'
}

/** input type for inserting data into table "prospection_marks" */
export type Prospection_Marks_Insert_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parcel_id?: InputMaybe<Scalars['String']['input']>;
  parcel_source?: InputMaybe<Scalars['String']['input']>;
  updated_by?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** response of any mutation on the table "prospection_marks" */
export type Prospection_Marks_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Prospection_Marks>;
};

/** on_conflict condition type for table "prospection_marks" */
export type Prospection_Marks_On_Conflict = {
  constraint: Prospection_Marks_Constraint;
  update_columns?: Array<Prospection_Marks_Update_Column>;
  where?: InputMaybe<Prospection_Marks_Bool_Exp>;
};

/** Ordering options when selecting data from "prospection_marks". */
export type Prospection_Marks_Order_By = {
  address?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  parcel_id?: InputMaybe<Order_By>;
  parcel_source?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updated_by?: InputMaybe<Users_Order_By>;
  updated_by_user_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: prospection_marks */
export type Prospection_Marks_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "prospection_marks" */
export enum Prospection_Marks_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  Note = 'note',
  /** column name */
  ParcelId = 'parcel_id',
  /** column name */
  ParcelSource = 'parcel_source',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedByUserId = 'updated_by_user_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "prospection_marks" */
export type Prospection_Marks_Set_Input = {
  note?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "prospection_marks" */
export type Prospection_Marks_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Prospection_Marks_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Prospection_Marks_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['float8']['input']>;
  lng?: InputMaybe<Scalars['float8']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  parcel_id?: InputMaybe<Scalars['String']['input']>;
  parcel_source?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_by_user_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "prospection_marks" */
export enum Prospection_Marks_Update_Column {
  /** column name */
  Note = 'note'
}

export type Prospection_Marks_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Prospection_Marks_Set_Input>;
  /** filter the rows which have to be updated */
  where: Prospection_Marks_Bool_Exp;
};

/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Pt_Cma_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pt_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pt_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  /** A computed field, executes function "listing_is_online" */
  is_online?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** Gets all places associated with this listing */
  places?: Maybe<Array<Pt_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  /** An object relationship */
  property_types?: Maybe<Pt_Property_Types>;
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  state?: Maybe<Pt_States>;
  state_id: Scalars['uuid']['output'];
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Pt_Cma_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Pt_Cma_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Pt_Cma_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Sale listings kept as comparables for valuations: deduplicated, on the market or offline for less than a year. Sale only, HOUSE and APPT only: not a count of the market, use post_merged_listings for that. Read through get_cma_listings_by_radius and get_similar_listings. */
export type Pt_Cma_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_listings" */
export type Pt_Cma_Listings_Aggregate = {
  aggregate?: Maybe<Pt_Cma_Listings_Aggregate_Fields>;
  nodes: Array<Pt_Cma_Listings>;
};

/** aggregate fields of "cma_listings" */
export type Pt_Cma_Listings_Aggregate_Fields = {
  avg?: Maybe<Pt_Cma_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Cma_Listings_Max_Fields>;
  min?: Maybe<Pt_Cma_Listings_Min_Fields>;
  stddev?: Maybe<Pt_Cma_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Cma_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Cma_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Cma_Listings_Sum_Fields>;
  var_pop?: Maybe<Pt_Cma_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Cma_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pt_Cma_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_listings" */
export type Pt_Cma_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_Cma_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings". All fields are combined with a logical 'AND'. */
export type Pt_Cma_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Cma_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Cma_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  available_from?: InputMaybe<Date_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Pt_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  property_types?: InputMaybe<Pt_Property_Types_Bool_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<Pt_States_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** columns and relationships of "cma_listings_distance" */
export type Pt_Cma_Listings_Distance = {
  distance_in_meters: Scalars['Float']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  listing?: Maybe<Pt_Cma_Listings>;
  listing_id: Scalars['Int']['output'];
  state_id: Scalars['uuid']['output'];
};

/** aggregated selection of "cma_listings_distance" */
export type Pt_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Pt_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Pt_Cma_Listings_Distance>;
};

/** aggregate fields of "cma_listings_distance" */
export type Pt_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Pt_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Pt_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Pt_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Pt_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Pt_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "cma_listings_distance" */
export type Pt_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Pt_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  listing?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Pt_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "cma_listings_distance". */
export type Pt_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  listing?: InputMaybe<Pt_Cma_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings_distance" */
export enum Pt_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  Id = 'id',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Pt_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Pt_Cma_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pt_Cma_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  available_from?: Maybe<Scalars['date']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_listings". */
export type Pt_Cma_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  available_from?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pt_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Pt_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  property_types?: InputMaybe<Pt_Property_Types_Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state?: InputMaybe<Pt_States_Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_listings" */
export enum Pt_Cma_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  AvailableFrom = 'available_from',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pt_Cma_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_Cma_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_Cma_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_Cma_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_Cma_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_Cma_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_Cma_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "cma_rental_listings" */
export type Pt_Cma_Rental_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pt_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pt_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Pt_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  /** A computed field, executes function "cma_rental_listings_places" */
  places?: Maybe<Array<Pt_Places>>;
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pt_Cma_Rental_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pt_Cma_Rental_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pt_Cma_Rental_ListingsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** columns and relationships of "cma_rental_listings" */
export type Pt_Cma_Rental_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "cma_rental_listings" */
export type Pt_Cma_Rental_Listings_Aggregate = {
  aggregate?: Maybe<Pt_Cma_Rental_Listings_Aggregate_Fields>;
  nodes: Array<Pt_Cma_Rental_Listings>;
};

/** aggregate fields of "cma_rental_listings" */
export type Pt_Cma_Rental_Listings_Aggregate_Fields = {
  avg?: Maybe<Pt_Cma_Rental_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Cma_Rental_Listings_Max_Fields>;
  min?: Maybe<Pt_Cma_Rental_Listings_Min_Fields>;
  stddev?: Maybe<Pt_Cma_Rental_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Cma_Rental_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Cma_Rental_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Cma_Rental_Listings_Sum_Fields>;
  var_pop?: Maybe<Pt_Cma_Rental_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Cma_Rental_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pt_Cma_Rental_Listings_Variance_Fields>;
};


/** aggregate fields of "cma_rental_listings" */
export type Pt_Cma_Rental_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Cma_Rental_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_Cma_Rental_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "cma_rental_listings". All fields are combined with a logical 'AND'. */
export type Pt_Cma_Rental_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Cma_Rental_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pt_Cma_Rental_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Cma_Rental_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Pt_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  places?: InputMaybe<Pt_Places_Bool_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Cma_Rental_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pt_Cma_Rental_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "cma_rental_listings". */
export type Pt_Cma_Rental_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pt_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Pt_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  places_aggregate?: InputMaybe<Pt_Places_Aggregate_Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "cma_rental_listings" */
export enum Pt_Cma_Rental_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pt_Cma_Rental_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_Cma_Rental_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_Cma_Rental_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_Cma_Rental_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_Cma_Rental_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_Cma_Rental_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_Cma_Rental_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Pt_External_Transactions = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  source_payload?: Maybe<Scalars['jsonb']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};


/** Recorded property sales: France only (DVF); empty in the other countries. signature_date, purchase_price, currency, type, surfaces, address. Large and not indexed on locality or postcode: do not filter on those text columns. Query through get_external_transactions_distance (a point and radius, a bbox, a polygon or a postcode), which also filters type, dates, surfaces, rooms and price. Technically an empty inheritance parent: the dated child tables are attached by the ml external_transactions sync job. */
export type Pt_External_TransactionsSource_PayloadArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "external_transactions" */
export type Pt_External_Transactions_Aggregate = {
  aggregate?: Maybe<Pt_External_Transactions_Aggregate_Fields>;
  nodes: Array<Pt_External_Transactions>;
};

/** aggregate fields of "external_transactions" */
export type Pt_External_Transactions_Aggregate_Fields = {
  avg?: Maybe<Pt_External_Transactions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_External_Transactions_Max_Fields>;
  min?: Maybe<Pt_External_Transactions_Min_Fields>;
  stddev?: Maybe<Pt_External_Transactions_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_External_Transactions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_External_Transactions_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_External_Transactions_Sum_Fields>;
  var_pop?: Maybe<Pt_External_Transactions_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_External_Transactions_Var_Samp_Fields>;
  variance?: Maybe<Pt_External_Transactions_Variance_Fields>;
};


/** aggregate fields of "external_transactions" */
export type Pt_External_Transactions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_External_Transactions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_External_Transactions_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions". All fields are combined with a logical 'AND'. */
export type Pt_External_Transactions_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_External_Transactions_Bool_Exp>>;
  _not?: InputMaybe<Pt_External_Transactions_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_External_Transactions_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  source_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** Rows returned by get_external_transactions_distance: a recorded sale and its distance_in_meters from the point asked. Data in France only. The table itself holds no row: call the function, with _lat and _lng always; nearest first unless _sort_field (with _sort_direction) is set. _max_distance_meters is 5 km by default and 50 km at most; pass _max_distance_meters: null to search a whole _postcode, bbox or _polygon_geojson beyond 5 km. _property_main_type, _cutoff_date and _cutoff_date_max, surfaces, rooms and price narrow further. At most 5000 rows (_max_results): a count over it stops there, so narrow the area or the dates for a large city. */
export type Pt_External_Transactions_Distance = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  distance_in_meters: Scalars['Float']['output'];
  external_id: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price: Scalars['Int']['output'];
  signature_date: Scalars['date']['output'];
  source: Scalars['String']['output'];
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "external_transactions_distance" */
export type Pt_External_Transactions_Distance_Aggregate = {
  aggregate?: Maybe<Pt_External_Transactions_Distance_Aggregate_Fields>;
  nodes: Array<Pt_External_Transactions_Distance>;
};

/** aggregate fields of "external_transactions_distance" */
export type Pt_External_Transactions_Distance_Aggregate_Fields = {
  avg?: Maybe<Pt_External_Transactions_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_External_Transactions_Distance_Max_Fields>;
  min?: Maybe<Pt_External_Transactions_Distance_Min_Fields>;
  stddev?: Maybe<Pt_External_Transactions_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_External_Transactions_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_External_Transactions_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_External_Transactions_Distance_Sum_Fields>;
  var_pop?: Maybe<Pt_External_Transactions_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_External_Transactions_Distance_Var_Samp_Fields>;
  variance?: Maybe<Pt_External_Transactions_Distance_Variance_Fields>;
};


/** aggregate fields of "external_transactions_distance" */
export type Pt_External_Transactions_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_External_Transactions_Distance_Avg_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "external_transactions_distance". All fields are combined with a logical 'AND'. */
export type Pt_External_Transactions_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_External_Transactions_Distance_Bool_Exp>>;
  _not?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_External_Transactions_Distance_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  distance_in_meters?: InputMaybe<Float_Comparison_Exp>;
  external_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type_name?: InputMaybe<String_Comparison_Exp>;
  purchase_price?: InputMaybe<Int_Comparison_Exp>;
  signature_date?: InputMaybe<Date_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  street_name?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  street_suffix?: InputMaybe<String_Comparison_Exp>;
  street_type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_External_Transactions_Distance_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pt_External_Transactions_Distance_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions_distance". */
export type Pt_External_Transactions_Distance_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  distance_in_meters?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions_distance" */
export enum Pt_External_Transactions_Distance_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Pt_External_Transactions_Distance_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_External_Transactions_Distance_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_External_Transactions_Distance_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_External_Transactions_Distance_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_External_Transactions_Distance_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_External_Transactions_Distance_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_External_Transactions_Distance_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate max on columns */
export type Pt_External_Transactions_Max_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Pt_External_Transactions_Min_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type_name?: Maybe<Scalars['String']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
  signature_date?: Maybe<Scalars['date']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  street_name?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  street_suffix?: Maybe<Scalars['String']['output']>;
  street_type?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "external_transactions". */
export type Pt_External_Transactions_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  external_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type_name?: InputMaybe<Order_By>;
  purchase_price?: InputMaybe<Order_By>;
  signature_date?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  source_payload?: InputMaybe<Order_By>;
  street_name?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  street_suffix?: InputMaybe<Order_By>;
  street_type?: InputMaybe<Order_By>;
};

/** select columns of table "external_transactions" */
export enum Pt_External_Transactions_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  Currency = 'currency',
  /** column name */
  ExternalId = 'external_id',
  /** column name */
  Id = 'id',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyTypeName = 'property_type_name',
  /** column name */
  PurchasePrice = 'purchase_price',
  /** column name */
  SignatureDate = 'signature_date',
  /** column name */
  Source = 'source',
  /** column name */
  SourcePayload = 'source_payload',
  /** column name */
  StreetName = 'street_name',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StreetSuffix = 'street_suffix',
  /** column name */
  StreetType = 'street_type'
}

/** aggregate stddev on columns */
export type Pt_External_Transactions_Stddev_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_External_Transactions_Stddev_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_External_Transactions_Stddev_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_External_Transactions_Sum_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  purchase_price?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_External_Transactions_Var_Pop_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_External_Transactions_Var_Samp_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_External_Transactions_Variance_Fields = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  purchase_price?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "get_merged_listings_type" */
export type Pt_Get_Merged_Listings_Type = {
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Scalars['json']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['float8']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['float8']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['Boolean']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
};


/** columns and relationships of "get_merged_listings_type" */
export type Pt_Get_Merged_Listings_TypeImagesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to filter rows from the table "get_merged_listings_type". All fields are combined with a logical 'AND'. */
export type Pt_Get_Merged_Listings_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Bool_Exp>>;
  _not?: InputMaybe<Pt_Get_Merged_Listings_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Bool_Exp>>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Json_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  lat?: InputMaybe<Float8_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float8_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
};

/** Ordering options when selecting data from "get_merged_listings_type". */
export type Pt_Get_Merged_Listings_Type_Order_By = {
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
};

/** select columns of table "get_merged_listings_type" */
export enum Pt_Get_Merged_Listings_Type_Select_Column {
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  Images = 'images',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  Lat = 'lat',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  UsableSurface = 'usable_surface'
}

/** columns and relationships of "merged_images" */
export type Pt_Merged_Images = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** aggregated selection of "merged_images" */
export type Pt_Merged_Images_Aggregate = {
  aggregate?: Maybe<Pt_Merged_Images_Aggregate_Fields>;
  nodes: Array<Pt_Merged_Images>;
};

/** aggregate fields of "merged_images" */
export type Pt_Merged_Images_Aggregate_Fields = {
  avg?: Maybe<Pt_Merged_Images_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Merged_Images_Max_Fields>;
  min?: Maybe<Pt_Merged_Images_Min_Fields>;
  stddev?: Maybe<Pt_Merged_Images_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Merged_Images_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Merged_Images_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Merged_Images_Sum_Fields>;
  var_pop?: Maybe<Pt_Merged_Images_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Merged_Images_Var_Samp_Fields>;
  variance?: Maybe<Pt_Merged_Images_Variance_Fields>;
};


/** aggregate fields of "merged_images" */
export type Pt_Merged_Images_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "merged_images" */
export type Pt_Merged_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Pt_Merged_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pt_Merged_Images_Max_Order_By>;
  min?: InputMaybe<Pt_Merged_Images_Min_Order_By>;
  stddev?: InputMaybe<Pt_Merged_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pt_Merged_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pt_Merged_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pt_Merged_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Pt_Merged_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pt_Merged_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Pt_Merged_Images_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pt_Merged_Images_Avg_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "merged_images" */
export type Pt_Merged_Images_Avg_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "merged_images". All fields are combined with a logical 'AND'. */
export type Pt_Merged_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Merged_Images_Bool_Exp>>;
  _not?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Merged_Images_Bool_Exp>>;
  bucket_name?: InputMaybe<String_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image_index?: InputMaybe<Int_Comparison_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Merged_Images_Max_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "merged_images" */
export type Pt_Merged_Images_Max_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pt_Merged_Images_Min_Fields = {
  bucket_name?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "merged_images" */
export type Pt_Merged_Images_Min_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "merged_images". */
export type Pt_Merged_Images_Order_By = {
  bucket_name?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** select columns of table "merged_images" */
export enum Pt_Merged_Images_Select_Column {
  /** column name */
  BucketName = 'bucket_name',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  ImageIndex = 'image_index',
  /** column name */
  ListingId = 'listing_id'
}

/** aggregate stddev on columns */
export type Pt_Merged_Images_Stddev_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "merged_images" */
export type Pt_Merged_Images_Stddev_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pt_Merged_Images_Stddev_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "merged_images" */
export type Pt_Merged_Images_Stddev_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pt_Merged_Images_Stddev_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "merged_images" */
export type Pt_Merged_Images_Stddev_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pt_Merged_Images_Sum_Fields = {
  image_index?: Maybe<Scalars['Int']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "merged_images" */
export type Pt_Merged_Images_Sum_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pt_Merged_Images_Var_Pop_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "merged_images" */
export type Pt_Merged_Images_Var_Pop_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pt_Merged_Images_Var_Samp_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "merged_images" */
export type Pt_Merged_Images_Var_Samp_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pt_Merged_Images_Variance_Fields = {
  image_index?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "merged_images" */
export type Pt_Merged_Images_Variance_Order_By = {
  image_index?: InputMaybe<Order_By>;
  listing_id?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pt_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at: Scalars['timestamptz']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pt_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pt_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  /** Hidden from the public site by an admin (per listing, together with its duplicates). It does not say whether the listing is still online: see offline_since. */
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pt_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pt_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, one row per listing, including those no longer online and duplicates of the same property across portals. Its dedup is looser than post_merged_listings: a reposted property can have several canonical rows, so do not count the market here. On the market now: online_listings where it is maintained (Switzerland, France, Spain, Italy), else post_merged_listings. History and offline listings: post_merged_listings. offer_type is 'buy' or 'rent'. Titles, descriptions and agency names are free text from the portals. */
export type Pt_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "merged_listings" */
export type Pt_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Pt_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Pt_Merged_Listings>;
};

/** aggregate fields of "merged_listings" */
export type Pt_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Pt_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Merged_Listings_Max_Fields>;
  min?: Maybe<Pt_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Pt_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Pt_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pt_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "merged_listings" */
export type Pt_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "merged_listings". All fields are combined with a logical 'AND'. */
export type Pt_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pt_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  /** When the listing was first seen. */
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  /** When the listing was seen to leave the portal. NULL = still online. */
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "merged_listings". */
export type Pt_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pt_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "merged_listings" */
export enum Pt_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pt_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  /** Id of the listing this one duplicates. NULL = canonical under this table's loose dedup; post_merged_listings is stricter. */
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_Places = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  breadcrumbs: Array<Pt_Places_Breadcrumbs>;
  /** An aggregate relationship */
  breadcrumbs_aggregate: Pt_Places_Breadcrumbs_Aggregate;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  canonical_place?: Maybe<Pt_Places>;
  children_bbox?: Maybe<Scalars['jsonb']['output']>;
  /** A computed field, executes function "count_children_place" */
  children_count?: Maybe<Scalars['Int']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  extra: Scalars['jsonb']['output'];
  geom: Scalars['geometry']['output'];
  id: Scalars['uuid']['output'];
  index: Scalars['Boolean']['output'];
  /** to use instead of label_en label_de etc, x-hasura-website-language must be set */
  label?: Maybe<Scalars['String']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  municipality?: Maybe<Pt_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  municipality_places: Array<Pt_Places>;
  /** An aggregate relationship */
  municipality_places_aggregate: Pt_Places_Aggregate;
  name: Scalars['String']['output'];
  /** An array relationship */
  neighbourhood: Array<Pt_Places>;
  /** An aggregate relationship */
  neighbourhood_aggregate: Pt_Places_Aggregate;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  price_stats: Array<Pt_Price_Stats>;
  /** An aggregate relationship */
  price_stats_aggregate: Pt_Price_Stats_Aggregate;
  /** An array relationship */
  price_stats_historical: Array<Pt_Price_Stats_Historical>;
  /** An aggregate relationship */
  price_stats_historical_aggregate: Pt_Price_Stats_Historical_Aggregate;
  /** An array relationship */
  region: Array<Pt_Places>;
  /** An aggregate relationship */
  region_aggregate: Pt_Places_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  search_base: Scalars['tsvector']['output'];
  /** to use instead of slug_en slug_de etc, x-hasura-website-language must be set */
  slug?: Maybe<Scalars['String']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  state: Array<Pt_Places>;
  /** An aggregate relationship */
  state_aggregate: Pt_Places_Aggregate;
  state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  state_places: Array<Pt_Places>;
  /** An aggregate relationship */
  state_places_aggregate: Pt_Places_Aggregate;
  /** An array relationship */
  street_stats_locality: Array<Pt_Street_Stats>;
  /** An aggregate relationship */
  street_stats_locality_aggregate: Pt_Street_Stats_Aggregate;
  /** An array relationship */
  street_stats_municipality: Array<Pt_Street_Stats>;
  /** An aggregate relationship */
  street_stats_municipality_aggregate: Pt_Street_Stats_Aggregate;
  type: Scalars['String']['output'];
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesBreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesBreadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesChildren_BboxArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesExtraArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesMunicipality_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesMunicipality_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesNeighbourhoodArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesNeighbourhood_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesPrice_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesPrice_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesPrice_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesPrice_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesRegionArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesRegion_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesStateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesState_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesState_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesState_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesStreet_Stats_LocalityArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesStreet_Stats_Locality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesStreet_Stats_MunicipalityArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};


/** Geographic areas. type is the level: country, state, region, district, agglomeration, municipality (a city or commune), locality, neighbourhood, postcode. A row carries the ids of the places it sits in (state_id, municipality_id, locality_id and so on). A non-null canonical_id means the row is an alias of that place. Find a place by name with search_places (Switzerland) or search_places_with_index. */
export type Pt_PlacesStreet_Stats_Municipality_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};

/** aggregated selection of "places" */
export type Pt_Places_Aggregate = {
  aggregate?: Maybe<Pt_Places_Aggregate_Fields>;
  nodes: Array<Pt_Places>;
};

/** aggregate fields of "places" */
export type Pt_Places_Aggregate_Fields = {
  avg?: Maybe<Pt_Places_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Places_Max_Fields>;
  min?: Maybe<Pt_Places_Min_Fields>;
  stddev?: Maybe<Pt_Places_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Places_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Places_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Places_Sum_Fields>;
  var_pop?: Maybe<Pt_Places_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Places_Var_Samp_Fields>;
  variance?: Maybe<Pt_Places_Variance_Fields>;
};


/** aggregate fields of "places" */
export type Pt_Places_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Places_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places" */
export type Pt_Places_Aggregate_Order_By = {
  avg?: InputMaybe<Pt_Places_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pt_Places_Max_Order_By>;
  min?: InputMaybe<Pt_Places_Min_Order_By>;
  stddev?: InputMaybe<Pt_Places_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pt_Places_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pt_Places_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pt_Places_Sum_Order_By>;
  var_pop?: InputMaybe<Pt_Places_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pt_Places_Var_Samp_Order_By>;
  variance?: InputMaybe<Pt_Places_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pt_Places_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places" */
export type Pt_Places_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places". All fields are combined with a logical 'AND'. */
export type Pt_Places_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Places_Bool_Exp>>;
  _not?: InputMaybe<Pt_Places_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Places_Bool_Exp>>;
  agglomeration_id?: InputMaybe<Uuid_Comparison_Exp>;
  breadcrumbs?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
  canonical_id?: InputMaybe<Uuid_Comparison_Exp>;
  canonical_place?: InputMaybe<Pt_Places_Bool_Exp>;
  children_bbox?: InputMaybe<Jsonb_Comparison_Exp>;
  children_count?: InputMaybe<Int_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  extra?: InputMaybe<Jsonb_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  index?: InputMaybe<Boolean_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  label_de?: InputMaybe<String_Comparison_Exp>;
  label_en?: InputMaybe<String_Comparison_Exp>;
  label_es?: InputMaybe<String_Comparison_Exp>;
  label_fr?: InputMaybe<String_Comparison_Exp>;
  label_it?: InputMaybe<String_Comparison_Exp>;
  label_pl?: InputMaybe<String_Comparison_Exp>;
  label_pt?: InputMaybe<String_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality?: InputMaybe<Pt_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  municipality_places?: InputMaybe<Pt_Places_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood?: InputMaybe<Pt_Places_Bool_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  population?: InputMaybe<Int_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  price_stats?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
  price_stats_historical?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
  region?: InputMaybe<Pt_Places_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  search_base?: InputMaybe<Tsvector_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  slug_de?: InputMaybe<String_Comparison_Exp>;
  slug_en?: InputMaybe<String_Comparison_Exp>;
  slug_es?: InputMaybe<String_Comparison_Exp>;
  slug_fr?: InputMaybe<String_Comparison_Exp>;
  slug_it?: InputMaybe<String_Comparison_Exp>;
  slug_pl?: InputMaybe<String_Comparison_Exp>;
  slug_pt?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Pt_Places_Bool_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  state_places?: InputMaybe<Pt_Places_Bool_Exp>;
  street_stats_locality?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
  street_stats_municipality?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** For a municipality, a locality or a neighbourhood (place_id), the places it sits in (breadcrumb_place_id -> places): order_num 1 locality, 2 municipality, 3 state; the place itself and non-state aliases are left out, so a locality starts at 2. */
export type Pt_Places_Breadcrumbs = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  /** An object relationship */
  place?: Maybe<Pt_Places>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Aggregate = {
  aggregate?: Maybe<Pt_Places_Breadcrumbs_Aggregate_Fields>;
  nodes: Array<Pt_Places_Breadcrumbs>;
};

/** aggregate fields of "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Aggregate_Fields = {
  avg?: Maybe<Pt_Places_Breadcrumbs_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Places_Breadcrumbs_Max_Fields>;
  min?: Maybe<Pt_Places_Breadcrumbs_Min_Fields>;
  stddev?: Maybe<Pt_Places_Breadcrumbs_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Places_Breadcrumbs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Places_Breadcrumbs_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Places_Breadcrumbs_Sum_Fields>;
  var_pop?: Maybe<Pt_Places_Breadcrumbs_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Places_Breadcrumbs_Var_Samp_Fields>;
  variance?: Maybe<Pt_Places_Breadcrumbs_Variance_Fields>;
};


/** aggregate fields of "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Places_Breadcrumbs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Aggregate_Order_By = {
  avg?: InputMaybe<Pt_Places_Breadcrumbs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pt_Places_Breadcrumbs_Max_Order_By>;
  min?: InputMaybe<Pt_Places_Breadcrumbs_Min_Order_By>;
  stddev?: InputMaybe<Pt_Places_Breadcrumbs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pt_Places_Breadcrumbs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pt_Places_Breadcrumbs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pt_Places_Breadcrumbs_Sum_Order_By>;
  var_pop?: InputMaybe<Pt_Places_Breadcrumbs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pt_Places_Breadcrumbs_Var_Samp_Order_By>;
  variance?: InputMaybe<Pt_Places_Breadcrumbs_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pt_Places_Breadcrumbs_Avg_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Avg_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "places_breadcrumbs". All fields are combined with a logical 'AND'. */
export type Pt_Places_Breadcrumbs_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Places_Breadcrumbs_Bool_Exp>>;
  _not?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Places_Breadcrumbs_Bool_Exp>>;
  breadcrumb_place_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_num?: InputMaybe<Bigint_Comparison_Exp>;
  place?: InputMaybe<Pt_Places_Bool_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Places_Breadcrumbs_Max_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Max_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pt_Places_Breadcrumbs_Min_Fields = {
  breadcrumb_place_id?: Maybe<Scalars['uuid']['output']>;
  order_num?: Maybe<Scalars['bigint']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Min_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places_breadcrumbs". */
export type Pt_Places_Breadcrumbs_Order_By = {
  breadcrumb_place_id?: InputMaybe<Order_By>;
  order_num?: InputMaybe<Order_By>;
  place?: InputMaybe<Pt_Places_Order_By>;
  place_id?: InputMaybe<Order_By>;
};

/** select columns of table "places_breadcrumbs" */
export enum Pt_Places_Breadcrumbs_Select_Column {
  /** column name */
  BreadcrumbPlaceId = 'breadcrumb_place_id',
  /** column name */
  OrderNum = 'order_num',
  /** column name */
  PlaceId = 'place_id'
}

/** aggregate stddev on columns */
export type Pt_Places_Breadcrumbs_Stddev_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Stddev_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pt_Places_Breadcrumbs_Stddev_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Stddev_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pt_Places_Breadcrumbs_Stddev_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Stddev_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pt_Places_Breadcrumbs_Sum_Fields = {
  order_num?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Sum_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pt_Places_Breadcrumbs_Var_Pop_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Var_Pop_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pt_Places_Breadcrumbs_Var_Samp_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Var_Samp_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pt_Places_Breadcrumbs_Variance_Fields = {
  order_num?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places_breadcrumbs" */
export type Pt_Places_Breadcrumbs_Variance_Order_By = {
  order_num?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Pt_Places_Max_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "places" */
export type Pt_Places_Max_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pt_Places_Min_Fields = {
  agglomeration_id?: Maybe<Scalars['uuid']['output']>;
  canonical_id?: Maybe<Scalars['uuid']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  label_de?: Maybe<Scalars['String']['output']>;
  label_en?: Maybe<Scalars['String']['output']>;
  label_es?: Maybe<Scalars['String']['output']>;
  label_fr?: Maybe<Scalars['String']['output']>;
  label_it?: Maybe<Scalars['String']['output']>;
  label_pl?: Maybe<Scalars['String']['output']>;
  label_pt?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  slug_de?: Maybe<Scalars['String']['output']>;
  slug_en?: Maybe<Scalars['String']['output']>;
  slug_es?: Maybe<Scalars['String']['output']>;
  slug_fr?: Maybe<Scalars['String']['output']>;
  slug_it?: Maybe<Scalars['String']['output']>;
  slug_pl?: Maybe<Scalars['String']['output']>;
  slug_pt?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "places" */
export type Pt_Places_Min_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "places". */
export type Pt_Places_Order_By = {
  agglomeration_id?: InputMaybe<Order_By>;
  breadcrumbs_aggregate?: InputMaybe<Pt_Places_Breadcrumbs_Aggregate_Order_By>;
  canonical_id?: InputMaybe<Order_By>;
  canonical_place?: InputMaybe<Pt_Places_Order_By>;
  children_bbox?: InputMaybe<Order_By>;
  children_count?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  extra?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  index?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  label_de?: InputMaybe<Order_By>;
  label_en?: InputMaybe<Order_By>;
  label_es?: InputMaybe<Order_By>;
  label_fr?: InputMaybe<Order_By>;
  label_it?: InputMaybe<Order_By>;
  label_pl?: InputMaybe<Order_By>;
  label_pt?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Pt_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  municipality_places_aggregate?: InputMaybe<Pt_Places_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_aggregate?: InputMaybe<Pt_Places_Aggregate_Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  price_stats_aggregate?: InputMaybe<Pt_Price_Stats_Aggregate_Order_By>;
  price_stats_historical_aggregate?: InputMaybe<Pt_Price_Stats_Historical_Aggregate_Order_By>;
  region_aggregate?: InputMaybe<Pt_Places_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  search_base?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  slug_de?: InputMaybe<Order_By>;
  slug_en?: InputMaybe<Order_By>;
  slug_es?: InputMaybe<Order_By>;
  slug_fr?: InputMaybe<Order_By>;
  slug_it?: InputMaybe<Order_By>;
  slug_pl?: InputMaybe<Order_By>;
  slug_pt?: InputMaybe<Order_By>;
  state_aggregate?: InputMaybe<Pt_Places_Aggregate_Order_By>;
  state_id?: InputMaybe<Order_By>;
  state_places_aggregate?: InputMaybe<Pt_Places_Aggregate_Order_By>;
  street_stats_locality_aggregate?: InputMaybe<Pt_Street_Stats_Aggregate_Order_By>;
  street_stats_municipality_aggregate?: InputMaybe<Pt_Street_Stats_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "places" */
export enum Pt_Places_Select_Column {
  /** column name */
  AgglomerationId = 'agglomeration_id',
  /** column name */
  CanonicalId = 'canonical_id',
  /** column name */
  ChildrenBbox = 'children_bbox',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  Extra = 'extra',
  /** column name */
  Geom = 'geom',
  /** column name */
  Id = 'id',
  /** column name */
  Index = 'index',
  /** column name */
  LabelDe = 'label_de',
  /** column name */
  LabelEn = 'label_en',
  /** column name */
  LabelEs = 'label_es',
  /** column name */
  LabelFr = 'label_fr',
  /** column name */
  LabelIt = 'label_it',
  /** column name */
  LabelPl = 'label_pl',
  /** column name */
  LabelPt = 'label_pt',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  Population = 'population',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  SearchBase = 'search_base',
  /** column name */
  SlugDe = 'slug_de',
  /** column name */
  SlugEn = 'slug_en',
  /** column name */
  SlugEs = 'slug_es',
  /** column name */
  SlugFr = 'slug_fr',
  /** column name */
  SlugIt = 'slug_it',
  /** column name */
  SlugPl = 'slug_pl',
  /** column name */
  SlugPt = 'slug_pt',
  /** column name */
  StateId = 'state_id',
  /** column name */
  Type = 'type'
}

/** aggregate stddev on columns */
export type Pt_Places_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "places" */
export type Pt_Places_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pt_Places_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "places" */
export type Pt_Places_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pt_Places_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "places" */
export type Pt_Places_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pt_Places_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "places" */
export type Pt_Places_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pt_Places_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "places" */
export type Pt_Places_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pt_Places_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "places" */
export type Pt_Places_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pt_Places_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "places" */
export type Pt_Places_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  population?: InputMaybe<Order_By>;
};

/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pt_Post_Merged_Listings = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  book_online?: Maybe<Scalars['Boolean']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** A computed field, executes function "get_least_created_at" */
  created_at_consolidated?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  features_for_sale_embedding?: Maybe<Scalars['vector']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  geog?: Maybe<Scalars['geography']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  has_balcony?: Maybe<Scalars['Boolean']['output']>;
  has_cable_tv?: Maybe<Scalars['Boolean']['output']>;
  has_cellar?: Maybe<Scalars['Boolean']['output']>;
  has_dish_washer?: Maybe<Scalars['Boolean']['output']>;
  has_elevator?: Maybe<Scalars['Boolean']['output']>;
  has_fireplace?: Maybe<Scalars['Boolean']['output']>;
  has_garage?: Maybe<Scalars['Boolean']['output']>;
  has_garden?: Maybe<Scalars['Boolean']['output']>;
  has_gas_supply?: Maybe<Scalars['Boolean']['output']>;
  has_internet?: Maybe<Scalars['Boolean']['output']>;
  has_lavatory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_lavotory_connection?: Maybe<Scalars['Boolean']['output']>;
  has_new_building_project?: Maybe<Scalars['Boolean']['output']>;
  has_parking?: Maybe<Scalars['Boolean']['output']>;
  has_play_ground?: Maybe<Scalars['Boolean']['output']>;
  has_restrooms?: Maybe<Scalars['Boolean']['output']>;
  has_sewerage_supply?: Maybe<Scalars['Boolean']['output']>;
  has_steamer?: Maybe<Scalars['Boolean']['output']>;
  has_storage_room?: Maybe<Scalars['Boolean']['output']>;
  has_swimming_pool?: Maybe<Scalars['Boolean']['output']>;
  has_tumble_dryer?: Maybe<Scalars['Boolean']['output']>;
  has_view?: Maybe<Scalars['Boolean']['output']>;
  has_virtual_tour?: Maybe<Scalars['Boolean']['output']>;
  has_washing_machine?: Maybe<Scalars['Boolean']['output']>;
  has_water_supply?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  /** An array relationship */
  images: Array<Pt_Merged_Images>;
  /** An aggregate relationship */
  images_aggregate: Pt_Merged_Images_Aggregate;
  is_animal_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_child_friendly?: Maybe<Scalars['Boolean']['output']>;
  is_fsbo?: Maybe<Scalars['Boolean']['output']>;
  is_furnished?: Maybe<Scalars['Boolean']['output']>;
  is_groundfloor_raised?: Maybe<Scalars['Boolean']['output']>;
  is_highlighted?: Maybe<Scalars['Boolean']['output']>;
  is_minergie_certified?: Maybe<Scalars['Boolean']['output']>;
  is_new_development?: Maybe<Scalars['Boolean']['output']>;
  is_old_building?: Maybe<Scalars['Boolean']['output']>;
  is_wheelchair_accessible?: Maybe<Scalars['Boolean']['output']>;
  knn_features_for_sale?: Maybe<Scalars['cube']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "get_listing_images" */
  listing_images?: Maybe<Array<Pt_Merged_Images>>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  locality_object?: Maybe<Pt_Places>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  municipality?: Maybe<Pt_Places>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type: Scalars['String']['output'];
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id: Scalars['String']['output'];
  portal: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type: Scalars['String']['output'];
  property_type: Scalars['String']['output'];
  recommendation: Scalars['Float']['output'];
  region_id?: Maybe<Scalars['uuid']['output']>;
  removed: Scalars['Boolean']['output'];
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  secondary_residence_eligible?: Maybe<Scalars['Boolean']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  translated_titles?: Maybe<Scalars['jsonb']['output']>;
  url: Scalars['String']['output'];
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from: Scalars['timestamptz']['output'];
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pt_Post_Merged_ListingsImagesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pt_Post_Merged_ListingsImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pt_Post_Merged_ListingsListing_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


/** Every portal listing ever collected, online and offline, deduplicated with the production rules (stricter than merged_listings). Nearly the same columns as merged_listings. On the market here: offline_since IS NULL and duplicate_id IS NULL and removed = false. Where online_listings is maintained (Switzerland, France, Spain, Italy) it is the faster source for what is on the market now. Always filter offer_type and locality_id or municipality_id: slow otherwise. Rows are capped at 100 per query for agents: count with the aggregate. */
export type Pt_Post_Merged_ListingsTranslated_TitlesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "post_merged_listings" */
export type Pt_Post_Merged_Listings_Aggregate = {
  aggregate?: Maybe<Pt_Post_Merged_Listings_Aggregate_Fields>;
  nodes: Array<Pt_Post_Merged_Listings>;
};

/** aggregate fields of "post_merged_listings" */
export type Pt_Post_Merged_Listings_Aggregate_Fields = {
  avg?: Maybe<Pt_Post_Merged_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Post_Merged_Listings_Max_Fields>;
  min?: Maybe<Pt_Post_Merged_Listings_Min_Fields>;
  stddev?: Maybe<Pt_Post_Merged_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Post_Merged_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Post_Merged_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Post_Merged_Listings_Sum_Fields>;
  var_pop?: Maybe<Pt_Post_Merged_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Post_Merged_Listings_Var_Samp_Fields>;
  variance?: Maybe<Pt_Post_Merged_Listings_Variance_Fields>;
};


/** aggregate fields of "post_merged_listings" */
export type Pt_Post_Merged_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Post_Merged_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_Post_Merged_Listings_Avg_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "post_merged_listings". All fields are combined with a logical 'AND'. */
export type Pt_Post_Merged_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Post_Merged_Listings_Bool_Exp>>;
  _not?: InputMaybe<Pt_Post_Merged_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Post_Merged_Listings_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_address?: InputMaybe<String_Comparison_Exp>;
  agency_contact_person?: InputMaybe<String_Comparison_Exp>;
  agency_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  agency_email_contact?: InputMaybe<String_Comparison_Exp>;
  agency_homepage_url?: InputMaybe<String_Comparison_Exp>;
  agency_name?: InputMaybe<String_Comparison_Exp>;
  agency_portal_id?: InputMaybe<String_Comparison_Exp>;
  agency_reference?: InputMaybe<String_Comparison_Exp>;
  balcony_surface?: InputMaybe<Float_Comparison_Exp>;
  book_online?: InputMaybe<Boolean_Comparison_Exp>;
  built_surface?: InputMaybe<Float_Comparison_Exp>;
  computed_price_per_sqm?: InputMaybe<Float_Comparison_Exp>;
  computed_surface?: InputMaybe<Float_Comparison_Exp>;
  construction_year?: InputMaybe<Int_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at_consolidated?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  dist_elementary_school?: InputMaybe<Float_Comparison_Exp>;
  dist_high_school?: InputMaybe<Float_Comparison_Exp>;
  dist_kindergarten?: InputMaybe<Float_Comparison_Exp>;
  dist_motor_way?: InputMaybe<Float_Comparison_Exp>;
  dist_public_transportation?: InputMaybe<Float_Comparison_Exp>;
  dist_shopping?: InputMaybe<Float_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  duplicate_id?: InputMaybe<Int_Comparison_Exp>;
  energy_certificate_version?: InputMaybe<String_Comparison_Exp>;
  energy_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  energy_cost_currency?: InputMaybe<String_Comparison_Exp>;
  energy_index?: InputMaybe<Float_Comparison_Exp>;
  energy_inspection_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  energy_reference_year?: InputMaybe<Float_Comparison_Exp>;
  estimated_higher_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  estimated_lower_energy_cost?: InputMaybe<Float_Comparison_Exp>;
  features_for_sale_embedding?: InputMaybe<Vector_Comparison_Exp>;
  flat_type?: InputMaybe<String_Comparison_Exp>;
  floor_of_flat?: InputMaybe<Int_Comparison_Exp>;
  garden_surface?: InputMaybe<Float_Comparison_Exp>;
  geog?: InputMaybe<Geography_Comparison_Exp>;
  greenhouse_gas_emissions_class?: InputMaybe<Energy_Ges_Values_Comparison_Exp>;
  greenhouse_gas_emissions_index?: InputMaybe<Float_Comparison_Exp>;
  gross_rent?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_auto?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_m2yearly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_rent_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  gross_vs_estimated_rent?: InputMaybe<Float_Comparison_Exp>;
  has_balcony?: InputMaybe<Boolean_Comparison_Exp>;
  has_cable_tv?: InputMaybe<Boolean_Comparison_Exp>;
  has_cellar?: InputMaybe<Boolean_Comparison_Exp>;
  has_dish_washer?: InputMaybe<Boolean_Comparison_Exp>;
  has_elevator?: InputMaybe<Boolean_Comparison_Exp>;
  has_fireplace?: InputMaybe<Boolean_Comparison_Exp>;
  has_garage?: InputMaybe<Boolean_Comparison_Exp>;
  has_garden?: InputMaybe<Boolean_Comparison_Exp>;
  has_gas_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_internet?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavatory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_lavotory_connection?: InputMaybe<Boolean_Comparison_Exp>;
  has_new_building_project?: InputMaybe<Boolean_Comparison_Exp>;
  has_parking?: InputMaybe<Boolean_Comparison_Exp>;
  has_play_ground?: InputMaybe<Boolean_Comparison_Exp>;
  has_restrooms?: InputMaybe<Boolean_Comparison_Exp>;
  has_sewerage_supply?: InputMaybe<Boolean_Comparison_Exp>;
  has_steamer?: InputMaybe<Boolean_Comparison_Exp>;
  has_storage_room?: InputMaybe<Boolean_Comparison_Exp>;
  has_swimming_pool?: InputMaybe<Boolean_Comparison_Exp>;
  has_tumble_dryer?: InputMaybe<Boolean_Comparison_Exp>;
  has_view?: InputMaybe<Boolean_Comparison_Exp>;
  has_virtual_tour?: InputMaybe<Boolean_Comparison_Exp>;
  has_washing_machine?: InputMaybe<Boolean_Comparison_Exp>;
  has_water_supply?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  images?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
  is_animal_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_child_friendly?: InputMaybe<Boolean_Comparison_Exp>;
  is_fsbo?: InputMaybe<Boolean_Comparison_Exp>;
  is_furnished?: InputMaybe<Boolean_Comparison_Exp>;
  is_groundfloor_raised?: InputMaybe<Boolean_Comparison_Exp>;
  is_highlighted?: InputMaybe<Boolean_Comparison_Exp>;
  is_minergie_certified?: InputMaybe<Boolean_Comparison_Exp>;
  is_new_development?: InputMaybe<Boolean_Comparison_Exp>;
  is_old_building?: InputMaybe<Boolean_Comparison_Exp>;
  is_wheelchair_accessible?: InputMaybe<Boolean_Comparison_Exp>;
  knn_features_for_sale?: InputMaybe<Cube_Comparison_Exp>;
  land_surface?: InputMaybe<Float_Comparison_Exp>;
  listing_images?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
  listing_language?: InputMaybe<String_Comparison_Exp>;
  living_surface?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality_object?: InputMaybe<Pt_Places_Bool_Exp>;
  lot_reference?: InputMaybe<String_Comparison_Exp>;
  municipality?: InputMaybe<Pt_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  number_of_bathrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_bedrooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_indoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_levels?: InputMaybe<Int_Comparison_Exp>;
  number_of_outdoor_parkings?: InputMaybe<Int_Comparison_Exp>;
  number_of_parking?: InputMaybe<Int_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Float_Comparison_Exp>;
  number_of_toilets?: InputMaybe<Float_Comparison_Exp>;
  offer_type?: InputMaybe<String_Comparison_Exp>;
  offline_since?: InputMaybe<Timestamptz_Comparison_Exp>;
  original_id?: InputMaybe<String_Comparison_Exp>;
  portal?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  price_hubble_lower_price?: InputMaybe<Int_Comparison_Exp>;
  price_hubble_upper_price?: InputMaybe<Int_Comparison_Exp>;
  price_unit?: InputMaybe<String_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  property_type?: InputMaybe<String_Comparison_Exp>;
  recommendation?: InputMaybe<Float_Comparison_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  removed?: InputMaybe<Boolean_Comparison_Exp>;
  renovation_year?: InputMaybe<Int_Comparison_Exp>;
  rent_extra?: InputMaybe<Float_Comparison_Exp>;
  rent_net?: InputMaybe<Float_Comparison_Exp>;
  rent_net_monthly?: InputMaybe<Float_Comparison_Exp>;
  rent_net_room_monthly?: InputMaybe<Float_Comparison_Exp>;
  rental_return?: InputMaybe<Float_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  sale_price?: InputMaybe<Float_Comparison_Exp>;
  sale_price_auto?: InputMaybe<Float_Comparison_Exp>;
  sale_price_iazi?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_land_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_price_per_living_surface?: InputMaybe<Float_Comparison_Exp>;
  sale_vs_estimated_price?: InputMaybe<Float_Comparison_Exp>;
  secondary_residence_eligible?: InputMaybe<Boolean_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  sub_locality?: InputMaybe<String_Comparison_Exp>;
  terrace_surface?: InputMaybe<Float_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  translated_titles?: InputMaybe<Jsonb_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  usable_surface?: InputMaybe<Float_Comparison_Exp>;
  valid_from?: InputMaybe<Timestamptz_Comparison_Exp>;
  visit_contact_email?: InputMaybe<String_Comparison_Exp>;
  visit_contact_person?: InputMaybe<String_Comparison_Exp>;
  visit_contact_phone_number?: InputMaybe<String_Comparison_Exp>;
  volume?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Post_Merged_Listings_Max_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate min on columns */
export type Pt_Post_Merged_Listings_Min_Fields = {
  address?: Maybe<Scalars['String']['output']>;
  agency_contact_address?: Maybe<Scalars['String']['output']>;
  agency_contact_person?: Maybe<Scalars['String']['output']>;
  agency_contact_phone_number?: Maybe<Scalars['String']['output']>;
  agency_email_contact?: Maybe<Scalars['String']['output']>;
  agency_homepage_url?: Maybe<Scalars['String']['output']>;
  agency_name?: Maybe<Scalars['String']['output']>;
  agency_portal_id?: Maybe<Scalars['String']['output']>;
  agency_reference?: Maybe<Scalars['String']['output']>;
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_certificate_version?: Maybe<Scalars['String']['output']>;
  energy_class?: Maybe<Scalars['energy_ges_values']['output']>;
  energy_cost_currency?: Maybe<Scalars['String']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_inspection_date?: Maybe<Scalars['timestamptz']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  flat_type?: Maybe<Scalars['String']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_class?: Maybe<Scalars['energy_ges_values']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  listing_language?: Maybe<Scalars['String']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lot_reference?: Maybe<Scalars['String']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  offer_type?: Maybe<Scalars['String']['output']>;
  offline_since?: Maybe<Scalars['timestamptz']['output']>;
  original_id?: Maybe<Scalars['String']['output']>;
  portal?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  price_unit?: Maybe<Scalars['String']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  property_type?: Maybe<Scalars['String']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  sub_locality?: Maybe<Scalars['String']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  valid_from?: Maybe<Scalars['timestamptz']['output']>;
  visit_contact_email?: Maybe<Scalars['String']['output']>;
  visit_contact_person?: Maybe<Scalars['String']['output']>;
  visit_contact_phone_number?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Ordering options when selecting data from "post_merged_listings". */
export type Pt_Post_Merged_Listings_Order_By = {
  address?: InputMaybe<Order_By>;
  agency_contact_address?: InputMaybe<Order_By>;
  agency_contact_person?: InputMaybe<Order_By>;
  agency_contact_phone_number?: InputMaybe<Order_By>;
  agency_email_contact?: InputMaybe<Order_By>;
  agency_homepage_url?: InputMaybe<Order_By>;
  agency_name?: InputMaybe<Order_By>;
  agency_portal_id?: InputMaybe<Order_By>;
  agency_reference?: InputMaybe<Order_By>;
  balcony_surface?: InputMaybe<Order_By>;
  book_online?: InputMaybe<Order_By>;
  built_surface?: InputMaybe<Order_By>;
  computed_price_per_sqm?: InputMaybe<Order_By>;
  computed_surface?: InputMaybe<Order_By>;
  construction_year?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_at_consolidated?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  dist_elementary_school?: InputMaybe<Order_By>;
  dist_high_school?: InputMaybe<Order_By>;
  dist_kindergarten?: InputMaybe<Order_By>;
  dist_motor_way?: InputMaybe<Order_By>;
  dist_public_transportation?: InputMaybe<Order_By>;
  dist_shopping?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  duplicate_id?: InputMaybe<Order_By>;
  energy_certificate_version?: InputMaybe<Order_By>;
  energy_class?: InputMaybe<Order_By>;
  energy_cost_currency?: InputMaybe<Order_By>;
  energy_index?: InputMaybe<Order_By>;
  energy_inspection_date?: InputMaybe<Order_By>;
  energy_reference_year?: InputMaybe<Order_By>;
  estimated_higher_energy_cost?: InputMaybe<Order_By>;
  estimated_lower_energy_cost?: InputMaybe<Order_By>;
  features_for_sale_embedding?: InputMaybe<Order_By>;
  flat_type?: InputMaybe<Order_By>;
  floor_of_flat?: InputMaybe<Order_By>;
  garden_surface?: InputMaybe<Order_By>;
  geog?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_class?: InputMaybe<Order_By>;
  greenhouse_gas_emissions_index?: InputMaybe<Order_By>;
  gross_rent?: InputMaybe<Order_By>;
  gross_rent_auto?: InputMaybe<Order_By>;
  gross_rent_m2yearly?: InputMaybe<Order_By>;
  gross_rent_monthly?: InputMaybe<Order_By>;
  gross_rent_room_monthly?: InputMaybe<Order_By>;
  gross_vs_estimated_rent?: InputMaybe<Order_By>;
  has_balcony?: InputMaybe<Order_By>;
  has_cable_tv?: InputMaybe<Order_By>;
  has_cellar?: InputMaybe<Order_By>;
  has_dish_washer?: InputMaybe<Order_By>;
  has_elevator?: InputMaybe<Order_By>;
  has_fireplace?: InputMaybe<Order_By>;
  has_garage?: InputMaybe<Order_By>;
  has_garden?: InputMaybe<Order_By>;
  has_gas_supply?: InputMaybe<Order_By>;
  has_internet?: InputMaybe<Order_By>;
  has_lavatory_connection?: InputMaybe<Order_By>;
  has_lavotory_connection?: InputMaybe<Order_By>;
  has_new_building_project?: InputMaybe<Order_By>;
  has_parking?: InputMaybe<Order_By>;
  has_play_ground?: InputMaybe<Order_By>;
  has_restrooms?: InputMaybe<Order_By>;
  has_sewerage_supply?: InputMaybe<Order_By>;
  has_steamer?: InputMaybe<Order_By>;
  has_storage_room?: InputMaybe<Order_By>;
  has_swimming_pool?: InputMaybe<Order_By>;
  has_tumble_dryer?: InputMaybe<Order_By>;
  has_view?: InputMaybe<Order_By>;
  has_virtual_tour?: InputMaybe<Order_By>;
  has_washing_machine?: InputMaybe<Order_By>;
  has_water_supply?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  images_aggregate?: InputMaybe<Pt_Merged_Images_Aggregate_Order_By>;
  is_animal_friendly?: InputMaybe<Order_By>;
  is_child_friendly?: InputMaybe<Order_By>;
  is_fsbo?: InputMaybe<Order_By>;
  is_furnished?: InputMaybe<Order_By>;
  is_groundfloor_raised?: InputMaybe<Order_By>;
  is_highlighted?: InputMaybe<Order_By>;
  is_minergie_certified?: InputMaybe<Order_By>;
  is_new_development?: InputMaybe<Order_By>;
  is_old_building?: InputMaybe<Order_By>;
  is_wheelchair_accessible?: InputMaybe<Order_By>;
  knn_features_for_sale?: InputMaybe<Order_By>;
  land_surface?: InputMaybe<Order_By>;
  listing_images_aggregate?: InputMaybe<Pt_Merged_Images_Aggregate_Order_By>;
  listing_language?: InputMaybe<Order_By>;
  living_surface?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  locality_object?: InputMaybe<Pt_Places_Order_By>;
  lot_reference?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Pt_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  number_of_bathrooms?: InputMaybe<Order_By>;
  number_of_bedrooms?: InputMaybe<Order_By>;
  number_of_indoor_parkings?: InputMaybe<Order_By>;
  number_of_levels?: InputMaybe<Order_By>;
  number_of_outdoor_parkings?: InputMaybe<Order_By>;
  number_of_parking?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  number_of_toilets?: InputMaybe<Order_By>;
  offer_type?: InputMaybe<Order_By>;
  offline_since?: InputMaybe<Order_By>;
  original_id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  price_hubble_lower_price?: InputMaybe<Order_By>;
  price_hubble_upper_price?: InputMaybe<Order_By>;
  price_unit?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  property_type?: InputMaybe<Order_By>;
  recommendation?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  removed?: InputMaybe<Order_By>;
  renovation_year?: InputMaybe<Order_By>;
  rent_extra?: InputMaybe<Order_By>;
  rent_net?: InputMaybe<Order_By>;
  rent_net_monthly?: InputMaybe<Order_By>;
  rent_net_room_monthly?: InputMaybe<Order_By>;
  rental_return?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  sale_price?: InputMaybe<Order_By>;
  sale_price_auto?: InputMaybe<Order_By>;
  sale_price_iazi?: InputMaybe<Order_By>;
  sale_price_per_land_surface?: InputMaybe<Order_By>;
  sale_price_per_living_surface?: InputMaybe<Order_By>;
  sale_vs_estimated_price?: InputMaybe<Order_By>;
  secondary_residence_eligible?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  sub_locality?: InputMaybe<Order_By>;
  terrace_surface?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  translated_titles?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  usable_surface?: InputMaybe<Order_By>;
  valid_from?: InputMaybe<Order_By>;
  visit_contact_email?: InputMaybe<Order_By>;
  visit_contact_person?: InputMaybe<Order_By>;
  visit_contact_phone_number?: InputMaybe<Order_By>;
  volume?: InputMaybe<Order_By>;
};

/** select columns of table "post_merged_listings" */
export enum Pt_Post_Merged_Listings_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  AgencyContactAddress = 'agency_contact_address',
  /** column name */
  AgencyContactPerson = 'agency_contact_person',
  /** column name */
  AgencyContactPhoneNumber = 'agency_contact_phone_number',
  /** column name */
  AgencyEmailContact = 'agency_email_contact',
  /** column name */
  AgencyHomepageUrl = 'agency_homepage_url',
  /** column name */
  AgencyName = 'agency_name',
  /** column name */
  AgencyPortalId = 'agency_portal_id',
  /** column name */
  AgencyReference = 'agency_reference',
  /** column name */
  BalconySurface = 'balcony_surface',
  /** column name */
  BookOnline = 'book_online',
  /** column name */
  BuiltSurface = 'built_surface',
  /** column name */
  ComputedPricePerSqm = 'computed_price_per_sqm',
  /** column name */
  ComputedSurface = 'computed_surface',
  /** column name */
  ConstructionYear = 'construction_year',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  Description = 'description',
  /** column name */
  DistElementarySchool = 'dist_elementary_school',
  /** column name */
  DistHighSchool = 'dist_high_school',
  /** column name */
  DistKindergarten = 'dist_kindergarten',
  /** column name */
  DistMotorWay = 'dist_motor_way',
  /** column name */
  DistPublicTransportation = 'dist_public_transportation',
  /** column name */
  DistShopping = 'dist_shopping',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DuplicateId = 'duplicate_id',
  /** column name */
  EnergyCertificateVersion = 'energy_certificate_version',
  /** column name */
  EnergyClass = 'energy_class',
  /** column name */
  EnergyCostCurrency = 'energy_cost_currency',
  /** column name */
  EnergyIndex = 'energy_index',
  /** column name */
  EnergyInspectionDate = 'energy_inspection_date',
  /** column name */
  EnergyReferenceYear = 'energy_reference_year',
  /** column name */
  EstimatedHigherEnergyCost = 'estimated_higher_energy_cost',
  /** column name */
  EstimatedLowerEnergyCost = 'estimated_lower_energy_cost',
  /** column name */
  FeaturesForSaleEmbedding = 'features_for_sale_embedding',
  /** column name */
  FlatType = 'flat_type',
  /** column name */
  FloorOfFlat = 'floor_of_flat',
  /** column name */
  GardenSurface = 'garden_surface',
  /** column name */
  Geog = 'geog',
  /** column name */
  GreenhouseGasEmissionsClass = 'greenhouse_gas_emissions_class',
  /** column name */
  GreenhouseGasEmissionsIndex = 'greenhouse_gas_emissions_index',
  /** column name */
  GrossRent = 'gross_rent',
  /** column name */
  GrossRentAuto = 'gross_rent_auto',
  /** column name */
  GrossRentM2yearly = 'gross_rent_m2yearly',
  /** column name */
  GrossRentMonthly = 'gross_rent_monthly',
  /** column name */
  GrossRentRoomMonthly = 'gross_rent_room_monthly',
  /** column name */
  GrossVsEstimatedRent = 'gross_vs_estimated_rent',
  /** column name */
  HasBalcony = 'has_balcony',
  /** column name */
  HasCableTv = 'has_cable_tv',
  /** column name */
  HasCellar = 'has_cellar',
  /** column name */
  HasDishWasher = 'has_dish_washer',
  /** column name */
  HasElevator = 'has_elevator',
  /** column name */
  HasFireplace = 'has_fireplace',
  /** column name */
  HasGarage = 'has_garage',
  /** column name */
  HasGarden = 'has_garden',
  /** column name */
  HasGasSupply = 'has_gas_supply',
  /** column name */
  HasInternet = 'has_internet',
  /** column name */
  HasLavatoryConnection = 'has_lavatory_connection',
  /** column name */
  HasLavotoryConnection = 'has_lavotory_connection',
  /** column name */
  HasNewBuildingProject = 'has_new_building_project',
  /** column name */
  HasParking = 'has_parking',
  /** column name */
  HasPlayGround = 'has_play_ground',
  /** column name */
  HasRestrooms = 'has_restrooms',
  /** column name */
  HasSewerageSupply = 'has_sewerage_supply',
  /** column name */
  HasSteamer = 'has_steamer',
  /** column name */
  HasStorageRoom = 'has_storage_room',
  /** column name */
  HasSwimmingPool = 'has_swimming_pool',
  /** column name */
  HasTumbleDryer = 'has_tumble_dryer',
  /** column name */
  HasView = 'has_view',
  /** column name */
  HasVirtualTour = 'has_virtual_tour',
  /** column name */
  HasWashingMachine = 'has_washing_machine',
  /** column name */
  HasWaterSupply = 'has_water_supply',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnimalFriendly = 'is_animal_friendly',
  /** column name */
  IsChildFriendly = 'is_child_friendly',
  /** column name */
  IsFsbo = 'is_fsbo',
  /** column name */
  IsFurnished = 'is_furnished',
  /** column name */
  IsGroundfloorRaised = 'is_groundfloor_raised',
  /** column name */
  IsHighlighted = 'is_highlighted',
  /** column name */
  IsMinergieCertified = 'is_minergie_certified',
  /** column name */
  IsNewDevelopment = 'is_new_development',
  /** column name */
  IsOldBuilding = 'is_old_building',
  /** column name */
  IsWheelchairAccessible = 'is_wheelchair_accessible',
  /** column name */
  KnnFeaturesForSale = 'knn_features_for_sale',
  /** column name */
  LandSurface = 'land_surface',
  /** column name */
  ListingLanguage = 'listing_language',
  /** column name */
  LivingSurface = 'living_surface',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LotReference = 'lot_reference',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  NumberOfBathrooms = 'number_of_bathrooms',
  /** column name */
  NumberOfBedrooms = 'number_of_bedrooms',
  /** column name */
  NumberOfIndoorParkings = 'number_of_indoor_parkings',
  /** column name */
  NumberOfLevels = 'number_of_levels',
  /** column name */
  NumberOfOutdoorParkings = 'number_of_outdoor_parkings',
  /** column name */
  NumberOfParking = 'number_of_parking',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  NumberOfToilets = 'number_of_toilets',
  /** column name */
  OfferType = 'offer_type',
  /** column name */
  OfflineSince = 'offline_since',
  /** column name */
  OriginalId = 'original_id',
  /** column name */
  Portal = 'portal',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  PriceHubbleLowerPrice = 'price_hubble_lower_price',
  /** column name */
  PriceHubbleUpperPrice = 'price_hubble_upper_price',
  /** column name */
  PriceUnit = 'price_unit',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  PropertyType = 'property_type',
  /** column name */
  Recommendation = 'recommendation',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Removed = 'removed',
  /** column name */
  RenovationYear = 'renovation_year',
  /** column name */
  RentExtra = 'rent_extra',
  /** column name */
  RentNet = 'rent_net',
  /** column name */
  RentNetMonthly = 'rent_net_monthly',
  /** column name */
  RentNetRoomMonthly = 'rent_net_room_monthly',
  /** column name */
  RentalReturn = 'rental_return',
  /** column name */
  Route = 'route',
  /** column name */
  SalePrice = 'sale_price',
  /** column name */
  SalePriceAuto = 'sale_price_auto',
  /** column name */
  SalePriceIazi = 'sale_price_iazi',
  /** column name */
  SalePricePerLandSurface = 'sale_price_per_land_surface',
  /** column name */
  SalePricePerLivingSurface = 'sale_price_per_living_surface',
  /** column name */
  SaleVsEstimatedPrice = 'sale_vs_estimated_price',
  /** column name */
  SecondaryResidenceEligible = 'secondary_residence_eligible',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  SubLocality = 'sub_locality',
  /** column name */
  TerraceSurface = 'terrace_surface',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedTitles = 'translated_titles',
  /** column name */
  Url = 'url',
  /** column name */
  UsableSurface = 'usable_surface',
  /** column name */
  ValidFrom = 'valid_from',
  /** column name */
  VisitContactEmail = 'visit_contact_email',
  /** column name */
  VisitContactPerson = 'visit_contact_person',
  /** column name */
  VisitContactPhoneNumber = 'visit_contact_phone_number',
  /** column name */
  Volume = 'volume'
}

/** aggregate stddev on columns */
export type Pt_Post_Merged_Listings_Stddev_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_Post_Merged_Listings_Stddev_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_Post_Merged_Listings_Stddev_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_Post_Merged_Listings_Sum_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Int']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Int']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Int']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_levels?: Maybe<Scalars['Int']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Int']['output']>;
  number_of_parking?: Maybe<Scalars['Int']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Int']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Int']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Int']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_Post_Merged_Listings_Var_Pop_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_Post_Merged_Listings_Var_Samp_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_Post_Merged_Listings_Variance_Fields = {
  balcony_surface?: Maybe<Scalars['Float']['output']>;
  built_surface?: Maybe<Scalars['Float']['output']>;
  computed_price_per_sqm?: Maybe<Scalars['Float']['output']>;
  computed_surface?: Maybe<Scalars['Float']['output']>;
  construction_year?: Maybe<Scalars['Float']['output']>;
  dist_elementary_school?: Maybe<Scalars['Float']['output']>;
  dist_high_school?: Maybe<Scalars['Float']['output']>;
  dist_kindergarten?: Maybe<Scalars['Float']['output']>;
  dist_motor_way?: Maybe<Scalars['Float']['output']>;
  dist_public_transportation?: Maybe<Scalars['Float']['output']>;
  dist_shopping?: Maybe<Scalars['Float']['output']>;
  duplicate_id?: Maybe<Scalars['Float']['output']>;
  energy_index?: Maybe<Scalars['Float']['output']>;
  energy_reference_year?: Maybe<Scalars['Float']['output']>;
  estimated_higher_energy_cost?: Maybe<Scalars['Float']['output']>;
  estimated_lower_energy_cost?: Maybe<Scalars['Float']['output']>;
  floor_of_flat?: Maybe<Scalars['Float']['output']>;
  garden_surface?: Maybe<Scalars['Float']['output']>;
  greenhouse_gas_emissions_index?: Maybe<Scalars['Float']['output']>;
  gross_rent?: Maybe<Scalars['Float']['output']>;
  gross_rent_auto?: Maybe<Scalars['Float']['output']>;
  gross_rent_m2yearly?: Maybe<Scalars['Float']['output']>;
  gross_rent_monthly?: Maybe<Scalars['Float']['output']>;
  gross_rent_room_monthly?: Maybe<Scalars['Float']['output']>;
  gross_vs_estimated_rent?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  land_surface?: Maybe<Scalars['Float']['output']>;
  living_surface?: Maybe<Scalars['Float']['output']>;
  number_of_bathrooms?: Maybe<Scalars['Float']['output']>;
  number_of_bedrooms?: Maybe<Scalars['Float']['output']>;
  number_of_indoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_levels?: Maybe<Scalars['Float']['output']>;
  number_of_outdoor_parkings?: Maybe<Scalars['Float']['output']>;
  number_of_parking?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  number_of_toilets?: Maybe<Scalars['Float']['output']>;
  price_hubble_lower_price?: Maybe<Scalars['Float']['output']>;
  price_hubble_upper_price?: Maybe<Scalars['Float']['output']>;
  recommendation?: Maybe<Scalars['Float']['output']>;
  renovation_year?: Maybe<Scalars['Float']['output']>;
  rent_extra?: Maybe<Scalars['Float']['output']>;
  rent_net?: Maybe<Scalars['Float']['output']>;
  rent_net_monthly?: Maybe<Scalars['Float']['output']>;
  rent_net_room_monthly?: Maybe<Scalars['Float']['output']>;
  rental_return?: Maybe<Scalars['Float']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  sale_price_auto?: Maybe<Scalars['Float']['output']>;
  sale_price_iazi?: Maybe<Scalars['Float']['output']>;
  sale_price_per_land_surface?: Maybe<Scalars['Float']['output']>;
  sale_price_per_living_surface?: Maybe<Scalars['Float']['output']>;
  sale_vs_estimated_price?: Maybe<Scalars['Float']['output']>;
  terrace_surface?: Maybe<Scalars['Float']['output']>;
  usable_surface?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** Price estimates of a place: one row per place_id x property_main_type x number_of_rooms. number_of_rooms = 0 is all sizes; property_main_type is ANY (all types), HOUSE or APPT. sale_price_m2_50 is the modelled price per m2; _10 and _90 are that estimate scaled to a typical low and high, not percentiles of the place. monthly_rent_* is gross monthly rent, yearly_rent_m2_* yearly rent per m2. Rebuilt monthly. */
export type Pt_Price_Stats = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** aggregated selection of "price_stats" */
export type Pt_Price_Stats_Aggregate = {
  aggregate?: Maybe<Pt_Price_Stats_Aggregate_Fields>;
  nodes: Array<Pt_Price_Stats>;
};

/** aggregate fields of "price_stats" */
export type Pt_Price_Stats_Aggregate_Fields = {
  avg?: Maybe<Pt_Price_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Price_Stats_Max_Fields>;
  min?: Maybe<Pt_Price_Stats_Min_Fields>;
  stddev?: Maybe<Pt_Price_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Price_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Price_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Price_Stats_Sum_Fields>;
  var_pop?: Maybe<Pt_Price_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Price_Stats_Var_Samp_Fields>;
  variance?: Maybe<Pt_Price_Stats_Variance_Fields>;
};


/** aggregate fields of "price_stats" */
export type Pt_Price_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats" */
export type Pt_Price_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Pt_Price_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pt_Price_Stats_Max_Order_By>;
  min?: InputMaybe<Pt_Price_Stats_Min_Order_By>;
  stddev?: InputMaybe<Pt_Price_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pt_Price_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pt_Price_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pt_Price_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Pt_Price_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pt_Price_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Pt_Price_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pt_Price_Stats_Avg_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats" */
export type Pt_Price_Stats_Avg_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats". All fields are combined with a logical 'AND'. */
export type Pt_Price_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Price_Stats_Bool_Exp>>;
  _not?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Price_Stats_Bool_Exp>>;
  monthly_rent_10?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_50?: InputMaybe<Float_Comparison_Exp>;
  monthly_rent_90?: InputMaybe<Float_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_parent_id?: InputMaybe<Uuid_Comparison_Exp>;
  place_type?: InputMaybe<Place_Type_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  rent_count?: InputMaybe<Int_Comparison_Exp>;
  rent_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_count?: InputMaybe<Int_Comparison_Exp>;
  sale_count_3month?: InputMaybe<Int_Comparison_Exp>;
  sale_price_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_90?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_10?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_50?: InputMaybe<Float_Comparison_Exp>;
  sale_price_m2_90?: InputMaybe<Float_Comparison_Exp>;
  stock?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  yearly_rent_m2_10?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_50?: InputMaybe<Float_Comparison_Exp>;
  yearly_rent_m2_90?: InputMaybe<Float_Comparison_Exp>;
};

/** Modelled sale price per m2 of a place over time: one row per place_id x property_main_type x number_of_rooms x date. All property types is 'ALL' here, where price_stats says ANY; number_of_rooms = 0 is all sizes. Daily for countries, states, districts and agglomerations, monthly for municipalities and localities. Always filter place_id, property_main_type, number_of_rooms and a date range. */
export type Pt_Price_Stats_Historical = {
  date: Scalars['date']['output'];
  number_of_rooms: Scalars['Int']['output'];
  place_id: Scalars['uuid']['output'];
  property_main_type: Scalars['String']['output'];
  sale_price_m2: Scalars['Float']['output'];
};

/** aggregated selection of "price_stats_historical" */
export type Pt_Price_Stats_Historical_Aggregate = {
  aggregate?: Maybe<Pt_Price_Stats_Historical_Aggregate_Fields>;
  nodes: Array<Pt_Price_Stats_Historical>;
};

/** aggregate fields of "price_stats_historical" */
export type Pt_Price_Stats_Historical_Aggregate_Fields = {
  avg?: Maybe<Pt_Price_Stats_Historical_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Price_Stats_Historical_Max_Fields>;
  min?: Maybe<Pt_Price_Stats_Historical_Min_Fields>;
  stddev?: Maybe<Pt_Price_Stats_Historical_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Price_Stats_Historical_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Price_Stats_Historical_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Price_Stats_Historical_Sum_Fields>;
  var_pop?: Maybe<Pt_Price_Stats_Historical_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Price_Stats_Historical_Var_Samp_Fields>;
  variance?: Maybe<Pt_Price_Stats_Historical_Variance_Fields>;
};


/** aggregate fields of "price_stats_historical" */
export type Pt_Price_Stats_Historical_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Price_Stats_Historical_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Aggregate_Order_By = {
  avg?: InputMaybe<Pt_Price_Stats_Historical_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pt_Price_Stats_Historical_Max_Order_By>;
  min?: InputMaybe<Pt_Price_Stats_Historical_Min_Order_By>;
  stddev?: InputMaybe<Pt_Price_Stats_Historical_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pt_Price_Stats_Historical_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pt_Price_Stats_Historical_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pt_Price_Stats_Historical_Sum_Order_By>;
  var_pop?: InputMaybe<Pt_Price_Stats_Historical_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pt_Price_Stats_Historical_Var_Samp_Order_By>;
  variance?: InputMaybe<Pt_Price_Stats_Historical_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pt_Price_Stats_Historical_Avg_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Avg_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "price_stats_historical". All fields are combined with a logical 'AND'. */
export type Pt_Price_Stats_Historical_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Price_Stats_Historical_Bool_Exp>>;
  _not?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Price_Stats_Historical_Bool_Exp>>;
  date?: InputMaybe<Date_Comparison_Exp>;
  number_of_rooms?: InputMaybe<Int_Comparison_Exp>;
  place_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_main_type?: InputMaybe<String_Comparison_Exp>;
  sale_price_m2?: InputMaybe<Float_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Price_Stats_Historical_Max_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Max_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pt_Price_Stats_Historical_Min_Fields = {
  date?: Maybe<Scalars['date']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Min_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats_historical". */
export type Pt_Price_Stats_Historical_Order_By = {
  date?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats_historical" */
export enum Pt_Price_Stats_Historical_Select_Column {
  /** column name */
  Date = 'date',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  SalePriceM2 = 'sale_price_m2'
}

/** aggregate stddev on columns */
export type Pt_Price_Stats_Historical_Stddev_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Stddev_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pt_Price_Stats_Historical_Stddev_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Stddev_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pt_Price_Stats_Historical_Stddev_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Stddev_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pt_Price_Stats_Historical_Sum_Fields = {
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Sum_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pt_Price_Stats_Historical_Var_Pop_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Var_Pop_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pt_Price_Stats_Historical_Var_Samp_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Var_Samp_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pt_Price_Stats_Historical_Variance_Fields = {
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  sale_price_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats_historical" */
export type Pt_Price_Stats_Historical_Variance_Order_By = {
  number_of_rooms?: InputMaybe<Order_By>;
  sale_price_m2?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Pt_Price_Stats_Max_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by max() on columns of table "price_stats" */
export type Pt_Price_Stats_Max_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pt_Price_Stats_Min_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  place_id?: Maybe<Scalars['uuid']['output']>;
  place_parent_id?: Maybe<Scalars['uuid']['output']>;
  place_type?: Maybe<Scalars['place_type']['output']>;
  property_main_type?: Maybe<Scalars['String']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by min() on columns of table "price_stats" */
export type Pt_Price_Stats_Min_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "price_stats". */
export type Pt_Price_Stats_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  place_id?: InputMaybe<Order_By>;
  place_parent_id?: InputMaybe<Order_By>;
  place_type?: InputMaybe<Order_By>;
  property_main_type?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  stock?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** select columns of table "price_stats" */
export enum Pt_Price_Stats_Select_Column {
  /** column name */
  MonthlyRent_10 = 'monthly_rent_10',
  /** column name */
  MonthlyRent_50 = 'monthly_rent_50',
  /** column name */
  MonthlyRent_90 = 'monthly_rent_90',
  /** column name */
  NumberOfRooms = 'number_of_rooms',
  /** column name */
  PlaceId = 'place_id',
  /** column name */
  PlaceParentId = 'place_parent_id',
  /** column name */
  PlaceType = 'place_type',
  /** column name */
  PropertyMainType = 'property_main_type',
  /** column name */
  RentCount = 'rent_count',
  /** column name */
  RentCount_3month = 'rent_count_3month',
  /** column name */
  SaleCount = 'sale_count',
  /** column name */
  SaleCount_3month = 'sale_count_3month',
  /** column name */
  SalePrice_10 = 'sale_price_10',
  /** column name */
  SalePrice_50 = 'sale_price_50',
  /** column name */
  SalePrice_90 = 'sale_price_90',
  /** column name */
  SalePriceM2_10 = 'sale_price_m2_10',
  /** column name */
  SalePriceM2_50 = 'sale_price_m2_50',
  /** column name */
  SalePriceM2_90 = 'sale_price_m2_90',
  /** column name */
  Stock = 'stock',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  YearlyRentM2_10 = 'yearly_rent_m2_10',
  /** column name */
  YearlyRentM2_50 = 'yearly_rent_m2_50',
  /** column name */
  YearlyRentM2_90 = 'yearly_rent_m2_90'
}

/** aggregate stddev on columns */
export type Pt_Price_Stats_Stddev_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "price_stats" */
export type Pt_Price_Stats_Stddev_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pt_Price_Stats_Stddev_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "price_stats" */
export type Pt_Price_Stats_Stddev_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pt_Price_Stats_Stddev_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "price_stats" */
export type Pt_Price_Stats_Stddev_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pt_Price_Stats_Sum_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Int']['output']>;
  rent_count?: Maybe<Scalars['Int']['output']>;
  rent_count_3month?: Maybe<Scalars['Int']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Int']['output']>;
  sale_count_3month?: Maybe<Scalars['Int']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Int']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "price_stats" */
export type Pt_Price_Stats_Sum_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pt_Price_Stats_Var_Pop_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "price_stats" */
export type Pt_Price_Stats_Var_Pop_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pt_Price_Stats_Var_Samp_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "price_stats" */
export type Pt_Price_Stats_Var_Samp_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pt_Price_Stats_Variance_Fields = {
  monthly_rent_10?: Maybe<Scalars['Float']['output']>;
  monthly_rent_50?: Maybe<Scalars['Float']['output']>;
  monthly_rent_90?: Maybe<Scalars['Float']['output']>;
  number_of_rooms?: Maybe<Scalars['Float']['output']>;
  rent_count?: Maybe<Scalars['Float']['output']>;
  rent_count_3month?: Maybe<Scalars['Float']['output']>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: Maybe<Scalars['Float']['output']>;
  sale_count_3month?: Maybe<Scalars['Float']['output']>;
  sale_price_10?: Maybe<Scalars['Float']['output']>;
  sale_price_50?: Maybe<Scalars['Float']['output']>;
  sale_price_90?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_10?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_50?: Maybe<Scalars['Float']['output']>;
  sale_price_m2_90?: Maybe<Scalars['Float']['output']>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_10?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_50?: Maybe<Scalars['Float']['output']>;
  yearly_rent_m2_90?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "price_stats" */
export type Pt_Price_Stats_Variance_Order_By = {
  monthly_rent_10?: InputMaybe<Order_By>;
  monthly_rent_50?: InputMaybe<Order_By>;
  monthly_rent_90?: InputMaybe<Order_By>;
  number_of_rooms?: InputMaybe<Order_By>;
  rent_count?: InputMaybe<Order_By>;
  rent_count_3month?: InputMaybe<Order_By>;
  /** Listings online for sale in the place, for the property type. The same figure on every number_of_rooms row, and 0 on the ANY rows: read it on the HOUSE or APPT row. rent_count works the same. */
  sale_count?: InputMaybe<Order_By>;
  sale_count_3month?: InputMaybe<Order_By>;
  sale_price_10?: InputMaybe<Order_By>;
  sale_price_50?: InputMaybe<Order_By>;
  sale_price_90?: InputMaybe<Order_By>;
  sale_price_m2_10?: InputMaybe<Order_By>;
  sale_price_m2_50?: InputMaybe<Order_By>;
  sale_price_m2_90?: InputMaybe<Order_By>;
  /** Weight of the data behind the estimate, not a number of listings or dwellings. Set on number_of_rooms = 0 rows only. */
  stock?: InputMaybe<Order_By>;
  yearly_rent_m2_10?: InputMaybe<Order_By>;
  yearly_rent_m2_50?: InputMaybe<Order_By>;
  yearly_rent_m2_90?: InputMaybe<Order_By>;
};

/** columns and relationships of "property_types" */
export type Pt_Property_Types = {
  /** A computed field, executes function "property_types_label" */
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type Pt_Property_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Property_Types_Bool_Exp>>;
  _not?: InputMaybe<Pt_Property_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Property_Types_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "property_types". */
export type Pt_Property_Types_Order_By = {
  label?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "property_types" */
export enum Pt_Property_Types_Select_Column {
  /** column name */
  Name = 'name'
}

/** columns and relationships of "rental_cma_listings_distance" */
export type Pt_Rental_Cma_Listings_Distance = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  is_online?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  listing?: Maybe<Pt_Cma_Rental_Listings>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

export type Pt_Rental_Cma_Listings_Distance_Aggregate = {
  aggregate?: Maybe<Pt_Rental_Cma_Listings_Distance_Aggregate_Fields>;
  nodes: Array<Pt_Rental_Cma_Listings_Distance>;
};

/** aggregate fields of "rental_cma_listings_distance" */
export type Pt_Rental_Cma_Listings_Distance_Aggregate_Fields = {
  avg?: Maybe<Pt_Rental_Cma_Listings_Distance_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Rental_Cma_Listings_Distance_Max_Fields>;
  min?: Maybe<Pt_Rental_Cma_Listings_Distance_Min_Fields>;
  stddev?: Maybe<Pt_Rental_Cma_Listings_Distance_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Rental_Cma_Listings_Distance_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Rental_Cma_Listings_Distance_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Rental_Cma_Listings_Distance_Sum_Fields>;
  var_pop?: Maybe<Pt_Rental_Cma_Listings_Distance_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Rental_Cma_Listings_Distance_Var_Samp_Fields>;
  variance?: Maybe<Pt_Rental_Cma_Listings_Distance_Variance_Fields>;
};


/** aggregate fields of "rental_cma_listings_distance" */
export type Pt_Rental_Cma_Listings_Distance_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Pt_Rental_Cma_Listings_Distance_Avg_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "rental_cma_listings_distance". All fields are combined with a logical 'AND'. */
export type Pt_Rental_Cma_Listings_Distance_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Bool_Exp>>;
  _not?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Bool_Exp>>;
  distance_in_meters?: InputMaybe<Float8_Comparison_Exp>;
  is_online?: InputMaybe<Boolean_Comparison_Exp>;
  listing?: InputMaybe<Pt_Cma_Rental_Listings_Bool_Exp>;
  listing_id?: InputMaybe<Int_Comparison_Exp>;
  net_rent_per_sqm?: InputMaybe<Float8_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Rental_Cma_Listings_Distance_Max_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Pt_Rental_Cma_Listings_Distance_Min_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "rental_cma_listings_distance". */
export type Pt_Rental_Cma_Listings_Distance_Order_By = {
  distance_in_meters?: InputMaybe<Order_By>;
  is_online?: InputMaybe<Order_By>;
  listing?: InputMaybe<Pt_Cma_Rental_Listings_Order_By>;
  listing_id?: InputMaybe<Order_By>;
  net_rent_per_sqm?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
};

/** select columns of table "rental_cma_listings_distance" */
export enum Pt_Rental_Cma_Listings_Distance_Select_Column {
  /** column name */
  DistanceInMeters = 'distance_in_meters',
  /** column name */
  IsOnline = 'is_online',
  /** column name */
  ListingId = 'listing_id',
  /** column name */
  NetRentPerSqm = 'net_rent_per_sqm',
  /** column name */
  StateId = 'state_id'
}

/** aggregate stddev on columns */
export type Pt_Rental_Cma_Listings_Distance_Stddev_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Pt_Rental_Cma_Listings_Distance_Stddev_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Pt_Rental_Cma_Listings_Distance_Stddev_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Pt_Rental_Cma_Listings_Distance_Sum_Fields = {
  distance_in_meters?: Maybe<Scalars['float8']['output']>;
  listing_id?: Maybe<Scalars['Int']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['float8']['output']>;
};

/** aggregate var_pop on columns */
export type Pt_Rental_Cma_Listings_Distance_Var_Pop_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Pt_Rental_Cma_Listings_Distance_Var_Samp_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Pt_Rental_Cma_Listings_Distance_Variance_Fields = {
  distance_in_meters?: Maybe<Scalars['Float']['output']>;
  listing_id?: Maybe<Scalars['Float']['output']>;
  net_rent_per_sqm?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "states" */
export type Pt_States = {
  name: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "states". All fields are combined with a logical 'AND'. */
export type Pt_States_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_States_Bool_Exp>>;
  _not?: InputMaybe<Pt_States_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_States_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "states". */
export type Pt_States_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** select columns of table "states" */
export enum Pt_States_Select_Column {
  /** column name */
  Name = 'name'
}

/** Sale price per m2 by street (route) within a municipality or locality: median, mean, 15th and 85th percentile, and total_count, the number of data points behind them. A street with a small total_count is noise: ask for at least 15. Rebuilt monthly. */
export type Pt_Street_Stats = {
  geom?: Maybe<Scalars['geometry']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  is_cross_locality?: Maybe<Scalars['Boolean']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  locality?: Maybe<Pt_Places>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  municipality?: Maybe<Pt_Places>;
  municipality_id: Scalars['uuid']['output'];
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  state_id: Scalars['uuid']['output'];
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "street_stats" */
export type Pt_Street_Stats_Aggregate = {
  aggregate?: Maybe<Pt_Street_Stats_Aggregate_Fields>;
  nodes: Array<Pt_Street_Stats>;
};

/** aggregate fields of "street_stats" */
export type Pt_Street_Stats_Aggregate_Fields = {
  avg?: Maybe<Pt_Street_Stats_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Pt_Street_Stats_Max_Fields>;
  min?: Maybe<Pt_Street_Stats_Min_Fields>;
  stddev?: Maybe<Pt_Street_Stats_Stddev_Fields>;
  stddev_pop?: Maybe<Pt_Street_Stats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Pt_Street_Stats_Stddev_Samp_Fields>;
  sum?: Maybe<Pt_Street_Stats_Sum_Fields>;
  var_pop?: Maybe<Pt_Street_Stats_Var_Pop_Fields>;
  var_samp?: Maybe<Pt_Street_Stats_Var_Samp_Fields>;
  variance?: Maybe<Pt_Street_Stats_Variance_Fields>;
};


/** aggregate fields of "street_stats" */
export type Pt_Street_Stats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "street_stats" */
export type Pt_Street_Stats_Aggregate_Order_By = {
  avg?: InputMaybe<Pt_Street_Stats_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Pt_Street_Stats_Max_Order_By>;
  min?: InputMaybe<Pt_Street_Stats_Min_Order_By>;
  stddev?: InputMaybe<Pt_Street_Stats_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Pt_Street_Stats_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Pt_Street_Stats_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Pt_Street_Stats_Sum_Order_By>;
  var_pop?: InputMaybe<Pt_Street_Stats_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Pt_Street_Stats_Var_Samp_Order_By>;
  variance?: InputMaybe<Pt_Street_Stats_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Pt_Street_Stats_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "street_stats" */
export type Pt_Street_Stats_Avg_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "street_stats". All fields are combined with a logical 'AND'. */
export type Pt_Street_Stats_Bool_Exp = {
  _and?: InputMaybe<Array<Pt_Street_Stats_Bool_Exp>>;
  _not?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
  _or?: InputMaybe<Array<Pt_Street_Stats_Bool_Exp>>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  is_cross_locality?: InputMaybe<Boolean_Comparison_Exp>;
  lat?: InputMaybe<Numeric_Comparison_Exp>;
  lng?: InputMaybe<Numeric_Comparison_Exp>;
  locality?: InputMaybe<Pt_Places_Bool_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  lower_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  mean_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  median_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
  municipality?: InputMaybe<Pt_Places_Bool_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  num_street_numbers?: InputMaybe<Int_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_count?: InputMaybe<Int_Comparison_Exp>;
  upper_15_percentile_price_per_m2?: InputMaybe<Numeric_Comparison_Exp>;
};

/** aggregate max on columns */
export type Pt_Street_Stats_Max_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "street_stats" */
export type Pt_Street_Stats_Max_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Pt_Street_Stats_Min_Fields = {
  google_place_id?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "street_stats" */
export type Pt_Street_Stats_Min_Order_By = {
  google_place_id?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "street_stats". */
export type Pt_Street_Stats_Order_By = {
  geom?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  is_cross_locality?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Pt_Places_Order_By>;
  locality_id?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  municipality?: InputMaybe<Pt_Places_Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** select columns of table "street_stats" */
export enum Pt_Street_Stats_Select_Column {
  /** column name */
  Geom = 'geom',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  IsCrossLocality = 'is_cross_locality',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  Lower_15PercentilePricePerM2 = 'lower_15_percentile_price_per_m2',
  /** column name */
  MeanPricePerM2 = 'mean_price_per_m2',
  /** column name */
  MedianPricePerM2 = 'median_price_per_m2',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  NumStreetNumbers = 'num_street_numbers',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  StateId = 'state_id',
  /** column name */
  TotalCount = 'total_count',
  /** column name */
  Upper_15PercentilePricePerM2 = 'upper_15_percentile_price_per_m2'
}

/** aggregate stddev on columns */
export type Pt_Street_Stats_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "street_stats" */
export type Pt_Street_Stats_Stddev_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Pt_Street_Stats_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "street_stats" */
export type Pt_Street_Stats_Stddev_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Pt_Street_Stats_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "street_stats" */
export type Pt_Street_Stats_Stddev_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Pt_Street_Stats_Sum_Fields = {
  lat?: Maybe<Scalars['numeric']['output']>;
  lng?: Maybe<Scalars['numeric']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  mean_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  median_price_per_m2?: Maybe<Scalars['numeric']['output']>;
  num_street_numbers?: Maybe<Scalars['Int']['output']>;
  total_count?: Maybe<Scalars['Int']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "street_stats" */
export type Pt_Street_Stats_Sum_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Pt_Street_Stats_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "street_stats" */
export type Pt_Street_Stats_Var_Pop_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Pt_Street_Stats_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "street_stats" */
export type Pt_Street_Stats_Var_Samp_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Pt_Street_Stats_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lower_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
  mean_price_per_m2?: Maybe<Scalars['Float']['output']>;
  median_price_per_m2?: Maybe<Scalars['Float']['output']>;
  num_street_numbers?: Maybe<Scalars['Float']['output']>;
  total_count?: Maybe<Scalars['Float']['output']>;
  upper_15_percentile_price_per_m2?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "street_stats" */
export type Pt_Street_Stats_Variance_Order_By = {
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  lower_15_percentile_price_per_m2?: InputMaybe<Order_By>;
  mean_price_per_m2?: InputMaybe<Order_By>;
  median_price_per_m2?: InputMaybe<Order_By>;
  num_street_numbers?: InputMaybe<Order_By>;
  total_count?: InputMaybe<Order_By>;
  upper_15_percentile_price_per_m2?: InputMaybe<Order_By>;
};

/** columns and relationships of "push_notification_tokens" */
export type Push_Notification_Tokens = {
  app_id: Scalars['String']['output'];
  app_version?: Maybe<Scalars['String']['output']>;
  capabilities: Array<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  platform?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "push_notification_tokens" */
export type Push_Notification_Tokens_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Push_Notification_Tokens_Max_Order_By>;
  min?: InputMaybe<Push_Notification_Tokens_Min_Order_By>;
};

/** input type for inserting array relation for remote table "push_notification_tokens" */
export type Push_Notification_Tokens_Arr_Rel_Insert_Input = {
  data: Array<Push_Notification_Tokens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Push_Notification_Tokens_On_Conflict>;
};

/** Boolean expression to filter rows from the table "push_notification_tokens". All fields are combined with a logical 'AND'. */
export type Push_Notification_Tokens_Bool_Exp = {
  _and?: InputMaybe<Array<Push_Notification_Tokens_Bool_Exp>>;
  _not?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
  _or?: InputMaybe<Array<Push_Notification_Tokens_Bool_Exp>>;
  app_id?: InputMaybe<String_Comparison_Exp>;
  app_version?: InputMaybe<String_Comparison_Exp>;
  capabilities?: InputMaybe<String_Array_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  platform?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "push_notification_tokens" */
export enum Push_Notification_Tokens_Constraint {
  /** unique or primary key constraint on columns "app_id", "token" */
  PushNotificationTokensAppIdTokenPlatformKey = 'push_notification_tokens_app_id_token_platform_key',
  /** unique or primary key constraint on columns "id" */
  PushNotificationTokensPkey = 'push_notification_tokens_pkey'
}

/** input type for inserting data into table "push_notification_tokens" */
export type Push_Notification_Tokens_Insert_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  platform?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "push_notification_tokens" */
export type Push_Notification_Tokens_Max_Order_By = {
  app_id?: InputMaybe<Order_By>;
  app_version?: InputMaybe<Order_By>;
  capabilities?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "push_notification_tokens" */
export type Push_Notification_Tokens_Min_Order_By = {
  app_id?: InputMaybe<Order_By>;
  app_version?: InputMaybe<Order_By>;
  capabilities?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "push_notification_tokens" */
export type Push_Notification_Tokens_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Push_Notification_Tokens>;
};

/** on_conflict condition type for table "push_notification_tokens" */
export type Push_Notification_Tokens_On_Conflict = {
  constraint: Push_Notification_Tokens_Constraint;
  update_columns?: Array<Push_Notification_Tokens_Update_Column>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};

/** Ordering options when selecting data from "push_notification_tokens". */
export type Push_Notification_Tokens_Order_By = {
  app_id?: InputMaybe<Order_By>;
  app_version?: InputMaybe<Order_By>;
  capabilities?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  platform?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: push_notification_tokens */
export type Push_Notification_Tokens_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "push_notification_tokens" */
export enum Push_Notification_Tokens_Select_Column {
  /** column name */
  AppId = 'app_id',
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  Capabilities = 'capabilities',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Platform = 'platform',
  /** column name */
  Token = 'token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "push_notification_tokens" */
export type Push_Notification_Tokens_Set_Input = {
  app_version?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Streaming cursor of the table "push_notification_tokens" */
export type Push_Notification_Tokens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Push_Notification_Tokens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Push_Notification_Tokens_Stream_Cursor_Value_Input = {
  app_id?: InputMaybe<Scalars['String']['input']>;
  app_version?: InputMaybe<Scalars['String']['input']>;
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "push_notification_tokens" */
export enum Push_Notification_Tokens_Update_Column {
  /** column name */
  AppVersion = 'app_version',
  /** column name */
  Capabilities = 'capabilities'
}

export type Push_Notification_Tokens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Push_Notification_Tokens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Push_Notification_Tokens_Bool_Exp;
};

export type Query_Root = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  /** fetch data from the table: "activities" using primary key columns */
  activities_by_pk?: Maybe<Activities>;
  /** fetch data from the table: "activity_feed" */
  activity_feed: Array<Activity_Feed>;
  /** fetch aggregated fields from the table: "activity_feed" */
  activity_feed_aggregate: Activity_Feed_Aggregate;
  /** fetch data from the table: "activity_feed" using primary key columns */
  activity_feed_by_pk?: Maybe<Activity_Feed>;
  /** fetch data from the table: "activity_feed_quarantine" */
  activity_feed_quarantine: Array<Activity_Feed_Quarantine>;
  /** fetch data from the table: "activity_feed_status" */
  activity_feed_status: Array<Activity_Feed_Status>;
  /** fetch data from the table: "address_display_options_enum" */
  address_display_options_enum: Array<Address_Display_Options_Enum>;
  /** fetch data from the table: "address_display_options_enum" using primary key columns */
  address_display_options_enum_by_pk?: Maybe<Address_Display_Options_Enum>;
  /** fetch data from the table: "agencies" */
  agencies: Array<Agencies>;
  /** execute function "agent_statistics" which returns "agent_stats" */
  agent_statistics: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" */
  agent_stats: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" using primary key columns */
  agent_stats_by_pk?: Maybe<Agent_Stats>;
  /** fetch data from the table: "agents" */
  agents: Array<Agents>;
  /** fetch data from the table: "api_keys" */
  api_keys: Array<Api_Keys>;
  /** fetch aggregated fields from the table: "api_keys" */
  api_keys_aggregate: Api_Keys_Aggregate;
  /** fetch data from the table: "api_keys" using primary key columns */
  api_keys_by_pk?: Maybe<Api_Keys>;
  /** An array relationship */
  api_keys_teams: Array<Api_Keys_Teams>;
  /** fetch data from the table: "api_keys_teams" using primary key columns */
  api_keys_teams_by_pk?: Maybe<Api_Keys_Teams>;
  /** An array relationship */
  appraisals: Array<Appraisals>;
  /** fetch data from the table: "appraisals" using primary key columns */
  appraisals_by_pk?: Maybe<Appraisals>;
  auto_assign_ranking?: Maybe<AutoAssignRankingEu>;
  /** Get agents eligible for a lead and rank them */
  auto_assign_ranking_ch?: Maybe<AutoAssignRankingCh>;
  /** fetch data from the table: "available_email_templates" */
  available_email_templates: Array<Available_Email_Templates>;
  /** fetch data from the table: "bed_type_enum" */
  bed_type_enum: Array<Bed_Type_Enum>;
  /** fetch data from the table: "bed_type_enum" using primary key columns */
  bed_type_enum_by_pk?: Maybe<Bed_Type_Enum>;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  /** fetch data from the table: "buyer_leads" using primary key columns */
  buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  /** fetch data from the table: "catchment_areas" using primary key columns */
  catchment_areas_by_pk?: Maybe<Catchment_Areas>;
  /** fetch data from the table: "buildings" */
  ch_buildings: Array<Ch_Buildings>;
  /** fetch data from the table: "buildings" using primary key columns */
  ch_buildings_by_pk?: Maybe<Ch_Buildings>;
  /** fetch data from the table: "cma_listings" */
  ch_cma_listings: Array<Ch_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  ch_cma_listings_aggregate: Ch_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  ch_cma_listings_by_pk?: Maybe<Ch_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  ch_cma_listings_distance: Array<Ch_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  ch_cma_listings_distance_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  ch_cma_listings_distance_by_pk?: Maybe<Ch_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  ch_cma_rental_listings: Array<Ch_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  ch_cma_rental_listings_aggregate: Ch_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  ch_cma_rental_listings_by_pk?: Maybe<Ch_Cma_Rental_Listings>;
  /** fetch data from the table: "external_transactions" */
  ch_external_transactions: Array<Ch_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  ch_external_transactions_aggregate: Ch_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  ch_external_transactions_distance: Array<Ch_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  ch_external_transactions_distance_aggregate: Ch_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  ch_external_transactions_distance_by_pk?: Maybe<Ch_External_Transactions_Distance>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  ch_get_buy_rent_listings: Array<Ch_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  ch_get_buy_rent_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  ch_get_cma_listings_by_radius: Array<Ch_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  ch_get_cma_listings_by_radius_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  ch_get_cma_listings_distance: Array<Ch_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  ch_get_cma_listings_distance_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  ch_get_external_transactions_distance: Array<Ch_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  ch_get_external_transactions_distance_aggregate: Ch_External_Transactions_Distance_Aggregate;
  /** execute function "get_house_appt_price_stats" which returns "price_stats" */
  ch_get_house_appt_price_stats: Array<Ch_Price_Stats>;
  /** execute function "get_house_appt_price_stats" and query aggregates on result of table type "price_stats" */
  ch_get_house_appt_price_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  ch_get_listings_stats?: Maybe<Ch_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  ch_get_listings_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_listings_stats_by_place_slug" which returns "price_stats" */
  ch_get_listings_stats_by_place_slug: Array<Ch_Price_Stats>;
  /** execute function "get_listings_stats_by_place_slug" and query aggregates on result of table type "price_stats" */
  ch_get_listings_stats_by_place_slug_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_map_place_stats" which returns "price_stats" */
  ch_get_map_place_stats: Array<Ch_Price_Stats>;
  /** execute function "get_map_place_stats" and query aggregates on result of table type "price_stats" */
  ch_get_map_place_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  ch_get_merged_listings: Array<Ch_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  ch_get_merged_listings_type: Array<Ch_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  ch_get_place_by_slug?: Maybe<Ch_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  ch_get_place_by_slug_aggregate: Ch_Places_Aggregate;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  ch_get_rental_cma_listings_distance: Array<Ch_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  ch_get_rental_cma_listings_distance_aggregate: Ch_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  ch_get_similar_listings: Array<Ch_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  ch_get_similar_listings_aggregate: Ch_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  ch_get_similar_listings_cohorts: Array<Ch_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  ch_get_similar_listings_cohorts_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  ch_get_similar_listings_vector: Array<Ch_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  ch_get_similar_listings_vector_aggregate: Ch_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  ch_get_similar_rental_listings_cohorts: Array<Ch_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  ch_get_similar_rental_listings_cohorts_aggregate: Ch_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  ch_merged_images: Array<Ch_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  ch_merged_images_aggregate: Ch_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  ch_merged_listings: Array<Ch_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  ch_merged_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  ch_merged_listings_by_pk?: Maybe<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  ch_merged_listings_compare: Array<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  ch_merged_listings_compare_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  ch_places: Array<Ch_Places>;
  /** fetch aggregated fields from the table: "places" */
  ch_places_aggregate: Ch_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs: Array<Ch_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs_aggregate: Ch_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  ch_places_by_pk?: Maybe<Ch_Places>;
  /** fetch data from the table: "plots" */
  ch_plots: Array<Ch_Plots>;
  /** fetch data from the table: "plots" using primary key columns */
  ch_plots_by_pk?: Maybe<Ch_Plots>;
  /** fetch data from the table: "post_merged_listings" */
  ch_post_merged_listings: Array<Ch_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  ch_post_merged_listings_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  ch_post_merged_listings_by_pk?: Maybe<Ch_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  ch_price_stats: Array<Ch_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  ch_price_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  ch_price_stats_historical: Array<Ch_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  ch_price_stats_historical_aggregate: Ch_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  ch_price_stats_historical_by_pk?: Maybe<Ch_Price_Stats_Historical>;
  /** fetch data from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles: Array<Ch_Price_Stats_Quantiles>;
  /** fetch aggregated fields from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles_aggregate: Ch_Price_Stats_Quantiles_Aggregate;
  /** fetch data from the table: "price_stats_quantiles" using primary key columns */
  ch_price_stats_quantiles_by_pk?: Maybe<Ch_Price_Stats_Quantiles>;
  /** fetch data from the table: "property_types" */
  ch_property_types: Array<Ch_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  ch_rental_cma_listings_distance: Array<Ch_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  ch_rental_cma_listings_distance_aggregate: Ch_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places" which returns "places" */
  ch_search_places: Array<Ch_Places>;
  /** execute function "search_places" and query aggregates on result of table type "places" */
  ch_search_places_aggregate: Ch_Places_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  ch_search_places_with_index: Array<Ch_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  ch_search_places_with_index_aggregate: Ch_Places_Aggregate;
  /** fetch data from the table: "states" */
  ch_states: Array<Ch_States>;
  /** fetch data from the table: "street_stats" */
  ch_street_stats: Array<Ch_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  ch_street_stats_aggregate: Ch_Street_Stats_Aggregate;
  /** fetch data from the table: "Chat" */
  chat_api_chat: Array<Chat_Api_Chat>;
  /** fetch aggregated fields from the table: "Chat" */
  chat_api_chat_aggregate: Chat_Api_Chat_Aggregate;
  /** fetch data from the table: "Chat" using primary key columns */
  chat_api_chat_by_pk?: Maybe<Chat_Api_Chat>;
  /** fetch data from the table: "chat_model_setting" */
  chat_api_chat_model_setting: Array<Chat_Api_Chat_Model_Setting>;
  /** fetch aggregated fields from the table: "chat_model_setting" */
  chat_api_chat_model_setting_aggregate: Chat_Api_Chat_Model_Setting_Aggregate;
  /** fetch data from the table: "chat_model_setting" using primary key columns */
  chat_api_chat_model_setting_by_pk?: Maybe<Chat_Api_Chat_Model_Setting>;
  /** fetch data from the table: "conversation_message" */
  chat_api_conversation_message: Array<Chat_Api_Conversation_Message>;
  /** fetch aggregated fields from the table: "conversation_message" */
  chat_api_conversation_message_aggregate: Chat_Api_Conversation_Message_Aggregate;
  /** fetch data from the table: "conversation_message" using primary key columns */
  chat_api_conversation_message_by_pk?: Maybe<Chat_Api_Conversation_Message>;
  /** fetch data from the table: "conversation_part" */
  chat_api_conversation_part: Array<Chat_Api_Conversation_Part>;
  /** fetch aggregated fields from the table: "conversation_part" */
  chat_api_conversation_part_aggregate: Chat_Api_Conversation_Part_Aggregate;
  /** fetch data from the table: "conversation_part" using primary key columns */
  chat_api_conversation_part_by_pk?: Maybe<Chat_Api_Conversation_Part>;
  /** fetch data from the table: "conversation_tool_call" */
  chat_api_conversation_tool_call: Array<Chat_Api_Conversation_Tool_Call>;
  /** fetch aggregated fields from the table: "conversation_tool_call" */
  chat_api_conversation_tool_call_aggregate: Chat_Api_Conversation_Tool_Call_Aggregate;
  /** fetch data from the table: "conversation_tool_call" using primary key columns */
  chat_api_conversation_tool_call_by_pk?: Maybe<Chat_Api_Conversation_Tool_Call>;
  /** fetch data from the table: "conversation_trace" */
  chat_api_conversation_trace: Array<Chat_Api_Conversation_Trace>;
  /** fetch aggregated fields from the table: "conversation_trace" */
  chat_api_conversation_trace_aggregate: Chat_Api_Conversation_Trace_Aggregate;
  /** fetch data from the table: "conversation_trace" using primary key columns */
  chat_api_conversation_trace_by_pk?: Maybe<Chat_Api_Conversation_Trace>;
  /** fetch data from the table: "Message_v2" */
  chat_api_message: Array<Chat_Api_Message>;
  /** fetch aggregated fields from the table: "Message_v2" */
  chat_api_message_aggregate: Chat_Api_Message_Aggregate;
  /** fetch data from the table: "Message_v2" using primary key columns */
  chat_api_message_by_pk?: Maybe<Chat_Api_Message>;
  /** fetch data from the table: "model_pricing" */
  chat_api_model_pricing: Array<Chat_Api_Model_Pricing>;
  /** fetch aggregated fields from the table: "model_pricing" */
  chat_api_model_pricing_aggregate: Chat_Api_Model_Pricing_Aggregate;
  /** fetch data from the table: "model_pricing" using primary key columns */
  chat_api_model_pricing_by_pk?: Maybe<Chat_Api_Model_Pricing>;
  /** fetch data from the table: "MutationAudit" */
  chat_api_mutation_audit: Array<Chat_Api_Mutation_Audit>;
  /** fetch aggregated fields from the table: "MutationAudit" */
  chat_api_mutation_audit_aggregate: Chat_Api_Mutation_Audit_Aggregate;
  /** fetch data from the table: "MutationAudit" using primary key columns */
  chat_api_mutation_audit_by_pk?: Maybe<Chat_Api_Mutation_Audit>;
  check_portal_connection?: Maybe<CheckPortalConnectionOutput>;
  /** An array relationship */
  cma_report_files: Array<Cma_Report_Files>;
  /** An aggregate relationship */
  cma_report_files_aggregate: Cma_Report_Files_Aggregate;
  /** fetch data from the table: "cma_report_files" using primary key columns */
  cma_report_files_by_pk?: Maybe<Cma_Report_Files>;
  /** fetch data from the table: "cma_report_source_enum" */
  cma_report_source_enum: Array<Cma_Report_Source_Enum>;
  /** fetch data from the table: "cma_report_source_enum" using primary key columns */
  cma_report_source_enum_by_pk?: Maybe<Cma_Report_Source_Enum>;
  /** An array relationship */
  cma_reports: Array<Cma_Reports>;
  /** An array relationship */
  cma_reports_agent_transactions: Array<Cma_Reports_Agent_Transactions>;
  /** fetch data from the table: "cma_reports_agent_transactions" using primary key columns */
  cma_reports_agent_transactions_by_pk?: Maybe<Cma_Reports_Agent_Transactions>;
  /** An aggregate relationship */
  cma_reports_aggregate: Cma_Reports_Aggregate;
  /** fetch data from the table: "cma_reports" using primary key columns */
  cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** fetch data from the table: "cma_reports_comparables" */
  cma_reports_comparables: Array<Cma_Reports_Comparables>;
  /** fetch data from the table: "cma_reports_comparables" using primary key columns */
  cma_reports_comparables_by_pk?: Maybe<Cma_Reports_Comparables>;
  /** fetch data from the table: "cma_reports_property_transactions" */
  cma_reports_property_transactions: Array<Cma_Reports_Property_Transactions>;
  /** fetch data from the table: "cma_reports_property_transactions" using primary key columns */
  cma_reports_property_transactions_by_pk?: Maybe<Cma_Reports_Property_Transactions>;
  /** fetch data from the table: "cma_reports_user_reviews" */
  cma_reports_user_reviews: Array<Cma_Reports_User_Reviews>;
  /** fetch data from the table: "cma_reports_user_reviews" using primary key columns */
  cma_reports_user_reviews_by_pk?: Maybe<Cma_Reports_User_Reviews>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  /** fetch data from the table: "cooling_enum" */
  cooling_enum: Array<Cooling_Enum>;
  /** fetch data from the table: "cooling_enum" using primary key columns */
  cooling_enum_by_pk?: Maybe<Cooling_Enum>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** Read-only self-scoped read: when did the current session user last answer the CSAT survey (PostHog is source of truth)? The recurrence rule lives in the client. Also returns the survey metadata to build a native `survey sent` event. */
  crm_csat_status?: Maybe<CrmCsatStatusOutput>;
  /** An array relationship */
  development_files: Array<Development_Files>;
  /** An aggregate relationship */
  development_files_aggregate: Development_Files_Aggregate;
  /** fetch data from the table: "development_files" using primary key columns */
  development_files_by_pk?: Maybe<Development_Files>;
  /** An array relationship */
  development_images: Array<Development_Images>;
  /** An aggregate relationship */
  development_images_aggregate: Development_Images_Aggregate;
  /** fetch data from the table: "development_images" using primary key columns */
  development_images_by_pk?: Maybe<Development_Images>;
  /** An array relationship */
  development_mappings: Array<Development_Mappings>;
  /** fetch data from the table: "development_mappings" using primary key columns */
  development_mappings_by_pk?: Maybe<Development_Mappings>;
  /** fetch data from the table: "development_status_enum" */
  development_status_enum: Array<Development_Status_Enum>;
  /** fetch data from the table: "development_status_enum" using primary key columns */
  development_status_enum_by_pk?: Maybe<Development_Status_Enum>;
  /** An array relationship */
  developments: Array<Developments>;
  /** An aggregate relationship */
  developments_aggregate: Developments_Aggregate;
  /** fetch data from the table: "developments" using primary key columns */
  developments_by_pk?: Maybe<Developments>;
  /** fetch data from the table: "dictionaries" */
  dictionaries: Array<Dictionaries>;
  /** fetch aggregated fields from the table: "dictionaries" */
  dictionaries_aggregate: Dictionaries_Aggregate;
  /** fetch data from the table: "dictionaries" using primary key columns */
  dictionaries_by_pk?: Maybe<Dictionaries>;
  /** fetch data from the table: "dictionaries_types_enum" */
  dictionaries_types_enum: Array<Dictionaries_Types_Enum>;
  /** fetch data from the table: "dictionaries_types_enum" using primary key columns */
  dictionaries_types_enum_by_pk?: Maybe<Dictionaries_Types_Enum>;
  /** fetch data from the table: "doc_template_themes" */
  doc_template_themes: Array<Doc_Template_Themes>;
  /** fetch data from the table: "doc_template_themes" using primary key columns */
  doc_template_themes_by_pk?: Maybe<Doc_Template_Themes>;
  /** fetch data from the table: "doc_template_type_enum" */
  doc_template_type_enum: Array<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_template_type_enum" using primary key columns */
  doc_template_type_enum_by_pk?: Maybe<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_template_versions" */
  doc_template_versions: Array<Doc_Template_Versions>;
  /** fetch data from the table: "doc_template_versions" using primary key columns */
  doc_template_versions_by_pk?: Maybe<Doc_Template_Versions>;
  /** fetch data from the table: "doc_templates" */
  doc_templates: Array<Doc_Templates>;
  /** fetch data from the table: "doc_templates" using primary key columns */
  doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** An array relationship */
  doc_templates_tenants: Array<Doc_Templates_Tenants>;
  /** fetch data from the table: "doc_templates_tenants" using primary key columns */
  doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** Whether a tracked document was shared with a buyer + its open stats */
  document_recipient_status?: Maybe<DocumentRecipientStatusOutput>;
  /** Buyers a tracked document (brochure, ...) has been shared with */
  document_recipients?: Maybe<DocumentRecipientsOutput>;
  /** Open-tracking stats for a docs document (brochure, CMA, report, ...) */
  document_stats?: Maybe<DocumentStatsOutput>;
  /** fetch data from the table: "email_campaigns" */
  email_campaigns: Array<Email_Campaigns>;
  /** fetch aggregated fields from the table: "email_campaigns" */
  email_campaigns_aggregate: Email_Campaigns_Aggregate;
  /** fetch data from the table: "email_campaigns" using primary key columns */
  email_campaigns_by_pk?: Maybe<Email_Campaigns>;
  /** An aggregate relationship */
  email_messages_aggregate: Email_Messages_Aggregate;
  /** fetch data from the table: "email_sequences" */
  email_sequences: Array<Email_Sequences>;
  /** fetch data from the table: "email_sequences" using primary key columns */
  email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** An array relationship */
  email_sequences_recipients: Array<Email_Sequences_Recipients>;
  /** An aggregate relationship */
  email_sequences_recipients_aggregate: Email_Sequences_Recipients_Aggregate;
  /** fetch data from the table: "email_sequences_recipients" using primary key columns */
  email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** An array relationship */
  email_sequences_steps: Array<Email_Sequences_Steps>;
  /** An aggregate relationship */
  email_sequences_steps_aggregate: Email_Sequences_Steps_Aggregate;
  /** fetch data from the table: "email_sequences_steps" using primary key columns */
  email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>;
  /** fetch data from the table: "email_threads" */
  email_threads: Array<Email_Threads>;
  /** fetch data from the table: "email_threads" using primary key columns */
  email_threads_by_pk?: Maybe<Email_Threads>;
  /** An array relationship */
  emails: Array<Emails>;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  /** fetch data from the table: "enquiries" using primary key columns */
  enquiries_by_pk?: Maybe<Enquiries>;
  /** fetch data from the table: "enquiries_source_enum" */
  enquiries_source_enum: Array<Enquiries_Source_Enum>;
  /** fetch data from the table: "enquiries_source_enum" using primary key columns */
  enquiries_source_enum_by_pk?: Maybe<Enquiries_Source_Enum>;
  /** fetch data from the table: "cma_listings" */
  es_cma_listings: Array<Es_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  es_cma_listings_aggregate: Es_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  es_cma_listings_by_pk?: Maybe<Es_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  es_cma_listings_distance: Array<Es_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  es_cma_listings_distance_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  es_cma_listings_distance_by_pk?: Maybe<Es_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  es_cma_rental_listings: Array<Es_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  es_cma_rental_listings_aggregate: Es_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  es_cma_rental_listings_by_pk?: Maybe<Es_Cma_Rental_Listings>;
  /** fetch data from the table: "external_transactions" */
  es_external_transactions: Array<Es_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  es_external_transactions_aggregate: Es_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  es_external_transactions_distance: Array<Es_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  es_external_transactions_distance_aggregate: Es_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  es_external_transactions_distance_by_pk?: Maybe<Es_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  es_get_cma_listings_by_radius: Array<Es_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  es_get_cma_listings_by_radius_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  es_get_cma_listings_distance: Array<Es_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  es_get_cma_listings_distance_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  es_get_external_transactions_distance: Array<Es_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  es_get_external_transactions_distance_aggregate: Es_External_Transactions_Distance_Aggregate;
  /** execute function "get_house_appt_price_stats" which returns "price_stats" */
  es_get_house_appt_price_stats: Array<Es_Price_Stats>;
  /** execute function "get_house_appt_price_stats" and query aggregates on result of table type "price_stats" */
  es_get_house_appt_price_stats_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  es_get_listings_stats?: Maybe<Es_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  es_get_listings_stats_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_listings_stats_by_place_slug" which returns "price_stats" */
  es_get_listings_stats_by_place_slug: Array<Es_Price_Stats>;
  /** execute function "get_listings_stats_by_place_slug" and query aggregates on result of table type "price_stats" */
  es_get_listings_stats_by_place_slug_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_map_place_stats" which returns "price_stats" */
  es_get_map_place_stats: Array<Es_Price_Stats>;
  /** execute function "get_map_place_stats" and query aggregates on result of table type "price_stats" */
  es_get_map_place_stats_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  es_get_merged_listings: Array<Es_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  es_get_merged_listings_type: Array<Es_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  es_get_place_by_slug?: Maybe<Es_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  es_get_place_by_slug_aggregate: Es_Places_Aggregate;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  es_get_rental_cma_listings_distance: Array<Es_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  es_get_rental_cma_listings_distance_aggregate: Es_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  es_get_similar_listings: Array<Es_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  es_get_similar_listings_aggregate: Es_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  es_get_similar_listings_cohorts: Array<Es_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  es_get_similar_listings_cohorts_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  es_get_similar_listings_vector: Array<Es_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  es_get_similar_listings_vector_aggregate: Es_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  es_get_similar_rental_listings_cohorts: Array<Es_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  es_get_similar_rental_listings_cohorts_aggregate: Es_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  es_merged_images: Array<Es_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  es_merged_images_aggregate: Es_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  es_merged_listings: Array<Es_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  es_merged_listings_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  es_merged_listings_by_pk?: Maybe<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  es_merged_listings_compare: Array<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  es_merged_listings_compare_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  es_places: Array<Es_Places>;
  /** fetch aggregated fields from the table: "places" */
  es_places_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  es_places_breadcrumbs: Array<Es_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  es_places_breadcrumbs_aggregate: Es_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  es_places_by_pk?: Maybe<Es_Places>;
  /** fetch data from the table: "plots" */
  es_plots: Array<Es_Plots>;
  /** fetch data from the table: "plots" using primary key columns */
  es_plots_by_pk?: Maybe<Es_Plots>;
  /** fetch data from the table: "post_merged_listings" */
  es_post_merged_listings: Array<Es_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  es_post_merged_listings_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  es_post_merged_listings_by_pk?: Maybe<Es_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  es_price_stats: Array<Es_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  es_price_stats_aggregate: Es_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  es_price_stats_historical: Array<Es_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  es_price_stats_historical_aggregate: Es_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  es_price_stats_historical_by_pk?: Maybe<Es_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  es_property_types: Array<Es_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  es_rental_cma_listings_distance: Array<Es_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  es_rental_cma_listings_distance_aggregate: Es_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  es_search_places_with_index: Array<Es_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  es_search_places_with_index_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "states" */
  es_states: Array<Es_States>;
  /** fetch data from the table: "street_stats" */
  es_street_stats: Array<Es_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  es_street_stats_aggregate: Es_Street_Stats_Aggregate;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** execute function "find_cma_leads_by_address" which returns "leads" */
  find_cma_leads_by_address: Array<Leads>;
  /** execute function "find_cma_leads_by_address" and query aggregates on result of table type "leads" */
  find_cma_leads_by_address_aggregate: Leads_Aggregate;
  find_onboarding_social_links: FindOnboardingSocialLinksOutput;
  /** execute function "find_price_map_places" which returns "places" */
  find_price_map_places: Array<Places>;
  /** execute function "find_price_map_places" and query aggregates on result of table type "places" */
  find_price_map_places_aggregate: Places_Aggregate;
  /** fetch data from the table: "cma_listings" */
  fr_cma_listings: Array<Fr_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  fr_cma_listings_aggregate: Fr_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  fr_cma_listings_by_pk?: Maybe<Fr_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  fr_cma_listings_distance: Array<Fr_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  fr_cma_listings_distance_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  fr_cma_listings_distance_by_pk?: Maybe<Fr_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  fr_cma_rental_listings: Array<Fr_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  fr_cma_rental_listings_aggregate: Fr_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  fr_cma_rental_listings_by_pk?: Maybe<Fr_Cma_Rental_Listings>;
  /** fetch data from the table: "energy_certificates" */
  fr_energy_certificates: Array<Fr_Energy_Certificates>;
  /** fetch data from the table: "energy_certificates" using primary key columns */
  fr_energy_certificates_by_pk?: Maybe<Fr_Energy_Certificates>;
  /** fetch data from the table: "external_transactions" */
  fr_external_transactions: Array<Fr_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  fr_external_transactions_aggregate: Fr_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  fr_external_transactions_distance: Array<Fr_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  fr_external_transactions_distance_aggregate: Fr_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  fr_external_transactions_distance_by_pk?: Maybe<Fr_External_Transactions_Distance>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  fr_get_buy_rent_listings: Array<Fr_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  fr_get_buy_rent_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  fr_get_cma_listings_by_radius: Array<Fr_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  fr_get_cma_listings_by_radius_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  fr_get_cma_listings_distance: Array<Fr_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  fr_get_cma_listings_distance_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  fr_get_external_transactions_distance: Array<Fr_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  fr_get_external_transactions_distance_aggregate: Fr_External_Transactions_Distance_Aggregate;
  /** execute function "get_house_appt_price_stats" which returns "price_stats" */
  fr_get_house_appt_price_stats: Array<Fr_Price_Stats>;
  /** execute function "get_house_appt_price_stats" and query aggregates on result of table type "price_stats" */
  fr_get_house_appt_price_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  fr_get_listings_stats?: Maybe<Fr_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  fr_get_listings_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_listings_stats_by_place_slug" which returns "price_stats" */
  fr_get_listings_stats_by_place_slug: Array<Fr_Price_Stats>;
  /** execute function "get_listings_stats_by_place_slug" and query aggregates on result of table type "price_stats" */
  fr_get_listings_stats_by_place_slug_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_map_place_stats" which returns "price_stats" */
  fr_get_map_place_stats: Array<Fr_Price_Stats>;
  /** execute function "get_map_place_stats" and query aggregates on result of table type "price_stats" */
  fr_get_map_place_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  fr_get_merged_listings: Array<Fr_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  fr_get_merged_listings_type: Array<Fr_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  fr_get_place_by_slug?: Maybe<Fr_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  fr_get_place_by_slug_aggregate: Fr_Places_Aggregate;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  fr_get_rental_cma_listings_distance: Array<Fr_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  fr_get_rental_cma_listings_distance_aggregate: Fr_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  fr_get_similar_listings: Array<Fr_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  fr_get_similar_listings_aggregate: Fr_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  fr_get_similar_listings_cohorts: Array<Fr_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  fr_get_similar_listings_cohorts_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  fr_get_similar_listings_vector: Array<Fr_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  fr_get_similar_listings_vector_aggregate: Fr_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  fr_get_similar_rental_listings_cohorts: Array<Fr_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  fr_get_similar_rental_listings_cohorts_aggregate: Fr_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  fr_merged_images: Array<Fr_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  fr_merged_images_aggregate: Fr_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  fr_merged_listings: Array<Fr_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  fr_merged_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  fr_merged_listings_by_pk?: Maybe<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  fr_merged_listings_compare: Array<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  fr_merged_listings_compare_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  fr_places: Array<Fr_Places>;
  /** fetch aggregated fields from the table: "places" */
  fr_places_aggregate: Fr_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs: Array<Fr_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs_aggregate: Fr_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  fr_places_by_pk?: Maybe<Fr_Places>;
  /** fetch data from the table: "plots" */
  fr_plots: Array<Fr_Plots>;
  /** fetch data from the table: "plots" using primary key columns */
  fr_plots_by_pk?: Maybe<Fr_Plots>;
  /** fetch data from the table: "post_merged_listings" */
  fr_post_merged_listings: Array<Fr_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  fr_post_merged_listings_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  fr_post_merged_listings_by_pk?: Maybe<Fr_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  fr_price_stats: Array<Fr_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  fr_price_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  fr_price_stats_historical: Array<Fr_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  fr_price_stats_historical_aggregate: Fr_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  fr_price_stats_historical_by_pk?: Maybe<Fr_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  fr_property_types: Array<Fr_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  fr_rental_cma_listings_distance: Array<Fr_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  fr_rental_cma_listings_distance_aggregate: Fr_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  fr_search_places_with_index: Array<Fr_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  fr_search_places_with_index_aggregate: Fr_Places_Aggregate;
  /** fetch data from the table: "states" */
  fr_states: Array<Fr_States>;
  /** fetch data from the table: "street_stats" */
  fr_street_stats: Array<Fr_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  fr_street_stats_aggregate: Fr_Street_Stats_Aggregate;
  /** execute function "fsbo_seller_cluster" which returns "fsbo_seller_cluster_result" */
  fsbo_seller_cluster: Array<Fsbo_Seller_Cluster_Result>;
  /** fetch data from the table: "fsbo_seller_cluster_result" */
  fsbo_seller_cluster_result: Array<Fsbo_Seller_Cluster_Result>;
  /** fetch data from the table: "fsbo_seller_cluster_result" using primary key columns */
  fsbo_seller_cluster_result_by_pk?: Maybe<Fsbo_Seller_Cluster_Result>;
  /** generate-agency-description */
  generate_agency_description?: Maybe<GenerateAgencyDescription>;
  /** generate-cma-description */
  generate_cma_description?: Maybe<GenerateCmaDescription>;
  /** generate-development-image-metadata */
  generate_development_image_metadata?: Maybe<GenerateImageMetadata>;
  /** generate-image-metadata */
  generate_image_metadata?: Maybe<GenerateImageMetadata>;
  /** generate-listing-title */
  generate_listing_title?: Maybe<GenerateListingTitle>;
  /** generate-listing-description */
  generate_listings_description?: Maybe<GenerateListingDescription>;
  /** geocode_address */
  geocode_address?: Maybe<GeocodeAddressOutput>;
  /** Returns a sanitized agent transaction summary after verifying ownership of the My Home property */
  getMyHomeAgentExpandedStats: MyHomeAgentExpandedStatsResult;
  /** Returns public My Home agent cards after verifying lead ownership and tenant */
  getMyHomeAgents: MyHomeAgentsResult;
  /** execute function "get_activities_feed_for_lead" which returns "activities" */
  get_activities_feed_for_lead: Array<Activities>;
  /** execute function "get_activities_feed_for_lead" and query aggregates on result of table type "activities" */
  get_activities_feed_for_lead_aggregate: Activities_Aggregate;
  /** execute function "get_activities_feed_for_lot" which returns "activities" */
  get_activities_feed_for_lot: Array<Activities>;
  /** execute function "get_activities_feed_for_lot" and query aggregates on result of table type "activities" */
  get_activities_feed_for_lot_aggregate: Activities_Aggregate;
  /** execute function "get_activities_feed_for_user" which returns "activities" */
  get_activities_feed_for_user: Array<Activities>;
  /** execute function "get_activities_feed_for_user" and query aggregates on result of table type "activities" */
  get_activities_feed_for_user_aggregate: Activities_Aggregate;
  /** execute function "get_agents_ranking" which returns "agents_rankings" */
  get_agents_ranking: Array<Agents_Rankings>;
  /** execute function "get_agents_ranking" and query aggregates on result of table type "agents_rankings" */
  get_agents_ranking_aggregate: Agents_Rankings_Aggregate;
  /** execute function "get_agents_ranking_deduped" which returns "agents_rankings" */
  get_agents_ranking_deduped: Array<Agents_Rankings>;
  /** execute function "get_agents_ranking_deduped" and query aggregates on result of table type "agents_rankings" */
  get_agents_ranking_deduped_aggregate: Agents_Rankings_Aggregate;
  get_api_key?: Maybe<ApiKey>;
  get_api_keys?: Maybe<Array<ApiKey>>;
  /** execute function "get_appraisals_by_slug" which returns "appraisals_public_view" */
  get_appraisals_by_slug: Array<Appraisals_Public_View>;
  /** execute function "get_catchment_area" which returns "places" */
  get_catchment_area: Array<Places>;
  /** execute function "get_catchment_area" and query aggregates on result of table type "places" */
  get_catchment_area_aggregate: Places_Aggregate;
  get_close_lead?: Maybe<CloseLeadDetails>;
  /** execute function "get_cma_agent_transactions" which returns "cma_reports_agent_transactions" */
  get_cma_agent_transactions: Array<Cma_Reports_Agent_Transactions>;
  /** Retrieve the email templates suggestions based on the provided parameters */
  get_email_template_suggestions?: Maybe<GetEmailTemplateSuggestionsOutput>;
  get_leads_statistics?: Maybe<GetLeadsStatisticsOutput>;
  get_legacy_api_key?: Maybe<LegacyApiKey>;
  get_legacy_api_keys?: Maybe<Array<LegacyApiKey>>;
  get_listing_references?: Maybe<GetListingReferencesOutput>;
  /** execute function "get_local_activity_feed" which returns "local_activity_feed_items" */
  get_local_activity_feed: Array<Local_Activity_Feed_Items>;
  /** execute function "get_local_activity_feed" and query aggregates on result of table type "local_activity_feed_items" */
  get_local_activity_feed_aggregate: Local_Activity_Feed_Items_Aggregate;
  /** execute function "get_lot_publication_history" which returns "lot_publication_history_result" */
  get_lot_publication_history: Array<Lot_Publication_History_Result>;
  get_me: GetMeOutput;
  get_monthly_perf?: Maybe<MonthlyPerfOutput>;
  /** execute function "get_nearby_appraisals" which returns "appraisals_public_view" */
  get_nearby_appraisals: Array<Appraisals_Public_View>;
  /** execute function "get_nearby_reviews" which returns "reviews" */
  get_nearby_reviews: Array<Reviews>;
  /** execute function "get_nearby_reviews" and query aggregates on result of table type "reviews" */
  get_nearby_reviews_aggregate: Reviews_Aggregate;
  /** execute function "get_nearby_transactions" which returns "property_transactions" */
  get_nearby_transactions: Array<Property_Transactions>;
  /** execute function "get_nearby_transactions" and query aggregates on result of table type "property_transactions" */
  get_nearby_transactions_aggregate: Property_Transactions_Aggregate;
  get_onboarding_state?: Maybe<GetOnboardingStateOutput>;
  /** execute function "get_online_listing_map_data" which returns "online_listing_map_data" */
  get_online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** execute function "get_online_listing_map_data" and query aggregates on result of table type "online_listing_map_data" */
  get_online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** execute function "get_property_transactions_distance" which returns "property_transactions_distance" */
  get_property_transactions_distance: Array<Property_Transactions_Distance>;
  /** execute function "get_property_transactions_distance" and query aggregates on result of table type "property_transactions_distance" */
  get_property_transactions_distance_aggregate: Property_Transactions_Distance_Aggregate;
  /** execute function "get_reviews_in_location" which returns "reviews" */
  get_reviews_in_location: Array<Reviews>;
  /** execute function "get_reviews_in_location" and query aggregates on result of table type "reviews" */
  get_reviews_in_location_aggregate: Reviews_Aggregate;
  /** execute function "get_similar_online_listings" which returns "online_listings" */
  get_similar_online_listings: Array<Online_Listings>;
  /** execute function "get_similar_online_listings" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_aggregate: Online_Listings_Aggregate;
  /** execute function "get_similar_online_listings_ids" which returns "similar_online_listings_ids" */
  get_similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** execute function "get_similar_online_listings_ids" and query aggregates on result of table type "similar_online_listings_ids" */
  get_similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** execute function "get_similar_online_listings_vector" which returns "online_listings" */
  get_similar_online_listings_vector: Array<Online_Listings>;
  /** execute function "get_similar_online_listings_vector" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_vector_aggregate: Online_Listings_Aggregate;
  /** Get the surrounding places of a property listing */
  get_surrounding_listing_places?: Maybe<Array<GetSurroundingListingPlacesOutput>>;
  /** execute function "get_teams_ranking" which returns "teams_rankings" */
  get_teams_ranking: Array<Teams_Rankings>;
  /** execute function "get_teams_ranking" and query aggregates on result of table type "teams_rankings" */
  get_teams_ranking_aggregate: Teams_Rankings_Aggregate;
  /** execute function "get_teams_ranking_by_distance" which returns "teams_rankings" */
  get_teams_ranking_by_distance: Array<Teams_Rankings>;
  /** execute function "get_teams_ranking_by_distance" and query aggregates on result of table type "teams_rankings" */
  get_teams_ranking_by_distance_aggregate: Teams_Rankings_Aggregate;
  /** Get competitor team stats with elevated privileges (bypasses agent row-level filters) */
  get_top_competitor_stats?: Maybe<TopCompetitorStatsOutput>;
  /** execute function "get_translated_enum" which returns "translated_enums" */
  get_translated_enum: Array<Translated_Enums>;
  get_valuation_link: GetValuationLinkOutput;
  /** execute function "global_statistics" which returns "global_stats" */
  global_statistics: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" */
  global_stats: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" using primary key columns */
  global_stats_by_pk?: Maybe<Global_Stats>;
  /** fetch data from the table: "google_addresses" */
  google_addresses: Array<Google_Addresses>;
  /** An array relationship */
  google_reviews: Array<Google_Reviews>;
  /** An aggregate relationship */
  google_reviews_aggregate: Google_Reviews_Aggregate;
  /** fetch data from the table: "google_reviews" using primary key columns */
  google_reviews_by_pk?: Maybe<Google_Reviews>;
  /** fetch data from the table: "heating_distribution_enum" */
  heating_distribution_enum: Array<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_distribution_enum" using primary key columns */
  heating_distribution_enum_by_pk?: Maybe<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_enum" */
  heating_enum: Array<Heating_Enum>;
  /** fetch data from the table: "heating_enum" using primary key columns */
  heating_enum_by_pk?: Maybe<Heating_Enum>;
  /** fetch data from the table: "images" */
  images: Array<Images>;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<Images>;
  /** Get impression dots with lat/lng for visibility map */
  impression_dots?: Maybe<ImpressionDotsOutput>;
  /** Get visibility impressions from bigquery grouped by a column */
  impressions_grouped_by_column?: Maybe<ImpressionsGroupedByColumnResponse>;
  /**
   * Single-row total impressions (count, user_count, average_position).
   * Use instead of impressions_grouped_by_column when only the total is
   * needed - skips the per-bucket GROUP BY for ~3-7x speedup, and returns
   * a true distinct user_count instead of the sum of per-bucket uniques.
   */
  impressions_total?: Maybe<ImpressionsTotalOutput>;
  /** improve_text */
  improve_text?: Maybe<ImprovedText>;
  /** fetch data from the table: "invitations" */
  invitations: Array<Invitations>;
  /** fetch aggregated fields from the table: "invitations" */
  invitations_aggregate: Invitations_Aggregate;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table: "cma_listings" */
  it_cma_listings: Array<It_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  it_cma_listings_aggregate: It_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  it_cma_listings_by_pk?: Maybe<It_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  it_cma_listings_distance: Array<It_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  it_cma_listings_distance_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  it_cma_listings_distance_by_pk?: Maybe<It_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  it_cma_rental_listings: Array<It_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  it_cma_rental_listings_aggregate: It_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  it_cma_rental_listings_by_pk?: Maybe<It_Cma_Rental_Listings>;
  /** fetch data from the table: "external_transactions" */
  it_external_transactions: Array<It_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  it_external_transactions_aggregate: It_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  it_external_transactions_distance: Array<It_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  it_external_transactions_distance_aggregate: It_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  it_external_transactions_distance_by_pk?: Maybe<It_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  it_get_cma_listings_by_radius: Array<It_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  it_get_cma_listings_by_radius_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  it_get_cma_listings_distance: Array<It_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  it_get_cma_listings_distance_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  it_get_external_transactions_distance: Array<It_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  it_get_external_transactions_distance_aggregate: It_External_Transactions_Distance_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  it_get_listings_stats?: Maybe<It_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  it_get_listings_stats_aggregate: It_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  it_get_merged_listings: Array<It_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  it_get_merged_listings_type: Array<It_Get_Merged_Listings_Type>;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  it_get_rental_cma_listings_distance: Array<It_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  it_get_rental_cma_listings_distance_aggregate: It_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  it_get_similar_listings: Array<It_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  it_get_similar_listings_aggregate: It_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  it_get_similar_listings_cohorts: Array<It_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  it_get_similar_listings_cohorts_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  it_get_similar_listings_vector: Array<It_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  it_get_similar_listings_vector_aggregate: It_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  it_get_similar_rental_listings_cohorts: Array<It_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  it_get_similar_rental_listings_cohorts_aggregate: It_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  it_merged_images: Array<It_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  it_merged_images_aggregate: It_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  it_merged_listings: Array<It_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  it_merged_listings_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  it_merged_listings_by_pk?: Maybe<It_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  it_merged_listings_compare: Array<It_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  it_merged_listings_compare_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  it_places: Array<It_Places>;
  /** fetch aggregated fields from the table: "places" */
  it_places_aggregate: It_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  it_places_breadcrumbs: Array<It_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  it_places_breadcrumbs_aggregate: It_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  it_places_by_pk?: Maybe<It_Places>;
  /** fetch data from the table: "post_merged_listings" */
  it_post_merged_listings: Array<It_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  it_post_merged_listings_aggregate: It_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  it_post_merged_listings_by_pk?: Maybe<It_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  it_price_stats: Array<It_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  it_price_stats_aggregate: It_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  it_price_stats_historical: Array<It_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  it_price_stats_historical_aggregate: It_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  it_price_stats_historical_by_pk?: Maybe<It_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  it_property_types: Array<It_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  it_rental_cma_listings_distance: Array<It_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  it_rental_cma_listings_distance_aggregate: It_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  it_search_places_with_index: Array<It_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  it_search_places_with_index_aggregate: It_Places_Aggregate;
  /** fetch data from the table: "states" */
  it_states: Array<It_States>;
  /** fetch data from the table: "street_stats" */
  it_street_stats: Array<It_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  it_street_stats_aggregate: It_Street_Stats_Aggregate;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** fetch data from the table: "lead_agents" using primary key columns */
  lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** fetch data from the table: "lead_stages" */
  lead_stages: Array<Lead_Stages>;
  /** fetch aggregated fields from the table: "lead_stages" */
  lead_stages_aggregate: Lead_Stages_Aggregate;
  /** fetch data from the table: "lead_stages" using primary key columns */
  lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  /** fetch data from the table: "leads" using primary key columns */
  leads_by_pk?: Maybe<Leads>;
  /** fetch data from the table: "leads_status" */
  leads_status: Array<Leads_Status>;
  /** fetch data from the table: "leads_status" using primary key columns */
  leads_status_by_pk?: Maybe<Leads_Status>;
  /** An array relationship */
  leads_tags: Array<Leads_Tags>;
  /** An aggregate relationship */
  leads_tags_aggregate: Leads_Tags_Aggregate;
  /** fetch data from the table: "leads_tags" using primary key columns */
  leads_tags_by_pk?: Maybe<Leads_Tags>;
  /** execute function "leads_the_same_address" which returns "leads" */
  leads_the_same_address: Array<Leads>;
  /** execute function "leads_the_same_address" and query aggregates on result of table type "leads" */
  leads_the_same_address_aggregate: Leads_Aggregate;
  listing_ga4_stats?: Maybe<ListingGa4StatsOutput>;
  /** fetch data from the table: "locality_adjacency" */
  locality_adjacency: Array<Locality_Adjacency>;
  /** fetch data from the table: "locality_adjacency" using primary key columns */
  locality_adjacency_by_pk?: Maybe<Locality_Adjacency>;
  /** An array relationship */
  lot_reference_aliases: Array<Lot_Reference_Aliases>;
  /** fetch data from the table: "lot_reference_aliases" using primary key columns */
  lot_reference_aliases_by_pk?: Maybe<Lot_Reference_Aliases>;
  /** An array relationship */
  lot_sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  lot_sellers_aggregate: Lot_Sellers_Aggregate;
  /** fetch data from the table: "lot_sellers" using primary key columns */
  lot_sellers_by_pk?: Maybe<Lot_Sellers>;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  /** fetch data from the table: "lots" using primary key columns */
  lots_by_pk?: Maybe<Lots>;
  /** fetch data from the table: "lots_member_access_enum" */
  lots_member_access_enum: Array<Lots_Member_Access_Enum>;
  /** fetch data from the table: "lots_member_access_enum" using primary key columns */
  lots_member_access_enum_by_pk?: Maybe<Lots_Member_Access_Enum>;
  /** fetch data from the table: "lots_status_enum" */
  lots_status_enum: Array<Lots_Status_Enum>;
  /** fetch data from the table: "lots_status_enum" using primary key columns */
  lots_status_enum_by_pk?: Maybe<Lots_Status_Enum>;
  /** fetch data from the table: "marketing_metadata" */
  marketing_metadata: Array<Marketing_Metadata>;
  /** fetch data from the table: "marketing_metadata" using primary key columns */
  marketing_metadata_by_pk?: Maybe<Marketing_Metadata>;
  /** fetch data from the table: "marketplace_conversation_participants" */
  marketplace_conversation_participants: Array<Marketplace_Conversation_Participants>;
  /** fetch data from the table: "marketplace_conversation_participants" using primary key columns */
  marketplace_conversation_participants_by_pk?: Maybe<Marketplace_Conversation_Participants>;
  /** fetch data from the table: "marketplace_conversation_public_participants" */
  marketplace_conversation_public_participants: Array<Marketplace_Conversation_Public_Participants>;
  /** fetch data from the table: "marketplace_conversations" */
  marketplace_conversations: Array<Marketplace_Conversations>;
  /** fetch data from the table: "marketplace_conversations" using primary key columns */
  marketplace_conversations_by_pk?: Maybe<Marketplace_Conversations>;
  marketplace_listing?: Maybe<MarketplaceListing>;
  marketplace_listing_markers: MarketplaceListingMarkersPage;
  marketplace_listings: MarketplaceListingsPage;
  /** fetch data from the table: "marketplace_message_delivery_channel_enum" */
  marketplace_message_delivery_channel_enum: Array<Marketplace_Message_Delivery_Channel_Enum>;
  /** fetch data from the table: "marketplace_message_delivery_channel_enum" using primary key columns */
  marketplace_message_delivery_channel_enum_by_pk?: Maybe<Marketplace_Message_Delivery_Channel_Enum>;
  /** fetch data from the table: "marketplace_message_delivery_status_enum" */
  marketplace_message_delivery_status_enum: Array<Marketplace_Message_Delivery_Status_Enum>;
  /** fetch data from the table: "marketplace_message_delivery_status_enum" using primary key columns */
  marketplace_message_delivery_status_enum_by_pk?: Maybe<Marketplace_Message_Delivery_Status_Enum>;
  /** fetch data from the table: "marketplace_message_origin_enum" */
  marketplace_message_origin_enum: Array<Marketplace_Message_Origin_Enum>;
  /** fetch data from the table: "marketplace_message_origin_enum" using primary key columns */
  marketplace_message_origin_enum_by_pk?: Maybe<Marketplace_Message_Origin_Enum>;
  /** fetch data from the table: "marketplace_messages" */
  marketplace_messages: Array<Marketplace_Messages>;
  /** fetch data from the table: "marketplace_messages" using primary key columns */
  marketplace_messages_by_pk?: Maybe<Marketplace_Messages>;
  /** fetch data from the table: "marketplace_participant_role_enum" */
  marketplace_participant_role_enum: Array<Marketplace_Participant_Role_Enum>;
  /** fetch data from the table: "marketplace_participant_role_enum" using primary key columns */
  marketplace_participant_role_enum_by_pk?: Maybe<Marketplace_Participant_Role_Enum>;
  marketplace_place_suggestions: Array<MarketplacePlace>;
  marketplace_popular_places: Array<MarketplacePlace>;
  marketplace_similar_listings: MarketplaceListingsPage;
  /** execute function "get_marketplace_similar_online_listings" which returns "online_listings" */
  marketplace_similar_online_listings: Array<Online_Listings>;
  /** execute function "get_marketplace_similar_online_listings" and query aggregates on result of table type "online_listings" */
  marketplace_similar_online_listings_aggregate: Online_Listings_Aggregate;
  /** execute function "me" which returns "users" */
  me?: Maybe<Users>;
  /** execute function "me" and query aggregates on result of table type "users" */
  me_aggregate: Users_Aggregate;
  /** execute function "mls_agent_buyer_matches" which returns "mls_buyer_match_edge" */
  mls_agent_buyer_matches: Array<Mls_Buyer_Match_Edge>;
  /** fetch data from the table: "mls_brokers" */
  mls_brokers: Array<Mls_Brokers>;
  /** fetch aggregated fields from the table: "mls_brokers" */
  mls_brokers_aggregate: Mls_Brokers_Aggregate;
  /** fetch data from the table: "mls_buyer_match_edge" */
  mls_buyer_match_edge: Array<Mls_Buyer_Match_Edge>;
  /** fetch data from the table: "mls_commission_type_enum" */
  mls_commission_type_enum: Array<Mls_Commission_Type_Enum>;
  /** fetch data from the table: "mls_commission_type_enum" using primary key columns */
  mls_commission_type_enum_by_pk?: Maybe<Mls_Commission_Type_Enum>;
  /** fetch data from the table: "mls_listing_enquiry_settings" */
  mls_listing_enquiry_settings: Array<Mls_Listing_Enquiry_Settings>;
  /** fetch aggregated fields from the table: "mls_listing_enquiry_settings" */
  mls_listing_enquiry_settings_aggregate: Mls_Listing_Enquiry_Settings_Aggregate;
  /** fetch data from the table: "mls_listing_enquiry_settings" using primary key columns */
  mls_listing_enquiry_settings_by_pk?: Maybe<Mls_Listing_Enquiry_Settings>;
  /** fetch data from the table: "mls_lots" */
  mls_lots: Array<Mls_Lots>;
  /** fetch aggregated fields from the table: "mls_lots" */
  mls_lots_aggregate: Mls_Lots_Aggregate;
  /** execute function "mls_lots_in_viewport" which returns "mls_lots" */
  mls_lots_in_viewport: Array<Mls_Lots>;
  /** execute function "mls_lots_in_viewport" and query aggregates on result of table type "mls_lots" */
  mls_lots_in_viewport_aggregate: Mls_Lots_Aggregate;
  /** fetch data from the table: "mls_network_teams" */
  mls_network_teams: Array<Mls_Network_Teams>;
  /** fetch aggregated fields from the table: "mls_network_teams" */
  mls_network_teams_aggregate: Mls_Network_Teams_Aggregate;
  /** fetch data from the table: "mls_settings" */
  mls_settings: Array<Mls_Settings>;
  /** fetch data from the table: "mls_settings" using primary key columns */
  mls_settings_by_pk?: Maybe<Mls_Settings>;
  /** fetch data from the table: "mls_share_mode_enum" */
  mls_share_mode_enum: Array<Mls_Share_Mode_Enum>;
  /** fetch data from the table: "mls_share_mode_enum" using primary key columns */
  mls_share_mode_enum_by_pk?: Maybe<Mls_Share_Mode_Enum>;
  /** fetch data from the table: "mls_share_status_enum" */
  mls_share_status_enum: Array<Mls_Share_Status_Enum>;
  /** fetch data from the table: "mls_share_status_enum" using primary key columns */
  mls_share_status_enum_by_pk?: Maybe<Mls_Share_Status_Enum>;
  /** An array relationship */
  mls_shares: Array<Mls_Shares>;
  /** An aggregate relationship */
  mls_shares_aggregate: Mls_Shares_Aggregate;
  /** fetch data from the table: "mls_shares" using primary key columns */
  mls_shares_by_pk?: Maybe<Mls_Shares>;
  /** fetch data from the table: "mls_teams" */
  mls_teams: Array<Mls_Teams>;
  /** fetch aggregated fields from the table: "mls_teams" */
  mls_teams_aggregate: Mls_Teams_Aggregate;
  /** Get nearby impressions totals, by locality, and profile views in one query */
  nearby_impressions?: Maybe<NearbyImpressionsResponse>;
  /** execute function "notification_setting_impact" which returns "notification_setting_impact_result" */
  notification_setting_impact: Array<Notification_Setting_Impact_Result>;
  /** fetch data from the table: "notification_settings" */
  notification_settings: Array<Notification_Settings>;
  /** fetch data from the table: "notification_settings" using primary key columns */
  notification_settings_by_pk?: Maybe<Notification_Settings>;
  /** fetch data from the table: "nylas_account_configs" */
  nylas_account_configs: Array<Nylas_Account_Configs>;
  /** fetch data from the table: "nylas_account_configs" using primary key columns */
  nylas_account_configs_by_pk?: Maybe<Nylas_Account_Configs>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  /** fetch data from the table: "online_listing_map_data" */
  online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** fetch aggregated fields from the table: "online_listing_map_data" */
  online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** fetch data from the table: "online_listings" */
  online_listings: Array<Online_Listings>;
  /** fetch aggregated fields from the table: "online_listings" */
  online_listings_aggregate: Online_Listings_Aggregate;
  /** fetch data from the table: "online_listings" using primary key columns */
  online_listings_by_pk?: Maybe<Online_Listings>;
  /** Stripe billing summary for the organisation monitoring view */
  organisation_billing_summary?: Maybe<OrganisationBillingSummaryOutput>;
  /** Organisation engagement score read from dbt (fct_engagement_score_current / _history), the same score synced to Close */
  organisation_engagement_score?: Maybe<OrganisationEngagementScoreOutput>;
  /** An array relationship */
  organisation_images: Array<Organisation_Images>;
  /** fetch data from the table: "organisation_images" using primary key columns */
  organisation_images_by_pk?: Maybe<Organisation_Images>;
  /** Aggregated organisation monitoring analytics for the CRM detail view */
  organisation_monitoring_analytics?: Maybe<OrganisationMonitoringAnalyticsOutput>;
  /** PostHog general CSAT survey responses for organisation team users */
  organisation_posthog_csat?: Maybe<OrganisationPosthogCsatOutput>;
  /** PostHog usage signals for organisation engagement scoring */
  organisation_posthog_usage?: Maybe<OrganisationPosthogUsageOutput>;
  /** An array relationship */
  organisation_users: Array<Organisation_Users>;
  /** Visibility score (ClickHouse + visibility-scoring package) with current/previous window and delta */
  organisation_visibility_score?: Maybe<OrganisationVisibilityScoreOutput>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** execute function "organisations_search" which returns "organisations" */
  organisations_search: Array<Organisations>;
  /** execute function "organisations_search" and query aggregates on result of table type "organisations" */
  organisations_search_aggregate: Organisations_Aggregate;
  /** Cadastral parcel at a WGS84 point via the Italian open cadastre WFS (IT AdE) — prospection map click lookup; FR and ES resolve from our own plots tables */
  parcel_at_point?: Maybe<ParcelAtPointOutput>;
  /** fetch data from the table: "phone_number_type_enum" */
  phone_number_type_enum: Array<Phone_Number_Type_Enum>;
  /** fetch data from the table: "phone_number_type_enum" using primary key columns */
  phone_number_type_enum_by_pk?: Maybe<Phone_Number_Type_Enum>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** fetch data from the table: "pipelines" */
  pipelines: Array<Pipelines>;
  /** fetch aggregated fields from the table: "pipelines" */
  pipelines_aggregate: Pipelines_Aggregate;
  /** fetch data from the table: "pipelines" using primary key columns */
  pipelines_by_pk?: Maybe<Pipelines>;
  /** fetch data from the table: "cma_listings" */
  pl_cma_listings: Array<Pl_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  pl_cma_listings_aggregate: Pl_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  pl_cma_listings_by_pk?: Maybe<Pl_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  pl_cma_listings_distance: Array<Pl_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  pl_cma_listings_distance_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  pl_cma_listings_distance_by_pk?: Maybe<Pl_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  pl_cma_rental_listings: Array<Pl_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  pl_cma_rental_listings_aggregate: Pl_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "external_transactions" */
  pl_external_transactions: Array<Pl_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  pl_external_transactions_aggregate: Pl_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  pl_external_transactions_distance: Array<Pl_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  pl_external_transactions_distance_aggregate: Pl_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  pl_external_transactions_distance_by_pk?: Maybe<Pl_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  pl_get_cma_listings_by_radius: Array<Pl_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  pl_get_cma_listings_by_radius_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  pl_get_cma_listings_distance: Array<Pl_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  pl_get_cma_listings_distance_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  pl_get_external_transactions_distance: Array<Pl_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  pl_get_external_transactions_distance_aggregate: Pl_External_Transactions_Distance_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  pl_get_listings_stats?: Maybe<Pl_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  pl_get_listings_stats_aggregate: Pl_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  pl_get_merged_listings: Array<Pl_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  pl_get_merged_listings_type: Array<Pl_Get_Merged_Listings_Type>;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  pl_get_rental_cma_listings_distance: Array<Pl_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  pl_get_rental_cma_listings_distance_aggregate: Pl_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  pl_get_similar_listings: Array<Pl_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  pl_get_similar_listings_aggregate: Pl_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  pl_get_similar_listings_cohorts: Array<Pl_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  pl_get_similar_listings_cohorts_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  pl_get_similar_listings_vector: Array<Pl_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  pl_get_similar_listings_vector_aggregate: Pl_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  pl_get_similar_rental_listings_cohorts: Array<Pl_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  pl_get_similar_rental_listings_cohorts_aggregate: Pl_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  pl_merged_images: Array<Pl_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  pl_merged_images_aggregate: Pl_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  pl_merged_listings: Array<Pl_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  pl_merged_listings_aggregate: Pl_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  pl_merged_listings_by_pk?: Maybe<Pl_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  pl_merged_listings_compare: Array<Pl_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  pl_merged_listings_compare_aggregate: Pl_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  pl_places: Array<Pl_Places>;
  /** fetch aggregated fields from the table: "places" */
  pl_places_aggregate: Pl_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  pl_places_breadcrumbs: Array<Pl_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  pl_places_breadcrumbs_aggregate: Pl_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  pl_places_by_pk?: Maybe<Pl_Places>;
  /** fetch data from the table: "post_merged_listings" */
  pl_post_merged_listings: Array<Pl_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  pl_post_merged_listings_aggregate: Pl_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  pl_post_merged_listings_by_pk?: Maybe<Pl_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  pl_price_stats: Array<Pl_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  pl_price_stats_aggregate: Pl_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  pl_price_stats_historical: Array<Pl_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  pl_price_stats_historical_aggregate: Pl_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  pl_price_stats_historical_by_pk?: Maybe<Pl_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  pl_property_types: Array<Pl_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  pl_rental_cma_listings_distance: Array<Pl_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  pl_rental_cma_listings_distance_aggregate: Pl_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  pl_search_places_with_index: Array<Pl_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  pl_search_places_with_index_aggregate: Pl_Places_Aggregate;
  /** fetch data from the table: "states" */
  pl_states: Array<Pl_States>;
  /** fetch data from the table: "street_stats" */
  pl_street_stats: Array<Pl_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  pl_street_stats_aggregate: Pl_Street_Stats_Aggregate;
  /** execute function "place_by_slug" which returns "places" */
  place_by_slug?: Maybe<Places>;
  /** execute function "place_by_slug" and query aggregates on result of table type "places" */
  place_by_slug_aggregate: Places_Aggregate;
  /** execute function "place_by_type" which returns "places" */
  place_by_type: Array<Places>;
  /** execute function "place_by_type" and query aggregates on result of table type "places" */
  place_by_type_aggregate: Places_Aggregate;
  /** fetch data from the table: "places" */
  places: Array<Places>;
  /** execute function "places_agent_ranking" which returns "agents_rankings" */
  places_agent_ranking: Array<Agents_Rankings>;
  /** execute function "places_agent_ranking" and query aggregates on result of table type "agents_rankings" */
  places_agent_ranking_aggregate: Agents_Rankings_Aggregate;
  /** fetch aggregated fields from the table: "places" */
  places_aggregate: Places_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  places_by_pk?: Maybe<Places>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  /** fetch data from the table: "portal_listings" using primary key columns */
  portal_listings_by_pk?: Maybe<Portal_Listings>;
  /** fetch data from the table: "portals" */
  portals: Array<Portals>;
  /** fetch aggregated fields from the table: "portals" */
  portals_aggregate: Portals_Aggregate;
  /** fetch data from the table: "portals" using primary key columns */
  portals_by_pk?: Maybe<Portals>;
  /** fetch data from the table: "portals_types_enum" */
  portals_types_enum: Array<Portals_Types_Enum>;
  /** fetch data from the table: "portals_types_enum" using primary key columns */
  portals_types_enum_by_pk?: Maybe<Portals_Types_Enum>;
  /** An array relationship */
  properties: Array<Properties>;
  /** fetch data from the table: "properties" using primary key columns */
  properties_by_pk?: Maybe<Properties>;
  /** check if property is appraisable */
  property_appraisable?: Maybe<PropertyAppraisableOutput>;
  /** An array relationship */
  property_files: Array<Property_Files>;
  /** An aggregate relationship */
  property_files_aggregate: Property_Files_Aggregate;
  /** fetch data from the table: "property_files" using primary key columns */
  property_files_by_pk?: Maybe<Property_Files>;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** fetch data from the table: "property_images" using primary key columns */
  property_images_by_pk?: Maybe<Property_Images>;
  /** fetch data from the table: "property_search_aggregator_source" */
  property_search_aggregator_source: Array<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_aggregator_source" using primary key columns */
  property_search_aggregator_source_by_pk?: Maybe<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_source" */
  property_search_source: Array<Property_Search_Source>;
  /** fetch data from the table: "property_search_source" using primary key columns */
  property_search_source_by_pk?: Maybe<Property_Search_Source>;
  /** An array relationship */
  property_searches: Array<Property_Searches>;
  /** An aggregate relationship */
  property_searches_aggregate: Property_Searches_Aggregate;
  /** fetch data from the table: "property_searches" using primary key columns */
  property_searches_by_pk?: Maybe<Property_Searches>;
  /** An array relationship */
  property_searches_places: Array<Property_Searches_Places>;
  /** fetch data from the table: "property_searches_places" using primary key columns */
  property_searches_places_by_pk?: Maybe<Property_Searches_Places>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** fetch data from the table: "property_transactions" using primary key columns */
  property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** fetch data from the table: "property_transactions_country_view" */
  property_transactions_country_view: Array<Property_Transactions_Country_View>;
  /** fetch data from the table: "property_transactions_distance" */
  property_transactions_distance: Array<Property_Transactions_Distance>;
  /** fetch aggregated fields from the table: "property_transactions_distance" */
  property_transactions_distance_aggregate: Property_Transactions_Distance_Aggregate;
  /** fetch data from the table: "property_transactions_distance" using primary key columns */
  property_transactions_distance_by_pk?: Maybe<Property_Transactions_Distance>;
  /** An array relationship */
  property_transactions_listings: Array<Property_Transactions_Listings>;
  /** fetch data from the table: "property_transactions_listings" using primary key columns */
  property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** fetch data from the table: "property_types" */
  property_types: Array<Property_Types>;
  /** fetch aggregated fields from the table: "property_types" */
  property_types_aggregate: Property_Types_Aggregate;
  /** fetch data from the table: "property_types" using primary key columns */
  property_types_by_pk?: Maybe<Property_Types>;
  /** fetch data from the table: "prospection_contact_message_templates" */
  prospection_contact_message_templates: Array<Prospection_Contact_Message_Templates>;
  /** fetch data from the table: "prospection_contact_message_templates" using primary key columns */
  prospection_contact_message_templates_by_pk?: Maybe<Prospection_Contact_Message_Templates>;
  prospection_contact_quota?: Maybe<ProspectionContactQuotaOutput>;
  /** fetch data from the table: "prospection_contact_settings" */
  prospection_contact_settings: Array<Prospection_Contact_Settings>;
  /** fetch data from the table: "prospection_contact_settings" using primary key columns */
  prospection_contact_settings_by_pk?: Maybe<Prospection_Contact_Settings>;
  /** fetch data from the table: "prospection_contact_teams" */
  prospection_contact_teams: Array<Prospection_Contact_Teams>;
  /** fetch data from the table: "prospection_contact_teams" using primary key columns */
  prospection_contact_teams_by_pk?: Maybe<Prospection_Contact_Teams>;
  /** fetch data from the table: "prospection_map_contact_attempts" */
  prospection_map_contact_attempts: Array<Prospection_Map_Contact_Attempts>;
  /** fetch aggregated fields from the table: "prospection_map_contact_attempts" */
  prospection_map_contact_attempts_aggregate: Prospection_Map_Contact_Attempts_Aggregate;
  /** fetch data from the table: "prospection_map_contact_attempts" using primary key columns */
  prospection_map_contact_attempts_by_pk?: Maybe<Prospection_Map_Contact_Attempts>;
  /** fetch data from the table: "prospection_map_emailable_leads" */
  prospection_map_emailable_leads: Array<Prospection_Map_Emailable_Leads>;
  /** fetch data from the table: "prospection_map_full_leads" */
  prospection_map_full_leads: Array<Prospection_Map_Full_Leads>;
  /** execute function "prospection_map_lead_addresses_in_bbox" which returns "prospection_map_lead_addresses" */
  prospection_map_lead_addresses_in_bbox: Array<Prospection_Map_Lead_Addresses>;
  /** fetch data from the table: "prospection_marks" */
  prospection_marks: Array<Prospection_Marks>;
  /** fetch data from the table: "prospection_marks" using primary key columns */
  prospection_marks_by_pk?: Maybe<Prospection_Marks>;
  /** fetch data from the table: "cma_listings" */
  pt_cma_listings: Array<Pt_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  pt_cma_listings_aggregate: Pt_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  pt_cma_listings_by_pk?: Maybe<Pt_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  pt_cma_listings_distance: Array<Pt_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  pt_cma_listings_distance_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  pt_cma_listings_distance_by_pk?: Maybe<Pt_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  pt_cma_rental_listings: Array<Pt_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  pt_cma_rental_listings_aggregate: Pt_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "external_transactions" */
  pt_external_transactions: Array<Pt_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  pt_external_transactions_aggregate: Pt_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  pt_external_transactions_distance: Array<Pt_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  pt_external_transactions_distance_aggregate: Pt_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  pt_external_transactions_distance_by_pk?: Maybe<Pt_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  pt_get_cma_listings_by_radius: Array<Pt_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  pt_get_cma_listings_by_radius_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  pt_get_cma_listings_distance: Array<Pt_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  pt_get_cma_listings_distance_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  pt_get_external_transactions_distance: Array<Pt_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  pt_get_external_transactions_distance_aggregate: Pt_External_Transactions_Distance_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  pt_get_listings_stats?: Maybe<Pt_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  pt_get_listings_stats_aggregate: Pt_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  pt_get_merged_listings: Array<Pt_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  pt_get_merged_listings_type: Array<Pt_Get_Merged_Listings_Type>;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  pt_get_rental_cma_listings_distance: Array<Pt_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  pt_get_rental_cma_listings_distance_aggregate: Pt_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  pt_get_similar_listings: Array<Pt_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  pt_get_similar_listings_aggregate: Pt_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  pt_get_similar_listings_cohorts: Array<Pt_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  pt_get_similar_listings_cohorts_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  pt_get_similar_listings_vector: Array<Pt_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  pt_get_similar_listings_vector_aggregate: Pt_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  pt_get_similar_rental_listings_cohorts: Array<Pt_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  pt_get_similar_rental_listings_cohorts_aggregate: Pt_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  pt_merged_images: Array<Pt_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  pt_merged_images_aggregate: Pt_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  pt_merged_listings: Array<Pt_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  pt_merged_listings_aggregate: Pt_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  pt_merged_listings_by_pk?: Maybe<Pt_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  pt_merged_listings_compare: Array<Pt_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  pt_merged_listings_compare_aggregate: Pt_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  pt_places: Array<Pt_Places>;
  /** fetch aggregated fields from the table: "places" */
  pt_places_aggregate: Pt_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  pt_places_breadcrumbs: Array<Pt_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  pt_places_breadcrumbs_aggregate: Pt_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  pt_places_by_pk?: Maybe<Pt_Places>;
  /** fetch data from the table: "post_merged_listings" */
  pt_post_merged_listings: Array<Pt_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  pt_post_merged_listings_aggregate: Pt_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  pt_post_merged_listings_by_pk?: Maybe<Pt_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  pt_price_stats: Array<Pt_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  pt_price_stats_aggregate: Pt_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  pt_price_stats_historical: Array<Pt_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  pt_price_stats_historical_aggregate: Pt_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  pt_price_stats_historical_by_pk?: Maybe<Pt_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  pt_property_types: Array<Pt_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  pt_rental_cma_listings_distance: Array<Pt_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  pt_rental_cma_listings_distance_aggregate: Pt_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  pt_search_places_with_index: Array<Pt_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  pt_search_places_with_index_aggregate: Pt_Places_Aggregate;
  /** fetch data from the table: "states" */
  pt_states: Array<Pt_States>;
  /** fetch data from the table: "street_stats" */
  pt_street_stats: Array<Pt_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  pt_street_stats_aggregate: Pt_Street_Stats_Aggregate;
  /** An array relationship */
  push_notification_tokens: Array<Push_Notification_Tokens>;
  /** fetch data from the table: "push_notification_tokens" using primary key columns */
  push_notification_tokens_by_pk?: Maybe<Push_Notification_Tokens>;
  /** fetch data from the table: "read_only_tenants" */
  read_only_tenants: Array<Read_Only_Tenants>;
  read_portal_idx?: Maybe<ReadPortalIdxOutput>;
  /** fetch data from the table: "review_invitation_templates" */
  review_invitation_templates: Array<Review_Invitation_Templates>;
  /** fetch aggregated fields from the table: "review_invitation_templates" */
  review_invitation_templates_aggregate: Review_Invitation_Templates_Aggregate;
  /** fetch data from the table: "review_invitation_templates" using primary key columns */
  review_invitation_templates_by_pk?: Maybe<Review_Invitation_Templates>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviews_by_pk?: Maybe<Reviews>;
  /** execute function "search_brockers_in_catchment_area" which returns "users" */
  search_brockers_in_catchment_area: Array<Users>;
  /** execute function "search_brockers_in_catchment_area" and query aggregates on result of table type "users" */
  search_brockers_in_catchment_area_aggregate: Users_Aggregate;
  /** execute function "search_buyer_leads_tsv" which returns "buyer_leads" */
  search_buyer_leads_tsv: Array<Buyer_Leads>;
  /** execute function "search_buyer_leads_tsv" and query aggregates on result of table type "buyer_leads" */
  search_buyer_leads_tsv_aggregate: Buyer_Leads_Aggregate;
  search_close_leads?: Maybe<CloseLeadSearchResponse>;
  /** execute function "search_leads" which returns "leads" */
  search_leads: Array<Leads>;
  /** execute function "search_leads" and query aggregates on result of table type "leads" */
  search_leads_aggregate: Leads_Aggregate;
  /** execute function "search_leads_tsv" which returns "leads" */
  search_leads_tsv: Array<Leads>;
  /** execute function "search_leads_tsv" and query aggregates on result of table type "leads" */
  search_leads_tsv_aggregate: Leads_Aggregate;
  /** execute function "search_lots_tsv" which returns "lots" */
  search_lots_tsv: Array<Lots>;
  /** execute function "search_lots_tsv" and query aggregates on result of table type "lots" */
  search_lots_tsv_aggregate: Lots_Aggregate;
  /** execute function "search_places" which returns "places" */
  search_places: Array<Places>;
  /** execute function "search_places" and query aggregates on result of table type "places" */
  search_places_aggregate: Places_Aggregate;
  /** execute function "search_places_ex" which returns "places" */
  search_places_ex: Array<Places>;
  /** execute function "search_places_ex" and query aggregates on result of table type "places" */
  search_places_ex_aggregate: Places_Aggregate;
  /** execute function "search_property_transactions_tsv" which returns "property_transactions" */
  search_property_transactions_tsv: Array<Property_Transactions>;
  /** execute function "search_property_transactions_tsv" and query aggregates on result of table type "property_transactions" */
  search_property_transactions_tsv_aggregate: Property_Transactions_Aggregate;
  /** execute function "search_public_agents_tsv" which returns "users" */
  search_public_agents_tsv: Array<Users>;
  /** execute function "search_public_agents_tsv" and query aggregates on result of table type "users" */
  search_public_agents_tsv_aggregate: Users_Aggregate;
  search_stripe_customers?: Maybe<StripeCustomerSearchResponse>;
  /** execute function "search_teams_tsv" which returns "teams" */
  search_teams_tsv: Array<Teams>;
  /** execute function "search_teams_tsv" and query aggregates on result of table type "teams" */
  search_teams_tsv_aggregate: Teams_Aggregate;
  /** execute function "search_users" which returns "users" */
  search_users: Array<Users>;
  /** execute function "search_users" and query aggregates on result of table type "users" */
  search_users_aggregate: Users_Aggregate;
  /** execute function "search_users_tsv" which returns "users" */
  search_users_tsv: Array<Users>;
  /** execute function "search_users_tsv" and query aggregates on result of table type "users" */
  search_users_tsv_aggregate: Users_Aggregate;
  /** fetch data from the table: "seller_notification_frequency_enum" */
  seller_notification_frequency_enum: Array<Seller_Notification_Frequency_Enum>;
  /** fetch data from the table: "seller_notification_frequency_enum" using primary key columns */
  seller_notification_frequency_enum_by_pk?: Maybe<Seller_Notification_Frequency_Enum>;
  /** fetch data from the table: "shared_portals" */
  shared_portals: Array<Shared_Portals>;
  /** fetch aggregated fields from the table: "shared_portals" */
  shared_portals_aggregate: Shared_Portals_Aggregate;
  /** fetch data from the table: "shared_portals" using primary key columns */
  shared_portals_by_pk?: Maybe<Shared_Portals>;
  /** fetch data from the table: "similar_online_listings_ids" */
  similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** fetch aggregated fields from the table: "similar_online_listings_ids" */
  similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** fetch data from the table: "smart_lists" */
  smart_lists: Array<Smart_Lists>;
  /** fetch data from the table: "smart_lists" using primary key columns */
  smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** sync dictionary enums for enum translations */
  sync_dictionary_enums?: Maybe<SyncDictionaryEnumsOutput>;
  /** An array relationship */
  team_images: Array<Team_Images>;
  /** fetch data from the table: "team_images" using primary key columns */
  team_images_by_pk?: Maybe<Team_Images>;
  /** Theme of an open CMA report or brochure, seen from the caller's default team */
  team_theme_context?: Maybe<TeamThemeContextOutput>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  /** fetch data from the table: "teams_portals" using primary key columns */
  teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** fetch data from the table: "tenant_gender_enum" */
  tenant_gender_enum: Array<Tenant_Gender_Enum>;
  /** fetch data from the table: "tenant_gender_enum" using primary key columns */
  tenant_gender_enum_by_pk?: Maybe<Tenant_Gender_Enum>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  test_close_connection?: Maybe<IntegrationConnectionTestResponse>;
  test_stripe_connection?: Maybe<IntegrationConnectionTestResponse>;
  /** An array relationship */
  transaction_valuations: Array<Transaction_Valuations>;
  /** An aggregate relationship */
  transaction_valuations_aggregate: Transaction_Valuations_Aggregate;
  translate_text?: Maybe<TranslatedText>;
  /** fetch data from the table: "translated_enums" */
  translated_enums: Array<Translated_Enums>;
  /** fetch data from the table: "translated_enums" using primary key columns */
  translated_enums_by_pk?: Maybe<Translated_Enums>;
  /** An array relationship */
  user_images: Array<User_Images>;
  /** fetch data from the table: "user_images" using primary key columns */
  user_images_by_pk?: Maybe<User_Images>;
  /** fetch data from the table: "user_onboarding_skip_reason_enum" */
  user_onboarding_skip_reason_enum: Array<User_Onboarding_Skip_Reason_Enum>;
  /** fetch data from the table: "user_onboarding_skip_reason_enum" using primary key columns */
  user_onboarding_skip_reason_enum_by_pk?: Maybe<User_Onboarding_Skip_Reason_Enum>;
  /** fetch data from the table: "user_onboarding_status_enum" */
  user_onboarding_status_enum: Array<User_Onboarding_Status_Enum>;
  /** fetch data from the table: "user_onboarding_status_enum" using primary key columns */
  user_onboarding_status_enum_by_pk?: Maybe<User_Onboarding_Status_Enum>;
  /** execute function "user_primary_phone" which returns "phone_numbers" */
  user_primary_phone: Array<Phone_Numbers>;
  /** execute function "user_primary_phone" and query aggregates on result of table type "phone_numbers" */
  user_primary_phone_aggregate: Phone_Numbers_Aggregate;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  users_listings: Array<Users_Listings>;
  /** An aggregate relationship */
  users_listings_aggregate: Users_Listings_Aggregate;
  /** fetch data from the table: "users_listings" using primary key columns */
  users_listings_by_pk?: Maybe<Users_Listings>;
  /** fetch data from the table: "users_view" */
  users_view: Array<Users_View>;
  /** validate_invitation */
  validate_invitation?: Maybe<ValidateInvitationOutput>;
  /** fetch data from the table: "valuation_models" */
  valuation_models: Array<Valuation_Models>;
  /** fetch data from the table: "valuation_models" using primary key columns */
  valuation_models_by_pk?: Maybe<Valuation_Models>;
  /** An array relationship */
  valuations: Array<Valuations>;
  /** fetch data from the table: "valuations" using primary key columns */
  valuations_by_pk?: Maybe<Valuations>;
  /** fetch data from the table: "visibility_inbox_lead_agents" */
  visibility_inbox_lead_agents: Array<Visibility_Inbox_Lead_Agents>;
  /** fetch data from the table: "visibility_inbox_profile_lead_history" */
  visibility_inbox_profile_lead_history: Array<Visibility_Inbox_Profile_Lead_History>;
  /** fetch data from the table: "visibility_profile_leads" */
  visibility_profile_leads: Array<Visibility_Profile_Leads>;
  /** fetch aggregated fields from the table: "visibility_profile_leads" */
  visibility_profile_leads_aggregate: Visibility_Profile_Leads_Aggregate;
  /** fetch data from the table: "webhook_event_types_enum" */
  webhook_event_types_enum: Array<Webhook_Event_Types_Enum>;
  /** fetch data from the table: "webhook_event_types_enum" using primary key columns */
  webhook_event_types_enum_by_pk?: Maybe<Webhook_Event_Types_Enum>;
  /** fetch data from the table: "webhook_subscriptions" */
  webhook_subscriptions: Array<Webhook_Subscriptions>;
  /** fetch aggregated fields from the table: "webhook_subscriptions" */
  webhook_subscriptions_aggregate: Webhook_Subscriptions_Aggregate;
  /** fetch data from the table: "webhook_subscriptions" using primary key columns */
  webhook_subscriptions_by_pk?: Maybe<Webhook_Subscriptions>;
  /** fetch data from the table: "webhook_subscriptions_event_types" */
  webhook_subscriptions_event_types: Array<Webhook_Subscriptions_Event_Types>;
  /** fetch data from the table: "webhook_subscriptions_event_types" using primary key columns */
  webhook_subscriptions_event_types_by_pk?: Maybe<Webhook_Subscriptions_Event_Types>;
  /** fetch data from the table: "window_view_enum" */
  window_view_enum: Array<Window_View_Enum>;
  /** fetch data from the table: "window_view_enum" using primary key columns */
  window_view_enum_by_pk?: Maybe<Window_View_Enum>;
};


export type Query_RootActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootActivities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootActivity_FeedArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Order_By>>;
  where?: InputMaybe<Activity_Feed_Bool_Exp>;
};


export type Query_RootActivity_Feed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Order_By>>;
  where?: InputMaybe<Activity_Feed_Bool_Exp>;
};


export type Query_RootActivity_Feed_By_PkArgs = {
  activity_id: Scalars['uuid']['input'];
};


export type Query_RootActivity_Feed_QuarantineArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Quarantine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Quarantine_Order_By>>;
  where?: InputMaybe<Activity_Feed_Quarantine_Bool_Exp>;
};


export type Query_RootActivity_Feed_StatusArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Status_Order_By>>;
  where?: InputMaybe<Activity_Feed_Status_Bool_Exp>;
};


export type Query_RootAddress_Display_Options_EnumArgs = {
  distinct_on?: InputMaybe<Array<Address_Display_Options_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Display_Options_Enum_Order_By>>;
  where?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
};


export type Query_RootAddress_Display_Options_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootAgenciesArgs = {
  distinct_on?: InputMaybe<Array<Agencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agencies_Order_By>>;
  where?: InputMaybe<Agencies_Bool_Exp>;
};


export type Query_RootAgent_StatisticsArgs = {
  args: Agent_Statistics_Args;
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Query_RootAgent_StatsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Query_RootAgent_Stats_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Query_RootAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Order_By>>;
  where?: InputMaybe<Agents_Bool_Exp>;
};


export type Query_RootApi_KeysArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Order_By>>;
  where?: InputMaybe<Api_Keys_Bool_Exp>;
};


export type Query_RootApi_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Order_By>>;
  where?: InputMaybe<Api_Keys_Bool_Exp>;
};


export type Query_RootApi_Keys_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootApi_Keys_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Teams_Order_By>>;
  where?: InputMaybe<Api_Keys_Teams_Bool_Exp>;
};


export type Query_RootApi_Keys_Teams_By_PkArgs = {
  api_key_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
};


export type Query_RootAppraisalsArgs = {
  distinct_on?: InputMaybe<Array<Appraisals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Order_By>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


export type Query_RootAppraisals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuto_Assign_RankingArgs = {
  lead_id: Scalars['uuid']['input'];
};


export type Query_RootAuto_Assign_Ranking_ChArgs = {
  cut_off_date?: InputMaybe<Scalars['date']['input']>;
  lead_id: Scalars['uuid']['input'];
};


export type Query_RootAvailable_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Available_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Available_Email_Templates_Order_By>>;
  where?: InputMaybe<Available_Email_Templates_Bool_Exp>;
};


export type Query_RootBed_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Bed_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bed_Type_Enum_Order_By>>;
  where?: InputMaybe<Bed_Type_Enum_Bool_Exp>;
};


export type Query_RootBed_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Query_RootBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Query_RootBuyer_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Query_RootCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Query_RootCatchment_Areas_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  tenant_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootCh_BuildingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Buildings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Buildings_Order_By>>;
  where?: InputMaybe<Ch_Buildings_Bool_Exp>;
};


export type Query_RootCh_Buildings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCh_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootCh_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCh_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootCh_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootCh_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootCh_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Bool_Exp>;
};


export type Query_RootCh_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Bool_Exp>;
};


export type Query_RootCh_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootCh_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootCh_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCh_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_House_Appt_Price_StatsArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_House_Appt_Price_Stats_AggregateArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_Listings_Stats_By_Place_SlugArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_Listings_Stats_By_Place_Slug_AggregateArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_Map_Place_StatsArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_Map_Place_Stats_AggregateArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootCh_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootCh_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Query_RootCh_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Query_RootCh_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCh_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootCh_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootCh_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCh_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Plots_Order_By>>;
  where?: InputMaybe<Ch_Plots_Bool_Exp>;
};


export type Query_RootCh_Plots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCh_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootCh_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootCh_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootCh_Price_Stats_QuantilesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_Quantiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Query_RootCh_Price_Stats_Quantiles_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootCh_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Property_Types_Order_By>>;
  where?: InputMaybe<Ch_Property_Types_Bool_Exp>;
};


export type Query_RootCh_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootCh_Search_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Search_Places_AggregateArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Query_RootCh_StatesArgs = {
  distinct_on?: InputMaybe<Array<Ch_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_States_Order_By>>;
  where?: InputMaybe<Ch_States_Bool_Exp>;
};


export type Query_RootCh_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};


export type Query_RootCh_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};


export type Query_RootChat_Api_ChatArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
};


export type Query_RootChat_Api_Chat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
};


export type Query_RootChat_Api_Chat_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Api_Chat_Model_SettingArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Model_Setting_Bool_Exp>;
};


export type Query_RootChat_Api_Chat_Model_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Model_Setting_Bool_Exp>;
};


export type Query_RootChat_Api_Chat_Model_Setting_By_PkArgs = {
  model_id: Scalars['String']['input'];
};


export type Query_RootChat_Api_Conversation_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Api_Conversation_PartArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Part_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Part_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Part_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Api_Conversation_Tool_CallArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Tool_Call_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Tool_Call_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Api_Conversation_TraceArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Trace_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Trace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Trace_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
};


export type Query_RootChat_Api_Conversation_Trace_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Api_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Message_Bool_Exp>;
};


export type Query_RootChat_Api_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Message_Bool_Exp>;
};


export type Query_RootChat_Api_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Api_Model_PricingArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Model_Pricing_Order_By>>;
  where?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
};


export type Query_RootChat_Api_Model_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Model_Pricing_Order_By>>;
  where?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
};


export type Query_RootChat_Api_Model_Pricing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChat_Api_Mutation_AuditArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Mutation_Audit_Order_By>>;
  where?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
};


export type Query_RootChat_Api_Mutation_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Mutation_Audit_Order_By>>;
  where?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
};


export type Query_RootChat_Api_Mutation_Audit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCheck_Portal_ConnectionArgs = {
  portal_id: Scalars['uuid']['input'];
};


export type Query_RootCma_Report_FilesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Query_RootCma_Report_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Query_RootCma_Report_Files_By_PkArgs = {
  cma_report_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


export type Query_RootCma_Report_Source_EnumArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Source_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Source_Enum_Order_By>>;
  where?: InputMaybe<Cma_Report_Source_Enum_Bool_Exp>;
};


export type Query_RootCma_Report_Source_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Query_RootCma_Reports_Agent_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};


export type Query_RootCma_Reports_Agent_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Query_RootCma_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCma_Reports_ComparablesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Comparables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Comparables_Order_By>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


export type Query_RootCma_Reports_Comparables_By_PkArgs = {
  aggregates_db__merged_listings_clusters_id: Scalars['bigint']['input'];
  cma_report_id: Scalars['uuid']['input'];
};


export type Query_RootCma_Reports_Property_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Property_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Property_Transactions_Bool_Exp>;
};


export type Query_RootCma_Reports_Property_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCma_Reports_User_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_User_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_User_Reviews_Order_By>>;
  where?: InputMaybe<Cma_Reports_User_Reviews_Bool_Exp>;
};


export type Query_RootCma_Reports_User_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Query_RootCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Query_RootCooling_EnumArgs = {
  distinct_on?: InputMaybe<Array<Cooling_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cooling_Enum_Order_By>>;
  where?: InputMaybe<Cooling_Enum_Bool_Exp>;
};


export type Query_RootCooling_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Query_RootCountries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCrm_Csat_StatusArgs = {
  survey_id: Scalars['uuid']['input'];
};


export type Query_RootDevelopment_FilesArgs = {
  distinct_on?: InputMaybe<Array<Development_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Files_Order_By>>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};


export type Query_RootDevelopment_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Files_Order_By>>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};


export type Query_RootDevelopment_Files_By_PkArgs = {
  development_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


export type Query_RootDevelopment_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


export type Query_RootDevelopment_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


export type Query_RootDevelopment_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDevelopment_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Development_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Mappings_Order_By>>;
  where?: InputMaybe<Development_Mappings_Bool_Exp>;
};


export type Query_RootDevelopment_Mappings_By_PkArgs = {
  image_id: Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
};


export type Query_RootDevelopment_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Development_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Status_Enum_Order_By>>;
  where?: InputMaybe<Development_Status_Enum_Bool_Exp>;
};


export type Query_RootDevelopment_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDevelopmentsArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Query_RootDevelopments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Query_RootDevelopments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDictionariesArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Order_By>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Query_RootDictionaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Order_By>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Query_RootDictionaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDictionaries_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Types_Enum_Order_By>>;
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
};


export type Query_RootDictionaries_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDoc_Template_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Themes_Order_By>>;
  where?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
};


export type Query_RootDoc_Template_Themes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDoc_Template_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Type_Enum_Order_By>>;
  where?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
};


export type Query_RootDoc_Template_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootDoc_Template_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Versions_Order_By>>;
  where?: InputMaybe<Doc_Template_Versions_Bool_Exp>;
};


export type Query_RootDoc_Template_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDoc_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Order_By>>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};


export type Query_RootDoc_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDoc_Templates_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Tenants_Order_By>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


export type Query_RootDoc_Templates_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDocument_Recipient_StatusArgs = {
  document_id: Scalars['String']['input'];
  document_type?: InputMaybe<Scalars['String']['input']>;
  recipient_user_id: Scalars['uuid']['input'];
};


export type Query_RootDocument_RecipientsArgs = {
  document_id: Scalars['String']['input'];
  document_type?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootDocument_StatsArgs = {
  document_id: Scalars['String']['input'];
  document_type?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  recipient_id?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['timestamptz']['input']>;
};


export type Query_RootEmail_CampaignsArgs = {
  distinct_on?: InputMaybe<Array<Email_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Campaigns_Order_By>>;
  where?: InputMaybe<Email_Campaigns_Bool_Exp>;
};


export type Query_RootEmail_Campaigns_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Campaigns_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Campaigns_Order_By>>;
  where?: InputMaybe<Email_Campaigns_Bool_Exp>;
};


export type Query_RootEmail_Campaigns_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_Messages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Messages_Order_By>>;
  where?: InputMaybe<Email_Messages_Bool_Exp>;
};


export type Query_RootEmail_SequencesArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Order_By>>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};


export type Query_RootEmail_Sequences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_Sequences_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_Sequences_StepsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Query_RootEmail_Sequences_Steps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Query_RootEmail_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmail_ThreadsArgs = {
  distinct_on?: InputMaybe<Array<Email_Threads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Threads_Order_By>>;
  where?: InputMaybe<Email_Threads_Bool_Exp>;
};


export type Query_RootEmail_Threads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Query_RootEmails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Query_RootEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Query_RootEnquiries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEnquiries_Source_EnumArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Source_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Source_Enum_Order_By>>;
  where?: InputMaybe<Enquiries_Source_Enum_Bool_Exp>;
};


export type Query_RootEnquiries_Source_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootEs_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootEs_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEs_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootEs_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootEs_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootEs_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Bool_Exp>;
};


export type Query_RootEs_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Bool_Exp>;
};


export type Query_RootEs_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootEs_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootEs_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEs_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_House_Appt_Price_StatsArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_House_Appt_Price_Stats_AggregateArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_Listings_Stats_By_Place_SlugArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_Listings_Stats_By_Place_Slug_AggregateArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_Map_Place_StatsArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_Map_Place_Stats_AggregateArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootEs_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootEs_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Query_RootEs_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Query_RootEs_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEs_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootEs_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootEs_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEs_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Es_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Plots_Order_By>>;
  where?: InputMaybe<Es_Plots_Bool_Exp>;
};


export type Query_RootEs_Plots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEs_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootEs_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootEs_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Query_RootEs_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootEs_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootEs_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootEs_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Es_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Property_Types_Order_By>>;
  where?: InputMaybe<Es_Property_Types_Bool_Exp>;
};


export type Query_RootEs_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootEs_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Query_RootEs_StatesArgs = {
  distinct_on?: InputMaybe<Array<Es_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_States_Order_By>>;
  where?: InputMaybe<Es_States_Bool_Exp>;
};


export type Query_RootEs_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};


export type Query_RootEs_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};


export type Query_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Query_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFind_Cma_Leads_By_AddressArgs = {
  args: Find_Cma_Leads_By_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootFind_Cma_Leads_By_Address_AggregateArgs = {
  args: Find_Cma_Leads_By_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootFind_Onboarding_Social_LinksArgs = {
  website_url: Scalars['String']['input'];
};


export type Query_RootFind_Price_Map_PlacesArgs = {
  args: Find_Price_Map_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootFind_Price_Map_Places_AggregateArgs = {
  args: Find_Price_Map_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootFr_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootFr_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFr_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootFr_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootFr_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootFr_Energy_CertificatesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Energy_Certificates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Energy_Certificates_Order_By>>;
  where?: InputMaybe<Fr_Energy_Certificates_Bool_Exp>;
};


export type Query_RootFr_Energy_Certificates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFr_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Bool_Exp>;
};


export type Query_RootFr_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Bool_Exp>;
};


export type Query_RootFr_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootFr_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootFr_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFr_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_House_Appt_Price_StatsArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_House_Appt_Price_Stats_AggregateArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_Listings_Stats_By_Place_SlugArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_Listings_Stats_By_Place_Slug_AggregateArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_Map_Place_StatsArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_Map_Place_Stats_AggregateArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootFr_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootFr_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Query_RootFr_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Query_RootFr_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFr_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootFr_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootFr_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFr_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Plots_Order_By>>;
  where?: InputMaybe<Fr_Plots_Bool_Exp>;
};


export type Query_RootFr_Plots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFr_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootFr_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootFr_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Query_RootFr_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootFr_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootFr_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootFr_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Property_Types_Order_By>>;
  where?: InputMaybe<Fr_Property_Types_Bool_Exp>;
};


export type Query_RootFr_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootFr_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Query_RootFr_StatesArgs = {
  distinct_on?: InputMaybe<Array<Fr_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_States_Order_By>>;
  where?: InputMaybe<Fr_States_Bool_Exp>;
};


export type Query_RootFr_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};


export type Query_RootFr_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};


export type Query_RootFsbo_Seller_ClusterArgs = {
  args: Fsbo_Seller_Cluster_Args;
  distinct_on?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Order_By>>;
  where?: InputMaybe<Fsbo_Seller_Cluster_Result_Bool_Exp>;
};


export type Query_RootFsbo_Seller_Cluster_ResultArgs = {
  distinct_on?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Order_By>>;
  where?: InputMaybe<Fsbo_Seller_Cluster_Result_Bool_Exp>;
};


export type Query_RootFsbo_Seller_Cluster_Result_By_PkArgs = {
  kind: Scalars['String']['input'];
  lot_id: Scalars['uuid']['input'];
};


export type Query_RootGenerate_Agency_DescriptionArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  agency_name: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGenerate_Cma_DescriptionArgs = {
  cma_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGenerate_Development_Image_MetadataArgs = {
  development_image_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGenerate_Image_MetadataArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  property_image_id: Scalars['uuid']['input'];
};


export type Query_RootGenerate_Listing_TitleArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  lot_id: Scalars['uuid']['input'];
};


export type Query_RootGenerate_Listings_DescriptionArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  lot_id: Scalars['uuid']['input'];
};


export type Query_RootGeocode_AddressArgs = {
  address: Scalars['String']['input'];
  country_code?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGetMyHomeAgentExpandedStatsArgs = {
  agentId: Scalars['uuid']['input'];
  propertyId: Scalars['uuid']['input'];
};


export type Query_RootGetMyHomeAgentsArgs = {
  leadId: Scalars['uuid']['input'];
};


export type Query_RootGet_Activities_Feed_For_LeadArgs = {
  args: Get_Activities_Feed_For_Lead_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootGet_Activities_Feed_For_Lead_AggregateArgs = {
  args: Get_Activities_Feed_For_Lead_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootGet_Activities_Feed_For_LotArgs = {
  args: Get_Activities_Feed_For_Lot_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootGet_Activities_Feed_For_Lot_AggregateArgs = {
  args: Get_Activities_Feed_For_Lot_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootGet_Activities_Feed_For_UserArgs = {
  args: Get_Activities_Feed_For_User_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootGet_Activities_Feed_For_User_AggregateArgs = {
  args: Get_Activities_Feed_For_User_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Query_RootGet_Agents_RankingArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootGet_Agents_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootGet_Agents_Ranking_DedupedArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Deduped_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootGet_Agents_Ranking_Deduped_AggregateArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Deduped_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootGet_Api_KeyArgs = {
  partnerId: Scalars['String']['input'];
};


export type Query_RootGet_Appraisals_By_SlugArgs = {
  args: Get_Appraisals_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Query_RootGet_Catchment_AreaArgs = {
  args: Get_Catchment_Area_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootGet_Catchment_Area_AggregateArgs = {
  args: Get_Catchment_Area_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootGet_Close_LeadArgs = {
  lead_id: Scalars['String']['input'];
};


export type Query_RootGet_Cma_Agent_TransactionsArgs = {
  args: Get_Cma_Agent_Transactions_Args;
  distinct_on?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};


export type Query_RootGet_Email_Template_SuggestionsArgs = {
  buyerLeadId?: InputMaybe<Scalars['uuid']['input']>;
  developmentId?: InputMaybe<Scalars['uuid']['input']>;
  enquiryId?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
  leadId?: InputMaybe<Scalars['uuid']['input']>;
  listingId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']>>;
  senderId?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGet_Leads_StatisticsArgs = {
  end_date?: InputMaybe<Scalars['date']['input']>;
  grouping_mode?: InputMaybe<GetLeadsStatisticsGroupingMode>;
  lead_origins?: InputMaybe<Array<GetLeadsStatisticsLeadOrigin>>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  start_date?: InputMaybe<Scalars['date']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGet_Legacy_Api_KeyArgs = {
  partnerId: Scalars['String']['input'];
};


export type Query_RootGet_Listing_ReferencesArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGet_Local_Activity_FeedArgs = {
  args: Get_Local_Activity_Feed_Args;
  distinct_on?: InputMaybe<Array<Local_Activity_Feed_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Local_Activity_Feed_Items_Order_By>>;
  where?: InputMaybe<Local_Activity_Feed_Items_Bool_Exp>;
};


export type Query_RootGet_Local_Activity_Feed_AggregateArgs = {
  args: Get_Local_Activity_Feed_Args;
  distinct_on?: InputMaybe<Array<Local_Activity_Feed_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Local_Activity_Feed_Items_Order_By>>;
  where?: InputMaybe<Local_Activity_Feed_Items_Bool_Exp>;
};


export type Query_RootGet_Lot_Publication_HistoryArgs = {
  args: Get_Lot_Publication_History_Args;
  distinct_on?: InputMaybe<Array<Lot_Publication_History_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Publication_History_Result_Order_By>>;
  where?: InputMaybe<Lot_Publication_History_Result_Bool_Exp>;
};


export type Query_RootGet_Monthly_PerfArgs = {
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};


export type Query_RootGet_Nearby_AppraisalsArgs = {
  args: Get_Nearby_Appraisals_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Query_RootGet_Nearby_ReviewsArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootGet_Nearby_Reviews_AggregateArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootGet_Nearby_TransactionsArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootGet_Nearby_Transactions_AggregateArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootGet_Online_Listing_Map_DataArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootGet_Online_Listing_Map_Data_AggregateArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootGet_Property_Transactions_DistanceArgs = {
  args: Get_Property_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Query_RootGet_Property_Transactions_Distance_AggregateArgs = {
  args: Get_Property_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Query_RootGet_Reviews_In_LocationArgs = {
  args: Get_Reviews_In_Location_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootGet_Reviews_In_Location_AggregateArgs = {
  args: Get_Reviews_In_Location_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_ListingsArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_AggregateArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_IdsArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_Ids_AggregateArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_VectorArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Similar_Online_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootGet_Surrounding_Listing_PlacesArgs = {
  listingId: Scalars['uuid']['input'];
  placeType: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootGet_Teams_RankingArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Query_RootGet_Teams_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Query_RootGet_Teams_Ranking_By_DistanceArgs = {
  args: Get_Teams_Ranking_By_Distance_Args;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Query_RootGet_Teams_Ranking_By_Distance_AggregateArgs = {
  args: Get_Teams_Ranking_By_Distance_Args;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Query_RootGet_Top_Competitor_StatsArgs = {
  competitor_team_ids: Array<Scalars['uuid']['input']>;
};


export type Query_RootGet_Translated_EnumArgs = {
  args: Get_Translated_Enum_Args;
  distinct_on?: InputMaybe<Array<Translated_Enums_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translated_Enums_Order_By>>;
  where?: InputMaybe<Translated_Enums_Bool_Exp>;
};


export type Query_RootGet_Valuation_LinkArgs = {
  agent_id: Scalars['String']['input'];
};


export type Query_RootGlobal_StatisticsArgs = {
  args: Global_Statistics_Args;
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Query_RootGlobal_StatsArgs = {
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Query_RootGlobal_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
};


export type Query_RootGoogle_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Google_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Addresses_Order_By>>;
  where?: InputMaybe<Google_Addresses_Bool_Exp>;
};


export type Query_RootGoogle_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Query_RootGoogle_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Query_RootGoogle_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootHeating_Distribution_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Distribution_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Distribution_Enum_Order_By>>;
  where?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
};


export type Query_RootHeating_Distribution_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootHeating_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Enum_Order_By>>;
  where?: InputMaybe<Heating_Enum_Bool_Exp>;
};


export type Query_RootHeating_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Query_RootImages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootImpression_DotsArgs = {
  agency_uuid: Scalars['uuid']['input'];
  agent_uuid?: InputMaybe<Scalars['uuid']['input']>;
  date_range_end: Scalars['String']['input'];
  date_range_start: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
};


export type Query_RootImpressions_Grouped_By_ColumnArgs = {
  agency_uuid?: InputMaybe<Scalars['uuid']['input']>;
  agency_uuids?: InputMaybe<Array<Scalars['uuid']['input']>>;
  agent_uuid?: InputMaybe<Scalars['uuid']['input']>;
  date_range_end?: InputMaybe<Scalars['String']['input']>;
  date_range_start?: InputMaybe<Scalars['String']['input']>;
  event_names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  grouping_column?: InputMaybe<ImpressionsGroupingColumn>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  order_by_column?: InputMaybe<Scalars['String']['input']>;
  order_by_direction?: InputMaybe<Scalars['String']['input']>;
  page_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Query_RootImpressions_TotalArgs = {
  agency_uuid: Scalars['uuid']['input'];
  agent_uuid?: InputMaybe<Scalars['uuid']['input']>;
  date_range_end: Scalars['String']['input'];
  date_range_start: Scalars['String']['input'];
  event_names?: InputMaybe<Array<Scalars['String']['input']>>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  page_types?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type Query_RootImprove_TextArgs = {
  text?: InputMaybe<Scalars['String']['input']>;
};


export type Query_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Query_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Query_RootInvitations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Query_RootInvoices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIt_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootIt_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIt_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootIt_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootIt_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootIt_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Bool_Exp>;
};


export type Query_RootIt_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Bool_Exp>;
};


export type Query_RootIt_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootIt_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootIt_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIt_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Query_RootIt_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Query_RootIt_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootIt_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootIt_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Query_RootIt_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Query_RootIt_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootIt_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootIt_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootIt_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootIt_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootIt_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIt_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootIt_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootIt_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Query_RootIt_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Query_RootIt_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootIt_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootIt_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootIt_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<It_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Property_Types_Order_By>>;
  where?: InputMaybe<It_Property_Types_Bool_Exp>;
};


export type Query_RootIt_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootIt_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootIt_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Query_RootIt_StatesArgs = {
  distinct_on?: InputMaybe<Array<It_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_States_Order_By>>;
  where?: InputMaybe<It_States_Bool_Exp>;
};


export type Query_RootIt_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};


export type Query_RootIt_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};


export type Query_RootLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Query_RootLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Query_RootLead_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLead_StagesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Query_RootLead_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Query_RootLead_Stages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootLeads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLeads_StatusArgs = {
  distinct_on?: InputMaybe<Array<Leads_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Status_Order_By>>;
  where?: InputMaybe<Leads_Status_Bool_Exp>;
};


export type Query_RootLeads_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLeads_TagsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Query_RootLeads_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Query_RootLeads_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLeads_The_Same_AddressArgs = {
  args: Leads_The_Same_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootLeads_The_Same_Address_AggregateArgs = {
  args: Leads_The_Same_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootListing_Ga4_StatsArgs = {
  date_from: Scalars['String']['input'];
  date_to: Scalars['String']['input'];
  lot_id: Scalars['uuid']['input'];
};


export type Query_RootLocality_AdjacencyArgs = {
  distinct_on?: InputMaybe<Array<Locality_Adjacency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locality_Adjacency_Order_By>>;
  where?: InputMaybe<Locality_Adjacency_Bool_Exp>;
};


export type Query_RootLocality_Adjacency_By_PkArgs = {
  adj_locality_id: Scalars['uuid']['input'];
  locality_id: Scalars['uuid']['input'];
};


export type Query_RootLot_Reference_AliasesArgs = {
  distinct_on?: InputMaybe<Array<Lot_Reference_Aliases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Reference_Aliases_Order_By>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


export type Query_RootLot_Reference_Aliases_By_PkArgs = {
  reference_alias_decoded: Scalars['Int']['input'];
};


export type Query_RootLot_SellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Query_RootLot_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Query_RootLot_Sellers_By_PkArgs = {
  lot_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootLots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootLots_Member_Access_EnumArgs = {
  distinct_on?: InputMaybe<Array<Lots_Member_Access_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Member_Access_Enum_Order_By>>;
  where?: InputMaybe<Lots_Member_Access_Enum_Bool_Exp>;
};


export type Query_RootLots_Member_Access_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootLots_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Lots_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Status_Enum_Order_By>>;
  where?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
};


export type Query_RootLots_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMarketing_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketing_Metadata_Order_By>>;
  where?: InputMaybe<Marketing_Metadata_Bool_Exp>;
};


export type Query_RootMarketing_Metadata_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMarketplace_Conversation_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversation_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversation_Participants_Order_By>>;
  where?: InputMaybe<Marketplace_Conversation_Participants_Bool_Exp>;
};


export type Query_RootMarketplace_Conversation_Participants_By_PkArgs = {
  conversation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Query_RootMarketplace_Conversation_Public_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Order_By>>;
  where?: InputMaybe<Marketplace_Conversation_Public_Participants_Bool_Exp>;
};


export type Query_RootMarketplace_ConversationsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversations_Order_By>>;
  where?: InputMaybe<Marketplace_Conversations_Bool_Exp>;
};


export type Query_RootMarketplace_Conversations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMarketplace_ListingArgs = {
  country_code: MarketplaceCountryCode;
  language: Scalars['String']['input'];
  listing_id: Scalars['Int']['input'];
};


export type Query_RootMarketplace_Listing_MarkersArgs = {
  limit: Scalars['Int']['input'];
  search: MarketplaceSearchInput;
};


export type Query_RootMarketplace_ListingsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search: MarketplaceSearchInput;
  sort: MarketplaceListingSort;
};


export type Query_RootMarketplace_Message_Delivery_Channel_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Message_Delivery_Channel_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Message_Delivery_Channel_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Message_Delivery_Channel_Enum_Bool_Exp>;
};


export type Query_RootMarketplace_Message_Delivery_Channel_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMarketplace_Message_Delivery_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Message_Delivery_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Message_Delivery_Status_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Message_Delivery_Status_Enum_Bool_Exp>;
};


export type Query_RootMarketplace_Message_Delivery_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMarketplace_Message_Origin_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Message_Origin_Enum_Bool_Exp>;
};


export type Query_RootMarketplace_Message_Origin_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMarketplace_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Messages_Order_By>>;
  where?: InputMaybe<Marketplace_Messages_Bool_Exp>;
};


export type Query_RootMarketplace_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMarketplace_Participant_Role_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Participant_Role_Enum_Bool_Exp>;
};


export type Query_RootMarketplace_Participant_Role_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMarketplace_Place_SuggestionsArgs = {
  country_code: MarketplaceCountryCode;
  language: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  search: Scalars['String']['input'];
};


export type Query_RootMarketplace_Popular_PlacesArgs = {
  country_code: MarketplaceCountryCode;
  language: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};


export type Query_RootMarketplace_Similar_ListingsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search: MarketplaceSimilarSearchInput;
};


export type Query_RootMarketplace_Similar_Online_ListingsArgs = {
  args: Get_Marketplace_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootMarketplace_Similar_Online_Listings_AggregateArgs = {
  args: Get_Marketplace_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootMeArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootMe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootMls_Agent_Buyer_MatchesArgs = {
  args: Mls_Agent_Buyer_Matches_Args;
  distinct_on?: InputMaybe<Array<Mls_Buyer_Match_Edge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Buyer_Match_Edge_Order_By>>;
  where?: InputMaybe<Mls_Buyer_Match_Edge_Bool_Exp>;
};


export type Query_RootMls_BrokersArgs = {
  distinct_on?: InputMaybe<Array<Mls_Brokers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Brokers_Order_By>>;
  where?: InputMaybe<Mls_Brokers_Bool_Exp>;
};


export type Query_RootMls_Brokers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Brokers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Brokers_Order_By>>;
  where?: InputMaybe<Mls_Brokers_Bool_Exp>;
};


export type Query_RootMls_Buyer_Match_EdgeArgs = {
  distinct_on?: InputMaybe<Array<Mls_Buyer_Match_Edge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Buyer_Match_Edge_Order_By>>;
  where?: InputMaybe<Mls_Buyer_Match_Edge_Bool_Exp>;
};


export type Query_RootMls_Commission_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Mls_Commission_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Commission_Type_Enum_Order_By>>;
  where?: InputMaybe<Mls_Commission_Type_Enum_Bool_Exp>;
};


export type Query_RootMls_Commission_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMls_Listing_Enquiry_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Order_By>>;
  where?: InputMaybe<Mls_Listing_Enquiry_Settings_Bool_Exp>;
};


export type Query_RootMls_Listing_Enquiry_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Order_By>>;
  where?: InputMaybe<Mls_Listing_Enquiry_Settings_Bool_Exp>;
};


export type Query_RootMls_Listing_Enquiry_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_LotsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Query_RootMls_Lots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Query_RootMls_Lots_In_ViewportArgs = {
  args: Mls_Lots_In_Viewport_Args;
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Query_RootMls_Lots_In_Viewport_AggregateArgs = {
  args: Mls_Lots_In_Viewport_Args;
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Query_RootMls_Network_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Network_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Network_Teams_Order_By>>;
  where?: InputMaybe<Mls_Network_Teams_Bool_Exp>;
};


export type Query_RootMls_Network_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Network_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Network_Teams_Order_By>>;
  where?: InputMaybe<Mls_Network_Teams_Bool_Exp>;
};


export type Query_RootMls_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Settings_Order_By>>;
  where?: InputMaybe<Mls_Settings_Bool_Exp>;
};


export type Query_RootMls_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_Share_Mode_EnumArgs = {
  distinct_on?: InputMaybe<Array<Mls_Share_Mode_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Share_Mode_Enum_Order_By>>;
  where?: InputMaybe<Mls_Share_Mode_Enum_Bool_Exp>;
};


export type Query_RootMls_Share_Mode_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMls_Share_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Mls_Share_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Share_Status_Enum_Order_By>>;
  where?: InputMaybe<Mls_Share_Status_Enum_Bool_Exp>;
};


export type Query_RootMls_Share_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootMls_SharesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


export type Query_RootMls_Shares_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


export type Query_RootMls_Shares_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMls_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Teams_Order_By>>;
  where?: InputMaybe<Mls_Teams_Bool_Exp>;
};


export type Query_RootMls_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Teams_Order_By>>;
  where?: InputMaybe<Mls_Teams_Bool_Exp>;
};


export type Query_RootNearby_ImpressionsArgs = {
  agency_uuids: Array<Scalars['uuid']['input']>;
  date_range_end: Scalars['String']['input'];
  date_range_start: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
};


export type Query_RootNotification_Setting_ImpactArgs = {
  args: Notification_Setting_Impact_Args;
  distinct_on?: InputMaybe<Array<Notification_Setting_Impact_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Setting_Impact_Result_Order_By>>;
  where?: InputMaybe<Notification_Setting_Impact_Result_Bool_Exp>;
};


export type Query_RootNotification_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Settings_Order_By>>;
  where?: InputMaybe<Notification_Settings_Bool_Exp>;
};


export type Query_RootNotification_Settings_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Query_RootNylas_Account_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Nylas_Account_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nylas_Account_Configs_Order_By>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


export type Query_RootNylas_Account_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Query_RootOffers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOnline_Listing_Map_DataArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootOnline_Listing_Map_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Query_RootOnline_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootOnline_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Query_RootOnline_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootOrganisation_Billing_SummaryArgs = {
  organisation_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_Engagement_ScoreArgs = {
  organisation_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Images_Order_By>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


export type Query_RootOrganisation_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_Monitoring_AnalyticsArgs = {
  agency_uuids: Array<Scalars['uuid']['input']>;
  date_range_end: Scalars['String']['input'];
  date_range_start: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
};


export type Query_RootOrganisation_Posthog_CsatArgs = {
  date_range_end?: InputMaybe<Scalars['String']['input']>;
  date_range_start?: InputMaybe<Scalars['String']['input']>;
  organisation_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_Posthog_UsageArgs = {
  date_range_end: Scalars['String']['input'];
  date_range_start: Scalars['String']['input'];
  organisation_id: Scalars['uuid']['input'];
};


export type Query_RootOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Users_Order_By>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


export type Query_RootOrganisation_Visibility_ScoreArgs = {
  hostname: Scalars['String']['input'];
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  window_days?: InputMaybe<Scalars['Int']['input']>;
};


export type Query_RootOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootOrganisations_SearchArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootOrganisations_Search_AggregateArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Query_RootParcel_At_PointArgs = {
  country: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type Query_RootPhone_Number_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Enum_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};


export type Query_RootPhone_Number_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootPhone_Numbers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPipelinesArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Query_RootPipelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Query_RootPipelines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPl_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Query_RootPl_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Query_RootPl_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootPl_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPl_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootPl_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootPl_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Bool_Exp>;
};


export type Query_RootPl_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Bool_Exp>;
};


export type Query_RootPl_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPl_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPl_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPl_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Query_RootPl_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Query_RootPl_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pl_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootPl_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pl_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootPl_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


export type Query_RootPl_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


export type Query_RootPl_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Query_RootPl_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Query_RootPl_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPl_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Query_RootPl_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Query_RootPl_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Query_RootPl_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Query_RootPl_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootPl_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootPl_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPl_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootPl_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootPl_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPl_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Query_RootPl_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Query_RootPl_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootPl_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootPl_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootPl_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Property_Types_Order_By>>;
  where?: InputMaybe<Pl_Property_Types_Bool_Exp>;
};


export type Query_RootPl_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPl_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Query_RootPl_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Query_RootPl_StatesArgs = {
  distinct_on?: InputMaybe<Array<Pl_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_States_Order_By>>;
  where?: InputMaybe<Pl_States_Bool_Exp>;
};


export type Query_RootPl_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};


export type Query_RootPl_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};


export type Query_RootPlace_By_SlugArgs = {
  args?: InputMaybe<Place_By_Slug_Args>;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlace_By_Slug_AggregateArgs = {
  args?: InputMaybe<Place_By_Slug_Args>;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlace_By_TypeArgs = {
  args: Place_By_Type_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlace_By_Type_AggregateArgs = {
  args: Place_By_Type_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlaces_Agent_RankingArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootPlaces_Agent_Ranking_AggregateArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Query_RootPlaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootPlaces_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Query_RootPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Query_RootPortal_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortalsArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Query_RootPortals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Query_RootPortals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortals_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portals_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Types_Enum_Order_By>>;
  where?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
};


export type Query_RootPortals_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Query_RootProperties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_AppraisableArgs = {
  property_id: Scalars['uuid']['input'];
};


export type Query_RootProperty_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Query_RootProperty_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Query_RootProperty_Files_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  property_id: Scalars['uuid']['input'];
};


export type Query_RootProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Query_RootProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Query_RootProperty_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Search_Aggregator_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Aggregator_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Aggregator_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
};


export type Query_RootProperty_Search_Aggregator_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProperty_Search_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Source_Bool_Exp>;
};


export type Query_RootProperty_Search_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootProperty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Query_RootProperty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Query_RootProperty_Searches_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Searches_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Places_Order_By>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


export type Query_RootProperty_Searches_Places_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_search_id: Scalars['uuid']['input'];
};


export type Query_RootProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootProperty_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Transactions_Country_ViewArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Country_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Country_View_Order_By>>;
  where?: InputMaybe<Property_Transactions_Country_View_Bool_Exp>;
};


export type Query_RootProperty_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Query_RootProperty_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Query_RootProperty_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProperty_Transactions_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Listings_Order_By>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


export type Query_RootProperty_Transactions_Listings_By_PkArgs = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};


export type Query_RootProperty_TypesArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Query_RootProperty_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Query_RootProperty_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProspection_Contact_Message_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Contact_Message_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Contact_Message_Templates_Order_By>>;
  where?: InputMaybe<Prospection_Contact_Message_Templates_Bool_Exp>;
};


export type Query_RootProspection_Contact_Message_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProspection_Contact_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Contact_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Contact_Settings_Order_By>>;
  where?: InputMaybe<Prospection_Contact_Settings_Bool_Exp>;
};


export type Query_RootProspection_Contact_Settings_By_PkArgs = {
  tenant_id: Scalars['uuid']['input'];
};


export type Query_RootProspection_Contact_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Contact_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Contact_Teams_Order_By>>;
  where?: InputMaybe<Prospection_Contact_Teams_Bool_Exp>;
};


export type Query_RootProspection_Contact_Teams_By_PkArgs = {
  team_id: Scalars['uuid']['input'];
};


export type Query_RootProspection_Map_Contact_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Order_By>>;
  where?: InputMaybe<Prospection_Map_Contact_Attempts_Bool_Exp>;
};


export type Query_RootProspection_Map_Contact_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Order_By>>;
  where?: InputMaybe<Prospection_Map_Contact_Attempts_Bool_Exp>;
};


export type Query_RootProspection_Map_Contact_Attempts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProspection_Map_Emailable_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Emailable_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Emailable_Leads_Order_By>>;
  where?: InputMaybe<Prospection_Map_Emailable_Leads_Bool_Exp>;
};


export type Query_RootProspection_Map_Full_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Full_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Full_Leads_Order_By>>;
  where?: InputMaybe<Prospection_Map_Full_Leads_Bool_Exp>;
};


export type Query_RootProspection_Map_Lead_Addresses_In_BboxArgs = {
  args?: InputMaybe<Prospection_Map_Lead_Addresses_In_Bbox_Args>;
  distinct_on?: InputMaybe<Array<Prospection_Map_Lead_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Lead_Addresses_Order_By>>;
  where?: InputMaybe<Prospection_Map_Lead_Addresses_Bool_Exp>;
};


export type Query_RootProspection_MarksArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Marks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Marks_Order_By>>;
  where?: InputMaybe<Prospection_Marks_Bool_Exp>;
};


export type Query_RootProspection_Marks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPt_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Query_RootPt_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Query_RootPt_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Query_RootPt_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPt_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootPt_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Rental_Listings_Bool_Exp>;
};


export type Query_RootPt_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Bool_Exp>;
};


export type Query_RootPt_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Bool_Exp>;
};


export type Query_RootPt_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPt_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPt_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPt_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Query_RootPt_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Query_RootPt_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pt_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootPt_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pt_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Query_RootPt_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


export type Query_RootPt_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


export type Query_RootPt_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Query_RootPt_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Query_RootPt_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPt_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Query_RootPt_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Query_RootPt_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Query_RootPt_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Query_RootPt_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootPt_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
};


export type Query_RootPt_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPt_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootPt_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Post_Merged_Listings_Bool_Exp>;
};


export type Query_RootPt_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootPt_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Query_RootPt_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Query_RootPt_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootPt_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
};


export type Query_RootPt_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Query_RootPt_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Property_Types_Order_By>>;
  where?: InputMaybe<Pt_Property_Types_Bool_Exp>;
};


export type Query_RootPt_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Query_RootPt_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Query_RootPt_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Query_RootPt_StatesArgs = {
  distinct_on?: InputMaybe<Array<Pt_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_States_Order_By>>;
  where?: InputMaybe<Pt_States_Bool_Exp>;
};


export type Query_RootPt_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};


export type Query_RootPt_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};


export type Query_RootPush_Notification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notification_Tokens_Order_By>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


export type Query_RootPush_Notification_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRead_Only_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Read_Only_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Read_Only_Tenants_Order_By>>;
  where?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
};


export type Query_RootRead_Portal_IdxArgs = {
  portal_id: Scalars['uuid']['input'];
};


export type Query_RootReview_Invitation_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Review_Invitation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Review_Invitation_Templates_Order_By>>;
  where?: InputMaybe<Review_Invitation_Templates_Bool_Exp>;
};


export type Query_RootReview_Invitation_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Invitation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Review_Invitation_Templates_Order_By>>;
  where?: InputMaybe<Review_Invitation_Templates_Bool_Exp>;
};


export type Query_RootReview_Invitation_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Query_RootReviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSearch_Brockers_In_Catchment_AreaArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Brockers_In_Catchment_Area_AggregateArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Buyer_Leads_TsvArgs = {
  args: Search_Buyer_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Query_RootSearch_Buyer_Leads_Tsv_AggregateArgs = {
  args: Search_Buyer_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Query_RootSearch_Close_LeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  query: Scalars['String']['input'];
};


export type Query_RootSearch_LeadsArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Leads_AggregateArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Leads_TsvArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Leads_Tsv_AggregateArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Query_RootSearch_Lots_TsvArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootSearch_Lots_Tsv_AggregateArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Query_RootSearch_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootSearch_Places_AggregateArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootSearch_Places_ExArgs = {
  args: Search_Places_Ex_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootSearch_Places_Ex_AggregateArgs = {
  args: Search_Places_Ex_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Query_RootSearch_Property_Transactions_TsvArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootSearch_Property_Transactions_Tsv_AggregateArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Query_RootSearch_Public_Agents_TsvArgs = {
  args: Search_Public_Agents_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Public_Agents_Tsv_AggregateArgs = {
  args: Search_Public_Agents_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Stripe_CustomersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  query: Scalars['String']['input'];
};


export type Query_RootSearch_Teams_TsvArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootSearch_Teams_Tsv_AggregateArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootSearch_UsersArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Users_AggregateArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Users_TsvArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSearch_Users_Tsv_AggregateArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootSeller_Notification_Frequency_EnumArgs = {
  distinct_on?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Order_By>>;
  where?: InputMaybe<Seller_Notification_Frequency_Enum_Bool_Exp>;
};


export type Query_RootSeller_Notification_Frequency_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootShared_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Query_RootShared_Portals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Query_RootShared_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSimilar_Online_Listings_IdsArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootSimilar_Online_Listings_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Query_RootSmart_ListsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Lists_Order_By>>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};


export type Query_RootSmart_Lists_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeam_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Team_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Images_Order_By>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


export type Query_RootTeam_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeam_Theme_ContextArgs = {
  document_id: Scalars['uuid']['input'];
  document_type: Scalars['String']['input'];
};


export type Query_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Query_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


export type Query_RootTeams_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Query_RootTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Query_RootTenant_Gender_EnumArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Gender_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenant_Gender_Enum_Order_By>>;
  where?: InputMaybe<Tenant_Gender_Enum_Bool_Exp>;
};


export type Query_RootTenant_Gender_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTenants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTransaction_ValuationsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Valuations_Order_By>>;
  where?: InputMaybe<Transaction_Valuations_Bool_Exp>;
};


export type Query_RootTransaction_Valuations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Valuations_Order_By>>;
  where?: InputMaybe<Transaction_Valuations_Bool_Exp>;
};


export type Query_RootTranslate_TextArgs = {
  target_language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type Query_RootTranslated_EnumsArgs = {
  distinct_on?: InputMaybe<Array<Translated_Enums_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translated_Enums_Order_By>>;
  where?: InputMaybe<Translated_Enums_Bool_Exp>;
};


export type Query_RootTranslated_Enums_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};


export type Query_RootUser_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUser_Onboarding_Skip_Reason_EnumArgs = {
  distinct_on?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Order_By>>;
  where?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Bool_Exp>;
};


export type Query_RootUser_Onboarding_Skip_Reason_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_Onboarding_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<User_Onboarding_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Onboarding_Status_Enum_Order_By>>;
  where?: InputMaybe<User_Onboarding_Status_Enum_Bool_Exp>;
};


export type Query_RootUser_Onboarding_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootUser_Primary_PhoneArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootUser_Primary_Phone_AggregateArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsers_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Query_RootUsers_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Query_RootUsers_Listings_By_PkArgs = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};


export type Query_RootUsers_ViewArgs = {
  distinct_on?: InputMaybe<Array<Users_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_View_Order_By>>;
  where?: InputMaybe<Users_View_Bool_Exp>;
};


export type Query_RootValidate_InvitationArgs = {
  token: Scalars['String']['input'];
};


export type Query_RootValuation_ModelsArgs = {
  distinct_on?: InputMaybe<Array<Valuation_Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuation_Models_Order_By>>;
  where?: InputMaybe<Valuation_Models_Bool_Exp>;
};


export type Query_RootValuation_Models_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Query_RootValuationsArgs = {
  distinct_on?: InputMaybe<Array<Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuations_Order_By>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};


export type Query_RootValuations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVisibility_Inbox_Lead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Inbox_Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Inbox_Lead_Agents_Order_By>>;
  where?: InputMaybe<Visibility_Inbox_Lead_Agents_Bool_Exp>;
};


export type Query_RootVisibility_Inbox_Profile_Lead_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Inbox_Profile_Lead_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Inbox_Profile_Lead_History_Order_By>>;
  where?: InputMaybe<Visibility_Inbox_Profile_Lead_History_Bool_Exp>;
};


export type Query_RootVisibility_Profile_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Profile_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Profile_Leads_Order_By>>;
  where?: InputMaybe<Visibility_Profile_Leads_Bool_Exp>;
};


export type Query_RootVisibility_Profile_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Profile_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Profile_Leads_Order_By>>;
  where?: InputMaybe<Visibility_Profile_Leads_Bool_Exp>;
};


export type Query_RootWebhook_Event_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Event_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Event_Types_Enum_Order_By>>;
  where?: InputMaybe<Webhook_Event_Types_Enum_Bool_Exp>;
};


export type Query_RootWebhook_Event_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Query_RootWebhook_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Subscriptions_Order_By>>;
  where?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
};


export type Query_RootWebhook_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Subscriptions_Order_By>>;
  where?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
};


export type Query_RootWebhook_Subscriptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWebhook_Subscriptions_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Order_By>>;
  where?: InputMaybe<Webhook_Subscriptions_Event_Types_Bool_Exp>;
};


export type Query_RootWebhook_Subscriptions_Event_Types_By_PkArgs = {
  event_type: Scalars['String']['input'];
  webhook_subscription_id: Scalars['uuid']['input'];
};


export type Query_RootWindow_View_EnumArgs = {
  distinct_on?: InputMaybe<Array<Window_View_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_View_Enum_Order_By>>;
  where?: InputMaybe<Window_View_Enum_Bool_Exp>;
};


export type Query_RootWindow_View_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};

/** columns and relationships of "read_only_tenants" */
export type Read_Only_Tenants = {
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "read_only_tenants". All fields are combined with a logical 'AND'. */
export type Read_Only_Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Read_Only_Tenants_Bool_Exp>>;
  _not?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Read_Only_Tenants_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "read_only_tenants". */
export type Read_Only_Tenants_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
};

/** select columns of table "read_only_tenants" */
export enum Read_Only_Tenants_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** Streaming cursor of the table "read_only_tenants" */
export type Read_Only_Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Read_Only_Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Read_Only_Tenants_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Reset_Cma_Market_Comparison_Places_Args = {
  _report_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "review_invitation_templates" */
export type Review_Invitation_Templates = {
  /** An object relationship */
  broker: Users;
  broker_id: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  language: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  type: Review_Invitation_Type_Enum_Enum;
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "review_invitation_templates" */
export type Review_Invitation_Templates_Aggregate = {
  aggregate?: Maybe<Review_Invitation_Templates_Aggregate_Fields>;
  nodes: Array<Review_Invitation_Templates>;
};

/** aggregate fields of "review_invitation_templates" */
export type Review_Invitation_Templates_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Review_Invitation_Templates_Max_Fields>;
  min?: Maybe<Review_Invitation_Templates_Min_Fields>;
};


/** aggregate fields of "review_invitation_templates" */
export type Review_Invitation_Templates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Invitation_Templates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "review_invitation_templates". All fields are combined with a logical 'AND'. */
export type Review_Invitation_Templates_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Invitation_Templates_Bool_Exp>>;
  _not?: InputMaybe<Review_Invitation_Templates_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Invitation_Templates_Bool_Exp>>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  type?: InputMaybe<Review_Invitation_Type_Enum_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_invitation_templates" */
export enum Review_Invitation_Templates_Constraint {
  /** unique or primary key constraint on columns "type", "broker_id", "language" */
  ReviewInvitationTemplatesBrokerTypeLanguageUnique = 'review_invitation_templates_broker_type_language_unique',
  /** unique or primary key constraint on columns "id" */
  ReviewInvitationTemplatesPkey = 'review_invitation_templates_pkey'
}

/** input type for inserting data into table "review_invitation_templates" */
export type Review_Invitation_Templates_Insert_Input = {
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Review_Invitation_Type_Enum_Enum>;
};

/** aggregate max on columns */
export type Review_Invitation_Templates_Max_Fields = {
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Review_Invitation_Templates_Min_Fields = {
  broker_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "review_invitation_templates" */
export type Review_Invitation_Templates_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Review_Invitation_Templates>;
};

/** on_conflict condition type for table "review_invitation_templates" */
export type Review_Invitation_Templates_On_Conflict = {
  constraint: Review_Invitation_Templates_Constraint;
  update_columns?: Array<Review_Invitation_Templates_Update_Column>;
  where?: InputMaybe<Review_Invitation_Templates_Bool_Exp>;
};

/** Ordering options when selecting data from "review_invitation_templates". */
export type Review_Invitation_Templates_Order_By = {
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: review_invitation_templates */
export type Review_Invitation_Templates_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "review_invitation_templates" */
export enum Review_Invitation_Templates_Select_Column {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Language = 'language',
  /** column name */
  Message = 'message',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "review_invitation_templates" */
export type Review_Invitation_Templates_Set_Input = {
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Review_Invitation_Type_Enum_Enum>;
};

/** Streaming cursor of the table "review_invitation_templates" */
export type Review_Invitation_Templates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Invitation_Templates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Invitation_Templates_Stream_Cursor_Value_Input = {
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<Review_Invitation_Type_Enum_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "review_invitation_templates" */
export enum Review_Invitation_Templates_Update_Column {
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  Language = 'language',
  /** column name */
  Message = 'message',
  /** column name */
  Type = 'type'
}

export type Review_Invitation_Templates_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Review_Invitation_Templates_Set_Input>;
  /** filter the rows which have to be updated */
  where: Review_Invitation_Templates_Bool_Exp;
};

export enum Review_Invitation_Type_Enum_Enum {
  /** Buyer */
  Buyer = 'buyer',
  /** Seller */
  Seller = 'seller'
}

/** Boolean expression to compare columns of type "review_invitation_type_enum_enum". All fields are combined with logical 'AND'. */
export type Review_Invitation_Type_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Review_Invitation_Type_Enum_Enum>;
  _in?: InputMaybe<Array<Review_Invitation_Type_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Review_Invitation_Type_Enum_Enum>;
  _nin?: InputMaybe<Array<Review_Invitation_Type_Enum_Enum>>;
};

/** Reviews clients leave an agent through the review form of the agent's public page: a client starts one and completes it from an emailed link; completed = true is a submitted review. user_id is the agent reviewed; team_id and organisation_id are not filled by the app: the agency is the agent's users.default_team_id, as in combined_reviews. Imported Google reviews are in google_reviews; combined_reviews has both. */
export type Reviews = {
  completed: Scalars['Boolean']['output'];
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  email_address: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  formatted_address: Scalars['String']['output'];
  /** An object relationship */
  google_address?: Maybe<Google_Addresses>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  has_accepted_terms: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  is_buyer: Scalars['Boolean']['output'];
  is_seller: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  marketing_metadata?: Maybe<Marketing_Metadata>;
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_date?: Maybe<Scalars['timestamptz']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  owner_answer_translations: Scalars['jsonb']['output'];
  /** An object relationship */
  property_transaction?: Maybe<Property_Transactions>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id: Scalars['uuid']['output'];
  transaction_date: Scalars['timestamptz']['output'];
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  translations: Scalars['jsonb']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** Reviews clients leave an agent through the review form of the agent's public page: a client starts one and completes it from an emailed link; completed = true is a submitted review. user_id is the agent reviewed; team_id and organisation_id are not filled by the app: the agency is the agent's users.default_team_id, as in combined_reviews. Imported Google reviews are in google_reviews; combined_reviews has both. */
export type ReviewsOwner_Answer_TranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Reviews clients leave an agent through the review form of the agent's public page: a client starts one and completes it from an emailed link; completed = true is a submitted review. user_id is the agent reviewed; team_id and organisation_id are not filled by the app: the agency is the agent's users.default_team_id, as in combined_reviews. Imported Google reviews are in google_reviews; combined_reviews has both. */
export type ReviewsTranslationsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "reviews" */
export type Reviews_Aggregate = {
  aggregate?: Maybe<Reviews_Aggregate_Fields>;
  nodes: Array<Reviews>;
};

export type Reviews_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Reviews_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Reviews_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Reviews_Aggregate_Bool_Exp_Count>;
};

export type Reviews_Aggregate_Bool_Exp_Bool_And = {
  arguments: Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reviews_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reviews_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Reviews_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Reviews_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "reviews" */
export type Reviews_Aggregate_Fields = {
  avg?: Maybe<Reviews_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Reviews_Max_Fields>;
  min?: Maybe<Reviews_Min_Fields>;
  stddev?: Maybe<Reviews_Stddev_Fields>;
  stddev_pop?: Maybe<Reviews_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Reviews_Stddev_Samp_Fields>;
  sum?: Maybe<Reviews_Sum_Fields>;
  var_pop?: Maybe<Reviews_Var_Pop_Fields>;
  var_samp?: Maybe<Reviews_Var_Samp_Fields>;
  variance?: Maybe<Reviews_Variance_Fields>;
};


/** aggregate fields of "reviews" */
export type Reviews_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Reviews_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reviews" */
export type Reviews_Aggregate_Order_By = {
  avg?: InputMaybe<Reviews_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Reviews_Max_Order_By>;
  min?: InputMaybe<Reviews_Min_Order_By>;
  stddev?: InputMaybe<Reviews_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Reviews_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Reviews_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Reviews_Sum_Order_By>;
  var_pop?: InputMaybe<Reviews_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Reviews_Var_Samp_Order_By>;
  variance?: InputMaybe<Reviews_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "reviews" */
export type Reviews_Arr_Rel_Insert_Input = {
  data: Array<Reviews_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** aggregate avg on columns */
export type Reviews_Avg_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reviews" */
export type Reviews_Avg_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "reviews". All fields are combined with a logical 'AND'. */
export type Reviews_Bool_Exp = {
  _and?: InputMaybe<Array<Reviews_Bool_Exp>>;
  _not?: InputMaybe<Reviews_Bool_Exp>;
  _or?: InputMaybe<Array<Reviews_Bool_Exp>>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email_address?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  formatted_address?: InputMaybe<String_Comparison_Exp>;
  google_address?: InputMaybe<Google_Addresses_Bool_Exp>;
  google_address_id?: InputMaybe<Uuid_Comparison_Exp>;
  has_accepted_terms?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_buyer?: InputMaybe<Boolean_Comparison_Exp>;
  is_seller?: InputMaybe<Boolean_Comparison_Exp>;
  language?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Bool_Exp>;
  neverbounce_result?: InputMaybe<String_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  owner_answer?: InputMaybe<String_Comparison_Exp>;
  owner_answer_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  owner_answer_source_language?: InputMaybe<String_Comparison_Exp>;
  owner_answer_translations?: InputMaybe<Jsonb_Comparison_Exp>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  rating?: InputMaybe<Int_Comparison_Exp>;
  review_text?: InputMaybe<String_Comparison_Exp>;
  review_url?: InputMaybe<String_Comparison_Exp>;
  source_language?: InputMaybe<String_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  transaction_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  translations?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "reviews" */
export enum Reviews_Constraint {
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ReviewsIdTenantIdUnique = 'reviews_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  ReviewsPkey = 'reviews_pkey'
}

/** input type for incrementing numeric columns in table "reviews" */
export type Reviews_Inc_Input = {
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reviews" */
export type Reviews_Insert_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address?: InputMaybe<Google_Addresses_Obj_Rel_Insert_Input>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Reviews_Max_Fields = {
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_date?: Maybe<Scalars['timestamptz']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_date?: Maybe<Scalars['timestamptz']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "reviews" */
export type Reviews_Max_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_date?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Reviews_Min_Fields = {
  completed_at?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  google_address_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  neverbounce_result?: Maybe<Scalars['String']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  owner_answer?: Maybe<Scalars['String']['output']>;
  owner_answer_date?: Maybe<Scalars['timestamptz']['output']>;
  owner_answer_source_language?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  review_text?: Maybe<Scalars['String']['output']>;
  review_url?: Maybe<Scalars['String']['output']>;
  source_language?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  transaction_date?: Maybe<Scalars['timestamptz']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "reviews" */
export type Reviews_Min_Order_By = {
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_date?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "reviews" */
export type Reviews_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Reviews>;
};

/** input type for inserting object relation for remote table "reviews" */
export type Reviews_Obj_Rel_Insert_Input = {
  data: Reviews_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Reviews_On_Conflict>;
};

/** on_conflict condition type for table "reviews" */
export type Reviews_On_Conflict = {
  constraint: Reviews_Constraint;
  update_columns?: Array<Reviews_Update_Column>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};

/** Ordering options when selecting data from "reviews". */
export type Reviews_Order_By = {
  completed?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email_address?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  formatted_address?: InputMaybe<Order_By>;
  google_address?: InputMaybe<Google_Addresses_Order_By>;
  google_address_id?: InputMaybe<Order_By>;
  has_accepted_terms?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_buyer?: InputMaybe<Order_By>;
  is_seller?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  marketing_metadata?: InputMaybe<Marketing_Metadata_Order_By>;
  neverbounce_result?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  owner_answer?: InputMaybe<Order_By>;
  owner_answer_date?: InputMaybe<Order_By>;
  owner_answer_source_language?: InputMaybe<Order_By>;
  owner_answer_translations?: InputMaybe<Order_By>;
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  rating?: InputMaybe<Order_By>;
  review_text?: InputMaybe<Order_By>;
  review_url?: InputMaybe<Order_By>;
  source_language?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  transaction_date?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  translations?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: reviews */
export type Reviews_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reviews" */
export enum Reviews_Select_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  Language = 'language',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  OwnerAnswerDate = 'owner_answer_date',
  /** column name */
  OwnerAnswerSourceLanguage = 'owner_answer_source_language',
  /** column name */
  OwnerAnswerTranslations = 'owner_answer_translations',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  SourceLanguage = 'source_language',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  Translations = 'translations',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "reviews_aggregate_bool_exp_bool_and_arguments_columns" columns of table "reviews" */
export enum Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

/** select "reviews_aggregate_bool_exp_bool_or_arguments_columns" columns of table "reviews" */
export enum Reviews_Select_Column_Reviews_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Completed = 'completed',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller'
}

/** input type for updating data in table "reviews" */
export type Reviews_Set_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_answer?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Reviews_Stddev_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reviews" */
export type Reviews_Stddev_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Reviews_Stddev_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "reviews" */
export type Reviews_Stddev_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Reviews_Stddev_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "reviews" */
export type Reviews_Stddev_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "reviews" */
export type Reviews_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Reviews_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Reviews_Stream_Cursor_Value_Input = {
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  completed_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email_address?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  formatted_address?: InputMaybe<Scalars['String']['input']>;
  google_address_id?: InputMaybe<Scalars['uuid']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_buyer?: InputMaybe<Scalars['Boolean']['input']>;
  is_seller?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  neverbounce_result?: InputMaybe<Scalars['String']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  owner_answer?: InputMaybe<Scalars['String']['input']>;
  owner_answer_date?: InputMaybe<Scalars['timestamptz']['input']>;
  owner_answer_source_language?: InputMaybe<Scalars['String']['input']>;
  owner_answer_translations?: InputMaybe<Scalars['jsonb']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  review_text?: InputMaybe<Scalars['String']['input']>;
  review_url?: InputMaybe<Scalars['String']['input']>;
  source_language?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  transaction_date?: InputMaybe<Scalars['timestamptz']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  translations?: InputMaybe<Scalars['jsonb']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Reviews_Sum_Fields = {
  rating?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reviews" */
export type Reviews_Sum_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** update columns of table "reviews" */
export enum Reviews_Update_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  EmailAddress = 'email_address',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FormattedAddress = 'formatted_address',
  /** column name */
  GoogleAddressId = 'google_address_id',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  Id = 'id',
  /** column name */
  IsBuyer = 'is_buyer',
  /** column name */
  IsSeller = 'is_seller',
  /** column name */
  LastName = 'last_name',
  /** column name */
  NeverbounceResult = 'neverbounce_result',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  OwnerAnswer = 'owner_answer',
  /** column name */
  Rating = 'rating',
  /** column name */
  ReviewText = 'review_text',
  /** column name */
  ReviewUrl = 'review_url',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TransactionDate = 'transaction_date',
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

export type Reviews_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Reviews_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Reviews_Set_Input>;
  /** filter the rows which have to be updated */
  where: Reviews_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Reviews_Var_Pop_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "reviews" */
export type Reviews_Var_Pop_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Reviews_Var_Samp_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "reviews" */
export type Reviews_Var_Samp_Order_By = {
  rating?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Reviews_Variance_Fields = {
  rating?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reviews" */
export type Reviews_Variance_Order_By = {
  rating?: InputMaybe<Order_By>;
};

export type Save_Property_Image_Version_Args = {
  expected_current_image_id?: InputMaybe<Scalars['uuid']['input']>;
  new_image_id?: InputMaybe<Scalars['uuid']['input']>;
  new_image_url?: InputMaybe<Scalars['String']['input']>;
  property_image_id?: InputMaybe<Scalars['uuid']['input']>;
  source_image_id?: InputMaybe<Scalars['uuid']['input']>;
  version_prompt?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Brockers_In_Catchment_Area_Args = {
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
};

export type Search_Buyer_Leads_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Leads_Args = {
  contact_id?: InputMaybe<Scalars['uuid']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Leads_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Lots_Tsv_Args = {
  dev_id?: InputMaybe<Scalars['uuid']['input']>;
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Places_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Places_Ex_Args = {
  id_in?: InputMaybe<Scalars['String']['input']>;
  index_eq?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Scalars['String']['input']>;
  type_nin?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Places_With_Index_Args = {
  search?: InputMaybe<Scalars['String']['input']>;
  with_index?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Search_Property_Transactions_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Public_Agents_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Teams_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Users_Args = {
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type Search_Users_Tsv_Args = {
  search_text?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "seller_notification_frequency_enum" */
export type Seller_Notification_Frequency_Enum = {
  comment: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "seller_notification_frequency_enum". All fields are combined with a logical 'AND'. */
export type Seller_Notification_Frequency_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Bool_Exp>>;
  _not?: InputMaybe<Seller_Notification_Frequency_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Seller_Notification_Frequency_Enum_Enum {
  /** Send seller notifications daily */
  Daily = 'daily',
  /** Send seller notifications monthly (1st of month) */
  Monthly = 'monthly',
  /** Never send seller notifications */
  Never = 'never',
  /** Send seller notifications weekly (Fridays) */
  Weekly = 'weekly'
}

/** Boolean expression to compare columns of type "seller_notification_frequency_enum_enum". All fields are combined with logical 'AND'. */
export type Seller_Notification_Frequency_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Seller_Notification_Frequency_Enum_Enum>;
  _in?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Seller_Notification_Frequency_Enum_Enum>;
  _nin?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Enum>>;
};

/** Ordering options when selecting data from "seller_notification_frequency_enum". */
export type Seller_Notification_Frequency_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "seller_notification_frequency_enum" */
export enum Seller_Notification_Frequency_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "seller_notification_frequency_enum" */
export type Seller_Notification_Frequency_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Seller_Notification_Frequency_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Seller_Notification_Frequency_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Set_Default_Team_Args = {
  user_ids?: InputMaybe<Scalars['_uuid']['input']>;
};

export type Set_User_Module_Grant_Args = {
  target_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  target_module_id?: InputMaybe<Scalars['String']['input']>;
  target_user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "shared_portals" */
export type Shared_Portals = {
  active?: Maybe<Scalars['Boolean']['output']>;
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  exact_address_required?: Maybe<Scalars['Boolean']['output']>;
  has_top_premium_listing?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "shared_portals" */
export type Shared_Portals_Aggregate = {
  aggregate?: Maybe<Shared_Portals_Aggregate_Fields>;
  nodes: Array<Shared_Portals>;
};

/** aggregate fields of "shared_portals" */
export type Shared_Portals_Aggregate_Fields = {
  avg?: Maybe<Shared_Portals_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Shared_Portals_Max_Fields>;
  min?: Maybe<Shared_Portals_Min_Fields>;
  stddev?: Maybe<Shared_Portals_Stddev_Fields>;
  stddev_pop?: Maybe<Shared_Portals_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Shared_Portals_Stddev_Samp_Fields>;
  sum?: Maybe<Shared_Portals_Sum_Fields>;
  var_pop?: Maybe<Shared_Portals_Var_Pop_Fields>;
  var_samp?: Maybe<Shared_Portals_Var_Samp_Fields>;
  variance?: Maybe<Shared_Portals_Variance_Fields>;
};


/** aggregate fields of "shared_portals" */
export type Shared_Portals_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Shared_Portals_Avg_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "shared_portals". All fields are combined with a logical 'AND'. */
export type Shared_Portals_Bool_Exp = {
  _and?: InputMaybe<Array<Shared_Portals_Bool_Exp>>;
  _not?: InputMaybe<Shared_Portals_Bool_Exp>;
  _or?: InputMaybe<Array<Shared_Portals_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  contract_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  exact_address_required?: InputMaybe<Boolean_Comparison_Exp>;
  has_top_premium_listing?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_protocol?: InputMaybe<Portal_Idx_Protocol_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  password?: InputMaybe<String_Comparison_Exp>;
  port?: InputMaybe<Int_Comparison_Exp>;
  quota?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Shared_Portals_Max_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Shared_Portals_Min_Fields = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_protocol?: Maybe<Scalars['portal_idx_protocol']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
};

/** Ordering options when selecting data from "shared_portals". */
export type Shared_Portals_Order_By = {
  active?: InputMaybe<Order_By>;
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  exact_address_required?: InputMaybe<Order_By>;
  has_top_premium_listing?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_protocol?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  password?: InputMaybe<Order_By>;
  port?: InputMaybe<Order_By>;
  quota?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
};

/** select columns of table "shared_portals" */
export enum Shared_Portals_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  ExactAddressRequired = 'exact_address_required',
  /** column name */
  HasTopPremiumListing = 'has_top_premium_listing',
  /** column name */
  Id = 'id',
  /** column name */
  IdxProtocol = 'idx_protocol',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password',
  /** column name */
  Port = 'port',
  /** column name */
  Quota = 'quota',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  Username = 'username',
  /** column name */
  WebsiteUrl = 'website_url'
}

/** aggregate stddev on columns */
export type Shared_Portals_Stddev_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Shared_Portals_Stddev_Pop_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Shared_Portals_Stddev_Samp_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "shared_portals" */
export type Shared_Portals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Shared_Portals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Shared_Portals_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exact_address_required?: InputMaybe<Scalars['Boolean']['input']>;
  has_top_premium_listing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_protocol?: InputMaybe<Scalars['portal_idx_protocol']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['Int']['input']>;
  quota?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Shared_Portals_Sum_Fields = {
  port?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Shared_Portals_Var_Pop_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Shared_Portals_Var_Samp_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Shared_Portals_Variance_Fields = {
  port?: Maybe<Scalars['Float']['output']>;
  quota?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "similar_online_listings_ids" */
export type Similar_Online_Listings_Ids = {
  id?: Maybe<Scalars['Int']['output']>;
};

export type Similar_Online_Listings_Ids_Aggregate = {
  aggregate?: Maybe<Similar_Online_Listings_Ids_Aggregate_Fields>;
  nodes: Array<Similar_Online_Listings_Ids>;
};

/** aggregate fields of "similar_online_listings_ids" */
export type Similar_Online_Listings_Ids_Aggregate_Fields = {
  avg?: Maybe<Similar_Online_Listings_Ids_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Similar_Online_Listings_Ids_Max_Fields>;
  min?: Maybe<Similar_Online_Listings_Ids_Min_Fields>;
  stddev?: Maybe<Similar_Online_Listings_Ids_Stddev_Fields>;
  stddev_pop?: Maybe<Similar_Online_Listings_Ids_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Similar_Online_Listings_Ids_Stddev_Samp_Fields>;
  sum?: Maybe<Similar_Online_Listings_Ids_Sum_Fields>;
  var_pop?: Maybe<Similar_Online_Listings_Ids_Var_Pop_Fields>;
  var_samp?: Maybe<Similar_Online_Listings_Ids_Var_Samp_Fields>;
  variance?: Maybe<Similar_Online_Listings_Ids_Variance_Fields>;
};


/** aggregate fields of "similar_online_listings_ids" */
export type Similar_Online_Listings_Ids_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Similar_Online_Listings_Ids_Avg_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "similar_online_listings_ids". All fields are combined with a logical 'AND'. */
export type Similar_Online_Listings_Ids_Bool_Exp = {
  _and?: InputMaybe<Array<Similar_Online_Listings_Ids_Bool_Exp>>;
  _not?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
  _or?: InputMaybe<Array<Similar_Online_Listings_Ids_Bool_Exp>>;
  id?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Similar_Online_Listings_Ids_Max_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Similar_Online_Listings_Ids_Min_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "similar_online_listings_ids". */
export type Similar_Online_Listings_Ids_Order_By = {
  id?: InputMaybe<Order_By>;
};

/** select columns of table "similar_online_listings_ids" */
export enum Similar_Online_Listings_Ids_Select_Column {
  /** column name */
  Id = 'id'
}

/** aggregate stddev on columns */
export type Similar_Online_Listings_Ids_Stddev_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Similar_Online_Listings_Ids_Stddev_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Similar_Online_Listings_Ids_Stddev_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Similar_Online_Listings_Ids_Sum_Fields = {
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Similar_Online_Listings_Ids_Var_Pop_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Similar_Online_Listings_Ids_Var_Samp_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Similar_Online_Listings_Ids_Variance_Fields = {
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "smallint". All fields are combined with logical 'AND'. */
export type Smallint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['smallint']['input']>;
  _gt?: InputMaybe<Scalars['smallint']['input']>;
  _gte?: InputMaybe<Scalars['smallint']['input']>;
  _in?: InputMaybe<Array<Scalars['smallint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['smallint']['input']>;
  _lte?: InputMaybe<Scalars['smallint']['input']>;
  _neq?: InputMaybe<Scalars['smallint']['input']>;
  _nin?: InputMaybe<Array<Scalars['smallint']['input']>>;
};

/** columns and relationships of "smart_lists" */
export type Smart_Lists = {
  created_at: Scalars['timestamptz']['output'];
  created_by: Scalars['uuid']['output'];
  crm_entity: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  is_shared: Scalars['Boolean']['output'];
  is_tenant_shared: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  where: Scalars['jsonb']['output'];
};


/** columns and relationships of "smart_lists" */
export type Smart_ListsWhereArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Smart_Lists_Append_Input = {
  order_by?: InputMaybe<Scalars['jsonb']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "smart_lists". All fields are combined with a logical 'AND'. */
export type Smart_Lists_Bool_Exp = {
  _and?: InputMaybe<Array<Smart_Lists_Bool_Exp>>;
  _not?: InputMaybe<Smart_Lists_Bool_Exp>;
  _or?: InputMaybe<Array<Smart_Lists_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  crm_entity?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_shared?: InputMaybe<Boolean_Comparison_Exp>;
  is_tenant_shared?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  where?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "smart_lists" */
export enum Smart_Lists_Constraint {
  /** unique or primary key constraint on columns "id" */
  SmartListsPkey = 'smart_lists_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Smart_Lists_Delete_At_Path_Input = {
  order_by?: InputMaybe<Array<Scalars['String']['input']>>;
  where?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Smart_Lists_Delete_Elem_Input = {
  order_by?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Smart_Lists_Delete_Key_Input = {
  order_by?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "smart_lists" */
export type Smart_Lists_Insert_Input = {
  crm_entity?: InputMaybe<Scalars['String']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_tenant_shared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** response of any mutation on the table "smart_lists" */
export type Smart_Lists_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Smart_Lists>;
};

/** on_conflict condition type for table "smart_lists" */
export type Smart_Lists_On_Conflict = {
  constraint: Smart_Lists_Constraint;
  update_columns?: Array<Smart_Lists_Update_Column>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};

/** Ordering options when selecting data from "smart_lists". */
export type Smart_Lists_Order_By = {
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  crm_entity?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_shared?: InputMaybe<Order_By>;
  is_tenant_shared?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  where?: InputMaybe<Order_By>;
};

/** primary key columns input for table: smart_lists */
export type Smart_Lists_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Smart_Lists_Prepend_Input = {
  order_by?: InputMaybe<Scalars['jsonb']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "smart_lists" */
export enum Smart_Lists_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  CrmEntity = 'crm_entity',
  /** column name */
  Id = 'id',
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsTenantShared = 'is_tenant_shared',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Where = 'where'
}

/** input type for updating data in table "smart_lists" */
export type Smart_Lists_Set_Input = {
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_tenant_shared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order_by?: InputMaybe<Scalars['jsonb']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "smart_lists" */
export type Smart_Lists_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Smart_Lists_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Smart_Lists_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  crm_entity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  is_shared?: InputMaybe<Scalars['Boolean']['input']>;
  is_tenant_shared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  where?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "smart_lists" */
export enum Smart_Lists_Update_Column {
  /** column name */
  IsShared = 'is_shared',
  /** column name */
  IsTenantShared = 'is_tenant_shared',
  /** column name */
  Name = 'name',
  /** column name */
  OrderBy = 'order_by',
  /** column name */
  Where = 'where'
}

export type Smart_Lists_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Smart_Lists_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Smart_Lists_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Smart_Lists_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Smart_Lists_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Smart_Lists_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Smart_Lists_Set_Input>;
  /** filter the rows which have to be updated */
  where: Smart_Lists_Bool_Exp;
};

export type St_D_Within_Geography_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geography']['input'];
  use_spheroid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type St_D_Within_Input = {
  distance: Scalars['Float']['input'];
  from: Scalars['geometry']['input'];
};

export type Subscription_Root = {
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  /** fetch data from the table: "activities" using primary key columns */
  activities_by_pk?: Maybe<Activities>;
  /** fetch data from the table in a streaming manner: "activities" */
  activities_stream: Array<Activities>;
  /** fetch data from the table: "activity_feed" */
  activity_feed: Array<Activity_Feed>;
  /** fetch aggregated fields from the table: "activity_feed" */
  activity_feed_aggregate: Activity_Feed_Aggregate;
  /** fetch data from the table: "activity_feed" using primary key columns */
  activity_feed_by_pk?: Maybe<Activity_Feed>;
  /** fetch data from the table: "activity_feed_quarantine" */
  activity_feed_quarantine: Array<Activity_Feed_Quarantine>;
  /** fetch data from the table in a streaming manner: "activity_feed_quarantine" */
  activity_feed_quarantine_stream: Array<Activity_Feed_Quarantine>;
  /** fetch data from the table: "activity_feed_status" */
  activity_feed_status: Array<Activity_Feed_Status>;
  /** fetch data from the table in a streaming manner: "activity_feed_status" */
  activity_feed_status_stream: Array<Activity_Feed_Status>;
  /** fetch data from the table in a streaming manner: "activity_feed" */
  activity_feed_stream: Array<Activity_Feed>;
  /** fetch data from the table: "address_display_options_enum" */
  address_display_options_enum: Array<Address_Display_Options_Enum>;
  /** fetch data from the table: "address_display_options_enum" using primary key columns */
  address_display_options_enum_by_pk?: Maybe<Address_Display_Options_Enum>;
  /** fetch data from the table in a streaming manner: "address_display_options_enum" */
  address_display_options_enum_stream: Array<Address_Display_Options_Enum>;
  /** fetch data from the table: "agencies" */
  agencies: Array<Agencies>;
  /** fetch data from the table in a streaming manner: "agencies" */
  agencies_stream: Array<Agencies>;
  /** execute function "agent_statistics" which returns "agent_stats" */
  agent_statistics: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" */
  agent_stats: Array<Agent_Stats>;
  /** fetch data from the table: "agent_stats" using primary key columns */
  agent_stats_by_pk?: Maybe<Agent_Stats>;
  /** fetch data from the table in a streaming manner: "agent_stats" */
  agent_stats_stream: Array<Agent_Stats>;
  /** fetch data from the table: "agents" */
  agents: Array<Agents>;
  /** fetch data from the table in a streaming manner: "agents" */
  agents_stream: Array<Agents>;
  /** fetch data from the table: "api_keys" */
  api_keys: Array<Api_Keys>;
  /** fetch aggregated fields from the table: "api_keys" */
  api_keys_aggregate: Api_Keys_Aggregate;
  /** fetch data from the table: "api_keys" using primary key columns */
  api_keys_by_pk?: Maybe<Api_Keys>;
  /** fetch data from the table in a streaming manner: "api_keys" */
  api_keys_stream: Array<Api_Keys>;
  /** An array relationship */
  api_keys_teams: Array<Api_Keys_Teams>;
  /** fetch data from the table: "api_keys_teams" using primary key columns */
  api_keys_teams_by_pk?: Maybe<Api_Keys_Teams>;
  /** fetch data from the table in a streaming manner: "api_keys_teams" */
  api_keys_teams_stream: Array<Api_Keys_Teams>;
  /** An array relationship */
  appraisals: Array<Appraisals>;
  /** fetch data from the table: "appraisals" using primary key columns */
  appraisals_by_pk?: Maybe<Appraisals>;
  /** fetch data from the table in a streaming manner: "appraisals" */
  appraisals_stream: Array<Appraisals>;
  /** fetch data from the table: "available_email_templates" */
  available_email_templates: Array<Available_Email_Templates>;
  /** fetch data from the table in a streaming manner: "available_email_templates" */
  available_email_templates_stream: Array<Available_Email_Templates>;
  /** fetch data from the table: "bed_type_enum" */
  bed_type_enum: Array<Bed_Type_Enum>;
  /** fetch data from the table: "bed_type_enum" using primary key columns */
  bed_type_enum_by_pk?: Maybe<Bed_Type_Enum>;
  /** fetch data from the table in a streaming manner: "bed_type_enum" */
  bed_type_enum_stream: Array<Bed_Type_Enum>;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  /** fetch data from the table: "buyer_leads" using primary key columns */
  buyer_leads_by_pk?: Maybe<Buyer_Leads>;
  /** fetch data from the table in a streaming manner: "buyer_leads" */
  buyer_leads_stream: Array<Buyer_Leads>;
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  /** fetch data from the table: "catchment_areas" using primary key columns */
  catchment_areas_by_pk?: Maybe<Catchment_Areas>;
  /** fetch data from the table in a streaming manner: "catchment_areas" */
  catchment_areas_stream: Array<Catchment_Areas>;
  /** fetch data from the table: "buildings" */
  ch_buildings: Array<Ch_Buildings>;
  /** fetch data from the table: "buildings" using primary key columns */
  ch_buildings_by_pk?: Maybe<Ch_Buildings>;
  /** fetch data from the table: "cma_listings" */
  ch_cma_listings: Array<Ch_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  ch_cma_listings_aggregate: Ch_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  ch_cma_listings_by_pk?: Maybe<Ch_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  ch_cma_listings_distance: Array<Ch_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  ch_cma_listings_distance_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  ch_cma_listings_distance_by_pk?: Maybe<Ch_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  ch_cma_rental_listings: Array<Ch_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  ch_cma_rental_listings_aggregate: Ch_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  ch_cma_rental_listings_by_pk?: Maybe<Ch_Cma_Rental_Listings>;
  /** fetch data from the table: "external_transactions" */
  ch_external_transactions: Array<Ch_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  ch_external_transactions_aggregate: Ch_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  ch_external_transactions_distance: Array<Ch_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  ch_external_transactions_distance_aggregate: Ch_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  ch_external_transactions_distance_by_pk?: Maybe<Ch_External_Transactions_Distance>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  ch_get_buy_rent_listings: Array<Ch_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  ch_get_buy_rent_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  ch_get_cma_listings_by_radius: Array<Ch_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  ch_get_cma_listings_by_radius_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  ch_get_cma_listings_distance: Array<Ch_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  ch_get_cma_listings_distance_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  ch_get_external_transactions_distance: Array<Ch_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  ch_get_external_transactions_distance_aggregate: Ch_External_Transactions_Distance_Aggregate;
  /** execute function "get_house_appt_price_stats" which returns "price_stats" */
  ch_get_house_appt_price_stats: Array<Ch_Price_Stats>;
  /** execute function "get_house_appt_price_stats" and query aggregates on result of table type "price_stats" */
  ch_get_house_appt_price_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  ch_get_listings_stats?: Maybe<Ch_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  ch_get_listings_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_listings_stats_by_place_slug" which returns "price_stats" */
  ch_get_listings_stats_by_place_slug: Array<Ch_Price_Stats>;
  /** execute function "get_listings_stats_by_place_slug" and query aggregates on result of table type "price_stats" */
  ch_get_listings_stats_by_place_slug_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_map_place_stats" which returns "price_stats" */
  ch_get_map_place_stats: Array<Ch_Price_Stats>;
  /** execute function "get_map_place_stats" and query aggregates on result of table type "price_stats" */
  ch_get_map_place_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  ch_get_merged_listings: Array<Ch_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  ch_get_merged_listings_type: Array<Ch_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  ch_get_place_by_slug?: Maybe<Ch_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  ch_get_place_by_slug_aggregate: Ch_Places_Aggregate;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  ch_get_rental_cma_listings_distance: Array<Ch_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  ch_get_rental_cma_listings_distance_aggregate: Ch_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  ch_get_similar_listings: Array<Ch_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  ch_get_similar_listings_aggregate: Ch_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  ch_get_similar_listings_cohorts: Array<Ch_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  ch_get_similar_listings_cohorts_aggregate: Ch_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  ch_get_similar_listings_vector: Array<Ch_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  ch_get_similar_listings_vector_aggregate: Ch_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  ch_get_similar_rental_listings_cohorts: Array<Ch_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  ch_get_similar_rental_listings_cohorts_aggregate: Ch_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  ch_merged_images: Array<Ch_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  ch_merged_images_aggregate: Ch_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  ch_merged_listings: Array<Ch_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  ch_merged_listings_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  ch_merged_listings_by_pk?: Maybe<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  ch_merged_listings_compare: Array<Ch_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  ch_merged_listings_compare_aggregate: Ch_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  ch_places: Array<Ch_Places>;
  /** fetch aggregated fields from the table: "places" */
  ch_places_aggregate: Ch_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs: Array<Ch_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  ch_places_breadcrumbs_aggregate: Ch_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  ch_places_by_pk?: Maybe<Ch_Places>;
  /** fetch data from the table: "plots" */
  ch_plots: Array<Ch_Plots>;
  /** fetch data from the table: "plots" using primary key columns */
  ch_plots_by_pk?: Maybe<Ch_Plots>;
  /** fetch data from the table: "post_merged_listings" */
  ch_post_merged_listings: Array<Ch_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  ch_post_merged_listings_aggregate: Ch_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  ch_post_merged_listings_by_pk?: Maybe<Ch_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  ch_price_stats: Array<Ch_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  ch_price_stats_aggregate: Ch_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  ch_price_stats_historical: Array<Ch_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  ch_price_stats_historical_aggregate: Ch_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  ch_price_stats_historical_by_pk?: Maybe<Ch_Price_Stats_Historical>;
  /** fetch data from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles: Array<Ch_Price_Stats_Quantiles>;
  /** fetch aggregated fields from the table: "price_stats_quantiles" */
  ch_price_stats_quantiles_aggregate: Ch_Price_Stats_Quantiles_Aggregate;
  /** fetch data from the table: "price_stats_quantiles" using primary key columns */
  ch_price_stats_quantiles_by_pk?: Maybe<Ch_Price_Stats_Quantiles>;
  /** fetch data from the table: "property_types" */
  ch_property_types: Array<Ch_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  ch_rental_cma_listings_distance: Array<Ch_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  ch_rental_cma_listings_distance_aggregate: Ch_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places" which returns "places" */
  ch_search_places: Array<Ch_Places>;
  /** execute function "search_places" and query aggregates on result of table type "places" */
  ch_search_places_aggregate: Ch_Places_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  ch_search_places_with_index: Array<Ch_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  ch_search_places_with_index_aggregate: Ch_Places_Aggregate;
  /** fetch data from the table: "states" */
  ch_states: Array<Ch_States>;
  /** fetch data from the table: "street_stats" */
  ch_street_stats: Array<Ch_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  ch_street_stats_aggregate: Ch_Street_Stats_Aggregate;
  /** fetch data from the table: "Chat" */
  chat_api_chat: Array<Chat_Api_Chat>;
  /** fetch aggregated fields from the table: "Chat" */
  chat_api_chat_aggregate: Chat_Api_Chat_Aggregate;
  /** fetch data from the table: "Chat" using primary key columns */
  chat_api_chat_by_pk?: Maybe<Chat_Api_Chat>;
  /** fetch data from the table: "chat_model_setting" */
  chat_api_chat_model_setting: Array<Chat_Api_Chat_Model_Setting>;
  /** fetch aggregated fields from the table: "chat_model_setting" */
  chat_api_chat_model_setting_aggregate: Chat_Api_Chat_Model_Setting_Aggregate;
  /** fetch data from the table: "chat_model_setting" using primary key columns */
  chat_api_chat_model_setting_by_pk?: Maybe<Chat_Api_Chat_Model_Setting>;
  /** fetch data from the table in a streaming manner: "chat_model_setting" */
  chat_api_chat_model_setting_stream: Array<Chat_Api_Chat_Model_Setting>;
  /** fetch data from the table in a streaming manner: "Chat" */
  chat_api_chat_stream: Array<Chat_Api_Chat>;
  /** fetch data from the table: "conversation_message" */
  chat_api_conversation_message: Array<Chat_Api_Conversation_Message>;
  /** fetch aggregated fields from the table: "conversation_message" */
  chat_api_conversation_message_aggregate: Chat_Api_Conversation_Message_Aggregate;
  /** fetch data from the table: "conversation_message" using primary key columns */
  chat_api_conversation_message_by_pk?: Maybe<Chat_Api_Conversation_Message>;
  /** fetch data from the table in a streaming manner: "conversation_message" */
  chat_api_conversation_message_stream: Array<Chat_Api_Conversation_Message>;
  /** fetch data from the table: "conversation_part" */
  chat_api_conversation_part: Array<Chat_Api_Conversation_Part>;
  /** fetch aggregated fields from the table: "conversation_part" */
  chat_api_conversation_part_aggregate: Chat_Api_Conversation_Part_Aggregate;
  /** fetch data from the table: "conversation_part" using primary key columns */
  chat_api_conversation_part_by_pk?: Maybe<Chat_Api_Conversation_Part>;
  /** fetch data from the table in a streaming manner: "conversation_part" */
  chat_api_conversation_part_stream: Array<Chat_Api_Conversation_Part>;
  /** fetch data from the table: "conversation_tool_call" */
  chat_api_conversation_tool_call: Array<Chat_Api_Conversation_Tool_Call>;
  /** fetch aggregated fields from the table: "conversation_tool_call" */
  chat_api_conversation_tool_call_aggregate: Chat_Api_Conversation_Tool_Call_Aggregate;
  /** fetch data from the table: "conversation_tool_call" using primary key columns */
  chat_api_conversation_tool_call_by_pk?: Maybe<Chat_Api_Conversation_Tool_Call>;
  /** fetch data from the table in a streaming manner: "conversation_tool_call" */
  chat_api_conversation_tool_call_stream: Array<Chat_Api_Conversation_Tool_Call>;
  /** fetch data from the table: "conversation_trace" */
  chat_api_conversation_trace: Array<Chat_Api_Conversation_Trace>;
  /** fetch aggregated fields from the table: "conversation_trace" */
  chat_api_conversation_trace_aggregate: Chat_Api_Conversation_Trace_Aggregate;
  /** fetch data from the table: "conversation_trace" using primary key columns */
  chat_api_conversation_trace_by_pk?: Maybe<Chat_Api_Conversation_Trace>;
  /** fetch data from the table in a streaming manner: "conversation_trace" */
  chat_api_conversation_trace_stream: Array<Chat_Api_Conversation_Trace>;
  /** fetch data from the table: "Message_v2" */
  chat_api_message: Array<Chat_Api_Message>;
  /** fetch aggregated fields from the table: "Message_v2" */
  chat_api_message_aggregate: Chat_Api_Message_Aggregate;
  /** fetch data from the table: "Message_v2" using primary key columns */
  chat_api_message_by_pk?: Maybe<Chat_Api_Message>;
  /** fetch data from the table in a streaming manner: "Message_v2" */
  chat_api_message_stream: Array<Chat_Api_Message>;
  /** fetch data from the table: "model_pricing" */
  chat_api_model_pricing: Array<Chat_Api_Model_Pricing>;
  /** fetch aggregated fields from the table: "model_pricing" */
  chat_api_model_pricing_aggregate: Chat_Api_Model_Pricing_Aggregate;
  /** fetch data from the table: "model_pricing" using primary key columns */
  chat_api_model_pricing_by_pk?: Maybe<Chat_Api_Model_Pricing>;
  /** fetch data from the table in a streaming manner: "model_pricing" */
  chat_api_model_pricing_stream: Array<Chat_Api_Model_Pricing>;
  /** fetch data from the table: "MutationAudit" */
  chat_api_mutation_audit: Array<Chat_Api_Mutation_Audit>;
  /** fetch aggregated fields from the table: "MutationAudit" */
  chat_api_mutation_audit_aggregate: Chat_Api_Mutation_Audit_Aggregate;
  /** fetch data from the table: "MutationAudit" using primary key columns */
  chat_api_mutation_audit_by_pk?: Maybe<Chat_Api_Mutation_Audit>;
  /** fetch data from the table in a streaming manner: "MutationAudit" */
  chat_api_mutation_audit_stream: Array<Chat_Api_Mutation_Audit>;
  /** An array relationship */
  cma_report_files: Array<Cma_Report_Files>;
  /** An aggregate relationship */
  cma_report_files_aggregate: Cma_Report_Files_Aggregate;
  /** fetch data from the table: "cma_report_files" using primary key columns */
  cma_report_files_by_pk?: Maybe<Cma_Report_Files>;
  /** fetch data from the table in a streaming manner: "cma_report_files" */
  cma_report_files_stream: Array<Cma_Report_Files>;
  /** fetch data from the table: "cma_report_source_enum" */
  cma_report_source_enum: Array<Cma_Report_Source_Enum>;
  /** fetch data from the table: "cma_report_source_enum" using primary key columns */
  cma_report_source_enum_by_pk?: Maybe<Cma_Report_Source_Enum>;
  /** fetch data from the table in a streaming manner: "cma_report_source_enum" */
  cma_report_source_enum_stream: Array<Cma_Report_Source_Enum>;
  /** An array relationship */
  cma_reports: Array<Cma_Reports>;
  /** An array relationship */
  cma_reports_agent_transactions: Array<Cma_Reports_Agent_Transactions>;
  /** fetch data from the table: "cma_reports_agent_transactions" using primary key columns */
  cma_reports_agent_transactions_by_pk?: Maybe<Cma_Reports_Agent_Transactions>;
  /** fetch data from the table in a streaming manner: "cma_reports_agent_transactions" */
  cma_reports_agent_transactions_stream: Array<Cma_Reports_Agent_Transactions>;
  /** An aggregate relationship */
  cma_reports_aggregate: Cma_Reports_Aggregate;
  /** fetch data from the table: "cma_reports" using primary key columns */
  cma_reports_by_pk?: Maybe<Cma_Reports>;
  /** fetch data from the table: "cma_reports_comparables" */
  cma_reports_comparables: Array<Cma_Reports_Comparables>;
  /** fetch data from the table: "cma_reports_comparables" using primary key columns */
  cma_reports_comparables_by_pk?: Maybe<Cma_Reports_Comparables>;
  /** fetch data from the table in a streaming manner: "cma_reports_comparables" */
  cma_reports_comparables_stream: Array<Cma_Reports_Comparables>;
  /** fetch data from the table: "cma_reports_property_transactions" */
  cma_reports_property_transactions: Array<Cma_Reports_Property_Transactions>;
  /** fetch data from the table: "cma_reports_property_transactions" using primary key columns */
  cma_reports_property_transactions_by_pk?: Maybe<Cma_Reports_Property_Transactions>;
  /** fetch data from the table in a streaming manner: "cma_reports_property_transactions" */
  cma_reports_property_transactions_stream: Array<Cma_Reports_Property_Transactions>;
  /** fetch data from the table in a streaming manner: "cma_reports" */
  cma_reports_stream: Array<Cma_Reports>;
  /** fetch data from the table: "cma_reports_user_reviews" */
  cma_reports_user_reviews: Array<Cma_Reports_User_Reviews>;
  /** fetch data from the table: "cma_reports_user_reviews" using primary key columns */
  cma_reports_user_reviews_by_pk?: Maybe<Cma_Reports_User_Reviews>;
  /** fetch data from the table in a streaming manner: "cma_reports_user_reviews" */
  cma_reports_user_reviews_stream: Array<Cma_Reports_User_Reviews>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  /** fetch data from the table in a streaming manner: "combined_reviews" */
  combined_reviews_stream: Array<Combined_Reviews>;
  /** fetch data from the table: "cooling_enum" */
  cooling_enum: Array<Cooling_Enum>;
  /** fetch data from the table: "cooling_enum" using primary key columns */
  cooling_enum_by_pk?: Maybe<Cooling_Enum>;
  /** fetch data from the table in a streaming manner: "cooling_enum" */
  cooling_enum_stream: Array<Cooling_Enum>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch data from the table: "countries" using primary key columns */
  countries_by_pk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countries_stream: Array<Countries>;
  /** An array relationship */
  development_files: Array<Development_Files>;
  /** An aggregate relationship */
  development_files_aggregate: Development_Files_Aggregate;
  /** fetch data from the table: "development_files" using primary key columns */
  development_files_by_pk?: Maybe<Development_Files>;
  /** fetch data from the table in a streaming manner: "development_files" */
  development_files_stream: Array<Development_Files>;
  /** An array relationship */
  development_images: Array<Development_Images>;
  /** An aggregate relationship */
  development_images_aggregate: Development_Images_Aggregate;
  /** fetch data from the table: "development_images" using primary key columns */
  development_images_by_pk?: Maybe<Development_Images>;
  /** fetch data from the table in a streaming manner: "development_images" */
  development_images_stream: Array<Development_Images>;
  /** An array relationship */
  development_mappings: Array<Development_Mappings>;
  /** fetch data from the table: "development_mappings" using primary key columns */
  development_mappings_by_pk?: Maybe<Development_Mappings>;
  /** fetch data from the table in a streaming manner: "development_mappings" */
  development_mappings_stream: Array<Development_Mappings>;
  /** fetch data from the table: "development_status_enum" */
  development_status_enum: Array<Development_Status_Enum>;
  /** fetch data from the table: "development_status_enum" using primary key columns */
  development_status_enum_by_pk?: Maybe<Development_Status_Enum>;
  /** fetch data from the table in a streaming manner: "development_status_enum" */
  development_status_enum_stream: Array<Development_Status_Enum>;
  /** An array relationship */
  developments: Array<Developments>;
  /** An aggregate relationship */
  developments_aggregate: Developments_Aggregate;
  /** fetch data from the table: "developments" using primary key columns */
  developments_by_pk?: Maybe<Developments>;
  /** fetch data from the table in a streaming manner: "developments" */
  developments_stream: Array<Developments>;
  /** fetch data from the table: "dictionaries" */
  dictionaries: Array<Dictionaries>;
  /** fetch aggregated fields from the table: "dictionaries" */
  dictionaries_aggregate: Dictionaries_Aggregate;
  /** fetch data from the table: "dictionaries" using primary key columns */
  dictionaries_by_pk?: Maybe<Dictionaries>;
  /** fetch data from the table in a streaming manner: "dictionaries" */
  dictionaries_stream: Array<Dictionaries>;
  /** fetch data from the table: "dictionaries_types_enum" */
  dictionaries_types_enum: Array<Dictionaries_Types_Enum>;
  /** fetch data from the table: "dictionaries_types_enum" using primary key columns */
  dictionaries_types_enum_by_pk?: Maybe<Dictionaries_Types_Enum>;
  /** fetch data from the table in a streaming manner: "dictionaries_types_enum" */
  dictionaries_types_enum_stream: Array<Dictionaries_Types_Enum>;
  /** fetch data from the table: "doc_template_themes" */
  doc_template_themes: Array<Doc_Template_Themes>;
  /** fetch data from the table: "doc_template_themes" using primary key columns */
  doc_template_themes_by_pk?: Maybe<Doc_Template_Themes>;
  /** fetch data from the table in a streaming manner: "doc_template_themes" */
  doc_template_themes_stream: Array<Doc_Template_Themes>;
  /** fetch data from the table: "doc_template_type_enum" */
  doc_template_type_enum: Array<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_template_type_enum" using primary key columns */
  doc_template_type_enum_by_pk?: Maybe<Doc_Template_Type_Enum>;
  /** fetch data from the table in a streaming manner: "doc_template_type_enum" */
  doc_template_type_enum_stream: Array<Doc_Template_Type_Enum>;
  /** fetch data from the table: "doc_template_versions" */
  doc_template_versions: Array<Doc_Template_Versions>;
  /** fetch data from the table: "doc_template_versions" using primary key columns */
  doc_template_versions_by_pk?: Maybe<Doc_Template_Versions>;
  /** fetch data from the table in a streaming manner: "doc_template_versions" */
  doc_template_versions_stream: Array<Doc_Template_Versions>;
  /** fetch data from the table: "doc_templates" */
  doc_templates: Array<Doc_Templates>;
  /** fetch data from the table: "doc_templates" using primary key columns */
  doc_templates_by_pk?: Maybe<Doc_Templates>;
  /** fetch data from the table in a streaming manner: "doc_templates" */
  doc_templates_stream: Array<Doc_Templates>;
  /** An array relationship */
  doc_templates_tenants: Array<Doc_Templates_Tenants>;
  /** fetch data from the table: "doc_templates_tenants" using primary key columns */
  doc_templates_tenants_by_pk?: Maybe<Doc_Templates_Tenants>;
  /** fetch data from the table in a streaming manner: "doc_templates_tenants" */
  doc_templates_tenants_stream: Array<Doc_Templates_Tenants>;
  /** fetch data from the table: "email_sequences" */
  email_sequences: Array<Email_Sequences>;
  /** fetch data from the table: "email_sequences" using primary key columns */
  email_sequences_by_pk?: Maybe<Email_Sequences>;
  /** An array relationship */
  email_sequences_recipients: Array<Email_Sequences_Recipients>;
  /** An aggregate relationship */
  email_sequences_recipients_aggregate: Email_Sequences_Recipients_Aggregate;
  /** fetch data from the table: "email_sequences_recipients" using primary key columns */
  email_sequences_recipients_by_pk?: Maybe<Email_Sequences_Recipients>;
  /** fetch data from the table in a streaming manner: "email_sequences_recipients" */
  email_sequences_recipients_stream: Array<Email_Sequences_Recipients>;
  /** An array relationship */
  email_sequences_steps: Array<Email_Sequences_Steps>;
  /** An aggregate relationship */
  email_sequences_steps_aggregate: Email_Sequences_Steps_Aggregate;
  /** fetch data from the table: "email_sequences_steps" using primary key columns */
  email_sequences_steps_by_pk?: Maybe<Email_Sequences_Steps>;
  /** fetch data from the table in a streaming manner: "email_sequences_steps" */
  email_sequences_steps_stream: Array<Email_Sequences_Steps>;
  /** fetch data from the table in a streaming manner: "email_sequences" */
  email_sequences_stream: Array<Email_Sequences>;
  /** An array relationship */
  email_templates: Array<Email_Templates>;
  /** fetch data from the table: "email_templates" using primary key columns */
  email_templates_by_pk?: Maybe<Email_Templates>;
  /** fetch data from the table in a streaming manner: "email_templates" */
  email_templates_stream: Array<Email_Templates>;
  /** An array relationship */
  emails: Array<Emails>;
  /** fetch data from the table: "emails" using primary key columns */
  emails_by_pk?: Maybe<Emails>;
  /** fetch data from the table in a streaming manner: "emails" */
  emails_stream: Array<Emails>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  /** fetch data from the table: "enquiries" using primary key columns */
  enquiries_by_pk?: Maybe<Enquiries>;
  /** fetch data from the table: "enquiries_source_enum" */
  enquiries_source_enum: Array<Enquiries_Source_Enum>;
  /** fetch data from the table: "enquiries_source_enum" using primary key columns */
  enquiries_source_enum_by_pk?: Maybe<Enquiries_Source_Enum>;
  /** fetch data from the table in a streaming manner: "enquiries_source_enum" */
  enquiries_source_enum_stream: Array<Enquiries_Source_Enum>;
  /** fetch data from the table in a streaming manner: "enquiries" */
  enquiries_stream: Array<Enquiries>;
  /** fetch data from the table: "cma_listings" */
  es_cma_listings: Array<Es_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  es_cma_listings_aggregate: Es_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  es_cma_listings_by_pk?: Maybe<Es_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  es_cma_listings_distance: Array<Es_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  es_cma_listings_distance_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  es_cma_listings_distance_by_pk?: Maybe<Es_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  es_cma_rental_listings: Array<Es_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  es_cma_rental_listings_aggregate: Es_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  es_cma_rental_listings_by_pk?: Maybe<Es_Cma_Rental_Listings>;
  /** fetch data from the table: "external_transactions" */
  es_external_transactions: Array<Es_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  es_external_transactions_aggregate: Es_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  es_external_transactions_distance: Array<Es_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  es_external_transactions_distance_aggregate: Es_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  es_external_transactions_distance_by_pk?: Maybe<Es_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  es_get_cma_listings_by_radius: Array<Es_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  es_get_cma_listings_by_radius_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  es_get_cma_listings_distance: Array<Es_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  es_get_cma_listings_distance_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  es_get_external_transactions_distance: Array<Es_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  es_get_external_transactions_distance_aggregate: Es_External_Transactions_Distance_Aggregate;
  /** execute function "get_house_appt_price_stats" which returns "price_stats" */
  es_get_house_appt_price_stats: Array<Es_Price_Stats>;
  /** execute function "get_house_appt_price_stats" and query aggregates on result of table type "price_stats" */
  es_get_house_appt_price_stats_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  es_get_listings_stats?: Maybe<Es_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  es_get_listings_stats_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_listings_stats_by_place_slug" which returns "price_stats" */
  es_get_listings_stats_by_place_slug: Array<Es_Price_Stats>;
  /** execute function "get_listings_stats_by_place_slug" and query aggregates on result of table type "price_stats" */
  es_get_listings_stats_by_place_slug_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_map_place_stats" which returns "price_stats" */
  es_get_map_place_stats: Array<Es_Price_Stats>;
  /** execute function "get_map_place_stats" and query aggregates on result of table type "price_stats" */
  es_get_map_place_stats_aggregate: Es_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  es_get_merged_listings: Array<Es_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  es_get_merged_listings_type: Array<Es_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  es_get_place_by_slug?: Maybe<Es_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  es_get_place_by_slug_aggregate: Es_Places_Aggregate;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  es_get_rental_cma_listings_distance: Array<Es_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  es_get_rental_cma_listings_distance_aggregate: Es_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  es_get_similar_listings: Array<Es_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  es_get_similar_listings_aggregate: Es_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  es_get_similar_listings_cohorts: Array<Es_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  es_get_similar_listings_cohorts_aggregate: Es_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  es_get_similar_listings_vector: Array<Es_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  es_get_similar_listings_vector_aggregate: Es_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  es_get_similar_rental_listings_cohorts: Array<Es_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  es_get_similar_rental_listings_cohorts_aggregate: Es_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  es_merged_images: Array<Es_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  es_merged_images_aggregate: Es_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  es_merged_listings: Array<Es_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  es_merged_listings_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  es_merged_listings_by_pk?: Maybe<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  es_merged_listings_compare: Array<Es_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  es_merged_listings_compare_aggregate: Es_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  es_places: Array<Es_Places>;
  /** fetch aggregated fields from the table: "places" */
  es_places_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  es_places_breadcrumbs: Array<Es_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  es_places_breadcrumbs_aggregate: Es_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  es_places_by_pk?: Maybe<Es_Places>;
  /** fetch data from the table: "plots" */
  es_plots: Array<Es_Plots>;
  /** fetch data from the table: "plots" using primary key columns */
  es_plots_by_pk?: Maybe<Es_Plots>;
  /** fetch data from the table: "post_merged_listings" */
  es_post_merged_listings: Array<Es_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  es_post_merged_listings_aggregate: Es_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  es_post_merged_listings_by_pk?: Maybe<Es_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  es_price_stats: Array<Es_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  es_price_stats_aggregate: Es_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  es_price_stats_historical: Array<Es_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  es_price_stats_historical_aggregate: Es_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  es_price_stats_historical_by_pk?: Maybe<Es_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  es_property_types: Array<Es_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  es_rental_cma_listings_distance: Array<Es_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  es_rental_cma_listings_distance_aggregate: Es_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  es_search_places_with_index: Array<Es_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  es_search_places_with_index_aggregate: Es_Places_Aggregate;
  /** fetch data from the table: "states" */
  es_states: Array<Es_States>;
  /** fetch data from the table: "street_stats" */
  es_street_stats: Array<Es_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  es_street_stats_aggregate: Es_Street_Stats_Aggregate;
  /** fetch data from the table: "files" */
  files: Array<Files>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: Maybe<Files>;
  /** fetch data from the table in a streaming manner: "files" */
  files_stream: Array<Files>;
  /** execute function "find_cma_leads_by_address" which returns "leads" */
  find_cma_leads_by_address: Array<Leads>;
  /** execute function "find_cma_leads_by_address" and query aggregates on result of table type "leads" */
  find_cma_leads_by_address_aggregate: Leads_Aggregate;
  /** execute function "find_price_map_places" which returns "places" */
  find_price_map_places: Array<Places>;
  /** execute function "find_price_map_places" and query aggregates on result of table type "places" */
  find_price_map_places_aggregate: Places_Aggregate;
  /** fetch data from the table: "cma_listings" */
  fr_cma_listings: Array<Fr_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  fr_cma_listings_aggregate: Fr_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  fr_cma_listings_by_pk?: Maybe<Fr_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  fr_cma_listings_distance: Array<Fr_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  fr_cma_listings_distance_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  fr_cma_listings_distance_by_pk?: Maybe<Fr_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  fr_cma_rental_listings: Array<Fr_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  fr_cma_rental_listings_aggregate: Fr_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  fr_cma_rental_listings_by_pk?: Maybe<Fr_Cma_Rental_Listings>;
  /** fetch data from the table: "energy_certificates" */
  fr_energy_certificates: Array<Fr_Energy_Certificates>;
  /** fetch data from the table: "energy_certificates" using primary key columns */
  fr_energy_certificates_by_pk?: Maybe<Fr_Energy_Certificates>;
  /** fetch data from the table: "external_transactions" */
  fr_external_transactions: Array<Fr_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  fr_external_transactions_aggregate: Fr_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  fr_external_transactions_distance: Array<Fr_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  fr_external_transactions_distance_aggregate: Fr_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  fr_external_transactions_distance_by_pk?: Maybe<Fr_External_Transactions_Distance>;
  /** execute function "get_buy_rent_listings" which returns "merged_listings" */
  fr_get_buy_rent_listings: Array<Fr_Merged_Listings>;
  /** execute function "get_buy_rent_listings" and query aggregates on result of table type "merged_listings" */
  fr_get_buy_rent_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  fr_get_cma_listings_by_radius: Array<Fr_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  fr_get_cma_listings_by_radius_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  fr_get_cma_listings_distance: Array<Fr_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  fr_get_cma_listings_distance_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  fr_get_external_transactions_distance: Array<Fr_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  fr_get_external_transactions_distance_aggregate: Fr_External_Transactions_Distance_Aggregate;
  /** execute function "get_house_appt_price_stats" which returns "price_stats" */
  fr_get_house_appt_price_stats: Array<Fr_Price_Stats>;
  /** execute function "get_house_appt_price_stats" and query aggregates on result of table type "price_stats" */
  fr_get_house_appt_price_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  fr_get_listings_stats?: Maybe<Fr_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  fr_get_listings_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_listings_stats_by_place_slug" which returns "price_stats" */
  fr_get_listings_stats_by_place_slug: Array<Fr_Price_Stats>;
  /** execute function "get_listings_stats_by_place_slug" and query aggregates on result of table type "price_stats" */
  fr_get_listings_stats_by_place_slug_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_map_place_stats" which returns "price_stats" */
  fr_get_map_place_stats: Array<Fr_Price_Stats>;
  /** execute function "get_map_place_stats" and query aggregates on result of table type "price_stats" */
  fr_get_map_place_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  fr_get_merged_listings: Array<Fr_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  fr_get_merged_listings_type: Array<Fr_Get_Merged_Listings_Type>;
  /** execute function "get_place_by_slug" which returns "places" */
  fr_get_place_by_slug?: Maybe<Fr_Places>;
  /** execute function "get_place_by_slug" and query aggregates on result of table type "places" */
  fr_get_place_by_slug_aggregate: Fr_Places_Aggregate;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  fr_get_rental_cma_listings_distance: Array<Fr_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  fr_get_rental_cma_listings_distance_aggregate: Fr_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  fr_get_similar_listings: Array<Fr_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  fr_get_similar_listings_aggregate: Fr_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  fr_get_similar_listings_cohorts: Array<Fr_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  fr_get_similar_listings_cohorts_aggregate: Fr_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  fr_get_similar_listings_vector: Array<Fr_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  fr_get_similar_listings_vector_aggregate: Fr_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  fr_get_similar_rental_listings_cohorts: Array<Fr_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  fr_get_similar_rental_listings_cohorts_aggregate: Fr_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  fr_merged_images: Array<Fr_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  fr_merged_images_aggregate: Fr_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  fr_merged_listings: Array<Fr_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  fr_merged_listings_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  fr_merged_listings_by_pk?: Maybe<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  fr_merged_listings_compare: Array<Fr_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  fr_merged_listings_compare_aggregate: Fr_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  fr_places: Array<Fr_Places>;
  /** fetch aggregated fields from the table: "places" */
  fr_places_aggregate: Fr_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs: Array<Fr_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  fr_places_breadcrumbs_aggregate: Fr_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  fr_places_by_pk?: Maybe<Fr_Places>;
  /** fetch data from the table: "plots" */
  fr_plots: Array<Fr_Plots>;
  /** fetch data from the table: "plots" using primary key columns */
  fr_plots_by_pk?: Maybe<Fr_Plots>;
  /** fetch data from the table: "post_merged_listings" */
  fr_post_merged_listings: Array<Fr_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  fr_post_merged_listings_aggregate: Fr_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  fr_post_merged_listings_by_pk?: Maybe<Fr_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  fr_price_stats: Array<Fr_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  fr_price_stats_aggregate: Fr_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  fr_price_stats_historical: Array<Fr_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  fr_price_stats_historical_aggregate: Fr_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  fr_price_stats_historical_by_pk?: Maybe<Fr_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  fr_property_types: Array<Fr_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  fr_rental_cma_listings_distance: Array<Fr_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  fr_rental_cma_listings_distance_aggregate: Fr_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  fr_search_places_with_index: Array<Fr_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  fr_search_places_with_index_aggregate: Fr_Places_Aggregate;
  /** fetch data from the table: "states" */
  fr_states: Array<Fr_States>;
  /** fetch data from the table: "street_stats" */
  fr_street_stats: Array<Fr_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  fr_street_stats_aggregate: Fr_Street_Stats_Aggregate;
  /** execute function "fsbo_seller_cluster" which returns "fsbo_seller_cluster_result" */
  fsbo_seller_cluster: Array<Fsbo_Seller_Cluster_Result>;
  /** fetch data from the table: "fsbo_seller_cluster_result" */
  fsbo_seller_cluster_result: Array<Fsbo_Seller_Cluster_Result>;
  /** fetch data from the table: "fsbo_seller_cluster_result" using primary key columns */
  fsbo_seller_cluster_result_by_pk?: Maybe<Fsbo_Seller_Cluster_Result>;
  /** fetch data from the table in a streaming manner: "fsbo_seller_cluster_result" */
  fsbo_seller_cluster_result_stream: Array<Fsbo_Seller_Cluster_Result>;
  /** execute function "get_activities_feed_for_lead" which returns "activities" */
  get_activities_feed_for_lead: Array<Activities>;
  /** execute function "get_activities_feed_for_lead" and query aggregates on result of table type "activities" */
  get_activities_feed_for_lead_aggregate: Activities_Aggregate;
  /** execute function "get_activities_feed_for_lot" which returns "activities" */
  get_activities_feed_for_lot: Array<Activities>;
  /** execute function "get_activities_feed_for_lot" and query aggregates on result of table type "activities" */
  get_activities_feed_for_lot_aggregate: Activities_Aggregate;
  /** execute function "get_activities_feed_for_user" which returns "activities" */
  get_activities_feed_for_user: Array<Activities>;
  /** execute function "get_activities_feed_for_user" and query aggregates on result of table type "activities" */
  get_activities_feed_for_user_aggregate: Activities_Aggregate;
  /** execute function "get_agents_ranking" which returns "agents_rankings" */
  get_agents_ranking: Array<Agents_Rankings>;
  /** execute function "get_agents_ranking" and query aggregates on result of table type "agents_rankings" */
  get_agents_ranking_aggregate: Agents_Rankings_Aggregate;
  /** execute function "get_agents_ranking_deduped" which returns "agents_rankings" */
  get_agents_ranking_deduped: Array<Agents_Rankings>;
  /** execute function "get_agents_ranking_deduped" and query aggregates on result of table type "agents_rankings" */
  get_agents_ranking_deduped_aggregate: Agents_Rankings_Aggregate;
  /** execute function "get_appraisals_by_slug" which returns "appraisals_public_view" */
  get_appraisals_by_slug: Array<Appraisals_Public_View>;
  /** execute function "get_catchment_area" which returns "places" */
  get_catchment_area: Array<Places>;
  /** execute function "get_catchment_area" and query aggregates on result of table type "places" */
  get_catchment_area_aggregate: Places_Aggregate;
  /** execute function "get_cma_agent_transactions" which returns "cma_reports_agent_transactions" */
  get_cma_agent_transactions: Array<Cma_Reports_Agent_Transactions>;
  /** execute function "get_local_activity_feed" which returns "local_activity_feed_items" */
  get_local_activity_feed: Array<Local_Activity_Feed_Items>;
  /** execute function "get_local_activity_feed" and query aggregates on result of table type "local_activity_feed_items" */
  get_local_activity_feed_aggregate: Local_Activity_Feed_Items_Aggregate;
  /** execute function "get_lot_publication_history" which returns "lot_publication_history_result" */
  get_lot_publication_history: Array<Lot_Publication_History_Result>;
  /** execute function "get_nearby_appraisals" which returns "appraisals_public_view" */
  get_nearby_appraisals: Array<Appraisals_Public_View>;
  /** execute function "get_nearby_reviews" which returns "reviews" */
  get_nearby_reviews: Array<Reviews>;
  /** execute function "get_nearby_reviews" and query aggregates on result of table type "reviews" */
  get_nearby_reviews_aggregate: Reviews_Aggregate;
  /** execute function "get_nearby_transactions" which returns "property_transactions" */
  get_nearby_transactions: Array<Property_Transactions>;
  /** execute function "get_nearby_transactions" and query aggregates on result of table type "property_transactions" */
  get_nearby_transactions_aggregate: Property_Transactions_Aggregate;
  /** execute function "get_online_listing_map_data" which returns "online_listing_map_data" */
  get_online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** execute function "get_online_listing_map_data" and query aggregates on result of table type "online_listing_map_data" */
  get_online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** execute function "get_property_transactions_distance" which returns "property_transactions_distance" */
  get_property_transactions_distance: Array<Property_Transactions_Distance>;
  /** execute function "get_property_transactions_distance" and query aggregates on result of table type "property_transactions_distance" */
  get_property_transactions_distance_aggregate: Property_Transactions_Distance_Aggregate;
  /** execute function "get_reviews_in_location" which returns "reviews" */
  get_reviews_in_location: Array<Reviews>;
  /** execute function "get_reviews_in_location" and query aggregates on result of table type "reviews" */
  get_reviews_in_location_aggregate: Reviews_Aggregate;
  /** execute function "get_similar_online_listings" which returns "online_listings" */
  get_similar_online_listings: Array<Online_Listings>;
  /** execute function "get_similar_online_listings" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_aggregate: Online_Listings_Aggregate;
  /** execute function "get_similar_online_listings_ids" which returns "similar_online_listings_ids" */
  get_similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** execute function "get_similar_online_listings_ids" and query aggregates on result of table type "similar_online_listings_ids" */
  get_similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** execute function "get_similar_online_listings_vector" which returns "online_listings" */
  get_similar_online_listings_vector: Array<Online_Listings>;
  /** execute function "get_similar_online_listings_vector" and query aggregates on result of table type "online_listings" */
  get_similar_online_listings_vector_aggregate: Online_Listings_Aggregate;
  /** execute function "get_teams_ranking" which returns "teams_rankings" */
  get_teams_ranking: Array<Teams_Rankings>;
  /** execute function "get_teams_ranking" and query aggregates on result of table type "teams_rankings" */
  get_teams_ranking_aggregate: Teams_Rankings_Aggregate;
  /** execute function "get_teams_ranking_by_distance" which returns "teams_rankings" */
  get_teams_ranking_by_distance: Array<Teams_Rankings>;
  /** execute function "get_teams_ranking_by_distance" and query aggregates on result of table type "teams_rankings" */
  get_teams_ranking_by_distance_aggregate: Teams_Rankings_Aggregate;
  /** execute function "get_translated_enum" which returns "translated_enums" */
  get_translated_enum: Array<Translated_Enums>;
  /** execute function "global_statistics" which returns "global_stats" */
  global_statistics: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" */
  global_stats: Array<Global_Stats>;
  /** fetch data from the table: "global_stats" using primary key columns */
  global_stats_by_pk?: Maybe<Global_Stats>;
  /** fetch data from the table in a streaming manner: "global_stats" */
  global_stats_stream: Array<Global_Stats>;
  /** fetch data from the table: "google_addresses" */
  google_addresses: Array<Google_Addresses>;
  /** An array relationship */
  google_reviews: Array<Google_Reviews>;
  /** An aggregate relationship */
  google_reviews_aggregate: Google_Reviews_Aggregate;
  /** fetch data from the table: "google_reviews" using primary key columns */
  google_reviews_by_pk?: Maybe<Google_Reviews>;
  /** fetch data from the table in a streaming manner: "google_reviews" */
  google_reviews_stream: Array<Google_Reviews>;
  /** fetch data from the table: "heating_distribution_enum" */
  heating_distribution_enum: Array<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_distribution_enum" using primary key columns */
  heating_distribution_enum_by_pk?: Maybe<Heating_Distribution_Enum>;
  /** fetch data from the table in a streaming manner: "heating_distribution_enum" */
  heating_distribution_enum_stream: Array<Heating_Distribution_Enum>;
  /** fetch data from the table: "heating_enum" */
  heating_enum: Array<Heating_Enum>;
  /** fetch data from the table: "heating_enum" using primary key columns */
  heating_enum_by_pk?: Maybe<Heating_Enum>;
  /** fetch data from the table in a streaming manner: "heating_enum" */
  heating_enum_stream: Array<Heating_Enum>;
  /** fetch data from the table: "images" */
  images: Array<Images>;
  /** fetch data from the table: "images" using primary key columns */
  images_by_pk?: Maybe<Images>;
  /** fetch data from the table in a streaming manner: "images" */
  images_stream: Array<Images>;
  /** fetch data from the table: "invitations" */
  invitations: Array<Invitations>;
  /** fetch aggregated fields from the table: "invitations" */
  invitations_aggregate: Invitations_Aggregate;
  /** fetch data from the table: "invitations" using primary key columns */
  invitations_by_pk?: Maybe<Invitations>;
  /** fetch data from the table in a streaming manner: "invitations" */
  invitations_stream: Array<Invitations>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  /** fetch data from the table: "invoices" using primary key columns */
  invoices_by_pk?: Maybe<Invoices>;
  /** fetch data from the table in a streaming manner: "invoices" */
  invoices_stream: Array<Invoices>;
  /** fetch data from the table: "cma_listings" */
  it_cma_listings: Array<It_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  it_cma_listings_aggregate: It_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  it_cma_listings_by_pk?: Maybe<It_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  it_cma_listings_distance: Array<It_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  it_cma_listings_distance_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  it_cma_listings_distance_by_pk?: Maybe<It_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  it_cma_rental_listings: Array<It_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  it_cma_rental_listings_aggregate: It_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "cma_rental_listings" using primary key columns */
  it_cma_rental_listings_by_pk?: Maybe<It_Cma_Rental_Listings>;
  /** fetch data from the table: "external_transactions" */
  it_external_transactions: Array<It_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  it_external_transactions_aggregate: It_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  it_external_transactions_distance: Array<It_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  it_external_transactions_distance_aggregate: It_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  it_external_transactions_distance_by_pk?: Maybe<It_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  it_get_cma_listings_by_radius: Array<It_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  it_get_cma_listings_by_radius_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  it_get_cma_listings_distance: Array<It_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  it_get_cma_listings_distance_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  it_get_external_transactions_distance: Array<It_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  it_get_external_transactions_distance_aggregate: It_External_Transactions_Distance_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  it_get_listings_stats?: Maybe<It_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  it_get_listings_stats_aggregate: It_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  it_get_merged_listings: Array<It_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  it_get_merged_listings_type: Array<It_Get_Merged_Listings_Type>;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  it_get_rental_cma_listings_distance: Array<It_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  it_get_rental_cma_listings_distance_aggregate: It_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  it_get_similar_listings: Array<It_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  it_get_similar_listings_aggregate: It_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  it_get_similar_listings_cohorts: Array<It_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  it_get_similar_listings_cohorts_aggregate: It_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  it_get_similar_listings_vector: Array<It_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  it_get_similar_listings_vector_aggregate: It_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  it_get_similar_rental_listings_cohorts: Array<It_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  it_get_similar_rental_listings_cohorts_aggregate: It_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  it_merged_images: Array<It_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  it_merged_images_aggregate: It_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  it_merged_listings: Array<It_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  it_merged_listings_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  it_merged_listings_by_pk?: Maybe<It_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  it_merged_listings_compare: Array<It_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  it_merged_listings_compare_aggregate: It_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  it_places: Array<It_Places>;
  /** fetch aggregated fields from the table: "places" */
  it_places_aggregate: It_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  it_places_breadcrumbs: Array<It_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  it_places_breadcrumbs_aggregate: It_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  it_places_by_pk?: Maybe<It_Places>;
  /** fetch data from the table: "post_merged_listings" */
  it_post_merged_listings: Array<It_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  it_post_merged_listings_aggregate: It_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  it_post_merged_listings_by_pk?: Maybe<It_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  it_price_stats: Array<It_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  it_price_stats_aggregate: It_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  it_price_stats_historical: Array<It_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  it_price_stats_historical_aggregate: It_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  it_price_stats_historical_by_pk?: Maybe<It_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  it_property_types: Array<It_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  it_rental_cma_listings_distance: Array<It_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  it_rental_cma_listings_distance_aggregate: It_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  it_search_places_with_index: Array<It_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  it_search_places_with_index_aggregate: It_Places_Aggregate;
  /** fetch data from the table: "states" */
  it_states: Array<It_States>;
  /** fetch data from the table: "street_stats" */
  it_street_stats: Array<It_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  it_street_stats_aggregate: It_Street_Stats_Aggregate;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** fetch data from the table: "lead_agents" using primary key columns */
  lead_agents_by_pk?: Maybe<Lead_Agents>;
  /** fetch data from the table in a streaming manner: "lead_agents" */
  lead_agents_stream: Array<Lead_Agents>;
  /** fetch data from the table: "lead_stages" */
  lead_stages: Array<Lead_Stages>;
  /** fetch aggregated fields from the table: "lead_stages" */
  lead_stages_aggregate: Lead_Stages_Aggregate;
  /** fetch data from the table: "lead_stages" using primary key columns */
  lead_stages_by_pk?: Maybe<Lead_Stages>;
  /** fetch data from the table in a streaming manner: "lead_stages" */
  lead_stages_stream: Array<Lead_Stages>;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  /** fetch data from the table: "leads" using primary key columns */
  leads_by_pk?: Maybe<Leads>;
  /** fetch data from the table: "leads_status" */
  leads_status: Array<Leads_Status>;
  /** fetch data from the table: "leads_status" using primary key columns */
  leads_status_by_pk?: Maybe<Leads_Status>;
  /** fetch data from the table in a streaming manner: "leads_status" */
  leads_status_stream: Array<Leads_Status>;
  /** fetch data from the table in a streaming manner: "leads" */
  leads_stream: Array<Leads>;
  /** An array relationship */
  leads_tags: Array<Leads_Tags>;
  /** An aggregate relationship */
  leads_tags_aggregate: Leads_Tags_Aggregate;
  /** fetch data from the table: "leads_tags" using primary key columns */
  leads_tags_by_pk?: Maybe<Leads_Tags>;
  /** fetch data from the table in a streaming manner: "leads_tags" */
  leads_tags_stream: Array<Leads_Tags>;
  /** execute function "leads_the_same_address" which returns "leads" */
  leads_the_same_address: Array<Leads>;
  /** execute function "leads_the_same_address" and query aggregates on result of table type "leads" */
  leads_the_same_address_aggregate: Leads_Aggregate;
  /** fetch data from the table: "locality_adjacency" */
  locality_adjacency: Array<Locality_Adjacency>;
  /** fetch data from the table: "locality_adjacency" using primary key columns */
  locality_adjacency_by_pk?: Maybe<Locality_Adjacency>;
  /** fetch data from the table in a streaming manner: "locality_adjacency" */
  locality_adjacency_stream: Array<Locality_Adjacency>;
  /** An array relationship */
  lot_reference_aliases: Array<Lot_Reference_Aliases>;
  /** fetch data from the table: "lot_reference_aliases" using primary key columns */
  lot_reference_aliases_by_pk?: Maybe<Lot_Reference_Aliases>;
  /** fetch data from the table in a streaming manner: "lot_reference_aliases" */
  lot_reference_aliases_stream: Array<Lot_Reference_Aliases>;
  /** An array relationship */
  lot_sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  lot_sellers_aggregate: Lot_Sellers_Aggregate;
  /** fetch data from the table: "lot_sellers" using primary key columns */
  lot_sellers_by_pk?: Maybe<Lot_Sellers>;
  /** fetch data from the table in a streaming manner: "lot_sellers" */
  lot_sellers_stream: Array<Lot_Sellers>;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  /** fetch data from the table: "lots" using primary key columns */
  lots_by_pk?: Maybe<Lots>;
  /** fetch data from the table: "lots_member_access_enum" */
  lots_member_access_enum: Array<Lots_Member_Access_Enum>;
  /** fetch data from the table: "lots_member_access_enum" using primary key columns */
  lots_member_access_enum_by_pk?: Maybe<Lots_Member_Access_Enum>;
  /** fetch data from the table in a streaming manner: "lots_member_access_enum" */
  lots_member_access_enum_stream: Array<Lots_Member_Access_Enum>;
  /** fetch data from the table: "lots_status_enum" */
  lots_status_enum: Array<Lots_Status_Enum>;
  /** fetch data from the table: "lots_status_enum" using primary key columns */
  lots_status_enum_by_pk?: Maybe<Lots_Status_Enum>;
  /** fetch data from the table in a streaming manner: "lots_status_enum" */
  lots_status_enum_stream: Array<Lots_Status_Enum>;
  /** fetch data from the table in a streaming manner: "lots" */
  lots_stream: Array<Lots>;
  /** fetch data from the table: "marketing_metadata" */
  marketing_metadata: Array<Marketing_Metadata>;
  /** fetch data from the table: "marketing_metadata" using primary key columns */
  marketing_metadata_by_pk?: Maybe<Marketing_Metadata>;
  /** fetch data from the table in a streaming manner: "marketing_metadata" */
  marketing_metadata_stream: Array<Marketing_Metadata>;
  /** fetch data from the table: "marketplace_conversation_participants" */
  marketplace_conversation_participants: Array<Marketplace_Conversation_Participants>;
  /** fetch data from the table: "marketplace_conversation_participants" using primary key columns */
  marketplace_conversation_participants_by_pk?: Maybe<Marketplace_Conversation_Participants>;
  /** fetch data from the table in a streaming manner: "marketplace_conversation_participants" */
  marketplace_conversation_participants_stream: Array<Marketplace_Conversation_Participants>;
  /** fetch data from the table: "marketplace_conversation_public_participants" */
  marketplace_conversation_public_participants: Array<Marketplace_Conversation_Public_Participants>;
  /** fetch data from the table in a streaming manner: "marketplace_conversation_public_participants" */
  marketplace_conversation_public_participants_stream: Array<Marketplace_Conversation_Public_Participants>;
  /** fetch data from the table: "marketplace_conversations" */
  marketplace_conversations: Array<Marketplace_Conversations>;
  /** fetch data from the table: "marketplace_conversations" using primary key columns */
  marketplace_conversations_by_pk?: Maybe<Marketplace_Conversations>;
  /** fetch data from the table in a streaming manner: "marketplace_conversations" */
  marketplace_conversations_stream: Array<Marketplace_Conversations>;
  /** fetch data from the table: "marketplace_message_delivery_channel_enum" */
  marketplace_message_delivery_channel_enum: Array<Marketplace_Message_Delivery_Channel_Enum>;
  /** fetch data from the table: "marketplace_message_delivery_channel_enum" using primary key columns */
  marketplace_message_delivery_channel_enum_by_pk?: Maybe<Marketplace_Message_Delivery_Channel_Enum>;
  /** fetch data from the table in a streaming manner: "marketplace_message_delivery_channel_enum" */
  marketplace_message_delivery_channel_enum_stream: Array<Marketplace_Message_Delivery_Channel_Enum>;
  /** fetch data from the table: "marketplace_message_delivery_status_enum" */
  marketplace_message_delivery_status_enum: Array<Marketplace_Message_Delivery_Status_Enum>;
  /** fetch data from the table: "marketplace_message_delivery_status_enum" using primary key columns */
  marketplace_message_delivery_status_enum_by_pk?: Maybe<Marketplace_Message_Delivery_Status_Enum>;
  /** fetch data from the table in a streaming manner: "marketplace_message_delivery_status_enum" */
  marketplace_message_delivery_status_enum_stream: Array<Marketplace_Message_Delivery_Status_Enum>;
  /** fetch data from the table: "marketplace_message_origin_enum" */
  marketplace_message_origin_enum: Array<Marketplace_Message_Origin_Enum>;
  /** fetch data from the table: "marketplace_message_origin_enum" using primary key columns */
  marketplace_message_origin_enum_by_pk?: Maybe<Marketplace_Message_Origin_Enum>;
  /** fetch data from the table in a streaming manner: "marketplace_message_origin_enum" */
  marketplace_message_origin_enum_stream: Array<Marketplace_Message_Origin_Enum>;
  /** fetch data from the table: "marketplace_messages" */
  marketplace_messages: Array<Marketplace_Messages>;
  /** fetch data from the table: "marketplace_messages" using primary key columns */
  marketplace_messages_by_pk?: Maybe<Marketplace_Messages>;
  /** fetch data from the table in a streaming manner: "marketplace_messages" */
  marketplace_messages_stream: Array<Marketplace_Messages>;
  /** fetch data from the table: "marketplace_participant_role_enum" */
  marketplace_participant_role_enum: Array<Marketplace_Participant_Role_Enum>;
  /** fetch data from the table: "marketplace_participant_role_enum" using primary key columns */
  marketplace_participant_role_enum_by_pk?: Maybe<Marketplace_Participant_Role_Enum>;
  /** fetch data from the table in a streaming manner: "marketplace_participant_role_enum" */
  marketplace_participant_role_enum_stream: Array<Marketplace_Participant_Role_Enum>;
  /** execute function "get_marketplace_similar_online_listings" which returns "online_listings" */
  marketplace_similar_online_listings: Array<Online_Listings>;
  /** execute function "get_marketplace_similar_online_listings" and query aggregates on result of table type "online_listings" */
  marketplace_similar_online_listings_aggregate: Online_Listings_Aggregate;
  /** execute function "me" which returns "users" */
  me?: Maybe<Users>;
  /** execute function "me" and query aggregates on result of table type "users" */
  me_aggregate: Users_Aggregate;
  /** execute function "mls_agent_buyer_matches" which returns "mls_buyer_match_edge" */
  mls_agent_buyer_matches: Array<Mls_Buyer_Match_Edge>;
  /** fetch data from the table: "mls_buyer_match_edge" */
  mls_buyer_match_edge: Array<Mls_Buyer_Match_Edge>;
  /** fetch data from the table in a streaming manner: "mls_buyer_match_edge" */
  mls_buyer_match_edge_stream: Array<Mls_Buyer_Match_Edge>;
  /** fetch data from the table: "mls_commission_type_enum" */
  mls_commission_type_enum: Array<Mls_Commission_Type_Enum>;
  /** fetch data from the table: "mls_commission_type_enum" using primary key columns */
  mls_commission_type_enum_by_pk?: Maybe<Mls_Commission_Type_Enum>;
  /** fetch data from the table in a streaming manner: "mls_commission_type_enum" */
  mls_commission_type_enum_stream: Array<Mls_Commission_Type_Enum>;
  /** fetch data from the table: "mls_listing_enquiry_settings" */
  mls_listing_enquiry_settings: Array<Mls_Listing_Enquiry_Settings>;
  /** fetch aggregated fields from the table: "mls_listing_enquiry_settings" */
  mls_listing_enquiry_settings_aggregate: Mls_Listing_Enquiry_Settings_Aggregate;
  /** fetch data from the table: "mls_listing_enquiry_settings" using primary key columns */
  mls_listing_enquiry_settings_by_pk?: Maybe<Mls_Listing_Enquiry_Settings>;
  /** fetch data from the table in a streaming manner: "mls_listing_enquiry_settings" */
  mls_listing_enquiry_settings_stream: Array<Mls_Listing_Enquiry_Settings>;
  /** fetch data from the table: "mls_lots" */
  mls_lots: Array<Mls_Lots>;
  /** fetch aggregated fields from the table: "mls_lots" */
  mls_lots_aggregate: Mls_Lots_Aggregate;
  /** execute function "mls_lots_in_viewport" which returns "mls_lots" */
  mls_lots_in_viewport: Array<Mls_Lots>;
  /** execute function "mls_lots_in_viewport" and query aggregates on result of table type "mls_lots" */
  mls_lots_in_viewport_aggregate: Mls_Lots_Aggregate;
  /** fetch data from the table in a streaming manner: "mls_lots" */
  mls_lots_stream: Array<Mls_Lots>;
  /** fetch data from the table: "mls_network_teams" */
  mls_network_teams: Array<Mls_Network_Teams>;
  /** fetch aggregated fields from the table: "mls_network_teams" */
  mls_network_teams_aggregate: Mls_Network_Teams_Aggregate;
  /** fetch data from the table in a streaming manner: "mls_network_teams" */
  mls_network_teams_stream: Array<Mls_Network_Teams>;
  /** fetch data from the table: "mls_settings" */
  mls_settings: Array<Mls_Settings>;
  /** fetch data from the table: "mls_settings" using primary key columns */
  mls_settings_by_pk?: Maybe<Mls_Settings>;
  /** fetch data from the table in a streaming manner: "mls_settings" */
  mls_settings_stream: Array<Mls_Settings>;
  /** fetch data from the table: "mls_share_mode_enum" */
  mls_share_mode_enum: Array<Mls_Share_Mode_Enum>;
  /** fetch data from the table: "mls_share_mode_enum" using primary key columns */
  mls_share_mode_enum_by_pk?: Maybe<Mls_Share_Mode_Enum>;
  /** fetch data from the table in a streaming manner: "mls_share_mode_enum" */
  mls_share_mode_enum_stream: Array<Mls_Share_Mode_Enum>;
  /** fetch data from the table: "mls_share_status_enum" */
  mls_share_status_enum: Array<Mls_Share_Status_Enum>;
  /** fetch data from the table: "mls_share_status_enum" using primary key columns */
  mls_share_status_enum_by_pk?: Maybe<Mls_Share_Status_Enum>;
  /** fetch data from the table in a streaming manner: "mls_share_status_enum" */
  mls_share_status_enum_stream: Array<Mls_Share_Status_Enum>;
  /** An array relationship */
  mls_shares: Array<Mls_Shares>;
  /** An aggregate relationship */
  mls_shares_aggregate: Mls_Shares_Aggregate;
  /** fetch data from the table: "mls_shares" using primary key columns */
  mls_shares_by_pk?: Maybe<Mls_Shares>;
  /** fetch data from the table in a streaming manner: "mls_shares" */
  mls_shares_stream: Array<Mls_Shares>;
  /** execute function "notification_setting_impact" which returns "notification_setting_impact_result" */
  notification_setting_impact: Array<Notification_Setting_Impact_Result>;
  /** fetch data from the table: "notification_settings" */
  notification_settings: Array<Notification_Settings>;
  /** fetch data from the table: "notification_settings" using primary key columns */
  notification_settings_by_pk?: Maybe<Notification_Settings>;
  /** fetch data from the table in a streaming manner: "notification_settings" */
  notification_settings_stream: Array<Notification_Settings>;
  /** fetch data from the table: "nylas_account_configs" */
  nylas_account_configs: Array<Nylas_Account_Configs>;
  /** fetch data from the table: "nylas_account_configs" using primary key columns */
  nylas_account_configs_by_pk?: Maybe<Nylas_Account_Configs>;
  /** fetch data from the table in a streaming manner: "nylas_account_configs" */
  nylas_account_configs_stream: Array<Nylas_Account_Configs>;
  /** An array relationship */
  offers: Array<Offers>;
  /** An aggregate relationship */
  offers_aggregate: Offers_Aggregate;
  /** fetch data from the table: "offers" using primary key columns */
  offers_by_pk?: Maybe<Offers>;
  /** fetch data from the table in a streaming manner: "offers" */
  offers_stream: Array<Offers>;
  /** fetch data from the table: "online_listing_map_data" */
  online_listing_map_data: Array<Online_Listing_Map_Data>;
  /** fetch aggregated fields from the table: "online_listing_map_data" */
  online_listing_map_data_aggregate: Online_Listing_Map_Data_Aggregate;
  /** fetch data from the table: "online_listings" */
  online_listings: Array<Online_Listings>;
  /** fetch aggregated fields from the table: "online_listings" */
  online_listings_aggregate: Online_Listings_Aggregate;
  /** fetch data from the table: "online_listings" using primary key columns */
  online_listings_by_pk?: Maybe<Online_Listings>;
  /** An array relationship */
  organisation_images: Array<Organisation_Images>;
  /** fetch data from the table: "organisation_images" using primary key columns */
  organisation_images_by_pk?: Maybe<Organisation_Images>;
  /** fetch data from the table in a streaming manner: "organisation_images" */
  organisation_images_stream: Array<Organisation_Images>;
  /** An array relationship */
  organisation_users: Array<Organisation_Users>;
  /** fetch data from the table in a streaming manner: "organisation_users" */
  organisation_users_stream: Array<Organisation_Users>;
  /** fetch data from the table: "organisations" */
  organisations: Array<Organisations>;
  /** fetch aggregated fields from the table: "organisations" */
  organisations_aggregate: Organisations_Aggregate;
  /** fetch data from the table: "organisations" using primary key columns */
  organisations_by_pk?: Maybe<Organisations>;
  /** execute function "organisations_search" which returns "organisations" */
  organisations_search: Array<Organisations>;
  /** execute function "organisations_search" and query aggregates on result of table type "organisations" */
  organisations_search_aggregate: Organisations_Aggregate;
  /** fetch data from the table in a streaming manner: "organisations" */
  organisations_stream: Array<Organisations>;
  /** fetch data from the table: "phone_number_type_enum" */
  phone_number_type_enum: Array<Phone_Number_Type_Enum>;
  /** fetch data from the table: "phone_number_type_enum" using primary key columns */
  phone_number_type_enum_by_pk?: Maybe<Phone_Number_Type_Enum>;
  /** fetch data from the table in a streaming manner: "phone_number_type_enum" */
  phone_number_type_enum_stream: Array<Phone_Number_Type_Enum>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** fetch data from the table: "phone_numbers" using primary key columns */
  phone_numbers_by_pk?: Maybe<Phone_Numbers>;
  /** fetch data from the table in a streaming manner: "phone_numbers" */
  phone_numbers_stream: Array<Phone_Numbers>;
  /** fetch data from the table: "pipelines" */
  pipelines: Array<Pipelines>;
  /** fetch aggregated fields from the table: "pipelines" */
  pipelines_aggregate: Pipelines_Aggregate;
  /** fetch data from the table: "pipelines" using primary key columns */
  pipelines_by_pk?: Maybe<Pipelines>;
  /** fetch data from the table in a streaming manner: "pipelines" */
  pipelines_stream: Array<Pipelines>;
  /** fetch data from the table: "cma_listings" */
  pl_cma_listings: Array<Pl_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  pl_cma_listings_aggregate: Pl_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  pl_cma_listings_by_pk?: Maybe<Pl_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  pl_cma_listings_distance: Array<Pl_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  pl_cma_listings_distance_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  pl_cma_listings_distance_by_pk?: Maybe<Pl_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  pl_cma_rental_listings: Array<Pl_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  pl_cma_rental_listings_aggregate: Pl_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "external_transactions" */
  pl_external_transactions: Array<Pl_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  pl_external_transactions_aggregate: Pl_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  pl_external_transactions_distance: Array<Pl_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  pl_external_transactions_distance_aggregate: Pl_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  pl_external_transactions_distance_by_pk?: Maybe<Pl_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  pl_get_cma_listings_by_radius: Array<Pl_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  pl_get_cma_listings_by_radius_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  pl_get_cma_listings_distance: Array<Pl_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  pl_get_cma_listings_distance_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  pl_get_external_transactions_distance: Array<Pl_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  pl_get_external_transactions_distance_aggregate: Pl_External_Transactions_Distance_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  pl_get_listings_stats?: Maybe<Pl_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  pl_get_listings_stats_aggregate: Pl_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  pl_get_merged_listings: Array<Pl_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  pl_get_merged_listings_type: Array<Pl_Get_Merged_Listings_Type>;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  pl_get_rental_cma_listings_distance: Array<Pl_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  pl_get_rental_cma_listings_distance_aggregate: Pl_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  pl_get_similar_listings: Array<Pl_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  pl_get_similar_listings_aggregate: Pl_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  pl_get_similar_listings_cohorts: Array<Pl_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  pl_get_similar_listings_cohorts_aggregate: Pl_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  pl_get_similar_listings_vector: Array<Pl_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  pl_get_similar_listings_vector_aggregate: Pl_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  pl_get_similar_rental_listings_cohorts: Array<Pl_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  pl_get_similar_rental_listings_cohorts_aggregate: Pl_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  pl_merged_images: Array<Pl_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  pl_merged_images_aggregate: Pl_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  pl_merged_listings: Array<Pl_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  pl_merged_listings_aggregate: Pl_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  pl_merged_listings_by_pk?: Maybe<Pl_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  pl_merged_listings_compare: Array<Pl_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  pl_merged_listings_compare_aggregate: Pl_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  pl_places: Array<Pl_Places>;
  /** fetch aggregated fields from the table: "places" */
  pl_places_aggregate: Pl_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  pl_places_breadcrumbs: Array<Pl_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  pl_places_breadcrumbs_aggregate: Pl_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  pl_places_by_pk?: Maybe<Pl_Places>;
  /** fetch data from the table: "post_merged_listings" */
  pl_post_merged_listings: Array<Pl_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  pl_post_merged_listings_aggregate: Pl_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  pl_post_merged_listings_by_pk?: Maybe<Pl_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  pl_price_stats: Array<Pl_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  pl_price_stats_aggregate: Pl_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  pl_price_stats_historical: Array<Pl_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  pl_price_stats_historical_aggregate: Pl_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  pl_price_stats_historical_by_pk?: Maybe<Pl_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  pl_property_types: Array<Pl_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  pl_rental_cma_listings_distance: Array<Pl_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  pl_rental_cma_listings_distance_aggregate: Pl_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  pl_search_places_with_index: Array<Pl_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  pl_search_places_with_index_aggregate: Pl_Places_Aggregate;
  /** fetch data from the table: "states" */
  pl_states: Array<Pl_States>;
  /** fetch data from the table: "street_stats" */
  pl_street_stats: Array<Pl_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  pl_street_stats_aggregate: Pl_Street_Stats_Aggregate;
  /** execute function "place_by_slug" which returns "places" */
  place_by_slug?: Maybe<Places>;
  /** execute function "place_by_slug" and query aggregates on result of table type "places" */
  place_by_slug_aggregate: Places_Aggregate;
  /** execute function "place_by_type" which returns "places" */
  place_by_type: Array<Places>;
  /** execute function "place_by_type" and query aggregates on result of table type "places" */
  place_by_type_aggregate: Places_Aggregate;
  /** fetch data from the table: "places" */
  places: Array<Places>;
  /** execute function "places_agent_ranking" which returns "agents_rankings" */
  places_agent_ranking: Array<Agents_Rankings>;
  /** execute function "places_agent_ranking" and query aggregates on result of table type "agents_rankings" */
  places_agent_ranking_aggregate: Agents_Rankings_Aggregate;
  /** fetch aggregated fields from the table: "places" */
  places_aggregate: Places_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  places_by_pk?: Maybe<Places>;
  /** fetch data from the table in a streaming manner: "places" */
  places_stream: Array<Places>;
  /** An array relationship */
  portal_listings: Array<Portal_Listings>;
  /** An aggregate relationship */
  portal_listings_aggregate: Portal_Listings_Aggregate;
  /** fetch data from the table: "portal_listings" using primary key columns */
  portal_listings_by_pk?: Maybe<Portal_Listings>;
  /** fetch data from the table in a streaming manner: "portal_listings" */
  portal_listings_stream: Array<Portal_Listings>;
  /** fetch data from the table: "portals" */
  portals: Array<Portals>;
  /** fetch aggregated fields from the table: "portals" */
  portals_aggregate: Portals_Aggregate;
  /** fetch data from the table: "portals" using primary key columns */
  portals_by_pk?: Maybe<Portals>;
  /** fetch data from the table in a streaming manner: "portals" */
  portals_stream: Array<Portals>;
  /** fetch data from the table: "portals_types_enum" */
  portals_types_enum: Array<Portals_Types_Enum>;
  /** fetch data from the table: "portals_types_enum" using primary key columns */
  portals_types_enum_by_pk?: Maybe<Portals_Types_Enum>;
  /** fetch data from the table in a streaming manner: "portals_types_enum" */
  portals_types_enum_stream: Array<Portals_Types_Enum>;
  /** An array relationship */
  properties: Array<Properties>;
  /** fetch data from the table: "properties" using primary key columns */
  properties_by_pk?: Maybe<Properties>;
  /** fetch data from the table in a streaming manner: "properties" */
  properties_stream: Array<Properties>;
  /** An array relationship */
  property_files: Array<Property_Files>;
  /** An aggregate relationship */
  property_files_aggregate: Property_Files_Aggregate;
  /** fetch data from the table: "property_files" using primary key columns */
  property_files_by_pk?: Maybe<Property_Files>;
  /** fetch data from the table in a streaming manner: "property_files" */
  property_files_stream: Array<Property_Files>;
  /** An array relationship */
  property_images: Array<Property_Images>;
  /** An aggregate relationship */
  property_images_aggregate: Property_Images_Aggregate;
  /** fetch data from the table: "property_images" using primary key columns */
  property_images_by_pk?: Maybe<Property_Images>;
  /** fetch data from the table in a streaming manner: "property_images" */
  property_images_stream: Array<Property_Images>;
  /** fetch data from the table: "property_search_aggregator_source" */
  property_search_aggregator_source: Array<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_aggregator_source" using primary key columns */
  property_search_aggregator_source_by_pk?: Maybe<Property_Search_Aggregator_Source>;
  /** fetch data from the table in a streaming manner: "property_search_aggregator_source" */
  property_search_aggregator_source_stream: Array<Property_Search_Aggregator_Source>;
  /** fetch data from the table: "property_search_source" */
  property_search_source: Array<Property_Search_Source>;
  /** fetch data from the table: "property_search_source" using primary key columns */
  property_search_source_by_pk?: Maybe<Property_Search_Source>;
  /** fetch data from the table in a streaming manner: "property_search_source" */
  property_search_source_stream: Array<Property_Search_Source>;
  /** An array relationship */
  property_searches: Array<Property_Searches>;
  /** An aggregate relationship */
  property_searches_aggregate: Property_Searches_Aggregate;
  /** fetch data from the table: "property_searches" using primary key columns */
  property_searches_by_pk?: Maybe<Property_Searches>;
  /** An array relationship */
  property_searches_places: Array<Property_Searches_Places>;
  /** fetch data from the table: "property_searches_places" using primary key columns */
  property_searches_places_by_pk?: Maybe<Property_Searches_Places>;
  /** fetch data from the table in a streaming manner: "property_searches_places" */
  property_searches_places_stream: Array<Property_Searches_Places>;
  /** fetch data from the table in a streaming manner: "property_searches" */
  property_searches_stream: Array<Property_Searches>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** fetch data from the table: "property_transactions" using primary key columns */
  property_transactions_by_pk?: Maybe<Property_Transactions>;
  /** fetch data from the table: "property_transactions_country_view" */
  property_transactions_country_view: Array<Property_Transactions_Country_View>;
  /** fetch data from the table in a streaming manner: "property_transactions_country_view" */
  property_transactions_country_view_stream: Array<Property_Transactions_Country_View>;
  /** fetch data from the table: "property_transactions_distance" */
  property_transactions_distance: Array<Property_Transactions_Distance>;
  /** fetch aggregated fields from the table: "property_transactions_distance" */
  property_transactions_distance_aggregate: Property_Transactions_Distance_Aggregate;
  /** fetch data from the table: "property_transactions_distance" using primary key columns */
  property_transactions_distance_by_pk?: Maybe<Property_Transactions_Distance>;
  /** fetch data from the table in a streaming manner: "property_transactions_distance" */
  property_transactions_distance_stream: Array<Property_Transactions_Distance>;
  /** An array relationship */
  property_transactions_listings: Array<Property_Transactions_Listings>;
  /** fetch data from the table: "property_transactions_listings" using primary key columns */
  property_transactions_listings_by_pk?: Maybe<Property_Transactions_Listings>;
  /** fetch data from the table in a streaming manner: "property_transactions_listings" */
  property_transactions_listings_stream: Array<Property_Transactions_Listings>;
  /** fetch data from the table in a streaming manner: "property_transactions" */
  property_transactions_stream: Array<Property_Transactions>;
  /** fetch data from the table: "property_types" */
  property_types: Array<Property_Types>;
  /** fetch aggregated fields from the table: "property_types" */
  property_types_aggregate: Property_Types_Aggregate;
  /** fetch data from the table: "property_types" using primary key columns */
  property_types_by_pk?: Maybe<Property_Types>;
  /** fetch data from the table in a streaming manner: "property_types" */
  property_types_stream: Array<Property_Types>;
  /** fetch data from the table: "prospection_contact_message_templates" */
  prospection_contact_message_templates: Array<Prospection_Contact_Message_Templates>;
  /** fetch data from the table: "prospection_contact_message_templates" using primary key columns */
  prospection_contact_message_templates_by_pk?: Maybe<Prospection_Contact_Message_Templates>;
  /** fetch data from the table in a streaming manner: "prospection_contact_message_templates" */
  prospection_contact_message_templates_stream: Array<Prospection_Contact_Message_Templates>;
  /** fetch data from the table: "prospection_contact_settings" */
  prospection_contact_settings: Array<Prospection_Contact_Settings>;
  /** fetch data from the table: "prospection_contact_settings" using primary key columns */
  prospection_contact_settings_by_pk?: Maybe<Prospection_Contact_Settings>;
  /** fetch data from the table in a streaming manner: "prospection_contact_settings" */
  prospection_contact_settings_stream: Array<Prospection_Contact_Settings>;
  /** fetch data from the table: "prospection_contact_teams" */
  prospection_contact_teams: Array<Prospection_Contact_Teams>;
  /** fetch data from the table: "prospection_contact_teams" using primary key columns */
  prospection_contact_teams_by_pk?: Maybe<Prospection_Contact_Teams>;
  /** fetch data from the table in a streaming manner: "prospection_contact_teams" */
  prospection_contact_teams_stream: Array<Prospection_Contact_Teams>;
  /** fetch data from the table: "prospection_map_contact_attempts" */
  prospection_map_contact_attempts: Array<Prospection_Map_Contact_Attempts>;
  /** fetch aggregated fields from the table: "prospection_map_contact_attempts" */
  prospection_map_contact_attempts_aggregate: Prospection_Map_Contact_Attempts_Aggregate;
  /** fetch data from the table: "prospection_map_contact_attempts" using primary key columns */
  prospection_map_contact_attempts_by_pk?: Maybe<Prospection_Map_Contact_Attempts>;
  /** fetch data from the table in a streaming manner: "prospection_map_contact_attempts" */
  prospection_map_contact_attempts_stream: Array<Prospection_Map_Contact_Attempts>;
  /** fetch data from the table: "prospection_map_emailable_leads" */
  prospection_map_emailable_leads: Array<Prospection_Map_Emailable_Leads>;
  /** fetch data from the table in a streaming manner: "prospection_map_emailable_leads" */
  prospection_map_emailable_leads_stream: Array<Prospection_Map_Emailable_Leads>;
  /** fetch data from the table: "prospection_map_full_leads" */
  prospection_map_full_leads: Array<Prospection_Map_Full_Leads>;
  /** fetch data from the table in a streaming manner: "prospection_map_full_leads" */
  prospection_map_full_leads_stream: Array<Prospection_Map_Full_Leads>;
  /** execute function "prospection_map_lead_addresses_in_bbox" which returns "prospection_map_lead_addresses" */
  prospection_map_lead_addresses_in_bbox: Array<Prospection_Map_Lead_Addresses>;
  /** fetch data from the table: "prospection_marks" */
  prospection_marks: Array<Prospection_Marks>;
  /** fetch data from the table: "prospection_marks" using primary key columns */
  prospection_marks_by_pk?: Maybe<Prospection_Marks>;
  /** fetch data from the table in a streaming manner: "prospection_marks" */
  prospection_marks_stream: Array<Prospection_Marks>;
  /** fetch data from the table: "cma_listings" */
  pt_cma_listings: Array<Pt_Cma_Listings>;
  /** fetch aggregated fields from the table: "cma_listings" */
  pt_cma_listings_aggregate: Pt_Cma_Listings_Aggregate;
  /** fetch data from the table: "cma_listings" using primary key columns */
  pt_cma_listings_by_pk?: Maybe<Pt_Cma_Listings>;
  /** fetch data from the table: "cma_listings_distance" */
  pt_cma_listings_distance: Array<Pt_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "cma_listings_distance" */
  pt_cma_listings_distance_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "cma_listings_distance" using primary key columns */
  pt_cma_listings_distance_by_pk?: Maybe<Pt_Cma_Listings_Distance>;
  /** fetch data from the table: "cma_rental_listings" */
  pt_cma_rental_listings: Array<Pt_Cma_Rental_Listings>;
  /** fetch aggregated fields from the table: "cma_rental_listings" */
  pt_cma_rental_listings_aggregate: Pt_Cma_Rental_Listings_Aggregate;
  /** fetch data from the table: "external_transactions" */
  pt_external_transactions: Array<Pt_External_Transactions>;
  /** fetch aggregated fields from the table: "external_transactions" */
  pt_external_transactions_aggregate: Pt_External_Transactions_Aggregate;
  /** fetch data from the table: "external_transactions_distance" */
  pt_external_transactions_distance: Array<Pt_External_Transactions_Distance>;
  /** fetch aggregated fields from the table: "external_transactions_distance" */
  pt_external_transactions_distance_aggregate: Pt_External_Transactions_Distance_Aggregate;
  /** fetch data from the table: "external_transactions_distance" using primary key columns */
  pt_external_transactions_distance_by_pk?: Maybe<Pt_External_Transactions_Distance>;
  /** execute function "get_cma_listings_by_radius" which returns "cma_listings_distance" */
  pt_get_cma_listings_by_radius: Array<Pt_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_by_radius" and query aggregates on result of table type "cma_listings_distance" */
  pt_get_cma_listings_by_radius_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** execute function "get_cma_listings_distance" which returns "cma_listings_distance" */
  pt_get_cma_listings_distance: Array<Pt_Cma_Listings_Distance>;
  /** execute function "get_cma_listings_distance" and query aggregates on result of table type "cma_listings_distance" */
  pt_get_cma_listings_distance_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** execute function "get_external_transactions_distance" which returns "external_transactions_distance" */
  pt_get_external_transactions_distance: Array<Pt_External_Transactions_Distance>;
  /** execute function "get_external_transactions_distance" and query aggregates on result of table type "external_transactions_distance" */
  pt_get_external_transactions_distance_aggregate: Pt_External_Transactions_Distance_Aggregate;
  /** execute function "get_listings_stats" which returns "price_stats" */
  pt_get_listings_stats?: Maybe<Pt_Price_Stats>;
  /** execute function "get_listings_stats" and query aggregates on result of table type "price_stats" */
  pt_get_listings_stats_aggregate: Pt_Price_Stats_Aggregate;
  /** execute function "get_merged_listings" which returns "get_merged_listings_type" */
  pt_get_merged_listings: Array<Pt_Get_Merged_Listings_Type>;
  /** fetch data from the table: "get_merged_listings_type" */
  pt_get_merged_listings_type: Array<Pt_Get_Merged_Listings_Type>;
  /** execute function "get_rental_cma_listings_distance" which returns "rental_cma_listings_distance" */
  pt_get_rental_cma_listings_distance: Array<Pt_Rental_Cma_Listings_Distance>;
  /** execute function "get_rental_cma_listings_distance" and query aggregates on result of table type "rental_cma_listings_distance" */
  pt_get_rental_cma_listings_distance_aggregate: Pt_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings" which returns "cma_listings" */
  pt_get_similar_listings: Array<Pt_Cma_Listings>;
  /** execute function "get_similar_listings" and query aggregates on result of table type "cma_listings" */
  pt_get_similar_listings_aggregate: Pt_Cma_Listings_Aggregate;
  /** execute function "get_similar_listings_cohorts" which returns "cma_listings_distance" */
  pt_get_similar_listings_cohorts: Array<Pt_Cma_Listings_Distance>;
  /** execute function "get_similar_listings_cohorts" and query aggregates on result of table type "cma_listings_distance" */
  pt_get_similar_listings_cohorts_aggregate: Pt_Cma_Listings_Distance_Aggregate;
  /** execute function "get_similar_listings_vector" which returns "cma_listings" */
  pt_get_similar_listings_vector: Array<Pt_Cma_Listings>;
  /** execute function "get_similar_listings_vector" and query aggregates on result of table type "cma_listings" */
  pt_get_similar_listings_vector_aggregate: Pt_Cma_Listings_Aggregate;
  /** execute function "get_similar_rental_listings_cohorts" which returns "rental_cma_listings_distance" */
  pt_get_similar_rental_listings_cohorts: Array<Pt_Rental_Cma_Listings_Distance>;
  /** execute function "get_similar_rental_listings_cohorts" and query aggregates on result of table type "rental_cma_listings_distance" */
  pt_get_similar_rental_listings_cohorts_aggregate: Pt_Rental_Cma_Listings_Distance_Aggregate;
  /** fetch data from the table: "merged_images" */
  pt_merged_images: Array<Pt_Merged_Images>;
  /** fetch aggregated fields from the table: "merged_images" */
  pt_merged_images_aggregate: Pt_Merged_Images_Aggregate;
  /** fetch data from the table: "merged_listings" */
  pt_merged_listings: Array<Pt_Merged_Listings>;
  /** fetch aggregated fields from the table: "merged_listings" */
  pt_merged_listings_aggregate: Pt_Merged_Listings_Aggregate;
  /** fetch data from the table: "merged_listings" using primary key columns */
  pt_merged_listings_by_pk?: Maybe<Pt_Merged_Listings>;
  /** execute function "merged_listings_compare" which returns "merged_listings" */
  pt_merged_listings_compare: Array<Pt_Merged_Listings>;
  /** execute function "merged_listings_compare" and query aggregates on result of table type "merged_listings" */
  pt_merged_listings_compare_aggregate: Pt_Merged_Listings_Aggregate;
  /** fetch data from the table: "places" */
  pt_places: Array<Pt_Places>;
  /** fetch aggregated fields from the table: "places" */
  pt_places_aggregate: Pt_Places_Aggregate;
  /** fetch data from the table: "places_breadcrumbs" */
  pt_places_breadcrumbs: Array<Pt_Places_Breadcrumbs>;
  /** fetch aggregated fields from the table: "places_breadcrumbs" */
  pt_places_breadcrumbs_aggregate: Pt_Places_Breadcrumbs_Aggregate;
  /** fetch data from the table: "places" using primary key columns */
  pt_places_by_pk?: Maybe<Pt_Places>;
  /** fetch data from the table: "post_merged_listings" */
  pt_post_merged_listings: Array<Pt_Post_Merged_Listings>;
  /** fetch aggregated fields from the table: "post_merged_listings" */
  pt_post_merged_listings_aggregate: Pt_Post_Merged_Listings_Aggregate;
  /** fetch data from the table: "post_merged_listings" using primary key columns */
  pt_post_merged_listings_by_pk?: Maybe<Pt_Post_Merged_Listings>;
  /** fetch data from the table: "price_stats" */
  pt_price_stats: Array<Pt_Price_Stats>;
  /** fetch aggregated fields from the table: "price_stats" */
  pt_price_stats_aggregate: Pt_Price_Stats_Aggregate;
  /** fetch data from the table: "price_stats_historical" */
  pt_price_stats_historical: Array<Pt_Price_Stats_Historical>;
  /** fetch aggregated fields from the table: "price_stats_historical" */
  pt_price_stats_historical_aggregate: Pt_Price_Stats_Historical_Aggregate;
  /** fetch data from the table: "price_stats_historical" using primary key columns */
  pt_price_stats_historical_by_pk?: Maybe<Pt_Price_Stats_Historical>;
  /** fetch data from the table: "property_types" */
  pt_property_types: Array<Pt_Property_Types>;
  /** fetch data from the table: "rental_cma_listings_distance" */
  pt_rental_cma_listings_distance: Array<Pt_Rental_Cma_Listings_Distance>;
  /** fetch aggregated fields from the table: "rental_cma_listings_distance" */
  pt_rental_cma_listings_distance_aggregate: Pt_Rental_Cma_Listings_Distance_Aggregate;
  /** execute function "search_places_with_index" which returns "places" */
  pt_search_places_with_index: Array<Pt_Places>;
  /** execute function "search_places_with_index" and query aggregates on result of table type "places" */
  pt_search_places_with_index_aggregate: Pt_Places_Aggregate;
  /** fetch data from the table: "states" */
  pt_states: Array<Pt_States>;
  /** fetch data from the table: "street_stats" */
  pt_street_stats: Array<Pt_Street_Stats>;
  /** fetch aggregated fields from the table: "street_stats" */
  pt_street_stats_aggregate: Pt_Street_Stats_Aggregate;
  /** An array relationship */
  push_notification_tokens: Array<Push_Notification_Tokens>;
  /** fetch data from the table: "push_notification_tokens" using primary key columns */
  push_notification_tokens_by_pk?: Maybe<Push_Notification_Tokens>;
  /** fetch data from the table in a streaming manner: "push_notification_tokens" */
  push_notification_tokens_stream: Array<Push_Notification_Tokens>;
  /** fetch data from the table: "read_only_tenants" */
  read_only_tenants: Array<Read_Only_Tenants>;
  /** fetch data from the table in a streaming manner: "read_only_tenants" */
  read_only_tenants_stream: Array<Read_Only_Tenants>;
  /** fetch data from the table: "review_invitation_templates" */
  review_invitation_templates: Array<Review_Invitation_Templates>;
  /** fetch aggregated fields from the table: "review_invitation_templates" */
  review_invitation_templates_aggregate: Review_Invitation_Templates_Aggregate;
  /** fetch data from the table: "review_invitation_templates" using primary key columns */
  review_invitation_templates_by_pk?: Maybe<Review_Invitation_Templates>;
  /** fetch data from the table in a streaming manner: "review_invitation_templates" */
  review_invitation_templates_stream: Array<Review_Invitation_Templates>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  /** fetch data from the table: "reviews" using primary key columns */
  reviews_by_pk?: Maybe<Reviews>;
  /** fetch data from the table in a streaming manner: "reviews" */
  reviews_stream: Array<Reviews>;
  /** execute function "search_brockers_in_catchment_area" which returns "users" */
  search_brockers_in_catchment_area: Array<Users>;
  /** execute function "search_brockers_in_catchment_area" and query aggregates on result of table type "users" */
  search_brockers_in_catchment_area_aggregate: Users_Aggregate;
  /** execute function "search_buyer_leads_tsv" which returns "buyer_leads" */
  search_buyer_leads_tsv: Array<Buyer_Leads>;
  /** execute function "search_buyer_leads_tsv" and query aggregates on result of table type "buyer_leads" */
  search_buyer_leads_tsv_aggregate: Buyer_Leads_Aggregate;
  /** execute function "search_leads" which returns "leads" */
  search_leads: Array<Leads>;
  /** execute function "search_leads" and query aggregates on result of table type "leads" */
  search_leads_aggregate: Leads_Aggregate;
  /** execute function "search_leads_tsv" which returns "leads" */
  search_leads_tsv: Array<Leads>;
  /** execute function "search_leads_tsv" and query aggregates on result of table type "leads" */
  search_leads_tsv_aggregate: Leads_Aggregate;
  /** execute function "search_lots_tsv" which returns "lots" */
  search_lots_tsv: Array<Lots>;
  /** execute function "search_lots_tsv" and query aggregates on result of table type "lots" */
  search_lots_tsv_aggregate: Lots_Aggregate;
  /** execute function "search_places" which returns "places" */
  search_places: Array<Places>;
  /** execute function "search_places" and query aggregates on result of table type "places" */
  search_places_aggregate: Places_Aggregate;
  /** execute function "search_places_ex" which returns "places" */
  search_places_ex: Array<Places>;
  /** execute function "search_places_ex" and query aggregates on result of table type "places" */
  search_places_ex_aggregate: Places_Aggregate;
  /** execute function "search_property_transactions_tsv" which returns "property_transactions" */
  search_property_transactions_tsv: Array<Property_Transactions>;
  /** execute function "search_property_transactions_tsv" and query aggregates on result of table type "property_transactions" */
  search_property_transactions_tsv_aggregate: Property_Transactions_Aggregate;
  /** execute function "search_public_agents_tsv" which returns "users" */
  search_public_agents_tsv: Array<Users>;
  /** execute function "search_public_agents_tsv" and query aggregates on result of table type "users" */
  search_public_agents_tsv_aggregate: Users_Aggregate;
  /** execute function "search_teams_tsv" which returns "teams" */
  search_teams_tsv: Array<Teams>;
  /** execute function "search_teams_tsv" and query aggregates on result of table type "teams" */
  search_teams_tsv_aggregate: Teams_Aggregate;
  /** execute function "search_users" which returns "users" */
  search_users: Array<Users>;
  /** execute function "search_users" and query aggregates on result of table type "users" */
  search_users_aggregate: Users_Aggregate;
  /** execute function "search_users_tsv" which returns "users" */
  search_users_tsv: Array<Users>;
  /** execute function "search_users_tsv" and query aggregates on result of table type "users" */
  search_users_tsv_aggregate: Users_Aggregate;
  /** fetch data from the table: "seller_notification_frequency_enum" */
  seller_notification_frequency_enum: Array<Seller_Notification_Frequency_Enum>;
  /** fetch data from the table: "seller_notification_frequency_enum" using primary key columns */
  seller_notification_frequency_enum_by_pk?: Maybe<Seller_Notification_Frequency_Enum>;
  /** fetch data from the table in a streaming manner: "seller_notification_frequency_enum" */
  seller_notification_frequency_enum_stream: Array<Seller_Notification_Frequency_Enum>;
  /** fetch data from the table: "shared_portals" */
  shared_portals: Array<Shared_Portals>;
  /** fetch aggregated fields from the table: "shared_portals" */
  shared_portals_aggregate: Shared_Portals_Aggregate;
  /** fetch data from the table: "shared_portals" using primary key columns */
  shared_portals_by_pk?: Maybe<Shared_Portals>;
  /** fetch data from the table in a streaming manner: "shared_portals" */
  shared_portals_stream: Array<Shared_Portals>;
  /** fetch data from the table: "similar_online_listings_ids" */
  similar_online_listings_ids: Array<Similar_Online_Listings_Ids>;
  /** fetch aggregated fields from the table: "similar_online_listings_ids" */
  similar_online_listings_ids_aggregate: Similar_Online_Listings_Ids_Aggregate;
  /** fetch data from the table: "smart_lists" */
  smart_lists: Array<Smart_Lists>;
  /** fetch data from the table: "smart_lists" using primary key columns */
  smart_lists_by_pk?: Maybe<Smart_Lists>;
  /** fetch data from the table in a streaming manner: "smart_lists" */
  smart_lists_stream: Array<Smart_Lists>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table in a streaming manner: "subscriptions" */
  subscriptions_stream: Array<Subscriptions>;
  /** An array relationship */
  team_images: Array<Team_Images>;
  /** fetch data from the table: "team_images" using primary key columns */
  team_images_by_pk?: Maybe<Team_Images>;
  /** fetch data from the table in a streaming manner: "team_images" */
  team_images_stream: Array<Team_Images>;
  /** An array relationship */
  teams: Array<Teams>;
  /** An aggregate relationship */
  teams_aggregate: Teams_Aggregate;
  /** fetch data from the table: "teams" using primary key columns */
  teams_by_pk?: Maybe<Teams>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  /** fetch data from the table: "teams_portals" using primary key columns */
  teams_portals_by_pk?: Maybe<Teams_Portals>;
  /** fetch data from the table in a streaming manner: "teams_portals" */
  teams_portals_stream: Array<Teams_Portals>;
  /** fetch data from the table in a streaming manner: "teams" */
  teams_stream: Array<Teams>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** fetch data from the table in a streaming manner: "teams_users" */
  teams_users_stream: Array<Teams_Users>;
  /** fetch data from the table: "tenant_gender_enum" */
  tenant_gender_enum: Array<Tenant_Gender_Enum>;
  /** fetch data from the table: "tenant_gender_enum" using primary key columns */
  tenant_gender_enum_by_pk?: Maybe<Tenant_Gender_Enum>;
  /** fetch data from the table in a streaming manner: "tenant_gender_enum" */
  tenant_gender_enum_stream: Array<Tenant_Gender_Enum>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenants_aggregate: Tenants_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenants_by_pk?: Maybe<Tenants>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenants_stream: Array<Tenants>;
  /** An array relationship */
  transaction_valuations: Array<Transaction_Valuations>;
  /** An aggregate relationship */
  transaction_valuations_aggregate: Transaction_Valuations_Aggregate;
  /** fetch data from the table in a streaming manner: "transaction_valuations" */
  transaction_valuations_stream: Array<Transaction_Valuations>;
  /** fetch data from the table: "translated_enums" */
  translated_enums: Array<Translated_Enums>;
  /** fetch data from the table: "translated_enums" using primary key columns */
  translated_enums_by_pk?: Maybe<Translated_Enums>;
  /** fetch data from the table in a streaming manner: "translated_enums" */
  translated_enums_stream: Array<Translated_Enums>;
  /** An array relationship */
  user_images: Array<User_Images>;
  /** fetch data from the table: "user_images" using primary key columns */
  user_images_by_pk?: Maybe<User_Images>;
  /** fetch data from the table in a streaming manner: "user_images" */
  user_images_stream: Array<User_Images>;
  /** fetch data from the table: "user_onboarding_skip_reason_enum" */
  user_onboarding_skip_reason_enum: Array<User_Onboarding_Skip_Reason_Enum>;
  /** fetch data from the table: "user_onboarding_skip_reason_enum" using primary key columns */
  user_onboarding_skip_reason_enum_by_pk?: Maybe<User_Onboarding_Skip_Reason_Enum>;
  /** fetch data from the table in a streaming manner: "user_onboarding_skip_reason_enum" */
  user_onboarding_skip_reason_enum_stream: Array<User_Onboarding_Skip_Reason_Enum>;
  /** fetch data from the table: "user_onboarding_status_enum" */
  user_onboarding_status_enum: Array<User_Onboarding_Status_Enum>;
  /** fetch data from the table: "user_onboarding_status_enum" using primary key columns */
  user_onboarding_status_enum_by_pk?: Maybe<User_Onboarding_Status_Enum>;
  /** fetch data from the table in a streaming manner: "user_onboarding_status_enum" */
  user_onboarding_status_enum_stream: Array<User_Onboarding_Status_Enum>;
  /** execute function "user_primary_phone" which returns "phone_numbers" */
  user_primary_phone: Array<Phone_Numbers>;
  /** execute function "user_primary_phone" and query aggregates on result of table type "phone_numbers" */
  user_primary_phone_aggregate: Phone_Numbers_Aggregate;
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** An array relationship */
  users_listings: Array<Users_Listings>;
  /** An aggregate relationship */
  users_listings_aggregate: Users_Listings_Aggregate;
  /** fetch data from the table: "users_listings" using primary key columns */
  users_listings_by_pk?: Maybe<Users_Listings>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
  /** fetch data from the table: "users_view" */
  users_view: Array<Users_View>;
  /** fetch data from the table in a streaming manner: "users_view" */
  users_view_stream: Array<Users_View>;
  /** fetch data from the table: "valuation_models" */
  valuation_models: Array<Valuation_Models>;
  /** fetch data from the table: "valuation_models" using primary key columns */
  valuation_models_by_pk?: Maybe<Valuation_Models>;
  /** fetch data from the table in a streaming manner: "valuation_models" */
  valuation_models_stream: Array<Valuation_Models>;
  /** An array relationship */
  valuations: Array<Valuations>;
  /** fetch data from the table: "valuations" using primary key columns */
  valuations_by_pk?: Maybe<Valuations>;
  /** fetch data from the table in a streaming manner: "valuations" */
  valuations_stream: Array<Valuations>;
  /** fetch data from the table: "visibility_inbox_lead_agents" */
  visibility_inbox_lead_agents: Array<Visibility_Inbox_Lead_Agents>;
  /** fetch data from the table in a streaming manner: "visibility_inbox_lead_agents" */
  visibility_inbox_lead_agents_stream: Array<Visibility_Inbox_Lead_Agents>;
  /** fetch data from the table: "visibility_inbox_profile_lead_history" */
  visibility_inbox_profile_lead_history: Array<Visibility_Inbox_Profile_Lead_History>;
  /** fetch data from the table in a streaming manner: "visibility_inbox_profile_lead_history" */
  visibility_inbox_profile_lead_history_stream: Array<Visibility_Inbox_Profile_Lead_History>;
  /** fetch data from the table: "visibility_profile_leads" */
  visibility_profile_leads: Array<Visibility_Profile_Leads>;
  /** fetch aggregated fields from the table: "visibility_profile_leads" */
  visibility_profile_leads_aggregate: Visibility_Profile_Leads_Aggregate;
  /** fetch data from the table in a streaming manner: "visibility_profile_leads" */
  visibility_profile_leads_stream: Array<Visibility_Profile_Leads>;
  /** fetch data from the table: "webhook_event_types_enum" */
  webhook_event_types_enum: Array<Webhook_Event_Types_Enum>;
  /** fetch data from the table: "webhook_event_types_enum" using primary key columns */
  webhook_event_types_enum_by_pk?: Maybe<Webhook_Event_Types_Enum>;
  /** fetch data from the table in a streaming manner: "webhook_event_types_enum" */
  webhook_event_types_enum_stream: Array<Webhook_Event_Types_Enum>;
  /** fetch data from the table: "webhook_subscriptions" */
  webhook_subscriptions: Array<Webhook_Subscriptions>;
  /** fetch aggregated fields from the table: "webhook_subscriptions" */
  webhook_subscriptions_aggregate: Webhook_Subscriptions_Aggregate;
  /** fetch data from the table: "webhook_subscriptions" using primary key columns */
  webhook_subscriptions_by_pk?: Maybe<Webhook_Subscriptions>;
  /** fetch data from the table: "webhook_subscriptions_event_types" */
  webhook_subscriptions_event_types: Array<Webhook_Subscriptions_Event_Types>;
  /** fetch data from the table: "webhook_subscriptions_event_types" using primary key columns */
  webhook_subscriptions_event_types_by_pk?: Maybe<Webhook_Subscriptions_Event_Types>;
  /** fetch data from the table in a streaming manner: "webhook_subscriptions_event_types" */
  webhook_subscriptions_event_types_stream: Array<Webhook_Subscriptions_Event_Types>;
  /** fetch data from the table in a streaming manner: "webhook_subscriptions" */
  webhook_subscriptions_stream: Array<Webhook_Subscriptions>;
  /** fetch data from the table: "window_view_enum" */
  window_view_enum: Array<Window_View_Enum>;
  /** fetch data from the table: "window_view_enum" using primary key columns */
  window_view_enum_by_pk?: Maybe<Window_View_Enum>;
  /** fetch data from the table in a streaming manner: "window_view_enum" */
  window_view_enum_stream: Array<Window_View_Enum>;
};


export type Subscription_RootActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootActivities_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivities_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activities_Stream_Cursor_Input>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootActivity_FeedArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Order_By>>;
  where?: InputMaybe<Activity_Feed_Bool_Exp>;
};


export type Subscription_RootActivity_Feed_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Order_By>>;
  where?: InputMaybe<Activity_Feed_Bool_Exp>;
};


export type Subscription_RootActivity_Feed_By_PkArgs = {
  activity_id: Scalars['uuid']['input'];
};


export type Subscription_RootActivity_Feed_QuarantineArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Quarantine_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Quarantine_Order_By>>;
  where?: InputMaybe<Activity_Feed_Quarantine_Bool_Exp>;
};


export type Subscription_RootActivity_Feed_Quarantine_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Feed_Quarantine_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Feed_Quarantine_Bool_Exp>;
};


export type Subscription_RootActivity_Feed_StatusArgs = {
  distinct_on?: InputMaybe<Array<Activity_Feed_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Feed_Status_Order_By>>;
  where?: InputMaybe<Activity_Feed_Status_Bool_Exp>;
};


export type Subscription_RootActivity_Feed_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Feed_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Feed_Status_Bool_Exp>;
};


export type Subscription_RootActivity_Feed_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Feed_Stream_Cursor_Input>>;
  where?: InputMaybe<Activity_Feed_Bool_Exp>;
};


export type Subscription_RootAddress_Display_Options_EnumArgs = {
  distinct_on?: InputMaybe<Array<Address_Display_Options_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Address_Display_Options_Enum_Order_By>>;
  where?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
};


export type Subscription_RootAddress_Display_Options_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAddress_Display_Options_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Address_Display_Options_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Display_Options_Enum_Bool_Exp>;
};


export type Subscription_RootAgenciesArgs = {
  distinct_on?: InputMaybe<Array<Agencies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agencies_Order_By>>;
  where?: InputMaybe<Agencies_Bool_Exp>;
};


export type Subscription_RootAgencies_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agencies_Stream_Cursor_Input>>;
  where?: InputMaybe<Agencies_Bool_Exp>;
};


export type Subscription_RootAgent_StatisticsArgs = {
  args: Agent_Statistics_Args;
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Subscription_RootAgent_StatsArgs = {
  distinct_on?: InputMaybe<Array<Agent_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agent_Stats_Order_By>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Subscription_RootAgent_Stats_By_PkArgs = {
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootAgent_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agent_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Agent_Stats_Bool_Exp>;
};


export type Subscription_RootAgentsArgs = {
  distinct_on?: InputMaybe<Array<Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Order_By>>;
  where?: InputMaybe<Agents_Bool_Exp>;
};


export type Subscription_RootAgents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Agents_Bool_Exp>;
};


export type Subscription_RootApi_KeysArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Order_By>>;
  where?: InputMaybe<Api_Keys_Bool_Exp>;
};


export type Subscription_RootApi_Keys_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Order_By>>;
  where?: InputMaybe<Api_Keys_Bool_Exp>;
};


export type Subscription_RootApi_Keys_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootApi_Keys_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Api_Keys_Stream_Cursor_Input>>;
  where?: InputMaybe<Api_Keys_Bool_Exp>;
};


export type Subscription_RootApi_Keys_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Api_Keys_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Api_Keys_Teams_Order_By>>;
  where?: InputMaybe<Api_Keys_Teams_Bool_Exp>;
};


export type Subscription_RootApi_Keys_Teams_By_PkArgs = {
  api_key_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
};


export type Subscription_RootApi_Keys_Teams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Api_Keys_Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Api_Keys_Teams_Bool_Exp>;
};


export type Subscription_RootAppraisalsArgs = {
  distinct_on?: InputMaybe<Array<Appraisals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Order_By>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


export type Subscription_RootAppraisals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAppraisals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Appraisals_Stream_Cursor_Input>>;
  where?: InputMaybe<Appraisals_Bool_Exp>;
};


export type Subscription_RootAvailable_Email_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Available_Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Available_Email_Templates_Order_By>>;
  where?: InputMaybe<Available_Email_Templates_Bool_Exp>;
};


export type Subscription_RootAvailable_Email_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Available_Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Available_Email_Templates_Bool_Exp>;
};


export type Subscription_RootBed_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Bed_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Bed_Type_Enum_Order_By>>;
  where?: InputMaybe<Bed_Type_Enum_Bool_Exp>;
};


export type Subscription_RootBed_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootBed_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Bed_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Bed_Type_Enum_Bool_Exp>;
};


export type Subscription_RootBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootBuyer_Leads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBuyer_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buyer_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Subscription_RootCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Subscription_RootCatchment_Areas_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  tenant_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootCatchment_Areas_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Catchment_Areas_Stream_Cursor_Input>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


export type Subscription_RootCh_BuildingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Buildings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Buildings_Order_By>>;
  where?: InputMaybe<Ch_Buildings_Bool_Exp>;
};


export type Subscription_RootCh_Buildings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Bool_Exp>;
};


export type Subscription_RootCh_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Bool_Exp>;
};


export type Subscription_RootCh_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootCh_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootCh_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Ch_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_House_Appt_Price_StatsArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_House_Appt_Price_Stats_AggregateArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_Listings_Stats_By_Place_SlugArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_Listings_Stats_By_Place_Slug_AggregateArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_Map_Place_StatsArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_Map_Place_Stats_AggregateArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootCh_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Ch_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootCh_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Ch_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Cma_Listings_Order_By>>;
  where?: InputMaybe<Ch_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Images_Order_By>>;
  where?: InputMaybe<Ch_Merged_Images_Bool_Exp>;
};


export type Subscription_RootCh_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCh_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Ch_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootCh_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Ch_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootCh_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Plots_Order_By>>;
  where?: InputMaybe<Ch_Plots_Bool_Exp>;
};


export type Subscription_RootCh_Plots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCh_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Ch_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootCh_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootCh_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootCh_Price_Stats_QuantilesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_Quantiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Price_Stats_Quantiles_Order_By>>;
  where?: InputMaybe<Ch_Price_Stats_Quantiles_Bool_Exp>;
};


export type Subscription_RootCh_Price_Stats_Quantiles_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootCh_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Ch_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Property_Types_Order_By>>;
  where?: InputMaybe<Ch_Property_Types_Bool_Exp>;
};


export type Subscription_RootCh_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Ch_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootCh_Search_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Search_Places_AggregateArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Ch_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Places_Order_By>>;
  where?: InputMaybe<Ch_Places_Bool_Exp>;
};


export type Subscription_RootCh_StatesArgs = {
  distinct_on?: InputMaybe<Array<Ch_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_States_Order_By>>;
  where?: InputMaybe<Ch_States_Bool_Exp>;
};


export type Subscription_RootCh_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};


export type Subscription_RootCh_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ch_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Ch_Street_Stats_Order_By>>;
  where?: InputMaybe<Ch_Street_Stats_Bool_Exp>;
};


export type Subscription_RootChat_Api_ChatArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
};


export type Subscription_RootChat_Api_Chat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
};


export type Subscription_RootChat_Api_Chat_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Chat_Model_SettingArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Model_Setting_Bool_Exp>;
};


export type Subscription_RootChat_Api_Chat_Model_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Chat_Model_Setting_Order_By>>;
  where?: InputMaybe<Chat_Api_Chat_Model_Setting_Bool_Exp>;
};


export type Subscription_RootChat_Api_Chat_Model_Setting_By_PkArgs = {
  model_id: Scalars['String']['input'];
};


export type Subscription_RootChat_Api_Chat_Model_Setting_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Chat_Model_Setting_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Chat_Model_Setting_Bool_Exp>;
};


export type Subscription_RootChat_Api_Chat_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Chat_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Chat_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Conversation_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Conversation_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Conversation_Message_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_PartArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Part_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Part_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Part_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Part_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Part_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Conversation_Part_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Conversation_Part_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Conversation_Part_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Tool_CallArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Tool_Call_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Tool_Call_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Tool_Call_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Conversation_Tool_Call_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Conversation_Tool_Call_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Conversation_Tool_Call_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_TraceArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Trace_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Trace_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Conversation_Trace_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Conversation_Trace_Order_By>>;
  where?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
};


export type Subscription_RootChat_Api_Conversation_Trace_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Conversation_Trace_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Conversation_Trace_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Conversation_Trace_Bool_Exp>;
};


export type Subscription_RootChat_Api_MessageArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Message_Bool_Exp>;
};


export type Subscription_RootChat_Api_Message_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Message_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Message_Order_By>>;
  where?: InputMaybe<Chat_Api_Message_Bool_Exp>;
};


export type Subscription_RootChat_Api_Message_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Message_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Message_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Message_Bool_Exp>;
};


export type Subscription_RootChat_Api_Model_PricingArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Model_Pricing_Order_By>>;
  where?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
};


export type Subscription_RootChat_Api_Model_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Model_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Model_Pricing_Order_By>>;
  where?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
};


export type Subscription_RootChat_Api_Model_Pricing_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Model_Pricing_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Model_Pricing_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Model_Pricing_Bool_Exp>;
};


export type Subscription_RootChat_Api_Mutation_AuditArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Mutation_Audit_Order_By>>;
  where?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
};


export type Subscription_RootChat_Api_Mutation_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Api_Mutation_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Chat_Api_Mutation_Audit_Order_By>>;
  where?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
};


export type Subscription_RootChat_Api_Mutation_Audit_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChat_Api_Mutation_Audit_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Chat_Api_Mutation_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Api_Mutation_Audit_Bool_Exp>;
};


export type Subscription_RootCma_Report_FilesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Subscription_RootCma_Report_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Files_Order_By>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Subscription_RootCma_Report_Files_By_PkArgs = {
  cma_report_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


export type Subscription_RootCma_Report_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Report_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Report_Files_Bool_Exp>;
};


export type Subscription_RootCma_Report_Source_EnumArgs = {
  distinct_on?: InputMaybe<Array<Cma_Report_Source_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Report_Source_Enum_Order_By>>;
  where?: InputMaybe<Cma_Report_Source_Enum_Bool_Exp>;
};


export type Subscription_RootCma_Report_Source_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCma_Report_Source_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Report_Source_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Report_Source_Enum_Bool_Exp>;
};


export type Subscription_RootCma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Subscription_RootCma_Reports_Agent_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};


export type Subscription_RootCma_Reports_Agent_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCma_Reports_Agent_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Reports_Agent_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};


export type Subscription_RootCma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Subscription_RootCma_Reports_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCma_Reports_ComparablesArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Comparables_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Comparables_Order_By>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


export type Subscription_RootCma_Reports_Comparables_By_PkArgs = {
  aggregates_db__merged_listings_clusters_id: Scalars['bigint']['input'];
  cma_report_id: Scalars['uuid']['input'];
};


export type Subscription_RootCma_Reports_Comparables_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Reports_Comparables_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Reports_Comparables_Bool_Exp>;
};


export type Subscription_RootCma_Reports_Property_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Property_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Property_Transactions_Bool_Exp>;
};


export type Subscription_RootCma_Reports_Property_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCma_Reports_Property_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Reports_Property_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Reports_Property_Transactions_Bool_Exp>;
};


export type Subscription_RootCma_Reports_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Reports_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


export type Subscription_RootCma_Reports_User_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_User_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_User_Reviews_Order_By>>;
  where?: InputMaybe<Cma_Reports_User_Reviews_Bool_Exp>;
};


export type Subscription_RootCma_Reports_User_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCma_Reports_User_Reviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cma_Reports_User_Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Cma_Reports_User_Reviews_Bool_Exp>;
};


export type Subscription_RootCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Subscription_RootCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Subscription_RootCombined_Reviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Combined_Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


export type Subscription_RootCooling_EnumArgs = {
  distinct_on?: InputMaybe<Array<Cooling_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cooling_Enum_Order_By>>;
  where?: InputMaybe<Cooling_Enum_Bool_Exp>;
};


export type Subscription_RootCooling_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootCooling_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Cooling_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Cooling_Enum_Bool_Exp>;
};


export type Subscription_RootCountriesArgs = {
  distinct_on?: InputMaybe<Array<Countries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Countries_Order_By>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootCountries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCountries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Countries_Stream_Cursor_Input>>;
  where?: InputMaybe<Countries_Bool_Exp>;
};


export type Subscription_RootDevelopment_FilesArgs = {
  distinct_on?: InputMaybe<Array<Development_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Files_Order_By>>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};


export type Subscription_RootDevelopment_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Files_Order_By>>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};


export type Subscription_RootDevelopment_Files_By_PkArgs = {
  development_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
};


export type Subscription_RootDevelopment_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Development_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Development_Files_Bool_Exp>;
};


export type Subscription_RootDevelopment_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


export type Subscription_RootDevelopment_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Development_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Images_Order_By>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


export type Subscription_RootDevelopment_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevelopment_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Development_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Development_Images_Bool_Exp>;
};


export type Subscription_RootDevelopment_MappingsArgs = {
  distinct_on?: InputMaybe<Array<Development_Mappings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Mappings_Order_By>>;
  where?: InputMaybe<Development_Mappings_Bool_Exp>;
};


export type Subscription_RootDevelopment_Mappings_By_PkArgs = {
  image_id: Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
};


export type Subscription_RootDevelopment_Mappings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Development_Mappings_Stream_Cursor_Input>>;
  where?: InputMaybe<Development_Mappings_Bool_Exp>;
};


export type Subscription_RootDevelopment_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Development_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Development_Status_Enum_Order_By>>;
  where?: InputMaybe<Development_Status_Enum_Bool_Exp>;
};


export type Subscription_RootDevelopment_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDevelopment_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Development_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Development_Status_Enum_Bool_Exp>;
};


export type Subscription_RootDevelopmentsArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Subscription_RootDevelopments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Developments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Developments_Order_By>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Subscription_RootDevelopments_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDevelopments_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Developments_Stream_Cursor_Input>>;
  where?: InputMaybe<Developments_Bool_Exp>;
};


export type Subscription_RootDictionariesArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Order_By>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Subscription_RootDictionaries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Order_By>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Subscription_RootDictionaries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDictionaries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dictionaries_Stream_Cursor_Input>>;
  where?: InputMaybe<Dictionaries_Bool_Exp>;
};


export type Subscription_RootDictionaries_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Dictionaries_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Dictionaries_Types_Enum_Order_By>>;
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
};


export type Subscription_RootDictionaries_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDictionaries_Types_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Dictionaries_Types_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
};


export type Subscription_RootDoc_Template_ThemesArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Themes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Themes_Order_By>>;
  where?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
};


export type Subscription_RootDoc_Template_Themes_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDoc_Template_Themes_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Template_Themes_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Template_Themes_Bool_Exp>;
};


export type Subscription_RootDoc_Template_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Type_Enum_Order_By>>;
  where?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
};


export type Subscription_RootDoc_Template_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootDoc_Template_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Template_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Template_Type_Enum_Bool_Exp>;
};


export type Subscription_RootDoc_Template_VersionsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Template_Versions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Template_Versions_Order_By>>;
  where?: InputMaybe<Doc_Template_Versions_Bool_Exp>;
};


export type Subscription_RootDoc_Template_Versions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDoc_Template_Versions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Template_Versions_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Template_Versions_Bool_Exp>;
};


export type Subscription_RootDoc_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Order_By>>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};


export type Subscription_RootDoc_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDoc_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
};


export type Subscription_RootDoc_Templates_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Doc_Templates_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Doc_Templates_Tenants_Order_By>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


export type Subscription_RootDoc_Templates_Tenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDoc_Templates_Tenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Doc_Templates_Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Doc_Templates_Tenants_Bool_Exp>;
};


export type Subscription_RootEmail_SequencesArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Order_By>>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Sequences_RecipientsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Recipients_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Recipients_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Recipients_Order_By>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Recipients_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Sequences_Recipients_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Sequences_Recipients_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Sequences_Recipients_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_StepsArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Steps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Sequences_Steps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Sequences_Steps_Order_By>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_Steps_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Sequences_Steps_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Sequences_Steps_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Sequences_Steps_Bool_Exp>;
};


export type Subscription_RootEmail_Sequences_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Sequences_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Sequences_Bool_Exp>;
};


export type Subscription_RootEmail_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Email_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Email_Templates_Order_By>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Subscription_RootEmail_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmail_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Email_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Templates_Bool_Exp>;
};


export type Subscription_RootEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEmails_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEmails_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Emails_Stream_Cursor_Input>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


export type Subscription_RootEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Subscription_RootEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Subscription_RootEnquiries_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEnquiries_Source_EnumArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Source_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Source_Enum_Order_By>>;
  where?: InputMaybe<Enquiries_Source_Enum_Bool_Exp>;
};


export type Subscription_RootEnquiries_Source_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootEnquiries_Source_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enquiries_Source_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Enquiries_Source_Enum_Bool_Exp>;
};


export type Subscription_RootEnquiries_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Enquiries_Stream_Cursor_Input>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


export type Subscription_RootEs_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Bool_Exp>;
};


export type Subscription_RootEs_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Bool_Exp>;
};


export type Subscription_RootEs_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootEs_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootEs_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Es_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_House_Appt_Price_StatsArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_House_Appt_Price_Stats_AggregateArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_Listings_Stats_By_Place_SlugArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_Listings_Stats_By_Place_Slug_AggregateArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_Map_Place_StatsArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_Map_Place_Stats_AggregateArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootEs_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Es_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootEs_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Es_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Cma_Listings_Order_By>>;
  where?: InputMaybe<Es_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Images_Order_By>>;
  where?: InputMaybe<Es_Merged_Images_Bool_Exp>;
};


export type Subscription_RootEs_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEs_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Es_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootEs_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Es_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootEs_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Es_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Plots_Order_By>>;
  where?: InputMaybe<Es_Plots_Bool_Exp>;
};


export type Subscription_RootEs_Plots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEs_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Es_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootEs_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootEs_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootEs_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Es_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootEs_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootEs_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Es_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Property_Types_Order_By>>;
  where?: InputMaybe<Es_Property_Types_Bool_Exp>;
};


export type Subscription_RootEs_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Es_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootEs_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Es_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Places_Order_By>>;
  where?: InputMaybe<Es_Places_Bool_Exp>;
};


export type Subscription_RootEs_StatesArgs = {
  distinct_on?: InputMaybe<Array<Es_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_States_Order_By>>;
  where?: InputMaybe<Es_States_Bool_Exp>;
};


export type Subscription_RootEs_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};


export type Subscription_RootEs_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Es_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Es_Street_Stats_Order_By>>;
  where?: InputMaybe<Es_Street_Stats_Bool_Exp>;
};


export type Subscription_RootFilesArgs = {
  distinct_on?: InputMaybe<Array<Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFiles_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFiles_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Files_Bool_Exp>;
};


export type Subscription_RootFind_Cma_Leads_By_AddressArgs = {
  args: Find_Cma_Leads_By_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootFind_Cma_Leads_By_Address_AggregateArgs = {
  args: Find_Cma_Leads_By_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootFind_Price_Map_PlacesArgs = {
  args: Find_Price_Map_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootFind_Price_Map_Places_AggregateArgs = {
  args: Find_Price_Map_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootFr_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_Energy_CertificatesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Energy_Certificates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Energy_Certificates_Order_By>>;
  where?: InputMaybe<Fr_Energy_Certificates_Bool_Exp>;
};


export type Subscription_RootFr_Energy_Certificates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Bool_Exp>;
};


export type Subscription_RootFr_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Bool_Exp>;
};


export type Subscription_RootFr_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootFr_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootFr_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_Get_Buy_Rent_ListingsArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Buy_Rent_Listings_AggregateArgs = {
  args: Get_Buy_Rent_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Fr_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_House_Appt_Price_StatsArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_House_Appt_Price_Stats_AggregateArgs = {
  args: Get_House_Appt_Price_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_Listings_Stats_By_Place_SlugArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_Listings_Stats_By_Place_Slug_AggregateArgs = {
  args: Get_Listings_Stats_By_Place_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_Map_Place_StatsArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_Map_Place_Stats_AggregateArgs = {
  args: Get_Map_Place_Stats_Args;
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootFr_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Fr_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootFr_Get_Place_By_SlugArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Get_Place_By_Slug_AggregateArgs = {
  args: Get_Place_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Fr_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Cma_Listings_Order_By>>;
  where?: InputMaybe<Fr_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Images_Order_By>>;
  where?: InputMaybe<Fr_Merged_Images_Bool_Exp>;
};


export type Subscription_RootFr_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFr_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Fr_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootFr_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Fr_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootFr_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_PlotsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Plots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Plots_Order_By>>;
  where?: InputMaybe<Fr_Plots_Bool_Exp>;
};


export type Subscription_RootFr_Plots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFr_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Fr_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootFr_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootFr_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootFr_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Fr_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootFr_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootFr_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Fr_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Property_Types_Order_By>>;
  where?: InputMaybe<Fr_Property_Types_Bool_Exp>;
};


export type Subscription_RootFr_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Fr_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootFr_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Fr_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Places_Order_By>>;
  where?: InputMaybe<Fr_Places_Bool_Exp>;
};


export type Subscription_RootFr_StatesArgs = {
  distinct_on?: InputMaybe<Array<Fr_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_States_Order_By>>;
  where?: InputMaybe<Fr_States_Bool_Exp>;
};


export type Subscription_RootFr_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};


export type Subscription_RootFr_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fr_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fr_Street_Stats_Order_By>>;
  where?: InputMaybe<Fr_Street_Stats_Bool_Exp>;
};


export type Subscription_RootFsbo_Seller_ClusterArgs = {
  args: Fsbo_Seller_Cluster_Args;
  distinct_on?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Order_By>>;
  where?: InputMaybe<Fsbo_Seller_Cluster_Result_Bool_Exp>;
};


export type Subscription_RootFsbo_Seller_Cluster_ResultArgs = {
  distinct_on?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Fsbo_Seller_Cluster_Result_Order_By>>;
  where?: InputMaybe<Fsbo_Seller_Cluster_Result_Bool_Exp>;
};


export type Subscription_RootFsbo_Seller_Cluster_Result_By_PkArgs = {
  kind: Scalars['String']['input'];
  lot_id: Scalars['uuid']['input'];
};


export type Subscription_RootFsbo_Seller_Cluster_Result_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Fsbo_Seller_Cluster_Result_Stream_Cursor_Input>>;
  where?: InputMaybe<Fsbo_Seller_Cluster_Result_Bool_Exp>;
};


export type Subscription_RootGet_Activities_Feed_For_LeadArgs = {
  args: Get_Activities_Feed_For_Lead_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootGet_Activities_Feed_For_Lead_AggregateArgs = {
  args: Get_Activities_Feed_For_Lead_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootGet_Activities_Feed_For_LotArgs = {
  args: Get_Activities_Feed_For_Lot_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootGet_Activities_Feed_For_Lot_AggregateArgs = {
  args: Get_Activities_Feed_For_Lot_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootGet_Activities_Feed_For_UserArgs = {
  args: Get_Activities_Feed_For_User_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootGet_Activities_Feed_For_User_AggregateArgs = {
  args: Get_Activities_Feed_For_User_Args;
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


export type Subscription_RootGet_Agents_RankingArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Agents_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Agents_Ranking_DedupedArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Deduped_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Agents_Ranking_Deduped_AggregateArgs = {
  args?: InputMaybe<Get_Agents_Ranking_Deduped_Args>;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Appraisals_By_SlugArgs = {
  args: Get_Appraisals_By_Slug_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Subscription_RootGet_Catchment_AreaArgs = {
  args: Get_Catchment_Area_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootGet_Catchment_Area_AggregateArgs = {
  args: Get_Catchment_Area_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootGet_Cma_Agent_TransactionsArgs = {
  args: Get_Cma_Agent_Transactions_Args;
  distinct_on?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Agent_Transactions_Order_By>>;
  where?: InputMaybe<Cma_Reports_Agent_Transactions_Bool_Exp>;
};


export type Subscription_RootGet_Local_Activity_FeedArgs = {
  args: Get_Local_Activity_Feed_Args;
  distinct_on?: InputMaybe<Array<Local_Activity_Feed_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Local_Activity_Feed_Items_Order_By>>;
  where?: InputMaybe<Local_Activity_Feed_Items_Bool_Exp>;
};


export type Subscription_RootGet_Local_Activity_Feed_AggregateArgs = {
  args: Get_Local_Activity_Feed_Args;
  distinct_on?: InputMaybe<Array<Local_Activity_Feed_Items_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Local_Activity_Feed_Items_Order_By>>;
  where?: InputMaybe<Local_Activity_Feed_Items_Bool_Exp>;
};


export type Subscription_RootGet_Lot_Publication_HistoryArgs = {
  args: Get_Lot_Publication_History_Args;
  distinct_on?: InputMaybe<Array<Lot_Publication_History_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Publication_History_Result_Order_By>>;
  where?: InputMaybe<Lot_Publication_History_Result_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_AppraisalsArgs = {
  args: Get_Nearby_Appraisals_Args;
  distinct_on?: InputMaybe<Array<Appraisals_Public_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Appraisals_Public_View_Order_By>>;
  where?: InputMaybe<Appraisals_Public_View_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_ReviewsArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_Reviews_AggregateArgs = {
  args: Get_Nearby_Reviews_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_TransactionsArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootGet_Nearby_Transactions_AggregateArgs = {
  args: Get_Nearby_Transactions_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootGet_Online_Listing_Map_DataArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootGet_Online_Listing_Map_Data_AggregateArgs = {
  args: Get_Online_Listing_Map_Data_Args;
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootGet_Property_Transactions_DistanceArgs = {
  args: Get_Property_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootGet_Property_Transactions_Distance_AggregateArgs = {
  args: Get_Property_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootGet_Reviews_In_LocationArgs = {
  args: Get_Reviews_In_Location_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootGet_Reviews_In_Location_AggregateArgs = {
  args: Get_Reviews_In_Location_Args;
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_ListingsArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_AggregateArgs = {
  args: Get_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_IdsArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_Ids_AggregateArgs = {
  args: Get_Similar_Online_Listings_Ids_Args;
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_VectorArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Similar_Online_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Online_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootGet_Teams_RankingArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Teams_Ranking_AggregateArgs = {
  args?: InputMaybe<Get_Teams_Ranking_Args>;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Teams_Ranking_By_DistanceArgs = {
  args: Get_Teams_Ranking_By_Distance_Args;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Teams_Ranking_By_Distance_AggregateArgs = {
  args: Get_Teams_Ranking_By_Distance_Args;
  distinct_on?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Rankings_Order_By>>;
  where?: InputMaybe<Teams_Rankings_Bool_Exp>;
};


export type Subscription_RootGet_Translated_EnumArgs = {
  args: Get_Translated_Enum_Args;
  distinct_on?: InputMaybe<Array<Translated_Enums_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translated_Enums_Order_By>>;
  where?: InputMaybe<Translated_Enums_Bool_Exp>;
};


export type Subscription_RootGlobal_StatisticsArgs = {
  args: Global_Statistics_Args;
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Subscription_RootGlobal_StatsArgs = {
  distinct_on?: InputMaybe<Array<Global_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Global_Stats_Order_By>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Subscription_RootGlobal_Stats_By_PkArgs = {
  date: Scalars['date']['input'];
};


export type Subscription_RootGlobal_Stats_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Global_Stats_Stream_Cursor_Input>>;
  where?: InputMaybe<Global_Stats_Bool_Exp>;
};


export type Subscription_RootGoogle_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Google_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Addresses_Order_By>>;
  where?: InputMaybe<Google_Addresses_Bool_Exp>;
};


export type Subscription_RootGoogle_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Subscription_RootGoogle_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Subscription_RootGoogle_Reviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootGoogle_Reviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Google_Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


export type Subscription_RootHeating_Distribution_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Distribution_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Distribution_Enum_Order_By>>;
  where?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
};


export type Subscription_RootHeating_Distribution_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootHeating_Distribution_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Heating_Distribution_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Heating_Distribution_Enum_Bool_Exp>;
};


export type Subscription_RootHeating_EnumArgs = {
  distinct_on?: InputMaybe<Array<Heating_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Heating_Enum_Order_By>>;
  where?: InputMaybe<Heating_Enum_Bool_Exp>;
};


export type Subscription_RootHeating_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootHeating_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Heating_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Heating_Enum_Bool_Exp>;
};


export type Subscription_RootImagesArgs = {
  distinct_on?: InputMaybe<Array<Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Images_Order_By>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootImages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootImages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Images_Bool_Exp>;
};


export type Subscription_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invitations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invitations_Order_By>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvitations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvitations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invitations_Stream_Cursor_Input>>;
  where?: InputMaybe<Invitations_Bool_Exp>;
};


export type Subscription_RootInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootInvoices_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootInvoices_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Invoices_Stream_Cursor_Input>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


export type Subscription_RootIt_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootIt_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIt_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Cma_Rental_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootIt_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Bool_Exp>;
};


export type Subscription_RootIt_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Bool_Exp>;
};


export type Subscription_RootIt_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootIt_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootIt_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIt_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<It_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<It_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Subscription_RootIt_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Subscription_RootIt_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootIt_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<It_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<It_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootIt_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<It_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Cma_Listings_Order_By>>;
  where?: InputMaybe<It_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Images_Order_By>>;
  where?: InputMaybe<It_Merged_Images_Bool_Exp>;
};


export type Subscription_RootIt_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootIt_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<It_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_PlacesArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootIt_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootIt_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootIt_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<It_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootIt_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootIt_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<It_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootIt_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootIt_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Subscription_RootIt_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Bool_Exp>;
};


export type Subscription_RootIt_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootIt_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<It_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootIt_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootIt_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<It_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Property_Types_Order_By>>;
  where?: InputMaybe<It_Property_Types_Bool_Exp>;
};


export type Subscription_RootIt_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<It_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootIt_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootIt_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<It_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Places_Order_By>>;
  where?: InputMaybe<It_Places_Bool_Exp>;
};


export type Subscription_RootIt_StatesArgs = {
  distinct_on?: InputMaybe<Array<It_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_States_Order_By>>;
  where?: InputMaybe<It_States_Bool_Exp>;
};


export type Subscription_RootIt_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};


export type Subscription_RootIt_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<It_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<It_Street_Stats_Order_By>>;
  where?: InputMaybe<It_Street_Stats_Bool_Exp>;
};


export type Subscription_RootLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Subscription_RootLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Subscription_RootLead_Agents_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLead_Agents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


export type Subscription_RootLead_StagesArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Subscription_RootLead_Stages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Stages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Stages_Order_By>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Subscription_RootLead_Stages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLead_Stages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lead_Stages_Stream_Cursor_Input>>;
  where?: InputMaybe<Lead_Stages_Bool_Exp>;
};


export type Subscription_RootLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLeads_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLeads_StatusArgs = {
  distinct_on?: InputMaybe<Array<Leads_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Status_Order_By>>;
  where?: InputMaybe<Leads_Status_Bool_Exp>;
};


export type Subscription_RootLeads_Status_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLeads_Status_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Leads_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Leads_Status_Bool_Exp>;
};


export type Subscription_RootLeads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLeads_TagsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Subscription_RootLeads_Tags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Tags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Tags_Order_By>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Subscription_RootLeads_Tags_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLeads_Tags_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Leads_Tags_Stream_Cursor_Input>>;
  where?: InputMaybe<Leads_Tags_Bool_Exp>;
};


export type Subscription_RootLeads_The_Same_AddressArgs = {
  args: Leads_The_Same_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLeads_The_Same_Address_AggregateArgs = {
  args: Leads_The_Same_Address_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootLocality_AdjacencyArgs = {
  distinct_on?: InputMaybe<Array<Locality_Adjacency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Locality_Adjacency_Order_By>>;
  where?: InputMaybe<Locality_Adjacency_Bool_Exp>;
};


export type Subscription_RootLocality_Adjacency_By_PkArgs = {
  adj_locality_id: Scalars['uuid']['input'];
  locality_id: Scalars['uuid']['input'];
};


export type Subscription_RootLocality_Adjacency_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Locality_Adjacency_Stream_Cursor_Input>>;
  where?: InputMaybe<Locality_Adjacency_Bool_Exp>;
};


export type Subscription_RootLot_Reference_AliasesArgs = {
  distinct_on?: InputMaybe<Array<Lot_Reference_Aliases_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Reference_Aliases_Order_By>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


export type Subscription_RootLot_Reference_Aliases_By_PkArgs = {
  reference_alias_decoded: Scalars['Int']['input'];
};


export type Subscription_RootLot_Reference_Aliases_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lot_Reference_Aliases_Stream_Cursor_Input>>;
  where?: InputMaybe<Lot_Reference_Aliases_Bool_Exp>;
};


export type Subscription_RootLot_SellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Subscription_RootLot_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Subscription_RootLot_Sellers_By_PkArgs = {
  lot_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootLot_Sellers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lot_Sellers_Stream_Cursor_Input>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


export type Subscription_RootLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootLots_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootLots_Member_Access_EnumArgs = {
  distinct_on?: InputMaybe<Array<Lots_Member_Access_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Member_Access_Enum_Order_By>>;
  where?: InputMaybe<Lots_Member_Access_Enum_Bool_Exp>;
};


export type Subscription_RootLots_Member_Access_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLots_Member_Access_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lots_Member_Access_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Lots_Member_Access_Enum_Bool_Exp>;
};


export type Subscription_RootLots_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Lots_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Status_Enum_Order_By>>;
  where?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
};


export type Subscription_RootLots_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootLots_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lots_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Lots_Status_Enum_Bool_Exp>;
};


export type Subscription_RootLots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Lots_Stream_Cursor_Input>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootMarketing_MetadataArgs = {
  distinct_on?: InputMaybe<Array<Marketing_Metadata_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketing_Metadata_Order_By>>;
  where?: InputMaybe<Marketing_Metadata_Bool_Exp>;
};


export type Subscription_RootMarketing_Metadata_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMarketing_Metadata_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketing_Metadata_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketing_Metadata_Bool_Exp>;
};


export type Subscription_RootMarketplace_Conversation_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversation_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversation_Participants_Order_By>>;
  where?: InputMaybe<Marketplace_Conversation_Participants_Bool_Exp>;
};


export type Subscription_RootMarketplace_Conversation_Participants_By_PkArgs = {
  conversation_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootMarketplace_Conversation_Participants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Conversation_Participants_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Conversation_Participants_Bool_Exp>;
};


export type Subscription_RootMarketplace_Conversation_Public_ParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversation_Public_Participants_Order_By>>;
  where?: InputMaybe<Marketplace_Conversation_Public_Participants_Bool_Exp>;
};


export type Subscription_RootMarketplace_Conversation_Public_Participants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Conversation_Public_Participants_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Conversation_Public_Participants_Bool_Exp>;
};


export type Subscription_RootMarketplace_ConversationsArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Conversations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Conversations_Order_By>>;
  where?: InputMaybe<Marketplace_Conversations_Bool_Exp>;
};


export type Subscription_RootMarketplace_Conversations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMarketplace_Conversations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Conversations_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Conversations_Bool_Exp>;
};


export type Subscription_RootMarketplace_Message_Delivery_Channel_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Message_Delivery_Channel_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Message_Delivery_Channel_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Message_Delivery_Channel_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_Message_Delivery_Channel_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMarketplace_Message_Delivery_Channel_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Message_Delivery_Channel_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Message_Delivery_Channel_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_Message_Delivery_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Message_Delivery_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Message_Delivery_Status_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Message_Delivery_Status_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_Message_Delivery_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMarketplace_Message_Delivery_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Message_Delivery_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Message_Delivery_Status_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_Message_Origin_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Message_Origin_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Message_Origin_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_Message_Origin_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMarketplace_Message_Origin_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Message_Origin_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Message_Origin_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_MessagesArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Messages_Order_By>>;
  where?: InputMaybe<Marketplace_Messages_Bool_Exp>;
};


export type Subscription_RootMarketplace_Messages_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMarketplace_Messages_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Messages_Bool_Exp>;
};


export type Subscription_RootMarketplace_Participant_Role_EnumArgs = {
  distinct_on?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Marketplace_Participant_Role_Enum_Order_By>>;
  where?: InputMaybe<Marketplace_Participant_Role_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_Participant_Role_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMarketplace_Participant_Role_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Marketplace_Participant_Role_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Marketplace_Participant_Role_Enum_Bool_Exp>;
};


export type Subscription_RootMarketplace_Similar_Online_ListingsArgs = {
  args: Get_Marketplace_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootMarketplace_Similar_Online_Listings_AggregateArgs = {
  args: Get_Marketplace_Similar_Online_Listings_Args;
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootMeArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootMe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootMls_Agent_Buyer_MatchesArgs = {
  args: Mls_Agent_Buyer_Matches_Args;
  distinct_on?: InputMaybe<Array<Mls_Buyer_Match_Edge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Buyer_Match_Edge_Order_By>>;
  where?: InputMaybe<Mls_Buyer_Match_Edge_Bool_Exp>;
};


export type Subscription_RootMls_Buyer_Match_EdgeArgs = {
  distinct_on?: InputMaybe<Array<Mls_Buyer_Match_Edge_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Buyer_Match_Edge_Order_By>>;
  where?: InputMaybe<Mls_Buyer_Match_Edge_Bool_Exp>;
};


export type Subscription_RootMls_Buyer_Match_Edge_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Buyer_Match_Edge_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Buyer_Match_Edge_Bool_Exp>;
};


export type Subscription_RootMls_Commission_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Mls_Commission_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Commission_Type_Enum_Order_By>>;
  where?: InputMaybe<Mls_Commission_Type_Enum_Bool_Exp>;
};


export type Subscription_RootMls_Commission_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMls_Commission_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Commission_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Commission_Type_Enum_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Enquiry_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Order_By>>;
  where?: InputMaybe<Mls_Listing_Enquiry_Settings_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Enquiry_Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Listing_Enquiry_Settings_Order_By>>;
  where?: InputMaybe<Mls_Listing_Enquiry_Settings_Bool_Exp>;
};


export type Subscription_RootMls_Listing_Enquiry_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Listing_Enquiry_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Listing_Enquiry_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Listing_Enquiry_Settings_Bool_Exp>;
};


export type Subscription_RootMls_LotsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_Lots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_Lots_In_ViewportArgs = {
  args: Mls_Lots_In_Viewport_Args;
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_Lots_In_Viewport_AggregateArgs = {
  args: Mls_Lots_In_Viewport_Args;
  distinct_on?: InputMaybe<Array<Mls_Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_Lots_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Lots_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
};


export type Subscription_RootMls_Network_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Network_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Network_Teams_Order_By>>;
  where?: InputMaybe<Mls_Network_Teams_Bool_Exp>;
};


export type Subscription_RootMls_Network_Teams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Network_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Network_Teams_Order_By>>;
  where?: InputMaybe<Mls_Network_Teams_Bool_Exp>;
};


export type Subscription_RootMls_Network_Teams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Network_Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Network_Teams_Bool_Exp>;
};


export type Subscription_RootMls_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Mls_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Settings_Order_By>>;
  where?: InputMaybe<Mls_Settings_Bool_Exp>;
};


export type Subscription_RootMls_Settings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Settings_Bool_Exp>;
};


export type Subscription_RootMls_Share_Mode_EnumArgs = {
  distinct_on?: InputMaybe<Array<Mls_Share_Mode_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Share_Mode_Enum_Order_By>>;
  where?: InputMaybe<Mls_Share_Mode_Enum_Bool_Exp>;
};


export type Subscription_RootMls_Share_Mode_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMls_Share_Mode_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Share_Mode_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Share_Mode_Enum_Bool_Exp>;
};


export type Subscription_RootMls_Share_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<Mls_Share_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Share_Status_Enum_Order_By>>;
  where?: InputMaybe<Mls_Share_Status_Enum_Bool_Exp>;
};


export type Subscription_RootMls_Share_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootMls_Share_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Share_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Share_Status_Enum_Bool_Exp>;
};


export type Subscription_RootMls_SharesArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


export type Subscription_RootMls_Shares_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Mls_Shares_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Mls_Shares_Order_By>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


export type Subscription_RootMls_Shares_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMls_Shares_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Mls_Shares_Stream_Cursor_Input>>;
  where?: InputMaybe<Mls_Shares_Bool_Exp>;
};


export type Subscription_RootNotification_Setting_ImpactArgs = {
  args: Notification_Setting_Impact_Args;
  distinct_on?: InputMaybe<Array<Notification_Setting_Impact_Result_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Setting_Impact_Result_Order_By>>;
  where?: InputMaybe<Notification_Setting_Impact_Result_Bool_Exp>;
};


export type Subscription_RootNotification_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Notification_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Notification_Settings_Order_By>>;
  where?: InputMaybe<Notification_Settings_Bool_Exp>;
};


export type Subscription_RootNotification_Settings_By_PkArgs = {
  type: Scalars['String']['input'];
};


export type Subscription_RootNotification_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Notification_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Settings_Bool_Exp>;
};


export type Subscription_RootNylas_Account_ConfigsArgs = {
  distinct_on?: InputMaybe<Array<Nylas_Account_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nylas_Account_Configs_Order_By>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


export type Subscription_RootNylas_Account_Configs_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNylas_Account_Configs_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Nylas_Account_Configs_Stream_Cursor_Input>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


export type Subscription_RootOffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOffers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOffers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Offers_Stream_Cursor_Input>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


export type Subscription_RootOnline_Listing_Map_DataArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootOnline_Listing_Map_Data_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listing_Map_Data_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listing_Map_Data_Order_By>>;
  where?: InputMaybe<Online_Listing_Map_Data_Bool_Exp>;
};


export type Subscription_RootOnline_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootOnline_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Online_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Online_Listings_Order_By>>;
  where?: InputMaybe<Online_Listings_Bool_Exp>;
};


export type Subscription_RootOnline_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootOrganisation_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Images_Order_By>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


export type Subscription_RootOrganisation_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisation_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Images_Bool_Exp>;
};


export type Subscription_RootOrganisation_UsersArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisation_Users_Order_By>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


export type Subscription_RootOrganisation_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisation_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Users_Bool_Exp>;
};


export type Subscription_RootOrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganisations_SearchArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_Search_AggregateArgs = {
  args: Organisations_Search_Args;
  distinct_on?: InputMaybe<Array<Organisations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Organisations_Order_By>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootOrganisations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Organisations_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisations_Bool_Exp>;
};


export type Subscription_RootPhone_Number_Type_EnumArgs = {
  distinct_on?: InputMaybe<Array<Phone_Number_Type_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Number_Type_Enum_Order_By>>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};


export type Subscription_RootPhone_Number_Type_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPhone_Number_Type_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Phone_Number_Type_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Phone_Number_Type_Enum_Bool_Exp>;
};


export type Subscription_RootPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPhone_Numbers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPhone_Numbers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Phone_Numbers_Stream_Cursor_Input>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootPipelinesArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Subscription_RootPipelines_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pipelines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pipelines_Order_By>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Subscription_RootPipelines_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPipelines_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Pipelines_Stream_Cursor_Input>>;
  where?: InputMaybe<Pipelines_Bool_Exp>;
};


export type Subscription_RootPl_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootPl_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPl_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootPl_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Bool_Exp>;
};


export type Subscription_RootPl_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Bool_Exp>;
};


export type Subscription_RootPl_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPl_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPl_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPl_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pl_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPl_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPl_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pl_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootPl_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pl_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootPl_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pl_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pl_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


export type Subscription_RootPl_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Images_Order_By>>;
  where?: InputMaybe<Pl_Merged_Images_Bool_Exp>;
};


export type Subscription_RootPl_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPl_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pl_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPl_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Subscription_RootPl_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Subscription_RootPl_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootPl_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pl_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootPl_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPl_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pl_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPl_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPl_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPl_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPl_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootPl_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pl_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootPl_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootPl_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Pl_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Property_Types_Order_By>>;
  where?: InputMaybe<Pl_Property_Types_Bool_Exp>;
};


export type Subscription_RootPl_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pl_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPl_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Subscription_RootPl_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pl_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Places_Order_By>>;
  where?: InputMaybe<Pl_Places_Bool_Exp>;
};


export type Subscription_RootPl_StatesArgs = {
  distinct_on?: InputMaybe<Array<Pl_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_States_Order_By>>;
  where?: InputMaybe<Pl_States_Bool_Exp>;
};


export type Subscription_RootPl_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};


export type Subscription_RootPl_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pl_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pl_Street_Stats_Order_By>>;
  where?: InputMaybe<Pl_Street_Stats_Bool_Exp>;
};


export type Subscription_RootPlace_By_SlugArgs = {
  args?: InputMaybe<Place_By_Slug_Args>;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlace_By_Slug_AggregateArgs = {
  args?: InputMaybe<Place_By_Slug_Args>;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlace_By_TypeArgs = {
  args: Place_By_Type_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlace_By_Type_AggregateArgs = {
  args: Place_By_Type_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlaces_Agent_RankingArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootPlaces_Agent_Ranking_AggregateArgs = {
  args: Places_Agent_Ranking_Args;
  distinct_on?: InputMaybe<Array<Agents_Rankings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Agents_Rankings_Order_By>>;
  where?: InputMaybe<Agents_Rankings_Bool_Exp>;
};


export type Subscription_RootPlaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPlaces_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPlaces_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Places_Stream_Cursor_Input>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootPortal_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Subscription_RootPortal_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portal_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portal_Listings_Order_By>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Subscription_RootPortal_Listings_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortal_Listings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portal_Listings_Stream_Cursor_Input>>;
  where?: InputMaybe<Portal_Listings_Bool_Exp>;
};


export type Subscription_RootPortalsArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Subscription_RootPortals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Order_By>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Subscription_RootPortals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portals_Stream_Cursor_Input>>;
  where?: InputMaybe<Portals_Bool_Exp>;
};


export type Subscription_RootPortals_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Portals_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portals_Types_Enum_Order_By>>;
  where?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
};


export type Subscription_RootPortals_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootPortals_Types_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portals_Types_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Portals_Types_Enum_Bool_Exp>;
};


export type Subscription_RootPropertiesArgs = {
  distinct_on?: InputMaybe<Array<Properties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Properties_Order_By>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Subscription_RootProperties_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperties_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Properties_Stream_Cursor_Input>>;
  where?: InputMaybe<Properties_Bool_Exp>;
};


export type Subscription_RootProperty_FilesArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Subscription_RootProperty_Files_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Files_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Files_Order_By>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Subscription_RootProperty_Files_By_PkArgs = {
  file_id: Scalars['uuid']['input'];
  property_id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Files_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Files_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Files_Bool_Exp>;
};


export type Subscription_RootProperty_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Subscription_RootProperty_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Images_Order_By>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Subscription_RootProperty_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Images_Bool_Exp>;
};


export type Subscription_RootProperty_Search_Aggregator_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Aggregator_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Aggregator_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Search_Aggregator_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProperty_Search_Aggregator_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Search_Aggregator_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Search_Aggregator_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Search_SourceArgs = {
  distinct_on?: InputMaybe<Array<Property_Search_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Search_Source_Order_By>>;
  where?: InputMaybe<Property_Search_Source_Bool_Exp>;
};


export type Subscription_RootProperty_Search_Source_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootProperty_Search_Source_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Search_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Search_Source_Bool_Exp>;
};


export type Subscription_RootProperty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Searches_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Places_Order_By>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_Places_By_PkArgs = {
  place_id: Scalars['uuid']['input'];
  property_search_id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Searches_Places_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Searches_Places_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Searches_Places_Bool_Exp>;
};


export type Subscription_RootProperty_Searches_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Searches_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


export type Subscription_RootProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Transactions_Country_ViewArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Country_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Country_View_Order_By>>;
  where?: InputMaybe<Property_Transactions_Country_View_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_Country_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Transactions_Country_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Transactions_Country_View_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Transactions_Distance_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Transactions_Distance_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Listings_Order_By>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_Listings_By_PkArgs = {
  listing_id: Scalars['Int']['input'];
  property_transaction_id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Transactions_Listings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Transactions_Listings_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Transactions_Listings_Bool_Exp>;
};


export type Subscription_RootProperty_Transactions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Transactions_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootProperty_TypesArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Subscription_RootProperty_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Types_Order_By>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Subscription_RootProperty_Types_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProperty_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Property_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Property_Types_Bool_Exp>;
};


export type Subscription_RootProspection_Contact_Message_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Contact_Message_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Contact_Message_Templates_Order_By>>;
  where?: InputMaybe<Prospection_Contact_Message_Templates_Bool_Exp>;
};


export type Subscription_RootProspection_Contact_Message_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProspection_Contact_Message_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospection_Contact_Message_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospection_Contact_Message_Templates_Bool_Exp>;
};


export type Subscription_RootProspection_Contact_SettingsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Contact_Settings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Contact_Settings_Order_By>>;
  where?: InputMaybe<Prospection_Contact_Settings_Bool_Exp>;
};


export type Subscription_RootProspection_Contact_Settings_By_PkArgs = {
  tenant_id: Scalars['uuid']['input'];
};


export type Subscription_RootProspection_Contact_Settings_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospection_Contact_Settings_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospection_Contact_Settings_Bool_Exp>;
};


export type Subscription_RootProspection_Contact_TeamsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Contact_Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Contact_Teams_Order_By>>;
  where?: InputMaybe<Prospection_Contact_Teams_Bool_Exp>;
};


export type Subscription_RootProspection_Contact_Teams_By_PkArgs = {
  team_id: Scalars['uuid']['input'];
};


export type Subscription_RootProspection_Contact_Teams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospection_Contact_Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospection_Contact_Teams_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Contact_AttemptsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Order_By>>;
  where?: InputMaybe<Prospection_Map_Contact_Attempts_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Contact_Attempts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Contact_Attempts_Order_By>>;
  where?: InputMaybe<Prospection_Map_Contact_Attempts_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Contact_Attempts_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProspection_Map_Contact_Attempts_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospection_Map_Contact_Attempts_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospection_Map_Contact_Attempts_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Emailable_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Emailable_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Emailable_Leads_Order_By>>;
  where?: InputMaybe<Prospection_Map_Emailable_Leads_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Emailable_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospection_Map_Emailable_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospection_Map_Emailable_Leads_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Full_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Map_Full_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Full_Leads_Order_By>>;
  where?: InputMaybe<Prospection_Map_Full_Leads_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Full_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospection_Map_Full_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospection_Map_Full_Leads_Bool_Exp>;
};


export type Subscription_RootProspection_Map_Lead_Addresses_In_BboxArgs = {
  args?: InputMaybe<Prospection_Map_Lead_Addresses_In_Bbox_Args>;
  distinct_on?: InputMaybe<Array<Prospection_Map_Lead_Addresses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Map_Lead_Addresses_Order_By>>;
  where?: InputMaybe<Prospection_Map_Lead_Addresses_Bool_Exp>;
};


export type Subscription_RootProspection_MarksArgs = {
  distinct_on?: InputMaybe<Array<Prospection_Marks_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Prospection_Marks_Order_By>>;
  where?: InputMaybe<Prospection_Marks_Bool_Exp>;
};


export type Subscription_RootProspection_Marks_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProspection_Marks_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Prospection_Marks_Stream_Cursor_Input>>;
  where?: InputMaybe<Prospection_Marks_Bool_Exp>;
};


export type Subscription_RootPt_Cma_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Cma_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Cma_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
  state_id: Scalars['uuid']['input'];
};


export type Subscription_RootPt_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Cma_Listings_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPt_Cma_Rental_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Cma_Rental_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Cma_Rental_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Rental_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Rental_Listings_Bool_Exp>;
};


export type Subscription_RootPt_External_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Bool_Exp>;
};


export type Subscription_RootPt_External_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Bool_Exp>;
};


export type Subscription_RootPt_External_Transactions_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPt_External_Transactions_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPt_External_Transactions_Distance_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPt_Get_Cma_Listings_By_RadiusArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Cma_Listings_By_Radius_AggregateArgs = {
  args: Get_Cma_Listings_By_Radius_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Cma_Listings_DistanceArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_External_Transactions_DistanceArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_External_Transactions_Distance_AggregateArgs = {
  args: Get_External_Transactions_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_External_Transactions_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_External_Transactions_Distance_Order_By>>;
  where?: InputMaybe<Pt_External_Transactions_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Listings_StatsArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPt_Get_Listings_Stats_AggregateArgs = {
  args: Get_Listings_Stats_Args;
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPt_Get_Merged_ListingsArgs = {
  args: Get_Merged_Listings_Args;
  distinct_on?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pt_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootPt_Get_Merged_Listings_TypeArgs = {
  distinct_on?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Get_Merged_Listings_Type_Order_By>>;
  where?: InputMaybe<Pt_Get_Merged_Listings_Type_Bool_Exp>;
};


export type Subscription_RootPt_Get_Rental_Cma_Listings_DistanceArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Rental_Cma_Listings_Distance_AggregateArgs = {
  args: Get_Rental_Cma_Listings_Distance_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_ListingsArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_Listings_AggregateArgs = {
  args: Get_Similar_Listings_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_Listings_CohortsArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_Listings_VectorArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_Listings_Vector_AggregateArgs = {
  args: Get_Similar_Listings_Vector_Args;
  distinct_on?: InputMaybe<Array<Pt_Cma_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Cma_Listings_Order_By>>;
  where?: InputMaybe<Pt_Cma_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_Rental_Listings_CohortsArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Get_Similar_Rental_Listings_Cohorts_AggregateArgs = {
  args: Get_Similar_Rental_Listings_Cohorts_Args;
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Merged_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


export type Subscription_RootPt_Merged_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Images_Order_By>>;
  where?: InputMaybe<Pt_Merged_Images_Bool_Exp>;
};


export type Subscription_RootPt_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPt_Merged_Listings_CompareArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Merged_Listings_Compare_AggregateArgs = {
  args: Merged_Listings_Compare_Args;
  distinct_on?: InputMaybe<Array<Pt_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPt_PlacesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Subscription_RootPt_Places_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Subscription_RootPt_Places_BreadcrumbsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootPt_Places_Breadcrumbs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Places_Breadcrumbs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Breadcrumbs_Order_By>>;
  where?: InputMaybe<Pt_Places_Breadcrumbs_Bool_Exp>;
};


export type Subscription_RootPt_Places_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPt_Post_Merged_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Post_Merged_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Post_Merged_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Post_Merged_Listings_Order_By>>;
  where?: InputMaybe<Pt_Post_Merged_Listings_Bool_Exp>;
};


export type Subscription_RootPt_Post_Merged_Listings_By_PkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootPt_Price_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPt_Price_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Bool_Exp>;
};


export type Subscription_RootPt_Price_Stats_HistoricalArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootPt_Price_Stats_Historical_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Price_Stats_Historical_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Price_Stats_Historical_Order_By>>;
  where?: InputMaybe<Pt_Price_Stats_Historical_Bool_Exp>;
};


export type Subscription_RootPt_Price_Stats_Historical_By_PkArgs = {
  date: Scalars['date']['input'];
  number_of_rooms: Scalars['Int']['input'];
  place_id: Scalars['uuid']['input'];
  property_main_type: Scalars['String']['input'];
};


export type Subscription_RootPt_Property_TypesArgs = {
  distinct_on?: InputMaybe<Array<Pt_Property_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Property_Types_Order_By>>;
  where?: InputMaybe<Pt_Property_Types_Bool_Exp>;
};


export type Subscription_RootPt_Rental_Cma_Listings_DistanceArgs = {
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Rental_Cma_Listings_Distance_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Rental_Cma_Listings_Distance_Order_By>>;
  where?: InputMaybe<Pt_Rental_Cma_Listings_Distance_Bool_Exp>;
};


export type Subscription_RootPt_Search_Places_With_IndexArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Subscription_RootPt_Search_Places_With_Index_AggregateArgs = {
  args: Search_Places_With_Index_Args;
  distinct_on?: InputMaybe<Array<Pt_Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Places_Order_By>>;
  where?: InputMaybe<Pt_Places_Bool_Exp>;
};


export type Subscription_RootPt_StatesArgs = {
  distinct_on?: InputMaybe<Array<Pt_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_States_Order_By>>;
  where?: InputMaybe<Pt_States_Bool_Exp>;
};


export type Subscription_RootPt_Street_StatsArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};


export type Subscription_RootPt_Street_Stats_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pt_Street_Stats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Pt_Street_Stats_Order_By>>;
  where?: InputMaybe<Pt_Street_Stats_Bool_Exp>;
};


export type Subscription_RootPush_Notification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notification_Tokens_Order_By>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


export type Subscription_RootPush_Notification_Tokens_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPush_Notification_Tokens_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Push_Notification_Tokens_Stream_Cursor_Input>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


export type Subscription_RootRead_Only_TenantsArgs = {
  distinct_on?: InputMaybe<Array<Read_Only_Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Read_Only_Tenants_Order_By>>;
  where?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
};


export type Subscription_RootRead_Only_Tenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Read_Only_Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Read_Only_Tenants_Bool_Exp>;
};


export type Subscription_RootReview_Invitation_TemplatesArgs = {
  distinct_on?: InputMaybe<Array<Review_Invitation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Review_Invitation_Templates_Order_By>>;
  where?: InputMaybe<Review_Invitation_Templates_Bool_Exp>;
};


export type Subscription_RootReview_Invitation_Templates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Invitation_Templates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Review_Invitation_Templates_Order_By>>;
  where?: InputMaybe<Review_Invitation_Templates_Bool_Exp>;
};


export type Subscription_RootReview_Invitation_Templates_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReview_Invitation_Templates_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Review_Invitation_Templates_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Invitation_Templates_Bool_Exp>;
};


export type Subscription_RootReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootReviews_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReviews_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Reviews_Stream_Cursor_Input>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


export type Subscription_RootSearch_Brockers_In_Catchment_AreaArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Brockers_In_Catchment_Area_AggregateArgs = {
  args?: InputMaybe<Search_Brockers_In_Catchment_Area_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Buyer_Leads_TsvArgs = {
  args: Search_Buyer_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Buyer_Leads_Tsv_AggregateArgs = {
  args: Search_Buyer_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


export type Subscription_RootSearch_LeadsArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Leads_AggregateArgs = {
  args?: InputMaybe<Search_Leads_Args>;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Leads_TsvArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Leads_Tsv_AggregateArgs = {
  args: Search_Leads_Tsv_Args;
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


export type Subscription_RootSearch_Lots_TsvArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootSearch_Lots_Tsv_AggregateArgs = {
  args: Search_Lots_Tsv_Args;
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


export type Subscription_RootSearch_PlacesArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootSearch_Places_AggregateArgs = {
  args: Search_Places_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootSearch_Places_ExArgs = {
  args: Search_Places_Ex_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootSearch_Places_Ex_AggregateArgs = {
  args: Search_Places_Ex_Args;
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


export type Subscription_RootSearch_Property_Transactions_TsvArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootSearch_Property_Transactions_Tsv_AggregateArgs = {
  args: Search_Property_Transactions_Tsv_Args;
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


export type Subscription_RootSearch_Public_Agents_TsvArgs = {
  args: Search_Public_Agents_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Public_Agents_Tsv_AggregateArgs = {
  args: Search_Public_Agents_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Teams_TsvArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootSearch_Teams_Tsv_AggregateArgs = {
  args: Search_Teams_Tsv_Args;
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootSearch_UsersArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Users_AggregateArgs = {
  args?: InputMaybe<Search_Users_Args>;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Users_TsvArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSearch_Users_Tsv_AggregateArgs = {
  args: Search_Users_Tsv_Args;
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootSeller_Notification_Frequency_EnumArgs = {
  distinct_on?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Seller_Notification_Frequency_Enum_Order_By>>;
  where?: InputMaybe<Seller_Notification_Frequency_Enum_Bool_Exp>;
};


export type Subscription_RootSeller_Notification_Frequency_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootSeller_Notification_Frequency_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Seller_Notification_Frequency_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Seller_Notification_Frequency_Enum_Bool_Exp>;
};


export type Subscription_RootShared_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Subscription_RootShared_Portals_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Shared_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Shared_Portals_Order_By>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Subscription_RootShared_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootShared_Portals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Shared_Portals_Stream_Cursor_Input>>;
  where?: InputMaybe<Shared_Portals_Bool_Exp>;
};


export type Subscription_RootSimilar_Online_Listings_IdsArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootSimilar_Online_Listings_Ids_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Similar_Online_Listings_Ids_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Similar_Online_Listings_Ids_Order_By>>;
  where?: InputMaybe<Similar_Online_Listings_Ids_Bool_Exp>;
};


export type Subscription_RootSmart_ListsArgs = {
  distinct_on?: InputMaybe<Array<Smart_Lists_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Smart_Lists_Order_By>>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};


export type Subscription_RootSmart_Lists_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSmart_Lists_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Smart_Lists_Stream_Cursor_Input>>;
  where?: InputMaybe<Smart_Lists_Bool_Exp>;
};


export type Subscription_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubscriptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootTeam_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Team_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Images_Order_By>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


export type Subscription_RootTeam_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeam_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Team_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


export type Subscription_RootTeamsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Order_By>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


export type Subscription_RootTeams_Portals_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTeams_Portals_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Portals_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


export type Subscription_RootTeams_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Bool_Exp>;
};


export type Subscription_RootTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTeams_Users_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Teams_Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


export type Subscription_RootTenant_Gender_EnumArgs = {
  distinct_on?: InputMaybe<Array<Tenant_Gender_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenant_Gender_Enum_Order_By>>;
  where?: InputMaybe<Tenant_Gender_Enum_Bool_Exp>;
};


export type Subscription_RootTenant_Gender_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTenant_Gender_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenant_Gender_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenant_Gender_Enum_Bool_Exp>;
};


export type Subscription_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenants_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenants_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTransaction_ValuationsArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Valuations_Order_By>>;
  where?: InputMaybe<Transaction_Valuations_Bool_Exp>;
};


export type Subscription_RootTransaction_Valuations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Transaction_Valuations_Order_By>>;
  where?: InputMaybe<Transaction_Valuations_Bool_Exp>;
};


export type Subscription_RootTransaction_Valuations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Transaction_Valuations_Stream_Cursor_Input>>;
  where?: InputMaybe<Transaction_Valuations_Bool_Exp>;
};


export type Subscription_RootTranslated_EnumsArgs = {
  distinct_on?: InputMaybe<Array<Translated_Enums_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Translated_Enums_Order_By>>;
  where?: InputMaybe<Translated_Enums_Bool_Exp>;
};


export type Subscription_RootTranslated_Enums_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootTranslated_Enums_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Translated_Enums_Stream_Cursor_Input>>;
  where?: InputMaybe<Translated_Enums_Bool_Exp>;
};


export type Subscription_RootUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};


export type Subscription_RootUser_Images_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUser_Images_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Images_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};


export type Subscription_RootUser_Onboarding_Skip_Reason_EnumArgs = {
  distinct_on?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Order_By>>;
  where?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Bool_Exp>;
};


export type Subscription_RootUser_Onboarding_Skip_Reason_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUser_Onboarding_Skip_Reason_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Onboarding_Skip_Reason_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Bool_Exp>;
};


export type Subscription_RootUser_Onboarding_Status_EnumArgs = {
  distinct_on?: InputMaybe<Array<User_Onboarding_Status_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Onboarding_Status_Enum_Order_By>>;
  where?: InputMaybe<User_Onboarding_Status_Enum_Bool_Exp>;
};


export type Subscription_RootUser_Onboarding_Status_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootUser_Onboarding_Status_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<User_Onboarding_Status_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Onboarding_Status_Enum_Bool_Exp>;
};


export type Subscription_RootUser_Primary_PhoneArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootUser_Primary_Phone_AggregateArgs = {
  args: User_Primary_Phone_Args;
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_ListingsArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Subscription_RootUsers_Listings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Listings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Listings_Order_By>>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};


export type Subscription_RootUsers_Listings_By_PkArgs = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_ViewArgs = {
  distinct_on?: InputMaybe<Array<Users_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_View_Order_By>>;
  where?: InputMaybe<Users_View_Bool_Exp>;
};


export type Subscription_RootUsers_View_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_View_Bool_Exp>;
};


export type Subscription_RootValuation_ModelsArgs = {
  distinct_on?: InputMaybe<Array<Valuation_Models_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuation_Models_Order_By>>;
  where?: InputMaybe<Valuation_Models_Bool_Exp>;
};


export type Subscription_RootValuation_Models_By_PkArgs = {
  name: Scalars['String']['input'];
};


export type Subscription_RootValuation_Models_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Valuation_Models_Stream_Cursor_Input>>;
  where?: InputMaybe<Valuation_Models_Bool_Exp>;
};


export type Subscription_RootValuationsArgs = {
  distinct_on?: InputMaybe<Array<Valuations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Valuations_Order_By>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};


export type Subscription_RootValuations_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootValuations_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Valuations_Stream_Cursor_Input>>;
  where?: InputMaybe<Valuations_Bool_Exp>;
};


export type Subscription_RootVisibility_Inbox_Lead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Inbox_Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Inbox_Lead_Agents_Order_By>>;
  where?: InputMaybe<Visibility_Inbox_Lead_Agents_Bool_Exp>;
};


export type Subscription_RootVisibility_Inbox_Lead_Agents_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Visibility_Inbox_Lead_Agents_Stream_Cursor_Input>>;
  where?: InputMaybe<Visibility_Inbox_Lead_Agents_Bool_Exp>;
};


export type Subscription_RootVisibility_Inbox_Profile_Lead_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Inbox_Profile_Lead_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Inbox_Profile_Lead_History_Order_By>>;
  where?: InputMaybe<Visibility_Inbox_Profile_Lead_History_Bool_Exp>;
};


export type Subscription_RootVisibility_Inbox_Profile_Lead_History_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Visibility_Inbox_Profile_Lead_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Visibility_Inbox_Profile_Lead_History_Bool_Exp>;
};


export type Subscription_RootVisibility_Profile_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Profile_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Profile_Leads_Order_By>>;
  where?: InputMaybe<Visibility_Profile_Leads_Bool_Exp>;
};


export type Subscription_RootVisibility_Profile_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visibility_Profile_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Visibility_Profile_Leads_Order_By>>;
  where?: InputMaybe<Visibility_Profile_Leads_Bool_Exp>;
};


export type Subscription_RootVisibility_Profile_Leads_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Visibility_Profile_Leads_Stream_Cursor_Input>>;
  where?: InputMaybe<Visibility_Profile_Leads_Bool_Exp>;
};


export type Subscription_RootWebhook_Event_Types_EnumArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Event_Types_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Event_Types_Enum_Order_By>>;
  where?: InputMaybe<Webhook_Event_Types_Enum_Bool_Exp>;
};


export type Subscription_RootWebhook_Event_Types_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWebhook_Event_Types_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Webhook_Event_Types_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Webhook_Event_Types_Enum_Bool_Exp>;
};


export type Subscription_RootWebhook_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Subscriptions_Order_By>>;
  where?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
};


export type Subscription_RootWebhook_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Subscriptions_Order_By>>;
  where?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
};


export type Subscription_RootWebhook_Subscriptions_By_PkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootWebhook_Subscriptions_Event_TypesArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Order_By>>;
  where?: InputMaybe<Webhook_Subscriptions_Event_Types_Bool_Exp>;
};


export type Subscription_RootWebhook_Subscriptions_Event_Types_By_PkArgs = {
  event_type: Scalars['String']['input'];
  webhook_subscription_id: Scalars['uuid']['input'];
};


export type Subscription_RootWebhook_Subscriptions_Event_Types_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Webhook_Subscriptions_Event_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Webhook_Subscriptions_Event_Types_Bool_Exp>;
};


export type Subscription_RootWebhook_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Webhook_Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
};


export type Subscription_RootWindow_View_EnumArgs = {
  distinct_on?: InputMaybe<Array<Window_View_Enum_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Window_View_Enum_Order_By>>;
  where?: InputMaybe<Window_View_Enum_Bool_Exp>;
};


export type Subscription_RootWindow_View_Enum_By_PkArgs = {
  value: Scalars['String']['input'];
};


export type Subscription_RootWindow_View_Enum_StreamArgs = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Window_View_Enum_Stream_Cursor_Input>>;
  where?: InputMaybe<Window_View_Enum_Bool_Exp>;
};

/** Boolean expression to compare columns of type "subscription_status". All fields are combined with logical 'AND'. */
export type Subscription_Status_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['subscription_status']['input']>;
  _gt?: InputMaybe<Scalars['subscription_status']['input']>;
  _gte?: InputMaybe<Scalars['subscription_status']['input']>;
  _in?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['subscription_status']['input']>;
  _lte?: InputMaybe<Scalars['subscription_status']['input']>;
  _neq?: InputMaybe<Scalars['subscription_status']['input']>;
  _nin?: InputMaybe<Array<Scalars['subscription_status']['input']>>;
};

/** columns and relationships of "subscriptions" */
export type Subscriptions = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['timestamptz']['output']>;
  billing_thresholds?: Maybe<Scalars['jsonb']['output']>;
  cancel_at?: Maybe<Scalars['timestamptz']['output']>;
  cancel_at_period_end: Scalars['Boolean']['output'];
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at: Scalars['timestamptz']['output'];
  current_period_end: Scalars['timestamptz']['output'];
  current_period_start: Scalars['timestamptz']['output'];
  customer: Scalars['String']['output'];
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  customer_object?: Maybe<Scalars['jsonb']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  default_tax_rates?: Maybe<Scalars['jsonb']['output']>;
  discount?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  email?: Maybe<Emails>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  interval_count?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  invoices: Array<Invoices>;
  /** An aggregate relationship */
  invoices_aggregate: Invoices_Aggregate;
  items: Scalars['jsonb']['output'];
  last_event_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  livemode: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['timestamptz']['output']>;
  pause_collection?: Maybe<Scalars['jsonb']['output']>;
  pending_invoice_item_interval?: Maybe<Scalars['jsonb']['output']>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  pending_update?: Maybe<Scalars['jsonb']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date: Scalars['timestamptz']['output'];
  status: Scalars['subscription_status']['output'];
  stripe_id: Scalars['String']['output'];
  tenant_id: Scalars['uuid']['output'];
  total_amount: Scalars['Int']['output'];
  transfer_data?: Maybe<Scalars['jsonb']['output']>;
  trial_end?: Maybe<Scalars['timestamptz']['output']>;
  trial_start?: Maybe<Scalars['timestamptz']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsBilling_ThresholdsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsCustomer_ObjectArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsDefault_Tax_RatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsDiscountArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsInvoicesArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsInvoices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Invoices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Invoices_Order_By>>;
  where?: InputMaybe<Invoices_Bool_Exp>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsItemsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsPause_CollectionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsPending_Invoice_Item_IntervalArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsPending_UpdateArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsTransfer_DataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "subscriptions" */
export type Subscriptions_Aggregate = {
  aggregate?: Maybe<Subscriptions_Aggregate_Fields>;
  nodes: Array<Subscriptions>;
};

export type Subscriptions_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Subscriptions_Aggregate_Bool_Exp_Count>;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_And = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Subscriptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subscriptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_Fields = {
  avg?: Maybe<Subscriptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Subscriptions_Max_Fields>;
  min?: Maybe<Subscriptions_Min_Fields>;
  stddev?: Maybe<Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Variance_Fields>;
};


/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "subscriptions" */
export type Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Subscriptions_Max_Order_By>;
  min?: InputMaybe<Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Subscriptions_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Subscriptions_Avg_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "subscriptions" */
export type Subscriptions_Avg_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "subscriptions". All fields are combined with a logical 'AND'. */
export type Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  application_fee_percent?: InputMaybe<Float_Comparison_Exp>;
  billing_cycle_anchor?: InputMaybe<Timestamptz_Comparison_Exp>;
  billing_thresholds?: InputMaybe<Jsonb_Comparison_Exp>;
  cancel_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  cancel_at_period_end?: InputMaybe<Boolean_Comparison_Exp>;
  canceled_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  collection_method?: InputMaybe<String_Comparison_Exp>;
  created?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  current_period_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  customer?: InputMaybe<String_Comparison_Exp>;
  customer_email?: InputMaybe<String_Comparison_Exp>;
  customer_name?: InputMaybe<String_Comparison_Exp>;
  customer_object?: InputMaybe<Jsonb_Comparison_Exp>;
  days_until_due?: InputMaybe<Int_Comparison_Exp>;
  default_payment_method?: InputMaybe<String_Comparison_Exp>;
  default_source?: InputMaybe<String_Comparison_Exp>;
  default_tax_rates?: InputMaybe<Jsonb_Comparison_Exp>;
  discount?: InputMaybe<Jsonb_Comparison_Exp>;
  email?: InputMaybe<Emails_Bool_Exp>;
  ended_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interval_count?: InputMaybe<Int_Comparison_Exp>;
  invoices?: InputMaybe<Invoices_Bool_Exp>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Bool_Exp>;
  items?: InputMaybe<Jsonb_Comparison_Exp>;
  last_event_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  latest_invoice?: InputMaybe<String_Comparison_Exp>;
  livemode?: InputMaybe<Boolean_Comparison_Exp>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp>;
  next_pending_invoice_item_invoice?: InputMaybe<Timestamptz_Comparison_Exp>;
  pause_collection?: InputMaybe<Jsonb_Comparison_Exp>;
  pending_invoice_item_interval?: InputMaybe<Jsonb_Comparison_Exp>;
  pending_setup_intent?: InputMaybe<String_Comparison_Exp>;
  pending_update?: InputMaybe<Jsonb_Comparison_Exp>;
  plan_name?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  schedule?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<Subscription_Status_Comparison_Exp>;
  stripe_id?: InputMaybe<String_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_amount?: InputMaybe<Int_Comparison_Exp>;
  transfer_data?: InputMaybe<Jsonb_Comparison_Exp>;
  trial_end?: InputMaybe<Timestamptz_Comparison_Exp>;
  trial_start?: InputMaybe<Timestamptz_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Subscriptions_Max_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['timestamptz']['output']>;
  cancel_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_period_end?: Maybe<Scalars['timestamptz']['output']>;
  current_period_start?: Maybe<Scalars['timestamptz']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  last_event_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['timestamptz']['output']>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['subscription_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
  trial_end?: Maybe<Scalars['timestamptz']['output']>;
  trial_start?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "subscriptions" */
export type Subscriptions_Max_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  billing_cycle_anchor?: InputMaybe<Order_By>;
  cancel_at?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  last_event_at?: InputMaybe<Order_By>;
  latest_invoice?: InputMaybe<Order_By>;
  next_pending_invoice_item_invoice?: InputMaybe<Order_By>;
  pending_setup_intent?: InputMaybe<Order_By>;
  plan_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  trial_end?: InputMaybe<Order_By>;
  trial_start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Subscriptions_Min_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  billing_cycle_anchor?: Maybe<Scalars['timestamptz']['output']>;
  cancel_at?: Maybe<Scalars['timestamptz']['output']>;
  canceled_at?: Maybe<Scalars['timestamptz']['output']>;
  collection_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['timestamptz']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  current_period_end?: Maybe<Scalars['timestamptz']['output']>;
  current_period_start?: Maybe<Scalars['timestamptz']['output']>;
  customer?: Maybe<Scalars['String']['output']>;
  customer_email?: Maybe<Scalars['String']['output']>;
  customer_name?: Maybe<Scalars['String']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  default_source?: Maybe<Scalars['String']['output']>;
  ended_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  last_event_at?: Maybe<Scalars['timestamptz']['output']>;
  latest_invoice?: Maybe<Scalars['String']['output']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['timestamptz']['output']>;
  pending_setup_intent?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['timestamptz']['output']>;
  status?: Maybe<Scalars['subscription_status']['output']>;
  stripe_id?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
  trial_end?: Maybe<Scalars['timestamptz']['output']>;
  trial_start?: Maybe<Scalars['timestamptz']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "subscriptions" */
export type Subscriptions_Min_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  billing_cycle_anchor?: InputMaybe<Order_By>;
  cancel_at?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  last_event_at?: InputMaybe<Order_By>;
  latest_invoice?: InputMaybe<Order_By>;
  next_pending_invoice_item_invoice?: InputMaybe<Order_By>;
  pending_setup_intent?: InputMaybe<Order_By>;
  plan_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  trial_end?: InputMaybe<Order_By>;
  trial_start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "subscriptions" */
export type Subscriptions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions>;
};

/** Ordering options when selecting data from "subscriptions". */
export type Subscriptions_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  billing_cycle_anchor?: InputMaybe<Order_By>;
  billing_thresholds?: InputMaybe<Order_By>;
  cancel_at?: InputMaybe<Order_By>;
  cancel_at_period_end?: InputMaybe<Order_By>;
  canceled_at?: InputMaybe<Order_By>;
  collection_method?: InputMaybe<Order_By>;
  created?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  current_period_end?: InputMaybe<Order_By>;
  current_period_start?: InputMaybe<Order_By>;
  customer?: InputMaybe<Order_By>;
  customer_email?: InputMaybe<Order_By>;
  customer_name?: InputMaybe<Order_By>;
  customer_object?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  default_payment_method?: InputMaybe<Order_By>;
  default_source?: InputMaybe<Order_By>;
  default_tax_rates?: InputMaybe<Order_By>;
  discount?: InputMaybe<Order_By>;
  email?: InputMaybe<Emails_Order_By>;
  ended_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  invoices_aggregate?: InputMaybe<Invoices_Aggregate_Order_By>;
  items?: InputMaybe<Order_By>;
  last_event_at?: InputMaybe<Order_By>;
  latest_invoice?: InputMaybe<Order_By>;
  livemode?: InputMaybe<Order_By>;
  metadata?: InputMaybe<Order_By>;
  next_pending_invoice_item_invoice?: InputMaybe<Order_By>;
  pause_collection?: InputMaybe<Order_By>;
  pending_invoice_item_interval?: InputMaybe<Order_By>;
  pending_setup_intent?: InputMaybe<Order_By>;
  pending_update?: InputMaybe<Order_By>;
  plan_name?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  schedule?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  stripe_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
  transfer_data?: InputMaybe<Order_By>;
  trial_end?: InputMaybe<Order_By>;
  trial_start?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions */
export type Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "subscriptions" */
export enum Subscriptions_Select_Column {
  /** column name */
  ApplicationFeePercent = 'application_fee_percent',
  /** column name */
  BillingCycleAnchor = 'billing_cycle_anchor',
  /** column name */
  BillingThresholds = 'billing_thresholds',
  /** column name */
  CancelAt = 'cancel_at',
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  CanceledAt = 'canceled_at',
  /** column name */
  CollectionMethod = 'collection_method',
  /** column name */
  Created = 'created',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CurrentPeriodEnd = 'current_period_end',
  /** column name */
  CurrentPeriodStart = 'current_period_start',
  /** column name */
  Customer = 'customer',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  CustomerObject = 'customer_object',
  /** column name */
  DaysUntilDue = 'days_until_due',
  /** column name */
  DefaultPaymentMethod = 'default_payment_method',
  /** column name */
  DefaultSource = 'default_source',
  /** column name */
  DefaultTaxRates = 'default_tax_rates',
  /** column name */
  Discount = 'discount',
  /** column name */
  EndedAt = 'ended_at',
  /** column name */
  Id = 'id',
  /** column name */
  IntervalCount = 'interval_count',
  /** column name */
  Items = 'items',
  /** column name */
  LastEventAt = 'last_event_at',
  /** column name */
  LatestInvoice = 'latest_invoice',
  /** column name */
  Livemode = 'livemode',
  /** column name */
  Metadata = 'metadata',
  /** column name */
  NextPendingInvoiceItemInvoice = 'next_pending_invoice_item_invoice',
  /** column name */
  PauseCollection = 'pause_collection',
  /** column name */
  PendingInvoiceItemInterval = 'pending_invoice_item_interval',
  /** column name */
  PendingSetupIntent = 'pending_setup_intent',
  /** column name */
  PendingUpdate = 'pending_update',
  /** column name */
  PlanName = 'plan_name',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Schedule = 'schedule',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  StripeId = 'stripe_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TotalAmount = 'total_amount',
  /** column name */
  TransferData = 'transfer_data',
  /** column name */
  TrialEnd = 'trial_end',
  /** column name */
  TrialStart = 'trial_start',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "subscriptions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "subscriptions" */
export enum Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

/** select "subscriptions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "subscriptions" */
export enum Subscriptions_Select_Column_Subscriptions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CancelAtPeriodEnd = 'cancel_at_period_end',
  /** column name */
  Livemode = 'livemode'
}

/** input type for updating data in table "subscriptions" */
export type Subscriptions_Set_Input = {
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Stddev_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Stddev_Pop_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Pop_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Stddev_Samp_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "subscriptions" */
export type Subscriptions_Stddev_Samp_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "subscriptions" */
export type Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Stream_Cursor_Value_Input = {
  application_fee_percent?: InputMaybe<Scalars['Float']['input']>;
  billing_cycle_anchor?: InputMaybe<Scalars['timestamptz']['input']>;
  billing_thresholds?: InputMaybe<Scalars['jsonb']['input']>;
  cancel_at?: InputMaybe<Scalars['timestamptz']['input']>;
  cancel_at_period_end?: InputMaybe<Scalars['Boolean']['input']>;
  canceled_at?: InputMaybe<Scalars['timestamptz']['input']>;
  collection_method?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['timestamptz']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_end?: InputMaybe<Scalars['timestamptz']['input']>;
  current_period_start?: InputMaybe<Scalars['timestamptz']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  customer_email?: InputMaybe<Scalars['String']['input']>;
  customer_name?: InputMaybe<Scalars['String']['input']>;
  customer_object?: InputMaybe<Scalars['jsonb']['input']>;
  days_until_due?: InputMaybe<Scalars['Int']['input']>;
  default_payment_method?: InputMaybe<Scalars['String']['input']>;
  default_source?: InputMaybe<Scalars['String']['input']>;
  default_tax_rates?: InputMaybe<Scalars['jsonb']['input']>;
  discount?: InputMaybe<Scalars['jsonb']['input']>;
  ended_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interval_count?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Scalars['jsonb']['input']>;
  last_event_at?: InputMaybe<Scalars['timestamptz']['input']>;
  latest_invoice?: InputMaybe<Scalars['String']['input']>;
  livemode?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  next_pending_invoice_item_invoice?: InputMaybe<Scalars['timestamptz']['input']>;
  pause_collection?: InputMaybe<Scalars['jsonb']['input']>;
  pending_invoice_item_interval?: InputMaybe<Scalars['jsonb']['input']>;
  pending_setup_intent?: InputMaybe<Scalars['String']['input']>;
  pending_update?: InputMaybe<Scalars['jsonb']['input']>;
  plan_name?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  schedule?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<Scalars['subscription_status']['input']>;
  stripe_id?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  total_amount?: InputMaybe<Scalars['Int']['input']>;
  transfer_data?: InputMaybe<Scalars['jsonb']['input']>;
  trial_end?: InputMaybe<Scalars['timestamptz']['input']>;
  trial_start?: InputMaybe<Scalars['timestamptz']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Subscriptions_Sum_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Int']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  total_amount?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "subscriptions" */
export type Subscriptions_Sum_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

export type Subscriptions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Var_Pop_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "subscriptions" */
export type Subscriptions_Var_Pop_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Var_Samp_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "subscriptions" */
export type Subscriptions_Var_Samp_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Subscriptions_Variance_Fields = {
  application_fee_percent?: Maybe<Scalars['Float']['output']>;
  days_until_due?: Maybe<Scalars['Float']['output']>;
  interval_count?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  total_amount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "subscriptions" */
export type Subscriptions_Variance_Order_By = {
  application_fee_percent?: InputMaybe<Order_By>;
  days_until_due?: InputMaybe<Order_By>;
  interval_count?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  total_amount?: InputMaybe<Order_By>;
};

/** columns and relationships of "team_images" */
export type Team_Images = {
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "team_images" */
export type Team_Images_Aggregate_Order_By = {
  avg?: InputMaybe<Team_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Team_Images_Max_Order_By>;
  min?: InputMaybe<Team_Images_Min_Order_By>;
  stddev?: InputMaybe<Team_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Team_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Team_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Team_Images_Sum_Order_By>;
  var_pop?: InputMaybe<Team_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Team_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<Team_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "team_images" */
export type Team_Images_Arr_Rel_Insert_Input = {
  data: Array<Team_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Team_Images_On_Conflict>;
};

/** order by avg() on columns of table "team_images" */
export type Team_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "team_images". All fields are combined with a logical 'AND'. */
export type Team_Images_Bool_Exp = {
  _and?: InputMaybe<Array<Team_Images_Bool_Exp>>;
  _not?: InputMaybe<Team_Images_Bool_Exp>;
  _or?: InputMaybe<Array<Team_Images_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "team_images" */
export enum Team_Images_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamImagesPkey = 'team_images_pkey',
  /** unique or primary key constraint on columns "team_id", "order_nr" */
  TeamImagesTeamIdOrderNrUnique = 'team_images_team_id_order_nr_unique'
}

/** input type for inserting data into table "team_images" */
export type Team_Images_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by max() on columns of table "team_images" */
export type Team_Images_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "team_images" */
export type Team_Images_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "team_images" */
export type Team_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Team_Images>;
};

/** on_conflict condition type for table "team_images" */
export type Team_Images_On_Conflict = {
  constraint: Team_Images_Constraint;
  update_columns?: Array<Team_Images_Update_Column>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "team_images". */
export type Team_Images_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "team_images" */
export enum Team_Images_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** order by stddev() on columns of table "team_images" */
export type Team_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "team_images" */
export type Team_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "team_images" */
export type Team_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "team_images" */
export type Team_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Team_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Team_Images_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** order by sum() on columns of table "team_images" */
export type Team_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** placeholder for update columns of table "team_images" (current role has no relevant permissions) */
export enum Team_Images_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** order by var_pop() on columns of table "team_images" */
export type Team_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "team_images" */
export type Team_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "team_images" */
export type Team_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

export type Team_Ranking_Places_Args = {
  exclude_rental_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  limit_count?: InputMaybe<Scalars['Int']['input']>;
  max_distance?: InputMaybe<Scalars['float8']['input']>;
  offset_count?: InputMaybe<Scalars['Int']['input']>;
  transaction_radius?: InputMaybe<Scalars['float8']['input']>;
};

/** An agency or office inside a tenant. Its members are in teams_users. */
export type Teams = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  centroid?: Maybe<Scalars['geometry']['output']>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  copy_reviews_to_google: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  cover_photo?: Maybe<Images>;
  cover_photo_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  default_team_users: Array<Users>;
  /** An aggregate relationship */
  default_team_users_aggregate: Users_Aggregate;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  do_follow_link?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  emails: Array<Emails>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  enquiry_email_contact?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['geometry']['output']>;
  google_business_id?: Maybe<Scalars['String']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  google_reviews: Array<Google_Reviews>;
  /** An aggregate relationship */
  google_reviews_aggregate: Google_Reviews_Aggregate;
  hide_exact_address: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  idx_agency_id?: Maybe<Scalars['String']['output']>;
  idx_ftp_client_id?: Maybe<Scalars['String']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  is_unclaimed: Scalars['Boolean']['output'];
  last_review_scraping?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  listings_agency_names?: Maybe<Array<Scalars['String']['output']>>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  logo?: Maybe<Images>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  lots_member_access: Lots_Member_Access_Enum_Enum;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  mv_agency?: Maybe<Agencies>;
  name: Scalars['String']['output'];
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  opening_hours?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  /** A computed field, executes function "team_places" */
  places?: Maybe<Array<Places>>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  region_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  share_transactions_in_cma?: Maybe<Scalars['Boolean']['output']>;
  show_in_agency_pages?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  team_images: Array<Team_Images>;
  /** An array relationship */
  teams_portals: Array<Teams_Portals>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  tiktok_url?: Maybe<Scalars['String']['output']>;
  /** Show this team's listings at the top of search results in agg-next. */
  top_listings: Scalars['Boolean']['output'];
  tsv?: Maybe<Scalars['tsvector']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  use_json_for_enquiry_emails: Scalars['Boolean']['output'];
  website_url?: Maybe<Scalars['String']['output']>;
  x_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsDefault_Team_UsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsDefault_Team_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsGoogle_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsGoogle_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Google_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Google_Reviews_Order_By>>;
  where?: InputMaybe<Google_Reviews_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsOpening_HoursArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsPlacesArgs = {
  distinct_on?: InputMaybe<Array<Places_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Places_Order_By>>;
  where?: InputMaybe<Places_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsTeam_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Team_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Team_Images_Order_By>>;
  where?: InputMaybe<Team_Images_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsTeams_PortalsArgs = {
  distinct_on?: InputMaybe<Array<Teams_Portals_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Portals_Order_By>>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** An agency or office inside a tenant. Its members are in teams_users. */
export type TeamsTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};

/** aggregated selection of "teams" */
export type Teams_Aggregate = {
  aggregate?: Maybe<Teams_Aggregate_Fields>;
  nodes: Array<Teams>;
};

export type Teams_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Teams_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Teams_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Teams_Aggregate_Bool_Exp_Count>;
};

export type Teams_Aggregate_Bool_Exp_Bool_And = {
  arguments: Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams" */
export type Teams_Aggregate_Fields = {
  avg?: Maybe<Teams_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Teams_Max_Fields>;
  min?: Maybe<Teams_Min_Fields>;
  stddev?: Maybe<Teams_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Sum_Fields>;
  var_pop?: Maybe<Teams_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Var_Samp_Fields>;
  variance?: Maybe<Teams_Variance_Fields>;
};


/** aggregate fields of "teams" */
export type Teams_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teams" */
export type Teams_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Max_Order_By>;
  min?: InputMaybe<Teams_Min_Order_By>;
  stddev?: InputMaybe<Teams_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Teams_Append_Input = {
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "teams" */
export type Teams_Arr_Rel_Insert_Input = {
  data: Array<Teams_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Avg_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "teams" */
export type Teams_Avg_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams". All fields are combined with a logical 'AND'. */
export type Teams_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Bool_Exp>>;
  _not?: InputMaybe<Teams_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Bool_Exp>>;
  active_since?: InputMaybe<Int_Comparison_Exp>;
  agency_slug?: InputMaybe<String_Comparison_Exp>;
  branding_color?: InputMaybe<String_Comparison_Exp>;
  centroid?: InputMaybe<Geometry_Comparison_Exp>;
  combined_reviews?: InputMaybe<Combined_Reviews_Bool_Exp>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp>;
  copy_reviews_to_google?: InputMaybe<Boolean_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  country_id?: InputMaybe<Uuid_Comparison_Exp>;
  cover_photo?: InputMaybe<Images_Bool_Exp>;
  cover_photo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  default_team_users?: InputMaybe<Users_Bool_Exp>;
  default_team_users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  district_id?: InputMaybe<Uuid_Comparison_Exp>;
  do_follow_link?: InputMaybe<Boolean_Comparison_Exp>;
  emails?: InputMaybe<Emails_Bool_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  enquiry_email_contact?: InputMaybe<String_Comparison_Exp>;
  facebook_url?: InputMaybe<String_Comparison_Exp>;
  geom?: InputMaybe<Geometry_Comparison_Exp>;
  google_business_id?: InputMaybe<String_Comparison_Exp>;
  google_place_description?: InputMaybe<String_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  google_reviews?: InputMaybe<Google_Reviews_Bool_Exp>;
  google_reviews_aggregate?: InputMaybe<Google_Reviews_Aggregate_Bool_Exp>;
  hide_exact_address?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  idx_agency_id?: InputMaybe<String_Comparison_Exp>;
  idx_ftp_client_id?: InputMaybe<String_Comparison_Exp>;
  instagram_url?: InputMaybe<String_Comparison_Exp>;
  is_unclaimed?: InputMaybe<Boolean_Comparison_Exp>;
  last_review_scraping?: InputMaybe<Timestamptz_Comparison_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  legal_name?: InputMaybe<String_Comparison_Exp>;
  linkedin_url?: InputMaybe<String_Comparison_Exp>;
  listings_agency_names?: InputMaybe<String_Array_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  locality_id?: InputMaybe<Uuid_Comparison_Exp>;
  logo?: InputMaybe<Images_Bool_Exp>;
  logo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  lots_member_access?: InputMaybe<Lots_Member_Access_Enum_Enum_Comparison_Exp>;
  municipality_id?: InputMaybe<Uuid_Comparison_Exp>;
  mv_agency?: InputMaybe<Agencies_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  neighbourhood_id?: InputMaybe<Uuid_Comparison_Exp>;
  opening_hours?: InputMaybe<Jsonb_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  phone_numbers?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp>;
  places?: InputMaybe<Places_Bool_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  postcode_id?: InputMaybe<Uuid_Comparison_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  region_id?: InputMaybe<Uuid_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  share_transactions_in_cma?: InputMaybe<Boolean_Comparison_Exp>;
  show_in_agency_pages?: InputMaybe<Boolean_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  state_id?: InputMaybe<Uuid_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  team_images?: InputMaybe<Team_Images_Bool_Exp>;
  teams_portals?: InputMaybe<Teams_Portals_Bool_Exp>;
  teams_users?: InputMaybe<Teams_Users_Bool_Exp>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Bool_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  tiktok_url?: InputMaybe<String_Comparison_Exp>;
  top_listings?: InputMaybe<Boolean_Comparison_Exp>;
  tsv?: InputMaybe<Tsvector_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  use_json_for_enquiry_emails?: InputMaybe<Boolean_Comparison_Exp>;
  website_url?: InputMaybe<String_Comparison_Exp>;
  x_url?: InputMaybe<String_Comparison_Exp>;
  youtube_url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams" */
export enum Teams_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPkey = 'teams_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  TeamsTenantIdIdIdx = 'teams_tenant_id_id_idx',
  /** unique or primary key constraint on columns "agency_slug" */
  UniqueAgencySlugIndex = 'unique_agency_slug_index'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Teams_Delete_At_Path_Input = {
  opening_hours?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Teams_Delete_Elem_Input = {
  opening_hours?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Teams_Delete_Key_Input = {
  opening_hours?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "teams" */
export type Teams_Inc_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "teams" */
export type Teams_Insert_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  copy_reviews_to_google?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  cover_photo?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  default_team_users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
  description?: InputMaybe<Scalars['String']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Emails_Arr_Rel_Insert_Input>;
  enquiries?: InputMaybe<Enquiries_Arr_Rel_Insert_Input>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  lots_member_access?: InputMaybe<Lots_Member_Access_Enum_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  phone_numbers?: InputMaybe<Phone_Numbers_Arr_Rel_Insert_Input>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  route?: InputMaybe<Scalars['String']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  team_images?: InputMaybe<Team_Images_Arr_Rel_Insert_Input>;
  teams_portals?: InputMaybe<Teams_Portals_Arr_Rel_Insert_Input>;
  teams_users?: InputMaybe<Teams_Users_Arr_Rel_Insert_Input>;
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  x_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Teams_Max_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  cover_photo_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  enquiry_email_contact?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  google_business_id?: Maybe<Scalars['String']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_agency_id?: Maybe<Scalars['String']['output']>;
  idx_ftp_client_id?: Maybe<Scalars['String']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  last_review_scraping?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  listings_agency_names?: Maybe<Array<Scalars['String']['output']>>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  tiktok_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  x_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "teams" */
export type Teams_Max_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  cover_photo_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  enquiry_email_contact?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  google_business_id?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_agency_id?: InputMaybe<Order_By>;
  idx_ftp_client_id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  last_review_scraping?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  listings_agency_names?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tiktok_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
  x_url?: InputMaybe<Order_By>;
  youtube_url?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Min_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  agency_slug?: Maybe<Scalars['String']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  country_id?: Maybe<Scalars['uuid']['output']>;
  cover_photo_image_id?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['uuid']['output']>;
  enquiry_email_contact?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  google_business_id?: Maybe<Scalars['String']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  idx_agency_id?: Maybe<Scalars['String']['output']>;
  idx_ftp_client_id?: Maybe<Scalars['String']['output']>;
  instagram_url?: Maybe<Scalars['String']['output']>;
  last_review_scraping?: Maybe<Scalars['timestamptz']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  legal_name?: Maybe<Scalars['String']['output']>;
  linkedin_url?: Maybe<Scalars['String']['output']>;
  listings_agency_names?: Maybe<Array<Scalars['String']['output']>>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  locality_id?: Maybe<Scalars['uuid']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  municipality_id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  neighbourhood_id?: Maybe<Scalars['uuid']['output']>;
  organisation_id?: Maybe<Scalars['uuid']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  postcode_id?: Maybe<Scalars['uuid']['output']>;
  region_id?: Maybe<Scalars['uuid']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  state_id?: Maybe<Scalars['uuid']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  tiktok_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  website_url?: Maybe<Scalars['String']['output']>;
  x_url?: Maybe<Scalars['String']['output']>;
  youtube_url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "teams" */
export type Teams_Min_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  cover_photo_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  enquiry_email_contact?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  google_business_id?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_agency_id?: InputMaybe<Order_By>;
  idx_ftp_client_id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  last_review_scraping?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  listings_agency_names?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  region_id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tiktok_url?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
  x_url?: InputMaybe<Order_By>;
  youtube_url?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams" */
export type Teams_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams>;
};

/** input type for inserting object relation for remote table "teams" */
export type Teams_Obj_Rel_Insert_Input = {
  data: Teams_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_On_Conflict>;
};

/** on_conflict condition type for table "teams" */
export type Teams_On_Conflict = {
  constraint: Teams_Constraint;
  update_columns?: Array<Teams_Update_Column>;
  where?: InputMaybe<Teams_Bool_Exp>;
};

/** Ordering options when selecting data from "teams". */
export type Teams_Order_By = {
  active_since?: InputMaybe<Order_By>;
  agency_slug?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  centroid?: InputMaybe<Order_By>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Order_By>;
  copy_reviews_to_google?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  country_id?: InputMaybe<Order_By>;
  cover_photo?: InputMaybe<Images_Order_By>;
  cover_photo_image_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  default_team_users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
  description?: InputMaybe<Order_By>;
  district_id?: InputMaybe<Order_By>;
  do_follow_link?: InputMaybe<Order_By>;
  emails_aggregate?: InputMaybe<Emails_Aggregate_Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  enquiry_email_contact?: InputMaybe<Order_By>;
  facebook_url?: InputMaybe<Order_By>;
  geom?: InputMaybe<Order_By>;
  google_business_id?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_reviews_aggregate?: InputMaybe<Google_Reviews_Aggregate_Order_By>;
  hide_exact_address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idx_agency_id?: InputMaybe<Order_By>;
  idx_ftp_client_id?: InputMaybe<Order_By>;
  instagram_url?: InputMaybe<Order_By>;
  is_unclaimed?: InputMaybe<Order_By>;
  last_review_scraping?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  legal_name?: InputMaybe<Order_By>;
  linkedin_url?: InputMaybe<Order_By>;
  listings_agency_names?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  locality_id?: InputMaybe<Order_By>;
  logo?: InputMaybe<Images_Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  lots_member_access?: InputMaybe<Order_By>;
  municipality_id?: InputMaybe<Order_By>;
  mv_agency?: InputMaybe<Agencies_Order_By>;
  name?: InputMaybe<Order_By>;
  neighbourhood_id?: InputMaybe<Order_By>;
  opening_hours?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  places_aggregate?: InputMaybe<Places_Aggregate_Order_By>;
  postcode?: InputMaybe<Order_By>;
  postcode_id?: InputMaybe<Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  region_id?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  share_transactions_in_cma?: InputMaybe<Order_By>;
  show_in_agency_pages?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  state_id?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  team_images_aggregate?: InputMaybe<Team_Images_Aggregate_Order_By>;
  teams_portals_aggregate?: InputMaybe<Teams_Portals_Aggregate_Order_By>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  tiktok_url?: InputMaybe<Order_By>;
  top_listings?: InputMaybe<Order_By>;
  tsv?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_json_for_enquiry_emails?: InputMaybe<Order_By>;
  website_url?: InputMaybe<Order_By>;
  x_url?: InputMaybe<Order_By>;
  youtube_url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams */
export type Teams_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "teams_portals" */
export type Teams_Portals = {
  contract_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portal: Portals;
  portal_id: Scalars['uuid']['output'];
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** order by aggregate values of table "teams_portals" */
export type Teams_Portals_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Portals_Max_Order_By>;
  min?: InputMaybe<Teams_Portals_Min_Order_By>;
};

/** input type for inserting array relation for remote table "teams_portals" */
export type Teams_Portals_Arr_Rel_Insert_Input = {
  data: Array<Teams_Portals_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_Portals_On_Conflict>;
};

/** Boolean expression to filter rows from the table "teams_portals". All fields are combined with a logical 'AND'. */
export type Teams_Portals_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Portals_Bool_Exp>>;
  _not?: InputMaybe<Teams_Portals_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Portals_Bool_Exp>>;
  contract_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  portal?: InputMaybe<Portals_Bool_Exp>;
  portal_id?: InputMaybe<Uuid_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams_portals" */
export enum Teams_Portals_Constraint {
  /** unique or primary key constraint on columns "id" */
  TeamsPortalsPkey = 'teams_portals_pkey',
  /** unique or primary key constraint on columns "portal_id", "team_id" */
  TeamsPortalsTeamIdPortalIdKey = 'teams_portals_team_id_portal_id_key'
}

/** input type for inserting data into table "teams_portals" */
export type Teams_Portals_Insert_Input = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
  portal?: InputMaybe<Portals_Obj_Rel_Insert_Input>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "teams_portals" */
export type Teams_Portals_Max_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "teams_portals" */
export type Teams_Portals_Min_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portal_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams_portals" */
export type Teams_Portals_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_Portals>;
};

/** on_conflict condition type for table "teams_portals" */
export type Teams_Portals_On_Conflict = {
  constraint: Teams_Portals_Constraint;
  update_columns?: Array<Teams_Portals_Update_Column>;
  where?: InputMaybe<Teams_Portals_Bool_Exp>;
};

/** Ordering options when selecting data from "teams_portals". */
export type Teams_Portals_Order_By = {
  contract_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  portal?: InputMaybe<Portals_Order_By>;
  portal_id?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: teams_portals */
export type Teams_Portals_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "teams_portals" */
export enum Teams_Portals_Select_Column {
  /** column name */
  ContractId = 'contract_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  PortalId = 'portal_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "teams_portals" */
export type Teams_Portals_Set_Input = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "teams_portals" */
export type Teams_Portals_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Portals_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Portals_Stream_Cursor_Value_Input = {
  contract_id?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portal_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "teams_portals" */
export enum Teams_Portals_Update_Column {
  /** column name */
  ContractId = 'contract_id'
}

export type Teams_Portals_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Portals_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Portals_Bool_Exp;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Teams_Prepend_Input = {
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Shape of the rows the functions get_teams_ranking (around a location) and get_teams_ranking_by_distance (the teams nearest current_team_id) return: a team (team_id -> teams) with transaction and review counts. The table itself holds no row: call a function. */
export type Teams_Rankings = {
  distance?: Maybe<Scalars['float8']['output']>;
  /** Whether the ranked team is an independent agent rather than an agency. Derived in SQL so that roles which cannot SELECT competitor teams still get the correct value, without any teams row being exposed. */
  is_independent_agent?: Maybe<Scalars['Boolean']['output']>;
  latest_review_date?: Maybe<Scalars['timestamptz']['output']>;
  latest_transaction_date?: Maybe<Scalars['timestamptz']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount: Scalars['Int']['output'];
  reviews_in_location?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  /** An object relationship */
  team?: Maybe<Teams>;
  team_id: Scalars['uuid']['output'];
  total_transactions: Scalars['Int']['output'];
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

export type Teams_Rankings_Aggregate = {
  aggregate?: Maybe<Teams_Rankings_Aggregate_Fields>;
  nodes: Array<Teams_Rankings>;
};

/** aggregate fields of "teams_rankings" */
export type Teams_Rankings_Aggregate_Fields = {
  avg?: Maybe<Teams_Rankings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Teams_Rankings_Max_Fields>;
  min?: Maybe<Teams_Rankings_Min_Fields>;
  stddev?: Maybe<Teams_Rankings_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Rankings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Rankings_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Rankings_Sum_Fields>;
  var_pop?: Maybe<Teams_Rankings_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Rankings_Var_Samp_Fields>;
  variance?: Maybe<Teams_Rankings_Variance_Fields>;
};


/** aggregate fields of "teams_rankings" */
export type Teams_Rankings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Rankings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Teams_Rankings_Avg_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  reviews_in_location?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "teams_rankings". All fields are combined with a logical 'AND'. */
export type Teams_Rankings_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Rankings_Bool_Exp>>;
  _not?: InputMaybe<Teams_Rankings_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Rankings_Bool_Exp>>;
  distance?: InputMaybe<Float8_Comparison_Exp>;
  is_independent_agent?: InputMaybe<Boolean_Comparison_Exp>;
  latest_review_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  latest_transaction_date?: InputMaybe<Timestamptz_Comparison_Exp>;
  nearby_radius_km?: InputMaybe<Float8_Comparison_Exp>;
  nearby_transaction_count?: InputMaybe<Int_Comparison_Exp>;
  payment_amount?: InputMaybe<Int_Comparison_Exp>;
  reviews_in_location?: InputMaybe<Int_Comparison_Exp>;
  subscription_status?: InputMaybe<Subscription_Status_Comparison_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  total_transactions?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_district?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_location?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_municipality?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_radius?: InputMaybe<Int_Comparison_Exp>;
  transactions_in_state?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Teams_Rankings_Max_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  latest_review_date?: Maybe<Scalars['timestamptz']['output']>;
  latest_transaction_date?: Maybe<Scalars['timestamptz']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  reviews_in_location?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type Teams_Rankings_Min_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  latest_review_date?: Maybe<Scalars['timestamptz']['output']>;
  latest_transaction_date?: Maybe<Scalars['timestamptz']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  reviews_in_location?: Maybe<Scalars['Int']['output']>;
  subscription_status?: Maybe<Scalars['subscription_status']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** Ordering options when selecting data from "teams_rankings". */
export type Teams_Rankings_Order_By = {
  distance?: InputMaybe<Order_By>;
  is_independent_agent?: InputMaybe<Order_By>;
  latest_review_date?: InputMaybe<Order_By>;
  latest_transaction_date?: InputMaybe<Order_By>;
  nearby_radius_km?: InputMaybe<Order_By>;
  nearby_transaction_count?: InputMaybe<Order_By>;
  payment_amount?: InputMaybe<Order_By>;
  reviews_in_location?: InputMaybe<Order_By>;
  subscription_status?: InputMaybe<Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  total_transactions?: InputMaybe<Order_By>;
  transactions_in_district?: InputMaybe<Order_By>;
  transactions_in_location?: InputMaybe<Order_By>;
  transactions_in_municipality?: InputMaybe<Order_By>;
  transactions_in_radius?: InputMaybe<Order_By>;
  transactions_in_state?: InputMaybe<Order_By>;
};

/** select columns of table "teams_rankings" */
export enum Teams_Rankings_Select_Column {
  /** column name */
  Distance = 'distance',
  /** column name */
  LatestReviewDate = 'latest_review_date',
  /** column name */
  LatestTransactionDate = 'latest_transaction_date',
  /** column name */
  NearbyRadiusKm = 'nearby_radius_km',
  /** column name */
  NearbyTransactionCount = 'nearby_transaction_count',
  /** column name */
  PaymentAmount = 'payment_amount',
  /** column name */
  ReviewsInLocation = 'reviews_in_location',
  /** column name */
  SubscriptionStatus = 'subscription_status',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TotalTransactions = 'total_transactions',
  /** column name */
  TransactionsInDistrict = 'transactions_in_district',
  /** column name */
  TransactionsInLocation = 'transactions_in_location',
  /** column name */
  TransactionsInMunicipality = 'transactions_in_municipality',
  /** column name */
  TransactionsInRadius = 'transactions_in_radius',
  /** column name */
  TransactionsInState = 'transactions_in_state'
}

/** aggregate stddev on columns */
export type Teams_Rankings_Stddev_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  reviews_in_location?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Teams_Rankings_Stddev_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  reviews_in_location?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Teams_Rankings_Stddev_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  reviews_in_location?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate sum on columns */
export type Teams_Rankings_Sum_Fields = {
  distance?: Maybe<Scalars['float8']['output']>;
  nearby_radius_km?: Maybe<Scalars['float8']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Int']['output']>;
  payment_amount?: Maybe<Scalars['Int']['output']>;
  reviews_in_location?: Maybe<Scalars['Int']['output']>;
  total_transactions?: Maybe<Scalars['Int']['output']>;
  transactions_in_district?: Maybe<Scalars['Int']['output']>;
  transactions_in_location?: Maybe<Scalars['Int']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Int']['output']>;
  transactions_in_radius?: Maybe<Scalars['Int']['output']>;
  transactions_in_state?: Maybe<Scalars['Int']['output']>;
};

/** aggregate var_pop on columns */
export type Teams_Rankings_Var_Pop_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  reviews_in_location?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Teams_Rankings_Var_Samp_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  reviews_in_location?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Teams_Rankings_Variance_Fields = {
  distance?: Maybe<Scalars['Float']['output']>;
  nearby_radius_km?: Maybe<Scalars['Float']['output']>;
  nearby_transaction_count?: Maybe<Scalars['Float']['output']>;
  payment_amount?: Maybe<Scalars['Float']['output']>;
  reviews_in_location?: Maybe<Scalars['Float']['output']>;
  total_transactions?: Maybe<Scalars['Float']['output']>;
  transactions_in_district?: Maybe<Scalars['Float']['output']>;
  transactions_in_location?: Maybe<Scalars['Float']['output']>;
  transactions_in_municipality?: Maybe<Scalars['Float']['output']>;
  transactions_in_radius?: Maybe<Scalars['Float']['output']>;
  transactions_in_state?: Maybe<Scalars['Float']['output']>;
};

/** select columns of table "teams" */
export enum Teams_Select_Column {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  Centroid = 'centroid',
  /** column name */
  CopyReviewsToGoogle = 'copy_reviews_to_google',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CountryId = 'country_id',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  DistrictId = 'district_id',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  EnquiryEmailContact = 'enquiry_email_contact',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  Geom = 'geom',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  Id = 'id',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  IsUnclaimed = 'is_unclaimed',
  /** column name */
  LastReviewScraping = 'last_review_scraping',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LocalityId = 'locality_id',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  LotsMemberAccess = 'lots_member_access',
  /** column name */
  MunicipalityId = 'municipality_id',
  /** column name */
  Name = 'name',
  /** column name */
  NeighbourhoodId = 'neighbourhood_id',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  PostcodeId = 'postcode_id',
  /** column name */
  RegionId = 'region_id',
  /** column name */
  Route = 'route',
  /** column name */
  ShareTransactionsInCma = 'share_transactions_in_cma',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StateId = 'state_id',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  TiktokUrl = 'tiktok_url',
  /** column name */
  TopListings = 'top_listings',
  /** column name */
  Tsv = 'tsv',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  XUrl = 'x_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

/** select "teams_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teams" */
export enum Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CopyReviewsToGoogle = 'copy_reviews_to_google',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  IsUnclaimed = 'is_unclaimed',
  /** column name */
  ShareTransactionsInCma = 'share_transactions_in_cma',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  TopListings = 'top_listings',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails'
}

/** select "teams_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teams" */
export enum Teams_Select_Column_Teams_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CopyReviewsToGoogle = 'copy_reviews_to_google',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  IsUnclaimed = 'is_unclaimed',
  /** column name */
  ShareTransactionsInCma = 'share_transactions_in_cma',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  TopListings = 'top_listings',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails'
}

/** input type for updating data in table "teams" */
export type Teams_Set_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  copy_reviews_to_google?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_email_contact?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  lots_member_access?: InputMaybe<Lots_Member_Access_Enum_Enum>;
  name?: InputMaybe<Scalars['String']['input']>;
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  share_transactions_in_cma?: InputMaybe<Scalars['Boolean']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  /** Show this team's listings at the top of search results in agg-next. */
  top_listings?: InputMaybe<Scalars['Boolean']['input']>;
  use_json_for_enquiry_emails?: InputMaybe<Scalars['Boolean']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  x_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Teams_Stddev_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "teams" */
export type Teams_Stddev_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Stddev_Pop_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "teams" */
export type Teams_Stddev_Pop_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Stddev_Samp_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "teams" */
export type Teams_Stddev_Samp_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams" */
export type Teams_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Stream_Cursor_Value_Input = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agency_slug?: InputMaybe<Scalars['String']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  centroid?: InputMaybe<Scalars['geometry']['input']>;
  copy_reviews_to_google?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  country_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['uuid']['input']>;
  do_follow_link?: InputMaybe<Scalars['Boolean']['input']>;
  enquiry_email_contact?: InputMaybe<Scalars['String']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  geom?: InputMaybe<Scalars['geometry']['input']>;
  google_business_id?: InputMaybe<Scalars['String']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  hide_exact_address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  idx_agency_id?: InputMaybe<Scalars['String']['input']>;
  idx_ftp_client_id?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  is_unclaimed?: InputMaybe<Scalars['Boolean']['input']>;
  last_review_scraping?: InputMaybe<Scalars['timestamptz']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  legal_name?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  listings_agency_names?: InputMaybe<Array<Scalars['String']['input']>>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  locality_id?: InputMaybe<Scalars['uuid']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  lots_member_access?: InputMaybe<Lots_Member_Access_Enum_Enum>;
  municipality_id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  neighbourhood_id?: InputMaybe<Scalars['uuid']['input']>;
  opening_hours?: InputMaybe<Scalars['jsonb']['input']>;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  postcode_id?: InputMaybe<Scalars['uuid']['input']>;
  region_id?: InputMaybe<Scalars['uuid']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  share_transactions_in_cma?: InputMaybe<Scalars['Boolean']['input']>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  state_id?: InputMaybe<Scalars['uuid']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  /** Show this team's listings at the top of search results in agg-next. */
  top_listings?: InputMaybe<Scalars['Boolean']['input']>;
  tsv?: InputMaybe<Scalars['tsvector']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  use_json_for_enquiry_emails?: InputMaybe<Scalars['Boolean']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  x_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Teams_Sum_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "teams" */
export type Teams_Sum_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** update columns of table "teams" */
export enum Teams_Update_Column {
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgencySlug = 'agency_slug',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  CopyReviewsToGoogle = 'copy_reviews_to_google',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CoverPhotoImageId = 'cover_photo_image_id',
  /** column name */
  Description = 'description',
  /** column name */
  DoFollowLink = 'do_follow_link',
  /** column name */
  EnquiryEmailContact = 'enquiry_email_contact',
  /** column name */
  FacebookUrl = 'facebook_url',
  /** column name */
  GoogleBusinessId = 'google_business_id',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  HideExactAddress = 'hide_exact_address',
  /** column name */
  IdxAgencyId = 'idx_agency_id',
  /** column name */
  IdxFtpClientId = 'idx_ftp_client_id',
  /** column name */
  InstagramUrl = 'instagram_url',
  /** column name */
  Lat = 'lat',
  /** column name */
  LegalName = 'legal_name',
  /** column name */
  LinkedinUrl = 'linkedin_url',
  /** column name */
  ListingsAgencyNames = 'listings_agency_names',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  LotsMemberAccess = 'lots_member_access',
  /** column name */
  Name = 'name',
  /** column name */
  OpeningHours = 'opening_hours',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Route = 'route',
  /** column name */
  ShareTransactionsInCma = 'share_transactions_in_cma',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TiktokUrl = 'tiktok_url',
  /** column name */
  TopListings = 'top_listings',
  /** column name */
  UseJsonForEnquiryEmails = 'use_json_for_enquiry_emails',
  /** column name */
  WebsiteUrl = 'website_url',
  /** column name */
  XUrl = 'x_url',
  /** column name */
  YoutubeUrl = 'youtube_url'
}

export type Teams_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Teams_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Teams_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Teams_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Teams_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Teams_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Bool_Exp;
};

/** Membership of a user in a team. is_leader marks a team leader; deactivated = true is a former member. To credit a team with a former member's leads or reviews, keep deactivated rows. */
export type Teams_Users = {
  created_at: Scalars['timestamptz']['output'];
  deactivated: Scalars['Boolean']['output'];
  is_leader: Scalars['Boolean']['output'];
  order_nr: Scalars['Int']['output'];
  /** An object relationship */
  property_transactions?: Maybe<Property_Transactions>;
  /** An object relationship */
  team: Teams;
  team_id: Scalars['uuid']['output'];
  title?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "teams_users" */
export type Teams_Users_Aggregate = {
  aggregate?: Maybe<Teams_Users_Aggregate_Fields>;
  nodes: Array<Teams_Users>;
};

export type Teams_Users_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Teams_Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Teams_Users_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Teams_Users_Aggregate_Bool_Exp_Count>;
};

export type Teams_Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Teams_Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Teams_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Teams_Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "teams_users" */
export type Teams_Users_Aggregate_Fields = {
  avg?: Maybe<Teams_Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Teams_Users_Max_Fields>;
  min?: Maybe<Teams_Users_Min_Fields>;
  stddev?: Maybe<Teams_Users_Stddev_Fields>;
  stddev_pop?: Maybe<Teams_Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Teams_Users_Stddev_Samp_Fields>;
  sum?: Maybe<Teams_Users_Sum_Fields>;
  var_pop?: Maybe<Teams_Users_Var_Pop_Fields>;
  var_samp?: Maybe<Teams_Users_Var_Samp_Fields>;
  variance?: Maybe<Teams_Users_Variance_Fields>;
};


/** aggregate fields of "teams_users" */
export type Teams_Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Teams_Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "teams_users" */
export type Teams_Users_Aggregate_Order_By = {
  avg?: InputMaybe<Teams_Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Teams_Users_Max_Order_By>;
  min?: InputMaybe<Teams_Users_Min_Order_By>;
  stddev?: InputMaybe<Teams_Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Teams_Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Teams_Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Teams_Users_Sum_Order_By>;
  var_pop?: InputMaybe<Teams_Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Teams_Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Teams_Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "teams_users" */
export type Teams_Users_Arr_Rel_Insert_Input = {
  data: Array<Teams_Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Teams_Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Teams_Users_Avg_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "teams_users" */
export type Teams_Users_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "teams_users". All fields are combined with a logical 'AND'. */
export type Teams_Users_Bool_Exp = {
  _and?: InputMaybe<Array<Teams_Users_Bool_Exp>>;
  _not?: InputMaybe<Teams_Users_Bool_Exp>;
  _or?: InputMaybe<Array<Teams_Users_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  deactivated?: InputMaybe<Boolean_Comparison_Exp>;
  is_leader?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  team?: InputMaybe<Teams_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "teams_users" */
export enum Teams_Users_Constraint {
  /** unique or primary key constraint on columns "user_id", "team_id" */
  TeamUsersTeamIdUserIdIdx = 'team_users_team_id_user_id_idx',
  /** unique or primary key constraint on columns "team_id", "order_nr" */
  UcTeamsUsersOrderNrTeamId = 'uc_teams_users_order_nr_team_id'
}

/** input type for incrementing numeric columns in table "teams_users" */
export type Teams_Users_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "teams_users" */
export type Teams_Users_Insert_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  property_transactions?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Teams_Users_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "teams_users" */
export type Teams_Users_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Teams_Users_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "teams_users" */
export type Teams_Users_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "teams_users" */
export type Teams_Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Teams_Users>;
};

/** on_conflict condition type for table "teams_users" */
export type Teams_Users_On_Conflict = {
  constraint: Teams_Users_Constraint;
  update_columns?: Array<Teams_Users_Update_Column>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};

/** Ordering options when selecting data from "teams_users". */
export type Teams_Users_Order_By = {
  created_at?: InputMaybe<Order_By>;
  deactivated?: InputMaybe<Order_By>;
  is_leader?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  property_transactions?: InputMaybe<Property_Transactions_Order_By>;
  team?: InputMaybe<Teams_Order_By>;
  team_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "teams_users" */
export enum Teams_Users_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

/** select "teams_users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "teams_users" */
export enum Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

/** select "teams_users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "teams_users" */
export enum Teams_Users_Select_Column_Teams_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader'
}

/** input type for updating data in table "teams_users" */
export type Teams_Users_Set_Input = {
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  is_leader?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Teams_Users_Stddev_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "teams_users" */
export type Teams_Users_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Teams_Users_Stddev_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "teams_users" */
export type Teams_Users_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Teams_Users_Stddev_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "teams_users" */
export type Teams_Users_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "teams_users" */
export type Teams_Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Teams_Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Teams_Users_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivated?: InputMaybe<Scalars['Boolean']['input']>;
  is_leader?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Teams_Users_Sum_Fields = {
  order_nr?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "teams_users" */
export type Teams_Users_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "teams_users" */
export enum Teams_Users_Update_Column {
  /** column name */
  Deactivated = 'deactivated',
  /** column name */
  IsLeader = 'is_leader',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  Title = 'title'
}

export type Teams_Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Teams_Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Teams_Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Teams_Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Teams_Users_Var_Pop_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "teams_users" */
export type Teams_Users_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Users_Var_Samp_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "teams_users" */
export type Teams_Users_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Users_Variance_Fields = {
  order_nr?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "teams_users" */
export type Teams_Users_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Teams_Var_Pop_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "teams" */
export type Teams_Var_Pop_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Teams_Var_Samp_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "teams" */
export type Teams_Var_Samp_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Teams_Variance_Fields = {
  /** The year when the agency started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "teams" */
export type Teams_Variance_Order_By = {
  /** The year when the agency started operating */
  active_since?: InputMaybe<Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenant_gender_enum" */
export type Tenant_Gender_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "tenant_gender_enum". All fields are combined with a logical 'AND'. */
export type Tenant_Gender_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Tenant_Gender_Enum_Bool_Exp>>;
  _not?: InputMaybe<Tenant_Gender_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Tenant_Gender_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Tenant_Gender_Enum_Enum {
  /** Both */
  Both = 'both',
  /** Female */
  Female = 'female',
  /** Male */
  Male = 'male'
}

/** Boolean expression to compare columns of type "tenant_gender_enum_enum". All fields are combined with logical 'AND'. */
export type Tenant_Gender_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Tenant_Gender_Enum_Enum>;
  _in?: InputMaybe<Array<Tenant_Gender_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Tenant_Gender_Enum_Enum>;
  _nin?: InputMaybe<Array<Tenant_Gender_Enum_Enum>>;
};

/** Ordering options when selecting data from "tenant_gender_enum". */
export type Tenant_Gender_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "tenant_gender_enum" */
export enum Tenant_Gender_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "tenant_gender_enum" */
export type Tenant_Gender_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenant_Gender_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenant_Gender_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A CRM account: one company or network. Every business row carries its tenant_id. */
export type Tenants = {
  activate_land_registry_owners: Scalars['Boolean']['output'];
  activate_model_details: Scalars['Boolean']['output'];
  activate_model_iazi: Scalars['Boolean']['output'];
  activate_model_pricehubble: Scalars['Boolean']['output'];
  activate_model_propertydata: Scalars['Boolean']['output'];
  activate_model_realadvisor_listings: Scalars['Boolean']['output'];
  activate_model_realadvisor_perceived: Scalars['Boolean']['output'];
  activate_model_realadvisor_transactions: Scalars['Boolean']['output'];
  activate_model_wup: Scalars['Boolean']['output'];
  ai_feed_summary_prompt?: Maybe<Scalars['String']['output']>;
  close_api_key?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code: Scalars['String']['output'];
  created_at: Scalars['timestamptz']['output'];
  debug_email_mode: Scalars['Boolean']['output'];
  default_pipeline_id: Scalars['uuid']['output'];
  email_is_verified: Scalars['Boolean']['output'];
  email_sender_email: Scalars['String']['output'];
  email_sender_name: Scalars['String']['output'];
  email_template?: Maybe<Scalars['email_template']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_tag_manager_id: Scalars['String']['output'];
  homepage_url: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image?: Maybe<Images>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality: Scalars['String']['output'];
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  main_color: Scalars['String']['output'];
  mortgage_rates?: Maybe<Scalars['jsonb']['output']>;
  name: Scalars['String']['output'];
  phone_main: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  route: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street_number: Scalars['String']['output'];
  stripe_secret_key?: Maybe<Scalars['String']['output']>;
  stripe_secret_key_test?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret_test?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** A CRM account: one company or network. Every business row carries its tenant_id. */
export type TenantsMortgage_RatesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** A CRM account: one company or network. Every business row carries its tenant_id. */
export type TenantsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** A CRM account: one company or network. Every business row carries its tenant_id. */
export type TenantsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** aggregated selection of "tenants" */
export type Tenants_Aggregate = {
  aggregate?: Maybe<Tenants_Aggregate_Fields>;
  nodes: Array<Tenants>;
};

/** aggregate fields of "tenants" */
export type Tenants_Aggregate_Fields = {
  avg?: Maybe<Tenants_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tenants_Max_Fields>;
  min?: Maybe<Tenants_Min_Fields>;
  stddev?: Maybe<Tenants_Stddev_Fields>;
  stddev_pop?: Maybe<Tenants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenants_Stddev_Samp_Fields>;
  sum?: Maybe<Tenants_Sum_Fields>;
  var_pop?: Maybe<Tenants_Var_Pop_Fields>;
  var_samp?: Maybe<Tenants_Var_Samp_Fields>;
  variance?: Maybe<Tenants_Variance_Fields>;
};


/** aggregate fields of "tenants" */
export type Tenants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Tenants_Avg_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Tenants_Bool_Exp>>;
  _not?: InputMaybe<Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Tenants_Bool_Exp>>;
  activate_land_registry_owners?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_details?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_iazi?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_pricehubble?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_propertydata?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_realadvisor_listings?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_realadvisor_perceived?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_realadvisor_transactions?: InputMaybe<Boolean_Comparison_Exp>;
  activate_model_wup?: InputMaybe<Boolean_Comparison_Exp>;
  ai_feed_summary_prompt?: InputMaybe<String_Comparison_Exp>;
  close_api_key?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  country_code?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  debug_email_mode?: InputMaybe<Boolean_Comparison_Exp>;
  default_pipeline_id?: InputMaybe<Uuid_Comparison_Exp>;
  email_is_verified?: InputMaybe<Boolean_Comparison_Exp>;
  email_sender_email?: InputMaybe<String_Comparison_Exp>;
  email_sender_name?: InputMaybe<String_Comparison_Exp>;
  email_template?: InputMaybe<Email_Template_Comparison_Exp>;
  google_place_description?: InputMaybe<String_Comparison_Exp>;
  google_place_id?: InputMaybe<String_Comparison_Exp>;
  google_tag_manager_id?: InputMaybe<String_Comparison_Exp>;
  homepage_url?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  lat?: InputMaybe<Float_Comparison_Exp>;
  lng?: InputMaybe<Float_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  logo_image_id?: InputMaybe<Uuid_Comparison_Exp>;
  main_color?: InputMaybe<String_Comparison_Exp>;
  mortgage_rates?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_main?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  slug?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  stripe_secret_key?: InputMaybe<String_Comparison_Exp>;
  stripe_secret_key_test?: InputMaybe<String_Comparison_Exp>;
  stripe_webhook_secret?: InputMaybe<String_Comparison_Exp>;
  stripe_webhook_secret_test?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** input type for incrementing numeric columns in table "tenants" */
export type Tenants_Inc_Input = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

/** aggregate max on columns */
export type Tenants_Max_Fields = {
  ai_feed_summary_prompt?: Maybe<Scalars['String']['output']>;
  close_api_key?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_pipeline_id?: Maybe<Scalars['uuid']['output']>;
  email_sender_email?: Maybe<Scalars['String']['output']>;
  email_sender_name?: Maybe<Scalars['String']['output']>;
  email_template?: Maybe<Scalars['email_template']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_tag_manager_id?: Maybe<Scalars['String']['output']>;
  homepage_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  main_color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_main?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  stripe_secret_key?: Maybe<Scalars['String']['output']>;
  stripe_secret_key_test?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret_test?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Tenants_Min_Fields = {
  ai_feed_summary_prompt?: Maybe<Scalars['String']['output']>;
  close_api_key?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_code?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  default_pipeline_id?: Maybe<Scalars['uuid']['output']>;
  email_sender_email?: Maybe<Scalars['String']['output']>;
  email_sender_name?: Maybe<Scalars['String']['output']>;
  email_template?: Maybe<Scalars['email_template']['output']>;
  google_place_description?: Maybe<Scalars['String']['output']>;
  google_place_id?: Maybe<Scalars['String']['output']>;
  google_tag_manager_id?: Maybe<Scalars['String']['output']>;
  homepage_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  logo_image_id?: Maybe<Scalars['uuid']['output']>;
  main_color?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_main?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  stripe_secret_key?: Maybe<Scalars['String']['output']>;
  stripe_secret_key_test?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret?: Maybe<Scalars['String']['output']>;
  stripe_webhook_secret_test?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "tenants" */
export type Tenants_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenants>;
};

/** Ordering options when selecting data from "tenants". */
export type Tenants_Order_By = {
  activate_land_registry_owners?: InputMaybe<Order_By>;
  activate_model_details?: InputMaybe<Order_By>;
  activate_model_iazi?: InputMaybe<Order_By>;
  activate_model_pricehubble?: InputMaybe<Order_By>;
  activate_model_propertydata?: InputMaybe<Order_By>;
  activate_model_realadvisor_listings?: InputMaybe<Order_By>;
  activate_model_realadvisor_perceived?: InputMaybe<Order_By>;
  activate_model_realadvisor_transactions?: InputMaybe<Order_By>;
  activate_model_wup?: InputMaybe<Order_By>;
  ai_feed_summary_prompt?: InputMaybe<Order_By>;
  close_api_key?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  country_code?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  debug_email_mode?: InputMaybe<Order_By>;
  default_pipeline_id?: InputMaybe<Order_By>;
  email_is_verified?: InputMaybe<Order_By>;
  email_sender_email?: InputMaybe<Order_By>;
  email_sender_name?: InputMaybe<Order_By>;
  email_template?: InputMaybe<Order_By>;
  google_place_description?: InputMaybe<Order_By>;
  google_place_id?: InputMaybe<Order_By>;
  google_tag_manager_id?: InputMaybe<Order_By>;
  homepage_url?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  lat?: InputMaybe<Order_By>;
  lng?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  logo_image_id?: InputMaybe<Order_By>;
  main_color?: InputMaybe<Order_By>;
  mortgage_rates?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_main?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  slug?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  stripe_secret_key?: InputMaybe<Order_By>;
  stripe_secret_key_test?: InputMaybe<Order_By>;
  stripe_webhook_secret?: InputMaybe<Order_By>;
  stripe_webhook_secret_test?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: tenants */
export type Tenants_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenants" */
export enum Tenants_Select_Column {
  /** column name */
  ActivateLandRegistryOwners = 'activate_land_registry_owners',
  /** column name */
  ActivateModelDetails = 'activate_model_details',
  /** column name */
  ActivateModelIazi = 'activate_model_iazi',
  /** column name */
  ActivateModelPricehubble = 'activate_model_pricehubble',
  /** column name */
  ActivateModelPropertydata = 'activate_model_propertydata',
  /** column name */
  ActivateModelRealadvisorListings = 'activate_model_realadvisor_listings',
  /** column name */
  ActivateModelRealadvisorPerceived = 'activate_model_realadvisor_perceived',
  /** column name */
  ActivateModelRealadvisorTransactions = 'activate_model_realadvisor_transactions',
  /** column name */
  ActivateModelWup = 'activate_model_wup',
  /** column name */
  AiFeedSummaryPrompt = 'ai_feed_summary_prompt',
  /** column name */
  CloseApiKey = 'close_api_key',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'country_code',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DebugEmailMode = 'debug_email_mode',
  /** column name */
  DefaultPipelineId = 'default_pipeline_id',
  /** column name */
  EmailIsVerified = 'email_is_verified',
  /** column name */
  EmailSenderEmail = 'email_sender_email',
  /** column name */
  EmailSenderName = 'email_sender_name',
  /** column name */
  EmailTemplate = 'email_template',
  /** column name */
  GooglePlaceDescription = 'google_place_description',
  /** column name */
  GooglePlaceId = 'google_place_id',
  /** column name */
  GoogleTagManagerId = 'google_tag_manager_id',
  /** column name */
  HomepageUrl = 'homepage_url',
  /** column name */
  Id = 'id',
  /** column name */
  Lat = 'lat',
  /** column name */
  Lng = 'lng',
  /** column name */
  Locality = 'locality',
  /** column name */
  LogoImageId = 'logo_image_id',
  /** column name */
  MainColor = 'main_color',
  /** column name */
  MortgageRates = 'mortgage_rates',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneMain = 'phone_main',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Route = 'route',
  /** column name */
  Slug = 'slug',
  /** column name */
  State = 'state',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  StripeSecretKey = 'stripe_secret_key',
  /** column name */
  StripeSecretKeyTest = 'stripe_secret_key_test',
  /** column name */
  StripeWebhookSecret = 'stripe_webhook_secret',
  /** column name */
  StripeWebhookSecretTest = 'stripe_webhook_secret_test',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "tenants" */
export type Tenants_Set_Input = {
  ai_feed_summary_prompt?: InputMaybe<Scalars['String']['input']>;
  close_api_key?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  debug_email_mode?: InputMaybe<Scalars['Boolean']['input']>;
  default_pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  email_sender_email?: InputMaybe<Scalars['String']['input']>;
  email_sender_name?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['email_template']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_tag_manager_id?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  main_color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_main?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key_test?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret_test?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Tenants_Stddev_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Tenants_Stddev_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Tenants_Stddev_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "tenants" */
export type Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenants_Stream_Cursor_Value_Input = {
  activate_land_registry_owners?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_details?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_iazi?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_pricehubble?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_propertydata?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_listings?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_perceived?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_realadvisor_transactions?: InputMaybe<Scalars['Boolean']['input']>;
  activate_model_wup?: InputMaybe<Scalars['Boolean']['input']>;
  ai_feed_summary_prompt?: InputMaybe<Scalars['String']['input']>;
  close_api_key?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  debug_email_mode?: InputMaybe<Scalars['Boolean']['input']>;
  default_pipeline_id?: InputMaybe<Scalars['uuid']['input']>;
  email_is_verified?: InputMaybe<Scalars['Boolean']['input']>;
  email_sender_email?: InputMaybe<Scalars['String']['input']>;
  email_sender_name?: InputMaybe<Scalars['String']['input']>;
  email_template?: InputMaybe<Scalars['email_template']['input']>;
  google_place_description?: InputMaybe<Scalars['String']['input']>;
  google_place_id?: InputMaybe<Scalars['String']['input']>;
  google_tag_manager_id?: InputMaybe<Scalars['String']['input']>;
  homepage_url?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  main_color?: InputMaybe<Scalars['String']['input']>;
  mortgage_rates?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_main?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key?: InputMaybe<Scalars['String']['input']>;
  stripe_secret_key_test?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret?: InputMaybe<Scalars['String']['input']>;
  stripe_webhook_secret_test?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Tenants_Sum_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type Tenants_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenants_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenants_Var_Pop_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Tenants_Var_Samp_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Tenants_Variance_Fields = {
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "third_pillar_organisation_type_a". All fields are combined with logical 'AND'. */
export type Third_Pillar_Organisation_Type_A_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_a']['input']>>;
};

/** Boolean expression to compare columns of type "third_pillar_organisation_type_b". All fields are combined with logical 'AND'. */
export type Third_Pillar_Organisation_Type_B_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _gte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _in?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _lte?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _neq?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  _nin?: InputMaybe<Array<Scalars['third_pillar_organisation_type_b']['input']>>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** The buyers of a recorded deal: one row per buyer (user_id -> users) of a property_transactions row (transaction_id). */
export type Transaction_Buyers = {
  /** An object relationship */
  property_transaction: Property_Transactions;
  transaction_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "transaction_buyers" */
export type Transaction_Buyers_Aggregate = {
  aggregate?: Maybe<Transaction_Buyers_Aggregate_Fields>;
  nodes: Array<Transaction_Buyers>;
};

export type Transaction_Buyers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Transaction_Buyers_Aggregate_Bool_Exp_Count>;
};

export type Transaction_Buyers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Buyers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transaction_buyers" */
export type Transaction_Buyers_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Buyers_Max_Fields>;
  min?: Maybe<Transaction_Buyers_Min_Fields>;
};


/** aggregate fields of "transaction_buyers" */
export type Transaction_Buyers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Buyers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transaction_buyers" */
export type Transaction_Buyers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Buyers_Max_Order_By>;
  min?: InputMaybe<Transaction_Buyers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "transaction_buyers" */
export type Transaction_Buyers_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Buyers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transaction_Buyers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "transaction_buyers". All fields are combined with a logical 'AND'. */
export type Transaction_Buyers_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Buyers_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Buyers_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Buyers_Bool_Exp>>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "transaction_buyers" */
export enum Transaction_Buyers_Constraint {
  /** unique or primary key constraint on columns "user_id", "transaction_id" */
  TransactionBuyersPkey = 'transaction_buyers_pkey',
  /** unique or primary key constraint on columns "user_id", "transaction_id" */
  TransactionBuyersTransactionIdUserIdUnique = 'transaction_buyers_transaction_id_user_id_unique'
}

/** input type for inserting data into table "transaction_buyers" */
export type Transaction_Buyers_Insert_Input = {
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Transaction_Buyers_Max_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transaction_buyers" */
export type Transaction_Buyers_Max_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Buyers_Min_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transaction_buyers" */
export type Transaction_Buyers_Min_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transaction_buyers" */
export type Transaction_Buyers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction_Buyers>;
};

/** on_conflict condition type for table "transaction_buyers" */
export type Transaction_Buyers_On_Conflict = {
  constraint: Transaction_Buyers_Constraint;
  update_columns?: Array<Transaction_Buyers_Update_Column>;
  where?: InputMaybe<Transaction_Buyers_Bool_Exp>;
};

/** Ordering options when selecting data from "transaction_buyers". */
export type Transaction_Buyers_Order_By = {
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "transaction_buyers" */
export enum Transaction_Buyers_Select_Column {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

/** placeholder for update columns of table "transaction_buyers" (current role has no relevant permissions) */
export enum Transaction_Buyers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** The sellers of a recorded deal: one row per seller (user_id -> users) of a property_transactions row (transaction_id). */
export type Transaction_Sellers = {
  /** An object relationship */
  property_transaction: Property_Transactions;
  transaction_id: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "transaction_sellers" */
export type Transaction_Sellers_Aggregate = {
  aggregate?: Maybe<Transaction_Sellers_Aggregate_Fields>;
  nodes: Array<Transaction_Sellers>;
};

export type Transaction_Sellers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Transaction_Sellers_Aggregate_Bool_Exp_Count>;
};

export type Transaction_Sellers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Sellers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transaction_sellers" */
export type Transaction_Sellers_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Sellers_Max_Fields>;
  min?: Maybe<Transaction_Sellers_Min_Fields>;
};


/** aggregate fields of "transaction_sellers" */
export type Transaction_Sellers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Sellers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transaction_sellers" */
export type Transaction_Sellers_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Sellers_Max_Order_By>;
  min?: InputMaybe<Transaction_Sellers_Min_Order_By>;
};

/** input type for inserting array relation for remote table "transaction_sellers" */
export type Transaction_Sellers_Arr_Rel_Insert_Input = {
  data: Array<Transaction_Sellers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Transaction_Sellers_On_Conflict>;
};

/** Boolean expression to filter rows from the table "transaction_sellers". All fields are combined with a logical 'AND'. */
export type Transaction_Sellers_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Sellers_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Sellers_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Sellers_Bool_Exp>>;
  property_transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "transaction_sellers" */
export enum Transaction_Sellers_Constraint {
  /** unique or primary key constraint on columns "user_id", "transaction_id" */
  TransactionSellersPkey = 'transaction_sellers_pkey',
  /** unique or primary key constraint on columns "user_id", "transaction_id" */
  TransactionSellersTransactionIdUserIdUnique = 'transaction_sellers_transaction_id_user_id_unique'
}

/** input type for inserting data into table "transaction_sellers" */
export type Transaction_Sellers_Insert_Input = {
  property_transaction?: InputMaybe<Property_Transactions_Obj_Rel_Insert_Input>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Transaction_Sellers_Max_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transaction_sellers" */
export type Transaction_Sellers_Max_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Sellers_Min_Fields = {
  transaction_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transaction_sellers" */
export type Transaction_Sellers_Min_Order_By = {
  transaction_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "transaction_sellers" */
export type Transaction_Sellers_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Transaction_Sellers>;
};

/** on_conflict condition type for table "transaction_sellers" */
export type Transaction_Sellers_On_Conflict = {
  constraint: Transaction_Sellers_Constraint;
  update_columns?: Array<Transaction_Sellers_Update_Column>;
  where?: InputMaybe<Transaction_Sellers_Bool_Exp>;
};

/** Ordering options when selecting data from "transaction_sellers". */
export type Transaction_Sellers_Order_By = {
  property_transaction?: InputMaybe<Property_Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "transaction_sellers" */
export enum Transaction_Sellers_Select_Column {
  /** column name */
  TransactionId = 'transaction_id',
  /** column name */
  UserId = 'user_id'
}

/** placeholder for update columns of table "transaction_sellers" (current role has no relevant permissions) */
export enum Transaction_Sellers_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/**
 * Matches property transactions with lead valuations based on property address (route, street_number, postcode, locality).
 * Includes latest appraisal values for each lead property.
 * Used by TransactionAnalysis component to show valuations for a specific transaction address.
 */
export type Transaction_Valuations = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  transaction?: Maybe<Property_Transactions>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "transaction_valuations" */
export type Transaction_Valuations_Aggregate = {
  aggregate?: Maybe<Transaction_Valuations_Aggregate_Fields>;
  nodes: Array<Transaction_Valuations>;
};

export type Transaction_Valuations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Transaction_Valuations_Aggregate_Bool_Exp_Count>;
};

export type Transaction_Valuations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Transaction_Valuations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "transaction_valuations" */
export type Transaction_Valuations_Aggregate_Fields = {
  avg?: Maybe<Transaction_Valuations_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Transaction_Valuations_Max_Fields>;
  min?: Maybe<Transaction_Valuations_Min_Fields>;
  stddev?: Maybe<Transaction_Valuations_Stddev_Fields>;
  stddev_pop?: Maybe<Transaction_Valuations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Transaction_Valuations_Stddev_Samp_Fields>;
  sum?: Maybe<Transaction_Valuations_Sum_Fields>;
  var_pop?: Maybe<Transaction_Valuations_Var_Pop_Fields>;
  var_samp?: Maybe<Transaction_Valuations_Var_Samp_Fields>;
  variance?: Maybe<Transaction_Valuations_Variance_Fields>;
};


/** aggregate fields of "transaction_valuations" */
export type Transaction_Valuations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Transaction_Valuations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "transaction_valuations" */
export type Transaction_Valuations_Aggregate_Order_By = {
  avg?: InputMaybe<Transaction_Valuations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Transaction_Valuations_Max_Order_By>;
  min?: InputMaybe<Transaction_Valuations_Min_Order_By>;
  stddev?: InputMaybe<Transaction_Valuations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Transaction_Valuations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Transaction_Valuations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Transaction_Valuations_Sum_Order_By>;
  var_pop?: InputMaybe<Transaction_Valuations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Transaction_Valuations_Var_Samp_Order_By>;
  variance?: InputMaybe<Transaction_Valuations_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Transaction_Valuations_Avg_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Avg_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "transaction_valuations". All fields are combined with a logical 'AND'. */
export type Transaction_Valuations_Bool_Exp = {
  _and?: InputMaybe<Array<Transaction_Valuations_Bool_Exp>>;
  _not?: InputMaybe<Transaction_Valuations_Bool_Exp>;
  _or?: InputMaybe<Array<Transaction_Valuations_Bool_Exp>>;
  appraisal_max?: InputMaybe<Float_Comparison_Exp>;
  appraisal_min?: InputMaybe<Float_Comparison_Exp>;
  appraisal_perceived_value?: InputMaybe<Float_Comparison_Exp>;
  appraisal_perception?: InputMaybe<String_Comparison_Exp>;
  appraisal_reason?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  locality?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  requalified_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  route?: InputMaybe<String_Comparison_Exp>;
  street_number?: InputMaybe<String_Comparison_Exp>;
  transaction?: InputMaybe<Property_Transactions_Bool_Exp>;
  transaction_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Transaction_Valuations_Max_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Max_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_reason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Transaction_Valuations_Min_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
  appraisal_perception?: Maybe<Scalars['String']['output']>;
  appraisal_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  requalified_at?: Maybe<Scalars['timestamptz']['output']>;
  route?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
  transaction_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Min_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_reason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_id?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "transaction_valuations". */
export type Transaction_Valuations_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
  appraisal_perception?: InputMaybe<Order_By>;
  appraisal_reason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  locality?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  requalified_at?: InputMaybe<Order_By>;
  route?: InputMaybe<Order_By>;
  street_number?: InputMaybe<Order_By>;
  transaction?: InputMaybe<Property_Transactions_Order_By>;
  transaction_id?: InputMaybe<Order_By>;
};

/** select columns of table "transaction_valuations" */
export enum Transaction_Valuations_Select_Column {
  /** column name */
  AppraisalMax = 'appraisal_max',
  /** column name */
  AppraisalMin = 'appraisal_min',
  /** column name */
  AppraisalPerceivedValue = 'appraisal_perceived_value',
  /** column name */
  AppraisalPerception = 'appraisal_perception',
  /** column name */
  AppraisalReason = 'appraisal_reason',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  Locality = 'locality',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  RequalifiedAt = 'requalified_at',
  /** column name */
  Route = 'route',
  /** column name */
  StreetNumber = 'street_number',
  /** column name */
  TransactionId = 'transaction_id'
}

/** aggregate stddev on columns */
export type Transaction_Valuations_Stddev_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Stddev_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Transaction_Valuations_Stddev_Pop_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Stddev_Pop_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Transaction_Valuations_Stddev_Samp_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Stddev_Samp_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "transaction_valuations" */
export type Transaction_Valuations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Transaction_Valuations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Transaction_Valuations_Stream_Cursor_Value_Input = {
  appraisal_max?: InputMaybe<Scalars['Float']['input']>;
  appraisal_min?: InputMaybe<Scalars['Float']['input']>;
  appraisal_perceived_value?: InputMaybe<Scalars['Float']['input']>;
  appraisal_perception?: InputMaybe<Scalars['String']['input']>;
  appraisal_reason?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  requalified_at?: InputMaybe<Scalars['timestamptz']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  transaction_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Transaction_Valuations_Sum_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by sum() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Sum_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Transaction_Valuations_Var_Pop_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Var_Pop_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Transaction_Valuations_Var_Samp_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Var_Samp_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Transaction_Valuations_Variance_Fields = {
  appraisal_max?: Maybe<Scalars['Float']['output']>;
  appraisal_min?: Maybe<Scalars['Float']['output']>;
  appraisal_perceived_value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "transaction_valuations" */
export type Transaction_Valuations_Variance_Order_By = {
  appraisal_max?: InputMaybe<Order_By>;
  appraisal_min?: InputMaybe<Order_By>;
  appraisal_perceived_value?: InputMaybe<Order_By>;
};

/** columns and relationships of "translated_enums" */
export type Translated_Enums = {
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "translated_enums". All fields are combined with a logical 'AND'. */
export type Translated_Enums_Bool_Exp = {
  _and?: InputMaybe<Array<Translated_Enums_Bool_Exp>>;
  _not?: InputMaybe<Translated_Enums_Bool_Exp>;
  _or?: InputMaybe<Array<Translated_Enums_Bool_Exp>>;
  label?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "translated_enums". */
export type Translated_Enums_Order_By = {
  label?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "translated_enums" */
export enum Translated_Enums_Select_Column {
  /** column name */
  Label = 'label',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "translated_enums" */
export type Translated_Enums_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Translated_Enums_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Translated_Enums_Stream_Cursor_Value_Input = {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum Travel_Modes_Enum_Enum {
  Cycling = 'cycling',
  Driving = 'driving',
  Walking = 'walking'
}

/** Boolean expression to compare columns of type "travel_modes_enum_enum". All fields are combined with logical 'AND'. */
export type Travel_Modes_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Travel_Modes_Enum_Enum>;
  _in?: InputMaybe<Array<Travel_Modes_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Travel_Modes_Enum_Enum>;
  _nin?: InputMaybe<Array<Travel_Modes_Enum_Enum>>;
};

/** Boolean expression to compare columns of type "tsvector". All fields are combined with logical 'AND'. */
export type Tsvector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['tsvector']['input']>;
  _gt?: InputMaybe<Scalars['tsvector']['input']>;
  _gte?: InputMaybe<Scalars['tsvector']['input']>;
  _in?: InputMaybe<Array<Scalars['tsvector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['tsvector']['input']>;
  _lte?: InputMaybe<Scalars['tsvector']['input']>;
  _neq?: InputMaybe<Scalars['tsvector']['input']>;
  _nin?: InputMaybe<Array<Scalars['tsvector']['input']>>;
};

export type Upsert_Mls_Share_Criteria_Args = {
  filters?: InputMaybe<Scalars['jsonb']['input']>;
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "user_images" */
export type User_Images = {
  id: Scalars['uuid']['output'];
  /** An object relationship */
  image: Images;
  image_id: Scalars['uuid']['output'];
  is_primary?: Maybe<Scalars['Boolean']['output']>;
  order_nr?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_images" */
export type User_Images_Aggregate_Order_By = {
  avg?: InputMaybe<User_Images_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Images_Max_Order_By>;
  min?: InputMaybe<User_Images_Min_Order_By>;
  stddev?: InputMaybe<User_Images_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Images_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Images_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Images_Sum_Order_By>;
  var_pop?: InputMaybe<User_Images_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Images_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Images_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_images" */
export type User_Images_Arr_Rel_Insert_Input = {
  data: Array<User_Images_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Images_On_Conflict>;
};

/** order by avg() on columns of table "user_images" */
export type User_Images_Avg_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_images". All fields are combined with a logical 'AND'. */
export type User_Images_Bool_Exp = {
  _and?: InputMaybe<Array<User_Images_Bool_Exp>>;
  _not?: InputMaybe<User_Images_Bool_Exp>;
  _or?: InputMaybe<Array<User_Images_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  image?: InputMaybe<Images_Bool_Exp>;
  image_id?: InputMaybe<Uuid_Comparison_Exp>;
  is_primary?: InputMaybe<Boolean_Comparison_Exp>;
  order_nr?: InputMaybe<Int_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_images" */
export enum User_Images_Constraint {
  /** unique or primary key constraint on columns "user_id", "is_primary" */
  IdxUserImagesUserIdIsPrimary = 'idx_user_images_user_id_is_primary',
  /** unique or primary key constraint on columns "id" */
  UserImagesIdKey = 'user_images_id_key',
  /** unique or primary key constraint on columns "id" */
  UserImagesPkey = 'user_images_pkey',
  /** unique or primary key constraint on columns "user_id", "image_id" */
  UserImagesUserIdImageIdUnique = 'user_images_user_id_image_id_unique'
}

/** input type for incrementing numeric columns in table "user_images" */
export type User_Images_Inc_Input = {
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_images" */
export type User_Images_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image?: InputMaybe<Images_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "user_images" */
export type User_Images_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_images" */
export type User_Images_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_images" */
export type User_Images_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Images>;
};

/** on_conflict condition type for table "user_images" */
export type User_Images_On_Conflict = {
  constraint: User_Images_Constraint;
  update_columns?: Array<User_Images_Update_Column>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};

/** Ordering options when selecting data from "user_images". */
export type User_Images_Order_By = {
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Images_Order_By>;
  image_id?: InputMaybe<Order_By>;
  is_primary?: InputMaybe<Order_By>;
  order_nr?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_images */
export type User_Images_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_images" */
export enum User_Images_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_images" */
export type User_Images_Set_Input = {
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
};

/** order by stddev() on columns of table "user_images" */
export type User_Images_Stddev_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_images" */
export type User_Images_Stddev_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_images" */
export type User_Images_Stddev_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_images" */
export type User_Images_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Images_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Images_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  image_id?: InputMaybe<Scalars['uuid']['input']>;
  is_primary?: InputMaybe<Scalars['Boolean']['input']>;
  order_nr?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by sum() on columns of table "user_images" */
export type User_Images_Sum_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** update columns of table "user_images" */
export enum User_Images_Update_Column {
  /** column name */
  IsPrimary = 'is_primary',
  /** column name */
  OrderNr = 'order_nr'
}

export type User_Images_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Images_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Images_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Images_Bool_Exp;
};

/** order by var_pop() on columns of table "user_images" */
export type User_Images_Var_Pop_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_images" */
export type User_Images_Var_Samp_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_images" */
export type User_Images_Variance_Order_By = {
  order_nr?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "user_language". All fields are combined with logical 'AND'. */
export type User_Language_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_language']['input']>;
  _gt?: InputMaybe<Scalars['user_language']['input']>;
  _gte?: InputMaybe<Scalars['user_language']['input']>;
  _in?: InputMaybe<Array<Scalars['user_language']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_language']['input']>;
  _lte?: InputMaybe<Scalars['user_language']['input']>;
  _neq?: InputMaybe<Scalars['user_language']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_language']['input']>>;
};

/** Current module access. Each insert and delete is recorded as a module_granted or module_revoked activity by trigger. */
export type User_Modules = {
  granted_at?: Maybe<Scalars['timestamptz']['output']>;
  granted_by?: Maybe<Scalars['uuid']['output']>;
  module_id: Modules_Enum_Enum;
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_modules" */
export type User_Modules_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Modules_Max_Order_By>;
  min?: InputMaybe<User_Modules_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_modules". All fields are combined with a logical 'AND'. */
export type User_Modules_Bool_Exp = {
  _and?: InputMaybe<Array<User_Modules_Bool_Exp>>;
  _not?: InputMaybe<User_Modules_Bool_Exp>;
  _or?: InputMaybe<Array<User_Modules_Bool_Exp>>;
  granted_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  granted_by?: InputMaybe<Uuid_Comparison_Exp>;
  module_id?: InputMaybe<Modules_Enum_Enum_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** order by max() on columns of table "user_modules" */
export type User_Modules_Max_Order_By = {
  granted_at?: InputMaybe<Order_By>;
  granted_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_modules" */
export type User_Modules_Min_Order_By = {
  granted_at?: InputMaybe<Order_By>;
  granted_by?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "user_modules". */
export type User_Modules_Order_By = {
  granted_at?: InputMaybe<Order_By>;
  granted_by?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "user_modules" */
export enum User_Modules_Select_Column {
  /** column name */
  GrantedAt = 'granted_at',
  /** column name */
  GrantedBy = 'granted_by',
  /** column name */
  ModuleId = 'module_id',
  /** column name */
  UserId = 'user_id'
}

/** columns and relationships of "user_notification_preferences" */
export type User_Notification_Preferences = {
  created_at: Scalars['timestamptz']['output'];
  email_enabled?: Maybe<Scalars['Boolean']['output']>;
  push_enabled?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  setting?: Maybe<Notification_Settings>;
  sms_enabled?: Maybe<Scalars['Boolean']['output']>;
  team_leader_cc_enabled?: Maybe<Scalars['Boolean']['output']>;
  type: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_notification_preferences" */
export type User_Notification_Preferences_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Notification_Preferences_Max_Order_By>;
  min?: InputMaybe<User_Notification_Preferences_Min_Order_By>;
};

/** input type for inserting array relation for remote table "user_notification_preferences" */
export type User_Notification_Preferences_Arr_Rel_Insert_Input = {
  data: Array<User_Notification_Preferences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Notification_Preferences_On_Conflict>;
};

/** Boolean expression to filter rows from the table "user_notification_preferences". All fields are combined with a logical 'AND'. */
export type User_Notification_Preferences_Bool_Exp = {
  _and?: InputMaybe<Array<User_Notification_Preferences_Bool_Exp>>;
  _not?: InputMaybe<User_Notification_Preferences_Bool_Exp>;
  _or?: InputMaybe<Array<User_Notification_Preferences_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  push_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  setting?: InputMaybe<Notification_Settings_Bool_Exp>;
  sms_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  team_leader_cc_enabled?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_notification_preferences" */
export enum User_Notification_Preferences_Constraint {
  /** unique or primary key constraint on columns "user_id", "type" */
  UserNotificationPreferencesPkey = 'user_notification_preferences_pkey'
}

/** input type for inserting data into table "user_notification_preferences" */
export type User_Notification_Preferences_Insert_Input = {
  email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  push_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  setting?: InputMaybe<Notification_Settings_Obj_Rel_Insert_Input>;
  sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "user_notification_preferences" */
export type User_Notification_Preferences_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_notification_preferences" */
export type User_Notification_Preferences_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_notification_preferences" */
export type User_Notification_Preferences_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Notification_Preferences>;
};

/** on_conflict condition type for table "user_notification_preferences" */
export type User_Notification_Preferences_On_Conflict = {
  constraint: User_Notification_Preferences_Constraint;
  update_columns?: Array<User_Notification_Preferences_Update_Column>;
  where?: InputMaybe<User_Notification_Preferences_Bool_Exp>;
};

/** Ordering options when selecting data from "user_notification_preferences". */
export type User_Notification_Preferences_Order_By = {
  created_at?: InputMaybe<Order_By>;
  email_enabled?: InputMaybe<Order_By>;
  push_enabled?: InputMaybe<Order_By>;
  setting?: InputMaybe<Notification_Settings_Order_By>;
  sms_enabled?: InputMaybe<Order_By>;
  team_leader_cc_enabled?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_notification_preferences */
export type User_Notification_Preferences_Pk_Columns_Input = {
  type: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "user_notification_preferences" */
export enum User_Notification_Preferences_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EmailEnabled = 'email_enabled',
  /** column name */
  PushEnabled = 'push_enabled',
  /** column name */
  SmsEnabled = 'sms_enabled',
  /** column name */
  TeamLeaderCcEnabled = 'team_leader_cc_enabled',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_notification_preferences" */
export type User_Notification_Preferences_Set_Input = {
  email_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  push_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  sms_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  team_leader_cc_enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "user_notification_preferences" */
export enum User_Notification_Preferences_Update_Column {
  /** column name */
  EmailEnabled = 'email_enabled',
  /** column name */
  PushEnabled = 'push_enabled',
  /** column name */
  SmsEnabled = 'sms_enabled',
  /** column name */
  TeamLeaderCcEnabled = 'team_leader_cc_enabled'
}

export type User_Notification_Preferences_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Notification_Preferences_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Notification_Preferences_Bool_Exp;
};

/** columns and relationships of "user_onboarding_skip_reason_enum" */
export type User_Onboarding_Skip_Reason_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "user_onboarding_skip_reason_enum". All fields are combined with a logical 'AND'. */
export type User_Onboarding_Skip_Reason_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Bool_Exp>>;
  _not?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum User_Onboarding_Skip_Reason_Enum_Enum {
  /** A CSM built the agent's profile */
  BuiltByCsm = 'built_by_csm',
  /** The agent only uses the CRM and is not to be published */
  CrmAccessOnly = 'crm_access_only',
  /** The agent was already a client before self-onboarding */
  ExistingClient = 'existing_client',
  /** Any other reason */
  Other = 'other'
}

/** Boolean expression to compare columns of type "user_onboarding_skip_reason_enum_enum". All fields are combined with logical 'AND'. */
export type User_Onboarding_Skip_Reason_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Enum>;
  _in?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Enum>;
  _nin?: InputMaybe<Array<User_Onboarding_Skip_Reason_Enum_Enum>>;
};

/** Ordering options when selecting data from "user_onboarding_skip_reason_enum". */
export type User_Onboarding_Skip_Reason_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "user_onboarding_skip_reason_enum" */
export enum User_Onboarding_Skip_Reason_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "user_onboarding_skip_reason_enum" */
export type User_Onboarding_Skip_Reason_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Onboarding_Skip_Reason_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Onboarding_Skip_Reason_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "user_onboarding_status_enum" */
export type User_Onboarding_Status_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "user_onboarding_status_enum". All fields are combined with a logical 'AND'. */
export type User_Onboarding_Status_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<User_Onboarding_Status_Enum_Bool_Exp>>;
  _not?: InputMaybe<User_Onboarding_Status_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<User_Onboarding_Status_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum User_Onboarding_Status_Enum_Enum {
  /** The invited agent onboarding has been approved */
  Approved = 'approved',
  /** The invited agent has started onboarding */
  InProgress = 'in_progress',
  /** The invited agent completed onboarding and is waiting for review */
  PendingReview = 'pending_review'
}

/** Boolean expression to compare columns of type "user_onboarding_status_enum_enum". All fields are combined with logical 'AND'. */
export type User_Onboarding_Status_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Onboarding_Status_Enum_Enum>;
  _in?: InputMaybe<Array<User_Onboarding_Status_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<User_Onboarding_Status_Enum_Enum>;
  _nin?: InputMaybe<Array<User_Onboarding_Status_Enum_Enum>>;
};

/** Ordering options when selecting data from "user_onboarding_status_enum". */
export type User_Onboarding_Status_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "user_onboarding_status_enum" */
export enum User_Onboarding_Status_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "user_onboarding_status_enum" */
export type User_Onboarding_Status_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Onboarding_Status_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Onboarding_Status_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type User_Primary_Phone_Args = {
  user_row?: InputMaybe<Scalars['users_scalar']['input']>;
};

/** Per user: release entries seen, guided tours and adoption campaigns (CRM product updates). */
export type User_Product_Experiences = {
  dismiss_count: Scalars['smallint']['output'];
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  /** Release: first seen. Tour: first started. Campaign: first reached the user (shown or held out). */
  first_seen_at: Scalars['timestamptz']['output'];
  /** Campaigns: true when the user is in the comparison group and never sees it. */
  holdout?: Maybe<Scalars['Boolean']['output']>;
  /** Release entry id (content/releases/<key>), tour id (tourRegistry.ts) or campaign id (campaignRegistry.ts). */
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: Maybe<Scalars['smallint']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  outcome_at?: Maybe<Scalars['timestamptz']['output']>;
  step_count?: Maybe<Scalars['smallint']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  user_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "user_product_experiences" */
export type User_Product_Experiences_Aggregate_Order_By = {
  avg?: InputMaybe<User_Product_Experiences_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Product_Experiences_Max_Order_By>;
  min?: InputMaybe<User_Product_Experiences_Min_Order_By>;
  stddev?: InputMaybe<User_Product_Experiences_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Product_Experiences_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Product_Experiences_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Product_Experiences_Sum_Order_By>;
  var_pop?: InputMaybe<User_Product_Experiences_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Product_Experiences_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Product_Experiences_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_product_experiences" */
export type User_Product_Experiences_Arr_Rel_Insert_Input = {
  data: Array<User_Product_Experiences_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Product_Experiences_On_Conflict>;
};

/** order by avg() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Avg_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_product_experiences". All fields are combined with a logical 'AND'. */
export type User_Product_Experiences_Bool_Exp = {
  _and?: InputMaybe<Array<User_Product_Experiences_Bool_Exp>>;
  _not?: InputMaybe<User_Product_Experiences_Bool_Exp>;
  _or?: InputMaybe<Array<User_Product_Experiences_Bool_Exp>>;
  dismiss_count?: InputMaybe<Smallint_Comparison_Exp>;
  dismiss_reason?: InputMaybe<String_Comparison_Exp>;
  first_seen_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  holdout?: InputMaybe<Boolean_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  last_step?: InputMaybe<Smallint_Comparison_Exp>;
  outcome?: InputMaybe<String_Comparison_Exp>;
  outcome_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  step_count?: InputMaybe<Smallint_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_product_experiences" */
export enum User_Product_Experiences_Constraint {
  /** unique or primary key constraint on columns "user_id", "key", "kind" */
  UserProductExperiencesPkey = 'user_product_experiences_pkey'
}

/** input type for incrementing numeric columns in table "user_product_experiences" */
export type User_Product_Experiences_Inc_Input = {
  dismiss_count?: InputMaybe<Scalars['smallint']['input']>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Scalars['smallint']['input']>;
  step_count?: InputMaybe<Scalars['smallint']['input']>;
};

/** input type for inserting data into table "user_product_experiences" */
export type User_Product_Experiences_Insert_Input = {
  dismiss_count?: InputMaybe<Scalars['smallint']['input']>;
  dismiss_reason?: InputMaybe<Scalars['String']['input']>;
  /** Campaigns: true when the user is in the comparison group and never sees it. */
  holdout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Release entry id (content/releases/<key>), tour id (tourRegistry.ts) or campaign id (campaignRegistry.ts). */
  key?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Scalars['smallint']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_at?: InputMaybe<Scalars['timestamptz']['input']>;
  step_count?: InputMaybe<Scalars['smallint']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** order by max() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Max_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  dismiss_reason?: InputMaybe<Order_By>;
  /** Release: first seen. Tour: first started. Campaign: first reached the user (shown or held out). */
  first_seen_at?: InputMaybe<Order_By>;
  /** Release entry id (content/releases/<key>), tour id (tourRegistry.ts) or campaign id (campaignRegistry.ts). */
  key?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_at?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Min_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  dismiss_reason?: InputMaybe<Order_By>;
  /** Release: first seen. Tour: first started. Campaign: first reached the user (shown or held out). */
  first_seen_at?: InputMaybe<Order_By>;
  /** Release entry id (content/releases/<key>), tour id (tourRegistry.ts) or campaign id (campaignRegistry.ts). */
  key?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_at?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_product_experiences" */
export type User_Product_Experiences_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Product_Experiences>;
};

/** on_conflict condition type for table "user_product_experiences" */
export type User_Product_Experiences_On_Conflict = {
  constraint: User_Product_Experiences_Constraint;
  update_columns?: Array<User_Product_Experiences_Update_Column>;
  where?: InputMaybe<User_Product_Experiences_Bool_Exp>;
};

/** Ordering options when selecting data from "user_product_experiences". */
export type User_Product_Experiences_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  dismiss_reason?: InputMaybe<Order_By>;
  first_seen_at?: InputMaybe<Order_By>;
  holdout?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  last_step?: InputMaybe<Order_By>;
  outcome?: InputMaybe<Order_By>;
  outcome_at?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_product_experiences */
export type User_Product_Experiences_Pk_Columns_Input = {
  /** Release entry id (content/releases/<key>), tour id (tourRegistry.ts) or campaign id (campaignRegistry.ts). */
  key: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "user_product_experiences" */
export enum User_Product_Experiences_Select_Column {
  /** column name */
  DismissCount = 'dismiss_count',
  /** column name */
  DismissReason = 'dismiss_reason',
  /** column name */
  FirstSeenAt = 'first_seen_at',
  /** column name */
  Holdout = 'holdout',
  /** column name */
  Key = 'key',
  /** column name */
  Kind = 'kind',
  /** column name */
  LastStep = 'last_step',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  OutcomeAt = 'outcome_at',
  /** column name */
  StepCount = 'step_count',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_product_experiences" */
export type User_Product_Experiences_Set_Input = {
  dismiss_count?: InputMaybe<Scalars['smallint']['input']>;
  dismiss_reason?: InputMaybe<Scalars['String']['input']>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Scalars['smallint']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcome_at?: InputMaybe<Scalars['timestamptz']['input']>;
  step_count?: InputMaybe<Scalars['smallint']['input']>;
};

/** order by stddev() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Stddev_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Stddev_Pop_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Stddev_Samp_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** order by sum() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Sum_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** update columns of table "user_product_experiences" */
export enum User_Product_Experiences_Update_Column {
  /** column name */
  DismissCount = 'dismiss_count',
  /** column name */
  DismissReason = 'dismiss_reason',
  /** column name */
  LastStep = 'last_step',
  /** column name */
  Outcome = 'outcome',
  /** column name */
  OutcomeAt = 'outcome_at',
  /** column name */
  StepCount = 'step_count'
}

export type User_Product_Experiences_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Product_Experiences_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Product_Experiences_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Product_Experiences_Bool_Exp;
};

/** order by var_pop() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Var_Pop_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Var_Samp_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user_product_experiences" */
export type User_Product_Experiences_Variance_Order_By = {
  dismiss_count?: InputMaybe<Order_By>;
  /** Tours: 1-based step shown when the outcome was recorded. */
  last_step?: InputMaybe<Order_By>;
  step_count?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "user_professional_situation". All fields are combined with logical 'AND'. */
export type User_Professional_Situation_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _gte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _in?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _lte?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _neq?: InputMaybe<Scalars['user_professional_situation']['input']>;
  _nin?: InputMaybe<Array<Scalars['user_professional_situation']['input']>>;
};

/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type Users = {
  /** An object relationship */
  account_manager?: Maybe<Users>;
  account_manager_id?: Maybe<Scalars['uuid']['output']>;
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  activities: Array<Activities>;
  /** An aggregate relationship */
  activities_aggregate: Activities_Aggregate;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  agent_slug?: Maybe<Scalars['String']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_credits?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_credits_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_income_additional_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  annual_income_salary13?: Maybe<Scalars['Boolean']['output']>;
  annual_income_salary14?: Maybe<Scalars['Boolean']['output']>;
  annual_leasings?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_leasings_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_other_exist?: Maybe<Scalars['Boolean']['output']>;
  annual_other_payments?: Maybe<Array<Scalars['float8']['output']>>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_second_pillar_exist?: Maybe<Scalars['Boolean']['output']>;
  assets_second_pillar_organisation?: Maybe<Scalars['String']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium_organization?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_exist?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_a_life_insurance?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_a']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_exist?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_b_life_insurance?: Maybe<Scalars['Boolean']['output']>;
  assets_third_pillar_b_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_b_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_b']['output']>;
  assets_third_pillar_exist?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  assigned_activities: Array<Activities>;
  /** An aggregate relationship */
  assigned_activities_aggregate: Activities_Aggregate;
  auto_assign_leads?: Maybe<Scalars['Boolean']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  branding_logo?: Maybe<Scalars['String']['output']>;
  branding_name?: Maybe<Scalars['String']['output']>;
  branding_website?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  broker?: Maybe<Users>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  broker_leads: Array<Lead_Agents>;
  /** An aggregate relationship */
  broker_leads_aggregate: Lead_Agents_Aggregate;
  /** An array relationship */
  buyer_leads: Array<Buyer_Leads>;
  /** An aggregate relationship */
  buyer_leads_aggregate: Buyer_Leads_Aggregate;
  /** An array relationship */
  buyer_offers: Array<Offers>;
  /** An aggregate relationship */
  buyer_offers_aggregate: Offers_Aggregate;
  can_edit_settings?: Maybe<Scalars['Boolean']['output']>;
  can_user_login_as: Scalars['Boolean']['output'];
  /** An array relationship */
  catchment_areas: Array<Catchment_Areas>;
  /** An aggregate relationship */
  catchment_areas_aggregate: Catchment_Areas_Aggregate;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  /** An array relationship */
  combined_reviews: Array<Combined_Reviews>;
  /** An aggregate relationship */
  combined_reviews_aggregate: Combined_Reviews_Aggregate;
  /** An array relationship */
  created_activities: Array<Activities>;
  /** An aggregate relationship */
  created_activities_aggregate: Activities_Aggregate;
  created_at: Scalars['timestamptz']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  created_cma_reports: Array<Cma_Reports>;
  /** An aggregate relationship */
  created_cma_reports_aggregate: Cma_Reports_Aggregate;
  /** An object relationship */
  creator?: Maybe<Users>;
  /** A computed field, executes function "users_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  default_team?: Maybe<Teams>;
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  divorce_date?: Maybe<Scalars['date']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_signature?: Maybe<Scalars['String']['output']>;
  email_signature_html?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  emails: Array<Emails>;
  employer?: Maybe<Scalars['String']['output']>;
  employer_id?: Maybe<Scalars['uuid']['output']>;
  employment_commencement_date?: Maybe<Scalars['date']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  /** An array relationship */
  enquiries: Array<Enquiries>;
  /** An aggregate relationship */
  enquiries_aggregate: Enquiries_Aggregate;
  facebook_profile?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** Accounts blocked together (one block_fsbo_users call, or an automatic block that joined the matched account's batch) share a batch id, so they can be unblocked together. */
  fsbo_block_batch_id?: Maybe<Scalars['uuid']['output']>;
  /** Set by the block_fsbo_user action: this advertiser's FSBO listings never go live (shadow ban). NULL = not blocked. */
  fsbo_blocked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** CRM user who blocked the advertiser (block_fsbo_user action). */
  fsbo_blocked_by?: Maybe<Scalars['uuid']['output']>;
  /** Free-text reason given in the CRM when the advertiser was blocked; staff only. */
  fsbo_blocked_reason?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  has_accepted_terms: Scalars['Boolean']['output'];
  has_children?: Maybe<Scalars['Boolean']['output']>;
  /** True unless the user was explicitly enrolled in onboarding (claim, payment, first team add, invitation). The CRM sends a user with false to the onboarding wizard until they finish it. */
  has_done_onboarding: Scalars['Boolean']['output'];
  has_free_crm_access: Scalars['Boolean']['output'];
  has_used_trial_button: Scalars['Boolean']['output'];
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_country_code?: Maybe<Scalars['String']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  home_address_locality?: Maybe<Scalars['String']['output']>;
  home_address_postcode?: Maybe<Scalars['String']['output']>;
  home_address_route?: Maybe<Scalars['String']['output']>;
  home_address_state?: Maybe<Scalars['String']['output']>;
  home_address_street_number?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  identification_document_expiry_date?: Maybe<Scalars['date']['output']>;
  identification_document_issue_date?: Maybe<Scalars['date']['output']>;
  identification_document_number?: Maybe<Scalars['String']['output']>;
  identification_document_type_id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  instagram_profile?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_intercom_hash" */
  intercom_hash?: Maybe<Scalars['String']['output']>;
  is_admin: Scalars['Boolean']['output'];
  is_bot: Scalars['Boolean']['output'];
  is_broker: Scalars['Boolean']['output'];
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_mortgage_broker: Scalars['Boolean']['output'];
  is_unclaimed: Scalars['Boolean']['output'];
  job_title?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  lead_agents: Array<Lead_Agents>;
  /** An aggregate relationship */
  lead_agents_aggregate: Lead_Agents_Aggregate;
  /** An array relationship */
  leads: Array<Leads>;
  /** An aggregate relationship */
  leads_aggregate: Leads_Aggregate;
  linked_in_profile?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  logins: Array<Logins>;
  /** An array relationship */
  lot_sellers: Array<Lot_Sellers>;
  /** An aggregate relationship */
  lot_sellers_aggregate: Lot_Sellers_Aggregate;
  /** An array relationship */
  lots: Array<Lots>;
  /** An aggregate relationship */
  lots_aggregate: Lots_Aggregate;
  marital_partner_id?: Maybe<Scalars['uuid']['output']>;
  marital_status?: Maybe<Scalars['marital_status']['output']>;
  matrimonial_regime?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  module_grants: Array<User_Modules>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  mv_agent?: Maybe<Agents>;
  /** An object relationship */
  nationality?: Maybe<Dictionaries>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  notification_preferences: Array<User_Notification_Preferences>;
  number_of_buyers: Scalars['Int']['output'];
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  nylas_account_config: Array<Nylas_Account_Configs>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  /** Why a CSM skipped self-onboarding (user_onboarding_skip_reason_enum). Null when it was not skipped, and cleared when the agent is sent back into the flow. */
  onboarding_skip_reason?: Maybe<User_Onboarding_Skip_Reason_Enum_Enum>;
  /** Tracks self-serve onboarding review state: in_progress, pending_review, or approved. */
  onboarding_status?: Maybe<User_Onboarding_Status_Enum_Enum>;
  /** An object relationship */
  organisation?: Maybe<Organisations>;
  /** An object relationship */
  organisation_user?: Maybe<Organisation_Users>;
  /** An array relationship */
  phone_numbers: Array<Phone_Numbers>;
  /** An aggregate relationship */
  phone_numbers_aggregate: Phone_Numbers_Aggregate;
  place_of_origin?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "user_primary_phone" */
  primary_phone_number?: Maybe<Array<Phone_Numbers>>;
  /** An array relationship */
  product_experiences: Array<User_Product_Experiences>;
  professional_address_country_code?: Maybe<Scalars['String']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  professional_address_locality?: Maybe<Scalars['String']['output']>;
  professional_address_postcode?: Maybe<Scalars['String']['output']>;
  professional_address_route?: Maybe<Scalars['String']['output']>;
  professional_address_state?: Maybe<Scalars['String']['output']>;
  professional_address_street_number?: Maybe<Scalars['String']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  properties_exist?: Maybe<Scalars['Boolean']['output']>;
  /** An array relationship */
  property_searches: Array<Property_Searches>;
  /** An aggregate relationship */
  property_searches_aggregate: Property_Searches_Aggregate;
  /** An array relationship */
  property_transactions: Array<Property_Transactions>;
  /** An aggregate relationship */
  property_transactions_aggregate: Property_Transactions_Aggregate;
  /** An array relationship */
  push_notification_tokens: Array<Push_Notification_Tokens>;
  recommended_listings: Scalars['Boolean']['output'];
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reviews: Array<Reviews>;
  /** An aggregate relationship */
  reviews_aggregate: Reviews_Aggregate;
  second_pillar_organisation_id?: Maybe<Scalars['uuid']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  show_in_agency_pages?: Maybe<Scalars['Boolean']['output']>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "users_sort_name" */
  sort_name?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subscriptions: Array<Subscriptions>;
  /** An aggregate relationship */
  subscriptions_aggregate: Subscriptions_Aggregate;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  teams_users: Array<Teams_Users>;
  /** An aggregate relationship */
  teams_users_aggregate: Teams_Users_Aggregate;
  /** An object relationship */
  tenant: Tenants;
  tenant_id: Scalars['uuid']['output'];
  /** A computed field, executes function "users_test_jwt" */
  test_jwt?: Maybe<Scalars['String']['output']>;
  third_pillar_a_annual_premium_organization_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_a_organisation_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_b_organisation_id?: Maybe<Scalars['uuid']['output']>;
  tiktok_profile?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['timestamptz']['output'];
  updates_daily_tasks: Scalars['Boolean']['output'];
  updates_introduction_to_lead_contacts?: Maybe<Scalars['Boolean']['output']>;
  updates_new_lead_assigned_sms?: Maybe<Scalars['Boolean']['output']>;
  updates_newsletter?: Maybe<Scalars['Boolean']['output']>;
  updates_property_revaluation: Scalars['Boolean']['output'];
  /** An array relationship */
  user_images: Array<User_Images>;
  wedding_date?: Maybe<Scalars['date']['output']>;
  /** An object relationship */
  work_permit?: Maybe<Dictionaries>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  x_profile?: Maybe<Scalars['String']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  youtube_profile?: Maybe<Scalars['String']['output']>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersActivities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersAssigned_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersAssigned_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersBroker_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersBroker_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersBuyer_LeadsArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersBuyer_Leads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Buyer_Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buyer_Leads_Order_By>>;
  where?: InputMaybe<Buyer_Leads_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersBuyer_OffersArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersBuyer_Offers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Offers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Offers_Order_By>>;
  where?: InputMaybe<Offers_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCatchment_AreasArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCatchment_Areas_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Catchment_Areas_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Catchment_Areas_Order_By>>;
  where?: InputMaybe<Catchment_Areas_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCombined_ReviewsArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCombined_Reviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Combined_Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Combined_Reviews_Order_By>>;
  where?: InputMaybe<Combined_Reviews_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCreated_ActivitiesArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCreated_Activities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Activities_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activities_Order_By>>;
  where?: InputMaybe<Activities_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCreated_Cma_ReportsArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersCreated_Cma_Reports_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cma_Reports_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By>>;
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersEmailsArgs = {
  distinct_on?: InputMaybe<Array<Emails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Emails_Order_By>>;
  where?: InputMaybe<Emails_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersEnquiriesArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersEnquiries_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Enquiries_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Enquiries_Order_By>>;
  where?: InputMaybe<Enquiries_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLead_AgentsArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLead_Agents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lead_Agents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lead_Agents_Order_By>>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLeadsArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLeads_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Leads_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Leads_Order_By>>;
  where?: InputMaybe<Leads_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLoginsArgs = {
  distinct_on?: InputMaybe<Array<Logins_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Logins_Order_By>>;
  where?: InputMaybe<Logins_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLot_SellersArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLot_Sellers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lot_Sellers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lot_Sellers_Order_By>>;
  where?: InputMaybe<Lot_Sellers_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLotsArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersLots_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Lots_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Lots_Order_By>>;
  where?: InputMaybe<Lots_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersModule_GrantsArgs = {
  distinct_on?: InputMaybe<Array<User_Modules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Modules_Order_By>>;
  where?: InputMaybe<User_Modules_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersNotification_PreferencesArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Preferences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Notification_Preferences_Order_By>>;
  where?: InputMaybe<User_Notification_Preferences_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersNylas_Account_ConfigArgs = {
  distinct_on?: InputMaybe<Array<Nylas_Account_Configs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Nylas_Account_Configs_Order_By>>;
  where?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersPhone_NumbersArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersPhone_Numbers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersPrimary_Phone_NumberArgs = {
  distinct_on?: InputMaybe<Array<Phone_Numbers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Phone_Numbers_Order_By>>;
  where?: InputMaybe<Phone_Numbers_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersProduct_ExperiencesArgs = {
  distinct_on?: InputMaybe<Array<User_Product_Experiences_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Product_Experiences_Order_By>>;
  where?: InputMaybe<User_Product_Experiences_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersProperty_SearchesArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersProperty_Searches_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Searches_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Searches_Order_By>>;
  where?: InputMaybe<Property_Searches_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersProperty_TransactionsArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersProperty_Transactions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Property_Transactions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By>>;
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersPush_Notification_TokensArgs = {
  distinct_on?: InputMaybe<Array<Push_Notification_Tokens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Push_Notification_Tokens_Order_By>>;
  where?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersReviewsArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Reviews_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Reviews_Order_By>>;
  where?: InputMaybe<Reviews_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersTeams_UsersArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersTeams_Users_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Teams_Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Teams_Users_Order_By>>;
  where?: InputMaybe<Teams_Users_Bool_Exp>;
};


/** Every person: contacts (owners, buyers) and agents are rows of this same table, each in one tenant. Agents are the users with an active teams_users row, and they also have is_broker = true (a few hundred legacy users have the flag without a current team). To find someone by name, email or phone call search_users_tsv (each word a prefix, all words required; words with @ are any-of; deleted users excluded) rather than a pattern on a name column. Addresses are in emails and phone_numbers. */
export type UsersUser_ImagesArgs = {
  distinct_on?: InputMaybe<Array<User_Images_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<User_Images_Order_By>>;
  where?: InputMaybe<User_Images_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Users_Aggregate_Bool_Exp_Avg>;
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or>;
  corr?: InputMaybe<Users_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Users_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Users_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Users_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Users_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Users_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Users_Aggregate_Bool_Exp_Var_Samp>;
};

export type Users_Aggregate_Bool_Exp_Avg = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_And = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Corr = {
  arguments: Users_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Users_Select_Column_Users_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Users_Select_Column_Users_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Users_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Users_Select_Column_Users_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Users_Select_Column_Users_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Users_Aggregate_Bool_Exp_Max = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Min = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Sum = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Users_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  account_manager?: InputMaybe<Users_Bool_Exp>;
  account_manager_id?: InputMaybe<Uuid_Comparison_Exp>;
  active_since?: InputMaybe<Int_Comparison_Exp>;
  activities?: InputMaybe<Activities_Bool_Exp>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  age?: InputMaybe<Int_Comparison_Exp>;
  agent_slug?: InputMaybe<String_Comparison_Exp>;
  annual_costs_child_support?: InputMaybe<Float8_Comparison_Exp>;
  annual_costs_leasing?: InputMaybe<Float8_Comparison_Exp>;
  annual_costs_other_credits?: InputMaybe<Float8_Comparison_Exp>;
  annual_credits?: InputMaybe<Jsonb_Array_Comparison_Exp>;
  annual_credits_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_income_additional_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_income_bonus?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_family_allowances?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_other?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_rent?: InputMaybe<Float8_Comparison_Exp>;
  annual_income_salary?: InputMaybe<Int_Comparison_Exp>;
  annual_income_salary13?: InputMaybe<Boolean_Comparison_Exp>;
  annual_income_salary14?: InputMaybe<Boolean_Comparison_Exp>;
  annual_leasings?: InputMaybe<Jsonb_Array_Comparison_Exp>;
  annual_leasings_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_other_exist?: InputMaybe<Boolean_Comparison_Exp>;
  annual_other_payments?: InputMaybe<Float8_Array_Comparison_Exp>;
  assets_savings?: InputMaybe<Int_Comparison_Exp>;
  assets_savings_donation?: InputMaybe<Float_Comparison_Exp>;
  assets_second_pillar?: InputMaybe<Int_Comparison_Exp>;
  assets_second_pillar_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assets_second_pillar_organisation?: InputMaybe<String_Comparison_Exp>;
  assets_securities?: InputMaybe<Float8_Comparison_Exp>;
  assets_third_pillar_a?: InputMaybe<Int_Comparison_Exp>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Float_Comparison_Exp>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<String_Comparison_Exp>;
  assets_third_pillar_a_cash?: InputMaybe<Float8_Comparison_Exp>;
  assets_third_pillar_a_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_a_organisation?: InputMaybe<String_Comparison_Exp>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Third_Pillar_Organisation_Type_A_Comparison_Exp>;
  assets_third_pillar_b?: InputMaybe<Float_Comparison_Exp>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Float_Comparison_Exp>;
  assets_third_pillar_b_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Boolean_Comparison_Exp>;
  assets_third_pillar_b_organisation?: InputMaybe<String_Comparison_Exp>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Third_Pillar_Organisation_Type_B_Comparison_Exp>;
  assets_third_pillar_exist?: InputMaybe<Boolean_Comparison_Exp>;
  assigned_activities?: InputMaybe<Activities_Bool_Exp>;
  assigned_activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  auto_assign_leads?: InputMaybe<Boolean_Comparison_Exp>;
  branding_color?: InputMaybe<String_Comparison_Exp>;
  branding_logo?: InputMaybe<String_Comparison_Exp>;
  branding_name?: InputMaybe<String_Comparison_Exp>;
  branding_website?: InputMaybe<String_Comparison_Exp>;
  broker?: InputMaybe<Users_Bool_Exp>;
  broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  broker_leads?: InputMaybe<Lead_Agents_Bool_Exp>;
  broker_leads_aggregate?: InputMaybe<Lead_Agents_Aggregate_Bool_Exp>;
  buyer_leads?: InputMaybe<Buyer_Leads_Bool_Exp>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Bool_Exp>;
  buyer_offers?: InputMaybe<Offers_Bool_Exp>;
  buyer_offers_aggregate?: InputMaybe<Offers_Aggregate_Bool_Exp>;
  can_edit_settings?: InputMaybe<Boolean_Comparison_Exp>;
  can_user_login_as?: InputMaybe<Boolean_Comparison_Exp>;
  catchment_areas?: InputMaybe<Catchment_Areas_Bool_Exp>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Bool_Exp>;
  certifications?: InputMaybe<String_Array_Comparison_Exp>;
  combined_reviews?: InputMaybe<Combined_Reviews_Bool_Exp>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Bool_Exp>;
  created_activities?: InputMaybe<Activities_Bool_Exp>;
  created_activities_aggregate?: InputMaybe<Activities_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  created_cma_reports?: InputMaybe<Cma_Reports_Bool_Exp>;
  created_cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Bool_Exp>;
  creator?: InputMaybe<Users_Bool_Exp>;
  crm_link?: InputMaybe<String_Comparison_Exp>;
  date_of_birth?: InputMaybe<Date_Comparison_Exp>;
  debt?: InputMaybe<Int_Comparison_Exp>;
  debt_leasing_balance?: InputMaybe<Float8_Comparison_Exp>;
  debt_mortgage_balance?: InputMaybe<Float8_Comparison_Exp>;
  debt_other_credits_balance?: InputMaybe<Int_Comparison_Exp>;
  default_team?: InputMaybe<Teams_Bool_Exp>;
  default_team_id?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  divorce_date?: InputMaybe<Date_Comparison_Exp>;
  donation?: InputMaybe<Float8_Comparison_Exp>;
  email_signature?: InputMaybe<String_Comparison_Exp>;
  email_signature_html?: InputMaybe<String_Comparison_Exp>;
  emails?: InputMaybe<Emails_Bool_Exp>;
  employer?: InputMaybe<String_Comparison_Exp>;
  employer_id?: InputMaybe<Uuid_Comparison_Exp>;
  employment_commencement_date?: InputMaybe<Date_Comparison_Exp>;
  employment_rate?: InputMaybe<Float8_Comparison_Exp>;
  enquiries?: InputMaybe<Enquiries_Bool_Exp>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Bool_Exp>;
  facebook_profile?: InputMaybe<String_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  fsbo_block_batch_id?: InputMaybe<Uuid_Comparison_Exp>;
  fsbo_blocked_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fsbo_blocked_by?: InputMaybe<Uuid_Comparison_Exp>;
  fsbo_blocked_reason?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  gender?: InputMaybe<String_Comparison_Exp>;
  has_accepted_terms?: InputMaybe<Boolean_Comparison_Exp>;
  has_children?: InputMaybe<Boolean_Comparison_Exp>;
  has_done_onboarding?: InputMaybe<Boolean_Comparison_Exp>;
  has_free_crm_access?: InputMaybe<Boolean_Comparison_Exp>;
  has_used_trial_button?: InputMaybe<Boolean_Comparison_Exp>;
  hires_on_realadvisor?: InputMaybe<Int_Comparison_Exp>;
  home_address_country_code?: InputMaybe<String_Comparison_Exp>;
  home_address_lat?: InputMaybe<Float_Comparison_Exp>;
  home_address_lng?: InputMaybe<Float_Comparison_Exp>;
  home_address_locality?: InputMaybe<String_Comparison_Exp>;
  home_address_postcode?: InputMaybe<String_Comparison_Exp>;
  home_address_route?: InputMaybe<String_Comparison_Exp>;
  home_address_state?: InputMaybe<String_Comparison_Exp>;
  home_address_street_number?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identification_document_expiry_date?: InputMaybe<Date_Comparison_Exp>;
  identification_document_issue_date?: InputMaybe<Date_Comparison_Exp>;
  identification_document_number?: InputMaybe<String_Comparison_Exp>;
  identification_document_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  imported_id?: InputMaybe<String_Comparison_Exp>;
  instagram_profile?: InputMaybe<String_Comparison_Exp>;
  intercom_hash?: InputMaybe<String_Comparison_Exp>;
  is_admin?: InputMaybe<Boolean_Comparison_Exp>;
  is_bot?: InputMaybe<Boolean_Comparison_Exp>;
  is_broker?: InputMaybe<Boolean_Comparison_Exp>;
  is_deleted?: InputMaybe<Boolean_Comparison_Exp>;
  is_mortgage_broker?: InputMaybe<Boolean_Comparison_Exp>;
  is_unclaimed?: InputMaybe<Boolean_Comparison_Exp>;
  job_title?: InputMaybe<String_Comparison_Exp>;
  landing_page_url?: InputMaybe<String_Comparison_Exp>;
  language?: InputMaybe<User_Language_Comparison_Exp>;
  languages?: InputMaybe<String_Array_Comparison_Exp>;
  last_bonus?: InputMaybe<Float8_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  lead_agents?: InputMaybe<Lead_Agents_Bool_Exp>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Bool_Exp>;
  leads?: InputMaybe<Leads_Bool_Exp>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Bool_Exp>;
  linked_in_profile?: InputMaybe<String_Comparison_Exp>;
  logins?: InputMaybe<Logins_Bool_Exp>;
  lot_sellers?: InputMaybe<Lot_Sellers_Bool_Exp>;
  lot_sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Bool_Exp>;
  lots?: InputMaybe<Lots_Bool_Exp>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Bool_Exp>;
  marital_partner_id?: InputMaybe<Uuid_Comparison_Exp>;
  marital_status?: InputMaybe<Marital_Status_Comparison_Exp>;
  matrimonial_regime?: InputMaybe<String_Comparison_Exp>;
  membership_type?: InputMaybe<String_Comparison_Exp>;
  module_grants?: InputMaybe<User_Modules_Bool_Exp>;
  modules?: InputMaybe<String_Array_Comparison_Exp>;
  mortgage_broker_id?: InputMaybe<Uuid_Comparison_Exp>;
  mv_agent?: InputMaybe<Agents_Bool_Exp>;
  nationality?: InputMaybe<Dictionaries_Bool_Exp>;
  nationality_id?: InputMaybe<Uuid_Comparison_Exp>;
  notification_preferences?: InputMaybe<User_Notification_Preferences_Bool_Exp>;
  number_of_buyers?: InputMaybe<Int_Comparison_Exp>;
  number_of_dependant_children?: InputMaybe<Int_Comparison_Exp>;
  nylas_account_config?: InputMaybe<Nylas_Account_Configs_Bool_Exp>;
  occupation_id?: InputMaybe<Uuid_Comparison_Exp>;
  occupation_text?: InputMaybe<String_Comparison_Exp>;
  onboarding_skip_reason?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Enum_Comparison_Exp>;
  onboarding_status?: InputMaybe<User_Onboarding_Status_Enum_Enum_Comparison_Exp>;
  organisation?: InputMaybe<Organisations_Bool_Exp>;
  organisation_user?: InputMaybe<Organisation_Users_Bool_Exp>;
  phone_numbers?: InputMaybe<Phone_Numbers_Bool_Exp>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Bool_Exp>;
  place_of_origin?: InputMaybe<String_Comparison_Exp>;
  primary_phone_number?: InputMaybe<Phone_Numbers_Bool_Exp>;
  product_experiences?: InputMaybe<User_Product_Experiences_Bool_Exp>;
  professional_address_country_code?: InputMaybe<String_Comparison_Exp>;
  professional_address_lat?: InputMaybe<Float8_Comparison_Exp>;
  professional_address_lng?: InputMaybe<Float8_Comparison_Exp>;
  professional_address_locality?: InputMaybe<String_Comparison_Exp>;
  professional_address_postcode?: InputMaybe<String_Comparison_Exp>;
  professional_address_route?: InputMaybe<String_Comparison_Exp>;
  professional_address_state?: InputMaybe<String_Comparison_Exp>;
  professional_address_street_number?: InputMaybe<String_Comparison_Exp>;
  professional_situation?: InputMaybe<User_Professional_Situation_Comparison_Exp>;
  properties_exist?: InputMaybe<Boolean_Comparison_Exp>;
  property_searches?: InputMaybe<Property_Searches_Bool_Exp>;
  property_searches_aggregate?: InputMaybe<Property_Searches_Aggregate_Bool_Exp>;
  property_transactions?: InputMaybe<Property_Transactions_Bool_Exp>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Bool_Exp>;
  push_notification_tokens?: InputMaybe<Push_Notification_Tokens_Bool_Exp>;
  recommended_listings?: InputMaybe<Boolean_Comparison_Exp>;
  referrer?: InputMaybe<String_Comparison_Exp>;
  referring_domain?: InputMaybe<String_Comparison_Exp>;
  registered_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  residence_country_code?: InputMaybe<String_Comparison_Exp>;
  residence_state_id?: InputMaybe<Uuid_Comparison_Exp>;
  reviews?: InputMaybe<Reviews_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Bool_Exp>;
  second_pillar_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  services?: InputMaybe<String_Array_Comparison_Exp>;
  show_in_agency_pages?: InputMaybe<Boolean_Comparison_Exp>;
  social_security_number?: InputMaybe<String_Comparison_Exp>;
  sort_name?: InputMaybe<String_Comparison_Exp>;
  subscriptions?: InputMaybe<Subscriptions_Bool_Exp>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Bool_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  teams_users?: InputMaybe<Teams_Users_Bool_Exp>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Bool_Exp>;
  tenant?: InputMaybe<Tenants_Bool_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  test_jwt?: InputMaybe<String_Comparison_Exp>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  third_pillar_a_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  third_pillar_b_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  tiktok_profile?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  updates_daily_tasks?: InputMaybe<Boolean_Comparison_Exp>;
  updates_introduction_to_lead_contacts?: InputMaybe<Boolean_Comparison_Exp>;
  updates_new_lead_assigned_sms?: InputMaybe<Boolean_Comparison_Exp>;
  updates_newsletter?: InputMaybe<Boolean_Comparison_Exp>;
  updates_property_revaluation?: InputMaybe<Boolean_Comparison_Exp>;
  user_images?: InputMaybe<User_Images_Bool_Exp>;
  wedding_date?: InputMaybe<Date_Comparison_Exp>;
  work_permit?: InputMaybe<Dictionaries_Bool_Exp>;
  work_permit_id?: InputMaybe<Uuid_Comparison_Exp>;
  x_profile?: InputMaybe<String_Comparison_Exp>;
  yearly_revenues_at_retirement?: InputMaybe<Float8_Comparison_Exp>;
  youtube_profile?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "agent_slug" */
  UniqueAgentSlugIndex = 'unique_agent_slug_index',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  UsersIdTenantIdUnique = 'users_id_tenant_id_unique',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  hires_on_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  home_address_lat?: InputMaybe<Scalars['Float']['input']>;
  home_address_lng?: InputMaybe<Scalars['Float']['input']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  account_manager?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  assigned_activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  broker?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  broker_leads?: InputMaybe<Lead_Agents_Arr_Rel_Insert_Input>;
  buyer_leads?: InputMaybe<Buyer_Leads_Arr_Rel_Insert_Input>;
  buyer_offers?: InputMaybe<Offers_Arr_Rel_Insert_Input>;
  catchment_areas?: InputMaybe<Catchment_Areas_Arr_Rel_Insert_Input>;
  created_activities?: InputMaybe<Activities_Arr_Rel_Insert_Input>;
  created_cma_reports?: InputMaybe<Cma_Reports_Arr_Rel_Insert_Input>;
  creator?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  default_team?: InputMaybe<Teams_Obj_Rel_Insert_Input>;
  emails?: InputMaybe<Emails_Arr_Rel_Insert_Input>;
  enquiries?: InputMaybe<Enquiries_Arr_Rel_Insert_Input>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_lat?: InputMaybe<Scalars['Float']['input']>;
  home_address_lng?: InputMaybe<Scalars['Float']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  lead_agents?: InputMaybe<Lead_Agents_Arr_Rel_Insert_Input>;
  leads?: InputMaybe<Leads_Arr_Rel_Insert_Input>;
  lot_sellers?: InputMaybe<Lot_Sellers_Arr_Rel_Insert_Input>;
  lots?: InputMaybe<Lots_Arr_Rel_Insert_Input>;
  nationality?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
  notification_preferences?: InputMaybe<User_Notification_Preferences_Arr_Rel_Insert_Input>;
  organisation?: InputMaybe<Organisations_Obj_Rel_Insert_Input>;
  phone_numbers?: InputMaybe<Phone_Numbers_Arr_Rel_Insert_Input>;
  product_experiences?: InputMaybe<User_Product_Experiences_Arr_Rel_Insert_Input>;
  property_searches?: InputMaybe<Property_Searches_Arr_Rel_Insert_Input>;
  property_transactions?: InputMaybe<Property_Transactions_Arr_Rel_Insert_Input>;
  push_notification_tokens?: InputMaybe<Push_Notification_Tokens_Arr_Rel_Insert_Input>;
  reviews?: InputMaybe<Reviews_Arr_Rel_Insert_Input>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  teams_users?: InputMaybe<Teams_Users_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']['input']>;
  user_images?: InputMaybe<User_Images_Arr_Rel_Insert_Input>;
  work_permit?: InputMaybe<Dictionaries_Obj_Rel_Insert_Input>;
};

/** columns and relationships of "users_listings" */
export type Users_Listings = {
  created_at: Scalars['timestamptz']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_listing_id: Scalars['Int']['output'];
  /** An object relationship */
  online_listing?: Maybe<Online_Listings>;
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['output'];
};

/** aggregated selection of "users_listings" */
export type Users_Listings_Aggregate = {
  aggregate?: Maybe<Users_Listings_Aggregate_Fields>;
  nodes: Array<Users_Listings>;
};

/** aggregate fields of "users_listings" */
export type Users_Listings_Aggregate_Fields = {
  avg?: Maybe<Users_Listings_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Listings_Max_Fields>;
  min?: Maybe<Users_Listings_Min_Fields>;
  stddev?: Maybe<Users_Listings_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Listings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Listings_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Listings_Sum_Fields>;
  var_pop?: Maybe<Users_Listings_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Listings_Var_Samp_Fields>;
  variance?: Maybe<Users_Listings_Variance_Fields>;
};


/** aggregate fields of "users_listings" */
export type Users_Listings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Listings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "users_listings" */
export type Users_Listings_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Listings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Listings_Max_Order_By>;
  min?: InputMaybe<Users_Listings_Min_Order_By>;
  stddev?: InputMaybe<Users_Listings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Listings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Listings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Listings_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Listings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Listings_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Listings_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Users_Listings_Avg_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "users_listings" */
export type Users_Listings_Avg_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_listings". All fields are combined with a logical 'AND'. */
export type Users_Listings_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Listings_Bool_Exp>>;
  _not?: InputMaybe<Users_Listings_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Listings_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<Citext_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  merged_listing_id?: InputMaybe<Int_Comparison_Exp>;
  online_listing?: InputMaybe<Online_Listings_Bool_Exp>;
  type?: InputMaybe<Users_Listings_Types_Enum_Comparison_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_listings" */
export enum Users_Listings_Constraint {
  /** unique or primary key constraint on columns "created_at", "type", "merged_listing_id", "user_id" */
  UsersListingsPkey = 'users_listings_pkey',
  /** unique or primary key constraint on columns "type", "merged_listing_id", "user_id" */
  UsersListingsUserIdMergedListingIdTypeIdx = 'users_listings_user_id_merged_listing_id_type_idx'
}

/** input type for incrementing numeric columns in table "users_listings" */
export type Users_Listings_Inc_Input = {
  merged_listing_id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "users_listings" */
export type Users_Listings_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  merged_listing_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Users_Listings_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Users_Listings_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_listing_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "users_listings" */
export type Users_Listings_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  merged_listing_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Listings_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  merged_listing_id?: Maybe<Scalars['Int']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "users_listings" */
export type Users_Listings_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  merged_listing_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_listings" */
export type Users_Listings_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_Listings>;
};

/** on_conflict condition type for table "users_listings" */
export type Users_Listings_On_Conflict = {
  constraint: Users_Listings_Constraint;
  update_columns?: Array<Users_Listings_Update_Column>;
  where?: InputMaybe<Users_Listings_Bool_Exp>;
};

/** Ordering options when selecting data from "users_listings". */
export type Users_Listings_Order_By = {
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  merged_listing_id?: InputMaybe<Order_By>;
  online_listing?: InputMaybe<Online_Listings_Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_listings */
export type Users_Listings_Pk_Columns_Input = {
  created_at: Scalars['timestamptz']['input'];
  merged_listing_id: Scalars['Int']['input'];
  type: Users_Listings_Types_Enum;
  user_id: Scalars['uuid']['input'];
};

/** select columns of table "users_listings" */
export enum Users_Listings_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MergedListingId = 'merged_listing_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "users_listings" */
export type Users_Listings_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  merged_listing_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Users_Listings_Types_Enum>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Users_Listings_Stddev_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users_listings" */
export type Users_Listings_Stddev_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Listings_Stddev_Pop_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users_listings" */
export type Users_Listings_Stddev_Pop_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Listings_Stddev_Samp_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users_listings" */
export type Users_Listings_Stddev_Samp_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate sum on columns */
export type Users_Listings_Sum_Fields = {
  merged_listing_id?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "users_listings" */
export type Users_Listings_Sum_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

export enum Users_Listings_Types_Enum {
  Clickout = 'clickout',
  Favourite = 'favourite',
  Hidden = 'hidden'
}

/** Boolean expression to compare columns of type "users_listings_types_enum". All fields are combined with logical 'AND'. */
export type Users_Listings_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Users_Listings_Types_Enum>;
  _in?: InputMaybe<Array<Users_Listings_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Users_Listings_Types_Enum>;
  _nin?: InputMaybe<Array<Users_Listings_Types_Enum>>;
};

/** update columns of table "users_listings" */
export enum Users_Listings_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  LastName = 'last_name',
  /** column name */
  MergedListingId = 'merged_listing_id',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** aggregate var_pop on columns */
export type Users_Listings_Var_Pop_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users_listings" */
export type Users_Listings_Var_Pop_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Listings_Var_Samp_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users_listings" */
export type Users_Listings_Var_Samp_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Listings_Variance_Fields = {
  merged_listing_id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users_listings" */
export type Users_Listings_Variance_Order_By = {
  merged_listing_id?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  account_manager_id?: Maybe<Scalars['uuid']['output']>;
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  agent_slug?: Maybe<Scalars['String']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_credits?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  annual_leasings?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_other_payments?: Maybe<Array<Scalars['float8']['output']>>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_second_pillar_organisation?: Maybe<Scalars['String']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium_organization?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_a']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_b_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_b']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  branding_logo?: Maybe<Scalars['String']['output']>;
  branding_name?: Maybe<Scalars['String']['output']>;
  branding_website?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  divorce_date?: Maybe<Scalars['date']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_signature?: Maybe<Scalars['String']['output']>;
  email_signature_html?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  employer_id?: Maybe<Scalars['uuid']['output']>;
  employment_commencement_date?: Maybe<Scalars['date']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  facebook_profile?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** Accounts blocked together (one block_fsbo_users call, or an automatic block that joined the matched account's batch) share a batch id, so they can be unblocked together. */
  fsbo_block_batch_id?: Maybe<Scalars['uuid']['output']>;
  /** Set by the block_fsbo_user action: this advertiser's FSBO listings never go live (shadow ban). NULL = not blocked. */
  fsbo_blocked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** CRM user who blocked the advertiser (block_fsbo_user action). */
  fsbo_blocked_by?: Maybe<Scalars['uuid']['output']>;
  /** Free-text reason given in the CRM when the advertiser was blocked; staff only. */
  fsbo_blocked_reason?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_country_code?: Maybe<Scalars['String']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  home_address_locality?: Maybe<Scalars['String']['output']>;
  home_address_postcode?: Maybe<Scalars['String']['output']>;
  home_address_route?: Maybe<Scalars['String']['output']>;
  home_address_state?: Maybe<Scalars['String']['output']>;
  home_address_street_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identification_document_expiry_date?: Maybe<Scalars['date']['output']>;
  identification_document_issue_date?: Maybe<Scalars['date']['output']>;
  identification_document_number?: Maybe<Scalars['String']['output']>;
  identification_document_type_id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  instagram_profile?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_intercom_hash" */
  intercom_hash?: Maybe<Scalars['String']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  linked_in_profile?: Maybe<Scalars['String']['output']>;
  marital_partner_id?: Maybe<Scalars['uuid']['output']>;
  marital_status?: Maybe<Scalars['marital_status']['output']>;
  matrimonial_regime?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  place_of_origin?: Maybe<Scalars['String']['output']>;
  professional_address_country_code?: Maybe<Scalars['String']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  professional_address_locality?: Maybe<Scalars['String']['output']>;
  professional_address_postcode?: Maybe<Scalars['String']['output']>;
  professional_address_route?: Maybe<Scalars['String']['output']>;
  professional_address_state?: Maybe<Scalars['String']['output']>;
  professional_address_street_number?: Maybe<Scalars['String']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar_organisation_id?: Maybe<Scalars['uuid']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "users_sort_name" */
  sort_name?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_test_jwt" */
  test_jwt?: Maybe<Scalars['String']['output']>;
  third_pillar_a_annual_premium_organization_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_a_organisation_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_b_organisation_id?: Maybe<Scalars['uuid']['output']>;
  tiktok_profile?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wedding_date?: Maybe<Scalars['date']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  x_profile?: Maybe<Scalars['String']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  youtube_profile?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  account_manager_id?: InputMaybe<Order_By>;
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  agent_slug?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  annual_leasings?: InputMaybe<Order_By>;
  annual_other_payments?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_second_pillar_organisation?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  branding_logo?: InputMaybe<Order_By>;
  branding_name?: InputMaybe<Order_By>;
  branding_website?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  certifications?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  default_team_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  divorce_date?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_signature?: InputMaybe<Order_By>;
  email_signature_html?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  employer_id?: InputMaybe<Order_By>;
  employment_commencement_date?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  facebook_profile?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  /** Accounts blocked together (one block_fsbo_users call, or an automatic block that joined the matched account's batch) share a batch id, so they can be unblocked together. */
  fsbo_block_batch_id?: InputMaybe<Order_By>;
  /** Set by the block_fsbo_user action: this advertiser's FSBO listings never go live (shadow ban). NULL = not blocked. */
  fsbo_blocked_at?: InputMaybe<Order_By>;
  /** CRM user who blocked the advertiser (block_fsbo_user action). */
  fsbo_blocked_by?: InputMaybe<Order_By>;
  /** Free-text reason given in the CRM when the advertiser was blocked; staff only. */
  fsbo_blocked_reason?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_country_code?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  home_address_locality?: InputMaybe<Order_By>;
  home_address_postcode?: InputMaybe<Order_By>;
  home_address_route?: InputMaybe<Order_By>;
  home_address_state?: InputMaybe<Order_By>;
  home_address_street_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification_document_expiry_date?: InputMaybe<Order_By>;
  identification_document_issue_date?: InputMaybe<Order_By>;
  identification_document_number?: InputMaybe<Order_By>;
  identification_document_type_id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  instagram_profile?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linked_in_profile?: InputMaybe<Order_By>;
  marital_partner_id?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  matrimonial_regime?: InputMaybe<Order_By>;
  membership_type?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  place_of_origin?: InputMaybe<Order_By>;
  professional_address_country_code?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  professional_address_locality?: InputMaybe<Order_By>;
  professional_address_postcode?: InputMaybe<Order_By>;
  professional_address_route?: InputMaybe<Order_By>;
  professional_address_state?: InputMaybe<Order_By>;
  professional_address_street_number?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  second_pillar_organisation_id?: InputMaybe<Order_By>;
  services?: InputMaybe<Order_By>;
  social_security_number?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Order_By>;
  third_pillar_a_organisation_id?: InputMaybe<Order_By>;
  third_pillar_b_organisation_id?: InputMaybe<Order_By>;
  tiktok_profile?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wedding_date?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  x_profile?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  youtube_profile?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  account_manager_id?: Maybe<Scalars['uuid']['output']>;
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  agent_slug?: Maybe<Scalars['String']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_credits?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  annual_leasings?: Maybe<Array<Scalars['jsonb']['output']>>;
  annual_other_payments?: Maybe<Array<Scalars['float8']['output']>>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_second_pillar_organisation?: Maybe<Scalars['String']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium_organization?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_a_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_a']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_organisation?: Maybe<Scalars['String']['output']>;
  assets_third_pillar_b_organisation_type?: Maybe<Scalars['third_pillar_organisation_type_b']['output']>;
  branding_color?: Maybe<Scalars['String']['output']>;
  branding_logo?: Maybe<Scalars['String']['output']>;
  branding_name?: Maybe<Scalars['String']['output']>;
  branding_website?: Maybe<Scalars['String']['output']>;
  broker_id?: Maybe<Scalars['uuid']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_crm_link" */
  crm_link?: Maybe<Scalars['String']['output']>;
  date_of_birth?: Maybe<Scalars['date']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  default_team_id?: Maybe<Scalars['uuid']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  divorce_date?: Maybe<Scalars['date']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  email_signature?: Maybe<Scalars['String']['output']>;
  email_signature_html?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  employer_id?: Maybe<Scalars['uuid']['output']>;
  employment_commencement_date?: Maybe<Scalars['date']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  facebook_profile?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  /** Accounts blocked together (one block_fsbo_users call, or an automatic block that joined the matched account's batch) share a batch id, so they can be unblocked together. */
  fsbo_block_batch_id?: Maybe<Scalars['uuid']['output']>;
  /** Set by the block_fsbo_user action: this advertiser's FSBO listings never go live (shadow ban). NULL = not blocked. */
  fsbo_blocked_at?: Maybe<Scalars['timestamptz']['output']>;
  /** CRM user who blocked the advertiser (block_fsbo_user action). */
  fsbo_blocked_by?: Maybe<Scalars['uuid']['output']>;
  /** Free-text reason given in the CRM when the advertiser was blocked; staff only. */
  fsbo_blocked_reason?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_country_code?: Maybe<Scalars['String']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  home_address_locality?: Maybe<Scalars['String']['output']>;
  home_address_postcode?: Maybe<Scalars['String']['output']>;
  home_address_route?: Maybe<Scalars['String']['output']>;
  home_address_state?: Maybe<Scalars['String']['output']>;
  home_address_street_number?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  identification_document_expiry_date?: Maybe<Scalars['date']['output']>;
  identification_document_issue_date?: Maybe<Scalars['date']['output']>;
  identification_document_number?: Maybe<Scalars['String']['output']>;
  identification_document_type_id?: Maybe<Scalars['uuid']['output']>;
  imported_id?: Maybe<Scalars['String']['output']>;
  instagram_profile?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "generate_intercom_hash" */
  intercom_hash?: Maybe<Scalars['String']['output']>;
  job_title?: Maybe<Scalars['String']['output']>;
  landing_page_url?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['user_language']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  linked_in_profile?: Maybe<Scalars['String']['output']>;
  marital_partner_id?: Maybe<Scalars['uuid']['output']>;
  marital_status?: Maybe<Scalars['marital_status']['output']>;
  matrimonial_regime?: Maybe<Scalars['String']['output']>;
  membership_type?: Maybe<Scalars['String']['output']>;
  modules?: Maybe<Array<Scalars['String']['output']>>;
  mortgage_broker_id?: Maybe<Scalars['uuid']['output']>;
  nationality_id?: Maybe<Scalars['uuid']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  occupation_id?: Maybe<Scalars['uuid']['output']>;
  occupation_text?: Maybe<Scalars['String']['output']>;
  place_of_origin?: Maybe<Scalars['String']['output']>;
  professional_address_country_code?: Maybe<Scalars['String']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  professional_address_locality?: Maybe<Scalars['String']['output']>;
  professional_address_postcode?: Maybe<Scalars['String']['output']>;
  professional_address_route?: Maybe<Scalars['String']['output']>;
  professional_address_state?: Maybe<Scalars['String']['output']>;
  professional_address_street_number?: Maybe<Scalars['String']['output']>;
  professional_situation?: Maybe<Scalars['user_professional_situation']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  referring_domain?: Maybe<Scalars['String']['output']>;
  registered_at?: Maybe<Scalars['timestamptz']['output']>;
  residence_country_code?: Maybe<Scalars['String']['output']>;
  residence_state_id?: Maybe<Scalars['uuid']['output']>;
  second_pillar_organisation_id?: Maybe<Scalars['uuid']['output']>;
  services?: Maybe<Array<Scalars['String']['output']>>;
  social_security_number?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "users_sort_name" */
  sort_name?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "users_test_jwt" */
  test_jwt?: Maybe<Scalars['String']['output']>;
  third_pillar_a_annual_premium_organization_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_a_organisation_id?: Maybe<Scalars['uuid']['output']>;
  third_pillar_b_organisation_id?: Maybe<Scalars['uuid']['output']>;
  tiktok_profile?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  wedding_date?: Maybe<Scalars['date']['output']>;
  work_permit_id?: Maybe<Scalars['uuid']['output']>;
  x_profile?: Maybe<Scalars['String']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
  youtube_profile?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  account_manager_id?: InputMaybe<Order_By>;
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  agent_slug?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  annual_leasings?: InputMaybe<Order_By>;
  annual_other_payments?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_second_pillar_organisation?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  branding_logo?: InputMaybe<Order_By>;
  branding_name?: InputMaybe<Order_By>;
  branding_website?: InputMaybe<Order_By>;
  broker_id?: InputMaybe<Order_By>;
  certifications?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  default_team_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  divorce_date?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_signature?: InputMaybe<Order_By>;
  email_signature_html?: InputMaybe<Order_By>;
  employer?: InputMaybe<Order_By>;
  employer_id?: InputMaybe<Order_By>;
  employment_commencement_date?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  facebook_profile?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  /** Accounts blocked together (one block_fsbo_users call, or an automatic block that joined the matched account's batch) share a batch id, so they can be unblocked together. */
  fsbo_block_batch_id?: InputMaybe<Order_By>;
  /** Set by the block_fsbo_user action: this advertiser's FSBO listings never go live (shadow ban). NULL = not blocked. */
  fsbo_blocked_at?: InputMaybe<Order_By>;
  /** CRM user who blocked the advertiser (block_fsbo_user action). */
  fsbo_blocked_by?: InputMaybe<Order_By>;
  /** Free-text reason given in the CRM when the advertiser was blocked; staff only. */
  fsbo_blocked_reason?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_country_code?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  home_address_locality?: InputMaybe<Order_By>;
  home_address_postcode?: InputMaybe<Order_By>;
  home_address_route?: InputMaybe<Order_By>;
  home_address_state?: InputMaybe<Order_By>;
  home_address_street_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification_document_expiry_date?: InputMaybe<Order_By>;
  identification_document_issue_date?: InputMaybe<Order_By>;
  identification_document_number?: InputMaybe<Order_By>;
  identification_document_type_id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  instagram_profile?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  linked_in_profile?: InputMaybe<Order_By>;
  marital_partner_id?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  matrimonial_regime?: InputMaybe<Order_By>;
  membership_type?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  place_of_origin?: InputMaybe<Order_By>;
  professional_address_country_code?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  professional_address_locality?: InputMaybe<Order_By>;
  professional_address_postcode?: InputMaybe<Order_By>;
  professional_address_route?: InputMaybe<Order_By>;
  professional_address_state?: InputMaybe<Order_By>;
  professional_address_street_number?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  second_pillar_organisation_id?: InputMaybe<Order_By>;
  services?: InputMaybe<Order_By>;
  social_security_number?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Order_By>;
  third_pillar_a_organisation_id?: InputMaybe<Order_By>;
  third_pillar_b_organisation_id?: InputMaybe<Order_By>;
  tiktok_profile?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  wedding_date?: InputMaybe<Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  x_profile?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  youtube_profile?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  account_manager?: InputMaybe<Users_Order_By>;
  account_manager_id?: InputMaybe<Order_By>;
  active_since?: InputMaybe<Order_By>;
  activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  age?: InputMaybe<Order_By>;
  agent_slug?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_credits?: InputMaybe<Order_By>;
  annual_credits_exist?: InputMaybe<Order_By>;
  annual_income_additional_exist?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  annual_income_salary13?: InputMaybe<Order_By>;
  annual_income_salary14?: InputMaybe<Order_By>;
  annual_leasings?: InputMaybe<Order_By>;
  annual_leasings_exist?: InputMaybe<Order_By>;
  annual_other_exist?: InputMaybe<Order_By>;
  annual_other_payments?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_second_pillar_exist?: InputMaybe<Order_By>;
  assets_second_pillar_organisation?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_a_exist?: InputMaybe<Order_By>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_b_exist?: InputMaybe<Order_By>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation?: InputMaybe<Order_By>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Order_By>;
  assets_third_pillar_exist?: InputMaybe<Order_By>;
  assigned_activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  auto_assign_leads?: InputMaybe<Order_By>;
  branding_color?: InputMaybe<Order_By>;
  branding_logo?: InputMaybe<Order_By>;
  branding_name?: InputMaybe<Order_By>;
  branding_website?: InputMaybe<Order_By>;
  broker?: InputMaybe<Users_Order_By>;
  broker_id?: InputMaybe<Order_By>;
  broker_leads_aggregate?: InputMaybe<Lead_Agents_Aggregate_Order_By>;
  buyer_leads_aggregate?: InputMaybe<Buyer_Leads_Aggregate_Order_By>;
  buyer_offers_aggregate?: InputMaybe<Offers_Aggregate_Order_By>;
  can_edit_settings?: InputMaybe<Order_By>;
  can_user_login_as?: InputMaybe<Order_By>;
  catchment_areas_aggregate?: InputMaybe<Catchment_Areas_Aggregate_Order_By>;
  certifications?: InputMaybe<Order_By>;
  combined_reviews_aggregate?: InputMaybe<Combined_Reviews_Aggregate_Order_By>;
  created_activities_aggregate?: InputMaybe<Activities_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  created_cma_reports_aggregate?: InputMaybe<Cma_Reports_Aggregate_Order_By>;
  creator?: InputMaybe<Users_Order_By>;
  crm_link?: InputMaybe<Order_By>;
  date_of_birth?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  default_team?: InputMaybe<Teams_Order_By>;
  default_team_id?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  divorce_date?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  email_signature?: InputMaybe<Order_By>;
  email_signature_html?: InputMaybe<Order_By>;
  emails_aggregate?: InputMaybe<Emails_Aggregate_Order_By>;
  employer?: InputMaybe<Order_By>;
  employer_id?: InputMaybe<Order_By>;
  employment_commencement_date?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  enquiries_aggregate?: InputMaybe<Enquiries_Aggregate_Order_By>;
  facebook_profile?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  fsbo_block_batch_id?: InputMaybe<Order_By>;
  fsbo_blocked_at?: InputMaybe<Order_By>;
  fsbo_blocked_by?: InputMaybe<Order_By>;
  fsbo_blocked_reason?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  gender?: InputMaybe<Order_By>;
  has_accepted_terms?: InputMaybe<Order_By>;
  has_children?: InputMaybe<Order_By>;
  has_done_onboarding?: InputMaybe<Order_By>;
  has_free_crm_access?: InputMaybe<Order_By>;
  has_used_trial_button?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_country_code?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  home_address_locality?: InputMaybe<Order_By>;
  home_address_postcode?: InputMaybe<Order_By>;
  home_address_route?: InputMaybe<Order_By>;
  home_address_state?: InputMaybe<Order_By>;
  home_address_street_number?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identification_document_expiry_date?: InputMaybe<Order_By>;
  identification_document_issue_date?: InputMaybe<Order_By>;
  identification_document_number?: InputMaybe<Order_By>;
  identification_document_type_id?: InputMaybe<Order_By>;
  imported_id?: InputMaybe<Order_By>;
  instagram_profile?: InputMaybe<Order_By>;
  intercom_hash?: InputMaybe<Order_By>;
  is_admin?: InputMaybe<Order_By>;
  is_bot?: InputMaybe<Order_By>;
  is_broker?: InputMaybe<Order_By>;
  is_deleted?: InputMaybe<Order_By>;
  is_mortgage_broker?: InputMaybe<Order_By>;
  is_unclaimed?: InputMaybe<Order_By>;
  job_title?: InputMaybe<Order_By>;
  landing_page_url?: InputMaybe<Order_By>;
  language?: InputMaybe<Order_By>;
  languages?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  lead_agents_aggregate?: InputMaybe<Lead_Agents_Aggregate_Order_By>;
  leads_aggregate?: InputMaybe<Leads_Aggregate_Order_By>;
  linked_in_profile?: InputMaybe<Order_By>;
  logins_aggregate?: InputMaybe<Logins_Aggregate_Order_By>;
  lot_sellers_aggregate?: InputMaybe<Lot_Sellers_Aggregate_Order_By>;
  lots_aggregate?: InputMaybe<Lots_Aggregate_Order_By>;
  marital_partner_id?: InputMaybe<Order_By>;
  marital_status?: InputMaybe<Order_By>;
  matrimonial_regime?: InputMaybe<Order_By>;
  membership_type?: InputMaybe<Order_By>;
  module_grants_aggregate?: InputMaybe<User_Modules_Aggregate_Order_By>;
  modules?: InputMaybe<Order_By>;
  mortgage_broker_id?: InputMaybe<Order_By>;
  mv_agent?: InputMaybe<Agents_Order_By>;
  nationality?: InputMaybe<Dictionaries_Order_By>;
  nationality_id?: InputMaybe<Order_By>;
  notification_preferences_aggregate?: InputMaybe<User_Notification_Preferences_Aggregate_Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  nylas_account_config_aggregate?: InputMaybe<Nylas_Account_Configs_Aggregate_Order_By>;
  occupation_id?: InputMaybe<Order_By>;
  occupation_text?: InputMaybe<Order_By>;
  onboarding_skip_reason?: InputMaybe<Order_By>;
  onboarding_status?: InputMaybe<Order_By>;
  organisation?: InputMaybe<Organisations_Order_By>;
  organisation_user?: InputMaybe<Organisation_Users_Order_By>;
  phone_numbers_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  place_of_origin?: InputMaybe<Order_By>;
  primary_phone_number_aggregate?: InputMaybe<Phone_Numbers_Aggregate_Order_By>;
  product_experiences_aggregate?: InputMaybe<User_Product_Experiences_Aggregate_Order_By>;
  professional_address_country_code?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  professional_address_locality?: InputMaybe<Order_By>;
  professional_address_postcode?: InputMaybe<Order_By>;
  professional_address_route?: InputMaybe<Order_By>;
  professional_address_state?: InputMaybe<Order_By>;
  professional_address_street_number?: InputMaybe<Order_By>;
  professional_situation?: InputMaybe<Order_By>;
  properties_exist?: InputMaybe<Order_By>;
  property_searches_aggregate?: InputMaybe<Property_Searches_Aggregate_Order_By>;
  property_transactions_aggregate?: InputMaybe<Property_Transactions_Aggregate_Order_By>;
  push_notification_tokens_aggregate?: InputMaybe<Push_Notification_Tokens_Aggregate_Order_By>;
  recommended_listings?: InputMaybe<Order_By>;
  referrer?: InputMaybe<Order_By>;
  referring_domain?: InputMaybe<Order_By>;
  registered_at?: InputMaybe<Order_By>;
  residence_country_code?: InputMaybe<Order_By>;
  residence_state_id?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Reviews_Aggregate_Order_By>;
  second_pillar_organisation_id?: InputMaybe<Order_By>;
  services?: InputMaybe<Order_By>;
  show_in_agency_pages?: InputMaybe<Order_By>;
  social_security_number?: InputMaybe<Order_By>;
  sort_name?: InputMaybe<Order_By>;
  subscriptions_aggregate?: InputMaybe<Subscriptions_Aggregate_Order_By>;
  team_id?: InputMaybe<Order_By>;
  teams_users_aggregate?: InputMaybe<Teams_Users_Aggregate_Order_By>;
  tenant?: InputMaybe<Tenants_Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  test_jwt?: InputMaybe<Order_By>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Order_By>;
  third_pillar_a_organisation_id?: InputMaybe<Order_By>;
  third_pillar_b_organisation_id?: InputMaybe<Order_By>;
  tiktok_profile?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  updates_daily_tasks?: InputMaybe<Order_By>;
  updates_introduction_to_lead_contacts?: InputMaybe<Order_By>;
  updates_new_lead_assigned_sms?: InputMaybe<Order_By>;
  updates_newsletter?: InputMaybe<Order_By>;
  updates_property_revaluation?: InputMaybe<Order_By>;
  user_images_aggregate?: InputMaybe<User_Images_Aggregate_Order_By>;
  wedding_date?: InputMaybe<Order_By>;
  work_permit?: InputMaybe<Dictionaries_Order_By>;
  work_permit_id?: InputMaybe<Order_By>;
  x_profile?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
  youtube_profile?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  AccountManagerId = 'account_manager_id',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualCredits = 'annual_credits',
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AnnualIncomeSalary = 'annual_income_salary',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasings = 'annual_leasings',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AnnualOtherPayments = 'annual_other_payments',
  /** column name */
  AssetsSavings = 'assets_savings',
  /** column name */
  AssetsSavingsDonation = 'assets_savings_donation',
  /** column name */
  AssetsSecondPillar = 'assets_second_pillar',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsSecondPillarOrganisation = 'assets_second_pillar_organisation',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarA = 'assets_third_pillar_a',
  /** column name */
  AssetsThirdPillarAAnnualPremium = 'assets_third_pillar_a_annual_premium',
  /** column name */
  AssetsThirdPillarAAnnualPremiumOrganization = 'assets_third_pillar_a_annual_premium_organization',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarAOrganisation = 'assets_third_pillar_a_organisation',
  /** column name */
  AssetsThirdPillarAOrganisationType = 'assets_third_pillar_a_organisation_type',
  /** column name */
  AssetsThirdPillarB = 'assets_third_pillar_b',
  /** column name */
  AssetsThirdPillarBAnnualPremium = 'assets_third_pillar_b_annual_premium',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarBOrganisation = 'assets_third_pillar_b_organisation',
  /** column name */
  AssetsThirdPillarBOrganisationType = 'assets_third_pillar_b_organisation_type',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DateOfBirth = 'date_of_birth',
  /** column name */
  Debt = 'debt',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  DebtOtherCreditsBalance = 'debt_other_credits_balance',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  DivorceDate = 'divorce_date',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmailSignature = 'email_signature',
  /** column name */
  EmailSignatureHtml = 'email_signature_html',
  /** column name */
  Employer = 'employer',
  /** column name */
  EmployerId = 'employer_id',
  /** column name */
  EmploymentCommencementDate = 'employment_commencement_date',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FsboBlockBatchId = 'fsbo_block_batch_id',
  /** column name */
  FsboBlockedAt = 'fsbo_blocked_at',
  /** column name */
  FsboBlockedBy = 'fsbo_blocked_by',
  /** column name */
  FsboBlockedReason = 'fsbo_blocked_reason',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Gender = 'gender',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasDoneOnboarding = 'has_done_onboarding',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  HiresOnRealadvisor = 'hires_on_realadvisor',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLat = 'home_address_lat',
  /** column name */
  HomeAddressLng = 'home_address_lng',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  Id = 'id',
  /** column name */
  IdentificationDocumentExpiryDate = 'identification_document_expiry_date',
  /** column name */
  IdentificationDocumentIssueDate = 'identification_document_issue_date',
  /** column name */
  IdentificationDocumentNumber = 'identification_document_number',
  /** column name */
  IdentificationDocumentTypeId = 'identification_document_type_id',
  /** column name */
  ImportedId = 'imported_id',
  /** column name */
  InstagramProfile = 'instagram_profile',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  IsUnclaimed = 'is_unclaimed',
  /** column name */
  JobTitle = 'job_title',
  /** column name */
  LandingPageUrl = 'landing_page_url',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  MaritalPartnerId = 'marital_partner_id',
  /** column name */
  MaritalStatus = 'marital_status',
  /** column name */
  MatrimonialRegime = 'matrimonial_regime',
  /** column name */
  MembershipType = 'membership_type',
  /** column name */
  Modules = 'modules',
  /** column name */
  MortgageBrokerId = 'mortgage_broker_id',
  /** column name */
  NationalityId = 'nationality_id',
  /** column name */
  NumberOfBuyers = 'number_of_buyers',
  /** column name */
  NumberOfDependantChildren = 'number_of_dependant_children',
  /** column name */
  OccupationId = 'occupation_id',
  /** column name */
  OccupationText = 'occupation_text',
  /** column name */
  OnboardingSkipReason = 'onboarding_skip_reason',
  /** column name */
  OnboardingStatus = 'onboarding_status',
  /** column name */
  PlaceOfOrigin = 'place_of_origin',
  /** column name */
  ProfessionalAddressCountryCode = 'professional_address_country_code',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  ProfessionalAddressLocality = 'professional_address_locality',
  /** column name */
  ProfessionalAddressPostcode = 'professional_address_postcode',
  /** column name */
  ProfessionalAddressRoute = 'professional_address_route',
  /** column name */
  ProfessionalAddressState = 'professional_address_state',
  /** column name */
  ProfessionalAddressStreetNumber = 'professional_address_street_number',
  /** column name */
  ProfessionalSituation = 'professional_situation',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  Referrer = 'referrer',
  /** column name */
  ReferringDomain = 'referring_domain',
  /** column name */
  RegisteredAt = 'registered_at',
  /** column name */
  ResidenceCountryCode = 'residence_country_code',
  /** column name */
  ResidenceStateId = 'residence_state_id',
  /** column name */
  SecondPillarOrganisationId = 'second_pillar_organisation_id',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  SocialSecurityNumber = 'social_security_number',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  ThirdPillarAAnnualPremiumOrganizationId = 'third_pillar_a_annual_premium_organization_id',
  /** column name */
  ThirdPillarAOrganisationId = 'third_pillar_a_organisation_id',
  /** column name */
  ThirdPillarBOrganisationId = 'third_pillar_b_organisation_id',
  /** column name */
  TiktokProfile = 'tiktok_profile',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation',
  /** column name */
  WeddingDate = 'wedding_date',
  /** column name */
  WorkPermitId = 'work_permit_id',
  /** column name */
  XProfile = 'x_profile',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement',
  /** column name */
  YoutubeProfile = 'youtube_profile'
}

/** select "users_aggregate_bool_exp_avg_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasDoneOnboarding = 'has_done_onboarding',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  IsUnclaimed = 'is_unclaimed',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  AnnualCreditsExist = 'annual_credits_exist',
  /** column name */
  AnnualIncomeAdditionalExist = 'annual_income_additional_exist',
  /** column name */
  AnnualIncomeSalary13 = 'annual_income_salary13',
  /** column name */
  AnnualIncomeSalary14 = 'annual_income_salary14',
  /** column name */
  AnnualLeasingsExist = 'annual_leasings_exist',
  /** column name */
  AnnualOtherExist = 'annual_other_exist',
  /** column name */
  AssetsSecondPillarExist = 'assets_second_pillar_exist',
  /** column name */
  AssetsThirdPillarAExist = 'assets_third_pillar_a_exist',
  /** column name */
  AssetsThirdPillarALifeInsurance = 'assets_third_pillar_a_life_insurance',
  /** column name */
  AssetsThirdPillarBExist = 'assets_third_pillar_b_exist',
  /** column name */
  AssetsThirdPillarBLifeInsurance = 'assets_third_pillar_b_life_insurance',
  /** column name */
  AssetsThirdPillarExist = 'assets_third_pillar_exist',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  CanEditSettings = 'can_edit_settings',
  /** column name */
  CanUserLoginAs = 'can_user_login_as',
  /** column name */
  HasAcceptedTerms = 'has_accepted_terms',
  /** column name */
  HasChildren = 'has_children',
  /** column name */
  HasDoneOnboarding = 'has_done_onboarding',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HasUsedTrialButton = 'has_used_trial_button',
  /** column name */
  IsAdmin = 'is_admin',
  /** column name */
  IsBot = 'is_bot',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  IsMortgageBroker = 'is_mortgage_broker',
  /** column name */
  IsUnclaimed = 'is_unclaimed',
  /** column name */
  PropertiesExist = 'properties_exist',
  /** column name */
  RecommendedListings = 'recommended_listings',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  UpdatesDailyTasks = 'updates_daily_tasks',
  /** column name */
  UpdatesIntroductionToLeadContacts = 'updates_introduction_to_lead_contacts',
  /** column name */
  UpdatesNewLeadAssignedSms = 'updates_new_lead_assigned_sms',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  UpdatesPropertyRevaluation = 'updates_property_revaluation'
}

/** select "users_aggregate_bool_exp_corr_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_max_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_min_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_sum_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** select "users_aggregate_bool_exp_var_samp_arguments_columns" columns of table "users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  AnnualCostsChildSupport = 'annual_costs_child_support',
  /** column name */
  AnnualCostsLeasing = 'annual_costs_leasing',
  /** column name */
  AnnualCostsOtherCredits = 'annual_costs_other_credits',
  /** column name */
  AnnualIncomeBonus = 'annual_income_bonus',
  /** column name */
  AnnualIncomeFamilyAllowances = 'annual_income_family_allowances',
  /** column name */
  AnnualIncomeOther = 'annual_income_other',
  /** column name */
  AnnualIncomeRent = 'annual_income_rent',
  /** column name */
  AssetsSecurities = 'assets_securities',
  /** column name */
  AssetsThirdPillarACash = 'assets_third_pillar_a_cash',
  /** column name */
  DebtLeasingBalance = 'debt_leasing_balance',
  /** column name */
  DebtMortgageBalance = 'debt_mortgage_balance',
  /** column name */
  Donation = 'donation',
  /** column name */
  EmploymentRate = 'employment_rate',
  /** column name */
  LastBonus = 'last_bonus',
  /** column name */
  ProfessionalAddressLat = 'professional_address_lat',
  /** column name */
  ProfessionalAddressLng = 'professional_address_lng',
  /** column name */
  YearlyRevenuesAtRetirement = 'yearly_revenues_at_retirement'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  account_manager_id?: InputMaybe<Scalars['uuid']['input']>;
  /** The year when the agent started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agent_slug?: InputMaybe<Scalars['String']['input']>;
  auto_assign_leads?: InputMaybe<Scalars['Boolean']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  branding_logo?: InputMaybe<Scalars['String']['input']>;
  branding_name?: InputMaybe<Scalars['String']['input']>;
  branding_website?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  default_team_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebook_profile?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** True unless the user was explicitly enrolled in onboarding (claim, payment, first team add, invitation). The CRM sends a user with false to the onboarding wizard until they finish it. */
  has_done_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  has_free_crm_access?: InputMaybe<Scalars['Boolean']['input']>;
  hires_on_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_lat?: InputMaybe<Scalars['Float']['input']>;
  home_address_lng?: InputMaybe<Scalars['Float']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  instagram_profile?: InputMaybe<Scalars['String']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  /** Why a CSM skipped self-onboarding (user_onboarding_skip_reason_enum). Null when it was not skipped, and cleared when the agent is sent back into the flow. */
  onboarding_skip_reason?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Enum>;
  /** Tracks self-serve onboarding review state: in_progress, pending_review, or approved. */
  onboarding_status?: InputMaybe<User_Onboarding_Status_Enum_Enum>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  tiktok_profile?: InputMaybe<Scalars['String']['input']>;
  updates_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  x_profile?: InputMaybe<Scalars['String']['input']>;
  youtube_profile?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  account_manager_id?: InputMaybe<Scalars['uuid']['input']>;
  /** The year when the agent started operating */
  active_since?: InputMaybe<Scalars['Int']['input']>;
  agent_slug?: InputMaybe<Scalars['String']['input']>;
  annual_costs_child_support?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_leasing?: InputMaybe<Scalars['float8']['input']>;
  annual_costs_other_credits?: InputMaybe<Scalars['float8']['input']>;
  annual_credits?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_credits_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_additional_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_bonus?: InputMaybe<Scalars['float8']['input']>;
  annual_income_family_allowances?: InputMaybe<Scalars['float8']['input']>;
  annual_income_other?: InputMaybe<Scalars['float8']['input']>;
  annual_income_rent?: InputMaybe<Scalars['float8']['input']>;
  annual_income_salary?: InputMaybe<Scalars['Int']['input']>;
  annual_income_salary13?: InputMaybe<Scalars['Boolean']['input']>;
  annual_income_salary14?: InputMaybe<Scalars['Boolean']['input']>;
  annual_leasings?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  annual_leasings_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_exist?: InputMaybe<Scalars['Boolean']['input']>;
  annual_other_payments?: InputMaybe<Array<Scalars['float8']['input']>>;
  assets_savings?: InputMaybe<Scalars['Int']['input']>;
  assets_savings_donation?: InputMaybe<Scalars['Float']['input']>;
  assets_second_pillar?: InputMaybe<Scalars['Int']['input']>;
  assets_second_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_second_pillar_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_securities?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a?: InputMaybe<Scalars['Int']['input']>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_a_annual_premium_organization?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_cash?: InputMaybe<Scalars['float8']['input']>;
  assets_third_pillar_a_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_a_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_a_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_a']['input']>;
  assets_third_pillar_b?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Scalars['Float']['input']>;
  assets_third_pillar_b_exist?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_life_insurance?: InputMaybe<Scalars['Boolean']['input']>;
  assets_third_pillar_b_organisation?: InputMaybe<Scalars['String']['input']>;
  assets_third_pillar_b_organisation_type?: InputMaybe<Scalars['third_pillar_organisation_type_b']['input']>;
  assets_third_pillar_exist?: InputMaybe<Scalars['Boolean']['input']>;
  auto_assign_leads?: InputMaybe<Scalars['Boolean']['input']>;
  branding_color?: InputMaybe<Scalars['String']['input']>;
  branding_logo?: InputMaybe<Scalars['String']['input']>;
  branding_name?: InputMaybe<Scalars['String']['input']>;
  branding_website?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  can_edit_settings?: InputMaybe<Scalars['Boolean']['input']>;
  can_user_login_as?: InputMaybe<Scalars['Boolean']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  debt?: InputMaybe<Scalars['Int']['input']>;
  debt_leasing_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_mortgage_balance?: InputMaybe<Scalars['float8']['input']>;
  debt_other_credits_balance?: InputMaybe<Scalars['Int']['input']>;
  default_team_id?: InputMaybe<Scalars['uuid']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_name?: InputMaybe<Scalars['String']['input']>;
  divorce_date?: InputMaybe<Scalars['date']['input']>;
  donation?: InputMaybe<Scalars['float8']['input']>;
  email_signature?: InputMaybe<Scalars['String']['input']>;
  email_signature_html?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  employer_id?: InputMaybe<Scalars['uuid']['input']>;
  employment_commencement_date?: InputMaybe<Scalars['date']['input']>;
  employment_rate?: InputMaybe<Scalars['float8']['input']>;
  facebook_profile?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** Accounts blocked together (one block_fsbo_users call, or an automatic block that joined the matched account's batch) share a batch id, so they can be unblocked together. */
  fsbo_block_batch_id?: InputMaybe<Scalars['uuid']['input']>;
  /** Set by the block_fsbo_user action: this advertiser's FSBO listings never go live (shadow ban). NULL = not blocked. */
  fsbo_blocked_at?: InputMaybe<Scalars['timestamptz']['input']>;
  /** CRM user who blocked the advertiser (block_fsbo_user action). */
  fsbo_blocked_by?: InputMaybe<Scalars['uuid']['input']>;
  /** Free-text reason given in the CRM when the advertiser was blocked; staff only. */
  fsbo_blocked_reason?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  has_accepted_terms?: InputMaybe<Scalars['Boolean']['input']>;
  has_children?: InputMaybe<Scalars['Boolean']['input']>;
  /** True unless the user was explicitly enrolled in onboarding (claim, payment, first team add, invitation). The CRM sends a user with false to the onboarding wizard until they finish it. */
  has_done_onboarding?: InputMaybe<Scalars['Boolean']['input']>;
  has_free_crm_access?: InputMaybe<Scalars['Boolean']['input']>;
  has_used_trial_button?: InputMaybe<Scalars['Boolean']['input']>;
  hires_on_realadvisor?: InputMaybe<Scalars['Int']['input']>;
  home_address_country_code?: InputMaybe<Scalars['String']['input']>;
  home_address_lat?: InputMaybe<Scalars['Float']['input']>;
  home_address_lng?: InputMaybe<Scalars['Float']['input']>;
  home_address_locality?: InputMaybe<Scalars['String']['input']>;
  home_address_postcode?: InputMaybe<Scalars['String']['input']>;
  home_address_route?: InputMaybe<Scalars['String']['input']>;
  home_address_state?: InputMaybe<Scalars['String']['input']>;
  home_address_street_number?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identification_document_expiry_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_issue_date?: InputMaybe<Scalars['date']['input']>;
  identification_document_number?: InputMaybe<Scalars['String']['input']>;
  identification_document_type_id?: InputMaybe<Scalars['uuid']['input']>;
  imported_id?: InputMaybe<Scalars['String']['input']>;
  instagram_profile?: InputMaybe<Scalars['String']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  is_bot?: InputMaybe<Scalars['Boolean']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_deleted?: InputMaybe<Scalars['Boolean']['input']>;
  is_mortgage_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_unclaimed?: InputMaybe<Scalars['Boolean']['input']>;
  job_title?: InputMaybe<Scalars['String']['input']>;
  landing_page_url?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  last_bonus?: InputMaybe<Scalars['float8']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  marital_partner_id?: InputMaybe<Scalars['uuid']['input']>;
  marital_status?: InputMaybe<Scalars['marital_status']['input']>;
  matrimonial_regime?: InputMaybe<Scalars['String']['input']>;
  membership_type?: InputMaybe<Scalars['String']['input']>;
  modules?: InputMaybe<Array<Scalars['String']['input']>>;
  mortgage_broker_id?: InputMaybe<Scalars['uuid']['input']>;
  nationality_id?: InputMaybe<Scalars['uuid']['input']>;
  number_of_buyers?: InputMaybe<Scalars['Int']['input']>;
  number_of_dependant_children?: InputMaybe<Scalars['Int']['input']>;
  occupation_id?: InputMaybe<Scalars['uuid']['input']>;
  occupation_text?: InputMaybe<Scalars['String']['input']>;
  /** Why a CSM skipped self-onboarding (user_onboarding_skip_reason_enum). Null when it was not skipped, and cleared when the agent is sent back into the flow. */
  onboarding_skip_reason?: InputMaybe<User_Onboarding_Skip_Reason_Enum_Enum>;
  /** Tracks self-serve onboarding review state: in_progress, pending_review, or approved. */
  onboarding_status?: InputMaybe<User_Onboarding_Status_Enum_Enum>;
  place_of_origin?: InputMaybe<Scalars['String']['input']>;
  professional_address_country_code?: InputMaybe<Scalars['String']['input']>;
  professional_address_lat?: InputMaybe<Scalars['float8']['input']>;
  professional_address_lng?: InputMaybe<Scalars['float8']['input']>;
  professional_address_locality?: InputMaybe<Scalars['String']['input']>;
  professional_address_postcode?: InputMaybe<Scalars['String']['input']>;
  professional_address_route?: InputMaybe<Scalars['String']['input']>;
  professional_address_state?: InputMaybe<Scalars['String']['input']>;
  professional_address_street_number?: InputMaybe<Scalars['String']['input']>;
  professional_situation?: InputMaybe<Scalars['user_professional_situation']['input']>;
  properties_exist?: InputMaybe<Scalars['Boolean']['input']>;
  recommended_listings?: InputMaybe<Scalars['Boolean']['input']>;
  referrer?: InputMaybe<Scalars['String']['input']>;
  referring_domain?: InputMaybe<Scalars['String']['input']>;
  registered_at?: InputMaybe<Scalars['timestamptz']['input']>;
  residence_country_code?: InputMaybe<Scalars['String']['input']>;
  residence_state_id?: InputMaybe<Scalars['uuid']['input']>;
  second_pillar_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  services?: InputMaybe<Array<Scalars['String']['input']>>;
  show_in_agency_pages?: InputMaybe<Scalars['Boolean']['input']>;
  social_security_number?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_annual_premium_organization_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_a_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  third_pillar_b_organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  tiktok_profile?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  updates_daily_tasks?: InputMaybe<Scalars['Boolean']['input']>;
  updates_introduction_to_lead_contacts?: InputMaybe<Scalars['Boolean']['input']>;
  updates_new_lead_assigned_sms?: InputMaybe<Scalars['Boolean']['input']>;
  updates_newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  updates_property_revaluation?: InputMaybe<Scalars['Boolean']['input']>;
  wedding_date?: InputMaybe<Scalars['date']['input']>;
  work_permit_id?: InputMaybe<Scalars['uuid']['input']>;
  x_profile?: InputMaybe<Scalars['String']['input']>;
  yearly_revenues_at_retirement?: InputMaybe<Scalars['float8']['input']>;
  youtube_profile?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Int']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['float8']['output']>;
  annual_costs_leasing?: Maybe<Scalars['float8']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['float8']['output']>;
  annual_income_bonus?: Maybe<Scalars['float8']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['float8']['output']>;
  annual_income_other?: Maybe<Scalars['float8']['output']>;
  annual_income_rent?: Maybe<Scalars['float8']['output']>;
  annual_income_salary?: Maybe<Scalars['Int']['output']>;
  assets_savings?: Maybe<Scalars['Int']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Int']['output']>;
  assets_securities?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Int']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['float8']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Int']['output']>;
  debt_leasing_balance?: Maybe<Scalars['float8']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['float8']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Int']['output']>;
  donation?: Maybe<Scalars['float8']['output']>;
  employment_rate?: Maybe<Scalars['float8']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Int']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['float8']['output']>;
  number_of_buyers?: Maybe<Scalars['Int']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Int']['output']>;
  professional_address_lat?: Maybe<Scalars['float8']['output']>;
  professional_address_lng?: Maybe<Scalars['float8']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['float8']['output']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  AccountManagerId = 'account_manager_id',
  /** column name */
  ActiveSince = 'active_since',
  /** column name */
  AgentSlug = 'agent_slug',
  /** column name */
  AutoAssignLeads = 'auto_assign_leads',
  /** column name */
  BrandingColor = 'branding_color',
  /** column name */
  BrandingLogo = 'branding_logo',
  /** column name */
  BrandingName = 'branding_name',
  /** column name */
  BrandingWebsite = 'branding_website',
  /** column name */
  BrokerId = 'broker_id',
  /** column name */
  Certifications = 'certifications',
  /** column name */
  DefaultTeamId = 'default_team_id',
  /** column name */
  Description = 'description',
  /** column name */
  FacebookProfile = 'facebook_profile',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  HasDoneOnboarding = 'has_done_onboarding',
  /** column name */
  HasFreeCrmAccess = 'has_free_crm_access',
  /** column name */
  HiresOnRealadvisor = 'hires_on_realadvisor',
  /** column name */
  HomeAddressCountryCode = 'home_address_country_code',
  /** column name */
  HomeAddressLat = 'home_address_lat',
  /** column name */
  HomeAddressLng = 'home_address_lng',
  /** column name */
  HomeAddressLocality = 'home_address_locality',
  /** column name */
  HomeAddressPostcode = 'home_address_postcode',
  /** column name */
  HomeAddressRoute = 'home_address_route',
  /** column name */
  HomeAddressState = 'home_address_state',
  /** column name */
  HomeAddressStreetNumber = 'home_address_street_number',
  /** column name */
  InstagramProfile = 'instagram_profile',
  /** column name */
  IsBroker = 'is_broker',
  /** column name */
  IsDeleted = 'is_deleted',
  /** column name */
  Language = 'language',
  /** column name */
  Languages = 'languages',
  /** column name */
  LastName = 'last_name',
  /** column name */
  LinkedInProfile = 'linked_in_profile',
  /** column name */
  MembershipType = 'membership_type',
  /** column name */
  OnboardingSkipReason = 'onboarding_skip_reason',
  /** column name */
  OnboardingStatus = 'onboarding_status',
  /** column name */
  Services = 'services',
  /** column name */
  ShowInAgencyPages = 'show_in_agency_pages',
  /** column name */
  TiktokProfile = 'tiktok_profile',
  /** column name */
  UpdatesNewsletter = 'updates_newsletter',
  /** column name */
  XProfile = 'x_profile',
  /** column name */
  YoutubeProfile = 'youtube_profile'
}

export type Users_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  /** The year when the agent started operating */
  active_since?: Maybe<Scalars['Float']['output']>;
  /** A computed field, executes function "user_age" */
  age?: Maybe<Scalars['Int']['output']>;
  annual_costs_child_support?: Maybe<Scalars['Float']['output']>;
  annual_costs_leasing?: Maybe<Scalars['Float']['output']>;
  annual_costs_other_credits?: Maybe<Scalars['Float']['output']>;
  annual_income_bonus?: Maybe<Scalars['Float']['output']>;
  annual_income_family_allowances?: Maybe<Scalars['Float']['output']>;
  annual_income_other?: Maybe<Scalars['Float']['output']>;
  annual_income_rent?: Maybe<Scalars['Float']['output']>;
  annual_income_salary?: Maybe<Scalars['Float']['output']>;
  assets_savings?: Maybe<Scalars['Float']['output']>;
  assets_savings_donation?: Maybe<Scalars['Float']['output']>;
  assets_second_pillar?: Maybe<Scalars['Float']['output']>;
  assets_securities?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_annual_premium?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_a_cash?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b?: Maybe<Scalars['Float']['output']>;
  assets_third_pillar_b_annual_premium?: Maybe<Scalars['Float']['output']>;
  debt?: Maybe<Scalars['Float']['output']>;
  debt_leasing_balance?: Maybe<Scalars['Float']['output']>;
  debt_mortgage_balance?: Maybe<Scalars['Float']['output']>;
  debt_other_credits_balance?: Maybe<Scalars['Float']['output']>;
  donation?: Maybe<Scalars['Float']['output']>;
  employment_rate?: Maybe<Scalars['Float']['output']>;
  hires_on_realadvisor?: Maybe<Scalars['Float']['output']>;
  home_address_lat?: Maybe<Scalars['Float']['output']>;
  home_address_lng?: Maybe<Scalars['Float']['output']>;
  last_bonus?: Maybe<Scalars['Float']['output']>;
  number_of_buyers?: Maybe<Scalars['Float']['output']>;
  number_of_dependant_children?: Maybe<Scalars['Float']['output']>;
  professional_address_lat?: Maybe<Scalars['Float']['output']>;
  professional_address_lng?: Maybe<Scalars['Float']['output']>;
  yearly_revenues_at_retirement?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  /** The year when the agent started operating */
  active_since?: InputMaybe<Order_By>;
  annual_costs_child_support?: InputMaybe<Order_By>;
  annual_costs_leasing?: InputMaybe<Order_By>;
  annual_costs_other_credits?: InputMaybe<Order_By>;
  annual_income_bonus?: InputMaybe<Order_By>;
  annual_income_family_allowances?: InputMaybe<Order_By>;
  annual_income_other?: InputMaybe<Order_By>;
  annual_income_rent?: InputMaybe<Order_By>;
  annual_income_salary?: InputMaybe<Order_By>;
  assets_savings?: InputMaybe<Order_By>;
  assets_savings_donation?: InputMaybe<Order_By>;
  assets_second_pillar?: InputMaybe<Order_By>;
  assets_securities?: InputMaybe<Order_By>;
  assets_third_pillar_a?: InputMaybe<Order_By>;
  assets_third_pillar_a_annual_premium?: InputMaybe<Order_By>;
  assets_third_pillar_a_cash?: InputMaybe<Order_By>;
  assets_third_pillar_b?: InputMaybe<Order_By>;
  assets_third_pillar_b_annual_premium?: InputMaybe<Order_By>;
  debt?: InputMaybe<Order_By>;
  debt_leasing_balance?: InputMaybe<Order_By>;
  debt_mortgage_balance?: InputMaybe<Order_By>;
  debt_other_credits_balance?: InputMaybe<Order_By>;
  donation?: InputMaybe<Order_By>;
  employment_rate?: InputMaybe<Order_By>;
  hires_on_realadvisor?: InputMaybe<Order_By>;
  home_address_lat?: InputMaybe<Order_By>;
  home_address_lng?: InputMaybe<Order_By>;
  last_bonus?: InputMaybe<Order_By>;
  number_of_buyers?: InputMaybe<Order_By>;
  number_of_dependant_children?: InputMaybe<Order_By>;
  professional_address_lat?: InputMaybe<Order_By>;
  professional_address_lng?: InputMaybe<Order_By>;
  yearly_revenues_at_retirement?: InputMaybe<Order_By>;
};

/** columns and relationships of "users_view" */
export type Users_View = {
  first_name?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  primary_email?: Maybe<Scalars['citext']['output']>;
  primary_phone_number?: Maybe<Scalars['String']['output']>;
  profile_image_url?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "users_view". All fields are combined with a logical 'AND'. */
export type Users_View_Bool_Exp = {
  _and?: InputMaybe<Array<Users_View_Bool_Exp>>;
  _not?: InputMaybe<Users_View_Bool_Exp>;
  _or?: InputMaybe<Array<Users_View_Bool_Exp>>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  full_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  primary_email?: InputMaybe<Citext_Comparison_Exp>;
  primary_phone_number?: InputMaybe<String_Comparison_Exp>;
  profile_image_url?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "users_view". */
export type Users_View_Order_By = {
  first_name?: InputMaybe<Order_By>;
  full_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  primary_email?: InputMaybe<Order_By>;
  primary_phone_number?: InputMaybe<Order_By>;
  profile_image_url?: InputMaybe<Order_By>;
};

/** select columns of table "users_view" */
export enum Users_View_Select_Column {
  /** column name */
  FirstName = 'first_name',
  /** column name */
  FullName = 'full_name',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'last_name',
  /** column name */
  PrimaryEmail = 'primary_email',
  /** column name */
  PrimaryPhoneNumber = 'primary_phone_number',
  /** column name */
  ProfileImageUrl = 'profile_image_url'
}

/** Streaming cursor of the table "users_view" */
export type Users_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_View_Stream_Cursor_Value_Input = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  primary_email?: InputMaybe<Scalars['citext']['input']>;
  primary_phone_number?: InputMaybe<Scalars['String']['input']>;
  profile_image_url?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "valuation_models" */
export type Valuation_Models = {
  name: Scalars['String']['output'];
  short_name?: Maybe<Scalars['String']['output']>;
};

/** Boolean expression to filter rows from the table "valuation_models". All fields are combined with a logical 'AND'. */
export type Valuation_Models_Bool_Exp = {
  _and?: InputMaybe<Array<Valuation_Models_Bool_Exp>>;
  _not?: InputMaybe<Valuation_Models_Bool_Exp>;
  _or?: InputMaybe<Array<Valuation_Models_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
  short_name?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "valuation_models". */
export type Valuation_Models_Order_By = {
  name?: InputMaybe<Order_By>;
  short_name?: InputMaybe<Order_By>;
};

/** select columns of table "valuation_models" */
export enum Valuation_Models_Select_Column {
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'short_name'
}

/** Streaming cursor of the table "valuation_models" */
export type Valuation_Models_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Valuation_Models_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Valuation_Models_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']['input']>;
  short_name?: InputMaybe<Scalars['String']['input']>;
};

/** One row per valuation model run for an appraisal (appraisal_id -> appraisals): model, value, min and max. The estimate to quote is the one on appraisals. Very large: read it through an appraisal. */
export type Valuations = {
  /** An object relationship */
  appraisal?: Maybe<Appraisals>;
  id: Scalars['uuid']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  model: Scalars['String']['output'];
  /** An object relationship */
  valuation_model: Valuation_Models;
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by aggregate values of table "valuations" */
export type Valuations_Aggregate_Order_By = {
  avg?: InputMaybe<Valuations_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Valuations_Max_Order_By>;
  min?: InputMaybe<Valuations_Min_Order_By>;
  stddev?: InputMaybe<Valuations_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Valuations_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Valuations_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Valuations_Sum_Order_By>;
  var_pop?: InputMaybe<Valuations_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Valuations_Var_Samp_Order_By>;
  variance?: InputMaybe<Valuations_Variance_Order_By>;
};

/** order by avg() on columns of table "valuations" */
export type Valuations_Avg_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "valuations". All fields are combined with a logical 'AND'. */
export type Valuations_Bool_Exp = {
  _and?: InputMaybe<Array<Valuations_Bool_Exp>>;
  _not?: InputMaybe<Valuations_Bool_Exp>;
  _or?: InputMaybe<Array<Valuations_Bool_Exp>>;
  appraisal?: InputMaybe<Appraisals_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  max?: InputMaybe<Float_Comparison_Exp>;
  min?: InputMaybe<Float_Comparison_Exp>;
  model?: InputMaybe<String_Comparison_Exp>;
  valuation_model?: InputMaybe<Valuation_Models_Bool_Exp>;
  value?: InputMaybe<Float_Comparison_Exp>;
};

/** order by max() on columns of table "valuations" */
export type Valuations_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "valuations" */
export type Valuations_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "valuations". */
export type Valuations_Order_By = {
  appraisal?: InputMaybe<Appraisals_Order_By>;
  id?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  model?: InputMaybe<Order_By>;
  valuation_model?: InputMaybe<Valuation_Models_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "valuations" */
export enum Valuations_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Max = 'max',
  /** column name */
  Min = 'min',
  /** column name */
  Model = 'model',
  /** column name */
  Value = 'value'
}

/** order by stddev() on columns of table "valuations" */
export type Valuations_Stddev_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "valuations" */
export type Valuations_Stddev_Pop_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "valuations" */
export type Valuations_Stddev_Samp_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "valuations" */
export type Valuations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Valuations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Valuations_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** order by sum() on columns of table "valuations" */
export type Valuations_Sum_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_pop() on columns of table "valuations" */
export type Valuations_Var_Pop_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "valuations" */
export type Valuations_Var_Samp_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "valuations" */
export type Valuations_Variance_Order_By = {
  max?: InputMaybe<Order_By>;
  min?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "vector". All fields are combined with logical 'AND'. */
export type Vector_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['vector']['input']>;
  _gt?: InputMaybe<Scalars['vector']['input']>;
  _gte?: InputMaybe<Scalars['vector']['input']>;
  _in?: InputMaybe<Array<Scalars['vector']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['vector']['input']>;
  _lte?: InputMaybe<Scalars['vector']['input']>;
  _neq?: InputMaybe<Scalars['vector']['input']>;
  _nin?: InputMaybe<Array<Scalars['vector']['input']>>;
};

/** columns and relationships of "visibility_inbox_lead_agents" */
export type Visibility_Inbox_Lead_Agents = {
  /** A computed field, executes function "visibility_inbox_enquiry_reason" */
  contact_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  lead?: Maybe<Leads>;
  lead_id?: Maybe<Scalars['uuid']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "visibility_inbox_lead_agents". All fields are combined with a logical 'AND'. */
export type Visibility_Inbox_Lead_Agents_Bool_Exp = {
  _and?: InputMaybe<Array<Visibility_Inbox_Lead_Agents_Bool_Exp>>;
  _not?: InputMaybe<Visibility_Inbox_Lead_Agents_Bool_Exp>;
  _or?: InputMaybe<Array<Visibility_Inbox_Lead_Agents_Bool_Exp>>;
  contact_reason?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lead?: InputMaybe<Leads_Bool_Exp>;
  lead_id?: InputMaybe<Uuid_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "visibility_inbox_lead_agents". */
export type Visibility_Inbox_Lead_Agents_Order_By = {
  contact_reason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lead?: InputMaybe<Leads_Order_By>;
  lead_id?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "visibility_inbox_lead_agents" */
export enum Visibility_Inbox_Lead_Agents_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LeadId = 'lead_id',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "visibility_inbox_lead_agents" */
export type Visibility_Inbox_Lead_Agents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visibility_Inbox_Lead_Agents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visibility_Inbox_Lead_Agents_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lead_id?: InputMaybe<Scalars['uuid']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "visibility_inbox_profile_lead_history" */
export type Visibility_Inbox_Profile_Lead_History = {
  anonymized_contact?: Maybe<Scalars['String']['output']>;
  contact_reason?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  recipient_name?: Maybe<Scalars['String']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
};

/** Boolean expression to filter rows from the table "visibility_inbox_profile_lead_history". All fields are combined with a logical 'AND'. */
export type Visibility_Inbox_Profile_Lead_History_Bool_Exp = {
  _and?: InputMaybe<Array<Visibility_Inbox_Profile_Lead_History_Bool_Exp>>;
  _not?: InputMaybe<Visibility_Inbox_Profile_Lead_History_Bool_Exp>;
  _or?: InputMaybe<Array<Visibility_Inbox_Profile_Lead_History_Bool_Exp>>;
  anonymized_contact?: InputMaybe<String_Comparison_Exp>;
  contact_reason?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  recipient_name?: InputMaybe<String_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** Ordering options when selecting data from "visibility_inbox_profile_lead_history". */
export type Visibility_Inbox_Profile_Lead_History_Order_By = {
  anonymized_contact?: InputMaybe<Order_By>;
  contact_reason?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  recipient_name?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
};

/** select columns of table "visibility_inbox_profile_lead_history" */
export enum Visibility_Inbox_Profile_Lead_History_Select_Column {
  /** column name */
  AnonymizedContact = 'anonymized_contact',
  /** column name */
  ContactReason = 'contact_reason',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  RecipientName = 'recipient_name',
  /** column name */
  TeamId = 'team_id'
}

/** Streaming cursor of the table "visibility_inbox_profile_lead_history" */
export type Visibility_Inbox_Profile_Lead_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visibility_Inbox_Profile_Lead_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visibility_Inbox_Profile_Lead_History_Stream_Cursor_Value_Input = {
  anonymized_contact?: InputMaybe<Scalars['String']['input']>;
  contact_reason?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recipient_name?: InputMaybe<Scalars['String']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "visibility_profile_leads" */
export type Visibility_Profile_Leads = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "visibility_profile_leads" */
export type Visibility_Profile_Leads_Aggregate = {
  aggregate?: Maybe<Visibility_Profile_Leads_Aggregate_Fields>;
  nodes: Array<Visibility_Profile_Leads>;
};

/** aggregate fields of "visibility_profile_leads" */
export type Visibility_Profile_Leads_Aggregate_Fields = {
  count: Scalars['Int']['output'];
  max?: Maybe<Visibility_Profile_Leads_Max_Fields>;
  min?: Maybe<Visibility_Profile_Leads_Min_Fields>;
};


/** aggregate fields of "visibility_profile_leads" */
export type Visibility_Profile_Leads_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visibility_Profile_Leads_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "visibility_profile_leads". All fields are combined with a logical 'AND'. */
export type Visibility_Profile_Leads_Bool_Exp = {
  _and?: InputMaybe<Array<Visibility_Profile_Leads_Bool_Exp>>;
  _not?: InputMaybe<Visibility_Profile_Leads_Bool_Exp>;
  _or?: InputMaybe<Array<Visibility_Profile_Leads_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  team_id?: InputMaybe<Uuid_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** aggregate max on columns */
export type Visibility_Profile_Leads_Max_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type Visibility_Profile_Leads_Min_Fields = {
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  team_id?: Maybe<Scalars['uuid']['output']>;
  user_id?: Maybe<Scalars['uuid']['output']>;
};

/** Ordering options when selecting data from "visibility_profile_leads". */
export type Visibility_Profile_Leads_Order_By = {
  created_at?: InputMaybe<Order_By>;
  team_id?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "visibility_profile_leads" */
export enum Visibility_Profile_Leads_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  TeamId = 'team_id',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "visibility_profile_leads" */
export type Visibility_Profile_Leads_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visibility_Profile_Leads_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visibility_Profile_Leads_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  team_id?: InputMaybe<Scalars['uuid']['input']>;
  user_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** columns and relationships of "webhook_event_types_enum" */
export type Webhook_Event_Types_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "webhook_event_types_enum". All fields are combined with a logical 'AND'. */
export type Webhook_Event_Types_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Webhook_Event_Types_Enum_Bool_Exp>>;
  _not?: InputMaybe<Webhook_Event_Types_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Webhook_Event_Types_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "webhook_event_types_enum". */
export type Webhook_Event_Types_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "webhook_event_types_enum" */
export enum Webhook_Event_Types_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "webhook_event_types_enum" */
export type Webhook_Event_Types_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Webhook_Event_Types_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Webhook_Event_Types_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "webhook_subscriptions" */
export type Webhook_Subscriptions = {
  active: Scalars['Boolean']['output'];
  created_by?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  event_types: Array<Webhook_Subscriptions_Event_Types>;
  id: Scalars['uuid']['output'];
  success_counter: Scalars['Int']['output'];
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};


/** columns and relationships of "webhook_subscriptions" */
export type Webhook_SubscriptionsEvent_TypesArgs = {
  distinct_on?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Order_By>>;
  where?: InputMaybe<Webhook_Subscriptions_Event_Types_Bool_Exp>;
};

/** aggregated selection of "webhook_subscriptions" */
export type Webhook_Subscriptions_Aggregate = {
  aggregate?: Maybe<Webhook_Subscriptions_Aggregate_Fields>;
  nodes: Array<Webhook_Subscriptions>;
};

/** aggregate fields of "webhook_subscriptions" */
export type Webhook_Subscriptions_Aggregate_Fields = {
  avg?: Maybe<Webhook_Subscriptions_Avg_Fields>;
  count: Scalars['Int']['output'];
  max?: Maybe<Webhook_Subscriptions_Max_Fields>;
  min?: Maybe<Webhook_Subscriptions_Min_Fields>;
  stddev?: Maybe<Webhook_Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Webhook_Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Webhook_Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Webhook_Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Webhook_Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Webhook_Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Webhook_Subscriptions_Variance_Fields>;
};


/** aggregate fields of "webhook_subscriptions" */
export type Webhook_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Webhook_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Webhook_Subscriptions_Avg_Fields = {
  success_counter?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "webhook_subscriptions". All fields are combined with a logical 'AND'. */
export type Webhook_Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Webhook_Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Webhook_Subscriptions_Bool_Exp>>;
  active?: InputMaybe<Boolean_Comparison_Exp>;
  created_by?: InputMaybe<Uuid_Comparison_Exp>;
  event_types?: InputMaybe<Webhook_Subscriptions_Event_Types_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  success_counter?: InputMaybe<Int_Comparison_Exp>;
  tenant_id?: InputMaybe<Uuid_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "webhook_subscriptions" */
export enum Webhook_Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  WebhookSubscriptionsPkey = 'webhook_subscriptions_pkey'
}

/** columns and relationships of "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types = {
  event_type: Scalars['String']['output'];
  /** An object relationship */
  webhook_subscription: Webhook_Subscriptions;
  webhook_subscription_id: Scalars['uuid']['output'];
};

/** order by aggregate values of table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Webhook_Subscriptions_Event_Types_Max_Order_By>;
  min?: InputMaybe<Webhook_Subscriptions_Event_Types_Min_Order_By>;
};

/** input type for inserting array relation for remote table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_Arr_Rel_Insert_Input = {
  data: Array<Webhook_Subscriptions_Event_Types_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Webhook_Subscriptions_Event_Types_On_Conflict>;
};

/** Boolean expression to filter rows from the table "webhook_subscriptions_event_types". All fields are combined with a logical 'AND'. */
export type Webhook_Subscriptions_Event_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Bool_Exp>>;
  _not?: InputMaybe<Webhook_Subscriptions_Event_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Webhook_Subscriptions_Event_Types_Bool_Exp>>;
  event_type?: InputMaybe<String_Comparison_Exp>;
  webhook_subscription?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
  webhook_subscription_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "webhook_subscriptions_event_types" */
export enum Webhook_Subscriptions_Event_Types_Constraint {
  /** unique or primary key constraint on columns "event_type", "webhook_subscription_id" */
  WebhookSubscriptionsEventTypesPkey = 'webhook_subscriptions_event_types_pkey'
}

/** input type for inserting data into table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_Insert_Input = {
  event_type?: InputMaybe<Scalars['String']['input']>;
  webhook_subscription?: InputMaybe<Webhook_Subscriptions_Obj_Rel_Insert_Input>;
  webhook_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** order by max() on columns of table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_Max_Order_By = {
  event_type?: InputMaybe<Order_By>;
  webhook_subscription_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_Min_Order_By = {
  event_type?: InputMaybe<Order_By>;
  webhook_subscription_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Webhook_Subscriptions_Event_Types>;
};

/** on_conflict condition type for table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_On_Conflict = {
  constraint: Webhook_Subscriptions_Event_Types_Constraint;
  update_columns?: Array<Webhook_Subscriptions_Event_Types_Update_Column>;
  where?: InputMaybe<Webhook_Subscriptions_Event_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "webhook_subscriptions_event_types". */
export type Webhook_Subscriptions_Event_Types_Order_By = {
  event_type?: InputMaybe<Order_By>;
  webhook_subscription?: InputMaybe<Webhook_Subscriptions_Order_By>;
  webhook_subscription_id?: InputMaybe<Order_By>;
};

/** select columns of table "webhook_subscriptions_event_types" */
export enum Webhook_Subscriptions_Event_Types_Select_Column {
  /** column name */
  EventType = 'event_type',
  /** column name */
  WebhookSubscriptionId = 'webhook_subscription_id'
}

/** Streaming cursor of the table "webhook_subscriptions_event_types" */
export type Webhook_Subscriptions_Event_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Webhook_Subscriptions_Event_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Webhook_Subscriptions_Event_Types_Stream_Cursor_Value_Input = {
  event_type?: InputMaybe<Scalars['String']['input']>;
  webhook_subscription_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** placeholder for update columns of table "webhook_subscriptions_event_types" (current role has no relevant permissions) */
export enum Webhook_Subscriptions_Event_Types_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for inserting data into table "webhook_subscriptions" */
export type Webhook_Subscriptions_Insert_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  event_types?: InputMaybe<Webhook_Subscriptions_Event_Types_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  secret?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Webhook_Subscriptions_Max_Fields = {
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  success_counter?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Webhook_Subscriptions_Min_Fields = {
  created_by?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  success_counter?: Maybe<Scalars['Int']['output']>;
  tenant_id?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "webhook_subscriptions" */
export type Webhook_Subscriptions_Mutation_Response = {
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Webhook_Subscriptions>;
};

/** input type for inserting object relation for remote table "webhook_subscriptions" */
export type Webhook_Subscriptions_Obj_Rel_Insert_Input = {
  data: Webhook_Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Webhook_Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "webhook_subscriptions" */
export type Webhook_Subscriptions_On_Conflict = {
  constraint: Webhook_Subscriptions_Constraint;
  update_columns?: Array<Webhook_Subscriptions_Update_Column>;
  where?: InputMaybe<Webhook_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "webhook_subscriptions". */
export type Webhook_Subscriptions_Order_By = {
  active?: InputMaybe<Order_By>;
  created_by?: InputMaybe<Order_By>;
  event_types_aggregate?: InputMaybe<Webhook_Subscriptions_Event_Types_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  success_counter?: InputMaybe<Order_By>;
  tenant_id?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
};

/** primary key columns input for table: webhook_subscriptions */
export type Webhook_Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "webhook_subscriptions" */
export enum Webhook_Subscriptions_Select_Column {
  /** column name */
  Active = 'active',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Id = 'id',
  /** column name */
  SuccessCounter = 'success_counter',
  /** column name */
  TenantId = 'tenant_id',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

/** input type for updating data in table "webhook_subscriptions" */
export type Webhook_Subscriptions_Set_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Webhook_Subscriptions_Stddev_Fields = {
  success_counter?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Webhook_Subscriptions_Stddev_Pop_Fields = {
  success_counter?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Webhook_Subscriptions_Stddev_Samp_Fields = {
  success_counter?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "webhook_subscriptions" */
export type Webhook_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Webhook_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Webhook_Subscriptions_Stream_Cursor_Value_Input = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created_by?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  success_counter?: InputMaybe<Scalars['Int']['input']>;
  tenant_id?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Webhook_Subscriptions_Sum_Fields = {
  success_counter?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "webhook_subscriptions" */
export enum Webhook_Subscriptions_Update_Column {
  /** column name */
  Active = 'active',
  /** column name */
  Title = 'title',
  /** column name */
  Url = 'url'
}

export type Webhook_Subscriptions_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Webhook_Subscriptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Webhook_Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Webhook_Subscriptions_Var_Pop_Fields = {
  success_counter?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Webhook_Subscriptions_Var_Samp_Fields = {
  success_counter?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Webhook_Subscriptions_Variance_Fields = {
  success_counter?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "window_view_enum" */
export type Window_View_Enum = {
  comment?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Boolean expression to filter rows from the table "window_view_enum". All fields are combined with a logical 'AND'. */
export type Window_View_Enum_Bool_Exp = {
  _and?: InputMaybe<Array<Window_View_Enum_Bool_Exp>>;
  _not?: InputMaybe<Window_View_Enum_Bool_Exp>;
  _or?: InputMaybe<Array<Window_View_Enum_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

export enum Window_View_Enum_Enum {
  /** Courtyard view */
  CourtyardView = 'courtyard_view',
  /** No window */
  NoWindow = 'no_window',
  /** Street view */
  StreetView = 'street_view'
}

/** Boolean expression to compare columns of type "window_view_enum_enum". All fields are combined with logical 'AND'. */
export type Window_View_Enum_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Window_View_Enum_Enum>;
  _in?: InputMaybe<Array<Window_View_Enum_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Window_View_Enum_Enum>;
  _nin?: InputMaybe<Array<Window_View_Enum_Enum>>;
};

/** Ordering options when selecting data from "window_view_enum". */
export type Window_View_Enum_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "window_view_enum" */
export enum Window_View_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** Streaming cursor of the table "window_view_enum" */
export type Window_View_Enum_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Window_View_Enum_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Window_View_Enum_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SearchTeamsQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type SearchTeamsQuery = { search_teams_tsv: Array<{ id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }>, emails: Array<{ email: string }> }> };

export type GetTenantBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetTenantBySlugQuery = { tenants: Array<{ id: string }> };

export type UserInputFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, branding_color?: string | null, branding_logo?: string | null, branding_name?: string | null, branding_website?: string | null, primaryEmail: Array<{ email: string }>, default_team?: { organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, subscriptions: Array<{ status: any }>, primaryImage: Array<{ image: { url?: string | null } }> };

export type UserInputSearchUsersQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UserInputSearchUsersQuery = { search_users_tsv: Array<{ id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, branding_color?: string | null, branding_logo?: string | null, branding_name?: string | null, branding_website?: string | null, primaryEmail: Array<{ email: string }>, default_team?: { organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, subscriptions: Array<{ status: any }>, primaryImage: Array<{ image: { url?: string | null } }> }> };

export type UserInputDefaultTeamsUsersQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserInputDefaultTeamsUsersQuery = { users_by_pk?: { default_team?: { teams_users: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, branding_color?: string | null, branding_logo?: string | null, branding_name?: string | null, branding_website?: string | null, primaryEmail: Array<{ email: string }>, default_team?: { organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, subscriptions: Array<{ status: any }>, primaryImage: Array<{ image: { url?: string | null } }> } }> } | null } | null };

export type UserActiveModuleGrantsFragment = { module_grants: Array<{ module_id: Modules_Enum_Enum }> };

export type LotImproveDescriptionQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type LotImproveDescriptionQuery = { improve_text?: { text: string } | null };

export type GetPropertyTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertyTypesQuery = { property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, composite_type?: string | null, type: string, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null }> };

export type GetUserTeamsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserTeamsQuery = { teams_users: Array<{ team_id: string, user_id: string }> };

export type GetAssignStageQueryVariables = Exact<{
  pipeline_id: Scalars['uuid']['input'];
}>;


export type GetAssignStageQuery = { lead_stages: Array<{ id: string }> };

export type GetPropertyDuplicationDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPropertyDuplicationDataQuery = { leads_by_pk?: { id: string, property?: { id: string, property_images: Array<{ id: string }>, property_files: Array<{ file_id: string, property_id: string }> } | null } | null };

export type DocTemplateDefaultLinksFragment = { doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> };

export type GetDocTemplatesForDefaultQueryVariables = Exact<{
  types: Array<Doc_Template_Type_Enum_Enum> | Doc_Template_Type_Enum_Enum;
}>;


export type GetDocTemplatesForDefaultQuery = { doc_templates: Array<{ id: string, name: string, type: Doc_Template_Type_Enum_Enum, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }> };

export type DocTemplateThemesQueryVariables = Exact<{
  type: Doc_Template_Type_Enum_Enum;
}>;


export type DocTemplateThemesQuery = { doc_templates: Array<{ id: string, name: string }> };

export type GetPhoneNumbersTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPhoneNumbersTypesQuery = { phone_number_type_enum: Array<{ value: string }> };

export type InsertUserMutationVariables = Exact<{
  user: Users_Insert_Input;
}>;


export type InsertUserMutation = { insert_users_one?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null };

export type AgentCard_UserFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, logo?: { id: string, url?: string | null } | null } | null, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type AutoAssignRankingChQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type AutoAssignRankingChQuery = { auto_assign_ranking_ch?: { message: string, agents?: Array<{ id?: string | null, membership_type?: string | null, modules?: Array<string | null> | null, full_name?: string | null, crm_link?: string | null, total_weighted_leads_assigned?: number | null, total_leads_assigned_30_days?: number | null, total_unique_lead_visits?: number | null, total_lead_mandates?: number | null, total_own_mandates?: number | null, total_transactions?: number | null, total_commissions?: number | null, total_agent_share?: number | null, lead_to_visit_conversion?: number | null, visit_to_mandate_conversion?: number | null, mandate_to_transaction_conversion?: number | null, lead_to_transaction_conversion?: number | null, lead_to_visit_score?: number | null, visit_to_mandate_score?: number | null, mandate_to_transaction_score?: number | null, lead_to_transaction_score?: number | null, overall_score?: number | null, revenues_per_lead?: number | null, gross_margin_per_lead?: number | null, number_of_overdue_leads?: number | null, number_of_overdue_days?: number | null, number_of_leads_without_activity?: number | null, number_of_listings_available?: number | null } | null> | null } | null, leads_by_pk?: { property?: { agent_ranking?: Array<{ transactions_in_location?: number | null, transactions_in_municipality?: number | null, transactions_in_district?: number | null, transactions_in_state?: number | null, total_transactions: number, distance?: number | null, agent?: { id: string, full_name?: string | null } | null }> | null } | null } | null };

export type AutoAssignRankingQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type AutoAssignRankingQuery = { auto_assign_ranking?: { message: string, should_auto_assign?: boolean | null, assign_to?: { id?: string | null, full_name?: string | null, crm_link?: string | null } | null, agents?: Array<{ id?: string | null, full_name?: string | null, crm_link?: string | null, auto_assign_leads?: boolean | null, cost_per_lead?: number | null, amount_spent?: number | null, assigned_leads?: number | null, already_assigned?: boolean | null, subscriptions?: Array<{ id?: string | null, status?: string | null } | null> | null } | null> | null } | null };

export type SearchBuyerLeadsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchBuyerLeadsQuery = { search_buyer_leads_tsv: Array<{ id: string, user: { id: string, first_name?: string | null, last_name?: string | null }, lot: { id: string, lot_reference?: string | null, title?: string | null, property: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } } }> };

export type BuyerLeadSelectFragment = { id: string, user: { id: string, first_name?: string | null, last_name?: string | null }, lot: { id: string, lot_reference?: string | null, title?: string | null, property: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } } };

export type GetBuyerLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadQuery = { buyer_leads_by_pk?: { id: string, user: { id: string, first_name?: string | null, last_name?: string | null }, lot: { id: string, lot_reference?: string | null, title?: string | null, property: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } } } | null };

export type DevelopmentSelectFragment = { id: string, title?: string | null, status: Development_Status_Enum_Enum, development_images: Array<{ image: { id: string, url?: string | null } }>, lots: Array<{ id: string, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } }> };

export type SearchDevelopmentsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  where: Developments_Bool_Exp;
}>;


export type SearchDevelopmentsQuery = { developments: Array<{ id: string, title?: string | null, status: Development_Status_Enum_Enum, development_images: Array<{ image: { id: string, url?: string | null } }>, lots: Array<{ id: string, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } }> }> };

export type GetDefaultDevelopmentQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultDevelopmentQuery = { developments_by_pk?: { id: string, title?: string | null, status: Development_Status_Enum_Enum, development_images: Array<{ image: { id: string, url?: string | null } }>, lots: Array<{ id: string, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } }> } | null };

export type SentEmailCountOverRolling24HQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  date: Scalars['timestamptz']['input'];
}>;


export type SentEmailCountOverRolling24HQuery = { email_messages_aggregate: { aggregate?: { count: number } | null } };

export type EmailTemplateFormFragment = { id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> };

export type EmailTemplateFormEnquiryFragment = { id: string, lot?: { id: string, tenant_id: string, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type EmailTemplateFormBuyerLeadFragment = { id: string, lot: { id: string, tenant_id: string, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } };

export type EmailTemplateFormListingFragment = { id: string, tenant_id: string, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } };

export type EmailTemplateFormLeadFragment = { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }>, lead_agents: Array<{ id: string, user: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } }>, lots: Array<{ id: string, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null }>, property?: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } | null };

export type EmailTemplateFormLotSnippetDataFragment = { id: string, tenant_id: string, title?: string | null, lot_reference?: string | null, mandate_type?: string | null, rent_net?: number | null, rent_extra?: number | null, sale_price?: number | null, brochure_doc_template_id?: string | null, property: { id: string, living_surface?: number | null, number_of_rooms?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type GetEmailTemplateFormDataQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  skipUsers: Scalars['Boolean']['input'];
  skipSuggestions: Scalars['Boolean']['input'];
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
  buyerLeadId?: InputMaybe<Scalars['uuid']['input']>;
  leadId?: InputMaybe<Scalars['uuid']['input']>;
  listingId?: InputMaybe<Scalars['uuid']['input']>;
  enquiryId?: InputMaybe<Scalars['uuid']['input']>;
  developmentId?: InputMaybe<Scalars['uuid']['input']>;
  senderId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetEmailTemplateFormDataQuery = { users?: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }>, get_email_template_suggestions?: { suggestions: any } | null };

export type GetSenderSuggestionsDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSenderSuggestionsDataQuery = { users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null };

export type EmailTemplateSelectFragment = { id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> };

export type SearchEmailTemplatesQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchEmailTemplatesQuery = { email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> };

export type FeedDeleteDialogDeleteActivityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type FeedDeleteDialogDeleteActivityMutation = { delete_activities_by_pk?: { id: string } | null };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteFileMutation = { delete_files_by_pk?: { id: string } | null };

export type GetDocumentTypesQueryVariables = Exact<{
  types: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDocumentTypesQuery = { document_types: Array<{ id: string, name: string, label?: string | null }> };

export type LanguageMenuUpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  language: Scalars['user_language']['input'];
}>;


export type LanguageMenuUpdateUserMutation = { update_users_by_pk?: { id: string, language?: any | null } | null };

export type LeadLostDialogGetLostStagesQueryVariables = Exact<{
  pipeline_id: Scalars['uuid']['input'];
}>;


export type LeadLostDialogGetLostStagesQuery = { lead_stages: Array<{ id: string, label?: string | null, label_en?: string | null, status: Leads_Status_Enum }> };

export type LeadLostDialogInsertActivityMutationVariables = Exact<{
  object: Activities_Insert_Input;
}>;


export type LeadLostDialogInsertActivityMutation = { insert_activities_one?: { id: string, lead_id?: string | null } | null };

export type LeadSelectFragment = { id: string, anonymized_contact?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> };

export type SearchLeadsTsvQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where: Leads_Bool_Exp;
  orderBy?: InputMaybe<Array<Leads_Order_By> | Leads_Order_By>;
}>;


export type SearchLeadsTsvQuery = { search_leads_tsv: Array<{ id: string, anonymized_contact?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> }> };

export type SearchLeadsQueryVariables = Exact<{
  where: Leads_Bool_Exp;
  orderBy?: InputMaybe<Array<Leads_Order_By> | Leads_Order_By>;
}>;


export type SearchLeadsQuery = { leads: Array<{ id: string, anonymized_contact?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> }> };

export type GetDefaultLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultLeadQuery = { leads_by_pk?: { id: string, anonymized_contact?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }> } | null };

export type ListingCardSnippetFragment = { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type ListingPriceFragment = { offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type LotCardCarousel_LotFragment = { lot_reference?: string | null, created_at: any, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null, property: { id: string, property_images: Array<{ id: string, title?: string | null, image: { id: string, url?: string | null } }> }, portal_listings: Array<{ id: string, live: boolean }> };

export type LotCardInfo_LotFragment = { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, enquiries_aggregate: { aggregate?: { count: number } | null }, offers_aggregate: { aggregate?: { count: number } | null }, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type LightLotCardInfo_LotFragment = { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type LotGenerateDescriptionQueryVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type LotGenerateDescriptionQuery = { generate_listings_description?: { description: string } | null };

export type LotGenerateTitleQueryVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type LotGenerateTitleQuery = { generate_listing_title?: { title: string } | null };

export type LotSelectFragment = { id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null };

export type SearchLotsQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where?: InputMaybe<Lots_Bool_Exp>;
  limitToDevelopment?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SearchLotsQuery = { search_lots_tsv: Array<{ id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null }> };

export type GetDefaultLotQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultLotQuery = { lots_by_pk?: { id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null } | null };

export type MultiEmailsFieldFragment = { id: string, email: string, verified: boolean, primary: boolean };

export type CheckEmailUnicityQueryVariables = Exact<{
  checks: Emails_Bool_Exp;
}>;


export type CheckEmailUnicityQuery = { emails: Array<{ id: string }> };

export type MultiPhoneNumbersFieldFragment = { id: string, number: string, verified?: boolean | null, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null };

export type CheckPhoneNumberExistsQueryVariables = Exact<{
  checks: Phone_Numbers_Bool_Exp;
}>;


export type CheckPhoneNumberExistsQuery = { phone_numbers: Array<{ id: string }> };

export type GetLeadRefusedReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadRefusedReasonsQuery = { dictionaries: Array<{ id: string, label?: string | null }> };

export type PhoneNumberCard_Phone_NumberFragment = { id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null };

export type GetPhoneNumbersQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type GetPhoneNumbersQuery = { users_by_pk?: { id: string, phone_numbers: Array<{ id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null }> } | null, phone_number_type_enum: Array<{ value: string }> };

export type UpsertPhoneNumberMutationVariables = Exact<{
  input: Phone_Numbers_Insert_Input;
}>;


export type UpsertPhoneNumberMutation = { insert_phone_numbers_one?: { id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null, user?: { id: string, phone_numbers: Array<{ id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null }> } | null } | null };

export type UpdatePrimaryPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type UpdatePrimaryPhoneNumberMutation = { update_phone_numbers?: { affected_rows: number } | null, update_phone_numbers_by_pk?: { id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null } | null };

export type DeletePhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePhoneNumberMutation = { delete_phone_numbers?: { returning: Array<{ user?: { id: string, phone_numbers: Array<{ id: string, user_id?: string | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null, primary?: boolean | null }> } | null }> } | null };

export type PropertyPoiFragment = { distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null };

export type PortalLogoFragment = { id: string, logo?: { id: string, url?: string | null } | null };

export type PropertyDetailsFragment = { residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type PropertyFeaturesFragment = { is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null };

export type PropertyFileFragment = { property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } };

export type UpdatePropertyFileDisplayOnListingMutationVariables = Exact<{
  display: Scalars['Boolean']['input'];
  file_id: Scalars['uuid']['input'];
  property_id: Scalars['uuid']['input'];
  should_reset_non_video: Scalars['Boolean']['input'];
  should_reset_video: Scalars['Boolean']['input'];
}>;


export type UpdatePropertyFileDisplayOnListingMutation = { update_property_file?: { returning: Array<{ property_id: string, file_id: string, display_on_listing: boolean }> } | null, reset_property_files?: { returning: Array<{ property_id: string, file_id: string, display_on_listing: boolean }> } | null, reset_property_files_video?: { returning: Array<{ property_id: string, file_id: string, display_on_listing: boolean }> } | null };

export type GetSmartListsQueryVariables = Exact<{
  crmEntity: Scalars['String']['input'];
}>;


export type GetSmartListsQuery = { smart_lists: Array<{ id: string, created_at: any, name: string, where: any, is_shared: boolean, is_tenant_shared: boolean, crm_entity: string, user: { id: string, full_name?: string | null } }> };

export type UpdateSmartListMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  name: Scalars['String']['input'];
  is_shared: Scalars['Boolean']['input'];
  is_tenant_shared: Scalars['Boolean']['input'];
}>;


export type UpdateSmartListMutation = { update_smart_lists_by_pk?: { id: string, name: string, is_shared: boolean, is_tenant_shared: boolean } | null };

export type DeleteSmartListMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSmartListMutation = { delete_smart_lists_by_pk?: { id: string } | null };

export type InsertSmartListMutationVariables = Exact<{
  name: Scalars['String']['input'];
  where: Scalars['jsonb']['input'];
  crmEntity: Scalars['String']['input'];
  is_shared: Scalars['Boolean']['input'];
  is_tenant_shared: Scalars['Boolean']['input'];
}>;


export type InsertSmartListMutation = { insert_smart_lists_one?: { id: string, name: string, where: any, is_shared: boolean, is_tenant_shared: boolean, user: { id: string, full_name?: string | null } } | null };

export type GetUserEmailSubscriptionsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserEmailSubscriptionsQuery = { users_by_pk?: { auto_assign_leads?: boolean | null, id: string, emails: Array<{ subscriptions: Array<{ id: string, status: any, created_at: any, start_date: any, ended_at?: any | null, current_period_end: any, current_period_start: any, total_amount: number, items: any, customer: string, plan_name?: string | null }> }> } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  autoAssignLeads?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { update_users_by_pk?: { id: string, auto_assign_leads?: boolean | null } | null };

export type TemplateSelectFragment = { id: string, name: string, type: Doc_Template_Type_Enum_Enum };

export type SearchTemplatesQueryVariables = Exact<{
  where: Doc_Templates_Bool_Exp;
}>;


export type SearchTemplatesQuery = { doc_templates: Array<{ id: string, name: string, type: Doc_Template_Type_Enum_Enum }> };

export type TransactionCardFragment = { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type TransactionSelectFragment = { id: string, signature_date?: any | null, buyer_broker?: { id: string, full_name?: string | null } | null, seller_broker?: { id: string, full_name?: string | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type SearchTransactionsQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where?: InputMaybe<Property_Transactions_Bool_Exp>;
}>;


export type SearchTransactionsQuery = { search_property_transactions_tsv: Array<{ id: string, signature_date?: any | null, buyer_broker?: { id: string, full_name?: string | null } | null, seller_broker?: { id: string, full_name?: string | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type GetDefaultTransactionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultTransactionQuery = { property_transactions_by_pk?: { id: string, signature_date?: any | null, buyer_broker?: { id: string, full_name?: string | null } | null, seller_broker?: { id: string, full_name?: string | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type UserAvatarFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> };

export type UserCardDisplayNameFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ id: string, email: string, primary: boolean }> };

export type UserCard_UserFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type UserChipFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type ActivityBannerQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type ActivityBannerQuery = { lead_agents_aggregate: { aggregate?: { count: number } | null }, enquiries_aggregate: { aggregate?: { count: number } | null } };

export type GetAppraisalHistoryQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetAppraisalHistoryQuery = { appraisals: Array<{ id: string, min?: number | null, max?: number | null, value?: number | null, created_at: any, updated_at: any }> };

export type GetPropertyAppraisableQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetPropertyAppraisableQuery = { property_appraisable?: { appraisable: { result: boolean, errors: Array<{ path: Array<string> }> } } | null };

export type UpdateBuyerLeadsStageMultipleMutationVariables = Exact<{
  buyerLeadIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  stageId: Scalars['uuid']['input'];
}>;


export type UpdateBuyerLeadsStageMultipleMutation = { update_buyer_leads?: { returning: Array<{ id: string, stage_id?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null }> } | null };

export type DevelopmentBuyerLeadsActionToolbarFragment = { id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lots: Array<{ property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } }> };

export type GetBuyerLeadToolbarSuggestionsQueryVariables = Exact<{
  senderId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  listingId?: InputMaybe<Scalars['uuid']['input']>;
  developmentId?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
}>;


export type GetBuyerLeadToolbarSuggestionsQuery = { get_email_template_suggestions?: { suggestions: any } | null };

export type GetBuyerLeadEmailContextQueryVariables = Exact<{
  buyerLeadId: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadEmailContextQuery = { buyer_leads_by_pk?: { id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ email: string }> }, lot: { id: string, tenant_id: string, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, brochure_doc_template_id?: string | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, response_sender?: { id: string, first_name?: string | null, last_name?: string | null, title?: string | null, emails: Array<{ email: string }>, phone_numbers: Array<{ number: string }>, organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null } | null } | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, title?: string | null, emails: Array<{ email: string }>, phone_numbers: Array<{ number: string }>, organisation?: { name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, google_address?: { formatted_address?: string | null } | null, property_type?: { label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null }, enquiryResponseTemplates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, development?: { id: string, enquiry_response_override_lot: boolean, email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null } } | null, enquiries: Array<{ id: string, response_activity?: { id: string } | null }> };

export type GetBuyerLeadSuggestionsQueryVariables = Exact<{
  senderId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  buyerLeadId?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
}>;


export type GetBuyerLeadSuggestionsQuery = { get_email_template_suggestions?: { suggestions: any } | null };

export type GetDocumentRecipientStatusQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  recipientUserId: Scalars['uuid']['input'];
}>;


export type GetDocumentRecipientStatusQuery = { document_recipient_status?: { shared: boolean, shared_at?: string | null, last_open_at?: string | null, total_opens: number, unique_opens: number, unidentified_opens?: number | null, daily: Array<{ date: string, total: number, unique: number }> } | null };

export type GetBuyerLeadDetailQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadDetailQuery = { buyer_leads_by_pk?: { id: string, source?: string | null, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null } | null };

export type BuyerLeadDeleteDialogMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BuyerLeadDeleteDialogMutation = { delete_buyer_leads_by_pk?: { id: string } | null };

export type BuyerLeadDnDColumnFragment = { id: string, stage_id?: string | null, order_nr: number, source?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, mls_lot?: { id?: string | null, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null } | null };

export type GetBuyerLeadDrawerQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadDrawerQuery = { buyer_leads_by_pk?: { id: string, created_at: any, source?: string | null, stage_id?: string | null, mls_share?: { id: string, status: string, team_id: string } | null, lot: { id: string, broker_id?: string | null, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type BuyerLeadEnquiryCardEnquiryFragment = { id: string, message?: string | null, raw_email?: string | null, created_at: any, processed: boolean, portal?: { id: string, name?: string | null } | null, lot?: { id: string, enquiry_response_email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, development?: { id: string, enquiry_response_override_lot: boolean, email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null } | null, user?: { id: string, full_name?: string | null, emails: Array<{ id: string, email: string }> } | null, response_activity?: { id: string, email_message?: { id: string, status: string, date: any } | null } | null };

export type GetBuyerLeadEnquiryQueryVariables = Exact<{
  buyerLeadId: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadEnquiryQuery = { enquiries: Array<{ id: string, message?: string | null, raw_email?: string | null, created_at: any, processed: boolean, portal?: { id: string, name?: string | null } | null, lot?: { id: string, enquiry_response_email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, development?: { id: string, enquiry_response_override_lot: boolean, email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null } | null, user?: { id: string, full_name?: string | null, emails: Array<{ id: string, email: string }> } | null, response_activity?: { id: string, email_message?: { id: string, status: string, date: any } | null } | null }> };

export type GetBuyerLeadEnquiryByIdQueryVariables = Exact<{
  buyerLeadId: Scalars['uuid']['input'];
  enquiryId: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadEnquiryByIdQuery = { enquiries: Array<{ id: string, message?: string | null, raw_email?: string | null, created_at: any, processed: boolean, portal?: { id: string, name?: string | null } | null, lot?: { id: string, enquiry_response_email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, development?: { id: string, enquiry_response_override_lot: boolean, email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null } | null, user?: { id: string, full_name?: string | null, emails: Array<{ id: string, email: string }> } | null, response_activity?: { id: string, email_message?: { id: string, status: string, date: any } | null } | null }> };

export type GetBuyerLeadEnquiryResponseSuggestionsQueryVariables = Exact<{
  senderId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  enquiryId?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
}>;


export type GetBuyerLeadEnquiryResponseSuggestionsQuery = { get_email_template_suggestions?: { suggestions: any } | null };

export type GetBuyerLeadOfferQueryVariables = Exact<{
  buyerId: Scalars['uuid']['input'];
  lotId: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadOfferQuery = { offers: Array<{ id: string, amount: number, status: Offers_Status_Enum, created_at: any, lot: { id: string, currency?: string | null } }> };

export type GetBuyerLeadOtherListingsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  excludeId: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadOtherListingsQuery = { buyer_leads: Array<{ id: string, updated_at: any, lead_stage?: { id: string, label?: string | null } | null, lot: { id: string, property: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } }>, property_searches: Array<{ id: string, offer_type?: string | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, property_types: Array<{ property_type: { id: string, name?: string | null, type: string, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }>, property_searches_places: Array<{ place_id: string }> }> };

export type BuyerLeadStatusCard_BuyerLeadFragment = { id: string, created_at: any, source?: string | null, stage_id?: string | null, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } };

export type UpdateBuyerLeadStageFromStatusCardMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  stageId: Scalars['uuid']['input'];
}>;


export type UpdateBuyerLeadStageFromStatusCardMutation = { update_buyer_leads_by_pk?: { id: string, stage_id?: string | null, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null } | null };

export type UpdateBuyerLeadStageKanbanMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: Buyer_Leads_Set_Input;
}>;


export type UpdateBuyerLeadStageKanbanMutation = { update_buyer_leads_by_pk?: { id: string, stage_id?: string | null, order_nr: number, source?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, name?: string | null, label?: string | null, order_nr: number, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, mls_lot?: { id?: string | null, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null } | null } | null };

export type GetBuyerLeadStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuyerLeadStagesQuery = { lead_stages: Array<{ id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum }> };

export type CreateBuyerLeadMutationVariables = Exact<{
  buyerLead: Buyer_Leads_Insert_Input;
}>;


export type CreateBuyerLeadMutation = { insert_buyer_leads_one?: { id: string, stage_id?: string | null, order_nr: number, source?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, mls_lot?: { id?: string | null, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null } | null } | null };

export type InsertBuyerLeadsManyMutationVariables = Exact<{
  buyer_leads: Array<Buyer_Leads_Insert_Input> | Buyer_Leads_Insert_Input;
}>;


export type InsertBuyerLeadsManyMutation = { insert_buyer_leads?: { returning: Array<{ id: string, user_id: string, lot_id: string, development_id?: string | null }> } | null };

export type BuyerLeadFeedQueryVariables = Exact<{
  buyer_lead_id: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BuyerLeadFeedQuery = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, note?: string | null, extra_data?: any | null, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, user_id?: string | null, lead_id?: string | null, created_by?: string | null, created_at: any, due_at?: any | null, start_date?: string | null, pinned: boolean, visibility: string, subject?: string | null, success: boolean, done: boolean, consolidated_done_at?: any | null, assigned_to?: string | null, enquiry?: { message?: string | null, id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ image: { url?: string | null } }>, emails: Array<{ email: string }> } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null } | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null, email_message?: { to: any, cc: any, id: string, from: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> }> };

export type DefaultBuyersMatchingFiltersFragment = { id: string, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, price_unit?: string | null, property: { id: string, computed_surface?: number | null, locality_id?: string | null, places?: Array<{ id: string }> | null, property_type?: { id: string, composite_type_object?: { id: string, name?: string | null } | null } | null } };

export type ComposeEmailSentMessageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ComposeEmailSentMessageQuery = { email_messages_aggregate: { nodes: Array<{ id: string, from: any, to: any, cc: any, bcc: any, subject?: string | null, message_id?: string | null, created_by?: string | null, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> }> } };

export type GetSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSourcesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null }> };

export type GetCreateLeadContactQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCreateLeadContactQuery = { users_by_pk?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null };

export type GetCreateListingLeadDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCreateListingLeadDataQuery = { leads_by_pk?: { id: string, contact_id?: string | null, property?: { id: string, created_at: any } | null, lead_agents: Array<{ user_id: string }> } | null };

export type GetLotOriginsCreateListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotOriginsCreateListingQuery = { origins: Array<{ id: string, name: string }> };

export type GetLotOriginsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotOriginsQuery = { origins: Array<{ id: string, name: string }> };

export type GetListingDocumentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingDocumentTemplatesQuery = { lot_brochure_doc_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }> };

export type ListingCreationAddressStepFragmentFragment = { address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lat?: number | null, dummy_lng?: number | null, property: { property_type_id?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null } };

export type DevelopmentCellFragment = { id: string, title?: string | null, lots: Array<{ id: string, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } }>, main_image: Array<{ image: { id: string, url?: string | null } }> };

export type ListingCell_ListingFragment = { id: string, title?: string | null, lot_reference?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } };

export type ListingPriceCellFragment = { offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } };

export type OrganisationCell_OrganisationFragment = { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, organisation_images: Array<{ image: { url?: string | null } }> };

export type OrganisationInfoFragment = { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> };

export type PropertyCell_PropertyFragment = { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> };

export type TeamInfo_TeamFragment = { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null };

export type TransactionCellFragment = { id: string, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type UserInfo_UserFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> };

export type UserInfo_EnquiryFragment = { id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null };

export type DictionarySelectFragment = { id: string, name: string, label?: string | null, type: Dictionaries_Types_Enum_Enum };

export type GetDictionariesQueryVariables = Exact<{
  type: Dictionaries_Types_Enum_Enum;
}>;


export type GetDictionariesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null, type: Dictionaries_Types_Enum_Enum }> };

export type GetComposerContactMatchesQueryVariables = Exact<{
  emails: Array<Scalars['citext']['input']> | Scalars['citext']['input'];
}>;


export type GetComposerContactMatchesQuery = { users: Array<{ id: string, full_name?: string | null, emails: Array<{ email: string }>, leads: Array<{ id: string, created_at: any, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null }> }> };

export type ComposerSignatureQueryVariables = Exact<{ [key: string]: never; }>;


export type ComposerSignatureQuery = { get_me: { me?: { id: string, email_signature?: string | null } | null } };

export type SaveMassMailTemplateMutationVariables = Exact<{
  emailTemplate: Email_Templates_Insert_Input;
}>;


export type SaveMassMailTemplateMutation = { insert_email_templates_one?: { id: string } | null };

export type GetLotForSnippetQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetLotForSnippetQuery = { lots_by_pk?: { id: string, tenant_id: string, brochure_doc_template_id?: string | null, lot_reference?: string | null, mandate_type?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type GetDevelopmentForSnippetQueryVariables = Exact<{
  developmentId: Scalars['uuid']['input'];
}>;


export type GetDevelopmentForSnippetQuery = { developments_by_pk?: { id: string, tenant_id: string, status: Development_Status_Enum_Enum, slug: string, title?: string | null, development_images: Array<{ image: { id: string, url?: string | null } }>, lots: Array<{ id: string, property: { number_of_rooms?: number | null, living_surface?: number | null } }>, display_lot: Array<{ property: { postcode?: string | null, locality?: string | null, property_type?: { label?: string | null } | null } }> } | null };

export type GetEmailTemplateSuggestionsQueryVariables = Exact<{
  senderId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
  leadId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetEmailTemplateSuggestionsQuery = { get_email_template_suggestions?: { suggestions: any } | null };

export type GetActivityForDetailQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetActivityForDetailQuery = { activities_by_pk?: { lead_id?: string | null, user_id?: string | null, id: string, activity_type: Activity_Types_Enum_Enum, note?: string | null, extra_data?: any | null, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, created_by?: string | null, created_at: any, due_at?: any | null, start_date?: string | null, pinned: boolean, visibility: string, subject?: string | null, success: boolean, done: boolean, consolidated_done_at?: any | null, assigned_to?: string | null, enquiry?: { message?: string | null, id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { first_name?: string | null, last_name?: string | null, id: string, full_name?: string | null, emails: Array<{ email: string }> } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null } | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null, email_message?: { to: any, cc: any, id: string, from: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> } | null };

export type ActivityItemContentFragment = { id: string, activity_type: Activity_Types_Enum_Enum, subject?: string | null, extra_data?: any | null, lead_id?: string | null, assigned_to?: string | null, lot_id?: string | null, email_message?: { id: string, from: any, to: any, cc: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null };

export type AssignmentActivityItemContentFragment = { id: string, lead_id?: string | null, assigned_to?: string | null };

export type ChangeActivityItemContentFragment = { id: string, lot_id?: string | null, extra_data?: any | null };

export type EmailActivityItemContentFragment = { id: string, email_message?: { id: string, from: any, to: any, cc: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null };

export type ActivityFiltersActivityFragment = { id: string, activity_type: Activity_Types_Enum_Enum, lead_id?: string | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { contact?: { id: string, full_name?: string | null, user_images: Array<{ image: { url?: string | null } }> } | null } | null };

export type ActivityItemFragment = { id: string, activity_type: Activity_Types_Enum_Enum, note?: string | null, extra_data?: any | null, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, user_id?: string | null, created_by?: string | null, created_at: any, due_at?: any | null, lead_id?: string | null, start_date?: string | null, pinned: boolean, visibility: string, subject?: string | null, success: boolean, done: boolean, consolidated_done_at?: any | null, assigned_to?: string | null, enquiry?: { message?: string | null, id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { first_name?: string | null, last_name?: string | null, id: string, full_name?: string | null, emails: Array<{ email: string }> } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null } | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null, email_message?: { to: any, cc: any, id: string, from: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> };

export type ActivityItemHeaderFragment = { id: string, activity_type: Activity_Types_Enum_Enum, created_by?: string | null, created_at: any, due_at?: any | null, lead_id?: string | null, start_date?: string | null, pinned: boolean, visibility: string, success: boolean, done: boolean, buyer_lead_id?: string | null, enquiry_id?: string | null, lot_id?: string | null, extra_data?: any | null, consolidated_done_at?: any | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, email_message?: { to: any, cc: any } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }>, lead?: { created_by?: string | null, origin_enquiry_id?: string | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null, contact?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, emails: Array<{ email: string }> } | null } | null };

export type ActivityItemLeadSnippetFragment = { id: string, lead?: { id: string, created_at: any, contact?: { first_name?: string | null, last_name?: string | null } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null } | null };

export type LotSnippetFieldsFragment = { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type ActivityItemLotSnippetFragment = { id: string, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, enquiry?: { id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null };

export type ActivityItemUserSnippetFragment = { id: string, user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null };

export type ActivityTitleFragment = { id: string, activity_type: Activity_Types_Enum_Enum, success: boolean, done: boolean, created_by?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, lot_id?: string | null, extra_data?: any | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, email_message?: { to: any, cc: any } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }>, lead?: { created_by?: string | null, origin_enquiry_id?: string | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null, contact?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, emails: Array<{ email: string }> } | null } | null };

export type AssignmentStatusChipFragment = { id: string, done: boolean, due_at?: any | null, success: boolean, consolidated_done_at?: any | null };

export type DateTooltipContentFragment = { id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, done: boolean, consolidated_done_at?: any | null, due_at?: any | null, start_date?: string | null };

export type GenerateLeadSummaryMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GenerateLeadSummaryMutation = { generateLeadSummary?: { summary: string } | null };

export type NameLinkFragment = { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null };

export type GetUserEmailFormRecipientQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserEmailFormRecipientQuery = { users_by_pk?: { id: string, full_name?: string | null, primaryEmail: Array<{ email: string }> } | null };

export type GetActivityEmailSuggestionsQueryVariables = Exact<{
  senderId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  leadId?: InputMaybe<Scalars['uuid']['input']>;
  listingId?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
}>;


export type GetActivityEmailSuggestionsQuery = { get_email_template_suggestions?: { suggestions: any } | null };

export type ClaimLeadMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  should_create_call_activity?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ClaimLeadMutation = { claim_lead?: { id: string } | null };

export type PassLeadMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type PassLeadMutation = { refuse_lead?: { id: string } | null };

export type ActivityProviderLeadInfoQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type ActivityProviderLeadInfoQuery = { leads_by_pk?: { id: string, phone_number?: string | null, lots: Array<{ id: string }>, contact?: { id: string, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, created_at: any }> } | null } | null };

export type CallOutcomeDialogFlowCompleteCallMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  success: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type CallOutcomeDialogFlowCompleteCallMutation = { update_activities_by_pk?: { id: string } | null };

export type CallOutcomeDialogFlowGetActivityQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CallOutcomeDialogFlowGetActivityQuery = { activities_by_pk?: { id: string, note?: string | null } | null };

export type ListingActivityContextQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingActivityContextQuery = { buyer_leads: Array<{ id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lead_stage?: { id: string, label?: string | null } | null }>, lots_by_pk?: { id: string, sellers: Array<{ seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null };

export type TaskOutcomeDialogFlowCompleteTaskMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  success: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaskOutcomeDialogFlowCompleteTaskMutation = { update_activities_by_pk?: { id: string } | null };

export type LeadDetailsActivityForEditQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type LeadDetailsActivityForEditQuery = { activities_by_pk?: { id: string, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, done: boolean, success: boolean, due_at?: any | null, start_date?: string | null, end_at?: any | null, location?: string | null, assigned_to?: string | null, created_by?: string | null, created_at: any, lead_id?: string | null, lot_id?: string | null, buyer_lead_id?: string | null, user_id?: string | null, visibility: string, activities_target_users: Array<{ target_user_id?: string | null }> } | null };

export type GetUserDetailsForActivityQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type GetUserDetailsForActivityQuery = { users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null } | null };

export type GetBuyerLeadDetailsForActivityQueryVariables = Exact<{
  buyer_lead_id: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadDetailsForActivityQuery = { buyer_leads_by_pk?: { id: string, lot_id: string, user: { id: string, first_name?: string | null, last_name?: string | null } } | null };

export type GetLotDetailsForActivityQueryVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
}>;


export type GetLotDetailsForActivityQuery = { lots_by_pk?: { id: string, property: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null, google_address?: { formatted_address?: string | null } | null }, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null } }> } | null };

export type VisitOutcomeDialogFlowActivityQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type VisitOutcomeDialogFlowActivityQuery = { activities_by_pk?: { id: string, note?: string | null, assigned_to?: string | null, lead?: { id: string, lead_agents: Array<{ id: string, user_id: string, win_probability?: number | null, predicted_win_date?: string | null, lead_stage?: { id: string, status: Leads_Status_Enum, pipeline: { id: string, name?: string | null, lead_type: any } } | null }> } | null } | null, mandate_probability_types: Array<{ name: string, label?: string | null }> };

export type VisitOutcomeDialogFlowCompleteVisitAndUpdateLeadAgentMutationVariables = Exact<{
  activityId: Scalars['uuid']['input'];
  success: Scalars['Boolean']['input'];
  done_at: Scalars['timestamptz']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  shouldUpdateLeadAgent: Scalars['Boolean']['input'];
  leadAgentId: Scalars['uuid']['input'];
  win_probability?: InputMaybe<Scalars['Int']['input']>;
  predicted_win_date?: InputMaybe<Scalars['date']['input']>;
}>;


export type VisitOutcomeDialogFlowCompleteVisitAndUpdateLeadAgentMutation = { update_activities_by_pk?: { id: string } | null, update_lead_agents_by_pk?: { id: string } | null };

export type ActivityFieldsFragment = { id: string, lead_id?: string | null, user_id?: string | null, buyer_lead_id?: string | null, lot_id?: string | null, enquiry_id?: string | null, created_at: any, created_by?: string | null, assigned_to?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, start_date?: string | null, end_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, pinned: boolean, visibility: string, location?: string | null, extra_data?: any | null, email_message?: { id: string, message_id?: string | null, created_by?: string | null, from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null }> } | null, creator?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, relationship: Leads_Relationship_Enum, source: { id: string, name: string }, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, property?: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null } | null, lot?: { id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } } | null, buyer_lead?: { id: string, user: { id: string, first_name?: string | null, last_name?: string | null } } | null, enquiry?: { id: string, first_name?: string | null, last_name?: string | null } | null, activities_target_users: Array<{ target_user_id?: string | null, email?: string | null, name?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> };

export type LeadDetailsPendingActivitiesQueryVariables = Exact<{
  where: Activities_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LeadDetailsPendingActivitiesQuery = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, subject?: string | null, due_at?: any | null, start_date?: string | null, end_at?: any | null, created_at: any, note?: string | null, assigned_to?: string | null, created_by?: string | null, lead_id?: string | null, lot_id?: string | null, buyer_lead_id?: string | null, user_id?: string | null, success: boolean, done: boolean, location?: string | null, activities_target_users: Array<{ target_user_id?: string | null }> }> };

export type LeadDetailsInsertActivityMutationVariables = Exact<{
  object: Activities_Insert_Input;
}>;


export type LeadDetailsInsertActivityMutation = { insert_activities_one?: { id: string, lead_id?: string | null } | null };

export type LeadDetailsUpdateActivityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Activities_Set_Input;
  targetUsers: Array<Activities_Target_Users_Insert_Input> | Activities_Target_Users_Insert_Input;
  updateTargetUsers: Scalars['Boolean']['input'];
}>;


export type LeadDetailsUpdateActivityMutation = { delete_activities_target_users?: { affected_rows: number } | null, update_activities_by_pk?: { id: string } | null, insert_activities_target_users?: { affected_rows: number } | null };

export type UpdateActivityPinnedMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  pinned: Scalars['Boolean']['input'];
}>;


export type UpdateActivityPinnedMutation = { update_activities_by_pk?: { id: string, pinned: boolean } | null };

export type ActivityWorkflowDialogCompleteTaskMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  success: Scalars['Boolean']['input'];
}>;


export type ActivityWorkflowDialogCompleteTaskMutation = { update_activities_by_pk?: { id: string } | null };

export type BuyerLeadWorkflowGetLostStageQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerLeadWorkflowGetLostStageQuery = { lead_stages: Array<{ id: string, label?: string | null, status: Leads_Status_Enum }> };

export type BuyerLeadWorkflowGetWonStageQueryVariables = Exact<{ [key: string]: never; }>;


export type BuyerLeadWorkflowGetWonStageQuery = { lead_stages: Array<{ id: string, status: Leads_Status_Enum }> };

export type BuyerLeadWorkflowGetActivationTargetQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BuyerLeadWorkflowGetActivationTargetQuery = { buyer_leads_by_pk?: { id: string, tenant_id: string, lead_stage?: { id: string, status: Leads_Status_Enum } | null } | null, lead_stages: Array<{ id: string, status: Leads_Status_Enum }> };

export type BuyerLeadWorkflowUpdateBuyerLeadMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Buyer_Leads_Set_Input;
}>;


export type BuyerLeadWorkflowUpdateBuyerLeadMutation = { update_buyer_leads_by_pk?: { id: string, stage_id?: string | null, lead_stage?: { id: string, status: Leads_Status_Enum } | null } | null };

export type GetEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnumsQuery = { dictionaries: Array<{ name: string, label?: string | null }> };

export type GetListingsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetListingsByIdsQuery = { lots: Array<{ id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ order_nr: number, image: { id: string, url?: string | null } }> }, broker?: { id: string, full_name?: string | null } | null }> };

export type GetMlsBrokersQueryVariables = Exact<{
  selectedIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  hasSelectedIds: Scalars['Boolean']['input'];
}>;


export type GetMlsBrokersQuery = { selected_brokers?: Array<{ id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, profile_image_url?: string | null }>, initial_brokers: Array<{ id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, profile_image_url?: string | null }> };

export type SearchMlsBrokersQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchMlsBrokersQuery = { mls_brokers: Array<{ id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, profile_image_url?: string | null }> };

export type GetMlsNetworkTeamOptionsQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  selectedIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  hasSelectedIds: Scalars['Boolean']['input'];
}>;


export type GetMlsNetworkTeamOptionsQuery = { selected_teams?: Array<{ id?: string | null, name?: string | null, logo_url?: string | null }>, initial_teams: Array<{ id?: string | null, name?: string | null, logo_url?: string | null }> };

export type SearchMlsNetworkTeamsQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  search: Scalars['String']['input'];
}>;


export type SearchMlsNetworkTeamsQuery = { mls_network_teams: Array<{ id?: string | null, name?: string | null, logo_url?: string | null }> };

export type GetMlsTeamsQueryVariables = Exact<{
  selectedIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  hasSelectedIds: Scalars['Boolean']['input'];
}>;


export type GetMlsTeamsQuery = { selected_teams?: Array<{ id?: string | null, name?: string | null, logo?: { url?: string | null } | null }>, initial_teams: Array<{ id?: string | null, name?: string | null, logo?: { url?: string | null } | null }> };

export type SearchMlsTeamsQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchMlsTeamsQuery = { mls_teams: Array<{ id?: string | null, name?: string | null, logo?: { url?: string | null } | null }> };

export type GetPlacesWithParentsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPlacesWithParentsQuery = { places: Array<{ id: string, parent_places?: Array<{ id: string }> | null }> };

export type TeamFilterFragment = { id: string, name: string };

export type TeamFilterSearchTeamsQueryVariables = Exact<{
  where: Teams_Bool_Exp;
}>;


export type TeamFilterSearchTeamsQuery = { teams: Array<{ id: string, name: string }> };

export type GetTeamsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  where?: InputMaybe<Teams_Bool_Exp>;
}>;


export type GetTeamsByIdsQuery = { selected_teams: Array<{ id: string, name: string }>, initial_teams: Array<{ id: string, name: string }> };

export type UserFilterFragment = { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> };

export type UserFilterSearchUsersTsvQueryVariables = Exact<{
  q: Scalars['String']['input'];
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type UserFilterSearchUsersTsvQuery = { search_users_tsv: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type GetUsersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  isNoneSelected: Scalars['Boolean']['input'];
  where?: InputMaybe<Users_Bool_Exp>;
}>;


export type GetUsersByIdsQuery = { selected_users?: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }>, initial_users: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type GetImageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetImageQuery = { images_by_pk?: { id: string, url?: string | null } | null };

export type GetListingPreviewQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
  includeOffer: Scalars['Boolean']['input'];
  offerId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetListingPreviewQuery = { lots_by_pk?: { id: string, broker_id?: string | null, mandate_type?: string | null, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, last_accepted_offer?: Array<{ id: string, amount: number, buyer_id: string }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null };

export type EnhanceImageMutationVariables = Exact<{
  prompt: Scalars['String']['input'];
  source_image_data: Scalars['String']['input'];
  aspect_ratio?: InputMaybe<Scalars['String']['input']>;
  image_size?: InputMaybe<Scalars['String']['input']>;
}>;


export type EnhanceImageMutation = { enhance_image?: { image_data: string } | null };

export type GetUserImagesQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type GetUserImagesQuery = { user_images: Array<{ id: string, order_nr?: number | null, is_primary?: boolean | null, image: { id: string, url?: string | null } }> };

export type GetTeamImagesQueryVariables = Exact<{
  team_id: Scalars['uuid']['input'];
}>;


export type GetTeamImagesQuery = { team_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> };

export type GetOrganisationImagesQueryVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
}>;


export type GetOrganisationImagesQuery = { organisation_images: Array<{ id: string, order_nr?: number | null, image: { id: string, url?: string | null } }> };

export type InsertUserImageMutationMutationVariables = Exact<{
  object: User_Images_Insert_Input;
}>;


export type InsertUserImageMutationMutation = { insert_user_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type InsertTeamImageMutationMutationVariables = Exact<{
  object: Team_Images_Insert_Input;
}>;


export type InsertTeamImageMutationMutation = { insert_team_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type InsertOrganisationImageMutationMutationVariables = Exact<{
  object: Organisation_Images_Insert_Input;
}>;


export type InsertOrganisationImageMutationMutation = { insert_organisation_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type InsertImageOneMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type InsertImageOneMutation = { insert_images_one?: { id: string, url?: string | null } | null };

export type GetUserImagesForGalleryQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserImagesForGalleryQuery = { user_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> };

export type GetPropertyImagesForGalleryQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetPropertyImagesForGalleryQuery = { property_images: Array<{ id: string, image: { id: string, url?: string | null } }> };

export type GetTeamImagesForGalleryQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamImagesForGalleryQuery = { teams_by_pk?: { id: string, logo_image_id?: string | null, cover_photo_image_id?: string | null, team_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } | null };

export type DeleteUserImageFromGalleryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserImageFromGalleryMutation = { delete_user_images_by_pk?: { id: string } | null };

export type DeleteTeamImageFromGalleryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamImageFromGalleryMutation = { delete_team_images_by_pk?: { id: string } | null };

export type InsertTeamImageMutationVariables = Exact<{
  url: Scalars['String']['input'];
  teamId: Scalars['uuid']['input'];
}>;


export type InsertTeamImageMutation = { insert_team_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type LinkImageToTeamMutationVariables = Exact<{
  imageId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
}>;


export type LinkImageToTeamMutation = { insert_team_images_one?: { id: string, image_id: string, team_id: string } | null };

export type SetTeamImageMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  imageId: Scalars['uuid']['input'];
  isLogo: Scalars['Boolean']['input'];
}>;


export type SetTeamImageMutation = { updateLogo?: { id: string, logo_image_id?: string | null, logo?: { id: string, url?: string | null } | null } | null, updateBanner?: { id: string, cover_photo_image_id?: string | null, cover_photo?: { id: string, url?: string | null } | null } | null };

export type InsertUserImageAtomicMutationVariables = Exact<{
  url: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
  setPrimary: Scalars['Boolean']['input'];
  aiEnhancedAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type InsertUserImageAtomicMutation = { update_user_images?: { affected_rows: number } | null, insert_user_images_one?: { id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } } | null };

export type SetPrimaryImageMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  userImageId: Scalars['uuid']['input'];
}>;


export type SetPrimaryImageMutation = { update_user_images?: { affected_rows: number } | null, update_user_images_by_pk?: { id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } } | null };

export type GetMaxOrderNumberQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetMaxOrderNumberQuery = { property_images_aggregate: { aggregate?: { max?: { order_nr?: number | null } | null } | null } };

export type NewPropertyImageFragment = { __typename: 'property_images', id: string, order_nr: number, image: { __typename: 'images', id: string, url?: string | null } };

export type LeadCardFragment = { id: string, created_by?: string | null, origin_enquiry_id?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null };

export type LeadPropertyDetailFragment = { id: string, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type LeadQualificationFunnelFragment = { appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, property?: { id: string, country_code?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null } | null } | null };

export type LeadUpdatedTimeAgoFragment = { created_at: any, requalified_at?: any | null };

export type SalesLeadDetailFragment = { id: string, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_perceived_value?: number | null, appraisal_perception?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, property?: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null, id: string, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null };

export type AutoMatchingFiltersFragment = { id: string, auto_matching_filters?: any | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, price_unit?: string | null, property: { id: string, computed_surface?: number | null, locality_id?: string | null, places?: Array<{ id: string }> | null, property_type?: { id: string, composite_type_object?: { id: string, name?: string | null } | null } | null } };

export type GetAutoFilterPlacesQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAutoFilterPlacesQuery = { places: Array<{ id: string, name: string, label?: string | null, label_en?: string | null }> };

export type GetAutoFilterUsersQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAutoFilterUsersQuery = { selected_users: Array<{ id: string, full_name?: string | null }> };

export type GetAutoFilterTeamsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAutoFilterTeamsQuery = { selected_teams: Array<{ id: string, name: string }> };

export type GetAutoFilterEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutoFilterEnumsQuery = { dictionaries: Array<{ name: string, label?: string | null }> };

export type ListingBuyersAutoMatchingEmailFragment = { id: string, tenant_id: string, auto_matching_response_enabled: boolean, listing_url?: string | null, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, auto_matching_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, automatching_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } };

export type UpdateBuyerAutoMatchingEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateBuyerAutoMatchingEmailMutation = { update_lots_by_pk?: { id: string, tenant_id: string, auto_matching_response_enabled: boolean, listing_url?: string | null, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, auto_matching_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, automatching_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type ListingEnquiryResponseEmailFragment = { id: string, enquiry_response_enabled?: boolean | null, tenant_id: string, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } };

export type DevelopmentEnquiryResponseEmailFragment = { id: string, enquiry_response_enabled?: boolean | null, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null };

export type GetListingReferencesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingReferencesQuery = { get_listing_references?: { id: string, reference_aliases_encoded: Array<{ alias: string, created_at: any }>, listing?: { id: string, lot_reference?: string | null } | null } | null };

export type RefreshReferenceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RefreshReferenceMutation = { insert_lot_reference_aliases_one?: { reference_alias_decoded: number } | null };

export type MarketingFormDataFragment = { id: string, dummy_living_surface: string, dummy_usable_surface: string, listing_url?: string | null, property: { id: string, gross_floor_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null }, tenant: { id: string, country_code: string } };

export type UpdateListingMarketingFormMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateListingMarketingFormMutation = { update_lots_by_pk?: { id: string, dummy_living_surface: string, dummy_usable_surface: string, listing_url?: string | null, property: { id: string, gross_floor_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null }, tenant: { id: string, country_code: string } } | null };

export type GetEnquiryResponseTourListingQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetEnquiryResponseTourListingQuery = { active: Array<{ id: string }>, any: Array<{ id: string }>, visible: Array<{ id: string }> };

export type GetSenderDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSenderDetailsQuery = { users_by_pk?: { id: string, branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null };

export type UpsertEmailTemplateMutationVariables = Exact<{
  listingId: Scalars['uuid']['input'];
  emailTemplateId: Scalars['uuid']['input'];
  listingUpdates: Lots_Set_Input;
  emailTemplate: Email_Templates_Insert_Input;
  files: Array<Email_Templates_Files_Insert_Input> | Email_Templates_Files_Insert_Input;
}>;


export type UpsertEmailTemplateMutation = { insert_email_templates_one?: { id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> } | null, delete_email_templates_files?: { affected_rows: number } | null, insert_email_templates_files?: { returning: Array<{ email_template_id: string, file_id: string }> } | null, update_lots_by_pk?: { id: string, enquiry_response_enabled?: boolean | null, tenant_id: string, auto_matching_response_enabled: boolean, listing_url?: string | null, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, auto_matching_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, automatching_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type EmailSenderFragment = { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null };

export type ListingOverviewPublishDocumentFieldFragment = { id: string, property: { id: string, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }> } };

export type MandateFormFragment = { mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, currency?: string | null, commission_rate?: number | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, origin?: { id: string, label?: string | null, name: string } | null, property: { id: string, country_code?: string | null } };

export type ListedByOverridesListingFragment = { use_dummy_contact: boolean, fsbo_hide_phone: boolean, fsbo_hide_last_name: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null };

export type AddressOverridesListingFragment = { use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null } };

export type ListingBuyerLeadsFragment = { id: string, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null } };

export type ListingMandateCardFragment = { currency?: string | null, commission_rate?: number | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, origin?: { id: string, label?: string | null, name: string } | null, property: { id: string, country_code?: string | null } };

export type ListingMapFragment = { id: string, lat?: number | null, lng?: number | null, google_address?: { lat?: number | null, lng?: number | null } | null };

export type PortalListingButtonFragment = { id: string, broker?: { id: string, teams_users: Array<{ team_id: string }> } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> };

export type GetListingQuickActionsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingQuickActionsDataQuery = { seller_report_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }>, brochure_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }>, lots_status_enum: Array<{ value: string }> };

export type ListingQuickActionsFragment = { id: string, offer_type?: string | null, shared_on_mls_at?: any | null, broker_id?: string | null, status: Lots_Status_Enum_Enum, tenant_id: string, broker?: { id: string, teams_users: Array<{ team_id: string }> } | null, sellers: Array<{ user_id: string, seller: { id: string } }>, created_by_user?: { id: string } | null, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { increment: number, id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> };

export type GetAggregatorListingUrlQueryVariables = Exact<{
  originalId: Scalars['String']['input'];
}>;


export type GetAggregatorListingUrlQuery = { online_listings: Array<{ url: string }> };

export type ListingStatusSelectFragment = { id: string, status: Lots_Status_Enum_Enum, tenant_id: string };

export type GetListingTransactionsDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingTransactionsDataQuery = { property_transactions: Array<{ id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, updated_at?: any | null, reviewed_at?: any | null, reviewed_by?: string | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, commissions: Array<{ id: string, type?: string | null, amount?: number | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, lot?: { currency?: string | null, id: string, property: { id: string, country_code?: string | null } } | null, property: { country_code?: string | null }, sellers: Array<{ transaction_id: string, user_id: string }>, buyers: Array<{ transaction_id: string, user_id: string }> }> };

export type SellerNotificationSettingsFragment = { id: string, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum };

export type ChangeOfferStatusModalFragment = { id: string, amount: number, lot: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } };

export type OfferEditFormFragment = { id: string, amount: number, valid_until?: string | null, lot_id: string, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } };

export type OrganisationSelectFragment = { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }>, teams: Array<{ id: string, logo?: { url?: string | null } | null }> };

export type SearchOrganisationsQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type SearchOrganisationsQuery = { organisations_search: Array<{ id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }>, teams: Array<{ id: string, logo?: { url?: string | null } | null }> }> };

export type GetDefaultOrganisationQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetDefaultOrganisationQuery = { selected_organisations: Array<{ id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }>, teams: Array<{ id: string, logo?: { url?: string | null } | null }> }>, initial_organisations: Array<{ id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }>, teams: Array<{ id: string, logo?: { url?: string | null } | null }> }> };

export type SearchPlaceFragmentFragment = { id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null };

export type SearchPlacesQueryVariables = Exact<{
  q: Scalars['String']['input'];
  placeTypes: Array<Place_Type_Enum_Enum> | Place_Type_Enum_Enum;
  selectedIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type SearchPlacesQuery = { search_places: Array<{ id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null }> };

export type GetPlacesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPlacesByIdsQuery = { places: Array<{ id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null }> };

export type AutoCatchmentAreaQueryVariables = Exact<{
  x: Scalars['float8']['input'];
  y: Scalars['float8']['input'];
  target_population: Scalars['Int']['input'];
}>;


export type AutoCatchmentAreaQuery = { get_catchment_area: Array<{ id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null }> };

export type GetPlaceByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPlaceByIdQuery = { places_by_pk?: { id: string, name: string, lat: number, lng: number, label?: string | null, label_en?: string | null, population?: number | null, type: Place_Type_Enum_Enum, state?: { id: string, name: string } | null } | null };

export type ProfileLayoutAgencyQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
}>;


export type ProfileLayoutAgencyQuery = { teams: Array<{ id: string, name: string, agency_slug?: string | null, is_unclaimed: boolean, logo?: { url?: string | null } | null, teams_users: Array<{ is_leader: boolean, user: { id: string, full_name?: string | null, agent_slug?: string | null, show_in_agency_pages?: boolean | null, user_images: Array<{ image: { url?: string | null } }> } }> }> };

export type ProfileTakedownAgentMutationVariables = Exact<{ [key: string]: never; }>;


export type ProfileTakedownAgentMutation = { takedown_agent?: { success: boolean } | null };

export type ProfilePageSlackNotificationMutationVariables = Exact<{
  channel: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type ProfilePageSlackNotificationMutation = { send_slack_notification?: { success: boolean, error?: string | null } | null };

export type ProfileTakedownAgencyMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type ProfileTakedownAgencyMutation = { takedown_agency?: { success: boolean } | null };

export type GetPropertyDistancesMutationVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetPropertyDistancesMutation = { get_property_distances: { success: boolean, distances?: any | null } };

export type PropertyFormPricingFragment = { is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null };

export type PropertyAddressFragment = { street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null };

export type PropertyFormDetailsFragment = { property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type PropertyFragmentFragment = { id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type GetPropertyQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPropertyQuery = { properties_by_pk?: { id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null } | null, property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, type: string }>, heating_enum: Array<{ value: string }>, heating_distribution_enum: Array<{ value: string }>, cooling_enum: Array<{ value: string }> };

export type UpdatePropertyMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  property: Properties_Set_Input;
}>;


export type UpdatePropertyMutation = { update_properties_by_pk?: { id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, basement_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, land_surface?: number | null, garden_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_lifts?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, energy_reference_year?: number | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, energy_inspection_date?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, emissions?: number | null, consumption?: number | null, plot_number?: string | null, micro_location?: number | null, macro_location?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null } | null };

export type PropertySearchesCardPropertySearchesFragment = { id: string, created_at: any, updated_at: any, offer_type?: string | null, number_of_rooms_gte?: number | null, number_of_rooms_lte?: number | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }> };

export type DummyMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type DummyMutationMutation = { __typename: 'mutation_root' };

export type TeamsSelectFragment = { id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }> };

export type TeamsSelectQueryVariables = Exact<{
  search: Scalars['String']['input'];
  where?: InputMaybe<Teams_Bool_Exp>;
}>;


export type TeamsSelectQuery = { search_teams_tsv: Array<{ id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }> }> };

export type GetDefaultTeamsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetDefaultTeamsQuery = { teams: Array<{ id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }> }> };

export type LoadTeamsQueryVariables = Exact<{
  where?: InputMaybe<Teams_Bool_Exp>;
}>;


export type LoadTeamsQuery = { teams: Array<{ id: string, name: string, logo?: { id: string, url?: string | null } | null, team_images: Array<{ image: { url?: string | null } }> }> };

export type ReadOnlyTenantSelectFragment = { id?: string | null, name?: string | null };

export type SearchReadOnlyTenantsQueryVariables = Exact<{
  where: Read_Only_Tenants_Bool_Exp;
}>;


export type SearchReadOnlyTenantsQuery = { read_only_tenants: Array<{ id?: string | null, name?: string | null }> };

export type GetDefaultTenantQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDefaultTenantQuery = { read_only_tenants: Array<{ id?: string | null, name?: string | null }> };

export type TransactionCommissionsFormQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TransactionCommissionsFormQueryQuery = { property_transactions_by_pk?: { id: string, purchase_price?: number | null, commissions: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null }>, lot?: { id: string, currency?: string | null, mandate_type?: string | null, property: { id: string, country_code?: string | null } } | null } | null };

export type TransactionsListRowFragment = { id: string, is_published: boolean, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, commissions: Array<{ id: string, is_paid?: boolean | null, amount?: number | null }>, lot?: { id: string, currency?: string | null } | null, sellers: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, buyers: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, commissions_aggregate: { aggregate?: { sum?: { amount?: number | null } | null } | null }, my_commissions: { aggregate?: { sum?: { amount?: number | null } | null } | null }, transaction_valuations_aggregate?: { aggregate?: { count: number } | null } };

export type GetBrandingValuesQueryVariables = Exact<{
  user_id: Scalars['String']['input'];
}>;


export type GetBrandingValuesQuery = { get_valuation_link: { name?: string | null, landing_url?: string | null, valuation_url?: string | null, error?: string | null, agent_id: string, agent?: { id: string, language?: any | null, tenant_id: string, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, branding_logo?: string | null } | null } };

export type UpdateBrandingValuesMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  input: Users_Set_Input;
}>;


export type UpdateBrandingValuesMutation = { update_users_by_pk?: { id: string, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, branding_logo?: string | null } | null };

export type UpsertValuationLinkMutationVariables = Exact<{
  name: Scalars['String']['input'];
  agent_id: Scalars['String']['input'];
  tenant_id: Scalars['String']['input'];
}>;


export type UpsertValuationLinkMutation = { upsert_valuation_link?: { name?: string | null, landing_url?: string | null, valuation_url?: string | null, agent_id?: string | null, survey_id?: string | null, error?: string | null } | null };

export type UserSelectFragment = { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> };

export type SearchUsersQueryVariables = Exact<{
  q: Scalars['String']['input'];
  order_by?: InputMaybe<Array<Users_Order_By> | Users_Order_By>;
  where?: InputMaybe<Users_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUsersQuery = { search_users_tsv: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type GetDefaultUsersQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetDefaultUsersQuery = { users: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type LoadUsersQueryVariables = Exact<{
  where?: InputMaybe<Users_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LoadUsersQuery = { users: Array<{ id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> }> };

export type UserPhoneNumbersFragment = { phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }> };

export type UserEmailsFragment = { emails: Array<{ id: string, email: string, primary: boolean, verified: boolean }> };

export type ContactCardUserFragmentFragment = { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean, verified: boolean }> };

export type DummyQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DummyQueryQuery = { __typename: 'query_root' };

export type GetTeamMemberEditDetailsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetTeamMemberEditDetailsQuery = { users_by_pk?: { __typename: 'users', id: string, first_name?: string | null, last_name?: string | null, description?: string | null, facebook_profile?: string | null, instagram_profile?: string | null, tiktok_profile?: string | null, x_profile?: string | null, youtube_profile?: string | null, linked_in_profile?: string | null, services?: Array<string> | null, certifications?: Array<string> | null, languages?: Array<string> | null, hires_on_realadvisor?: number | null, active_since?: number | null, show_in_agency_pages?: boolean | null, agent_slug?: string | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null, is_visibility: boolean }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, teams_users: Array<{ team: { id: string, name: string, phone_numbers: Array<{ id: string, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, cover_photo?: { id: string, url?: string | null } | null } }>, module_grants: Array<{ module_id: Modules_Enum_Enum }> } | null };

export type GetAgentReviewsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Reviews_Order_By> | Reviews_Order_By>;
}>;


export type GetAgentReviewsQuery = { users_by_pk?: { id: string, reviews: Array<{ id: string, rating?: number | null, review_text?: string | null, completed_at?: any | null, display_name?: string | null, transaction_id?: string | null, owner_answer?: string | null, owner_answer_date?: any | null }> } | null };

export type GetAgentReviewsCountQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetAgentReviewsCountQuery = { users_by_pk?: { id: string, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } | null };

export type GetAgentTransactionsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetAgentTransactionsQuery = { property_transactions: Array<{ id: string, property_id: string, signature_date?: any | null, purchase_price?: number | null, property: { id: string, country_code?: string | null, number_of_rooms?: number | null, living_surface?: number | null, built_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, property_type?: { label?: string | null } | null, locality_place?: { label?: string | null } | null, property_images: Array<{ image: { url?: string | null } }> }, reviews_aggregate: { aggregate?: { count: number } | null }, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null } | null, seller_broker_team?: { id: string, name: string } | null }> };

export type GetAgentTransactionsCountQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetAgentTransactionsCountQuery = { property_transactions_aggregate: { aggregate?: { count: number } | null } };

export type GetAgencyOnlineListingsCountQueryVariables = Exact<{
  idx_ftp_client_id: Scalars['String']['input'];
  idx_agency_id: Scalars['String']['input'];
}>;


export type GetAgencyOnlineListingsCountQuery = { online_listings_aggregate: { aggregate?: { count: number } | null } };

export type GetAgencyOnlineListingsCountByNamesQueryVariables = Exact<{
  agency_names: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAgencyOnlineListingsCountByNamesQuery = { online_listings_aggregate: { aggregate?: { count: number } | null } };

export type GetAgencyOnlineListingsByIdxQueryVariables = Exact<{
  idx_ftp_client_id: Scalars['String']['input'];
  idx_agency_id: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetAgencyOnlineListingsByIdxQuery = { online_listings_aggregate: { aggregate?: { count: number } | null }, online_listings: Array<{ id: number, offer_type: string, property_type: string, portal: string, route?: string | null, postcode?: string | null, locality?: string | null, images?: any | null, title?: string | null, number_of_rooms?: number | null, computed_surface?: number | null, sale_price?: number | null, gross_rent_monthly?: number | null, currency?: string | null, url: string, valid_from: any }> };

export type GetAgencyOnlineListingsByNamesQueryVariables = Exact<{
  agency_names: Array<Scalars['String']['input']> | Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetAgencyOnlineListingsByNamesQuery = { online_listings_aggregate: { aggregate?: { count: number } | null }, online_listings: Array<{ id: number, offer_type: string, property_type: string, portal: string, route?: string | null, postcode?: string | null, locality?: string | null, images?: any | null, title?: string | null, number_of_rooms?: number | null, computed_surface?: number | null, sale_price?: number | null, gross_rent_monthly?: number | null, currency?: string | null, url: string, valid_from: any }> };

export type GetAgencyEditDetailsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetAgencyEditDetailsQuery = { teams_by_pk?: { __typename: 'teams', id: string, name: string, agency_slug?: string | null, description?: string | null, locality?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, state?: string | null, country?: string | null, lat?: number | null, lng?: number | null, active_since?: number | null, website_url?: string | null, facebook_url?: string | null, instagram_url?: string | null, tiktok_url?: string | null, linkedin_url?: string | null, x_url?: string | null, youtube_url?: string | null, show_in_agency_pages?: boolean | null, google_place_description?: string | null, idx_ftp_client_id?: string | null, idx_agency_id?: string | null, listings_agency_names?: Array<string> | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, logo?: { id: string, url?: string | null } | null, cover_photo?: { id: string, url?: string | null } | null, teams_users_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { count: number } | null }, teams_users: Array<{ deactivated: boolean, user: { id: string, show_in_agency_pages?: boolean | null, property_transactions_aggregate: { aggregate?: { count: number } | null } } }> } | null };

export type GetAgencyDrawerReviewsQueryVariables = Exact<{
  reviewsWhere: Reviews_Bool_Exp;
}>;


export type GetAgencyDrawerReviewsQuery = { reviews: Array<{ id: string, rating?: number | null, review_text?: string | null, completed_at?: any | null, display_name?: string | null, completed: boolean, transaction_id?: string | null, owner_answer?: string | null, owner_answer_date?: any | null }> };

export type GetAgencyReviewsCountQueryVariables = Exact<{
  reviewsWhere: Reviews_Bool_Exp;
}>;


export type GetAgencyReviewsCountQuery = { reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } };

export type GetAgencyDrawerTransactionsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetAgencyDrawerTransactionsQuery = { property_transactions: Array<{ id: string, property_id: string, signature_date?: any | null, purchase_price?: number | null, property: { id: string, number_of_rooms?: number | null, property_type?: { label?: string | null } | null, locality_place?: { label?: string | null } | null, property_images: Array<{ image: { url?: string | null } }> }, reviews_aggregate: { aggregate?: { count: number } | null }, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null } | null, seller_broker_team?: { id: string, name: string } | null }> };

export type GetAgencyTransactionsCountQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetAgencyTransactionsCountQuery = { property_transactions_aggregate: { aggregate?: { count: number } | null } };

export type InsertAndSetVisibilityPhoneMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  input: Phone_Numbers_Insert_Input;
}>;


export type InsertAndSetVisibilityPhoneMutation = { clear?: { returning: Array<{ id: string, is_visibility: boolean }> } | null, insert_phone_numbers_one?: { id: string, number: string, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null, is_visibility: boolean, user?: { id: string, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null, is_visibility: boolean }> } | null } | null };

export type ClearVisibilityPhonesMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type ClearVisibilityPhonesMutation = { update_phone_numbers?: { returning: Array<{ id: string, is_visibility: boolean }> } | null };

export type SetVisibilityPhoneMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  phoneId: Scalars['uuid']['input'];
}>;


export type SetVisibilityPhoneMutation = { clear?: { returning: Array<{ id: string, is_visibility: boolean }> } | null, update_phone_numbers_by_pk?: { id: string, is_visibility: boolean } | null };

export type GetUserImageForEnhancedActionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserImageForEnhancedActionQuery = { user_images_by_pk?: { id: string, is_primary?: boolean | null, user_id: string, image: { id: string, ai_enhanced_at?: any | null } } | null };

export type DeleteNonPrimaryUserImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type DeleteNonPrimaryUserImageMutation = { delete_user_images?: { returning: Array<{ id: string }> } | null };

export type GetTransactionByIdQueryVariables = Exact<{
  transactionId: Scalars['uuid']['input'];
}>;


export type GetTransactionByIdQuery = { property_transactions_by_pk?: { id: string, property_id: string, signature_date?: any | null, purchase_price?: number | null, property: { id: string, country_code?: string | null, number_of_rooms?: number | null, living_surface?: number | null, built_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, property_type?: { label?: string | null } | null, locality_place?: { label?: string | null } | null, property_images: Array<{ image: { url?: string | null } }> }, reviews_aggregate: { aggregate?: { count: number } | null }, reviews: Array<{ id: string, is_buyer: boolean }>, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, agent_slug?: string | null } | null, seller_broker_team?: { id: string, name: string } | null } | null };

export type LotWatermarkEnabledFragment = { id: string, watermark_enabled: boolean };

export type LotWatermarkConfigFragment = { watermark_image_url?: string | null, watermark_position: string, watermark_opacity: any, watermark_scale: any, watermark_rotation: number, watermark_position_x: number, watermark_position_y: number, id: string, watermark_enabled: boolean };

export type GetLotWatermarkConfigQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetLotWatermarkConfigQuery = { lots_by_pk?: { watermark_image_url?: string | null, watermark_position: string, watermark_opacity: any, watermark_scale: any, watermark_rotation: number, watermark_position_x: number, watermark_position_y: number, id: string, watermark_enabled: boolean } | null };

export type UpdateLotWatermarkMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateLotWatermarkMutation = { update_lots_by_pk?: { watermark_image_url?: string | null, watermark_position: string, watermark_opacity: any, watermark_scale: any, watermark_rotation: number, watermark_position_x: number, watermark_position_y: number, id: string, watermark_enabled: boolean } | null };

export type CompositeWatermarkImagesMutationVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
}>;


export type CompositeWatermarkImagesMutation = { composite_watermark_images?: { processed_count: number, skipped_count: number } | null };

export type GetLastLotWatermarkConfigQueryVariables = Exact<{
  brokerId: Scalars['uuid']['input'];
}>;


export type GetLastLotWatermarkConfigQuery = { lots: Array<{ watermark_image_url?: string | null, watermark_position: string, watermark_opacity: any, watermark_scale: any, watermark_rotation: number, watermark_position_x: number, watermark_position_y: number, id: string, watermark_enabled: boolean }> };

export type AppraisalGraphQueryVariables = Exact<{
  appraisalId: Scalars['uuid']['input'];
}>;


export type AppraisalGraphQuery = { appraisals_by_pk?: { id: string, min?: number | null, max?: number | null, value?: number | null, updated_at: any, valuations: Array<{ id: string, min?: number | null, value?: number | null, max?: number | null, model: string, valuation_model: { name: string, short_name?: string | null } }> } | null };

export type AppraisalDetailsFragment = { id: string, min?: number | null, max?: number | null, value?: number | null, updated_at: any, valuations: Array<{ id: string, min?: number | null, value?: number | null, max?: number | null, model: string, valuation_model: { name: string, short_name?: string | null } }> };

export type AppraiseMutationVariables = Exact<{
  property_id: Scalars['String']['input'];
}>;


export type AppraiseMutation = { value_property?: { appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null, updated_at: any, valuations: Array<{ id: string, min?: number | null, value?: number | null, max?: number | null, model: string, valuation_model: { name: string, short_name?: string | null } }> } | null } | null };

export type GetComposeEmailDraftQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  emails: Array<Scalars['citext']['input']> | Scalars['citext']['input'];
  fileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  templateIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  replyToIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  leadIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  buyerLeadIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  enquiryIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lotIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  contactIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetComposeEmailDraftQuery = { recipientsById: Array<{ id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ email: string, primary: boolean }> }>, recipientsByEmail: Array<{ id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ email: string, primary: boolean }> }>, files: Array<{ id: string, name: string, url: string, size: number, mimetype?: string | null }>, email_templates: Array<{ id: string, name?: string | null, subject?: string | null, subject_plaintext?: string | null, text?: string | null, add_signature: boolean, cc?: any | null, bcc?: any | null, email_templates_files: Array<{ file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, email_messages_aggregate: { nodes: Array<{ id: string, message_id?: string | null, created_by?: string | null, subject?: string | null, from: any, cc: any, bcc: any, date: any }> }, leads: Array<{ id: string, first_name?: string | null, last_name?: string | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }>, buyer_leads: Array<{ id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null }, mls_user?: { id?: string | null } | null, lot: { id: string, title?: string | null } }>, enquiries: Array<{ id: string, first_name?: string | null, last_name?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, lot?: { id: string, title?: string | null } | null }>, lots: Array<{ id: string, title?: string | null }>, contacts: Array<{ id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null }> };

export type GetComposeEmailTemplateSuggestionsQueryVariables = Exact<{
  senderId?: InputMaybe<Scalars['uuid']['input']>;
  recipients?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  leadId?: InputMaybe<Scalars['uuid']['input']>;
  listingId?: InputMaybe<Scalars['uuid']['input']>;
  buyerLeadId?: InputMaybe<Scalars['uuid']['input']>;
  enquiryId?: InputMaybe<Scalars['uuid']['input']>;
  language?: InputMaybe<GetEmailTemplateSuggestionsLanguage>;
}>;


export type GetComposeEmailTemplateSuggestionsQuery = { get_email_template_suggestions?: { suggestions: any } | null };

export type InsertLeadMutationVariables = Exact<{
  input: Leads_Insert_Input;
  lead_id: Scalars['uuid']['input'];
  broker_id: Scalars['uuid']['input'];
  include_call_activity: Scalars['Boolean']['input'];
  claimed_at: Scalars['timestamptz']['input'];
  stage_id: Scalars['uuid']['input'];
  origination_activity: Activities_Insert_Input;
  assignment_activity: Activities_Insert_Input;
  call_activity: Activities_Insert_Input;
}>;


export type InsertLeadMutation = { insert_leads_one?: { id: string, property_id?: string | null } | null, origination?: { id: string } | null, assignment?: { id: string } | null, call?: { id: string, activities_target_users: Array<{ target_user_id?: string | null }> } | null, insert_lead_agents_one?: { id: string } | null };

export type GetLeadMetadataQueryVariables = Exact<{
  sourceName: Scalars['String']['input'];
}>;


export type GetLeadMetadataQuery = { pipelines: Array<{ id: string, stages: Array<{ id: string, name?: string | null }> }>, dictionaries: Array<{ id: string }> };

export type ClaimAgencyMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type ClaimAgencyMutation = { claim_agency?: { success: boolean } | null };

export type StartTrialMutationVariables = Exact<{ [key: string]: never; }>;


export type StartTrialMutation = { start_trial?: { success: boolean } | null };

export type ClaimAgentMutationVariables = Exact<{ [key: string]: never; }>;


export type ClaimAgentMutation = { claim_agent?: { success: boolean } | null };

export type GetTeamBrokerOptionsQueryVariables = Exact<{
  team_id: Scalars['uuid']['input'];
}>;


export type GetTeamBrokerOptionsQuery = { teams_users: Array<{ user: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type GetTeamHasPublicPageQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  publishedAgentsWhere: Teams_Users_Bool_Exp;
}>;


export type GetTeamHasPublicPageQuery = { teams_by_pk?: { id: string, show_in_agency_pages?: boolean | null, teams_users: Array<{ user_id: string }> } | null };

export type GetTenantIntegrationsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTenantIntegrationsQuery = { stripe: { aggregate?: { count: number } | null }, close: { aggregate?: { count: number } | null } };

export type NewPortalListingFragment = { __typename: 'portal_listings', id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean }, lot: { id: string, status: Lots_Status_Enum_Enum } };

export type GetVisibilityStatsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  hostname: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetVisibilityStatsQuery = { impressions_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null, average_position?: number | null }> | null } | null, views_data?: { user_count: number } | null, phone_clicks_data?: { user_count: number } | null, impressions_by_locality?: { data?: Array<{ count?: number | null, average_position?: number | null }> | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { get_me: { user_ids_in_led_teams?: Array<string> | null, show_plans: string, claimed_at?: any | null, me?: { id: string, created_at: any, is_admin: boolean, is_broker: boolean, onboarding_status?: User_Onboarding_Status_Enum_Enum | null, has_done_onboarding: boolean, title?: string | null, language?: any | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, has_used_trial_button: boolean, has_free_crm_access: boolean, is_unclaimed: boolean, auto_assign_leads?: boolean | null, can_user_login_as: boolean, can_edit_settings?: boolean | null, show_in_agency_pages?: boolean | null, agent_slug?: string | null, tenant_id: string, intercom_hash?: string | null, email_signature?: string | null, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null, default_team?: { id: string, name: string, lng?: number | null, lat?: number | null, show_in_agency_pages?: boolean | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, listings_agency_names?: Array<string> | null } | null, teams_users: Array<{ team_id: string }>, emails: Array<{ id: string, email: string, primary: boolean, verified: boolean }>, tenant: { slug: string, id: string, name: string, country_code: string, lng?: number | null, lat?: number | null, default_pipeline_id: string, image?: { url?: string | null } | null }, subscriptions: Array<{ status: any, customer: string }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, teams: Array<{ is_leader: boolean, team_id: string, team: { id: string, name: string, organisation_id?: string | null, listings_agency_names?: Array<string> | null } }>, nylas_account: Array<{ id: string, invalid: boolean, self_username?: string | null }>, module_grants: Array<{ module_id: Modules_Enum_Enum }> } | null } };

export type ContactRequestEnquiryFragment = { id: string, created_at: any, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, contact_reason?: string | null, message?: string | null, broker?: { full_name?: string | null } | null, team?: { name: string } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, property: { country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, living_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, id: string, computed_surface?: number | null, land_surface?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> }, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }> } | null };

export type EmailUserFragment = { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null };

export type EmailPropertyFragment = { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null };

export type EmailListingFragment = { title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null };

export type PrepareUploadMutationVariables = Exact<{
  id: Scalars['String']['input'];
  file_type: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
  mime_type: Scalars['String']['input'];
}>;


export type PrepareUploadMutation = { prepare_upload?: { id: string, url: string, signed_url: string } | null };

export type LeadAppraisalLocationFragment = { appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null };

export type TrackedDocumentUrlMutationVariables = Exact<{
  url: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackedDocumentUrlMutation = { tracked_document_url?: { url: string } | null };

export type NoAccessQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type NoAccessQuery = { users: Array<{ display_name?: string | null, phone_numbers: Array<{ number: string }>, emails: Array<{ email: string }> }> };

export type GetBuyerLeadsQueryVariables = Exact<{
  where: Buyer_Leads_Bool_Exp;
  order_by: Array<Buyer_Leads_Order_By> | Buyer_Leads_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetBuyerLeadsQuery = { buyer_leads: Array<{ id: string, created_at: any, updated_at: any, source?: string | null, lead_stage?: { id: string, name?: string | null, label?: string | null } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, title?: string | null, lot_reference?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } } }> };

export type GetBuyerLeadsCountQueryVariables = Exact<{
  where: Buyer_Leads_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBuyerLeadsCountQuery = { buyer_leads_aggregate: { aggregate?: { count: number } | null } };

export type ImportBuyerLeadsMutationVariables = Exact<{
  objects: Array<BuyerLeadImportInput> | BuyerLeadImportInput;
}>;


export type ImportBuyerLeadsMutation = { import_buyer_leads?: Array<{ buyer_lead_id?: string | null }> | null };

export type DeleteBuyerLeadsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteBuyerLeadsMutation = { delete_buyer_leads?: { affected_rows: number } | null };

export type ClaimProfileImpressionsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  userId?: InputMaybe<Scalars['uuid']['input']>;
  hostname: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  eventNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ClaimProfileImpressionsQuery = { impressions_total?: { count: number } | null };

export type DashboardActivityPropertyFragment = { street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, country?: string | null };

export type GetDashboardUserDataQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
}>;


export type GetDashboardUserDataQuery = { users_by_pk?: { show_in_agency_pages?: boolean | null, agent_slug?: string | null, languages?: Array<string> | null, active_since?: number | null, description?: string | null, services?: Array<string> | null, certifications?: Array<string> | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, cover_photo?: { id: string, url?: string | null } | null } | null, transactions: { aggregate?: { count: number } | null }, all_reviews_count: { aggregate?: { count: number } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null };

export type GetDashboardNewEnquiriesQueryVariables = Exact<{
  where: Enquiries_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDashboardNewEnquiriesQuery = { enquiries: Array<{ id: string, first_name?: string | null, last_name?: string | null, created_at: any, processed: boolean, source?: Enquiries_Source_Enum_Enum | null, buyer_lead?: { id: string, user: { first_name?: string | null, last_name?: string | null } } | null, portal?: { id: string, name?: string | null } | null, lot?: { id: string, title?: string | null, property: { street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, country?: string | null, property_images: Array<{ image: { url?: string | null } }> } } | null }>, enquiries_aggregate?: { aggregate?: { count: number } | null } };

export type GetDashboardNewLeadsQueryVariables = Exact<{
  where: Leads_Bool_Exp;
  leadAgentsWhere?: InputMaybe<Lead_Agents_Bool_Exp>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDashboardNewLeadsQuery = { leads: Array<{ id: string, created_at: any, updated_at: any, requalified_or_created_at?: any | null, created_by?: string | null, origin_enquiry_id?: string | null, completed: boolean, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_perception?: string | null, appraisal_perceived_value?: number | null, anonymized_contact?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, relationship: Leads_Relationship_Enum, ownership?: any | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, appraisal_open_to_offer?: string | null, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, lead_agents_aggregate: { aggregate?: { max?: { created_at?: any | null } | null } | null }, lead_agents: Array<{ id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, user_id: string, user: { id: string, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }>, property?: { country_code?: string | null, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { label?: string | null, name?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, contact?: { first_name?: string | null, last_name?: string | null } | null }>, leads_aggregate?: { aggregate?: { count: number } | null } };

export type GetTeamVisibilityStatusQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamVisibilityStatusQuery = { teams_by_pk?: { id: string, show_in_agency_pages?: boolean | null, published_agents: { aggregate?: { count: number } | null } } | null };

export type GetDashboardCmaReportsQueryVariables = Exact<{
  where: Cma_Reports_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDashboardCmaReportsQuery = { cma_reports: Array<{ id: string, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, created_at: any, cover_image?: { url?: string | null } | null, property: { country_code?: string | null, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null }, contact?: { first_name?: string | null, last_name?: string | null } | null }>, cma_reports_aggregate?: { aggregate?: { count: number } | null } };

export type GetDashboardTasksQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetDashboardTasksQuery = { allTasks: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, subject?: string | null, location?: string | null, due_at?: any | null, start_date?: string | null, created_by?: string | null, assigned_to?: string | null, user_id?: string | null, lot?: { id: string, property: { street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, country?: string | null } } | null, buyer_lead?: { id: string, lot: { id: string, property: { street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, country?: string | null } } } | null, lead?: { id: string, contact?: { first_name?: string | null, last_name?: string | null, emails: Array<{ email: string }> } | null, property?: { street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, country?: string | null } | null } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, is_owner: boolean, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, emails: Array<{ email: string }> } | null }> }> };

export type GetDashboardListingsQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDashboardListingsQuery = { lots: Array<{ id: string, title?: string | null, created_at: any, sale_price?: number | null, rent_net?: number | null, currency?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, offer_type?: string | null, price_unit?: string | null, rent_extra?: number | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ image: { url?: string | null } }> }, contact?: { first_name?: string | null, last_name?: string | null } | null, enquiries_aggregate: { aggregate?: { count: number } | null }, buyer_leads_aggregate: { aggregate?: { count: number } | null }, portal_listings_aggregate: { aggregate?: { count: number } | null } }>, lots_aggregate?: { aggregate?: { count: number } | null } };

export type GetDashboardMlsShareRequestsQueryVariables = Exact<{
  where: Mls_Shares_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  includeCount?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDashboardMlsShareRequestsQuery = { mls_shares: Array<{ id: string, status: string, created_at: any, lot_id: string, team_id: string, requester_name?: string | null, requester_team_name?: string | null, lot: { id: string, title?: string | null, property: { street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, country?: string | null, property_images: Array<{ image: { url?: string | null } }> } } }>, mls_shares_aggregate?: { aggregate?: { count: number } | null } };

export type DashboardFeedQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DashboardFeedQuery = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, note?: string | null, extra_data?: any | null, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, user_id?: string | null, lead_id?: string | null, created_by?: string | null, created_at: any, due_at?: any | null, start_date?: string | null, pinned: boolean, visibility: string, subject?: string | null, success: boolean, done: boolean, consolidated_done_at?: any | null, assigned_to?: string | null, enquiry?: { message?: string | null, id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ image: { url?: string | null } }>, emails: Array<{ email: string }> } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null } | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null, email_message?: { to: any, cc: any, id: string, from: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> }> };

export type CreateDevelopmentMutationVariables = Exact<{
  development: Developments_Insert_Input;
}>;


export type CreateDevelopmentMutation = { insert_developments_one?: { id: string } | null };

export type GetDevelopmentBuyerLeadsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentBuyerLeadsQuery = { developments_by_pk?: { id: string, buyer_leads: Array<{ id: string, stage_id?: string | null, order_nr: number, source?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, mls_lot?: { id?: string | null, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null } | null }>, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lots: Array<{ property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } }> } | null };

export type DevelopmentDocumentsFragment = { development_id: string, file_id: string, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } };

export type UpdateFileDocumentTypeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  document_type_id: Scalars['uuid']['input'];
}>;


export type UpdateFileDocumentTypeMutation = { update_files_by_pk?: { id: string, document_type_id?: string | null, document_type?: { id: string, label?: string | null } | null } | null };

export type GetDevelopmentImagesQueryVariables = Exact<{
  development_id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentImagesQuery = { development_images: Array<{ id: string, development_id: string, title?: string | null, description?: string | null, display_on_brochure: boolean, display_on_listing: boolean, size: string, crop: string, background_color: string, order_nr: number, image: { id: string, url?: string | null } }> };

export type InsertDevelopmentImagesBatchMutationVariables = Exact<{
  objects: Array<Development_Images_Insert_Input> | Development_Images_Insert_Input;
}>;


export type InsertDevelopmentImagesBatchMutation = { insert_development_images?: { returning: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } | null };

export type DeleteDevelopmentImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDevelopmentImageMutation = { delete_development_images_by_pk?: { id: string } | null };

export type UpdateDevelopmentImagesOrderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  new_order: Scalars['Int']['input'];
}>;


export type UpdateDevelopmentImagesOrderMutation = { update_development_images_by_pk?: { id: string, order_nr: number } | null };

export type GenerateDevelopmentImageMetadataQueryVariables = Exact<{
  development_image_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateDevelopmentImageMetadataQuery = { generate_development_image_metadata?: { title: string, description: string } | null };

export type UpdateDevelopmentImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Development_Images_Set_Input;
}>;


export type UpdateDevelopmentImageMutation = { update_development_images_by_pk?: { id: string } | null };

export type DevelopmentMappingsLotsTableFragment = { id: string, title?: string | null, lot_reference?: string | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, balcony_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, development_mappings: Array<{ lot_id: string, image_id: string, svg_path: string }> };

export type GetDevelopmentMappingDataQueryVariables = Exact<{
  development_id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentMappingDataQuery = { developments_by_pk?: { id: string, mapping_image_id?: string | null, mapping_image?: { id: string, url?: string | null } | null, lots: Array<{ id: string, title?: string | null, lot_reference?: string | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, balcony_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, development_mappings: Array<{ lot_id: string, image_id: string, svg_path: string }> }> } | null };

export type UpdateDevelopmentMappingImageMutationVariables = Exact<{
  development_id: Scalars['uuid']['input'];
  mapping_image_id: Scalars['uuid']['input'];
  url: Scalars['String']['input'];
}>;


export type UpdateDevelopmentMappingImageMutation = { insert_images_one?: { id: string, url?: string | null } | null, update_developments_by_pk?: { id: string, mapping_image_id?: string | null, mapping_image?: { id: string, url?: string | null } | null } | null };

export type DeleteMappingImageMutationVariables = Exact<{
  development_id: Scalars['uuid']['input'];
  image_id: Scalars['uuid']['input'];
}>;


export type DeleteMappingImageMutation = { delete_images_by_pk?: { id: string } | null, update_developments_by_pk?: { id: string, mapping_image_id?: string | null } | null };

export type UpsertDevelopmentMappingMutationVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
  image_id: Scalars['uuid']['input'];
  svg_path: Scalars['String']['input'];
}>;


export type UpsertDevelopmentMappingMutation = { insert_development_mappings_one?: { lot_id: string, image_id: string, svg_path: string } | null };

export type DeleteDevelopmentMappingMutationVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
  image_id: Scalars['uuid']['input'];
}>;


export type DeleteDevelopmentMappingMutation = { delete_development_mappings_by_pk?: { lot_id: string, image_id: string } | null };

export type DevelopmentMarketingFragment = { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, lots: Array<{ id: string, broker?: { id: string, teams_users: Array<{ team_id: string, user_id: string }> } | null, portal_listings: Array<{ id: string, portal_id: string }> }>, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null };

export type UpdateDevelopmentEnquiryResponseEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  development?: InputMaybe<Developments_Set_Input>;
}>;


export type UpdateDevelopmentEnquiryResponseEmailMutation = { update_developments_by_pk?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, lots: Array<{ id: string, broker?: { id: string, teams_users: Array<{ team_id: string, user_id: string }> } | null, portal_listings: Array<{ id: string, portal_id: string }> }>, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null } | null };

export type GetDevelopmentOverviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentOverviewQuery = { developments_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, is_published: boolean, status: Development_Status_Enum_Enum, slug: string, delivery_date?: string | null, registration_type: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, logo?: { id: string, url?: string | null } | null } | null, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null } | null, development_images: Array<{ image: { id: string, url?: string | null } }>, developer?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null, architect?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null, general_contractor?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null, development_collaborators: Array<{ development_id: string, user_id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null };

export type UpdateDevelopmentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  development: Developments_Set_Input;
}>;


export type UpdateDevelopmentMutation = { update_developments_by_pk?: { id: string, title?: string | null, slug: string, description?: string | null, delivery_date?: string | null, registration_type: string } | null };

export type DevelopmentCardFragment = { id: string, title?: string | null, created_at: any, lots: Array<{ id: string, status: Lots_Status_Enum_Enum, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, buyer_leads_aggregate: { aggregate?: { count: number } | null }, portal_listings_aggregate: { aggregate?: { count: number } | null } }>, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, developer?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }>, teams: Array<{ id: string, logo?: { url?: string | null } | null }> } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null } | null, development_images: Array<{ image: { id: string, url?: string | null } }> };

export type DevelopmentCardCarouselFragment = { id: string, created_at: any, lots: Array<{ id: string, portal_listings_aggregate: { aggregate?: { count: number } | null } }>, creator?: { id: string, first_name?: string | null, last_name?: string | null } | null, development_images: Array<{ image: { id: string, url?: string | null } }> };

export type DevelopmentCarouselFragment = { id: string, created_at: any, creator?: { id: string, first_name?: string | null, last_name?: string | null } | null, development_images: Array<{ image: { id: string, url?: string | null } }> };

export type UpdateDevelopmentBrokerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateDevelopmentBrokerMutation = { update_developments_by_pk?: { id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, logo?: { id: string, url?: string | null } | null } | null, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null } | null };

export type DevelopmentOverviewFormFragment = { id: string, title?: string | null, slug: string, description?: string | null, delivery_date?: string | null, registration_type: string };

export type DevelopmentQuickActionsFragment = { id: string, is_published: boolean, status: Development_Status_Enum_Enum, slug: string };

export type UpdateDevelopmentPublishedMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  is_published: Scalars['Boolean']['input'];
}>;


export type UpdateDevelopmentPublishedMutation = { update_developments_by_pk?: { id: string, is_published: boolean } | null };

export type DevelopmentSharingCardFragment = { id: string, development_collaborators: Array<{ development_id: string, user_id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type AddDevelopmentCollaboratorMutationVariables = Exact<{
  development_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type AddDevelopmentCollaboratorMutation = { insert_development_collaborators_one?: { development_id: string, user_id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type RemoveDevelopmentCollaboratorMutationVariables = Exact<{
  development_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type RemoveDevelopmentCollaboratorMutation = { delete_development_collaborators?: { affected_rows: number } | null };

export type NewDevelopmentCollaboratorFragment = { __typename: 'development_collaborators', development_id: string, user_id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } };

export type DevelopmentStakeholdersCardFragment = { id: string, developer?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null, architect?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null, general_contractor?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null };

export type UpdateDevelopmentStakeholdersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: Developments_Set_Input;
}>;


export type UpdateDevelopmentStakeholdersMutation = { update_developments_by_pk?: { id: string, developer_id?: string | null, architect_id?: string | null, general_contractor_id?: string | null, developer?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null, architect?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null, general_contractor?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }> } | null } | null };

export type DevelopmentPriceFragment = { id: string, lots: Array<{ id: string, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } }> };

export type DevelopmentStatusSelectFragment = { id: string, status: Development_Status_Enum_Enum };

export type GetDevelopmentStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDevelopmentStatusesQuery = { get_translated_enum: Array<{ value: string, label?: string | null }> };

export type UpdateDevelopmentStatusMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status: Development_Status_Enum_Enum;
}>;


export type UpdateDevelopmentStatusMutation = { update_developments_by_pk?: { id: string, status: Development_Status_Enum_Enum } | null };

export type GetDevelopmentsListQueryVariables = Exact<{
  where: Developments_Bool_Exp;
  order_by: Array<Developments_Order_By> | Developments_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetDevelopmentsListQuery = { developments: Array<{ id: string, slug: string, status: Development_Status_Enum_Enum, is_published: boolean, delivery_date?: string | null, updated_at: any, title?: string | null, created_at: any, lots: Array<{ id: string, status: Lots_Status_Enum_Enum, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, buyer_leads_aggregate: { aggregate?: { count: number } | null }, portal_listings_aggregate: { aggregate?: { count: number } | null } }>, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, developer?: { id: string, name?: string | null, website?: string | null, organisation_images: Array<{ image: { id: string, url?: string | null } }>, teams: Array<{ id: string, logo?: { url?: string | null } | null }> } | null, main_image: Array<{ image: { id: string, url?: string | null } }>, creator?: { id: string, first_name?: string | null, last_name?: string | null } | null, development_images: Array<{ image: { id: string, url?: string | null } }> }> };

export type GetDevelopmentsListCountQueryVariables = Exact<{
  where: Developments_Bool_Exp;
}>;


export type GetDevelopmentsListCountQuery = { developments_aggregate: { aggregate?: { count: number } | null } };

export type GetDevelopmentDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentDetailsQuery = { developments_by_pk?: { id: string, title?: string | null, lots: Array<{ id: string, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } }> } | null };

export type DeleteDevelopmentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDevelopmentMutation = { delete_developments_by_pk?: { id: string } | null };

export type GetDevelopmentDocumentsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentDocumentsQuery = { developments_by_pk?: { id: string, development_files: Array<{ development_id: string, file_id: string, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }> } | null };

export type CreateDevelopmentFileMutationVariables = Exact<{
  object: Development_Files_Insert_Input;
}>;


export type CreateDevelopmentFileMutation = { insert_development_files_one?: { development_id: string, file_id: string, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } } | null };

export type GetDevelopmentMarketingQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentMarketingQuery = { developments_by_pk?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, lots: Array<{ id: string, broker?: { id: string, teams_users: Array<{ team_id: string, user_id: string }> } | null, portal_listings: Array<{ id: string, portal_id: string }> }>, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null } | null };

export type GetAvailablePortalsForDevelopmentQueryVariables = Exact<{
  lot_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetAvailablePortalsForDevelopmentQuery = { portals: Array<{ id: string, team_id?: string | null, name?: string | null, quota?: number | null, type: Portals_Types_Enum_Enum, portal_listings_aggregate: { aggregate?: { count: number } | null }, team?: { id: string, name: string } | null, teams_portals: Array<{ team_id: string }> }> };

export type GetDevelopmentPortalListingsQueryVariables = Exact<{
  development_id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentPortalListingsQuery = { lots: Array<{ created_at: any, title?: string | null, status: Lots_Status_Enum_Enum, id: string, lot_reference?: string | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, lots_status: { label?: string | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, portal_listings: Array<{ id: string, portal_id: string, live: boolean }>, property: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, country_code?: string | null, computed_surface?: number | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, enquiries: Array<{ id: string, portal_id?: string | null }>, enquiries_aggregate: { aggregate?: { count: number, max?: { created_at?: any | null } | null } | null } }> };

export type UpsertDevelopmentEmailTemplateMutationVariables = Exact<{
  developmentId: Scalars['uuid']['input'];
  emailTemplateId: Scalars['uuid']['input'];
  developmentUpdates: Developments_Set_Input;
  emailTemplate: Email_Templates_Insert_Input;
  files: Array<Email_Templates_Files_Insert_Input> | Email_Templates_Files_Insert_Input;
}>;


export type UpsertDevelopmentEmailTemplateMutation = { insert_email_templates_one?: { id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> } | null, delete_email_templates_files?: { affected_rows: number } | null, insert_email_templates_files?: { returning: Array<{ email_template_id: string, file_id: string }> } | null, update_developments_by_pk?: { id: string, enquiry_response_enabled?: boolean | null, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null } | null };

export type GetDevelopmentListingCreationDataQueryVariables = Exact<{
  development_id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentListingCreationDataQuery = { developments_by_pk?: { id: string, last_lot: Array<{ id: string, property: { id: string, country?: string | null, country_code?: string | null, locality?: string | null, postcode?: string | null, route?: string | null, state?: string | null, street_number?: string | null, lat?: number | null, lng?: number | null, property_type_id?: string | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null } }> } | null };

export type GetDictEnumsQueryVariables = Exact<{
  where?: InputMaybe<Dictionaries_Types_Enum_Bool_Exp>;
}>;


export type GetDictEnumsQuery = { dictionaries_types_enum: Array<{ value: string, label?: string | null }> };

export type DictionaryItemFragment = { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null };

export type GetDictionariesByTypeQueryVariables = Exact<{
  type: Dictionaries_Types_Enum_Enum;
}>;


export type GetDictionariesByTypeQuery = { dictionaries: Array<{ id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null }> };

export type DeleteDictionaryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDictionaryMutation = { delete_dictionaries_by_pk?: { id: string } | null };

export type Get_Dictionary_GroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type Get_Dictionary_GroupsQuery = { groups: Array<{ id: string, label?: string | null }> };

export type Get_Dictionary_ItemQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type Get_Dictionary_ItemQuery = { dictionaries_by_pk?: { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null } | null };

export type Insert_Dictionary_ItemMutationVariables = Exact<{
  dictionary: Dictionaries_Insert_Input;
}>;


export type Insert_Dictionary_ItemMutation = { insert_dictionaries_one?: { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null } | null };

export type Update_Dictionary_ItemMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  dictionary: Dictionaries_Set_Input;
}>;


export type Update_Dictionary_ItemMutation = { update_dictionaries_by_pk?: { id: string, label?: string | null, type: Dictionaries_Types_Enum_Enum, name: string, label_de?: string | null, label_es?: string | null, label_fr?: string | null, label_en: string, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, is_deletable?: boolean | null, is_used?: boolean | null, updated_at: any, created_at: any, types?: Array<string> | null, group_id?: string | null, tenant_id?: string | null, group?: { id: string, label?: string | null } | null } | null };

export type Sync_Dictionary_EnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type Sync_Dictionary_EnumsQuery = { sync_dictionary_enums?: { success: boolean, error?: string | null } | null };

export type DocTemplateFieldsFragment = { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, theme_id?: string | null, translations?: any | null, theme?: { id: string, name: string } | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_templates_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> };

export type GetDocTemplatesQueryVariables = Exact<{
  where?: InputMaybe<Doc_Templates_Bool_Exp>;
}>;


export type GetDocTemplatesQuery = { doc_templates: Array<{ id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, theme_id?: string | null, translations?: any | null, theme?: { id: string, name: string } | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_templates_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> }> };

export type DeleteDocTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDocTemplateMutation = { delete_doc_templates_by_pk?: { id: string } | null };

export type DuplicateDocTemplateMutationVariables = Exact<{
  input: Doc_Templates_Insert_Input;
}>;


export type DuplicateDocTemplateMutation = { insert_doc_templates_one?: { id: string } | null };

export type GetDocTemplateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocTemplateQuery = { doc_templates_by_pk?: { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, theme_id?: string | null, translations?: any | null, theme?: { id: string, name: string } | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_templates_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> } | null };

export type CreateDocTemplateMutationVariables = Exact<{
  input: Doc_Templates_Insert_Input;
}>;


export type CreateDocTemplateMutation = { insert_doc_templates_one?: { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, theme_id?: string | null, translations?: any | null, theme?: { id: string, name: string } | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_templates_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> } | null };

export type UpdateDocTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Doc_Templates_Set_Input;
}>;


export type UpdateDocTemplateMutation = { update_doc_templates_by_pk?: { id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, theme_id?: string | null, translations?: any | null, theme?: { id: string, name: string } | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_templates_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> } | null };

export type SaveDocTemplateMutationVariables = Exact<{
  where: Doc_Templates_Bool_Exp;
  input: Doc_Templates_Set_Input;
}>;


export type SaveDocTemplateMutation = { update_doc_templates?: { affected_rows: number, returning: Array<{ id: string, name: string, updated_at: any, type: Doc_Template_Type_Enum_Enum, active: boolean, content: string, filename_template: string, theme_id?: string | null, translations?: any | null, theme?: { id: string, name: string } | null, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_templates_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> }> } | null };

export type GetDocTemplateVersionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocTemplateVersionsQuery = { doc_template_versions: Array<{ id: string, created_at: any, updated_by_user?: { id: string, first_name?: string | null, last_name?: string | null } | null }> };

export type GetDocTemplateVersionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  templateId: Scalars['uuid']['input'];
}>;


export type GetDocTemplateVersionQuery = { doc_template_versions_by_pk?: { id: string, content: string, translations?: any | null } | null, newest: Array<{ id: string, content: string, translations?: any | null }>, current?: { id: string, content: string, translations?: any | null } | null };

export type RestoreDocTemplateVersionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  currentContent: Scalars['String']['input'];
  currentTranslations: Jsonb_Comparison_Exp;
  content: Scalars['String']['input'];
  translations?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type RestoreDocTemplateVersionMutation = { update_doc_templates?: { affected_rows: number } | null };

export type UpdateTenantShareMutationVariables = Exact<{
  doc_template_id: Scalars['uuid']['input'];
  tenant_id: Scalars['uuid']['input'];
  is_default: Scalars['Boolean']['input'];
}>;


export type UpdateTenantShareMutation = { insert_doc_templates_tenants_one?: { id: string, doc_template_id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null } | null };

export type DeleteTenantShareMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTenantShareMutation = { delete_doc_templates_tenants_by_pk?: { id: string, tenant_id: string } | null };

export type UpsertTeamShareMutationVariables = Exact<{
  doc_template_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
  is_default: Scalars['Boolean']['input'];
}>;


export type UpsertTeamShareMutation = { insert_doc_templates_teams_one?: { id: string, doc_template_id: string, team_id: string, is_default: boolean } | null };

export type DeleteTeamShareMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamShareMutation = { delete_doc_templates_teams_by_pk?: { id: string, team_id: string } | null };

export type GetCmaThemePreviewSampleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCmaThemePreviewSampleQuery = { cma_reports: Array<{ id: string, doc_template?: { id: string, content: string, translations?: any | null } | null }> };

export type GetLotThemePreviewSampleQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLotThemePreviewSampleQuery = { lots: Array<{ id: string, doc_template?: { id: string, content: string, translations?: any | null } | null }> };

export type GetDocTemplateTypeEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocTemplateTypeEnumQuery = { doc_template_type_enum: Array<{ value: string }> };

export type DocThemeFieldsFragment = { id: string, name: string, active: boolean, updated_at: any, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates: Array<{ id: string, type: Doc_Template_Type_Enum_Enum, updated_at: any }>, empty_files: Array<{ id: string }>, doc_template_themes_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_template_themes_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> };

export type GetDocThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocThemesQuery = { doc_template_themes: Array<{ id: string, name: string, active: boolean, updated_at: any, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates: Array<{ id: string, type: Doc_Template_Type_Enum_Enum, updated_at: any }>, empty_files: Array<{ id: string }>, doc_template_themes_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_template_themes_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> }> };

export type GetDocThemeQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDocThemeQuery = { doc_template_themes_by_pk?: { id: string, name: string, active: boolean, updated_at: any, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates: Array<{ id: string, type: Doc_Template_Type_Enum_Enum, updated_at: any }>, empty_files: Array<{ id: string }>, doc_template_themes_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_template_themes_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> } | null };

export type CreateDocThemeMutationVariables = Exact<{
  input: Doc_Template_Themes_Insert_Input;
}>;


export type CreateDocThemeMutation = { insert_doc_template_themes_one?: { id: string, name: string, active: boolean, updated_at: any, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates: Array<{ id: string, type: Doc_Template_Type_Enum_Enum, updated_at: any }>, empty_files: Array<{ id: string }>, doc_template_themes_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_template_themes_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> } | null };

export type UpdateDocThemeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Doc_Template_Themes_Set_Input;
}>;


export type UpdateDocThemeMutation = { update_doc_template_themes_by_pk?: { id: string, name: string, active: boolean, updated_at: any, created_by_tenant?: { id?: string | null, name?: string | null } | null, doc_templates: Array<{ id: string, type: Doc_Template_Type_Enum_Enum, updated_at: any }>, empty_files: Array<{ id: string }>, doc_template_themes_tenants: Array<{ id: string, tenant_id: string, is_default: boolean, tenant?: { id?: string | null, name?: string | null } | null }>, doc_template_themes_teams: Array<{ id: string, team_id: string, is_default: boolean, team: { id: string, name: string } }> } | null };

export type DeleteDocThemeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteDocThemeMutation = { delete_doc_template_themes_by_pk?: { id: string } | null };

export type CreateDocThemeFileMutationVariables = Exact<{
  input: Doc_Templates_Insert_Input;
}>;


export type CreateDocThemeFileMutation = { insert_doc_templates_one?: { id: string, type: Doc_Template_Type_Enum_Enum, theme_id?: string | null } | null };

export type GetDocThemeFilesContentQueryVariables = Exact<{
  theme_id: Scalars['uuid']['input'];
}>;


export type GetDocThemeFilesContentQuery = { doc_templates: Array<{ id: string, type: Doc_Template_Type_Enum_Enum, content: string, filename_template: string, translations?: any | null }> };

export type UpsertThemeTenantShareMutationVariables = Exact<{
  theme_id: Scalars['uuid']['input'];
  tenant_id: Scalars['uuid']['input'];
  is_default: Scalars['Boolean']['input'];
}>;


export type UpsertThemeTenantShareMutation = { insert_doc_template_themes_tenants_one?: { id: string, tenant_id: string, is_default: boolean } | null };

export type DeleteThemeTenantShareMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteThemeTenantShareMutation = { delete_doc_template_themes_tenants_by_pk?: { id: string } | null };

export type UpsertThemeTeamShareMutationVariables = Exact<{
  theme_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
  is_default: Scalars['Boolean']['input'];
}>;


export type UpsertThemeTeamShareMutation = { insert_doc_template_themes_teams_one?: { id: string, team_id: string, is_default: boolean } | null };

export type DeleteThemeTeamShareMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteThemeTeamShareMutation = { delete_doc_template_themes_teams_by_pk?: { id: string } | null };

export type EmailCampaignsListQueryVariables = Exact<{
  where: Email_Campaigns_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Email_Campaigns_Order_By> | Email_Campaigns_Order_By>;
}>;


export type EmailCampaignsListQuery = { email_campaigns_aggregate: { aggregate?: { count: number } | null }, email_campaigns: Array<{ id: string, status?: Email_Campaigns_Status_Enum_Enum | null, created_at: any, user?: { id: string, first_name?: string | null, last_name?: string | null } | null, first_message: Array<{ id: string, subject_template?: string | null, body_template?: string | null, activity?: { buyer_lead?: { lot: { id: string, title?: string | null, lot_reference?: string | null, property: { id: string, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null } | null }>, total: { aggregate?: { count: number } | null }, sent: { aggregate?: { count: number } | null }, error: { aggregate?: { count: number } | null }, pending: { aggregate?: { count: number } | null } }> };

export type EmailCampaignPreviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EmailCampaignPreviewQuery = { email_campaigns_by_pk?: { id: string, status?: Email_Campaigns_Status_Enum_Enum | null, created_at: any, user?: { id: string, first_name?: string | null, last_name?: string | null } | null, first_message: Array<{ id: string, subject_template?: string | null, body_template?: string | null, activity?: { buyer_lead?: { lot: { id: string, title?: string | null, lot_reference?: string | null, property: { id: string, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null } | null }>, total: { aggregate?: { count: number } | null }, sent: { aggregate?: { count: number } | null }, error: { aggregate?: { count: number } | null }, pending: { aggregate?: { count: number } | null } } | null };

export type EmailCampaignRecipientsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type EmailCampaignRecipientsQuery = { email_campaigns_by_pk?: { id: string, recipients: Array<{ id: string, to: any, status: string, error_message?: string | null }> } | null };

export type MassMailListingsQueryVariables = Exact<{
  where: Lots_Bool_Exp;
  limit: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Lots_Order_By> | Lots_Order_By>;
}>;


export type MassMailListingsQuery = { lots: Array<{ id: string, title?: string | null, lot_reference?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> }, buyer_leads_aggregate: { aggregate?: { count: number } | null } }> };

export type EmailPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailPreferencesQuery = { get_me: { me?: { id: string, email_signature?: string | null, emails: Array<{ id: string, email: string, email_display_name?: string | null }>, nylas_login: Array<{ id: string, invalid: boolean, self_nylas_provider?: string | null, self_username?: string | null }>, nylas_account_config: Array<{ sync_enabled?: boolean | null, sync_state?: string | null, calendar_sync_enabled: boolean }> } | null } };

export type UpdateEmailPreferencesMutationVariables = Exact<{
  email_signature?: InputMaybe<Scalars['String']['input']>;
  email_signature_html?: InputMaybe<Scalars['String']['input']>;
  email_id?: InputMaybe<Scalars['uuid']['input']>;
  email_display_name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEmailPreferencesMutation = { update_user_email_preferences?: { id: string } | null };

export type EmailTemplatesListQueryVariables = Exact<{
  where: Email_Templates_Bool_Exp;
  limit: Scalars['Int']['input'];
  order_by?: InputMaybe<Array<Email_Templates_Order_By> | Email_Templates_Order_By>;
}>;


export type EmailTemplatesListQuery = { email_templates: Array<{ id: string, name?: string | null, subject_plaintext?: string | null, created_at: any, is_shared_with_everyone: boolean, is_shared_with_organisation: boolean, user?: { id: string, first_name?: string | null, last_name?: string | null } | null }> };

export type GetEmailTemplateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEmailTemplateQuery = { email_templates_by_pk?: { id: string, name?: string | null, subject?: string | null, text?: string | null, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, add_signature: boolean, created_at: any, user_id?: string | null, lot_id?: string | null, development_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null } | null, email_templates_files: Array<{ file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> } | null };

export type GetEmailTemplatePreviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEmailTemplatePreviewQuery = { email_templates_by_pk?: { id: string, name?: string | null, subject_plaintext?: string | null, text_html?: string | null, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, add_signature: boolean, created_at: any, user_id?: string | null, lot_id?: string | null, development_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null } | null, email_templates_files: Array<{ file_id: string, file: { id: string, name: string, url: string } }> } | null };

export type DeleteEmailTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteEmailTemplateMutation = { delete_email_templates_by_pk?: { id: string } | null };

export type UpsertStandaloneEmailTemplateMutationVariables = Exact<{
  emailTemplateId: Scalars['uuid']['input'];
  emailTemplate: Email_Templates_Insert_Input;
  files: Array<Email_Templates_Files_Insert_Input> | Email_Templates_Files_Insert_Input;
}>;


export type UpsertStandaloneEmailTemplateMutation = { insert_email_templates_one?: { id: string, subject_plaintext?: string | null, text_html?: string | null, text_plaintext?: string | null, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> } | null, delete_email_templates_files?: { affected_rows: number } | null, insert_email_templates_files?: { returning: Array<{ email_template_id: string, file_id: string }> } | null };

export type EmailThreadsListQueryVariables = Exact<{
  where: Email_Threads_Bool_Exp;
  order_by: Array<Email_Threads_Order_By> | Email_Threads_Order_By;
  limit: Scalars['Int']['input'];
  sent: Scalars['Boolean']['input'];
}>;


export type EmailThreadsListQuery = { email_threads: Array<{ id: string, subject?: string | null, snippet?: string | null, visibility: string, unread?: boolean | null, last_message_received_timestamp?: any | null, last_message_sent_timestamp?: any | null, last_received_message?: Array<{ from: any }>, last_sent_message: Array<{ to: any }> }> };

export type GetEmailThreadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  messagesLimit: Scalars['Int']['input'];
}>;


export type GetEmailThreadQuery = { email_threads_by_pk?: { id: string, subject?: string | null, visibility: string, unread?: boolean | null, email_messages: Array<{ id: string, message_id?: string | null, created_by?: string | null, from: any, to: any, cc: any, bcc: any, reply_to: any, subject?: string | null, date: any, snippet?: string | null, files?: any | null, is_sent: boolean }> } | null };

export type UpdateEmailThreadVisibilityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  visibility: Scalars['String']['input'];
}>;


export type UpdateEmailThreadVisibilityMutation = { update_email_thread_visibility?: { __typename: 'UpdateEmailThreadVisibilityOutput', id: string, visibility: string } | null };

export type MarkEmailThreadReadMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MarkEmailThreadReadMutation = { mark_email_thread_read?: { __typename: 'MarkEmailThreadReadOutput', id: string, unread: boolean } | null };

export type GetEmailMessageFilingQueryVariables = Exact<{
  emailMessageId: Scalars['uuid']['input'];
}>;


export type GetEmailMessageFilingQuery = { activities: Array<{ id: string, lead_id?: string | null, enquiry_id?: string | null, lot_id?: string | null, user_id?: string | null, buyer_lead_id?: string | null }> };

export type GetEnquiryBuyerLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEnquiryBuyerLeadQuery = { enquiries_by_pk?: { id: string, created_at: any, message?: string | null, buyer_lead_id?: string | null, lot_id?: string | null, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, raw_email_address?: string | null, raw_phone_number?: string | null, user_id?: string | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, portal?: { name?: string | null } | null } | null };

export type AssignEnquiryListingMutationVariables = Exact<{
  enquiryId: Scalars['uuid']['input'];
  lotId: Scalars['uuid']['input'];
}>;


export type AssignEnquiryListingMutation = { update_enquiries_by_pk?: { id: string, buyer_lead_id?: string | null, lot_id?: string | null, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, raw_email_address?: string | null, raw_phone_number?: string | null, user_id?: string | null } | null };

export type EnquiryCreateBuyerLeadFragment = { id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, raw_email_address?: string | null, raw_phone_number?: string | null, user_id?: string | null, lot_id?: string | null, buyer_lead_id?: string | null };

export type CreateMissingBuyerLeadMutationVariables = Exact<{
  enquiryId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type CreateMissingBuyerLeadMutation = { create_enquiry_buyer_lead?: { buyer_lead?: { id: string } | null, enquiry?: { id: string, buyer_lead_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_lead?: { id: string, created_at: any, source?: string | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null } | null } | null };

export type AttachBuyerLeadMutationVariables = Exact<{
  enquiryId: Scalars['uuid']['input'];
  buyerLeadId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type AttachBuyerLeadMutation = { update_enquiries_by_pk?: { id: string, buyer_lead_id?: string | null, buyer_lead?: { id: string, created_at: any, source?: string | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null } | null };

export type GetListingBuyerLeadsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetListingBuyerLeadsQuery = { buyer_leads: Array<{ id: string, user: { id: string, first_name?: string | null, last_name?: string | null } }> };

export type FindMatchingUserQueryVariables = Exact<{
  email?: InputMaybe<Scalars['citext']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindMatchingUserQuery = { users: Array<{ id: string }> };

export type GetEnquiriesListQueryVariables = Exact<{
  where: Enquiries_Bool_Exp;
  order_by?: InputMaybe<Array<Enquiries_Order_By> | Enquiries_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetEnquiriesListQuery = { enquiries: Array<{ id: string, created_at: any, updated_at: any, processed: boolean, first_name?: string | null, last_name?: string | null, email_address?: string | null, portal?: { name?: string | null } | null, lot?: { id: string, title?: string | null, lot_reference?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, team?: { id: string, name: string } | null }> };

export type GetEnquiriesListCountQueryVariables = Exact<{
  where: Enquiries_Bool_Exp;
}>;


export type GetEnquiriesListCountQuery = { enquiries_aggregate: { aggregate?: { count: number } | null } };

export type GetEnquiryTypeQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEnquiryTypeQuery = { enquiries_by_pk?: { id: string, broker_id?: string | null, team_id?: string | null, buyer_lead_id?: string | null, created_at: any } | null };

export type GetEnquiryContactRequestQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEnquiryContactRequestQuery = { enquiries_by_pk?: { id: string, created_at: any, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, contact_reason?: string | null, message?: string | null, broker?: { id: string, full_name?: string | null } | null, team?: { id: string, name: string } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, property: { country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, living_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, id: string, computed_surface?: number | null, land_surface?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> }, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }> } | null } | null };

export type DeleteEnquiryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteEnquiryMutation = { delete_enquiries_by_pk?: { id: string } | null };

export type UpdateEnquiryResponseActivityMutationVariables = Exact<{
  enquiryId: Scalars['uuid']['input'];
  responseActivityId: Scalars['uuid']['input'];
  buyerLeadId: Scalars['uuid']['input'];
  buyerLeadStage?: InputMaybe<Scalars['uuid']['input']>;
  updateBuyerLeadStage: Scalars['Boolean']['input'];
}>;


export type UpdateEnquiryResponseActivityMutation = { update_enquiries_by_pk?: { id: string, processed: boolean, response_activity?: { id: string, email_message?: { id: string, status: string, date: any } | null } | null } | null, update_buyer_leads?: { returning: Array<{ id: string, stage_id?: string | null, lead_stage?: { id: string, status: Leads_Status_Enum } | null }> } | null, update_activities_by_pk?: { id: string, buyer_lead_id?: string | null } | null };

export type GetBrochureSentStageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrochureSentStageQuery = { lead_stages: Array<{ id: string }> };

export type MarkEnquiryAsProcessedMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type MarkEnquiryAsProcessedMutation = { update_enquiries_by_pk?: { id: string, processed: boolean } | null };

export type ValidateInvitationQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ValidateInvitationQuery = { validate_invitation?: { success: boolean, tenant_id?: string | null, magic_token?: string | null } | null };

export type GetLeadDetailsQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadDetailsQuery = { leads_by_pk?: { id: string, origin_enquiry_id?: string | null, created_by?: string | null, anonymized_contact?: string | null, appraisal_perceived_value?: number | null, appraisal_reason: Leads_Appraisal_Reason_Enum, relationship: Leads_Relationship_Enum, appraisal_open_to_offer?: string | null, appraisal_property_occupied?: string | null, property_usage: Leads_Property_Usage_Enum, potential_development: boolean, sale_horizon: Leads_Sale_Horizon_Enum, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, phone_number?: string | null, email_address?: string | null, created_at: any, requalified_at?: any | null, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, source: { id: string, label?: string | null, name: string }, origin_enquiry?: { id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, display_name?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }>, property_searches: Array<{ id: string, created_at: any, updated_at: any, offer_type?: string | null, number_of_rooms_gte?: number | null, number_of_rooms_lte?: number | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }> }> } | null, lots: Array<{ id: string, updated_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, use_dummy_address?: boolean | null, dummy_route?: string | null, dummy_street_number?: string | null, dummy_postcode?: string | null, dummy_locality?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ image: { url?: string | null } }> } }>, property?: { id: string, lat?: number | null, lng?: number | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null, plot_number?: string | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, residential_surface?: number | null, commercial_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, minergie_code?: number | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, is_commercial_fully_rented?: boolean | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, has_gym?: boolean | null, has_view?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_elevator?: boolean | null, has_photovoltaic_panels?: boolean | null, has_attic?: boolean | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, google_address?: { lat?: number | null, lng?: number | null, formatted_address?: string | null } | null, property_files: Array<{ property_id: string, file_id: string, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { first_name?: string | null, last_name?: string | null } | null } }>, property_type?: { label?: string | null, name?: string | null, main_type?: string | null } | null, appraisals: Array<{ id: string, min?: number | null, max?: number | null, value?: number | null, updated_at: any }> } | null, lead_agents: Array<{ id: string, user_id: string, claimed_at?: any | null, passed_at?: any | null, win_probability?: number | null, predicted_win_date?: string | null, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, display_name?: string | null, organisation?: { name?: string | null } | null } }>, leads_tags: Array<{ id: string, dictionary?: { id: string, label?: string | null } | null }>, cma_reports: Array<{ id: string, created_by?: string | null, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, updated_at: any, created_at: any, report_source?: Cma_Report_Source_Enum_Enum | null }> } | null };

export type LeadDetailsDrawerDeleteLeadMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type LeadDetailsDrawerDeleteLeadMutation = { delete_leads_by_pk?: { id: string } | null };

export type GetLeadAgentStatusDrawerQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadAgentStatusDrawerQuery = { lead_agents: Array<{ id: string, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string } } | null, user: { id: string, first_name?: string | null, last_name?: string | null } }> };

export type GetDuplicateStageDrawerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDuplicateStageDrawerQuery = { lead_stages: Array<{ id: string }> };

export type SelfAssignLeadAgentDrawerMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  broker_id: Scalars['uuid']['input'];
  stage_id: Scalars['uuid']['input'];
  claimed_at: Scalars['timestamptz']['input'];
}>;


export type SelfAssignLeadAgentDrawerMutation = { insert_lead_agents_one?: { id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, lead_id: string, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string } } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type GetTeamMembersQueryVariables = Exact<{
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetTeamMembersQuery = { teams_users: Array<{ user: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type CreateFileWithPropertyLinkMutationVariables = Exact<{
  object: Property_Files_Insert_Input;
}>;


export type CreateFileWithPropertyLinkMutation = { insert_property_files_one?: { property_id: string, file_id: string, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { first_name?: string | null, last_name?: string | null } | null } } | null };

export type GetLeadsTheSameAddressQueryVariables = Exact<{
  leadId: Scalars['uuid']['input'];
}>;


export type GetLeadsTheSameAddressQuery = { leads_the_same_address: Array<{ id: string, completed: boolean, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, lead_agents_aggregate: { aggregate?: { count: number } | null } }> };

export type ProspectionLeadContactStatusQueryVariables = Exact<{
  leadId: Scalars['uuid']['input'];
}>;


export type ProspectionLeadContactStatusQuery = { prospection_map_contact_attempts: Array<{ id: string, declined_at?: any | null, user: { first_name?: string | null, last_name?: string | null } }>, prospection_map_emailable_leads: Array<{ lead_id?: string | null }> };

export type GetLeadDataQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadDataQuery = { leads_by_pk?: { id: string, lots: Array<{ id: string }>, leads_tags: Array<{ id: string, created_by?: string | null, created_at: any, dictionary?: { id: string, label?: string | null } | null }> } | null, dictionaries: Array<{ id: string, label?: string | null }> };

export type UpdateLeadTagsMutationVariables = Exact<{
  removedTags: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  newTags: Array<Leads_Tags_Insert_Input> | Leads_Tags_Insert_Input;
}>;


export type UpdateLeadTagsMutation = { delete_leads_tags?: { affected_rows: number } | null, insert_leads_tags?: { affected_rows: number } | null };

export type GetLeadAgentStatusQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadAgentStatusQuery = { lead_agents: Array<{ id: string, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string } } | null, user: { id: string, first_name?: string | null, last_name?: string | null } }> };

export type UpdateLeadContactMutationVariables = Exact<{
  leadId: Scalars['uuid']['input'];
  contactId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateLeadContactMutation = { update_leads_by_pk?: { id: string, contact_id?: string | null } | null };

export type GetValuationDataForLeadDetailsQueryVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetValuationDataForLeadDetailsQuery = { property_appraisable?: { appraisable: { result: boolean, errors: Array<{ path: Array<string> }> } } | null, doc_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }> };

export type GetCmaReportForPreviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCmaReportForPreviewQuery = { cma_reports_by_pk?: { __typename: 'cma_reports', report_source?: Cma_Report_Source_Enum_Enum | null, id: string, updated_at: any, language: any, broker_id?: string | null, doc_template_id?: string | null, doc_template_theme_id?: string | null, include_cover: boolean, include_introduction: boolean, include_property: boolean, include_description: boolean, include_photos: boolean, include_pois: boolean, include_poi_map: boolean, poi_map_zoom_level: number, include_hedonistic_valuation: boolean, include_comparables_valuation: boolean, include_rental_comparables: boolean, comparable_listings_map_zoom_level?: number | null, include_transactions?: boolean | null, transaction_map_zoom_level?: number | null, include_cuprate_valuation: boolean, include_intrinsic_valuation: boolean, include_final_value: boolean, include_potential_buyers: boolean, include_agent: boolean, include_agent_agency: boolean, include_client_testimonial: boolean, include_append_files: boolean, include_market_data: boolean, broker?: { show_in_agency_pages?: boolean | null, default_team?: { show_in_agency_pages?: boolean | null } | null } | null, property: { id: string, updated_at: any, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, lat?: number | null, lng?: number | null }, doc_template?: { id: string, content: string, filename_template: string, translations?: any | null } | null, doc_template_theme?: { id: string, name: string, content: string } | null } | null };

export type UsersForSubjectQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UsersForSubjectQuery = { users: Array<{ id: string, first_name?: string | null, last_name?: string | null, display_name?: string | null, default_team?: { name: string } | null, emails: Array<{ id: string, email: string, primary: boolean }> }> };

export type GetLeadOneClickCmaTourLeadQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetLeadOneClickCmaTourLeadQuery = { leads: Array<{ id: string }>, visible: Array<{ id: string }> };

export type AssignBrokerWithActivitiesMutationVariables = Exact<{
  assignment_activities: Array<Activities_Insert_Input> | Activities_Insert_Input;
  lead_agents: Array<Lead_Agents_Insert_Input> | Lead_Agents_Insert_Input;
  activities_updates: Array<Activities_Updates> | Activities_Updates;
  lead_agents_to_remove: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  reassignments: Array<Lead_Agents_Updates> | Lead_Agents_Updates;
}>;


export type AssignBrokerWithActivitiesMutation = { update_activities_many?: Array<{ affected_rows: number } | null> | null, insert_activities?: { affected_rows: number, returning: Array<{ id: string, lead_id?: string | null }> } | null, insert_lead_agents?: { affected_rows: number, returning: Array<{ id: string }> } | null, delete_lead_agents?: { affected_rows: number } | null, update_lead_agents_many?: Array<{ affected_rows: number } | null> | null };

export type GetLeadsDataQueryVariables = Exact<{
  leads_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  broker_id: Scalars['uuid']['input'];
  owner_initiated_sources: Array<Lead_Agent_Source_Enum_Enum> | Lead_Agent_Source_Enum_Enum;
}>;


export type GetLeadsDataQuery = { leads: Array<{ id: string, owner_team_id?: string | null, lead_agents: Array<{ id: string, user_id: string }> }>, lead_stages: Array<{ id: string }>, team_members: Array<{ team_id: string, user_id: string }>, broker_team_memberships: Array<{ team_id: string }> };

export type GetPipelinesQueryVariables = Exact<{
  leadType: Scalars['lead_type']['input'];
}>;


export type GetPipelinesQuery = { pipelines: Array<{ id: string, label?: string | null, stages: Array<{ id: string, label?: string | null, status: Leads_Status_Enum }> }> };

export type UpdateMultipleLeadsStageMutationVariables = Exact<{
  updates: Array<Lead_Agents_Updates> | Lead_Agents_Updates;
  activities: Array<Activities_Insert_Input> | Activities_Insert_Input;
}>;


export type UpdateMultipleLeadsStageMutation = { update_lead_agents_many?: Array<{ returning: Array<{ id: string, lead_id: string, user_id: string, stage_id?: string | null, lead_stage?: { id: string, label?: string | null } | null }> } | null> | null, insert_activities?: { returning: Array<{ id: string }> } | null };

export type LeadsKanbanColumnLeadFragment = { id: string, created_by?: string | null, anonymized_contact?: string | null, origin_enquiry_id?: string | null, relationship: Leads_Relationship_Enum, appraisal_perceived_value?: number | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, created_at: any, requalified_at?: any | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, emails: Array<{ id: string, email: string }> } | null, lots: Array<{ id: string }>, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, due_at?: any | null, start_date?: string | null }>, property?: { id: string, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } | null };

export type LeadsKanbanColumnItemFragment = { id: string, claimed_at?: any | null, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, stage_id?: string | null, lead: { id: string, created_by?: string | null, anonymized_contact?: string | null, origin_enquiry_id?: string | null, relationship: Leads_Relationship_Enum, appraisal_perceived_value?: number | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, created_at: any, requalified_at?: any | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, emails: Array<{ id: string, email: string }> } | null, lots: Array<{ id: string }>, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, due_at?: any | null, start_date?: string | null }>, property?: { id: string, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } | null }, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } };

export type LeadsListItemFragment = { id: string, created_at: any, requalified_at?: any | null, requalified_or_created_at?: any | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_perceived_value?: number | null, appraisal_perception?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, anonymized_contact?: string | null, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, source: { id: string, label?: string | null }, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, stage_id?: string | null, claimed_at?: any | null, created_at: any, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, next_activity?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, last_activity?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, property?: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null } | null } | null };

export type ActivityCellFragment = { id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null };

export type LeadsListRowActivitiesFragment = { next_activity_assigned_to?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, last_activity_assigned_to?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }> };

export type GetLeadsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Leads_Bool_Exp>;
  order_by?: InputMaybe<Array<Leads_Order_By> | Leads_Order_By>;
  hasUserFilter: Scalars['Boolean']['input'];
  userIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetLeadsQuery = { leads: Array<{ id: string, created_at: any, requalified_at?: any | null, requalified_or_created_at?: any | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_perceived_value?: number | null, appraisal_perception?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, anonymized_contact?: string | null, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, source: { id: string, label?: string | null }, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, stage_id?: string | null, claimed_at?: any | null, created_at: any, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, next_activity?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, last_activity?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, property?: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null } | null } | null, next_activity_assigned_to?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, last_activity_assigned_to?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }> }> };

export type SearchLeadsListQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Leads_Bool_Exp>;
  order_by?: InputMaybe<Array<Leads_Order_By> | Leads_Order_By>;
  hasUserFilter: Scalars['Boolean']['input'];
  userIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type SearchLeadsListQuery = { leads: Array<{ id: string, created_at: any, requalified_at?: any | null, requalified_or_created_at?: any | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_perceived_value?: number | null, appraisal_perception?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, anonymized_contact?: string | null, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, source: { id: string, label?: string | null }, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, stage_id?: string | null, claimed_at?: any | null, created_at: any, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, next_activity?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, last_activity?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, property?: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null } | null } | null, next_activity_assigned_to?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }>, last_activity_assigned_to?: Array<{ id: string, created_at: any, due_at?: any | null, done_at?: any | null, consolidated_done_at?: any | null, start_date?: string | null, end_date?: string | null, done: boolean, success: boolean, subject?: string | null, activity_type: Activity_Types_Enum_Enum, note?: string | null }> }> };

export type GetKanbanLeadsAgentsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
  where_leads?: InputMaybe<Leads_Bool_Exp>;
  include_leads: Scalars['Boolean']['input'];
}>;


export type GetKanbanLeadsAgentsQuery = { lead_agents?: Array<{ id: string, claimed_at?: any | null, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, stage_id?: string | null, lead: { id: string, created_by?: string | null, anonymized_contact?: string | null, origin_enquiry_id?: string | null, relationship: Leads_Relationship_Enum, appraisal_perceived_value?: number | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, created_at: any, requalified_at?: any | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, emails: Array<{ id: string, email: string }> } | null, lots: Array<{ id: string }>, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, due_at?: any | null, start_date?: string | null }>, property?: { id: string, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } | null }, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, leads?: Array<{ id: string, created_by?: string | null, anonymized_contact?: string | null, origin_enquiry_id?: string | null, relationship: Leads_Relationship_Enum, appraisal_perceived_value?: number | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, appraisal_property_country_code?: string | null, appraisal_property_lat?: number | null, appraisal_property_lng?: number | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, created_at: any, requalified_at?: any | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, emails: Array<{ id: string, email: string }> } | null, lots: Array<{ id: string }>, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, due_at?: any | null, start_date?: string | null }>, property?: { id: string, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } | null }> };

export type GetKanbanLeadsCountQueryVariables = Exact<{
  where?: InputMaybe<Lead_Agents_Bool_Exp>;
  where_leads?: InputMaybe<Leads_Bool_Exp>;
  include_leads: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetKanbanLeadsCountQuery = { lead_agents_aggregate?: { aggregate?: { count: number } | null }, leads_aggregate?: { aggregate?: { count: number } | null } };

export type GetLeadsCountQueryVariables = Exact<{
  where?: InputMaybe<Leads_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeadsCountQuery = { leads_aggregate: { aggregate?: { count: number } | null } };

export type SearchLeadsListCountQueryVariables = Exact<{
  search: Scalars['String']['input'];
  where?: InputMaybe<Leads_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchLeadsListCountQuery = { leads_aggregate: { aggregate?: { count: number } | null } };

export type GetLeadQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadQuery = { leads_by_pk?: { id: string, tenant_id: string, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_perception?: string | null, appraisal_perceived_value?: number | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, property?: { id: string, latest_appraisal?: { id: string, value?: number | null } | null } | null, lots: Array<{ id: string }>, lead_agents: Array<{ id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean, verified: boolean }> } | null } | null, lead_stages: Array<{ id: string }> };

export type LeadFeedQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type LeadFeedQuery = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, note?: string | null, extra_data?: any | null, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, user_id?: string | null, lead_id?: string | null, created_by?: string | null, created_at: any, due_at?: any | null, start_date?: string | null, pinned: boolean, visibility: string, subject?: string | null, success: boolean, done: boolean, consolidated_done_at?: any | null, assigned_to?: string | null, enquiry?: { message?: string | null, id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ image: { url?: string | null } }>, emails: Array<{ email: string }> } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null } | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null, email_message?: { to: any, cc: any, id: string, from: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> }> };

export type OldLeadFeedQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type OldLeadFeedQuery = { activities: Array<{ id: string, lead_id?: string | null, user_id?: string | null, buyer_lead_id?: string | null, lot_id?: string | null, enquiry_id?: string | null, created_at: any, created_by?: string | null, assigned_to?: string | null, done: boolean, due_at?: any | null, done_at?: any | null, start_date?: string | null, end_at?: any | null, consolidated_done_at?: any | null, activity_type: Activity_Types_Enum_Enum, subject?: string | null, note?: string | null, success: boolean, pinned: boolean, visibility: string, location?: string | null, extra_data?: any | null, email_message?: { id: string, message_id?: string | null, created_by?: string | null, from: any, to: any, cc: any, bcc: any, unread?: boolean | null, snippet?: string | null, subject?: string | null, nylas_thread_id?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null }> } | null, creator?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, relationship: Leads_Relationship_Enum, source: { id: string, name: string }, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, property?: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null } | null, lot?: { id: string, title?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } } | null, buyer_lead?: { id: string, user: { id: string, first_name?: string | null, last_name?: string | null } } | null, enquiry?: { id: string, first_name?: string | null, last_name?: string | null } | null, activities_target_users: Array<{ target_user_id?: string | null, email?: string | null, name?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> }> };

export type LeadAgentFragment = { id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, lead_id: string, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string } } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } };

export type GetLeadAgentsQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadAgentsQuery = { leads_by_pk?: { owner_team_id?: string | null } | null, lead_agents: Array<{ id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, lead_id: string, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string } } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type AddLeadAgentMutationVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  activity_object: Activities_Insert_Input;
}>;


export type AddLeadAgentMutation = { insert_lead_agents_one?: { id: string } | null, insert_activities_one?: { id: string } | null };

export type DeleteLeadAgentMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lead_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type DeleteLeadAgentMutation = { delete_lead_agents_by_pk?: { id: string } | null, update_activities?: { affected_rows: number } | null };

export type UpdateLeadAgentsMutationVariables = Exact<{
  where: Lead_Agents_Bool_Exp;
  set: Lead_Agents_Set_Input;
}>;


export type UpdateLeadAgentsMutation = { update_lead_agents?: { returning: Array<{ id: string, created_at: any, claimed_at?: any | null, passed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null, win_probability?: number | null, predicted_win_date?: string | null, lead_id: string, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum, pipeline: { id: string } } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> } | null };

export type GetBrokeragePipelineQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokeragePipelineQuery = { pipelines: Array<{ id: string, stages: Array<{ id: string, label?: string | null, status: Leads_Status_Enum, name?: string | null, pipeline: { id: string, lead_type: any } }> }> };

export type GetPipelineStagesQueryVariables = Exact<{
  pipeline_id: Scalars['uuid']['input'];
}>;


export type GetPipelineStagesQuery = { pipelines_by_pk?: { id: string, stages: Array<{ id: string, label?: string | null, status: Leads_Status_Enum, name?: string | null, pipeline: { id: string, lead_type: any } }> } | null };

export type GetLeadAgentSelectCardQueryVariables = Exact<{
  lead_id: Scalars['uuid']['input'];
}>;


export type GetLeadAgentSelectCardQuery = { leads_by_pk?: { owner_team_id?: string | null } | null, lead_agents: Array<{ id: string, lead_id: string, source?: Lead_Agent_Source_Enum_Enum | null, passed_at?: any | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lead_stage?: { id: string, pipeline_id: string } | null }> };

export type AssignBrokerMutationVariables = Exact<{
  broker_id: Scalars['uuid']['input'];
  lead_id: Scalars['uuid']['input'];
  team_ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  stage_id?: InputMaybe<Scalars['uuid']['input']>;
  activity_object: Activities_Insert_Input;
  reassignment: Lead_Agents_Updates;
  keep_tasks: Activities_Bool_Exp;
}>;


export type AssignBrokerMutation = { update_activities?: { affected_rows: number } | null, insert_activities_one?: { id: string } | null, insert_lead_agents_one?: { id: string } | null, delete_lead_agents?: { affected_rows: number } | null, update_lead_agents_many?: Array<{ affected_rows: number } | null> | null };

export type MarketingCardLeadFragmentFragment = { referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null };

export type GetListingBrochureTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingBrochureTemplatesQuery = { brochure_templates: Array<{ id: string, name: string, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }> };

export type GetListingBrochureStatsQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  to?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetListingBrochureStatsQuery = { document_stats?: { total_opens: number, unique_opens: number, unidentified_opens?: number | null, daily: Array<{ date: string, total: number, unique: number }> } | null };

export type GetListingBuyersLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeBuyerLeads: Scalars['Boolean']['input'];
  buyerLeadsWhere: Buyer_Leads_Bool_Exp;
}>;


export type GetListingBuyersLeadQuery = { matched_stage: Array<{ id: string, name?: string | null, label?: string | null }>, lots_by_pk?: { id: string, title?: string | null, mandate_type?: string | null, lot_reference?: string | null, auto_matching_filters?: any | null, tenant_id: string, brochure_doc_template_id?: string | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, price_unit?: string | null, rent_extra?: number | null, property: { id: string, locality?: string | null, locality_id?: string | null, postcode?: string | null, number_of_rooms?: number | null, computed_surface?: number | null, living_surface?: number | null, route?: string | null, street_number?: string | null, state?: string | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, property_type?: { id: string, label?: string | null, main_type?: string | null, name?: string | null, composite_type_object?: { id: string, name?: string | null } | null } | null, places?: Array<{ id: string }> | null, municipality_place?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null }, buyer_leads?: Array<{ id: string, stage_id?: string | null, order_nr: number, source?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, mls_lot?: { id?: string | null, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null } | null }>, all_buyer_leads?: Array<{ id: string, stage_id?: string | null, user_id: string }>, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null } | null };

export type GetListingDuplicateDialogDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingDuplicateDialogDataQuery = { lots_by_pk?: { property: { id: string, property_images_aggregate: { aggregate?: { count: number } | null }, property_files_aggregate: { aggregate?: { count: number } | null } } } | null };

export type GetListingDuplicationDataQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeDocuments: Scalars['Boolean']['input'];
  includePhotos: Scalars['Boolean']['input'];
}>;


export type GetListingDuplicationDataQuery = { lots_by_pk?: { id: string, use_custom_brochure_description: boolean, brochure_description_en?: string | null, brochure_description_fr?: string | null, brochure_description_de?: string | null, brochure_description_it?: string | null, brochure_description_es?: string | null, brochure_description_pl?: string | null, brochure_description_pt?: string | null, property: { id: string, property_files?: Array<{ file_id: string, property_id: string, file: { id: string } }>, property_images?: Array<{ id: string, property_id: string, image_id: string, image: { id: string } }> } } | null };

export type GetListingMarketingQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
}>;


export type GetListingMarketingQuery = { lots_by_pk?: { id: string, status: Lots_Status_Enum_Enum, offer_type?: string | null, shared_on_mls_at?: any | null, enable_auto_matching: boolean, auto_matching_filters?: any | null, send_enquiries_to_sellers: boolean, dummy_living_surface: string, dummy_usable_surface: string, listing_url?: string | null, enquiry_response_enabled?: boolean | null, tenant_id: string, title?: string | null, lot_reference?: string | null, mandate_type?: string | null, rent_net?: number | null, rent_extra?: number | null, sale_price?: number | null, brochure_doc_template_id?: string | null, broker?: { id: string, branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, teams_users: Array<{ team_id: string, user_id: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }>, property: { id: string, gross_floor_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, land_surface?: number | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null }, tenant: { id: string, country_code: string }, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null } | null };

export type UpdateEnquiryReponseEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateEnquiryReponseEmailMutation = { update_lots_by_pk?: { id: string, enquiry_response_enabled?: boolean | null, tenant_id: string, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, enquiry_response_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, response_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, development?: { id: string, enquiry_response_override_lot: boolean, enquiry_response_enabled?: boolean | null, email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }> } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } | null };

export type GetListingOffersQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
}>;


export type GetListingOffersQuery = { offers: Array<{ id: string, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, created_by?: string | null, lot: { id: string, currency?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { id: string, country_code?: string | null } }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type ListingOverviewPropertyFragment = { residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, id: string, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null };

export type ListingOverviewFragment = { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, development_id?: string | null, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, fsbo_hide_phone: boolean, fsbo_hide_last_name: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls_at?: any | null, tenant_number?: number | null, minimal_stay?: number | null, tenant_gender?: Tenant_Gender_Enum_Enum | null, youngest_tenant_age?: number | null, oldest_tenant_age?: number | null, smoking_allowed?: boolean | null, couples_allowed?: boolean | null, pets_allowed?: boolean | null, occupied_now?: boolean | null, furnished?: boolean | null, owner_living?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum, tenant_id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null, fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null } | null, lead?: { id: string, created_by?: string | null, origin_enquiry_id?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, bed_type?: Bed_Type_Enum_Enum | null, window_view?: Window_View_Enum_Enum | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }>, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { increment: number, id: string, name?: string | null, active: boolean } }>, origin?: { id: string, label?: string | null, name: string } | null, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> };

export type UpdateListingSellersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  sellers: Array<Lot_Sellers_Insert_Input> | Lot_Sellers_Insert_Input;
}>;


export type UpdateListingSellersMutation = { delete_lot_sellers?: { affected_rows: number } | null, insert_lot_sellers?: { returning: Array<{ user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null };

export type PropertyImageVersionFieldsFragment = { id: string, image_id: string, source_image_id?: string | null, prompt?: string | null, created_at: any, image: { id: string, url?: string | null } };

export type GetPropertyImagesQueryVariables = Exact<{
  property_id: Scalars['uuid']['input'];
}>;


export type GetPropertyImagesQuery = { watermark_lots: Array<{ id: string, watermark_enabled: boolean }>, property_images: Array<{ id: string, property_id: string, title?: string | null, description?: string | null, display_on_brochure: boolean, display_on_listing: boolean, is_floor_plan: boolean, size: string, crop: string, background_color: string, order_nr: number, watermarked_url?: string | null, image_id: string, image: { id: string, url?: string | null }, versions: Array<{ id: string, image_id: string, source_image_id?: string | null, prompt?: string | null, created_at: any, image: { id: string, url?: string | null } }> }> };

export type GetPropertyImagesCountQueryVariables = Exact<{
  property_id: Scalars['uuid']['input'];
}>;


export type GetPropertyImagesCountQuery = { property_images_aggregate: { aggregate?: { count: number } | null } };

export type InsertPropertyImageMutationVariables = Exact<{
  object: Property_Images_Insert_Input;
}>;


export type InsertPropertyImageMutation = { insert_property_images_one?: { display_on_brochure: boolean, display_on_listing: boolean, id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } } | null };

export type InsertPropertyImagesBatchMutationVariables = Exact<{
  objects: Array<Property_Images_Insert_Input> | Property_Images_Insert_Input;
}>;


export type InsertPropertyImagesBatchMutation = { insert_property_images?: { returning: Array<{ id: string, property_id: string, title?: string | null, description?: string | null, display_on_brochure: boolean, display_on_listing: boolean, is_floor_plan: boolean, size: string, crop: string, background_color: string, order_nr: number, watermarked_url?: string | null, image_id: string, image: { id: string, url?: string | null }, versions: Array<{ id: string, image_id: string, source_image_id?: string | null, prompt?: string | null, created_at: any, image: { id: string, url?: string | null } }> }> } | null };

export type DeletePropertyImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePropertyImageMutation = { delete_property_images_by_pk?: { id: string } | null };

export type UpdatePropertyImagesOrderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  new_order: Scalars['Int']['input'];
}>;


export type UpdatePropertyImagesOrderMutation = { update_property_images_by_pk?: { id: string, order_nr: number } | null };

export type UpdatePropertyImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  object: Property_Images_Set_Input;
}>;


export type UpdatePropertyImageMutation = { update_property_images_by_pk?: { id: string, title?: string | null, description?: string | null, display_on_brochure: boolean, display_on_listing: boolean, is_floor_plan: boolean, size: string, crop: string, background_color: string, order_nr: number, image: { id: string, url?: string | null } } | null };

export type SavePropertyImageVersionMutationVariables = Exact<{
  propertyImageId: Scalars['uuid']['input'];
  newImageId: Scalars['uuid']['input'];
  newImageUrl: Scalars['String']['input'];
  sourceImageId?: InputMaybe<Scalars['uuid']['input']>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  expectedCurrentImageId: Scalars['uuid']['input'];
}>;


export type SavePropertyImageVersionMutation = { save_property_image_version: Array<{ id: string, image_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null }, versions: Array<{ id: string, image_id: string, source_image_id?: string | null, prompt?: string | null, created_at: any, image: { id: string, url?: string | null } }> }> };

export type ActivatePropertyImageVersionMutationVariables = Exact<{
  propertyImageId: Scalars['uuid']['input'];
  targetImageId: Scalars['uuid']['input'];
  expectedCurrentImageId: Scalars['uuid']['input'];
}>;


export type ActivatePropertyImageVersionMutation = { activate_property_image_version: Array<{ id: string, image_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null }, versions: Array<{ id: string, image_id: string, source_image_id?: string | null, prompt?: string | null, created_at: any, image: { id: string, url?: string | null } }> }> };

export type GenerateImageMetadataQueryVariables = Exact<{
  property_image_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateImageMetadataQuery = { generate_image_metadata?: { title: string, description: string } | null };

export type GetListingTransactionsQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  includeValuations?: Scalars['Boolean']['input'];
}>;


export type GetListingTransactionsQuery = { property_transactions: Array<{ id: string, is_published: boolean, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, commissions: Array<{ id: string, is_paid?: boolean | null, amount?: number | null }>, lot?: { id: string, currency?: string | null } | null, sellers: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, buyers: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, commissions_aggregate: { aggregate?: { sum?: { amount?: number | null } | null } | null }, my_commissions: { aggregate?: { sum?: { amount?: number | null } | null } | null }, transaction_valuations_aggregate?: { aggregate?: { count: number } | null } }> };

export type ListingsDetailedViewFragment = { property: { id: string, floor_of_flat?: number | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, basement_surface?: number | null, garden_surface?: number | null, land_surface?: number | null } };

export type CurrentListingFragment = { id: string, order_nr: number };

export type GetListingBuyersQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetListingBuyersQuery = { buyer_leads: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type GetDocumentRecipientsQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDocumentRecipientsQuery = { document_recipients?: { recipients: Array<{ user_id: string, name?: string | null, total_opens: number, unique_opens: number, last_open_at?: string | null }> } | null };

export type TrackedBrochureLinkMutationVariables = Exact<{
  url: Scalars['String']['input'];
  documentType?: InputMaybe<Scalars['String']['input']>;
  recipientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackedBrochureLinkMutation = { tracked_document_url?: { url: string } | null };

export type GetBrochureRecipientStatsQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
  recipientId: Scalars['String']['input'];
  from?: InputMaybe<Scalars['timestamptz']['input']>;
  to?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type GetBrochureRecipientStatsQuery = { document_stats?: { total_opens: number, unique_opens: number, daily: Array<{ date: string, total: number, unique: number }> } | null };

export type GetListingBuyersAutoMatchingQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
}>;


export type GetListingBuyersAutoMatchingQuery = { lots_by_pk?: { id: string, auto_matching_filters?: any | null, offer_type?: string | null, enable_auto_matching: boolean, tenant_id: string, auto_matching_response_enabled: boolean, listing_url?: string | null, sale_price?: number | null, rent_net?: number | null, price_unit?: string | null, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, rent_extra?: number | null, auto_matching_email_templates: Array<{ id: string, name?: string | null, cc?: any | null, bcc?: any | null, subject?: string | null, text?: string | null, add_signature: boolean, is_shared_with_organisation: boolean, is_shared_with_everyone: boolean, email_templates_files: Array<{ email_template_id: string, file_id: string, file: { id: string, name: string, url: string, size: number, mimetype?: string | null } }> }>, automatching_sender?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, broker?: { branding_logo?: string | null, branding_color?: string | null, branding_name?: string | null, branding_website?: string | null, id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, nylas_account: Array<{ __typename: 'logins' }>, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, property: { id: string, computed_surface?: number | null, locality_id?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, places?: Array<{ id: string }> | null, property_type?: { id: string, label?: string | null, composite_type_object?: { id: string, name?: string | null } | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null }, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null } | null };

export type UpdateListingBuyersAutoMatchingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: Lots_Set_Input;
}>;


export type UpdateListingBuyersAutoMatchingMutation = { update_lots_by_pk?: { id: string, enable_auto_matching: boolean, auto_matching_response_enabled: boolean } | null };

export type GetListingPortalsSettingsQueryVariables = Exact<{
  listingId: Scalars['uuid']['input'];
}>;


export type GetListingPortalsSettingsQuery = { lots_by_pk?: { id: string, offer_type?: string | null, dummy_living_surface: string, dummy_usable_surface: string, listing_url?: string | null, broker?: { id: string, teams_users: Array<{ team_id: string, user_id: string }> } | null, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { id: string, name?: string | null, active: boolean } }>, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }>, property: { id: string, gross_floor_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, built_surface?: number | null }, tenant: { id: string, country_code: string } } | null };

export type UpdateListingReferenceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot_reference?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateListingReferenceMutation = { update_lots_by_pk?: { id: string, lot_reference?: string | null } | null };

export type RentedRoomDetailsFragment = { tenant_number?: number | null, minimal_stay?: number | null, tenant_gender?: Tenant_Gender_Enum_Enum | null, youngest_tenant_age?: number | null, oldest_tenant_age?: number | null, smoking_allowed?: boolean | null, couples_allowed?: boolean | null, pets_allowed?: boolean | null, occupied_now?: boolean | null, furnished?: boolean | null, owner_living?: boolean | null, property: { bed_type?: Bed_Type_Enum_Enum | null, window_view?: Window_View_Enum_Enum | null } };

export type GetRentedRoomEnumLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRentedRoomEnumLabelsQuery = { bed_type_options: Array<{ value: string, label?: string | null }>, window_view_options: Array<{ value: string, label?: string | null }>, tenant_gender_options: Array<{ value: string, label?: string | null }> };

export type ListingEnquiriesOverTimeQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingEnquiriesOverTimeQuery = { enquiries: Array<{ id: string, created_at: any, portal_id?: string | null, portal?: { id: string, name?: string | null } | null }> };

export type ListingBuyerLeadsOverTimeQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingBuyerLeadsOverTimeQuery = { buyer_leads: Array<{ id: string, created_at: any, source?: string | null }> };

export type ListingOffersOverTimeQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingOffersOverTimeQuery = { offers: Array<{ id: string, made_on: string, status: Offers_Status_Enum }> };

export type ListingFunnelQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  from: Scalars['timestamptz']['input'];
  to: Scalars['timestamptz']['input'];
  realadvisorPortalId: Scalars['uuid']['input'];
}>;


export type ListingFunnelQuery = { realadvisor_portal_listings: Array<{ id: string, live: boolean, milliseconds_online: number, updated_at: any }>, enquiries: { aggregate?: { count: number } | null }, lot_buyer_leads: Array<{ user_id: string, successful_viewings: { aggregate?: { min?: { due_at?: any | null } | null } | null } }>, lot_offers: Array<{ id: string, buyer_id: string, made_on: string }> };

export type ListingDomQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingDomQuery = { lots_by_pk?: { id: string, status: Lots_Status_Enum_Enum } | null, get_lot_publication_history: Array<{ history: any }> };

export type ListingInsightsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  staleFloor: Scalars['timestamptz']['input'];
  staleBefore: Scalars['timestamptz']['input'];
  recentFrom: Scalars['timestamptz']['input'];
  priorFrom: Scalars['timestamptz']['input'];
  monthFrom: Scalars['timestamptz']['input'];
  now: Scalars['timestamptz']['input'];
}>;


export type ListingInsightsQuery = { unanswered: { aggregate?: { count: number } | null }, pending_offers: { aggregate?: { count: number } | null }, recent_enquiries: { aggregate?: { count: number } | null }, prior_enquiries: { aggregate?: { count: number } | null }, recent_viewings: { aggregate?: { count: number } | null }, prior_viewings: { aggregate?: { count: number } | null }, month_enquiries: { aggregate?: { count: number } | null }, month_viewings: { aggregate?: { count: number } | null } };

export type ListingBenchmarkSubjectQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingBenchmarkSubjectQuery = { lots_by_pk?: { id: string, sale_price?: number | null, lot_reference?: string | null, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, property: { id: string, lat?: number | null, lng?: number | null, number_of_rooms?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, property_type?: { main_type?: string | null, name?: string | null } | null } } | null };

export type ListingComparablesQueryVariables = Exact<{
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  property_main_type?: InputMaybe<Scalars['String']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
}>;


export type ListingComparablesQuery = { ch_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, state_id: string, original_id: string, lot_reference?: string | null, agency_reference?: string | null, url: string, property_type: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, es_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, state_id: string, original_id: string, lot_reference?: string | null, agency_reference?: string | null, url: string, property_type: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, fr_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, state_id: string, original_id: string, lot_reference?: string | null, agency_reference?: string | null, url: string, property_type: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, it_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, state_id: string, original_id: string, lot_reference?: string | null, agency_reference?: string | null, url: string, property_type: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }> };

export type ListingTransactionsQueryVariables = Exact<{
  target_property_id: Scalars['uuid']['input'];
}>;


export type ListingTransactionsQuery = { get_property_transactions_distance: Array<{ id: string, transaction_id: string, distance_in_meters: number, transaction?: { id?: string | null, purchase_price?: number | null, signature_date?: any | null, locality?: string | null, locality_id?: string | null, living_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, postcode?: string | null, property_type_name?: string | null } | null }> };

export type ListingTransactionPriceStatsQueryVariables = Exact<{
  placeIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  dateMin: Scalars['date']['input'];
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
}>;


export type ListingTransactionPriceStatsQuery = { ch_price_stats_historical?: Array<{ place_id: string, date: string, sale_price_m2: number }>, es_price_stats_historical?: Array<{ place_id: string, date: string, sale_price_m2: number }>, fr_price_stats_historical?: Array<{ place_id: string, date: string, sale_price_m2: number }>, it_price_stats_historical?: Array<{ place_id: string, date: string, sale_price_m2: number }> };

export type ListingGa4StatsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
}>;


export type ListingGa4StatsQuery = { listing_ga4_stats?: { data: Array<{ day: string, event_name: string, item_list_id?: string | null, count: number }> } | null };

export type GetListingBrochureTourOwnListingQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetListingBrochureTourOwnListingQuery = { lots: Array<{ id: string }> };

export type GetListingBrochureTourAnyListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingBrochureTourAnyListingQuery = { lots: Array<{ id: string }> };

export type BuyerLeadDashboardActivityFragment = { id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null };

export type BuyerLeadDashboardRowFragment = { id: string, source?: string | null, stage_id?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, name?: string | null, label?: string | null, order_nr: number } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, last_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }> };

export type GetListingBuyersDashboardQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingBuyersDashboardQuery = { lots_by_pk?: { id: string, enable_auto_matching: boolean, offers: Array<{ id: string, status: Offers_Status_Enum }>, buyer_leads: Array<{ id: string, source?: string | null, stage_id?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, name?: string | null, label?: string | null, order_nr: number } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, last_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }> }>, enquiries: Array<{ id: string, buyer_lead_id?: string | null }> } | null, viewings_pending: { aggregate?: { count: number } | null }, viewings_done: { aggregate?: { count: number } | null } };

export type GetListingBuyerLeadsListQueryVariables = Exact<{
  where: Buyer_Leads_Bool_Exp;
}>;


export type GetListingBuyerLeadsListQuery = { buyer_leads: Array<{ id: string, source?: string | null, stage_id?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, name?: string | null, label?: string | null, order_nr: number } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, last_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }> }> };

export type ListingEmailCampaignActivityFragment = { id: string, created_at: any, buyer_lead?: { id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null } | null, email_message?: { id: string, campaign_id?: string | null, status: string, subject?: string | null, created_at: any, error_message?: string | null, to: any } | null };

export type GetListingEmailCampaignsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetListingEmailCampaignsQuery = { activities: Array<{ email_message?: { id: string, campaign_id?: string | null, status: string, subject?: string | null, created_at: any } | null }> };

export type GetListingEmailCampaignRecipientsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  campaignId: Scalars['uuid']['input'];
}>;


export type GetListingEmailCampaignRecipientsQuery = { activities: Array<{ id: string, created_at: any, buyer_lead?: { id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null } | null, email_message?: { id: string, campaign_id?: string | null, status: string, subject?: string | null, created_at: any, error_message?: string | null, to: any } | null }> };

export type GetListingBuyersTourListingQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetListingBuyersTourListingQuery = { withBuyers: Array<{ id: string }>, any: Array<{ id: string }>, visibleWithBuyers: Array<{ id: string }> };

export type GetListingWatermarkTourListingQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetListingWatermarkTourListingQuery = { own: Array<{ id: string }>, visible: Array<{ id: string }> };

export type GetLotQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetLotQuery = { lots_by_pk?: { id: string, title?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null } } | null };

export type GetLotsListQueryVariables = Exact<{
  where: Lots_Bool_Exp;
  order_by: Array<Lots_Order_By> | Lots_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetLotsListQuery = { me?: { id: string, teams_users: Array<{ team_id: string }> } | null, lots: Array<{ created_at: any, updated_at: any, signed_at?: string | null, title?: string | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, status: Lots_Status_Enum_Enum, order_nr: number, is_exclusive?: boolean | null, lot_reference?: string | null, id: string, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, price_unit?: string | null, currency?: string | null, lots_status: { label?: string | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, fsbo_blocked_at?: any | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, fsbo_blocked_at?: any | null, first_name?: string | null, last_name?: string | null } | null, portal_listings: Array<{ id: string, portal_id: string, live: boolean }>, property: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, land_surface?: number | null, living_surface?: number | null, built_surface?: number | null, floor_of_flat?: number | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, basement_surface?: number | null, garden_surface?: number | null, country_code?: string | null, computed_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, title?: string | null, image: { id: string, url?: string | null } }>, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, enquiries: Array<{ id: string, portal_id?: string | null }>, enquiries_aggregate: { aggregate?: { count: number, max?: { created_at?: any | null } | null } | null }, offers_aggregate: { aggregate?: { count: number } | null } }>, portals: Array<{ id: string, team_id?: string | null, name?: string | null, quota?: number | null, type: Portals_Types_Enum_Enum, portal_listings_aggregate: { aggregate?: { count: number } | null }, team?: { id: string, name: string } | null, teams_portals: Array<{ team_id: string }> }> };

export type GetLotsListCountQueryVariables = Exact<{
  where: Lots_Bool_Exp;
}>;


export type GetLotsListCountQuery = { lots_aggregate: { aggregate?: { count: number } | null } };

export type TogglePortalListingMutationVariables = Exact<{
  portal_id: Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
  skip_ftp_check?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TogglePortalListingMutation = { toggle_portal_listing?: { id: string, portal_id: string, lot_id: string, live: boolean, milliseconds_online: number, last_publication_warnings?: any | null, lot?: { id: string, status: Lots_Status_Enum_Enum, tenant_id: string } | null, portal?: { id: string, name?: string | null, active: boolean } | null } | null };

export type SyncPortalListingMutationVariables = Exact<{
  portalId: Scalars['uuid']['input'];
  lotId: Scalars['uuid']['input'];
}>;


export type SyncPortalListingMutation = { update_portal_listing?: { success: boolean, warnings?: any | null } | null };

export type GetAvailableListingPortalsQueryVariables = Exact<{
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lot_id: Scalars['uuid']['input'];
}>;


export type GetAvailableListingPortalsQuery = { portals: Array<{ id: string, name?: string | null, type: Portals_Types_Enum_Enum, active: boolean, team_id?: string | null, teams_portals: Array<{ team_id: string }> }> };

export type DeleteLotMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteLotMutation = { delete_lots_by_pk?: { id: string } | null };

export type LotFeedQueryVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
}>;


export type LotFeedQuery = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, note?: string | null, extra_data?: any | null, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, user_id?: string | null, lead_id?: string | null, created_by?: string | null, created_at: any, due_at?: any | null, start_date?: string | null, pinned: boolean, visibility: string, subject?: string | null, success: boolean, done: boolean, consolidated_done_at?: any | null, assigned_to?: string | null, enquiry?: { message?: string | null, id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ image: { url?: string | null } }>, emails: Array<{ email: string }> } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null } | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null, email_message?: { to: any, cc: any, id: string, from: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> }> };

export type GetListingDetailsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingDetailsQuery = { lots_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, development_id?: string | null, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, fsbo_hide_phone: boolean, fsbo_hide_last_name: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls_at?: any | null, tenant_number?: number | null, minimal_stay?: number | null, tenant_gender?: Tenant_Gender_Enum_Enum | null, youngest_tenant_age?: number | null, oldest_tenant_age?: number | null, smoking_allowed?: boolean | null, couples_allowed?: boolean | null, pets_allowed?: boolean | null, occupied_now?: boolean | null, furnished?: boolean | null, owner_living?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum, tenant_id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null, fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null } | null, lead?: { id: string, created_by?: string | null, origin_enquiry_id?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, bed_type?: Bed_Type_Enum_Enum | null, window_view?: Window_View_Enum_Enum | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }>, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { increment: number, id: string, name?: string | null, active: boolean } }>, origin?: { id: string, label?: string | null, name: string } | null, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null };

export type GetListingEditContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingEditContextQuery = { property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, type: string }>, heating_enum: Array<{ value: string }>, heating_distribution_enum: Array<{ value: string }>, cooling_enum: Array<{ value: string }>, bed_type_options: Array<{ value: string, label?: string | null }>, window_view_options: Array<{ value: string, label?: string | null }>, tenant_gender_options: Array<{ value: string, label?: string | null }> };

export type FileFragment = { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null };

export type UpdateListingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lot?: InputMaybe<Lots_Set_Input>;
}>;


export type UpdateListingMutation = { update_lots_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, development_id?: string | null, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, fsbo_hide_phone: boolean, fsbo_hide_last_name: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls_at?: any | null, tenant_number?: number | null, minimal_stay?: number | null, tenant_gender?: Tenant_Gender_Enum_Enum | null, youngest_tenant_age?: number | null, oldest_tenant_age?: number | null, smoking_allowed?: boolean | null, couples_allowed?: boolean | null, pets_allowed?: boolean | null, occupied_now?: boolean | null, furnished?: boolean | null, owner_living?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum, tenant_id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null, fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null } | null, lead?: { id: string, created_by?: string | null, origin_enquiry_id?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, bed_type?: Bed_Type_Enum_Enum | null, window_view?: Window_View_Enum_Enum | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }>, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { increment: number, id: string, name?: string | null, active: boolean } }>, origin?: { id: string, label?: string | null, name: string } | null, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null };

export type UpdateListingTrackedMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Lots_Set_Input;
  activities: Array<Activities_Insert_Input> | Activities_Insert_Input;
  hasActivities: Scalars['Boolean']['input'];
}>;


export type UpdateListingTrackedMutation = { update_lots_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, development_id?: string | null, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, fsbo_hide_phone: boolean, fsbo_hide_last_name: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls_at?: any | null, tenant_number?: number | null, minimal_stay?: number | null, tenant_gender?: Tenant_Gender_Enum_Enum | null, youngest_tenant_age?: number | null, oldest_tenant_age?: number | null, smoking_allowed?: boolean | null, couples_allowed?: boolean | null, pets_allowed?: boolean | null, occupied_now?: boolean | null, furnished?: boolean | null, owner_living?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum, tenant_id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null, fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null } | null, lead?: { id: string, created_by?: string | null, origin_enquiry_id?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, bed_type?: Bed_Type_Enum_Enum | null, window_view?: Window_View_Enum_Enum | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }>, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { increment: number, id: string, name?: string | null, active: boolean } }>, origin?: { id: string, label?: string | null, name: string } | null, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null, insert_activities?: { returning: Array<{ id: string }> } | null };

export type CreateListingMutationVariables = Exact<{
  lot: InsertListingLotsInsertInput;
}>;


export type CreateListingMutation = { insert_lots_derived?: { id: string, lot?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, development_id?: string | null, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, fsbo_hide_phone: boolean, fsbo_hide_last_name: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls_at?: any | null, tenant_number?: number | null, minimal_stay?: number | null, tenant_gender?: Tenant_Gender_Enum_Enum | null, youngest_tenant_age?: number | null, oldest_tenant_age?: number | null, smoking_allowed?: boolean | null, couples_allowed?: boolean | null, pets_allowed?: boolean | null, occupied_now?: boolean | null, furnished?: boolean | null, owner_living?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum, tenant_id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null, fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null } | null, lead?: { id: string, created_by?: string | null, origin_enquiry_id?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, bed_type?: Bed_Type_Enum_Enum | null, window_view?: Window_View_Enum_Enum | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }>, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { increment: number, id: string, name?: string | null, active: boolean } }>, origin?: { id: string, label?: string | null, name: string } | null, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null } | null };

export type CreatePropertyFileMutationVariables = Exact<{
  object: Property_Files_Insert_Input;
}>;


export type CreatePropertyFileMutation = { insert_property_files_one?: { order_nr: number, is_visible: boolean, property_id: string, file_id: string, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, document_type?: { id: string, name: string, label?: string | null } | null } } | null };

export type UpdateListingWithPropertyMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  prop_id: Scalars['uuid']['input'];
  lot: Lots_Set_Input;
  property: Properties_Set_Input;
  activities?: Array<Activities_Insert_Input> | Activities_Insert_Input;
  hasActivities?: Scalars['Boolean']['input'];
}>;


export type UpdateListingWithPropertyMutation = { update_lots_by_pk?: { id: string, title?: string | null, description?: string | null, created_at: any, status: Lots_Status_Enum_Enum, currency?: string | null, sale_price?: number | null, offer_type?: string | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, minimum_net_seller_price?: number | null, commission_rate?: number | null, available_from?: string | null, virtual_visit_url?: string | null, video_url?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, broker_id?: string | null, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, is_parking_included_in_total: boolean, development_id?: string | null, use_dummy_address?: boolean | null, address_display_option: Address_Display_Options_Enum_Enum, dummy_route?: string | null, dummy_street_number?: string | null, dummy_locality?: string | null, dummy_state?: string | null, dummy_country_code?: string | null, dummy_postcode?: string | null, dummy_lng?: number | null, dummy_lat?: number | null, use_dummy_contact: boolean, fsbo_hide_phone: boolean, fsbo_hide_last_name: boolean, dummy_broker_name?: string | null, dummy_broker_phone?: string | null, dummy_organisation_name?: string | null, dummy_organisation_phone?: string | null, dummy_organisation_route?: string | null, dummy_organisation_street_number?: string | null, dummy_organisation_locality?: string | null, dummy_organisation_state?: string | null, dummy_organisation_country_code?: string | null, dummy_organisation_postcode?: string | null, dummy_organisation_lng?: number | null, dummy_organisation_lat?: number | null, mandate_sale_price?: number | null, is_sales_tax_inclusive?: boolean | null, duration_in_months?: number | null, origin_id?: string | null, has_success_fee: boolean, success_fee_type: string, success_fee_custom?: string | null, success_fee_percentage?: number | null, shared_on_mls_at?: any | null, tenant_number?: number | null, minimal_stay?: number | null, tenant_gender?: Tenant_Gender_Enum_Enum | null, youngest_tenant_age?: number | null, oldest_tenant_age?: number | null, smoking_allowed?: boolean | null, couples_allowed?: boolean | null, pets_allowed?: boolean | null, occupied_now?: boolean | null, furnished?: boolean | null, owner_living?: boolean | null, fixed_fee?: number | null, is_exclusive?: boolean | null, mandate_type?: string | null, expected_time_to_sell: string, signed_at?: string | null, seller_notification_frequency: Seller_Notification_Frequency_Enum_Enum, tenant_id: string, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, default_team?: { id: string, name: string, route?: string | null, street_number?: string | null, locality?: string | null, state?: string | null, country?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null }>, logo?: { id: string, url?: string | null } | null } | null, teams_users: Array<{ team_id: string }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, created_by_user?: { id: string, first_name?: string | null, last_name?: string | null, fsbo_blocked_at?: any | null, fsbo_blocked_reason?: string | null, fsbo_block_batch_id?: string | null } | null, lead?: { id: string, created_by?: string | null, origin_enquiry_id?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, appraisal_open_to_offer?: string | null, appraisal_selling_with?: string | null, appraisal_market_time?: number | null, appraisal_next_step?: string | null, appraisal_monthly_gross_rent?: number | null, appraisal_perceived_value?: number | null, appraisal_separation_next_step?: string | null, appraisal_inheritance_next_step?: string | null, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_perception?: string | null, buy_horizon: Leads_Buy_Horizon_Enum, ownership?: any | null, relationship: Leads_Relationship_Enum, mortgage_buying_status?: any | null, mortgage_status?: any | null, received_mortgage_offer?: boolean | null, created_at: any, requalified_at?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, appraisal_property_usage?: string | null, appraisal_property_occupied?: string | null, appraisal_property_route?: string | null, appraisal_property_street_number?: string | null, appraisal_property_postcode?: string | null, appraisal_property_locality?: string | null, appraisal_property_state?: string | null, appraisal_property_country_code?: string | null, anonymized_contact?: string | null, property?: { id: string, lat?: number | null, lng?: number | null, country_code?: string | null, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_residential_units?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, parking_yearly_rental_income?: number | null, number_of_commercial_units?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, plot_number?: string | null, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, max?: number | null, min?: number | null } | null } | null, lead_agents: Array<{ id: string, user_id: string, source?: Lead_Agent_Source_Enum_Enum | null, claimed_at?: any | null }>, contact?: { id: string, first_name?: string | null, last_name?: string | null, referrer?: string | null } | null } | null, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, computed_surface?: number | null, bed_type?: Bed_Type_Enum_Enum | null, window_view?: Window_View_Enum_Enum | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, property_images: Array<{ id: string, property_id: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }>, google_address?: { lat?: number | null, lng?: number | null } | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null }, buyer_leads: Array<{ id: string, source?: string | null }>, enquiries_aggregate: { aggregate?: { count: number } | null }, lot_reference_aliases: Array<{ reference_alias_decoded: number }>, portal_listings: Array<{ id: string, live: boolean, portal_id: string, portal: { increment: number, id: string, name?: string | null, active: boolean } }>, origin?: { id: string, label?: string | null, name: string } | null, enquiries: Array<{ id: string, created_at: any, portal_id?: string | null }> } | null, update_properties_by_pk?: { id: string, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, income_includes_parking?: boolean | null, is_parking_fully_rented?: boolean | null, parking_yearly_rental_income?: number | null, parking_potential_rental_income?: number | null, charges?: number | null, renovation_fund?: number | null, energy_certificate_version?: string | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, minergie_code?: number | null, plot_number?: string | null, floor_of_flat?: number | null, distance_to_airport?: number | null, distance_to_hospital?: number | null, distance_to_motorway?: number | null, distance_to_city_center?: number | null, distance_to_high_school?: number | null, distance_to_grocery_shop?: number | null, distance_to_kindergarten?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development: boolean, has_gym?: boolean | null, has_view?: boolean | null, has_attic?: boolean | null, has_sauna?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, residential_surface?: number | null, commercial_surface?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, gross_floor_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, land_surface?: number | null, basement_surface?: number | null, weighted_floor_surface?: number | null, building_volume?: number | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, is_oriented_south: boolean, is_oriented_west: boolean, is_oriented_north: boolean, is_oriented_east: boolean, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, construction_year?: number | null, renovation_year?: number | null, building_standard?: number | null, building_condition?: number | null, created_at: any, created_by?: string | null, property_type_id?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, street_number?: string | null, route?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, postcode?: string | null, lat?: number | null, lng?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, __property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null } | null, insert_activities?: { returning: Array<{ id: string }> } | null };

export type ListingDocumentsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type ListingDocumentsQuery = { lots_by_pk?: { id: string, property_id: string, property: { id: string, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }> } } | null };

export type UpdateFileMutationVariables = Exact<{
  input: Files_Set_Input;
  id: Scalars['uuid']['input'];
}>;


export type UpdateFileMutation = { update_files?: { affected_rows: number } | null };

export type UpdatePropertyFileMutationVariables = Exact<{
  input: Property_Files_Set_Input;
  file_id: Scalars['uuid']['input'];
  property_id: Scalars['uuid']['input'];
}>;


export type UpdatePropertyFileMutation = { update_property_files?: { returning: Array<{ property_id: string, file_id: string, is_visible: boolean }> } | null };

export type ReOrderPropertyFilesMutationVariables = Exact<{
  property_id: Scalars['uuid']['input'];
  file_id: Scalars['uuid']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type ReOrderPropertyFilesMutation = { update_property_files?: { affected_rows: number, returning: Array<{ property_id: string, file_id: string, order_nr: number }> } | null };

export type InsertLotsMutationVariables = Exact<{
  objects: Array<LotImportInput> | LotImportInput;
  development_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertLotsMutation = { import_lots?: Array<{ lot_id?: string | null }> | null };

export type DeleteLotsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteLotsMutation = { delete_lots?: { affected_rows: number } | null };

export type ExportLotsQueryVariables = Exact<{
  where: Lots_Bool_Exp;
}>;


export type ExportLotsQuery = { lots: Array<{ id: string, lot_reference?: string | null, status: Lots_Status_Enum_Enum, title?: string | null, description?: string | null, offer_type?: string | null, price_unit?: string | null, currency?: string | null, sale_price?: number | null, rent_extra?: number | null, rent_net?: number | null, monthly_rent_computed?: number | null, available_from?: string | null, brochure_title_en?: string | null, brochure_title_fr?: string | null, brochure_title_de?: string | null, brochure_title_it?: string | null, brochure_title_pl?: string | null, brochure_title_pt?: string | null, brochure_title_es?: string | null, brochure_description_de?: string | null, brochure_description_en?: string | null, brochure_description_es?: string | null, brochure_description_fr?: string | null, brochure_description_it?: string | null, brochure_description_pl?: string | null, brochure_description_pt?: string | null, video_url?: string | null, virtual_visit_url?: string | null, use_custom_brochure_description: boolean, use_custom_brochure_title: boolean, hide_price_on_brochure: boolean, hide_price_on_portals: boolean, send_enquiries_to_sellers: boolean, origin_id?: string | null, shared_on_mls_at?: any | null, mls_share_mode: string, mls_terms_enabled?: boolean | null, mls_commission_type?: Mls_Commission_Type_Enum_Enum | null, mls_buyer_agent_share_percent?: any | null, mls_buyer_agent_share_fixed_amount?: any | null, enquiry_response_enabled?: boolean | null, mandate_type?: string | null, is_exclusive?: boolean | null, signed_at?: string | null, is_sales_tax_inclusive?: boolean | null, commission_rate?: number | null, duration_in_months?: number | null, fixed_fee?: number | null, has_success_fee: boolean, order_nr: number, mandate_sale_price?: number | null, minimum_net_seller_price?: number | null, success_fee_percentage?: number | null, expected_time_to_sell: string, success_fee_custom?: string | null, success_fee_type: string, development_id?: string | null, created_at: any, updated_at: any, broker?: { full_name?: string | null, emails: Array<{ email: string }> } | null, property: { id: string, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, macro_location?: number | null, micro_location?: number | null, living_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, gross_floor_surface?: number | null, built_surface?: number | null, land_surface?: number | null, balcony_surface?: number | null, terrace_surface?: number | null, garden_surface?: number | null, basement_surface?: number | null, commercial_surface?: number | null, residential_surface?: number | null, ceiling_height?: number | null, building_volume?: number | null, building_volume_norm?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_floors?: number | null, floor_of_flat?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, parking_potential_rental_income?: number | null, parking_yearly_rental_income?: number | null, income_includes_parking?: boolean | null, number_of_lifts?: number | null, minergie_code?: number | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, has_view?: boolean | null, has_fireplace?: boolean | null, has_sauna?: boolean | null, has_gym?: boolean | null, has_wellness_area?: boolean | null, has_photovoltaic_panels?: boolean | null, has_swimming_pool?: boolean | null, has_attic?: boolean | null, has_cellar?: boolean | null, has_storage_room?: boolean | null, has_elevator?: boolean | null, is_child_friendly?: boolean | null, is_commercial_fully_rented?: boolean | null, is_luxury?: boolean | null, is_maisonette?: boolean | null, is_parking_fully_rented?: boolean | null, is_rental?: boolean | null, is_residential_fully_rented?: boolean | null, is_secondary_residence?: boolean | null, is_wheelchair_accessible?: boolean | null, construction_year?: number | null, renovation_year?: number | null, building_condition?: number | null, flat_condition?: number | null, plot_number?: string | null, plot_registry_number?: string | null, plot_is_constructible?: boolean | null, plot_has_constructible_reserve?: boolean | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, share_of_ownership?: number | null, residential_yearly_rental_income?: number | null, residential_potential_rental_income?: number | null, commercial_yearly_rental_income?: number | null, commercial_potential_rental_income?: number | null, renovation_fund?: number | null, heating?: Heating_Enum_Enum | null, cooling?: Cooling_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, energy_certificate_version?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, emissions?: number | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, estimated_higher_energy_cost?: number | null, estimated_lower_energy_cost?: number | null, created_at: any, updated_at: any, property_type?: { id: string, name?: string | null, main_type?: string | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, property_files: Array<{ property_id: string, file_id: string, file: { id: string, url: string } }> } }> };

export type UpdateLotsOrderMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type UpdateLotsOrderMutation = { update_lots_by_pk?: { id: string } | null };

export type UpdateAutoMatchingFiltersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  filters?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateAutoMatchingFiltersMutation = { update_lots_by_pk?: { id: string, auto_matching_filters?: any | null } | null };

export type GetListingSurroundingPlacesQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetListingSurroundingPlacesQuery = { get_surrounding_listing_places?: Array<{ place_id: string }> | null };

export type GetDevelopmentQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDevelopmentQuery = { developments_by_pk?: { id: string, title?: string | null, status: Development_Status_Enum_Enum, is_published: boolean, development_images: Array<{ image: { id: string, url?: string | null } }> } | null };

export type BlockFsboUsersMutationVariables = Exact<{
  user_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  lot_id?: InputMaybe<Scalars['uuid']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  batch_id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type BlockFsboUsersMutation = { block_fsbo_users?: { batch_id: string, blocked_user_ids: Array<string>, unpublished_lots: number, failed_portal_listings: number, failed_lots: number } | null };

export type UnblockFsboUsersMutationVariables = Exact<{
  user_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnblockFsboUsersMutation = { unblock_fsbo_users?: { user_ids: Array<string> } | null };

export type GetFsboBlockBatchQueryVariables = Exact<{
  batch_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type GetFsboBlockBatchQuery = { users: Array<{ id: string, full_name?: string | null, fsbo_blocked_at?: any | null }> };

export type GetFsboSellerClusterQueryVariables = Exact<{
  lot_id: Scalars['uuid']['input'];
}>;


export type GetFsboSellerClusterQuery = { fsbo_seller_cluster: Array<{ lot_id: string, kind: string, value: string, other_accounts: number, rejected_accounts: number, blocked_accounts: number, accounts: any, network_owner?: string | null }> };

export type CatchmentAreasQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type CatchmentAreasQuery = { users_by_pk?: { default_team?: { teams_users: Array<{ user: { catchment_areas: Array<{ place: { id: string, postcode?: string | null, country_code: string, lat: number, lng: number } }> } }> } | null } | null };

export type GetMlsBuyerLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetMlsBuyerLeadQuery = { buyer_leads_by_pk?: { id: string, created_at: any, source?: string | null, stage_id?: string | null, lead_stage?: { id: string, name?: string | null, label?: string | null } | null, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null } | null, lead_stages: Array<{ id: string, name?: string | null, label?: string | null }> };

export type UpdateMlsBuyerLeadStageFromDrawerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  stageId: Scalars['uuid']['input'];
}>;


export type UpdateMlsBuyerLeadStageFromDrawerMutation = { update_buyer_leads_by_pk?: { id: string, stage_id?: string | null, lead_stage?: { id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum } | null } | null };

export type GetMlsBuyerLeadsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetMlsBuyerLeadsQuery = { lead_stages: Array<{ id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum }>, buyer_leads: Array<{ id: string, stage_id?: string | null, order_nr: number, source?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, mls_lot?: { id?: string | null, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null } | null }> };

export type UpdateMlsBuyerLeadStageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: Buyer_Leads_Set_Input;
}>;


export type UpdateMlsBuyerLeadStageMutation = { update_buyer_leads_by_pk?: { id: string, stage_id?: string | null, order_nr: number, source?: string | null, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lot: { id: string, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null, broker?: { id: string, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }> } | null }, mls_user?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, primary_email?: string | null, primary_phone_number?: string | null, profile_image_url?: string | null } | null, mls_lot?: { id?: string | null, offer_type?: string | null, sale_price?: number | null, lot_reference?: string | null, broker_id?: string | null } | null } | null };

export type GetMlsListingActivityCountsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetMlsListingActivityCountsQuery = { matching_count: { aggregate?: { count: number } | null }, manual_count: { aggregate?: { count: number } | null }, other_count: { aggregate?: { count: number } | null }, offers_pending: { aggregate?: { count: number } | null }, offers_refused: { aggregate?: { count: number } | null }, offers_accepted: { aggregate?: { count: number } | null } };

export type GetMlsListingDrawerQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  teamIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  hasTeamId: Scalars['Boolean']['input'];
}>;


export type GetMlsListingDrawerQuery = { mls_lots: Array<{ id?: string | null, tenant_id?: string | null, title?: string | null, description?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, offer_type?: string | null, status?: string | null, created_at?: any | null, available_from?: string | null, lot_reference?: string | null, mls_share_mode?: string | null, mls_terms_enabled?: boolean | null, mls_commission_type?: string | null, mls_buyer_agent_share_percent?: any | null, mls_buyer_agent_share_fixed_amount?: any | null, mls_note?: string | null, effective_address?: any | null, broker?: { id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, profile_image_url?: string | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }>, default_team?: { id: string, name: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, state?: string | null, country?: string | null, logo?: { id: string, url?: string | null } | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, organisation?: { id: string, organisation_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }> } | null } | null } | null, property?: { id?: string | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bathrooms?: number | null, construction_year?: number | null, property_images: Array<{ id: string, property_id: string, image: { id: string, url?: string | null } }>, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }>, property_type?: { id: string, label?: string | null } | null } | null }>, lot_brochure_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }>, existing_share: Array<{ id: string }>, pending_request: Array<{ id: string }>, my_website_portal?: Array<{ portal: { id: string, name?: string | null, type: Portals_Types_Enum_Enum } }>, existing_portal_listings: Array<{ id: string, portal_id: string, live: boolean, portal: { id: string, type: Portals_Types_Enum_Enum } }> };

export type GetListingMlsSettingsQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetListingMlsSettingsQuery = { lot?: { id: string, shared_on_mls_at?: any | null, mls_share_mode: string, mls_terms_enabled?: boolean | null, mls_commission_type?: Mls_Commission_Type_Enum_Enum | null, mls_buyer_agent_share_percent?: any | null, mls_buyer_agent_share_fixed_amount?: any | null, mls_note?: string | null, currency?: string | null, broker?: { id: string, teams_users: Array<{ team_id: string }> } | null, portal_listings: Array<{ id: string, portal: { id: string, team_id?: string | null } }> } | null, listing_shares: Array<{ id: string, lot_id: string, team_id: string, shared_by_user_id?: string | null, created_at: any, team: { id: string, name: string } }>, share_requests: Array<{ id: string, lot_id: string, team_id: string, requested_by_user_id?: string | null, requester_name?: string | null, status: string, handled_at?: any | null, created_at: any, team: { id: string, name: string } }> };

export type GetMlsSharedTeamDetailsQueryVariables = Exact<{
  teamIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetMlsSharedTeamDetailsQuery = { shared_teams: Array<{ id?: string | null, name?: string | null, logo_url?: string | null, team?: { id: string, locality?: string | null, postcode?: string | null } | null }> };

export type GetMlsNetworkTeamsQueryVariables = Exact<{
  where: Mls_Network_Teams_Bool_Exp;
  countryCode: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Mls_Network_Teams_Order_By> | Mls_Network_Teams_Order_By>;
}>;


export type GetMlsNetworkTeamsQuery = { network_teams: Array<{ id?: string | null, name?: string | null, country_code?: string | null, broker_count?: any | null, active_mls_listings_count?: any | null, logo_url?: string | null, team?: { id: string, locality?: string | null, postcode?: string | null, places?: Array<{ id: string }> | null } | null }>, network_teams_aggregate: { aggregate?: { count: number } | null }, network_teams_total: { aggregate?: { count: number } | null } };

export type GetMlsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By> | Mls_Lots_Order_By>;
}>;


export type GetMlsQuery = { mls_lots_aggregate: { aggregate?: { count: number } | null }, mls_lots: Array<{ id?: string | null, created_at?: any | null, shared_on_mls_at?: any | null, title?: string | null, lot_reference?: string | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, status?: string | null, currency?: string | null, hide_price_on_portals?: boolean | null, mls_share_mode?: string | null, mls_terms_enabled?: boolean | null, mls_commission_type?: string | null, mls_buyer_agent_share_percent?: any | null, access_status?: string | null, effective_address?: any | null, portal_listings: Array<{ id: string, live: boolean }>, broker?: { id?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null, default_team?: { id: string, name: string, logo?: { url?: string | null } | null } | null } | null, property?: { id?: string | null, living_surface?: number | null, number_of_rooms?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, property_type?: { id: string, label?: string | null } | null, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }> } | null }> };

export type GetMlsLotsMapQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mls_Lots_Bool_Exp>;
  order_by?: InputMaybe<Array<Mls_Lots_Order_By> | Mls_Lots_Order_By>;
  minLng: Scalars['float8']['input'];
  minLat: Scalars['float8']['input'];
  maxLng: Scalars['float8']['input'];
  maxLat: Scalars['float8']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  marketOn?: Scalars['Boolean']['input'];
}>;


export type GetMlsLotsMapQuery = { mls_lots: Array<{ id?: string | null, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, status?: string | null, currency?: string | null, access_status?: string | null, effective_address?: any | null, market_place_id?: string | null, mls_share_mode?: string | null, mls_commission_type?: string | null, mls_buyer_agent_share_percent?: any | null, mls_buyer_agent_share_fixed_amount?: any | null, hot_score?: number | null, broker_id?: string | null, property?: { id?: string | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, number_of_rooms?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null, composite_type_object?: { id: string, name?: string | null } | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, broker?: { id?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null, default_team?: { id: string, name: string, logo?: { url?: string | null } | null } | null } | null }> };

export type GetMlsAgentBboxQueryVariables = Exact<{
  where: Mls_Lots_Bool_Exp;
  limit: Scalars['Int']['input'];
}>;


export type GetMlsAgentBboxQuery = { mls_lots: Array<{ id?: string | null, effective_address?: any | null }> };

export type GetMlsViewportMatchesQueryVariables = Exact<{
  lotIds: Scalars['_uuid']['input'];
}>;


export type GetMlsViewportMatchesQuery = { mls_agent_buyer_matches: Array<{ lot_id?: string | null, buyer_user_id?: string | null, property_search_id?: string | null }> };

export type GetAgentPropertySearchesQueryVariables = Exact<{
  where: Property_Searches_Bool_Exp;
  limit: Scalars['Int']['input'];
  includeGeometry?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAgentPropertySearchesQuery = { property_searches: Array<{ id: string, user_id?: string | null, offer_type?: string | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, composite_property_type_eq?: string | null, property_searches_places: Array<{ place_id: string, place: { id: string, name: string, lat: number, lng: number, simplified_geom?: any | null } }>, user?: { id: string, first_name?: string | null, last_name?: string | null } | null }> };

export type GetPlacesGeometryQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPlacesGeometryQuery = { places: Array<{ id: string, name: string, simplified_geom?: any | null }> };

export type GetMlsAccessQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  teamId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetMlsAccessQuery = { existing_share: Array<{ id: string }>, pending_request: Array<{ id: string }>, my_website_portal: Array<{ portal: { id: string, name?: string | null, type: Portals_Types_Enum_Enum } }>, existing_portal_listings: Array<{ id: string, portal_id: string, live: boolean }>, lot_brochure_templates: Array<{ id: string, name: string, active: boolean, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }> };

export type GetTeamMlsSettingsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamMlsSettingsQuery = { settings: Array<{ id: string, team_id: string, tenant_id: string, auto_publish_shared_listings?: boolean | null, auto_match_with_buyers?: boolean | null, auto_matching_email_template_id?: string | null, auto_matching_email_template?: { id: string, name?: string | null } | null }> };

export type UpdateLotMlsFieldMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  changes: Lots_Set_Input;
}>;


export type UpdateLotMlsFieldMutation = { update_lots_by_pk?: { id: string, shared_on_mls_at?: any | null, mls_share_mode: string, mls_terms_enabled?: boolean | null, mls_commission_type?: Mls_Commission_Type_Enum_Enum | null, mls_buyer_agent_share_percent?: any | null, mls_buyer_agent_share_fixed_amount?: any | null, mls_note?: string | null } | null };

export type UpdateListingMlsSettingsMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  sharedOnMlsAt?: InputMaybe<Scalars['timestamptz']['input']>;
  mlsShareMode?: InputMaybe<Scalars['String']['input']>;
  mlsTermsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mlsCommissionType?: InputMaybe<Mls_Commission_Type_Enum_Enum>;
  mlsBuyerAgentSharePercent?: InputMaybe<Scalars['numeric']['input']>;
  mlsBuyerAgentShareFixedAmount?: InputMaybe<Scalars['numeric']['input']>;
  mlsNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateListingMlsSettingsMutation = { update_lots_by_pk?: { id: string, shared_on_mls_at?: any | null, mls_share_mode: string, mls_terms_enabled?: boolean | null, mls_commission_type?: Mls_Commission_Type_Enum_Enum | null, mls_buyer_agent_share_percent?: any | null, mls_buyer_agent_share_fixed_amount?: any | null, mls_note?: string | null } | null };

export type ShareListingWithTeamMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
  sharedByUserId: Scalars['uuid']['input'];
}>;


export type ShareListingWithTeamMutation = { insert_mls_shares_one?: { id: string, lot_id: string, team_id: string, status: string, created_at: any } | null };

export type RemoveListingShareMutationVariables = Exact<{
  shareId: Scalars['uuid']['input'];
}>;


export type RemoveListingShareMutation = { delete_mls_shares_by_pk?: { id: string } | null };

export type RequestMlsListingAccessMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  requestingTeamId: Scalars['uuid']['input'];
  requestingUserId: Scalars['uuid']['input'];
}>;


export type RequestMlsListingAccessMutation = { insert_mls_shares_one?: { id: string, lot_id: string, team_id: string, status: string, created_at: any } | null };

export type HandleMlsShareRequestMutationVariables = Exact<{
  requestId: Scalars['uuid']['input'];
  status: Scalars['String']['input'];
  handledByUserId: Scalars['uuid']['input'];
}>;


export type HandleMlsShareRequestMutation = { update_mls_shares_by_pk?: { id: string, status: string, handled_at?: any | null, lot_id: string, team_id: string } | null };

export type UpdateTeamMlsSettingsMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  autoPublishSharedListings?: InputMaybe<Scalars['Boolean']['input']>;
  autoMatchWithBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  autoMatchingEmailTemplateId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpdateTeamMlsSettingsMutation = { insert_mls_settings_one?: { id: string, team_id: string, auto_publish_shared_listings?: boolean | null, auto_match_with_buyers?: boolean | null, auto_matching_email_template_id?: string | null } | null };

export type GetMlsLotForMatchingQueryVariables = Exact<{
  lotId: Scalars['uuid']['input'];
}>;


export type GetMlsLotForMatchingQuery = { mls_lots: Array<{ id?: string | null, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, price_unit?: string | null, property?: { id?: string | null, places?: Array<{ id: string, type: Place_Type_Enum_Enum }> | null, property_type?: { id: string, composite_type_object?: { id: string, name?: string | null } | null } | null } | null }>, get_surrounding_listing_places?: Array<{ place_id: string }> | null };

export type GetMlsShareMatchingCriteriaQueryVariables = Exact<{
  shareId: Scalars['uuid']['input'];
}>;


export type GetMlsShareMatchingCriteriaQuery = { mls_shares_by_pk?: { id: string, auto_matching_filters?: any | null } | null };

export type UpsertMlsShareMatchingCriteriaMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  filters?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpsertMlsShareMatchingCriteriaMutation = { upsert_mls_share_criteria: Array<{ id: string, auto_matching_filters?: any | null }> };

export type PublishMlsListingToWebsiteMutationVariables = Exact<{
  lotId: Scalars['uuid']['input'];
  portalId: Scalars['uuid']['input'];
  live: Scalars['Boolean']['input'];
}>;


export type PublishMlsListingToWebsiteMutation = { insert_portal_listings_one?: { id: string, lot_id: string, portal_id: string, live: boolean } | null };

export type GetMlsShareTourListingQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetMlsShareTourListingQuery = { unshared: Array<{ id: string }>, any: Array<{ id: string }>, visibleUnshared: Array<{ id: string }> };

export type GetMlsBuyersEmailTourListingQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetMlsBuyersEmailTourListingQuery = { own: Array<{ lot_id: string }>, any: Array<{ lot_id: string }> };

export type NotificationSettingFieldsFragment = { type: string, is_active: boolean, requires_channel: boolean, modules?: Array<string> | null, country_codes?: Array<string> | null, audience: string, order_nr: number, created_at: any, updated_at: any, label_en: string, label_fr?: string | null, label_de?: string | null, label_it?: string | null, label_es?: string | null, label_pl?: string | null, label_pt?: string | null, description_en: string, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_es?: string | null, description_pl?: string | null, description_pt?: string | null, email_available: boolean, email_default: boolean, sms_available: boolean, sms_default: boolean, push_available: boolean, push_default: boolean, team_leader_cc_available: boolean, team_leader_cc_default: boolean };

export type GetUserNotificationSettingsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserNotificationSettingsQuery = { users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string }>, pro_app_tokens: Array<{ id: string }>, tenant: { id: string, country_code: string }, teams_users: Array<{ team_id: string }>, module_grants: Array<{ module_id: Modules_Enum_Enum }> } | null, notification_settings: Array<{ type: string, is_active: boolean, requires_channel: boolean, modules?: Array<string> | null, country_codes?: Array<string> | null, audience: string, order_nr: number, created_at: any, updated_at: any, label_en: string, label_fr?: string | null, label_de?: string | null, label_it?: string | null, label_es?: string | null, label_pl?: string | null, label_pt?: string | null, description_en: string, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_es?: string | null, description_pl?: string | null, description_pt?: string | null, email_available: boolean, email_default: boolean, sms_available: boolean, sms_default: boolean, push_available: boolean, push_default: boolean, team_leader_cc_available: boolean, team_leader_cc_default: boolean, user_preferences: Array<{ email_enabled?: boolean | null, sms_enabled?: boolean | null, push_enabled?: boolean | null, team_leader_cc_enabled?: boolean | null }> }> };

export type SaveUserNotificationPreferencesMutationVariables = Exact<{
  objects: Array<User_Notification_Preferences_Insert_Input> | User_Notification_Preferences_Insert_Input;
  updateColumns: Array<User_Notification_Preferences_Update_Column> | User_Notification_Preferences_Update_Column;
}>;


export type SaveUserNotificationPreferencesMutation = { insert_user_notification_preferences?: { returning: Array<{ user_id: string, type: string, email_enabled?: boolean | null, sms_enabled?: boolean | null, push_enabled?: boolean | null, team_leader_cc_enabled?: boolean | null }> } | null };

export type GetAdminNotificationSettingsQueryVariables = Exact<{
  where?: InputMaybe<Notification_Settings_Bool_Exp>;
}>;


export type GetAdminNotificationSettingsQuery = { notification_settings: Array<{ type: string, is_active: boolean, requires_channel: boolean, modules?: Array<string> | null, country_codes?: Array<string> | null, audience: string, order_nr: number, created_at: any, updated_at: any, label_en: string, label_fr?: string | null, label_de?: string | null, label_it?: string | null, label_es?: string | null, label_pl?: string | null, label_pt?: string | null, description_en: string, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_es?: string | null, description_pl?: string | null, description_pt?: string | null, email_available: boolean, email_default: boolean, sms_available: boolean, sms_default: boolean, push_available: boolean, push_default: boolean, team_leader_cc_available: boolean, team_leader_cc_default: boolean }> };

export type GetNotificationSettingImpactQueryVariables = Exact<{
  settingType?: InputMaybe<Scalars['String']['input']>;
  countryCodes?: InputMaybe<Scalars['_text']['input']>;
  modules?: InputMaybe<Scalars['_text']['input']>;
  audience?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNotificationSettingImpactQuery = { notification_setting_impact: Array<{ eligible_users: number, email_on: number, sms_on: number, push_on: number, team_leader_cc_on: number, any_on: number, email_unset: number, sms_unset: number, push_unset: number, team_leader_cc_unset: number }> };

export type CreateAdminNotificationSettingMutationVariables = Exact<{
  object: Notification_Settings_Insert_Input;
  type: Scalars['String']['input'];
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  teamLeaderCc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateAdminNotificationSettingMutation = { insert_notification_settings_one?: { type: string, is_active: boolean, requires_channel: boolean, modules?: Array<string> | null, country_codes?: Array<string> | null, audience: string, order_nr: number, created_at: any, updated_at: any, label_en: string, label_fr?: string | null, label_de?: string | null, label_it?: string | null, label_es?: string | null, label_pl?: string | null, label_pt?: string | null, description_en: string, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_es?: string | null, description_pl?: string | null, description_pt?: string | null, email_available: boolean, email_default: boolean, sms_available: boolean, sms_default: boolean, push_available: boolean, push_default: boolean, team_leader_cc_available: boolean, team_leader_cc_default: boolean } | null, apply_notification_channels_to_existing_users: Array<{ type: string }> };

export type UpdateAdminNotificationSettingMutationVariables = Exact<{
  type: Scalars['String']['input'];
  newType: Scalars['String']['input'];
  set: Notification_Settings_Set_Input;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
  push?: InputMaybe<Scalars['Boolean']['input']>;
  teamLeaderCc?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAdminNotificationSettingMutation = { update_notification_settings_by_pk?: { type: string, is_active: boolean, requires_channel: boolean, modules?: Array<string> | null, country_codes?: Array<string> | null, audience: string, order_nr: number, created_at: any, updated_at: any, label_en: string, label_fr?: string | null, label_de?: string | null, label_it?: string | null, label_es?: string | null, label_pl?: string | null, label_pt?: string | null, description_en: string, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_es?: string | null, description_pl?: string | null, description_pt?: string | null, email_available: boolean, email_default: boolean, sms_available: boolean, sms_default: boolean, push_available: boolean, push_default: boolean, team_leader_cc_available: boolean, team_leader_cc_default: boolean } | null, apply_notification_channels_to_existing_users: Array<{ type: string }> };

export type DeleteAdminNotificationSettingMutationVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type DeleteAdminNotificationSettingMutation = { delete_notification_settings_by_pk?: { type: string } | null };

export type GetOffersQueryVariables = Exact<{
  where: Offers_Bool_Exp;
  order_by: Array<Offers_Order_By> | Offers_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetOffersQuery = { offers: Array<{ id: string, amount: number, valid_until?: string | null, status: Offers_Status_Enum, made_on: string, comments?: string | null, created_by?: string | null, lot: { id: string, currency?: string | null, title?: string | null, lot_reference?: string | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, hide_price_on_portals: boolean, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { id: string, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_surface?: number | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> };

export type GetOffersCountQueryVariables = Exact<{
  where: Offers_Bool_Exp;
}>;


export type GetOffersCountQuery = { offers_count: { aggregate?: { count: number } | null } };

export type GetOfferDrawerQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOfferDrawerQuery = { offers_by_pk?: { id: string, created_by?: string | null, amount: number, valid_until?: string | null, lot_id: string, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type DeleteOfferMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteOfferMutation = { delete_offers?: { affected_rows: number } | null };

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: Offers_Set_Input;
}>;


export type UpdateOfferMutation = { update_offers_by_pk?: { id: string, amount: number, valid_until?: string | null, lot_id: string, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type GetOfferRefusedTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfferRefusedTypesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null }> };

export type InsertOfferMutationVariables = Exact<{
  offer: Offers_Insert_Input;
}>;


export type InsertOfferMutation = { insert_offers_one?: { id: string, amount: number, valid_until?: string | null, lot_id: string, status: Offers_Status_Enum, made_on: string, comments?: string | null, lot: { id: string, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }, offer_refused_type?: { id: string, label?: string | null } | null, buyer: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } } | null };

export type OnboardingGenerateAgencyDescriptionQueryVariables = Exact<{
  agency_name: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type OnboardingGenerateAgencyDescriptionQuery = { generate_agency_description?: { description: string } | null };

export type FindOnboardingSocialLinksQueryVariables = Exact<{
  websiteUrl: Scalars['String']['input'];
}>;


export type FindOnboardingSocialLinksQuery = { find_onboarding_social_links: { links: Array<{ platform: string, url: string }> } };

export type GetAgentOnboardingPhonesQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetAgentOnboardingPhonesQuery = { users_by_pk?: { id: string, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null, is_visibility: boolean }> } | null };

export type BootstrapOnboardingAgencyMutationVariables = Exact<{
  team_name: Scalars['String']['input'];
  address: AgencySetupAddressInput;
}>;


export type BootstrapOnboardingAgencyMutation = { bootstrap_onboarding_agency?: { success: boolean, team_id: string } | null };

export type SaveOnboardingProgressMutationVariables = Exact<{
  input: SaveOnboardingProgressInput;
}>;


export type SaveOnboardingProgressMutation = { save_onboarding_progress?: { success: boolean, team_id: string } | null };

export type OnboardingAgentDictionaryAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingAgentDictionaryAvailabilityQuery = { languages: Array<{ id: string }>, certifications: Array<{ id: string }>, services: Array<{ id: string }> };

export type GetOnboardingAgentTransactionsQueryVariables = Exact<{
  brokerId: Scalars['uuid']['input'];
}>;


export type GetOnboardingAgentTransactionsQuery = { property_transactions: Array<{ id: string, signature_date?: any | null, property: { number_of_rooms?: number | null, number_of_bedrooms?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, seller_broker_team?: { id: string, name: string } | null, seller_broker?: { id: string, full_name?: string | null } | null }> };

export type GetOnboardingStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnboardingStateQuery = { get_onboarding_state?: { success: boolean, state: { can_invite_team_members: boolean, can_edit_team: boolean, is_claimed_profile: boolean, country_code?: string | null, team?: { id: string, name: string, show_in_agency_pages?: boolean | null, phone?: string | null, website_url?: string | null, description?: string | null, active_since?: number | null, logo_image_id?: string | null, logo_image_url?: string | null, cover_photo_image_id?: string | null, cover_photo_image_url?: string | null, facebook_url?: string | null, instagram_url?: string | null, tiktok_url?: string | null, linkedin_url?: string | null, x_url?: string | null, youtube_url?: string | null, address: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null }, members: Array<{ id: string, first_name?: string | null, last_name?: string | null, image_url?: string | null, is_leader: boolean }> } | null, agent: { first_name?: string | null, last_name?: string | null, phone?: string | null, description?: string | null, active_since?: number | null, languages?: Array<string> | null, certifications?: Array<string> | null, services?: Array<string> | null, user_image_id?: string | null, user_image_url?: string | null, facebook_profile?: string | null, instagram_profile?: string | null, tiktok_profile?: string | null, youtube_profile?: string | null, linked_in_profile?: string | null, x_profile?: string | null } } } | null };

export type CompleteFullOnboardingMutationVariables = Exact<{
  team_name: Scalars['String']['input'];
  address?: InputMaybe<AgencySetupAddressInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  active_since?: InputMaybe<Scalars['Int']['input']>;
  logo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  cover_photo_image_id?: InputMaybe<Scalars['uuid']['input']>;
  facebook_url?: InputMaybe<Scalars['String']['input']>;
  instagram_url?: InputMaybe<Scalars['String']['input']>;
  tiktok_url?: InputMaybe<Scalars['String']['input']>;
  linkedin_url?: InputMaybe<Scalars['String']['input']>;
  x_url?: InputMaybe<Scalars['String']['input']>;
  youtube_url?: InputMaybe<Scalars['String']['input']>;
  agent_first_name?: InputMaybe<Scalars['String']['input']>;
  agent_last_name?: InputMaybe<Scalars['String']['input']>;
  agent_description?: InputMaybe<Scalars['String']['input']>;
  agent_active_since?: InputMaybe<Scalars['Int']['input']>;
  agent_languages?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  agent_certifications?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  agent_services?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  agent_user_image_id?: InputMaybe<Scalars['uuid']['input']>;
  agent_facebook_profile?: InputMaybe<Scalars['String']['input']>;
  agent_instagram_profile?: InputMaybe<Scalars['String']['input']>;
  agent_tiktok_profile?: InputMaybe<Scalars['String']['input']>;
  agent_youtube_profile?: InputMaybe<Scalars['String']['input']>;
  agent_linked_in_profile?: InputMaybe<Scalars['String']['input']>;
  agent_x_profile?: InputMaybe<Scalars['String']['input']>;
  invitations?: InputMaybe<Array<OnboardingInvitationInput> | OnboardingInvitationInput>;
}>;


export type CompleteFullOnboardingMutation = { complete_full_onboarding?: { success: boolean, team_id: string, invitations_sent: boolean, onboarding_status?: string | null } | null };

export type OrganisationSettingsFragment = { id: string, name?: string | null, branding_color?: string | null, website?: string | null, is_lender: boolean, lat?: number | null, lng?: number | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, phone_numbers: Array<{ id: string, number: string, verified?: boolean | null, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null }>, emails: Array<{ id: string, email: string, verified: boolean, primary: boolean }> };

export type MatchTenantByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type MatchTenantByNameQuery = { read_only_tenants: Array<{ id?: string | null, name?: string | null }> };

export type OrganisationScoreCardsFragment = { id: string, teams: Array<{ id: string, teams_users: Array<{ user: { id: string, broker_leads_aggregate: { aggregate?: { count: number } | null }, lots_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { sum?: { purchase_price?: number | null } | null } | null } } }> }> };

export type OrganisationAddressFragment = { street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null };

export type GetOrganisationsListQueryVariables = Exact<{
  where: Organisations_Bool_Exp;
  order_by?: InputMaybe<Array<Organisations_Order_By> | Organisations_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetOrganisationsListQuery = { organisations: Array<{ id: string, created_at: any, updated_at: any, name?: string | null, lat?: number | null, lng?: number | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, organisation_images: Array<{ image: { url?: string | null } }>, teams: Array<{ id: string, logo?: { url?: string | null } | null }>, teams_aggregate: { aggregate?: { count: number } | null } }> };

export type GetOrganisationsListCountQueryVariables = Exact<{
  where: Organisations_Bool_Exp;
}>;


export type GetOrganisationsListCountQuery = { organisations_aggregate: { aggregate?: { count: number } | null } };

export type GetOrganisationQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationQuery = { organisations_by_pk?: { id: string, created_at: any, updated_at: any, name?: string | null } | null };

export type GetOrganisationMonitoringQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetOrganisationMonitoringQuery = { organisations_by_pk?: { id: string, name?: string | null, created_at: any, stripe_customer_ids: Array<string>, close_lead_id?: string | null, linked_tenant_id?: string | null, sales_rep_user_id?: string | null, csm_rep_user_id?: string | null, organisation_images: Array<{ image: { url?: string | null } }>, linked_tenant?: { id: string, name: string } | null, sales_rep?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, csm_rep?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, teams: Array<{ id: string, name: string, show_in_agency_pages?: boolean | null, agency_slug?: string | null, description?: string | null, website_url?: string | null, active_since?: number | null, locality?: string | null, country?: string | null, logo_image_id?: string | null, cover_photo_image_id?: string | null, idx_ftp_client_id?: string | null, idx_agency_id?: string | null, listings_agency_names?: Array<string> | null, logo?: { id: string, url?: string | null } | null, cover_photo?: { id: string, url?: string | null } | null, phone_numbers: Array<{ number: string }>, teams_users: Array<{ user: { id: string, full_name?: string | null, show_in_agency_pages?: boolean | null, description?: string | null, languages?: Array<string> | null, active_since?: number | null, services?: Array<string> | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, profile_user_images: Array<{ image: { id: string, url?: string | null } }>, user_transactions_2y: { aggregate?: { count: number } | null }, user_reviews_aggregate: { aggregate?: { count: number } | null }, engagement_reviews: Array<{ id: string, rating?: number | null, created_at: any }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }>, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, combined_reviews: Array<{ id?: string | null, rating?: number | null, review_date?: string | null }>, property_transactions_aggregate: { aggregate?: { count: number } | null }, recent_transactions: Array<{ id: string, created_at?: any | null, signature_date?: any | null, purchase_price?: number | null }> }> } | null };

export type GetOrganisationMonitoringActivityQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
  twoYearsAgoDate: Scalars['String']['input'];
  sellerContactsAvgPeriodStart: Scalars['timestamptz']['input'];
}>;


export type GetOrganisationMonitoringActivityQuery = { combined_reviews: Array<{ id?: string | null, review_date?: string | null, rating?: number | null, team_id?: string | null, type?: string | null }>, property_transactions: Array<{ id: string, signature_date?: any | null, created_at?: any | null, seller_broker_team_id?: string | null, purchase_price?: number | null }>, seller_contacts_avg_period: { aggregate?: { count: number } | null } };

export type GetOrganisationSellerSignalsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  windowStart: Scalars['timestamptz']['input'];
}>;


export type GetOrganisationSellerSignalsQuery = { seller_contacts_window: { aggregate?: { count: number } | null }, seller_enquiries_window: { aggregate?: { count: number } | null } };

export type GetOrganisationMonitoringAnalyticsQueryVariables = Exact<{
  agencyUuids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
}>;


export type GetOrganisationMonitoringAnalyticsQuery = { organisation_monitoring_analytics?: { profile_views_total: number, valuation_impressions_total: number, phone_clicks_total: number, profile_views_by_date: Array<{ date: string, count: number }>, valuation_impressions_by_date: Array<{ date: string, count: number }>, valuation_impressions_by_position?: Array<{ position: number, count: number }> | null } | null };

export type GetOrganisationPosthogUsageQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetOrganisationPosthogUsageQuery = { organisation_posthog_usage?: { source_usage: { crm_web: { active_users_30d: number, last_seen_date?: string | null }, b2b_mobile: { active_users_30d: number, last_seen_date?: string | null } }, cma: { active_days_30d: number, active_users_30d: number, events_30d: number, score: number, eligible: boolean, source_breakdown: { crm_web_events: number, b2b_mobile_events: number }, daily_series: Array<{ date: string, events: number, active_users: number, crm_web_events: number, b2b_mobile_events: number }>, users: Array<{ user_id: string, events_30d: number, active_days_30d: number, last_seen_date?: string | null }> }, visibility: { active_days_30d: number, active_users_30d: number, events_30d: number, score: number, eligible: boolean, source_breakdown: { crm_web_events: number, b2b_mobile_events: number }, daily_series: Array<{ date: string, events: number, active_users: number, crm_web_events: number, b2b_mobile_events: number }>, users: Array<{ user_id: string, events_30d: number, active_days_30d: number, last_seen_date?: string | null }> }, pmap: { active_days_30d: number, active_users_30d: number, events_30d: number, score: number, eligible: boolean, source_breakdown: { crm_web_events: number, b2b_mobile_events: number }, daily_series: Array<{ date: string, events: number, active_users: number, crm_web_events: number, b2b_mobile_events: number }>, users: Array<{ user_id: string, events_30d: number, active_days_30d: number, last_seen_date?: string | null }> }, crm: { active_days_30d: number, active_users_30d: number, events_30d: number, score: number, eligible: boolean, source_breakdown: { crm_web_events: number, b2b_mobile_events: number }, daily_series: Array<{ date: string, events: number, active_users: number, crm_web_events: number, b2b_mobile_events: number }>, users: Array<{ user_id: string, events_30d: number, active_days_30d: number, last_seen_date?: string | null }> } } | null };

export type OrganisationPosthogModuleUsageFragment = { active_days_30d: number, active_users_30d: number, events_30d: number, score: number, eligible: boolean, source_breakdown: { crm_web_events: number, b2b_mobile_events: number }, daily_series: Array<{ date: string, events: number, active_users: number, crm_web_events: number, b2b_mobile_events: number }>, users: Array<{ user_id: string, events_30d: number, active_days_30d: number, last_seen_date?: string | null }> };

export type GetOrganisationEngagementScoreQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
}>;


export type GetOrganisationEngagementScoreQuery = { organisation_engagement_score?: { organisation_id: string, score: number, previous_score: number, updated_at: string, signals: Array<{ key: string, score: number, previous_score: number, counted: boolean }>, history: Array<{ date: string, score: number, profile?: number | null, reviews?: number | null, transactions?: number | null, visibility?: number | null, cma?: number | null, prospection_map?: number | null, crm?: number | null, widget?: number | null }> } | null };

export type GetOrganisationVisibilityScoreQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
  hostname: Scalars['String']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrganisationVisibilityScoreQuery = { organisation_visibility_score?: { organisation_id: string, computed_at: string, window_days: number, hostname: string, country?: string | null, delta: number, current: { score: number, raw_score: number, profile_points: number, valuation_points: number, profile_views_total: number, valuation_views_total: number, phone_clicks_total: number, profile_views_target: number, effective_impressions: number, target_impressions: number, size_multiplier: number, transactions_count_24mo: number, seller_contact_target_per_month?: number | null, position_breakdown: Array<{ position: number, count: number, weight: number, weighted: number }>, signals: Array<{ id: string, points: number, max_points: number, color: string }> }, previous: { score: number, raw_score: number, profile_points: number, valuation_points: number, profile_views_total: number, valuation_views_total: number, phone_clicks_total: number, profile_views_target: number, effective_impressions: number, target_impressions: number, size_multiplier: number, transactions_count_24mo: number, seller_contact_target_per_month?: number | null, position_breakdown: Array<{ position: number, count: number, weight: number, weighted: number }>, signals: Array<{ id: string, points: number, max_points: number, color: string }> } } | null };

export type GetOrganisationPosthogCsatQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganisationPosthogCsatQuery = { organisation_posthog_csat?: { survey_count: number, team_user_count: number, response_count: number, response_rate_percent: number, average_score?: number | null, last_response_date?: string | null, responses: Array<{ user_id: string, score: number, responded_at: string, survey_id: string, survey_name?: string | null }> } | null };

export type GetOrganisationBillingSummaryQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
}>;


export type GetOrganisationBillingSummaryQuery = { organisation_billing_summary?: { customer_count: number, currency: string, subscription_status?: string | null, billing_interval?: string | null, mrr_amount_cents: number, mrr_list_amount_cents: number, arr_amount_cents: number, next_invoice_date?: string | null, next_invoice_amount_cents?: number | null, renewal_date?: string | null, discount_label?: string | null, lifetime_value_amount_cents: number, invoices_paid_count: number, invoices_outstanding_count: number, invoices_outstanding_amount_cents: number, history_url?: string | null, customer_since?: string | null } | null };

export type UpdateOrganisationMonitoringFieldsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  organisation: Organisations_Set_Input;
}>;


export type UpdateOrganisationMonitoringFieldsMutation = { update_organisations_by_pk?: { id: string, stripe_customer_ids: Array<string>, close_lead_id?: string | null, linked_tenant_id?: string | null, sales_rep_user_id?: string | null, csm_rep_user_id?: string | null, linked_tenant?: { id: string, name: string } | null, sales_rep?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, csm_rep?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null } | null };

export type SearchStripeCustomersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SearchStripeCustomersQuery = { search_stripe_customers?: { data: Array<{ id: string, name?: string | null, email?: string | null, url: string }> } | null };

export type SearchCloseLeadsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type SearchCloseLeadsQuery = { search_close_leads?: { data: Array<{ id: string, name?: string | null, email?: string | null, status?: string | null, url: string }> } | null };

export type GetCloseLeadQueryVariables = Exact<{
  leadId: Scalars['String']['input'];
}>;


export type GetCloseLeadQuery = { get_close_lead?: { id: string, name?: string | null, email?: string | null, sales_rep_user_id?: string | null, csm_rep_user_id?: string | null } | null };

export type DeleteOrganisationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteOrganisationMutation = { delete_organisations_by_pk?: { id: string } | null };

export type GetOrganisationOverviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationOverviewQuery = { organisations_by_pk?: { id: string, name?: string | null, teams: Array<{ id: string, created_at: any, name: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, logo?: { id: string, url?: string | null } | null, teams_users_aggregate: { aggregate?: { count: number } | null }, teams_users: Array<{ user: { id: string, broker_leads_aggregate: { aggregate?: { count: number } | null }, lots_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { sum?: { purchase_price?: number | null } | null } | null } } }> }> } | null };

export type AddTeamToOrganisationMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  organisation_id: Scalars['uuid']['input'];
}>;


export type AddTeamToOrganisationMutation = { update_teams_by_pk?: { id: string, organisation_id?: string | null } | null };

export type RemoveTeamFromOrganisationMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
}>;


export type RemoveTeamFromOrganisationMutation = { update_teams_by_pk?: { id: string, organisation_id?: string | null } | null };

export type GetOrganisationDetailsImagesQueryVariables = Exact<{
  organisationId: Scalars['uuid']['input'];
}>;


export type GetOrganisationDetailsImagesQuery = { organisation_images: Array<{ id: string, order_nr?: number | null, is_primary?: boolean | null, image: { id: string, url?: string | null } }> };

export type DeleteOrganisationImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  imageId: Scalars['uuid']['input'];
}>;


export type DeleteOrganisationImageMutation = { delete_organisation_images?: { returning: Array<{ id: string }> } | null, delete_images_by_pk?: { id: string } | null };

export type InsertOrganisationImagesBatchMutationVariables = Exact<{
  objects: Array<Organisation_Images_Insert_Input> | Organisation_Images_Insert_Input;
}>;


export type InsertOrganisationImagesBatchMutation = { insert_organisation_images?: { returning: Array<{ id: string, order_nr?: number | null, is_primary?: boolean | null, organisation_id: string, image: { id: string, url?: string | null } }> } | null };

export type SetOrganisationImagePrimaryMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  organisationId: Scalars['uuid']['input'];
}>;


export type SetOrganisationImagePrimaryMutation = { reset_other_images?: { returning: Array<{ id: string, is_primary?: boolean | null, organisation_id: string }> } | null, update_organisation_images?: { returning: Array<{ id: string, is_primary?: boolean | null, organisation_id: string }> } | null };

export type GetOrganisationSettingsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationSettingsQuery = { organisations_by_pk?: { id: string, name?: string | null, branding_color?: string | null, website?: string | null, is_lender: boolean, lat?: number | null, lng?: number | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, phone_numbers: Array<{ id: string, number: string, verified?: boolean | null, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null }>, emails: Array<{ id: string, email: string, verified: boolean, primary: boolean }> } | null };

export type GetOrganisationAccountFieldsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationAccountFieldsQuery = { organisations_by_pk?: { id: string, name?: string | null, stripe_customer_ids: Array<string>, close_lead_id?: string | null, linked_tenant_id?: string | null, sales_rep_user_id?: string | null, csm_rep_user_id?: string | null, emails: Array<{ email: string }>, teams: Array<{ teams_users: Array<{ user: { id: string, full_name?: string | null, emails: Array<{ email: string }> } }> }> } | null };

export type UpdateOrganisationSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  organisation: Organisations_Set_Input;
  phoneNumbers: Array<Phone_Numbers_Insert_Input> | Phone_Numbers_Insert_Input;
  emails: Array<Emails_Insert_Input> | Emails_Insert_Input;
  updatePhoneNumbers: Scalars['Boolean']['input'];
  updateEmails: Scalars['Boolean']['input'];
}>;


export type UpdateOrganisationSettingsMutation = { delete_phone_numbers?: { returning: Array<{ id: string }> } | null, insert_phone_numbers?: { returning: Array<{ id: string }> } | null, delete_emails?: { returning: Array<{ id: string }> } | null, insert_emails?: { returning: Array<{ id: string }> } | null, update_organisations_by_pk?: { id: string, name?: string | null, branding_color?: string | null, website?: string | null, is_lender: boolean, lat?: number | null, lng?: number | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, phone_numbers: Array<{ id: string, number: string, verified?: boolean | null, primary?: boolean | null, type?: Phone_Number_Type_Enum_Enum | null }>, emails: Array<{ id: string, email: string, verified: boolean, primary: boolean }> } | null };

export type CreateOrganisationMutationVariables = Exact<{
  organisation: Organisations_Insert_Input;
}>;


export type CreateOrganisationMutation = { insert_organisations_one?: { id: string, created_at: any, updated_at: any, name?: string | null, lat?: number | null, lng?: number | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null };

export type ActivityPropertyFragment = { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null };

export type ActivityLotFragment = { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } };

export type ActivityFeedItemFragment = { id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, done: boolean, success: boolean, done_at?: any | null, due_at?: any | null, start_date?: string | null, subject?: string | null, note?: string | null, created_by?: string | null, assigned_to?: string | null, is_overdue?: boolean | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lead?: { id: string, first_name?: string | null, last_name?: string | null, created_by?: string | null, property_id?: string | null, source: { name: string }, property?: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null } | null, lot?: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } } | null, enquiry?: { id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, lot?: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } } | null } | null, buyer_lead?: { id: string, is_mls: boolean, lot: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } }, mls_lot?: { id?: string | null, title?: string | null, effective_address?: any | null } | null } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, offer?: { id: string, buyer: { id: string, first_name?: string | null, last_name?: string | null } } | null, email_message?: { id: string, subject?: string | null } | null, activities_target_users: Array<{ target_user_id?: string | null, name?: string | null, email?: string | null, is_owner: boolean, type?: string | null, status?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null } | null }> };

export type GetActivityFeedPageQueryVariables = Exact<{
  where: Activity_Feed_Bool_Exp;
  order_by: Array<Activity_Feed_Order_By> | Activity_Feed_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetActivityFeedPageQuery = { feed: Array<{ activity_id: string, activity?: { id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, done: boolean, success: boolean, done_at?: any | null, due_at?: any | null, start_date?: string | null, subject?: string | null, note?: string | null, created_by?: string | null, assigned_to?: string | null, is_overdue?: boolean | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lead?: { id: string, first_name?: string | null, last_name?: string | null, created_by?: string | null, property_id?: string | null, source: { name: string }, property?: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null } | null, lot?: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } } | null, enquiry?: { id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, lot?: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } } | null } | null, buyer_lead?: { id: string, is_mls: boolean, lot: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } }, mls_lot?: { id?: string | null, title?: string | null, effective_address?: any | null } | null } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, offer?: { id: string, buyer: { id: string, first_name?: string | null, last_name?: string | null } } | null, email_message?: { id: string, subject?: string | null } | null, activities_target_users: Array<{ target_user_id?: string | null, name?: string | null, email?: string | null, is_owner: boolean, type?: string | null, status?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null } | null }> } | null }>, status: Array<{ ready: boolean }>, blocked: Array<{ principal_id: string }> };

export type GetActivityFeedCountQueryVariables = Exact<{
  where: Activity_Feed_Bool_Exp;
  count_limit: Scalars['Int']['input'];
}>;


export type GetActivityFeedCountQuery = { feed_aggregate: { aggregate?: { count: number } | null } };

export type GetActivitiesPageQueryVariables = Exact<{
  where: Activities_Bool_Exp;
  order_by: Array<Activities_Order_By> | Activities_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetActivitiesPageQuery = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, done: boolean, success: boolean, done_at?: any | null, due_at?: any | null, start_date?: string | null, subject?: string | null, note?: string | null, created_by?: string | null, assigned_to?: string | null, is_overdue?: boolean | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, lead?: { id: string, first_name?: string | null, last_name?: string | null, created_by?: string | null, property_id?: string | null, source: { name: string }, property?: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null } | null, lot?: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } } | null, enquiry?: { id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, lot?: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } } | null } | null, buyer_lead?: { id: string, is_mls: boolean, lot: { id: string, title?: string | null, property_id: string, created_by_user?: { first_name?: string | null, last_name?: string | null } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country_code?: string | null } }, mls_lot?: { id?: string | null, title?: string | null, effective_address?: any | null } | null } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, offer?: { id: string, buyer: { id: string, first_name?: string | null, last_name?: string | null } } | null, email_message?: { id: string, subject?: string | null } | null, activities_target_users: Array<{ target_user_id?: string | null, name?: string | null, email?: string | null, is_owner: boolean, type?: string | null, status?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null } | null }> }> };

export type GetActivitiesCountQueryVariables = Exact<{
  where: Activities_Bool_Exp;
  count_limit: Scalars['Int']['input'];
}>;


export type GetActivitiesCountQuery = { activities_aggregate: { aggregate?: { count: number } | null } };

export type GetUserNameQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserNameQuery = { users_by_pk?: { full_name?: string | null } | null };

export type GetOrganisationNameQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrganisationNameQuery = { organisations_by_pk?: { name?: string | null } | null };

export type GetTeamNameQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTeamNameQuery = { teams_by_pk?: { name: string } | null };

export type GetSellerLeadsStatisticsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['date']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  groupingMode?: InputMaybe<GetLeadsStatisticsGroupingMode>;
  leadOrigins?: InputMaybe<Array<GetLeadsStatisticsLeadOrigin> | GetLeadsStatisticsLeadOrigin>;
  organisationId?: InputMaybe<Scalars['uuid']['input']>;
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetSellerLeadsStatisticsQuery = { get_leads_statistics?: { data: Array<{ date_group: string, assigned_leads: number, claimed_leads: number, call_attempts: number, call_successful: number, call_missed: number, visit_booked: number, visit_completed: number, sale_mandate: number, rental_mandate: number }> } | null };

export type PortalTeamsQueryVariables = Exact<{
  portalId: Scalars['uuid']['input'];
}>;


export type PortalTeamsQuery = { portals_by_pk?: { id: string, name?: string | null, teams_portals: Array<{ id: string, contract_id?: string | null, team: { id: string, name: string } }> } | null, portal_listings: Array<{ lot: { broker?: { teams_users: Array<{ team_id: string }> } | null } }> };

export type AddPortalTeamMutationVariables = Exact<{
  portalId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
}>;


export type AddPortalTeamMutation = { insert_teams_portals_one?: { id: string, portal_id: string, team_id: string } | null };

export type UpdatePortalTeamMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  contract_id?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdatePortalTeamMutation = { update_teams_portals_by_pk?: { id: string, contract_id?: string | null } | null };

export type PortalConnectionStatusFragment = { id: string, type: Portals_Types_Enum_Enum };

export type PortalFragmentFragment = { __typename: 'portals', id: string, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null };

export type GetPortalsQueryVariables = Exact<{
  where: Portals_Bool_Exp;
  order_by: Array<Portals_Order_By> | Portals_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetPortalsQuery = { portals: Array<{ __typename: 'portals', id: string, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null }> };

export type GetPortalsCountQueryVariables = Exact<{
  where: Portals_Bool_Exp;
}>;


export type GetPortalsCountQuery = { portals_aggregate: { aggregate?: { count: number } | null } };

export type GetPortalQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPortalQuery = { portals_by_pk?: { __typename: 'portals', id: string, username?: string | null, password?: string | null, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null } | null };

export type CheckPortalConnectionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CheckPortalConnectionQuery = { check_portal_connection?: { success: boolean, error?: string | null } | null };

export type ImportPortalListingsMutationVariables = Exact<{
  portal_id: Scalars['uuid']['input'];
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  dry_run: Scalars['Boolean']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ImportPortalListingsMutation = { import_portal_listings?: { page: number, total_pages: number, total_properties: number, inserted: number, updated: number, errors: number, items: Array<{ external_property_id: string, reference?: string | null, label?: string | null, outcome: string, lot_id?: string | null, errors?: Array<string> | null, warnings?: Array<string> | null }> } | null };

export type GetPortalLiveListingsQueryVariables = Exact<{
  portal_id: Scalars['uuid']['input'];
}>;


export type GetPortalLiveListingsQuery = { portal_listings: Array<{ id: string, lot_id: string, external_property_id?: string | null, lot: { id: string, dummy_usable_surface: string, property: { id: string, built_surface?: number | null, usable_surface?: number | null, living_surface?: number | null, gross_floor_surface?: number | null, weighted_floor_surface?: number | null } } }> };

export type GetPortalTeamsQueryVariables = Exact<{
  portal_id: Scalars['uuid']['input'];
}>;


export type GetPortalTeamsQuery = { portals_by_pk?: { id: string, team_id?: string | null, teams_portals: Array<{ team_id: string }> } | null };

export type GetPortalTeamBrokersQueryVariables = Exact<{
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetPortalTeamBrokersQuery = { teams_users: Array<{ user: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, primaryEmail: Array<{ email: string }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> };

export type ReadPortalIdxQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ReadPortalIdxQuery = { read_portal_idx?: { rows: any, columns: Array<string>, count: number, truncated: boolean } | null };

export type GetPortalMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPortalMetadataQuery = { shared_portals: Array<{ id: string, name?: string | null }>, portals_types_enum: Array<{ value: string }> };

export type UpdatePortalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  portal: Portals_Set_Input;
}>;


export type UpdatePortalMutation = { update_portals_by_pk?: { __typename: 'portals', id: string, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null } | null };

export type UpsertPortalMutationVariables = Exact<{
  portal: Portals_Insert_Input;
}>;


export type UpsertPortalMutation = { insert_portals_one?: { __typename: 'portals', id: string, username?: string | null, password?: string | null, created_at: any, updated_at: any, created_by?: string | null, active: boolean, contract_id?: string | null, email?: string | null, exact_address_required: boolean, exclude_from_published_stats: boolean, has_top_premium_listing?: boolean | null, idx_protocol: any, master_portal_id?: string | null, name?: string | null, port?: number | null, quota?: number | null, type: Portals_Types_Enum_Enum, url?: string | null, website_url?: string | null, team_id?: string | null, portal_listings_aggregate: { aggregate?: { count: number } | null }, logo?: { id: string, url?: string | null } | null } | null };

export type DeletePortalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePortalMutation = { delete_portals_by_pk?: { id: string } | null };

export type GetCampaignRecentCmaReportQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
}>;


export type GetCampaignRecentCmaReportQuery = { cma_reports: Array<{ id: string }> };

export type GetMyProductExperiencesQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetMyProductExperiencesQuery = { users_by_pk?: { id: string, product_experiences: Array<{ kind: string, key: string, first_seen_at: any, outcome?: string | null, outcome_at?: any | null, last_step?: any | null, step_count?: any | null, dismiss_reason?: string | null, dismiss_count: any, holdout?: boolean | null }> } | null };

export type RecordProductExperiencesMutationVariables = Exact<{
  objects: Array<User_Product_Experiences_Insert_Input> | User_Product_Experiences_Insert_Input;
  updateColumns: Array<User_Product_Experiences_Update_Column> | User_Product_Experiences_Update_Column;
  where?: InputMaybe<User_Product_Experiences_Bool_Exp>;
}>;


export type RecordProductExperiencesMutation = { insert_user_product_experiences?: { affected_rows: number } | null };

export type ResetMyProductExperiencesMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type ResetMyProductExperiencesMutation = { delete_user_product_experiences?: { affected_rows: number } | null };

export type PropertySearchFormFragment = { offer_type?: string | null, notification: any, property_status?: string | null, comment?: string | null, property_usage?: string | null, activate_aggregator: boolean, sale_price_lte?: number | null, sale_price_gte?: number | null, sale_price_per_land_surface_gte?: number | null, sale_price_per_land_surface_lte?: number | null, sale_price_per_living_surface_gte?: number | null, sale_price_per_living_surface_lte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, gross_rent_room_monthly_gte?: number | null, gross_rent_room_monthly_lte?: number | null, gross_rent_m2_yearly_gte?: number | null, gross_rent_m2_yearly_lte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bathrooms_lte?: number | null, number_of_bathrooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, built_surface_lte?: number | null, built_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, has_balcony?: boolean | null, has_garden?: boolean | null, has_lift?: boolean | null, has_parking?: boolean | null, has_swimming_pool: boolean, has_view?: boolean | null, is_child_friendly?: boolean | null, is_fsbo?: boolean | null, is_furnished?: boolean | null, is_minergie_certified?: boolean | null, is_new_development?: boolean | null, is_wheelchair_accessible?: boolean | null, property_types: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type?: string | null, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }>, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }>, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null };

export type GetPropertySearchesListQueryVariables = Exact<{
  where: Property_Searches_Bool_Exp;
  order_by?: InputMaybe<Array<Property_Searches_Order_By> | Property_Searches_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetPropertySearchesListQuery = { property_searches: Array<{ id: string, created_at: any, offer_type?: string | null, property_usage?: string | null, notification: any, source?: Property_Search_Source_Enum | null, aggregator_source?: Property_Search_Aggregator_Source_Enum | null, property_main_type_in?: Array<string> | null, property_main_type_nin?: Array<string> | null, composite_property_type_eq?: string | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, number_of_bathrooms_lte?: number | null, number_of_bathrooms_gte?: number | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }>, property_types: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type_object?: { id: string, label?: string | null } | null } }> }> };

export type GetPropertySearchesCountQueryVariables = Exact<{
  where: Property_Searches_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPropertySearchesCountQuery = { property_searches_aggregate: { aggregate?: { count: number } | null } };

export type GetPropertySearchDrawerQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPropertySearchDrawerQuery = { property_searches_by_pk?: { id: string, created_at: any, created_by?: string | null, source?: Property_Search_Source_Enum | null, aggregator_source?: Property_Search_Aggregator_Source_Enum | null, offer_type?: string | null, notification: any, property_status?: string | null, comment?: string | null, property_usage?: string | null, activate_aggregator: boolean, sale_price_lte?: number | null, sale_price_gte?: number | null, sale_price_per_land_surface_gte?: number | null, sale_price_per_land_surface_lte?: number | null, sale_price_per_living_surface_gte?: number | null, sale_price_per_living_surface_lte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, gross_rent_room_monthly_gte?: number | null, gross_rent_room_monthly_lte?: number | null, gross_rent_m2_yearly_gte?: number | null, gross_rent_m2_yearly_lte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bathrooms_lte?: number | null, number_of_bathrooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, built_surface_lte?: number | null, built_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, has_balcony?: boolean | null, has_garden?: boolean | null, has_lift?: boolean | null, has_parking?: boolean | null, has_swimming_pool: boolean, has_view?: boolean | null, is_child_friendly?: boolean | null, is_fsbo?: boolean | null, is_furnished?: boolean | null, is_minergie_certified?: boolean | null, is_new_development?: boolean | null, is_wheelchair_accessible?: boolean | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, teams_users: Array<{ team_id: string }>, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_types: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type?: string | null, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }>, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }> } | null, dictionaries: Array<{ id: string, name: string, label?: string | null }> };

export type InsertPropertySearchMutationVariables = Exact<{
  object: Property_Searches_Insert_Input;
}>;


export type InsertPropertySearchMutation = { insert_property_searches_one?: { id: string, created_at: any, source?: Property_Search_Source_Enum | null, aggregator_source?: Property_Search_Aggregator_Source_Enum | null, offer_type?: string | null, notification: any, property_status?: string | null, comment?: string | null, property_usage?: string | null, activate_aggregator: boolean, sale_price_lte?: number | null, sale_price_gte?: number | null, sale_price_per_land_surface_gte?: number | null, sale_price_per_land_surface_lte?: number | null, sale_price_per_living_surface_gte?: number | null, sale_price_per_living_surface_lte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, gross_rent_room_monthly_gte?: number | null, gross_rent_room_monthly_lte?: number | null, gross_rent_m2_yearly_gte?: number | null, gross_rent_m2_yearly_lte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bathrooms_lte?: number | null, number_of_bathrooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, built_surface_lte?: number | null, built_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, has_balcony?: boolean | null, has_garden?: boolean | null, has_lift?: boolean | null, has_parking?: boolean | null, has_swimming_pool: boolean, has_view?: boolean | null, is_child_friendly?: boolean | null, is_fsbo?: boolean | null, is_furnished?: boolean | null, is_minergie_certified?: boolean | null, is_new_development?: boolean | null, is_wheelchair_accessible?: boolean | null, property_types: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type?: string | null, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }>, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }>, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null } | null };

export type ImportPropertySearchesMutationVariables = Exact<{
  objects: Array<PropertySearchImportInput> | PropertySearchImportInput;
}>;


export type ImportPropertySearchesMutation = { import_property_searches?: Array<{ property_search_id?: string | null, property_search?: { id: string, user?: { id: string } | null, property_searches_places: Array<{ place: { id: string } }> } | null }> | null };

export type UpdatePropertySearchesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  propertySearch: Property_Searches_Set_Input;
  propertyPlaces: Array<Property_Searches_Places_Insert_Input> | Property_Searches_Places_Insert_Input;
  propertyTypes: Array<Property_Searches_Property_Types_Insert_Input> | Property_Searches_Property_Types_Insert_Input;
}>;


export type UpdatePropertySearchesMutation = { update_property_searches_by_pk?: { id: string, offer_type?: string | null, notification: any, property_status?: string | null, comment?: string | null, property_usage?: string | null, activate_aggregator: boolean, sale_price_lte?: number | null, sale_price_gte?: number | null, sale_price_per_land_surface_gte?: number | null, sale_price_per_land_surface_lte?: number | null, sale_price_per_living_surface_gte?: number | null, sale_price_per_living_surface_lte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, gross_rent_room_monthly_gte?: number | null, gross_rent_room_monthly_lte?: number | null, gross_rent_m2_yearly_gte?: number | null, gross_rent_m2_yearly_lte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bathrooms_lte?: number | null, number_of_bathrooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, built_surface_lte?: number | null, built_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, has_balcony?: boolean | null, has_garden?: boolean | null, has_lift?: boolean | null, has_parking?: boolean | null, has_swimming_pool: boolean, has_view?: boolean | null, is_child_friendly?: boolean | null, is_fsbo?: boolean | null, is_furnished?: boolean | null, is_minergie_certified?: boolean | null, is_new_development?: boolean | null, is_wheelchair_accessible?: boolean | null, property_types: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type?: string | null, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }>, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }>, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null } | null, delete_property_searches_places?: { affected_rows: number } | null, insert_property_searches_places?: { returning: Array<{ property_search_id: string, place: { id: string, name: string, label?: string | null } }> } | null, delete_property_searches_property_types?: { affected_rows: number } | null, insert_property_searches_property_types?: { returning: Array<{ property_type: { id: string, label?: string | null, type: string, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }> } | null };

export type DeletePropertySearchesMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeletePropertySearchesMutation = { delete_property_searches?: { affected_rows: number } | null };

export type ExportPropertySearchesQueryVariables = Exact<{
  where: Property_Searches_Bool_Exp;
}>;


export type ExportPropertySearchesQuery = { property_searches: Array<{ id: string, created_at: any, offer_type?: string | null, property_usage?: string | null, notification: any, source?: Property_Search_Source_Enum | null, property_main_type_in?: Array<string> | null, property_main_type_nin?: Array<string> | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, living_surface_lte?: number | null, living_surface_gte?: number | null, land_surface_lte?: number | null, land_surface_gte?: number | null, number_of_rooms_lte?: number | null, number_of_rooms_gte?: number | null, number_of_bedrooms_lte?: number | null, number_of_bedrooms_gte?: number | null, user?: { id: string, full_name?: string | null, emails: Array<{ email: string }>, phone_numbers: Array<{ number: string }> } | null, property_searches_places: Array<{ place: { name: string, slug_en?: string | null } }> }> };

export type GetPropertySearchesDictionaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPropertySearchesDictionaryQuery = { sources: Array<{ id: string, name: string, label?: string | null }>, aggregator_sources: Array<{ id: string, name: string, label?: string | null }> };

export type ProspectionMapV2CatchmentAreasQueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type ProspectionMapV2CatchmentAreasQuery = { users_by_pk?: { id: string, catchment_areas: Array<{ place: { id: string, lat: number, lng: number } }>, default_team?: { id: string, teams_users: Array<{ user: { id: string, catchment_areas: Array<{ place: { id: string, postcode?: string | null, country_code: string, lat: number, lng: number } }> } }> } | null } | null };

export type ProspectionMapV2FallbackCatchmentQueryVariables = Exact<{
  x: Scalars['float8']['input'];
  y: Scalars['float8']['input'];
  target_population: Scalars['Int']['input'];
}>;


export type ProspectionMapV2FallbackCatchmentQuery = { get_catchment_area: Array<{ id: string, postcode?: string | null, country_code: string }> };

export type ProspectionParcelAtPointQueryVariables = Exact<{
  country: Scalars['String']['input'];
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
}>;


export type ProspectionParcelAtPointQuery = { parcel_at_point?: { found: boolean, parcel_id?: string | null, geometry?: any | null, area_m2?: number | null, attributes?: any | null, source: string } | null };

export type ProspectionFrParcelAtPointQueryVariables = Exact<{
  point: Scalars['geometry']['input'];
}>;


export type ProspectionFrParcelAtPointQuery = { fr_plots: Array<{ id: string, local_plot_id?: string | null, area_m2?: any | null, extra: any, geom: any }> };

export type ProspectionEsParcelAtPointQueryVariables = Exact<{
  point: Scalars['geometry']['input'];
}>;


export type ProspectionEsParcelAtPointQuery = { es_plots: Array<{ id: string, local_plot_id?: string | null, area_m2?: any | null, extra: any, geom: any }> };

export type ProspectionContactQuotaQueryVariables = Exact<{ [key: string]: never; }>;


export type ProspectionContactQuotaQuery = { prospection_contact_quota?: { enabled: boolean, used: number, limit: number, remaining: number, resets_at?: any | null } | null };

export type ProspectionContactTeamQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type ProspectionContactTeamQuery = { users_by_pk?: { default_team_id?: string | null, tenant_id: string, teams_users: Array<{ team_id: string, deactivated: boolean, team: { tenant_id: string } }> } | null };

export type ProspectionMyContactAttemptsQueryVariables = Exact<{
  where: Prospection_Map_Contact_Attempts_Bool_Exp;
  offset: Scalars['Int']['input'];
}>;


export type ProspectionMyContactAttemptsQuery = { prospection_map_contact_attempts: Array<{ id: string, lead_id: string, user_id: string, created_at: any, accepted_at?: any | null, declined_at?: any | null, user: { first_name?: string | null, last_name?: string | null } }> };

export type ProspectionFullLeadsQueryVariables = Exact<{
  leadIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ProspectionFullLeadsQuery = { prospection_map_full_leads: Array<{ lead_id?: string | null }> };

export type ProspectionEmailableLeadsQueryVariables = Exact<{
  leadIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ProspectionEmailableLeadsQuery = { prospection_map_emailable_leads: Array<{ lead_id?: string | null }> };

export type ContactProspectionLeadMutationVariables = Exact<{
  leadId: Scalars['uuid']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['user_language']['input']>;
}>;


export type ContactProspectionLeadMutation = { contact_prospection_lead?: { lead_id: string, used: number, limit: number, remaining: number, resets_at?: any | null } | null };

export type ProspectionLeadContactLanguageQueryVariables = Exact<{
  leadId: Scalars['uuid']['input'];
}>;


export type ProspectionLeadContactLanguageQuery = { leads_by_pk?: { id: string, contact?: { id: string, language?: any | null } | null } | null };

export type ProspectionContactMessageTemplateQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  language: Scalars['user_language']['input'];
}>;


export type ProspectionContactMessageTemplateQuery = { prospection_contact_message_templates: Array<{ id: string, language: any, message: string }> };

export type UpsertProspectionContactMessageTemplateMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  language: Scalars['user_language']['input'];
  message: Scalars['String']['input'];
}>;


export type UpsertProspectionContactMessageTemplateMutation = { insert_prospection_contact_message_templates_one?: { id: string, language: any, message: string } | null };

export type ProspectionDpeAtParcelQueryVariables = Exact<{
  poly: Scalars['geometry']['input'];
}>;


export type ProspectionDpeAtParcelQuery = { fr_energy_certificates: Array<{ id: string, external_id: string, energy_rating?: string | null, emissions_rating?: string | null, date_of_diagnostic?: string | null, date_of_expiry?: string | null, geom?: any | null, adresse_ban: any, type_batiment: any, surface_m2: any, building_period: any }> };

export type ProspectionLeadAddressesInBboxQueryVariables = Exact<{
  west?: InputMaybe<Scalars['float8']['input']>;
  south?: InputMaybe<Scalars['float8']['input']>;
  east?: InputMaybe<Scalars['float8']['input']>;
  north?: InputMaybe<Scalars['float8']['input']>;
  houseIds?: InputMaybe<Scalars['_uuid']['input']>;
}>;


export type ProspectionLeadAddressesInBboxQuery = { prospection_map_lead_addresses_in_bbox: Array<{ id?: string | null, main_type?: string | null, route?: string | null, street_number?: string | null, lat?: number | null, lng?: number | null, date?: string | null, reason?: string | null, surface?: number | null, rooms?: number | null, value?: number | null, locality?: string | null, postcode?: string | null, locality_id?: string | null, country_code?: string | null }> };

export type ProspectionMyLeadsQueryVariables = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  statuses: Array<Leads_Status_Enum> | Leads_Status_Enum;
  minLat: Scalars['Float']['input'];
  maxLat: Scalars['Float']['input'];
  minLng: Scalars['Float']['input'];
  maxLng: Scalars['Float']['input'];
}>;


export type ProspectionMyLeadsQuery = { leads: Array<{ id: string, requalified_or_created_at?: any | null, first_name?: string | null, last_name?: string | null, anonymized_contact?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, first_name?: string | null, last_name?: string | null } | null, assignments: Array<{ user_id: string, claimed_at?: any | null }>, lead_agents: Array<{ id: string, user_id: string, user: { id: string, first_name?: string | null, last_name?: string | null }, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum } | null }>, property?: { id: string, lat?: number | null, lng?: number | null, route?: string | null, street_number?: string | null, locality?: string | null, postcode?: string | null, living_surface?: number | null, number_of_rooms?: number | null, property_type?: { id: string, main_type?: string | null } | null } | null }> };

export type ProspectionParcelRegistryQueryVariables = Exact<{
  parcelId: Scalars['uuid']['input'];
  buildingIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ProspectionParcelRegistryQuery = { plots: Array<{ id: string, area_m2?: any | null, geom: any, extra: any }>, buildings: Array<{ id: string, footprint_area_m2?: number | null, volume?: number | null, year_built?: number | null, number_of_floors?: number | null, display_information?: any | null, extra?: any | null }> };

export type ProspectionParcelPlotAttrsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ProspectionParcelPlotAttrsQuery = { ch_plots: Array<{ id: string, area_m2?: any | null }> };

export type ProspectionParcelBuildingAttrsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ProspectionParcelBuildingAttrsQuery = { ch_buildings: Array<{ id: string, footprint_area_m2?: number | null, year_built?: number | null, display_information?: any | null }> };

export type ProspectionMarksQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type ProspectionMarksQuery = { prospection_marks: Array<{ id: string, user_id: string, lat: number, lng: number, parcel_id?: string | null, parcel_source?: string | null, address?: string | null, locality?: string | null, note?: string | null, created_at: any, updated_at: any, user: { id: string, first_name?: string | null, last_name?: string | null } }> };

export type InsertProspectionMarkMutationVariables = Exact<{
  lat: Scalars['float8']['input'];
  lng: Scalars['float8']['input'];
  parcelId?: InputMaybe<Scalars['String']['input']>;
  parcelSource?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsertProspectionMarkMutation = { insert_prospection_marks_one?: { id: string } | null };

export type UpdateProspectionMarkNoteMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProspectionMarkNoteMutation = { update_prospection_marks_by_pk?: { id: string, note?: string | null } | null };

export type DeleteProspectionMarkMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteProspectionMarkMutation = { delete_prospection_marks_by_pk?: { id: string } | null };

export type ProspectionSaleTypeLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProspectionSaleTypeLabelsQuery = { property_types: Array<{ name?: string | null, main_type?: string | null, label_en?: string | null }> };

export type BrochureReportIncludeFragment = { brochure_include_cover: boolean, brochure_include_property: boolean, brochure_include_description: boolean, brochure_include_photos: boolean, brochure_include_pois: boolean, brochure_include_poi_map: boolean, brochure_poi_map_zoom_level: number, brochure_include_append_files: boolean };

export type GetBrochureReportQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetBrochureReportQuery = { lots_by_pk?: { __typename: 'lots', id: string, updated_at: any, broker_id?: string | null, show_image_captions_on_brochure?: boolean | null, doc_template_theme_id?: string | null, title?: string | null, use_custom_brochure_title: boolean, brochure_title_en?: string | null, brochure_title_fr?: string | null, brochure_title_de?: string | null, brochure_title_it?: string | null, brochure_title_pl?: string | null, brochure_title_pt?: string | null, brochure_title_es?: string | null, hide_price_on_brochure: boolean, address_display_option_brochure: Address_Display_Options_Enum_Enum, brochure_show_agent_on_brochure: boolean, brochure_font_family?: string | null, brochure_cover_image_id?: string | null, brochure_description_en?: string | null, brochure_description_fr?: string | null, brochure_description_de?: string | null, brochure_description_it?: string | null, brochure_description_pl?: string | null, brochure_description_pt?: string | null, brochure_description_es?: string | null, use_custom_brochure_description: boolean, brochure_description_layout: any, description?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, offer_type?: string | null, status: Lots_Status_Enum_Enum, currency?: string | null, available_from?: string | null, lot_reference?: string | null, price_unit?: string | null, is_parking_included_in_total: boolean, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, brochure_include_cover: boolean, brochure_include_property: boolean, brochure_include_description: boolean, brochure_include_photos: boolean, brochure_include_pois: boolean, brochure_include_poi_map: boolean, brochure_poi_map_zoom_level: number, brochure_include_append_files: boolean, broker?: { id: string, language?: any | null, active_teams_users: Array<{ team_id: string, team: { id: string, lots_member_access: Lots_Member_Access_Enum_Enum } }>, default_team?: { id: string, branding_color?: string | null } | null } | null, doc_template?: { id: string, content: string, filename_template: string, translations?: any | null } | null, doc_template_theme?: { id: string, name: string, content: string } | null, property: { id: string, updated_at: any, balcony_surface?: number | null, basement_surface?: number | null, building_condition?: number | null, building_standard?: number | null, building_volume?: number | null, built_surface?: number | null, charges?: number | null, commercial_potential_rental_income?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, construction_year?: number | null, consumption?: number | null, cooling?: Cooling_Enum_Enum | null, distance_to_airport?: number | null, distance_to_city_center?: number | null, distance_to_grocery_shop?: number | null, distance_to_high_school?: number | null, distance_to_hospital?: number | null, distance_to_kindergarten?: number | null, distance_to_motorway?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, emissions?: number | null, energy_certificate_version?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, energy_inspection_date?: string | null, energy_reference_year?: number | null, estimated_higher_energy_cost?: number | null, estimated_lower_energy_cost?: number | null, floor_of_flat?: number | null, garden_surface?: number | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, gross_floor_surface?: number | null, has_attic?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_gym?: boolean | null, has_photovoltaic_panels?: boolean | null, has_sauna?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_view?: boolean | null, has_wellness_area?: boolean | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, income_includes_parking?: boolean | null, is_child_friendly?: boolean | null, is_commercial_fully_rented?: boolean | null, is_luxury?: boolean | null, is_maisonette?: boolean | null, is_new_development: boolean, is_parking_fully_rented?: boolean | null, is_rental?: boolean | null, is_residential_fully_rented?: boolean | null, is_secondary_residence?: boolean | null, is_wheelchair_accessible?: boolean | null, land_surface?: number | null, living_surface?: number | null, macro_location?: number | null, micro_location?: number | null, minergie_code?: number | null, number_of_bathrooms?: number | null, number_of_bedrooms?: number | null, number_of_commercial_units?: number | null, number_of_floors?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_residential_units?: number | null, number_of_rooms?: number | null, number_of_toilets?: number | null, orientation?: string | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, parking_potential_rental_income?: number | null, parking_yearly_rental_income?: number | null, plot_number?: string | null, renovation_fund?: number | null, renovation_year?: number | null, residential_potential_rental_income?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, side?: Property_Side_Enum_Enum | null, terrace_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, property_pois: Array<{ id: string, distance_meters: number, walking_distance_meters?: number | null, cycling_distance_meters?: number | null, walking_time_minutes?: number | null, cycling_time_minutes?: number | null, poi: { id: string, name: string, formatted_address: string, category: string, types: Array<string>, primary_type: string, lat: number, lng: number } }> }, brochure_cover_image?: { id: string } | null } | null };

export type StepCoverPhotoBrochureFragment = { id: string, title?: string | null, updated_at: any, use_custom_brochure_title: boolean, brochure_title_en?: string | null, brochure_title_fr?: string | null, brochure_title_de?: string | null, brochure_title_it?: string | null, brochure_title_pl?: string | null, brochure_title_pt?: string | null, brochure_title_es?: string | null, hide_price_on_brochure: boolean, address_display_option_brochure: Address_Display_Options_Enum_Enum, brochure_show_agent_on_brochure: boolean, brochure_font_family?: string | null, doc_template_theme_id?: string | null, brochure_cover_image_id?: string | null, doc_template?: { id: string } | null, doc_template_theme?: { id: string, name: string } | null, brochure_cover_image?: { id: string } | null, broker?: { id: string, language?: any | null, default_team?: { id: string, branding_color?: string | null } | null } | null, property: { id: string, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }> } };

export type UpdateBrochureCoverMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateBrochureCoverMutation = { update_lots_by_pk?: { id: string, title?: string | null, updated_at: any, use_custom_brochure_title: boolean, brochure_title_en?: string | null, brochure_title_fr?: string | null, brochure_title_de?: string | null, brochure_title_it?: string | null, brochure_title_pl?: string | null, brochure_title_pt?: string | null, brochure_title_es?: string | null, hide_price_on_brochure: boolean, address_display_option_brochure: Address_Display_Options_Enum_Enum, brochure_show_agent_on_brochure: boolean, brochure_font_family?: string | null, doc_template_theme_id?: string | null, brochure_cover_image_id?: string | null, doc_template?: { id: string } | null, doc_template_theme?: { id: string, name: string } | null, brochure_cover_image?: { id: string } | null, broker?: { id: string, language?: any | null, default_team?: { id: string, branding_color?: string | null } | null } | null, property: { id: string, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }> } } | null };

export type StepDescriptionBrochureFragment = { id: string, updated_at: any, brochure_description_en?: string | null, brochure_description_fr?: string | null, brochure_description_de?: string | null, brochure_description_it?: string | null, brochure_description_pl?: string | null, brochure_description_pt?: string | null, brochure_description_es?: string | null, use_custom_brochure_description: boolean, brochure_description_layout: any, description?: string | null, broker?: { id: string, language?: any | null } | null };

export type UpdateBrochureDescriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateBrochureDescriptionMutation = { update_lots_by_pk?: { id: string, updated_at: any, brochure_description_en?: string | null, brochure_description_fr?: string | null, brochure_description_de?: string | null, brochure_description_it?: string | null, brochure_description_pl?: string | null, brochure_description_pt?: string | null, brochure_description_es?: string | null, use_custom_brochure_description: boolean, brochure_description_layout: any, description?: string | null, broker?: { id: string, language?: any | null } | null } | null };

export type UpdatePropertyDetailsBrochureMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdatePropertyDetailsBrochureMutation = { update_lots_by_pk?: { id: string, updated_at: any, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, offer_type?: string | null, status: Lots_Status_Enum_Enum, currency?: string | null, available_from?: string | null, lot_reference?: string | null, price_unit?: string | null, is_parking_included_in_total: boolean, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, property: { id: string, updated_at: any, balcony_surface?: number | null, basement_surface?: number | null, building_condition?: number | null, building_standard?: number | null, building_volume?: number | null, built_surface?: number | null, charges?: number | null, commercial_potential_rental_income?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, construction_year?: number | null, consumption?: number | null, cooling?: Cooling_Enum_Enum | null, distance_to_airport?: number | null, distance_to_city_center?: number | null, distance_to_grocery_shop?: number | null, distance_to_high_school?: number | null, distance_to_hospital?: number | null, distance_to_kindergarten?: number | null, distance_to_motorway?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, emissions?: number | null, energy_certificate_version?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, energy_inspection_date?: string | null, energy_reference_year?: number | null, estimated_higher_energy_cost?: number | null, estimated_lower_energy_cost?: number | null, floor_of_flat?: number | null, garden_surface?: number | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, gross_floor_surface?: number | null, has_attic?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_gym?: boolean | null, has_photovoltaic_panels?: boolean | null, has_sauna?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_view?: boolean | null, has_wellness_area?: boolean | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, income_includes_parking?: boolean | null, is_child_friendly?: boolean | null, is_commercial_fully_rented?: boolean | null, is_luxury?: boolean | null, is_maisonette?: boolean | null, is_new_development: boolean, is_parking_fully_rented?: boolean | null, is_rental?: boolean | null, is_residential_fully_rented?: boolean | null, is_secondary_residence?: boolean | null, is_wheelchair_accessible?: boolean | null, land_surface?: number | null, living_surface?: number | null, macro_location?: number | null, micro_location?: number | null, minergie_code?: number | null, number_of_bathrooms?: number | null, number_of_bedrooms?: number | null, number_of_commercial_units?: number | null, number_of_floors?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_residential_units?: number | null, number_of_rooms?: number | null, number_of_toilets?: number | null, orientation?: string | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, parking_potential_rental_income?: number | null, parking_yearly_rental_income?: number | null, plot_number?: string | null, renovation_fund?: number | null, renovation_year?: number | null, residential_potential_rental_income?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, side?: Property_Side_Enum_Enum | null, terrace_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null } } | null };

export type UpdateStepPoiBrochureMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateStepPoiBrochureMutation = { update_lots_by_pk?: { id: string, updated_at: any } | null };

export type StepPropertyDetailsBrochureFragment = { id: string, updated_at: any, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, offer_type?: string | null, status: Lots_Status_Enum_Enum, currency?: string | null, available_from?: string | null, lot_reference?: string | null, price_unit?: string | null, is_parking_included_in_total: boolean, parking_price?: number | null, parking_price_type?: Parking_Price_Type_Enum_Enum | null, indoor_parking_price?: number | null, outdoor_parking_price?: number | null, property: { id: string, updated_at: any, balcony_surface?: number | null, basement_surface?: number | null, building_condition?: number | null, building_standard?: number | null, building_volume?: number | null, built_surface?: number | null, charges?: number | null, commercial_potential_rental_income?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, construction_year?: number | null, consumption?: number | null, cooling?: Cooling_Enum_Enum | null, distance_to_airport?: number | null, distance_to_city_center?: number | null, distance_to_grocery_shop?: number | null, distance_to_high_school?: number | null, distance_to_hospital?: number | null, distance_to_kindergarten?: number | null, distance_to_motorway?: number | null, distance_to_primary_school?: number | null, distance_to_public_transport?: number | null, distance_to_sports_center?: number | null, distance_to_train_station?: number | null, emissions?: number | null, energy_certificate_version?: string | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, energy_inspection_date?: string | null, energy_reference_year?: number | null, estimated_higher_energy_cost?: number | null, estimated_lower_energy_cost?: number | null, floor_of_flat?: number | null, garden_surface?: number | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, gross_floor_surface?: number | null, has_attic?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_gym?: boolean | null, has_photovoltaic_panels?: boolean | null, has_sauna?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, has_view?: boolean | null, has_wellness_area?: boolean | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, income_includes_parking?: boolean | null, is_child_friendly?: boolean | null, is_commercial_fully_rented?: boolean | null, is_luxury?: boolean | null, is_maisonette?: boolean | null, is_new_development: boolean, is_parking_fully_rented?: boolean | null, is_rental?: boolean | null, is_residential_fully_rented?: boolean | null, is_secondary_residence?: boolean | null, is_wheelchair_accessible?: boolean | null, land_surface?: number | null, living_surface?: number | null, macro_location?: number | null, micro_location?: number | null, minergie_code?: number | null, number_of_bathrooms?: number | null, number_of_bedrooms?: number | null, number_of_commercial_units?: number | null, number_of_floors?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_residential_units?: number | null, number_of_rooms?: number | null, number_of_toilets?: number | null, orientation?: string | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, parking_potential_rental_income?: number | null, parking_yearly_rental_income?: number | null, plot_number?: string | null, renovation_fund?: number | null, renovation_year?: number | null, residential_potential_rental_income?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, side?: Property_Side_Enum_Enum | null, terrace_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null } };

export type StepPhotosBrochureFragment = { id: string, updated_at: any, show_image_captions_on_brochure?: boolean | null, property: { id: string, updated_at: any, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }> } };

export type UpdateStepPhotosBrochureMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateStepPhotosBrochureMutation = { update_lots_by_pk?: { id: string, updated_at: any, show_image_captions_on_brochure?: boolean | null, property: { id: string, updated_at: any, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }> } } | null };

export type DocTemplatesBrochureReportQueryVariables = Exact<{ [key: string]: never; }>;


export type DocTemplatesBrochureReportQuery = { doc_templates: Array<{ id: string, name: string, active: boolean, type: Doc_Template_Type_Enum_Enum, translations?: any | null }> };

export type UpdateBrochureReportFileMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Lots_Set_Input;
}>;


export type UpdateBrochureReportFileMutation = { update_lots_by_pk?: { id: string, updated_at: any } | null };

export type UpdateTeamBrandingColorBrochureMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  brandingColor?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['uuid']['input'];
}>;


export type UpdateTeamBrandingColorBrochureMutation = { update_teams_by_pk?: { id: string, branding_color?: string | null } | null, update_lots_by_pk?: { id: string, updated_at: any } | null };

export type GetCmaReportsListQueryVariables = Exact<{
  where: Cma_Reports_Bool_Exp;
  order_by?: InputMaybe<Array<Cma_Reports_Order_By> | Cma_Reports_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetCmaReportsListQuery = { cma_reports: Array<{ id: string, language: any, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, updated_at: any, created_at: any, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, cover_image?: { url?: string | null } | null, doc_template?: { id: string, name: string } | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> } }> };

export type GenerateCmaDescriptionQueryVariables = Exact<{
  cma_id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type GenerateCmaDescriptionQuery = { generate_cma_description?: { description: string, prompt: string } | null };

export type GetMarketPlacesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetMarketPlacesByIdsQuery = { places: Array<{ id: string, label?: string | null, type: Place_Type_Enum_Enum }> };

export type ResetCmaMarketComparisonPlacesMutationVariables = Exact<{
  reportId: Scalars['uuid']['input'];
}>;


export type ResetCmaMarketComparisonPlacesMutation = { reset_cma_market_comparison_places: Array<{ id: string, market_comparison_places?: any | null }>, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type GetLeadsByAddressQueryVariables = Exact<{
  route: Scalars['String']['input'];
  streetNumber: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLeadsByAddressQuery = { find_cma_leads_by_address: Array<{ id: string, anonymized_contact?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, created_at: any, requalified_at?: any | null, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, appraisal_open_to_offer?: string | null, phone_number?: string | null, email_address?: string | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null, property?: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } | null, lots: Array<{ id: string }>, lead_agents: Array<{ id: string, claimed_at?: any | null, user_id: string, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> }> };

export type GetCmaReportsCountQueryVariables = Exact<{
  where?: InputMaybe<Cma_Reports_Bool_Exp>;
}>;


export type GetCmaReportsCountQuery = { cma_reports_aggregate: { aggregate?: { count: number } | null } };

export type StepMarketDataFragment = { id: string, include_market_data: boolean, market_comparison_places?: any | null, market_data_show_map: boolean, market_data_show_chart: boolean, market_data_map_zoom_level?: number | null, updated_at: any };

export type StepCoverPhotoCmaFragment = { id: string, broker_id?: string | null, lead_id?: string | null, report_title?: string | null, updated_at: any, language: any, font_family?: string | null, doc_template_theme_id?: string | null, contact_id?: string | null, cover_image_id?: string | null, doc_template?: { id: string } | null, doc_template_theme?: { id: string, name: string } | null, contact?: { id: string } | null, broker?: { id: string, show_in_agency_pages?: boolean | null, default_team?: { id: string, branding_color?: string | null, show_in_agency_pages?: boolean | null, description?: string | null } | null } | null, cover_image?: { id: string, url?: string | null } | null, property: { id: string, updated_at: any, lat?: number | null, lng?: number | null, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }> } };

export type StepHedonisticValuationFragment = { id: string, updated_at: any, include_hedonistic_valuation: boolean, property: { id: string, updated_at: any, latest_appraisal?: { id: string, updated_at: any } | null, appraisals: Array<{ id: string }> } };

export type CmaReportFileFragment = { cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } };

export type CmaPropertyFileFragment = { property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } };

export type StepDescriptionFragment = { id: string, updated_at: any, include_description: boolean, language: any, description_en?: string | null, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_pl?: string | null, description_pt?: string | null, description_es?: string | null };

export type UpdateStepPhotosMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateStepPhotosMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type UpdateStepPointsOfInterestMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateStepPointsOfInterestMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type UpdateDescriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateDescriptionMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_description: boolean, language: any, description_en?: string | null, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_pl?: string | null, description_pt?: string | null, description_es?: string | null } | null };

export type StepAppendFilesFragment = { id: string, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }>, property: { id: string, property_files: Array<{ property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } };

export type CmaReportEditorFragment = { id: string, updated_at: any, language: any, broker_id?: string | null, doc_template_id?: string | null, doc_template_theme_id?: string | null, property: { id: string, updated_at: any, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, lat?: number | null, lng?: number | null }, doc_template?: { id: string, content: string, filename_template: string, translations?: any | null } | null, doc_template_theme?: { id: string, name: string, content: string } | null };

export type StepIntroductionFragment = { id: string, updated_at: any, introduction?: string | null };

export type StepPropertyDetailsFragment = { id: string, updated_at: any, property: { id: string, updated_at: any, balcony_surface?: number | null, basement_surface?: number | null, building_condition?: number | null, building_standard?: number | null, building_volume?: number | null, built_surface?: number | null, charges?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, construction_year?: number | null, cooling?: Cooling_Enum_Enum | null, floor_of_flat?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, income_includes_parking?: boolean | null, land_surface?: number | null, living_surface?: number | null, minergie_code?: number | null, number_of_bathrooms?: number | null, number_of_bedrooms?: number | null, number_of_floors?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_rooms?: number | null, number_of_toilets?: number | null, parking_yearly_rental_income?: number | null, renovation_fund?: number | null, renovation_year?: number | null, residential_potential_rental_income?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, terrace_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, plot_number?: string | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, commercial_potential_rental_income?: number | null, is_parking_fully_rented?: boolean | null, parking_potential_rental_income?: number | null, orientation?: string | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_view?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, is_new_development: boolean, has_swimming_pool?: boolean | null, has_gym?: boolean | null, has_sauna?: boolean | null, has_wellness_area?: boolean | null, has_cellar?: boolean | null, has_attic?: boolean | null, has_photovoltaic_panels?: boolean | null, property_type?: { main_type?: string | null, name?: string | null } | null } };

export type StepFinalFragment = { id: string, updated_at: any, positive_comments?: string | null, negative_comments?: string | null, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, show_probability: boolean, probability_min?: number | null, probability_max?: number | null, probability_time_period?: number | null };

export type StepPotentialBuyersFragment = { id: string, updated_at: any, max_budget?: number | null, min_budget?: number | null, include_potential_buyers: boolean, suggested_market_value?: number | null, property: { id: string, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } };

export type DeleteCmaReportMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCmaReportMutation = { delete_cma_reports_by_pk?: { id: string } | null };

export type DocTemplatesCmaReportQueryVariables = Exact<{ [key: string]: never; }>;


export type DocTemplatesCmaReportQuery = { doc_templates: Array<{ id: string, name: string, active: boolean, type: Doc_Template_Type_Enum_Enum, doc_templates_tenants: Array<{ tenant_id: string, is_default: boolean }>, doc_templates_teams: Array<{ team_id: string, is_default: boolean }> }> };

export type StepPoisFragment = { property_pois: Array<{ id: string, distance_meters: number, walking_distance_meters?: number | null, cycling_distance_meters?: number | null, walking_time_minutes?: number | null, cycling_time_minutes?: number | null, poi: { id: string, name: string, formatted_address: string, category: string, types: Array<string>, primary_type: string, lat: number, lng: number } }> };

export type StepAgencyProfileFragment = { id: string, include_agency_description: boolean, agency_team_members?: any | null, sort_display_mode: string, cma_agent_transactions: Array<{ id: string, transaction_id: string }>, cma_user_reviews: Array<{ id: string, review_id: string }> };

export type GetCmaReportQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCmaReportQuery = { cma_reports_by_pk?: { __typename: 'cma_reports', rental_comparables: any, id: string, updated_at: any, language: any, broker_id?: string | null, doc_template_id?: string | null, doc_template_theme_id?: string | null, introduction?: string | null, lead_id?: string | null, report_title?: string | null, font_family?: string | null, contact_id?: string | null, cover_image_id?: string | null, include_description: boolean, description_en?: string | null, description_fr?: string | null, description_de?: string | null, description_it?: string | null, description_pl?: string | null, description_pt?: string | null, description_es?: string | null, include_hedonistic_valuation: boolean, include_comparables_valuation: boolean, include_comparable_listing_details: boolean, is_property_comparable_listings_square_meter_calculation?: boolean | null, show_full_idx_description: boolean, show_comparable_listing_cards: boolean, comparable_listings_map_zoom_level?: number | null, report_source?: Cma_Report_Source_Enum_Enum | null, rental_comparables_search_params: any, include_rental_comparable_listing_details: boolean, rental_comparable_listings_map_zoom_level?: number | null, show_full_rental_description: boolean, show_rental_comparable_listing_cards: boolean, include_transactions?: boolean | null, adjust_price_by_evolution?: boolean | null, is_property_transaction_square_meter_calculation?: boolean | null, transaction_map_zoom_level?: number | null, caprate_estimated_monthly_rent?: number | null, caprate_minimum_required_yield?: number | null, include_rental_comparables: boolean, construction_cost_base?: Cma_Reports_Construction_Base_Enum_Enum | null, intrinsic_building_surface?: number | null, intrinsic_construction_cost?: number | null, intrinsic_annual_deprecation_rate?: number | null, intrinsic_land_value?: number | null, intrinsic_custom_fields?: any | null, positive_comments?: string | null, negative_comments?: string | null, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, show_probability: boolean, probability_min?: number | null, probability_max?: number | null, probability_time_period?: number | null, max_budget?: number | null, min_budget?: number | null, include_potential_buyers: boolean, include_agency_description: boolean, agency_team_members?: any | null, sort_display_mode: string, include_market_data: boolean, market_comparison_places?: any | null, market_data_show_map: boolean, market_data_show_chart: boolean, market_data_map_zoom_level?: number | null, include_cover: boolean, include_introduction: boolean, include_property: boolean, include_photos: boolean, include_pois: boolean, include_poi_map: boolean, poi_map_zoom_level: number, include_cuprate_valuation: boolean, include_intrinsic_valuation: boolean, include_final_value: boolean, include_agent: boolean, include_agent_agency: boolean, include_client_testimonial: boolean, include_append_files: boolean, property: { id: string, updated_at: any, street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, lat?: number | null, lng?: number | null, balcony_surface?: number | null, basement_surface?: number | null, building_condition?: number | null, building_standard?: number | null, building_volume?: number | null, built_surface?: number | null, charges?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, construction_year?: number | null, cooling?: Cooling_Enum_Enum | null, floor_of_flat?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, income_includes_parking?: boolean | null, land_surface?: number | null, living_surface?: number | null, minergie_code?: number | null, number_of_bathrooms?: number | null, number_of_bedrooms?: number | null, number_of_floors?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_rooms?: number | null, number_of_toilets?: number | null, parking_yearly_rental_income?: number | null, renovation_fund?: number | null, renovation_year?: number | null, residential_potential_rental_income?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, terrace_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, plot_number?: string | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, commercial_potential_rental_income?: number | null, is_parking_fully_rented?: boolean | null, parking_potential_rental_income?: number | null, orientation?: string | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_view?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, is_new_development: boolean, has_swimming_pool?: boolean | null, has_gym?: boolean | null, has_sauna?: boolean | null, has_wellness_area?: boolean | null, has_cellar?: boolean | null, has_attic?: boolean | null, has_photovoltaic_panels?: boolean | null, state?: string | null, computed_surface?: number | null, locality_id?: string | null, country_code?: string | null, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }>, property_type?: { id: string, name?: string | null, main_type?: string | null, label?: string | null } | null, latest_appraisal?: { id: string, updated_at: any, value?: number | null, rent_value?: number | null, min?: number | null, max?: number | null } | null, appraisals: Array<{ id: string }>, locality_place?: { id: string, label?: string | null } | null, state_place?: { id: string } | null, property_files: Array<{ property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }>, property_pois: Array<{ id: string, distance_meters: number, walking_distance_meters?: number | null, cycling_distance_meters?: number | null, walking_time_minutes?: number | null, cycling_time_minutes?: number | null, poi: { id: string, name: string, formatted_address: string, category: string, types: Array<string>, primary_type: string, lat: number, lng: number } }> }, doc_template?: { id: string, content: string, filename_template: string, translations?: any | null } | null, doc_template_theme?: { id: string, name: string, content: string } | null, contact?: { id: string } | null, broker?: { id: string, show_in_agency_pages?: boolean | null, default_team?: { id: string, branding_color?: string | null, show_in_agency_pages?: boolean | null, description?: string | null } | null } | null, cover_image?: { id: string, url?: string | null } | null, comparable_listings: Array<{ cma_report_id: string, order_nr: number, aggregates_db__merged_listings_clusters_id: any }>, lead?: { id: string } | null, cma_agent_transactions: Array<{ id: string, transaction_id: string }>, cma_user_reviews: Array<{ id: string, review_id: string }>, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }>, cma_property_transactions: Array<{ id: string, cma_report_id: string, order_nr: number, source: string, transaction_id?: string | null, external_id?: string | null, created_at: any, distance_in_meters?: any | null, include_in_median: boolean, price_evolution_rate?: any | null, price_evolution_rate_updated_at?: any | null, transaction?: { purchase_price?: number | null, signature_date?: any | null, id?: string | null, locality?: string | null, postcode?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type_name?: string | null, property_main_type?: string | null, locality_place?: { id: string, name: string, label?: string | null } | null } | null }> } | null };

export type GetCmaReportBrokerSelectionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCmaReportBrokerSelectionsQuery = { cma_reports_by_pk?: { id: string, include_agency_description: boolean, agency_team_members?: any | null, sort_display_mode: string, cma_agent_transactions: Array<{ id: string, transaction_id: string }>, cma_user_reviews: Array<{ id: string, review_id: string }> } | null };

export type GetCmaReportTransactionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCmaReportTransactionsQuery = { cma_reports_by_pk?: { id: string, cma_property_transactions: Array<{ id: string, cma_report_id: string, order_nr: number, source: string, transaction_id?: string | null, external_id?: string | null, created_at: any, distance_in_meters?: any | null, include_in_median: boolean, price_evolution_rate?: any | null, price_evolution_rate_updated_at?: any | null, transaction?: { purchase_price?: number | null, signature_date?: any | null, id?: string | null, locality?: string | null, postcode?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type_name?: string | null, property_main_type?: string | null, locality_place?: { id: string, name: string, label?: string | null } | null } | null }> } | null };

export type GetCmaReportPoisQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCmaReportPoisQuery = { cma_reports_by_pk?: { id: string, property: { id: string, property_pois: Array<{ id: string, distance_meters: number, walking_distance_meters?: number | null, cycling_distance_meters?: number | null, walking_time_minutes?: number | null, cycling_time_minutes?: number | null, poi: { id: string, name: string, formatted_address: string, category: string, types: Array<string>, primary_type: string, lat: number, lng: number } }> } } | null };

export type UpdateCmaReportDocTemplateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaReportDocTemplateMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, doc_template?: { id: string, name: string, type: Doc_Template_Type_Enum_Enum } | null } | null };

export type UpdateCmaStepCoverMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaStepCoverMutation = { update_cma_reports_by_pk?: { id: string, broker_id?: string | null, lead_id?: string | null, report_title?: string | null, updated_at: any, language: any, font_family?: string | null, doc_template_theme_id?: string | null, contact_id?: string | null, cover_image_id?: string | null, doc_template?: { id: string } | null, doc_template_theme?: { id: string, name: string } | null, contact?: { id: string } | null, broker?: { id: string, show_in_agency_pages?: boolean | null, default_team?: { id: string, branding_color?: string | null, show_in_agency_pages?: boolean | null, description?: string | null } | null } | null, cover_image?: { id: string, url?: string | null } | null, property: { id: string, updated_at: any, lat?: number | null, lng?: number | null, property_images: Array<{ id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } }> } } | null };

export type StepCoverInsertPropertyImageMutationVariables = Exact<{
  object: Property_Images_Insert_Input;
}>;


export type StepCoverInsertPropertyImageMutation = { insert_property_images_one?: { id: string, image: { id: string, url?: string | null } } | null };

export type UpdateTeamBrandingColorCmaMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  brandingColor?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['uuid']['input'];
}>;


export type UpdateTeamBrandingColorCmaMutation = { update_teams_by_pk?: { id: string, branding_color?: string | null } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type UpdateCmaIntroductionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaIntroductionMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, introduction?: string | null } | null };

export type UpdatePropertyDetailsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdatePropertyDetailsMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, property: { id: string, updated_at: any, balcony_surface?: number | null, basement_surface?: number | null, building_condition?: number | null, building_standard?: number | null, building_volume?: number | null, built_surface?: number | null, charges?: number | null, commercial_surface?: number | null, commercial_yearly_rental_income?: number | null, construction_year?: number | null, cooling?: Cooling_Enum_Enum | null, floor_of_flat?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, heating?: Heating_Enum_Enum | null, heating_distribution?: Heating_Distribution_Enum_Enum | null, income_includes_parking?: boolean | null, land_surface?: number | null, living_surface?: number | null, minergie_code?: number | null, number_of_bathrooms?: number | null, number_of_bedrooms?: number | null, number_of_floors?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, number_of_rooms?: number | null, number_of_toilets?: number | null, parking_yearly_rental_income?: number | null, renovation_fund?: number | null, renovation_year?: number | null, residential_potential_rental_income?: number | null, residential_surface?: number | null, residential_yearly_rental_income?: number | null, terrace_surface?: number | null, usable_surface?: number | null, weighted_floor_surface?: number | null, plot_number?: string | null, number_of_residential_units?: number | null, number_of_commercial_units?: number | null, number_of_lifts?: number | null, side?: Property_Side_Enum_Enum | null, energy_consumption_class?: Energy_Class_Type_Enum_Enum | null, gas_emissions_class?: Energy_Class_Type_Enum_Enum | null, consumption?: number | null, emissions?: number | null, energy_reference_year?: number | null, energy_inspection_date?: string | null, estimated_lower_energy_cost?: number | null, estimated_higher_energy_cost?: number | null, energy_certificate_version?: string | null, micro_location?: number | null, macro_location?: number | null, is_residential_fully_rented?: boolean | null, is_commercial_fully_rented?: boolean | null, commercial_potential_rental_income?: number | null, is_parking_fully_rented?: boolean | null, parking_potential_rental_income?: number | null, orientation?: string | null, is_oriented_north: boolean, is_oriented_south: boolean, is_oriented_east: boolean, is_oriented_west: boolean, is_luxury?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, has_view?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, is_new_development: boolean, has_swimming_pool?: boolean | null, has_gym?: boolean | null, has_sauna?: boolean | null, has_wellness_area?: boolean | null, has_cellar?: boolean | null, has_attic?: boolean | null, has_photovoltaic_panels?: boolean | null, property_type?: { main_type?: string | null, name?: string | null } | null } } | null };

export type UpdateHedonisticValuationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateHedonisticValuationMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_hedonistic_valuation: boolean, property: { id: string, updated_at: any, latest_appraisal?: { id: string, updated_at: any } | null, appraisals: Array<{ id: string }> } } | null };

export type UpdateFinalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateFinalMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, positive_comments?: string | null, negative_comments?: string | null, suggested_market_value?: number | null, is_price_range: boolean, price_range_min?: number | null, price_range_max?: number | null, show_probability: boolean, probability_min?: number | null, probability_max?: number | null, probability_time_period?: number | null } | null };

export type UpdatePotentialBuyersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdatePotentialBuyersMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, max_budget?: number | null, min_budget?: number | null, include_potential_buyers: boolean, suggested_market_value?: number | null, property: { id: string, latest_appraisal?: { id: string, min?: number | null, max?: number | null } | null } } | null };

export type UpdateCmaMarketDataMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaMarketDataMutation = { update_cma_reports_by_pk?: { id: string, include_market_data: boolean, market_comparison_places?: any | null, market_data_show_map: boolean, market_data_show_chart: boolean, market_data_map_zoom_level?: number | null, updated_at: any } | null };

export type StepAddCmaReportFileMutationVariables = Exact<{
  object: Cma_Report_Files_Insert_Input;
  cma_report_id: Scalars['uuid']['input'];
}>;


export type StepAddCmaReportFileMutation = { insert_cma_report_files_one?: { cma_report_id: string, file_id: string, cma_report?: { id: string, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } | null } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepDeleteCmaReportFileMutationVariables = Exact<{
  file_id: Scalars['uuid']['input'];
  cma_report_id: Scalars['uuid']['input'];
}>;


export type StepDeleteCmaReportFileMutation = { delete_cma_report_files?: { returning: Array<{ cma_report_id: string, file_id: string }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepUpdateCmaReportFileMutationVariables = Exact<{
  input: Cma_Report_Files_Set_Input;
  file_id: Scalars['uuid']['input'];
  cma_report_id: Scalars['uuid']['input'];
}>;


export type StepUpdateCmaReportFileMutation = { update_cma_report_files?: { returning: Array<{ cma_report_id: string, file_id: string, cma_report?: { id: string, cma_report_files: Array<{ cma_report_id: string, file_id: string, is_visible: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } | null }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepUpdateCmaReportFileVisibilityMutationVariables = Exact<{
  file_id: Scalars['uuid']['input'];
  cma_report_id: Scalars['uuid']['input'];
  is_visible: Scalars['Boolean']['input'];
}>;


export type StepUpdateCmaReportFileVisibilityMutation = { update_cma_report_files?: { returning: Array<{ cma_report_id: string, file_id: string, is_visible: boolean }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type StepAppendAddPropertyFileMutationVariables = Exact<{
  object: Property_Files_Insert_Input;
}>;


export type StepAppendAddPropertyFileMutation = { insert_property_files_one?: { property_id: string, file_id: string, property: { id: string, property_files: Array<{ property_id: string, file_id: string, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any } }> } } | null };

export type StepListingsCompareFragment = { id: string, include_comparables_valuation: boolean, include_comparable_listing_details: boolean, is_property_comparable_listings_square_meter_calculation?: boolean | null, show_full_idx_description: boolean, show_comparable_listing_cards: boolean, comparable_listings_map_zoom_level?: number | null, report_source?: Cma_Report_Source_Enum_Enum | null, updated_at: any, comparable_listings: Array<{ cma_report_id: string, order_nr: number, aggregates_db__merged_listings_clusters_id: any }>, property: { id: string, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, land_surface?: number | null, state?: string | null, lat?: number | null, lng?: number | null, locality_place?: { id: string, label?: string | null } | null, state_place?: { id: string } | null, latest_appraisal?: { value?: number | null } | null, property_type?: { main_type?: string | null, name?: string | null } | null }, lead?: { id: string } | null };

export type StepListingsCompareListingsQueryVariables = Exact<{
  ids?: InputMaybe<Scalars['jsonb']['input']>;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
  pl: Scalars['Boolean']['input'];
  pt: Scalars['Boolean']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
}>;


export type StepListingsCompareListingsQuery = { ch_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, fr_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, es_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, it_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pl_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pt_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }> };

export type StepListingsCompareAlgoQueryVariables = Exact<{
  built_surface?: InputMaybe<Scalars['Float']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  living_surface?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Int']['input']>;
  property_main_type?: InputMaybe<Scalars['String']['input']>;
  sale_price?: InputMaybe<Scalars['Float']['input']>;
  usable_surface?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
  pl: Scalars['Boolean']['input'];
  pt: Scalars['Boolean']['input'];
}>;


export type StepListingsCompareAlgoQuery = { ch_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, es_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, fr_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, it_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pl_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pt_get_similar_listings_cohorts?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, property_type: string, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, valid_from: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }> };

export type FindCmaListingByPortalIdQueryVariables = Exact<{
  portal: Scalars['String']['input'];
  originalId: Scalars['String']['input'];
  isCh: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
}>;


export type FindCmaListingByPortalIdQuery = { ch_cma_listings?: Array<{ id: number }>, es_cma_listings?: Array<{ id: number }>, fr_cma_listings?: Array<{ id: number }>, it_cma_listings?: Array<{ id: number }>, pl_cma_listings?: Array<{ id: number }>, pt_cma_listings?: Array<{ id: number }> };

export type FindCmaListingByRawIdentifierQueryVariables = Exact<{
  raw: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  isCh: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
}>;


export type FindCmaListingByRawIdentifierQuery = { ch_cma_listings?: Array<{ id: number }>, es_cma_listings?: Array<{ id: number }>, fr_cma_listings?: Array<{ id: number }>, it_cma_listings?: Array<{ id: number }>, pl_cma_listings?: Array<{ id: number }>, pt_cma_listings?: Array<{ id: number }> };

export type UpdateComparablesListMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateComparablesListMutation = { update_cma_reports_by_pk?: { id: string, include_comparables_valuation: boolean, updated_at: any } | null };

export type InsertCmaReportsComparablesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  objects: Array<Cma_Reports_Comparables_Insert_Input> | Cma_Reports_Comparables_Insert_Input;
}>;


export type InsertCmaReportsComparablesMutation = { delete_cma_reports_comparables?: { __typename: 'cma_reports_comparables_mutation_response' } | null, insert_cma_reports_comparables?: { returning: Array<{ aggregates_db__merged_listings_clusters_id: any, cma_report_id: string, order_nr: number }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type UpdateCmaReportsComparablesMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  listing_id: Scalars['bigint']['input'];
  order_nr: Scalars['Float']['input'];
}>;


export type UpdateCmaReportsComparablesMutation = { update_cma_reports_comparables?: { returning: Array<{ cma_report: { comparable_listings: Array<{ order_nr: number, cma_report_id: string, aggregates_db__merged_listings_clusters_id: any }> } }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type DeleteCmaReportsComparablesMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  listing_id: Scalars['bigint']['input'];
}>;


export type DeleteCmaReportsComparablesMutation = { delete_cma_reports_comparables?: { returning: Array<{ cma_report: { comparable_listings: Array<{ order_nr: number, cma_report_id: string, aggregates_db__merged_listings_clusters_id: any }> } }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type ComparableCmaListingDetailsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  stateId: Scalars['uuid']['input'];
  isCh: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
}>;


export type ComparableCmaListingDetailsQuery = { ch_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, state_id: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, fr_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, state_id: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, es_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, state_id: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, it_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, state_id: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, pl_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, state_id: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null, pt_cma_listings_by_pk?: { id: number, title?: string | null, address?: string | null, offline_since?: any | null, valid_from: any, description?: string | null, sale_price?: number | null, number_of_rooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, offer_type: string, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, country_code?: string | null, living_surface?: number | null, built_surface?: number | null, computed_price_per_sqm?: number | null, property_type: string, floor_of_flat?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, construction_year?: number | null, property_main_type: string, agency_name?: string | null, agency_contact_address?: string | null, agency_contact_person?: string | null, url: string, state_id: string, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, created_at: any, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null };

export type ComparableCmaListingsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  stateId?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  listingIds?: InputMaybe<Scalars['jsonb']['input']>;
  chWhere?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
  frWhere?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
  esWhere?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
  itWhere?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
  plWhere?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
  ptWhere?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
  isCh: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
}>;


export type ComparableCmaListingsQuery = { ch_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, created_at: any, valid_from: any, state_id: string, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, fr_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, created_at: any, valid_from: any, state_id: string, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, es_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, created_at: any, valid_from: any, state_id: string, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, it_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, created_at: any, valid_from: any, state_id: string, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pl_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, created_at: any, valid_from: any, state_id: string, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pt_get_cma_listings_distance?: Array<{ id: string, distance_in_meters: number, listing?: { id: number, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, created_at: any, valid_from: any, state_id: string, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }> };

export type CmaListingsByRadiusQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  radiusMeters: Scalars['Float']['input'];
  isCh: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
  chWhere?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
  frWhere?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
  esWhere?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
  itWhere?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
  plWhere?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
  ptWhere?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
}>;


export type CmaListingsByRadiusQuery = { ch_get_cma_listings_by_radius?: Array<{ distance_in_meters: number, listing?: { id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, created_at: any, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, fr_get_cma_listings_by_radius?: Array<{ distance_in_meters: number, listing?: { id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, created_at: any, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, es_get_cma_listings_by_radius?: Array<{ distance_in_meters: number, listing?: { id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, created_at: any, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, it_get_cma_listings_by_radius?: Array<{ listing?: { id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, created_at: any, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pl_get_cma_listings_by_radius?: Array<{ distance_in_meters: number, listing?: { id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, created_at: any, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }>, pt_get_cma_listings_by_radius?: Array<{ distance_in_meters: number, listing?: { id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, created_at: any, country_code?: string | null, agency_name?: string | null, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> } | null }> };

export type CmaListingsByAreaQueryVariables = Exact<{
  isCh: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
  chWhere: Ch_Cma_Listings_Bool_Exp;
  frWhere: Fr_Cma_Listings_Bool_Exp;
  esWhere: Es_Cma_Listings_Bool_Exp;
  itWhere: It_Cma_Listings_Bool_Exp;
  plWhere: Pl_Cma_Listings_Bool_Exp;
  ptWhere: Pt_Cma_Listings_Bool_Exp;
}>;


export type CmaListingsByAreaQuery = { ch_cma_listings?: Array<{ id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, country_code?: string | null, agency_name?: string | null, created_at: any, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, fr_cma_listings?: Array<{ id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, country_code?: string | null, agency_name?: string | null, created_at: any, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, es_cma_listings?: Array<{ id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, country_code?: string | null, agency_name?: string | null, created_at: any, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, it_cma_listings?: Array<{ id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, country_code?: string | null, agency_name?: string | null, created_at: any, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, pl_cma_listings?: Array<{ id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, country_code?: string | null, agency_name?: string | null, created_at: any, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, pt_cma_listings?: Array<{ id: number, state_id: string, sale_price?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_price_per_sqm?: number | null, property_type: string, offline_since?: any | null, valid_from: any, country_code?: string | null, agency_name?: string | null, created_at: any, visit_contact_person?: string | null, agency_contact_person?: string | null, state?: { name: string } | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }> };

export type ComparableCmaListingsCountQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  stateId?: InputMaybe<Scalars['uuid']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  listingIds?: InputMaybe<Scalars['jsonb']['input']>;
  chWhere?: InputMaybe<Ch_Cma_Listings_Distance_Bool_Exp>;
  frWhere?: InputMaybe<Fr_Cma_Listings_Distance_Bool_Exp>;
  esWhere?: InputMaybe<Es_Cma_Listings_Distance_Bool_Exp>;
  itWhere?: InputMaybe<It_Cma_Listings_Distance_Bool_Exp>;
  plWhere?: InputMaybe<Pl_Cma_Listings_Distance_Bool_Exp>;
  ptWhere?: InputMaybe<Pt_Cma_Listings_Distance_Bool_Exp>;
  isCh: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
}>;


export type ComparableCmaListingsCountQuery = { ch_get_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, fr_get_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, es_get_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, it_get_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, pl_get_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, pt_get_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null } };

export type GenerateCmaReportMutationVariables = Exact<{
  leadId: Scalars['uuid']['input'];
  source: Cma_Report_Source_Enum_Enum;
}>;


export type GenerateCmaReportMutation = { generate_cma_report?: { cma_report_id: string } | null };

export type CreateCmaReportMutationVariables = Exact<{
  input: Cma_Reports_Insert_Input;
}>;


export type CreateCmaReportMutation = { insert_cma_reports_one?: { id: string } | null };

export type CmaReportIncludeFragment = { id: string, include_cover: boolean, include_introduction: boolean, include_property: boolean, include_description: boolean, include_photos: boolean, include_pois: boolean, include_poi_map: boolean, poi_map_zoom_level: number, include_hedonistic_valuation: boolean, include_comparables_valuation: boolean, include_rental_comparables: boolean, comparable_listings_map_zoom_level?: number | null, include_transactions?: boolean | null, transaction_map_zoom_level?: number | null, include_cuprate_valuation: boolean, include_intrinsic_valuation: boolean, include_final_value: boolean, include_potential_buyers: boolean, include_agent: boolean, include_agent_agency: boolean, include_client_testimonial: boolean, include_append_files: boolean, include_market_data: boolean };

export type UpdateCmaReportStepVisibilityMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCmaReportStepVisibilityMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_cover: boolean, include_introduction: boolean, include_property: boolean, include_description: boolean, include_photos: boolean, include_pois: boolean, include_poi_map: boolean, poi_map_zoom_level: number, include_hedonistic_valuation: boolean, include_comparables_valuation: boolean, include_rental_comparables: boolean, comparable_listings_map_zoom_level?: number | null, include_transactions?: boolean | null, transaction_map_zoom_level?: number | null, include_cuprate_valuation: boolean, include_intrinsic_valuation: boolean, include_final_value: boolean, include_potential_buyers: boolean, include_agent: boolean, include_agent_agency: boolean, include_client_testimonial: boolean, include_append_files: boolean, include_market_data: boolean } | null };

export type StepCapRateValuationFragment = { id: string, updated_at: any, caprate_estimated_monthly_rent?: number | null, caprate_minimum_required_yield?: number | null, include_rental_comparables: boolean, rental_comparables: any, property: { id: string, lat?: number | null, lng?: number | null, computed_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type?: { name?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, value?: number | null, rent_value?: number | null } | null } };

export type StepIntrinsicValuationFragment = { id: string, updated_at: any, construction_cost_base?: Cma_Reports_Construction_Base_Enum_Enum | null, intrinsic_building_surface?: number | null, intrinsic_construction_cost?: number | null, intrinsic_annual_deprecation_rate?: number | null, intrinsic_land_value?: number | null, intrinsic_custom_fields?: any | null, property: { id: string, building_volume?: number | null, construction_year?: number | null, renovation_year?: number | null, land_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, basement_surface?: number | null, commercial_surface?: number | null, balcony_surface?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, residential_surface?: number | null, terrace_surface?: number | null, weighted_floor_surface?: number | null } };

export type UpdateCapRateValuationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateCapRateValuationMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, caprate_estimated_monthly_rent?: number | null, caprate_minimum_required_yield?: number | null, include_rental_comparables: boolean, rental_comparables: any, property: { id: string, lat?: number | null, lng?: number | null, computed_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type?: { name?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, value?: number | null, rent_value?: number | null } | null } } | null };

export type UpdateIntrinsicValuationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  input: Cma_Reports_Set_Input;
}>;


export type UpdateIntrinsicValuationMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, construction_cost_base?: Cma_Reports_Construction_Base_Enum_Enum | null, intrinsic_building_surface?: number | null, intrinsic_construction_cost?: number | null, intrinsic_annual_deprecation_rate?: number | null, intrinsic_land_value?: number | null, intrinsic_custom_fields?: any | null, property: { id: string, building_volume?: number | null, construction_year?: number | null, renovation_year?: number | null, land_surface?: number | null, living_surface?: number | null, usable_surface?: number | null, basement_surface?: number | null, commercial_surface?: number | null, balcony_surface?: number | null, garden_surface?: number | null, gross_floor_surface?: number | null, residential_surface?: number | null, terrace_surface?: number | null, weighted_floor_surface?: number | null } } | null };

export type UpdateCmaReportsTransactionsMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  cma_property_transaction_id: Scalars['uuid']['input'];
  order_nr: Scalars['Int']['input'];
}>;


export type UpdateCmaReportsTransactionsMutation = { __typename: 'mutation_root', update_cma_reports_property_transactions_by_pk?: { __typename: 'cma_reports_property_transactions', id: string, order_nr: number, cma_report_id: string, transaction_id?: string | null, created_at: any } | null, update_cma_reports_by_pk?: { __typename: 'cma_reports', id: string, updated_at: any } | null };

export type UpdateCmaPropertyTransactionIncludeMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  id: Scalars['uuid']['input'];
  include_in_median: Scalars['Boolean']['input'];
}>;


export type UpdateCmaPropertyTransactionIncludeMutation = { update_cma_reports_property_transactions_by_pk?: { id: string, include_in_median: boolean } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type ClearPriceEvolutionCacheMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
}>;


export type ClearPriceEvolutionCacheMutation = { update_cma_reports_property_transactions?: { affected_rows: number, returning: Array<{ id: string, cma_report_id: string, transaction_id?: string | null, order_nr: number, created_at: any, price_evolution_rate?: any | null, price_evolution_rate_updated_at?: any | null }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type DeleteCmaReportsTransactionsMutationVariables = Exact<{
  cma_property_transaction_id: Scalars['uuid']['input'];
  cma_report_id: Scalars['uuid']['input'];
}>;


export type DeleteCmaReportsTransactionsMutation = { delete_cma_reports_property_transactions_by_pk?: { id: string } | null, update_cma_reports_by_pk?: { id: string, updated_at: any, cma_property_transactions: Array<{ id: string, cma_report_id: string, order_nr: number, source: string, transaction_id?: string | null, external_id?: string | null, created_at: any, distance_in_meters?: any | null, include_in_median: boolean, price_evolution_rate?: any | null, price_evolution_rate_updated_at?: any | null, transaction?: { purchase_price?: number | null, signature_date?: any | null, id?: string | null, locality?: string | null, postcode?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type_name?: string | null, property_main_type?: string | null, locality_place?: { id: string, name: string, label?: string | null } | null } | null }> } | null };

export type StepTransactionsListFragment = { id: string, cma_property_transactions: Array<{ id: string, cma_report_id: string, order_nr: number, source: string, transaction_id?: string | null, external_id?: string | null, created_at: any, distance_in_meters?: any | null, include_in_median: boolean, price_evolution_rate?: any | null, price_evolution_rate_updated_at?: any | null, transaction?: { purchase_price?: number | null, signature_date?: any | null, id?: string | null, locality?: string | null, postcode?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type_name?: string | null, property_main_type?: string | null, locality_place?: { id: string, name: string, label?: string | null } | null } | null }> };

export type StepTransactionsFragment = { id: string, include_transactions?: boolean | null, adjust_price_by_evolution?: boolean | null, is_property_transaction_square_meter_calculation?: boolean | null, transaction_map_zoom_level?: number | null, updated_at: any, property: { id: string, locality_id?: string | null, country_code?: string | null, lat?: number | null, lng?: number | null, property_type?: { id: string, name?: string | null, label?: string | null, main_type?: string | null } | null, latest_appraisal?: { value?: number | null } | null }, cma_property_transactions: Array<{ id: string, cma_report_id: string, order_nr: number, source: string, transaction_id?: string | null, external_id?: string | null, created_at: any, distance_in_meters?: any | null, include_in_median: boolean, price_evolution_rate?: any | null, price_evolution_rate_updated_at?: any | null, transaction?: { purchase_price?: number | null, signature_date?: any | null, id?: string | null, locality?: string | null, postcode?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type_name?: string | null, property_main_type?: string | null, locality_place?: { id: string, name: string, label?: string | null } | null } | null }> };

export type ReplaceCmaReportsTransactionsMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  transactions: Array<Cma_Reports_Property_Transactions_Insert_Input> | Cma_Reports_Property_Transactions_Insert_Input;
  crm_transaction_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  external_transaction_ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  to_delete_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ReplaceCmaReportsTransactionsMutation = { delete_cma_reports_property_transactions?: { affected_rows: number } | null, insert_cma_reports_property_transactions?: { returning: Array<{ id: string }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any, cma_property_transactions: Array<{ id: string, cma_report_id: string, order_nr: number, source: string, transaction_id?: string | null, external_id?: string | null, created_at: any, distance_in_meters?: any | null, include_in_median: boolean, price_evolution_rate?: any | null, price_evolution_rate_updated_at?: any | null, transaction?: { purchase_price?: number | null, signature_date?: any | null, id?: string | null, locality?: string | null, postcode?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type_name?: string | null, property_main_type?: string | null, locality_place?: { id: string, name: string, label?: string | null } | null } | null }> } | null };

export type UpdateCmaReportAdjustPriceMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  adjust_price_by_evolution: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportAdjustPriceMutation = { update_cma_reports_by_pk?: { id: string, adjust_price_by_evolution?: boolean | null, updated_at: any } | null };

export type UpdateCmaReportTransactionsSquareMeterCalculationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  is_property_transaction_square_meter_calculation: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportTransactionsSquareMeterCalculationMutation = { update_cma_reports_by_pk?: { id: string, is_property_transaction_square_meter_calculation?: boolean | null, updated_at: any } | null };

export type UpdateCmaReportTransactionMapZoomLevelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  transaction_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateCmaReportTransactionMapZoomLevelMutation = { update_cma_reports_by_pk?: { id: string, transaction_map_zoom_level?: number | null, updated_at: any } | null };

export type UpdateCmaReportComparableListingsMapZoomLevelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateCmaReportComparableListingsMapZoomLevelMutation = { update_cma_reports_by_pk?: { id: string, comparable_listings_map_zoom_level?: number | null, updated_at: any } | null };

export type UpdateCmaReportComparableListingsSquareMeterCalculationMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  is_property_comparable_listings_square_meter_calculation: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportComparableListingsSquareMeterCalculationMutation = { update_cma_reports_by_pk?: { id: string, is_property_comparable_listings_square_meter_calculation?: boolean | null, updated_at: any } | null };

export type ExternalTransactionDistanceFieldsFragment = { id: string, source: string, external_id: string, country_code: string, currency: string, signature_date: string, purchase_price: number, property_main_type?: string | null, property_type_name?: string | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, locality?: string | null, postcode?: string | null, street_number?: string | null, street_suffix?: string | null, street_type?: string | null, street_name?: string | null, lat?: number | null, lng?: number | null, distance_in_meters: number };

export type ExternalTransactionFieldsFragment = { id: string, source: string, external_id: string, country_code: string, currency: string, signature_date: string, purchase_price: number, property_main_type?: string | null, property_type_name?: string | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, locality?: string | null, postcode?: string | null, street_number?: string | null, street_suffix?: string | null, street_type?: string | null, street_name?: string | null, lat?: number | null, lng?: number | null };

export type GetAutomaticExternalTransactionsQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  source: Scalars['_text']['input'];
  property_main_type?: InputMaybe<Scalars['_text']['input']>;
  cutoff_date?: InputMaybe<Scalars['date']['input']>;
  cutoff_date_max?: InputMaybe<Scalars['date']['input']>;
}>;


export type GetAutomaticExternalTransactionsQuery = { fr_get_external_transactions_distance: Array<{ id: string, source: string, external_id: string, country_code: string, currency: string, signature_date: string, purchase_price: number, property_main_type?: string | null, property_type_name?: string | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, locality?: string | null, postcode?: string | null, street_number?: string | null, street_suffix?: string | null, street_type?: string | null, street_name?: string | null, lat?: number | null, lng?: number | null, distance_in_meters: number }> };

export type GetAutomaticTransactionsQueryVariables = Exact<{
  target_property_id: Scalars['uuid']['input'];
  max_signature_date?: InputMaybe<Scalars['date']['input']>;
}>;


export type GetAutomaticTransactionsQuery = { get_property_transactions_distance: Array<{ id: string, transaction_id: string, distance_in_meters: number, transaction?: { id?: string | null, purchase_price?: number | null, signature_date?: any | null, postcode?: string | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, property_type_name?: string | null, property_main_type?: string | null } | null }> };

export type CmaTransactionsWithDistanceRowsQueryVariables = Exact<{
  target_property_id: Scalars['uuid']['input'];
  max_distance_meters?: InputMaybe<Scalars['float8']['input']>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
  order_by?: InputMaybe<Array<Property_Transactions_Distance_Order_By> | Property_Transactions_Distance_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CmaTransactionsWithDistanceRowsQuery = { get_property_transactions_distance: Array<{ id: string, transaction_id: string, distance_in_meters: number, transaction?: { id?: string | null, purchase_price?: number | null, signature_date?: any | null, locality?: string | null, living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, postcode?: string | null, property_type_name?: string | null, property_main_type?: string | null, locality_place?: { id: string, name: string, label?: string | null } | null } | null }> };

export type CmaTransactionsWithDistanceCountQueryVariables = Exact<{
  target_property_id: Scalars['uuid']['input'];
  max_distance_meters?: InputMaybe<Scalars['float8']['input']>;
  where?: InputMaybe<Property_Transactions_Distance_Bool_Exp>;
}>;


export type CmaTransactionsWithDistanceCountQuery = { get_property_transactions_distance_aggregate: { aggregate?: { count: number } | null } };

export type CmaExternalTransactionsWithDistanceRowsQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  source: Scalars['_text']['input'];
  max_distance_meters?: InputMaybe<Scalars['Float']['input']>;
  max_results?: InputMaybe<Scalars['Int']['input']>;
  property_main_type?: InputMaybe<Scalars['_text']['input']>;
  cutoff_date?: InputMaybe<Scalars['date']['input']>;
  cutoff_date_max?: InputMaybe<Scalars['date']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  living_surface_min?: InputMaybe<Scalars['Float']['input']>;
  living_surface_max?: InputMaybe<Scalars['Float']['input']>;
  land_surface_min?: InputMaybe<Scalars['Float']['input']>;
  land_surface_max?: InputMaybe<Scalars['Float']['input']>;
  rooms_min?: InputMaybe<Scalars['Int']['input']>;
  rooms_max?: InputMaybe<Scalars['Int']['input']>;
  price_min?: InputMaybe<Scalars['Int']['input']>;
  price_max?: InputMaybe<Scalars['Int']['input']>;
  polygon_geojson?: InputMaybe<Scalars['String']['input']>;
  sort_field?: InputMaybe<Scalars['String']['input']>;
  sort_direction?: InputMaybe<Scalars['String']['input']>;
}>;


export type CmaExternalTransactionsWithDistanceRowsQuery = { fr_get_external_transactions_distance: Array<{ id: string, source: string, external_id: string, country_code: string, currency: string, signature_date: string, purchase_price: number, property_main_type?: string | null, property_type_name?: string | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, locality?: string | null, postcode?: string | null, street_number?: string | null, street_suffix?: string | null, street_type?: string | null, street_name?: string | null, lat?: number | null, lng?: number | null, distance_in_meters: number }> };

export type CmaExternalTransactionsWithDistanceCountQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  source: Scalars['_text']['input'];
  max_distance_meters?: InputMaybe<Scalars['Float']['input']>;
  property_main_type?: InputMaybe<Scalars['_text']['input']>;
  cutoff_date?: InputMaybe<Scalars['date']['input']>;
  cutoff_date_max?: InputMaybe<Scalars['date']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  living_surface_min?: InputMaybe<Scalars['Float']['input']>;
  living_surface_max?: InputMaybe<Scalars['Float']['input']>;
  land_surface_min?: InputMaybe<Scalars['Float']['input']>;
  land_surface_max?: InputMaybe<Scalars['Float']['input']>;
  rooms_min?: InputMaybe<Scalars['Int']['input']>;
  rooms_max?: InputMaybe<Scalars['Int']['input']>;
  price_min?: InputMaybe<Scalars['Int']['input']>;
  price_max?: InputMaybe<Scalars['Int']['input']>;
  polygon_geojson?: InputMaybe<Scalars['String']['input']>;
}>;


export type CmaExternalTransactionsWithDistanceCountQuery = { fr_get_external_transactions_distance_aggregate: { aggregate?: { count: number } | null } };

export type GetPlaceGeometriesQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  withGeometry: Scalars['Boolean']['input'];
}>;


export type GetPlaceGeometriesQuery = { places: Array<{ id: string, children_bbox: any, simplified_geom?: any | null }> };

export type GetSavedExternalTransactionsQueryVariables = Exact<{
  source: Scalars['String']['input'];
  externalIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSavedExternalTransactionsQuery = { fr_external_transactions: Array<{ id: string, source: string, external_id: string, country_code: string, currency: string, signature_date: string, purchase_price: number, property_main_type?: string | null, property_type_name?: string | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, locality?: string | null, postcode?: string | null, street_number?: string | null, street_suffix?: string | null, street_type?: string | null, street_name?: string | null, lat?: number | null, lng?: number | null }> };

export type GetCurrentUserTeamOptInStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserTeamOptInStatusQuery = { get_me: { me?: { id: string, default_team?: { id: string, name: string, share_transactions_in_cma?: boolean | null } | null, teams_users: Array<{ team_id: string, is_leader: boolean, team: { id: string, name: string } }> } | null } };

export type UpdateTeamShareTransactionsInCmaMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  share_transactions_in_cma: Scalars['Boolean']['input'];
  cma_report_id: Scalars['uuid']['input'];
}>;


export type UpdateTeamShareTransactionsInCmaMutation = { update_teams_by_pk?: { id: string, share_transactions_in_cma?: boolean | null, updated_at: any } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type DeleteCmaAgentTransactionMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  transaction_id: Scalars['uuid']['input'];
}>;


export type DeleteCmaAgentTransactionMutation = { delete_cma_reports_agent_transactions?: { returning: Array<{ cma_report_id: string, transaction_id: string }> } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type InsertCmaAgentTransactionMutationVariables = Exact<{
  cma_report_id: Scalars['uuid']['input'];
  transaction_id: Scalars['uuid']['input'];
  distance_in_meters?: InputMaybe<Scalars['numeric']['input']>;
  zone?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertCmaAgentTransactionMutation = { insert_cma_reports_agent_transactions_one?: { id: string, transaction_id: string, distance_in_meters?: any | null, zone?: number | null, created_at: any, transaction: { id: string, signature_date?: any | null, purchase_price?: number | null, property: { id: string, locality?: string | null, postcode?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, country_code?: string | null, property_images: Array<{ image: { id: string, url?: string | null } }> } } } | null, update_cma_reports_by_pk?: { id: string, updated_at: any } | null };

export type CmaAgentTransactionDetailsFragment = { id: string, transaction_id: string, distance_in_meters?: any | null, zone?: number | null, created_at: any, transaction: { id: string, signature_date?: any | null, purchase_price?: number | null, property: { id: string, locality?: string | null, postcode?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, country_code?: string | null, property_images: Array<{ image: { id: string, url?: string | null } }> } } };

export type GetCmaAgentTransactionsQueryVariables = Exact<{
  cmaReportId: Scalars['uuid']['input'];
}>;


export type GetCmaAgentTransactionsQuery = { cma_reports_by_pk?: { id: string, sort_display_mode: string, cma_agent_transactions: Array<{ id: string, transaction_id: string, distance_in_meters?: any | null, zone?: number | null, created_at: any, transaction: { id: string, signature_date?: any | null, purchase_price?: number | null, property: { id: string, locality?: string | null, postcode?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, country_code?: string | null, property_images: Array<{ image: { id: string, url?: string | null } }> } } }> } | null };

export type GetCmaAgentTransactionsPaginatedQueryVariables = Exact<{
  cmaReportId: Scalars['uuid']['input'];
  sortMode: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetCmaAgentTransactionsPaginatedQuery = { get_cma_agent_transactions: Array<{ id: string, transaction_id: string, distance_in_meters?: any | null, zone?: number | null, created_at: any, transaction: { id: string, signature_date?: any | null, purchase_price?: number | null, property: { id: string, locality?: string | null, postcode?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, built_surface?: number | null, country_code?: string | null, property_images: Array<{ image: { id: string, url?: string | null } }> } } }> };

export type UpdateCmaAgentSortingModeMutationVariables = Exact<{
  cmaReportId: Scalars['uuid']['input'];
  sortMode: Scalars['String']['input'];
  objects: Array<Cma_Reports_Agent_Transactions_Insert_Input> | Cma_Reports_Agent_Transactions_Insert_Input;
  hasTransactions: Scalars['Boolean']['input'];
}>;


export type UpdateCmaAgentSortingModeMutation = { delete_cma_reports_agent_transactions?: { affected_rows: number } | null, insert_cma_reports_agent_transactions?: { affected_rows: number } | null, update_cma_reports_by_pk?: { updated_at: any, id: string, include_agency_description: boolean, agency_team_members?: any | null, sort_display_mode: string, cma_agent_transactions: Array<{ id: string, transaction_id: string }>, cma_user_reviews: Array<{ id: string, review_id: string }> } | null };

export type UpdateCmaReportIncludeAgencyDescriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  include_agency_description: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportIncludeAgencyDescriptionMutation = { update_cma_reports_by_pk?: { id: string, include_agency_description: boolean, updated_at: any } | null };

export type GetCmaAgencyTeamMembersQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCmaAgencyTeamMembersQuery = { cma_reports_by_pk?: { id: string, agency_team_members?: any | null, broker?: { id: string, default_team?: { id: string, teams_users: Array<{ user_id: string, title?: string | null, user: { show_in_agency_pages?: boolean | null, id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } }> } | null } | null } | null };

export type UpdateCmaReportAgencyTeamMembersMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  agency_team_members: Scalars['jsonb']['input'];
}>;


export type UpdateCmaReportAgencyTeamMembersMutation = { update_cma_reports_by_pk?: { __typename: 'cma_reports', id: string, agency_team_members?: any | null, updated_at: any } | null };

export type CmaUserReviewDetailsFragment = { id: string, review_id: string, created_at: any, review: { id: string, display_name?: string | null, first_name?: string | null, last_name?: string | null, rating?: number | null, created_at: any, review_text?: string | null, is_seller: boolean, google_address?: { formatted_address?: string | null } | null, user?: { first_name?: string | null, last_name?: string | null } | null } };

export type GetCmaUserReviewsQueryVariables = Exact<{
  cmaReportId: Scalars['uuid']['input'];
}>;


export type GetCmaUserReviewsQuery = { cma_reports_by_pk?: { id: string, cma_user_reviews: Array<{ id: string, review_id: string, created_at: any, review: { id: string, display_name?: string | null, first_name?: string | null, last_name?: string | null, rating?: number | null, created_at: any, review_text?: string | null, is_seller: boolean, google_address?: { formatted_address?: string | null } | null, user?: { first_name?: string | null, last_name?: string | null } | null } }> } | null };

export type DeleteCmaUserReviewMutationVariables = Exact<{
  cmaReportId: Scalars['uuid']['input'];
  reviewId: Scalars['uuid']['input'];
}>;


export type DeleteCmaUserReviewMutation = { delete_cma_reports_user_reviews?: { affected_rows: number } | null, update_cma_reports_by_pk?: { id: string, updated_at: any, cma_user_reviews: Array<{ id: string, review_id: string }> } | null };

export type InsertCmaUserReviewMutationVariables = Exact<{
  cmaReportId: Scalars['uuid']['input'];
  reviewId: Scalars['uuid']['input'];
}>;


export type InsertCmaUserReviewMutation = { insert_cma_reports_user_reviews_one?: { id: string, cma_report_id: string, review_id: string } | null, update_cma_reports_by_pk?: { id: string, updated_at: any, cma_user_reviews: Array<{ id: string, review_id: string }> } | null };

export type GetCmaBrokerReviewsPaginatedQueryVariables = Exact<{
  brokerId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetCmaBrokerReviewsPaginatedQuery = { reviews: Array<{ id: string, display_name?: string | null, first_name?: string | null, last_name?: string | null, rating?: number | null, created_at: any, review_text?: string | null, is_seller: boolean, google_address?: { formatted_address?: string | null } | null, user?: { first_name?: string | null, last_name?: string | null } | null }> };

export type UpdateCmaReportComparablesShowFullIdxDescriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  show_full_idx_description: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportComparablesShowFullIdxDescriptionMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, show_full_idx_description: boolean } | null };

export type UpdateCmaReportIncludeComparableListingDetailsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  include_comparable_listing_details: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportIncludeComparableListingDetailsMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_comparable_listing_details: boolean } | null };

export type UpdateCmaReportShowComparableListingCardsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  show_comparable_listing_cards: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportShowComparableListingCardsMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, show_comparable_listing_cards: boolean } | null };

export type UpdateCmaReportIncludeRentalComparableListingDetailsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  include_rental_comparable_listing_details: Scalars['Boolean']['input'];
}>;


export type UpdateCmaReportIncludeRentalComparableListingDetailsMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, include_rental_comparable_listing_details: boolean } | null };

export type StateByCoordinatesQueryVariables = Exact<{
  point: Scalars['geometry']['input'];
  isCh: Scalars['Boolean']['input'];
  isFr: Scalars['Boolean']['input'];
  isEs: Scalars['Boolean']['input'];
  isIt: Scalars['Boolean']['input'];
  isPl: Scalars['Boolean']['input'];
  isPt: Scalars['Boolean']['input'];
}>;


export type StateByCoordinatesQuery = { ch_places?: Array<{ id: string, name: string }>, fr_places?: Array<{ id: string, name: string }>, es_places?: Array<{ id: string, name: string }>, it_places?: Array<{ id: string, name: string }>, pl_places?: Array<{ id: string, name: string }>, pt_places?: Array<{ id: string, name: string }> };

export type GetCmaTourReportQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetCmaTourReportQuery = { own: Array<{ id: string }>, visible: Array<{ id: string }> };

export type RentalPreviewFixtureQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RentalPreviewFixtureQuery = { cma_reports_by_pk?: { id: string, include_rental_comparables: boolean, rental_comparables: any } | null };

export type RentalStepFixtureQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RentalStepFixtureQuery = { cma_reports_by_pk?: { id: string } | null };

export type StepRentalListingsFragment = { id: string, rental_comparables: any, rental_comparables_search_params: any, is_property_comparable_listings_square_meter_calculation?: boolean | null, include_rental_comparable_listing_details: boolean, rental_comparable_listings_map_zoom_level?: number | null, show_full_rental_description: boolean, show_rental_comparable_listing_cards: boolean, property: { id: string, lat?: number | null, lng?: number | null, computed_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, property_type?: { name?: string | null, main_type?: string | null } | null, latest_appraisal?: { id: string, rent_value?: number | null } | null } };

export type RentalCmaListingsQueryVariables = Exact<{
  chWhere: Ch_Cma_Rental_Listings_Bool_Exp;
  esWhere: Es_Cma_Rental_Listings_Bool_Exp;
  frWhere: Fr_Cma_Rental_Listings_Bool_Exp;
  itWhere: It_Cma_Rental_Listings_Bool_Exp;
  plWhere: Pl_Cma_Rental_Listings_Bool_Exp;
  ptWhere: Pt_Cma_Rental_Listings_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
  pl: Scalars['Boolean']['input'];
  pt: Scalars['Boolean']['input'];
}>;


export type RentalCmaListingsQuery = { ch_cma_rental_listings?: Array<{ id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> }>, es_cma_rental_listings?: Array<{ id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> }>, fr_cma_rental_listings?: Array<{ id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> }>, it_cma_rental_listings?: Array<{ id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> }>, pl_cma_rental_listings?: Array<{ id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> }>, pt_cma_rental_listings?: Array<{ id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> }> };

export type RentalCmaListingChFragment = { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> };

export type RentalCmaListingEsFragment = { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> };

export type RentalCmaListingFrFragment = { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> };

export type RentalCmaListingItFragment = { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> };

export type RentalCmaListingPlFragment = { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> };

export type RentalCmaListingPtFragment = { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> };

export type RentalCmaCohortsQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  property_main_type: Scalars['String']['input'];
  computed_surface?: InputMaybe<Scalars['Float']['input']>;
  number_of_rooms?: InputMaybe<Scalars['Float']['input']>;
  rent_net_monthly?: InputMaybe<Scalars['Float']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
  pl: Scalars['Boolean']['input'];
  pt: Scalars['Boolean']['input'];
}>;


export type RentalCmaCohortsQuery = { ch_get_similar_rental_listings_cohorts?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, es_get_similar_rental_listings_cohorts?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, fr_get_similar_rental_listings_cohorts?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, it_get_similar_rental_listings_cohorts?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, pl_get_similar_rental_listings_cohorts?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, pt_get_similar_rental_listings_cohorts?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }> };

export type RentalCmaListingsCountQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  stateId?: InputMaybe<Scalars['uuid']['input']>;
  chWhere: Ch_Rental_Cma_Listings_Distance_Bool_Exp;
  esWhere: Es_Rental_Cma_Listings_Distance_Bool_Exp;
  frWhere: Fr_Rental_Cma_Listings_Distance_Bool_Exp;
  itWhere: It_Rental_Cma_Listings_Distance_Bool_Exp;
  plWhere: Pl_Rental_Cma_Listings_Distance_Bool_Exp;
  ptWhere: Pt_Rental_Cma_Listings_Distance_Bool_Exp;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
  pl: Scalars['Boolean']['input'];
  pt: Scalars['Boolean']['input'];
}>;


export type RentalCmaListingsCountQuery = { ch_get_rental_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, es_get_rental_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, fr_get_rental_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, it_get_rental_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, pl_get_rental_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null }, pt_get_rental_cma_listings_distance_aggregate?: { aggregate?: { count: number } | null } };

export type RentalCmaManualListingsQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  stateId?: InputMaybe<Scalars['uuid']['input']>;
  chWhere: Ch_Rental_Cma_Listings_Distance_Bool_Exp;
  esWhere: Es_Rental_Cma_Listings_Distance_Bool_Exp;
  frWhere: Fr_Rental_Cma_Listings_Distance_Bool_Exp;
  itWhere: It_Rental_Cma_Listings_Distance_Bool_Exp;
  plWhere: Pl_Rental_Cma_Listings_Distance_Bool_Exp;
  ptWhere: Pt_Rental_Cma_Listings_Distance_Bool_Exp;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
  pl: Scalars['Boolean']['input'];
  pt: Scalars['Boolean']['input'];
}>;


export type RentalCmaManualListingsQuery = { ch_get_rental_cma_listings_distance?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, es_get_rental_cma_listings_distance?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, fr_get_rental_cma_listings_distance?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, it_get_rental_cma_listings_distance?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, pl_get_rental_cma_listings_distance?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }>, pt_get_rental_cma_listings_distance?: Array<{ listing_id?: number | null, distance_in_meters?: number | null, listing?: { id: number, address?: string | null, locality?: string | null, computed_surface?: number | null, number_of_rooms?: number | null, rent_net_monthly?: number | null, gross_rent_monthly?: number | null, property_type: string, valid_from: any, offline_since?: any | null, agency_name?: string | null, description?: string | null, title?: string | null, created_at: any, geog?: any | null, url: string, property_main_type: string, living_surface?: number | null, land_surface?: number | null, floor_of_flat?: number | null, construction_year?: number | null, renovation_year?: number | null, number_of_bedrooms?: number | null, number_of_bathrooms?: number | null, number_of_toilets?: number | null, number_of_indoor_parkings?: number | null, number_of_outdoor_parkings?: number | null, has_view?: boolean | null, has_cellar?: boolean | null, has_elevator?: boolean | null, has_fireplace?: boolean | null, has_storage_room?: boolean | null, has_swimming_pool?: boolean | null, is_child_friendly?: boolean | null, is_wheelchair_accessible?: boolean | null, is_new_development?: boolean | null, agency_contact_address?: string | null, agency_contact_person?: string | null, images: Array<{ id?: string | null, bucket_name?: string | null, file_name?: string | null }> } | null }> };

export type RentalCmaListingLookupQueryVariables = Exact<{
  chWhere: Ch_Cma_Rental_Listings_Bool_Exp;
  esWhere: Es_Cma_Rental_Listings_Bool_Exp;
  frWhere: Fr_Cma_Rental_Listings_Bool_Exp;
  itWhere: It_Cma_Rental_Listings_Bool_Exp;
  plWhere: Pl_Cma_Rental_Listings_Bool_Exp;
  ptWhere: Pt_Cma_Rental_Listings_Bool_Exp;
  limit: Scalars['Int']['input'];
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
  pl: Scalars['Boolean']['input'];
  pt: Scalars['Boolean']['input'];
}>;


export type RentalCmaListingLookupQuery = { ch_cma_rental_listings?: Array<{ id: number }>, es_cma_rental_listings?: Array<{ id: number }>, fr_cma_rental_listings?: Array<{ id: number }>, it_cma_rental_listings?: Array<{ id: number }>, pl_cma_rental_listings?: Array<{ id: number }>, pt_cma_rental_listings?: Array<{ id: number }> };

export type UpdateRentalComparablesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  rental_comparables: Scalars['jsonb']['input'];
}>;


export type UpdateRentalComparablesMutation = { update_cma_reports_by_pk?: { __typename: 'cma_reports', id: string, rental_comparables: any, updated_at: any } | null };

export type UpdateRentalComparableListingsMapZoomLevelMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  rental_comparable_listings_map_zoom_level?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateRentalComparableListingsMapZoomLevelMutation = { update_cma_reports_by_pk?: { id: string, rental_comparable_listings_map_zoom_level?: number | null, updated_at: any } | null };

export type UpdateRentalShowFullDescriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  show_full_rental_description: Scalars['Boolean']['input'];
}>;


export type UpdateRentalShowFullDescriptionMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, show_full_rental_description: boolean } | null };

export type UpdateRentalShowComparableListingCardsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  show_rental_comparable_listing_cards: Scalars['Boolean']['input'];
}>;


export type UpdateRentalShowComparableListingCardsMutation = { update_cma_reports_by_pk?: { id: string, updated_at: any, show_rental_comparable_listing_cards: boolean } | null };

export type UpdateRentalComparablesSearchParamsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  rental_comparables_search_params: Scalars['jsonb']['input'];
}>;


export type UpdateRentalComparablesSearchParamsMutation = { update_cma_reports_by_pk?: { id: string, rental_comparables_search_params: any, updated_at: any } | null };

export type DeletePropertyPoiMutationVariables = Exact<{
  propertyPoiId: Scalars['uuid']['input'];
}>;


export type DeletePropertyPoiMutation = { delete_property_pois_by_pk?: { id: string } | null };

export type GetPoiTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPoiTypesQuery = { dictionaries: Array<{ id: string, name: string, label?: string | null, types?: Array<string> | null }> };

export type GetAutoPoisMutationVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
}>;


export type GetAutoPoisMutation = { auto_search_pois: boolean };

export type GetManualPoisMutationVariables = Exact<{
  propertyId: Scalars['uuid']['input'];
  search: Scalars['String']['input'];
}>;


export type GetManualPoisMutation = { manual_search_pois: Array<{ id: string, name: string, formattedAddress: string, distance: number, types: Array<string>, category: string, latitude: number, longitude: number, primaryType: string }> };

export type InsertPoiMutationVariables = Exact<{
  input: InsertPoisOneInput;
}>;


export type InsertPoiMutation = { insert_pois_one: boolean };

export type ReportPropertyImageFragment = { id: string, order_nr: number, title?: string | null, description?: string | null, size: string, crop: string, background_color: string, watermarked_url?: string | null, image: { id: string, url?: string | null } };

export type TranslateTextQueryVariables = Exact<{
  text: Scalars['String']['input'];
  target_language: Scalars['String']['input'];
}>;


export type TranslateTextQuery = { translate_text?: { text: string } | null };

export type ReviewDrawerFragment = { id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, display_name?: string | null, is_buyer: boolean, formatted_address: string, transaction_date: any, owner_answer?: string | null, owner_answer_date?: any | null, user?: { id: string, agent_slug?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type GetReviewReplyTourReviewQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetReviewReplyTourReviewQuery = { unanswered: Array<{ id: string }>, any: Array<{ id: string }>, visible: Array<{ id: string }> };

export type GetReviewsQueryVariables = Exact<{
  where?: InputMaybe<Reviews_Bool_Exp>;
  orderBy?: InputMaybe<Array<Reviews_Order_By> | Reviews_Order_By>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetReviewsQuery = { reviews: Array<{ id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, formatted_address: string, is_buyer: boolean, transaction_date: any, property_transaction?: { id: string, property: { id: string, street_number?: string | null, route?: string | null, locality?: string | null, postcode?: string | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }> };

export type GetReviewsCountQueryVariables = Exact<{
  where?: InputMaybe<Reviews_Bool_Exp>;
}>;


export type GetReviewsCountQuery = { reviews_aggregate: { aggregate?: { count: number } | null } };

export type DeleteReviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteReviewMutation = { delete_reviews_by_pk?: { id: string } | null };

export type GetReviewQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetReviewQuery = { reviews_by_pk?: { id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, display_name?: string | null, is_buyer: boolean, formatted_address: string, transaction_date: any, owner_answer?: string | null, owner_answer_date?: any | null, user?: { id: string, agent_slug?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null };

export type UpdateReviewMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  review?: InputMaybe<Reviews_Set_Input>;
}>;


export type UpdateReviewMutation = { update_reviews_by_pk?: { id: string, completed_at?: any | null, created_at: any, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, display_name?: string | null, is_buyer: boolean, formatted_address: string, transaction_date: any, owner_answer?: string | null, owner_answer_date?: any | null, user?: { id: string, agent_slug?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, default_team?: { id: string, name: string } | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null };

export type UpdateReviewAnswerMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  answer?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateReviewAnswerMutation = { update_reviews_by_pk?: { id: string, owner_answer?: string | null, owner_answer_date?: any | null } | null };

export type GetTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantsQuery = { tenants: Array<{ id: string, name: string, slug: string }> };

export type CreateApiKeyMutationVariables = Exact<{
  partnerName: Scalars['String']['input'];
  partnerRole: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type CreateApiKeyMutation = { create_key?: { PartnerID: string, PartnerApiKey?: string | null } | null };

export type DeleteApiKeyMutationVariables = Exact<{
  partnerId: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { delete_key?: { rowsDeleted?: string | null, message?: string | null } | null };

export type DeleteLegacyApiKeyMutationVariables = Exact<{
  partnerId: Scalars['String']['input'];
}>;


export type DeleteLegacyApiKeyMutation = { delete_legacy_key?: { rowsDeleted?: string | null, message?: string | null } | null };

export type UpdateApiKeyMutationVariables = Exact<{
  partnerId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  partnerRole: Scalars['String']['input'];
}>;


export type UpdateApiKeyMutation = { update_key?: { PartnerID: string, PartnerName: string, PartnerTeamsIds?: Array<string> | null, PartnerRole: string } | null };

export type UpdateLegacyApiKeyMutationVariables = Exact<{
  partnerId: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  partnerTeamsIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  partnerRole: Scalars['String']['input'];
}>;


export type UpdateLegacyApiKeyMutation = { update_legacy_key?: { PartnerID: string, PartnerName: string, PartnerTeamsIds: Array<string>, PartnerRole: string, PartnerTenantId: string, KeyPrefix: string } | null };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { get_api_keys?: Array<{ PartnerID: string, PartnerName: string, PartnerRole: string, PartnerTeamsIds?: Array<string> | null, PartnerTenantId: string, OwnerUserId?: string | null, OwnerName?: string | null, KeyPrefix?: string | null, CreatedAt?: any | null, ExpiresAt?: any | null, RevokedAt?: any | null, LastUsedAt?: any | null }> | null };

export type GetLegacyApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLegacyApiKeysQuery = { get_legacy_api_keys?: Array<{ PartnerID: string, PartnerName: string, PartnerRole: string, PartnerTeamsIds: Array<string>, PartnerTenantId: string, KeyPrefix: string }> | null };

export type GetLegacyApiKeyQueryVariables = Exact<{
  partnerId: Scalars['String']['input'];
}>;


export type GetLegacyApiKeyQuery = { get_legacy_api_key?: { PartnerID: string, PartnerName: string, PartnerRole: string, PartnerTeamsIds: Array<string>, PartnerTenantId: string, KeyPrefix: string } | null };

export type GetApiKeyQueryVariables = Exact<{
  partnerId: Scalars['String']['input'];
}>;


export type GetApiKeyQuery = { get_api_key?: { PartnerID: string, PartnerName: string, PartnerRole: string, PartnerTeamsIds?: Array<string> | null, PartnerTenantId: string, OwnerUserId?: string | null, OwnerName?: string | null, KeyPrefix?: string | null, CreatedAt?: any | null, ExpiresAt?: any | null, RevokedAt?: any | null, LastUsedAt?: any | null } | null };

export type GetTeamMlsSettingsPageQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamMlsSettingsPageQuery = { settings: Array<{ id: string, team_id: string, tenant_id: string, auto_publish_shared_listings?: boolean | null }> };

export type UpdateTeamMlsSettingsPageMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
  autoPublishSharedListings?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTeamMlsSettingsPageMutation = { insert_mls_settings_one?: { id: string, team_id: string, auto_publish_shared_listings?: boolean | null } | null };

export type LeadStageFieldsFragment = { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string };

export type LeadStagesQueryVariables = Exact<{
  pipelineId: Scalars['uuid']['input'];
}>;


export type LeadStagesQuery = { lead_stages: Array<{ id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string }> };

export type UpdatePipelineLeadStageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  lead_stage: Lead_Stages_Set_Input;
}>;


export type UpdatePipelineLeadStageMutation = { update_lead_stages_by_pk?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string } | null };

export type ReorderLeadStagesMutationVariables = Exact<{
  pipelineId: Scalars['uuid']['input'];
  leadStageId: Scalars['uuid']['input'];
  starting_position: Scalars['Int']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type ReorderLeadStagesMutation = { temp?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string } | null, down?: { returning: Array<{ id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string }> } | null, up?: { returning: Array<{ id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string }> } | null, final?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string } | null };

export type CreateLeadStageMutationVariables = Exact<{
  stage: Lead_Stages_Insert_Input;
}>;


export type CreateLeadStageMutation = { insert_lead_stages_one?: { id: string, name?: string | null, status: Leads_Status_Enum, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, order_nr: number, pipeline_id: string } | null };

export type DeleteLeadStageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteLeadStageMutation = { delete_lead_stages_by_pk?: { id: string } | null };

export type PipelineFragmentFragment = { id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, lead_type: any };

export type GetPipelinesListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPipelinesListQuery = { pipelines: Array<{ id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, lead_type: any, stages_aggregate: { aggregate?: { count: number } | null } }>, pipelines_aggregate: { aggregate?: { count: number } | null } };

export type GetPipelineQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPipelineQuery = { pipelines_by_pk?: { id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, lead_type: any } | null };

export type DeletePipelineMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePipelineMutation = { delete_pipelines_by_pk?: { id: string } | null };

export type UpsertPipelineMutationVariables = Exact<{
  pipeline: Pipelines_Insert_Input;
}>;


export type UpsertPipelineMutation = { insert_pipelines_one?: { id: string, created_at: any, updated_at: any, name?: string | null, label?: string | null, label_fr?: string | null, label_en?: string | null, label_de?: string | null, label_es?: string | null, label_it?: string | null, label_pl?: string | null, label_pt?: string | null, lead_type: any } | null };

export type TenantSettingsFragmentFragment = { id: string, name: string, logo_image_id?: string | null, main_color: string, default_pipeline_id: string, email_template?: any | null, phone_main: string, email_sender_name: string, email_sender_email: string, google_tag_manager_id: string, stripe_secret_key?: string | null, stripe_webhook_secret?: string | null, stripe_secret_key_test?: string | null, stripe_webhook_secret_test?: string | null, close_api_key?: string | null, debug_email_mode: boolean, ai_feed_summary_prompt?: string | null, route: string, street_number: string, postcode: string, locality: string, state: string, country?: string | null, google_place_description?: string | null, country_code: string, lng?: number | null, lat?: number | null, google_place_id?: string | null, image?: { id: string, url?: string | null } | null };

export type GetTenantSettingsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTenantSettingsQuery = { tenants_by_pk?: { id: string, name: string, logo_image_id?: string | null, main_color: string, default_pipeline_id: string, email_template?: any | null, phone_main: string, email_sender_name: string, email_sender_email: string, google_tag_manager_id: string, stripe_secret_key?: string | null, stripe_webhook_secret?: string | null, stripe_secret_key_test?: string | null, stripe_webhook_secret_test?: string | null, close_api_key?: string | null, debug_email_mode: boolean, ai_feed_summary_prompt?: string | null, route: string, street_number: string, postcode: string, locality: string, state: string, country?: string | null, google_place_description?: string | null, country_code: string, lng?: number | null, lat?: number | null, google_place_id?: string | null, image?: { id: string, url?: string | null } | null } | null, pipelines: Array<{ id: string, name?: string | null, label?: string | null, lead_type: any, stages_aggregate: { aggregate?: { count: number } | null } }>, available_email_templates: Array<{ value?: any | null }> };

export type GetTenantContactSettingsQueryVariables = Exact<{
  tenantId: Scalars['uuid']['input'];
}>;


export type GetTenantContactSettingsQuery = { prospection_contact_settings_by_pk?: { tenant_id: string, weekly_limit: number } | null };

export type UpsertTenantContactSettingsMutationVariables = Exact<{
  tenantId: Scalars['uuid']['input'];
  weeklyLimit: Scalars['Int']['input'];
}>;


export type UpsertTenantContactSettingsMutation = { insert_prospection_contact_settings_one?: { tenant_id: string, weekly_limit: number } | null };

export type ClearTeamContactLimitOverridesMutationVariables = Exact<{
  tenantId: Scalars['uuid']['input'];
  weeklyLimit: Scalars['Int']['input'];
}>;


export type ClearTeamContactLimitOverridesMutation = { update_prospection_contact_teams?: { affected_rows: number } | null };

export type UpdateTenantSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  tenant: Tenants_Set_Input;
}>;


export type UpdateTenantSettingsMutation = { update_tenants_by_pk?: { id: string, name: string, logo_image_id?: string | null, main_color: string, default_pipeline_id: string, email_template?: any | null, phone_main: string, email_sender_name: string, email_sender_email: string, google_tag_manager_id: string, stripe_secret_key?: string | null, stripe_webhook_secret?: string | null, stripe_secret_key_test?: string | null, stripe_webhook_secret_test?: string | null, close_api_key?: string | null, debug_email_mode: boolean, ai_feed_summary_prompt?: string | null, route: string, street_number: string, postcode: string, locality: string, state: string, country?: string | null, google_place_description?: string | null, country_code: string, lng?: number | null, lat?: number | null, google_place_id?: string | null, image?: { id: string, url?: string | null } | null } | null };

export type WebhookDrawerEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type WebhookDrawerEventTypesQuery = { webhook_event_types_enum: Array<{ value: string, comment?: string | null }>, dictionaries: Array<{ name: string, label?: string | null }> };

export type WebhookDrawerByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type WebhookDrawerByIdQuery = { webhook_subscriptions_by_pk?: { id: string, title?: string | null, url: string, event_types: Array<{ event_type: string }> } | null };

export type ValidateWebhookUrlMutationVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type ValidateWebhookUrlMutation = { validate_webhook_url?: { valid: boolean, reason?: string | null } | null };

export type InsertWebhookSubscriptionMutationVariables = Exact<{
  object: Webhook_Subscriptions_Insert_Input;
}>;


export type InsertWebhookSubscriptionMutation = { insert_webhook_subscriptions_one?: { id: string } | null };

export type UpdateWebhookSubscriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Webhook_Subscriptions_Set_Input;
  event_types: Array<Webhook_Subscriptions_Event_Types_Insert_Input> | Webhook_Subscriptions_Event_Types_Insert_Input;
}>;


export type UpdateWebhookSubscriptionMutation = { delete_webhook_subscriptions_event_types?: { affected_rows: number } | null, insert_webhook_subscriptions_event_types?: { affected_rows: number } | null, update_webhook_subscriptions_by_pk?: { id: string, title?: string | null, url: string, active: boolean } | null };

export type WebhookSubscriptionsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type WebhookSubscriptionsPageQuery = { webhook_subscriptions: Array<{ id: string, title?: string | null, url: string, active: boolean, success_counter: number, event_types: Array<{ event_type: string }> }>, dictionaries: Array<{ name: string, label?: string | null }> };

export type ToggleWebhookActiveMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type ToggleWebhookActiveMutation = { update_webhook_subscriptions_by_pk?: { id: string, active: boolean } | null };

export type DeleteWebhookSubscriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteWebhookSubscriptionMutation = { delete_webhook_subscriptions_by_pk?: { id: string } | null };

export type TestWebhookMutationVariables = Exact<{
  subscription_id: Scalars['uuid']['input'];
}>;


export type TestWebhookMutation = { test_webhook?: { results: Array<{ event_type: string, success: boolean, status_code?: number | null, error?: string | null }> } | null };

export type InvoiceFragmentFragment = { id: string, stripe_id: string, created?: any | null, status: any, period_start?: any | null, period_end?: any | null, amount_due?: number | null, amount_paid?: number | null, lines?: any | null };

export type GetSubscriptionsListQueryVariables = Exact<{
  where: Subscriptions_Bool_Exp;
  order_by?: InputMaybe<Array<Subscriptions_Order_By> | Subscriptions_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetSubscriptionsListQuery = { subscriptions: Array<{ id: string, stripe_id: string, created_at: any, updated_at: any, start_date: any, current_period_start: any, current_period_end: any, customer_email?: string | null, customer: string, status: any, total_amount: number, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, broker_leads_aggregate: { aggregate?: { count: number } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } }> };

export type GetSubscriptionsListCountQueryVariables = Exact<{
  where: Subscriptions_Bool_Exp;
}>;


export type GetSubscriptionsListCountQuery = { subscriptions_aggregate: { aggregate?: { count: number } | null } };

export type GetSubscriptionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetSubscriptionQuery = { subscriptions_by_pk?: { id: string, stripe_id: string, created_at: any, updated_at: any, start_date: any, current_period_start: any, current_period_end: any, customer_email?: string | null, customer: string, status: any, total_amount: number, user_id?: string | null, user?: { id: string, full_name?: string | null, broker_leads_aggregate: { aggregate?: { count: number } | null } } | null, invoices: Array<{ id: string, stripe_id: string, created?: any | null, status: any, period_start?: any | null, period_end?: any | null, amount_due?: number | null, amount_paid?: number | null, lines?: any | null }>, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type UpdateSubscriptionMutation = { update_subscriptions_by_pk?: { id: string, user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, broker_leads_aggregate: { aggregate?: { count: number } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null } | null };

export type GetTeamReviewsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamReviewsQuery = { teams_by_pk?: { id: string, last_review_scraping?: any | null, google_place_description?: string | null, google_reviews: Array<{ id: string, updated_at: any, google_timestamp: any, rating: number, review_text?: string | null, original_review_text?: string | null, profile_name: string, profile_url: string, review_url: string, profile_image_url: string, owner_answer?: string | null }>, google_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } | null };

export type ScrapeReviewsMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type ScrapeReviewsMutation = { scrape_google_reviews?: { status_message?: string | null, status_code?: number | null, tasks?: any | null } | null };

export type DeleteReviewsMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type DeleteReviewsMutation = { delete_google_reviews?: { affected_rows: number } | null };

export type TeamProspectionContactConfigQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type TeamProspectionContactConfigQuery = { teams_by_pk?: { id: string, tenant_id: string } | null, prospection_contact_teams_by_pk?: { team_id: string, tenant_id: string, enabled: boolean, weekly_limit?: number | null, counter_reset_at?: any | null, note?: string | null, updated_at: any } | null, prospection_contact_settings: Array<{ tenant_id: string, weekly_limit: number }> };

export type TeamProspectionContactUsageQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
}>;


export type TeamProspectionContactUsageQuery = { prospection_map_contact_attempts_aggregate: { aggregate?: { count: number } | null } };

export type UpsertTeamProspectionContactMutationVariables = Exact<{
  object: Prospection_Contact_Teams_Insert_Input;
}>;


export type UpsertTeamProspectionContactMutation = { insert_prospection_contact_teams_one?: { team_id: string, enabled: boolean, weekly_limit?: number | null, counter_reset_at?: any | null, note?: string | null } | null };

export type TeamCombinedReviewsAggFragment = { combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } };

export type GetTeamPortalsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamPortalsQuery = { portals: Array<{ id: string, name?: string | null, active: boolean, quota?: number | null, type: Portals_Types_Enum_Enum, portal_listings_aggregate: { aggregate?: { count: number } | null } }>, teams_portals: Array<{ id: string, portal: { id: string, name?: string | null, active: boolean, quota?: number | null, type: Portals_Types_Enum_Enum } }>, portal_listings: Array<{ portal: { id: string } }> };

export type DeleteTeamPortalMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamPortalMutation = { delete_teams_portals_by_pk?: { portal_id: string, team_id: string } | null };

export type TeamAddressFragment = { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null };

export type TeamAddress_LightFragment = { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null };

export type GetTeamsListQueryVariables = Exact<{
  where: Teams_Bool_Exp;
  order_by: Array<Teams_Order_By> | Teams_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetTeamsListQuery = { teams: Array<{ id: string, created_at: any, name: string, lat?: number | null, lng?: number | null, show_in_agency_pages?: boolean | null, agency_slug?: string | null, google_place_description?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, google_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, logo?: { id: string, url?: string | null } | null, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, organisation_images: Array<{ image: { url?: string | null } }> } | null, teams_users: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, subscriptions: Array<{ status: any, total_amount: number }>, lead_agents_aggregate: { aggregate?: { count: number } | null } } }>, property_transactions_aggregate: { aggregate?: { count: number, max?: { updated_at?: any | null } | null } | null }, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } }> };

export type GetTeamsListCountQueryVariables = Exact<{
  where: Teams_Bool_Exp;
}>;


export type GetTeamsListCountQuery = { teams_aggregate: { aggregate?: { count: number } | null } };

export type DrawerGetTeamQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DrawerGetTeamQuery = { teams_by_pk?: { id: string, created_at: any, name: string, teams_users_aggregate: { nodes: Array<{ user_id: string }> } } | null };

export type OverviewGetTeamQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeSubscriptions: Scalars['Boolean']['input'];
}>;


export type OverviewGetTeamQuery = { teams_by_pk?: { id: string, created_at: any, name: string, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, teams_users: Array<{ created_at: any, is_leader: boolean, title?: string | null, deactivated: boolean, order_nr: number, user: { id: string, is_broker: boolean, is_admin: boolean, first_name?: string | null, last_name?: string | null, full_name?: string | null, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, subscriptions?: Array<{ total_amount: number, status: any, current_period_start: any, current_period_end: any, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } }>, broker_leads_aggregate: { aggregate?: { count: number } | null }, lots_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { sum?: { purchase_price?: number | null } | null } | null }, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, combined_reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } | null };

export type CreateTeamMutationVariables = Exact<{
  team: Teams_Insert_Input;
}>;


export type CreateTeamMutation = { insert_teams_one?: { id: string } | null };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  userIdsString?: InputMaybe<Scalars['_uuid']['input']>;
}>;


export type DeleteTeamMutation = { delete_teams_by_pk?: { id: string } | null, update_users?: { returning: Array<{ default_team_id?: string | null }> } | null, delete_teams_users?: { affected_rows: number } | null, disable_broker?: { returning: Array<{ is_broker: boolean }> } | null, set_default_team: Array<{ id: string }> };

export type DeleteTeamUserMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type DeleteTeamUserMutation = { update_users?: { returning: Array<{ default_team_id?: string | null, teams_users: Array<{ deactivated: boolean, team: { id: string } }> }> } | null, delete_teams_users?: { affected_rows: number } | null, disable_broker?: { returning: Array<{ is_broker: boolean }> } | null };

export type AddTeamUserMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
}>;


export type AddTeamUserMutation = { set_default_team_id?: { returning: Array<{ default_team_id?: string | null }> } | null, insert_teams_users_one?: { team: { id: string }, user: { id: string } } | null, reset_onboarding?: { affected_rows: number } | null, enable_broker?: { returning: Array<{ is_broker: boolean }> } | null };

export type UpdateTeamUserOrderMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  user_id: Scalars['uuid']['input'];
  target_position: Scalars['Int']['input'];
}>;


export type UpdateTeamUserOrderMutation = { update_teams_users?: { affected_rows: number, returning: Array<{ user_id: string, order_nr: number }> } | null };

export type UpdateTeamUserMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
  team_user: Teams_Users_Set_Input;
}>;


export type UpdateTeamUserMutation = { update_teams_users?: { returning: Array<{ is_leader: boolean }> } | null, enable_broker?: { returning: Array<{ is_broker: boolean, default_team_id?: string | null, teams_users: Array<{ deactivated: boolean, team: { id: string } }> }> } | null, disable_broker?: { returning: Array<{ is_broker: boolean }> } | null };

export type TeamsCardQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type TeamsCardQuery = { users: Array<{ default_team_id?: string | null, teams_users: Array<{ deactivated: boolean, is_leader: boolean, team: { id: string, name: string } }> }> };

export type TeamsCardUpdateUserDefaultTeamMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
}>;


export type TeamsCardUpdateUserDefaultTeamMutation = { update_users?: { returning: Array<{ default_team_id?: string | null }> } | null };

export type DeleteTeamImageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamImageMutation = { delete_team_images_by_pk?: { id: string } | null };

export type TeamSettingsFragmentFragment = { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, copy_reviews_to_google: boolean, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, top_listings: boolean, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, share_transactions_in_cma?: boolean | null, lots_member_access: Lots_Member_Access_Enum_Enum, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, tiktok_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, x_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, phone_numbers: Array<{ id: string, number: string, type?: Phone_Number_Type_Enum_Enum | null, primary?: boolean | null }>, emails: Array<{ id: string, email: string }> };

export type GetTeamSettingsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTeamSettingsQuery = { teams_by_pk?: { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, copy_reviews_to_google: boolean, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, top_listings: boolean, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, share_transactions_in_cma?: boolean | null, lots_member_access: Lots_Member_Access_Enum_Enum, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, tiktok_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, x_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, phone_numbers: Array<{ id: string, number: string, type?: Phone_Number_Type_Enum_Enum | null, primary?: boolean | null }>, emails: Array<{ id: string, email: string }> } | null };

export type UpdateTeamSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  team: Teams_Set_Input;
}>;


export type UpdateTeamSettingsMutation = { update_teams_by_pk?: { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, copy_reviews_to_google: boolean, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, top_listings: boolean, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, share_transactions_in_cma?: boolean | null, lots_member_access: Lots_Member_Access_Enum_Enum, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, tiktok_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, x_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, phone_numbers: Array<{ id: string, number: string, type?: Phone_Number_Type_Enum_Enum | null, primary?: boolean | null }>, emails: Array<{ id: string, email: string }> } | null };

export type UpsertTeamEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  email: Scalars['citext']['input'];
}>;


export type UpsertTeamEmailMutation = { delete_emails?: { affected_rows: number } | null, insert_emails_one?: { id: string, email: string } | null };

export type DeleteTeamEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamEmailMutation = { delete_emails?: { affected_rows: number } | null };

export type UpdateTeamPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  phone_numbers: Array<Phone_Numbers_Insert_Input> | Phone_Numbers_Insert_Input;
}>;


export type UpdateTeamPhoneNumberMutation = { delete_phone_numbers?: { affected_rows: number } | null, insert_phone_numbers?: { returning: Array<{ id: string, number: string, type?: Phone_Number_Type_Enum_Enum | null, primary?: boolean | null }> } | null };

export type DeleteTeamPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTeamPhoneNumberMutation = { delete_phone_numbers?: { affected_rows: number } | null };

export type UpdateTeamPrimaryPhoneNumberMutationVariables = Exact<{
  team_id: Scalars['uuid']['input'];
  number: Scalars['String']['input'];
}>;


export type UpdateTeamPrimaryPhoneNumberMutation = { delete_phone_numbers?: { affected_rows: number } | null, insert_phone_numbers_one?: { id: string, number: string, type?: Phone_Number_Type_Enum_Enum | null, primary?: boolean | null } | null };

export type UpdateTeamImagesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  team: Teams_Set_Input;
}>;


export type UpdateTeamImagesMutation = { update_teams_by_pk?: { id: string, branding_color?: string | null, created_at: any, created_by?: string | null, name: string, description?: string | null, website_url?: string | null, do_follow_link?: boolean | null, legal_name?: string | null, agency_slug?: string | null, copy_reviews_to_google: boolean, idx_agency_id?: string | null, idx_ftp_client_id?: string | null, top_listings: boolean, show_in_agency_pages?: boolean | null, hide_exact_address: boolean, share_transactions_in_cma?: boolean | null, lots_member_access: Lots_Member_Access_Enum_Enum, active_since?: number | null, country_code?: string | null, lat?: number | null, lng?: number | null, google_place_id?: string | null, google_place_description?: string | null, organisation_id?: string | null, facebook_url?: string | null, instagram_url?: string | null, tiktok_url?: string | null, youtube_url?: string | null, linkedin_url?: string | null, x_url?: string | null, listings_agency_names?: Array<string> | null, enquiry_email_contact?: string | null, use_json_for_enquiry_emails: boolean, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, phone_numbers: Array<{ id: string, number: string, type?: Phone_Number_Type_Enum_Enum | null, primary?: boolean | null }>, emails: Array<{ id: string, email: string }> } | null };

export type GetTeamValuationRequestsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetTeamValuationRequestsQuery = { lead_agents: Array<{ id: string, created_at: any, user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> }, lead: { id: string, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, anonymized_contact?: string | null, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, phone_numbers: Array<{ id: string, number: string }>, emails: Array<{ id: string, email: string }> } | null, lead_agents: Array<{ id: string, claimed_at?: any | null, user_id: string }> } }> };

export type GetTeamContactRequestsQueryVariables = Exact<{
  contactRequestsWhere: Enquiries_Bool_Exp;
}>;


export type GetTeamContactRequestsQuery = { enquiries: Array<{ id: string, created_at: any, contact_reason?: string | null, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, message?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property_transaction?: { signature_date?: any | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null } } | null }> };

export type CheckProxyPhoneNumberQueryVariables = Exact<{
  number: Scalars['String']['input'];
  currentTeamId: Scalars['uuid']['input'];
}>;


export type CheckProxyPhoneNumberQuery = { teams: Array<{ id: string, name: string }> };

export type GetCreateTransactionDataQueryVariables = Exact<{
  includeListing: Scalars['Boolean']['input'];
  includeOffer: Scalars['Boolean']['input'];
  offerId?: InputMaybe<Scalars['uuid']['input']>;
  listingId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetCreateTransactionDataQuery = { lots?: Array<{ id: string, broker_id?: string | null, mandate_type?: string | null, title?: string | null, status: Lots_Status_Enum_Enum, hide_price_on_portals: boolean, shared_on_mls_at?: any | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, broker?: { id: string, default_team_id?: string | null, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, last_accepted_offer?: Array<{ id: string, amount: number, buyer_id: string }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null }, sellers: Array<{ lot_id: string, user_id: string, seller: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> }>, property_types: Array<{ id: string, name?: string | null, label?: string | null, main_type?: string | null, composite_type?: string | null, type: string }> };

export type GetLinkedListingIdsForTeamsQueryVariables = Exact<{
  teamIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetLinkedListingIdsForTeamsQuery = { property_transactions_listings: Array<{ listing_id: number }> };

export type GetPropertyTransactionsQueryVariables = Exact<{
  where: Property_Transactions_Bool_Exp;
  order_by?: InputMaybe<Array<Property_Transactions_Order_By> | Property_Transactions_Order_By>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  team_ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  includeValuations?: Scalars['Boolean']['input'];
}>;


export type GetPropertyTransactionsQuery = { property_transactions: Array<{ id: string, is_published: boolean, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, reviews: Array<{ id: string, is_buyer: boolean }>, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, property: { living_surface?: number | null, built_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { id: string, label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, commissions: Array<{ id: string, is_paid?: boolean | null, amount?: number | null }>, lot?: { id: string, currency?: string | null } | null, sellers: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, buyers: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }>, commissions_aggregate: { aggregate?: { sum?: { amount?: number | null } | null } | null }, my_commissions: { aggregate?: { sum?: { amount?: number | null } | null } | null }, transaction_valuations_aggregate?: { aggregate?: { count: number } | null } }> };

export type GetPropertyTransactionsListCountQueryVariables = Exact<{
  where: Property_Transactions_Bool_Exp;
}>;


export type GetPropertyTransactionsListCountQuery = { property_transactions_aggregate: { aggregate?: { count: number } | null } };

export type GetDuplicateTransactionsQueryVariables = Exact<{
  route?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDuplicateTransactionsQuery = { property_transactions: Array<{ id: string, purchase_price?: number | null, signature_date?: any | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null }, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null } | null }> };

export type TransactionDrawerGetTransactionQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TransactionDrawerGetTransactionQuery = { property_transactions_by_pk?: { id: string, lot_id?: string | null, property_id: string, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, created_by?: string | null, mls_share?: { id: string, team_id: string } | null } | null };

export type DeleteTransactionMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteTransactionMutation = { delete_property_transactions_by_pk?: { id: string } | null };

export type TransactionFormFragmentFragment = { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, updated_at?: any | null, reviewed_at?: any | null, reviewed_by?: string | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null, sellers: Array<{ transaction_id: string, user_id: string }>, buyers: Array<{ transaction_id: string, user_id: string }> };

export type TransactionCommissionsFormFragmentFragment = { id: string, purchase_price?: number | null, commissions: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null }>, lot?: { id: string, currency?: string | null, mandate_type?: string | null, property: { id: string, country_code?: string | null } } | null };

export type TransactionFormQueryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TransactionFormQueryQuery = { property_transactions_by_pk?: { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, updated_at?: any | null, reviewed_at?: any | null, reviewed_by?: string | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null, sellers: Array<{ transaction_id: string, user_id: string }>, buyers: Array<{ transaction_id: string, user_id: string }> } | null };

export type UpdateTransactionReviewedAtMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  reviewed_at: Scalars['timestamptz']['input'];
  reviewed_by: Scalars['uuid']['input'];
}>;


export type UpdateTransactionReviewedAtMutation = { update_property_transactions_by_pk?: { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, updated_at?: any | null, reviewed_at?: any | null, reviewed_by?: string | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null, sellers: Array<{ transaction_id: string, user_id: string }>, buyers: Array<{ transaction_id: string, user_id: string }> } | null };

export type TransactionFormUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  transaction: Property_Transactions_Set_Input;
  sellers: Array<Transaction_Sellers_Insert_Input> | Transaction_Sellers_Insert_Input;
  buyers: Array<Transaction_Buyers_Insert_Input> | Transaction_Buyers_Insert_Input;
}>;


export type TransactionFormUpdateMutation = { update_property_transactions_by_pk?: { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, updated_at?: any | null, reviewed_at?: any | null, reviewed_by?: string | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null, sellers: Array<{ transaction_id: string, user_id: string }>, buyers: Array<{ transaction_id: string, user_id: string }> } | null, delete_transaction_buyers?: { returning: Array<{ transaction_id: string, user_id: string }> } | null, delete_transaction_sellers?: { returning: Array<{ transaction_id: string, user_id: string }> } | null, insert_transaction_buyers?: { returning: Array<{ transaction_id: string, user_id: string }> } | null, insert_transaction_sellers?: { returning: Array<{ transaction_id: string, user_id: string }> } | null };

export type TransactionCommissionsFormUpdateMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  commissions: Array<Commissions_Insert_Input> | Commissions_Insert_Input;
}>;


export type TransactionCommissionsFormUpdateMutation = { delete_commissions?: { returning: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null, property_transaction_id?: string | null }> } | null, insert_commissions?: { returning: Array<{ id: string, type?: string | null, amount?: number | null, vat?: number | null, contact_id?: string | null, beneficiary_team_id?: string | null, property_transaction_id?: string | null }> } | null };

export type CreateTransactionMutationVariables = Exact<{
  transaction: Property_Transactions_Insert_Input;
}>;


export type CreateTransactionMutation = { insert_property_transactions_one?: { id: string, created_by?: string | null, created_at?: any | null, signature_date?: any | null, updated_at?: any | null, reviewed_at?: any | null, reviewed_by?: string | null, buyer_broker_id?: string | null, seller_broker_id?: string | null, buyer_broker_team_id?: string | null, seller_broker_team_id?: string | null, estimated_signature_date?: any | null, payment_date?: any | null, purchase_price?: number | null, is_published: boolean, lot_id?: string | null, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, property: { id: string }, buyers: Array<{ user_id: string, transaction_id: string }>, sellers: Array<{ user_id: string, transaction_id: string }>, lot?: { id: string, currency?: string | null, property: { id: string, country_code?: string | null } } | null } | null };

export type GetUserDefaultTeamIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserDefaultTeamIdQuery = { users_by_pk?: { default_team_id?: string | null, teams_users: Array<{ team_id: string }> } | null };

export type GetTransactionDocumentsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTransactionDocumentsQuery = { property_transactions_by_pk?: { id: string, property: { id: string, property_files: Array<{ property_id: string, file_id: string, is_visible: boolean, display_on_listing: boolean, order_nr: number, file: { id: string, name: string, url: string, mimetype?: string | null, created_at: any, uploader?: { id: string, first_name?: string | null, last_name?: string | null } | null, document_type?: { id: string, name: string, label?: string | null } | null } }> } } | null };

export type GetTransactionPropertyQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetTransactionPropertyQuery = { property_transactions_by_pk?: { id: string, purchase_price?: number | null, signature_date?: any | null, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }>, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, living_surface?: number | null, land_surface?: number | null, number_of_rooms?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null };

export type DeletePropertyTransactionListingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  listingId: Scalars['Int']['input'];
}>;


export type DeletePropertyTransactionListingMutation = { delete_property_transactions_listings?: { affected_rows: number, returning: Array<{ property_transaction_id: string, listing_id: number }> } | null };

export type GetLinkedListingsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  ch: Scalars['Boolean']['input'];
  es: Scalars['Boolean']['input'];
  fr: Scalars['Boolean']['input'];
  it: Scalars['Boolean']['input'];
}>;


export type GetLinkedListingsQuery = { ch_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, fr_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, es_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }>, it_cma_listings?: Array<{ id: number, number_of_rooms?: number | null, number_of_bathrooms?: number | null, computed_surface?: number | null, land_surface?: number | null, sale_price?: number | null, computed_price_per_sqm?: number | null, offline_since?: any | null, created_at: any, valid_from: any, country_code?: string | null, address?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state_id: string, visit_contact_person?: string | null, agency_contact_person?: string | null, agency_name?: string | null, property_type: string, places?: Array<{ id: string, label?: string | null }> | null, images: Array<{ id?: string | null, file_name?: string | null, bucket_name?: string | null }> }> };

export type InsertPropertyTransactionListingsMutationVariables = Exact<{
  objects: Array<Property_Transactions_Listings_Insert_Input> | Property_Transactions_Listings_Insert_Input;
}>;


export type InsertPropertyTransactionListingsMutation = { insert_property_transactions_listings?: { returning: Array<{ property_transaction_id: string, listing_id: number, property_transaction: { id: string, property_transactions_listings: Array<{ property_transaction_id: string, listing_id: number }> } }> } | null };

export type GetTransactionValuationsQueryVariables = Exact<{
  transactionId: Scalars['uuid']['input'];
}>;


export type GetTransactionValuationsQuery = { transaction_valuations: Array<{ lead_id?: string | null, first_name?: string | null, last_name?: string | null, created_at?: any | null, requalified_at?: any | null, appraisal_perception?: string | null, appraisal_perceived_value?: number | null, postcode?: string | null, locality?: string | null, route?: string | null, street_number?: string | null, appraisal_min?: number | null, appraisal_max?: number | null, appraisal_reason?: string | null, lead?: { sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, property?: { property_type?: { main_type?: string | null, label?: string | null, composite_type?: string | null, main_type_object?: { label?: string | null } | null, composite_type_object?: { label?: string | null } | null } | null } | null } | null }> };

export type TransactionCreationFragmentFragment = { id: string, created_at?: any | null, updated_at?: any | null, seller_broker_id?: string | null, buyer_broker_id?: string | null, seller_broker_team_id?: string | null, buyer_broker_team_id?: string | null, purchase_price?: number | null, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, property_id: string, property: { id: string, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, state_id?: string | null, country?: string | null, lat?: number | null, lng?: number | null, property_type_id?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null, main_type_object?: { label?: string | null } | null } | null, property_images: Array<{ id: string, image_id: string, image: { id: string, url?: string | null } }> }, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null };

export type CreateTransactionWithPropertyMutationVariables = Exact<{
  transaction: Property_Transactions_Insert_Input;
}>;


export type CreateTransactionWithPropertyMutation = { insert_property_transactions_one?: { id: string, created_at?: any | null, updated_at?: any | null, seller_broker_id?: string | null, buyer_broker_id?: string | null, seller_broker_team_id?: string | null, buyer_broker_team_id?: string | null, purchase_price?: number | null, signature_date?: any | null, estimated_signature_date?: any | null, payment_date?: any | null, property_id: string, property: { id: string, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, state_id?: string | null, country?: string | null, lat?: number | null, lng?: number | null, property_type_id?: string | null, number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, land_surface?: number | null, built_surface?: number | null, usable_surface?: number | null, property_type?: { id: string, label?: string | null, main_type?: string | null, main_type_object?: { label?: string | null } | null } | null, property_images: Array<{ id: string, image_id: string, image: { id: string, url?: string | null } }> }, seller_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, buyer_broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null, buyer_broker_team?: { id: string, name: string, locality?: string | null, state?: string | null, postcode?: string | null, logo?: { id: string, url?: string | null } | null } | null } | null };

export type AddPropertyImageMutationVariables = Exact<{
  property_image: Property_Images_Insert_Input;
}>;


export type AddPropertyImageMutation = { insert_property_images_one?: { id: string, property_id: string, image_id: string, image: { id: string, url?: string | null } } | null };

export type BulkPublishTransactionsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type BulkPublishTransactionsMutation = { update_property_transactions?: { affected_rows: number, returning: Array<{ id: string, is_published: boolean }> } | null };

export type BulkUnpublishTransactionsMutationVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type BulkUnpublishTransactionsMutation = { update_property_transactions?: { affected_rows: number, returning: Array<{ id: string, is_published: boolean }> } | null };

export type GetBrokerAndTeamNamesQueryVariables = Exact<{
  broker_id: Scalars['uuid']['input'];
  team_id: Scalars['uuid']['input'];
  include_team: Scalars['Boolean']['input'];
}>;


export type GetBrokerAndTeamNamesQuery = { broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null, team?: { id: string, name: string } | null };

export type RestoreUserMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RestoreUserMutation = { update_users_by_pk?: { id: string, is_deleted?: boolean | null } | null };

export type GetCatchmentAreaQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetCatchmentAreaQuery = { users_by_pk?: { catchment_areas: Array<{ place: { id: string, postcode?: string | null, population?: number | null, lat: number, lng: number } }> } | null };

export type SetCatchmentAreaMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  objects: Array<Catchment_Areas_Insert_Input> | Catchment_Areas_Insert_Input;
}>;


export type SetCatchmentAreaMutation = { delete_catchment_areas?: { affected_rows: number } | null, insert_catchment_areas?: { affected_rows: number } | null };

export type GetUserSubscriptionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserSubscriptionsQuery = { users_by_pk?: { id: string, subscriptions: Array<{ id: string, total_amount: number, status: any, created?: any | null, current_period_start: any, current_period_end: any, invoices: Array<{ id: string, stripe_id: string, created?: any | null, status: any, period_start?: any | null, period_end?: any | null, amount_due?: number | null, amount_paid?: number | null, lines?: any | null }>, invoices_aggregate: { aggregate?: { sum?: { amount_paid?: number | null } | null } | null } }> } | null };

export type UserBuyerLeadActionToolbarBuyerLeadFragment = { id: string, stage_id?: string | null, user: { id: string, first_name?: string | null, emails: Array<{ id: string, email: string }> }, lot: { id: string, tenant_id: string, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, title?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null, property: { id: string, route?: string | null, locality?: string | null, postcode?: string | null, street_number?: string | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null, latest_appraisal?: { id: string, min?: number | null, max?: number | null, value?: number | null } | null } } };

export type UserBuyerLeadKanbanItemFragment = { id: string, stage_id?: string | null, order_nr: number, user_order_nr: number, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, lot: { id: string, title?: string | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } } };

export type ListingsMatchingFiltersPropertySearchesFragment = { id: string, offer_type?: string | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, property_types: Array<{ property_type: { id: string, name?: string | null, type: string, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }>, property_searches_places: Array<{ place_id: string }> };

export type GetListingsMatchingQueryVariables = Exact<{
  where: Lots_Bool_Exp;
  order_by: Array<Lots_Order_By> | Lots_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetListingsMatchingQuery = { lots: Array<{ id: string, status: Lots_Status_Enum_Enum, title?: string | null, lot_reference?: string | null, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, lots_status: { label?: string | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, last_enquiry: { aggregate?: { max?: { created_at?: any | null } | null } | null }, buyer_leads_aggregate: { aggregate?: { count: number } | null }, offers_aggregate: { aggregate?: { count: number } | null }, live_portals_count: { aggregate?: { count: number } | null }, property: { id: string, country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, computed_surface?: number | null, single_property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null } }> };

export type GetUserBuyersLeadQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserBuyersLeadQuery = { lead_stages: Array<{ id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum }>, buyer_leads: Array<{ id: string, stage_id?: string | null, order_nr: number, user_order_nr: number, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, lot: { id: string, title?: string | null, tenant_id: string, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null, price_per_living_surface_meter_squared?: number | null } | null, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null }, user: { id: string, first_name?: string | null, emails: Array<{ id: string, email: string }> } }>, property_searches: Array<{ id: string, offer_type?: string | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, property_types: Array<{ property_type: { id: string, name?: string | null, type: string, composite_type_object?: { id: string, label?: string | null, name?: string | null } | null } }>, property_searches_places: Array<{ place_id: string }> }> };

export type UpdateBuyerLeadUserStageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  updates: Buyer_Leads_Set_Input;
}>;


export type UpdateBuyerLeadUserStageMutation = { update_buyer_leads_by_pk?: { id: string, stage_id?: string | null, order_nr: number, user_order_nr: number, created_at: any, updated_at: any, lead_stage?: { id: string, status: Leads_Status_Enum } | null, next_activity: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, start_date?: string | null, due_at?: any | null, done: boolean, done_at?: any | null, success: boolean, subject?: string | null, note?: string | null, consolidated_due_at?: any | null, consolidated_done_at?: any | null }>, lot: { id: string, title?: string | null, tenant_id: string, offer_type?: string | null, sale_price?: number | null, price_unit?: string | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, hide_price_on_portals: boolean, lot_reference?: string | null, mandate_type?: string | null, brochure_doc_template_id?: string | null, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, state?: string | null, number_of_rooms?: number | null, living_surface?: number | null, land_surface?: number | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }>, latest_appraisal?: { id: string, min?: number | null, value?: number | null, max?: number | null, price_per_living_surface_meter_squared?: number | null } | null, municipality_place?: { id: string, label?: string | null } | null, property_type?: { id: string, label?: string | null } | null }, broker?: { id: string, first_name?: string | null, last_name?: string | null, gender?: string | null, title?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string }>, organisation?: { id: string, name?: string | null, street?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null } | null, lead?: { id: string, cma_reports: Array<{ id: string, doc_template_id?: string | null }> } | null }, user: { id: string, first_name?: string | null, emails: Array<{ id: string, email: string }> } } | null };

export type GetBuyerLeadsCardQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetBuyerLeadsCardQuery = { buyer_leads: Array<{ id: string, created_at: any, lead_stage?: { id: string, label?: string | null } | null, lot: { id: string, property: { street_number?: string | null, route?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } } }>, buyer_leads_aggregate: { aggregate?: { count: number } | null }, lead_stages: Array<{ id: string, name?: string | null, label?: string | null, status: Leads_Status_Enum }> };

export type GetLeadsCardQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  where: Leads_Bool_Exp;
}>;


export type GetLeadsCardQuery = { leads: Array<{ id: string, appraisal_reason: Leads_Appraisal_Reason_Enum, sale_horizon: Leads_Sale_Horizon_Enum, buy_horizon: Leads_Buy_Horizon_Enum, created_at: any, requalified_at?: any | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } | null, lead_agents: Array<{ id: string, lead_stage?: { id: string, label?: string | null, status: Leads_Status_Enum } | null }> }>, leads_aggregate: { aggregate?: { count: number } | null } };

export type GetUserSellerListingsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserSellerListingsQuery = { lots: Array<{ id: string, created_at: any, title?: string | null, status: Lots_Status_Enum_Enum, property: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, state?: string | null, country?: string | null } }>, lots_aggregate: { aggregate?: { count: number } | null } };

export type GetUserCreatorQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserCreatorQuery = { users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null };

export type GetUserPropertySearchesQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserPropertySearchesQuery = { property_searches: Array<{ id: string, created_at: any, updated_at: any, offer_type?: string | null, number_of_rooms_gte?: number | null, number_of_rooms_lte?: number | null, sale_price_lte?: number | null, sale_price_gte?: number | null, monthly_rent_lte?: number | null, monthly_rent_gte?: number | null, property_searches_places: Array<{ place: { id: string, name: string, label?: string | null } }> }> };

export type GetUsersListQueryVariables = Exact<{
  where: Users_Bool_Exp;
  order_by: Array<Users_Order_By> | Users_Order_By;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type GetUsersListQuery = { users: Array<{ id: string, created_at: any, first_name?: string | null, last_name?: string | null, onboarding_status?: User_Onboarding_Status_Enum_Enum | null, is_admin: boolean, is_broker: boolean, account_manager_id?: string | null, account_manager?: { id: string, full_name?: string | null } | null, user_images: Array<{ id: string, image: { url?: string | null } }>, emails: Array<{ primary: boolean, email: string }>, phone_numbers: Array<{ primary?: boolean | null, number: string }> }> };

export type BulkReassignUserAccountManagerMutationVariables = Exact<{
  users: Scalars['jsonb']['input'];
  newAccountManagerId: Scalars['uuid']['input'];
  transferOpenActivities: Scalars['Boolean']['input'];
}>;


export type BulkReassignUserAccountManagerMutation = { bulk_reassign_user_account_manager: Array<{ id: string, account_manager_id?: string | null, account_manager?: { id: string, full_name?: string | null } | null }> };

export type GetUsersListCountQueryVariables = Exact<{
  where: Users_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUsersListCountQuery = { users_aggregate: { aggregate?: { count: number } | null } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  includeSubscriptions: Scalars['Boolean']['input'];
}>;


export type GetUserQuery = { users_by_pk?: { id: string, is_deleted?: boolean | null, onboarding_status?: User_Onboarding_Status_Enum_Enum | null, has_done_onboarding: boolean, membership_type?: string | null, full_name?: string | null, language?: any | null, referrer?: string | null, referring_domain?: string | null, landing_page_url?: string | null, created_at: any, created_by?: string | null, home_address_route?: string | null, home_address_street_number?: string | null, home_address_postcode?: string | null, home_address_locality?: string | null, home_address_state?: string | null, home_address_country_code?: string | null, home_address_lat?: number | null, home_address_lng?: number | null, default_team_id?: string | null, auto_assign_leads?: boolean | null, first_name?: string | null, last_name?: string | null, is_broker: boolean, is_admin: boolean, has_free_crm_access: boolean, can_edit_settings?: boolean | null, can_user_login_as: boolean, agent_slug?: string | null, show_in_agency_pages?: boolean | null, user_images: Array<{ image: { id: string, url?: string | null } }>, teams_users: Array<{ is_leader: boolean, deactivated: boolean, team: { id: string, name: string } }>, default_team?: { id: string, name: string } | null, broker?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, account_manager?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, phone_numbers: Array<{ id: string, primary?: boolean | null, number: string, type?: Phone_Number_Type_Enum_Enum | null, verified?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, subscription_emails?: Array<{ subscriptions: Array<{ id: string, total_amount: number, status: any, created?: any | null, current_period_start: any, current_period_end: any, items: any, customer: string, plan_name?: string | null }> }>, module_grants: Array<{ module_id: Modules_Enum_Enum }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean, verified: boolean }> } | null };

export type UserSettingsFragmentFragment = { id: string, first_name?: string | null, last_name?: string | null, is_broker: boolean, is_admin: boolean, has_free_crm_access: boolean, can_edit_settings?: boolean | null, can_user_login_as: boolean, agent_slug?: string | null, show_in_agency_pages?: boolean | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  user: Users_Set_Input;
}>;


export type UpdateUserSettingsMutation = { update_users_by_pk?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, is_broker: boolean, is_admin: boolean, has_free_crm_access: boolean, can_edit_settings?: boolean | null, can_user_login_as: boolean, agent_slug?: string | null, show_in_agency_pages?: boolean | null } | null };

export type ApproveUserOnboardingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ApproveUserOnboardingMutation = { update_users?: { affected_rows: number, returning: Array<{ id: string, onboarding_status?: User_Onboarding_Status_Enum_Enum | null }> } | null };

export type SkipUserOnboardingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  reason: User_Onboarding_Skip_Reason_Enum_Enum;
}>;


export type SkipUserOnboardingMutation = { update_users?: { affected_rows: number, returning: Array<{ id: string, onboarding_status?: User_Onboarding_Status_Enum_Enum | null }> } | null };

export type GetUserOnboardingHistoryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserOnboardingHistoryQuery = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_at: any, created_by?: string | null, extra_data?: any | null, creator?: { id: string, full_name?: string | null } | null }>, users_by_pk?: { id: string, onboarding_skip_reason?: User_Onboarding_Skip_Reason_Enum_Enum | null } | null };

export type UpdateUserPermissionFlagsMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  can_edit_settings?: InputMaybe<Scalars['Boolean']['input']>;
  can_user_login_as?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserPermissionFlagsMutation = { update_user_permission_flags?: { id: string } | null };

export type GetUsersForMergeQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetUsersForMergeQuery = { users: Array<{ id: string, first_name?: string | null, last_name?: string | null, is_broker: boolean, is_admin: boolean, date_of_birth?: string | null, gender?: string | null, broker_id?: string | null, broker?: { id: string, first_name?: string | null, last_name?: string | null } | null, emails: Array<{ id: string, email: string }> }> };

export type MergeUserMutationVariables = Exact<{
  left_user_id: Scalars['uuid']['input'];
  right_user_id: Scalars['uuid']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  is_broker?: InputMaybe<Scalars['Boolean']['input']>;
  is_admin?: InputMaybe<Scalars['Boolean']['input']>;
  date_of_birth?: InputMaybe<Scalars['date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  broker_id?: InputMaybe<Scalars['uuid']['input']>;
  primary_email?: InputMaybe<Scalars['String']['input']>;
  resolve_enquiries?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MergeUserMutation = { merge_user?: { id: string } | null };

export type DeleteUserMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
}>;


export type DeleteUserMutation = { delete_user?: { id: string } | null };

export type InsertUsersMutationVariables = Exact<{
  users: Array<Users_Insert_Input> | Users_Insert_Input;
}>;


export type InsertUsersMutation = { insert_users?: { affected_rows: number } | null };

export type ImportUsersMutationVariables = Exact<{
  objects: Array<UserImportInput> | UserImportInput;
}>;


export type ImportUsersMutation = { import_users?: Array<{ label: string, skipped: boolean, skip_reason?: string | null }> | null };

export type ExportUsersQueryVariables = Exact<{
  where: Users_Bool_Exp;
}>;


export type ExportUsersQuery = { users: Array<{ id: string, first_name?: string | null, last_name?: string | null, created_at: any, emails: Array<{ email: string }>, phone_numbers: Array<{ number: string }> }> };

export type InsertUserEmailMutationVariables = Exact<{
  input: Emails_Insert_Input;
}>;


export type InsertUserEmailMutation = { insert_emails_one?: { id: string, email: string, primary: boolean, verified: boolean, user_id?: string | null } | null };

export type UpdateUserEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Emails_Set_Input;
}>;


export type UpdateUserEmailMutation = { update_emails_by_pk?: { id: string, email: string, primary: boolean, verified: boolean } | null };

export type DeleteUserEmailMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserEmailMutation = { delete_emails_by_pk?: { id: string } | null };

export type UpdatePrimaryUserEmailMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  email_id: Scalars['uuid']['input'];
}>;


export type UpdatePrimaryUserEmailMutation = { update_emails?: { affected_rows: number } | null, update_emails_by_pk?: { id: string, primary: boolean } | null };

export type InsertUserPhoneNumberMutationVariables = Exact<{
  input: Phone_Numbers_Insert_Input;
}>;


export type InsertUserPhoneNumberMutation = { insert_phone_numbers_one?: { id: string, number: string, primary?: boolean | null, verified?: boolean | null, user_id?: string | null } | null };

export type UpdateUserPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  set: Phone_Numbers_Set_Input;
}>;


export type UpdateUserPhoneNumberMutation = { update_phone_numbers_by_pk?: { id: string, number: string, primary?: boolean | null, verified?: boolean | null } | null };

export type DeleteUserPhoneNumberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteUserPhoneNumberMutation = { delete_phone_numbers_by_pk?: { id: string } | null };

export type GetUserProfileCompletionQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
}>;


export type GetUserProfileCompletionQuery = { users_by_pk?: { id: string, languages?: Array<string> | null, active_since?: number | null, description?: string | null, services?: Array<string> | null, user_images: Array<{ image: { id: string, url?: string | null } }>, transactions: { aggregate?: { count: number } | null }, reviews_aggregate: { aggregate?: { count: number } | null } } | null };

export type GetUserModuleGrantsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserModuleGrantsQuery = { users_by_pk?: { id: string, module_grants: Array<{ module_id: Modules_Enum_Enum }> } | null };

export type GetUserModuleHistoryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserModuleHistoryQuery = { users_by_pk?: { id: string, activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, created_by?: string | null, done_at?: any | null, extra_data?: any | null }>, module_grants: Array<{ module_id: Modules_Enum_Enum, granted_at?: any | null }> } | null };

export type GetModuleHistoryActorsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetModuleHistoryActorsQuery = { users: Array<{ id: string, full_name?: string | null, user_images: Array<{ image: { url?: string | null } }> }> };

export type SetUserModuleGrantMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  module: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetUserModuleGrantMutation = { set_user_module_grant: Array<{ id: string, module_grants: Array<{ module_id: Modules_Enum_Enum }> }> };

export type UpdateUserAutoAssignLeadsMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  autoAssignLeads?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserAutoAssignLeadsMutation = { update_users_by_pk?: { id: string, auto_assign_leads?: boolean | null } | null };

export type UpdateUserNameMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserNameMutation = { update_users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null };

export type UpdateUserLanguageMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  language?: InputMaybe<Scalars['user_language']['input']>;
}>;


export type UpdateUserLanguageMutation = { update_users_by_pk?: { id: string, language?: any | null } | null };

export type SetUserHomeAddressMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  user: Users_Set_Input;
}>;


export type SetUserHomeAddressMutation = { update_users_by_pk?: { id: string, home_address_route?: string | null, home_address_street_number?: string | null, home_address_postcode?: string | null, home_address_locality?: string | null, home_address_state?: string | null, home_address_country_code?: string | null, home_address_lat?: number | null, home_address_lng?: number | null } | null };

export type UpdatePrimaryUserPhoneNumberMutationVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  phone_id: Scalars['uuid']['input'];
}>;


export type UpdatePrimaryUserPhoneNumberMutation = { update_phone_numbers?: { affected_rows: number } | null, update_phone_numbers_by_pk?: { id: string, primary?: boolean | null } | null };

export type UserFeedV2QueryVariables = Exact<{
  user_id: Scalars['uuid']['input'];
  after_date?: InputMaybe<Scalars['timestamptz']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserFeedV2Query = { activities: Array<{ id: string, activity_type: Activity_Types_Enum_Enum, note?: string | null, extra_data?: any | null, lot_id?: string | null, buyer_lead_id?: string | null, enquiry_id?: string | null, user_id?: string | null, lead_id?: string | null, created_by?: string | null, created_at: any, due_at?: any | null, start_date?: string | null, pinned: boolean, visibility: string, subject?: string | null, success: boolean, done: boolean, consolidated_done_at?: any | null, assigned_to?: string | null, enquiry?: { message?: string | null, id: string, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null } | null, creator?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, assignee?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }> } | null, lead?: { id: string, created_at: any, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ image: { url?: string | null } }>, emails: Array<{ email: string }> } | null, property?: { route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, latest_appraisal?: { min?: number | null, max?: number | null } | null } | null, source: { id: string, name: string }, lead_agents: Array<{ user_id: string, claimed_at?: any | null, source?: Lead_Agent_Source_Enum_Enum | null }>, profile_contact?: { id?: string | null, full_name?: string | null, first_name?: string | null, last_name?: string | null, profile_image_url?: string | null } | null } | null, lot?: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } | null, buyer_lead?: { id: string, lot: { id: string, title?: string | null, created_at: any, offer_type?: string | null, sale_price?: number | null, rent_net?: number | null, rent_extra?: number | null, currency?: string | null, price_unit?: string | null, hide_price_on_portals: boolean, property: { id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, computed_surface?: number | null, latest_appraisal?: { id: string, value?: number | null, price_per_living_surface_meter_squared?: number | null } | null, property_images: Array<{ id: string, image: { id: string, url?: string | null } }> } } } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, is_broker: boolean } | null, email_message?: { to: any, cc: any, id: string, from: any, bcc: any, reply_to: any, is_sent: boolean, subject?: string | null, snippet?: string | null, message_id?: string | null, created_by?: string | null, date: any, email_messages_files: Array<{ nylas_file_id?: string | null, name?: string | null, size?: number | null, content_type?: string | null }> } | null, activities_target_users: Array<{ name?: string | null, email?: string | null, target_user_id?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null } | null }> }> };

export type GetUserDrawerTabCountsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  buyAppraisalReasons: Array<Leads_Appraisal_Reason_Enum> | Leads_Appraisal_Reason_Enum;
}>;


export type GetUserDrawerTabCountsQuery = { selling_leads: { aggregate?: { count: number } | null }, listings: { aggregate?: { count: number } | null }, buyer_leads: { aggregate?: { count: number } | null }, property_searches: { aggregate?: { count: number } | null } };

export type GetValuationLinkStatsQueryVariables = Exact<{
  where: Leads_Bool_Exp;
  agentId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  since: Scalars['timestamptz']['input'];
  chartSince: Scalars['timestamptz']['input'];
}>;


export type GetValuationLinkStatsQuery = { leads: Array<{ id: string, created_at: any }>, total: { aggregate?: { count: number } | null }, last30: { aggregate?: { count: number } | null }, won: { aggregate?: { count: number } | null }, lost: { aggregate?: { count: number } | null } };

export type GetAgentVisibilityProfileQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetAgentVisibilityProfileQuery = { users_by_pk?: { full_name?: string | null, agent_slug?: string | null, certifications?: Array<string> | null, facebook_profile?: string | null, instagram_profile?: string | null, tiktok_profile?: string | null, x_profile?: string | null, youtube_profile?: string | null, linked_in_profile?: string | null, id: string, first_name?: string | null, last_name?: string | null, display_name?: string | null, show_in_agency_pages?: boolean | null, description?: string | null, active_since?: number | null, languages?: Array<string> | null, services?: Array<string> | null, transactions: { aggregate?: { count: number } | null }, last_transaction: Array<{ signature_date?: any | null }>, latest_review: Array<{ completed_at?: any | null }>, teams_users: Array<{ title?: string | null, is_leader: boolean, deactivated: boolean, team: { id: string, name: string, agency_slug?: string | null, cover_photo?: { url?: string | null } | null, logo?: { url?: string | null } | null } }>, user_images: Array<{ image: { url?: string | null } }>, phone_numbers: Array<{ number: string }>, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, verified_reviews: { aggregate?: { count: number } | null } } | null };

export type GetAgentImpressionsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetAgentImpressionsQuery = { totals?: { count: number, user_count: number, average_position?: number | null } | null, profile_views?: { user_count: number } | null, phone_clicks?: { user_count: number } | null };

export type GetAgentProfileEngagementQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetAgentProfileEngagementQuery = { website_clicks?: { count: number } | null, social_clicks_by_platform?: { data?: Array<{ name?: string | null, count?: number | null }> | null } | null };

export type GetAgentResponseTimesQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
}>;


export type GetAgentResponseTimesQuery = { lead_agents: Array<{ id: string, created_at: any, claimed_at?: any | null }> };

export type GetAgentLeadAgentsByLeadIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type GetAgentLeadAgentsByLeadIdsQuery = { lead_agents: Array<{ id: string, lead_id: string, claimed_at?: any | null }> };

export type GetAgentContactsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
  enquiriesWhere: Enquiries_Bool_Exp;
}>;


export type GetAgentContactsQuery = { lead_agents_aggregate: { aggregate?: { count: number } | null }, enquiries_aggregate: { aggregate?: { count: number } | null }, profile_leads: { aggregate?: { count: number } | null } };

export type GetVisibilityV2MapDataQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  hostname: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetVisibilityV2MapDataQuery = { impressions?: { data?: Array<{ name?: string | null, count?: number | null, average_position?: number | null }> | null } | null };

export type GetPlacesBySlugsQueryVariables = Exact<{
  countryCode: Scalars['String']['input'];
  slugs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  teamLat: Scalars['Float']['input'];
  teamLng: Scalars['Float']['input'];
  maxDistanceMeters: Scalars['Float']['input'];
}>;


export type GetPlacesBySlugsQuery = { places: Array<{ id: string, type: Place_Type_Enum_Enum, name: string, label?: string | null, slug_en?: string | null, slug_fr?: string | null, slug_de?: string | null, slug_it?: string | null, slug_es?: string | null, slug_pl?: string | null, slug_pt?: string | null, postcode?: string | null, lat: number, lng: number, population?: number | null, state_id?: string | null, district_id?: string | null, municipality_id?: string | null, locality_id?: string | null, state?: { id: string, name: string, label?: string | null, slug_en?: string | null, slug_fr?: string | null, slug_de?: string | null, slug_it?: string | null, slug_es?: string | null, slug_pl?: string | null, slug_pt?: string | null } | null, district?: { id: string, name: string, label?: string | null, slug_en?: string | null, slug_fr?: string | null, slug_de?: string | null, slug_it?: string | null, slug_es?: string | null, slug_pl?: string | null, slug_pt?: string | null } | null, municipality?: { postcode?: string | null, id: string, name: string, label?: string | null, slug_en?: string | null, slug_fr?: string | null, slug_de?: string | null, slug_it?: string | null, slug_es?: string | null, slug_pl?: string | null, slug_pt?: string | null } | null, locality?: { postcode?: string | null, id: string, name: string, label?: string | null, slug_en?: string | null, slug_fr?: string | null, slug_de?: string | null, slug_it?: string | null, slug_es?: string | null, slug_pl?: string | null, slug_pt?: string | null } | null }> };

export type PlaceSlugFieldsFragment = { id: string, name: string, label?: string | null, slug_en?: string | null, slug_fr?: string | null, slug_de?: string | null, slug_it?: string | null, slug_es?: string | null, slug_pl?: string | null, slug_pt?: string | null };

export type GetTopLocationsUrlDataQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  hostname: Scalars['String']['input'];
  currentStartDate: Scalars['String']['input'];
  currentEndDate: Scalars['String']['input'];
  previousStartDate: Scalars['String']['input'];
  previousEndDate: Scalars['String']['input'];
}>;


export type GetTopLocationsUrlDataQuery = { team?: { lat?: number | null, lng?: number | null } | null, current_period?: { data?: Array<{ name?: string | null, count?: number | null, average_position?: number | null }> | null } | null, previous_period?: { data?: Array<{ name?: string | null, count?: number | null, average_position?: number | null }> | null } | null };

export type GetImpressionDotsV2QueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  userId?: InputMaybe<Scalars['uuid']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
}>;


export type GetImpressionDotsV2Query = { impression_dots?: { data?: Array<{ lead_id: string, lat: number, lng: number, postcode?: string | null, locality?: string | null, event_date?: string | null, position?: number | null, appraisal_reason?: string | null, relationship?: string | null, sale_horizon?: string | null, requalified_or_created_at?: string | null, agent_uuid?: string | null }> | null } | null };

export type VisibilityUserProfileFieldsFragment = { id: string, first_name?: string | null, last_name?: string | null, display_name?: string | null, show_in_agency_pages?: boolean | null, description?: string | null, active_since?: number | null, languages?: Array<string> | null, services?: Array<string> | null, user_images: Array<{ image: { url?: string | null } }>, phone_numbers: Array<{ number: string }>, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, verified_reviews: { aggregate?: { count: number } | null } };

export type VisibilityAgentProfileFieldsFragment = { full_name?: string | null, agent_slug?: string | null, certifications?: Array<string> | null, facebook_profile?: string | null, instagram_profile?: string | null, tiktok_profile?: string | null, x_profile?: string | null, youtube_profile?: string | null, linked_in_profile?: string | null, id: string, first_name?: string | null, last_name?: string | null, display_name?: string | null, show_in_agency_pages?: boolean | null, description?: string | null, active_since?: number | null, languages?: Array<string> | null, services?: Array<string> | null, user_images: Array<{ image: { url?: string | null } }>, phone_numbers: Array<{ number: string }>, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, verified_reviews: { aggregate?: { count: number } | null } };

export type VisibilityLeadAgentClaimFieldsFragment = { id: string, lead_id: string, claimed_at?: any | null };

export type VisibilityResponseTimeLeadAgentFieldsFragment = { id: string, created_at: any, claimed_at?: any | null };

export type GetLeadAgentsByLeadIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetLeadAgentsByLeadIdsQuery = { lead_agents: Array<{ user_id: string, id: string, lead_id: string, claimed_at?: any | null, user: { id: string, teams_users: Array<{ team_id: string }> } }>, accessible_leads: Array<{ id: string }> };

export type GetTeamResponseTimesQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
}>;


export type GetTeamResponseTimesQuery = { lead_agents: Array<{ id: string, created_at: any, claimed_at?: any | null }> };

export type GetVisibilityDashboardDataQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
  ownReviewsWhere: Reviews_Bool_Exp;
}>;


export type GetVisibilityDashboardDataQuery = { teams_by_pk?: { id: string, name: string, agency_slug?: string | null, show_in_agency_pages?: boolean | null, description?: string | null, website_url?: string | null, lat?: number | null, lng?: number | null, locality?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, state?: string | null, country?: string | null, active_since?: number | null, logo_image_id?: string | null, cover_photo_image_id?: string | null, idx_ftp_client_id?: string | null, idx_agency_id?: string | null, listings_agency_names?: Array<string> | null, logo?: { url?: string | null } | null, cover_photo?: { url?: string | null } | null, phone_numbers: Array<{ number: string }>, transactions: { aggregate?: { count: number } | null }, last_transaction: Array<{ signature_date?: any | null }>, teams_users: Array<{ title?: string | null, is_leader: boolean, user: { id: string, first_name?: string | null, last_name?: string | null, display_name?: string | null, show_in_agency_pages?: boolean | null, description?: string | null, active_since?: number | null, languages?: Array<string> | null, services?: Array<string> | null, transactions: { aggregate?: { count: number } | null }, user_images: Array<{ image: { url?: string | null } }>, phone_numbers: Array<{ number: string }>, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, verified_reviews: { aggregate?: { count: number } | null } } }> } | null, last_review: Array<{ completed_at?: any | null }>, own_reviews: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, own_verified_reviews: { aggregate?: { count: number } | null } };

export type GetTopCompetitorStatsQueryVariables = Exact<{
  competitorTeamIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetTopCompetitorStatsQuery = { get_top_competitor_stats?: { medianResponseMinutes?: number | null, profileCompletion?: number | null } | null };

export type GetDashboardContactClicksQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetDashboardContactClicksQuery = { phone_clicks_total?: { user_count: number } | null };

export type GetDashboardProfileEngagementQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetDashboardProfileEngagementQuery = { website_clicks_total?: { count: number } | null, social_clicks_by_platform?: { data?: Array<{ name?: string | null, count?: number | null }> | null } | null };

export type GetDashboardContactsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  since: Scalars['timestamptz']['input'];
  until: Scalars['timestamptz']['input'];
  enquiriesWhere: Enquiries_Bool_Exp;
}>;


export type GetDashboardContactsQuery = { lead_agents_aggregate: { aggregate?: { count: number } | null }, enquiries_aggregate: { aggregate?: { count: number } | null }, profile_leads: { aggregate?: { count: number } | null } };

export type GetNearbyImpressionsQueryVariables = Exact<{
  agencyUuids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  hostname: Scalars['String']['input'];
}>;


export type GetNearbyImpressionsQuery = { nearby_impressions?: { totals?: Array<{ agency_id: string, count: number, user_count: number, average_position?: number | null }> | null, by_locality?: Array<{ agency_id: string, name: string, count: number, average_position?: number | null }> | null, profile_views?: Array<{ agency_id: string, user_count: number }> | null } | null };

export type GetVisibilityInboxProfileLeadHistoryQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetVisibilityInboxProfileLeadHistoryQuery = { visibility_inbox_profile_lead_history: Array<{ anonymized_contact?: string | null, contact_reason?: string | null, created_at?: any | null, id?: string | null, recipient_name?: string | null }> };

export type GetVisibilityInboxQueryVariables = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
  contactRequestsWhere: Enquiries_Bool_Exp;
}>;


export type GetVisibilityInboxQuery = { visibility_inbox_lead_agents: Array<{ id?: string | null, created_at?: any | null, lead_id?: string | null, contact_reason?: string | null, lead?: { anonymized_contact?: string | null, appraisal_reason: Leads_Appraisal_Reason_Enum, created_by?: string | null, origin_enquiry_id?: string | null, contact?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, origin_enquiry?: { contact_reason?: string | null, message?: string | null, id: string, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null } | null, lead_agents: Array<{ id: string, claimed_at?: any | null, passed_at?: any | null, user_id: string, user: { full_name?: string | null, teams_users: Array<{ team_id: string }> } }> } | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }>, enquiries: Array<{ id: string, created_at: any, updated_at: any, first_name?: string | null, last_name?: string | null, phone_number?: string | null, email_address?: string | null, contact_reason?: string | null, message?: string | null, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, broker?: { full_name?: string | null } | null, team?: { name: string } | null }> };

export type GetInboxMessageQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetInboxMessageQuery = { visibility_inbox_lead_agents: Array<{ id?: string | null, lead_id?: string | null }>, enquiries_by_pk?: { updated_at: any, id: string, created_at: any, first_name?: string | null, last_name?: string | null, email_address?: string | null, phone_number?: string | null, contact_reason?: string | null, message?: string | null, user?: { full_name?: string | null } | null, broker?: { full_name?: string | null } | null, team?: { name: string } | null, property_transaction?: { id: string, purchase_price?: number | null, signature_date?: any | null, property: { country_code?: string | null, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, living_surface?: number | null, built_surface?: number | null, number_of_rooms?: number | null, id: string, computed_surface?: number | null, land_surface?: number | null, lat?: number | null, lng?: number | null, property_type?: { name?: string | null, id: string, label?: string | null } | null, locality_place?: { id: string } | null, state_place?: { id: string } | null, cover_images: Array<{ id: string, image: { id: string, url?: string | null } }> }, seller_broker?: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null, seller_broker_team?: { id: string, name: string, listings_agency_names?: Array<string> | null } | null, property_transactions_listings: Array<{ listing_id: number }> } | null } | null };

export type VisibilityReviewFragment = { id: string, completed_at?: any | null, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null };

export type GetUserSlugQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserSlugQuery = { users_by_pk?: { id: string, agent_slug?: string | null, show_in_agency_pages?: boolean | null, first_name?: string | null, last_name?: string | null } | null };

export type GetVisibilityReviewsAggregateQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetVisibilityReviewsAggregateQuery = { teams_by_pk?: { id: string, teams_users: Array<{ user: { id: string, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null } } }> } | null };

export type GetVisibilityReviewsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<Reviews_Order_By> | Reviews_Order_By>;
}>;


export type GetVisibilityReviewsQuery = { reviews: Array<{ id: string, completed_at?: any | null, rating?: number | null, review_text?: string | null, first_name?: string | null, last_name?: string | null, email_address: string, user?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } | null }> };

export type GetVisibilityReviewsRowCountQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
}>;


export type GetVisibilityReviewsRowCountQuery = { reviews_aggregate: { aggregate?: { count: number } | null } };

export type GetReviewInvitationTemplateQueryVariables = Exact<{
  brokerId: Scalars['uuid']['input'];
  type: Review_Invitation_Type_Enum_Enum;
  language: Scalars['String']['input'];
}>;


export type GetReviewInvitationTemplateQuery = { review_invitation_templates: Array<{ id: string, broker_id: string, tenant_id: string, type: Review_Invitation_Type_Enum_Enum, language: string, message: string, created_at: any, updated_at: any }> };

export type UpsertReviewInvitationTemplateMutationVariables = Exact<{
  brokerId: Scalars['uuid']['input'];
  type: Review_Invitation_Type_Enum_Enum;
  language: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type UpsertReviewInvitationTemplateMutation = { insert_review_invitation_templates_one?: { id: string, broker_id: string, tenant_id: string, type: Review_Invitation_Type_Enum_Enum, language: string, message: string, created_at: any, updated_at: any } | null };

export type GetReviewsWidgetAgentsQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  publishedAgentsWhere: Teams_Users_Bool_Exp;
}>;


export type GetReviewsWidgetAgentsQuery = { teams_by_pk?: { id: string, show_in_agency_pages?: boolean | null, teams_users: Array<{ user: { id: string, full_name?: string | null, combined_reviews_aggregate: { aggregate?: { count: number } | null } } }> } | null };

export type GetImpressionsDrilldownQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  agentId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  pageTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetImpressionsDrilldownQuery = { drilldown?: { data?: Array<{ name?: string | null, count?: number | null, average_position?: number | null }> | null } | null };

export type GetTeamVisibilityStatsGraphQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  agencyUuids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  hostname?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTeamVisibilityStatsGraphQuery = { impressions_graph_data?: { data?: Array<{ name?: string | null, count?: number | null, average_position?: number | null }> | null } | null, views_by_first_seen?: { data?: Array<{ name?: string | null, user_count?: number | null }> | null } | null, views_total?: { user_count: number } | null, show_phone_number_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null }> | null } | null, show_phone_number_total?: { user_count: number } | null, impressions_by_locality?: { data?: Array<{ count?: number | null, average_position?: number | null }> | null } | null };

export type GetTeamVisibilityStatsListQueryVariables = Exact<{
  teamId?: InputMaybe<Scalars['uuid']['input']>;
  agentId?: InputMaybe<Scalars['uuid']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<ImpressionsGroupingColumn>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  hostname?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTeamVisibilityStatsListQuery = { list_data?: { data?: Array<{ name?: string | null, count?: number | null, user_count?: number | null, average_position?: number | null }> | null } | null };

export type GetTeamsRankingQueryVariables = Exact<{
  currentTeamId: Scalars['uuid']['input'];
}>;


export type GetTeamsRankingQuery = { get_teams_ranking_by_distance: Array<{ team_id: string, distance?: number | null, total_transactions: number, reviews_in_location?: number | null, latest_review_date?: any | null, latest_transaction_date?: any | null, transactions_in_location?: number | null, is_independent_agent?: boolean | null }> };

export type GetVisibilityTeamMembersQueryVariables = Exact<{
  teamId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
  teamReviewsWhere: Reviews_Bool_Exp;
}>;


export type GetVisibilityTeamMembersQuery = { team_reviews: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, teams_by_pk?: { id: string, name: string, teams_users: Array<{ user: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, display_name?: string | null, description?: string | null, active_since?: number | null, show_in_agency_pages?: boolean | null, languages?: Array<string> | null, services?: Array<string> | null, certifications?: Array<string> | null, facebook_profile?: string | null, instagram_profile?: string | null, tiktok_profile?: string | null, x_profile?: string | null, youtube_profile?: string | null, linked_in_profile?: string | null, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, user_images: Array<{ id: string, is_primary?: boolean | null, image: { id: string, url?: string | null } }>, reviews_aggregate: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, property_transactions_aggregate: { aggregate?: { count: number } | null }, last_2_years_property_transactions_aggregate: { aggregate?: { count: number } | null } } }> } | null };

export type GetAgentTeamSettingsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
}>;


export type GetAgentTeamSettingsQuery = { users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null, show_in_agency_pages?: boolean | null, default_team_id?: string | null, teams_users: Array<{ is_leader: boolean, title?: string | null, deactivated: boolean }> } | null, teams: Array<{ id: string, name: string }> };

export type GetTeamMemberDetailsQueryVariables = Exact<{
  userId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
  twoYearsAgo: Scalars['timestamptz']['input'];
}>;


export type GetTeamMemberDetailsQuery = { users_by_pk?: { id: string, first_name?: string | null, last_name?: string | null, full_name?: string | null, agent_slug?: string | null, show_in_agency_pages?: boolean | null, description?: string | null, active_since?: number | null, languages?: Array<string> | null, services?: Array<string> | null, default_team_id?: string | null, emails: Array<{ id: string, email: string, primary: boolean }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null }>, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, teams_users: Array<{ is_leader: boolean, title?: string | null, deactivated: boolean, team: { id: string, name: string, cover_photo?: { id: string, url?: string | null } | null } }>, all_reviews_count: { aggregate?: { count: number, avg?: { rating?: number | null } | null } | null }, verified_reviews_count: { aggregate?: { count: number } | null }, latest_review: Array<{ completed_at?: any | null }> } | null, last_transaction: Array<{ signature_date?: any | null }>, all_transactions_count: { aggregate?: { count: number } | null }, last_2_years_transactions: Array<{ purchase_price?: number | null }>, teams: Array<{ id: string, name: string }> };

export type CreateTeamInvitationMutationVariables = Exact<{
  invitation: Invitations_Insert_Input;
}>;


export type CreateTeamInvitationMutation = { insert_invitations_one?: { id: string } | null };

export type CheckExistingTeamMemberQueryVariables = Exact<{
  email: Scalars['citext']['input'];
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
}>;


export type CheckExistingTeamMemberQuery = { users: Array<{ id: string, first_name?: string | null, last_name?: string | null }> };

export type CheckExistingInvitationQueryVariables = Exact<{
  email: Scalars['citext']['input'];
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
}>;


export type CheckExistingInvitationQuery = { invitations_aggregate: { aggregate?: { count: number } | null } };

export type CancelExistingInvitationsMutationVariables = Exact<{
  email: Scalars['citext']['input'];
  teamId: Scalars['uuid']['input'];
  tenantId: Scalars['uuid']['input'];
}>;


export type CancelExistingInvitationsMutation = { update_invitations?: { affected_rows: number } | null };

export type PublishUserMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  agentSlug: Scalars['String']['input'];
}>;


export type PublishUserMutation = { update_users_by_pk?: { id: string, show_in_agency_pages?: boolean | null, agent_slug?: string | null } | null };

export type UnpublishUserMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UnpublishUserMutation = { update_users_by_pk?: { id: string, show_in_agency_pages?: boolean | null } | null };

export type UpdateTeamMemberSettingsMutationVariables = Exact<{
  userId: Scalars['uuid']['input'];
  teamId: Scalars['uuid']['input'];
  defaultTeamId?: InputMaybe<Scalars['uuid']['input']>;
  isLeader: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  deactivated: Scalars['Boolean']['input'];
}>;


export type UpdateTeamMemberSettingsMutation = { update_users_by_pk?: { id: string } | null, update_teams_users?: { affected_rows: number } | null };

export type GetVisibilityTransactionsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  startDate: Scalars['timestamptz']['input'];
  endDate: Scalars['timestamptz']['input'];
}>;


export type GetVisibilityTransactionsQuery = { teams: Array<{ id: string, name: string }>, property_transactions: Array<{ id: string, signature_date?: any | null, is_published: boolean, property: { number_of_rooms?: number | null, number_of_bedrooms?: number | null, living_surface?: number | null, id: string, route?: string | null, street_number?: string | null, postcode?: string | null, locality?: string | null, country_code?: string | null, property_type?: { label?: string | null } | null, property_images: Array<{ id: string, order_nr: number, image: { id: string, url?: string | null } }> }, seller_broker_team?: { id: string, name: string } | null, seller_broker?: { id: string, full_name?: string | null } | null, reviews: Array<{ id: string, is_buyer: boolean }> }>, teams_by_pk?: { id: string, created_at: any, name: string, cover_photo?: { id: string, url?: string | null } | null, logo?: { id: string, url?: string | null } | null, teams_users: Array<{ created_at: any, is_leader: boolean, title?: string | null, deactivated: boolean, order_nr: number, user: { id: string, full_name?: string | null, first_name?: string | null, last_name?: string | null, last_2_years_property_transactions_aggregate: { aggregate?: { count: number } | null }, property_transactions_aggregate: { aggregate?: { count: number } | null }, user_images: Array<{ id: string, image: { id: string, url?: string | null } }>, phone_numbers: Array<{ id: string, number: string, primary?: boolean | null, verified?: boolean | null }>, emails: Array<{ id: string, email: string, primary: boolean }> } }> } | null, team_transactions: { aggregate?: { count: number } | null } };

export const UserInputFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInput"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primaryImage"},"name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}}]}}]} as unknown as DocumentNode<UserInputFragment, unknown>;
export const UserActiveModuleGrantsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveModuleGrants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}}]}}]}}]} as unknown as DocumentNode<UserActiveModuleGrantsFragment, unknown>;
export const DocTemplateDefaultLinksFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<DocTemplateDefaultLinksFragment, unknown>;
export const BuyerLeadSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<BuyerLeadSelectFragment, unknown>;
export const DevelopmentSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentSelectFragment, unknown>;
export const EmailListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}}]} as unknown as DocumentNode<EmailListingFragment, unknown>;
export const OrganisationAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<OrganisationAddressFragment, unknown>;
export const EmailUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<EmailUserFragment, unknown>;
export const EmailPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<EmailPropertyFragment, unknown>;
export const EmailTemplateFormListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormListingFragment, unknown>;
export const EmailTemplateFormEnquiryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormEnquiryFragment, unknown>;
export const EmailTemplateFormBuyerLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormBuyerLeadFragment, unknown>;
export const EmailTemplateFormLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormLeadFragment, unknown>;
export const EmailTemplateFormLotSnippetDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormLotSnippetData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormLotSnippetDataFragment, unknown>;
export const LeadSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<LeadSelectFragment, unknown>;
export const LotCardCarousel_LotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardCarousel_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}}]}}]} as unknown as DocumentNode<LotCardCarousel_LotFragment, unknown>;
export const ListingPriceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<ListingPriceFragment, unknown>;
export const LightLotCardInfo_LotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<LightLotCardInfo_LotFragment, unknown>;
export const LotCardInfo_LotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}}]} as unknown as DocumentNode<LotCardInfo_LotFragment, unknown>;
export const LotSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<LotSelectFragment, unknown>;
export const PhoneNumberCard_Phone_NumberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<PhoneNumberCard_Phone_NumberFragment, unknown>;
export const TemplateSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<TemplateSelectFragment, unknown>;
export const TransactionCellFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCellFragment, unknown>;
export const TransactionSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TransactionSelectFragment, unknown>;
export const DevelopmentBuyerLeadsActionToolbarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentBuyerLeadsActionToolbar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"route"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<DevelopmentBuyerLeadsActionToolbarFragment, unknown>;
export const BuyerLeadDashboardActivityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}}]} as unknown as DocumentNode<BuyerLeadDashboardActivityFragment, unknown>;
export const UserAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UserAvatarFragment, unknown>;
export const UserCardDisplayNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserCardDisplayNameFragment, unknown>;
export const UserCard_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserCard_UserFragment, unknown>;
export const BuyerLeadDnDColumnFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<BuyerLeadDnDColumnFragment, unknown>;
export const EmailTemplateSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateSelectFragment, unknown>;
export const BuyerLeadEnquiryCardEnquiryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadEnquiryCardEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<BuyerLeadEnquiryCardEnquiryFragment, unknown>;
export const BuyerLeadStatusCard_BuyerLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadStatusCard_buyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]} as unknown as DocumentNode<BuyerLeadStatusCard_BuyerLeadFragment, unknown>;
export const ListingCreationAddressStepFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCreationAddressStepFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}}]}}]} as unknown as DocumentNode<ListingCreationAddressStepFragmentFragment, unknown>;
export const DevelopmentCellFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"main_image"},"name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentCellFragment, unknown>;
export const OrganisationCell_OrganisationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationCell_organisation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationCell_OrganisationFragment, unknown>;
export const UserInfo_EnquiryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_enquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}}]} as unknown as DocumentNode<UserInfo_EnquiryFragment, unknown>;
export const DictionarySelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionarySelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<DictionarySelectFragment, unknown>;
export const ActivityFiltersActivityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFiltersActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ActivityFiltersActivityFragment, unknown>;
export const NameLinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]} as unknown as DocumentNode<NameLinkFragment, unknown>;
export const ActivityTitleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]} as unknown as DocumentNode<ActivityTitleFragment, unknown>;
export const AssignmentStatusChipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}}]} as unknown as DocumentNode<AssignmentStatusChipFragment, unknown>;
export const DateTooltipContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}}]} as unknown as DocumentNode<DateTooltipContentFragment, unknown>;
export const ActivityItemHeaderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}}]} as unknown as DocumentNode<ActivityItemHeaderFragment, unknown>;
export const EmailActivityItemContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}}]} as unknown as DocumentNode<EmailActivityItemContentFragment, unknown>;
export const AssignmentActivityItemContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}}]} as unknown as DocumentNode<AssignmentActivityItemContentFragment, unknown>;
export const ChangeActivityItemContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}}]} as unknown as DocumentNode<ChangeActivityItemContentFragment, unknown>;
export const ActivityItemContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}}]} as unknown as DocumentNode<ActivityItemContentFragment, unknown>;
export const ActivityItemLeadSnippetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActivityItemLeadSnippetFragment, unknown>;
export const LotSnippetFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LotSnippetFieldsFragment, unknown>;
export const ActivityItemLotSnippetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActivityItemLotSnippetFragment, unknown>;
export const ActivityItemUserSnippetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]} as unknown as DocumentNode<ActivityItemUserSnippetFragment, unknown>;
export const ActivityItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLeadSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLotSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemUserSnippet"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]} as unknown as DocumentNode<ActivityItemFragment, unknown>;
export const ActivityFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"nylas_thread_id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<ActivityFieldsFragment, unknown>;
export const TeamFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<TeamFilterFragment, unknown>;
export const UserFilterFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UserFilterFragment, unknown>;
export const NewPropertyImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<NewPropertyImageFragment, unknown>;
export const DefaultBuyersMatchingFiltersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"country"},{"kind":"EnumValue","value":"region"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DefaultBuyersMatchingFiltersFragment, unknown>;
export const AutoMatchingFiltersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoMatchingFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"country"},{"kind":"EnumValue","value":"region"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AutoMatchingFiltersFragment, unknown>;
export const EmailTemplateFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplateFormFragment, unknown>;
export const EmailSenderFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}}]} as unknown as DocumentNode<EmailSenderFragment, unknown>;
export const ListingBuyersAutoMatchingEmailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyersAutoMatchingEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","alias":{"kind":"Name","value":"auto_matching_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyers_auto_matching","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automatching_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListingBuyersAutoMatchingEmailFragment, unknown>;
export const ListingEnquiryResponseEmailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListingEnquiryResponseEmailFragment, unknown>;
export const MarketingFormDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingFormData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<MarketingFormDataFragment, unknown>;
export const ChangeOfferStatusModalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeOfferStatusModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<ChangeOfferStatusModalFragment, unknown>;
export const UserChipFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserChipFragment, unknown>;
export const ListingCardSnippetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<ListingCardSnippetFragment, unknown>;
export const OfferEditFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<OfferEditFormFragment, unknown>;
export const SearchPlaceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchPlaceFragmentFragment, unknown>;
export const PropertySearchesCardPropertySearchesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertySearchesCardPropertySearches"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<PropertySearchesCardPropertySearchesFragment, unknown>;
export const TeamsSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TeamsSelectFragment, unknown>;
export const ReadOnlyTenantSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReadOnlyTenantSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"read_only_tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<ReadOnlyTenantSelectFragment, unknown>;
export const UserPhoneNumbersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<UserPhoneNumbersFragment, unknown>;
export const UserInfo_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UserInfo_UserFragment, unknown>;
export const TeamInfo_TeamFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]} as unknown as DocumentNode<TeamInfo_TeamFragment, unknown>;
export const PropertyCell_PropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<PropertyCell_PropertyFragment, unknown>;
export const TransactionsListRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionsListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"total","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_commissions"},"name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"split","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"beneficiary_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transaction_valuations_aggregate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeValuations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionsListRowFragment, unknown>;
export const UserSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UserSelectFragment, unknown>;
export const UserEmailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<UserEmailsFragment, unknown>;
export const ContactCardUserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactCardUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserEmails"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<ContactCardUserFragmentFragment, unknown>;
export const LotWatermarkEnabledFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkEnabled"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_enabled"}}]}}]} as unknown as DocumentNode<LotWatermarkEnabledFragment, unknown>;
export const LotWatermarkConfigFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_opacity"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_scale"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_rotation"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_x"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_y"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkEnabled"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_enabled"}}]}}]} as unknown as DocumentNode<LotWatermarkConfigFragment, unknown>;
export const AppraisalDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppraisalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appraisals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"valuations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}}]}}]}}]} as unknown as DocumentNode<AppraisalDetailsFragment, unknown>;
export const NewPortalListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewPortalListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portal_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<NewPortalListingFragment, unknown>;
export const TransactionCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCardFragment, unknown>;
export const ContactRequestEnquiryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactRequestEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ContactRequestEnquiryFragment, unknown>;
export const DashboardActivityPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<DashboardActivityPropertyFragment, unknown>;
export const FileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<FileFragment, unknown>;
export const DevelopmentDocumentsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentDocuments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"development_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<DevelopmentDocumentsFragment, unknown>;
export const ListingCell_ListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListingCell_ListingFragment, unknown>;
export const ListingPriceCellFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPriceCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<ListingPriceCellFragment, unknown>;
export const DevelopmentMappingsLotsTableFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentMappingsLotsTable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPriceCell"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_mappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"svg_path"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPriceCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentMappingsLotsTableFragment, unknown>;
export const DevelopmentEnquiryResponseEmailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<DevelopmentEnquiryResponseEmailFragment, unknown>;
export const DevelopmentMarketingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentMarketing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}}]}}]} as unknown as DocumentNode<DevelopmentMarketingFragment, unknown>;
export const DevelopmentCarouselFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentCarouselFragment, unknown>;
export const DevelopmentCardCarouselFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCardCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCarousel"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentCardCarouselFragment, unknown>;
export const DevelopmentPriceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentPriceFragment, unknown>;
export const OrganisationSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationSelectFragment, unknown>;
export const DevelopmentCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCardCarousel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCardCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCarousel"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentCardFragment, unknown>;
export const DevelopmentOverviewFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentOverviewForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_date"}},{"kind":"Field","name":{"kind":"Name","value":"registration_type"}}]}}]} as unknown as DocumentNode<DevelopmentOverviewFormFragment, unknown>;
export const DevelopmentQuickActionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]} as unknown as DocumentNode<DevelopmentQuickActionsFragment, unknown>;
export const DevelopmentSharingCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentSharingCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"development_collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<DevelopmentSharingCardFragment, unknown>;
export const NewDevelopmentCollaboratorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NewDevelopmentCollaborator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"development_collaborators"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<NewDevelopmentCollaboratorFragment, unknown>;
export const OrganisationInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationInfoFragment, unknown>;
export const DevelopmentStakeholdersCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentStakeholdersCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"architect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"general_contractor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<DevelopmentStakeholdersCardFragment, unknown>;
export const DevelopmentStatusSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]} as unknown as DocumentNode<DevelopmentStatusSelectFragment, unknown>;
export const DictionaryItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<DictionaryItemFragment, unknown>;
export const DocTemplateFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<DocTemplateFieldsFragment, unknown>;
export const DocThemeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocThemeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_themes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"empty_files"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DocThemeFieldsFragment, unknown>;
export const EnquiryCreateBuyerLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnquiryCreateBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email_address"}},{"kind":"Field","name":{"kind":"Name","value":"raw_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}}]}}]} as unknown as DocumentNode<EnquiryCreateBuyerLeadFragment, unknown>;
export const LeadAppraisalLocationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}}]} as unknown as DocumentNode<LeadAppraisalLocationFragment, unknown>;
export const LeadUpdatedTimeAgoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}}]} as unknown as DocumentNode<LeadUpdatedTimeAgoFragment, unknown>;
export const LeadsKanbanColumnLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsKanbanColumnLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}}]} as unknown as DocumentNode<LeadsKanbanColumnLeadFragment, unknown>;
export const LeadsKanbanColumnItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsKanbanColumnItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsKanbanColumnLead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsKanbanColumnLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<LeadsKanbanColumnItemFragment, unknown>;
export const ActivityCellFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]} as unknown as DocumentNode<ActivityCellFragment, unknown>;
export const LeadsListItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_or_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]} as unknown as DocumentNode<LeadsListItemFragment, unknown>;
export const LeadsListRowActivitiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsListRowActivities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"next_activity_assigned_to"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity_assigned_to"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]} as unknown as DocumentNode<LeadsListRowActivitiesFragment, unknown>;
export const LeadAgentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<LeadAgentFragment, unknown>;
export const MarketingCardLeadFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingCardLeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}}]}}]} as unknown as DocumentNode<MarketingCardLeadFragmentFragment, unknown>;
export const AddressOverridesListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<AddressOverridesListingFragment, unknown>;
export const AgentCard_UserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<AgentCard_UserFragment, unknown>;
export const ListedByOverridesListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_phone"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<ListedByOverridesListingFragment, unknown>;
export const ListingMandateCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<ListingMandateCardFragment, unknown>;
export const MandateFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<MandateFormFragment, unknown>;
export const SellerNotificationSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}}]} as unknown as DocumentNode<SellerNotificationSettingsFragment, unknown>;
export const ListingBuyerLeadsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerNotificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}}]} as unknown as DocumentNode<ListingBuyerLeadsFragment, unknown>;
export const ListingStatusSelectFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}}]} as unknown as DocumentNode<ListingStatusSelectFragment, unknown>;
export const PortalListingButtonFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]} as unknown as DocumentNode<PortalListingButtonFragment, unknown>;
export const ListingQuickActionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference_alias_decoded"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]} as unknown as DocumentNode<ListingQuickActionsFragment, unknown>;
export const PropertyFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<PropertyFileFragment, unknown>;
export const ListingOverviewPublishDocumentFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<ListingOverviewPublishDocumentFieldFragment, unknown>;
export const RentedRoomDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentedRoomDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_number"}},{"kind":"Field","name":{"kind":"Name","value":"minimal_stay"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_gender"}},{"kind":"Field","name":{"kind":"Name","value":"youngest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"oldest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"smoking_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"couples_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"pets_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"occupied_now"}},{"kind":"Field","name":{"kind":"Name","value":"furnished"}},{"kind":"Field","name":{"kind":"Name","value":"owner_living"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bed_type"}},{"kind":"Field","name":{"kind":"Name","value":"window_view"}}]}}]}}]} as unknown as DocumentNode<RentedRoomDetailsFragment, unknown>;
export const LeadQualificationFunnelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}}]} as unknown as DocumentNode<LeadQualificationFunnelFragment, unknown>;
export const LeadPropertyDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]} as unknown as DocumentNode<LeadPropertyDetailFragment, unknown>;
export const SalesLeadDetailFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]} as unknown as DocumentNode<SalesLeadDetailFragment, unknown>;
export const LeadCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}}]} as unknown as DocumentNode<LeadCardFragment, unknown>;
export const PropertyPoiFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}}]} as unknown as DocumentNode<PropertyPoiFragment, unknown>;
export const PropertyFeaturesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}}]} as unknown as DocumentNode<PropertyFeaturesFragment, unknown>;
export const PropertyDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]} as unknown as DocumentNode<PropertyDetailsFragment, unknown>;
export const PropertyFormDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}}]} as unknown as DocumentNode<PropertyFormDetailsFragment, unknown>;
export const PropertyFormPricingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}}]} as unknown as DocumentNode<PropertyFormPricingFragment, unknown>;
export const PropertyAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<PropertyAddressFragment, unknown>;
export const PropertyFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<PropertyFragmentFragment, unknown>;
export const ListingOverviewPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}}]} as unknown as DocumentNode<ListingOverviewPropertyFragment, unknown>;
export const ListingMapFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<ListingMapFragment, unknown>;
export const ListingOverviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentedRoomDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_phone"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerNotificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference_alias_decoded"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentedRoomDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_number"}},{"kind":"Field","name":{"kind":"Name","value":"minimal_stay"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_gender"}},{"kind":"Field","name":{"kind":"Name","value":"youngest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"oldest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"smoking_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"couples_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"pets_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"occupied_now"}},{"kind":"Field","name":{"kind":"Name","value":"furnished"}},{"kind":"Field","name":{"kind":"Name","value":"owner_living"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bed_type"}},{"kind":"Field","name":{"kind":"Name","value":"window_view"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]} as unknown as DocumentNode<ListingOverviewFragment, unknown>;
export const PropertyImageVersionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyImageVersionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_image_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PropertyImageVersionFieldsFragment, unknown>;
export const ListingsDetailedViewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingsDetailedView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}}]}}]}}]} as unknown as DocumentNode<ListingsDetailedViewFragment, unknown>;
export const CurrentListingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CurrentListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]} as unknown as DocumentNode<CurrentListingFragment, unknown>;
export const BuyerLeadDashboardRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}}]} as unknown as DocumentNode<BuyerLeadDashboardRowFragment, unknown>;
export const ListingEmailCampaignActivityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEmailCampaignActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaign_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"error_message"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<ListingEmailCampaignActivityFragment, unknown>;
export const NotificationSettingFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationSettingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"requires_channel"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"country_codes"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"email_available"}},{"kind":"Field","name":{"kind":"Name","value":"email_default"}},{"kind":"Field","name":{"kind":"Name","value":"sms_available"}},{"kind":"Field","name":{"kind":"Name","value":"sms_default"}},{"kind":"Field","name":{"kind":"Name","value":"push_available"}},{"kind":"Field","name":{"kind":"Name","value":"push_default"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_available"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_default"}}]}}]} as unknown as DocumentNode<NotificationSettingFieldsFragment, unknown>;
export const MultiPhoneNumbersFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiPhoneNumbersField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<MultiPhoneNumbersFieldFragment, unknown>;
export const MultiEmailsFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiEmailsField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"emails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<MultiEmailsFieldFragment, unknown>;
export const OrganisationSettingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"is_lender"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiPhoneNumbersField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiEmailsField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiPhoneNumbersField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiEmailsField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"emails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<OrganisationSettingsFragment, unknown>;
export const OrganisationScoreCardsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationScoreCards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"lead_id"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganisationScoreCardsFragment, unknown>;
export const OrganisationPosthogModuleUsageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_days_30d"}},{"kind":"Field","name":{"kind":"Name","value":"active_users_30d"}},{"kind":"Field","name":{"kind":"Name","value":"events_30d"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"source_breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crm_web_events"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_mobile_events"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"events"}},{"kind":"Field","name":{"kind":"Name","value":"active_users"}},{"kind":"Field","name":{"kind":"Name","value":"crm_web_events"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_mobile_events"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"events_30d"}},{"kind":"Field","name":{"kind":"Name","value":"active_days_30d"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen_date"}}]}}]}}]} as unknown as DocumentNode<OrganisationPosthogModuleUsageFragment, unknown>;
export const ActivityPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]} as unknown as DocumentNode<ActivityPropertyFragment, unknown>;
export const ActivityLotFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityLot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityProperty"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]} as unknown as DocumentNode<ActivityLotFragment, unknown>;
export const ActivityFeedItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","alias":{"kind":"Name","value":"is_overdue"},"name":{"kind":"Name","value":"performance_is_overdue"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityProperty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_mls"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"effective_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target_user_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityLot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityProperty"}}]}}]}}]} as unknown as DocumentNode<ActivityFeedItemFragment, unknown>;
export const PortalConnectionStatusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalConnectionStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<PortalConnectionStatusFragment, unknown>;
export const PortalLogoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PortalLogoFragment, unknown>;
export const PortalFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PortalFragmentFragment, unknown>;
export const PropertySearchFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertySearchForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"property_status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"activate_aggregator"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"has_balcony"}},{"kind":"Field","name":{"kind":"Name","value":"has_garden"}},{"kind":"Field","name":{"kind":"Name","value":"has_lift"}},{"kind":"Field","name":{"kind":"Name","value":"has_parking"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_fsbo"}},{"kind":"Field","name":{"kind":"Name","value":"is_furnished"}},{"kind":"Field","name":{"kind":"Name","value":"is_minergie_certified"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<PropertySearchFormFragment, unknown>;
export const BrochureReportIncludeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrochureReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brochure_include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_property"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_poi_map"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_poi_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_append_files"}}]}}]} as unknown as DocumentNode<BrochureReportIncludeFragment, unknown>;
export const ReportPropertyImageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ReportPropertyImageFragment, unknown>;
export const StepCoverPhotoBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pt"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_es"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_show_agent_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<StepCoverPhotoBrochureFragment, unknown>;
export const StepDescriptionBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescriptionBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_es"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_layout"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<StepDescriptionBrochureFragment, unknown>;
export const StepPropertyDetailsBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_maisonette"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_rental"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_secondary_residence"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]} as unknown as DocumentNode<StepPropertyDetailsBrochureFragment, unknown>;
export const StepPhotosBrochureFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPhotosBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"show_image_captions_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<StepPhotosBrochureFragment, unknown>;
export const StepMarketDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepMarketData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_market_data"}},{"kind":"Field","name":{"kind":"Name","value":"market_comparison_places"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_show_map"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_show_chart"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<StepMarketDataFragment, unknown>;
export const StepCoverPhotoCmaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"report_title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<StepCoverPhotoCmaFragment, unknown>;
export const StepHedonisticValuationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepHedonisticValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<StepHedonisticValuationFragment, unknown>;
export const StepDescriptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}}]}}]} as unknown as DocumentNode<StepDescriptionFragment, unknown>;
export const CmaReportFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<CmaReportFileFragment, unknown>;
export const CmaPropertyFileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<CmaPropertyFileFragment, unknown>;
export const StepAppendFilesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAppendFiles"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaPropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepAppendFilesFragment, unknown>;
export const CmaReportEditorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CMAReportEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<CmaReportEditorFragment, unknown>;
export const StepIntroductionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntroduction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}}]}}]} as unknown as DocumentNode<StepIntroductionFragment, unknown>;
export const StepPropertyDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<StepPropertyDetailsFragment, unknown>;
export const StepFinalFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepFinal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"positive_comments"}},{"kind":"Field","name":{"kind":"Name","value":"negative_comments"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"show_probability"}},{"kind":"Field","name":{"kind":"Name","value":"probability_min"}},{"kind":"Field","name":{"kind":"Name","value":"probability_max"}},{"kind":"Field","name":{"kind":"Name","value":"probability_time_period"}}]}}]} as unknown as DocumentNode<StepFinalFragment, unknown>;
export const StepPotentialBuyersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPotentialBuyers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"max_budget"}},{"kind":"Field","name":{"kind":"Name","value":"min_budget"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]} as unknown as DocumentNode<StepPotentialBuyersFragment, unknown>;
export const StepPoisFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPois"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"poi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"primary_type"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<StepPoisFragment, unknown>;
export const StepAgencyProfileFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAgencyProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_agency_description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_team_members"}},{"kind":"Field","name":{"kind":"Name","value":"sort_display_mode"}},{"kind":"Field","name":{"kind":"Name","value":"cma_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_in_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cma_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}}]}}]}}]} as unknown as DocumentNode<StepAgencyProfileFragment, unknown>;
export const StepListingsCompareFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepListingsCompare"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparable_listing_details"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"show_full_idx_description"}},{"kind":"Field","name":{"kind":"Name","value":"show_comparable_listing_cards"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report_source"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<StepListingsCompareFragment, unknown>;
export const CmaReportIncludeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"include_introduction"}},{"kind":"Field","name":{"kind":"Name","value":"include_property"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"include_poi_map"}},{"kind":"Field","name":{"kind":"Name","value":"poi_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_cuprate_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_intrinsic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_final_value"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent_agency"}},{"kind":"Field","name":{"kind":"Name","value":"include_client_testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"include_append_files"}},{"kind":"Field","name":{"kind":"Name","value":"include_market_data"}}]}}]} as unknown as DocumentNode<CmaReportIncludeFragment, unknown>;
export const StepCapRateValuationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCapRateValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_estimated_monthly_rent"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_minimum_required_yield"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}}]} as unknown as DocumentNode<StepCapRateValuationFragment, unknown>;
export const StepIntrinsicValuationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntrinsicValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"construction_cost_base"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_building_surface"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_construction_cost"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_annual_deprecation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_land_value"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_custom_fields"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]} as unknown as DocumentNode<StepIntrinsicValuationFragment, unknown>;
export const StepTransactionsListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactionsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"include_in_median"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StepTransactionsListFragment, unknown>;
export const StepTransactionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"adjust_price_by_evolution"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_transaction_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_map_zoom_level"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepTransactionsList"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactionsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"include_in_median"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StepTransactionsFragment, unknown>;
export const ExternalTransactionDistanceFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalTransactionDistanceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_external_transactions_distance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"street_suffix"}},{"kind":"Field","name":{"kind":"Name","value":"street_type"}},{"kind":"Field","name":{"kind":"Name","value":"street_name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}}]}}]} as unknown as DocumentNode<ExternalTransactionDistanceFieldsFragment, unknown>;
export const ExternalTransactionFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_external_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"street_suffix"}},{"kind":"Field","name":{"kind":"Name","value":"street_type"}},{"kind":"Field","name":{"kind":"Name","value":"street_name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<ExternalTransactionFieldsFragment, unknown>;
export const CmaAgentTransactionDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaAgentTransactionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_agent_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CmaAgentTransactionDetailsFragment, unknown>;
export const CmaUserReviewDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaUserReviewDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_user_reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_seller"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<CmaUserReviewDetailsFragment, unknown>;
export const StepRentalListingsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepRentalListings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables_search_params"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparable_listing_details"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"show_full_rental_description"}},{"kind":"Field","name":{"kind":"Name","value":"show_rental_comparable_listing_cards"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}}]} as unknown as DocumentNode<StepRentalListingsFragment, unknown>;
export const RentalCmaListingChFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingCh"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingChFragment, unknown>;
export const RentalCmaListingEsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingEs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingEsFragment, unknown>;
export const RentalCmaListingFrFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingFr"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingFrFragment, unknown>;
export const RentalCmaListingItFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingIt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingItFragment, unknown>;
export const RentalCmaListingPlFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPl"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingPlFragment, unknown>;
export const RentalCmaListingPtFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingPtFragment, unknown>;
export const ReviewDrawerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer_date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReviewDrawerFragment, unknown>;
export const LeadStageFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<LeadStageFieldsFragment, unknown>;
export const PipelineFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<PipelineFragmentFragment, unknown>;
export const TenantSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"main_color"}},{"kind":"Field","name":{"kind":"Name","value":"default_pipeline_id"}},{"kind":"Field","name":{"kind":"Name","value":"email_template"}},{"kind":"Field","name":{"kind":"Name","value":"phone_main"}},{"kind":"Field","name":{"kind":"Name","value":"email_sender_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_sender_email"}},{"kind":"Field","name":{"kind":"Name","value":"google_tag_manager_id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_secret_key"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_webhook_secret"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_secret_key_test"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_webhook_secret_test"}},{"kind":"Field","name":{"kind":"Name","value":"close_api_key"}},{"kind":"Field","name":{"kind":"Name","value":"debug_email_mode"}},{"kind":"Field","name":{"kind":"Name","value":"ai_feed_summary_prompt"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}}]}}]} as unknown as DocumentNode<TenantSettingsFragmentFragment, unknown>;
export const InvoiceFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]} as unknown as DocumentNode<InvoiceFragmentFragment, unknown>;
export const TeamCombinedReviewsAggFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<TeamCombinedReviewsAggFragment, unknown>;
export const TeamAddress_LightFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress_light"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]} as unknown as DocumentNode<TeamAddress_LightFragment, unknown>;
export const TeamAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<TeamAddressFragment, unknown>;
export const TeamSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"copy_reviews_to_google"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"top_listings"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"share_transactions_in_cma"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"x_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<TeamSettingsFragmentFragment, unknown>;
export const TransactionFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<TransactionFormFragmentFragment, unknown>;
export const TransactionCommissionsFormFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCommissionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCommissionsFormFragmentFragment, unknown>;
export const TransactionCreationFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCreationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]} as unknown as DocumentNode<TransactionCreationFragmentFragment, unknown>;
export const UserBuyerLeadActionToolbarBuyerLeadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBuyerLeadActionToolbarBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserBuyerLeadActionToolbarBuyerLeadFragment, unknown>;
export const UserBuyerLeadKanbanItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBuyerLeadKanbanItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user_order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}}]} as unknown as DocumentNode<UserBuyerLeadKanbanItemFragment, unknown>;
export const ListingsMatchingFiltersPropertySearchesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingsMatchingFiltersPropertySearches"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}}]}}]} as unknown as DocumentNode<ListingsMatchingFiltersPropertySearchesFragment, unknown>;
export const UserSettingsFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"can_edit_settings"}},{"kind":"Field","name":{"kind":"Name","value":"can_user_login_as"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]} as unknown as DocumentNode<UserSettingsFragmentFragment, unknown>;
export const PlaceSlugFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaceSlugFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"slug_en"}},{"kind":"Field","name":{"kind":"Name","value":"slug_fr"}},{"kind":"Field","name":{"kind":"Name","value":"slug_de"}},{"kind":"Field","name":{"kind":"Name","value":"slug_it"}},{"kind":"Field","name":{"kind":"Name","value":"slug_es"}},{"kind":"Field","name":{"kind":"Name","value":"slug_pl"}},{"kind":"Field","name":{"kind":"Name","value":"slug_pt"}}]}}]} as unknown as DocumentNode<PlaceSlugFieldsFragment, unknown>;
export const VisibilityUserProfileFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityUserProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"verified_reviews"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<VisibilityUserProfileFieldsFragment, unknown>;
export const VisibilityAgentProfileFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityAgentProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityUserProfileFields"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_profile"}},{"kind":"Field","name":{"kind":"Name","value":"x_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityUserProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"verified_reviews"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<VisibilityAgentProfileFieldsFragment, unknown>;
export const VisibilityLeadAgentClaimFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityLeadAgentClaimFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]} as unknown as DocumentNode<VisibilityLeadAgentClaimFieldsFragment, unknown>;
export const VisibilityResponseTimeLeadAgentFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityResponseTimeLeadAgentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]} as unknown as DocumentNode<VisibilityResponseTimeLeadAgentFieldsFragment, unknown>;
export const VisibilityReviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityReview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<VisibilityReviewFragment, unknown>;
export const SearchTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_teams_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<SearchTeamsQuery, SearchTeamsQueryVariables>;
export const GetTenantBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>;
export const UserInputSearchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInputSearchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_users_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInput"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInput"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primaryImage"},"name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}}]}}]} as unknown as DocumentNode<UserInputSearchUsersQuery, UserInputSearchUsersQueryVariables>;
export const UserInputDefaultTeamsUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserInputDefaultTeamsUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInput"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInput"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"primaryImage"},"name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}}]}}]} as unknown as DocumentNode<UserInputDefaultTeamsUsersQuery, UserInputDefaultTeamsUsersQueryVariables>;
export const LotImproveDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LotImproveDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"improve_text"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<LotImproveDescriptionQuery, LotImproveDescriptionQueryVariables>;
export const GetPropertyTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPropertyTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyTypesQuery, GetPropertyTypesQueryVariables>;
export const GetUserTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<GetUserTeamsQuery, GetUserTeamsQueryVariables>;
export const GetAssignStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAssignStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"assign","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetAssignStageQuery, GetAssignStageQueryVariables>;
export const GetPropertyDuplicationDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyDuplicationData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyDuplicationDataQuery, GetPropertyDuplicationDataQueryVariables>;
export const GetDocTemplatesForDefaultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplatesForDefault"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_type_enum_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<GetDocTemplatesForDefaultQuery, GetDocTemplatesForDefaultQueryVariables>;
export const DocTemplateThemesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocTemplateThemes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_type_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"theme"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DocTemplateThemesQuery, DocTemplateThemesQueryVariables>;
export const GetPhoneNumbersTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhoneNumbersTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_number_type_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetPhoneNumbersTypesQuery, GetPhoneNumbersTypesQueryVariables>;
export const InsertUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<InsertUserMutation, InsertUserMutationVariables>;
export const AutoAssignRankingChDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoAssignRankingCh"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_assign_ranking_ch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"membership_type"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"crm_link"}},{"kind":"Field","name":{"kind":"Name","value":"total_weighted_leads_assigned"}},{"kind":"Field","name":{"kind":"Name","value":"total_leads_assigned_30_days"}},{"kind":"Field","name":{"kind":"Name","value":"total_unique_lead_visits"}},{"kind":"Field","name":{"kind":"Name","value":"total_lead_mandates"}},{"kind":"Field","name":{"kind":"Name","value":"total_own_mandates"}},{"kind":"Field","name":{"kind":"Name","value":"total_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"total_commissions"}},{"kind":"Field","name":{"kind":"Name","value":"total_agent_share"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_visit_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"visit_to_mandate_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_to_transaction_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_transaction_conversion"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_visit_score"}},{"kind":"Field","name":{"kind":"Name","value":"visit_to_mandate_score"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_to_transaction_score"}},{"kind":"Field","name":{"kind":"Name","value":"lead_to_transaction_score"}},{"kind":"Field","name":{"kind":"Name","value":"overall_score"}},{"kind":"Field","name":{"kind":"Name","value":"revenues_per_lead"}},{"kind":"Field","name":{"kind":"Name","value":"gross_margin_per_lead"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_overdue_leads"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_overdue_days"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_leads_without_activity"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_listings_available"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agent_ranking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agent"},"name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_location"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_municipality"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_district"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_state"}},{"kind":"Field","name":{"kind":"Name","value":"total_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AutoAssignRankingChQuery, AutoAssignRankingChQueryVariables>;
export const AutoAssignRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoAssignRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_assign_ranking"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"should_auto_assign"}},{"kind":"Field","name":{"kind":"Name","value":"assign_to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"crm_link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"crm_link"}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}},{"kind":"Field","name":{"kind":"Name","value":"cost_per_lead"}},{"kind":"Field","name":{"kind":"Name","value":"amount_spent"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_leads"}},{"kind":"Field","name":{"kind":"Name","value":"already_assigned"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AutoAssignRankingQuery, AutoAssignRankingQueryVariables>;
export const SearchBuyerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchBuyerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_buyer_leads_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<SearchBuyerLeadsQuery, SearchBuyerLeadsQueryVariables>;
export const GetBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadQuery, GetBuyerLeadQueryVariables>;
export const SearchDevelopmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchDevelopments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"where"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}}]}}]} as unknown as DocumentNode<SearchDevelopmentsQuery, SearchDevelopmentsQueryVariables>;
export const GetDefaultDevelopmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultDevelopment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}}]}}]} as unknown as DocumentNode<GetDefaultDevelopmentQuery, GetDefaultDevelopmentQueryVariables>;
export const SentEmailCountOverRolling24HDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SentEmailCountOverRolling24H"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_sent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"sent","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<SentEmailCountOverRolling24HQuery, SentEmailCountOverRolling24HQueryVariables>;
export const GetEmailTemplateFormDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEmailTemplateFormData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skipSuggestions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailTemplateSuggestionsLanguage"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipUsers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"get_email_template_suggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"senderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"enquiryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"buyerLeadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"developmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skipSuggestions"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetEmailTemplateFormDataQuery, GetEmailTemplateFormDataQueryVariables>;
export const GetSenderSuggestionsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSenderSuggestionsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}}]} as unknown as DocumentNode<GetSenderSuggestionsDataQuery, GetSenderSuggestionsDataQueryVariables>;
export const SearchEmailTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchEmailTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"development_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<SearchEmailTemplatesQuery, SearchEmailTemplatesQueryVariables>;
export const FeedDeleteDialogDeleteActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FeedDeleteDialogDeleteActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FeedDeleteDialogDeleteActivityMutation, FeedDeleteDialogDeleteActivityMutationVariables>;
export const DeleteFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteFileMutation, DeleteFileMutationVariables>;
export const GetDocumentTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"document_types"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"documents"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetDocumentTypesQuery, GetDocumentTypesQueryVariables>;
export const LanguageMenuUpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LanguageMenuUpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_language"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<LanguageMenuUpdateUserMutation, LanguageMenuUpdateUserMutationVariables>;
export const LeadLostDialogGetLostStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadLostDialogGetLostStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lost"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<LeadLostDialogGetLostStagesQuery, LeadLostDialogGetLostStagesQueryVariables>;
export const LeadLostDialogInsertActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadLostDialogInsertActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}}]}}]} as unknown as DocumentNode<LeadLostDialogInsertActivityMutation, LeadLostDialogInsertActivityMutationVariables>;
export const SearchLeadsTsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLeadsTsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_leads_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<SearchLeadsTsvQuery, SearchLeadsTsvQueryVariables>;
export const SearchLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<SearchLeadsQuery, SearchLeadsQueryVariables>;
export const GetDefaultLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<GetDefaultLeadQuery, GetDefaultLeadQueryVariables>;
export const LotGenerateDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LotGenerateDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_listings_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<LotGenerateDescriptionQuery, LotGenerateDescriptionQueryVariables>;
export const LotGenerateTitleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LotGenerateTitle"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_listing_title"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<LotGenerateTitleQuery, LotGenerateTitleQueryVariables>;
export const SearchLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitToDevelopment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_lots_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dev_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitToDevelopment"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<SearchLotsQuery, SearchLotsQueryVariables>;
export const GetDefaultLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetDefaultLotQuery, GetDefaultLotQueryVariables>;
export const CheckEmailUnicityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckEmailUnicity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checks"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"emails_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checks"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CheckEmailUnicityQuery, CheckEmailUnicityQueryVariables>;
export const CheckPhoneNumberExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckPhoneNumberExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checks"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checks"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CheckPhoneNumberExistsQuery, CheckPhoneNumberExistsQueryVariables>;
export const GetLeadRefusedReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadRefusedReasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lead_refused_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetLeadRefusedReasonsQuery, GetLeadRefusedReasonsQueryVariables>;
export const GetPhoneNumbersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPhoneNumbers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_number_type_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<GetPhoneNumbersQuery, GetPhoneNumbersQueryVariables>;
export const UpsertPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"phone_numbers_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"number"},{"kind":"EnumValue","value":"type"},{"kind":"EnumValue","value":"verified"},{"kind":"EnumValue","value":"primary"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<UpsertPhoneNumberMutation, UpsertPhoneNumberMutationVariables>;
export const UpdatePrimaryPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePrimaryPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<UpdatePrimaryPhoneNumberMutation, UpdatePrimaryPhoneNumberMutationVariables>;
export const DeletePhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PhoneNumberCard_phone_number"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]} as unknown as DocumentNode<DeletePhoneNumberMutation, DeletePhoneNumberMutationVariables>;
export const UpdatePropertyFileDisplayOnListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyFileDisplayOnListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"display"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"should_reset_non_video"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"should_reset_video"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"update_property_file"},"name":{"kind":"Name","value":"update_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_listing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"display"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reset_property_files"},"name":{"kind":"Name","value":"update_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_listing"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"document_type"},"value":{"kind":"ObjectValue","fields":[]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"document_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"video","block":false}}]}}]}}]}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"should_reset_non_video"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reset_property_files_video"},"name":{"kind":"Name","value":"update_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_listing"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"document_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"video","block":false}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"should_reset_video"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyFileDisplayOnListingMutation, UpdatePropertyFileDisplayOnListingMutationVariables>;
export const GetSmartListsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSmartLists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"smart_lists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"crm_entity"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"where"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared"}},{"kind":"Field","name":{"kind":"Name","value":"is_tenant_shared"}},{"kind":"Field","name":{"kind":"Name","value":"crm_entity"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetSmartListsQuery, GetSmartListsQueryVariables>;
export const UpdateSmartListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSmartList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_smart_lists_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_tenant_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared"}},{"kind":"Field","name":{"kind":"Name","value":"is_tenant_shared"}}]}}]}}]} as unknown as DocumentNode<UpdateSmartListMutation, UpdateSmartListMutationVariables>;
export const DeleteSmartListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSmartList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_smart_lists_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSmartListMutation, DeleteSmartListMutationVariables>;
export const InsertSmartListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertSmartList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_smart_lists_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"crm_entity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crmEntity"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_shared"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_tenant_shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_tenant_shared"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"where"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared"}},{"kind":"Field","name":{"kind":"Name","value":"is_tenant_shared"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<InsertSmartListMutation, InsertSmartListMutationVariables>;
export const GetUserEmailSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserEmailSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"ended_at"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"plan_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserEmailSubscriptionsQuery, GetUserEmailSubscriptionsQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoAssignLeads"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auto_assign_leads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoAssignLeads"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const SearchTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TemplateSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<SearchTemplatesQuery, SearchTemplatesQueryVariables>;
export const SearchTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_property_transactions_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<SearchTransactionsQuery, SearchTransactionsQueryVariables>;
export const GetDefaultTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetDefaultTransactionQuery, GetDefaultTransactionQueryVariables>;
export const ActivityBannerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActivityBanner"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ActivityBannerQuery, ActivityBannerQueryVariables>;
export const GetAppraisalHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAppraisalHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<GetAppraisalHistoryQuery, GetAppraisalHistoryQueryVariables>;
export const GetPropertyAppraisableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyAppraisable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_appraisable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyAppraisableQuery, GetPropertyAppraisableQueryVariables>;
export const UpdateBuyerLeadsStageMultipleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBuyerLeadsStageMultiple"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBuyerLeadsStageMultipleMutation, UpdateBuyerLeadsStageMultipleMutationVariables>;
export const GetBuyerLeadToolbarSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadToolbarSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailTemplateSuggestionsLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_email_template_suggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"senderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"developmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadToolbarSuggestionsQuery, GetBuyerLeadToolbarSuggestionsQueryVariables>;
export const GetBuyerLeadEmailContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadEmailContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"enquiryResponseTemplates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"response_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadEmailContextQuery, GetBuyerLeadEmailContextQueryVariables>;
export const GetBuyerLeadSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailTemplateSuggestionsLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_email_template_suggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"senderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"Argument","name":{"kind":"Name","value":"buyerLeadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadSuggestionsQuery, GetBuyerLeadSuggestionsQueryVariables>;
export const GetDocumentRecipientStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentRecipientStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_recipient_status"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"document_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipient_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientUserId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shared"}},{"kind":"Field","name":{"kind":"Name","value":"shared_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_open_at"}},{"kind":"Field","name":{"kind":"Name","value":"total_opens"}},{"kind":"Field","name":{"kind":"Name","value":"unique_opens"}},{"kind":"Field","name":{"kind":"Name","value":"unidentified_opens"}},{"kind":"Field","name":{"kind":"Name","value":"daily"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"unique"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentRecipientStatusQuery, GetDocumentRecipientStatusQueryVariables>;
export const GetBuyerLeadDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadDetailQuery, GetBuyerLeadDetailQueryVariables>;
export const BuyerLeadDeleteDialogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuyerLeadDeleteDialog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BuyerLeadDeleteDialogMutation, BuyerLeadDeleteDialogMutationVariables>;
export const GetBuyerLeadDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadStatusCard_buyerLead"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadStatusCard_buyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadDrawerQuery, GetBuyerLeadDrawerQueryVariables>;
export const GetBuyerLeadEnquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadEnquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadEnquiryCardEnquiry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadEnquiryCardEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadEnquiryQuery, GetBuyerLeadEnquiryQueryVariables>;
export const GetBuyerLeadEnquiryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadEnquiryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadEnquiryCardEnquiry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadEnquiryCardEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadEnquiryByIdQuery, GetBuyerLeadEnquiryByIdQueryVariables>;
export const GetBuyerLeadEnquiryResponseSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadEnquiryResponseSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailTemplateSuggestionsLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_email_template_suggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"senderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"Argument","name":{"kind":"Name","value":"enquiryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadEnquiryResponseSuggestionsQuery, GetBuyerLeadEnquiryResponseSuggestionsQueryVariables>;
export const GetBuyerLeadOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadOfferQuery, GetBuyerLeadOfferQueryVariables>;
export const GetBuyerLeadOtherListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadOtherListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"notification"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"never","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingsMatchingFiltersPropertySearches"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingsMatchingFiltersPropertySearches"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}}]}}]} as unknown as DocumentNode<GetBuyerLeadOtherListingsQuery, GetBuyerLeadOtherListingsQueryVariables>;
export const UpdateBuyerLeadStageFromStatusCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBuyerLeadStageFromStatusCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBuyerLeadStageFromStatusCardMutation, UpdateBuyerLeadStageFromStatusCardMutationVariables>;
export const UpdateBuyerLeadStageKanbanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBuyerLeadStageKanban"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}}]}}]}}]} as unknown as DocumentNode<UpdateBuyerLeadStageKanbanMutation, UpdateBuyerLeadStageKanbanMutationVariables>;
export const GetBuyerLeadStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadStages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadStagesQuery, GetBuyerLeadStagesQueryVariables>;
export const CreateBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_buyer_leads_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLead"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}}]}}]}}]} as unknown as DocumentNode<CreateBuyerLeadMutation, CreateBuyerLeadMutationVariables>;
export const InsertBuyerLeadsManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertBuyerLeadsMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyer_leads"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyer_leads"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertBuyerLeadsManyMutation, InsertBuyerLeadsManyMutationVariables>;
export const BuyerLeadFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuyerLeadFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyer_lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyer_lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"change"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pinned"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFiltersActivity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLeadSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLotSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemUserSnippet"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFiltersActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BuyerLeadFeedQuery, BuyerLeadFeedQueryVariables>;
export const ComposeEmailSentMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComposeEmailSentMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComposeEmailSentMessageQuery, ComposeEmailSentMessageQueryVariables>;
export const GetSourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lead_source_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetSourcesQuery, GetSourcesQueryVariables>;
export const GetCreateLeadContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateLeadContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetCreateLeadContactQuery, GetCreateLeadContactQueryVariables>;
export const GetCreateListingLeadDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateListingLeadData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}}]}}]}}]} as unknown as DocumentNode<GetCreateListingLeadDataQuery, GetCreateListingLeadDataQueryVariables>;
export const GetLotOriginsCreateListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotOriginsCreateListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"origins"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_origin_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLotOriginsCreateListingQuery, GetLotOriginsCreateListingQueryVariables>;
export const GetLotOriginsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotOrigins"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"origins"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_origin_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLotOriginsQuery, GetLotOriginsQueryVariables>;
export const GetListingDocumentTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDocumentTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lot_brochure_doc_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<GetListingDocumentTemplatesQuery, GetListingDocumentTemplatesQueryVariables>;
export const GetDictionariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDictionaries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_types_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionarySelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionarySelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<GetDictionariesQuery, GetDictionariesQueryVariables>;
export const GetComposerContactMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComposerContactMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emails"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetComposerContactMatchesQuery, GetComposerContactMatchesQueryVariables>;
export const ComposerSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComposerSignature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_signature"}}]}}]}}]}}]} as unknown as DocumentNode<ComposerSignatureQuery, ComposerSignatureQueryVariables>;
export const SaveMassMailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveMassMailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SaveMassMailTemplateMutation, SaveMassMailTemplateMutationVariables>;
export const GetLotForSnippetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotForSnippet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLotForSnippetQuery, GetLotForSnippetQueryVariables>;
export const GetDevelopmentForSnippetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentForSnippet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"display_lot"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentForSnippetQuery, GetDevelopmentForSnippetQueryVariables>;
export const GetEmailTemplateSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmailTemplateSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailTemplateSuggestionsLanguage"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_email_template_suggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"senderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<GetEmailTemplateSuggestionsQuery, GetEmailTemplateSuggestionsQueryVariables>;
export const GetActivityForDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivityForDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItem"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLeadSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLotSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemUserSnippet"}}]}}]} as unknown as DocumentNode<GetActivityForDetailQuery, GetActivityForDetailQueryVariables>;
export const GenerateLeadSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateLeadSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateLeadSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]} as unknown as DocumentNode<GenerateLeadSummaryMutation, GenerateLeadSummaryMutationVariables>;
export const GetUserEmailFormRecipientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserEmailFormRecipient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserEmailFormRecipientQuery, GetUserEmailFormRecipientQueryVariables>;
export const GetActivityEmailSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivityEmailSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailTemplateSuggestionsLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_email_template_suggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"senderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<GetActivityEmailSuggestionsQuery, GetActivityEmailSuggestionsQueryVariables>;
export const ClaimLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"should_create_call_activity"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claim_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"should_create_call_activity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"should_create_call_activity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClaimLeadMutation, ClaimLeadMutationVariables>;
export const PassLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PassLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refuse_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PassLeadMutation, PassLeadMutationVariables>;
export const ActivityProviderLeadInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActivityProviderLeadInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActivityProviderLeadInfoQuery, ActivityProviderLeadInfoQueryVariables>;
export const CallOutcomeDialogFlowCompleteCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CallOutcomeDialogFlowCompleteCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"success"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"Variable","name":{"kind":"Name","value":"success"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CallOutcomeDialogFlowCompleteCallMutation, CallOutcomeDialogFlowCompleteCallMutationVariables>;
export const CallOutcomeDialogFlowGetActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CallOutcomeDialogFlowGetActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<CallOutcomeDialogFlowGetActivityQuery, CallOutcomeDialogFlowGetActivityQueryVariables>;
export const ListingActivityContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingActivityContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<ListingActivityContextQuery, ListingActivityContextQueryVariables>;
export const TaskOutcomeDialogFlowCompleteTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TaskOutcomeDialogFlowCompleteTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"success"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"Variable","name":{"kind":"Name","value":"success"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<TaskOutcomeDialogFlowCompleteTaskMutation, TaskOutcomeDialogFlowCompleteTaskMutationVariables>;
export const LeadDetailsActivityForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadDetailsActivityForEdit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_at"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}}]}}]}}]}}]} as unknown as DocumentNode<LeadDetailsActivityForEditQuery, LeadDetailsActivityForEditQueryVariables>;
export const GetUserDetailsForActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDetailsForActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]} as unknown as DocumentNode<GetUserDetailsForActivityQuery, GetUserDetailsForActivityQueryVariables>;
export const GetBuyerLeadDetailsForActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadDetailsForActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyer_lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyer_lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadDetailsForActivityQuery, GetBuyerLeadDetailsForActivityQueryVariables>;
export const GetLotDetailsForActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotDetailsForActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLotDetailsForActivityQuery, GetLotDetailsForActivityQueryVariables>;
export const VisitOutcomeDialogFlowActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VisitOutcomeDialogFlowActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mandate_probability_types"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"mandate_probability_types"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<VisitOutcomeDialogFlowActivityQuery, VisitOutcomeDialogFlowActivityQueryVariables>;
export const VisitOutcomeDialogFlowCompleteVisitAndUpdateLeadAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VisitOutcomeDialogFlowCompleteVisitAndUpdateLeadAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"success"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"done_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdateLeadAgent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadAgentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"win_probability"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"predicted_win_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"Variable","name":{"kind":"Name","value":"success"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"done_at"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadAgentId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"win_probability"},"value":{"kind":"Variable","name":{"kind":"Name","value":"win_probability"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"predicted_win_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"predicted_win_date"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldUpdateLeadAgent"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<VisitOutcomeDialogFlowCompleteVisitAndUpdateLeadAgentMutation, VisitOutcomeDialogFlowCompleteVisitAndUpdateLeadAgentMutationVariables>;
export const LeadDetailsPendingActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadDetailsPendingActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}}]}}]}}]}}]} as unknown as DocumentNode<LeadDetailsPendingActivitiesQuery, LeadDetailsPendingActivitiesQueryVariables>;
export const LeadDetailsInsertActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadDetailsInsertActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}}]}}]} as unknown as DocumentNode<LeadDetailsInsertActivityMutation, LeadDetailsInsertActivityMutationVariables>;
export const LeadDetailsUpdateActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadDetailsUpdateActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetUsers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_target_users_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateTargetUsers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTargetUsers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetUsers"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateTargetUsers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<LeadDetailsUpdateActivityMutation, LeadDetailsUpdateActivityMutationVariables>;
export const UpdateActivityPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateActivityPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pinned"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pinned"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pinned"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}}]}}]}}]} as unknown as DocumentNode<UpdateActivityPinnedMutation, UpdateActivityPinnedMutationVariables>;
export const ActivityWorkflowDialogCompleteTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivityWorkflowDialogCompleteTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"success"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"Variable","name":{"kind":"Name","value":"success"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ActivityWorkflowDialogCompleteTaskMutation, ActivityWorkflowDialogCompleteTaskMutationVariables>;
export const BuyerLeadWorkflowGetLostStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuyerLeadWorkflowGetLostStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lost"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<BuyerLeadWorkflowGetLostStageQuery, BuyerLeadWorkflowGetLostStageQueryVariables>;
export const BuyerLeadWorkflowGetWonStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuyerLeadWorkflowGetWonStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"won"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<BuyerLeadWorkflowGetWonStageQuery, BuyerLeadWorkflowGetWonStageQueryVariables>;
export const BuyerLeadWorkflowGetActivationTargetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BuyerLeadWorkflowGetActivationTarget"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<BuyerLeadWorkflowGetActivationTargetQuery, BuyerLeadWorkflowGetActivationTargetQueryVariables>;
export const BuyerLeadWorkflowUpdateBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuyerLeadWorkflowUpdateBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<BuyerLeadWorkflowUpdateBuyerLeadMutation, BuyerLeadWorkflowUpdateBuyerLeadMutationVariables>;
export const GetEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetEnumsQuery, GetEnumsQueryVariables>;
export const GetListingsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetListingsByIdsQuery, GetListingsByIdsQueryVariables>;
export const GetMlsBrokersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsBrokers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasSelectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_brokers"},"name":{"kind":"Name","value":"mls_brokers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasSelectedIds"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_brokers"},"name":{"kind":"Name","value":"mls_brokers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}}]}}]} as unknown as DocumentNode<GetMlsBrokersQuery, GetMlsBrokersQueryVariables>;
export const SearchMlsBrokersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchMlsBrokers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_brokers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}}]}}]} as unknown as DocumentNode<SearchMlsBrokersQuery, SearchMlsBrokersQueryVariables>;
export const GetMlsNetworkTeamOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsNetworkTeamOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasSelectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_teams"},"name":{"kind":"Name","value":"mls_network_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasSelectedIds"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_teams"},"name":{"kind":"Name","value":"mls_network_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo_url"}}]}}]}}]} as unknown as DocumentNode<GetMlsNetworkTeamOptionsQuery, GetMlsNetworkTeamOptionsQueryVariables>;
export const SearchMlsNetworkTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchMlsNetworkTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_network_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo_url"}}]}}]}}]} as unknown as DocumentNode<SearchMlsNetworkTeamsQuery, SearchMlsNetworkTeamsQueryVariables>;
export const GetMlsTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasSelectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_teams"},"name":{"kind":"Name","value":"mls_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasSelectedIds"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_teams"},"name":{"kind":"Name","value":"mls_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetMlsTeamsQuery, GetMlsTeamsQueryVariables>;
export const SearchMlsTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchMlsTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<SearchMlsTeamsQuery, SearchMlsTeamsQueryVariables>;
export const GetPlacesWithParentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlacesWithParents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlacesWithParentsQuery, GetPlacesWithParentsQueryVariables>;
export const TeamFilterSearchTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamFilterSearchTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<TeamFilterSearchTeamsQuery, TeamFilterSearchTeamsQueryVariables>;
export const GetTeamsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_teams"},"name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFilter"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_teams"},"name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetTeamsByIdsQuery, GetTeamsByIdsQueryVariables>;
export const UserFilterSearchUsersTsvDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserFilterSearchUsersTsv"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_users_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UserFilterSearchUsersTsvQuery, UserFilterSearchUsersTsvQueryVariables>;
export const GetUsersByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isNoneSelected"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_users"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isNoneSelected"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFilter"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_users"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFilter"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFilter"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>;
export const GetImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetImageQuery, GetImageQueryVariables>;
export const GetListingPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","alias":{"kind":"Name","value":"last_accepted_offer"},"name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingPreviewQuery, GetListingPreviewQueryVariables>;
export const EnhanceImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnhanceImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source_image_data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aspect_ratio"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image_size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enhance_image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"prompt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}}},{"kind":"Argument","name":{"kind":"Name","value":"source_image_data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source_image_data"}}},{"kind":"Argument","name":{"kind":"Name","value":"aspect_ratio"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aspect_ratio"}}},{"kind":"Argument","name":{"kind":"Name","value":"image_size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image_size"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image_data"}}]}}]}}]} as unknown as DocumentNode<EnhanceImageMutation, EnhanceImageMutationVariables>;
export const GetUserImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserImagesQuery, GetUserImagesQueryVariables>;
export const GetTeamImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamImagesQuery, GetTeamImagesQueryVariables>;
export const GetOrganisationImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationImagesQuery, GetOrganisationImagesQueryVariables>;
export const InsertUserImageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertUserImageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertUserImageMutationMutation, InsertUserImageMutationMutationVariables>;
export const InsertTeamImageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertTeamImageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"team_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_team_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertTeamImageMutationMutation, InsertTeamImageMutationMutationVariables>;
export const InsertOrganisationImageMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertOrganisationImageMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertOrganisationImageMutationMutation, InsertOrganisationImageMutationMutationVariables>;
export const InsertImageOneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"insertImageOne"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<InsertImageOneMutation, InsertImageOneMutationVariables>;
export const GetUserImagesForGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserImagesForGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserImagesForGalleryQuery, GetUserImagesForGalleryQueryVariables>;
export const GetPropertyImagesForGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyImagesForGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyImagesForGalleryQuery, GetPropertyImagesForGalleryQueryVariables>;
export const GetTeamImagesForGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamImagesForGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamImagesForGalleryQuery, GetTeamImagesForGalleryQueryVariables>;
export const DeleteUserImageFromGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserImageFromGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserImageFromGalleryMutation, DeleteUserImageFromGalleryMutationVariables>;
export const DeleteTeamImageFromGalleryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamImageFromGallery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_team_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamImageFromGalleryMutation, DeleteTeamImageFromGalleryMutationVariables>;
export const InsertTeamImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertTeamImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_team_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertTeamImageMutation, InsertTeamImageMutationVariables>;
export const LinkImageToTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkImageToTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_team_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<LinkImageToTeamMutation, LinkImageToTeamMutationVariables>;
export const SetTeamImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetTeamImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isLogo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateLogo"},"name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isLogo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"updateBanner"},"name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cover_photo_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isLogo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<SetTeamImageMutation, SetTeamImageMutationVariables>;
export const InsertUserImageAtomicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserImageAtomic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setPrimary"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aiEnhancedAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setPrimary"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_user_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"image"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"ai_enhanced_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aiEnhancedAt"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setPrimary"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<InsertUserImageAtomicMutation, InsertUserImageAtomicMutationVariables>;
export const SetPrimaryImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPrimaryImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_user_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userImageId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<SetPrimaryImageMutation, SetPrimaryImageMutationVariables>;
export const GetMaxOrderNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMaxOrderNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_images_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMaxOrderNumberQuery, GetMaxOrderNumberQueryVariables>;
export const GetAutoFilterPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterPlacesQuery, GetAutoFilterPlacesQueryVariables>;
export const GetAutoFilterUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_users"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterUsersQuery, GetAutoFilterUsersQueryVariables>;
export const GetAutoFilterTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_teams"},"name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterTeamsQuery, GetAutoFilterTeamsQueryVariables>;
export const GetAutoFilterEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutoFilterEnums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetAutoFilterEnumsQuery, GetAutoFilterEnumsQueryVariables>;
export const UpdateBuyerAutoMatchingEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBuyerAutoMatchingEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyersAutoMatchingEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyersAutoMatchingEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","alias":{"kind":"Name","value":"auto_matching_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyers_auto_matching","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automatching_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]} as unknown as DocumentNode<UpdateBuyerAutoMatchingEmailMutation, UpdateBuyerAutoMatchingEmailMutationVariables>;
export const GetListingReferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingReferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_listing_references"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference_aliases_encoded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingReferencesQuery, GetListingReferencesQueryVariables>;
export const RefreshReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefreshReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lot_reference_aliases_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}}]}}]} as unknown as DocumentNode<RefreshReferenceMutation, RefreshReferenceMutationVariables>;
export const UpdateListingMarketingFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingMarketingForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingFormData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingFormData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<UpdateListingMarketingFormMutation, UpdateListingMarketingFormMutationVariables>;
export const GetEnquiryResponseTourListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiryResponseTourListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"active"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"any"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visible"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetEnquiryResponseTourListingQuery, GetEnquiryResponseTourListingQueryVariables>;
export const GetSenderDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSenderDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<GetSenderDetailsQuery, GetSenderDetailsQueryVariables>;
export const UpsertEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingUpdates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_files_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"email_templates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"add_signature"},{"kind":"EnumValue","value":"bcc"},{"kind":"EnumValue","value":"cc"},{"kind":"EnumValue","value":"is_shared_with_everyone"},{"kind":"EnumValue","value":"is_shared_with_organisation"},{"kind":"EnumValue","value":"subject"},{"kind":"EnumValue","value":"subject_plaintext"},{"kind":"EnumValue","value":"text"},{"kind":"EnumValue","value":"text_html"},{"kind":"EnumValue","value":"text_plaintext"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingUpdates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyersAutoMatchingEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyersAutoMatchingEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","alias":{"kind":"Name","value":"auto_matching_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyers_auto_matching","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automatching_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]} as unknown as DocumentNode<UpsertEmailTemplateMutation, UpsertEmailTemplateMutationVariables>;
export const GetListingQuickActionsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingQuickActionsData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"seller_report_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"seller_report"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"brochure_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_status_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<GetListingQuickActionsDataQuery, GetListingQuickActionsDataQueryVariables>;
export const GetAggregatorListingUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAggregatorListingUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"online_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"realadvisor","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetAggregatorListingUrlQuery, GetAggregatorListingUrlQueryVariables>;
export const GetListingTransactionsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingTransactionsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<GetListingTransactionsDataQuery, GetListingTransactionsDataQueryVariables>;
export const SearchOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<SearchOrganisationsQuery, SearchOrganisationsQueryVariables>;
export const GetDefaultOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selected_organisations"},"name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSelect"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"initial_organisations"},"name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetDefaultOrganisationQuery, GetDefaultOrganisationQueryVariables>;
export const SearchPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"place_type_enum_enum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeTypes"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"population"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchPlacesQuery, SearchPlacesQueryVariables>;
export const GetPlacesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlacesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"label"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetPlacesByIdsQuery, GetPlacesByIdsQueryVariables>;
export const AutoCatchmentAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoCatchmentArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_population"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_catchment_area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_population"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_population"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AutoCatchmentAreaQuery, AutoCatchmentAreaQueryVariables>;
export const GetPlaceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchPlaceFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchPlaceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetPlaceByIdQuery, GetPlaceByIdQueryVariables>;
export const ProfileLayoutAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileLayoutAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_in_agency_pages"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"is_unclaimed"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileLayoutAgencyQuery, ProfileLayoutAgencyQueryVariables>;
export const ProfileTakedownAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfileTakedownAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"takedown_agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ProfileTakedownAgentMutation, ProfileTakedownAgentMutationVariables>;
export const ProfilePageSlackNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfilePageSlackNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"send_slack_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<ProfilePageSlackNotificationMutation, ProfilePageSlackNotificationMutationVariables>;
export const ProfileTakedownAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfileTakedownAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"takedown_agency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ProfileTakedownAgencyMutation, ProfileTakedownAgencyMutationVariables>;
export const GetPropertyDistancesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetPropertyDistances"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_property_distances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"distances"}}]}}]}}]} as unknown as DocumentNode<GetPropertyDistancesMutation, GetPropertyDistancesMutationVariables>;
export const GetPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cooling_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}}]} as unknown as DocumentNode<GetPropertyQuery, GetPropertyQueryVariables>;
export const UpdatePropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"properties_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_properties_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}}]} as unknown as DocumentNode<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const DummyMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DummyMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DummyMutationMutation, DummyMutationMutationVariables>;
export const TeamsSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamsSelect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_teams_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamsSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<TeamsSelectQuery, TeamsSelectQueryVariables>;
export const GetDefaultTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamsSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetDefaultTeamsQuery, GetDefaultTeamsQueryVariables>;
export const LoadTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamsSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamsSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<LoadTeamsQuery, LoadTeamsQueryVariables>;
export const SearchReadOnlyTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchReadOnlyTenants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"read_only_tenants_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read_only_tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReadOnlyTenantSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReadOnlyTenantSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"read_only_tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<SearchReadOnlyTenantsQuery, SearchReadOnlyTenantsQueryVariables>;
export const GetDefaultTenantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultTenant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read_only_tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReadOnlyTenantSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReadOnlyTenantSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"read_only_tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]} as unknown as DocumentNode<GetDefaultTenantQuery, GetDefaultTenantQueryVariables>;
export const TransactionCommissionsFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionCommissionsFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCommissionsFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCommissionsFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"payment_date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCommissionsFormQueryQuery, TransactionCommissionsFormQueryQueryVariables>;
export const GetBrandingValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrandingValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_valuation_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agent_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"landing_url"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_url"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"agent_id"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}}]}}]}}]}}]} as unknown as DocumentNode<GetBrandingValuesQuery, GetBrandingValuesQueryVariables>;
export const UpdateBrandingValuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrandingValues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}}]}}]}}]} as unknown as DocumentNode<UpdateBrandingValuesMutation, UpdateBrandingValuesMutationVariables>;
export const UpsertValuationLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertValuationLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert_valuation_link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"landing_url"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_url"}},{"kind":"Field","name":{"kind":"Name","value":"agent_id"}},{"kind":"Field","name":{"kind":"Name","value":"survey_id"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<UpsertValuationLinkMutation, UpsertValuationLinkMutationVariables>;
export const SearchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_users_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<SearchUsersQuery, SearchUsersQueryVariables>;
export const GetDefaultUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetDefaultUsersQuery, GetDefaultUsersQueryVariables>;
export const LoadUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<LoadUsersQuery, LoadUsersQueryVariables>;
export const DummyQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DummyQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<DummyQueryQuery, DummyQueryQueryVariables>;
export const GetTeamMemberEditDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamMemberEditDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_profile"}},{"kind":"Field","name":{"kind":"Name","value":"x_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"hires_on_realadvisor"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveModuleGrants"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveModuleGrants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}}]}}]}}]} as unknown as DocumentNode<GetTeamMemberEditDetailsQuery, GetTeamMemberEditDetailsQueryVariables>;
export const GetAgentReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer_date"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentReviewsQuery, GetAgentReviewsQueryVariables>;
export const GetAgentReviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentReviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentReviewsCountQuery, GetAgentReviewsCountQueryVariables>;
export const GetAgentTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentTransactionsQuery, GetAgentTransactionsQueryVariables>;
export const GetAgentTransactionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentTransactionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentTransactionsCountQuery, GetAgentTransactionsCountQueryVariables>;
export const GetAgencyOnlineListingsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyOnlineListingsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idx_ftp_client_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idx_agency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"online_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idx_client_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idx_ftp_client_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"agency_portal_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idx_agency_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgencyOnlineListingsCountQuery, GetAgencyOnlineListingsCountQueryVariables>;
export const GetAgencyOnlineListingsCountByNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyOnlineListingsCountByNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agency_names"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"online_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agency_names"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgencyOnlineListingsCountByNamesQuery, GetAgencyOnlineListingsCountByNamesQueryVariables>;
export const GetAgencyOnlineListingsByIdxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyOnlineListingsByIdx"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idx_ftp_client_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idx_agency_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"online_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idx_client_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idx_ftp_client_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"agency_portal_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idx_agency_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"online_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idx_client_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idx_ftp_client_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"agency_portal_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idx_agency_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}}]} as unknown as DocumentNode<GetAgencyOnlineListingsByIdxQuery, GetAgencyOnlineListingsByIdxQueryVariables>;
export const GetAgencyOnlineListingsByNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyOnlineListingsByNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agency_names"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"online_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agency_names"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"online_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agency_names"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"portal"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}}]} as unknown as DocumentNode<GetAgencyOnlineListingsByNamesQuery, GetAgencyOnlineListingsByNamesQueryVariables>;
export const GetAgencyEditDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyEditDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"x_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAgencyEditDetailsQuery, GetAgencyEditDetailsQueryVariables>;
export const GetAgencyDrawerReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyDrawerReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer_date"}}]}}]}}]} as unknown as DocumentNode<GetAgencyDrawerReviewsQuery, GetAgencyDrawerReviewsQueryVariables>;
export const GetAgencyReviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyReviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAgencyReviewsCountQuery, GetAgencyReviewsCountQueryVariables>;
export const GetAgencyDrawerTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyDrawerTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgencyDrawerTransactionsQuery, GetAgencyDrawerTransactionsQueryVariables>;
export const GetAgencyTransactionsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgencyTransactionsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgencyTransactionsCountQuery, GetAgencyTransactionsCountQueryVariables>;
export const InsertAndSetVisibilityPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertAndSetVisibilityPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clear"},"name":{"kind":"Name","value":"update_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_visibility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_visibility"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertAndSetVisibilityPhoneMutation, InsertAndSetVisibilityPhoneMutationVariables>;
export const ClearVisibilityPhonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearVisibilityPhones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_visibility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_visibility"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}}]}}]}}]}}]} as unknown as DocumentNode<ClearVisibilityPhonesMutation, ClearVisibilityPhonesMutationVariables>;
export const SetVisibilityPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetVisibilityPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"clear"},"name":{"kind":"Name","value":"update_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_visibility"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_visibility"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_visibility"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}}]}}]}}]} as unknown as DocumentNode<SetVisibilityPhoneMutation, SetVisibilityPhoneMutationVariables>;
export const GetUserImageForEnhancedActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserImageForEnhancedAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ai_enhanced_at"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserImageForEnhancedActionQuery, GetUserImageForEnhancedActionQueryVariables>;
export const DeleteNonPrimaryUserImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteNonPrimaryUserImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteNonPrimaryUserImageMutation, DeleteNonPrimaryUserImageMutationVariables>;
export const GetTransactionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionByIdQuery, GetTransactionByIdQueryVariables>;
export const GetLotWatermarkConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotWatermarkConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkConfig"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkEnabled"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_enabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_opacity"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_scale"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_rotation"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_x"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_y"}}]}}]} as unknown as DocumentNode<GetLotWatermarkConfigQuery, GetLotWatermarkConfigQueryVariables>;
export const UpdateLotWatermarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLotWatermark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkConfig"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkEnabled"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_enabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_opacity"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_scale"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_rotation"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_x"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_y"}}]}}]} as unknown as DocumentNode<UpdateLotWatermarkMutation, UpdateLotWatermarkMutationVariables>;
export const CompositeWatermarkImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompositeWatermarkImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"composite_watermark_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processed_count"}},{"kind":"Field","name":{"kind":"Name","value":"skipped_count"}}]}}]}}]} as unknown as DocumentNode<CompositeWatermarkImagesMutation, CompositeWatermarkImagesMutationVariables>;
export const GetLastLotWatermarkConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastLotWatermarkConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"watermark_enabled"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkConfig"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkEnabled"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_enabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_opacity"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_scale"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_rotation"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_x"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_position_y"}}]}}]} as unknown as DocumentNode<GetLastLotWatermarkConfigQuery, GetLastLotWatermarkConfigQueryVariables>;
export const AppraisalGraphDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AppraisalGraph"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appraisalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appraisalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppraisalDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppraisalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appraisals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"valuations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}}]}}]}}]} as unknown as DocumentNode<AppraisalGraphQuery, AppraisalGraphQueryVariables>;
export const AppraiseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Appraise"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value_property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AppraisalDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppraisalDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"appraisals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"valuations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_model"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_name"}}]}}]}}]}}]} as unknown as DocumentNode<AppraiseMutation, AppraiseMutationVariables>;
export const GetComposeEmailDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComposeEmailDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"replyToIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"recipientsById"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recipientsByEmail"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emails"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateSelect"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"replyToIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contacts"},"name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<GetComposeEmailDraftQuery, GetComposeEmailDraftQueryVariables>;
export const GetComposeEmailTemplateSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetComposeEmailTemplateSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetEmailTemplateSuggestionsLanguage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_email_template_suggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"senderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"senderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipients"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipients"}}},{"kind":"Argument","name":{"kind":"Name","value":"leadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"buyerLeadId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"enquiryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestions"}}]}}]}}]} as unknown as DocumentNode<GetComposeEmailTemplateSuggestionsQuery, GetComposeEmailTemplateSuggestionsQueryVariables>;
export const InsertLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_call_activity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"claimed_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"origination_activity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignment_activity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"call_activity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_leads_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"origination"},"name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"origination_activity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assignment"},"name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignment_activity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"call"},"name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"call_activity"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_call_activity"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"crm"}},{"kind":"ObjectField","name":{"kind":"Name","value":"claimed_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"claimed_at"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertLeadMutation, InsertLeadMutationVariables>;
export const GetLeadMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"claimed","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lead_source_types"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceName"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLeadMetadataQuery, GetLeadMetadataQueryVariables>;
export const ClaimAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claim_agency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ClaimAgencyMutation, ClaimAgencyMutationVariables>;
export const StartTrialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartTrial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_trial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<StartTrialMutation, StartTrialMutationVariables>;
export const ClaimAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClaimAgent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claim_agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ClaimAgentMutation, ClaimAgentMutationVariables>;
export const GetTeamBrokerOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamBrokerOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetTeamBrokerOptionsQuery, GetTeamBrokerOptionsQueryVariables>;
export const GetTeamHasPublicPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamHasPublicPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publishedAgentsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_users_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publishedAgentsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamHasPublicPageQuery, GetTeamHasPublicPageQueryVariables>;
export const GetTenantIntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantIntegrations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stripe"},"name":{"kind":"Name","value":"tenants_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"stripe_secret_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"close"},"name":{"kind":"Name","value":"tenants_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"close_api_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetTenantIntegrationsQuery, GetTenantIntegrationsQueryVariables>;
export const GetVisibilityStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"impressions_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"views_data"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"page_types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"agency-detail","block":false},{"kind":"StringValue","value":"agent-detail","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phone_clicks_data"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"show_phone_number","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"impressions_by_locality"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"page_location"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityStatsQuery, GetVisibilityStatsQueryVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_ids_in_led_teams"}},{"kind":"Field","name":{"kind":"Name","value":"show_plans"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_status"}},{"kind":"Field","name":{"kind":"Name","value":"has_done_onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"has_used_trial_button"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"is_unclaimed"}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}},{"kind":"Field","name":{"kind":"Name","value":"can_user_login_as"}},{"kind":"Field","name":{"kind":"Name","value":"can_edit_settings"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveModuleGrants"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"intercom_hash"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"default_pipeline_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"teams"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invalid"}},{"kind":"Field","name":{"kind":"Name","value":"self_username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_signature"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveModuleGrants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const PrepareUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mime_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepare_upload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"file_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_type"}}},{"kind":"Argument","name":{"kind":"Name","value":"file_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"mime_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mime_type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"signed_url"}}]}}]}}]} as unknown as DocumentNode<PrepareUploadMutation, PrepareUploadMutationVariables>;
export const TrackedDocumentUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrackedDocumentUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracked_document_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"document_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<TrackedDocumentUrlMutation, TrackedDocumentUrlMutationVariables>;
export const NoAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NoAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<NoAccessQuery, NoAccessQueryVariables>;
export const GetBuyerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadsQuery, GetBuyerLeadsQueryVariables>;
export const GetBuyerLeadsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadsCountQuery, GetBuyerLeadsCountQueryVariables>;
export const ImportBuyerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportBuyerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BuyerLeadImportInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import_buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}}]}}]}}]} as unknown as DocumentNode<ImportBuyerLeadsMutation, ImportBuyerLeadsMutationVariables>;
export const DeleteBuyerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteBuyerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteBuyerLeadsMutation, DeleteBuyerLeadsMutationVariables>;
export const ClaimProfileImpressionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClaimProfileImpressions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventNames"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventNames"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<ClaimProfileImpressionsQuery, ClaimProfileImpressionsQueryVariables>;
export const GetDashboardUserDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardUserData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactions"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"all_reviews_count"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetDashboardUserDataQuery, GetDashboardUserDataQueryVariables>;
export const GetDashboardNewEnquiriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardNewEnquiries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardActivityProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<GetDashboardNewEnquiriesQuery, GetDashboardNewEnquiriesQueryVariables>;
export const GetDashboardNewLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardNewLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadAgentsWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_agents_aggregate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"max"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_or_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadAgentsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}}]} as unknown as DocumentNode<GetDashboardNewLeadsQuery, GetDashboardNewLeadsQueryVariables>;
export const GetTeamVisibilityStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamVisibilityStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","alias":{"kind":"Name","value":"published_agents"},"name":{"kind":"Name","value":"teams_users_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_in_agency_pages"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamVisibilityStatusQuery, GetTeamVisibilityStatusQueryVariables>;
export const GetDashboardCmaReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardCMAReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardCmaReportsQuery, GetDashboardCmaReportsQueryVariables>;
export const GetDashboardTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allTasks"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_today"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_overdue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardActivityProperty"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardActivityProperty"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardActivityProperty"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<GetDashboardTasksQuery, GetDashboardTasksQueryVariables>;
export const GetDashboardListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"draft"},{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"},{"kind":"EnumValue","value":"paused"},{"kind":"EnumValue","value":"reserved"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"contact"},"name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"matched","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"draft"},{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"},{"kind":"EnumValue","value":"paused"},{"kind":"EnumValue","value":"reserved"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardListingsQuery, GetDashboardListingsQueryVariables>;
export const GetDashboardMlsShareRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardMlsShareRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_shares_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_shares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"requester_name"}},{"kind":"Field","name":{"kind":"Name","value":"requester_team_name"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DashboardActivityProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_shares_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DashboardActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<GetDashboardMlsShareRequestsQuery, GetDashboardMlsShareRequestsQueryVariables>;
export const DashboardFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DashboardFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"change"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pinned"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFiltersActivity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLeadSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLotSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemUserSnippet"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFiltersActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DashboardFeedQuery, DashboardFeedQueryVariables>;
export const CreateDevelopmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDevelopment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_developments_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDevelopmentMutation, CreateDevelopmentMutationVariables>;
export const GetDevelopmentBuyerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentBuyerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentBuyerLeadsActionToolbar"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentBuyerLeadsActionToolbar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"route"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentBuyerLeadsQuery, GetDevelopmentBuyerLeadsQueryVariables>;
export const UpdateFileDocumentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFileDocumentType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"document_type_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_files_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"document_type_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"document_type_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"document_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateFileDocumentTypeMutation, UpdateFileDocumentTypeMutationVariables>;
export const GetDevelopmentImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"development_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentImagesQuery, GetDevelopmentImagesQueryVariables>;
export const InsertDevelopmentImagesBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertDevelopmentImagesBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"development_images_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertDevelopmentImagesBatchMutation, InsertDevelopmentImagesBatchMutationVariables>;
export const DeleteDevelopmentImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDevelopmentImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_development_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDevelopmentImageMutation, DeleteDevelopmentImageMutationVariables>;
export const UpdateDevelopmentImagesOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopmentImagesOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"new_order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_development_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"new_order"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentImagesOrderMutation, UpdateDevelopmentImagesOrderMutationVariables>;
export const GenerateDevelopmentImageMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateDevelopmentImageMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_image_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_development_image_metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"development_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_image_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GenerateDevelopmentImageMetadataQuery, GenerateDevelopmentImageMetadataQueryVariables>;
export const UpdateDevelopmentImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopmentImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"development_images_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_development_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentImageMutation, UpdateDevelopmentImageMutationVariables>;
export const GetDevelopmentMappingDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentMappingData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mapping_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"mapping_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentMappingsLotsTable"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPriceCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentMappingsLotsTable"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPriceCell"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_mappings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"svg_path"}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentMappingDataQuery, GetDevelopmentMappingDataQueryVariables>;
export const UpdateDevelopmentMappingImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopmentMappingImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mapping_image_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mapping_image_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mapping_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mapping_image_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mapping_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"mapping_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentMappingImageMutation, UpdateDevelopmentMappingImageMutationVariables>;
export const DeleteMappingImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMappingImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mapping_image_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mapping_image_id"}}]}}]}}]} as unknown as DocumentNode<DeleteMappingImageMutation, DeleteMappingImageMutationVariables>;
export const UpsertDevelopmentMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertDevelopmentMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"svg_path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_development_mappings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"svg_path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"svg_path"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"development_mappings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"svg_path"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"svg_path"}}]}}]}}]} as unknown as DocumentNode<UpsertDevelopmentMappingMutation, UpsertDevelopmentMappingMutationVariables>;
export const DeleteDevelopmentMappingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDevelopmentMapping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_development_mappings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}}]}}]}}]} as unknown as DocumentNode<DeleteDevelopmentMappingMutation, DeleteDevelopmentMappingMutationVariables>;
export const UpdateDevelopmentEnquiryResponseEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDevelopmentEnquiryResponseEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentMarketing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentMarketing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentEnquiryResponseEmailMutation, UpdateDevelopmentEnquiryResponseEmailMutationVariables>;
export const GetDevelopmentOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCarousel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentQuickActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentOverviewForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentStakeholdersCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentSharingCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentOverviewForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_date"}},{"kind":"Field","name":{"kind":"Name","value":"registration_type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentStakeholdersCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"architect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"general_contractor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentSharingCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"development_collaborators"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentOverviewQuery, GetDevelopmentOverviewQueryVariables>;
export const UpdateDevelopmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentOverviewForm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentOverviewForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_date"}},{"kind":"Field","name":{"kind":"Name","value":"registration_type"}}]}}]} as unknown as DocumentNode<UpdateDevelopmentMutation, UpdateDevelopmentMutationVariables>;
export const UpdateDevelopmentBrokerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopmentBroker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentBrokerMutation, UpdateDevelopmentBrokerMutationVariables>;
export const UpdateDevelopmentPublishedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopmentPublished"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_published"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_published"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentPublishedMutation, UpdateDevelopmentPublishedMutationVariables>;
export const AddDevelopmentCollaboratorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddDevelopmentCollaborator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_development_collaborators_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"development_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<AddDevelopmentCollaboratorMutation, AddDevelopmentCollaboratorMutationVariables>;
export const RemoveDevelopmentCollaboratorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveDevelopmentCollaborator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_development_collaborators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"development_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<RemoveDevelopmentCollaboratorMutation, RemoveDevelopmentCollaboratorMutationVariables>;
export const UpdateDevelopmentStakeholdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopmentStakeholders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"developer_id"}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"architect_id"}},{"kind":"Field","name":{"kind":"Name","value":"architect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"general_contractor_id"}},{"kind":"Field","name":{"kind":"Name","value":"general_contractor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationInfo"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentStakeholdersMutation, UpdateDevelopmentStakeholdersMutationVariables>;
export const GetDevelopmentStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_translated_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enum_table_name"},"value":{"kind":"StringValue","value":"development_status_enum","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentStatusesQuery, GetDevelopmentStatusesQueryVariables>;
export const UpdateDevelopmentStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDevelopmentStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"development_status_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateDevelopmentStatusMutation, UpdateDevelopmentStatusMutationVariables>;
export const GetDevelopmentsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_date"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCell"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCardCarousel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCarousel"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentCardCarousel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentPrice"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"developer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSelect"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"main_image"},"name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentsListQuery, GetDevelopmentsListQueryVariables>;
export const GetDevelopmentsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentsListCountQuery, GetDevelopmentsListCountQueryVariables>;
export const GetDevelopmentDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentDetailsQuery, GetDevelopmentDetailsQueryVariables>;
export const DeleteDevelopmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDevelopment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDevelopmentMutation, DeleteDevelopmentMutationVariables>;
export const GetDevelopmentDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"development_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentDocuments"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentDocuments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"development_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentDocumentsQuery, GetDevelopmentDocumentsQueryVariables>;
export const CreateDevelopmentFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDevelopmentFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"development_files_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_development_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentDocuments"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentDocuments"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"development_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<CreateDevelopmentFileMutation, CreateDevelopmentFileMutationVariables>;
export const GetDevelopmentMarketingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentMarketing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentMarketing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentMarketing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentMarketingQuery, GetDevelopmentMarketingQueryVariables>;
export const GetAvailablePortalsForDevelopmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailablePortalsForDevelopment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_listings"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_portals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAvailablePortalsForDevelopmentQuery, GetAvailablePortalsForDevelopmentQueryVariables>;
export const GetDevelopmentPortalListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentPortalListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"development_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lots_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPriceCell"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPriceCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetDevelopmentPortalListingsQuery, GetDevelopmentPortalListingsQueryVariables>;
export const UpsertDevelopmentEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertDevelopmentEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"developmentUpdates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"developments_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_files_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"email_templates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"add_signature"},{"kind":"EnumValue","value":"bcc"},{"kind":"EnumValue","value":"cc"},{"kind":"EnumValue","value":"is_shared_with_everyone"},{"kind":"EnumValue","value":"is_shared_with_organisation"},{"kind":"EnumValue","value":"subject"},{"kind":"EnumValue","value":"subject_plaintext"},{"kind":"EnumValue","value":"text"},{"kind":"EnumValue","value":"text_html"},{"kind":"EnumValue","value":"text_plaintext"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"developmentId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"developmentUpdates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DevelopmentEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"developments"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}}]}}]} as unknown as DocumentNode<UpsertDevelopmentEmailTemplateMutation, UpsertDevelopmentEmailTemplateMutationVariables>;
export const GetDevelopmentListingCreationDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopmentListingCreationData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"last_lot"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentListingCreationDataQuery, GetDevelopmentListingCreationDataQueryVariables>;
export const GetDictEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDictEnums"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_types_enum_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries_types_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetDictEnumsQuery, GetDictEnumsQueryVariables>;
export const GetDictionariesByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDictionariesByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_types_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetDictionariesByTypeQuery, GetDictionariesByTypeQueryVariables>;
export const DeleteDictionaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDictionary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_dictionaries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDictionaryMutation, DeleteDictionaryMutationVariables>;
export const Get_Dictionary_GroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_DICTIONARY_GROUPS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"groups"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"document_type_groups"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Get_Dictionary_GroupsQuery, Get_Dictionary_GroupsQueryVariables>;
export const Get_Dictionary_ItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GET_DICTIONARY_ITEM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Get_Dictionary_ItemQuery, Get_Dictionary_ItemQueryVariables>;
export const Insert_Dictionary_ItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"INSERT_DICTIONARY_ITEM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_dictionaries_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Insert_Dictionary_ItemMutation, Insert_Dictionary_ItemMutationVariables>;
export const Update_Dictionary_ItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UPDATE_DICTIONARY_ITEM"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_dictionaries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dictionary"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DictionaryItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DictionaryItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"dictionaries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"is_deletable"}},{"kind":"Field","name":{"kind":"Name","value":"is_used"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"group_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<Update_Dictionary_ItemMutation, Update_Dictionary_ItemMutationVariables>;
export const Sync_Dictionary_EnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SYNC_DICTIONARY_ENUMS"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sync_dictionary_enums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<Sync_Dictionary_EnumsQuery, Sync_Dictionary_EnumsQueryVariables>;
export const GetDocTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<GetDocTemplatesQuery, GetDocTemplatesQueryVariables>;
export const DeleteDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDocTemplateMutation, DeleteDocTemplateMutationVariables>;
export const DuplicateDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DuplicateDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DuplicateDocTemplateMutation, DuplicateDocTemplateMutationVariables>;
export const GetDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<GetDocTemplateQuery, GetDocTemplateQueryVariables>;
export const CreateDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<CreateDocTemplateMutation, CreateDocTemplateMutationVariables>;
export const UpdateDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_doc_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<UpdateDocTemplateMutation, UpdateDocTemplateMutationVariables>;
export const SaveDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]} as unknown as DocumentNode<SaveDocTemplateMutation, SaveDocTemplateMutationVariables>;
export const GetDocTemplateVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplateVersions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_template_versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"doc_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocTemplateVersionsQuery, GetDocTemplateVersionsQueryVariables>;
export const GetDocTemplateVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplateVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_template_versions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"newest"},"name":{"kind":"Name","value":"doc_template_versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"doc_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"current"},"name":{"kind":"Name","value":"doc_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}}]} as unknown as DocumentNode<GetDocTemplateVersionQuery, GetDocTemplateVersionQueryVariables>;
export const RestoreDocTemplateVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreDocTemplateVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentContent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTranslations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb_comparison_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"content"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"translations"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentContent"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTranslations"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"Variable","name":{"kind":"Name","value":"content"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"translations"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<RestoreDocTemplateVersionMutation, RestoreDocTemplateVersionMutationVariables>;
export const UpdateTenantShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doc_template_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_tenants_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"doc_template_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doc_template_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_default"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"doc_templates_tenants_doc_template_id_tenant_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"is_default"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTenantShareMutation, UpdateTenantShareMutationVariables>;
export const DeleteTenantShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTenantShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_templates_tenants_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}}]}}]} as unknown as DocumentNode<DeleteTenantShareMutation, DeleteTenantShareMutationVariables>;
export const UpsertTeamShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertTeamShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"doc_template_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_teams_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"doc_template_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"doc_template_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_default"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"doc_templates_teams_doc_template_id_team_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"is_default"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<UpsertTeamShareMutation, UpsertTeamShareMutationVariables>;
export const DeleteTeamShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_templates_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamShareMutation, DeleteTeamShareMutationVariables>;
export const GetCmaThemePreviewSampleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaThemePreviewSample"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"doc_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaThemePreviewSampleQuery, GetCmaThemePreviewSampleQueryVariables>;
export const GetLotThemePreviewSampleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotThemePreviewSample"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brochure_doc_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"brochure_show_agent_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}}]}}]} as unknown as DocumentNode<GetLotThemePreviewSampleQuery, GetLotThemePreviewSampleQueryVariables>;
export const GetDocTemplateTypeEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTemplateTypeEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_template_type_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetDocTemplateTypeEnumQuery, GetDocTemplateTypeEnumQueryVariables>;
export const GetDocThemesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocThemes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocThemeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocThemeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_themes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"empty_files"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocThemesQuery, GetDocThemesQueryVariables>;
export const GetDocThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocThemeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocThemeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_themes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"empty_files"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocThemeQuery, GetDocThemeQueryVariables>;
export const CreateDocThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_themes_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_template_themes_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocThemeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocThemeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_themes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"empty_files"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDocThemeMutation, CreateDocThemeMutationVariables>;
export const UpdateDocThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDocTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_themes_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_doc_template_themes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocThemeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocThemeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_template_themes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"empty_files"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"content"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_themes_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateDocThemeMutation, UpdateDocThemeMutationVariables>;
export const DeleteDocThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDocTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_template_themes_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteDocThemeMutation, DeleteDocThemeMutationVariables>;
export const CreateDocThemeFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocThemeFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"theme_id"}}]}}]}}]} as unknown as DocumentNode<CreateDocThemeFileMutation, CreateDocThemeFileMutationVariables>;
export const GetDocThemeFilesContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocThemeFilesContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"theme_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theme_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"theme_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}}]} as unknown as DocumentNode<GetDocThemeFilesContentQuery, GetDocThemeFilesContentQueryVariables>;
export const UpsertThemeTenantShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertThemeTenantShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"theme_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_template_themes_tenants_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theme_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"theme_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenant_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_default"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"doc_template_themes_tenants_theme_id_tenant_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"is_default"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<UpsertThemeTenantShareMutation, UpsertThemeTenantShareMutationVariables>;
export const DeleteThemeTenantShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteThemeTenantShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_template_themes_tenants_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteThemeTenantShareMutation, DeleteThemeTenantShareMutationVariables>;
export const UpsertThemeTeamShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertThemeTeamShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"theme_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_doc_template_themes_teams_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"theme_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"theme_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_default"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_default"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"doc_template_themes_teams_theme_id_team_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"is_default"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<UpsertThemeTeamShareMutation, UpsertThemeTeamShareMutationVariables>;
export const DeleteThemeTeamShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteThemeTeamShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_doc_template_themes_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteThemeTeamShareMutation, DeleteThemeTeamShareMutationVariables>;
export const EmailCampaignsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailCampaignsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_campaigns_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_campaigns_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_campaigns_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_campaigns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"first_message"},"name":{"kind":"Name","value":"email_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject_template"}},{"kind":"Field","name":{"kind":"Name","value":"body_template"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"total"},"name":{"kind":"Name","value":"email_messages_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sent"},"name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"sent","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"error"},"name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"error","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pending"},"name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"pending","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailCampaignsListQuery, EmailCampaignsListQueryVariables>;
export const EmailCampaignPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailCampaignPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_campaigns_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"first_message"},"name":{"kind":"Name","value":"email_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject_template"}},{"kind":"Field","name":{"kind":"Name","value":"body_template"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"total"},"name":{"kind":"Name","value":"email_messages_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"sent"},"name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"sent","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"error"},"name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"error","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pending"},"name":{"kind":"Name","value":"email_messages_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"pending","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailCampaignPreviewQuery, EmailCampaignPreviewQueryVariables>;
export const EmailCampaignRecipientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailCampaignRecipients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_campaigns_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"recipients"},"name":{"kind":"Name","value":"email_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"error_message"}}]}}]}}]}}]} as unknown as DocumentNode<EmailCampaignRecipientsQuery, EmailCampaignRecipientsQueryVariables>;
export const MassMailListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MassMailListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MassMailListingsQuery, MassMailListingsQueryVariables>;
export const EmailPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_signature"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"email_display_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_login"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invalid"}},{"kind":"Field","name":{"kind":"Name","value":"self_nylas_provider"}},{"kind":"Field","name":{"kind":"Name","value":"self_username"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nylas_account_config"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sync_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"sync_state"}},{"kind":"Field","name":{"kind":"Name","value":"calendar_sync_enabled"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EmailPreferencesQuery, EmailPreferencesQueryVariables>;
export const UpdateEmailPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEmailPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email_signature"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email_signature_html"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email_display_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_email_preferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email_signature"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email_signature"}}},{"kind":"Argument","name":{"kind":"Name","value":"email_signature_html"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email_signature_html"}}},{"kind":"Argument","name":{"kind":"Name","value":"email_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"email_display_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email_display_name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>;
export const EmailTemplatesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailTemplatesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<EmailTemplatesListQuery, EmailTemplatesListQueryVariables>;
export const GetEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export const GetEmailTemplatePreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmailTemplatePreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text_html"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEmailTemplatePreviewQuery, GetEmailTemplatePreviewQueryVariables>;
export const DeleteEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_email_templates_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables>;
export const UpsertStandaloneEmailTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertStandaloneEmailTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates_files_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplate"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"email_templates_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"add_signature"},{"kind":"EnumValue","value":"is_shared_with_everyone"},{"kind":"EnumValue","value":"is_shared_with_organisation"},{"kind":"EnumValue","value":"subject"},{"kind":"EnumValue","value":"subject_plaintext"},{"kind":"EnumValue","value":"text"},{"kind":"EnumValue","value":"text_html"},{"kind":"EnumValue","value":"text_plaintext"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject_plaintext"}},{"kind":"Field","name":{"kind":"Name","value":"text_html"}},{"kind":"Field","name":{"kind":"Name","value":"text_plaintext"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email_template_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailTemplateId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_email_templates_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertStandaloneEmailTemplateMutation, UpsertStandaloneEmailTemplateMutationVariables>;
export const EmailThreadsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EmailThreadsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_threads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"email_threads_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_threads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_received_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"last_message_sent_timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"last_received_message"},"name":{"kind":"Name","value":"email_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_sent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sent"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_sent_message"},"name":{"kind":"Name","value":"email_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_sent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]} as unknown as DocumentNode<EmailThreadsListQuery, EmailThreadsListQueryVariables>;
export const GetEmailThreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmailThread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"messagesLimit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_threads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"messagesLimit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"files"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}}]}}]}}]}}]} as unknown as DocumentNode<GetEmailThreadQuery, GetEmailThreadQueryVariables>;
export const UpdateEmailThreadVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEmailThreadVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_email_thread_visibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"thread_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"visibility"},"value":{"kind":"Variable","name":{"kind":"Name","value":"visibility"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]}}]} as unknown as DocumentNode<UpdateEmailThreadVisibilityMutation, UpdateEmailThreadVisibilityMutationVariables>;
export const MarkEmailThreadReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkEmailThreadRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mark_email_thread_read"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"thread_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}}]}}]}}]} as unknown as DocumentNode<MarkEmailThreadReadMutation, MarkEmailThreadReadMutationVariables>;
export const GetEmailMessageFilingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmailMessageFiling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email_message_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailMessageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}}]}}]}}]} as unknown as DocumentNode<GetEmailMessageFilingQuery, GetEmailMessageFilingQueryVariables>;
export const GetEnquiryBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiryBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnquiryCreateBuyerLead"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnquiryCreateBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email_address"}},{"kind":"Field","name":{"kind":"Name","value":"raw_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}}]}}]} as unknown as DocumentNode<GetEnquiryBuyerLeadQuery, GetEnquiryBuyerLeadQueryVariables>;
export const AssignEnquiryListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignEnquiryListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnquiryCreateBuyerLead"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnquiryCreateBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"raw_email_address"}},{"kind":"Field","name":{"kind":"Name","value":"raw_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}}]}}]} as unknown as DocumentNode<AssignEnquiryListingMutation, AssignEnquiryListingMutationVariables>;
export const CreateMissingBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMissingBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_enquiry_buyer_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"enquiryId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<CreateMissingBuyerLeadMutation, CreateMissingBuyerLeadMutationVariables>;
export const AttachBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AttachBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<AttachBuyerLeadMutation, AttachBuyerLeadMutationVariables>;
export const GetListingBuyerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingBuyerLeadsQuery, GetListingBuyerLeadsQueryVariables>;
export const FindMatchingUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindMatchingUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emails"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"phone_numbers"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumber"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FindMatchingUserQuery, FindMatchingUserQueryVariables>;
export const GetEnquiriesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiriesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetEnquiriesListQuery, GetEnquiriesListQueryVariables>;
export const GetEnquiriesListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiriesListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetEnquiriesListCountQuery, GetEnquiriesListCountQueryVariables>;
export const GetEnquiryTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiryType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetEnquiryTypeQuery, GetEnquiryTypeQueryVariables>;
export const GetEnquiryContactRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquiryContactRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactRequestEnquiry"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactRequestEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}}]}}]}}]}}]} as unknown as DocumentNode<GetEnquiryContactRequestQuery, GetEnquiryContactRequestQueryVariables>;
export const DeleteEnquiryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEnquiry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteEnquiryMutation, DeleteEnquiryMutationVariables>;
export const UpdateEnquiryResponseActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEnquiryResponseActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"responseActivityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadStage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateBuyerLeadStage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiryId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"response_activity_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseActivityId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"processed"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"response_activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"active"}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadStage"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateBuyerLeadStage"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_activities_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"responseActivityId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}}]}}]}}]} as unknown as DocumentNode<UpdateEnquiryResponseActivityMutation, UpdateEnquiryResponseActivityMutationVariables>;
export const GetBrochureSentStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrochureSentStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brochure_sent","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetBrochureSentStageQuery, GetBrochureSentStageQueryVariables>;
export const MarkEnquiryAsProcessedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkEnquiryAsProcessed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processed"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}}]}}]}}]} as unknown as DocumentNode<MarkEnquiryAsProcessedMutation, MarkEnquiryAsProcessedMutationVariables>;
export const ValidateInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ValidateInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validate_invitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"magic_token"}}]}}]}}]} as unknown as DocumentNode<ValidateInvitationQuery, ValidateInvitationQueryVariables>;
export const GetLeadDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"potential_development"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_enquiry"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertySearchesCardPropertySearches"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_listing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dictionary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"report_source"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_enquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertySearchesCardPropertySearches"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadDetailsQuery, GetLeadDetailsQueryVariables>;
export const LeadDetailsDrawerDeleteLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeadDetailsDrawerDeleteLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LeadDetailsDrawerDeleteLeadMutation, LeadDetailsDrawerDeleteLeadMutationVariables>;
export const GetLeadAgentStatusDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadAgentStatusDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadAgentStatusDrawerQuery, GetLeadAgentStatusDrawerQueryVariables>;
export const GetDuplicateStageDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDuplicateStageDrawer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"is_a_duplicate","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetDuplicateStageDrawerQuery, GetDuplicateStageDrawerQueryVariables>;
export const SelfAssignLeadAgentDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SelfAssignLeadAgentDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"claimed_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"crm"}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"claimed_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"claimed_at"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAgent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SelfAssignLeadAgentDrawerMutation, SelfAssignLeadAgentDrawerMutationVariables>;
export const GetTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamMembersQuery, GetTeamMembersQueryVariables>;
export const CreateFileWithPropertyLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFileWithPropertyLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_files_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateFileWithPropertyLinkMutation, CreateFileWithPropertyLinkMutationVariables>;
export const GetLeadsTheSameAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadsTheSameAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_the_same_address"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadsTheSameAddressQuery, GetLeadsTheSameAddressQueryVariables>;
export const ProspectionLeadContactStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionLeadContactStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_map_contact_attempts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"declined_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"declined_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"declined_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prospection_map_emailable_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}}]}}]} as unknown as DocumentNode<ProspectionLeadContactStatusQuery, ProspectionLeadContactStatusQueryVariables>;
export const GetLeadDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"dictionary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"tags_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetLeadDataQuery, GetLeadDataQueryVariables>;
export const UpdateLeadTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLeadTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removedTags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newTags"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_tags_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_leads_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removedTags"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_leads_tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newTags"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateLeadTagsMutation, UpdateLeadTagsMutationVariables>;
export const GetLeadAgentStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadAgentStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadAgentStatusQuery, GetLeadAgentStatusQueryVariables>;
export const UpdateLeadContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLeadContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contact_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}}]}}]}}]} as unknown as DocumentNode<UpdateLeadContactMutation, UpdateLeadContactMutationVariables>;
export const GetValuationDataForLeadDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValuationDataForLeadDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_appraisable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisable"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"appraisal_report"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<GetValuationDataForLeadDetailsQuery, GetValuationDataForLeadDetailsQueryVariables>;
export const GetCmaReportForPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReportForPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CMAReportEditor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportInclude"}},{"kind":"Field","name":{"kind":"Name","value":"report_source"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CMAReportEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"include_introduction"}},{"kind":"Field","name":{"kind":"Name","value":"include_property"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"include_poi_map"}},{"kind":"Field","name":{"kind":"Name","value":"poi_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_cuprate_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_intrinsic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_final_value"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent_agency"}},{"kind":"Field","name":{"kind":"Name","value":"include_client_testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"include_append_files"}},{"kind":"Field","name":{"kind":"Name","value":"include_market_data"}}]}}]} as unknown as DocumentNode<GetCmaReportForPreviewQuery, GetCmaReportForPreviewQueryVariables>;
export const UsersForSubjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersForSubject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]} as unknown as DocumentNode<UsersForSubjectQuery, UsersForSubjectQueryVariables>;
export const GetLeadOneClickCmaTourLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadOneClickCmaTourLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_agents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_reports"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appraisals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"min"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"max"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visible"},"name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_reports"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appraisals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"min"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"max"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetLeadOneClickCmaTourLeadQuery, GetLeadOneClickCmaTourLeadQueryVariables>;
export const AssignBrokerWithActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignBrokerWithActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assignment_activities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_agents"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities_updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_updates"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_agents_to_remove"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reassignments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_updates"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities_updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assignment_activities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_agents"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"lead_agents_lead_id_user_id_source_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"passed_at"},{"kind":"EnumValue","value":"stage_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_agents_to_remove"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reassignments"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AssignBrokerWithActivitiesMutation, AssignBrokerWithActivitiesMutationVariables>;
export const GetLeadsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leads_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"owner_initiated_sources"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agent_source_enum_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leads_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"owner_initiated_sources"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"assign","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"team_members"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker_team_memberships"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<GetLeadsDataQuery, GetLeadsDataQueryVariables>;
export const GetPipelinesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipelines"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_type"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"new","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<GetPipelinesQuery, GetPipelinesQueryVariables>;
export const UpdateMultipleLeadsStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMultipleLeadsStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_updates"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMultipleLeadsStageMutation, UpdateMultipleLeadsStageMutationVariables>;
export const GetLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_order_by"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsListItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsListRowActivities"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_or_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsListRowActivities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"next_activity_assigned_to"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity_assigned_to"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}}]}}]} as unknown as DocumentNode<GetLeadsQuery, GetLeadsQueryVariables>;
export const SearchLeadsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLeadsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_order_by"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"leads"},"name":{"kind":"Name","value":"search_leads_tsv"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsListItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsListRowActivities"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_date"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_or_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"EnumValue","value":"user_id"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsListRowActivities"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"next_activity_assigned_to"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity_assigned_to"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasUserFilter"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityCell"}}]}}]}}]} as unknown as DocumentNode<SearchLeadsListQuery, SearchLeadsListQueryVariables>;
export const GetKanbanLeadsAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKanbanLeadsAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where_leads"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_leads"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_leads"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsKanbanColumnItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where_leads"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_leads"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsKanbanColumnLead"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAppraisalLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lat"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_lng"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsKanbanColumnLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAppraisalLocation"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadsKanbanColumnItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadsKanbanColumnLead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}}]} as unknown as DocumentNode<GetKanbanLeadsAgentsQuery, GetKanbanLeadsAgentsQueryVariables>;
export const GetKanbanLeadsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKanbanLeadsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where_leads"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_leads"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_leads"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where_leads"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_leads"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetKanbanLeadsCountQuery, GetKanbanLeadsCountQueryVariables>;
export const GetLeadsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadsCountQuery, GetLeadsCountQueryVariables>;
export const SearchLeadsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLeadsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"leads_aggregate"},"name":{"kind":"Name","value":"search_leads_tsv_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search_text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<SearchLeadsListCountQuery, SearchLeadsListCountQueryVariables>;
export const GetLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingCardLeadFragment"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactCardUserFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"assign","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingCardLeadFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactCardUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserEmails"}}]}}]} as unknown as DocumentNode<GetLeadQuery, GetLeadQueryVariables>;
export const LeadFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activities"},"name":{"kind":"Name","value":"get_activities_feed_for_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFiltersActivity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLeadSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLotSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemUserSnippet"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFiltersActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LeadFeedQuery, LeadFeedQueryVariables>;
export const OldLeadFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OldLeadFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activities"},"name":{"kind":"Name","value":"get_activities_feed_for_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"activityFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"activityFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"end_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"unread"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"nylas_thread_id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<OldLeadFeedQuery, OldLeadFeedQueryVariables>;
export const GetLeadAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner_team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAgent"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadAgentsQuery, GetLeadAgentsQueryVariables>;
export const AddLeadAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddLeadAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activity_object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"crm"}},{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"lead_agents_lead_id_user_id_source_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"passed_at"},{"kind":"EnumValue","value":"stage_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activity_object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddLeadAgentMutation, AddLeadAgentMutationVariables>;
export const DeleteLeadAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLeadAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lead_agents_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assignment"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assigned_to"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteLeadAgentMutation, DeleteLeadAgentMutationVariables>;
export const UpdateLeadAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLeadAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadAgent"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadAgent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"win_probability"}},{"kind":"Field","name":{"kind":"Name","value":"predicted_win_date"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLeadAgentsMutation, UpdateLeadAgentsMutationVariables>;
export const GetBrokeragePipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokeragePipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"brokerage","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBrokeragePipelineQuery, GetBrokeragePipelineQueryVariables>;
export const GetPipelineStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipelineStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPipelineStagesQuery, GetPipelineStagesQueryVariables>;
export const GetLeadAgentSelectCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadAgentSelectCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner_team_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<GetLeadAgentSelectCardQuery, GetLeadAgentSelectCardQueryVariables>;
export const AssignBrokerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignBroker"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activity_object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reassignment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents_updates"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keep_tasks"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"assignment"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"assignee"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"keep_tasks"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activity_object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lead_agents_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"EnumValue","value":"crm"}},{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"NullValue"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"lead_agents_lead_id_user_id_source_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"passed_at"},{"kind":"EnumValue","value":"stage_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lead_agents_many"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updates"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"reassignment"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AssignBrokerMutation, AssignBrokerMutationVariables>;
export const GetListingBrochureTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBrochureTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"brochure_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<GetListingBrochureTemplatesQuery, GetListingBrochureTemplatesQueryVariables>;
export const GetListingBrochureStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBrochureStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"document_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document_type"},"value":{"kind":"StringValue","value":"lot_brochure","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_opens"}},{"kind":"Field","name":{"kind":"Name","value":"unique_opens"}},{"kind":"Field","name":{"kind":"Name","value":"unidentified_opens"}},{"kind":"Field","name":{"kind":"Name","value":"daily"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"unique"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingBrochureStatsQuery, GetListingBrochureStatsQueryVariables>;
export const GetListingBuyersLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyersLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeBuyerLeads"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"matched_stage"},"name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"matched","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerLeadsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeBuyerLeads"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"all_buyer_leads"},"name":{"kind":"Name","value":"buyer_leads"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeBuyerLeads"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"country"},{"kind":"EnumValue","value":"region"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}}]}}]}}]} as unknown as DocumentNode<GetListingBuyersLeadQuery, GetListingBuyersLeadQueryVariables>;
export const GetListingDuplicateDialogDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDuplicateDialogData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_files_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingDuplicateDialogDataQuery, GetListingDuplicateDialogDataQueryVariables>;
export const GetListingDuplicationDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDuplicationData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDocuments"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePhotos"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_es"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDocuments"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePhotos"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingDuplicationDataQuery, GetListingDuplicationDataQueryVariables>;
export const GetListingMarketingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingMarketing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingFormData"}},{"kind":"Field","name":{"kind":"Name","value":"enable_auto_matching"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}},{"kind":"Field","name":{"kind":"Name","value":"send_enquiries_to_sellers"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormLotSnippetData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingFormData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormLotSnippetData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingMarketingQuery, GetListingMarketingQueryVariables>;
export const UpdateEnquiryReponseEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEnquiryReponseEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEnquiryResponseEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","alias":{"kind":"Name","value":"enquiry_response_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"response_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}},{"kind":"Field","name":{"kind":"Name","value":"development"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_override_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"enquiry_auto_response","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateEnquiryReponseEmailMutation, UpdateEnquiryReponseEmailMutationVariables>;
export const GetListingOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"made_on"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeOfferStatusModal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeOfferStatusModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingOffersQuery, GetListingOffersQueryVariables>;
export const UpdateListingSellersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateListingSellers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lot_sellers_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lot_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_lot_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<UpdateListingSellersMutation, UpdateListingSellersMutationVariables>;
export const GetPropertyImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"watermark_lots"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotWatermarkEnabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"is_floor_plan"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyImageVersionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotWatermarkEnabled"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"watermark_enabled"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyImageVersionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_image_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetPropertyImagesQuery, GetPropertyImagesQueryVariables>;
export const GetPropertyImagesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyImagesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_images_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyImagesCountQuery, GetPropertyImagesCountQueryVariables>;
export const InsertPropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<InsertPropertyImageMutation, InsertPropertyImageMutationVariables>;
export const InsertPropertyImagesBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertyImagesBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"is_floor_plan"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyImageVersionFields"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyImageVersionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_image_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<InsertPropertyImagesBatchMutation, InsertPropertyImagesBatchMutationVariables>;
export const DeletePropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePropertyImageMutation, DeletePropertyImageMutationVariables>;
export const UpdatePropertyImagesOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyImagesOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"new_order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"new_order"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyImagesOrderMutation, UpdatePropertyImagesOrderMutationVariables>;
export const UpdatePropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"is_floor_plan"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyImageMutation, UpdatePropertyImageMutationVariables>;
export const SavePropertyImageVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SavePropertyImageVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newImageUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sourceImageId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expectedCurrentImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"save_property_image_version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyImageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"new_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newImageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"new_image_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newImageUrl"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"source_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sourceImageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"version_prompt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prompt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expected_current_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expectedCurrentImageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyImageVersionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyImageVersionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_image_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<SavePropertyImageVersionMutation, SavePropertyImageVersionMutationVariables>;
export const ActivatePropertyImageVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivatePropertyImageVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"targetImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expectedCurrentImageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activate_property_image_version"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyImageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"targetImageId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"expected_current_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expectedCurrentImageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyImageVersionFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyImageVersionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_image_versions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"source_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ActivatePropertyImageVersionMutation, ActivatePropertyImageVersionMutationVariables>;
export const GenerateImageMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateImageMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_image_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_image_metadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_image_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GenerateImageMetadataQuery, GenerateImageMetadataQueryVariables>;
export const GetListingTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeValuations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionsListRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionsListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"total","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_commissions"},"name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"split","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"beneficiary_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transaction_valuations_aggregate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeValuations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingTransactionsQuery, GetListingTransactionsQueryVariables>;
export const GetListingBuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<GetListingBuyersQuery, GetListingBuyersQueryVariables>;
export const GetDocumentRecipientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentRecipients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_recipients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"document_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recipients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"total_opens"}},{"kind":"Field","name":{"kind":"Name","value":"unique_opens"}},{"kind":"Field","name":{"kind":"Name","value":"last_open_at"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentRecipientsQuery, GetDocumentRecipientsQueryVariables>;
export const TrackedBrochureLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TrackedBrochureLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracked_document_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"document_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentType"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipient_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<TrackedBrochureLinkMutation, TrackedBrochureLinkMutationVariables>;
export const GetBrochureRecipientStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrochureRecipientStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document_stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"document_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"document_type"},"value":{"kind":"StringValue","value":"lot_brochure","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"recipient_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientId"}}},{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_opens"}},{"kind":"Field","name":{"kind":"Name","value":"unique_opens"}},{"kind":"Field","name":{"kind":"Name","value":"daily"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"unique"}}]}}]}}]}}]} as unknown as DocumentNode<GetBrochureRecipientStatsQuery, GetBrochureRecipientStatsQueryVariables>;
export const GetListingBuyersAutoMatchingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyersAutoMatching"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"enable_auto_matching"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyersAutoMatchingEmail"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AutoMatchingFilters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"email_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"add_signature"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_organisation"}},{"kind":"Field","name":{"kind":"Name","value":"is_shared_with_everyone"}},{"kind":"Field","name":{"kind":"Name","value":"email_templates_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailSender"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}},{"kind":"Field","name":{"kind":"Name","value":"branding_logo"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"branding_name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_website"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"nylas_account"},"name":{"kind":"Name","value":"logins"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"nylas-v3","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"country"},{"kind":"EnumValue","value":"region"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyersAutoMatchingEmail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","alias":{"kind":"Name","value":"auto_matching_email_templates"},"name":{"kind":"Name","value":"email_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyers_auto_matching","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"automatching_sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailSender"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AutoMatchingFilters"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultBuyersMatchingFilters"}}]}}]} as unknown as DocumentNode<GetListingBuyersAutoMatchingQuery, GetListingBuyersAutoMatchingQueryVariables>;
export const UpdateListingBuyersAutoMatchingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingBuyersAutoMatching"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enable_auto_matching"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_response_enabled"}}]}}]}}]} as unknown as DocumentNode<UpdateListingBuyersAutoMatchingMutation, UpdateListingBuyersAutoMatchingMutationVariables>;
export const GetListingPortalsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingPortalsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketingFormData"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketingFormData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"listing_url"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<GetListingPortalsSettingsQuery, GetListingPortalsSettingsQueryVariables>;
export const UpdateListingReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_reference"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_reference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_reference"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}}]}}]}}]} as unknown as DocumentNode<UpdateListingReferenceMutation, UpdateListingReferenceMutationVariables>;
export const GetRentedRoomEnumLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRentedRoomEnumLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"bed_type_options"},"name":{"kind":"Name","value":"get_translated_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enum_table_name"},"value":{"kind":"StringValue","value":"bed_type_enum","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"window_view_options"},"name":{"kind":"Name","value":"get_translated_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enum_table_name"},"value":{"kind":"StringValue","value":"window_view_enum","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tenant_gender_options"},"name":{"kind":"Name","value":"get_translated_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enum_table_name"},"value":{"kind":"StringValue","value":"tenant_gender_enum","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetRentedRoomEnumLabelsQuery, GetRentedRoomEnumLabelsQueryVariables>;
export const ListingEnquiriesOverTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingEnquiriesOverTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ListingEnquiriesOverTimeQuery, ListingEnquiriesOverTimeQueryVariables>;
export const ListingBuyerLeadsOverTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingBuyerLeadsOverTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<ListingBuyerLeadsOverTimeQuery, ListingBuyerLeadsOverTimeQueryVariables>;
export const ListingOffersOverTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingOffersOverTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"made_on"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ListingOffersOverTimeQuery, ListingOffersOverTimeQueryVariables>;
export const ListingFunnelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingFunnel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"realadvisorPortalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"realadvisor_portal_listings"},"name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"realadvisorPortalId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"milliseconds_online"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"enquiries"},"name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lot_buyer_leads"},"name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","alias":{"kind":"Name","value":"successful_viewings"},"name":{"kind":"Name","value":"activities_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"visit"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"due_at"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lot_offers"},"name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_id"}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}}]}}]}}]} as unknown as DocumentNode<ListingFunnelQuery, ListingFunnelQueryVariables>;
export const ListingDomDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingDom"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"get_lot_publication_history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"history"}}]}}]}}]} as unknown as DocumentNode<ListingDomQuery, ListingDomQueryVariables>;
export const ListingInsightsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingInsights"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"staleFloor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"staleBefore"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recentFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priorFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"monthFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"now"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unanswered"},"name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"response_activity_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"staleFloor"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"staleBefore"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pending_offers"},"name":{"kind":"Name","value":"offers_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recent_enquiries"},"name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recentFrom"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"prior_enquiries"},"name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priorFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recentFrom"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recent_viewings"},"name":{"kind":"Name","value":"activities_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"visit"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recentFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enquiry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"prior_viewings"},"name":{"kind":"Name","value":"activities_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"visit"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priorFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recentFrom"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enquiry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"month_enquiries"},"name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthFrom"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"month_viewings"},"name":{"kind":"Name","value":"activities_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"visit"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"due_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"monthFrom"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"now"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enquiry"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ListingInsightsQuery, ListingInsightsQueryVariables>;
export const ListingBenchmarkSubjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingBenchmarkSubject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListingBenchmarkSubjectQuery, ListingBenchmarkSubjectQueryVariables>;
export const ListingComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"original_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"agency_reference"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"original_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"agency_reference"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"original_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"agency_reference"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"original_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"agency_reference"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListingComparablesQuery, ListingComparablesQueryVariables>;
export const ListingTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_property_transactions_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_target_property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_max_distance_meters"},"value":{"kind":"IntValue","value":"50000"}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_max_results"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_match_main_type"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_years_back"},"value":{"kind":"IntValue","value":"2"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}}]}}]}}]}}]} as unknown as DocumentNode<ListingTransactionsQuery, ListingTransactionsQueryVariables>;
export const ListingTransactionPriceStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingTransactionPriceStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"placeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateMin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_price_stats_historical"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"place_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateMin"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"number_of_rooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_main_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ALL","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_m2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_price_stats_historical"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"place_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateMin"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"number_of_rooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_main_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ALL","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_m2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_price_stats_historical"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"place_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateMin"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"number_of_rooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_main_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ALL","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_m2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_price_stats_historical"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"place_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"placeIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateMin"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"number_of_rooms"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_main_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"ALL","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_m2"}}]}}]}}]} as unknown as DocumentNode<ListingTransactionPriceStatsQuery, ListingTransactionPriceStatsQueryVariables>;
export const ListingGa4StatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingGa4Stats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_ga4_stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateFrom"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dateTo"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"event_name"}},{"kind":"Field","name":{"kind":"Name","value":"item_list_id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ListingGa4StatsQuery, ListingGa4StatsQueryVariables>;
export const GetListingBrochureTourOwnListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBrochureTourOwnListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"},{"kind":"EnumValue","value":"reserved"},{"kind":"EnumValue","value":"paused"},{"kind":"EnumValue","value":"draft"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetListingBrochureTourOwnListingQuery, GetListingBrochureTourOwnListingQueryVariables>;
export const GetListingBrochureTourAnyListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBrochureTourAnyListing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetListingBrochureTourAnyListingQuery, GetListingBrochureTourAnyListingQueryVariables>;
export const GetListingBuyersDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyersDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enable_auto_matching"}},{"kind":"Field","name":{"kind":"Name","value":"offers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardRow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"viewings_pending"},"name":{"kind":"Name","value":"activities_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"visit"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"viewings_done"},"name":{"kind":"Name","value":"activities_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"visit"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}}]}}]} as unknown as DocumentNode<GetListingBuyersDashboardQuery, GetListingBuyersDashboardQueryVariables>;
export const GetListingBuyerLeadsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyerLeadsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"note"},{"kind":"EnumValue","value":"assignment"},{"kind":"EnumValue","value":"task"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}}]}}]} as unknown as DocumentNode<GetListingBuyerLeadsListQuery, GetListingBuyerLeadsListQueryVariables>;
export const GetListingEmailCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingEmailCampaigns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"email"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"email_message"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"campaign_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaign_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingEmailCampaignsQuery, GetListingEmailCampaignsQueryVariables>;
export const GetListingEmailCampaignRecipientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingEmailCampaignRecipients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"email"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"email_message"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"campaign_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingEmailCampaignActivity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingEmailCampaignActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"campaign_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"error_message"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]} as unknown as DocumentNode<GetListingEmailCampaignRecipientsQuery, GetListingEmailCampaignRecipientsQueryVariables>;
export const GetListingBuyersTourListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingBuyersTourListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"withBuyers"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_leads"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"any"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visibleWithBuyers"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_leads"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetListingBuyersTourListingQuery, GetListingBuyersTourListingQueryVariables>;
export const GetListingWatermarkTourListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingWatermarkTourListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"own"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visible"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetListingWatermarkTourListingQuery, GetListingWatermarkTourListingQueryVariables>;
export const GetLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]}}]} as unknown as DocumentNode<GetLotQuery, GetLotQueryVariables>;
export const GetLotsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotCardCarousel_lot"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotCardInfo_lot"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingsDetailedView"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lots_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardCarousel_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingsDetailedView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetLotsListQuery, GetLotsListQueryVariables>;
export const GetLotsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLotsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetLotsListCountQuery, GetLotsListCountQueryVariables>;
export const TogglePortalListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TogglePortalListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip_ftp_check"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggle_portal_listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip_ftp_check"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip_ftp_check"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"milliseconds_online"}},{"kind":"Field","name":{"kind":"Name","value":"last_publication_warnings"}}]}}]}}]} as unknown as DocumentNode<TogglePortalListingMutation, TogglePortalListingMutationVariables>;
export const SyncPortalListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncPortalListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_portal_listing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"warnings"}}]}}]}}]} as unknown as DocumentNode<SyncPortalListingMutation, SyncPortalListingMutationVariables>;
export const GetAvailableListingPortalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAvailableListingPortals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_listings"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_portals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAvailableListingPortalsQuery, GetAvailableListingPortalsQueryVariables>;
export const DeleteLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLotMutation, DeleteLotMutationVariables>;
export const LotFeedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LotFeed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activities"},"name":{"kind":"Name","value":"get_activities_feed_for_lot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFiltersActivity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLeadSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLotSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemUserSnippet"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFiltersActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LotFeedQuery, LotFeedQueryVariables>;
export const GetListingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_phone"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerNotificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference_alias_decoded"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentedRoomDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_number"}},{"kind":"Field","name":{"kind":"Name","value":"minimal_stay"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_gender"}},{"kind":"Field","name":{"kind":"Name","value":"youngest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"oldest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"smoking_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"couples_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"pets_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"occupied_now"}},{"kind":"Field","name":{"kind":"Name","value":"furnished"}},{"kind":"Field","name":{"kind":"Name","value":"owner_living"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bed_type"}},{"kind":"Field","name":{"kind":"Name","value":"window_view"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentedRoomDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetListingDetailsQuery, GetListingDetailsQueryVariables>;
export const GetListingEditContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingEditContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cooling_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"bed_type_options"},"name":{"kind":"Name","value":"get_translated_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enum_table_name"},"value":{"kind":"StringValue","value":"bed_type_enum","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"window_view_options"},"name":{"kind":"Name","value":"get_translated_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enum_table_name"},"value":{"kind":"StringValue","value":"window_view_enum","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"tenant_gender_options"},"name":{"kind":"Name","value":"get_translated_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"enum_table_name"},"value":{"kind":"StringValue","value":"tenant_gender_enum","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetListingEditContextQuery, GetListingEditContextQueryVariables>;
export const UpdateListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_phone"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerNotificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference_alias_decoded"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentedRoomDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_number"}},{"kind":"Field","name":{"kind":"Name","value":"minimal_stay"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_gender"}},{"kind":"Field","name":{"kind":"Name","value":"youngest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"oldest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"smoking_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"couples_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"pets_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"occupied_now"}},{"kind":"Field","name":{"kind":"Name","value":"furnished"}},{"kind":"Field","name":{"kind":"Name","value":"owner_living"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bed_type"}},{"kind":"Field","name":{"kind":"Name","value":"window_view"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentedRoomDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateListingMutation, UpdateListingMutationVariables>;
export const UpdateListingTrackedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateListingTracked"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasActivities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasActivities"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_phone"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerNotificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference_alias_decoded"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentedRoomDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_number"}},{"kind":"Field","name":{"kind":"Name","value":"minimal_stay"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_gender"}},{"kind":"Field","name":{"kind":"Name","value":"youngest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"oldest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"smoking_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"couples_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"pets_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"occupied_now"}},{"kind":"Field","name":{"kind":"Name","value":"furnished"}},{"kind":"Field","name":{"kind":"Name","value":"owner_living"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bed_type"}},{"kind":"Field","name":{"kind":"Name","value":"window_view"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentedRoomDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateListingTrackedMutation, UpdateListingTrackedMutationVariables>;
export const CreateListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertListingLotsInsertInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lots_derived"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lot"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_phone"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerNotificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference_alias_decoded"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentedRoomDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_number"}},{"kind":"Field","name":{"kind":"Name","value":"minimal_stay"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_gender"}},{"kind":"Field","name":{"kind":"Name","value":"youngest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"oldest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"smoking_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"couples_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"pets_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"occupied_now"}},{"kind":"Field","name":{"kind":"Name","value":"furnished"}},{"kind":"Field","name":{"kind":"Name","value":"owner_living"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bed_type"}},{"kind":"Field","name":{"kind":"Name","value":"window_view"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentedRoomDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateListingMutation, CreateListingMutationVariables>;
export const CreatePropertyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePropertyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_files_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreatePropertyFileMutation, CreatePropertyFileMutationVariables>;
export const UpdateListingWithPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateListingWithProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"prop_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"properties_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"activities"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_insert_input"}}}}},"defaultValue":{"kind":"ListValue","values":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasActivities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverview"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_properties_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"prop_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"activities"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasActivities"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddressOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_address"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_lat"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AgentCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListedByOverridesListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"use_dummy_contact"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_phone"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_hide_last_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_broker_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_name"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_phone"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_route"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_locality"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_state"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lng"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_organisation_lat"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMandateCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MandateForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMandateCard"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SellerNotificationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_notification_frequency"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingBuyerLeads"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SellerNotificationSettings"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer_lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingStatusSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalListingButton"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingQuickActions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingStatusSelect"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalListingButton"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference_aliases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reference_alias_decoded"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reference_alias_decoded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"increment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentedRoomDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_number"}},{"kind":"Field","name":{"kind":"Name","value":"minimal_stay"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_gender"}},{"kind":"Field","name":{"kind":"Name","value":"youngest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"oldest_tenant_age"}},{"kind":"Field","name":{"kind":"Name","value":"smoking_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"couples_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"pets_allowed"}},{"kind":"Field","name":{"kind":"Name","value":"occupied_now"}},{"kind":"Field","name":{"kind":"Name","value":"furnished"}},{"kind":"Field","name":{"kind":"Name","value":"owner_living"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bed_type"}},{"kind":"Field","name":{"kind":"Name","value":"window_view"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadQualificationFunnel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_selling_with"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_market_time"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_monthly_gross_rent"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_separation_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_inheritance_next_step"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"ownership"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_buying_status"}},{"kind":"Field","name":{"kind":"Name","value":"mortgage_status"}},{"kind":"Field","name":{"kind":"Name","value":"received_mortgage_offer"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadPropertyDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SalesLeadDetail"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_occupied"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_route"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_locality"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_state"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_property_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadPropertyDetail"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadQualificationFunnel"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SalesLeadDetail"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyPoi"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFeatures"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","alias":{"kind":"Name","value":"__property_type"},"name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFormPricing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFormPricing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyAddress"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverviewProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyPoi"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFeatures"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFragment"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingMap"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddressOverridesListing"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AgentCard_user"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListedByOverridesListing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MandateForm"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingBuyerLeads"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingQuickActions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewPublishDocumentField"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentedRoomDetails"}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_reason"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_block_batch_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingOverviewProperty"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingMap"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateListingWithPropertyMutation, UpdateListingWithPropertyMutationVariables>;
export const ListingDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListingDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<ListingDocumentsQuery, ListingDocumentsQueryVariables>;
export const UpdateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"files_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateFileMutation, UpdateFileMutationVariables>;
export const UpdatePropertyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_files_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyFileMutation, UpdatePropertyFileMutationVariables>;
export const ReOrderPropertyFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReOrderPropertyFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ReOrderPropertyFilesMutation, ReOrderPropertyFilesMutationVariables>;
export const InsertLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LotImportInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"development_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"development_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}}]}}]}}]} as unknown as DocumentNode<InsertLotsMutation, InsertLotsMutationVariables>;
export const DeleteLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteLotsMutation, DeleteLotsMutationVariables>;
export const ExportLotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportLots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_computed"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pt"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_es"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_es"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"video_url"}},{"kind":"Field","name":{"kind":"Name","value":"virtual_visit_url"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"send_enquiries_to_sellers"}},{"kind":"Field","name":{"kind":"Name","value":"origin_id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share_mode"}},{"kind":"Field","name":{"kind":"Name","value":"mls_terms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mls_commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_fixed_amount"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_response_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"is_exclusive"}},{"kind":"Field","name":{"kind":"Name","value":"signed_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_sales_tax_inclusive"}},{"kind":"Field","name":{"kind":"Name","value":"commission_rate"}},{"kind":"Field","name":{"kind":"Name","value":"duration_in_months"}},{"kind":"Field","name":{"kind":"Name","value":"fixed_fee"}},{"kind":"Field","name":{"kind":"Name","value":"has_success_fee"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"minimum_net_seller_price"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_percentage"}},{"kind":"Field","name":{"kind":"Name","value":"expected_time_to_sell"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_custom"}},{"kind":"Field","name":{"kind":"Name","value":"success_fee_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"development_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"ceiling_height"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume_norm"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_maisonette"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_rental"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_secondary_residence"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"flat_condition"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"plot_registry_number"}},{"kind":"Field","name":{"kind":"Name","value":"plot_is_constructible"}},{"kind":"Field","name":{"kind":"Name","value":"plot_has_constructible_reserve"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"share_of_ownership"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExportLotsQuery, ExportLotsQueryVariables>;
export const UpdateLotsOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLotsOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateLotsOrderMutation, UpdateLotsOrderMutationVariables>;
export const UpdateAutoMatchingFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAutoMatchingFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auto_matching_filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}}]}}]}}]} as unknown as DocumentNode<UpdateAutoMatchingFiltersMutation, UpdateAutoMatchingFiltersMutationVariables>;
export const GetListingSurroundingPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingSurroundingPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_surrounding_listing_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"placeType"},"value":{"kind":"StringValue","value":"locality","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}}]}}]}}]} as unknown as DocumentNode<GetListingSurroundingPlacesQuery, GetListingSurroundingPlacesQueryVariables>;
export const GetDevelopmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDevelopment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"developments_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"development_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDevelopmentQuery, GetDevelopmentQueryVariables>;
export const BlockFsboUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BlockFsboUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"batch_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block_fsbo_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}},{"kind":"Argument","name":{"kind":"Name","value":"batch_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"batch_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batch_id"}},{"kind":"Field","name":{"kind":"Name","value":"blocked_user_ids"}},{"kind":"Field","name":{"kind":"Name","value":"unpublished_lots"}},{"kind":"Field","name":{"kind":"Name","value":"failed_portal_listings"}},{"kind":"Field","name":{"kind":"Name","value":"failed_lots"}}]}}]}}]} as unknown as DocumentNode<BlockFsboUsersMutation, BlockFsboUsersMutationVariables>;
export const UnblockFsboUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnblockFsboUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unblock_fsbo_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_ids"}}]}}]}}]} as unknown as DocumentNode<UnblockFsboUsersMutation, UnblockFsboUsersMutationVariables>;
export const GetFsboBlockBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFsboBlockBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"batch_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fsbo_block_batch_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"batch_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fsbo_blocked_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fsbo_blocked_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"fsbo_blocked_at"}}]}}]}}]} as unknown as DocumentNode<GetFsboBlockBatchQuery, GetFsboBlockBatchQueryVariables>;
export const GetFsboSellerClusterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFsboSellerCluster"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fsbo_seller_cluster"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lot_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"other_accounts"}},{"kind":"Field","name":{"kind":"Name","value":"rejected_accounts"}},{"kind":"Field","name":{"kind":"Name","value":"blocked_accounts"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"}},{"kind":"Field","name":{"kind":"Name","value":"network_owner"}}]}}]}}]} as unknown as DocumentNode<GetFsboSellerClusterQuery, GetFsboSellerClusterQueryVariables>;
export const CatchmentAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CatchmentAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catchment_areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CatchmentAreasQuery, CatchmentAreasQueryVariables>;
export const GetMlsBuyerLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsBuyerLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<GetMlsBuyerLeadQuery, GetMlsBuyerLeadQueryVariables>;
export const UpdateMlsBuyerLeadStageFromDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMlsBuyerLeadStageFromDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"stage_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stageId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateMlsBuyerLeadStageFromDrawerMutation, UpdateMlsBuyerLeadStageFromDrawerMutationVariables>;
export const GetMlsBuyerLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsBuyerLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}}]}}]}}]} as unknown as DocumentNode<GetMlsBuyerLeadsQuery, GetMlsBuyerLeadsQueryVariables>;
export const UpdateMlsBuyerLeadStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMlsBuyerLeadStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDnDColumn"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDnDColumn"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"primary_email"}},{"kind":"Field","name":{"kind":"Name","value":"primary_phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}}]}}]}}]} as unknown as DocumentNode<UpdateMlsBuyerLeadStageMutation, UpdateMlsBuyerLeadStageMutationVariables>;
export const GetMlsListingActivityCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsListingActivityCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"matching_count"},"name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"matching","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"manual_count"},"name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"manual","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"other_count"},"name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"matching","block":false},{"kind":"StringValue","value":"manual","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"offers_pending"},"name":{"kind":"Name","value":"offers_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"offers_refused"},"name":{"kind":"Name","value":"offers_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"refused"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"offers_accepted"},"name":{"kind":"Name","value":"offers_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"accepted"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetMlsListingActivityCountsQuery, GetMlsListingActivityCountsQueryVariables>;
export const GetMlsListingDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsListingDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasTeamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share_mode"}},{"kind":"Field","name":{"kind":"Name","value":"mls_terms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mls_commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_fixed_amount"}},{"kind":"Field","name":{"kind":"Name","value":"mls_note"}},{"kind":"Field","name":{"kind":"Name","value":"effective_address"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lot_brochure_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"existing_share"},"name":{"kind":"Name","value":"mls_shares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"shared","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pending_request"},"name":{"kind":"Name","value":"mls_shares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"pending","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_website_portal"},"name":{"kind":"Name","value":"teams_portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"idx"},{"kind":"EnumValue","value":"shared"}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasTeamId"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"existing_portal_listings"},"name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<GetMlsListingDrawerQuery, GetMlsListingDrawerQueryVariables>;
export const GetListingMlsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingMlsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lot"},"name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share_mode"}},{"kind":"Field","name":{"kind":"Name","value":"mls_terms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mls_commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_fixed_amount"}},{"kind":"Field","name":{"kind":"Name","value":"mls_note"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"idx"},{"kind":"EnumValue","value":"shared"}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"listing_shares"},"name":{"kind":"Name","value":"mls_shares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"shared","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_by_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"share_requests"},"name":{"kind":"Name","value":"mls_shares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"pending","block":false},{"kind":"StringValue","value":"rejected","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"requester_name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"handled_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetListingMlsSettingsQuery, GetListingMlsSettingsQueryVariables>;
export const GetMlsSharedTeamDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsSharedTeamDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shared_teams"},"name":{"kind":"Name","value":"mls_network_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo_url"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]}}]} as unknown as DocumentNode<GetMlsSharedTeamDetailsQuery, GetMlsSharedTeamDetailsQueryVariables>;
export const GetMlsNetworkTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsNetworkTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_network_teams_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_network_teams_order_by"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"network_teams"},"name":{"kind":"Name","value":"mls_network_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"broker_count"}},{"kind":"Field","name":{"kind":"Name","value":"active_mls_listings_count"}},{"kind":"Field","name":{"kind":"Name","value":"logo_url"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"network_teams_aggregate"},"name":{"kind":"Name","value":"mls_network_teams_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"network_teams_total"},"name":{"kind":"Name","value":"mls_network_teams_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetMlsNetworkTeamsQuery, GetMlsNetworkTeamsQueryVariables>;
export const GetMlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_lots_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_lots_order_by"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shared_on_mls_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_lots_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share_mode"}},{"kind":"Field","name":{"kind":"Name","value":"mls_terms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mls_commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"access_status"}},{"kind":"Field","name":{"kind":"Name","value":"effective_address"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<GetMlsQuery, GetMlsQueryVariables>;
export const GetMlsLotsMapDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsLotsMap"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_lots_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_lots_order_by"}}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shared_on_mls_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minLng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minLat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxLng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxLat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketOn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"mls_lots"},"name":{"kind":"Name","value":"mls_lots_in_viewport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"min_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minLng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"min_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minLat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"max_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxLng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"max_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxLat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_country_code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"access_status"}},{"kind":"Field","name":{"kind":"Name","value":"effective_address"}},{"kind":"Field","name":{"kind":"Name","value":"market_place_id"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketOn"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"mls_share_mode"}},{"kind":"Field","name":{"kind":"Name","value":"mls_commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_fixed_amount"}},{"kind":"Field","name":{"kind":"Name","value":"hot_score"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetMlsLotsMapQuery, GetMlsLotsMapQueryVariables>;
export const GetMlsAgentBboxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsAgentBbox"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_lots_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"effective_address"}}]}}]}}]} as unknown as DocumentNode<GetMlsAgentBboxQuery, GetMlsAgentBboxQueryVariables>;
export const GetMlsViewportMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsViewportMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotIds"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_agent_buyer_matches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_search_id"}}]}}]}}]} as unknown as DocumentNode<GetMlsViewportMatchesQuery, GetMlsViewportMatchesQueryVariables>;
export const GetAgentPropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentPropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeGeometry"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"composite_property_type_eq"}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"simplified_geom"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeGeometry"}}}]}]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentPropertySearchesQuery, GetAgentPropertySearchesQueryVariables>;
export const GetPlacesGeometryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlacesGeometry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"simplified_geom"}}]}}]}}]} as unknown as DocumentNode<GetPlacesGeometryQuery, GetPlacesGeometryQueryVariables>;
export const GetMlsAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"existing_share"},"name":{"kind":"Name","value":"mls_shares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"shared","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pending_request"},"name":{"kind":"Name","value":"mls_shares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"pending","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_website_portal"},"name":{"kind":"Name","value":"teams_portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"idx"},{"kind":"EnumValue","value":"shared"}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"existing_portal_listings"},"name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lot_brochure_templates"},"name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<GetMlsAccessQuery, GetMlsAccessQueryVariables>;
export const GetTeamMlsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamMlsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"settings"},"name":{"kind":"Name","value":"mls_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_publish_shared_listings"}},{"kind":"Field","name":{"kind":"Name","value":"auto_match_with_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_email_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_email_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamMlsSettingsQuery, GetTeamMlsSettingsQueryVariables>;
export const UpdateLotMlsFieldDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLotMlsField"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"changes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"changes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share_mode"}},{"kind":"Field","name":{"kind":"Name","value":"mls_terms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mls_commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_fixed_amount"}},{"kind":"Field","name":{"kind":"Name","value":"mls_note"}}]}}]}}]} as unknown as DocumentNode<UpdateLotMlsFieldMutation, UpdateLotMlsFieldMutationVariables>;
export const UpdateListingMlsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateListingMlsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedOnMlsAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mlsShareMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mlsTermsEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mlsCommissionType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"mls_commission_type_enum_enum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mlsBuyerAgentSharePercent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mlsBuyerAgentShareFixedAmount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mlsNote"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shared_on_mls_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedOnMlsAt"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mls_share_mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mlsShareMode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mls_terms_enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mlsTermsEnabled"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mls_commission_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mlsCommissionType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mlsBuyerAgentSharePercent"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mls_buyer_agent_share_fixed_amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mlsBuyerAgentShareFixedAmount"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mls_note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mlsNote"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share_mode"}},{"kind":"Field","name":{"kind":"Name","value":"mls_terms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mls_commission_type"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_percent"}},{"kind":"Field","name":{"kind":"Name","value":"mls_buyer_agent_share_fixed_amount"}},{"kind":"Field","name":{"kind":"Name","value":"mls_note"}}]}}]}}]} as unknown as DocumentNode<UpdateListingMlsSettingsMutation, UpdateListingMlsSettingsMutationVariables>;
export const ShareListingWithTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShareListingWithTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sharedByUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_mls_shares_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"shared_by_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sharedByUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"shared","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"mls_shares_lot_id_team_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"status"},{"kind":"EnumValue","value":"shared_by_user_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<ShareListingWithTeamMutation, ShareListingWithTeamMutationVariables>;
export const RemoveListingShareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveListingShare"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_mls_shares_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveListingShareMutation, RemoveListingShareMutationVariables>;
export const RequestMlsListingAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestMlsListingAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestingTeamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestingUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_mls_shares_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestingTeamId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requested_by_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestingUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"pending","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"mls_shares_lot_id_team_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<RequestMlsListingAccessMutation, RequestMlsListingAccessMutationVariables>;
export const HandleMlsShareRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"HandleMlsShareRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handledByUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_mls_shares_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"shared_by_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handledByUserId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"handled_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"handled_at"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<HandleMlsShareRequestMutation, HandleMlsShareRequestMutationVariables>;
export const UpdateTeamMlsSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamMlsSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoPublishSharedListings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoMatchWithBuyers"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoMatchingEmailTemplateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_mls_settings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"auto_publish_shared_listings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoPublishSharedListings"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"auto_match_with_buyers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoMatchWithBuyers"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"auto_matching_email_template_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoMatchingEmailTemplateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"mls_settings_team_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"auto_publish_shared_listings"},{"kind":"EnumValue","value":"auto_match_with_buyers"},{"kind":"EnumValue","value":"auto_matching_email_template_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_publish_shared_listings"}},{"kind":"Field","name":{"kind":"Name","value":"auto_match_with_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_email_template_id"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMlsSettingsMutation, UpdateTeamMlsSettingsMutationVariables>;
export const GetMlsLotForMatchingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsLotForMatching"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"get_surrounding_listing_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"Argument","name":{"kind":"Name","value":"placeType"},"value":{"kind":"StringValue","value":"locality","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"StringValue","value":"mls_lot","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}}]}}]}}]} as unknown as DocumentNode<GetMlsLotForMatchingQuery, GetMlsLotForMatchingQueryVariables>;
export const GetMlsShareMatchingCriteriaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsShareMatchingCriteria"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shareId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mls_shares_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shareId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}}]}}]}}]} as unknown as DocumentNode<GetMlsShareMatchingCriteriaQuery, GetMlsShareMatchingCriteriaQueryVariables>;
export const UpsertMlsShareMatchingCriteriaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertMlsShareMatchingCriteria"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsert_mls_share_criteria"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_matching_filters"}}]}}]}}]} as unknown as DocumentNode<UpsertMlsShareMatchingCriteriaMutation, UpsertMlsShareMatchingCriteriaMutationVariables>;
export const PublishMlsListingToWebsiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishMlsListingToWebsite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"live"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_portal_listings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lotId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"Variable","name":{"kind":"Name","value":"live"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"portal_listings_portal_id_lot_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"live"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"live"}}]}}]}}]} as unknown as DocumentNode<PublishMlsListingToWebsiteMutation, PublishMlsListingToWebsiteMutationVariables>;
export const GetMlsShareTourListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsShareTourListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unshared"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"shared_on_mls_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"any"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visibleUnshared"},"name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shared_on_mls_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"available"},{"kind":"EnumValue","value":"available_coming_soon"},{"kind":"EnumValue","value":"available_off_market"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetMlsShareTourListingQuery, GetMlsShareTourListingQueryVariables>;
export const GetMlsBuyersEmailTourListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMlsBuyersEmailTourListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"own"},"name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mls_share_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"any"},"name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mls_share_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}}]}}]}}]} as unknown as DocumentNode<GetMlsBuyersEmailTourListingQuery, GetMlsBuyersEmailTourListingQueryVariables>;
export const GetUserNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"pro_app_tokens"},"name":{"kind":"Name","value":"push_notification_tokens"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"realadvisor-pro","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveModuleGrants"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_leader"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notification_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationSettingFields"}},{"kind":"Field","name":{"kind":"Name","value":"user_preferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"sms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"push_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_enabled"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveModuleGrants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationSettingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"requires_channel"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"country_codes"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"email_available"}},{"kind":"Field","name":{"kind":"Name","value":"email_default"}},{"kind":"Field","name":{"kind":"Name","value":"sms_available"}},{"kind":"Field","name":{"kind":"Name","value":"sms_default"}},{"kind":"Field","name":{"kind":"Name","value":"push_available"}},{"kind":"Field","name":{"kind":"Name","value":"push_default"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_available"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_default"}}]}}]} as unknown as DocumentNode<GetUserNotificationSettingsQuery, GetUserNotificationSettingsQueryVariables>;
export const SaveUserNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveUserNotificationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_notification_preferences_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateColumns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_notification_preferences_update_column"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_notification_preferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_notification_preferences_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateColumns"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"email_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"sms_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"push_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_enabled"}}]}}]}}]}}]} as unknown as DocumentNode<SaveUserNotificationPreferencesMutation, SaveUserNotificationPreferencesMutationVariables>;
export const GetAdminNotificationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAdminNotificationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationSettingFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationSettingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"requires_channel"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"country_codes"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"email_available"}},{"kind":"Field","name":{"kind":"Name","value":"email_default"}},{"kind":"Field","name":{"kind":"Name","value":"sms_available"}},{"kind":"Field","name":{"kind":"Name","value":"sms_default"}},{"kind":"Field","name":{"kind":"Name","value":"push_available"}},{"kind":"Field","name":{"kind":"Name","value":"push_default"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_available"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_default"}}]}}]} as unknown as DocumentNode<GetAdminNotificationSettingsQuery, GetAdminNotificationSettingsQueryVariables>;
export const GetNotificationSettingImpactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationSettingImpact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"settingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCodes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"modules"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"audience"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification_setting_impact"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"setting_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"settingType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"country_codes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCodes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"modules"},"value":{"kind":"Variable","name":{"kind":"Name","value":"modules"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"audience"},"value":{"kind":"Variable","name":{"kind":"Name","value":"audience"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligible_users"}},{"kind":"Field","name":{"kind":"Name","value":"email_on"}},{"kind":"Field","name":{"kind":"Name","value":"sms_on"}},{"kind":"Field","name":{"kind":"Name","value":"push_on"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_on"}},{"kind":"Field","name":{"kind":"Name","value":"any_on"}},{"kind":"Field","name":{"kind":"Name","value":"email_unset"}},{"kind":"Field","name":{"kind":"Name","value":"sms_unset"}},{"kind":"Field","name":{"kind":"Name","value":"push_unset"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_unset"}}]}}]}}]} as unknown as DocumentNode<GetNotificationSettingImpactQuery, GetNotificationSettingImpactQueryVariables>;
export const CreateAdminNotificationSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAdminNotificationSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"push"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamLeaderCc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_notification_settings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationSettingFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"apply_notification_channels_to_existing_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"setting_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"push"},"value":{"kind":"Variable","name":{"kind":"Name","value":"push"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_leader_cc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamLeaderCc"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationSettingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"requires_channel"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"country_codes"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"email_available"}},{"kind":"Field","name":{"kind":"Name","value":"email_default"}},{"kind":"Field","name":{"kind":"Name","value":"sms_available"}},{"kind":"Field","name":{"kind":"Name","value":"sms_default"}},{"kind":"Field","name":{"kind":"Name","value":"push_available"}},{"kind":"Field","name":{"kind":"Name","value":"push_default"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_available"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_default"}}]}}]} as unknown as DocumentNode<CreateAdminNotificationSettingMutation, CreateAdminNotificationSettingMutationVariables>;
export const UpdateAdminNotificationSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAdminNotificationSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"push"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamLeaderCc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_notification_settings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationSettingFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"apply_notification_channels_to_existing_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"setting_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"push"},"value":{"kind":"Variable","name":{"kind":"Name","value":"push"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_leader_cc"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamLeaderCc"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationSettingFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"notification_settings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"requires_channel"}},{"kind":"Field","name":{"kind":"Name","value":"modules"}},{"kind":"Field","name":{"kind":"Name","value":"country_codes"}},{"kind":"Field","name":{"kind":"Name","value":"audience"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"email_available"}},{"kind":"Field","name":{"kind":"Name","value":"email_default"}},{"kind":"Field","name":{"kind":"Name","value":"sms_available"}},{"kind":"Field","name":{"kind":"Name","value":"sms_default"}},{"kind":"Field","name":{"kind":"Name","value":"push_available"}},{"kind":"Field","name":{"kind":"Name","value":"push_default"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_available"}},{"kind":"Field","name":{"kind":"Name","value":"team_leader_cc_default"}}]}}]} as unknown as DocumentNode<UpdateAdminNotificationSettingMutation, UpdateAdminNotificationSettingMutationVariables>;
export const DeleteAdminNotificationSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteAdminNotificationSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_notification_settings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<DeleteAdminNotificationSettingMutation, DeleteAdminNotificationSettingMutationVariables>;
export const GetOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPriceCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeOfferStatusModal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPriceCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeOfferStatusModal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]}}]} as unknown as DocumentNode<GetOffersQuery, GetOffersQueryVariables>;
export const GetOffersCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOffersCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"offers_count"},"name":{"kind":"Name","value":"offers_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOffersCountQuery, GetOffersCountQueryVariables>;
export const GetOfferDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOfferDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferEditForm"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]} as unknown as DocumentNode<GetOfferDrawerQuery, GetOfferDrawerQueryVariables>;
export const DeleteOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteOfferMutation, DeleteOfferMutationVariables>;
export const UpdateOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_offers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferEditForm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]} as unknown as DocumentNode<UpdateOfferMutation, UpdateOfferMutationVariables>;
export const GetOfferRefusedTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOfferRefusedTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"offer_refused_types"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetOfferRefusedTypesQuery, GetOfferRefusedTypesQueryVariables>;
export const InsertOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"offers_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_offers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offer"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferEditForm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferEditForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"offers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valid_until"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"offer_refused_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"made_on"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}}]}}]} as unknown as DocumentNode<InsertOfferMutation, InsertOfferMutationVariables>;
export const OnboardingGenerateAgencyDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingGenerateAgencyDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agency_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"website_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_agency_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agency_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"website_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"website_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<OnboardingGenerateAgencyDescriptionQuery, OnboardingGenerateAgencyDescriptionQueryVariables>;
export const FindOnboardingSocialLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindOnboardingSocialLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"find_onboarding_social_links"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"website_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"platform"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<FindOnboardingSocialLinksQuery, FindOnboardingSocialLinksQueryVariables>;
export const GetAgentOnboardingPhonesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentOnboardingPhones"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"is_visibility"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentOnboardingPhonesQuery, GetAgentOnboardingPhonesQueryVariables>;
export const BootstrapOnboardingAgencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BootstrapOnboardingAgency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencySetupAddressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bootstrap_onboarding_agency"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<BootstrapOnboardingAgencyMutation, BootstrapOnboardingAgencyMutationVariables>;
export const SaveOnboardingProgressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveOnboardingProgress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveOnboardingProgressInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"save_onboarding_progress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<SaveOnboardingProgressMutation, SaveOnboardingProgressMutationVariables>;
export const OnboardingAgentDictionaryAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingAgentDictionaryAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"languages"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"languages"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"certifications"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"certifications"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"services"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"services"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OnboardingAgentDictionaryAvailabilityQuery, OnboardingAgentDictionaryAvailabilityQueryVariables>;
export const GetOnboardingAgentTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOnboardingAgentTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetOnboardingAgentTransactionsQuery, GetOnboardingAgentTransactionsQueryVariables>;
export const GetOnboardingStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOnboardingState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_onboarding_state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"can_invite_team_members"}},{"kind":"Field","name":{"kind":"Name","value":"can_edit_team"}},{"kind":"Field","name":{"kind":"Name","value":"is_claimed_profile"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"x_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"image_url"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"user_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}},{"kind":"Field","name":{"kind":"Name","value":"x_profile"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOnboardingStateQuery, GetOnboardingStateQueryVariables>;
export const CompleteFullOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteFullOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgencySetupAddressInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"website_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active_since"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"logo_image_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cover_photo_image_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"facebook_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instagram_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tiktok_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkedin_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"youtube_url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_first_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_last_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_description"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_active_since"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_languages"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_certifications"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_services"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_user_image_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_facebook_profile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_instagram_profile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_tiktok_profile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_youtube_profile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_linked_in_profile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agent_x_profile"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitations"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OnboardingInvitationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete_full_onboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}},{"kind":"Argument","name":{"kind":"Name","value":"website_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"website_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"active_since"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active_since"}}},{"kind":"Argument","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"logo_image_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"cover_photo_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cover_photo_image_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"facebook_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"facebook_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"instagram_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instagram_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"tiktok_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tiktok_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"linkedin_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkedin_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"x_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"youtube_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"youtube_url"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_first_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_last_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_description"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_active_since"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_active_since"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_languages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_languages"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_certifications"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_certifications"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_services"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_services"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_user_image_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_user_image_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_facebook_profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_facebook_profile"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_instagram_profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_instagram_profile"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_tiktok_profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_tiktok_profile"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_youtube_profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_youtube_profile"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_linked_in_profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_linked_in_profile"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_x_profile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agent_x_profile"}}},{"kind":"Argument","name":{"kind":"Name","value":"invitations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"invitations_sent"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_status"}}]}}]}}]} as unknown as DocumentNode<CompleteFullOnboardingMutation, CompleteFullOnboardingMutationVariables>;
export const MatchTenantByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchTenantByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read_only_tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MatchTenantByNameQuery, MatchTenantByNameQueryVariables>;
export const GetOrganisationsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"logo_image_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"teams_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<GetOrganisationsListQuery, GetOrganisationsListQueryVariables>;
export const GetOrganisationsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationsListCountQuery, GetOrganisationsListCountQueryVariables>;
export const GetOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationQuery, GetOrganisationQueryVariables>;
export const GetOrganisationMonitoringDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationMonitoring"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripe_customer_ids"}},{"kind":"Field","name":{"kind":"Name","value":"close_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"linked_tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sales_rep_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"csm_rep_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"linked_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sales_rep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"csm_rep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profile_user_images"},"name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"user_transactions_2y"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"user_reviews_aggregate"},"name":{"kind":"Name","value":"combined_reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"engagement_reviews"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"combined_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review_date"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recent_transactions"},"name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationMonitoringQuery, GetOrganisationMonitoringQueryVariables>;
export const GetOrganisationMonitoringActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationMonitoringActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgoDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellerContactsAvgPeriodStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combined_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"review_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgoDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review_date"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_date"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"seller_contacts_avg_period"},"name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellerContactsAvgPeriodStart"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appraisal_reason"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"sell"},{"kind":"EnumValue","value":"already_for_sale"},{"kind":"EnumValue","value":"inheritance"},{"kind":"EnumValue","value":"separation"}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationMonitoringActivityQuery, GetOrganisationMonitoringActivityQueryVariables>;
export const GetOrganisationSellerSignalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationSellerSignals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"windowStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"seller_contacts_window"},"name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"windowStart"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"appraisal_reason"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"sell"},{"kind":"EnumValue","value":"already_for_sale"},{"kind":"EnumValue","value":"inheritance"},{"kind":"EnumValue","value":"separation"}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"seller_enquiries_window"},"name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"windowStart"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationSellerSignalsQuery, GetOrganisationSellerSignalsQueryVariables>;
export const GetOrganisationMonitoringAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationMonitoringAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyUuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_monitoring_analytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyUuids"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile_views_total"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_impressions_total"}},{"kind":"Field","name":{"kind":"Name","value":"phone_clicks_total"}},{"kind":"Field","name":{"kind":"Name","value":"profile_views_by_date"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valuation_impressions_by_date"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"valuation_impressions_by_position"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationMonitoringAnalyticsQuery, GetOrganisationMonitoringAnalyticsQueryVariables>;
export const GetOrganisationPosthogUsageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationPosthogUsage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_posthog_usage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source_usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crm_web"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_users_30d"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"b2b_mobile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_users_30d"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen_date"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cma"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"visibility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pmap"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"crm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrganisationPosthogModuleUsage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active_days_30d"}},{"kind":"Field","name":{"kind":"Name","value":"active_users_30d"}},{"kind":"Field","name":{"kind":"Name","value":"events_30d"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"eligible"}},{"kind":"Field","name":{"kind":"Name","value":"source_breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crm_web_events"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_mobile_events"}}]}},{"kind":"Field","name":{"kind":"Name","value":"daily_series"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"events"}},{"kind":"Field","name":{"kind":"Name","value":"active_users"}},{"kind":"Field","name":{"kind":"Name","value":"crm_web_events"}},{"kind":"Field","name":{"kind":"Name","value":"b2b_mobile_events"}}]}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"events_30d"}},{"kind":"Field","name":{"kind":"Name","value":"active_days_30d"}},{"kind":"Field","name":{"kind":"Name","value":"last_seen_date"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationPosthogUsageQuery, GetOrganisationPosthogUsageQueryVariables>;
export const GetOrganisationEngagementScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationEngagementScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_engagement_score"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"previous_score"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"previous_score"}},{"kind":"Field","name":{"kind":"Name","value":"counted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"profile"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"cma"}},{"kind":"Field","name":{"kind":"Name","value":"prospection_map"}},{"kind":"Field","name":{"kind":"Name","value":"crm"}},{"kind":"Field","name":{"kind":"Name","value":"widget"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationEngagementScoreQuery, GetOrganisationEngagementScoreQueryVariables>;
export const GetOrganisationVisibilityScoreDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationVisibilityScore"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"windowDays"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_visibility_score"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"window_days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"windowDays"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"computed_at"}},{"kind":"Field","name":{"kind":"Name","value":"window_days"}},{"kind":"Field","name":{"kind":"Name","value":"hostname"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}},{"kind":"Field","name":{"kind":"Name","value":"current"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"raw_score"}},{"kind":"Field","name":{"kind":"Name","value":"profile_points"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_points"}},{"kind":"Field","name":{"kind":"Name","value":"profile_views_total"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_views_total"}},{"kind":"Field","name":{"kind":"Name","value":"phone_clicks_total"}},{"kind":"Field","name":{"kind":"Name","value":"profile_views_target"}},{"kind":"Field","name":{"kind":"Name","value":"effective_impressions"}},{"kind":"Field","name":{"kind":"Name","value":"target_impressions"}},{"kind":"Field","name":{"kind":"Name","value":"size_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_count_24mo"}},{"kind":"Field","name":{"kind":"Name","value":"seller_contact_target_per_month"}},{"kind":"Field","name":{"kind":"Name","value":"position_breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"weighted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"max_points"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previous"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"raw_score"}},{"kind":"Field","name":{"kind":"Name","value":"profile_points"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_points"}},{"kind":"Field","name":{"kind":"Name","value":"profile_views_total"}},{"kind":"Field","name":{"kind":"Name","value":"valuation_views_total"}},{"kind":"Field","name":{"kind":"Name","value":"phone_clicks_total"}},{"kind":"Field","name":{"kind":"Name","value":"profile_views_target"}},{"kind":"Field","name":{"kind":"Name","value":"effective_impressions"}},{"kind":"Field","name":{"kind":"Name","value":"target_impressions"}},{"kind":"Field","name":{"kind":"Name","value":"size_multiplier"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_count_24mo"}},{"kind":"Field","name":{"kind":"Name","value":"seller_contact_target_per_month"}},{"kind":"Field","name":{"kind":"Name","value":"position_breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"weighted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"max_points"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationVisibilityScoreQuery, GetOrganisationVisibilityScoreQueryVariables>;
export const GetOrganisationPosthogCsatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationPosthogCsat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_posthog_csat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"survey_count"}},{"kind":"Field","name":{"kind":"Name","value":"team_user_count"}},{"kind":"Field","name":{"kind":"Name","value":"response_count"}},{"kind":"Field","name":{"kind":"Name","value":"response_rate_percent"}},{"kind":"Field","name":{"kind":"Name","value":"average_score"}},{"kind":"Field","name":{"kind":"Name","value":"last_response_date"}},{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"responded_at"}},{"kind":"Field","name":{"kind":"Name","value":"survey_id"}},{"kind":"Field","name":{"kind":"Name","value":"survey_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationPosthogCsatQuery, GetOrganisationPosthogCsatQueryVariables>;
export const GetOrganisationBillingSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationBillingSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_billing_summary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer_count"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"subscription_status"}},{"kind":"Field","name":{"kind":"Name","value":"billing_interval"}},{"kind":"Field","name":{"kind":"Name","value":"mrr_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"mrr_list_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"arr_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"next_invoice_date"}},{"kind":"Field","name":{"kind":"Name","value":"next_invoice_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"renewal_date"}},{"kind":"Field","name":{"kind":"Name","value":"discount_label"}},{"kind":"Field","name":{"kind":"Name","value":"lifetime_value_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"invoices_paid_count"}},{"kind":"Field","name":{"kind":"Name","value":"invoices_outstanding_count"}},{"kind":"Field","name":{"kind":"Name","value":"invoices_outstanding_amount_cents"}},{"kind":"Field","name":{"kind":"Name","value":"history_url"}},{"kind":"Field","name":{"kind":"Name","value":"customer_since"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationBillingSummaryQuery, GetOrganisationBillingSummaryQueryVariables>;
export const UpdateOrganisationMonitoringFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganisationMonitoringFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_customer_ids"}},{"kind":"Field","name":{"kind":"Name","value":"close_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"linked_tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sales_rep_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"csm_rep_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"linked_tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sales_rep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"csm_rep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganisationMonitoringFieldsMutation, UpdateOrganisationMonitoringFieldsMutationVariables>;
export const SearchStripeCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchStripeCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_stripe_customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<SearchStripeCustomersQuery, SearchStripeCustomersQueryVariables>;
export const SearchCloseLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchCloseLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search_close_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<SearchCloseLeadsQuery, SearchCloseLeadsQueryVariables>;
export const GetCloseLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCloseLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_close_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"sales_rep_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"csm_rep_user_id"}}]}}]}}]} as unknown as DocumentNode<GetCloseLeadQuery, GetCloseLeadQueryVariables>;
export const DeleteOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOrganisationMutation, DeleteOrganisationMutationVariables>;
export const GetOrganisationOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationScoreCards"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress_light"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationScoreCards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"lead_id"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress_light"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]} as unknown as DocumentNode<GetOrganisationOverviewQuery, GetOrganisationOverviewQueryVariables>;
export const AddTeamToOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTeamToOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]} as unknown as DocumentNode<AddTeamToOrganisationMutation, AddTeamToOrganisationMutationVariables>;
export const RemoveTeamFromOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveTeamFromOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]} as unknown as DocumentNode<RemoveTeamFromOrganisationMutation, RemoveTeamFromOrganisationMutationVariables>;
export const GetOrganisationDetailsImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationDetailsImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationDetailsImagesQuery, GetOrganisationDetailsImagesQueryVariables>;
export const DeleteOrganisationImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOrganisationImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"imageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOrganisationImageMutation, DeleteOrganisationImageMutationVariables>;
export const InsertOrganisationImagesBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertOrganisationImagesBatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisation_images_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertOrganisationImagesBatchMutation, InsertOrganisationImagesBatchMutationVariables>;
export const SetOrganisationImagePrimaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetOrganisationImagePrimary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reset_other_images"},"name":{"kind":"Name","value":"update_organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}}]}}]}}]}}]} as unknown as DocumentNode<SetOrganisationImagePrimaryMutation, SetOrganisationImagePrimaryMutationVariables>;
export const GetOrganisationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSettings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiPhoneNumbersField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiEmailsField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"emails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"is_lender"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiPhoneNumbersField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiEmailsField"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationSettingsQuery, GetOrganisationSettingsQueryVariables>;
export const GetOrganisationAccountFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationAccountFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_customer_ids"}},{"kind":"Field","name":{"kind":"Name","value":"close_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"linked_tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"sales_rep_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"csm_rep_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOrganisationAccountFieldsQuery, GetOrganisationAccountFieldsQueryVariables>;
export const UpdateOrganisationSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganisationSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumbers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emails"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"emails_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updatePhoneNumbers"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateEmails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhoneNumbers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneNumbers"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updatePhoneNumbers"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateEmails"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emails"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateEmails"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationSettings"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiPhoneNumbersField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MultiEmailsField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"emails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationSettings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"is_lender"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiPhoneNumbersField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MultiEmailsField"}}]}}]}}]} as unknown as DocumentNode<UpdateOrganisationSettingsMutation, UpdateOrganisationSettingsMutationVariables>;
export const CreateOrganisationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrganisation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"organisations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_organisations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode<CreateOrganisationMutation, CreateOrganisationMutationVariables>;
export const GetActivityFeedPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivityFeedPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activity_feed_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activity_feed_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"feed"},"name":{"kind":"Name","value":"activity_feed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activity_id"}},{"kind":"Field","name":{"kind":"Name","value":"activity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedItem"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"status"},"name":{"kind":"Name","value":"activity_feed_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ready"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"blocked"},"name":{"kind":"Name","value":"activity_feed_quarantine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"principal_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityLot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityProperty"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","alias":{"kind":"Name","value":"is_overdue"},"name":{"kind":"Name","value":"performance_is_overdue"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityProperty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_mls"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"effective_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target_user_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetActivityFeedPageQuery, GetActivityFeedPageQueryVariables>;
export const GetActivityFeedCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivityFeedCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activity_feed_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count_limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"feed_aggregate"},"name":{"kind":"Name","value":"activity_feed_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count_limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetActivityFeedCountQuery, GetActivityFeedCountQueryVariables>;
export const GetActivitiesPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivitiesPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activities"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFeedItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityLot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by_user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityProperty"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFeedItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","alias":{"kind":"Name","value":"is_overdue"},"name":{"kind":"Name","value":"performance_is_overdue"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityProperty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_mls"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityLot"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mls_lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"effective_address"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target_user_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"is_owner"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetActivitiesPageQuery, GetActivitiesPageQueryVariables>;
export const GetActivitiesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivitiesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"activities_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count_limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activities_aggregate"},"name":{"kind":"Name","value":"activities_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count_limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetActivitiesCountQuery, GetActivitiesCountQueryVariables>;
export const GetUserNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<GetUserNameQuery, GetUserNameQueryVariables>;
export const GetOrganisationNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrganisationName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetOrganisationNameQuery, GetOrganisationNameQueryVariables>;
export const GetTeamNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTeamNameQuery, GetTeamNameQueryVariables>;
export const GetSellerLeadsStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSellerLeadsStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupingMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GetLeadsStatisticsGroupingMode"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadOrigins"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetLeadsStatisticsLeadOrigin"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_leads_statistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupingMode"}}},{"kind":"Argument","name":{"kind":"Name","value":"lead_origins"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadOrigins"}}},{"kind":"Argument","name":{"kind":"Name","value":"organisation_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organisationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_group"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_leads"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_leads"}},{"kind":"Field","name":{"kind":"Name","value":"call_attempts"}},{"kind":"Field","name":{"kind":"Name","value":"call_successful"}},{"kind":"Field","name":{"kind":"Name","value":"call_missed"}},{"kind":"Field","name":{"kind":"Name","value":"visit_booked"}},{"kind":"Field","name":{"kind":"Name","value":"visit_completed"}},{"kind":"Field","name":{"kind":"Name","value":"sale_mandate"}},{"kind":"Field","name":{"kind":"Name","value":"rental_mandate"}}]}}]}}]}}]} as unknown as DocumentNode<GetSellerLeadsStatisticsQuery, GetSellerLeadsStatisticsQueryVariables>;
export const PortalTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PortalTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PortalTeamsQuery, PortalTeamsQueryVariables>;
export const AddPortalTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPortalTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_teams_portals_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portalId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<AddPortalTeamMutation, AddPortalTeamMutationVariables>;
export const UpdatePortalTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePortalTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contract_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contract_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contract_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}}]}}]}}]} as unknown as DocumentNode<UpdatePortalTeamMutation, UpdatePortalTeamMutationVariables>;
export const GetPortalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalsQuery, GetPortalsQueryVariables>;
export const GetPortalsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortalsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalsCountQuery, GetPortalsCountQueryVariables>;
export const GetPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"password"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalQuery, GetPortalQueryVariables>;
export const CheckPortalConnectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckPortalConnection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"check_portal_connection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<CheckPortalConnectionQuery, CheckPortalConnectionQueryVariables>;
export const ImportPortalListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportPortalListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dry_run"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page_size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import_portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"dry_run"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dry_run"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"page_size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page_size"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"page"}},{"kind":"Field","name":{"kind":"Name","value":"total_pages"}},{"kind":"Field","name":{"kind":"Name","value":"total_properties"}},{"kind":"Field","name":{"kind":"Name","value":"inserted"}},{"kind":"Field","name":{"kind":"Name","value":"updated"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external_property_id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"warnings"}}]}}]}}]}}]} as unknown as DocumentNode<ImportPortalListingsMutation, ImportPortalListingsMutationVariables>;
export const GetPortalLiveListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortalLiveListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_property_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dummy_usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalLiveListingsQuery, GetPortalLiveListingsQueryVariables>;
export const GetPortalTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortalTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetPortalTeamsQuery, GetPortalTeamsQueryVariables>;
export const GetPortalTeamBrokersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortalTeamBrokers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"full_name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSelect"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSelect"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","alias":{"kind":"Name","value":"primaryEmail"},"name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetPortalTeamBrokersQuery, GetPortalTeamBrokersQueryVariables>;
export const ReadPortalIdxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReadPortalIdx"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read_portal_idx"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portal_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"}},{"kind":"Field","name":{"kind":"Name","value":"columns"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"truncated"}}]}}]}}]} as unknown as DocumentNode<ReadPortalIdxQuery, ReadPortalIdxQueryVariables>;
export const GetPortalMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPortalMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shared_portals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"portals_types_enum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<GetPortalMetadataQuery, GetPortalMetadataQueryVariables>;
export const UpdatePortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePortalMutation, UpdatePortalMutationVariables>;
export const UpsertPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"portals_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_portals_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"real_estate_portals_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"active"},{"kind":"EnumValue","value":"contract_id"},{"kind":"EnumValue","value":"email"},{"kind":"EnumValue","value":"exact_address_required"},{"kind":"EnumValue","value":"exclude_from_published_stats"},{"kind":"EnumValue","value":"has_top_premium_listing"},{"kind":"EnumValue","value":"idx_protocol"},{"kind":"EnumValue","value":"master_portal_id"},{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"password"},{"kind":"EnumValue","value":"port"},{"kind":"EnumValue","value":"quota"},{"kind":"EnumValue","value":"type"},{"kind":"EnumValue","value":"url"},{"kind":"EnumValue","value":"username"},{"kind":"EnumValue","value":"website_url"},{"kind":"EnumValue","value":"team_id"},{"kind":"EnumValue","value":"logo_image_id"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalFragment"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"password"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalLogo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PortalFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portals"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"contract_id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"exact_address_required"}},{"kind":"Field","name":{"kind":"Name","value":"exclude_from_published_stats"}},{"kind":"Field","name":{"kind":"Name","value":"has_top_premium_listing"}},{"kind":"Field","name":{"kind":"Name","value":"idx_protocol"}},{"kind":"Field","name":{"kind":"Name","value":"master_portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PortalLogo"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertPortalMutation, UpsertPortalMutationVariables>;
export const DeletePortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePortalMutation, DeletePortalMutationVariables>;
export const GetCampaignRecentCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaignRecentCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetCampaignRecentCmaReportQuery, GetCampaignRecentCmaReportQueryVariables>;
export const GetMyProductExperiencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMyProductExperiences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product_experiences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"first_seen_at"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"outcome_at"}},{"kind":"Field","name":{"kind":"Name","value":"last_step"}},{"kind":"Field","name":{"kind":"Name","value":"step_count"}},{"kind":"Field","name":{"kind":"Name","value":"dismiss_reason"}},{"kind":"Field","name":{"kind":"Name","value":"dismiss_count"}},{"kind":"Field","name":{"kind":"Name","value":"holdout"}}]}}]}}]}}]} as unknown as DocumentNode<GetMyProductExperiencesQuery, GetMyProductExperiencesQueryVariables>;
export const RecordProductExperiencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordProductExperiences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_product_experiences_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateColumns"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_product_experiences_update_column"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_product_experiences_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_user_product_experiences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"user_product_experiences_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateColumns"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<RecordProductExperiencesMutation, RecordProductExperiencesMutationVariables>;
export const ResetMyProductExperiencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetMyProductExperiences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user_product_experiences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ResetMyProductExperiencesMutation, ResetMyProductExperiencesMutationVariables>;
export const GetPropertySearchesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_source"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_in"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_nin"}},{"kind":"Field","name":{"kind":"Name","value":"composite_property_type_eq"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_gte"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetPropertySearchesListQuery, GetPropertySearchesListQueryVariables>;
export const GetPropertySearchesCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchesCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertySearchesCountQuery, GetPropertySearchesCountQueryVariables>;
export const GetPropertySearchDrawerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchDrawer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_source"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertySearchForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"property_search_source.%","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"property_search_aggregator_source.%","block":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertySearchForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"property_status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"activate_aggregator"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"has_balcony"}},{"kind":"Field","name":{"kind":"Name","value":"has_garden"}},{"kind":"Field","name":{"kind":"Name","value":"has_lift"}},{"kind":"Field","name":{"kind":"Name","value":"has_parking"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_fsbo"}},{"kind":"Field","name":{"kind":"Name","value":"is_furnished"}},{"kind":"Field","name":{"kind":"Name","value":"is_minergie_certified"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}}]}}]} as unknown as DocumentNode<GetPropertySearchDrawerQuery, GetPropertySearchDrawerQueryVariables>;
export const InsertPropertySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_searches_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"aggregator_source"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertySearchForm"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertySearchForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"property_status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"activate_aggregator"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"has_balcony"}},{"kind":"Field","name":{"kind":"Name","value":"has_garden"}},{"kind":"Field","name":{"kind":"Name","value":"has_lift"}},{"kind":"Field","name":{"kind":"Name","value":"has_parking"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_fsbo"}},{"kind":"Field","name":{"kind":"Name","value":"is_furnished"}},{"kind":"Field","name":{"kind":"Name","value":"is_minergie_certified"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}}]}}]} as unknown as DocumentNode<InsertPropertySearchMutation, InsertPropertySearchMutationVariables>;
export const ImportPropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportPropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertySearchImportInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import_property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_search_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_search"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ImportPropertySearchesMutation, ImportPropertySearchesMutationVariables>;
export const UpdatePropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertySearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyPlaces"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_places_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_property_types_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_searches_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertySearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertySearchForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_property_searches_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_search_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_property_searches_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyPlaces"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_search_id"}},{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_property_searches_property_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_search_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_property_searches_property_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyTypes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertySearchForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"property_status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"activate_aggregator"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_per_living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_room_monthly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_gte"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_m2_yearly_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"has_balcony"}},{"kind":"Field","name":{"kind":"Name","value":"has_garden"}},{"kind":"Field","name":{"kind":"Name","value":"has_lift"}},{"kind":"Field","name":{"kind":"Name","value":"has_parking"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_fsbo"}},{"kind":"Field","name":{"kind":"Name","value":"is_furnished"}},{"kind":"Field","name":{"kind":"Name","value":"is_minergie_certified"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}}]}}]} as unknown as DocumentNode<UpdatePropertySearchesMutation, UpdatePropertySearchesMutationVariables>;
export const DeletePropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeletePropertySearchesMutation, DeletePropertySearchesMutationVariables>;
export const ExportPropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportPropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug_en"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_usage"}},{"kind":"Field","name":{"kind":"Name","value":"notification"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_in"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type_nin"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_lte"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms_gte"}}]}}]}}]} as unknown as DocumentNode<ExportPropertySearchesQuery, ExportPropertySearchesQueryVariables>;
export const GetPropertySearchesDictionaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertySearchesDictionary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"sources"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"property_search_source.%","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"aggregator_sources"},"name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"property_search_aggregator_source.%","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetPropertySearchesDictionaryQuery, GetPropertySearchesDictionaryQueryVariables>;
export const ProspectionMapV2CatchmentAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionMapV2CatchmentAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catchment_areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"catchment_areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProspectionMapV2CatchmentAreasQuery, ProspectionMapV2CatchmentAreasQueryVariables>;
export const ProspectionMapV2FallbackCatchmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionMapV2FallbackCatchment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"x"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"y"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_population"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_catchment_area"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"x"},"value":{"kind":"Variable","name":{"kind":"Name","value":"x"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"y"},"value":{"kind":"Variable","name":{"kind":"Name","value":"y"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_population"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_population"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<ProspectionMapV2FallbackCatchmentQuery, ProspectionMapV2FallbackCatchmentQueryVariables>;
export const ProspectionParcelAtPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionParcelAtPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parcel_at_point"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"Argument","name":{"kind":"Name","value":"lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"found"}},{"kind":"Field","name":{"kind":"Name","value":"parcel_id"}},{"kind":"Field","name":{"kind":"Name","value":"geometry"}},{"kind":"Field","name":{"kind":"Name","value":"area_m2"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]} as unknown as DocumentNode<ProspectionParcelAtPointQuery, ProspectionParcelAtPointQueryVariables>;
export const ProspectionFrParcelAtPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionFrParcelAtPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"point"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"geometry"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fr_plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area_m2"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"local_plot_id"}},{"kind":"Field","name":{"kind":"Name","value":"area_m2"}},{"kind":"Field","name":{"kind":"Name","value":"extra"}},{"kind":"Field","name":{"kind":"Name","value":"geom"}}]}}]}}]} as unknown as DocumentNode<ProspectionFrParcelAtPointQuery, ProspectionFrParcelAtPointQueryVariables>;
export const ProspectionEsParcelAtPointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionEsParcelAtPoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"point"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"geometry"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"es_plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area_m2"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"local_plot_id"}},{"kind":"Field","name":{"kind":"Name","value":"area_m2"}},{"kind":"Field","name":{"kind":"Name","value":"extra"}},{"kind":"Field","name":{"kind":"Name","value":"geom"}}]}}]}}]} as unknown as DocumentNode<ProspectionEsParcelAtPointQuery, ProspectionEsParcelAtPointQueryVariables>;
export const ProspectionContactQuotaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionContactQuota"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_contact_quota"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"used"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}},{"kind":"Field","name":{"kind":"Name","value":"resets_at"}}]}}]}}]} as unknown as DocumentNode<ProspectionContactQuotaQuery, ProspectionContactQuotaQueryVariables>;
export const ProspectionContactTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionContactTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProspectionContactTeamQuery, ProspectionContactTeamQueryVariables>;
export const ProspectionMyContactAttemptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionMyContactAttempts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"prospection_map_contact_attempts_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_map_contact_attempts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1000"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"accepted_at"}},{"kind":"Field","name":{"kind":"Name","value":"declined_at"}}]}}]}}]} as unknown as DocumentNode<ProspectionMyContactAttemptsQuery, ProspectionMyContactAttemptsQueryVariables>;
export const ProspectionFullLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionFullLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_map_full_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}}]}}]} as unknown as DocumentNode<ProspectionFullLeadsQuery, ProspectionFullLeadsQueryVariables>;
export const ProspectionEmailableLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionEmailableLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_map_emailable_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}}]}}]} as unknown as DocumentNode<ProspectionEmailableLeadsQuery, ProspectionEmailableLeadsQueryVariables>;
export const ContactProspectionLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContactProspectionLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact_prospection_lead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"used"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}},{"kind":"Field","name":{"kind":"Name","value":"remaining"}},{"kind":"Field","name":{"kind":"Name","value":"resets_at"}}]}}]}}]} as unknown as DocumentNode<ContactProspectionLeadMutation, ContactProspectionLeadMutationVariables>;
export const ProspectionLeadContactLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionLeadContactLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]}}]} as unknown as DocumentNode<ProspectionLeadContactLanguageQuery, ProspectionLeadContactLanguageQueryVariables>;
export const ProspectionContactMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionContactMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_language"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_contact_message_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ProspectionContactMessageTemplateQuery, ProspectionContactMessageTemplateQueryVariables>;
export const UpsertProspectionContactMessageTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertProspectionContactMessageTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_language"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_prospection_contact_message_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"prospection_contact_message_templates_user_language_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"message"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<UpsertProspectionContactMessageTemplateMutation, UpsertProspectionContactMessageTemplateMutationVariables>;
export const ProspectionDpeAtParcelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionDpeAtParcel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"poly"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"geometry"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fr_energy_certificates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"date_of_diagnostic"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_intersects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"poly"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"energy_rating"}},{"kind":"Field","name":{"kind":"Name","value":"emissions_rating"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_diagnostic"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_expiry"}},{"kind":"Field","name":{"kind":"Name","value":"geom"}},{"kind":"Field","alias":{"kind":"Name","value":"adresse_ban"},"name":{"kind":"Name","value":"extra"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"adresse_ban","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"type_batiment"},"name":{"kind":"Name","value":"extra"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"type_batiment","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"surface_m2"},"name":{"kind":"Name","value":"extra"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"surface_habitable_logement","block":false}}]},{"kind":"Field","alias":{"kind":"Name","value":"building_period"},"name":{"kind":"Name","value":"extra"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"StringValue","value":"periode_construction","block":false}}]}]}}]}}]} as unknown as DocumentNode<ProspectionDpeAtParcelQuery, ProspectionDpeAtParcelQueryVariables>;
export const ProspectionLeadAddressesInBboxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionLeadAddressesInBbox"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"west"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"south"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"east"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"north"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"houseIds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_map_lead_addresses_in_bbox"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"west"},"value":{"kind":"Variable","name":{"kind":"Name","value":"west"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"south"},"value":{"kind":"Variable","name":{"kind":"Name","value":"south"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"east"},"value":{"kind":"Variable","name":{"kind":"Name","value":"east"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"north"},"value":{"kind":"Variable","name":{"kind":"Name","value":"north"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"house_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"houseIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"surface"}},{"kind":"Field","name":{"kind":"Name","value":"rooms"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}}]} as unknown as DocumentNode<ProspectionLeadAddressesInBboxQuery, ProspectionLeadAddressesInBboxQueryVariables>;
export const ProspectionMyLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionMyLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_status_enum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minLat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxLat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minLng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxLng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_agents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lat"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minLat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxLat"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lng"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minLng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxLng"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_or_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"assignments"},"name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"statuses"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProspectionMyLeadsQuery, ProspectionMyLeadsQueryVariables>;
export const ProspectionParcelRegistryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionParcelRegistry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parcelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buildingIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"plots"},"name":{"kind":"Name","value":"ch_plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parcelId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area_m2"}},{"kind":"Field","name":{"kind":"Name","value":"geom"}},{"kind":"Field","name":{"kind":"Name","value":"extra"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buildings"},"name":{"kind":"Name","value":"ch_buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buildingIds"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"footprint_area_m2"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"year_built"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"display_information"}},{"kind":"Field","name":{"kind":"Name","value":"extra"}}]}}]}}]} as unknown as DocumentNode<ProspectionParcelRegistryQuery, ProspectionParcelRegistryQueryVariables>;
export const ProspectionParcelPlotAttrsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionParcelPlotAttrs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_plots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"area_m2"}}]}}]}}]} as unknown as DocumentNode<ProspectionParcelPlotAttrsQuery, ProspectionParcelPlotAttrsQueryVariables>;
export const ProspectionParcelBuildingAttrsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionParcelBuildingAttrs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_buildings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"footprint_area_m2"}},{"kind":"Field","name":{"kind":"Name","value":"year_built"}},{"kind":"Field","name":{"kind":"Name","value":"display_information"}}]}}]}}]} as unknown as DocumentNode<ProspectionParcelBuildingAttrsQuery, ProspectionParcelBuildingAttrsQueryVariables>;
export const ProspectionMarksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionMarks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_marks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"parcel_id"}},{"kind":"Field","name":{"kind":"Name","value":"parcel_source"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<ProspectionMarksQuery, ProspectionMarksQueryVariables>;
export const InsertProspectionMarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertProspectionMark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parcelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parcelSource"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_prospection_marks_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parcel_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parcelId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"parcel_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parcelSource"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertProspectionMarkMutation, InsertProspectionMarkMutationVariables>;
export const UpdateProspectionMarkNoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProspectionMarkNote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_prospection_marks_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<UpdateProspectionMarkNoteMutation, UpdateProspectionMarkNoteMutationVariables>;
export const DeleteProspectionMarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProspectionMark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_prospection_marks_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProspectionMarkMutation, DeleteProspectionMarkMutationVariables>;
export const ProspectionSaleTypeLabelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProspectionSaleTypeLabels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"main_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"HOUSE","block":false},{"kind":"StringValue","value":"APPT","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}}]}}]}}]} as unknown as DocumentNode<ProspectionSaleTypeLabelsQuery, ProspectionSaleTypeLabelsQueryVariables>;
export const GetBrochureReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrochureReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"active_teams_users"},"name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"show_image_captions_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPois"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoBrochure"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescriptionBrochure"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrochureReportInclude"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPois"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"poi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"primary_type"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pt"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_es"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_show_agent_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescriptionBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_es"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_layout"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_maisonette"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_rental"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_secondary_residence"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrochureReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brochure_include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_property"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_poi_map"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_poi_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_include_append_files"}}]}}]} as unknown as DocumentNode<GetBrochureReportQuery, GetBrochureReportQueryVariables>;
export const UpdateBrochureCoverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrochureCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_title"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_pt"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_title_es"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"address_display_option_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_show_agent_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBrochureCoverMutation, UpdateBrochureCoverMutationVariables>;
export const UpdateBrochureDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrochureDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescriptionBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescriptionBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_en"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_de"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_it"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_es"}},{"kind":"Field","name":{"kind":"Name","value":"use_custom_brochure_description"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_description_layout"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<UpdateBrochureDescriptionMutation, UpdateBrochureDescriptionMutationVariables>;
export const UpdatePropertyDetailsBrochureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyDetailsBrochure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetailsBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"available_from"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_included_in_total"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"parking_price_type"}},{"kind":"Field","name":{"kind":"Name","value":"indoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"outdoor_parking_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_airport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_city_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_grocery_shop"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_high_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_hospital"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_kindergarten"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_motorway"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_primary_school"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_public_transport"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_sports_center"}},{"kind":"Field","name":{"kind":"Name","value":"distance_to_train_station"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_maisonette"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_rental"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_secondary_residence"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyDetailsBrochureMutation, UpdatePropertyDetailsBrochureMutationVariables>;
export const UpdateStepPoiBrochureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepPOIBrochure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateStepPoiBrochureMutation, UpdateStepPoiBrochureMutationVariables>;
export const UpdateStepPhotosBrochureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepPhotosBrochure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPhotosBrochure"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPhotosBrochure"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"show_image_captions_on_brochure"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateStepPhotosBrochureMutation, UpdateStepPhotosBrochureMutationVariables>;
export const DocTemplatesBrochureReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocTemplatesBrochureReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lot_brochure"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}}]}}]} as unknown as DocumentNode<DocTemplatesBrochureReportQuery, DocTemplatesBrochureReportQueryVariables>;
export const UpdateBrochureReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBrochureReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateBrochureReportFileMutation, UpdateBrochureReportFileMutationVariables>;
export const UpdateTeamBrandingColorBrochureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamBrandingColorBrochure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandingColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"branding_color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandingColor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_lots_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamBrandingColorBrochureMutation, UpdateTeamBrandingColorBrochureMutationVariables>;
export const GetCmaReportsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCMAReportsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportsListQuery, GetCmaReportsListQueryVariables>;
export const GenerateCmaDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenerateCmaDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_cma_description"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cma_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}}]} as unknown as DocumentNode<GenerateCmaDescriptionQuery, GenerateCmaDescriptionQueryVariables>;
export const GetMarketPlacesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMarketPlacesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GetMarketPlacesByIdsQuery, GetMarketPlacesByIdsQueryVariables>;
export const ResetCmaMarketComparisonPlacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetCmaMarketComparisonPlaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reset_cma_market_comparison_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_report_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"market_comparison_places"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<ResetCmaMarketComparisonPlacesMutation, ResetCmaMarketComparisonPlacesMutationVariables>;
export const GetLeadsByAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadsByAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"route"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"streetNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"find_cma_leads_by_address"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_route"},"value":{"kind":"Variable","name":{"kind":"Name","value":"route"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_street_number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"streetNumber"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_open_to_offer"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetLeadsByAddressQuery, GetLeadsByAddressQueryVariables>;
export const GetCmaReportsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReportsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportsCountQuery, GetCmaReportsCountQueryVariables>;
export const UpdateStepPhotosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepPhotos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateStepPhotosMutation, UpdateStepPhotosMutationVariables>;
export const UpdateStepPointsOfInterestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateStepPointsOfInterest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateStepPointsOfInterestMutation, UpdateStepPointsOfInterestMutationVariables>;
export const UpdateDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescription"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}}]}}]} as unknown as DocumentNode<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>;
export const DeleteCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCmaReportMutation, DeleteCmaReportMutationVariables>;
export const DocTemplatesCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocTemplatesCmaReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"cma_report"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocTemplateDefaultLinks"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocTemplateDefaultLinks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"doc_templates"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"doc_templates_tenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_templates_teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_default"}}]}}]}}]} as unknown as DocumentNode<DocTemplatesCmaReportQuery, DocTemplatesCmaReportQueryVariables>;
export const GetCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CMAReportEditor"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntroduction"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoCma"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetails"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepDescription"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepHedonisticValuation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepListingsCompare"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepRentalListings"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepTransactions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCapRateValuation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntrinsicValuation"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepFinal"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPotentialBuyers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepAgencyProfile"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepAppendFiles"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepMarketData"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportInclude"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPois"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactionsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"include_in_median"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CMAReportEditor"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"filename_template"}},{"kind":"Field","name":{"kind":"Name","value":"translations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntroduction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"report_title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepDescription"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description_en"}},{"kind":"Field","name":{"kind":"Name","value":"description_fr"}},{"kind":"Field","name":{"kind":"Name","value":"description_de"}},{"kind":"Field","name":{"kind":"Name","value":"description_it"}},{"kind":"Field","name":{"kind":"Name","value":"description_pl"}},{"kind":"Field","name":{"kind":"Name","value":"description_pt"}},{"kind":"Field","name":{"kind":"Name","value":"description_es"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepHedonisticValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepListingsCompare"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparable_listing_details"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"show_full_idx_description"}},{"kind":"Field","name":{"kind":"Name","value":"show_comparable_listing_cards"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"report_source"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepRentalListings"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables_search_params"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparable_listing_details"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"show_full_rental_description"}},{"kind":"Field","name":{"kind":"Name","value":"show_rental_comparable_listing_cards"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactions"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"adjust_price_by_evolution"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_transaction_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_map_zoom_level"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepTransactionsList"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCapRateValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_estimated_monthly_rent"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_minimum_required_yield"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntrinsicValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"construction_cost_base"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_building_surface"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_construction_cost"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_annual_deprecation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_land_value"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_custom_fields"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepFinal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"positive_comments"}},{"kind":"Field","name":{"kind":"Name","value":"negative_comments"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"show_probability"}},{"kind":"Field","name":{"kind":"Name","value":"probability_min"}},{"kind":"Field","name":{"kind":"Name","value":"probability_max"}},{"kind":"Field","name":{"kind":"Name","value":"probability_time_period"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPotentialBuyers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"max_budget"}},{"kind":"Field","name":{"kind":"Name","value":"min_budget"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAgencyProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_agency_description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_team_members"}},{"kind":"Field","name":{"kind":"Name","value":"sort_display_mode"}},{"kind":"Field","name":{"kind":"Name","value":"cma_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_in_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cma_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAppendFiles"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaPropertyFile"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepMarketData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_market_data"}},{"kind":"Field","name":{"kind":"Name","value":"market_comparison_places"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_show_map"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_show_chart"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"include_introduction"}},{"kind":"Field","name":{"kind":"Name","value":"include_property"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"include_poi_map"}},{"kind":"Field","name":{"kind":"Name","value":"poi_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_cuprate_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_intrinsic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_final_value"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent_agency"}},{"kind":"Field","name":{"kind":"Name","value":"include_client_testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"include_append_files"}},{"kind":"Field","name":{"kind":"Name","value":"include_market_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPois"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"poi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"primary_type"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportQuery, GetCmaReportQueryVariables>;
export const GetCmaReportBrokerSelectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReportBrokerSelections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepAgencyProfile"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAgencyProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_agency_description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_team_members"}},{"kind":"Field","name":{"kind":"Name","value":"sort_display_mode"}},{"kind":"Field","name":{"kind":"Name","value":"cma_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_in_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cma_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}}]}}]}}]} as unknown as DocumentNode<GetCmaReportBrokerSelectionsQuery, GetCmaReportBrokerSelectionsQueryVariables>;
export const GetCmaReportTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReportTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepTransactionsList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactionsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"include_in_median"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportTransactionsQuery, GetCmaReportTransactionsQueryVariables>;
export const GetCmaReportPoisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaReportPois"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPois"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPois"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_distance_meters"}},{"kind":"Field","name":{"kind":"Name","value":"walking_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"cycling_time_minutes"}},{"kind":"Field","name":{"kind":"Name","value":"poi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"primary_type"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaReportPoisQuery, GetCmaReportPoisQueryVariables>;
export const UpdateCmaReportDocTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportDocTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportDocTemplateMutation, UpdateCmaReportDocTemplateMutationVariables>;
export const UpdateCmaStepCoverDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaStepCover"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCoverPhotoCma"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportPropertyImage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_images"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"crop"}},{"kind":"Field","name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"watermarked_url"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCoverPhotoCma"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"report_title"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"font_family"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme_id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_theme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"display_on_brochure"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportPropertyImage"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCmaStepCoverMutation, UpdateCmaStepCoverMutationVariables>;
export const StepCoverInsertPropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepCoverInsertPropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<StepCoverInsertPropertyImageMutation, StepCoverInsertPropertyImageMutationVariables>;
export const UpdateTeamBrandingColorCmaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamBrandingColorCma"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brandingColor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"branding_color"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brandingColor"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamBrandingColorCmaMutation, UpdateTeamBrandingColorCmaMutationVariables>;
export const UpdateCmaIntroductionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaIntroduction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntroduction"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntroduction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"introduction"}}]}}]} as unknown as DocumentNode<UpdateCmaIntroductionMutation, UpdateCmaIntroductionMutationVariables>;
export const UpdatePropertyDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPropertyDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"building_condition"}},{"kind":"Field","name":{"kind":"Name","value":"building_standard"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"charges"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"cooling"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"heating"}},{"kind":"Field","name":{"kind":"Name","value":"heating_distribution"}},{"kind":"Field","name":{"kind":"Name","value":"income_includes_parking"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"minergie_code"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_floors"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"parking_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_fund"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"residential_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_yearly_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"plot_number"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_residential_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_commercial_units"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_lifts"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"energy_consumption_class"}},{"kind":"Field","name":{"kind":"Name","value":"gas_emissions_class"}},{"kind":"Field","name":{"kind":"Name","value":"consumption"}},{"kind":"Field","name":{"kind":"Name","value":"emissions"}},{"kind":"Field","name":{"kind":"Name","value":"energy_reference_year"}},{"kind":"Field","name":{"kind":"Name","value":"energy_inspection_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_lower_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_higher_energy_cost"}},{"kind":"Field","name":{"kind":"Name","value":"energy_certificate_version"}},{"kind":"Field","name":{"kind":"Name","value":"micro_location"}},{"kind":"Field","name":{"kind":"Name","value":"macro_location"}},{"kind":"Field","name":{"kind":"Name","value":"is_residential_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"is_commercial_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"is_parking_fully_rented"}},{"kind":"Field","name":{"kind":"Name","value":"parking_potential_rental_income"}},{"kind":"Field","name":{"kind":"Name","value":"orientation"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_north"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_south"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_east"}},{"kind":"Field","name":{"kind":"Name","value":"is_oriented_west"}},{"kind":"Field","name":{"kind":"Name","value":"is_luxury"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"has_gym"}},{"kind":"Field","name":{"kind":"Name","value":"has_sauna"}},{"kind":"Field","name":{"kind":"Name","value":"has_wellness_area"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_attic"}},{"kind":"Field","name":{"kind":"Name","value":"has_photovoltaic_panels"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyDetailsMutation, UpdatePropertyDetailsMutationVariables>;
export const UpdateHedonisticValuationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateHedonisticValuation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepHedonisticValuation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepHedonisticValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appraisals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateHedonisticValuationMutation, UpdateHedonisticValuationMutationVariables>;
export const UpdateFinalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFinal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepFinal"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepFinal"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"positive_comments"}},{"kind":"Field","name":{"kind":"Name","value":"negative_comments"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"is_price_range"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_min"}},{"kind":"Field","name":{"kind":"Name","value":"price_range_max"}},{"kind":"Field","name":{"kind":"Name","value":"show_probability"}},{"kind":"Field","name":{"kind":"Name","value":"probability_min"}},{"kind":"Field","name":{"kind":"Name","value":"probability_max"}},{"kind":"Field","name":{"kind":"Name","value":"probability_time_period"}}]}}]} as unknown as DocumentNode<UpdateFinalMutation, UpdateFinalMutationVariables>;
export const UpdatePotentialBuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePotentialBuyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepPotentialBuyers"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepPotentialBuyers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"max_budget"}},{"kind":"Field","name":{"kind":"Name","value":"min_budget"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"suggested_market_value"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePotentialBuyersMutation, UpdatePotentialBuyersMutationVariables>;
export const UpdateCmaMarketDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaMarketData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepMarketData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepMarketData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_market_data"}},{"kind":"Field","name":{"kind":"Name","value":"market_comparison_places"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_show_map"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_show_chart"}},{"kind":"Field","name":{"kind":"Name","value":"market_data_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]} as unknown as DocumentNode<UpdateCmaMarketDataMutation, UpdateCmaMarketDataMutationVariables>;
export const StepAddCmaReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepAddCmaReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files_insert_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_cma_report_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepAddCmaReportFileMutation, StepAddCmaReportFileMutationVariables>;
export const StepDeleteCmaReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepDeleteCmaReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<StepDeleteCmaReportFileMutation, StepDeleteCmaReportFileMutationVariables>;
export const StepUpdateCmaReportFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepUpdateCmaReportFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportFile"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepUpdateCmaReportFileMutation, StepUpdateCmaReportFileMutationVariables>;
export const StepUpdateCmaReportFileVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepUpdateCmaReportFileVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_visible"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_report_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"file_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_visible"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_visible"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<StepUpdateCmaReportFileVisibilityMutation, StepUpdateCmaReportFileVisibilityMutationVariables>;
export const StepAppendAddPropertyFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StepAppendAddPropertyFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_files_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_files_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaPropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaPropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<StepAppendAddPropertyFileMutation, StepAppendAddPropertyFileMutationVariables>;
export const StepListingsCompareListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StepListingsCompareListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}}]}}]} as unknown as DocumentNode<StepListingsCompareListingsQuery, StepListingsCompareListingsQueryVariables>;
export const StepListingsCompareAlgoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StepListingsCompareAlgo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_similar_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_built_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"built_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sale_price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sale_price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_usable_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"usable_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}}]}}]}}]}}]} as unknown as DocumentNode<StepListingsCompareAlgoQuery, StepListingsCompareAlgoQueryVariables>;
export const FindCmaListingByPortalIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindCmaListingByPortalId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portal"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FindCmaListingByPortalIdQuery, FindCmaListingByPortalIdQueryVariables>;
export const FindCmaListingByRawIdentifierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindCmaListingByRawIdentifier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"raw"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"original_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_reference"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raw"}}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"removed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FindCmaListingByRawIdentifierQuery, FindCmaListingByRawIdentifierQueryVariables>;
export const UpdateComparablesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateComparablesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateComparablesListMutation, UpdateComparablesListMutationVariables>;
export const InsertCmaReportsComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertCmaReportsComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_comparables_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<InsertCmaReportsComparablesMutation, InsertCmaReportsComparablesMutationVariables>;
export const UpdateCmaReportsComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportsComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_nr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_nr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportsComparablesMutation, UpdateCmaReportsComparablesMutationVariables>;
export const DeleteCmaReportsComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCmaReportsComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"bigint"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_comparables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listing_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comparable_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates_db__merged_listings_clusters_id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<DeleteCmaReportsComparablesMutation, DeleteCmaReportsComparablesMutationVariables>;
export const ComparableCmaListingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComparableCmaListingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_cma_listings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<ComparableCmaListingDetailsQuery, ComparableCmaListingDetailsQueryVariables>;
export const ComparableCmaListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComparableCmaListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_locality"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComparableCmaListingsQuery, ComparableCmaListingsQueryVariables>;
export const CmaListingsByRadiusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmaListingsByRadius"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"radiusMeters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_listings_distance_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_cma_listings_by_radius"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_radius_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radiusMeters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_cma_listings_by_radius"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_radius_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radiusMeters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_cma_listings_by_radius"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_radius_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radiusMeters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_cma_listings_by_radius"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_radius_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radiusMeters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_cma_listings_by_radius"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_radius_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radiusMeters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_cma_listings_by_radius"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_radius_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"radiusMeters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CmaListingsByRadiusQuery, CmaListingsByRadiusQueryVariables>;
export const CmaListingsByAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmaListingsByArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_listings_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]} as unknown as DocumentNode<CmaListingsByAreaQuery, CmaListingsByAreaQueryVariables>;
export const ComparableCmaListingsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ComparableCmaListingsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_listings_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_listing_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<ComparableCmaListingsCountQuery, ComparableCmaListingsCountQueryVariables>;
export const GenerateCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_report_source_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generate_cma_report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadId"}}},{"kind":"Argument","name":{"kind":"Name","value":"source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}}]}}]}}]} as unknown as DocumentNode<GenerateCmaReportMutation, GenerateCmaReportMutationVariables>;
export const CreateCmaReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCmaReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"cma_reports_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCmaReportMutation, CreateCmaReportMutationVariables>;
export const UpdateCmaReportStepVisibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportStepVisibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaReportInclude"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaReportInclude"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_cover"}},{"kind":"Field","name":{"kind":"Name","value":"include_introduction"}},{"kind":"Field","name":{"kind":"Name","value":"include_property"}},{"kind":"Field","name":{"kind":"Name","value":"include_description"}},{"kind":"Field","name":{"kind":"Name","value":"include_photos"}},{"kind":"Field","name":{"kind":"Name","value":"include_pois"}},{"kind":"Field","name":{"kind":"Name","value":"include_poi_map"}},{"kind":"Field","name":{"kind":"Name","value":"poi_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_hedonistic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparables_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"include_cuprate_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_intrinsic_valuation"}},{"kind":"Field","name":{"kind":"Name","value":"include_final_value"}},{"kind":"Field","name":{"kind":"Name","value":"include_potential_buyers"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent"}},{"kind":"Field","name":{"kind":"Name","value":"include_agent_agency"}},{"kind":"Field","name":{"kind":"Name","value":"include_client_testimonial"}},{"kind":"Field","name":{"kind":"Name","value":"include_append_files"}},{"kind":"Field","name":{"kind":"Name","value":"include_market_data"}}]}}]} as unknown as DocumentNode<UpdateCmaReportStepVisibilityMutation, UpdateCmaReportStepVisibilityMutationVariables>;
export const UpdateCapRateValuationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCapRateValuation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepCapRateValuation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepCapRateValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_estimated_monthly_rent"}},{"kind":"Field","name":{"kind":"Name","value":"caprate_minimum_required_yield"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"rent_value"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCapRateValuationMutation, UpdateCapRateValuationMutationVariables>;
export const UpdateIntrinsicValuationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntrinsicValuation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepIntrinsicValuation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepIntrinsicValuation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"construction_cost_base"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_building_surface"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_construction_cost"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_annual_deprecation_rate"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_land_value"}},{"kind":"Field","name":{"kind":"Name","value":"intrinsic_custom_fields"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"building_volume"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"basement_surface"}},{"kind":"Field","name":{"kind":"Name","value":"commercial_surface"}},{"kind":"Field","name":{"kind":"Name","value":"balcony_surface"}},{"kind":"Field","name":{"kind":"Name","value":"garden_surface"}},{"kind":"Field","name":{"kind":"Name","value":"gross_floor_surface"}},{"kind":"Field","name":{"kind":"Name","value":"residential_surface"}},{"kind":"Field","name":{"kind":"Name","value":"terrace_surface"}},{"kind":"Field","name":{"kind":"Name","value":"weighted_floor_surface"}}]}}]}}]} as unknown as DocumentNode<UpdateIntrinsicValuationMutation, UpdateIntrinsicValuationMutationVariables>;
export const UpdateCmaReportsTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportsTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_property_transaction_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_nr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_property_transaction_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_nr"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportsTransactionsMutation, UpdateCmaReportsTransactionsMutationVariables>;
export const UpdateCmaPropertyTransactionIncludeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaPropertyTransactionInclude"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_in_median"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_in_median"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_in_median"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_in_median"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaPropertyTransactionIncludeMutation, UpdateCmaPropertyTransactionIncludeMutationVariables>;
export const ClearPriceEvolutionCacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearPriceEvolutionCache"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"price_evolution_rate"},"value":{"kind":"NullValue"}},{"kind":"ObjectField","name":{"kind":"Name","value":"price_evolution_rate_updated_at"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate_updated_at"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<ClearPriceEvolutionCacheMutation, ClearPriceEvolutionCacheMutationVariables>;
export const DeleteCmaReportsTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCmaReportsTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_property_transaction_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_property_transaction_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepTransactionsList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactionsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"include_in_median"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCmaReportsTransactionsMutation, DeleteCmaReportsTransactionsMutationVariables>;
export const ReplaceCmaReportsTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplaceCmaReportsTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_property_transactions_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"crm_transaction_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"external_transaction_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to_delete_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to_delete_ids"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"crm_transaction_ids"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"dvf_fr","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"external_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"external_transaction_ids"}}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepTransactionsList"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepTransactionsList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"include_in_median"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate"}},{"kind":"Field","name":{"kind":"Name","value":"price_evolution_rate_updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ReplaceCmaReportsTransactionsMutation, ReplaceCmaReportsTransactionsMutationVariables>;
export const UpdateCmaReportAdjustPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportAdjustPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"adjust_price_by_evolution"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"adjust_price_by_evolution"},"value":{"kind":"Variable","name":{"kind":"Name","value":"adjust_price_by_evolution"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"adjust_price_by_evolution"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportAdjustPriceMutation, UpdateCmaReportAdjustPriceMutationVariables>;
export const UpdateCmaReportTransactionsSquareMeterCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportTransactionsSquareMeterCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_property_transaction_square_meter_calculation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_property_transaction_square_meter_calculation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_property_transaction_square_meter_calculation"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_transaction_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportTransactionsSquareMeterCalculationMutation, UpdateCmaReportTransactionsSquareMeterCalculationMutationVariables>;
export const UpdateCmaReportTransactionMapZoomLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportTransactionMapZoomLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_map_zoom_level"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_map_zoom_level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_map_zoom_level"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportTransactionMapZoomLevelMutation, UpdateCmaReportTransactionMapZoomLevelMutationVariables>;
export const UpdateCmaReportComparableListingsMapZoomLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportComparableListingsMapZoomLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportComparableListingsMapZoomLevelMutation, UpdateCmaReportComparableListingsMapZoomLevelMutationVariables>;
export const UpdateCmaReportComparableListingsSquareMeterCalculationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportComparableListingsSquareMeterCalculation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_property_comparable_listings_square_meter_calculation"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportComparableListingsSquareMeterCalculationMutation, UpdateCmaReportComparableListingsSquareMeterCalculationMutationVariables>;
export const GetAutomaticExternalTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutomaticExternalTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fr_get_external_transactions_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_max_distance_meters"},"value":{"kind":"IntValue","value":"50000"}},{"kind":"ObjectField","name":{"kind":"Name","value":"_max_results"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_cutoff_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_cutoff_date_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date_max"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalTransactionDistanceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalTransactionDistanceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_external_transactions_distance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"street_suffix"}},{"kind":"Field","name":{"kind":"Name","value":"street_type"}},{"kind":"Field","name":{"kind":"Name","value":"street_name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}}]}}]} as unknown as DocumentNode<GetAutomaticExternalTransactionsQuery, GetAutomaticExternalTransactionsQueryVariables>;
export const GetAutomaticTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAutomaticTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_signature_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_property_transactions_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_target_property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_max_distance_meters"},"value":{"kind":"IntValue","value":"50000"}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_max_results"},"value":{"kind":"IntValue","value":"10"}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_match_main_type"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_years_back"},"value":{"kind":"IntValue","value":"2"}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_max_signature_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_signature_date"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}}]}}]}}]}}]} as unknown as DocumentNode<GetAutomaticTransactionsQuery, GetAutomaticTransactionsQueryVariables>;
export const CmaTransactionsWithDistanceRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmaTransactionsWithDistanceRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_distance_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_distance_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_property_transactions_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_target_property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_max_distance_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CmaTransactionsWithDistanceRowsQuery, CmaTransactionsWithDistanceRowsQueryVariables>;
export const CmaTransactionsWithDistanceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmaTransactionsWithDistanceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_distance_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_property_transactions_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_target_property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_property_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_max_distance_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CmaTransactionsWithDistanceCountQuery, CmaTransactionsWithDistanceCountQueryVariables>;
export const CmaExternalTransactionsWithDistanceRowsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmaExternalTransactionsWithDistanceRows"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_results"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rooms_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rooms_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"polygon_geojson"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort_field"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort_direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fr_get_external_transactions_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_max_distance_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_max_results"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_results"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_cutoff_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_cutoff_date_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_land_surface_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_land_surface_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rooms_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rooms_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rooms_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rooms_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_price_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_price_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_polygon_geojson"},"value":{"kind":"Variable","name":{"kind":"Name","value":"polygon_geojson"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sort_field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort_field"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_sort_direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort_direction"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalTransactionDistanceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalTransactionDistanceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_external_transactions_distance"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"street_suffix"}},{"kind":"Field","name":{"kind":"Name","value":"street_type"}},{"kind":"Field","name":{"kind":"Name","value":"street_name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}}]}}]} as unknown as DocumentNode<CmaExternalTransactionsWithDistanceRowsQuery, CmaExternalTransactionsWithDistanceRowsQueryVariables>;
export const CmaExternalTransactionsWithDistanceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CmaExternalTransactionsWithDistanceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_text"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rooms_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rooms_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price_min"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price_max"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"polygon_geojson"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fr_get_external_transactions_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_source"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_max_distance_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"max_distance_meters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_max_results"},"value":{"kind":"IntValue","value":"2001"}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_cutoff_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_cutoff_date_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cutoff_date_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_postcode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_living_surface_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"living_surface_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_land_surface_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_land_surface_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"land_surface_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rooms_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rooms_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rooms_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rooms_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_price_min"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price_min"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_price_max"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price_max"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_polygon_geojson"},"value":{"kind":"Variable","name":{"kind":"Name","value":"polygon_geojson"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CmaExternalTransactionsWithDistanceCountQuery, CmaExternalTransactionsWithDistanceCountQueryVariables>;
export const GetPlaceGeometriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceGeometries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withGeometry"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children_bbox"}},{"kind":"Field","name":{"kind":"Name","value":"simplified_geom"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withGeometry"}}}]}]}]}}]}}]} as unknown as DocumentNode<GetPlaceGeometriesQuery, GetPlaceGeometriesQueryVariables>;
export const GetSavedExternalTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedExternalTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"source"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"externalIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fr_external_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"source"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"external_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"externalIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalTransactionFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalTransactionFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_external_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"external_id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_name"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"street_suffix"}},{"kind":"Field","name":{"kind":"Name","value":"street_type"}},{"kind":"Field","name":{"kind":"Name","value":"street_name"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]} as unknown as DocumentNode<GetSavedExternalTransactionsQuery, GetSavedExternalTransactionsQueryVariables>;
export const GetCurrentUserTeamOptInStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUserTeamOptInStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"share_transactions_in_cma"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentUserTeamOptInStatusQuery, GetCurrentUserTeamOptInStatusQueryVariables>;
export const UpdateTeamShareTransactionsInCmaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamShareTransactionsInCma"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"share_transactions_in_cma"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"share_transactions_in_cma"},"value":{"kind":"Variable","name":{"kind":"Name","value":"share_transactions_in_cma"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"share_transactions_in_cma"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamShareTransactionsInCmaMutation, UpdateTeamShareTransactionsInCmaMutationVariables>;
export const DeleteCmaAgentTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCmaAgentTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_id"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<DeleteCmaAgentTransactionMutation, DeleteCmaAgentTransactionMutationVariables>;
export const InsertCmaAgentTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertCmaAgentTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distance_in_meters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"numeric"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_agent_transactions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"distance_in_meters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distance_in_meters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zone"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaAgentTransactionDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cma_report_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaAgentTransactionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_agent_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertCmaAgentTransactionMutation, InsertCmaAgentTransactionMutationVariables>;
export const GetCmaAgentTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaAgentTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_display_mode"}},{"kind":"Field","name":{"kind":"Name","value":"cma_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_in_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaAgentTransactionDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaAgentTransactionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_agent_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaAgentTransactionsQuery, GetCmaAgentTransactionsQueryVariables>;
export const GetCmaAgentTransactionsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaAgentTransactionsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortMode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_cma_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_cma_report_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_sorting_mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortMode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaAgentTransactionDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaAgentTransactionDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_agent_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"zone"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaAgentTransactionsPaginatedQuery, GetCmaAgentTransactionsPaginatedQueryVariables>;
export const UpdateCmaAgentSortingModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaAgentSortingMode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortMode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_agent_transactions_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasTransactions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasTransactions"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sort_display_mode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortMode"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StepAgencyProfile"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StepAgencyProfile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_agency_description"}},{"kind":"Field","name":{"kind":"Name","value":"agency_team_members"}},{"kind":"Field","name":{"kind":"Name","value":"sort_display_mode"}},{"kind":"Field","name":{"kind":"Name","value":"cma_agent_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zone"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"distance_in_meters"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cma_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaAgentSortingModeMutation, UpdateCmaAgentSortingModeMutationVariables>;
export const UpdateCmaReportIncludeAgencyDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportIncludeAgencyDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_agency_description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_agency_description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_agency_description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_agency_description"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportIncludeAgencyDescriptionMutation, UpdateCmaReportIncludeAgencyDescriptionMutationVariables>;
export const GetCmaAgencyTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaAgencyTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agency_team_members"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaAgencyTeamMembersQuery, GetCmaAgencyTeamMembersQueryVariables>;
export const UpdateCmaReportAgencyTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportAgencyTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agency_team_members"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agency_team_members"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agency_team_members"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agency_team_members"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportAgencyTeamMembersMutation, UpdateCmaReportAgencyTeamMembersMutationVariables>;
export const GetCmaUserReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaUserReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CmaUserReviewDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CmaUserReviewDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"cma_reports_user_reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"review"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_seller"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaUserReviewsQuery, GetCmaUserReviewsQueryVariables>;
export const DeleteCmaUserReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCmaUserReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_cma_reports_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"cma_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteCmaUserReviewMutation, DeleteCmaUserReviewMutationVariables>;
export const InsertCmaUserReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertCmaUserReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_cma_reports_user_reviews_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cma_report_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"review_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_report_id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cmaReportId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"cma_user_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"review_id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertCmaUserReviewMutation, InsertCmaUserReviewMutationVariables>;
export const GetCmaBrokerReviewsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaBrokerReviewsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"review_text"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"review_text"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"is_seller"}},{"kind":"Field","name":{"kind":"Name","value":"google_address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCmaBrokerReviewsPaginatedQuery, GetCmaBrokerReviewsPaginatedQueryVariables>;
export const UpdateCmaReportComparablesShowFullIdxDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportComparablesShowFullIdxDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"show_full_idx_description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_full_idx_description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"show_full_idx_description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"show_full_idx_description"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportComparablesShowFullIdxDescriptionMutation, UpdateCmaReportComparablesShowFullIdxDescriptionMutationVariables>;
export const UpdateCmaReportIncludeComparableListingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportIncludeComparableListingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_comparable_listing_details"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_comparable_listing_details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_comparable_listing_details"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_comparable_listing_details"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportIncludeComparableListingDetailsMutation, UpdateCmaReportIncludeComparableListingDetailsMutationVariables>;
export const UpdateCmaReportShowComparableListingCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportShowComparableListingCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"show_comparable_listing_cards"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_comparable_listing_cards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"show_comparable_listing_cards"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"show_comparable_listing_cards"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportShowComparableListingCardsMutation, UpdateCmaReportShowComparableListingCardsMutationVariables>;
export const UpdateCmaReportIncludeRentalComparableListingDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCmaReportIncludeRentalComparableListingDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_rental_comparable_listing_details"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"include_rental_comparable_listing_details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_rental_comparable_listing_details"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparable_listing_details"}}]}}]}}]} as unknown as DocumentNode<UpdateCmaReportIncludeRentalComparableListingDetailsMutation, UpdateCmaReportIncludeRentalComparableListingDetailsMutationVariables>;
export const StateByCoordinatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StateByCoordinates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"point"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"geometry"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"state","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isCh"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"state","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isFr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"state","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isEs"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"state","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isIt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"state","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"state","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"point"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<StateByCoordinatesQuery, StateByCoordinatesQueryVariables>;
export const GetCmaTourReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCmaTourReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"own"},"name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visible"},"name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetCmaTourReportQuery, GetCmaTourReportQueryVariables>;
export const RentalPreviewFixtureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RentalPreviewFixture"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"include_rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}}]}}]}}]} as unknown as DocumentNode<RentalPreviewFixtureQuery, RentalPreviewFixtureQueryVariables>;
export const RentalStepFixtureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RentalStepFixture"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RentalStepFixtureQuery, RentalStepFixtureQueryVariables>;
export const RentalCmaListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RentalCmaListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingCh"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingEs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingFr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingIt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingPl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingPt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingCh"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingEs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingFr"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingIt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPl"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingsQuery, RentalCmaListingsQueryVariables>;
export const RentalCmaCohortsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RentalCmaCohorts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"computed_surface"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rent_net_monthly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"10"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_similar_rental_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_computed_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"computed_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rent_net_monthly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rent_net_monthly"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingCh"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_similar_rental_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_computed_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"computed_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rent_net_monthly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rent_net_monthly"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingEs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_similar_rental_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_computed_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"computed_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rent_net_monthly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rent_net_monthly"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingFr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_similar_rental_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_computed_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"computed_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rent_net_monthly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rent_net_monthly"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingIt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_similar_rental_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_computed_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"computed_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rent_net_monthly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rent_net_monthly"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingPl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_similar_rental_listings_cohorts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_property_main_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_main_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_computed_surface"},"value":{"kind":"Variable","name":{"kind":"Name","value":"computed_surface"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_number_of_rooms"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number_of_rooms"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_rent_net_monthly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rent_net_monthly"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingPt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingCh"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingEs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingFr"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingIt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPl"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaCohortsQuery, RentalCmaCohortsQueryVariables>;
export const RentalCmaListingsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RentalCmaListingsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"es_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"it_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_rental_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_rental_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_rental_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_rental_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_rental_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_rental_cma_listings_distance_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingsCountQuery, RentalCmaListingsCountQueryVariables>;
export const RentalCmaManualListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RentalCmaManualListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"es_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"it_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_rental_cma_listings_distance_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_get_rental_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingCh"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_get_rental_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingEs"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_get_rental_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingFr"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_get_rental_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingIt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_get_rental_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingPl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_get_rental_cma_listings_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lat"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lng"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lng"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_state_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"valid_from"},"value":{"kind":"EnumValue","value":"desc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance_in_meters"}},{"kind":"Field","name":{"kind":"Name","value":"listing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RentalCmaListingPt"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingCh"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingEs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingFr"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingIt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPl"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RentalCmaListingPt"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_rental_listings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"gross_rent_monthly"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"geog"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"property_main_type"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"floor_of_flat"}},{"kind":"Field","name":{"kind":"Name","value":"construction_year"}},{"kind":"Field","name":{"kind":"Name","value":"renovation_year"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_toilets"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_indoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_outdoor_parkings"}},{"kind":"Field","name":{"kind":"Name","value":"has_view"}},{"kind":"Field","name":{"kind":"Name","value":"has_cellar"}},{"kind":"Field","name":{"kind":"Name","value":"has_elevator"}},{"kind":"Field","name":{"kind":"Name","value":"has_fireplace"}},{"kind":"Field","name":{"kind":"Name","value":"has_storage_room"}},{"kind":"Field","name":{"kind":"Name","value":"has_swimming_pool"}},{"kind":"Field","name":{"kind":"Name","value":"is_child_friendly"}},{"kind":"Field","name":{"kind":"Name","value":"is_wheelchair_accessible"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_development"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_address"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"12"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}}]}}]}}]} as unknown as DocumentNode<RentalCmaManualListingsQuery, RentalCmaManualListingsQueryVariables>;
export const RentalCmaListingLookupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RentalCmaListingLookup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ch_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"es_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"fr_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"it_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pl_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pt_cma_rental_listings_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"esWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"itWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pl_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"plWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pl"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pt_cma_rental_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ptWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pt"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RentalCmaListingLookupQuery, RentalCmaListingLookupQueryVariables>;
export const UpdateRentalComparablesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRentalComparables"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rental_comparables"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rental_comparables"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rental_comparables"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateRentalComparablesMutation, UpdateRentalComparablesMutationVariables>;
export const UpdateRentalComparableListingsMapZoomLevelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRentalComparableListingsMapZoomLevel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rental_comparable_listings_map_zoom_level"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rental_comparable_listings_map_zoom_level"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rental_comparable_listings_map_zoom_level"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparable_listings_map_zoom_level"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateRentalComparableListingsMapZoomLevelMutation, UpdateRentalComparableListingsMapZoomLevelMutationVariables>;
export const UpdateRentalShowFullDescriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRentalShowFullDescription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"show_full_rental_description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_full_rental_description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"show_full_rental_description"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"show_full_rental_description"}}]}}]}}]} as unknown as DocumentNode<UpdateRentalShowFullDescriptionMutation, UpdateRentalShowFullDescriptionMutationVariables>;
export const UpdateRentalShowComparableListingCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRentalShowComparableListingCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"show_rental_comparable_listing_cards"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_rental_comparable_listing_cards"},"value":{"kind":"Variable","name":{"kind":"Name","value":"show_rental_comparable_listing_cards"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"show_rental_comparable_listing_cards"}}]}}]}}]} as unknown as DocumentNode<UpdateRentalShowComparableListingCardsMutation, UpdateRentalShowComparableListingCardsMutationVariables>;
export const UpdateRentalComparablesSearchParamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRentalComparablesSearchParams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rental_comparables_search_params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_cma_reports_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"rental_comparables_search_params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rental_comparables_search_params"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rental_comparables_search_params"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpdateRentalComparablesSearchParamsMutation, UpdateRentalComparablesSearchParamsMutationVariables>;
export const DeletePropertyPoiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePropertyPoi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyPoiId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_pois_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyPoiId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePropertyPoiMutation, DeletePropertyPoiMutationVariables>;
export const GetPoiTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPoiTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"poi_types"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}}]}}]} as unknown as DocumentNode<GetPoiTypesQuery, GetPoiTypesQueryVariables>;
export const GetAutoPoisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetAutoPois"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"auto_search_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}}]}]}}]} as unknown as DocumentNode<GetAutoPoisMutation, GetAutoPoisMutationVariables>;
export const GetManualPoisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetManualPois"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"manual_search_pois"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"propertyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"types"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"primaryType"}}]}}]}}]} as unknown as DocumentNode<GetManualPoisMutation, GetManualPoisMutationVariables>;
export const InsertPoiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPoi"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InsertPoisOneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_pois_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<InsertPoiMutation, InsertPoiMutationVariables>;
export const TranslateTextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TranslateText"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"text"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translate_text"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"text"},"value":{"kind":"Variable","name":{"kind":"Name","value":"text"}}},{"kind":"Argument","name":{"kind":"Name","value":"target_language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<TranslateTextQuery, TranslateTextQueryVariables>;
export const GetReviewReplyTourReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviewReplyTourReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"unanswered"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner_answer"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"any"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"visible"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner_answer"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetReviewReplyTourReviewQuery, GetReviewReplyTourReviewQueryVariables>;
export const GetReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCell"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCell"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetReviewsQuery, GetReviewsQueryVariables>;
export const GetReviewsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviewsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetReviewsCountQuery, GetReviewsCountQueryVariables>;
export const DeleteReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteReviewMutation, DeleteReviewMutationVariables>;
export const GetReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewDrawer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer_date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}}]} as unknown as DocumentNode<GetReviewQuery, GetReviewQueryVariables>;
export const UpdateReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"review"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_set_input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"review"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReviewDrawer"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewDrawer"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}},{"kind":"Field","name":{"kind":"Name","value":"formatted_address"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer_date"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}}]} as unknown as DocumentNode<UpdateReviewMutation, UpdateReviewMutationVariables>;
export const UpdateReviewAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReviewAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"answer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_reviews_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner_answer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"answer"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer_date"}}]}}]}}]} as unknown as DocumentNode<UpdateReviewAnswerMutation, UpdateReviewAnswerMutationVariables>;
export const GetTenantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]} as unknown as DocumentNode<GetTenantsQuery, GetTenantsQueryVariables>;
export const CreateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownerUserId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"create_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerTeamsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"ownerUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownerUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"expiresAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerApiKey"}}]}}]}}]} as unknown as DocumentNode<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const DeleteLegacyApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLegacyApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_legacy_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rowsDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<DeleteLegacyApiKeyMutation, DeleteLegacyApiKeyMutationVariables>;
export const UpdateApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerTeamsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}}]}}]}}]} as unknown as DocumentNode<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const UpdateLegacyApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLegacyApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_legacy_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerName"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerTeamsIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerTeamsIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"partnerRole"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerRole"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"KeyPrefix"}}]}}]}}]} as unknown as DocumentNode<UpdateLegacyApiKeyMutation, UpdateLegacyApiKeyMutationVariables>;
export const GetApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_api_keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerName"}},{"kind":"Field","name":{"kind":"Name","value":"KeyPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"RevokedAt"}},{"kind":"Field","name":{"kind":"Name","value":"LastUsedAt"}}]}}]}}]} as unknown as DocumentNode<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const GetLegacyApiKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyApiKeys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_legacy_api_keys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"KeyPrefix"}}]}}]}}]} as unknown as DocumentNode<GetLegacyApiKeysQuery, GetLegacyApiKeysQueryVariables>;
export const GetLegacyApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLegacyApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_legacy_api_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"KeyPrefix"}}]}}]}}]} as unknown as DocumentNode<GetLegacyApiKeyQuery, GetLegacyApiKeyQueryVariables>;
export const GetApiKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetApiKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_api_key"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"partnerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"partnerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PartnerID"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerName"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerRole"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTeamsIds"}},{"kind":"Field","name":{"kind":"Name","value":"PartnerTenantId"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerUserId"}},{"kind":"Field","name":{"kind":"Name","value":"OwnerName"}},{"kind":"Field","name":{"kind":"Name","value":"KeyPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"CreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ExpiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"RevokedAt"}},{"kind":"Field","name":{"kind":"Name","value":"LastUsedAt"}}]}}]}}]} as unknown as DocumentNode<GetApiKeyQuery, GetApiKeyQueryVariables>;
export const GetTeamMlsSettingsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamMlsSettingsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"settings"},"name":{"kind":"Name","value":"mls_settings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_publish_shared_listings"}}]}}]}}]} as unknown as DocumentNode<GetTeamMlsSettingsPageQuery, GetTeamMlsSettingsPageQueryVariables>;
export const UpdateTeamMlsSettingsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamMlsSettingsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoPublishSharedListings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_mls_settings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"auto_publish_shared_listings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoPublishSharedListings"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"mls_settings_team_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"auto_publish_shared_listings"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_publish_shared_listings"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMlsSettingsPageMutation, UpdateTeamMlsSettingsPageMutationVariables>;
export const LeadStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LeadStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc_nulls_first"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<LeadStagesQuery, LeadStagesQueryVariables>;
export const UpdatePipelineLeadStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePipelineLeadStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead_stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead_stage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<UpdatePipelineLeadStageMutation, UpdatePipelineLeadStageMutationVariables>;
export const ReorderLeadStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReorderLeadStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"starting_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"temp"},"name":{"kind":"Name","value":"update_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"-1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"down"},"name":{"kind":"Name","value":"update_lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"starting_position"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"up"},"name":{"kind":"Name","value":"update_lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipelineId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"starting_position"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_inc"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"-1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"final"},"name":{"kind":"Name","value":"update_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"leadStageId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadStageFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadStageFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]} as unknown as DocumentNode<ReorderLeadStagesMutation, ReorderLeadStagesMutationVariables>;
export const CreateLeadStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLeadStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stage"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lead_stages_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_lead_stages_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stage"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"pipeline_id"}}]}}]}}]} as unknown as DocumentNode<CreateLeadStageMutation, CreateLeadStageMutationVariables>;
export const DeleteLeadStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLeadStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_lead_stages_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLeadStageMutation, DeleteLeadStageMutationVariables>;
export const GetPipelinesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipelinesList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineFragment"}},{"kind":"Field","name":{"kind":"Name","value":"stages_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<GetPipelinesListQuery, GetPipelinesListQueryVariables>;
export const GetPipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pipelines_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<GetPipelineQuery, GetPipelineQueryVariables>;
export const DeletePipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_pipelines_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePipelineMutation, DeletePipelineMutationVariables>;
export const UpsertPipelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPipeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_pipelines_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pipeline"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"pipelines_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"label_fr"},{"kind":"EnumValue","value":"label_en"},{"kind":"EnumValue","value":"label_de"},{"kind":"EnumValue","value":"label_es"},{"kind":"EnumValue","value":"label_it"},{"kind":"EnumValue","value":"label_pl"},{"kind":"EnumValue","value":"label_pt"},{"kind":"EnumValue","value":"lead_type"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PipelineFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PipelineFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pipelines"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"label_fr"}},{"kind":"Field","name":{"kind":"Name","value":"label_en"}},{"kind":"Field","name":{"kind":"Name","value":"label_de"}},{"kind":"Field","name":{"kind":"Name","value":"label_es"}},{"kind":"Field","name":{"kind":"Name","value":"label_it"}},{"kind":"Field","name":{"kind":"Name","value":"label_pl"}},{"kind":"Field","name":{"kind":"Name","value":"label_pt"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}}]}}]} as unknown as DocumentNode<UpsertPipelineMutation, UpsertPipelineMutationVariables>;
export const GetTenantSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenants_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantSettingsFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pipelines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"sales","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"lead_type"}},{"kind":"Field","name":{"kind":"Name","value":"stages_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"available_email_templates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"main_color"}},{"kind":"Field","name":{"kind":"Name","value":"default_pipeline_id"}},{"kind":"Field","name":{"kind":"Name","value":"email_template"}},{"kind":"Field","name":{"kind":"Name","value":"phone_main"}},{"kind":"Field","name":{"kind":"Name","value":"email_sender_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_sender_email"}},{"kind":"Field","name":{"kind":"Name","value":"google_tag_manager_id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_secret_key"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_webhook_secret"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_secret_key_test"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_webhook_secret_test"}},{"kind":"Field","name":{"kind":"Name","value":"close_api_key"}},{"kind":"Field","name":{"kind":"Name","value":"debug_email_mode"}},{"kind":"Field","name":{"kind":"Name","value":"ai_feed_summary_prompt"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}}]}}]} as unknown as DocumentNode<GetTenantSettingsQuery, GetTenantSettingsQueryVariables>;
export const GetTenantContactSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantContactSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_contact_settings_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_limit"}}]}}]}}]} as unknown as DocumentNode<GetTenantContactSettingsQuery, GetTenantContactSettingsQueryVariables>;
export const UpsertTenantContactSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertTenantContactSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeklyLimit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_prospection_contact_settings_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"weekly_limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeklyLimit"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"prospection_contact_settings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"weekly_limit"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_limit"}}]}}]}}]} as unknown as DocumentNode<UpsertTenantContactSettingsMutation, UpsertTenantContactSettingsMutationVariables>;
export const ClearTeamContactLimitOverridesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearTeamContactLimitOverrides"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"weeklyLimit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_prospection_contact_teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"weekly_limit"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"weeklyLimit"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"weekly_limit"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<ClearTeamContactLimitOverridesMutation, ClearTeamContactLimitOverridesMutationVariables>;
export const UpdateTenantSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTenantSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"tenants_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_tenants_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenant"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TenantSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TenantSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"tenants"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"main_color"}},{"kind":"Field","name":{"kind":"Name","value":"default_pipeline_id"}},{"kind":"Field","name":{"kind":"Name","value":"email_template"}},{"kind":"Field","name":{"kind":"Name","value":"phone_main"}},{"kind":"Field","name":{"kind":"Name","value":"email_sender_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_sender_email"}},{"kind":"Field","name":{"kind":"Name","value":"google_tag_manager_id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_secret_key"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_webhook_secret"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_secret_key_test"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_webhook_secret_test"}},{"kind":"Field","name":{"kind":"Name","value":"close_api_key"}},{"kind":"Field","name":{"kind":"Name","value":"debug_email_mode"}},{"kind":"Field","name":{"kind":"Name","value":"ai_feed_summary_prompt"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}}]}}]} as unknown as DocumentNode<UpdateTenantSettingsMutation, UpdateTenantSettingsMutationVariables>;
export const WebhookDrawerEventTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WebhookDrawerEventTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhook_event_types_enum"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"webhook_event_types_enum.%","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<WebhookDrawerEventTypesQuery, WebhookDrawerEventTypesQueryVariables>;
export const WebhookDrawerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WebhookDrawerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhook_subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"event_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_type"}}]}}]}}]}}]} as unknown as DocumentNode<WebhookDrawerByIdQuery, WebhookDrawerByIdQueryVariables>;
export const ValidateWebhookUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateWebhookUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validate_webhook_url"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valid"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<ValidateWebhookUrlMutation, ValidateWebhookUrlMutationVariables>;
export const InsertWebhookSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertWebhookSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"webhook_subscriptions_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_webhook_subscriptions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertWebhookSubscriptionMutation, InsertWebhookSubscriptionMutationVariables>;
export const UpdateWebhookSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWebhookSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"webhook_subscriptions_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"webhook_subscriptions_event_types_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_webhook_subscriptions_event_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"webhook_subscription_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_webhook_subscriptions_event_types"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event_types"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_webhook_subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<UpdateWebhookSubscriptionMutation, UpdateWebhookSubscriptionMutationVariables>;
export const WebhookSubscriptionsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WebhookSubscriptionsPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhook_subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"success_counter"}},{"kind":"Field","name":{"kind":"Name","value":"event_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dictionaries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"enums"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_like"},"value":{"kind":"StringValue","value":"webhook_event_types_enum.%","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<WebhookSubscriptionsPageQuery, WebhookSubscriptionsPageQueryVariables>;
export const ToggleWebhookActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleWebhookActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_webhook_subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<ToggleWebhookActiveMutation, ToggleWebhookActiveMutationVariables>;
export const DeleteWebhookSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWebhookSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_webhook_subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteWebhookSubscriptionMutation, DeleteWebhookSubscriptionMutationVariables>;
export const TestWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TestWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscription_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"test_webhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscription_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscription_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"status_code"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<TestWebhookMutation, TestWebhookMutationVariables>;
export const GetSubscriptionsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscriptionsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"subscriptions_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"subscriptions_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"customer_email"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"lead_id"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetSubscriptionsListQuery, GetSubscriptionsListQueryVariables>;
export const GetSubscriptionsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscriptionsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"subscriptions_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetSubscriptionsListCountQuery, GetSubscriptionsListCountQueryVariables>;
export const GetSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"customer_email"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"lead_id"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]} as unknown as DocumentNode<GetSubscriptionQuery, GetSubscriptionQueryVariables>;
export const UpdateSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_subscriptions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"lead_id"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const GetTeamReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last_review_scraping"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"google_reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"google_timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"original_review_text"}},{"kind":"Field","name":{"kind":"Name","value":"profile_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_url"}},{"kind":"Field","name":{"kind":"Name","value":"review_url"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}},{"kind":"Field","name":{"kind":"Name","value":"owner_answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"google_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamReviewsQuery, GetTeamReviewsQueryVariables>;
export const ScrapeReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScrapeReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scrape_google_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status_message"}},{"kind":"Field","name":{"kind":"Name","value":"status_code"}},{"kind":"Field","name":{"kind":"Name","value":"tasks"}}]}}]}}]} as unknown as DocumentNode<ScrapeReviewsMutation, ScrapeReviewsMutationVariables>;
export const DeleteReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_google_reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteReviewsMutation, DeleteReviewsMutationVariables>;
export const TeamProspectionContactConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamProspectionContactConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prospection_contact_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_limit"}},{"kind":"Field","name":{"kind":"Name","value":"counter_reset_at"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prospection_contact_settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_limit"}}]}}]}}]} as unknown as DocumentNode<TeamProspectionContactConfigQuery, TeamProspectionContactConfigQueryVariables>;
export const TeamProspectionContactUsageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamProspectionContactUsage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospection_map_contact_attempts_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<TeamProspectionContactUsageQuery, TeamProspectionContactUsageQueryVariables>;
export const UpsertTeamProspectionContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertTeamProspectionContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"object"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"prospection_contact_teams_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_prospection_contact_teams_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"object"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"prospection_contact_teams_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"enabled"},{"kind":"EnumValue","value":"weekly_limit"},{"kind":"EnumValue","value":"counter_reset_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"weekly_limit"}},{"kind":"Field","name":{"kind":"Name","value":"counter_reset_at"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]} as unknown as DocumentNode<UpsertTeamProspectionContactMutation, UpsertTeamProspectionContactMutationVariables>;
export const GetTeamPortalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamPortals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_portals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"portal"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"quota"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"portal_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamPortalsQuery, GetTeamPortalsQueryVariables>;
export const DeleteTeamPortalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamPortal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_teams_portals_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"portal_id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamPortalMutation, DeleteTeamPortalMutationVariables>;
export const GetTeamsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress_light"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"}},{"kind":"Field","name":{"kind":"Name","value":"google_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationCell_organisation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress_light"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationCell_organisation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamsListQuery, GetTeamsListQueryVariables>;
export const GetTeamsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamsListCountQuery, GetTeamsListCountQueryVariables>;
export const DrawerGetTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DrawerGetTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DrawerGetTeamQuery, DrawerGetTeamQueryVariables>;
export const OverviewGetTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OverviewGetTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"native","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct_on"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"lead_id"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamCombinedReviewsAgg"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<OverviewGetTeamQuery, OverviewGetTeamQueryVariables>;
export const CreateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_teams_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTeamMutation, CreateTeamMutationVariables>;
export const DeleteTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userIdsString"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"_uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"disable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIds"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"set_default_team"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userIdsString"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const DeleteTeamUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"NullValue"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"disable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteTeamUserMutation, DeleteTeamUserMutationVariables>;
export const AddTeamUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTeamUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"set_default_team_id"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_teams_users_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"IntValue","value":"1000"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reset_onboarding"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_admin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"has_done_onboarding"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"enable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]}}]} as unknown as DocumentNode<AddTeamUserMutation, AddTeamUserMutationVariables>;
export const UpdateTeamUserOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamUserOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"Variable","name":{"kind":"Name","value":"target_position"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamUserOrderMutation, UpdateTeamUserOrderMutationVariables>;
export const UpdateTeamUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"enable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"disable_broker"},"name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTeamUserMutation, UpdateTeamUserMutationVariables>;
export const TeamsCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TeamsCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<TeamsCardQuery, TeamsCardQueryVariables>;
export const TeamsCardUpdateUserDefaultTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TeamsCardUpdateUserDefaultTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}}]}}]}}]} as unknown as DocumentNode<TeamsCardUpdateUserDefaultTeamMutation, TeamsCardUpdateUserDefaultTeamMutationVariables>;
export const DeleteTeamImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTeamImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_team_images_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamImageMutation, DeleteTeamImageMutationVariables>;
export const GetTeamSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTeamSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"copy_reviews_to_google"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"top_listings"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"share_transactions_in_cma"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"x_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<GetTeamSettingsQuery, GetTeamSettingsQueryVariables>;
export const UpdateTeamSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"copy_reviews_to_google"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"top_listings"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"share_transactions_in_cma"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"x_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamSettingsMutation, UpdateTeamSettingsMutationVariables>;
export const UpsertTeamEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertTeamEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_emails_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpsertTeamEmailMutation, UpsertTeamEmailMutationVariables>;
export const DeleteTeamEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeamEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamEmailMutation, DeleteTeamEmailMutationVariables>;
export const UpdateTeamPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone_numbers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone_numbers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateTeamPhoneNumberMutation, UpdateTeamPhoneNumberMutationVariables>;
export const DeleteTeamPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTeamPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteTeamPhoneNumberMutation, DeleteTeamPhoneNumberMutationVariables>;
export const UpdateTeamPrimaryPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamPrimaryPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"EnumValue","value":"proxy"}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamPrimaryPhoneNumberMutation, UpdateTeamPrimaryPhoneNumberMutationVariables>;
export const UpdateTeamImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeamImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"branding_color"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"do_follow_link"}},{"kind":"Field","name":{"kind":"Name","value":"legal_name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"copy_reviews_to_google"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"top_listings"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"hide_exact_address"}},{"kind":"Field","name":{"kind":"Name","value":"share_transactions_in_cma"}},{"kind":"Field","name":{"kind":"Name","value":"lots_member_access"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamAddress"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_id"}},{"kind":"Field","name":{"kind":"Name","value":"google_place_description"}},{"kind":"Field","name":{"kind":"Name","value":"organisation_id"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_url"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_url"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_url"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_url"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin_url"}},{"kind":"Field","name":{"kind":"Name","value":"x_url"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_email_contact"}},{"kind":"Field","name":{"kind":"Name","value":"use_json_for_enquiry_emails"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamImagesMutation, UpdateTeamImagesMutationVariables>;
export const GetTeamValuationRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamValuationRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetTeamValuationRequestsQuery, GetTeamValuationRequestsQueryVariables>;
export const GetTeamContactRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamContactRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRequestsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRequestsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_enquiry"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_enquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetTeamContactRequestsQuery, GetTeamContactRequestsQueryVariables>;
export const CheckProxyPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckProxyPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"number"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTeamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTeamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"phone_numbers"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"number"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"proxy"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CheckProxyPhoneNumberQuery, CheckProxyPhoneNumberQueryVariables>;
export const GetCreateTransactionDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreateTransactionData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeListing"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeListing"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCardSnippet"}},{"kind":"Field","alias":{"kind":"Name","value":"last_accepted_offer"},"name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offerId"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeOffer"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LightLotCardInfo_lot"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"shared_on_mls_at"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCardSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LightLotCardInfo_lot"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}}]}}]}}]} as unknown as DocumentNode<GetCreateTransactionDataQuery, GetCreateTransactionDataQueryVariables>;
export const GetLinkedListingIdsForTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLinkedListingIdsForTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_transaction"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamIds"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}}]}}]} as unknown as DocumentNode<GetLinkedListingIdsForTeamsQuery, GetLinkedListingIdsForTeamsQueryVariables>;
export const GetPropertyTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPropertyTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_order_by"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeValuations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionsListRow"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionsListRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_paid"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"total","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"my_commissions"},"name":{"kind":"Name","value":"commissions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"split","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"beneficiary_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transaction_valuations_aggregate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeValuations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyTransactionsQuery, GetPropertyTransactionsQueryVariables>;
export const GetPropertyTransactionsListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getPropertyTransactionsListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyTransactionsListCountQuery, GetPropertyTransactionsListCountQueryVariables>;
export const GetDuplicateTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDuplicateTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"route"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"street_number"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locality"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"route"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"route"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"street_number"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"street_number"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"postcode"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"postcode"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"locality"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locality"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDuplicateTransactionsQuery, GetDuplicateTransactionsQueryVariables>;
export const TransactionDrawerGetTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionDrawerGetTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"mls_share"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionDrawerGetTransactionQuery, TransactionDrawerGetTransactionQueryVariables>;
export const DeleteTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteTransactionMutation, DeleteTransactionMutationVariables>;
export const TransactionFormQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TransactionFormQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<TransactionFormQueryQuery, TransactionFormQueryQueryVariables>;
export const UpdateTransactionReviewedAtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTransactionReviewedAt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewed_at"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reviewed_by"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"reviewed_at"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewed_at"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reviewed_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reviewed_by"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<UpdateTransactionReviewedAtMutation, UpdateTransactionReviewedAtMutationVariables>;
export const TransactionFormUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransactionFormUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_set_input"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"transaction_sellers_insert_input"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"transaction_buyers_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_transaction_buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_transaction_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_transaction_buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_transaction_sellers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sellers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]} as unknown as DocumentNode<TransactionFormUpdateMutation, TransactionFormUpdateMutationVariables>;
export const TransactionCommissionsFormUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TransactionCommissionsFormUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"commissions_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_commissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"vat"}},{"kind":"Field","name":{"kind":"Name","value":"contact_id"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}}]}}]}}]}}]} as unknown as DocumentNode<TransactionCommissionsFormUpdateMutation, TransactionCommissionsFormUpdateMutationVariables>;
export const CreateTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_transactions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFormFragment"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFormFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_at"}},{"kind":"Field","name":{"kind":"Name","value":"reviewed_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]} as unknown as DocumentNode<CreateTransactionMutation, CreateTransactionMutationVariables>;
export const GetUserDefaultTeamIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDefaultTeamId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDefaultTeamIdQuery, GetUserDefaultTeamIdQueryVariables>;
export const GetTransactionDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyFile"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"File"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"mimetype"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"document_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyFile"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_files"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"file_id"}},{"kind":"Field","name":{"kind":"Name","value":"is_visible"}},{"kind":"Field","name":{"kind":"Name","value":"display_on_listing"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"File"}}]}}]}}]} as unknown as DocumentNode<GetTransactionDocumentsQuery, GetTransactionDocumentsQueryVariables>;
export const GetTransactionPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transactions_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionPropertyQuery, GetTransactionPropertyQueryVariables>;
export const DeletePropertyTransactionListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePropertyTransactionListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_property_transactions_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"property_transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"listing_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}}]}}]}}]} as unknown as DocumentNode<DeletePropertyTransactionListingMutation, DeletePropertyTransactionListingMutationVariables>;
export const GetLinkedListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLinkedListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"es"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fr"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"it"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ch_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ch"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fr_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fr"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"es_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"es"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"it_cma_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"it"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"computed_price_per_sqm"}},{"kind":"Field","name":{"kind":"Name","value":"offline_since"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"valid_from"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"visit_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_contact_person"}},{"kind":"Field","name":{"kind":"Name","value":"agency_name"}},{"kind":"Field","name":{"kind":"Name","value":"places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_type"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"image_index"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file_name"}},{"kind":"Field","name":{"kind":"Name","value":"bucket_name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkedListingsQuery, GetLinkedListingsQueryVariables>;
export const InsertPropertyTransactionListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertPropertyTransactionListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_listings_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_transactions_listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"property_transactions_listings_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"updated_at"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_transaction_id"}},{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}}]}}]}}]} as unknown as DocumentNode<InsertPropertyTransactionListingsMutation, InsertPropertyTransactionListingsMutationVariables>;
export const GetTransactionValuationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTransactionValuations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction_valuations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perception"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_perceived_value"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_min"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_max"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"composite_type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetTransactionValuationsQuery, GetTransactionValuationsQueryVariables>;
export const CreateTransactionWithPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTransactionWithProperty"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_transactions_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transaction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCreationFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamInfo_team"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"teams"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCreationFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"estimated_signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"payment_date"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"property_type_id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"main_type"}},{"kind":"Field","name":{"kind":"Name","value":"main_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"usable_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeamInfo_team"}}]}}]}}]} as unknown as DocumentNode<CreateTransactionWithPropertyMutation, CreateTransactionWithPropertyMutationVariables>;
export const AddPropertyImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPropertyImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_image"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"property_images_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_property_images_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_image"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_id"}},{"kind":"Field","name":{"kind":"Name","value":"image_id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<AddPropertyImageMutation, AddPropertyImageMutationVariables>;
export const BulkPublishTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkPublishTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"reviewed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}}]}}]}}]}}]} as unknown as DocumentNode<BulkPublishTransactionsMutation, BulkPublishTransactionsMutationVariables>;
export const BulkUnpublishTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUnpublishTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}}]}}]}}]}}]} as unknown as DocumentNode<BulkUnpublishTransactionsMutation, BulkUnpublishTransactionsMutationVariables>;
export const GetBrokerAndTeamNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokerAndTeamNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"include_team"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"team"},"name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"team_id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"include_team"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetBrokerAndTeamNamesQuery, GetBrokerAndTeamNamesQueryVariables>;
export const RestoreUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestoreUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_deleted"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}}]}}]}}]} as unknown as DocumentNode<RestoreUserMutation, RestoreUserMutationVariables>;
export const GetCatchmentAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCatchmentArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"catchment_areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCatchmentAreaQuery, GetCatchmentAreaQueryVariables>;
export const SetCatchmentAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCatchmentArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"catchment_areas_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_catchment_areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insert_catchment_areas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<SetCatchmentAreaMutation, SetCatchmentAreaMutationVariables>;
export const GetUserSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvoiceFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvoiceFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"invoices"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripe_id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"amount_due"}},{"kind":"Field","name":{"kind":"Name","value":"amount_paid"}},{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]} as unknown as DocumentNode<GetUserSubscriptionsQuery, GetUserSubscriptionsQueryVariables>;
export const GetListingsMatchingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingsMatching"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"lots_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lots_status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingCell_listing"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_enquiry"},"name":{"kind":"Name","value":"enquiries_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"live_portals_count"},"name":{"kind":"Name","value":"portal_listings_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"live"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingCell_listing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","alias":{"kind":"Name","value":"single_property_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetListingsMatchingQuery, GetListingsMatchingQueryVariables>;
export const GetUserBuyersLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserBuyersLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBuyerLeadKanbanItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBuyerLeadActionToolbarBuyerLead"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"notification"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"never","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingsMatchingFiltersPropertySearches"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBuyerLeadKanbanItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user_order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBuyerLeadActionToolbarBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingsMatchingFiltersPropertySearches"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"property_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"composite_type_object"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}}]}}]} as unknown as DocumentNode<GetUserBuyersLeadQuery, GetUserBuyersLeadQueryVariables>;
export const UpdateBuyerLeadUserStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBuyerLeadUserStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_buyer_leads_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updates"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBuyerLeadKanbanItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBuyerLeadActionToolbarBuyerLead"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_due_at"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ListingPrice"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrganisationAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"organisations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organisation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrganisationAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailTemplateFormListing"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailListing"}},{"kind":"Field","name":{"kind":"Name","value":"lot_reference"}},{"kind":"Field","name":{"kind":"Name","value":"mandate_type"}},{"kind":"Field","name":{"kind":"Name","value":"brochure_doc_template_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailUser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cma_reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"updated_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"doc_template_id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailProperty"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBuyerLeadKanbanItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user_order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","alias":{"kind":"Name","value":"next_activity"},"name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"call"},{"kind":"EnumValue","value":"visit"},{"kind":"EnumValue","value":"task"},{"kind":"EnumValue","value":"assignment"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"consolidated_due_at"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BuyerLeadDashboardActivity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ListingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBuyerLeadActionToolbarBuyerLead"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"buyer_leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailTemplateFormListing"}}]}}]}}]} as unknown as DocumentNode<UpdateBuyerLeadUserStageMutation, UpdateBuyerLeadUserStageMutationVariables>;
export const GetBuyerLeadsCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerLeadsCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer_leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_stages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pipeline"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"buyer","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"house_sales","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetBuyerLeadsCardQuery, GetBuyerLeadsCardQueryVariables>;
export const GetLeadsCardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadsCard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"where"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requalified_or_created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"buy_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"passed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]},{"kind":"Variable","name":{"kind":"Name","value":"where"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeadUpdatedTimeAgo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"leads"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_at"}}]}}]} as unknown as DocumentNode<GetLeadsCardQuery, GetLeadsCardQueryVariables>;
export const GetUserSellerListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSellerListings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sellers"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sellers"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserSellerListingsQuery, GetUserSellerListingsQueryVariables>;
export const GetUserCreatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserCreator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetUserCreatorQuery, GetUserCreatorQueryVariables>;
export const GetUserPropertySearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPropertySearches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property_searches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertySearchesCardPropertySearches"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertySearchesCardPropertySearches"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_searches"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_gte"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_lte"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price_gte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_lte"}},{"kind":"Field","name":{"kind":"Name","value":"monthly_rent_gte"}},{"kind":"Field","name":{"kind":"Name","value":"property_searches_places"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserPropertySearchesQuery, GetUserPropertySearchesQueryVariables>;
export const GetUsersListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_order_by"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_status"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"account_manager_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersListQuery, GetUsersListQueryVariables>;
export const BulkReassignUserAccountManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkReassignUserAccountManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newAccountManagerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transferOpenActivities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulk_reassign_user_account_manager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"selected_users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"new_account_manager_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newAccountManagerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"transfer_open_activities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transferOpenActivities"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"account_manager_id"}},{"kind":"Field","name":{"kind":"Name","value":"account_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]}}]} as unknown as DocumentNode<BulkReassignUserAccountManagerMutation, BulkReassignUserAccountManagerMutationVariables>;
export const GetUsersListCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersListCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersListCountQuery, GetUsersListCountQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_deleted"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_status"}},{"kind":"Field","name":{"kind":"Name","value":"has_done_onboarding"}},{"kind":"Field","name":{"kind":"Name","value":"membership_type"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveModuleGrants"}},{"kind":"Field","name":{"kind":"Name","value":"referrer"}},{"kind":"Field","name":{"kind":"Name","value":"referring_domain"}},{"kind":"Field","name":{"kind":"Name","value":"landing_page_url"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_route"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_locality"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_state"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_lat"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_lng"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSettingsFragment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactCardUserFragment"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"EnumValue","value":"asc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account_manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCard_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}},{"kind":"Field","alias":{"kind":"Name","value":"subscription_emails"},"name":{"kind":"Name","value":"emails"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSubscriptions"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total_amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_start"}},{"kind":"Field","name":{"kind":"Name","value":"current_period_end"}},{"kind":"Field","name":{"kind":"Name","value":"items"}},{"kind":"Field","name":{"kind":"Name","value":"customer"}},{"kind":"Field","name":{"kind":"Name","value":"plan_name"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserEmails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveModuleGrants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"can_edit_settings"}},{"kind":"Field","name":{"kind":"Name","value":"can_user_login_as"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactCardUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserEmails"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCard_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const UpdateUserSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSettingsFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"has_free_crm_access"}},{"kind":"Field","name":{"kind":"Name","value":"can_edit_settings"}},{"kind":"Field","name":{"kind":"Name","value":"can_user_login_as"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]} as unknown as DocumentNode<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const ApproveUserOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApproveUserOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"pending_review"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_status"},"value":{"kind":"EnumValue","value":"approved"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_status"}}]}}]}}]}}]} as unknown as DocumentNode<ApproveUserOnboardingMutation, ApproveUserOnboardingMutationVariables>;
export const SkipUserOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SkipUserOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"user_onboarding_skip_reason_enum_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"in_progress"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_done_onboarding"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_status"},"value":{"kind":"EnumValue","value":"approved"}},{"kind":"ObjectField","name":{"kind":"Name","value":"has_done_onboarding"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"onboarding_skip_reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}},{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_status"}}]}}]}}]}}]} as unknown as DocumentNode<SkipUserOnboardingMutation, SkipUserOnboardingMutationVariables>;
export const GetUserOnboardingHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserOnboardingHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"onboarding_enrolled"},{"kind":"EnumValue","value":"onboarding_status_changed"},{"kind":"EnumValue","value":"agent_profile_visibility_changed"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"onboarding_skip_reason"}}]}}]}}]} as unknown as DocumentNode<GetUserOnboardingHistoryQuery, GetUserOnboardingHistoryQueryVariables>;
export const UpdateUserPermissionFlagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserPermissionFlags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_admin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"can_edit_settings"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"can_user_login_as"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_user_permission_flags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_admin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_admin"}}},{"kind":"Argument","name":{"kind":"Name","value":"can_edit_settings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"can_edit_settings"}}},{"kind":"Argument","name":{"kind":"Name","value":"can_user_login_as"},"value":{"kind":"Variable","name":{"kind":"Name","value":"can_user_login_as"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateUserPermissionFlagsMutation, UpdateUserPermissionFlagsMutationVariables>;
export const GetUsersForMergeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersForMerge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}},{"kind":"Field","name":{"kind":"Name","value":"is_admin"}},{"kind":"Field","name":{"kind":"Name","value":"date_of_birth"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<GetUsersForMergeQuery, GetUsersForMergeQueryVariables>;
export const MergeUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MergeUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"left_user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"right_user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_broker"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"is_admin"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date_of_birth"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gender"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"primary_email"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resolve_enquiries"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merge_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"left_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"left_user_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"right_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"right_user_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_broker"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_broker"}}},{"kind":"Argument","name":{"kind":"Name","value":"is_admin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"is_admin"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_of_birth"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date_of_birth"}}},{"kind":"Argument","name":{"kind":"Name","value":"gender"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gender"}}},{"kind":"Argument","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"broker_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"primary_email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"primary_email"}}},{"kind":"Argument","name":{"kind":"Name","value":"resolve_enquiries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resolve_enquiries"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MergeUserMutation, MergeUserMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const InsertUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"users_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<InsertUsersMutation, InsertUsersMutationVariables>;
export const ImportUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objects"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserImportInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"import_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objects"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"skipped"}},{"kind":"Field","name":{"kind":"Name","value":"skip_reason"}}]}}]}}]} as unknown as DocumentNode<ImportUsersMutation, ImportUsersMutationVariables>;
export const ExportUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExportUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<ExportUsersQuery, ExportUsersQueryVariables>;
export const InsertUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"emails_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_emails_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<InsertUserEmailMutation, InsertUserEmailMutationVariables>;
export const UpdateUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"emails_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_emails_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<UpdateUserEmailMutation, UpdateUserEmailMutationVariables>;
export const DeleteUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_emails_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserEmailMutation, DeleteUserEmailMutationVariables>;
export const UpdatePrimaryUserEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePrimaryUserEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_emails_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UpdatePrimaryUserEmailMutation, UpdatePrimaryUserEmailMutationVariables>;
export const InsertUserPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertUserPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_phone_numbers_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}}]}}]}}]} as unknown as DocumentNode<InsertUserPhoneNumberMutation, InsertUserPhoneNumberMutationVariables>;
export const UpdateUserPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"set"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"phone_numbers_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"set"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<UpdateUserPhoneNumberMutation, UpdateUserPhoneNumberMutationVariables>;
export const DeleteUserPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_phone_numbers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteUserPhoneNumberMutation, DeleteUserPhoneNumberMutationVariables>;
export const GetUserProfileCompletionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserProfileCompletion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactions"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUserProfileCompletionQuery, GetUserProfileCompletionQueryVariables>;
export const GetUserModuleGrantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserModuleGrants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveModuleGrants"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveModuleGrants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}}]}}]}}]} as unknown as DocumentNode<GetUserModuleGrantsQuery, GetUserModuleGrantsQueryVariables>;
export const GetUserModuleHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserModuleHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"activity_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"module_granted"},{"kind":"EnumValue","value":"module_revoked"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"done_at"},"value":{"kind":"EnumValue","value":"desc_nulls_last"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"done_at"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}},{"kind":"Field","name":{"kind":"Name","value":"granted_at"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserModuleHistoryQuery, GetUserModuleHistoryQueryVariables>;
export const GetModuleHistoryActorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetModuleHistoryActors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetModuleHistoryActorsQuery, GetModuleHistoryActorsQueryVariables>;
export const SetUserModuleGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserModuleGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"module"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"set_user_module_grant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"target_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_module_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"module"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"target_enabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabled"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserActiveModuleGrants"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserActiveModuleGrants"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_grants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"module_id"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"module_id"}}]}}]}}]} as unknown as DocumentNode<SetUserModuleGrantMutation, SetUserModuleGrantMutationVariables>;
export const UpdateUserAutoAssignLeadsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserAutoAssignLeads"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoAssignLeads"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"auto_assign_leads"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoAssignLeads"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"auto_assign_leads"}}]}}]}}]} as unknown as DocumentNode<UpdateUserAutoAssignLeadsMutation, UpdateUserAutoAssignLeadsMutationVariables>;
export const UpdateUserNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"last_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last_name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}}]}}]} as unknown as DocumentNode<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export const UpdateUserLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"user_language"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}}]}}]}}]} as unknown as DocumentNode<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;
export const SetUserHomeAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetUserHomeAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"users_set_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_route"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_street_number"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_postcode"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_locality"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_state"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_country_code"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_lat"}},{"kind":"Field","name":{"kind":"Name","value":"home_address_lng"}}]}}]}}]} as unknown as DocumentNode<SetUserHomeAddressMutation, SetUserHomeAddressMutationVariables>;
export const UpdatePrimaryUserPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePrimaryUserPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_phone_numbers_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone_id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]} as unknown as DocumentNode<UpdatePrimaryUserPhoneNumberMutation, UpdatePrimaryUserPhoneNumberMutationVariables>;
export const UserFeedV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserFeedV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"overdue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activities"},"name":{"kind":"Name","value":"get_activities_feed_for_user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"p_user_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_after_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after_date"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"p_overdue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"overdue"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItem"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityFiltersActivity"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NameLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityTitle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activities_target_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"target_user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NameLink"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentStatusChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DateTooltipContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"done"}},{"kind":"Field","name":{"kind":"Name","value":"consolidated_done_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"due_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"start_date"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityTitle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentStatusChip"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DateTooltipContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EmailActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email_message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}},{"kind":"Field","name":{"kind":"Name","value":"cc"}},{"kind":"Field","name":{"kind":"Name","value":"bcc"}},{"kind":"Field","name":{"kind":"Name","value":"reply_to"}},{"kind":"Field","name":{"kind":"Name","value":"is_sent"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"snippet"}},{"kind":"Field","name":{"kind":"Name","value":"message_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"email_messages_files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nylas_file_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AssignmentActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"assigned_to"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChangeActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EmailActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AssignmentActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChangeActivityItemContent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLeadSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LotSnippetFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lots"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"offer_type"}},{"kind":"Field","name":{"kind":"Name","value":"sale_price"}},{"kind":"Field","name":{"kind":"Name","value":"rent_net"}},{"kind":"Field","name":{"kind":"Name","value":"rent_extra"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_unit"}},{"kind":"Field","name":{"kind":"Name","value":"hide_price_on_portals"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"latest_appraisal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_living_surface_meter_squared"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemLotSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LotSnippetFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItemUserSnippet"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"is_broker"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"extra_data"}},{"kind":"Field","name":{"kind":"Name","value":"lot_id"}},{"kind":"Field","name":{"kind":"Name","value":"buyer_lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemHeader"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLeadSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemLotSnippet"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActivityItemUserSnippet"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActivityFiltersActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"activities"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"activity_type"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"creator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserFeedV2Query, UserFeedV2QueryVariables>;
export const GetUserDrawerTabCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserDrawerTabCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyAppraisalReasons"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_appraisal_reason_enum"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"selling_leads"},"name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contact_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"appraisal_reason"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyAppraisalReasons"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"listings"},"name":{"kind":"Name","value":"lots_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sellers"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"buyer_leads"},"name":{"kind":"Name","value":"buyer_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"property_searches"},"name":{"kind":"Name","value":"property_searches_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserDrawerTabCountsQuery, GetUserDrawerTabCountsQueryVariables>;
export const GetValuationLinkStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValuationLinkStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"leads_bool_exp"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chartSince"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"where"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartSince"}}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"total"},"name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"where"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartSince"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last30"},"name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"where"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"won"},"name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"where"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartSince"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_agents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"won"}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lost"},"name":{"kind":"Name","value":"leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"where"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chartSince"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_agents"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead_stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"lost"}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetValuationLinkStatsQuery, GetValuationLinkStatsQueryVariables>;
export const GetAgentVisibilityProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentVisibilityProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityAgentProfileFields"}},{"kind":"Field","alias":{"kind":"Name","value":"transactions"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_transaction"},"name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature_date"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latest_review"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityUserProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"verified_reviews"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityAgentProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityUserProfileFields"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_profile"}},{"kind":"Field","name":{"kind":"Name","value":"x_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}}]}}]} as unknown as DocumentNode<GetAgentVisibilityProfileQuery, GetAgentVisibilityProfileQueryVariables>;
export const GetAgentImpressionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentImpressions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"totals"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profile_views"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"page_types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"agent-detail","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"phone_clicks"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"show_phone_number","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}}]} as unknown as DocumentNode<GetAgentImpressionsQuery, GetAgentImpressionsQueryVariables>;
export const GetAgentProfileEngagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentProfileEngagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"website_clicks"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"website_link_clicked","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"social_clicks_by_platform"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"event_name"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"social_link_clicked_instagram","block":false},{"kind":"StringValue","value":"social_link_clicked_tiktok","block":false},{"kind":"StringValue","value":"social_link_clicked_youtube","block":false},{"kind":"StringValue","value":"social_link_clicked_x","block":false},{"kind":"StringValue","value":"social_link_clicked_facebook","block":false},{"kind":"StringValue","value":"social_link_clicked_linkedin","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentProfileEngagementQuery, GetAgentProfileEngagementQueryVariables>;
export const GetAgentResponseTimesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentResponseTimes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"claimed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityResponseTimeLeadAgentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityResponseTimeLeadAgentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]} as unknown as DocumentNode<GetAgentResponseTimesQuery, GetAgentResponseTimesQueryVariables>;
export const GetAgentLeadAgentsByLeadIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentLeadAgentsByLeadIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityLeadAgentClaimFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityLeadAgentClaimFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]} as unknown as DocumentNode<GetAgentLeadAgentsByLeadIdsQuery, GetAgentLeadAgentsByLeadIdsQueryVariables>;
export const GetAgentContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"until"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiriesWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"until"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiriesWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profile_leads"},"name":{"kind":"Name","value":"visibility_profile_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"until"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetAgentContactsQuery, GetAgentContactsQueryVariables>;
export const GetVisibilityV2MapDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityV2MapData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"impressions"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"page_location"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"count","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"desc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityV2MapDataQuery, GetVisibilityV2MapDataQueryVariables>;
export const GetPlacesBySlugsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlacesBySlugs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamLat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamLng"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxDistanceMeters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"places"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"country_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countryCode"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_en"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_fr"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_de"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_it"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_es"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_pl"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug_pt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slugs"}}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"simplified_geom"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_cast"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"geography"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_st_d_within"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"from"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"Point","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"coordinates"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"teamLng"}},{"kind":"Variable","name":{"kind":"Name","value":"teamLat"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"distance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxDistanceMeters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"use_spheroid"},"value":{"kind":"BooleanValue","value":false}}]}}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"slug_en"}},{"kind":"Field","name":{"kind":"Name","value":"slug_fr"}},{"kind":"Field","name":{"kind":"Name","value":"slug_de"}},{"kind":"Field","name":{"kind":"Name","value":"slug_it"}},{"kind":"Field","name":{"kind":"Name","value":"slug_es"}},{"kind":"Field","name":{"kind":"Name","value":"slug_pl"}},{"kind":"Field","name":{"kind":"Name","value":"slug_pt"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"population"}},{"kind":"Field","name":{"kind":"Name","value":"state_id"}},{"kind":"Field","name":{"kind":"Name","value":"district_id"}},{"kind":"Field","name":{"kind":"Name","value":"municipality_id"}},{"kind":"Field","name":{"kind":"Name","value":"locality_id"}},{"kind":"Field","name":{"kind":"Name","value":"state"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaceSlugFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaceSlugFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"municipality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaceSlugFields"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlaceSlugFields"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlaceSlugFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"places"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"slug_en"}},{"kind":"Field","name":{"kind":"Name","value":"slug_fr"}},{"kind":"Field","name":{"kind":"Name","value":"slug_de"}},{"kind":"Field","name":{"kind":"Name","value":"slug_it"}},{"kind":"Field","name":{"kind":"Name","value":"slug_es"}},{"kind":"Field","name":{"kind":"Name","value":"slug_pl"}},{"kind":"Field","name":{"kind":"Name","value":"slug_pt"}}]}}]} as unknown as DocumentNode<GetPlacesBySlugsQuery, GetPlacesBySlugsQueryVariables>;
export const GetTopLocationsUrlDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTopLocationsUrlData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentStartDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentEndDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previousStartDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"previousEndDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"team"},"name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"current_period"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"page_location"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"average_position","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"previous_period"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previousStartDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"previousEndDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"page_location"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"average_position","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}}]}}]} as unknown as DocumentNode<GetTopLocationsUrlDataQuery, GetTopLocationsUrlDataQueryVariables>;
export const GetImpressionDotsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImpressionDotsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impression_dots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"event_date"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"sale_horizon"}},{"kind":"Field","name":{"kind":"Name","value":"requalified_or_created_at"}},{"kind":"Field","name":{"kind":"Name","value":"agent_uuid"}}]}}]}}]}}]} as unknown as DocumentNode<GetImpressionDotsV2Query, GetImpressionDotsV2QueryVariables>;
export const GetLeadAgentsByLeadIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLeadAgentsByLeadIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityLeadAgentClaimFields"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accessible_leads"},"name":{"kind":"Name","value":"leads"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityLeadAgentClaimFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]} as unknown as DocumentNode<GetLeadAgentsByLeadIdsQuery, GetLeadAgentsByLeadIdsQueryVariables>;
export const GetTeamResponseTimesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamResponseTimes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"claimed_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityResponseTimeLeadAgentFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityResponseTimeLeadAgentFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"lead_agents"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}}]}}]} as unknown as DocumentNode<GetTeamResponseTimesQuery, GetTeamResponseTimesQueryVariables>;
export const GetVisibilityDashboardDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityDashboardData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ownReviewsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"agency_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"website_url"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo_image_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_ftp_client_id"}},{"kind":"Field","name":{"kind":"Name","value":"idx_agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactions"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_transaction"},"name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature_date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityUserProfileFields"}},{"kind":"Field","alias":{"kind":"Name","value":"transactions"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_review"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownReviewsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed_at"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"own_reviews"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ownReviewsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"own_verified_reviews"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"ownReviewsWhere"}},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityUserProfileFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"verified_reviews"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityDashboardDataQuery, GetVisibilityDashboardDataQueryVariables>;
export const GetTopCompetitorStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTopCompetitorStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"competitorTeamIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_top_competitor_stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"competitor_team_ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"competitorTeamIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medianResponseMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"profileCompletion"}}]}}]}}]} as unknown as DocumentNode<GetTopCompetitorStatsQuery, GetTopCompetitorStatsQueryVariables>;
export const GetDashboardContactClicksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardContactClicks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"phone_clicks_total"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"show_phone_number","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}}]} as unknown as DocumentNode<GetDashboardContactClicksQuery, GetDashboardContactClicksQueryVariables>;
export const GetDashboardProfileEngagementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardProfileEngagement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"website_clicks_total"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"website_link_clicked","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"social_clicks_by_platform"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"event_name"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"social_link_clicked_instagram","block":false},{"kind":"StringValue","value":"social_link_clicked_tiktok","block":false},{"kind":"StringValue","value":"social_link_clicked_youtube","block":false},{"kind":"StringValue","value":"social_link_clicked_x","block":false},{"kind":"StringValue","value":"social_link_clicked_facebook","block":false},{"kind":"StringValue","value":"social_link_clicked_linkedin","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardProfileEngagementQuery, GetDashboardProfileEngagementQueryVariables>;
export const GetDashboardContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"until"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enquiriesWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lead_agents_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"source"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"EnumValue","value":"result_page"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"until"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enquiriesWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"profile_leads"},"name":{"kind":"Name","value":"visibility_profile_leads_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"until"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardContactsQuery, GetDashboardContactsQueryVariables>;
export const GetNearbyImpressionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNearbyImpressions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyUuids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nearby_impressions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyUuids"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"by_locality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profile_views"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agency_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}}]}}]} as unknown as DocumentNode<GetNearbyImpressionsQuery, GetNearbyImpressionsQueryVariables>;
export const GetVisibilityInboxProfileLeadHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityInboxProfileLeadHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibility_inbox_profile_lead_history"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipient_name"}}]}}]}}]} as unknown as DocumentNode<GetVisibilityInboxProfileLeadHistoryQuery, GetVisibilityInboxProfileLeadHistoryQueryVariables>;
export const GetVisibilityInboxDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityInbox"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactRequestsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibility_inbox_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"lead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"anonymized_contact"}},{"kind":"Field","name":{"kind":"Name","value":"appraisal_reason"}},{"kind":"Field","name":{"kind":"Name","value":"created_by"}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry_id"}},{"kind":"Field","name":{"kind":"Name","value":"contact"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin_enquiry"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_enquiry"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"claimed_at"}},{"kind":"Field","name":{"kind":"Name","value":"passed_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactRequestsWhere"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_enquiry"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_enquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}}]}}]} as unknown as DocumentNode<GetVisibilityInboxQuery, GetVisibilityInboxQueryVariables>;
export const GetInboxMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInboxMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"visibility_inbox_lead_agents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lead"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"origin_enquiry_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lead_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enquiries_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ContactRequestEnquiry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserChip"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"property_transactions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserChip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"listings_agency_names"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"computed_surface"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"land_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"locality_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state_place"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cover_images"},"name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ContactRequestEnquiry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"enquiries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_number"}},{"kind":"Field","name":{"kind":"Name","value":"contact_reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionCard"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"built_surface"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}}]}}]}}]}}]} as unknown as DocumentNode<GetInboxMessageQuery, GetInboxMessageQueryVariables>;
export const GetUserSlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getUserSlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]} as unknown as DocumentNode<GetUserSlugQuery, GetUserSlugQueryVariables>;
export const GetVisibilityReviewsAggregateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityReviewsAggregate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityReviewsAggregateQuery, GetVisibilityReviewsAggregateQueryVariables>;
export const GetVisibilityReviewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityReviews"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_order_by"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VisibilityReview"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VisibilityReview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"reviews"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completed_at"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review_text"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email_address"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}}]}}]}}]} as unknown as DocumentNode<GetVisibilityReviewsQuery, GetVisibilityReviewsQueryVariables>;
export const GetVisibilityReviewsRowCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityReviewsRowCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityReviewsRowCountQuery, GetVisibilityReviewsRowCountQueryVariables>;
export const GetReviewInvitationTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviewInvitationTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"review_invitation_type_enum_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"review_invitation_templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<GetReviewInvitationTemplateQuery, GetReviewInvitationTemplateQueryVariables>;
export const UpsertReviewInvitationTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertReviewInvitationTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"review_invitation_type_enum_enum"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_review_invitation_templates_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"broker_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brokerId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"review_invitation_templates_broker_type_language_unique"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"message"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broker_id"}},{"kind":"Field","name":{"kind":"Name","value":"tenant_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}}]}}]}}]} as unknown as DocumentNode<UpsertReviewInvitationTemplateMutation, UpsertReviewInvitationTemplateMutationVariables>;
export const GetReviewsWidgetAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReviewsWidgetAgents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"publishedAgentsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"teams_users_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"publishedAgentsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"combined_reviews_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetReviewsWidgetAgentsQuery, GetReviewsWidgetAgentsQueryVariables>;
export const GetImpressionsDrilldownDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetImpressionsDrilldown"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"drilldown"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"page_types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"page_location"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"count","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"desc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}}]}}]} as unknown as DocumentNode<GetImpressionsDrilldownQuery, GetImpressionsDrilldownQueryVariables>;
export const GetTeamVisibilityStatsGraphDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamVisibilityStatsGraph"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agencyUuids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"impressions_graph_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"views_by_first_seen"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agencyUuids"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"page_types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"agency-detail","block":false},{"kind":"StringValue","value":"agent-detail","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date_first_seen"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"views_total"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"page_types"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"agency-detail","block":false},{"kind":"StringValue","value":"agent-detail","block":false}]}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"show_phone_number_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"date"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"StringValue","value":"name","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"StringValue","value":"asc","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"show_phone_number","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"show_phone_number_total"},"name":{"kind":"Name","value":"impressions_total"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}},{"kind":"Argument","name":{"kind":"Name","value":"event_names"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"show_phone_number","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_count"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"impressions_by_locality"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"EnumValue","value":"page_location"}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamVisibilityStatsGraphQuery, GetTeamVisibilityStatsGraphQueryVariables>;
export const GetTeamVisibilityStatsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamVisibilityStatsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ImpressionsGroupingColumn"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"list_data"},"name":{"kind":"Name","value":"impressions_grouped_by_column"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agency_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}},{"kind":"Argument","name":{"kind":"Name","value":"agent_uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_start"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"date_range_end"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"grouping_column"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_column"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by_direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderDirection"}}},{"kind":"Argument","name":{"kind":"Name","value":"hostname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hostname"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"user_count"}},{"kind":"Field","name":{"kind":"Name","value":"average_position"}}]}}]}}]}}]} as unknown as DocumentNode<GetTeamVisibilityStatsListQuery, GetTeamVisibilityStatsListQueryVariables>;
export const GetTeamsRankingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamsRanking"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"currentTeamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"get_teams_ranking_by_distance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"current_team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"currentTeamId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team_id"}},{"kind":"Field","name":{"kind":"Name","value":"distance"}},{"kind":"Field","name":{"kind":"Name","value":"total_transactions"}},{"kind":"Field","name":{"kind":"Name","value":"reviews_in_location"}},{"kind":"Field","name":{"kind":"Name","value":"latest_review_date"}},{"kind":"Field","name":{"kind":"Name","value":"latest_transaction_date"}},{"kind":"Field","name":{"kind":"Name","value":"transactions_in_location"}},{"kind":"Field","name":{"kind":"Name","value":"is_independent_agent"}}]}}]}}]} as unknown as DocumentNode<GetTeamsRankingQuery, GetTeamsRankingQueryVariables>;
export const GetVisibilityTeamMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityTeamMembers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamReviewsWhere"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"reviews_bool_exp"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"team_reviews"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamReviewsWhere"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"certifications"}},{"kind":"Field","name":{"kind":"Name","value":"facebook_profile"}},{"kind":"Field","name":{"kind":"Name","value":"instagram_profile"}},{"kind":"Field","name":{"kind":"Name","value":"tiktok_profile"}},{"kind":"Field","name":{"kind":"Name","value":"x_profile"}},{"kind":"Field","name":{"kind":"Name","value":"youtube_profile"}},{"kind":"Field","name":{"kind":"Name","value":"linked_in_profile"}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_primary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_2_years_property_transactions_aggregate"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVisibilityTeamMembersQuery, GetVisibilityTeamMembersQueryVariables>;
export const GetAgentTeamSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAgentTeamSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAgentTeamSettingsQuery, GetAgentTeamSettingsQueryVariables>;
export const GetTeamMemberDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTeamMemberDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active_since"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"services"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"default_team_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"all_reviews_count"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"avg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"verified_reviews_count"},"name":{"kind":"Name","value":"reviews_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"transaction_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latest_review"},"name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completed_at"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_transaction"},"name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signature_date"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"all_transactions_count"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"last_2_years_transactions"},"name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"twoYearsAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"purchase_price"},"value":{"kind":"EnumValue","value":"asc_nulls_last"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchase_price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTeamMemberDetailsQuery, GetTeamMemberDetailsQueryVariables>;
export const CreateTeamInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTeamInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitation"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"invitations_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_invitations_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitation"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTeamInvitationMutation, CreateTeamInvitationMutationVariables>;
export const CheckExistingTeamMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckExistingTeamMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"emails"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"teams_users"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}}]}}]}}]} as unknown as DocumentNode<CheckExistingTeamMemberQuery, CheckExistingTeamMemberQueryVariables>;
export const CheckExistingInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckExistingInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invitations_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]} as unknown as DocumentNode<CheckExistingInvitationQuery, CheckExistingInvitationQueryVariables>;
export const CancelExistingInvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelExistingInvitations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"citext"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_invitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"tenant_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accepted_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cancelled_at"},"value":{"kind":"StringValue","value":"now()","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<CancelExistingInvitationsMutation, CancelExistingInvitationsMutationVariables>;
export const PublishUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PublishUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentSlug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_in_agency_pages"},"value":{"kind":"BooleanValue","value":true}},{"kind":"ObjectField","name":{"kind":"Name","value":"agent_slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentSlug"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}},{"kind":"Field","name":{"kind":"Name","value":"agent_slug"}}]}}]}}]} as unknown as DocumentNode<PublishUserMutation, PublishUserMutationVariables>;
export const UnpublishUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnpublishUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_in_agency_pages"},"value":{"kind":"BooleanValue","value":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"show_in_agency_pages"}}]}}]}}]} as unknown as DocumentNode<UnpublishUserMutation, UnpublishUserMutationVariables>;
export const UpdateTeamMemberSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTeamMemberSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"defaultTeamId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isLeader"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"title"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deactivated"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_users_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default_team_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"defaultTeamId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"update_teams_users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_leader"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isLeader"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"title"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deactivated"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deactivated"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMemberSettingsMutation, UpdateTeamMemberSettingsMutationVariables>;
export const GetVisibilityTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisibilityTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"timestamptz"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"10000"}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signature_date"}},{"kind":"Field","name":{"kind":"Name","value":"is_published"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCell_property"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_rooms"}},{"kind":"Field","name":{"kind":"Name","value":"number_of_bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"living_surface"}},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker_team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seller_broker"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"completed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_buyer"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teams_users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"is_leader"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"deactivated"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo_user"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","alias":{"kind":"Name","value":"last_2_years_property_transactions_aggregate"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"team_transactions"},"name":{"kind":"Name","value":"property_transactions_aggregate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"seller_broker_team_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"signature_date"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lot"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"offer_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"rent","block":false}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"is_published"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"user_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is_primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserPhoneNumbers"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone_numbers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserCardDisplayName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"full_name"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"verified"},"value":{"kind":"EnumValue","value":"desc"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCell_property"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"properties"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"route"}},{"kind":"Field","name":{"kind":"Name","value":"street_number"}},{"kind":"Field","name":{"kind":"Name","value":"postcode"}},{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"country_code"}},{"kind":"Field","name":{"kind":"Name","value":"property_images"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order_nr"},"value":{"kind":"EnumValue","value":"asc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order_nr"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserInfo_user"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"users"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserPhoneNumbers"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserCardDisplayName"}}]}}]} as unknown as DocumentNode<GetVisibilityTransactionsQuery, GetVisibilityTransactionsQueryVariables>;